/**
 * Auto-generated translation store on 2026-11-04T11:54:44.809Z
 * Do not modify this file directly.
 * 
 * This file contains all translations bundled at build time for optimal performance.
 * Translations are automatically updated when source files change.
 */

import { TranslationStore } from './translation-store.interface';

export const translationStore: TranslationStore = {
  "tr": {
    "root": {
      "ADMIN_PORTAL": "YÖNETİCİ PORTALI",
      "SUPPORT": "DESTEK",
      "U": "K",
      "USER": "Kullanıcı",
      "LOGOUT": "Oturumu Kapat",
      "ADMIN": "Yönetici",
      "SUPPORT_SMALL": "Destek",
      "QUANTIFIED_AI": "Quantified.AI",
      "MICROPHONE": "MİKROFON",
      "CAMERA": "KAMERA",
      "ACCESS_DENIED": "ERİŞİM_REDDEDİLDİ"
    },
    "teams": {
      "MY_TEAMS": "Ekiplerim",
      "COMPLETED": "Tamamlandı",
      "IN_PROGRESS": "Devam ediyor",
      "NOT_STARTED": "Başlatılmadı",
      "ASSIGNMET_MODULE": "Atama Modülü",
      "START_DATE": "Başlangıç tarihi",
      "DUE_DATE": "Son teslim tarihi",
      "ASSIGNED_MEMBERS": "Atanan üyeler",
      "CALLS_IN_MODULE": "Modüldeki simülasyonlar",
      "COMPLETION_REQUIRMENT": "Tamamlama gereksinimi",
      "COMPLETE_ALL_CALLS": "Tüm simülasyonları",
      "OR_HIGHER": "veya daha yüksek",
      "PROGRESS_OVERVIEW": "İLERLEME DURUMUNA GENEL BAKIŞ",
      "TEAM_MEMBERS": "ekip üyeleri",
      "AVERAGE_HIGH_SCORE": "Ortalama yüksek puan",
      "AVERAGE_NUMBER_ATTEMPTS_CALL": "Simülasyon başına ortalama deneme sayısı",
      "TOTAL_PRACTICES": "Toplam alıştırma sayısı",
      "INDIVIDUAL_CALL_PROGRESS": "BİREYSEL SİMÜLASYON İLERLEME DURUMU",
      "OF_TEAM_MEMBERS": "ekip üyesi tamamladı",
      "AVERAGE_PRACTICES_TO_COMPLETION": "Tamamlanana kadar ortalama alıştırma sayısı",
      "TEAM_MEMBER_DETAILS": "EKİP ÜYESİ AYRINTILARI",
      "DOWNLOAD_ACTIVITY_REPORT": "Etkinlik raporunu indir",
      "TEAM_MEMBER": "Ekip üyesi",
      "PROGRESS": "İlerleme durumu",
      "CALLS_COMPLETED": "Tamamlanan simülasyonlar",
      "PRACTICES": "Alıştırma oturumları",
      "MOST_RECENT_PRACTICE": "En son oturum",
      "THIS_TEAM_HAS_NO_ACTIVE_ASSIGNMENTS": "Bu ekibin şu anda aktif bir görevi yok",
      "CALL_NAME_LABEL": "Simülasyon adı",
      "HIGHEST_SCORE": "En Yüksek Puan"
    },
    "simulationBuilder": {
      "THRESHOLD": "Eşik",
      "TYPE": "Tür",
      "SELECT_AN_OPTION": "Bir seçenek belirleyin",
      "CORRECT_FEEDBACK": "Doğru geri bildirim",
      "INCORRECT_FEEDBACK": "Yanlış geri bildirim",
      "CORRECT_FEEDBACK_PLACEHOLDER": "Öğrenci bu soruyu doğru cevapladığında görüntülenir",
      "INCORRECT_FEEDBACK_PLACEHOLDER": "Öğrenci bu soruyu yanlış cevapladığında görüntülenir",
      "MESSAGE_NUMBER": "Mesaj {{ index }}",
      "ENTER_MESSAGE_TEXT": "Mesaj metnini girin...",
      "FACT_MESSAGE_LABEL": "Mesaj",
      "FACT_MESSAGE_DESCRIPTION": "Mesajlar, tam bir cümle olarak yazılmış tek bir bilgi parçası olmalıdır. Mesajlarınızı spesifik, basit ve kapsamı sınırlı tutun; kısmen ifade edilebilecek mesajlardan kaçının.",
      "FACT_INCORRECT_ANSWER_LABEL": "Yanlış cevap metni",
      "FACT_INCORRECT_ANSWER_DESCRIPTION": "Öğrenci bu bilgiyi yanlış cevapladığında kendisine gösterilen metin",
      "SHOW_INCORRECT_ANSWER_TEXT": "Yanlış yanıtlar için alternatif metin göster",
      "ADD_NEW_FACT": "Yeni bilgi ekle",
      "FACT_SINGULAR": "bilgi",
      "FACT_PLURAL": "bilgi",
      "FACT_EXTRACTED_SINGULAR": "{{ count }} bilgi çıkarıldı",
      "FACT_EXTRACTED_PLURAL": "{{ count }} bilgi çıkarıldı",
      "FACTS_CANNOT_BE_EMPTY": "Bilgiler alanı boş olamaz. Test etmeden veya yayımlamadan önce her bir bilgiye bir mesaj ekleyin.",
      "REVIEW_REQUIRED_LABEL": "Önerileni incele",
      "DELETE": "Sil",
      "SCORABLE": "Puanlanabilir",
      "SEARCH_BY_SIMULATION_NAME": "Simülasyon adına göre ara",
      "SIMULATION_STATUS_PLACEHOLDER": "Simülasyon durumu",
      "SIMULATION_STATUS_PREFIX": "Simülasyon durumu:",
      "NO_SIMULATIONS_FOUND": "Simülasyon bulunamadı",
      "SELECT_ALL": "Tümünü seç",
      "DESELECT_ALL": "Tümünün seçimini kaldır",
      "STATUS_TESTING": "Test Ediliyor",
      "STATUS_DRAFT": "Taslak",
      "STATUS_PUBLISHED": "Yayımlanmış",
      "STATUS_ARCHIVED": "Arşivlenmiş",
      "SEARCH_BY_ASSIGNMENT_NAME": "Atama adına göre ara",
      "ASSIGNEES_ZERO_STATE_MESSAGE": "Henüz hiçbir kullanıcı atanmadı",
      "ADD_USERS_TO_ASSIGNMENT": "Atamaya kullanıcı ekle",
      "NO_DATA_FOUND": "Veri Bulunamadı!",
      "NO_USERS_SELECTED": "Seçilen kullanıcı yok",
      "COL_FIRST_NAME": "Ad",
      "COL_LAST_NAME": "Soyadı",
      "COL_EMAIL": "E-posta",
      "COL_VIEW_USER": "Kullanıcıyı görüntüle",
      "COL_VIEW_ASSIGNMENT": "Atamayı görüntüle",
      "COL_ASSIGNMENT_NAME": "Atama adı",
      "COL_STATUS": "Durum",
      "COL_TEAM_ASSOCIATIONS": "Ekip ilişkileri",
      "COL_REPORTING_STATUS": "Raporlama durumu",
      "BREADCRUMB_USERS": "Kullanıcılar",
      "STATUS_STAGED": "Aşamalı",
      "STATUS_ACTIVE": "Etkin",
      "STATUS_ENDED": "Sona Erdi",
      "STATUS_CLOSED": "Kapatıldı",
      "SEARCH_USERS_PLACEHOLDER": "Kullanıcı ara",
      "NO_USERS_FOUND": "Kullanıcı bulunamadı",
      "USERS_TAB_LABEL": "Kullanıcılar",
      "ADD_TO_ASSIGNMENT": "Atamaya Ekle",
      "ASSIGNMENTS_COUNT": "atamalar",
      "REPORTING_EXCLUDED": "Hariç Tutuldu",
      "REPORTING_INCLUDED": "Dahil Edildi",
      "KEBAB_EDIT_TEAM_ASSOCIATIONS": "Ekip ilişkilendirmelerini düzenle",
      "KEBAB_EXCLUDE_FROM_REPORTING": "Raporlamadan hariç tut",
      "KEBAB_INCLUDE_IN_REPORTING": "Raporlamaya dahil et",
      "KEBAB_REMOVE_FROM_ASSIGNMENT": "Atamadan kaldır",
      "NO_TEAMS": "—",
      "TEAMS_COUNT": "{{ count }} ekip",
      "ADD_TO_ASSIGNMENT_MODAL_HEADING": "Atamaya ekle",
      "FIELD_LABEL_ASSIGNMENT": "Atama",
      "SEARCH_ASSIGNMENTS_PLACEHOLDER": "Atama ara",
      "BUTTON_SET_TEAM_ASSOCIATION": "Ekip ilişkisini belirle",
      "FIELD_LABEL_TEAM": "Ekip",
      "SEARCH_TEAM_PLACEHOLDER": "Ekip ara",
      "BUTTON_BACK": "Geri",
      "BUTTON_CANCEL": "İptal et",
      "BUTTON_ADD_TO_ASSIGNMENT": "Atamaya ekle",
      "EDIT_TEAM_ASSOCIATIONS_HEADING": "Ekip ilişkilendirmelerini düzenle",
      "EDIT_TEAM_ASSOCIATIONS_DESCRIPTION": "{{ assignmentName }} ataması için",
      "BUTTON_SAVE_ASSOCIATIONS": "İlişkilendirmeleri kaydet",
      "REFERENCE_DOCUMENT_STATUS_UPLOADING": "– Yükleniyor...",
      "REFERENCE_DOCUMENT_STATUS_SUCCESS": "– %100 yüklendi",
      "REFERENCE_DOCUMENT_STATUS_ERROR": "– Yükleme hatası",
      "REFERENCE_DOCUMENT_STATUS_DELETING": "– Siliniyor",
      "REFERENCE_DOCUMENT_DELETE_ERROR": "Belge silinemedi. Lütfen tekrar deneyin.",
      "REFERENCE_DOCUMENT_UPLOAD_ERROR": "Belge yüklenemedi. Lütfen tekrar deneyin.",
      "CONTENT_LIMIT_EXCEEDED_ERROR": "İçerik sınırı aşıldı. Devam etmek için bir veya daha fazla belgeyi kaldırın.",
      "LAST_FACT_DELETE_WARNING_HEADING": "Son bilgi silinsin mi?",
      "LAST_FACT_DELETE_WARNING_DESCRIPTION": "Son bilgiyi silmek, bu simülasyonla olan tüm kullanıcı ilişkilerini kaldırır ve durumunu Taslak olarak geri alır.",
      "LEAVE_CONFIRMATION_HEADING": "Simülasyon oluşturma işleminden çık",
      "LEAVE_CONFIRMATION_DESCRIPTION": "Çıkmak istediğinizden emin misiniz? Tüm ilerlemeniz kaybolacak.",
      "LEAVE_CONFIRMATION_LEAVE_BUTTON": "Çık",
      "CREATE_SIMULATION_DETAILS_BUTTON": "Simülasyon ayrıntılarını oluştur",
      "SELF_AUTHORING_DESCRIPTION": "Başlamak için bir ad, kısa bir senaryo açıklaması ve simülasyona özgü belgeleri girin",
      "CLICK_TO_UPLOAD": "Yüklemek için tıklayın",
      "OR_DRAG_AND_DROP": "veya sürükleyip bırakın",
      "REFERENCE_DOCUMENTS_UPLOAD_DESCRIPTION": "PDF (maks. 50 MB)",
      "ASSIGNMENT_NAME_LABEL": "Atama adı *",
      "SIMULATION_NAME_LABEL": "Simülasyon adı",
      "NAME_FIELD_DESCRIPTION": "Bu ad daha sonra değiştirilebilir",
      "PRODUCT_LABEL": "Ürün",
      "SELECT_A_PRODUCT_PLACEHOLDER": "Ürün seç",
      "ADD_NEW_PRODUCT": "Yeni ürün ekle",
      "SCENARIO_LABEL": "Senaryo",
      "REFERENCE_DOCUMENTS_LABEL": "Referans belgeler",
      "ACTION_CREATE_NEW": "Yeni oluştur",
      "ACTION_CREATE": "Oluştur",
      "ACTION_DUPLICATE": "Yinelenen",
      "ENTITY_TYPE_SIMULATION_DISPLAY": "Simülasyon",
      "ENTITY_TYPE_ASSIGNMENT_DISPLAY": "Atama",
      "ENTITY_TYPE_SIMULATION_LOWER": "simülasyon",
      "ENTITY_TYPE_ASSIGNMENT_LOWER": "atama",
      "MODAL_TITLE": "{{ action }} {{ type }}",
      "CONFIRM_BUTTON_LABEL": "{{ action }} {{ type }}",
      "DUPLICATE_NAME_ERROR_ASSIGNMENT": "Aynı ada sahip bir atama zaten mevcut.",
      "DUPLICATE_NAME_ERROR_SIMULATION": "Aynı ada sahip bir simülasyon zaten mevcut.",
      "NAME_REQUIRED_ERROR": "Ad zorunludur.",
      "COPY_OF_PREFIX": "{{ name }} kopyası",
      "SCORE_DISTRIBUTION_TITLE": "Mevcut puan dağılımı",
      "EDIT_SECTIONS_AND_WEIGHTING": "Bölümleri ve ağırlıklandırmayı düzenle",
      "SCORING_WEIGHTS_TITLE": "Puanlamayı yapılandır",
      "SCORING_WEIGHTS_DESCRIPTION": "Hangi alanların puanlanacağını ve her birinin genel derecelendirmeye ne kadar katkıda bulunacağını seçin. Etkinleştirilen tüm bölüm ağırlıklarının toplamı %100 olmalıdır. Beceri bölümü, %20'den fazla ağırlığa sahip olamaz.",
      "SCORING_WEIGHT_REQUIRED": "Zorunlu",
      "MESSAGING_TITLE": "Mesajlaşma",
      "MESSAGING_SUBTITLE": "Önemli bilgilerin aktarılıp aktarılmadığını değerlendirin",
      "METHODOLOGY_TITLE": "Metodoloji",
      "METHODOLOGY_SUBTITLE": "Görüşme yaklaşımını ve yapısını değerlendirin",
      "METHODOLOGY_WEIGHTING_LABEL": "Ağırlık: %{{ weight }}",
      "METHODOLOGY_RUBRIC_LABEL": "Metodoloji Değerlendirme Ölçeği",
      "SELECT_RUBRIC_PLACEHOLDER": "Değerlendirme ölçeği seç",
      "SKILLS_TITLE": "Beceriler",
      "SKILLS_SUBTITLE": "İletişim ve sosyal becerileri değerlendirin",
      "SKILLS_WEIGHTING_LABEL": "Ağırlık: %{{ weight }}",
      "SKILLS_RUBRIC_LABEL": "Beceri Değerlendirme Ölçeği",
      "PROCESSING_DOCUMENTS_MESSAGE": "Belgeler işleniyor...",
      "PROCESSING_DOCUMENTS_SUPPORTING_TEXT": "İstediğiniz zaman ayrılabilirsiniz. Sonuçlar 5 dakika içinde hazır olacaktır.",
      "CORE_SIGNAL_MESSAGE": "İçeriğinizi yorumluyoruz...",
      "SECTION_PLAN_MESSAGE": "Simülasyonunuzun yapısı planlanıyor...",
      "DERIVED_COMPONENT_MESSAGE": "Simülasyonunuzun bileşenleri oluşturuluyor...",
      "COMPONENT_WAVE_1_MESSAGE": "Simülasyonunuzun içeriği yazılıyor...",
      "COMPONENT_WAVE_2_MESSAGE": "Simülasyonunuzun içeriği iyileştiriliyor...",
      "COMPONENT_WAVE_3_MESSAGE": "Simülasyonunuzun içeriği son haline getiriliyor...",
      "MESSAGE_ADHERENCE_MESSAGE": "Mesajlaşma puanlama ölçütleri öneriliyor...",
      "ASSEMBLING_MESSAGE": "Simülasyonunuz derleniyor...",
      "FINISHING_SIMULATION_MESSAGE": "Simülasyonunuz tamamlanıyor...",
      "STILL_PROCESSING_TITLE": "Hâlâ işleniyor...",
      "STILL_PROCESSING_BODY": "Bu işlem normalden uzun sürüyor. Bu simülasyondan çıkıp daha sonra simülasyon listesi görünümünden geri dönebilirsiniz.",
      "PROCESSING_FAILED_TITLE": "İşleme başarısız oldu",
      "PROCESSING_FAILED_BODY": "Belgeleriniz işlenirken bir sorun oluştu. Lütfen yeniden deneyin. Sorun devam ederse ",
      "PROCESSING_FAILED_SUFFIX": " ile iletişime geçin.",
      "BUTTON_RETRY": "Yeniden deneyin",
      "TOKEN_LIMIT_EXCEEDED_BODY_PREFIX": "İçerik sınırı aşıldı. Sorun devam ederse bir veya daha fazla belgeyi kaldırıp tekrar deneyin veya ",
      "TOKEN_LIMIT_EXCEEDED_BODY_SUFFIX": " ile iletişime geçin.",
      "TEST_SIMULATION_BUTTON": "Simülasyonu test et",
      "SIMULATION_PROCESSED_TITLE": "Belgeler işlendi",
      "SIMULATION_PROCESSED_BODY": "Simülasyonunuzun belgeleri işlendi.",
      "SIMULATION_DOCUMENTS_PROCESSED_TITLE": "Simülasyon belgeleri işlendi.",
      "SIMULATION_DOCUMENTS_PROCESSED_BODY": "{{ name }} simülasyonu için yüklediğiniz belgeler işlendi.",
      "SIMULATION_DOCUMENTS_FAILED_TITLE": "Simülasyon belgeleri işlenemedi.",
      "SIMULATION_DOCUMENTS_FAILED_BODY": "{{ name }} simülasyonu için yüklediğiniz belgeler işlenmedi.",
      "DISMISS": "Kapat",
      "VIEW_SIMULATION": "Simülasyonu görüntüle",
      "AVATAR_LOOK_LABEL": "Görünüm",
      "AVATAR_SELECT_PLACEHOLDER": "Avatar seç",
      "AVATAR_VOICE_LABEL": "Ses",
      "AVATAR_ALT": "Avatar",
      "PLAY_VOICE_PREVIEW_BUTTON": "Sesi oynat önizlemesi",
      "VOICE_OPTION_1": "Ses 1",
      "VOICE_OPTION_2": "Ses 2",
      "BACK_TO_SIMULATION_DETAILS_BUTTON": "Simülasyon ayrıntılarına geri dön",
      "AVATAR_SELECTION_TITLE": "Avatar Seçimi",
      "VIEW_DOCUMENTS": "Belgeleri görüntüle",
      "SELECT_AVATAR_BUTTON": "Avatar seç",
      "REQUEST_CHANGES_PLACEHOLDER": "Yukarıdaki bilgilerde değişiklik talep et",
      "CALL_DETAILS_LOAD_ERROR": "Görüşme ayrıntılarınızı yükleyemedik. Lütfen tekrar deneyin.",
      "BLANK_THEME_MESSAGE_TOOLTIP": "Yeni bir tema eklemeden önce boş mesaja metin ekleyin.",
      "BLANK_MESSAGE_TOOLTIP": "Başka bir mesaj eklemeden önce bu mesaja metin ekleyin.",
      "ADD_NEW_THEME_BUTTON": "Yeni tema ekle",
      "ADD_THEME_BUTTON": "Tema ekle",
      "ADD_MESSAGE_BUTTON": "Mesaj ekle",
      "SCORE_LAST_SESSION": "Son oturumumu puanla",
      "SCORE_LAST_SESSION_MODAL_HEADING": "Son oturumu puanla",
      "SCORE_LAST_SESSION_MODAL_DESCRIPTION": "Önce simülasyonu test edin, ardından buraya geri dönüp seçilen değerlendirme ölçeğine göre puanlayın.",
      "SCORE_LAST_SESSION_MODAL_ERROR_HEADING": "Bir sorun oluştu",
      "SCORE_LAST_SESSION_MODAL_ERROR_DESCRIPTION": "Tekrar deneyin.",
      "REFINEMENT_THINKING_MESSAGE": "Düşünüyorum...",
      "REFINEMENT_UPDATED_MESSAGE": "Güncellendi",
      "REFINEMENT_WARNING_PREFIX": "Bu bilgi manuel olarak değiştirildi. Lütfen güncellemeler için şu birimle iletişime geçin:",
      "REFINEMENT_WARNING_SUFFIX": ".",
      "REFINEMENT_ERROR_PREFIX": "Maalesef bu konuda size yardımcı olamam ancak",
      "REFINEMENT_ERROR_SUFFIX": "yardımcı olabilir.",
      "REFINEMENT_APPLIED_TITLE": "İstenen değişiklikler uygulandı.",
      "REFINEMENT_APPLIED_BODY": "{{ name }} simülasyonu için talep ettiğiniz değişiklikler uygulandı.",
      "REFINEMENT_FAILED_TITLE": "Talep edilen değişiklikler başarısız oldu.",
      "REFINEMENT_FAILED_BODY": "{{ name }} simülasyonu için talep ettiğiniz değişiklikleri uygulayamadık.",
      "WHAT_USERS_SEE_DESCRIPTION_TITLE": "Simülasyon Açıklaması",
      "WHAT_USERS_SEE_DESCRIPTION_HELPER": "Genel sekmesinde güncellenen bilgiler, manuel güncelleme yapılmadıkça buraya yansıtılacaktır.",
      "WHAT_USERS_SEE_DESCRIPTION_FIELD_LABEL": "Açıklama",
      "WHAT_USERS_SEE_DETAILS_TITLE": "Simülasyon ayrıntıları",
      "WHAT_USERS_SEE_DETAILS_HELPER": "Bu, kullanıcının Simülasyona başlamadan önce kendisine sunulacak içeriktir. Genel sekmesinde güncellenen bilgiler, manuel güncelleme yapılmadıkça buraya yansıtılacaktır. Boş bırakılan bölümler öğrenciye gösterilmeyecektir. Tüm bölümler markdown biçimlendirmesini destekler.",
      "WHAT_USERS_SEE_OVERVIEW_FIELD_LABEL": "Simülasyona genel bakış",
      "WHAT_USERS_SEE_PERSONA_FIELD_LABEL": "Persona hakkında",
      "WHAT_USERS_SEE_SCORING_FIELD_LABEL": "Puanlama ölçütleri",
      "WHAT_USERS_SEE_SCORING_FIELD_HELPER": "Bu bölüm, puanlama sekmesinde yapılan seçimlere göre doldurulur. Buradaki bilgileri düzenlemek, simülasyonun puanlanma şeklini değiştirmez.",
      "WHAT_USERS_SEE_PREVIEW_DETAILS_CTA": "Simülasyon ayrıntılarını önizleme açılır penceresi",
      "WHAT_USERS_SEE_PREVIEW_CARD_CTA": "Simülasyon kartını önizle",
      "TAB_GENERAL": "Genel",
      "TAB_CONTENTS": "İçindekiler",
      "TAB_KEY_WORDS": "Anahtar Kelimeler",
      "TAB_SCORING": "Puanlama",
      "TAB_TESTING": "Test",
      "TAB_PROMPTS": "İstemler",
      "TAB_WHAT_USERS_SEE": "Kullanıcıların gördükleri",
      "ACCURACY_FEEDBACK_TITLE": "Doğruluk geri bildirimi",
      "ACCURACY_FEEDBACK_DESCRIPTION": "Temsilcinin her ifadesinin, yüklenen belgelere göre doğruluğunu değerlendirin",
      "ACCURACY_FEEDBACK_STATUS_ON": "Etkin",
      "ACCURACY_FEEDBACK_STATUS_OFF": "Kapalı",
      "ACCURACY_FEEDBACK_STATUS_DISABLED": "Devre dışı",
      "ACCURACY_FEEDBACK_NO_DOCUMENTS": "Hiçbir ilgili belge eklenmediğinden doğruluk puanlaması yapılamaz.",
      "SCORING_AI_REVIEW_NOTICE": "Bu sekmedeki bazı içerikler, sağladığınız materyallerden oluşturulmuştur. Bu görüşmeyi yayımlamadan önce tüm içeriğin doğruluğunu kontrol edin.",
      "EXPORT_SIMULATION_SUMMARY_BUTTON": "Simülasyon özetini dışa aktar",
      "CALL": "Görüşme",
      "REFINEMENT_OVERRIDDEN_PREFIX": "Bu bilgi manuel olarak değiştirildi. Lütfen güncellemeler için şu birimle iletişime geçin:",
      "REFINEMENT_OVERRIDDEN_SUFFIX": ".",
      "SUPPORT_EMAIL": "help@quantified.ai",
      "WHAT_USERS_SEE_OVERRIDE_WARNING_TITLE": "Bu alanları düzenlemek, gelecekteki güncellemeleri engelleyecektir",
      "WHAT_USERS_SEE_OVERRIDE_WARNING_BODY": "Bu bölümleri manuel olarak güncellemek, Genel sekmesindeki iyileştirme sürecinden gelecek ek güncellemelerin bu bölümlere ulaşmasını engelleyecektir.",
      "WHAT_USERS_SEE_DETAILS_OVERRIDE_EDITED_TITLE": "Bu alanlar düzenlenmiştir",
      "WHAT_USERS_SEE_DETAILS_OVERRIDE_EDITED_BODY": "Artık Genel sekmesinde yapılan iyileştirme güncellemelerini almayacaklardır",
      "SIMULATION_BUILDER_HEADING": "Simülasyon Oluşturucu",
      "ASSIGNMENTS_TAB_LABEL": "Atamalar",
      "SIMULATIONS_TAB_LABEL": "Simülasyonlar",
      "CREATE_NEW_ASSIGNMENT_BUTTON": "Yeni atama oluştur",
      "CREATE_NEW_SIMULATION_BUTTON": "Yeni simülasyon oluştur",
      "NO_ASSIGNMENTS_FOUND": "Hiçbir atama bulunamadı",
      "ASSIGNMENT_STATUS_PLACEHOLDER": "Atama durumu",
      "ASSIGNMENT_STATUS_PREFIX": "Atama durumu:",
      "ASSIGNMENT_TYPE_LABEL": "Atama türü",
      "SELECT_ASSIGNMENT_TYPE_PLACEHOLDER": "Atama türü seç",
      "NAME_LABEL": "Ad",
      "ASSIGNMENT_NAME_PLACEHOLDER": "Atama adı",
      "PASSING_SCORE_LABEL": "Geçme puanı",
      "PASSING_SCORE_OPTIONAL_LABEL": "Geçme puanı (isteğe bağlı)",
      "SCORE_MAX_EXCEEDED_ERROR": "Puan 5'i geçmemelidir",
      "GET_HELP_BUTTON": "Yardım alın",
      "PASSING_SCORE_TOOLTIP": "Bu, öğrencinin simülasyonu geçmek için ulaşması gereken genel puanı belirler.",
      "DESCRIPTION_LABEL": "Açıklama",
      "ASSIGNMENT_DESCRIPTION_PLACEHOLDER": "Simülasyon açıklaması",
      "MESSAGING_FEEDBACK_LABEL": "Mesajlaşma geri bildirimi",
      "MESSAGING_FEEDBACK_TOOLTIP_HEADING": "Mesajlaşma Geri Bildirimi",
      "MESSAGING_FEEDBACK_TOOLTIP_BODY": "Bir öğrenci bir mesajı yanlış ifade ettiğinde, bir dahaki sefere nasıl daha iyi ifade edebileceğine dair bilgiler gösterilir. Bu ayar, söz konusu bilginin gösterilip gösterilmeyeceğini belirler.",
      "ENABLED_TEXT": "Etkin",
      "DISABLED_TEXT": "Devre dışı",
      "PAUSE_BUTTON_LABEL": "Duraklat düğmesi",
      "ASSIGNMENT_START_DATE_LABEL": "Atama başlangıç tarihi",
      "SELECT_DATE_PLACEHOLDER": "Tarih seç",
      "ASSIGNMENT_END_DATE_LABEL": "Atama bitiş tarihi",
      "ASSIGNMENT_END_DATE_OPTIONAL_LABEL": "Atama bitiş tarihi (isteğe bağlı)",
      "END_DATE_RANGE_ERROR": "Başlangıç tarihi ve bitiş tarihi aynı olamaz",
      "ASSIGNMENT_INFORMATION_TITLE": "Atama Bilgileri",
      "ASSIGNMENT_TYPE_CERTIFICATION": "Sertifika",
      "ASSIGNMENT_TYPE_PRACTICE": "Alıştırma",
      "ASSIGNMENT_TYPE_PERSONALIZED_PRACTICE": "Kişiselleştirilmiş Alıştırma",
      "BUTTON_SAVE_AND_CLOSE": "Kaydet ve kapat",
      "BUTTON_ADD_SIMULATIONS": "Simülasyon ekle",
      "ATTEMPTS_UNLIMITED": "Sınırsız",
      "SEARCH_FOR_SIMULATION_LABEL": "Simülasyon ara",
      "SIMULATION_NAME_PLACEHOLDER": "Simülasyon adı",
      "BUTTON_REMOVE_ALL": "Tümünü kaldır",
      "SIMULATIONS_IN_ASSIGNMENT_LABEL": "Atamadaki simülasyonlar",
      "BUTTON_ASSIGN_LEARNERS": "Öğrenci ata",
      "CALL_TYPE_UNKNOWN": "Bilinmiyor",
      "ASSIGNMENT_COUNT_NONE": "Yok",
      "ASSIGNMENT_COUNT_SINGULAR": "{{ count }} atama",
      "ASSIGNMENT_COUNT_PLURAL": "{{ count }} atama",
      "ERROR_LOADING_ASSIGNMENTS": "Atamalar yüklenirken hata oluştu",
      "SEARCH_ASSIGNEES_TITLE": "Atanan kişi ara",
      "DIALOG_DESCRIPTION_ADD_USERS": "Atamaya katılacak kullanıcıları seçin. Bir ekibi aradığınızda, söz konusu ekipteki belirli kullanıcılara atama yapabilir veya atamalarını kaldırabilirsiniz. Belirli bir kullanıcıyı seçerken bu kullanıcının raporlama amacıyla doğru ekiple ilişkilendirildiğinden emin olun.",
      "ADD_USERS_TO_ASSIGNMENT_HEADING": "Atamaya kullanıcı ekle",
      "BUTTON_REVIEW_SELECTED_USERS": "Seçilen kullanıcıları gözden geçir",
      "FIND_USERS_LABEL": "Kullanıcı bul",
      "BUTTON_CLEAR": "Temizle",
      "LEARNER_COUNT_NONE": "Yok",
      "LEARNER_COUNT_SINGULAR": "{{ count }} öğrenci",
      "LEARNER_COUNT_PLURAL": "{{ count }} öğrenci",
      "ASSIGNMENT_TAB_DETAILS": "Ayrıntılar",
      "ASSIGNMENT_TAB_SIMULATIONS": "Simülasyonlar",
      "ASSIGNMENT_TAB_ASSIGNEES": "Atanan Kişiler",
      "LOADING_ASSIGNMENT_DETAILS": "Atama ayrıntıları yükleniyor...",
      "BREADCRUMB_ASSIGNMENTS": "Atamalar",
      "ASSIGNMENTS_COL_NAME": "Ad",
      "ASSIGNMENTS_COL_START_DATE": "Atama başlangıç tarihi",
      "ASSIGNMENTS_COL_END_DATE": "Atama bitiş tarihi",
      "ASSIGNMENTS_COL_LEARNERS": "Öğrenci atandı",
      "ASSIGNMENTS_COL_TYPE": "Atama türü",
      "ASSIGNMENTS_COL_STATUS": "Atama durumu",
      "SIMULATIONS_COL_NAME": "Ad",
      "SIMULATIONS_COL_PRODUCT": "Ürün",
      "SIMULATIONS_COL_DATE_MODIFIED": "Son değiştirilme tarihi",
      "SIMULATIONS_COL_STATUS": "Durum",
      "SIMULATIONS_COL_USED_IN": "Kullanıldığı yer",
      "SIMULATIONS_COL_TYPE": "Simülasyon türü",
      "SIMULATIONS_COL_DATE_PUBLISHED": "Yayımlanma tarihi",
      "CONVERSE_PROMPT_LABEL": "Konuşma İstemi",
      "CONVERSE_PROMPT_EXPAND_TO_EDIT": "Düzenlemek için genişlet",
      "CONVERSE_PROMPT_ENTER_LABEL": "Konuşma istemini buraya girin *",
      "CONVERSE_PROMPT_EDITING_HEADING": "Konuşma istemini düzenleme",
      "CONVERSE_PROMPT_OVERRIDE_CONFIRMATION_HEADING": "İstem geçersiz kılma onayı",
      "CONVERSE_PROMPT_OVERRIDE_DESCRIPTION": "Konuşma istemini geçersiz kılmak istediğinizden emin misiniz? Geçersiz kılınırsa yazarlar kendi kendilerine iyileştirme erişimini kaybedeceklerdir.",
      "CONVERSE_PROMPT_FIELD_LABEL": "Konuşma istemi",
      "CONVERSE_PROMPT_SAVE_BUTTON": "İstemi kaydet",
      "BUTTON_CONFIRM": "Onayla",
      "DELETE_SIM_HEADING": "Simülasyonu sil",
      "DELETE_SIM_CONTENT": "Bu simülasyon silinecektir. Simülasyonla ilişkili tüm test atamaları da kaldırılacaktır.",
      "DELETE_SIM_LABEL": "Simülasyonu sil",
      "DELETE_ASSIGNMENT_HEADING": "Atamayı sil",
      "DELETE_ASSIGNMENT_CONTENT": "Bu atama kalıcı olarak silinecektir.",
      "DELETE_ASSIGNMENT_LABEL": "Atamayı sil",
      "DELETE_ASSIGNMENT_NON_STAGED_CONTENT": "Etkin veya Sona Erdi durumundaki bir atamayı silmek için lütfen CX ekibiyle iletişime geçin. Teşekkür ederiz.",
      "REMOVE_FROM_ASSIGNMENT_HEADING": "Atamadan kaldır",
      "REMOVE_FROM_ASSIGNMENT_CONTENT": "Bu işlem, kullanıcıyı atamadan ve ilgili tüm ekip bağlantılarından kaldıracaktır.",
      "REMOVE_FROM_ASSIGNMENT_LABEL": "Atamadan kaldır",
      "PUBLISH_SIMULATION_HEADING": "Simülasyonu yayımla",
      "PUBLISH_CONTINUE_EDITING": "Düzenlemeye devam et",
      "PUBLISH_BUTTON": "Yayımla",
      "PUBLISH_SIMULATION_DESCRIPTION": "Rol canlandırma atamalara eklenebilecektir ancak persona, puanlama ve istem bilgileri artık düzenlenemeyecektir.",
      "CONFIRMATION_SELECTED_USERS_HEADING": "Seçilen Kullanıcılar",
      "CONFIRMATION_TOTAL_COUNT": "Toplam {{ count }}",
      "CONFIRMATION_CREATE_HEADING": "Yeni atama oluştur",
      "CONFIRMATION_ADD_USERS_HEADING": "Atamaya kullanıcı ekle",
      "CONFIRMATION_SAVE_ASSIGNMENT_BTN": "Atamayı kaydet",
      "CONFIRMATION_REMOVE_USER": "Kaldır",
      "EDIT_WEIGHTING_HEADING": "Puanlama ağırlıklandırmasını düzenle",
      "EDIT_WEIGHTING_DESCRIPTION": "Genel puan, aşağıdaki bölümlerin ağırlıklı ortalamasından hesaplanacaktır. Etkinleştirilen tüm bölüm ağırlıklarının toplamı %100 olmalıdır. Beceri bölümü, %20'den fazla ağırlığa sahip olamaz.",
      "EDIT_WEIGHTING_ERROR_ALL_DISABLED": "En az bir puanlama işlemi etkinleştirilmelidir",
      "EDIT_WEIGHTING_ERROR_WEIGHT_RANGE": "Bölüm ağırlığı 0 ile 100 arasında olmalıdır",
      "EDIT_WEIGHTING_ERROR_SKILLS_MAX": "Beceri bölümü, %20'den fazla ağırlığa sahip olamaz.",
      "EDIT_WEIGHTING_ERROR_TOTAL": "Bölümlerin toplam ağırlığı %100 olmalıdır",
      "PERSONA_INFORMATION_TITLE": "Persona Bilgileri",
      "PERSONA_AVATAR_LABEL": "Avatar *",
      "PERSONA_NAME_LABEL": "Ad *",
      "PERSONA_INITIAL_GREETINGS_LABEL": "İlk selamlamalar *",
      "PERSONA_INITIAL_GREETINGS_DESCRIPTION": "Persona, simülasyona bu selamlamalardan biriyle başlayacaktır. En fazla 5 seçenek belirleyebilirsiniz.",
      "PERSONA_ADD_GREETING_OPTION": "Selamlama seçeneği ekle",
      "PERSONA_RESUME_MESSAGE_LABEL": "Mesaja devam et",
      "PERSONA_RESUME_MESSAGE_DESCRIPTION": "Bir öğrenci duraklamadan sonra simülasyona devam ettiğinde, persona bu selamlamalardan biriyle başlayacaktır. En fazla 5 seçenek belirleyebilirsiniz.",
      "PERSONA_ADD_MESSAGE_OPTION": "Mesaj seçeneği ekle",
      "PERSONA_UPLOADING": "Yükleniyor...",
      "PERSONA_DELETING": "Siliniyor...",
      "PERSONA_CUSTOM_BG_PREVIEW_ALT": "Özel Arka Plan Önizlemesi",
      "PERSONA_AVATAR_THUMBNAIL_ALT": "Avatar Küçük Resmi",
      "PERSONA_AVATAR_WITH_BG_ALT": "Özel arka plana sahip avatar",
      "PERSONA_PROCESSING_IMAGE": "Resim işleniyor...",
      "PERSONA_CUSTOM_BACKGROUND_LABEL": "Özel Arka Plan",
      "PERSONA_REMOVE_BACKGROUND": "Arka planı kaldır",
      "PERSONA_CLICK_TO_REPLACE": "Değiştirmek için tıklayın",
      "PERSONA_UPLOAD_DESCRIPTION": "PNG veya JPG, tercihen 16:9 en-boy oranı, maks. 2 MB",
      "SIM_INFORMATION_TITLE": "Simülasyon Bilgileri",
      "SIM_NAME_FIELD_LABEL": "Ad *",
      "SIM_LANGUAGE_FIELD_LABEL": "Dil",
      "SIM_DETAILS_SECTION_TITLE": "Simülasyon Ayrıntıları",
      "SIM_ADDITIONAL_SECTION_TITLE_LABEL": "Ek bölüm başlığı",
      "SIM_ADDITIONAL_SECTION_INFO_LABEL": "Ek bölüm bilgileri",
      "TESTING_SECTION_TITLE": "Test edenler",
      "TESTING_SEND_ASSIGNMENTS_BTN": "Test atamalarını gönder",
      "TESTING_MESSAGING_TOOLTIP": "Test etmeden veya yayımlamadan önce Mesajlara Uyum’a en az bir bilgi ekleyin.",
      "TESTING_DESCRIPTION": "Simülasyonu test edecek kullanıcıları arayın, ardından onlara test atamasını gönderin.",
      "TESTING_COL_NUMBER_OF_ATTEMPTS": "Deneme sayısı",
      "TESTING_COL_DATE_OF_LAST_ATTEMPT": "Son deneme tarihi",
      "TESTING_CLEAR_USERS": "Kullanıcıları temizle",
      "TESTING_REMOVE_ASSIGNEE": "Atanan kişiyi kaldır",
      "OVERALL_SECTION_TITLE": "Bölümler, ağırlıklar ve istemler",
      "OVERALL_HEADING": "Genel",
      "TRANSCRIPT_PROMPT_TITLE": "Transkript istemi",
      "TRANSCRIPT_PROMPT_FIELD_LABEL": "Temiz transkript istemini buraya girin",
      "SIMULATION_PROMPTS_TITLE": "Simülasyon istemleri",
      "TAGS_LABEL": "Etiketler",
      "CREATE_TAG_OPTION": "{{term}} Oluştur",
      "TAG_CREATE_ERROR": "Etiket oluşturulamadı, lütfen tekrar deneyin",
      "EDIT_SIMULATION_TAGS_TITLE": "Simülasyon etiketlerini düzenle",
      "SAVE_TAGS_BUTTON": "Etiketleri kaydet",
      "CLOSE_BUTTON": "Kapat",
      "TAG_UPDATE_ERROR": "Etiket güncellenemedi, lütfen tekrar deneyin",
      "SCREEN_SHARE_TITLE": "Ekran paylaşımı",
      "SCREEN_SHARE_DESCRIPTION": "Kullanıcının görüşme sırasında ekranını avatar ile paylaşmasına olanak tanır, böylece avatar, ekranda gösterilenleri görebilir ve bunlara yanıt verebilir",
      "SCREEN_SHARE_STATUS_ON": "Etkin",
      "SCREEN_SHARE_STATUS_OFF": "Devre dışı",
      "SCREEN_SHARE_NO_PERSONA": "Ekran paylaşımını etkinleştirmek için önce bir persona ekleyin.",
      "HIDE_RESULTS_LABEL": "Sonuçları gizle",
      "SEARCH_FIELD_HINT": "Aramaya başlamak için en az üç karakter yazın",
      "OTHERS_SINGULAR": "ve 1 tane daha",
      "OTHERS_PLURAL": "ve {{ count }} tane daha",
      "PAGINATION_PREVIOUS": "Önceki",
      "PAGINATION_NEXT": "Sonraki",
      "SKILLS_RUBRIC_REQUIRED_TOOLTIP": "Beceri değerlendirme ölçeği ekleyin. Beceriler özelliği, ağırlık %0'ın üzerinde olduğunda etkinleştirilir.",
      "ENTITY_TYPE_KNOWLEDGE_CHECK_DISPLAY": "bilgi kontrolü",
      "NAME_MAX_LENGTH_ERROR": "Ad en fazla 255 karakterden oluşmalıdır.",
      "UUID_COPIED_TOAST": "Görüşme UUID’si panoya kopyalandı",
      "MENU_ARCHIVE": "Arşiv",
      "MENU_EDIT_SIMULATION_TAGS": "Simülasyon etiketlerini düzenle",
      "MENU_COPY_UUID": "UUID'yi kopyala",
      "REFINEMENT_IN_PROGRESS_TOOLTIP": "İyileştirme devam ediyor. İşlem tamamlandığında devam edebilirsiniz.",
      "SIMULATION_DOCUMENTS_PARSE_FAILED_BODY": "{{ name }} için belgelerinizden biri okunamadı. Belgeyi kontrol edin veya değiştirin ve tekrar deneyin.",
      "REFINEMENT_ERROR_MESSAGE": "Üzgünüz, bu talep tamamlanamadı. Lütfen tekrar deneyin",
      "REFINEMENT_OUT_OF_SCOPE_TITLE": "Talep kapsam dışı.",
      "REFINEMENT_OUT_OF_SCOPE_BODY": "{{ name }} ile ilgili talebiniz, iyileştirmenin yapabileceği işlemlerin kapsamı dışında. Lütfen destek ile iletişime geçin.",
      "TAB_QUESTIONS": "Sorular",
      "KNOWLEDGE_CHECK_NAME_LABEL": "Ad*",
      "AVATAR_APPEARANCE_LABEL": "Avatar görünümü",
      "KNOWLEDGE_CHECK_AVATAR_NAME_LABEL": "Avatar adı",
      "KNOWLEDGE_CHECK_SKILLS_FEEDBACK_TITLE": "Beceriler geri bildirimi",
      "KNOWLEDGE_CHECK_SCORING_DESCRIPTION": "Bilgi Kontrolü simülasyonları, her soru için kapsanan cevap puanlarının yüzdesine göre puanlanır. Niteliksel geri bildirim almak için aşağıdan bir beceri değerlendirme ölçeği seçin.",
      "KNOWLEDGE_CHECK_SCORING_RESCORE_DESCRIPTION": "Simülasyonu en az bir kez test ettikten sonra, puanınızı görüntülemek için “Son oturumumu puanla” seçeneğini belirleyin. Cevap puanlarını düzenlerseniz aynı oturumu yeniden puanlayabilirsiniz. Soruları düzenlerseniz puanlama yapmadan önce yeni bir test oturumu gerçekleştirmeniz gerekir.",
      "KNOWLEDGE_CHECK_SKILLS_RUBRIC_LABEL": "Beceri Değerlendirme Ölçeği (isteğe bağlı)",
      "SIMULATION_TYPE_MODAL_TITLE": "Yeni simülasyon oluştur",
      "SIMULATION_TYPE_MODAL_DESCRIPTION": "Öğrencilerinizin nasıl pratik yapacağını seçin.",
      "SIMULATION_TYPE_ROLE_PLAY_TITLE": "Rol Canlandırma",
      "SIMULATION_TYPE_ROLE_PLAY_DESCRIPTION": "Öğrenciler, söylediklerine doğal bir şekilde yanıt veren bir yapay zeka karakteriyle açık bir görüşme yürütür.",
      "SIMULATION_TYPE_ROLE_PLAY_BEST_FOR": "En uygun kullanım alanı: satış görüşmeleri, örneğin, satış sunumları ve itirazların ele alınması gibi konularda gerçekçi alıştırmalar yapmak.",
      "SIMULATION_TYPE_KNOWLEDGE_CHECK_TITLE": "Bilgi Kontrolü",
      "SIMULATION_TYPE_KNOWLEDGE_CHECK_DESCRIPTION": "Bir yapay zeka karakteri, yazdığınız soruları belirlediğiniz sırayla öğrencilere sorar.",
      "SIMULATION_TYPE_KNOWLEDGE_CHECK_BEST_FOR": "En uygun kullanım alanı: ürün bilgisini test etmek ve satış temsilcilerinin hazır olduğunu onaylamak.",
      "TAGS_FILTER_LABEL": "Etiketler",
      "TAGS_FILTER_PLACEHOLDER": "Etiket seç",
      "CLEAR_ALL_FILTERS": "Tüm filtreleri temizle",
      "LAST_SAVED_LABEL": "Son kaydedilen",
      "BUTTON_OK": "Tamam",
      "KEYWORDS_RESET_TO_PRODUCT_DEFAULT": "Ürün varsayılanına sıfırla",
      "KEYWORDS_DETACH_FROM_PRODUCT_DEFAULT": "Ürün varsayılanından ayır",
      "KEYWORDS_SAVE_AS_PRODUCT_DEFAULT": "Ürün varsayılanı olarak kaydet",
      "KEYWORDS_SAVE_AS_DEFAULT_OVERWRITE": "Bu işlem, {{ moduleName }} ürünü için varsayılan {{ keywordTitle }} değerinin üzerine yazacaktır.",
      "KEYWORDS_SAVE_AS_DEFAULT_IMPACT": "Bu kelimeler, {{ moduleName }} için yeni simülasyonlara eklenecektir. {{ moduleName }} ürününe yönelik tüm görüşmeler etkilenir.",
      "KEYWORDS_ADD_NEW_WORD": "Yeni kelime ekle",
      "KEYWORDS_FROM_LABEL": "Orijinal",
      "KEYWORDS_TO_LABEL": "Yeni",
      "KEYWORDS_PRONOUNCE_TITLE": "Kelimeleri telaffuz et",
      "KEYWORDS_PRONOUNCE_DESCRIPTION": "Yapay zeka temsilcisinin adları/terimleri doğru telaffuz etmesi için telaffuz düzeltmeleri sağlayın. Temsilci, yaygın telaffuz hatalarını/varyantları Yeni telaffuza eşler.",
      "KEYWORDS_PRONOUNCE_NAME": "kelimeleri telaffuz et",
      "KEYWORDS_ADD_MISPRONUNCIATION": "Yanlış telaffuz ekle",
      "KEYWORDS_SELECT_PERSONA_NOTICE": "Kelime telaffuzu eklemek için lütfen bir persona seçin.",
      "KEYWORDS_REPLACE_TITLE": "Kelimeleri değiştir",
      "KEYWORDS_REPLACE_DESCRIPTION": "Kullanıcı transkript metni için açık bul-ve-değiştir düzeltmeleri, fonetik düzeltmeden önce gerçekleşen doğrudan kelime yenilemeleri.",
      "KEYWORDS_REPLACE_NAME": "kelimeleri değiştir",
      "KEYWORDS_ADD_REPLACEMENT": "Yenileme ekle",
      "KEYWORDS_STT_TITLE": "STT kelimeleri",
      "KEYWORDS_STT_DESCRIPTION": "Konuşmadan Metne (STT) sağlayıcılarına (ör. AssemblyAI, Tavus) sağlanan, özellikle STT sağlayıcı yapılandırması için hazırlanmış kelime listesi.",
      "KEYWORDS_STT_NAME": "stt kelimeleri",
      "KEYWORDS_GENERATING": "Oluşturuluyor...",
      "KEYWORDS_GENERATE_STT_PROMPT": "stt_prompt oluştur",
      "KEYWORDS_STT_PROMPT_OUTDATED": "Bu istem oluşturulduğundan beri kelime listesi güncellenmiştir. En son değişiklikleri yansıtmak için yeniden oluşturun.",
      "KEYWORDS_STT_CANNOT_SAVE_HEADING": "Ürün Düzeyinde Kaydedilemez",
      "KEYWORDS_STT_CANNOT_SAVE_BODY": "STT kelimeleri ve istem, ürün düzeyinde kaydedilemez. Diğer simülasyon STT yapılandırmalarını manuel olarak değiştirebilir veya yardım için yöneticinize başvurabilirsiniz.",
      "KEYWORDS_CLEAN_TRANSCRIPT_TITLE": "Transkript kelimelerini temizle",
      "KEYWORDS_CLEAN_TRANSCRIPT_DESCRIPTION": "CLEAN_TRANSCRIPT_V2 istemine eklenen kelimeler.",
      "KEYWORDS_CLEAN_TRANSCRIPT_NAME": "transkript kelimelerini temizle",
      "KEYWORDS_CALL_TITLE": "Görüşme kelimeleri",
      "KEYWORDS_CALL_DESCRIPTION": "Fonetik düzeltme için doğru kelimelerden oluşan sözlük. Double Metaphone algoritması tarafından fonetik olarak benzer yazım hatalarını düzeltmek için kullanılır. \"Anti MuSK AB+\" gibi çok kelimeli terimlerden kaçının. Çünkü kod tabanlı transkript düzeltici yalnızca tek kelimelerle güvenilir şekilde çalışır. Ayrıca, düzelticiyi karıştırma eğilimi gösterdiklerinden sembol (ör. \"lp(a)\") kullanmaktan kaçının. Bu işlem, bir LLM yerine deterministik bir algoritma tarafından gerçekleştirildiğinden ve bağlamsal anlama yeteneği bulunmadığından liste mümkün olduğunca küçük ve basit tutulmalıdır.",
      "KEYWORDS_CALL_NAME": "görüşme kelimeleri"
    },
    "settings": {
      "DEVICE_SETUP_INTRO": "Cihazınızın konfigüre edildiğinden emin olalım.",
      "MICROPHONE_REQUIRED_NOTICE": "Çalışır durumda bir mikrofon gereklidir.",
      "DEVICE_ENABLE_INSTRUCTIONS": "Bu sayfayı yeniledikten sonra cihazlarınızı etkinleştirmeniz talebinde bulunan bir açılır pencere görmediyseniz lütfen sistem veya tarayıcı ayarlarınıza gidin ve cihazlarınızı etkinleştirin. Aşağıda daha ayrıntılı talimatlar içeren destek sayfaları bulunmaktadır.",
      "ENABLE_CAMERA": "Kameranızı etkinleştirme:",
      "WINDOWS_USERS": "Windows kullanıcıları",
      "MAC_USERS": "Mac kullanıcıları",
      "IPAD_USERS": "iPad kullanıcıları",
      "ENABLE_MICROPHONE": "Mikrofonunuzu etkinleştirme:",
      "ENABLE_DEVICES_BY_BROWSER": "Tarayıcı üzerinden cihazlarınızı etkinleştirme:",
      "CHROME_USERS": "Chrome kullanıcıları",
      "SAFARI_USERS": "Safari kullanıcıları",
      "FIREFOX_USERS": "Firefox",
      "EDGE_USERS": "Edge",
      "START_WITHOUT_CAMERA_BUTTON": "Kamera olmadan başlat",
      "START_CALL_BUTTON": "Görüşmeyi Başlat",
      "MICROPHONE_REQUIRED_WARNING": "Çalışır durumda bir mikrofon gereklidir.",
      "MICROPHONE_ALT": "mikrofon",
      "MICROPHONE": "Mikrofon",
      "SELECT_MICROPHONE": "Mikrofonunuzu Seçin",
      "ALERT": "uyarı",
      "GIVE_PERMISSION": "İzin Ver",
      "SELECT_VIDEO_DEVICE": "Video Cihazınızı Seçin",
      "VIDEO": "video",
      "DEVICE_BLOCKED_ERROR": "Görünüşe göre bu tarayıcının bir veya daha fazla cihazınıza erişimini engellediniz. Cihazları etkinleştirmek için lütfen sistem ayarlarınıza veya tarayıcı ayarlarınıza gidin ve erişimi etkinleştirin.",
      "DEVICE_SETTINGS": "Cihaz ayarları",
      "CONFIRM_SETTINGS": "Ayarları Onayla",
      "LAPTOP": "Dizüstü bilgisayar",
      "SAD_EMOTE_FACE": "Üzgün Yüz İfadesi",
      "GRANT_BROWSER_ACCESS": "Bu simülasyonu tamamlamak için lütfen tarayıcınızın Konuşma Tanıma özelliğine erişim izni verin",
      "USING_IPAD": "iPad kullanıyorsanız şuraya gidin:",
      "SETTINGS": "Ayarlar",
      "PRIVACY_AND_SECURITY": "Gizlilik ve Güvenlik",
      "SPEECH_RECOGNITION": "Konuşma Tanıma",
      "GRANT_ACCESS_REFRESH": "Tarayıcıya erişim izni verin ve sayfayı yenileyin",
      "REFRESH_PAGE": "SAYFAYI YENİLE",
      "BROWSER_UNABLE_TO_ACCESS": "Tarayıcı bu cihaza erişemiyor",
      "ACCESS_DENIED": "erişim reddedildi",
      "CAMERA": "Kamera",
      "DIAGNOSTIC_PASSED": "Tüm tanılama testleri başarıyla tamamlandı.",
      "DIAGNOSTIC_FAILED_MESSAGE": "Bazı tanılama testleri başarısız oldu. Lütfen yukarıdaki \"Tanılama Sonuçlarını Kopyala\" düğmesine tıklayın ve yardım almak için sonuçları destek ekibine gönderin.",
      "DIAGNOSTIC_PARTIAL": "Tanılama testlerinin çoğu başarıyla tamamlandı. Bağlantınız iyi görünüyor.",
      "DIAGNOSTIC_RUNNING_MESSAGE": "Tanılama testleri çalışırken lütfen bekleyin...",
      "DIAGNOSTIC_RUNNING": "Tanılama Çalışıyor",
      "COPY_DIAGNOSTIC_RESULTS": "Tanılama Sonuçlarını Kopyala",
      "RUN_DIAGNOSTIC": "Tanılama Çalıştır",
      "RERUN_DIAGNOSTIC": "Tanılamayı Yeniden Çalıştır",
      "DIAGNOSTIC_RESULTS_COPIED": "Tanılama sonuçları panoya kopyalandı",
      "DIAGNOSTIC_FAILED": "Tanılama başarısız",
      "DIAGNOSTIC_WEBSOCKET_NOT_TESTED": "Websocket: not tested",
      "DIAGNOSTIC_TURN_NOT_TESTED": "TURN: not tested",
      "DIAGNOSTIC_QUALITY_NOT_TESTED": "Quality: not tested",
      "DIAGNOSTIC_QUANTIFIED_DIAGNOSTICS": "Sayısallaştırılmış Tanılama",
      "DIAGNOSTIC_TIME": "Zaman",
      "DIAGNOSTIC_SUMMARY": "Özet",
      "DIAGNOSTIC_CLIENT_INFO": "İstemci bilgileri",
      "DIAGNOSTIC_PLATFORM": "Platform",
      "DIAGNOSTIC_RTT_AVG_MAX": "RTT avg/max",
      "DIAGNOSTIC_PACKET_LOSS_SEND": "Paket kaybı (gönderme)",
      "DIAGNOSTIC_AVG_SEND_BITRATE": "Ortalama gönderme bit hızı",
      "DIAGNOSTIC_NA": "yok",
      "DIAGNOSTIC_PROBLEMS_CONNECTING_PREFIX": "Bağlantı sorunu mu yaşıyorsunuz?",
      "DIAGNOSTIC_CLICK_HERE": "Buraya",
      "DIAGNOSTIC_TO_RUN_SUFFIX": "tıklayın ve bir tanılama yürütün."
    },
    "results": {
      "RETURN_HOME": "ANA SAYFAYA DÖN",
      "RETURN_TO_PATHWAY": "YOL HARİTASINA DÖN",
      "CLOSE_BUTTON": "Kapat Düğmesi",
      "CONVERSATIONAL_CALL": "ROL CANLANDIRMA",
      "INFORMATION_ICON": "Bilgi Simgesi",
      "TOOLTIP_ARROW": "Araç İpucu Oku",
      "INFORMATION_TOOLTIP_CONTENT": "Simülasyonun akışını kendiniz kontrol ederek görüşmeyi bir dizi hedefe doğru yönlendirirsiniz. Rol canlandırmaları, konuyu derinlemesine irdeleme ve ikinci düzey sorular sorma, sorunlu noktaları ortaya çıkarma ve iyi bir ilişki kurma gibi becerileri test etmek için mükemmeldir.",
      "CLOCK_ICON": "Saat Simgesi",
      "CALL_RESULTS": "Sonuçlar",
      "QUIZ_RESULTS_SUMMARY": "Test Sonuçları Özeti",
      "PROCESSING_RESULTS": "Sonuçlar işleniyor...",
      "SKILLS": "Beceriler",
      "MESSAGE_ADHERENCE": "Mesajlara Uyum",
      "MESSAGING": "Mesajlaşma",
      "TRY_AGAIN_MESSAGE": "Tekrar deneyin ve puanınızı artırın.",
      "QUIZ_SUMMARY_BASE": "Biraz zaman ayırıp bu testteki performansınızı gözden geçirin.",
      "QUIZ_SUMMARY_FAILED": "Biraz zaman ayırıp bu testteki performansınızı gözden geçirin. Bir sonraki denemenize daha iyi hazırlanmak için yol haritasına genel bakış ekranında vurgulanan {{stepNames}} {{stepWord}} gözden geçirin.",
      "QUIZ_SUMMARY_PASSED_WITH_MISSES": "Biraz zaman ayırıp bu testteki performansınızı gözden geçirin. {{stepNames}} {{stepWord}} {{stepVerb}} en düşük puan aldığınız {{areaWord}}.",
      "PRACTICE_BENEFITS": "Haftalık alıştırmalar özgüveninizi artırır ve gerçek hayattaki sonuçlarınızı iyileştirir.",
      "CALL_SUCCESS": "Harika iş çıkardınız! Bu simülasyonu başarıyla tamamladınız.",
      "MAX_ATTEMPTS_REACHED": "Maksimum deneme sayısına ulaştınız",
      "TRY_AGAIN": "Tekrar Dene",
      "GREAT_JOB_YOU_SUCCESSFULLY": "Harika iş çıkardınız! Başarıyla",
      "COMPLETED_THIS_CALL": "bu simülasyonu tamamladınız.",
      "ACHIEVED_SCORE": "Elde ettiğiniz puan:",
      "ACHIEVE_SCORE": "Elde etmeniz gereken puan:",
      "OR_HIGHER": "veya üstü.",
      "OBJECTIVES_NOT_MET": "Gerekli tüm hedefleri yerine getirmediniz.",
      "TRY_AGAIN_TARGET_SCORE": "Tekrar deneyerek şu puanı elde edin:",
      "YOUR_SCORE": "Puanınız",
      "OUT_OF_5": "5 ÜZERİNDEN",
      "OUT_OF_100": "100 ÜZERİNDEN",
      "CALL_FEEDBACK": "GERİ BİLDİRİM ÖZETİ",
      "STRENGTH_ICON_ALT": "Güç Simgesi",
      "OPPORTUNITIES_ICON_ALT": "Fırsatlar Simgesi",
      "OBJECTIVES_FEEDBACK": "METODOLOJİ HAKKINDA GERİ BİLDİRİM",
      "SESSION_ID": "Oturum Kimliği:",
      "SESSION_ID_COPIED": "Oturum Kimliği kopyalandı!",
      "OBJECTIVE": "METODOLOJİ:",
      "HOW_YOU_DID": "Performansınız:",
      "LIGHTBULB_ICON_ALT": "Ampul Simgesi",
      "WHAT_WE_SUGGEST": "Önerimiz:",
      "NO_SPECIFIC_RECOMMENDATION": "Sistemimiz size özel bir öneri bulamadı.",
      "WHY": "Neden?",
      "NO_INSIGHTS_AVAILABLE": "Sistemimiz bu öneri hakkında bilgi sağlayamadı.",
      "CONFETTI_ICON_ALT": "Konfeti Simgesi",
      "OBJECTIVE_SUCCESS_MESSAGE": "Bu metodolojide harika bir iş çıkardınız, böyle devam edin!",
      "PROCESSING_CALL": "Puanınızı ve geri bildiriminizi hazırlıyoruz.",
      "HANG_TIGHT": "Biraz bekleyin veya daha sonra tekrar kontrol ederek",
      "VIEW_YOUR_RESULTS": "sonuçlarınızı görüntüleyin.",
      "NEED_MORE_TIME": "Sonuçları hesaplamak için biraz daha zamana ihtiyacımız var.",
      "REFRESH_INSTRUCTION": "Lütfen birkaç dakika sonra tekrar kontrol edin veya atama",
      "RESULTS_IN_FEW_MINUTES": "sonuçlarını yenileyin.",
      "QUIZ_RESULTS_LOADING": "Sonuçların yüklenmesi biraz zaman alıyor. Yol haritasından çıkın. Sonuçlar hazır olduğunda sizi bilgilendireceğiz.",
      "KC_TOAST_TITLE": "Bilgi kontrolü sonuçlarınız işlendi",
      "KC_TOAST_TITLE_PATHWAY": "{{stepName}} bilgi kontrolü sonuçlarınız işlendi",
      "KC_TOAST_CONTENT": "Görüntülemek için aşağıya tıklayın veya bir sonraki adımınız için yol haritası ayrıntıları ekranına geri dönün.",
      "DISMISS": "Kapat",
      "SCORE_CALCULATION_QUESTION": "Bu nasıl hesaplanır?",
      "SINGLE_SCORE_EXPLANATION": "Bu simülasyonda tek bir puan bileşeni olduğundan, görüntülenen puan hem münferit bölüm puanınızı hem de genel puanınızı gösterir.",
      "OVERALL_SCORE_PERCENT": "(genel puana göre)",
      "SECTION_SCORE": "Bölüm puanı",
      "ELEVATE_MESSAGE_ADHERENCE_TITLE": "Görüşme mesajlarına uyumunuzu artırın",
      "MESSAGE_ADHERENCE_NOTE": "Mesajlara uyum, başarılı görüşmeler yürütmek için çok önemlidir ancak genel puanınızı etkilemez.",
      "NO_CREDIT": "Kredi yok",
      "PARTIAL_CREDIT": "Kısmi kredi",
      "FULL_CREDIT": "Tam kredi",
      "WHAT_YOU_DID_WELL": "Başarılı olduğunuz noktalar",
      "MISSED_ALL_KEY_POINTS": "Tüm önemli noktaları kaçırdınız, bunları gözden geçirip tekrar deneyin.",
      "WHAT_TO_IMPROVE": "Daha başarılı olabileceğiniz noktalar",
      "PERFECT_SCORE_MESSAGE": "Tebrikler! Mükemmel bir puan aldınız, tüm önemli noktalara doğru bir şekilde değindiniz.",
      "POINTS_LABEL": "Noktalar",
      "TALKING_POINTS_COVERED": "Ele alınan konu başlıkları",
      "COVERED": "Ele alınan",
      "CHECKMARK_ICON_ALT": "onay işareti",
      "TALKING_POINTS_MISSED": "Eksik kalan konu başlıkları",
      "MISSED": "Atlanan",
      "X_ICON_ALT": "x",
      "PRACTICE_AGAIN": "Tekrar alıştırma yap",
      "OUT_OF": "/",
      "OBJECTIVES": "Metodoloji",
      "ELEVATE_OBJECTIVES_TITLE": "Görüşme metodolojinizi geliştirin",
      "OBJECTIVES_NOTE": "Metodoloji, başarılı görüşmeler yürütmek için çok önemlidir ancak genel puanınızı etkilemez.",
      "UNTIL": "Son tarih",
      "TO_IMPROVE_SCORE": "öncesinde puanınızı iyileştirin.",
      "YOU_HAVE": "Son",
      "MORE_ATTEMPTS": "deneme hakkınız var ve puan ölçütü",
      "OR_HIGHER_BEFORE": "veya üstü, son tarih",
      "AND_TRY_AGAIN": "ve tekrar deneyin.",
      "UNEXPECTED_STATE": "Beklenmeyen bir durum oluştu.",
      "REVIEW_APP_LOGIC": "Lütfen uygulamanın mantığını gözden geçirin.",
      "ASSIGNMENTS": "Atamalar",
      "VIEW_CALL_DETAILS": "Görüşme ayrıntılarını görüntüle",
      "PRACTICE_SESSION": "Alıştırma oturumu",
      "OVERALL_SCORE": "Genel puan",
      "OVERALL_SCORE_EXPLANATION": "Toplam puan, her bölümün puanının ağırlıklı ortalaması alınarak hesaplanır. Her bölümün ağırlığı, puanın yanında yüzde olarak gösterilir.",
      "SCORE_CONFIG_NOTE": "Ağırlık yüzdeleri ile bölümlerin dahil edilmesi veya hariç tutulması, şirketiniz tarafından belirlenir. Tüm puanlar, en yakın ondalık basamağa yuvarlanır.",
      "STRENGTHS": "Güçlü Yönler",
      "OPPORTUNITIES": "Fırsatlar",
      "YOUR_RESPONSE": "Yanıtınız",
      "MINUS": "eksi",
      "PLUS": "artı",
      "RECOMMENDED_RESPONSE": "Önerilen Yanıt",
      "REVIEW_MISSED_TITLE": "Kaçırdığınız kısımları gözden geçirin.",
      "NO_TALKING_POINTS_COVERED": "Bu konuyla ilgili gerekli konu başlıklarının hiçbirine değinmediniz.",
      "LEARN_WHAT_YOU_MISSED": "Kaçırdıklarınızı Öğrenin",
      "NICE_JOB": "Tebrikler!",
      "ALL_POINTS_COVERED": "Bu konuyla ilgili gerekli tüm konu başlıklarını başarıyla ele aldınız.",
      "COVER_ALL_MESSAGES": "Tüm önemli mesajları ele alın.",
      "HIGHLIGHT_KEY_POINTS_NOTE": "Görüşme boyunca önemli noktaları vurgulamak, görüşmede konulardan sapmamaya yardımcı olacaktır.",
      "MESSAGES_LABEL": "Mesajlar",
      "NO_FACTS_COVERED": "Tüh! Görünüşe göre bu mesajdaki hiçbir bilgiyi ele almamışsınız.",
      "NO_SPECIFICS_AVAILABLE": "Tüh! Görünüşe göre, nelerin atlandığına dair ayrıntılı bilgi veremedik.",
      "ALL_KEY_POINTS_COVERED": "Harika iş çıkardınız! Tüm önemli noktalara değindiniz.",
      "PROCESSING_SKILLS_FEEDBACK": "Beceri geri bildiriminizi işliyoruz.",
      "SKILLS_SCORING_NOT_ENABLED": "Üzgünüz ancak gönderim sırasında beceri puanlaması etkinleştirilmediğinden son görüşmenizi analiz edemedik. Geri bildirim almak için, daha önce yaptığınız gibi görüşme alıştırmanızı yeniden göndermeniz yeterlidir. Yardıma ihtiyacınız olursa destek ekibimizle iletişime geçmekten çekinmeyin. Anlayışınız ve kendinizi geliştirme konusundaki kararlılığınız için teşekkür ederiz!",
      "ELEVATE_CONVERSATION_SKILLS": "Görüşme Becerilerinizi Geliştirin",
      "SKILLS_NOTE": "Beceriler, başarılı görüşmeler yürütmek için çok önemlidir ancak genel puanınızı etkilemez.",
      "SKILLS_SUMMARY_TITLE": "BECERİLER ÖZETİ",
      "LEARN_MORE_ABOUT_SKILLS": "Beceriler hakkında daha fazla bilgi edinin",
      "SKILLS_FEEDBACK_LABEL": "GERİ BİLDİRİM",
      "WHAT_ARE_SKILLS_TITLE": "Beceriler Nedir?",
      "SKILLS_DESCRIPTION": "Beceriler, kişisel gelişiminizi desteklemek amacıyla tasarlanmıştır. Bu beceriler, görüşmenizin sayısal değerlendirmesinin bir parçası olmasa da, etkinliğinizi artırmak amacıyla kuruluşunuz tarafından seçilmiştir.",
      "PROFICIENCY_SCALE_TITLE": "YETERLİLİK ÖLÇEĞİ",
      "EXPERT": "Uzman",
      "PROFICIENT": "Yeterli",
      "DEVELOPING": "Gelişmekte",
      "CALL_TRANSCRIPT": "Görüşme transkripti",
      "COLLAPSE_ALL": "Tümünü Daralt",
      "EXPAND_ALL": "Tümünü Genişlet",
      "THUMBNAIL": "Küçük resim",
      "OUT_OF_FIVE_POINTS": "/5 puan",
      "TALKING_POINTS": "konu başlıkları",
      "TRANSCRIPT_LABEL": "Transkript",
      "YOU_ARE_OUT_OF_ATTEMPTS": "Deneme hakkınız bitti.",
      "REVIEW_GUIDELINES_REMAIN_COMPLIANT": "Yönergeleri gözden geçirin ve gelecekte kurallara uyun.",
      "TRY_AGAIN_ATTENTION_TO_COMPLIANCE": "Tekrar deneyin ve uygunluk yönergelerine dikkat edin.",
      "NO_SCORE_OUT_OF_COMPLIANCE": "Uygunluk dışı olabilecek bir durum tespit ettik",
      "WHY_OUT_OF_COMPLIANCE": "Neden yönergelere uymuyor olabilirsiniz?",
      "REVIEW_TRANSCRIPT_MISSED_GUIDELINES": "Transkriptinizi gözden geçirerek uygunluk yönergelerinde kaçırdığınız noktaları belirleyin.",
      "YOU_DID_FOLLOW_GUIDELINES": "Bu yönergelere etkili bir şekilde uydunuz.",
      "REVIEW_MISSED_GUIDELINES": "Kaçırdığınız uygunluk yönergelerini gözden geçirin.",
      "OUT_OF_COMPLIANCE": "Uygunluk dışı",
      "SCORE_CALCULATION_TITLE": "Puan hesaplaması",
      "PROCESSING_TRANSCRIPT": "Transkriptinizi işliyoruz.",
      "WAIT_OR_REVIEW_SCORES": "Sayfadan ayrılmayın veya transkript yüklenirken diğer puan",
      "TRANSCRIPT_LOADING": "bölümlerini gözden geçirin.",
      "REVIEW_FEEDBACK_KEEP_PRACTICING": "Geri bildiriminizi gözden geçirip alıştırma yapmaya devam edin,",
      "HIGH_PERFORMERS_PRACTICE": "Başarılı kullanıcılar haftada en az bir kez alıştırma yapıyor",
      "SUCCESSFULLY_PASSED": "Harika iş çıkardınız! Bu simülasyonu başarıyla geçtiniz.",
      "DIDNT_REACH_PASSING_SCORE": "Bu simülasyonda geçme puanına ulaşamadınız.",
      "OUT_OF_ATTEMPTS": "<b>Deneme hakkınız bitti.</b> Nasıl gelişebileceğinizi öğrenmek için geri bildiriminizi gözden geçirin.",
      "REVIEW_FEEDBACK_THEN_RETURN": "Geri bildiriminizi gözden geçirin, ardından hazır olduğunuzda ana sayfaya dönün.",
      "GREAT_JOB_PRACTICED": "Harika iş çıkardınız, {{count}} {{times}} alıştırma yaptınız. Aynen devam edin!",
      "TIME": "kez",
      "TIMES": "kez",
      "COMPLIANCE_GUIDELINES": "Uygunluk yönergeleri",
      "TALKING_POINT_TITLE": "EKSİK KALAN VEYA YANLIŞ ZAMANDA ELE ALINAN KONU BAŞLIKLARI",
      "NO_TRANSCRIPT": "Transkript mevcut değil.",
      "RETURN_TO_ASSIGNMENT": "Atamaya geri dön",
      "NONE_PERFECT": "Yok - Mükemmel!",
      "MISSED_ONE_TALKING_POINT": "Bu konu için 1 konu başlığını atladınız.",
      "MISSED_X_TALKING_POINTS": "Bu konu için {{count}} konuşma başlığını atladınız.",
      "MISSED_ONE_REQUIRED_TALKING_POINT": "Bu konu için 1 gerekli konu başlığını atladınız",
      "MISSED_X_REQUIRED_TALKING_POINTS": "Bu konu için {{count}} gerekli konuşma başlığını atladınız",
      "MISSED_ALL_ONE_REQUIRED_TALKING_POINT_TITLE": "Bu konu için 1 gerekli konu başlığını atladınız.",
      "MISSED_ALL_X_REQUIRED_TALKING_POINTS_TITLE": "Bu konu için {{count}} gerekli konuşma başlığını atladınız.",
      "REVIEW_MATERIAL_NEXT_TIME": "Bir dahaki sefere daha başarılı olabilmek için materyali gözden geçirin.",
      "ROLEPLAY_POST_CALL_TITLE": "Bu görüşmenin sonuna geldiniz.",
      "ROLEPLAY_POST_CALL_SUBTITLE_PROCESSING": "Sonuçlarınız işlenirken lütfen geri bildirim bırakın.",
      "ROLEPLAY_POST_CALL_SUBTITLE_DELAY": "Sonuçların yüklenmesi biraz zaman alıyor. Yol haritasından çıkın. Sonuçlar hazır olduğunda sizi bilgilendireceğiz.",
      "ROLEPLAY_POST_CALL_SUBTITLE_ERROR": "Sonuçlarınız işlenirken bir hata oluştu. Lütfen destek ekibiyle iletişime geçin:",
      "ROLEPLAY_POST_CALL_PROCESSING_LABEL": "Sonuçlar işleniyor...",
      "ROLEPLAY_POST_CALL_FEEDBACK_QUESTION": "Bu görüşme size gerçekçi ve doğal geldi mi?",
      "FEEDBACK_THANK_YOU": "Geri bildiriminiz için teşekkür ederiz!",
      "FEEDBACK_IMPROVEMENT_NOTE": "Geri bildiriminiz için teşekkür ederiz! Deneyimi iyileştirme konusunda çalışacağız.",
      "VIEW_RESULTS": "Sonuçları Görüntüle",
      "FEEDBACK_IMPROVEMENT_SUFFIX": "Deneyimi iyileştirme konusunda çalışacağız.",
      "POINT_LABEL": "Puan",
      "GREAT_JOB_PRACTICED_FEMALE": "Harika iş çıkardınız, {{count}} {{times}} alıştırma yaptınız. Aynen devam edin!",
      "ACCURACY": "Doğruluk",
      "ACCURACY_LOADING": "Yükleniyor...",
      "ACCURACY_FLAGGED_MESSAGE": "Kaynak materyallerinizden farklı olabilecek bazı şeyler söylediniz. Daha fazla ayrıntı için aşağıya bakın.",
      "ACCURACY_ALL_CLEAR": "Kaynak materyallerle çelişen hiçbir iddia tespit etmedik.",
      "ACCURACY_ERROR": "Bu oturumla ilgili geri bildirimde bulunulamadı",
      "ACCURACY_YOU_SAID": "SİZİN İFADENİZ",
      "ACCURACY_CLAIM_IDENTIFIED": "TESPİT ETTİĞİMİZ İDDİA",
      "ACCURACY_MATERIALS_STATE": "MATERYALLERİNİZDE BELİRTİLEN",
      "ACCURACY_OVERALL_BLOCK_PREFIX": "Bazı ifadeleriniz yanlış olabilir. Daha fazla ayrıntı için ",
      "ACCURACY_OVERALL_BLOCK_LINK": "doğruluk",
      "ACCURACY_OVERALL_BLOCK_SUFFIX": " sekmesine göz atın.",
      "PRACTICE_SIMULATION_AGAIN": "Tekrar simülasyon alıştırması yap",
      "CALL_TYPE_CONVERSATIONAL": "Sohbet Niteliğinde Görüşme",
      "CALL_TYPE_GUIDED": "Rehberli Görüşme",
      "CALL_TYPE_VISUAL_AID": "Görsel Yardımlı Görüşme",
      "CALL_TYPE_ROLEPLAY": "Rol Canlandırmalı Görüşme",
      "PERSONALIZED_PRACTICE_BREADCRUMB": "Kişiselleştirilmiş alıştırma",
      "CONVERSATION_TYPE_LABEL": "Görüşme türü:",
      "DIFFICULTY_LABEL": "Zorluk derecesi:",
      "MOOD_LABEL": "Ruh hali:",
      "DIFFICULTY": "Zorluk derecesi",
      "TEMPERAMENT": "Karakter",
      "OVERALL_SCORE_TAB": "Genel",
      "MESSAGE_ADHERENCE_TAB": "Mesajlar",
      "OBJECTIVES_TAB": "Hedefler"
    },
    "reportingV2": {
      "DASHBOARD": "Gösterge Paneli",
      "LOADING_ACCOUNTS": "Hesaplar yükleniyor...",
      "SELECT_AN_ACCOUNT": "Hesap seç",
      "SELECT_ASSIGNMENTS": "Atama Seç",
      "SEARCH_TEAMS": "Ekip ara",
      "LOADING_TEAMS": "Ekipler yükleniyor...",
      "ALL_TEAMS": "Tüm ekipler",
      "ACCOUNT": "Hesap",
      "TEAMS": "Ekipler",
      "TEAM_LABEL": "Ekip",
      "TOTAL_LABEL": "Toplam",
      "PASSING_SCORE": "Geçme Puanı",
      "ASSIGNMENT_LABEL": "Atamalar",
      "USER_LABEL": "Kullanıcılar",
      "PRACTICE_LABEL": "Alıştırma",
      "CERTIFICATION_LABEL": "Sertifika",
      "CERTIFICATION_STATUS_LABEL": "Sertifika durumu",
      "CERTIFICATION_STATUS_PREFIX_LABEL": "Sertifika Durumu:",
      "CERTIFIED_ON_FIRST_ATTEMPT_LABEL": "İlk denemede sertifikalandırıldınız mı?",
      "DATE_OF_CERTIFICATION_LABEL": "Sertifika tarihi",
      "RESULTS_DESCRIPTION": "İşte tüm alıştırma atamalarında ekibinizin/ekiplerinizin sonuçları:",
      "ENGAGEMENT_BY_ASSIGNMENT": "Atamaya göre katılım",
      "ASSIGNMENT_ENGAGEMENT": "Atama Katılımı",
      "ENGAGED_LABEL": "Katılım",
      "ENGAGEMENT_STATUS_LABEL": "Katılım durumu",
      "ENGAGEMENT_STATUS_PREFIX_LABEL": "Katılım Durumu:",
      "PROFICIENT_LABEL": "Yeterli",
      "ASSIGNMENT_NAME": "Atama adı",
      "ACTIVE_USERS": "Aktif kullanıcılar",
      "ASSIGNMENT_PROGRESS": "Atamaya göre ilerleme durumu",
      "IN_PROGRESS_LABEL": "Devam ediyor",
      "CERTIFIED_LABEL": "Sertifikalı",
      "OUT_OF_ATTEMPTS_LABEL": "Deneme hakkı",
      "USERS_ENGAGED_LABEL": "Katılan kullanıcılar",
      "SESSIONS_PER_ACTIVE_USERS_LABEL": "Aktif kullanıcı başına oturum sayısı",
      "HIGHER_THAN_LABEL": "Şundan yüksek",
      "MORE_THAN_LABEL": "Şundan fazla",
      "TOTAL_SESSIONS_COMPLETED_LABEL": "Tamamlanan toplam oturum sayısı",
      "USER_CERTIFIED": "Tüm atamalarda sertifika alan kullanıcılar",
      "ASSIGNMENT_CERTIFICATION": "%100 sertifika içeren atamalar",
      "TRAINER_TIME_SAVED": "Eğitmenlerin tasarruf ettiği zaman",
      "HOURS_LABEL": "saat",
      "PRACTICE_ASSIGNMENT_LABEL": "Alıştırma Atamaları",
      "CERTIFICATION_ASSIGNMENT_LABEL": "Sertifika Atamaları",
      "START_DATE_LABEL": "Başlangıç tarihi",
      "END_DATE_LABEL": "Bitiş tarihi",
      "NAME_LABEL": "Ad",
      "EMAIL_LABEL": "E-posta",
      "MEMBER_OF_TEAMS_LABEL": "Ekip üyesi",
      "ASSIGNMENTS_COUNT_LABEL": "Atama sayısı",
      "TOTAL_SESSIONS_LABEL": "Toplam oturum sayısı",
      "NUMBER_OF_SESSIONS_LABEL": "Oturum sayısı",
      "TOTAL_USERS_LABEL": "Toplam Kullanıcı Sayısı",
      "AVERAGE_SCORE_LABEL": "Ortalama puan",
      "INITIAL_SCORE_LABEL": "Başlangıç puanı",
      "HIGH_SCORE_LABEL": "Yüksek puan",
      "LAST_PRACTICE_DATE_LABEL": "Son alıştırma tarihi",
      "PERCENT_IMPROVED_LABEL": "İyileşme yüzdesi",
      "PERCENT_IMPROVED_TOOLTIP_TEXT": "Bu metrik, kullanıcının başlangıç puanını en yüksek puanıyla karşılaştırır ve bu karşılaştırma, mümkün olan maksimum iyileşmenin yüzdesi olarak ifade edilir.",
      "ASSIGNMENTS_CERTIFIED_LABEL": "Sertifikalı atamaları",
      "ASSIGNMENTS_PROFICIENT_LABEL": "Yeterli atamaları",
      "ASSIGNMENTS_CERTIFIED_TOOLTIP_TEXT": "Kullanıcının atamadaki tüm simülasyonlarda puan ölçütlerini karşıladığı veya aştığı atamaların sayısı",
      "ASSIGNMENTS_PROFICIENT_TOOLTIP_TEXT": "Kullanıcının atamadaki tüm simülasyonlarda puan ölçütlerini en az bir kez karşıladığı veya aştığı atamaların sayısı",
      "PROFICIENT_TOOLTIP": "Bu atamadaki tüm simülasyonlarda puan kriterlerini en az bir kez karşılayan veya aşan kullanıcıların yüzdesi",
      "ENGAGED_TOOLTIP": "Bu atamadaki bir simülasyonun bir veya daha fazla oturumunu tamamlamış ancak henüz tüm simülasyonlarda yeterlilik düzeyine ulaşmamış kullanıcıların yüzdesi.",
      "IN_PROGRESS_TOOLTIP": "Bu atamadaki bir simülasyonun en az bir oturumunu tamamlayıp puan almış kullanıcıların yüzdesi",
      "OUT_OF_ATTEMPTS_TOOLTIP": "Atamadaki bir veya daha fazla simülasyon için kendilerine ayrılan deneme sayısını aşan kullanıcıların yüzdesi.",
      "CERTIFIED_TOOLTIP": "Atamadaki tüm simülasyonlarda puan ölçütlerini karşılayan veya aşan kullanıcıların yüzdesi.",
      "SEARCH_FOR_A_USER_LABEL": "Kullanıcı ara",
      "NO_USERS_FOUND_LABEL": "Kullanıcı bulunamadı",
      "TRAINER_TIME_SAVED_TOOLTIP": "Kullanıcıların Quantified'da sertifika denemelerini tamamlamak için harcadıkları süre.",
      "AVG_SESSIONS_PER_ASSIGNMENT": "Atama başına ortalama oturum sayısı",
      "ASSIGNMENTS_ENGAGED_WITH": "Katılım sağlanan atamalar",
      "AVERAGE_IMPROVEMENT": "Ortalama gelişme",
      "STATUS": "Durum",
      "ASSIGNMENT_STATUS": "Atama durumu",
      "STATUS_ACTIVE": "Etkin",
      "STATUS_ENDED": "Sona Erdi",
      "STATUS_CLOSED": "Kapatıldı",
      "STATUS_ARCHIVED": "Arşivlenmiş",
      "TOTAL_NUMBER_OF_SESSIONS": "Toplam oturum sayısı",
      "DATE_OF_LAST_PRACTICE": "Son alıştırma tarihi",
      "CALL_NAME": "Görüşme Adı",
      "SESSION_DATE": "Oturum tarihi",
      "DURATION_OF_SESSION": "Oturum süresi",
      "DURATION_OF_ATTEMPT": "Deneme süresi",
      "OVERALL_SCORE": "Genel puan",
      "MESSAGING_SCORE": "Mesajlara uyum puanı",
      "METHODOLOGY_SCORE": "Metodoloji puanı",
      "SKILLS_SCORE": "Beceri puanı",
      "SESSIONS": "Oturumlar",
      "TOTAL": "Toplam",
      "ALL_ASSIGNMENTS": "Tüm atamalar",
      "RECENT_ASSIGNMENTS": "Son atamalar",
      "USER_NAME": "Kullanıcı adı",
      "LEARNER": "Öğrenci",
      "DATE_RANGE": "Tarih Aralığı",
      "DATE_RANGE_LABEL": "Tarih aralığı",
      "SEARCH_USERS": "Kullanıcı ara...",
      "SEARCH_SIMULATIONS": "Simülasyon ara...",
      "SEARCH_DATES": "Tarih ara...",
      "SEARCH_ASSIGNMENTS": "Atama ara...",
      "CERTIFIED_ON_FIRST_TRY": "İlk denemede sertifika alındı",
      "DATE_OF_CERTIFICATION": "Sertifika tarihi",
      "AVERAGE_CERTIFICATION_SCORE": "Ortalama sertifika puanı",
      "TOTAL_TIME_CERTIFYING": "Sertifikalandırma için harcanan toplam süre",
      "OF_THE_TIME": "(toplamda)",
      "AVERAGE_SESSIONS_ACTIVE_USER": "Ortalama aktif kullanıcı oturumu",
      "HOURS_IN_SIMULATIONS": "Simülasyonlarda geçirilen saatler",
      "AVERAGE_SESSIONS_TO_PROFICIENCY": "Yeterlilik seviyesine ulaşana kadar geçen ortalama oturum sayısı",
      "PERCENT_PROFICIENT": "Yeterlilik yüzdesi",
      "SYSTEM_RUNNING_NORMALLY": "Sistem şu anda normal çalışıyor",
      "PRACTICE_SIMULATIONS_LABEL": "Simülasyonlar",
      "SIMULATION_NAME": "Simülasyon adı",
      "AVERAGE_DURATION_OF_SESSION": "Ortalama oturum süresi",
      "AVERAGE_SESSIONS_PER_ACTIVE_USER": "Aktif kullanıcı başına ortalama oturum sayısı",
      "NO_USERS_MATCHING_FILTERS_LABEL": "Filtrelerinize uyan sonuç bulunamadı. Aramayı genişletmek için bir veya daha fazla filtreyi kaldırmayı deneyin.",
      "USERS_PASSED": "Simülasyonu geçen kullanıcılar",
      "AVERAGE_TIME": "Sertifika alma için geçen ortalama süre",
      "USERS_OUT_OF_ATTEMPTS": "Deneme hakkı kalmayan kullanıcılar",
      "NO_CERTIFICATION_SIMULATION": "Sertifikasyon simülasyonu bulunamadı",
      "AVERAGE_OVERALL_SCORE": "Ortalama genel puan",
      "SIMULATION": "Simülasyon",
      "No_SIMULATION": "Oturum yok",
      "PERCENT_CERTIFIED": "Sertifikalandırılanların yüzdesi",
      "PERCENT_CERTIFIED_FIRST_ATTEMPT": "İlk denemede sertifikalandırılanların yüzdesi",
      "USERS": "Kullanıcılar",
      "ATTEMPTS_LABEL": "Deneme sayısı",
      "NO_ATTEMPTS": "Deneme yok",
      "DATE_OF_SESSION": "Oturum tarihi",
      "TOTAL_ASSIGNMENTS": "Toplam atama",
      "ASSIGNMENTS_CERTIFIED": "Sertifikalı atamaları",
      "TOTAL_SESSIONS": "Toplam oturum sayısı",
      "HOURS_SPENT_PRACTICING": "Alıştırmaya harcanan saatler",
      "LAST_LOGIN": "Son oturum açma",
      "NO_ASSIGNMENTS_MATCH_FILTERS": "Seçilen filtrelere uyan atama yok",
      "NO_TEAMS_DATA": "Bu hesapta hiçbir ekip yok",
      "ASSIGNED_LABEL": "Başlatılmadı",
      "USERS_ASSIGNED_LABEL": "Atanan toplam kullanıcı sayısı",
      "SESSION_ID": "Oturum Kimliği",
      "USER_NAME_LABEL": "Kullanıcı adı",
      "NO_SIMULATIONS_FOUND_LABEL": "Simülasyon Bulunamadı",
      "MIN": "dk",
      "SEC": "sn",
      "OF_LABEL": "/",
      "SECOND": "saniye",
      "SECONDS": "saniye",
      "MINUTE": "dakika",
      "MINUTES": "dakika",
      "ASSIGNMENT_NAME_LABEL": "Atama Adı",
      "SIMULATION_NAME_LABEL": "Simülasyon Adı",
      "START_DATE": "Başlangıç Tarihi",
      "END_DATE": "Bitiş Tarihi",
      "NO_ASSIGNMENTS": "Bu kullanıcı için atama bulunamadı.",
      "ASSIGNED": "Atandı",
      "TOTAL_PRACTICE_ASSIGNMENTS": "Toplam alıştırma atamaları",
      "SESSION_SCORES_OVER_TIME": "Zaman içindeki oturum puanları",
      "TIME": "Zaman",
      "SCORE": "Puan",
      "NO_SESSIONS_AVAILABLE": "Grafik oluşturulabilecek oturum yok.",
      "MESSAGING_SCORE_LABEL": "Mesajlaşma puanı",
      "PERSONALIZED_PRACTICE_LABEL": "Kişiselleştirilmiş alıştırma",
      "NO_PRODUCTS": "Seçilen ekipler için kişiselleştirilmiş alıştırma ürünü yok",
      "TOTAL_TIME_SPENT_PRACTICING": "Alıştırma için harcanan toplam süre",
      "AVERAGE_SESSIONS_PER_USER": "Kullanıcı başına ortalama oturum sayısı",
      "MOST_COMMON_CONVERSATION_TYPE_SELECTION": "En yaygın görüşme türü seçimi",
      "LEAST_COMMON_CONVERSATION_TYPE_SELECTION": "En az yaygın görüşme türü seçimi",
      "CLEAR": "Temizle",
      "CLEAR_TEAMS": "Ekipleri temizle",
      "METHODOLOGY_SCORE_DESCRIPTION": "Öğrencilerin önerilen görüşme yapısını ne kadar iyi takip ettiklerini ölçer. Puanlar, bu simülasyonun tüm oturumlarının ortalamasını yansıtır.",
      "METHODOLOGY": "Metodoloji",
      "MESSAGING": "Mesajlaşma",
      "MESSAGING_V2_DASHBOARD_DESCRIPTION": "Öğrencilerin görüşme sırasında ana fikirleri net bir şekilde ifade edip etmediklerini ölçer. Grafikler, tüm oturumlar genelinde tema başına doğru bir şekilde ifade edilen mesajların ortalama yüzdesini gösterir.",
      "NO_METRICS_MESSAGE": "İçgörüler elde etmek için daha fazla oturum gereklidir.",
      "SELECT_ALL": "Tümünü seç",
      "DESELECT_ALL": "Tümünün seçimini kaldır",
      "SKILLS": "Beceriler",
      "SKILLS_SCORE_STATS_DESCRIPTION": "Öğrencilerin görüşme sırasında temel becerileri ne kadar iyi sergilediğini ölçer. Puanlar, tüm oturumların ortalaması alınarak hesaplanan bir yapay zeka değerlendirmesini yansıtır.",
      "EXPERT": "Uzman",
      "PROFICIENT": "Yeterli",
      "DEVELOPING": "Gelişmekte",
      "FULLY_ARTICULATED": "Tamamen ifade edilmiş",
      "PARTIALLY_ARTICULATED": "Kısmen ifade edilmiş",
      "NOT_MENTIONED": "Bahsedilmedi",
      "MESSAGING_SCORE_STATS_DESCRIPTION": "Öğrencilerin görüşme sırasında ana fikirleri net bir şekilde ifade edip etmediklerini ölçer. Grafikler, tüm oturumlar genelinde her bir mesajın ne sıklıkla doğru bir şekilde ifade edildiğini gösterir.",
      "CLEAR_STATUS": "Durumu temizle",
      "CLEAR_USERS": "Kullanıcıları temizle",
      "CLEAR_SIMULATIONS": "Simülasyonları temizle",
      "CLEAR_ASSIGNMENTS": "Atamaları temizle",
      "MODAL_SUBHEADING": "{{ count }} hedefin tamamı - tüm oturumlar genelinde ortalama puanlar",
      "VIEW_ALL_OBJECTIVES": "{{ count }} hedefin tamamını görüntüle →",
      "LEAST_MISSED_QUESTION": "EN AZ YANLIŞ CEVAPLANAN SORU",
      "MOST_MISSED_QUESTION": "EN ÇOK YANLIŞ CEVAPLANAN SORU",
      "HIGHEST_SCORING_METHODOLOGY_SECTION": "EN YÜKSEK PUAN ALAN METODOLOJİ BÖLÜMÜ",
      "LOWEST_SCORING_METHODOLOGY_SECTION": "EN DÜŞÜK PUAN ALAN METODOLOJİ BÖLÜMÜ",
      "LEAST_ARTICULATED_MESSAGE": "EN AZ İFADE EDİLEN MESAJ",
      "ENGAGEMENT": "KATILIM",
      "USER_ENGAGEMENT_MORE_SESSIONS": "daha fazla oturum tamamlandı (ekip ortalamasına kıyasla)",
      "USER_ENGAGEMENT_FEWER_SESSIONS": "daha az oturum tamamlandı (ekip ortalamasına kıyasla)",
      "QUESTION_CORRECT_PERCENTAGE_DESC": "- toplamda buna doğru cevap verdikleri yüzde",
      "QUESTION_CORRECT_PERCENTAGE_DESC_ASSIGNMENT": "- toplamda kullanıcıların bunu doğru anladıkları yüzde",
      "METHODOLOGY_AVERAGE_POINTS_DESC": "tüm oturumlarda bu hedefe ilişkin ortalama puan",
      "MOST_ARTICULATED_MESSAGE": "EN ÇOK İFADE EDİLEN MESAJ",
      "LEAST_MISSED_ANSWER_POINT": "EN AZ YANLIŞ VERİLEN CEVAP PUANI",
      "MOST_MISSED_ANSWER_POINT": "EN ÇOK YANLIŞ VERİLEN CEVAP PUANI",
      "MOST_ARTICULATED_MESSAGE_DESCRIPTION": "- toplamda bu mesajı tam olarak ifade ettikleri yüzde",
      "LEAST_ARTICULATED_MESSAGE_DESCRIPTION": "- toplamda bu mesajı ifade ettikleri yüzde",
      "MOST_ARTICULATED_MESSAGE_DESCRIPTION_ASSIGNMENT": "- toplamda kullanıcıların bu mesajı ifade ettikleri yüzde",
      "LEAST_ARTICULATED_MESSAGE_DESCRIPTION_ASSIGNMENT": "- toplamda kullanıcıların bu mesajı ifade ettikleri yüzde",
      "OTHERS_SINGULAR": "ve 1 tane daha",
      "OTHERS_PLURAL": "ve {{ count }} tane daha",
      "PAGINATION_PREVIOUS": "Önceki",
      "PAGINATION_NEXT": "Sonraki",
      "HOUR_LABEL": "saat",
      "SESSIONS_LABEL": "oturumlar"
    },
    "personalizedPractice": {
      "TITLE": "Kişiselleştirilmiş Alıştırma",
      "DESCRIPTION": "Merhaba {{userFirstName}}! Kişiselleştirilmiş alıştırmalar, kendi senaryolarınızı olabildiğince gerçekçi olacak şekilde ayarlamanızı sağlar.",
      "LOADING": "Yükleniyor...",
      "VIEW_SESSIONS": "Oturumları görüntüle",
      "VIEW_SIMULATION": "Simülasyonu görüntüle",
      "TOTAL_SESSION": "toplam oturum",
      "TOTAL_SESSIONS": "toplam oturum",
      "BREADCRUMB": "Kişiselleştirilmiş alıştırma",
      "SCENARIO_DETAILS_TITLE": "Senaryo ayrıntıları",
      "SCENARIO_DETAILS_DESCRIPTION": "Simülasyonu ihtiyaçlarınıza göre ayarlamak için aşağıdaki seçeneklerden değişkenleri seçin.",
      "AVATAR": "Avatar",
      "SELECT_PLACEHOLDER": "Seç",
      "CONVERSATION_TYPE": "Görüşme türü",
      "SELECT_CONVERSATION_TYPE": "Görüşme türünü seç",
      "LAUNCH_SIMULATION": "Seçimlerle simülasyonu başlat",
      "PREVIOUS_SESSIONS": "Önceki oturumlar",
      "TOTAL": "Toplam",
      "FILTERS": "Filtreler:",
      "DATE": "Tarih",
      "DIFFICULTY": "Zorluk derecesi",
      "TEMPERAMENT": "Karakter",
      "SESSION_DATE": "Oturum tarihi",
      "SESSION_SCORE": "Oturum puanı",
      "DURATION": "Süre",
      "OVERALL_SCORE": "Genel puan",
      "MESSAGING": "Mesajlaşma",
      "METHODOLOGY": "Metodoloji",
      "SKILLS": "Beceriler",
      "RESULTS": "Sonuçlar",
      "VIEW_FEEDBACK": "Geri bildirimi görüntüle",
      "OVERALL_SCORE_LABEL": "Genel Puan",
      "SCORE": "Puan",
      "NO_PRODUCTS_TITLE": "Mevcut ürün yok",
      "NO_PRODUCTS_DESCRIPTION": "Henüz kişiselleştirilmiş alıştırma ürününüz yok.",
      "NO_SESSIONS_FOUND": "Seçilen filtrelere uyan oturum bulunamadı",
      "TIME": "Zaman",
      "ALL": "Tümü",
      "LEARNER": "Öğrenci",
      "MOOD": "Ruh hali",
      "CLEAR_FILTERS": "Filtreleri temizle",
      "PAGINATION_PREVIOUS": "Önceki",
      "PAGINATION_NEXT": "Sonraki",
      "DURATION_MINUTES_SECONDS": "{{minutes}} dk. {{seconds}} sn.",
      "DURATION_SECONDS": "{{seconds}} sn."
    },
    "login": {
      "TITLE": "Tekrar hoş geldiniz",
      "SUB_TITLE": "Nasıl oturum açmak istersiniz?  ",
      "LOGIN_WITH_SSO": "Şirket SSO'su ile oturum aç",
      "LOGIN_WITH_PASSWORD": "Şifre ile oturum aç",
      "PROVIDE_EMAIL": "E-posta adresinizi girin",
      "HELP_TEXT": "Yardıma mı ihtiyacınız var? İletişim kurun:",
      "EMAIL_ERROR": "Oturum açamıyoruz, lütfen şirket yöneticinizle veya BT departmanınızla iletişime geçin.",
      "EMAIL": "E-posta",
      "LOGIN": "Oturum Aç",
      "ALERT": "Uyarı",
      "EMAIL_PLACEHOLDER": "olivia@untitledui.com",
      "LOGIN_CONSENT_MESSAGE": "Hesabınızda oturum açarak {{termsLink}} ve {{privacyLink}} içeriğini kabul etmiş olursunuz.",
      "TERMS_OF_SERVICE": "Hizmet Şartları",
      "PRIVACY_POLICY": "Gizlilik Politikası",
      "WRONG_REGION_MESSAGE": "Oturum açamıyoruz, lütfen şirket yöneticinizle iletişime geçin.",
      "WRONG_REGION_LINK": "Ayrıca {{regionName}} sitesinde oturum açmayı da deneyebilirsiniz."
    },
    "learningPathway": {
      "BEGIN": "Başla",
      "SUBMIT_ANSWER": "Cevabı Gönder",
      "CONTINUE": "Devam Et",
      "REVIEW_MATERIAL": "Materyali gözden geçir",
      "ASK_QUESTIONS_ABOUT_PATHWAY": "Yol haritası hakkında soru sor",
      "DUE_DATE": "Son Teslim Tarihi",
      "FOOTER_SUBTITLE_READY": "Bana dilediğinizi sorabilirsiniz! Yardım etmeye hazırım.",
      "FOOTER_SUBTITLE_READY_LEARN_WITH_X": "Sorunuz varsa koç sizi dinliyor",
      "FOOTER_SUBTITLE_MUTED": "Şu anda sesiniz kapalı. Koç sizi duyamıyor.",
      "FOOTER_SUBTITLE_LISTENING": "Sorunuzu dinliyorum...",
      "FOOTER_SUBTITLE_THINKING": "Yanıt düşünüyorum...",
      "LEAVE_STEP": "Adımı Atla",
      "VIEW_CALL_DETAILS": "Görüşme ayrıntılarını görüntüle",
      "NEXT_STEP": "Sonraki Adım",
      "NOTIFICATIONS_ARIA": "Bildirimler",
      "PDF_LOADING": "PDF Yükleniyor",
      "PDF_NEXT_PAGE": "Sonraki sayfa",
      "PDF_NO_SOURCE": "PDF kaynağı sağlanmadı.",
      "PDF_PREVIOUS_PAGE": "Önceki sayfa",
      "PDF_SCROLL_HINT": "Okumaya devam etmek için kaydırın",
      "PDF_FULLSCREEN_ENTER": "Tam ekrana geç",
      "PDF_FULLSCREEN_EXIT": "Tam ekrandan çık",
      "PDF_ZOOM_IN": "Yakınlaştır",
      "PDF_ZOOM_OUT": "Uzaklaştır",
      "POST_CALL_SUBTITLE": "Sonuçlarınız işlenirken lütfen geri bildirim bırakın",
      "POST_CALL_TITLE": "Bu testin sonuna geldiniz.",
      "SETTINGS": "Ayarlar",
      "TOAST_CONTENT": "Görüntülemek için aşağıya tıklayın veya bir sonraki adımınız için yol haritası ayrıntıları ekranına geri dönün.",
      "TOAST_TITLE": "{{ stepName }} rol canlandırma sonuçlarınız işlendi",
      "ASSIGNMENTS": "Atamalar",
      "USER_FALLBACK": "Kullanıcı",
      "VIEW_RESULTS": "Sonuçları görüntüle",
      "DISMISS": "Kapat",
      "QUIZ_TITLE": "Test",
      "QUIZ_OVERALL_SCORE_TOOLTIP": "Genel puan, bu denemede verdiğiniz cevapların ağırlıklı ortalamasıdır.",
      "COLUMN_DATE": "Tarih",
      "COLUMN_OVERALL_SCORE": "Genel Puan",
      "COLUMN_RESULTS": "Sonuçlar",
      "COLUMN_ANSWER_POINTS": "Cevap puanları",
      "COLUMN_MESSAGING_SCORE": "Mesajlaşma Puanı",
      "COLUMN_METHODOLOGY_SCORE": "Metodoloji Puanı",
      "COLUMN_SKILLS_SCORE": "Beceri Puanı",
      "PRACTICE_AGAIN": "Tekrar alıştırma yap",
      "DEBRIEF_LATEST_SESSION": "Son oturumu değerlendir",
      "COMPLETE_STEP": "Tamamla",
      "ERROR_TITLE": "Bir sorun oluştu",
      "ERROR_MESSAGE": "Lütfen yol haritasından çıkıp yeniden girin. Sorun devam ederse şu adrese başvurun:",
      "ERROR_HELP_EMAIL": "help@quantified.ai",
      "PATHWAY_COMPLETED_TITLE": "Bu yol haritasını tamamladınız",
      "PATHWAY_COMPLETED_BODY": "Sonuçlarınızı istediğiniz zaman inceleyebilir veya alıştırma yapmaya devam etmek için herhangi bir adımı tekrar ziyaret edebilirsiniz.",
      "PATHWAY_COMPLETED_RETURN": "Atamalara geri dön",
      "PATHWAY_OUT_OF_ATTEMPTS_TITLE": "Yol haritasındaki bir adım için deneme hakkınız kalmadı",
      "PATHWAY_OUT_OF_ATTEMPTS_BODY": "Sonraki adımları görüşmek için yöneticinize başvurun.",
      "COMPLETED": "Tamamlandı",
      "EXITING_QUIZ_EARLY": "Bu testi şimdi kapatırsanız bir deneme olarak sayılacaktır",
      "TRY_AGAIN": "Tekrar Dene",
      "RETURN_TO_PATHWAY": "Yol haritasının ana sayfasına geri dön",
      "REVIEW_BEFORE_QUIZ_TOOLTIP": "Testi yeniden denemeden önce bu adımı gözden geçirin",
      "EXIT_MODAL_TITLE": "Bu rol canlandırmasını sonlandırmak istediğinizden emin misiniz?",
      "EXIT_MODAL_EXIT": "Çık",
      "EXIT_MODAL_RESUME": "Devam Et",
      "EXIT_MODAL_DESC_LIMITED_ATTEMPTS": "Rol canlandırmadan şimdi çıkarsanız canlandırma puanlanmayacak ancak yine de bir deneme olarak sayılacaktır.",
      "EXIT_MODAL_DESC_UNLIMITED_ATTEMPTS": "Rol canlandırmadan şimdi çıkarsanız canlandırma puanlanmayacaktır.",
      "EXIT_MODAL_DESC_SCORED": "Rol canlandırmadan şimdi çıkarsanız görüşmenizi olduğu gibi puanlayacağız.",
      "RESULTS_PROCESSING": "Sonuçlar işleniyor",
      "RESULTS_FAILED": "Sonuçlar yüklenemedi. help@quantified.ai adresine başvurun",
      "DEBRIEF_TITLE": "Değerlendirme",
      "DEBRIEF_DESCRIPTION": "Son sertifika denemenizin sonuçlarını tartışın",
      "DEBRIEF_DESCRIPTION_PRACTICE": "Son alıştırma oturumunuzun sonuçlarını tartışın",
      "VIEW_ALL_SESSIONS": "Tüm oturumları görüntüle",
      "COLLAPSE_SESSIONS": "Oturumları daralt",
      "VIEW_ALL_ATTEMPTS": "Tüm denemeleri görüntüle",
      "COLLAPSE_ATTEMPTS": "Denemeleri daralt",
      "REATTEMPT_CERTIFICATION": "Sertifika almayı yeniden dene",
      "DEBRIEF_EXIT_MODAL_TITLE": "Bu değerlendirmeyi sonlandırmak istediğinizden emin misiniz?",
      "DEBRIEF_EXIT_MODAL_DESC": "Değerlendirmeden şimdi çıkarsanız tamamlanmış olarak işaretlenmeyecektir.",
      "EXIT_PATHWAY": "Yol haritasından çık",
      "HELP": "Yardım",
      "DOWNLOAD": "İndir",
      "LEARN_STEP_HELP_CLOSE": "Kapat",
      "LEARN_STEP_HELP_TROUBLE": "Hâlâ sorun yaşıyorsanız şu adrese başvurun:",
      "LEARN_STEP_HELP_EMAIL": "help@quantified.ai",
      "LEARN_STEP_HELP_VIDEO_P1": "Materyali izleyin ve Koç'a sorularınızı sorun.",
      "LEARN_STEP_HELP_VIDEO_P2": "Videoyu başlatmak için oynat düğmesini seçin. Materyali yeniden gözden geçirmek için geriye doğru atlayabilirsiniz.",
      "LEARN_STEP_HELP_VIDEO_P3": "Soru sormak için sağ alt köşedeki ses açma düğmesine tıklayın. Bu işlem videoyu duraklatacaktır. Videoyu oynattığınızda mikrofonunuzu sessize alacağız.",
      "LEARN_STEP_HELP_VIDEO_P4": "Videonun tamamını izledikten sonra bir sonraki adıma geçin.",
      "LEARN_STEP_HELP_PDF_P1": "Materyali okuyun ve Koç'a sorularınızı sorun.",
      "LEARN_STEP_HELP_PDF_P2": "Sayfalar arasında gezinmek için kaydırma yapın veya her iki taraftaki ok düğmelerini kullanın.",
      "LEARN_STEP_HELP_PDF_P3": "Sağ alt köşeden mikrofonunuzu sessize alabilir veya sesini açabilirsiniz.",
      "LEARN_STEP_HELP_PDF_P4": "Her şeyi okuduktan sonra bir sonraki adıma geçin.",
      "ASSESSMENT_EXIT_MODAL_TITLE": "Devam etmek istediğinizden emin misiniz?",
      "ASSESSMENT_EXIT_MODAL_DESC": "Bu görüşme tamamlanmadan devam etmeniz, öğrenme deneyiminizin daha uzun sürmesine ve daha az kişiselleştirilmiş olmasına neden olacaktır.",
      "ASSESSMENT_EXIT_MODAL_RESUME": "Değerlendirmeye devam et",
      "ASSESSMENT_EXIT_MODAL_PROCEED": "Devam et",
      "ASSESSMENT_PERSONALIZATION_ERROR_TITLE": "Yol haritanızı kişiselleştiremedik",
      "ASSESSMENT_PERSONALIZATION_ERROR_DESC_START": "Size tam yol haritasını atadık. Kişiselleştirmeyi yeniden denemek istiyorsanız ",
      "ASSESSMENT_PERSONALIZATION_ERROR_DESC_END": " adresine başvurun.",
      "OPTIONAL": "İsteğe bağlı"
    },
    "leaderboard": {
      "LEADERBOARD": "Liderlik Tablosu",
      "TOP10PERCENT": "İlk %10",
      "PRACTICE_ASSIGNMENT": "Alıştırma Atamaları",
      "SIMULATION": "Simülasyon",
      "SELECT_ASSIGNMENT": "Atama seç",
      "SELECT_SIMULATION": "Simülasyon seç",
      "SELECT_ASSIGNMENT_AND_SIMULATION": "Liderleri görmek için bir atama ve simülasyon seçin",
      "NO_DATA": "Henüz hiçbir etkinlik yok. Ekip etkinliklere katılmaya başladığında, sıralamalar burada görünecektir.",
      "NO_ASSIGNMENTS_AVAILABLE": "Atama yok",
      "NO_SIMULATIONS_AVAILABLE": "Simülasyon yok",
      "NAME": "Ad",
      "HIGH_SCORE": "Yüksek puan",
      "AVERAGE_SCORE": "Ortalama puan",
      "TOTAL_SESSIONS": "Toplam oturum sayısı",
      "LAST_SESSION": "Son oturum",
      "TOP5": "İlk 5",
      "OF": "/",
      "ENGAGED_USERS": "katılan kullanıcı",
      "ENGAGED_USER": "katılan kullanıcı",
      "NO_USERS_ENGAGED": "Katılan kullanıcı yok",
      "HIDE_SESSIONS_WITH_LOW_SCORE": "Düşük beceri puanına sahip oturumları gizle",
      "SESSIONS_WITH_LOW_SCORE_TOOLTIP": "Beceri bölümü puanı \"gelişmekte\" olan oturumlar, yüksek veya ortalama puan sütunlarına dahil edilmez.",
      "PAGINATION_PREVIOUS": "Önceki",
      "PAGINATION_NEXT": "Sonraki"
    },
    "hotjarSurveys": {
      "FEEDBACK_MESSAGE": "Gelişimimize katkıda bulunmak için lütfen geri bildiriminizi paylaşın.",
      "THANK_YOU_MESSAGE": "Teşekkür ederiz, deneyiminizi iyileştirmek için çalışmaya devam edeceğiz"
    },
    "general": {
      "NEED_HELP_QUESTION": "Yardıma mı ihtiyacınız var?",
      "CONTACT": "İletişim kurun:",
      "HELP_EMAIL": "help@quantified.ai",
      "PARENT_ACCOUNT": "Üst Hesap",
      "ACCOUNT": "Hesap",
      "CHECKMARK": "Onay İşareti",
      "ICON": "Simge",
      "ALERT": "uyarı",
      "HEADS_UP": "Dikkat!",
      "USE_HEADPHONES_FOR_OPTIMAL_AUDIO": "iPad'de en iyi ses kalitesini elde etmek için lütfen kulaklık kullanın.",
      "SETTINGS": "AYARLAR",
      "RP": "RP",
      "EMAIL_LABEL": "E-posta",
      "RAVEN_EMAIL": "Raven@InspireHR.com",
      "TEAM_MANAGER_FOR": "Ekip Yöneticisi:",
      "MIAMI_SALE": "Miami Satış",
      "CHARLOTTE_SALES": "Charlotte Satış",
      "ATLANTA_SALES": "Atlanta Satış",
      "TEAM": "Ekip",
      "ASSIGNMENTS": "Atamalar",
      "MY_TEAMS": "Ekiplerim",
      "REPORTING": "Raporlama",
      "DASHBOARD": "Gösterge Paneli",
      "LEADERBOARD": "Liderlik Tablosu",
      "PERSONALIZED_PRACTICE": "Kişiselleştirilmiş Alıştırma",
      "HELP_SEARCH_OUR": "Sorularla ilgili olarak",
      "HELP_OR_REACH_OUT_TO": "arama yapın veya",
      "HELP_WITH_QUESTIONS": "adresine başvurun",
      "KNOWLEDGE_BASE": "bilgi bankamızda",
      "NO_ROLE_WEB_MESSAGE": "Bu kullanıcıya sisteme erişim izni verilmemiştir. Lütfen bir sistem yöneticisiyle iletişime geçin.",
      "NO_ROLE_IOS_TITLE": "Uygulamamız, öğrenci deneyimine odaklanmıştır",
      "NO_ROLE_IOS_BODY_START": "Mobil tarayıcınızda",
      "NO_ROLE_IOS_WEB_APP": "web uygulamamıza",
      "NO_ROLE_IOS_BODY_END": "erişerek ek işlevleri kullanın.",
      "HELP_SECTION": "YARDIM",
      "ABOUT_SECTION": "HAKKINDA",
      "CONTACT_SUPPORT": "Destek ile iletişime geçin",
      "OPEN_WEB_APP": "Web uygulamasını açın",
      "SEARCH_KNOWLEDGE_BASE": "Bilgi bankasında arama yapın",
      "PRIVACY_POLICY": "Gizlilik politikası",
      "TERMS_OF_SERVICE": "Hizmet şartları",
      "VERSION": "Sürüm",
      "LOG_OUT": "Oturumu kapat"
    },
    "dashboard": {
      "ALL": "Tümü",
      "IN_COMPLETE": "Tamamlanmamış",
      "COMPLETED": "Tamamlandı",
      "NO_ASSIGNMENT_TITLE": "Hiçbir atamanız yok.",
      "NO_ASSIGNMENT_DETAILS": "Tamamlamanız gereken atamalarınız olduğunda bilgilendirileceksiniz.",
      "IN_COMPLETE_ASSIGNMENT_TITLE": "Tamamlanmamış atamanız yok.",
      "IN_COMPLETE_ASSIGNMENT_DETAILS": "Yeni bir atamanın teslim tarihi geldiğinde bilgilendirileceksiniz.",
      "COMPLETED_ASSIGNMENT_TITLE": "Tamamlanmış atamanız yok.",
      "COMPLETED_ASSIGNMENT_DETAILS": "Bir atamayı tamamladıktan sonra tekrar kontrol edin.",
      "NO_ASSIGNMENT_FILTERED_TITLE": "Hiçbir atama bulunamadı.",
      "NO_ASSIGNMENT_FILTERED_DETAILS": "Mevcut atamaları görmek için filtrelerinizi ayarlamayı deneyin veya yeni atamalar eklendiğinde daha sonra tekrar kontrol edin.",
      "VIEW_ASSIGNMENT": "Atamayı Görüntüle",
      "VIEW_PATHWAY": "Yol haritasını görüntüle",
      "START_PATHWAY": "Yol haritasını başlat",
      "GET_STARTED": "Başlayın",
      "ASSIGNMENT_LABEL": "Atamalar",
      "MODULE_ASSIGNMENT_ALT": "Modül Atama Simgesi",
      "VIEW_ASSIGNMENT_FOR": "Şunun için atamayı görüntüle:",
      "DAY": "Gün",
      "DAYS": "Gün",
      "UNTILL_DUE": "Son Tarihe Kadar",
      "PAST_DUE": "Son Tarihi Geçmiş",
      "AVAILABLE_IN": "Mevcut olma durumu:",
      "DUE_TODAY": "Son Tarihi Bugün",
      "PRACTICE": "Alıştırma",
      "CERTIFICATION": "Sertifika",
      "UPCOMING": "Yaklaşan",
      "TEST_ASSIGNMENT": "Test Ataması",
      "CLOSED": "Kapatıldı",
      "ENDED": "Sona Erdi",
      "TOTAL": "Toplam",
      "ASSIGNMENT_STATUS_LABEL": "Atama durumu",
      "ASSIGNMENT_STATUS_SELECTION_LABEL": "Atama durumu:",
      "STATUS_SELECTION_LABEL": "Durum:",
      "ASSIGNMENT_TYPE": "Atama türü",
      "ASSIGNMENT_TYPE_SELECTION_LABEL": "Atama türü:",
      "NOT_STARTED": "Başlatılmadı",
      "CERTIFIED": "Sertifikalı",
      "NOT_CERTIFIED": "Sertifikasız",
      "IN_PROGRESS": "Devam Ediyor",
      "PATHWAY": "Öğrenme Yol Haritası",
      "SELECT_ALL": "Tümünü seç",
      "DESELECT_ALL": "Tümünün seçimini kaldır",
      "CLEAR_STATUS": "Durumu temizle",
      "OTHERS_SINGULAR": "ve 1 tane daha",
      "OTHERS_PLURAL": "ve {{ count }} tane daha"
    },
    "cognito": {
      "INVITATION_SUBJECT": "Quantified’a hoş geldiniz!",
      "INVITATION_MESSAGE": "Sizi aramızda görmekten büyük mutluluk duyuyoruz! Başlamak için lütfen aşağıdaki adımları izleyerek hesabınızda ilk kez oturum açın.",
      "ACCOUNT_DETAILS": "Hesap bilgileriniz:",
      "USERNAME": "Kullanıcı adı",
      "PASSWORD": "Geçici şifre",
      "STEPS_LABEL": "Oturum açmak için sonraki adımlar",
      "STEP_1": "1. Oturum açma sayfasına gitmek için aşağıdaki \"Oturum Aç\" düğmesine tıklayın.",
      "STEP_2": "2. Yukarıda verilen kullanıcı adınızı ve geçici şifrenizi girin.",
      "STEP_3": "3. Oturum açtıktan sonra, yeni bir şifre belirlemeniz istenecektir.",
      "LOGIN_BUTTON": "Oturum Aç",
      "ABOUT_US": "Quantified’ın Simülatörü, temel becerileri hızla geliştirmenize yardımcı olmak üzere tasarlanmış sanal bir ortamdır ve müşterilerle daha etkili bir şekilde bağlantı kurup iletişim kurmanızı sağlar.",
      "EXPIRY_TIME": "Bu geçici şifrenin süresi 24 saat sonra sona erecektir. Oturum açarken herhangi bir sorun yaşarsanız lütfen destek ekibimizle iletişime geçin:",
      "TEAM": "Quantified Ekibi",
      "INVITATION_SMS_USERNAME": "Kullanıcı adınız:",
      "INVITATION_SMS_PASSWORD": "ve geçici şifreniz:",
      "AUTHENTICATION_CODE": "Doğrulama kodunuz:",
      "PASSWORD_RESET_CODE": "Quantified Şifre Sıfırlama Kodunuz",
      "RESET_PASSWORD_EMAIL": "Şifre Sıfırlama E-postası",
      "HELLO": "Merhaba",
      "USE_VERIFICATION_CODE": "Şifre sıfırlama talebinde bulundunuz. Lütfen işlemi tamamlamak için aşağıdaki doğrulama kodunu kullanın.",
      "VERIFICATION_CODE": "Doğrulama kodu",
      "NEXT_STEP": "Sonraki adımlar",
      "RETURN_TO_PATHWAY": "Yol haritasının ana sayfasına geri dön",
      "RESET_PASSWORD_PAGE": "Tarayıcınızdaki şifre sıfırlama sayfasına geri dönün.",
      "ENTER_VERIFICATION_CODE": "İstenildiğinde doğrulama kodunu girin.",
      "CREATE_PASSWORD": "Kod doğrulandıktan sonra, talimatları izleyerek yeni bir şifre oluşturun.",
      "DISREGARD_NOTE": "Şifre sıfırlama talebinde bulunmadıysanız lütfen bu e-postayı dikkate almayınız.",
      "CONTACT_SUPPORT": "Daha fazla yardım için destek ekibimize şu adresten ulaşabilirsiniz:",
      "HELP_EMAIL": "help@quantified.ai",
      "THANK_YOU": "Teşekkür ederiz",
      "QUANTIFIED_TEAM": "Quantified Ekibi",
      "ADDRESS": "4200 Marathon Blvd, Suite 210, Austin, Texas 78756, Amerika Birleşik Devletleri"
    },
    "call": {
      "LOADING": "Yükleniyor",
      "SIMULATION_PAUSED": "Simülasyon duraklatıldı.",
      "CLICK_RESUME": "Devam etmek için aşağıdaki “Devam Et” düğmesine tıklayın.",
      "NO_INTERNET": "İnternet bağlantısı yok",
      "TRY_AGAIN": "Lütfen bağlantınızı kontrol edin ve tekrar deneyin.",
      "MIC_MUTED": "Mikrofon sessize alınmış",
      "MIC_MUTED_DESCRIPTION": "Görünüşe göre mikrofonunuzun sesi kapalı. Yanıt vermek ve devam etmek için sesini açın.",
      "NO_RESPONSE": "Yanıt Algılanmadı",
      "MIC_NOT_CONNECTED": "Görünüşe göre mikrofonunuz bağlı değil. Yanıt vermek ve devam etmek için cihazınızı yeniden seçin.",
      "AUDIO_ISSUE": "Bir sorun oluştu. Cihaz ayarlarınızı kontrol edin ve arka plan gürültüsünün olmadığı sessiz bir yerde olduğunuzdan emin olun.",
      "LOADING_ALT": "Yükleniyor...",
      "REPEAT_RESPONSE": "Yanıtınızı tekrarlayıp işlemi tekrar denemeniz için simülasyona otomatik olarak geri yönlendirileceksiniz.",
      "NEEDS_MORE_TIME_QUESTION": "düşünmek için biraz daha zamana ihtiyaç duyuyor, beklemek ister misiniz?",
      "NEEDS_MORE_TIME": "düşünmek için biraz daha zamana ihtiyaç duyuyor.",
      "WAIT_OR_END_CALL": "Hazır olduğunda size bildireceğiz. Alternatif olarak görüşmeyi sonlandırabilir ve",
      "RETURN_TO_ASSIGNMENTS": "atamaya geri dönebilirsiniz",
      "READY": "Hazır",
      "IS_READY": "görüşmenize devam etmeye hazır.",
      "TRY_AGAIN_LABEL": "Tekrar Dene",
      "CHECK_SETTINGS": "Ayarları Kontrol Et",
      "PAUSED_SIMULATION": "Bu simülasyonu duraklattınız.",
      "PAUSED_SIMULATION_DESCRIPTION": "Simülasyon devam ettirilene kadar video ve ses kaydı duraklatılır.",
      "RESUME": "Devam Et",
      "SETTINGS": "Ayarlar",
      "CAPTURING_RESPONSE": "Yanıtlarınız Kaydediliyor",
      "TOUR_MESSAGE": "Konuşmanızı bitirdikten sonra, yanıtlarınızın kaydedilip puanlanmasını sağlamak için Devam Et düğmesine tıkladığınızdan emin olun.",
      "NEXT": "Sonraki",
      "START_CALL": "Başlat",
      "END_CALL_TITLE": "Bu simülasyonu sonlandırmak istediğinizden emin misiniz?",
      "END_CALL_DESCRIPTION": "Simülasyonu şimdi sonlandırırsanız görüşmenizle ilgili bir puan veya geri bildirim almayacaksınız.",
      "END_CALL": "Sonlandır",
      "BROWSER_ACCESS_DENIED": "Tarayıcınızın bu cihaza erişimi reddedildi.",
      "COPY_SESSION_ID_BUTTON": "Oturum kimliğini kopyala",
      "RECONNECTING_AUDIO": "Ses bağlantısı yeniden kuruluyor...",
      "TIPS_GUIDANCE_MESSAGE": "Konu başlıkları ve ipuçları burada görünecektir.",
      "CONTINUE": "Devam Et",
      "SESSION_ID_LABEL": "Oturum Kimliği:",
      "SESSION_ID_COPIED": "Oturum Kimliği kopyalandı!",
      "HINTS_AND_SUGGESTIONS_TITLE": "İpuçları ve Öneriler",
      "HINT_LABEL": "İpucu",
      "CAPTIONS_LABEL": "Altyazılar",
      "PAUSE_LABEL": "Duraklat",
      "VIDEO_LABEL": "Video",
      "PARTY_EMOJI": "parti emojisi",
      "CALL_ENDED_MESSAGE": "Bu simülasyonun sonuna geldiniz.",
      "CALL_ENDED_INACTIVITY": "Bu simülasyon, etkinlik olmaması nedeniyle sona erdi",
      "CALL_ENDED_GENERIC": "Bu simülasyon sona erdi",
      "FEEDBACK_PROMPT": "Sonuçlarınız işlenirken lütfen geri bildirim bırakın.",
      "INTERACTION_THRESHOLD_NOT_MET": "Puanlama için gerekli etkileşim eşiğini karşılamadınız, lütfen tekrar deneyin.",
      "REALISTIC_CONVERSATION_QUESTION": "Bu görüşme size gerçekçi ve doğal geldi mi?",
      "KNOWLEDGEABLE_PREPARED_QUESTION": "Bu simülasyondan sonra kendinizi daha bilgili ve hazır hissediyor musunuz?",
      "FEEDBACK_THANK_YOU": "Geri bildiriminiz için teşekkür ederiz!",
      "FEEDBACK_IMPROVEMENT_NOTE": "Geri bildiriminiz için teşekkür ederiz! Deneyimi iyileştirme konusunda çalışacağız.",
      "AUDIO": "Ses",
      "MUTE": "Sesi Kapat",
      "UNMUTE": "Sesi Aç",
      "VISUAL_AID_LOAD_ERROR": "Görsel Yardım yüklenemedi",
      "BEGIN_CALL": "Başlat",
      "LEAVE_STEP_TITLE": "Bu adımdan çıkmak istediğinizden emin misiniz?",
      "EXIT": "Çık",
      "LEAVE_CALL_BRIEFING": "Bilgilendirmeden Çık",
      "RESTORE_CALL": "Simülasyonunuz geri yükleniyor",
      "FEW_SECONDS": "Bu işlem birkaç saniye sürebilir.",
      "CHECK_ALT": "Kontrol et",
      "COPY_ALT": "Kopyala",
      "HINTS_ALT": "İpuçları",
      "CLOSE_CAPTIONS": "Altyazıları Kapat",
      "MICROPHONE_MUTED": "Mikrofon Sessize Alındı",
      "RETURN_TO_CALL": "Simülasyona Geri Dön",
      "YES": "Evet",
      "NO": "Hayır",
      "VIEW_RESULTS": "Sonuçları Görüntüle",
      "RETURN_TO_ASSIGNMENT": "Atamaya Geri Dön",
      "HAVING_ISSUES": "Bağlantı sorunu yaşıyoruz, lütfen internet bağlantınızı kontrol edin ve ardından Tamam'a tıklayın.",
      "OK": "Tamam",
      "RESULTS_NOT_GENERATED": "Üzgünüz, şu anda sonuç üretemiyoruz, lütfen tekrar deneyin.",
      "INACTIVITY_ALERT_MESSAGE": "Etkinlik olmadığı için bu görüşme sonlandırılıyor. Devam etmek için avatarla konuşun veya görüşmeyi sonlandırmak için “Görüşmeyi Sonlandır”ı seçin.",
      "INACTIVITY_DEFAULT_ALERT_TITLE": "Bu görüşme {{secondsUntilHangup}} saniye içinde sonlandırılacak",
      "INACTIVITY_SHORT_ALERT_TITLE": "Bu görüşme birkaç saniye içinde sonlandırılacak",
      "TELL_YOUR_GENDER_HEADING": "Lütfen cinsiyetinizi belirtin:",
      "BY_KNOWING_YOUR_GENDER_DESCRIPTION": "Cinsiyetinizi bilmek, avatarın doğru dilbilgisi kullanmasını sağlayarak görüşmeyi daha doğal ve gerçekçi hale getirir.",
      "GENDER_SELECTION": "Cinsiyet seçimi:",
      "SELECT_OPTION": "Bir seçenek belirleyin",
      "CONFIRM": "Onayla",
      "MALE": "Erkek",
      "FEMALE": "Kadın",
      "NON_BINARY": "İkilik Dışı/Diğer",
      "PREFER_NOT_TO_ANSWER": "Cevap vermek istemiyorum",
      "NON_BINARY_MESSAGE": "Anlıyoruz ve ikilik dışı cinsiyet kimliğinize saygı duyuyoruz. Mevcut teknolojik sınırlamalar nedeniyle, varsayılan olarak eril zamirleri kullanıyoruz. Gelecekte tüm cinsiyet kimliklerini daha iyi kapsayabilmek için iyileştirmeler üzerinde çalıştığımızı lütfen unutmayın. Anlayışınız ve sabrınız için teşekkür ederiz.",
      "PREFER_NOT_TO_ANSWER_MESSAGE": "Cinsiyet bilgisi vermeme tercihine saygı duyuyoruz. Bu tür durumlarda teknolojimiz, mevcut sınırlamalar nedeniyle varsayılan olarak eril zamirleri kullanır.",
      "DISPLAY_VISUAL_AID": "Görsel Yardımı Görüntüle",
      "FULL_SCREEN": "Tam Ekran",
      "COLLAPSE": "Küçült",
      "COMPLETED_CONVERSATION_MESSAGE": "Bu görüşmeyi tamamladığınız için teşekkür ederiz",
      "CONVERSATION_COMPLETION_FEEDBACK": "Görüşleriniz işlenirken lütfen geri bildirim bırakın.",
      "ERROR_MESSAGE": "Bir hata oluştu. Lütfen şu birimle iletişime geçin:",
      "SAVED_CONVERSATION_MESSAGE": "Görüşmeniz kaydedildi.",
      "RETURN_TO_MY_ASSIGNMENTS": "Atamalarıma geri dön",
      "RETURN_TO_PERSONALIZED_PRACTICE": "Kişiselleştirilmiş alıştırmalara dön",
      "CERT_ACK_TITLE": "Sertifika Videosu Onayı",
      "CERT_ACK_ACCEPT_AND_BEGIN": "Kabul et ve başla",
      "CERT_ACK_RESUME_CALL": "Görüşmeye devam et",
      "CERT_ACK_PROCESSING": "İşleniyor...",
      "CERT_ACK_CAMERA_WARNING": "Sertifika işlemine devam etmek için lütfen kameranızı etkinleştirin.",
      "CERT_ACK_CAMERA_OFF_DURING_CALL": "Kameranız kapalıydı. Sertifika işlemine devam etmek için lütfen kameranızı yeniden etkinleştirin.",
      "CERT_ACK_TEXT_1": "Bu sertifikaya ilişkin bütünlüğü ve adaleti sağlamak için, oturum boyunca kameranız açık kalmalıdır ve oturum izlenecektir. Bu gereklilik, tüm sertifika standartlarına uyumu onaylamak içindir.",
      "CERT_ACK_TEXT_2": "Devam ederek, bu gereklilikleri onaylamış ve kabul etmiş olursunuz.",
      "CERT_ACK_END_CALL": "Görüşmeyi sonlandır",
      "LAUNCH_SIMULATION": "Simülasyonu başlat",
      "DEBRIEF_LATEST_SESSION": "Son oturumu değerlendir",
      "END": "Sonlandır",
      "START_DEBRIEF": "Son oturumu değerlendir",
      "MOVE_TO_NEXT": "Bir sonraki adıma geç",
      "RETRY_ROLEPLAY": "Rol canlandırmasını yeniden dene",
      "EXIT_PATHWAY": "Yol haritasından çık",
      "PROCESSING": "İşleniyor...",
      "FEEDBACK_PROMPT_REQUIRED": "Sonuçlarınızı görüntülemeden önce geri bildirim bırakın.",
      "SCREENSHARE_LABEL": "Ekranı paylaş",
      "SCREENSHARE_UNSUPPORTED_TITLE": "{{callName}} ekran paylaşımı kullanıyor",
      "SCREENSHARE_UNSUPPORTED_MESSAGE_APP": "Görüşmeye devam etmek için lütfen tarayıcınız yerine uygulamamızı kullanın.",
      "SCREENSHARE_UNSUPPORTED_MESSAGE_DESKTOP": "Görüşmeye devam etmek için bir masaüstü bilgisayardan erişin.",
      "SCREENSHARE_UNSUPPORTED_CLOSE_BUTTON": "Kapat",
      "SCREENSHARE_UNSUPPORTED_GO_TO_APP_BUTTON": "Uygulamaya git",
      "SCREENSHARE_UNSUPPORTED_GO_TO_APP_UNAVAILABLE": "Mobil uygulama henüz kullanılamıyor. Lütfen biraz sonra tekrar kontrol edin.",
      "SCREENSHARE_STOP_LABEL": "Ekran paylaşımını durdur",
      "SCREENSHARE_PIP_REOPEN_LABEL": "Video önizlemesini yeniden aç",
      "SCREENSHARE_ACTIVE_LABEL": "Şu anda ekran paylaşıyorsunuz",
      "SCREENSHARE_OS_PERMISSION_HINT": "Ekran paylaşımı başlatılamadı. Sistem Ayarları > Gizlilik ve Güvenlik bölümünden tarayıcınız için Ekran Kaydı özelliğini etkinleştirin, ardından tekrar deneyin.",
      "SCREENSHARE_SAFARI_BLOCKED_HINT": "Safari, bu oturum için ekran paylaşımını engelledi. Oturumu kapatıp yeniden oturum açın, ardından tekrar deneyin."
    },
    "assignment": {
      "STATUS": "DURUM",
      "SCORE": "PUAN",
      "MUST_ACHIEVE": "Alınması gereken puan en az",
      "OR_HIGHER": "veya daha yüksek",
      "TEST": "Test",
      "OUT_OF_5": "(5 üzerinden)",
      "LATEST_ATTEMPT": "SON DENEME",
      "TOTAL_ATTEMPTS": "toplam deneme sayısı",
      "UNLIMITED": "Sınırsız",
      "REMAINING": "Kalan",
      "VIEW_CALL_DETAILS": "Ayrıntıları Görüntüle",
      "MAX_ATTEMPTS_REACHED": "Maksimum deneme sayısına ulaştınız",
      "DUE_DATE": "Son Teslim Tarihi",
      "DAYS": "Gün",
      "DAY": "Gün",
      "UNTILL_DUE": "Son Tarihe Kadar",
      "PAST_DUE": "Son Tarihi Geçmiş",
      "ONGOING": "Devam ediyor",
      "SCORE_REQUIREMENT": "Puan Gereksinimi",
      "SCORE_REQUIREMENT_DETAIL": "Her bir zorunlu simülasyonu tamamlamak için",
      "TO_COMPLETE_EACH_CALL": "puan almanız gerekir.",
      "CALLS_IN_ASSIGNMENT": "Atamadaki Simülasyonlar",
      "INCOMPLETE_CALL": "Tamamlanmamış",
      "PREVIOUS_RESULTS": "Önceki Sonuçlar",
      "DATE": "Tarih",
      "RESULTS": "Sonuçlar",
      "VIEW_PREVIOUS_RESULTS": "Önceki Sonuçları Görüntüle",
      "VIEW_FEEDBACK": "Geri Bildirimi Görüntüle",
      "LAUNCH_CALL": "Başlat",
      "CLOSE_BUTTON": "Kapat Düğmesi",
      "CHECKMARK": "onay işareti",
      "CALL": "Görüşme",
      "QUESTION": "Soru",
      "COMPLETED": "Tamamlandı",
      "IN_PROGRESS": "Devam ediyor",
      "NOT_STARTED": "Başlatılmadı",
      "CERTIFIED": "Sertifikalı",
      "GUIDED": "Rehberli",
      "CONVERSATIONAL": "Görüşme Odaklı",
      "GUIDED_SIMULATION": "Bilgi Kontrolü",
      "CONVERSATIONAL_SIMULATION": "Rol Canlandırma",
      "NO_ATTEMPTS_LEFT": "Kalan deneme hakkı yok",
      "NO_ATTEMPTS": "Deneme yok",
      "OVERVIEW": "Genel Bakış",
      "ABOUT_THE_AVATAR": "Avatar Hakkında",
      "SCORING_CRITERIA": "Puanlama Ölçütleri",
      "SIMULATION_OVERVIEW": "Simülasyona Genel Bakış",
      "ABOUT_THE_PERSONA": "Persona Hakkında",
      "OUTOF_COMPLIANCE": "Uygunluk dışı",
      "CLOSED": "Kapatıldı",
      "COMPLETED_CALLS": "Görüşmeler Tamamlandı"
    }
  },
  "pt-PT": {
    "root": {
      "ADMIN_PORTAL": "PORTAL DE ADMINISTRAÇÃO",
      "SUPPORT": "ASSISTÊNCIA",
      "U": "U",
      "USER": "Utilizador",
      "LOGOUT": "Terminar sessão",
      "ADMIN": "Administrador",
      "SUPPORT_SMALL": "Assistência",
      "QUANTIFIED_AI": "Quantified.AI",
      "MICROPHONE": "MICROFONE",
      "CAMERA": "CÂMARA",
      "ACCESS_DENIED": "ACESSO_NEGADO"
    },
    "teams": {
      "MY_TEAMS": "As minhas equipas",
      "COMPLETED": "Concluído",
      "IN_PROGRESS": "Em curso",
      "NOT_STARTED": "Não iniciada",
      "ASSIGNMET_MODULE": "Módulo de tarefa",
      "START_DATE": "Data de início",
      "DUE_DATE": "Data limite",
      "ASSIGNED_MEMBERS": "Membros atribuídos",
      "CALLS_IN_MODULE": "Simulações no módulo",
      "COMPLETION_REQUIRMENT": "Requisito de conclusão",
      "COMPLETE_ALL_CALLS": "Completar todas as simulações com uma pontuação de",
      "OR_HIGHER": "ou superior",
      "PROGRESS_OVERVIEW": "SÍNTESE DO PROGRESSO",
      "TEAM_MEMBERS": "membros da equipa",
      "AVERAGE_HIGH_SCORE": "Média das pontuações mais elevadas",
      "AVERAGE_NUMBER_ATTEMPTS_CALL": "Número médio de tentativas por simulação",
      "TOTAL_PRACTICES": "Total de práticas",
      "INDIVIDUAL_CALL_PROGRESS": "PROGRESSO DA SIMULAÇÃO INDIVIDUAL",
      "OF_TEAM_MEMBERS": "de membros da equipa concluídos",
      "AVERAGE_PRACTICES_TO_COMPLETION": "Média de práticas até à conclusão",
      "TEAM_MEMBER_DETAILS": "DETALHES DO MEMBRO DA EQUIPA",
      "DOWNLOAD_ACTIVITY_REPORT": "Transferir o relatório de atividade",
      "TEAM_MEMBER": "Membro da equipa",
      "PROGRESS": "Progresso",
      "CALLS_COMPLETED": "Simulações concluídas",
      "PRACTICES": "Sessões de prática",
      "MOST_RECENT_PRACTICE": "Sessão mais recente",
      "THIS_TEAM_HAS_NO_ACTIVE_ASSIGNMENTS": "Esta equipa não tem tarefas ativas neste momento",
      "CALL_NAME_LABEL": "Nome da simulação",
      "HIGHEST_SCORE": "Pontuação mais elevada"
    },
    "simulationBuilder": {
      "THRESHOLD": "Limiar",
      "TYPE": "Tipo",
      "SELECT_AN_OPTION": "Selecionar uma opção",
      "CORRECT_FEEDBACK": "Feedback correto",
      "INCORRECT_FEEDBACK": "Feedback incorreto",
      "CORRECT_FEEDBACK_PLACEHOLDER": "Apresentado quando o formando acerta",
      "INCORRECT_FEEDBACK_PLACEHOLDER": "Apresentado quando o formando erra",
      "ENTER_MESSAGE_TEXT": "Introduzir o texto da mensagem...",
      "DELETE": "Eliminar",
      "SCORABLE": "Pontuável",
      "MESSAGE_NUMBER": "Mensagem {{ index }}",
      "SEARCH_BY_SIMULATION_NAME": "Pesquisa por nome da simulação",
      "SEARCH_BY_ASSIGNMENT_NAME": "Pesquisa por nome da tarefa",
      "SIMULATION_STATUS_PLACEHOLDER": "Estado da simulação",
      "SIMULATION_STATUS_PREFIX": "Estado da simulação:",
      "NO_SIMULATIONS_FOUND": "Nenhuma simulação encontrada",
      "SELECT_ALL": "Selecionar tudo",
      "DESELECT_ALL": "Desmarcar tudo",
      "STATUS_TESTING": "Em teste",
      "STATUS_DRAFT": "Rascunho",
      "STATUS_PUBLISHED": "Publicada",
      "STATUS_ARCHIVED": "Arquivada",
      "ASSIGNEES_ZERO_STATE_MESSAGE": "Ainda não foram atribuídos utilizadores",
      "ADD_USERS_TO_ASSIGNMENT": "Adicionar utilizadores à tarefa",
      "NO_DATA_FOUND": "Não foram encontrados dados",
      "NO_USERS_SELECTED": "Nenhum utilizador selecionado",
      "COL_FIRST_NAME": "Nome próprio",
      "COL_LAST_NAME": "Apelido",
      "COL_EMAIL": "E-mail",
      "COL_VIEW_USER": "Ver utilizador",
      "COL_VIEW_ASSIGNMENT": "Ver tarefa",
      "COL_ASSIGNMENT_NAME": "Nome da tarefa",
      "COL_STATUS": "Estado",
      "COL_TEAM_ASSOCIATIONS": "Associações de equipas",
      "COL_REPORTING_STATUS": "Estado do relatório",
      "BREADCRUMB_USERS": "Utilizadores",
      "STATUS_STAGED": "Encenada",
      "STATUS_ACTIVE": "Ativa",
      "STATUS_ENDED": "Concluída",
      "STATUS_CLOSED": "Encerrada",
      "SEARCH_USERS_PLACEHOLDER": "Procurar utilizadores",
      "NO_USERS_FOUND": "Nenhum utilizador encontrado",
      "USERS_TAB_LABEL": "Utilizadores",
      "ADD_TO_ASSIGNMENT": "Adicionar à tarefa",
      "ASSIGNMENTS_COUNT": "tarefas",
      "REPORTING_EXCLUDED": "Excluídos",
      "REPORTING_INCLUDED": "Incluídos",
      "KEBAB_EDIT_TEAM_ASSOCIATIONS": "Editar associações de equipas",
      "KEBAB_EXCLUDE_FROM_REPORTING": "Excluir do relatório",
      "KEBAB_INCLUDE_IN_REPORTING": "Incluir no relatório",
      "KEBAB_REMOVE_FROM_ASSIGNMENT": "Remover da tarefa",
      "NO_TEAMS": "—",
      "TEAMS_COUNT": "{{count}} equipas",
      "ADD_TO_ASSIGNMENT_MODAL_HEADING": "Adicionar à tarefa",
      "FIELD_LABEL_ASSIGNMENT": "Atribuição",
      "SEARCH_ASSIGNMENTS_PLACEHOLDER": "Procurar tarefas",
      "BUTTON_SET_TEAM_ASSOCIATION": "Definir associação de equipas",
      "FIELD_LABEL_TEAM": "Equipa",
      "SEARCH_TEAM_PLACEHOLDER": "Procurar equipa",
      "BUTTON_BACK": "Voltar",
      "BUTTON_CANCEL": "Cancelar",
      "BUTTON_ADD_TO_ASSIGNMENT": "Adicionar à tarefa",
      "EDIT_TEAM_ASSOCIATIONS_HEADING": "Editar associações de equipas",
      "EDIT_TEAM_ASSOCIATIONS_DESCRIPTION": "Para a tarefa {{assignmentName}}",
      "BUTTON_SAVE_ASSOCIATIONS": "Guardar associações",
      "REFERENCE_DOCUMENT_STATUS_UPLOADING": "– A carregar...",
      "REFERENCE_DOCUMENT_STATUS_SUCCESS": "– 100% carregado",
      "REFERENCE_DOCUMENT_STATUS_ERROR": "– Erro de carregamento",
      "CREATE_SIMULATION_DETAILS_BUTTON": "Criar os detalhes da simulação",
      "SELF_AUTHORING_DESCRIPTION": "Indique um nome, uma breve descrição do cenário e quaisquer documentos específicos da simulação para começar",
      "CLICK_TO_UPLOAD": "Clique para carregar",
      "OR_DRAG_AND_DROP": "ou arraste e solte",
      "REFERENCE_DOCUMENTS_UPLOAD_DESCRIPTION": "PDF (máx. 50 MB)",
      "ASSIGNMENT_NAME_LABEL": "Nome da tarefa *",
      "SIMULATION_NAME_LABEL": "Nome da simulação",
      "NAME_FIELD_DESCRIPTION": "Este nome pode ser alterado mais tarde",
      "PRODUCT_LABEL": "Produto",
      "SELECT_A_PRODUCT_PLACEHOLDER": "Selecione um produto",
      "ADD_NEW_PRODUCT": "Adicionar novo produto",
      "SCENARIO_LABEL": "Cenário",
      "REFERENCE_DOCUMENTS_LABEL": "Documentos de referência",
      "ACTION_CREATE_NEW": "Criar novo",
      "ACTION_CREATE": "Criar",
      "ACTION_DUPLICATE": "Duplicar",
      "ENTITY_TYPE_SIMULATION_DISPLAY": "Simulação",
      "ENTITY_TYPE_ASSIGNMENT_DISPLAY": "Tarefa",
      "ENTITY_TYPE_SIMULATION_LOWER": "simulação",
      "ENTITY_TYPE_ASSIGNMENT_LOWER": "tarefa",
      "MODAL_TITLE": "{{ action }} {{ type }}",
      "CONFIRM_BUTTON_LABEL": "{{ action }} {{ type }}",
      "DUPLICATE_NAME_ERROR_ASSIGNMENT": "Já existe uma tarefa com o mesmo nome.",
      "DUPLICATE_NAME_ERROR_SIMULATION": "Já existe uma simulação com o mesmo nome.",
      "NAME_REQUIRED_ERROR": "O nome é obrigatório.",
      "COPY_OF_PREFIX": "Cópia de - {{ name }}",
      "SCORE_DISTRIBUTION_TITLE": "Distribuição da pontuação atual",
      "EDIT_SECTIONS_AND_WEIGHTING": "Editar secções e ponderações",
      "SCORING_WEIGHTS_TITLE": "Configurar a pontuação",
      "SCORING_WEIGHTS_DESCRIPTION": "Escolha quais as áreas a pontuar e qual a contribuição de cada uma para a pontuação global. A soma de todas as ponderações das secções ativadas deve ser igual a 100%. A secção de competências não pode ter uma ponderação superior a 20%.",
      "SCORING_WEIGHT_REQUIRED": "Obrigatório",
      "REFERENCE_DOCUMENT_STATUS_DELETING": "– A eliminar",
      "REFERENCE_DOCUMENT_DELETE_ERROR": "Não foi possível eliminar o documento. Tentar novamente.",
      "REFERENCE_DOCUMENT_UPLOAD_ERROR": "Não foi possível carregar o documento. Tentar novamente.",
      "CONTENT_LIMIT_EXCEEDED_ERROR": "Limite de conteúdo excedido. Remova um ou mais documentos para continuar.",
      "LAST_FACT_DELETE_WARNING_HEADING": "Deseja eliminar o último facto?",
      "LAST_FACT_DELETE_WARNING_DESCRIPTION": "A eliminação do último facto irá remover todas as associações de utilizadores a esta simulação e reverter o seu estado para Rascunho.",
      "LEAVE_CONFIRMATION_HEADING": "Sair da criação da simulação",
      "LEAVE_CONFIRMATION_DESCRIPTION": "Tem a certeza de que deseja sair? Todo o progresso que tenha feito será perdido.",
      "LEAVE_CONFIRMATION_LEAVE_BUTTON": "Sair",
      "METHODOLOGY_TITLE": "Metodologia",
      "METHODOLOGY_SUBTITLE": "Avalie a abordagem e a estrutura da chamada",
      "METHODOLOGY_WEIGHTING_LABEL": "Ponderação: {{ weight }}%",
      "METHODOLOGY_RUBRIC_LABEL": "Rubrica de metodologia",
      "SELECT_RUBRIC_PLACEHOLDER": "Selecionar rubrica",
      "SKILLS_TITLE": "Competências",
      "SKILLS_SUBTITLE": "Pontuação em comunicação e competências interpessoais",
      "SKILLS_WEIGHTING_LABEL": "Ponderação: {{ weight }}%",
      "SKILLS_RUBRIC_LABEL": "Rubrica de competências",
      "PROCESSING_DOCUMENTS_MESSAGE": "A processar resultados...",
      "PROCESSING_DOCUMENTS_SUPPORTING_TEXT": "Enquanto espera, pode fazer uma pequena pausa. Daqui a cerca de 5 minutos, os resultados estarão prontos.",
      "CORE_SIGNAL_MESSAGE": "A interpretar o seu conteúdo...",
      "SECTION_PLAN_MESSAGE": "A definir a estrutura da sua simulação...",
      "DERIVED_COMPONENT_MESSAGE": "A criar os componentes da sua simulação...",
      "COMPONENT_WAVE_1_MESSAGE": "A criar o conteúdo da sua simulação...",
      "STILL_PROCESSING_TITLE": "A processar...",
      "STILL_PROCESSING_BODY": "Está a demorar mais do que o habitual. Pode sair desta simulação e voltar mais tarde a partir da lista de simulações.",
      "PROCESSING_FAILED_TITLE": "O processamento falhou",
      "PROCESSING_FAILED_BODY": "Ocorreu um erro durante o processamento dos seus documentos — tente novamente. Entre em contacto com ",
      "TEST_SIMULATION_BUTTON": "Testar simulação",
      "SIMULATION_PROCESSED_TITLE": "Documentos processados",
      "SIMULATION_PROCESSED_BODY": "Os documentos da sua simulação foram processados.",
      "SIMULATION_DOCUMENTS_PROCESSED_TITLE": "Documentos da simulação processados.",
      "SIMULATION_DOCUMENTS_PROCESSED_BODY": "Os documentos que carregou para a simulação {{ name }} foram processados.",
      "SIMULATION_DOCUMENTS_FAILED_TITLE": "Não foi possível processar os documentos da simulação.",
      "SIMULATION_DOCUMENTS_FAILED_BODY": "Os documentos que carregou para a simulação {{ name }} não foram processados.",
      "DISMISS": "Ignorar",
      "VIEW_SIMULATION": "Ver simulação",
      "FACT_MESSAGE_LABEL": "Mensagem",
      "FACT_MESSAGE_DESCRIPTION": "As mensagens devem conter uma única informação, redigida sob a forma de uma frase completa. Seja específico, simples e conciso — evite mensagens que possam ser interpretadas de forma parcial.",
      "FACT_INCORRECT_ANSWER_LABEL": "Texto de resposta incorreta",
      "FACT_INCORRECT_ANSWER_DESCRIPTION": "O texto apresentado ao formando caso este responda incorretamente a este facto",
      "SHOW_INCORRECT_ANSWER_TEXT": "Mostrar texto alternativo para respostas incorretas",
      "ADD_NEW_FACT": "Adicionar novo facto",
      "FACT_SINGULAR": "facto",
      "FACT_PLURAL": "factos",
      "FACT_EXTRACTED_SINGULAR": "{{ count }} facto extraído",
      "FACT_EXTRACTED_PLURAL": "{{ count }} factos extraídos",
      "REVIEW_REQUIRED_LABEL": "Revisão sugerida",
      "MESSAGING_TITLE": "Mensagens",
      "MESSAGING_SUBTITLE": "Avalie se os factos-chave são comunicados",
      "COMPONENT_WAVE_2_MESSAGE": "A aperfeiçoar o conteúdo da sua simulação...",
      "COMPONENT_WAVE_3_MESSAGE": "A finalizar o conteúdo da sua simulação...",
      "MESSAGE_ADHERENCE_MESSAGE": "A sugerir critérios de avaliação da mensagem...",
      "ASSEMBLING_MESSAGE": "A preparar a sua simulação...",
      "PROCESSING_FAILED_SUFFIX": " se o problema persistir.",
      "BUTTON_RETRY": "Tentar novamente",
      "TOKEN_LIMIT_EXCEEDED_BODY_PREFIX": "Limite de conteúdo excedido. Remova um ou mais documentos e tente novamente ou contacte ",
      "TOKEN_LIMIT_EXCEEDED_BODY_SUFFIX": " se o problema persistir.",
      "AVATAR_LOOK_LABEL": "Aparência",
      "AVATAR_SELECT_PLACEHOLDER": "Selecionar avatar",
      "AVATAR_VOICE_LABEL": "Voz",
      "AVATAR_ALT": "Avatar",
      "PLAY_VOICE_PREVIEW_BUTTON": "Reproduzir pré-visualização de voz",
      "VOICE_OPTION_1": "Voz 1",
      "VOICE_OPTION_2": "Voz 2",
      "BACK_TO_SIMULATION_DETAILS_BUTTON": "Voltar aos detalhes da simulação",
      "AVATAR_SELECTION_TITLE": "Seleção do avatar",
      "VIEW_DOCUMENTS": "Ver documentos",
      "SELECT_AVATAR_BUTTON": "Selecionar avatar",
      "REQUEST_CHANGES_PLACEHOLDER": "Solicitar alterações às informações acima",
      "CALL_DETAILS_LOAD_ERROR": "Não foi possível carregar os detalhes da sua chamada. Tentar novamente.",
      "FACTS_CANNOT_BE_EMPTY": "Os factos não podem estar vazios. Adicione uma mensagem a cada facto antes de o testar ou publicar.",
      "FINISHING_SIMULATION_MESSAGE": "A terminar a sua simulação...",
      "BLANK_THEME_MESSAGE_TOOLTIP": "Adicione texto à mensagem em branco antes de adicionar um novo tema.",
      "BLANK_MESSAGE_TOOLTIP": "Adicione texto a esta mensagem antes de adicionar outra.",
      "ADD_NEW_THEME_BUTTON": "Adicionar novo tema",
      "ADD_THEME_BUTTON": "Adicionar tema",
      "ADD_MESSAGE_BUTTON": "Adicionar mensagem",
      "SCORE_LAST_SESSION": "Avalia a minha última sessão",
      "SCORE_LAST_SESSION_MODAL_HEADING": "Avalia a última sessão",
      "SCORE_LAST_SESSION_MODAL_DESCRIPTION": "Teste primeiro a simulação e, em seguida, volte aqui para a avaliar de acordo com a rubrica selecionada.",
      "SCORE_LAST_SESSION_MODAL_ERROR_HEADING": "Algo correu mal",
      "SCORE_LAST_SESSION_MODAL_ERROR_DESCRIPTION": "Tentar de novo.",
      "REFINEMENT_THINKING_MESSAGE": "A pensar...",
      "REFINEMENT_UPDATED_MESSAGE": "Atualizado",
      "REFINEMENT_WARNING_PREFIX": "Esta informação foi alterada manualmente — contacte-nos",
      "REFINEMENT_WARNING_SUFFIX": "para quaisquer atualizações.",
      "REFINEMENT_ERROR_PREFIX": "Infelizmente, não posso ajudá-lo com isso, mas",
      "REFINEMENT_ERROR_SUFFIX": "talvez possa.",
      "REFINEMENT_APPLIED_TITLE": "As alterações solicitadas foram aplicadas.",
      "REFINEMENT_APPLIED_BODY": "As alterações que solicitou para a simulação {{ name }} foram aplicadas.",
      "REFINEMENT_FAILED_TITLE": "As alterações solicitadas falharam.",
      "REFINEMENT_FAILED_BODY": "Não foi possível aplicar as alterações que solicitou para a simulação {{ name }}.",
      "WHAT_USERS_SEE_DESCRIPTION_TITLE": "Descrição da simulação",
      "WHAT_USERS_SEE_DESCRIPTION_HELPER": "As informações atualizadas no separador Geral serão refletidas aqui, a menos que sejam efetuadas atualizações manuais.",
      "WHAT_USERS_SEE_DESCRIPTION_FIELD_LABEL": "Descrição",
      "WHAT_USERS_SEE_DETAILS_TITLE": "Detalhes da simulação",
      "WHAT_USERS_SEE_DETAILS_HELPER": "Este é o conteúdo que será apresentado ao utilizador antes de este iniciar a simulação. As informações atualizadas no separador Geral serão refletidas aqui, a menos que sejam efetuadas atualizações manuais. Quaisquer secções deixadas em branco não serão apresentadas ao formando. Todas as secções suportam formatação Markdown.",
      "WHAT_USERS_SEE_OVERVIEW_FIELD_LABEL": "Visão geral da simulação",
      "WHAT_USERS_SEE_PERSONA_FIELD_LABEL": "Sobre a Persona",
      "WHAT_USERS_SEE_SCORING_FIELD_LABEL": "Critérios de pontuação",
      "WHAT_USERS_SEE_SCORING_FIELD_HELPER": "Esta secção é preenchida com base nas seleções efetuadas no separador Pontuação. A edição das informações aqui não alterará a forma como a simulação é pontuada.",
      "WHAT_USERS_SEE_PREVIEW_DETAILS_CTA": "Detalhes da simulação de pré-visualização",
      "WHAT_USERS_SEE_PREVIEW_CARD_CTA": "Cartão de pré-visualização da simulação",
      "TAB_GENERAL": "Geral",
      "TAB_CONTENTS": "Índice",
      "TAB_KEY_WORDS": "Palavras-chave",
      "TAB_SCORING": "Pontuação",
      "TAB_TESTING": "Em teste",
      "TAB_PROMPTS": "Instruções",
      "TAB_WHAT_USERS_SEE": "O que os utilizadores veem",
      "ACCURACY_FEEDBACK_TITLE": "Feedback sobre a precisão",
      "ACCURACY_FEEDBACK_DESCRIPTION": "Avaliar a exatidão de cada afirmação feita pelo representante com base nos documentos carregados",
      "ACCURACY_FEEDBACK_STATUS_ON": "Ativado",
      "ACCURACY_FEEDBACK_STATUS_OFF": "Desligado",
      "ACCURACY_FEEDBACK_STATUS_DISABLED": "Desativado",
      "ACCURACY_FEEDBACK_NO_DOCUMENTS": "A pontuação de precisão não está disponível porque não foram adicionados documentos relacionados.",
      "SCORING_AI_REVIEW_NOTICE": "Parte do conteúdo deste separador foi gerado a partir dos materiais que forneceu. Verificar a exatidão de todo o conteúdo antes de publicar esta chamada.",
      "EXPORT_SIMULATION_SUMMARY_BUTTON": "Exportar resumo da simulação",
      "CALL": "Chamada",
      "REFINEMENT_OVERRIDDEN_PREFIX": "Esta informação foi alterada manualmente — contacte-nos",
      "REFINEMENT_OVERRIDDEN_SUFFIX": "para quaisquer atualizações.",
      "SUPPORT_EMAIL": "help@quantified.ai",
      "WHAT_USERS_SEE_OVERRIDE_WARNING_TITLE": "A edição destes campos bloqueará futuras atualizações",
      "WHAT_USERS_SEE_OVERRIDE_WARNING_BODY": "A atualização manual destas secções impedirá que recebam quaisquer atualizações adicionais do processo de refinamento no separador Geral.",
      "WHAT_USERS_SEE_DETAILS_OVERRIDE_EDITED_TITLE": "Estes campos foram editados",
      "WHAT_USERS_SEE_DETAILS_OVERRIDE_EDITED_BODY": "Já não receberão atualizações de refinamento efetuadas no separador Geral",
      "SIMULATION_BUILDER_HEADING": "Criador de simulações",
      "ASSIGNMENTS_TAB_LABEL": "Tarefas",
      "SIMULATIONS_TAB_LABEL": "Simulações",
      "CREATE_NEW_ASSIGNMENT_BUTTON": "Criar nova tarefa",
      "CREATE_NEW_SIMULATION_BUTTON": "Criar nova simulação",
      "NO_ASSIGNMENTS_FOUND": "Não foram encontradas tarefas",
      "ASSIGNMENT_STATUS_PLACEHOLDER": "Estado da tarefa",
      "ASSIGNMENT_STATUS_PREFIX": "Estado da tarefa:",
      "ASSIGNMENT_TYPE_LABEL": "Tipo de tarefa",
      "SELECT_ASSIGNMENT_TYPE_PLACEHOLDER": "Selecionar tipo de tarefa",
      "NAME_LABEL": "Nome",
      "ASSIGNMENT_NAME_PLACEHOLDER": "Nome da tarefa",
      "PASSING_SCORE_LABEL": "Pontuação de aprovação",
      "PASSING_SCORE_OPTIONAL_LABEL": "Pontuação de aprovação (opcional)",
      "SCORE_MAX_EXCEEDED_ERROR": "A pontuação não deve exceder 5",
      "GET_HELP_BUTTON": "Obter ajuda",
      "PASSING_SCORE_TOOLTIP": "Isto define a pontuação global que um formando deve atingir para ser aprovado na simulação.",
      "DESCRIPTION_LABEL": "Descrição",
      "ASSIGNMENT_DESCRIPTION_PLACEHOLDER": "Descrição da tarefa",
      "MESSAGING_FEEDBACK_LABEL": "Feedback sobre as mensagens",
      "MESSAGING_FEEDBACK_TOOLTIP_HEADING": "Feedback sobre as mensagens",
      "MESSAGING_FEEDBACK_TOOLTIP_BODY": "Quando um formando formula incorretamente uma mensagem, são-lhe apresentadas informações sobre como a verbalizar melhor da próxima vez. Esta configuração permite ativar ou desativar a exibição dessas informações.",
      "ENABLED_TEXT": "Ativado",
      "DISABLED_TEXT": "Desativado",
      "PAUSE_BUTTON_LABEL": "Botão de pausa",
      "ASSIGNMENT_START_DATE_LABEL": "Data de início da tarefa",
      "SELECT_DATE_PLACEHOLDER": "Selecionar data",
      "ASSIGNMENT_END_DATE_LABEL": "Data de término da tarefa",
      "ASSIGNMENT_END_DATE_OPTIONAL_LABEL": "Data de término da tarefa (opcional)",
      "END_DATE_RANGE_ERROR": "A data de início e a data de término não podem ser iguais",
      "ASSIGNMENT_INFORMATION_TITLE": "Informações sobre a tarefa",
      "ASSIGNMENT_TYPE_CERTIFICATION": "Certificação",
      "ASSIGNMENT_TYPE_PRACTICE": "Prática",
      "ASSIGNMENT_TYPE_PERSONALIZED_PRACTICE": "Prática personalizada",
      "BUTTON_SAVE_AND_CLOSE": "Guardar e fechar",
      "BUTTON_ADD_SIMULATIONS": "Adicionar simulações",
      "ATTEMPTS_UNLIMITED": "Ilimitadas",
      "SEARCH_FOR_SIMULATION_LABEL": "Procurar por simulação",
      "SIMULATION_NAME_PLACEHOLDER": "Nome da simulação",
      "BUTTON_REMOVE_ALL": "Remover todas",
      "SIMULATIONS_IN_ASSIGNMENT_LABEL": "Simulações na tarefa",
      "BUTTON_ASSIGN_LEARNERS": "Formandos ativos",
      "CALL_TYPE_UNKNOWN": "Desconhecido",
      "ASSIGNMENT_COUNT_NONE": "Nenhuma",
      "ASSIGNMENT_COUNT_SINGULAR": "{{ count }} tarefa",
      "ASSIGNMENT_COUNT_PLURAL": "{{ count }} tarefas",
      "ERROR_LOADING_ASSIGNMENTS": "Erro ao carregar as tarefas",
      "SEARCH_ASSIGNEES_TITLE": "Pesquisar utilizadores designados",
      "DIALOG_DESCRIPTION_ADD_USERS": "Selecionar os utilizadores que participarão na tarefa. A pesquisa por uma equipa permitirá atribuir ou retirar a atribuição a utilizadores específicos dessa equipa. Ao selecionar um utilizador específico, certifique-se de que este está associado à equipa correta para efeitos de relatório.",
      "ADD_USERS_TO_ASSIGNMENT_HEADING": "Adicionar utilizadores à tarefa",
      "BUTTON_REVIEW_SELECTED_USERS": "Verifique os utilizadores selecionados",
      "FIND_USERS_LABEL": "Encontrar utilizadores",
      "BUTTON_CLEAR": "Limpar",
      "LEARNER_COUNT_NONE": "Nenhuma",
      "LEARNER_COUNT_SINGULAR": "{{ count }} formando",
      "LEARNER_COUNT_PLURAL": "{{ count }} formandos",
      "ASSIGNMENT_TAB_DETAILS": "Detalhes",
      "ASSIGNMENT_TAB_SIMULATIONS": "Simulações",
      "ASSIGNMENT_TAB_ASSIGNEES": "Utilizadores designados",
      "LOADING_ASSIGNMENT_DETAILS": "A carregar detalhes da atribuição...",
      "BREADCRUMB_ASSIGNMENTS": "Tarefas",
      "ASSIGNMENTS_COL_NAME": "Nome",
      "ASSIGNMENTS_COL_START_DATE": "Data de início da tarefa",
      "ASSIGNMENTS_COL_END_DATE": "Data de término da tarefa",
      "ASSIGNMENTS_COL_LEARNERS": "Formando designado",
      "ASSIGNMENTS_COL_TYPE": "Tipo de tarefa",
      "ASSIGNMENTS_COL_STATUS": "Estado da tarefa",
      "SIMULATIONS_COL_NAME": "Nome",
      "SIMULATIONS_COL_PRODUCT": "Produto",
      "SIMULATIONS_COL_DATE_MODIFIED": "Data da última modificação",
      "SIMULATIONS_COL_STATUS": "Estado",
      "SIMULATIONS_COL_USED_IN": "Utilizado em",
      "SIMULATIONS_COL_TYPE": "Tipo de simulação",
      "SIMULATIONS_COL_DATE_PUBLISHED": "Data de publicação",
      "CONVERSE_PROMPT_LABEL": "Instrução de conversa",
      "CONVERSE_PROMPT_EXPAND_TO_EDIT": "Expandir para editar",
      "CONVERSE_PROMPT_ENTER_LABEL": "Introduzir aqui a instrução de conversa *",
      "CONVERSE_PROMPT_EDITING_HEADING": "A editar a instrução de conversa",
      "CONVERSE_PROMPT_OVERRIDE_CONFIRMATION_HEADING": "Confirmação de substituição da instrução",
      "CONVERSE_PROMPT_OVERRIDE_DESCRIPTION": "Tem a certeza de que pretende substituir a instrução de conversação? Os autores deixarão de ter acesso à possibilidade de refinamento autónomo se esta instrução for substituída.",
      "CONVERSE_PROMPT_FIELD_LABEL": "Instrução de conversa",
      "CONVERSE_PROMPT_SAVE_BUTTON": "Guardar instrução",
      "BUTTON_CONFIRM": "Confirmar",
      "DELETE_SIM_HEADING": "Eliminar simulação",
      "DELETE_SIM_CONTENT": "Esta simulação será eliminada. Quaisquer tarefas de teste associadas à simulação serão igualmente removidas.",
      "DELETE_SIM_LABEL": "Eliminar simulação",
      "DELETE_ASSIGNMENT_HEADING": "Eliminar tarefa",
      "DELETE_ASSIGNMENT_CONTENT": "Esta tarefa será eliminada definitivamente.",
      "DELETE_ASSIGNMENT_LABEL": "Eliminar tarefa",
      "DELETE_ASSIGNMENT_NON_STAGED_CONTENT": "Para eliminar uma tarefa com o estado Ativa ou Concluída, contacte a equipa de CX. Obrigado.",
      "REMOVE_FROM_ASSIGNMENT_HEADING": "Remover da tarefa",
      "REMOVE_FROM_ASSIGNMENT_CONTENT": "Isto irá remover o utilizador da tarefa e de todas as ligações de equipa associadas.",
      "REMOVE_FROM_ASSIGNMENT_LABEL": "Remover da tarefa",
      "PUBLISH_SIMULATION_HEADING": "Publicar simulação",
      "PUBLISH_CONTINUE_EDITING": "Continuar a editar",
      "PUBLISH_BUTTON": "Publicar",
      "PUBLISH_SIMULATION_DESCRIPTION": "A simulação de papéis poderá ser adicionada às tarefas, e as informações relativas à persona, pontuação e instruções já não poderão ser editadas.",
      "CONFIRMATION_SELECTED_USERS_HEADING": "Utilizadores selecionados",
      "CONFIRMATION_TOTAL_COUNT": "{{ count }} total",
      "CONFIRMATION_CREATE_HEADING": "Criar nova tarefa",
      "CONFIRMATION_ADD_USERS_HEADING": "Adicionar utilizadores à tarefa",
      "CONFIRMATION_SAVE_ASSIGNMENT_BTN": "Guardar tarefa",
      "CONFIRMATION_REMOVE_USER": "Remover",
      "EDIT_WEIGHTING_HEADING": "Editar ponderação da pontuação",
      "EDIT_WEIGHTING_DESCRIPTION": "A pontuação global será calculada a partir da média ponderada das seguintes secções. A soma de todas as ponderações das secções ativadas deve ser igual a 100%. A secção de competências não pode ter uma ponderação superior a 20%.",
      "EDIT_WEIGHTING_ERROR_ALL_DISABLED": "Deve estar ativada pelo menos uma ação de pontuação",
      "EDIT_WEIGHTING_ERROR_WEIGHT_RANGE": "O peso da secção deve situar-se entre 0 e 100",
      "EDIT_WEIGHTING_ERROR_SKILLS_MAX": "A secção de competências não pode ter uma ponderação superior a 20%",
      "EDIT_WEIGHTING_ERROR_TOTAL": "A ponderação total das secções deve ser de 100%",
      "PERSONA_INFORMATION_TITLE": "Informação da persona",
      "PERSONA_AVATAR_LABEL": "Avatar *",
      "PERSONA_NAME_LABEL": "Nome *",
      "PERSONA_INITIAL_GREETINGS_LABEL": "Saudações iniciais *",
      "PERSONA_INITIAL_GREETINGS_DESCRIPTION": "A persona iniciará a simulação com uma destas saudações. Pode definir um máximo de 5 opções.",
      "PERSONA_ADD_GREETING_OPTION": "Adicionar opção de saudação",
      "PERSONA_RESUME_MESSAGE_LABEL": "Mensagem de retoma",
      "PERSONA_RESUME_MESSAGE_DESCRIPTION": "Quando um formando retomar uma simulação após uma pausa, a personagem começará com uma destas saudações. Pode definir um máximo de 5 opções.",
      "PERSONA_ADD_MESSAGE_OPTION": "Adicionar opção de mensagem",
      "PERSONA_UPLOADING": "A carregar...",
      "PERSONA_DELETING": "A eliminar...",
      "PERSONA_CUSTOM_BG_PREVIEW_ALT": "Pré-visualização do fundo personalizado",
      "PERSONA_AVATAR_THUMBNAIL_ALT": "Miniatura do avatar",
      "PERSONA_AVATAR_WITH_BG_ALT": "Avatar com fundo personalizado",
      "PERSONA_PROCESSING_IMAGE": "A processar imagem...",
      "PERSONA_CUSTOM_BACKGROUND_LABEL": "Fundo personalizado",
      "PERSONA_REMOVE_BACKGROUND": "Remover fundo",
      "PERSONA_CLICK_TO_REPLACE": "Clicar para substituir",
      "PERSONA_UPLOAD_DESCRIPTION": "PNG ou JPG, preferencialmente com proporção 16:9, máx. 2 MB",
      "SIM_INFORMATION_TITLE": "Informações sobre a simulação",
      "SIM_NAME_FIELD_LABEL": "Nome *",
      "SIM_LANGUAGE_FIELD_LABEL": "Idioma",
      "SIM_DETAILS_SECTION_TITLE": "Detalhes da simulação",
      "SIM_ADDITIONAL_SECTION_TITLE_LABEL": "Título adicional da secção",
      "SIM_ADDITIONAL_SECTION_INFO_LABEL": "Informações adicionais da secção",
      "TESTING_SECTION_TITLE": "Verificadores",
      "TESTING_SEND_ASSIGNMENTS_BTN": "Enviar tarefas de teste",
      "TESTING_MESSAGING_TOOLTIP": "Adicionar pelo menos um facto à Adesão à mensagem antes de testar ou publicar.",
      "TESTING_DESCRIPTION": "Procurar os utilizadores que irão testar a simulação e, em seguida, enviar-lhes a tarefa de teste.",
      "TESTING_COL_NUMBER_OF_ATTEMPTS": "Número de tentativas",
      "TESTING_COL_DATE_OF_LAST_ATTEMPT": "Data da última tentativa",
      "TESTING_CLEAR_USERS": "Limpar utilizadores",
      "TESTING_REMOVE_ASSIGNEE": "Remover o utilizador designado",
      "OVERALL_SECTION_TITLE": "Secções, ponderações e instruções",
      "OVERALL_HEADING": "Global",
      "TRANSCRIPT_PROMPT_TITLE": "Instrução da transcrição",
      "TRANSCRIPT_PROMPT_FIELD_LABEL": "Introduzir aqui a instrução da transcrição limpa",
      "SIMULATION_PROMPTS_TITLE": "Instruções da simulação",
      "TAGS_LABEL": "Etiquetas",
      "CREATE_TAG_OPTION": "Criar {{term}}",
      "TAG_CREATE_ERROR": "Não foi possível criar a etiqueta. Tente novamente",
      "EDIT_SIMULATION_TAGS_TITLE": "Editar etiquetas da simulação",
      "SAVE_TAGS_BUTTON": "Guardar etiquetas",
      "CLOSE_BUTTON": "Fechar",
      "TAG_UPDATE_ERROR": "Não foi possível atualizar a etiqueta. Tente novamente",
      "SCREEN_SHARE_TITLE": "Partilha de ecrã",
      "SCREEN_SHARE_DESCRIPTION": "Permite ao utilizador partilhar o seu ecrã com o avatar durante a chamada, para que este possa ver e responder ao que está a ser apresentado",
      "SCREEN_SHARE_STATUS_ON": "Ativado",
      "SCREEN_SHARE_STATUS_OFF": "Desativado",
      "SCREEN_SHARE_NO_PERSONA": "Adicione primeiro uma persona para ativar a partilha de ecrã.",
      "HIDE_RESULTS_LABEL": "Ocultar resultados",
      "SEARCH_FIELD_HINT": "Digitar pelo menos três caracteres para iniciar a pesquisa",
      "OTHERS_SINGULAR": "e mais 1",
      "OTHERS_PLURAL": "e {{ count }} mais",
      "PAGINATION_PREVIOUS": "Anterior",
      "PAGINATION_NEXT": "Seguinte",
      "SKILLS_RUBRIC_REQUIRED_TOOLTIP": "Anexa um rubrica de competências. As competências estão ativadas com uma ponderação superior a 0%.",
      "ENTITY_TYPE_KNOWLEDGE_CHECK_DISPLAY": "verificação de conhecimentos",
      "NAME_MAX_LENGTH_ERROR": "O nome deve ter, no máximo, 255 caracteres.",
      "UUID_COPIED_TOAST": "IUU da chamada copiado para a área de transferência",
      "MENU_ARCHIVE": "Arquivo",
      "MENU_EDIT_SIMULATION_TAGS": "Editar etiquetas da simulação",
      "MENU_COPY_UUID": "Copiar IUU",
      "REFINEMENT_IN_PROGRESS_TOOLTIP": "Refinamento em curso. Pode continuar assim que estiver concluído.",
      "SIMULATION_DOCUMENTS_PARSE_FAILED_BODY": "Um dos seus documentos para {{ name }} não pôde ser lido — verifique-o ou substitua-o e tente novamente.",
      "REFINEMENT_ERROR_MESSAGE": "Lamentamos, mas este pedido não pôde ser concluído. Tentar novamente",
      "REFINEMENT_OUT_OF_SCOPE_TITLE": "Pedido fora do âmbito.",
      "REFINEMENT_OUT_OF_SCOPE_BODY": "A sua solicitação para {{ name }} está fora do âmbito do que o refinamento consegue fazer. Contacte a assistência.",
      "TAB_QUESTIONS": "Perguntas",
      "KNOWLEDGE_CHECK_NAME_LABEL": "Nome*",
      "AVATAR_APPEARANCE_LABEL": "Aparência do avatar",
      "KNOWLEDGE_CHECK_AVATAR_NAME_LABEL": "Nome do avatar",
      "KNOWLEDGE_CHECK_SKILLS_FEEDBACK_TITLE": "Feedback sobre competências",
      "KNOWLEDGE_CHECK_SCORING_DESCRIPTION": "As simulações da verificação de conhecimentos são pontuadas com base na percentagem de pontos de resposta abrangidos em cada pergunta. Selecione uma rubrica de competências abaixo para receber também feedback qualitativo.",
      "KNOWLEDGE_CHECK_SCORING_RESCORE_DESCRIPTION": "Depois de testar a simulação pelo menos uma vez, selecione «Pontuar a minha última sessão» para ver a sua pontuação. Se editar os pontos de resposta, poderá voltar a pontuar a mesma sessão. Se editar as perguntas, terá de realizar uma nova sessão de teste antes de atribuir a pontuação.",
      "KNOWLEDGE_CHECK_SKILLS_RUBRIC_LABEL": "Rubrica de competências (opcional)",
      "SIMULATION_TYPE_MODAL_TITLE": "Criar nova simulação",
      "SIMULATION_TYPE_MODAL_DESCRIPTION": "Escolha como os seus formandos irão praticar.",
      "SIMULATION_TYPE_ROLE_PLAY_TITLE": "Dramatização",
      "SIMULATION_TYPE_ROLE_PLAY_DESCRIPTION": "Os formandos conduzem uma conversa aberta com uma personagem de IA, que responde naturalmente a tudo o que dizem.",
      "SIMULATION_TYPE_ROLE_PLAY_BEST_FOR": "Ideal para: praticar chamadas de vendas realistas, como apresentações de vendas e gestão de objeções.",
      "SIMULATION_TYPE_KNOWLEDGE_CHECK_TITLE": "Verificação de conhecimentos",
      "SIMULATION_TYPE_KNOWLEDGE_CHECK_DESCRIPTION": "Uma personagem de IA faz aos formandos as perguntas que escrever, na ordem que definir.",
      "SIMULATION_TYPE_KNOWLEDGE_CHECK_BEST_FOR": "Ideal para: testar o conhecimento do produto e certificar-se de que os representantes estão preparados.",
      "TAGS_FILTER_LABEL": "Etiquetas",
      "TAGS_FILTER_PLACEHOLDER": "Selecionar uma etiqueta",
      "CLEAR_ALL_FILTERS": "Limpar todos os filtros",
      "LAST_SAVED_LABEL": "Última gravação",
      "BUTTON_OK": "OK",
      "KEYWORDS_RESET_TO_PRODUCT_DEFAULT": "Redefinir para os valores predefinidos do produto",
      "KEYWORDS_DETACH_FROM_PRODUCT_DEFAULT": "Desvincular das predefinições do produto",
      "KEYWORDS_SAVE_AS_PRODUCT_DEFAULT": "Guardar como predefinição do produto",
      "KEYWORDS_SAVE_AS_DEFAULT_OVERWRITE": "Isto irá substituir o valor predefinido {{ keywordTitle }} para o produto {{ moduleName }}.",
      "KEYWORDS_SAVE_AS_DEFAULT_IMPACT": "Estas palavras serão adicionadas às novas simulações para {{ moduleName }}. Todas as chamadas relacionadas com o produto {{ moduleName }} serão afetadas.",
      "KEYWORDS_ADD_NEW_WORD": "Adicionar nova palavra",
      "KEYWORDS_FROM_LABEL": "De",
      "KEYWORDS_TO_LABEL": "Para",
      "KEYWORDS_PRONOUNCE_TITLE": "Pronunciar palavras",
      "KEYWORDS_PRONOUNCE_DESCRIPTION": "Forneça correções de pronúncia ao agente de IA, para que este pronuncie nomes/termos corretamente. O agente associa erros de pronúncia e variantes comuns à nova pronúncia.",
      "KEYWORDS_PRONOUNCE_NAME": "pronunciar palavras",
      "KEYWORDS_ADD_MISPRONUNCIATION": "Adicionar pronúncia errada",
      "KEYWORDS_SELECT_PERSONA_NOTICE": "Selecione uma persona para adicionar palavras a pronunciar.",
      "KEYWORDS_REPLACE_TITLE": "Substituir palavras",
      "KEYWORDS_REPLACE_DESCRIPTION": "Correções explícitas de «procurar e substituir» no texto transcrito pelo utilizador; substituições diretas de palavras que ocorrem antes da correção fonética.",
      "KEYWORDS_REPLACE_NAME": "substituir palavras",
      "KEYWORDS_ADD_REPLACEMENT": "Adicionar substituição",
      "KEYWORDS_STT_TITLE": "Palavras de STT",
      "KEYWORDS_STT_DESCRIPTION": "Lista de palavras fornecida aos fornecedores de Speech-to-Text (STT) (por exemplo, AssemblyAI, Tavus), especificamente para a configuração do fornecedor de STT.",
      "KEYWORDS_STT_NAME": "palavras de stt",
      "KEYWORDS_GENERATING": "A criar...",
      "KEYWORDS_GENERATE_STT_PROMPT": "Criar stt_prompt",
      "KEYWORDS_STT_PROMPT_OUTDATED": "A lista de palavras foi atualizada desde que esta instrução foi criada. Voltar a criar para refletir as alterações mais recentes.",
      "KEYWORDS_STT_CANNOT_SAVE_HEADING": "Não é possível guardar ao nível do produto",
      "KEYWORDS_STT_CANNOT_SAVE_BODY": "As palavras e a instrução de STT não podem ser guardados ao nível do produto. Pode alterar manualmente outras configurações de simulação do STT ou contactar o seu administrador para obter ajuda.",
      "KEYWORDS_CLEAN_TRANSCRIPT_TITLE": "Palavras da transcrição limpa",
      "KEYWORDS_CLEAN_TRANSCRIPT_DESCRIPTION": "Palavras que são inseridas na instrução CLEAN_TRANSCRIPT_V2.",
      "KEYWORDS_CLEAN_TRANSCRIPT_NAME": "palavras da transcrição limpa",
      "KEYWORDS_CALL_TITLE": "Palavras da chamada",
      "KEYWORDS_CALL_DESCRIPTION": "Dicionário de palavras corretas para correção fonética, utilizado pelo algoritmo Double Metaphone para corrigir erros ortográficos foneticamente semelhantes. Evite termos compostos por várias palavras, como «Anti MuSK AB+», uma vez que o corretor de transcrições baseado em código só funciona de forma fiável com palavras isoladas. Evite também símbolos, por exemplo, «lp(a)», pois tendem a confundir o corretor. A lista deve permanecer o mais pequena e simples possível, uma vez que é gerida por um algoritmo determinístico, e não por um MLGE, e não possui compreensão contextual",
      "KEYWORDS_CALL_NAME": "palavras da chamada"
    },
    "settings": {
      "DEVICE_SETUP_INTRO": "Vamos certificar-nos de que o seu dispositivo está configurado.",
      "MICROPHONE_REQUIRED_NOTICE": "É necessário um microfone funcional.",
      "DEVICE_ENABLE_INSTRUCTIONS": "Se não vir um pedido de pop-up para ativar os seus dispositivos após atualizar esta página, aceda às definições do seu sistema ou navegador e ative os seus dispositivos. Abaixo encontram-se páginas de apoio com instruções adicionais.",
      "ENABLE_CAMERA": "Como ativar a sua câmara:",
      "WINDOWS_USERS": "Utilizadores de Windows",
      "MAC_USERS": "Utilizadores de Mac",
      "IPAD_USERS": "Utilizadores de iPad",
      "ENABLE_MICROPHONE": "Como ativar o microfone:",
      "ENABLE_DEVICES_BY_BROWSER": "Como ativar os seus dispositivos por browser:",
      "CHROME_USERS": "Utilizadores do Chrome",
      "SAFARI_USERS": "Utilizadores do Safari",
      "FIREFOX_USERS": "Firefox",
      "EDGE_USERS": "Edge",
      "START_WITHOUT_CAMERA_BUTTON": "Iniciar sem câmara",
      "START_CALL_BUTTON": "Iniciar chamada",
      "MICROPHONE_REQUIRED_WARNING": "É necessário um microfone funcional.",
      "MICROPHONE_ALT": "microfone",
      "MICROPHONE": "Microfone",
      "SELECT_MICROPHONE": "Selecione o seu microfone",
      "ALERT": "alerta",
      "GIVE_PERMISSION": "Dar autorização",
      "SELECT_VIDEO_DEVICE": "Selecione o seu dispositivo de vídeo",
      "VIDEO": "vídeo",
      "DEVICE_BLOCKED_ERROR": "Parece que negou o acesso deste navegador a um ou mais dos seus dispositivos. Para ativar os dispositivos, aceda às definições do sistema ou às definições do browser e ative o acesso.",
      "DEVICE_SETTINGS": "Definições do dispositivo",
      "CONFIRM_SETTINGS": "Confirmar definições",
      "LAPTOP": "Computador portátil",
      "SAD_EMOTE_FACE": "Carinha triste",
      "GRANT_BROWSER_ACCESS": "Para concluir esta simulação, conceda o acesso do navegador ao reconhecimento de voz",
      "USING_IPAD": "Se estiver a utilizar um iPad, aceda a",
      "SETTINGS": "Definições",
      "PRIVACY_AND_SECURITY": "Privacidade e segurança",
      "SPEECH_RECOGNITION": "Reconhecimento de voz",
      "GRANT_ACCESS_REFRESH": "Conceder acesso ao navegador e atualizar a página",
      "REFRESH_PAGE": "ATUALIZAR A PÁGINA",
      "BROWSER_UNABLE_TO_ACCESS": "O navegador não consegue aceder a este dispositivo",
      "ACCESS_DENIED": "acesso negado",
      "CAMERA": "Câmara",
      "DIAGNOSTIC_PASSED": "Todos os testes de diagnóstico foram aprovados com sucesso.",
      "DIAGNOSTIC_FAILED_MESSAGE": "Alguns testes de diagnóstico falharam. Clique no botão «Copiar resultados de diagnóstico» acima e envie os resultados para a equipa de apoio para obter assistência.",
      "DIAGNOSTIC_PARTIAL": "A maioria dos testes de diagnóstico foi aprovada com sucesso. A sua ligação parece estar boa.",
      "DIAGNOSTIC_RUNNING_MESSAGE": "Aguarde enquanto os testes de diagnóstico estão a ser executados...",
      "DIAGNOSTIC_RUNNING": "Diagnóstico em execução",
      "COPY_DIAGNOSTIC_RESULTS": "Copiar resultados do diagnóstico",
      "RUN_DIAGNOSTIC": "Executar diagnóstico",
      "RERUN_DIAGNOSTIC": "Voltar a executar diagnóstico",
      "DIAGNOSTIC_RESULTS_COPIED": "Resultados do diagnóstico copiados para a área de transferência",
      "DIAGNOSTIC_FAILED": "Falha no diagnóstico",
      "DIAGNOSTIC_WEBSOCKET_NOT_TESTED": "Websocket: not tested",
      "DIAGNOSTIC_TURN_NOT_TESTED": "TURN: not tested",
      "DIAGNOSTIC_QUALITY_NOT_TESTED": "Quality: not tested",
      "DIAGNOSTIC_QUANTIFIED_DIAGNOSTICS": "Diagnósticos quantificados",
      "DIAGNOSTIC_TIME": "tempo",
      "DIAGNOSTIC_SUMMARY": "Resumo",
      "DIAGNOSTIC_CLIENT_INFO": "Informações do cliente",
      "DIAGNOSTIC_PLATFORM": "Plataforma",
      "DIAGNOSTIC_RTT_AVG_MAX": "RTT avg/max",
      "DIAGNOSTIC_PACKET_LOSS_SEND": "Perda de pacotes (envio)",
      "DIAGNOSTIC_AVG_SEND_BITRATE": "Velocidade de transmissão média",
      "DIAGNOSTIC_NA": "n/a",
      "DIAGNOSTIC_PROBLEMS_CONNECTING_PREFIX": "Está com dificuldades em ligar-se?",
      "DIAGNOSTIC_CLICK_HERE": "Clique aqui",
      "DIAGNOSTIC_TO_RUN_SUFFIX": "para executar um diagnóstico."
    },
    "results": {
      "RETURN_HOME": "REGRESSAR AO INÍCIO",
      "CLOSE_BUTTON": "Botão de fechar",
      "CONVERSATIONAL_CALL": "DRAMATIZAÇÃO",
      "INFORMATION_ICON": "Ícone de informação",
      "TOOLTIP_ARROW": "Seta de descrição",
      "INFORMATION_TOOLTIP_CONTENT": "O utilizador controla o fluxo da simulação, conduzindo a conversa para um conjunto de objetivos. As dramatizações são ótimas para testar competências como aprofundar questões, fazer perguntas de segundo nível, identificar pontos críticos e criar relações.",
      "CLOCK_ICON": "Ícone do relógio",
      "CALL_RESULTS": "Resultados",
      "SKILLS": "Competências",
      "MESSAGE_ADHERENCE": "Aderência à mensagem",
      "TRY_AGAIN_MESSAGE": "Tente novamente e melhore a sua pontuação.",
      "PRACTICE_BENEFITS": "A prática semanal aumenta a confiança e melhora os resultados no mundo real.",
      "CALL_SUCCESS": "Excelente trabalho! Esta simulação foi concluída com êxito.",
      "MAX_ATTEMPTS_REACHED": "Atingiu o número máximo de tentativas",
      "TRY_AGAIN": "Tentar de novo",
      "GREAT_JOB_YOU_SUCCESSFULLY": "Excelente trabalho! Conseguiu completar",
      "COMPLETED_THIS_CALL": "completou esta simulação.",
      "ACHIEVED_SCORE": "O formando obteve uma pontuação de",
      "ACHIEVE_SCORE": "Obtenha uma pontuação de",
      "OR_HIGHER": "ou superior.",
      "OBJECTIVES_NOT_MET": "Não cumpriu todos os objetivos exigidos.",
      "TRY_AGAIN_TARGET_SCORE": "Tente novamente para obter uma pontuação de",
      "YOUR_SCORE": "A sua pontuação",
      "OUT_OF_5": "DE 5",
      "CALL_FEEDBACK": "RESUMO DO FEEDBACK",
      "STRENGTH_ICON_ALT": "Ícone de força",
      "OPPORTUNITIES_ICON_ALT": "Ícone de oportunidades",
      "OBJECTIVES_FEEDBACK": "FEEDBACK SOBRE A METODOLOGIA",
      "SESSION_ID": "ID da sessão:",
      "SESSION_ID_COPIED": "ID da sessão copiado!",
      "OBJECTIVE": "METODOLOGIA:",
      "HOW_YOU_DID": "O seu desempenho:",
      "LIGHTBULB_ICON_ALT": "Ícone de lâmpada",
      "WHAT_WE_SUGGEST": "O que sugerimos:",
      "NO_SPECIFIC_RECOMMENDATION": "O nosso sistema não conseguiu encontrar uma recomendação específica para si.",
      "WHY": "Porquê?",
      "NO_INSIGHTS_AVAILABLE": "O nosso sistema não foi capaz de fornecer informações sobre esta sugestão.",
      "CONFETTI_ICON_ALT": "Ícone de confettis",
      "OBJECTIVE_SUCCESS_MESSAGE": "Excelente desempenho nesta metodologia, mantenha o bom trabalho!",
      "PROCESSING_CALL": "Estamos a preparar a sua pontuação e o seu feedback.",
      "HANG_TIGHT": "Aguarde ou volte mais tarde para",
      "VIEW_YOUR_RESULTS": "ver os seus resultados.",
      "NEED_MORE_TIME": "Precisamos de mais tempo para calcular os resultados.",
      "REFRESH_INSTRUCTION": "Verifique novamente ou atualize a tarefa",
      "RESULTS_IN_FEW_MINUTES": "resultados em poucos minutos.",
      "SCORE_CALCULATION_QUESTION": "Como é que isto é calculado?",
      "SINGLE_SCORE_EXPLANATION": "Esta simulação tem apenas um componente de pontuação, pelo que a pontuação exibida corresponde tanto à pontuação da secção individual como à pontuação global.",
      "OVERALL_SCORE_PERCENT": "da pontuação global",
      "SECTION_SCORE": "Pontuação da secção",
      "ELEVATE_MESSAGE_ADHERENCE_TITLE": "Aumente a aderência da mensagem na conversa",
      "MESSAGE_ADHERENCE_NOTE": "A aderência à mensagem é fundamental para conduzir conversas bem sucedidas, mas não afeta a sua pontuação global.",
      "NO_CREDIT": "Sem crédito",
      "PARTIAL_CREDIT": "Crédito parcial",
      "FULL_CREDIT": "Crédito total",
      "WHAT_YOU_DID_WELL": "O que fez bem",
      "MISSED_ALL_KEY_POINTS": "Falhou todos os pontos-chave; reveja-os e tente novamente.",
      "WHAT_TO_IMPROVE": "O que pode melhorar",
      "PERFECT_SCORE_MESSAGE": "Parabéns! Obteve uma pontuação perfeita, falando corretamente de todos os pontos-chave.",
      "POINTS_LABEL": "Pontos",
      "TALKING_POINTS_COVERED": "Temas de discussão abordados",
      "CHECKMARK_ICON_ALT": "marca de verificação",
      "TALKING_POINTS_MISSED": "Temas de discussão não abordados",
      "X_ICON_ALT": "x",
      "PRACTICE_AGAIN": "Praticar novamente",
      "OUT_OF": "de",
      "OBJECTIVES": "Metodologia",
      "ELEVATE_OBJECTIVES_TITLE": "Melhore a sua metodologia de conversação",
      "OBJECTIVES_NOTE": "A metodologia é fundamental para conduzir conversas bem sucedidas, mas não afeta a sua pontuação global.",
      "UNTIL": "até",
      "TO_IMPROVE_SCORE": "para melhorar a sua pontuação.",
      "YOU_HAVE": "Tem",
      "MORE_ATTEMPTS": "mais tentativas de pontuar",
      "OR_HIGHER_BEFORE": "ou superior antes de",
      "AND_TRY_AGAIN": "e tentar novamente.",
      "UNEXPECTED_STATE": "Ocorreu um estado inesperado.",
      "REVIEW_APP_LOGIC": "Reveja a lógica da aplicação.",
      "ASSIGNMENTS": "Tarefas",
      "VIEW_CALL_DETAILS": "Ver detalhes da chamada",
      "PRACTICE_SESSION": "Sessão de prática",
      "OVERALL_SCORE": "Pontuação global",
      "OVERALL_SCORE_EXPLANATION": "A pontuação global é calculada através de uma média ponderada da pontuação de cada secção. O peso de cada secção é apresentado como uma percentagem junto à pontuação.",
      "SCORE_CONFIG_NOTE": "As percentagens de peso, bem como a inclusão e exclusão de secções, são definidas pela sua empresa. Todas as pontuações são arredondadas ao décimo mais próximo.",
      "STRENGTHS": "Pontos fortes",
      "OPPORTUNITIES": "Oportunidades",
      "YOUR_RESPONSE": "A sua resposta",
      "MINUS": "menos",
      "PLUS": "mais",
      "RECOMMENDED_RESPONSE": "Resposta recomendada",
      "REVIEW_MISSED_TITLE": "Reveja o que falhou.",
      "NO_TALKING_POINTS_COVERED": "Não abrangeu nenhum dos temas de discussão necessários para este tópico.",
      "LEARN_WHAT_YOU_MISSED": "Saiba o que falhou",
      "NICE_JOB": "Bom trabalho!",
      "ALL_POINTS_COVERED": "Conseguiu abordar todos os temas de discussão necessários para este tópico.",
      "COVER_ALL_MESSAGES": "Abordou todas as mensagens-chave.",
      "HIGHLIGHT_KEY_POINTS_NOTE": "Destacar os pontos-chave durante a chamada ajudará a manter a conversa focada.",
      "MESSAGES_LABEL": "Mensagens",
      "NO_FACTS_COVERED": "Ups! Parece que não abordou nenhum dos factos desta mensagem.",
      "NO_SPECIFICS_AVAILABLE": "Ups! Parece que não foi possível fornecer detalhes sobre o que foi falhou.",
      "ALL_KEY_POINTS_COVERED": "Excelente trabalho! Abordou todos os pontos essenciais.",
      "PROCESSING_SKILLS_FEEDBACK": "Estamos a processar o feedback das suas competências.",
      "SKILLS_SCORING_NOT_ENABLED": "Lamentamos, mas não foi possível analisar a sua chamada recente porque a pontuação de competências não estava ativada no momento da submissão. Para obter feedback, basta voltar a submeter a sua prática da chamada como fez anteriormente. Se precisar de ajuda, não hesite em contactar a nossa equipa de assistência. Agradecemos a sua compreensão e empenho em melhorar!",
      "ELEVATE_CONVERSATION_SKILLS": "Melhore as suas capacidades de conversação",
      "SKILLS_NOTE": "As competências são fundamentais para conduzir conversas bem-sucedidas, mas não afetam a sua pontuação global.",
      "SKILLS_SUMMARY_TITLE": "RESUMO DAS COMPETÊNCIAS",
      "LEARN_MORE_ABOUT_SKILLS": "Saiba mais sobre as competências",
      "SKILLS_FEEDBACK_LABEL": "FEEDBACK",
      "WHAT_ARE_SKILLS_TITLE": "O que são competências",
      "SKILLS_DESCRIPTION": "As competências são ajustadas para favorecer o desenvolvimento pessoal. Embora estas competências não façam parte da avaliação numérica da sua chamada, foram selecionadas pela sua organização para aumentar a sua eficácia.",
      "PROFICIENCY_SCALE_TITLE": "ESCALA DE PROFICIÊNCIA",
      "EXPERT": "Perito",
      "PROFICIENT": "Proficiente",
      "DEVELOPING": "Em desenvolvimento",
      "CALL_TRANSCRIPT": "Transcrição da chamada",
      "COLLAPSE_ALL": "Fechar tudo",
      "EXPAND_ALL": "Expandir tudo",
      "THUMBNAIL": "Miniatura",
      "OUT_OF_FIVE_POINTS": "/5 pontos",
      "TALKING_POINTS": "temas de discussão",
      "TRANSCRIPT_LABEL": "Transcrição",
      "YOU_ARE_OUT_OF_ATTEMPTS": "Não há mais tentativas.",
      "REVIEW_GUIDELINES_REMAIN_COMPLIANT": "Reveja as diretrizes e mantenha-se em conformidade no futuro.",
      "TRY_AGAIN_ATTENTION_TO_COMPLIANCE": "Tente novamente, tendo em conta as diretrizes de conformidade.",
      "NO_SCORE_OUT_OF_COMPLIANCE": "Identificámos algo que poderá estar em incumprimento",
      "WHY_OUT_OF_COMPLIANCE": "Por que razão poderá não estar em conformidade",
      "REVIEW_TRANSCRIPT_MISSED_GUIDELINES": "Reveja a sua transcrição para ver onde não cumpriu as diretrizes de conformidade.",
      "YOU_DID_FOLLOW_GUIDELINES": "Seguiu efetivamente estas diretrizes.",
      "REVIEW_MISSED_GUIDELINES": "Rever as diretrizes de conformidade em falta.",
      "OUT_OF_COMPLIANCE": "Não conformidade",
      "SCORE_CALCULATION_TITLE": "Cálculo da pontuação",
      "PROCESSING_TRANSCRIPT": "Estamos a processar a sua transcrição.",
      "WAIT_OR_REVIEW_SCORES": "Aguarde aqui ou reveja as outras secções",
      "TRANSCRIPT_LOADING": "de pontuação enquanto a transcrição é carregada.",
      "REVIEW_FEEDBACK_KEEP_PRACTICING": "Analise o seu feedback e continue a praticar.",
      "HIGH_PERFORMERS_PRACTICE": "Os formandos com bom desempenho praticam pelo menos uma vez por semana",
      "SUCCESSFULLY_PASSED": "Excelente trabalho! Passou esta simulação com sucesso.",
      "DIDNT_REACH_PASSING_SCORE": "Não atingiu a pontuação mínima para passar nesta simulação.",
      "OUT_OF_ATTEMPTS": "<b>Não há tentativas disponíveis.</b> Analise o seu feedback para saber como pode melhorar.",
      "REVIEW_FEEDBACK_THEN_RETURN": "Analise o feedback e volte à página inicial quando quiser.",
      "GREAT_JOB_PRACTICED": "Bom trabalho, praticou {{count}} {{times}}. Continue!",
      "TIME": "tempo",
      "TIMES": "tempos",
      "COMPLIANCE_GUIDELINES": "Diretrizes de conformidade",
      "TALKING_POINT_TITLE": "TEMAS DE DISCUSSÃO NÃO ABORDADOS OU ABORDADOS NO MOMENTO ERRADO",
      "NO_TRANSCRIPT": "Não há transcrição disponível.",
      "QUIZ_SUMMARY_BASE": "Reserve um momento para rever o seu desempenho neste questionário.",
      "QUIZ_SUMMARY_FAILED": "Reserve um momento para rever o seu desempenho neste questionário. Reveja o {{stepNames}} {{stepWord}} destacado na síntese do percurso para se preparar melhor para a sua próxima tentativa.",
      "QUIZ_SUMMARY_PASSED_WITH_MISSES": "Reserve um momento para rever o seu desempenho neste questionário. A sua área de pontuação mais baixas foi em {{stepNames}} {{stepWord}} {{stepVerb}}.",
      "OUT_OF_100": "DE 100",
      "COVERED": "Abordado",
      "MISSED": "Falhou",
      "RETURN_TO_ASSIGNMENT": "Regressar à tarefa",
      "RETURN_TO_PATHWAY": "REGRESSAR AO PERCURSO",
      "QUIZ_RESULTS_SUMMARY": "Resumo dos resultados do questionário",
      "PROCESSING_RESULTS": "A processar resultados...",
      "NONE_PERFECT": "Nenhum - Perfeito!",
      "MESSAGING": "Mensagens",
      "MISSED_ONE_TALKING_POINT": "Faltou-lhe 1 ponto de discussão sobre este tema.",
      "MISSED_X_TALKING_POINTS": "Faltaram-lhe {{count}} pontos de discussão sobre este tema.",
      "ROLEPLAY_POST_CALL_TITLE": "Chegou ao fim da chamada.",
      "ROLEPLAY_POST_CALL_SUBTITLE_PROCESSING": "Deixe-nos feedback enquanto processamos os seus resultados.",
      "ROLEPLAY_POST_CALL_SUBTITLE_DELAY": "Os resultados estão a demorar algum tempo a carregar. Saia do percurso e avisaremos quando estiverem prontos.",
      "ROLEPLAY_POST_CALL_SUBTITLE_ERROR": "Ocorreu um erro ao processar os seus resultados. Entre em contacto com o apoio ao cliente através do",
      "ROLEPLAY_POST_CALL_PROCESSING_LABEL": "A processar resultados...",
      "ROLEPLAY_POST_CALL_FEEDBACK_QUESTION": "Esta conversa foi realista e natural?",
      "FEEDBACK_THANK_YOU": "Agradecemos o seu feedback!",
      "FEEDBACK_IMPROVEMENT_NOTE": "Agradecemos o seu feedback! Estamos a empenhar-nos para aprimorar a experiência.",
      "VIEW_RESULTS": "Ver resultados",
      "FEEDBACK_IMPROVEMENT_SUFFIX": "Estamos a empenhar-nos para aprimorar a experiência.",
      "QUIZ_RESULTS_LOADING": "Os resultados estão a demorar algum tempo a carregar. Saia do percurso; avisaremos quando estiverem prontos.",
      "KC_TOAST_TITLE": "Os resultados da sua verificação de conhecimentos já estão disponíveis",
      "KC_TOAST_CONTENT": "Clique abaixo para visualizar ou volte ao ecrã de detalhes do percurso para o próximo passo.",
      "DISMISS": "Ignorar",
      "KC_TOAST_TITLE_PATHWAY": "Os resultados da sua verificação de conhecimentos {{stepName}} já foram processados",
      "MISSED_ONE_REQUIRED_TALKING_POINT": "Faltou-lhe 1 ponto de discussão necessário sobre este tema",
      "MISSED_X_REQUIRED_TALKING_POINTS": "Faltaram-lhe {{count}} pontos de discussão necessários sobre este tema",
      "MISSED_ALL_ONE_REQUIRED_TALKING_POINT_TITLE": "Faltou-lhe 1 ponto de discussão necessário sobre este tema.",
      "MISSED_ALL_X_REQUIRED_TALKING_POINTS_TITLE": "Faltaram-lhe {{count}} pontos de discussão necessários sobre este tema.",
      "REVIEW_MATERIAL_NEXT_TIME": "Reveja o material para melhorar na próxima vez.",
      "POINT_LABEL": "Ponto",
      "GREAT_JOB_PRACTICED_FEMALE": "Bom trabalho, praticou {{count}} {{times}}. Continue!",
      "ACCURACY": "Precisão",
      "ACCURACY_LOADING": "A carregar...",
      "ACCURACY_FLAGGED_MESSAGE": "Disse algumas coisas que podem diferir dos seus materiais de referência. Consulte abaixo para obter mais detalhes.",
      "ACCURACY_ALL_CLEAR": "Não identificámos quaisquer afirmações que fossem imprecisas em relação aos materiais de referência.",
      "ACCURACY_ERROR": "Não foi possível fornecer feedback sobre esta sessão",
      "ACCURACY_YOU_SAID": "O QUE DISSE",
      "ACCURACY_CLAIM_IDENTIFIED": "A AFIRMAÇÃO QUE IDENTIFICÁMOS",
      "ACCURACY_MATERIALS_STATE": "O QUE OS SEUS MATERIAIS AFIRMAM",
      "ACCURACY_OVERALL_BLOCK_PREFIX": "Disse algumas coisas que podem estar incorretas. Verificar a ",
      "ACCURACY_OVERALL_BLOCK_LINK": "precisão",
      "ACCURACY_OVERALL_BLOCK_SUFFIX": " para mais detalhes.",
      "PRACTICE_SIMULATION_AGAIN": "Fazer novamente a simulação",
      "CALL_TYPE_CONVERSATIONAL": "Chamada de conversação",
      "CALL_TYPE_GUIDED": "Chamada guiada",
      "CALL_TYPE_VISUAL_AID": "Chamada com apoio visual",
      "CALL_TYPE_ROLEPLAY": "Chamada com dramatização",
      "PERSONALIZED_PRACTICE_BREADCRUMB": "Prática personalizada",
      "CONVERSATION_TYPE_LABEL": "Tipo de conversa:",
      "DIFFICULTY_LABEL": "Dificuldade:",
      "MOOD_LABEL": "Humor:",
      "DIFFICULTY": "Dificuldade",
      "TEMPERAMENT": "Temperamento",
      "OVERALL_SCORE_TAB": "Global",
      "MESSAGE_ADHERENCE_TAB": "Mensagens",
      "OBJECTIVES_TAB": "Objetivos"
    },
    "reportingV2": {
      "DASHBOARD": "Painel de controlo",
      "LOADING_ACCOUNTS": "A carregar contas...",
      "SELECT_AN_ACCOUNT": "Selecionar uma conta",
      "SEARCH_TEAMS": "Pesquisar equipas",
      "LOADING_TEAMS": "A carregar equipas...",
      "ALL_TEAMS": "Todas as equipas",
      "ACCOUNT": "Conta",
      "TEAMS": "Equipas",
      "TEAM_LABEL": "Equipa",
      "TOTAL_LABEL": "Total",
      "PASSING_SCORE": "Pontuação de aprovação",
      "ASSIGNMENT_LABEL": "Tarefas",
      "USER_LABEL": "Utilizadores",
      "PRACTICE_LABEL": "Prática",
      "CERTIFICATION_LABEL": "Certificação",
      "RESULTS_DESCRIPTION": "Aqui estão os resultados da(s) sua(s) equipa(s) em todas as tarefas de treino:",
      "ENGAGEMENT_BY_ASSIGNMENT": "Envolvimento por tarefa",
      "ASSIGNMENT_ENGAGEMENT": "Envolvimento com a tarefa",
      "ENGAGED_LABEL": "Com participação",
      "ENGAGEMENT_STATUS_LABEL": "Estado do envolvimento",
      "PROFICIENT_LABEL": "Proficiente",
      "ASSIGNMENT_NAME": "Nome da tarefa",
      "ACTIVE_USERS": "Utilizadores ativos",
      "ASSIGNMENT_PROGRESS": "Progresso por tarefa",
      "IN_PROGRESS_LABEL": "Em curso",
      "CERTIFIED_LABEL": "Certificado",
      "OUT_OF_ATTEMPTS_LABEL": "Sem tentativas",
      "USERS_ENGAGED_LABEL": "Utilizadores com participação",
      "SESSIONS_PER_ACTIVE_USERS_LABEL": "Sessões por utilizador ativo",
      "HIGHER_THAN_LABEL": "Superior a",
      "MORE_THAN_LABEL": "Mais de",
      "TOTAL_SESSIONS_COMPLETED_LABEL": "Total de sessões concluídas",
      "USER_CERTIFIED": "Utilizadores certificados em todas as tarefas",
      "ASSIGNMENT_CERTIFICATION": "Tarefas com certificação a 100%",
      "TRAINER_TIME_SAVED": "Poupança de tempo do formador",
      "HOURS_LABEL": "horas",
      "PRACTICE_ASSIGNMENT_LABEL": "Tarefas práticas",
      "CERTIFICATION_ASSIGNMENT_LABEL": "Tarefas de certificação",
      "START_DATE_LABEL": "Data de início",
      "END_DATE_LABEL": "Data final",
      "NAME_LABEL": "Nome",
      "EMAIL_LABEL": "E-mail",
      "MEMBER_OF_TEAMS_LABEL": "Membro de equipas",
      "ASSIGNMENTS_COUNT_LABEL": "Número de tarefas",
      "TOTAL_SESSIONS_LABEL": "Total de sessões",
      "NUMBER_OF_SESSIONS_LABEL": "Número de sessões",
      "TOTAL_USERS_LABEL": "Total de utilizadores",
      "AVERAGE_SCORE_LABEL": "Pontuação média",
      "INITIAL_SCORE_LABEL": "Pontuação inicial",
      "HIGH_SCORE_LABEL": "Pontuação elevada",
      "LAST_PRACTICE_DATE_LABEL": "Data do último treino",
      "PERCENT_IMPROVED_LABEL": "% de melhoria",
      "PERCENT_IMPROVED_TOOLTIP_TEXT": "Esta métrica compara a pontuação inicial de um utilizador com a sua pontuação mais elevada, expressa como uma percentagem da melhoria máxima possível.",
      "ASSIGNMENTS_CERTIFIED_LABEL": "Tarefas certificadas",
      "ASSIGNMENTS_PROFICIENT_LABEL": "Tarefas com bom desempenho",
      "ASSIGNMENTS_CERTIFIED_TOOLTIP_TEXT": "O número de tarefas em que o utilizador cumpriu ou excedeu os critérios de pontuação para todas as simulações na tarefa.",
      "ASSIGNMENTS_PROFICIENT_TOOLTIP_TEXT": "O número de tarefas em que o utilizador cumpriu ou excedeu os critérios de pontuação, pelo menos uma vez, em todas as simulações da tarefa.",
      "PROFICIENT_TOOLTIP": "O número de utilizadores nesta tarefa que atingiram ou superaram, pelo menos uma vez, os critérios definidos para pontuação alta em todas as chamadas desta tarefa.",
      "IN_PROGRESS_TOOLTIP": "A percentagem de utilizadores que completaram pelo menos uma sessão de uma simulação nesta tarefa e receberam uma pontuação.",
      "OUT_OF_ATTEMPTS_TOOLTIP": "A percentagem de utilizadores que excederam as tentativas atribuídas para uma ou mais simulações na tarefa.",
      "CERTIFIED_TOOLTIP": "A percentagem de utilizadores que atingiram ou excederam os critérios de pontuação para todas as simulações na tarefa.",
      "SEARCH_FOR_A_USER_LABEL": "Procurar um utilizador",
      "NO_USERS_FOUND_LABEL": "Nenhum utilizador encontrado",
      "TRAINER_TIME_SAVED_TOOLTIP": "A quantidade de tempo que os utilizadores passaram na Quantified a completar tentativas de certificação.",
      "AVG_SESSIONS_PER_ASSIGNMENT": "Média de sessões por tarefa",
      "ASSIGNMENTS_ENGAGED_WITH": "Tarefas com participação com",
      "AVERAGE_IMPROVEMENT": "Melhoria média",
      "STATUS": "Estado",
      "TOTAL_NUMBER_OF_SESSIONS": "Número total de sessões",
      "DATE_OF_LAST_PRACTICE": "Data do último treino",
      "CALL_NAME": "Nome da chamada",
      "SESSION_DATE": "Data da sessão",
      "DURATION_OF_SESSION": "Duração da sessão",
      "OVERALL_SCORE": "Pontuação global",
      "MESSAGING_SCORE": "Pontuação de adesão à mensagem",
      "METHODOLOGY_SCORE": "Pontuação metodológica",
      "SKILLS_SCORE": "Pontuação de competências",
      "SESSIONS": "Sessões",
      "TOTAL": "Total",
      "ALL_ASSIGNMENTS": "Todas as tarefas",
      "RECENT_ASSIGNMENTS": "Tarefas recentes",
      "AVERAGE_SESSIONS_ACTIVE_USER": "Média de sessões de utilizadores ativos",
      "HOURS_IN_SIMULATIONS": "Horas em simulações",
      "AVERAGE_SESSIONS_TO_PROFICIENCY": "Média de sessões até à proficiência",
      "PERCENT_PROFICIENT": "Percentagem de proficiência",
      "SYSTEM_RUNNING_NORMALLY": "O sistema está a funcionar normalmente",
      "PRACTICE_SIMULATIONS_LABEL": "Simulações",
      "NO_USERS_MATCHING_FILTERS_LABEL": "Nenhum resultado corresponde aos seus filtros. Tente limpar um ou mais filtros para alargar a pesquisa.",
      "USERS_PASSED": "Utilizadores que passaram na simulação",
      "AVERAGE_TIME": "Tempo médio para certificar",
      "USERS_OUT_OF_ATTEMPTS": "Utilizadores sem tentativas",
      "NO_CERTIFICATION_SIMULATION": "Não foram encontradas simulações de certificação",
      "SIMULATION": "Simulação",
      "No_SIMULATION": "Sem sessões",
      "PERCENT_CERTIFIED": "Percentagem de certificação",
      "PERCENT_CERTIFIED_FIRST_ATTEMPT": "Percentagem de certificação na 1.ª tentativa",
      "USERS": "Utilizadores",
      "ATTEMPTS_LABEL": "Tentativas",
      "NO_ATTEMPTS": "Sem tentativas",
      "DATE_OF_SESSION": "Data da sessão",
      "NO_ASSIGNMENTS_MATCH_FILTERS": "Nenhuma tarefa corresponde aos filtros selecionados",
      "NO_TEAMS_DATA": "Não existem equipas nesta conta",
      "SIMULATION_NAME": "Nome da simulação",
      "AVERAGE_DURATION_OF_SESSION": "Duração média da sessão",
      "AVERAGE_SESSIONS_PER_ACTIVE_USER": "Número médio de sessões por utilizador ativo",
      "AVERAGE_OVERALL_SCORE": "Pontuação média global",
      "AVERAGE_CERTIFICATION_SCORE": "Pontuação média de certificação",
      "CERTIFICATION_STATUS_LABEL": "Estado da certificação",
      "CERTIFICATION_STATUS_PREFIX_LABEL": "Estado da certificação:",
      "CERTIFIED_ON_FIRST_ATTEMPT_LABEL": "Certificado na primeira tentativa?",
      "CERTIFIED_ON_FIRST_TRY": "Certificado na primeira tentativa",
      "DATE_OF_CERTIFICATION": "Data da certificação",
      "DATE_OF_CERTIFICATION_LABEL": "Data da certificação",
      "DATE_RANGE": "Intervalo de datas",
      "DATE_RANGE_LABEL": "Intervalo de datas",
      "DURATION_OF_ATTEMPT": "Duração da tentativa",
      "ENGAGEMENT_STATUS_PREFIX_LABEL": "Estado do envolvimento:",
      "LEARNER": "Formando",
      "OF_THE_TIME": "do tempo",
      "SEARCH_DATES": "Procurar datas...",
      "SEARCH_SIMULATIONS": "Procurar simulações...",
      "SEARCH_USERS": "Procurar utilizadores...",
      "TOTAL_TIME_CERTIFYING": "Tempo total de certificação",
      "USER_NAME": "Nome do utilizador",
      "ASSIGNMENTS_CERTIFIED": "Tarefas certificadas",
      "HOURS_SPENT_PRACTICING": "Horas passadas a praticar",
      "LAST_LOGIN": "Último login",
      "SELECT_ASSIGNMENTS": "Selecionar tarefas",
      "TOTAL_ASSIGNMENTS": "Total de atribuições",
      "TOTAL_SESSIONS": "Total de sessões",
      "ASSIGNED_LABEL": "Não iniciada",
      "USERS_ASSIGNED_LABEL": "Total de utilizadores atribuídos",
      "SESSION_ID": "ID da sessão",
      "NO_SIMULATIONS_FOUND_LABEL": "Nenhuma simulação encontrada",
      "USER_NAME_LABEL": "Nome do utilizador",
      "MIN": "min.",
      "SEC": "seg.",
      "OF_LABEL": "de",
      "SECOND": "segundo",
      "SECONDS": "segundos",
      "MINUTE": "minuto",
      "MINUTES": "minutos",
      "ASSIGNED": "Atribuído",
      "ENGAGED_TOOLTIP": "A porcentagem de utilizadores que concluíram uma ou mais sessões de simulação nesta tarefa, mas ainda não atingiram proficiência em todas as simulações.",
      "SEARCH_ASSIGNMENTS": "Pesquisar tarefas...",
      "ASSIGNMENT_NAME_LABEL": "Nome da tarefa",
      "SIMULATION_NAME_LABEL": "Nome da simulação",
      "START_DATE": "Data de início",
      "END_DATE": "Data final",
      "NO_ASSIGNMENTS": "Nenhuma tarefa encontrada para este utilizador.",
      "TOTAL_PRACTICE_ASSIGNMENTS": "Total de tarefas práticas",
      "SESSION_SCORES_OVER_TIME": "Pontuações de sessão ao longo do tempo",
      "TIME": "tempo",
      "SCORE": "média",
      "NO_SESSIONS_AVAILABLE": "Nenhuma sessão disponível para representar graficamente.",
      "MESSAGING_SCORE_LABEL": "Pontuação de mensagens",
      "PERSONALIZED_PRACTICE_LABEL": "Prática personalizada",
      "ASSIGNMENT_ENAGEMENT": "Envolvimento por tarefa",
      "NO_PRODUCTS": "Nenhum produto de prática personalizado para as equipas selecionadas",
      "TOTAL_TIME_SPENT_PRACTICING": "Tempo total passado a praticar",
      "AVERAGE_SESSIONS_PER_USER": "Sessões médias por utilizador",
      "MOST_COMMON_CONVERSATION_TYPE_SELECTION": "Seleção do tipo de conversa mais comum",
      "LEAST_COMMON_CONVERSATION_TYPE_SELECTION": "Seleção do tipo de conversa menos comum",
      "CLEAR_TEAMS": "Limpar equipas",
      "METHODOLOGY_SCORE_DESCRIPTION": "Avalia em que medida os formandos seguem a estrutura recomendada para as chamadas. As pontuações refletem a média de todas as sessões desta simulação.",
      "METHODOLOGY": "Metodologia",
      "MESSAGING": "Mensagens",
      "MESSAGING_V2_DASHBOARD_DESCRIPTION": "Avalia se os formandos expressam as ideias principais durante a chamada. Os gráficos mostram a percentagem média de mensagens corretamente expressas por tema, em todas as sessões.",
      "NO_METRICS_MESSAGE": "São necessárias mais sessões para obter insights.",
      "SELECT_ALL": "Selecionar tudo",
      "DESELECT_ALL": "Desmarcar tudo",
      "SKILLS": "Competências",
      "SKILLS_SCORE_STATS_DESCRIPTION": "Avalia o desempenho dos formandos na demonstração das competências essenciais durante a chamada. As pontuações refletem uma avaliação da IA calculada com base na média de todas as sessões.",
      "EXPERT": "Perito",
      "PROFICIENT": "Proficiente",
      "DEVELOPING": "Em desenvolvimento",
      "FULLY_ARTICULATED": "Totalmente articulada",
      "PARTIALLY_ARTICULATED": "Parcialmente articulada",
      "NOT_MENTIONED": "Não mencionada",
      "MESSAGING_SCORE_STATS_DESCRIPTION": "Avalia se os formandos expressam as ideias principais durante a chamada. Os gráficos mostram a frequência com que cada mensagem foi articulada corretamente, em todas as sessões.",
      "CLEAR": "Limpar",
      "CLEAR_STATUS": "Limpar estado",
      "CLEAR_USERS": "Limpar utilizadores",
      "CLEAR_SIMULATIONS": "Limpar simulações",
      "CLEAR_ASSIGNMENTS": "Limpar tarefas",
      "MODAL_SUBHEADING": "Todos os {{ count }} objetivos — médias de pontuação em todas as sessões",
      "VIEW_ALL_OBJECTIVES": "Ver todos os {{ count }} objetivos →",
      "LEAST_MISSED_QUESTION": "PERGUNTA MENOS ERRADA",
      "MOST_MISSED_QUESTION": "PERGUNTA MAIS ERRADA",
      "HIGHEST_SCORING_METHODOLOGY_SECTION": "SECÇÃO DE METODOLOGIA DE PONTUAÇÃO MAIS ELEVADA",
      "LOWEST_SCORING_METHODOLOGY_SECTION": "SECÇÃO DE METODOLOGIA DE PONTUAÇÃO MAIS BAIXA",
      "LEAST_ARTICULATED_MESSAGE": "MENSAGEM MENOS ARTICULADA",
      "ENGAGEMENT": "ENVOLVIMENTO",
      "USER_ENGAGEMENT_MORE_SESSIONS": "mais sessões concluídas do que a média da equipa",
      "QUESTION_CORRECT_PERCENTAGE_DESC": "das vezes, acertaram",
      "QUESTION_CORRECT_PERCENTAGE_DESC_ASSIGNMENT": "das vezes, os utilizadores acertam",
      "METHODOLOGY_AVERAGE_POINTS_DESC": "pontuação média neste objetivo em todas as sessões",
      "MOST_ARTICULATED_MESSAGE": "MENSAGEM MAIS ARTICULADA",
      "LEAST_MISSED_ANSWER_POINT": "MENOR FALHA NO PONTO DE RESPOSTA",
      "MOST_MISSED_ANSWER_POINT": "MAIOR FALHA NO PONTO DE RESPOSTA",
      "MOST_ARTICULATED_MESSAGE_DESCRIPTION": "das vezes, articulam completamente esta mensagem",
      "LEAST_ARTICULATED_MESSAGE_DESCRIPTION": "das vezes, articulam esta mensagem",
      "ASSIGNMENT_STATUS": "Estado da tarefa",
      "STATUS_ACTIVE": "Ativa",
      "STATUS_ENDED": "Concluída",
      "STATUS_CLOSED": "Encerrada",
      "STATUS_ARCHIVED": "Arquivada",
      "USER_ENGAGEMENT_FEWER_SESSIONS": "menos sessões concluídas do que a média da equipa",
      "MOST_ARTICULATED_MESSAGE_DESCRIPTION_ASSIGNMENT": "das vezes, os utilizadores articulam esta mensagem",
      "LEAST_ARTICULATED_MESSAGE_DESCRIPTION_ASSIGNMENT": "das vezes, os utilizadores articulam esta mensagem",
      "OTHERS_SINGULAR": "e mais 1",
      "OTHERS_PLURAL": "e {{ count }} mais",
      "PAGINATION_PREVIOUS": "Anterior",
      "PAGINATION_NEXT": "Seguinte",
      "HOUR_LABEL": "hora",
      "SESSIONS_LABEL": "sessões"
    },
    "personalizedPractice": {
      "TITLE": "Prática personalizada",
      "DESCRIPTION": "Olá, {{userFirstName}}! As práticas personalizadas permitem-lhe definir os seus próprios cenários para que sejam o mais realistas possível.",
      "LOADING": "A carregar...",
      "VIEW_SESSIONS": "Ver sessões",
      "VIEW_SIMULATION": "Ver simulação",
      "TOTAL_SESSION": "sessão total",
      "TOTAL_SESSIONS": "Total de sessões",
      "BREADCRUMB": "Prática personalizada",
      "SCENARIO_DETAILS_TITLE": "Detalhes do cenário",
      "SCENARIO_DETAILS_DESCRIPTION": "Selecione variáveis a partir das opções abaixo para ajustar a simulação de acordo com as suas necessidades.",
      "AVATAR": "Avatar",
      "SELECT_PLACEHOLDER": "Selecionar",
      "CONVERSATION_TYPE": "Tipo de conversa",
      "SELECT_CONVERSATION_TYPE": "Selecionar tipo de conversa",
      "LAUNCH_SIMULATION": "Lançar simulação com seleções",
      "PREVIOUS_SESSIONS": "Sessões anteriores",
      "TOTAL": "Total",
      "FILTERS": "Filtros:",
      "DATE": "Data",
      "DIFFICULTY": "Dificuldade",
      "TEMPERAMENT": "Temperamento",
      "SESSION_DATE": "Data da sessão",
      "SESSION_SCORE": "Pontuação da sessão",
      "DURATION": "Duração",
      "OVERALL_SCORE": "Pontuação global",
      "MESSAGING": "Mensagens",
      "METHODOLOGY": "Metodologia",
      "SKILLS": "Competências",
      "RESULTS": "Resultados",
      "VIEW_FEEDBACK": "Ver feedback",
      "OVERALL_SCORE_LABEL": "Pontuação global",
      "SCORE": "média",
      "NO_PRODUCTS_TITLE": "Não existem produtos disponíveis",
      "NO_PRODUCTS_DESCRIPTION": "Ainda não tem nenhum produto de prática personalizado.",
      "NO_SESSIONS_FOUND": "Não foram encontradas sessões com os filtros selecionados",
      "TIME": "tempo",
      "ALL": "Todas",
      "LEARNER": "Formando",
      "MOOD": "Humor",
      "CLEAR_FILTERS": "Limpar filtros",
      "PAGINATION_PREVIOUS": "Anterior",
      "PAGINATION_NEXT": "Seguinte",
      "DURATION_MINUTES_SECONDS": "{{minutes}}m {{seconds}}s",
      "DURATION_SECONDS": "{{seconds}}s"
    },
    "login": {
      "TITLE": "Damos-lhe as boas-vindas novamente",
      "SUB_TITLE": "Como gostaria de iniciar sessão?  ",
      "LOGIN_WITH_SSO": "Iniciar sessão com o SSO da empresa",
      "LOGIN_WITH_PASSWORD": "Iniciar sessão com palavra-passe",
      "PROVIDE_EMAIL": "Forneça o seu endereço de e-mail",
      "HELP_TEXT": "Precisa de ajuda? Contacto",
      "EMAIL_ERROR": "Não foi possível iniciar sessão. Contacte o administrador da sua empresa ou o departamento de TI.",
      "EMAIL": "E-mail",
      "LOGIN": "Iniciar sessão",
      "ALERT": "Alerta",
      "EMAIL_PLACEHOLDER": "olivia@untitledui.com",
      "LOGIN_CONSENT_MESSAGE": "Ao iniciar sessão na sua conta, o utilizador concorda com os {{termsLink}} e a {{privacyLink}}.",
      "TERMS_OF_SERVICE": "Termos do serviço",
      "PRIVACY_POLICY": "Política de privacidade",
      "WRONG_REGION_MESSAGE": "Não conseguimos iniciar a sua sessão. Contacte o administrador da sua empresa.",
      "WRONG_REGION_LINK": "Também pode tentar iniciar sessão no site {{regionName}}."
    },
    "learningPathway": {
      "BEGIN": "Começar",
      "DUE_DATE": "Data limite",
      "FOOTER_SUBTITLE_READY": "Pergunte-me o que quiser! Estou a postos para ajudar.",
      "LEAVE_STEP": "Deixar passo",
      "NEXT_STEP": "Próximo passo",
      "NOTIFICATIONS_ARIA": "Notificações",
      "PDF_NEXT_PAGE": "Próxima página",
      "PDF_NO_SOURCE": "Nenhuma fonte em PDF fornecida.",
      "PDF_PREVIOUS_PAGE": "Página anterior",
      "POST_CALL_SUBTITLE": "Deixe-nos feedback enquanto processamos os seus resultados",
      "POST_CALL_TITLE": "Chegou ao fim deste questionário.",
      "SETTINGS": "Definições",
      "TOAST_CONTENT": "Clique abaixo para visualizar ou volte ao ecrã de detalhes do percurso para o próximo passo.",
      "TOAST_TITLE": "Os resultados da sua simulação {{stepName}} já foram processados",
      "ASSIGNMENTS": "Tarefas",
      "USER_FALLBACK": "Utilizador",
      "VIEW_RESULTS": "Ver resultados",
      "QUIZ_TITLE": "Quiz",
      "SUBMIT_ANSWER": "Submeter resposta",
      "CONTINUE": "Continuar",
      "REVIEW_MATERIAL": "Rever material",
      "ASK_QUESTIONS_ABOUT_PATHWAY": "Fazer perguntas sobre o percurso",
      "FOOTER_SUBTITLE_MUTED": "Atualmente está com o som desativado. O formador não o consegue ouvir.",
      "FOOTER_SUBTITLE_LISTENING": "A ouvir a sua pergunta...",
      "FOOTER_SUBTITLE_THINKING": "A pensar numa resposta...",
      "PDF_LOADING": "A carregar PDF",
      "PDF_SCROLL_HINT": "Desça para continuar a ler",
      "QUIZ_OVERALL_SCORE_TOOLTIP": "A pontuação total é a média ponderada das suas respostas para esta tentativa.",
      "QUIZ_COLUMN_DATE": "Data",
      "QUIZ_COLUMN_OVERALL_SCORE": "Pontuação global",
      "QUIZ_COLUMN_ANSWER_POINTS": "Pontos de resposta",
      "QUIZ_COLUMN_RESULTS": "Resultados",
      "COMPLETE_STEP": "Completo",
      "ERROR_TITLE": "Algo correu mal",
      "ERROR_MESSAGE": "Saia e volte a entrar no percurso. Se o problema persistir, entre em contacto com",
      "ERROR_HELP_EMAIL": "help@quantified.ai",
      "PATHWAY_COMPLETED_TITLE": "Concluiu este percurso",
      "PATHWAY_COMPLETED_BODY": "Pode rever os seus resultados a qualquer momento ou revisitar qualquer etapa para continuar a praticar.",
      "PATHWAY_COMPLETED_RETURN": "Regressar às tarefas",
      "PATHWAY_OUT_OF_ATTEMPTS_TITLE": "Já não tem tentativas disponíveis para uma etapa no percurso",
      "PATHWAY_OUT_OF_ATTEMPTS_BODY": "Contacte o seu gestor para discutir os próximos passos.",
      "COMPLETED": "Concluído",
      "EXITING_QUIZ_EARLY": "Sair deste questionário agora contará como uma tentativa",
      "TRY_AGAIN": "Tentar de novo",
      "RETURN_TO_PATHWAY": "Regressar ao início do percurso",
      "REVIEW_BEFORE_QUIZ_TOOLTIP": "Reveja esta etapa antes de voltar a tentar o questionário",
      "FOOTER_SUBTITLE_QUIZ_RESULT_DONE": "Clique no botão à direita →",
      "VIEW_CALL_DETAILS": "Ver detalhes da chamada",
      "FOOTER_SUBTITLE_READY_LEARN_WITH_X": "O formador está à disposição caso tenha alguma dúvida",
      "COLUMN_DATE": "Data",
      "COLUMN_OVERALL_SCORE": "Pontuação global",
      "COLUMN_RESULTS": "Resultados",
      "COLUMN_ANSWER_POINTS": "Pontos de resposta",
      "COLUMN_MESSAGING_SCORE": "Pontuação de mensagens",
      "COLUMN_METHODOLOGY_SCORE": "Pontuação metodológica",
      "COLUMN_SKILLS_SCORE": "Pontuação de competências",
      "PRACTICE_AGAIN": "Praticar novamente",
      "DEBRIEF_LATEST_SESSION": "Relatório da última sessão",
      "EXIT_MODAL_TITLE": "Tem a certeza de que quer terminar esta simulação?",
      "EXIT_MODAL_EXIT": "Sair",
      "EXIT_MODAL_RESUME": "Retomar",
      "EXIT_MODAL_DESC_LIMITED_ATTEMPTS": "Se sair da simulação agora, esta não será avaliada, mas continuará a contar como uma tentativa.",
      "EXIT_MODAL_DESC_UNLIMITED_ATTEMPTS": "Se sair da simulação agora, esta não será avaliada.",
      "EXIT_MODAL_DESC_SCORED": "Se sair da simulação agora, avaliaremos a sua chamada tal como está.",
      "RESULTS_PROCESSING": "Processamento dos resultados",
      "RESULTS_FAILED": "Não foi possível carregar os resultados. Entre em contacto com help@quantified.ai",
      "DEBRIEF_TITLE": "Relatório",
      "DEBRIEF_DESCRIPTION": "Discuta os resultados da sua última tentativa de certificação",
      "DEBRIEF_DESCRIPTION_PRACTICE": "Discuta os resultados da sua última sessão de prática",
      "VIEW_ALL_SESSIONS": "Ver todas as sessões",
      "COLLAPSE_SESSIONS": "Fechar sessões",
      "VIEW_ALL_ATTEMPTS": "Ver todas as tentativas",
      "COLLAPSE_ATTEMPTS": "Tentativas de fecho",
      "REATTEMPT_CERTIFICATION": "Nova tentativa de certificação",
      "DEBRIEF_EXIT_MODAL_TITLE": "Tem a certeza de que quer terminar este relatório?",
      "DEBRIEF_EXIT_MODAL_DESC": "Se sair do relatório agora, este não será marcado como concluído.",
      "EXIT_PATHWAY": "Percurso de saída",
      "HELP": "Ajuda",
      "LEARN_STEP_HELP_CLOSE": "Fechar",
      "LEARN_STEP_HELP_TROUBLE": "Se continuar com dificuldades, contacte",
      "LEARN_STEP_HELP_EMAIL": "help@quantified.ai",
      "LEARN_STEP_HELP_VIDEO_P1": "Assista ao material e coloque as suas dúvidas ao formador.",
      "LEARN_STEP_HELP_VIDEO_P2": "Clique no botão de reprodução para iniciar o vídeo. Pode voltar atrás para rever o conteúdo.",
      "LEARN_STEP_HELP_VIDEO_P3": "Ative o som no canto inferior direito para fazer uma pergunta. Isto irá colocar o vídeo em pausa. Quando reproduzir o vídeo, iremos desativar o som do seu microfone.",
      "LEARN_STEP_HELP_VIDEO_P4": "Quando tiver visto o vídeo na íntegra, avance para o passo seguinte.",
      "LEARN_STEP_HELP_PDF_P1": "Leia o material e coloque as suas dúvidas ao formador.",
      "LEARN_STEP_HELP_PDF_P2": "Navegue pelo conteúdo deslocando a página ou utilizando os botões de seta de cada lado para passar de uma página para outra.",
      "LEARN_STEP_HELP_PDF_P3": "Pode ativar ou desativar o som do seu microfone no canto inferior direito.",
      "LEARN_STEP_HELP_PDF_P4": "Quando tiver lido tudo, passe à etapa seguinte.",
      "PDF_FULLSCREEN_ENTER": "Entrar no modo ecrã inteiro",
      "PDF_FULLSCREEN_EXIT": "Sair do modo ecrã inteiro",
      "PDF_ZOOM_IN": "Ampliar",
      "PDF_ZOOM_OUT": "Reduzir",
      "ASSESSMENT_EXIT_MODAL_TITLE": "Tem a certeza de que deseja continuar?",
      "ASSESSMENT_EXIT_MODAL_DESC": "Avançar antes de esta conversa estar concluída, resultará numa experiência de aprendizagem mais demorada e menos personalizada.",
      "ASSESSMENT_EXIT_MODAL_RESUME": "Retomar avaliação",
      "ASSESSMENT_EXIT_MODAL_PROCEED": "Continuar",
      "ASSESSMENT_PERSONALIZATION_ERROR_TITLE": "Não foi possível personalizar o seu percurso",
      "ASSESSMENT_PERSONALIZATION_ERROR_DESC_START": "Atribuímos-lhe o percurso completo. Entre em contacto com ",
      "ASSESSMENT_PERSONALIZATION_ERROR_DESC_END": " se quiser tentar novamente a personalização",
      "OPTIONAL": "Opcional",
      "DISMISS": "Ignorar",
      "DOWNLOAD": "Transferir"
    },
    "leaderboard": {
      "LEADERBOARD": "Tabela de classificação",
      "TOP10PERCENT": "Top 10%",
      "PRACTICE_ASSIGNMENT": "Tarefas práticas",
      "SIMULATION": "Simulação",
      "SELECT_ASSIGNMENT": "Selecionar tarefa",
      "SELECT_SIMULATION": "Selecionar simulação",
      "SELECT_ASSIGNMENT_AND_SIMULATION": "Selecione uma tarefa e uma simulação para ver os líderes",
      "NO_DATA": "Ainda não há atividade. Quando a equipa começar a envolver-se, verá as classificações aparecerem aqui.",
      "NO_ASSIGNMENTS_AVAILABLE": "Não há tarefas disponíveis",
      "NO_SIMULATIONS_AVAILABLE": "Não há simulações disponíveis",
      "NAME": "Nome",
      "HIGH_SCORE": "Pontuação elevada",
      "AVERAGE_SCORE": "Pontuação média",
      "TOTAL_SESSIONS": "Total de sessões",
      "LAST_SESSION": "Última sessão",
      "TOP5": "Top 5",
      "OF": "de",
      "ENGAGED_USERS": "utilizadores com participação",
      "ENGAGED_USER": "utilizador com participação",
      "HIDE_SESSIONS_WITH_LOW_SCORE": "Ocultar sessões com pontuações de competências baixas",
      "SESSIONS_WITH_LOW_SCORE_TOOLTIP": "As sessões com uma pontuação de «em desenvolvimento» na secção de competências não contribuem para as colunas de pontuação alta ou média.",
      "NO_USERS_ENGAGED": "Nenhum utilizador envolvido",
      "PAGINATION_PREVIOUS": "Anterior",
      "PAGINATION_NEXT": "Seguinte"
    },
    "hotjarSurveys": {
      "FEEDBACK_MESSAGE": "Partilhe a sua opinião para nos ajudar a melhorar.",
      "THANK_YOU_MESSAGE": "Obrigado. Continuaremos a trabalhar para melhorar a sua experiência"
    },
    "general": {
      "NEED_HELP_QUESTION": "Precisa de ajuda?",
      "CONTACT": "Contacto",
      "HELP_EMAIL": "help@quantified.ai",
      "PARENT_ACCOUNT": "Conta principal",
      "ACCOUNT": "Conta",
      "CHECKMARK": "Marca de verificação",
      "ICON": "Ícone",
      "ALERT": "alerta",
      "HEADS_UP": "Atenção!",
      "USE_HEADPHONES_FOR_OPTIMAL_AUDIO": "Para otimizar o áudio no iPad, utilize auscultadores.",
      "SETTINGS": "DEFINIÇÕES",
      "RP": "RP",
      "EMAIL_LABEL": "E-mail",
      "RAVEN_EMAIL": "Raven@InspireHR.com",
      "TEAM_MANAGER_FOR": "Gestor de equipa para",
      "MIAMI_SALE": "Vendas de Miami",
      "CHARLOTTE_SALES": "Vendas de Charlotte",
      "ATLANTA_SALES": "Vendas de Atlanta",
      "TEAM": "Equipa",
      "ASSIGNMENTS": "Tarefas",
      "MY_TEAMS": "As minhas equipas",
      "REPORTING": "Relatórios",
      "DASHBOARD": "Painel de controlo",
      "LEADERBOARD": "Tabela de classificação",
      "PERSONALIZED_PRACTICE": "Prática personalizada",
      "HELP_SEARCH_OUR": "Pesquise na nossa",
      "HELP_OR_REACH_OUT_TO": "ou entre em contato com",
      "HELP_WITH_QUESTIONS": "com perguntas",
      "KNOWLEDGE_BASE": "base de conhecimento",
      "NO_ROLE_WEB_MESSAGE": "Este utilizador não tem acesso ao sistema. Contacte um administrador do sistema.",
      "NO_ROLE_IOS_TITLE": "A nossa aplicação centra-se na experiência do formando",
      "NO_ROLE_IOS_BODY_START": "Aceda à nossa",
      "NO_ROLE_IOS_WEB_APP": "aplicação web",
      "NO_ROLE_IOS_BODY_END": "no navegador do seu telemóvel para utilizar funcionalidades adicionais.",
      "HELP_SECTION": "AJUDA",
      "ABOUT_SECTION": "ACERCA",
      "CONTACT_SUPPORT": "Contacte a assistência",
      "OPEN_WEB_APP": "Abra a aplicação web",
      "SEARCH_KNOWLEDGE_BASE": "Pesquisar na base de conhecimento",
      "PRIVACY_POLICY": "Política de privacidade",
      "TERMS_OF_SERVICE": "Termos do serviço",
      "VERSION": "Versão",
      "LOG_OUT": "Terminar sessão"
    },
    "dashboard": {
      "ALL": "Todas",
      "IN_COMPLETE": "Incompletas",
      "COMPLETED": "Concluído",
      "NO_ASSIGNMENT_TITLE": "Não tem quaisquer tarefas.",
      "NO_ASSIGNMENT_DETAILS": "Receberá uma notificação quando tiver tarefas para completar.",
      "IN_COMPLETE_ASSIGNMENT_TITLE": "Não tem tarefas incompletas.",
      "IN_COMPLETE_ASSIGNMENT_DETAILS": "Receberá uma notificação quando houver uma nova tarefa com prazo.",
      "COMPLETED_ASSIGNMENT_TITLE": "Não tem tarefas concluídas.",
      "COMPLETED_ASSIGNMENT_DETAILS": "Volte a consultar quando tiver concluído uma tarefa.",
      "VIEW_ASSIGNMENT": "Ver tarefa",
      "ASSIGNMENT_LABEL": "Tarefas",
      "MODULE_ASSIGNMENT_ALT": "Ícone da tarefa do módulo",
      "VIEW_ASSIGNMENT_FOR": "Ver tarefa para",
      "DAY": "Dia",
      "UNTILL_DUE": "Até ao vencimento",
      "PAST_DUE": "Vencido",
      "AVAILABLE_IN": "Disponível em",
      "DUE_TODAY": "Vencimento hoje",
      "PRACTICE": "Prática",
      "CERTIFICATION": "Certificação",
      "UPCOMING": "Em breve",
      "TEST_ASSIGNMENT": "Atribuição de teste",
      "CLOSED": "Encerrada",
      "NO_ASSIGNMENT_FILTERED_TITLE": "Não foram encontradas tarefas.",
      "NO_ASSIGNMENT_FILTERED_DETAILS": "Tente ajustar os filtros para ver as tarefas disponíveis ou volte mais tarde quando novas tarefas forem adicionadas.",
      "VIEW_PATHWAY": "Ver percurso",
      "TOTAL": "Total",
      "STATUS_LABEL": "Estado",
      "STATUS_SELECTION_LABEL": "Estado:",
      "ASSIGNMENT_TYPE": "Tipo de trabalho",
      "ASSIGNMENT_TYPE_SELECTION_LABEL": "Tipo de trabalho:",
      "NOT_STARTED": "Não iniciada",
      "CERTIFIED": "Certificado",
      "NOT_CERTIFIED": "Não Certificado",
      "IN_PROGRESS": "Em curso",
      "PATHWAY": "Percurso de aprendizagem",
      "SELECT_ALL": "Selecionar tudo",
      "DESELECT_ALL": "Desmarcar tudo",
      "GET_STARTED": "Começar",
      "ASSIGNMENT_STATUS_LABEL": "Estado da tarefa",
      "ASSIGNMENT_STATUS_SELECTION_LABEL": "Estado da tarefa:",
      "CLEAR_STATUS": "Limpar estado",
      "ENDED": "Concluído",
      "START_PATHWAY": "Iniciar percurso",
      "DAYS": "Dias",
      "OTHERS_SINGULAR": "e mais 1",
      "OTHERS_PLURAL": "e {{ count }} mais"
    },
    "cognito": {
      "INVITATION_SUBJECT": "Damos-lhe as boas-vindas ao Quantified!",
      "INVITATION_MESSAGE": "Estamos muito felizes por contar consigo! Para começar, siga os passos abaixo para iniciar sessão na sua conta pela primeira vez.",
      "ACCOUNT_DETAILS": "Os dados da sua conta:",
      "USERNAME": "Nome de utilizador",
      "PASSWORD": "Palavra-passe temporária",
      "STEPS_LABEL": "Próximos passos para iniciar sessão",
      "STEP_1": "1. Clique no botão «Iniciar sessão» abaixo para aceder à página de início de sessão.",
      "STEP_2": "2. Introduzir o seu nome de utilizador e a palavra-passe temporária fornecidos acima.",
      "STEP_3": "3. Uma vez iniciada a sessão, ser-lhe-á pedido que defina uma nova palavra-passe.",
      "LOGIN_BUTTON": "Iniciar sessão",
      "ABOUT_US": "O Simulador da Quantified é um ambiente virtual concebido para o ajudar a desenvolver rapidamente competências essenciais, permitindo-lhe estabelecer ligações e comunicar mais eficazmente com os clientes.",
      "EXPIRY_TIME": "Esta palavra-passe temporária expira dentro de 24 horas. Se tiver algum problema ao iniciar sessão, contacte a nossa equipa de assistência através de",
      "TEAM": "A equipa Quantified",
      "INVITATION_SMS_USERNAME": "O seu nome de utilizador é",
      "INVITATION_SMS_PASSWORD": "e a palavra-passe temporária é",
      "AUTHENTICATION_CODE": "O seu código de autenticação é",
      "PASSWORD_RESET_CODE": "O seu código de reposição da palavra-passe da Quantified",
      "RESET_PASSWORD_EMAIL": "Redefinir a palavra-passe do e-mail",
      "HELLO": "Olá,",
      "USE_VERIFICATION_CODE": "Solicitou uma reposição da palavra-passe. Utilize o código de verificação abaixo para concluir o processo.",
      "VERIFICATION_CODE": "Código de verificação",
      "NEXT_STEP": "Próximas etapas",
      "RESET_PASSWORD_PAGE": "Regressar à página de reposição da palavra-passe no seu browser.",
      "ENTER_VERIFICATION_CODE": "Introduzir o código de verificação quando lhe for pedido.",
      "CREATE_PASSWORD": "Quando o código for verificado, siga as instruções para criar uma nova palavra-passe.",
      "DISREGARD_NOTE": "Se não solicitou uma redefinição da palavra-passe, ignore esta mensagem de e-mail.",
      "CONTACT_SUPPORT": "Para obter mais assistência, contacte a nossa equipa de assistência através de",
      "HELP_EMAIL": "help@quantified.ai",
      "THANK_YOU": "Agradecimentos,",
      "QUANTIFIED_TEAM": "A equipa Quantified",
      "ADDRESS": "4200 Marathon Blvd, Suite 210, Austin, Texas 78756, Estados Unidos",
      "RETURN_TO_PATHWAY": "Regressar ao início do percurso"
    },
    "call": {
      "LOADING": "A carregar",
      "SIMULATION_PAUSED": "A simulação foi colocada em pausa.",
      "CLICK_RESUME": "Clique no botão «Retomar» abaixo para continuar.",
      "NO_INTERNET": "Sem ligação à Internet",
      "TRY_AGAIN": "Verifique a sua ligação e tente novamente.",
      "MIC_MUTED": "O microfone está sem som",
      "MIC_MUTED_DESCRIPTION": "Ups, parece que o seu microfone está sem som. Desative o som para responder e continuar.",
      "NO_RESPONSE": "Nenhuma resposta detetada",
      "MIC_NOT_CONNECTED": "Ups, parece que o seu microfone não está ligado. Volte a selecionar o seu dispositivo para responder e continuar.",
      "AUDIO_ISSUE": "Ups, algo correu mal. Verifique as definições do seu dispositivo e certifique-se de que se encontra num local calmo e sem ruídos de fundo.",
      "LOADING_ALT": "A carregar...",
      "REPEAT_RESPONSE": "Será automaticamente reencaminhado para a sua simulação para repetir a sua resposta e tentar novamente.",
      "NEEDS_MORE_TIME_QUESTION": "precisa de mais tempo para pensar, quer esperar?",
      "NEEDS_MORE_TIME": "precisa de mais tempo para pensar.",
      "WAIT_OR_END_CALL": "Informá-lo-emos quando estiverem prontos ou pode terminar a chamada e",
      "RETURN_TO_ASSIGNMENTS": "regressar à tarefa",
      "READY": "Pronto",
      "IS_READY": "está pronto para continuar a vossa conversa.",
      "TRY_AGAIN_LABEL": "Tentar de novo",
      "CHECK_SETTINGS": "Verificar definições",
      "PAUSED_SIMULATION": "A simulação foi interrompida.",
      "PAUSED_SIMULATION_DESCRIPTION": "A gravação de vídeo e áudio é interrompida até que a simulação seja retomada.",
      "RESUME": "Retomar",
      "SETTINGS": "Definições",
      "CAPTURING_RESPONSE": "A capturar as suas respostas",
      "TOUR_MESSAGE": "Quando terminar de falar, não se esqueça de clicar no botão Continuar para garantir que as suas respostas são registadas e classificadas.",
      "NEXT": "Seguinte",
      "START_CALL": "Início",
      "END_CALL_TITLE": "Tem a certeza de que quer terminar esta simulação?",
      "END_CALL_DESCRIPTION": "Se terminar a simulação agora, não receberá uma pontuação ou feedback sobre a sua conversa.",
      "END_CALL": "Fim",
      "BROWSER_ACCESS_DENIED": "O seu browser não tem acesso a este dispositivo.",
      "COPY_SESSION_ID_BUTTON": "Copiar ID da sessão",
      "TIPS_GUIDANCE_MESSAGE": "Os temas de discussão e as dicas aparecerão aqui.",
      "CONTINUE": "Continuar",
      "SESSION_ID_LABEL": "ID da sessão:",
      "SESSION_ID_COPIED": "ID da sessão copiado!",
      "HINTS_AND_SUGGESTIONS_TITLE": "Dicas e sugestões",
      "HINT_LABEL": "Dica",
      "CAPTIONS_LABEL": "Legendas",
      "PAUSE_LABEL": "Pausa",
      "VIDEO_LABEL": "Vídeo",
      "PARTY_EMOJI": "emoji de festa",
      "CALL_ENDED_MESSAGE": "Chegou ao fim desta simulação.",
      "CALL_ENDED_INACTIVITY": "Esta simulação terminou devido a inatividade",
      "CALL_ENDED_GENERIC": "Esta simulação terminou",
      "FEEDBACK_PROMPT": "Deixe-nos feedback enquanto processamos os seus resultados.",
      "INTERACTION_THRESHOLD_NOT_MET": "Não atingiu o limiar mínimo de interações para receber uma pontuação, tente novamente.",
      "REALISTIC_CONVERSATION_QUESTION": "Esta conversa foi realista e natural?",
      "KNOWLEDGEABLE_PREPARED_QUESTION": "Esta simulação ajudou a aumentar a sua preparação e conhecimento?",
      "FEEDBACK_THANK_YOU": "Agradecemos o seu feedback!",
      "FEEDBACK_IMPROVEMENT_NOTE": "Agradecemos o seu feedback! Estamos a empenhar-nos para aprimorar a experiência.",
      "AUDIO": "Áudio",
      "VISUAL_AID_LOAD_ERROR": "Não foi possível carregar o auxílio visual",
      "BEGIN_CALL": "Início",
      "LEAVE_CALL_BRIEFING": "Terminar o resumo",
      "RESTORE_CALL": "Restaurar a sua simulação",
      "FEW_SECONDS": "Isto pode demorar alguns segundos.",
      "CHECK_ALT": "Verificar",
      "COPY_ALT": "Copiar",
      "HINTS_ALT": "Dicas",
      "CLOSE_CAPTIONS": "Fechar legendas",
      "MICROPHONE_MUTED": "Microfone sem som",
      "RETURN_TO_CALL": "Regressar à simulação",
      "YES": "Sim",
      "NO": "Não",
      "VIEW_RESULTS": "Ver resultados",
      "RETURN_TO_ASSIGNMENT": "Regressar à tarefa",
      "HAVING_ISSUES": "Estamos com problemas de ligação, verifique a sua ligação à Internet e clique em OK.",
      "OK": "OK",
      "RESULTS_NOT_GENERATED": "Lamentamos, mas não é possível gerar resultados neste momento. Tente novamente.",
      "INACTIVITY_ALERT_MESSAGE": "Esta chamada está a ser terminada devido a inatividade. Fale com o avatar para continuar ou selecione «Terminar chamada» para terminar a chamada.",
      "INACTIVITY_DEFAULT_ALERT_TITLE": "Esta chamada terminará em {{secondsUntilHangup}} segundos",
      "INACTIVITY_SHORT_ALERT_TITLE": "Esta chamada terminará dentro de alguns segundos",
      "TELL_YOUR_GENDER_HEADING": "Indique-nos o seu género:",
      "BY_KNOWING_YOUR_GENDER_DESCRIPTION": "Ao conhecer o seu género, o avatar consegue utilizar a gramática correta, tornando a conversa mais natural e realista.",
      "GENDER_SELECTION": "Seleção do género:",
      "SELECT_OPTION": "Selecionar uma opção",
      "CONFIRM": "Confirmar",
      "MALE": "Masculino",
      "FEMALE": "Feminino",
      "NON_BINARY": "Não binário/Outro",
      "PREFER_NOT_TO_ANSWER": "Prefiro não responder",
      "NON_BINARY_MESSAGE": "Compreendemos e respeitamos a sua identidade de género não binária. Devido às atuais limitações tecnológicas, utilizamos por defeito os pronomes masculinos. Saiba que estamos a trabalhar em melhorias para melhor acomodar todas as identidades de género no futuro. Agradecemos a sua compreensão e paciência.",
      "PREFER_NOT_TO_ANSWER_MESSAGE": "Respeitamos a sua opção de não indicar um género. Nesses casos, a nossa tecnologia utiliza por defeito os pronomes masculinos devido às limitações atuais.",
      "DISPLAY_VISUAL_AID": "Exibir auxílio visual",
      "FULL_SCREEN": "Ecrã inteiro",
      "COLLAPSE": "Fechar",
      "COMPLETED_CONVERSATION_MESSAGE": "Obrigado por completar esta conversa",
      "CONVERSATION_COMPLETION_FEEDBACK": "Deixe-nos feedback enquanto processamos a sua conversa.",
      "ERROR_MESSAGE": "Ocorreu um erro. Entre em contato com",
      "SAVED_CONVERSATION_MESSAGE": "A sua conversa foi guardada.",
      "RETURN_TO_MY_ASSIGNMENTS": "Voltar às minhas tarefas",
      "RETURN_TO_PERSONALIZED_PRACTICE": "Voltar à prática personalizada",
      "PERSONALIZED_CALL_NOTE": "Acabou de completar uma conversa de prática personalizada.",
      "LEAVE_STEP_TITLE": "Tem a certeza de que deseja sair desta etapa?",
      "EXIT": "Sair",
      "CERT_ACK_TITLE": "Confirmação do Vídeo de Certificação",
      "CERT_ACK_ACCEPT_AND_BEGIN": "Aceitar e começar",
      "CERT_ACK_RESUME_CALL": "Retomar chamada",
      "CERT_ACK_PROCESSING": "A processar...",
      "CERT_ACK_CAMERA_WARNING": "Ative a sua câmara para prosseguir com a certificação.",
      "CERT_ACK_CAMERA_OFF_DURING_CALL": "A sua câmara estava desligada. Reative a sua câmara para retomar a certificação.",
      "CERT_ACK_TEXT_1": "Para garantir a integridade e a equidade desta certificação, a sua câmara deve permanecer ligada durante toda a sessão e a sessão será monitorizada. Este requisito é para confirmar a conformidade com todos os padrões de certificação.",
      "CERT_ACK_TEXT_2": "Ao continuar, reconhece e concorda com estes requisitos.",
      "CERT_ACK_END_CALL": "Terminar chamada",
      "LAUNCH_SIMULATION": "Iniciar simulação",
      "DEBRIEF_LATEST_SESSION": "Relatório da última sessão",
      "RECONNECTING_AUDIO": "A restabelecer a ligação de áudio...",
      "END": "Fim",
      "START_DEBRIEF": "Relatório da última sessão",
      "MOVE_TO_NEXT": "Passar para o passo seguinte",
      "RETRY_ROLEPLAY": "Repetir a dramatização",
      "EXIT_PATHWAY": "Percurso de saída",
      "PROCESSING": "A processar...",
      "FEEDBACK_PROMPT_REQUIRED": "Deixe o seu comentário antes de ver os resultados.",
      "MUTE": "Silenciar",
      "UNMUTE": "Ativar o som",
      "SCREENSHARE_LABEL": "Partilhar ecrã",
      "SCREENSHARE_UNSUPPORTED_TITLE": "A {{callName}} utiliza a partilha de ecrã",
      "SCREENSHARE_UNSUPPORTED_MESSAGE_APP": "Para prosseguir com a chamada, utilize a nossa aplicação em vez do seu navegador.",
      "SCREENSHARE_UNSUPPORTED_MESSAGE_DESKTOP": "Para prosseguir com a chamada, aceda-a num computador de secretária.",
      "SCREENSHARE_UNSUPPORTED_CLOSE_BUTTON": "Fechar",
      "SCREENSHARE_UNSUPPORTED_GO_TO_APP_BUTTON": "Ir para a aplicação",
      "SCREENSHARE_UNSUPPORTED_GO_TO_APP_UNAVAILABLE": "A aplicação móvel ainda não está disponível. Volte a verificar em breve.",
      "SCREENSHARE_STOP_LABEL": "Parar de partilhar o ecrã",
      "SCREENSHARE_PIP_REOPEN_LABEL": "Reabrir a pré-visualização do vídeo",
      "SCREENSHARE_ACTIVE_LABEL": "Atualmente está a partilhar o ecrã",
      "SCREENSHARE_OS_PERMISSION_HINT": "Não foi possível iniciar a partilha de ecrã. Ative a gravação de ecrã para o seu navegador em Definições do sistema > Privacidade e segurança e, em seguida, tente novamente.",
      "SCREENSHARE_SAFARI_BLOCKED_HINT": "O Safari bloqueou a partilha de ecrã para esta sessão. Saia da sua conta e volte a iniciar sessão; depois, tente novamente."
    },
    "assignment": {
      "STATUS": "ESTADO",
      "SCORE": "PONTUAÇÃO",
      "MUST_ACHIEVE": "Deve atingir um",
      "OR_HIGHER": "ou superior",
      "TEST": "Teste",
      "OUT_OF_5": "de 5",
      "LATEST_ATTEMPT": "TENTATIVA MAIS RECENTE",
      "TOTAL_ATTEMPTS": "total de tentativas",
      "UNLIMITED": "Ilimitadas",
      "REMAINING": "Restantes",
      "VIEW_CALL_DETAILS": "Ver detalhes",
      "MAX_ATTEMPTS_REACHED": "Atingiu o número máximo de tentativas",
      "DUE_DATE": "Data limite",
      "DAYS": "Dias",
      "DAY": "Dia",
      "UNTILL_DUE": "Até ao vencimento",
      "PAST_DUE": "Vencido",
      "ONGOING": "Em curso",
      "SCORE_REQUIREMENT": "Exigência de pontuação",
      "SCORE_REQUIREMENT_DETAIL": "O formando deve obter uma pontuação de",
      "TO_COMPLETE_EACH_CALL": "para completar cada simulação necessária.",
      "CALLS_IN_ASSIGNMENT": "Simulações na tarefa",
      "INCOMPLETE_CALL": "Incompletas",
      "PREVIOUS_RESULTS": "Resultados anteriores",
      "DATE": "Data",
      "RESULTS": "Resultados",
      "VIEW_PREVIOUS_RESULTS": "Ver resultados anteriores",
      "VIEW_FEEDBACK": "Ver feedback",
      "LAUNCH_CALL": "Arranque",
      "CLOSE_BUTTON": "Botão de fechar",
      "CHECKMARK": "marca de verificação",
      "CALL": "Chamada",
      "QUESTION": "Questão",
      "COMPLETED": "Concluído",
      "IN_PROGRESS": "Em curso",
      "NOT_STARTED": "Não iniciada",
      "CERTIFIED": "Certificado",
      "GUIDED": "Guiada",
      "CONVERSATIONAL": "Conversação",
      "GUIDED_SIMULATION": "Verificação de conhecimentos",
      "CONVERSATIONAL_SIMULATION": "Dramatização",
      "NO_ATTEMPTS_LEFT": "Não restam tentativas",
      "NO_ATTEMPTS": "Sem tentativas",
      "OVERVIEW": "Síntese",
      "ABOUT_THE_AVATAR": "Sobre o avatar",
      "SCORING_CRITERIA": "Critérios de pontuação",
      "SIMULATION_OVERVIEW": "Visão geral da simulação",
      "ABOUT_THE_PERSONA": "Sobre a Persona",
      "OUTOF_COMPLIANCE": "Não conformidade",
      "CLOSED": "Encerrada",
      "COMPLETED_CALLS": "Chamadas concluídas"
    }
  },
  "pt-BR": {
    "root": {
      "ADMIN_PORTAL": "PORTAL DO ADMINISTRADOR",
      "SUPPORT": "SUPORTE",
      "U": "U",
      "USER": "Usuário",
      "LOGOUT": "Sair",
      "ADMIN": "Administrador",
      "SUPPORT_SMALL": "Suporte",
      "QUANTIFIED_AI": "Quantified.AI",
      "MICROPHONE": "MICROFONE",
      "CAMERA": "CÂMERA",
      "ACCESS_DENIED": "ACESSO_NEGADO"
    },
    "teams": {
      "MY_TEAMS": "Minhas equipes",
      "COMPLETED": "Concluída",
      "IN_PROGRESS": "Em andamento",
      "NOT_STARTED": "Não iniciada",
      "ASSIGNMET_MODULE": "Módulo de tarefas",
      "START_DATE": "Data de início",
      "DUE_DATE": "Data de vencimento",
      "ASSIGNED_MEMBERS": "Membros designados",
      "CALLS_IN_MODULE": "Simulações no módulo",
      "COMPLETION_REQUIRMENT": "Requisito de conclusão",
      "COMPLETE_ALL_CALLS": "Conclua todas as simulações com pontuação de",
      "OR_HIGHER": "ou mais",
      "PROGRESS_OVERVIEW": "VISÃO GERAL DO PROGRESSO",
      "TEAM_MEMBERS": "membros da equipe",
      "AVERAGE_HIGH_SCORE": "Média de pontuação alta",
      "AVERAGE_NUMBER_ATTEMPTS_CALL": "Número médio de tentativas por simulação",
      "TOTAL_PRACTICES": "Total de práticas",
      "INDIVIDUAL_CALL_PROGRESS": "PROGRESSO DA SIMULAÇÃO INDIVIDUAL",
      "OF_TEAM_MEMBERS": "dos membros da equipe concluíram",
      "AVERAGE_PRACTICES_TO_COMPLETION": "Média de práticas até a conclusão",
      "TEAM_MEMBER_DETAILS": "DETALHES DOS MEMBROS DA EQUIPE",
      "DOWNLOAD_ACTIVITY_REPORT": "Baixar relatório de atividades",
      "TEAM_MEMBER": "Membro da equipe",
      "PROGRESS": "Progresso",
      "CALLS_COMPLETED": "Simulações concluídas",
      "PRACTICES": "Sessões de prática",
      "MOST_RECENT_PRACTICE": "Sessão mais recente",
      "THIS_TEAM_HAS_NO_ACTIVE_ASSIGNMENTS": "Esta equipe não tem tarefas ativas no momento",
      "CALL_NAME_LABEL": "Nome da simulação",
      "HIGHEST_SCORE": "Pontuação mais alta"
    },
    "simulationBuilder": {
      "THRESHOLD": "Limite",
      "TYPE": "Tipo",
      "SELECT_AN_OPTION": "Selecione uma opção",
      "CORRECT_FEEDBACK": "Feedback correto",
      "INCORRECT_FEEDBACK": "Feedback incorreto",
      "CORRECT_FEEDBACK_PLACEHOLDER": "Exibido quando o participante acerta",
      "INCORRECT_FEEDBACK_PLACEHOLDER": "Exibido quando o participante erra",
      "ENTER_MESSAGE_TEXT": "Digite o texto da mensagem...",
      "DELETE": "Excluir",
      "SCORABLE": "Pontuável",
      "MESSAGE_NUMBER": "Mensagem {{ index }}",
      "SEARCH_BY_SIMULATION_NAME": "Pesquisar por nome da simulação",
      "SEARCH_BY_ASSIGNMENT_NAME": "Pesquisar por nome da tarefa",
      "SIMULATION_STATUS_PLACEHOLDER": "Status da simulação",
      "SIMULATION_STATUS_PREFIX": "Status da simulação:",
      "NO_SIMULATIONS_FOUND": "Nenhuma simulação encontrada",
      "SELECT_ALL": "Selecionar tudo",
      "DESELECT_ALL": "Desmarcar tudo",
      "STATUS_TESTING": "Testes",
      "STATUS_DRAFT": "Rascunho",
      "STATUS_PUBLISHED": "Publicado",
      "STATUS_ARCHIVED": "Arquivada",
      "ASSIGNEES_ZERO_STATE_MESSAGE": "Ainda não foram atribuídos usuários",
      "ADD_USERS_TO_ASSIGNMENT": "Adicionar usuários à tarefa",
      "NO_DATA_FOUND": "Nenhum dado encontrado!",
      "NO_USERS_SELECTED": "Nenhum usuário selecionado",
      "COL_FIRST_NAME": "Nome",
      "COL_LAST_NAME": "Sobrenome",
      "COL_EMAIL": "E-mail",
      "COL_VIEW_USER": "Ver usuário",
      "COL_VIEW_ASSIGNMENT": "Ver tarefa",
      "COL_ASSIGNMENT_NAME": "Nome da tarefa",
      "COL_STATUS": "Status",
      "COL_TEAM_ASSOCIATIONS": "Associações de equipe",
      "COL_REPORTING_STATUS": "Status do relatório",
      "BREADCRUMB_USERS": "Usuários",
      "STATUS_STAGED": "Preparada",
      "STATUS_ACTIVE": "Ativa",
      "STATUS_ENDED": "Terminada",
      "STATUS_CLOSED": "Encerrada",
      "SEARCH_USERS_PLACEHOLDER": "Pesquisar usuários",
      "NO_USERS_FOUND": "Nenhum usuário encontrado",
      "USERS_TAB_LABEL": "Usuários",
      "ADD_TO_ASSIGNMENT": "Adicionar à tarefa",
      "ASSIGNMENTS_COUNT": "tarefas",
      "REPORTING_EXCLUDED": "Excluído",
      "REPORTING_INCLUDED": "Incluído",
      "KEBAB_EDIT_TEAM_ASSOCIATIONS": "Editar associações de equipe",
      "KEBAB_EXCLUDE_FROM_REPORTING": "Excluir dos relatórios",
      "KEBAB_INCLUDE_IN_REPORTING": "Incluir nos relatórios",
      "KEBAB_REMOVE_FROM_ASSIGNMENT": "Remover da tarefa",
      "NO_TEAMS": "—",
      "TEAMS_COUNT": "{{count}} equipes",
      "ADD_TO_ASSIGNMENT_MODAL_HEADING": "Adicionar à tarefa",
      "FIELD_LABEL_ASSIGNMENT": "Tarefa",
      "SEARCH_ASSIGNMENTS_PLACEHOLDER": "Pesquisar tarefas",
      "BUTTON_SET_TEAM_ASSOCIATION": "Definir associação de equipe",
      "FIELD_LABEL_TEAM": "Equipe",
      "SEARCH_TEAM_PLACEHOLDER": "Pesquisar equipe",
      "BUTTON_BACK": "Voltar",
      "BUTTON_CANCEL": "Cancelar",
      "BUTTON_ADD_TO_ASSIGNMENT": "Adicionar à tarefa",
      "EDIT_TEAM_ASSOCIATIONS_HEADING": "Editar associações de equipe",
      "EDIT_TEAM_ASSOCIATIONS_DESCRIPTION": "Para a tarefa {{assignmentName}}",
      "BUTTON_SAVE_ASSOCIATIONS": "Salvar associações",
      "REFERENCE_DOCUMENT_STATUS_UPLOADING": "– Carregando...",
      "REFERENCE_DOCUMENT_STATUS_SUCCESS": "– 100% carregado",
      "REFERENCE_DOCUMENT_STATUS_ERROR": "– Erro no carregamento",
      "CREATE_SIMULATION_DETAILS_BUTTON": "Criar detalhes da simulação",
      "SELF_AUTHORING_DESCRIPTION": "Insira um nome, uma breve descrição do cenário e quaisquer documentos específicos da simulação para começar",
      "CLICK_TO_UPLOAD": "Clique para carregar",
      "OR_DRAG_AND_DROP": "ou arraste e solte",
      "REFERENCE_DOCUMENTS_UPLOAD_DESCRIPTION": "PDF (máx. 50 MB)",
      "ASSIGNMENT_NAME_LABEL": "Nome da tarefa *",
      "SIMULATION_NAME_LABEL": "Nome da simulação",
      "NAME_FIELD_DESCRIPTION": "Este nome pode ser alterado posteriormente",
      "PRODUCT_LABEL": "Produto",
      "SELECT_A_PRODUCT_PLACEHOLDER": "Selecionar um produto",
      "ADD_NEW_PRODUCT": "Adicionar novo produto",
      "SCENARIO_LABEL": "Detalhes do cenário",
      "REFERENCE_DOCUMENTS_LABEL": "Documentos de referência",
      "ACTION_CREATE_NEW": "Criar novo",
      "ACTION_CREATE": "Criar",
      "ACTION_DUPLICATE": "Duplicar",
      "ENTITY_TYPE_SIMULATION_DISPLAY": "Simulação",
      "ENTITY_TYPE_ASSIGNMENT_DISPLAY": "Tarefa",
      "ENTITY_TYPE_SIMULATION_LOWER": "simulação",
      "ENTITY_TYPE_ASSIGNMENT_LOWER": "tarefa",
      "MODAL_TITLE": "{{ action }} {{ type }}",
      "CONFIRM_BUTTON_LABEL": "{{ action }} {{ type }}",
      "DUPLICATE_NAME_ERROR_ASSIGNMENT": "Já existe uma tarefa com o mesmo nome.",
      "DUPLICATE_NAME_ERROR_SIMULATION": "Já existe uma simulação com o mesmo nome.",
      "NAME_REQUIRED_ERROR": "É necessário informar um nome.",
      "COPY_OF_PREFIX": "Cópia de - {{ name }}",
      "SCORE_DISTRIBUTION_TITLE": "Distribuição atual de pontuação",
      "EDIT_SECTIONS_AND_WEIGHTING": "Editar seções e pesos",
      "SCORING_WEIGHTS_TITLE": "Configurar pontuação",
      "SCORING_WEIGHTS_DESCRIPTION": "Escolha quais áreas serão avaliadas e quanto cada uma contribui para a nota geral. A soma de todos os pesos das seções ativadas deve ser igual a 100%. A seção de habilidades não pode ter um peso superior a 20%.",
      "SCORING_WEIGHT_REQUIRED": "Obrigatório",
      "REFERENCE_DOCUMENT_STATUS_DELETING": "– Excluindo",
      "REFERENCE_DOCUMENT_DELETE_ERROR": "Falha ao excluir o documento. Tente novamente.",
      "REFERENCE_DOCUMENT_UPLOAD_ERROR": "Falha ao carregar o documento. Tente novamente.",
      "CONTENT_LIMIT_EXCEEDED_ERROR": "Limite de conteúdo excedido. Remova um ou mais documentos para continuar.",
      "LAST_FACT_DELETE_WARNING_HEADING": "Excluir o último fato?",
      "LAST_FACT_DELETE_WARNING_DESCRIPTION": "A exclusão do último fato removerá todas as associações do usuário com esta simulação e reverterá seu status para Rascunho.",
      "LEAVE_CONFIRMATION_HEADING": "Sair da criação da simulação",
      "LEAVE_CONFIRMATION_DESCRIPTION": "Tem certeza de que deseja sair? Todo o progresso que você fez será perdido.",
      "LEAVE_CONFIRMATION_LEAVE_BUTTON": "Sair",
      "METHODOLOGY_TITLE": "Metodologia",
      "METHODOLOGY_SUBTITLE": "Avalie a abordagem e a estrutura da chamada",
      "METHODOLOGY_WEIGHTING_LABEL": "Ponderação: {{ weight }}%",
      "METHODOLOGY_RUBRIC_LABEL": "Rubrica de metodologia",
      "SELECT_RUBRIC_PLACEHOLDER": "Selecionar rubrica",
      "SKILLS_TITLE": "Habilidades",
      "SKILLS_SUBTITLE": "Pontuação em comunicação e habilidades interpessoais",
      "SKILLS_WEIGHTING_LABEL": "Ponderação: {{ weight }}%",
      "SKILLS_RUBRIC_LABEL": "Rubrica de habilidades",
      "PROCESSING_DOCUMENTS_MESSAGE": "Processando documentos...",
      "PROCESSING_DOCUMENTS_SUPPORTING_TEXT": "Fique à vontade para se ausentar — os resultados estarão prontos em 5 minutos.",
      "CORE_SIGNAL_MESSAGE": "Interpretando seu conteúdo...",
      "SECTION_PLAN_MESSAGE": "Planejando a estrutura da sua simulação...",
      "DERIVED_COMPONENT_MESSAGE": "Criando os componentes da sua simulação...",
      "COMPONENT_WAVE_1_MESSAGE": "Criando o conteúdo da sua simulação...",
      "STILL_PROCESSING_TITLE": "Ainda processando...",
      "STILL_PROCESSING_BODY": "Isso está demorando mais do que o normal — você pode sair desta simulação e voltar a ela mais tarde pela visualização da lista de simulações.",
      "PROCESSING_FAILED_TITLE": "Falha no processamento",
      "PROCESSING_FAILED_BODY": "Ocorreu um erro durante o processamento dos seus documentos — tente novamente. Entre em contato com ",
      "TEST_SIMULATION_BUTTON": "Testar simulação",
      "SIMULATION_PROCESSED_TITLE": "Documentos processados",
      "SIMULATION_PROCESSED_BODY": "Os documentos da sua simulação foram processados.",
      "SIMULATION_DOCUMENTS_PROCESSED_TITLE": "Documentos da simulação processados.",
      "SIMULATION_DOCUMENTS_PROCESSED_BODY": "Os documentos que você enviou para a simulação {{ name }} foram processados.",
      "SIMULATION_DOCUMENTS_FAILED_TITLE": "Falha no processamento dos documentos da simulação.",
      "SIMULATION_DOCUMENTS_FAILED_BODY": "Os documentos que você enviou para a simulação {{ nome }} não foram processados.",
      "DISMISS": "Ignorar",
      "VIEW_SIMULATION": "Ver simulação",
      "FACT_MESSAGE_LABEL": "Mensagem",
      "FACT_MESSAGE_DESCRIPTION": "As mensagens devem conter uma única informação, redigida como uma frase completa. Mantenha-as específicas, simples e de escopo limitado — evite mensagens que possam ser interpretadas de forma parcial.",
      "FACT_INCORRECT_ANSWER_LABEL": "Texto de resposta incorreta",
      "FACT_INCORRECT_ANSWER_DESCRIPTION": "O texto exibido ao aluno caso ele erre essa informação",
      "SHOW_INCORRECT_ANSWER_TEXT": "Mostrar texto alternativo para respostas incorretas",
      "ADD_NEW_FACT": "Adicionar novo fato",
      "FACT_SINGULAR": "fato",
      "FACT_PLURAL": "fatos",
      "FACT_EXTRACTED_SINGULAR": "{{ count }} fato extraído",
      "FACT_EXTRACTED_PLURAL": "{{ count }} fatos extraídos",
      "REVIEW_REQUIRED_LABEL": "Revisão sugerida",
      "MESSAGING_TITLE": "Mensagens",
      "MESSAGING_SUBTITLE": "Avalie se os fatos principais foram comunicados",
      "COMPONENT_WAVE_2_MESSAGE": "Refinando o conteúdo da sua simulação...",
      "COMPONENT_WAVE_3_MESSAGE": "Finalizando o conteúdo da sua simulação...",
      "MESSAGE_ADHERENCE_MESSAGE": "Sugerindo critérios de avaliação da mensagem...",
      "ASSEMBLING_MESSAGE": "Preparando sua simulação...",
      "PROCESSING_FAILED_SUFFIX": " se o problema persistir.",
      "BUTTON_RETRY": "Tente novamente",
      "TOKEN_LIMIT_EXCEEDED_BODY_PREFIX": "Limite de conteúdo excedido. Remova um ou mais documentos e tente novamente ou entre em contato com ",
      "TOKEN_LIMIT_EXCEEDED_BODY_SUFFIX": " se o problema persistir.",
      "AVATAR_LOOK_LABEL": "Aparência",
      "AVATAR_SELECT_PLACEHOLDER": "Selecionar avatar",
      "AVATAR_VOICE_LABEL": "Voz",
      "AVATAR_ALT": "Avatar",
      "PLAY_VOICE_PREVIEW_BUTTON": "Reproduzir pré-visualização de voz",
      "VOICE_OPTION_1": "Voz 1",
      "VOICE_OPTION_2": "Voz 2",
      "BACK_TO_SIMULATION_DETAILS_BUTTON": "Voltar aos detalhes da simulação",
      "AVATAR_SELECTION_TITLE": "Seleção de avatar",
      "VIEW_DOCUMENTS": "Visualizar documentos",
      "SELECT_AVATAR_BUTTON": "Selecionar avatar",
      "REQUEST_CHANGES_PLACEHOLDER": "Solicitar alterações nas informações acima",
      "CALL_DETAILS_LOAD_ERROR": "Não foi possível carregar os detalhes da sua chamada. Tente novamente.",
      "FACTS_CANNOT_BE_EMPTY": "Os fatos não podem estar vazios. Adicione uma mensagem a cada fato antes de testar ou publicar.",
      "FINISHING_SIMULATION_MESSAGE": "Finalizando sua simulação...",
      "BLANK_THEME_MESSAGE_TOOLTIP": "Adicione texto à mensagem vazia antes de adicionar um novo tema.",
      "BLANK_MESSAGE_TOOLTIP": "Adicione texto a esta mensagem antes de adicionar outra.",
      "ADD_NEW_THEME_BUTTON": "Adicionar novo tema",
      "ADD_THEME_BUTTON": "Adicionar tema",
      "ADD_MESSAGE_BUTTON": "Adicionar mensagem",
      "SCORE_LAST_SESSION": "Pontuar minha última sessão",
      "SCORE_LAST_SESSION_MODAL_HEADING": "Pontuar última sessão",
      "SCORE_LAST_SESSION_MODAL_DESCRIPTION": "Teste a simulação primeiro e, em seguida, volte aqui para avaliá-la com base na rubrica selecionada.",
      "SCORE_LAST_SESSION_MODAL_ERROR_HEADING": "Ocorreu um erro",
      "SCORE_LAST_SESSION_MODAL_ERROR_DESCRIPTION": "Tente novamente.",
      "REFINEMENT_THINKING_MESSAGE": "Pensando...",
      "REFINEMENT_UPDATED_MESSAGE": "Atualizado",
      "REFINEMENT_WARNING_PREFIX": "As informações foram alteradas manualmente — entre em contato com",
      "REFINEMENT_WARNING_SUFFIX": "para quaisquer atualizações.",
      "REFINEMENT_ERROR_PREFIX": "Infelizmente, não posso ajudar você com isso, mas",
      "REFINEMENT_ERROR_SUFFIX": "talvez seja possível.",
      "REFINEMENT_APPLIED_TITLE": "Alterações solicitadas aplicadas.",
      "REFINEMENT_APPLIED_BODY": "As alterações solicitadas para a simulação {{ name }} foram aplicadas.",
      "REFINEMENT_FAILED_TITLE": "As alterações solicitadas falharam.",
      "REFINEMENT_FAILED_BODY": "Não foi possível aplicar as alterações solicitadas para a simulação {{ nome }}.",
      "WHAT_USERS_SEE_DESCRIPTION_TITLE": "Descrição da simulação",
      "WHAT_USERS_SEE_DESCRIPTION_HELPER": "As informações atualizadas na aba “Geral” serão refletidas aqui, a menos que sejam feitas atualizações manuais.",
      "WHAT_USERS_SEE_DESCRIPTION_FIELD_LABEL": "Descrição",
      "WHAT_USERS_SEE_DETAILS_TITLE": "Detalhes da simulação",
      "WHAT_USERS_SEE_DETAILS_HELPER": "Este é o conteúdo que será apresentado ao usuário antes de iniciar a simulação. As informações atualizadas na aba “Geral” serão refletidas aqui, a menos que sejam feitas atualizações manuais. Quaisquer seções deixadas em branco não serão exibidas ao aluno. Todas as seções aceitam formatação markdown.",
      "WHAT_USERS_SEE_OVERVIEW_FIELD_LABEL": "Visão geral da simulação",
      "WHAT_USERS_SEE_PERSONA_FIELD_LABEL": "Sobre a persona",
      "WHAT_USERS_SEE_SCORING_FIELD_LABEL": "Critérios de pontuação",
      "WHAT_USERS_SEE_SCORING_FIELD_HELPER": "Esta seção é preenchida com base nas seleções feitas na guia “Pontuação”. Editar as informações aqui não alterará a forma como a simulação é pontuada.",
      "WHAT_USERS_SEE_PREVIEW_DETAILS_CTA": "Visualizar modal de detalhes da simulação",
      "WHAT_USERS_SEE_PREVIEW_CARD_CTA": "Visualizar cartão de simulação",
      "TAB_GENERAL": "Geral",
      "TAB_CONTENTS": "Índice",
      "TAB_KEY_WORDS": "Palavras-chave",
      "TAB_SCORING": "Pontuação",
      "TAB_TESTING": "Testes",
      "TAB_PROMPTS": "Prompts",
      "TAB_WHAT_USERS_SEE": "O que os usuários veem",
      "ACCURACY_FEEDBACK_TITLE": "Feedback sobre a precisão",
      "ACCURACY_FEEDBACK_DESCRIPTION": "Avaliar a precisão de cada afirmação feita pelo representante em relação aos documentos enviados",
      "ACCURACY_FEEDBACK_STATUS_ON": "Ativado",
      "ACCURACY_FEEDBACK_STATUS_OFF": "Desligado",
      "ACCURACY_FEEDBACK_STATUS_DISABLED": "Desativado",
      "ACCURACY_FEEDBACK_NO_DOCUMENTS": "A pontuação de precisão não está disponível porque nenhum documento relacionado foi adicionado.",
      "SCORING_AI_REVIEW_NOTICE": "Parte do conteúdo desta guia foi gerado a partir dos materiais que você forneceu. Revise todo o conteúdo quanto à precisão antes de publicar esta chamada.",
      "EXPORT_SIMULATION_SUMMARY_BUTTON": "Exportar resumo da simulação",
      "CALL": "Chamada",
      "REFINEMENT_OVERRIDDEN_PREFIX": "As informações foram alteradas manualmente — entre em contato com",
      "REFINEMENT_OVERRIDDEN_SUFFIX": "para quaisquer atualizações.",
      "SUPPORT_EMAIL": "help@quantified.ai",
      "WHAT_USERS_SEE_OVERRIDE_WARNING_TITLE": "A edição desses campos bloqueará atualizações futuras",
      "WHAT_USERS_SEE_OVERRIDE_WARNING_BODY": "A atualização manual dessas seções impedirá que elas recebam quaisquer atualizações adicionais do processo de refinamento na guia “Geral”.",
      "WHAT_USERS_SEE_DETAILS_OVERRIDE_EDITED_TITLE": "Esses campos foram editados",
      "WHAT_USERS_SEE_DETAILS_OVERRIDE_EDITED_BODY": "Eles não receberão mais as atualizações de refinamento feitas na guia “Geral”",
      "SIMULATION_BUILDER_HEADING": "Criador de simulações",
      "ASSIGNMENTS_TAB_LABEL": "Tarefas",
      "SIMULATIONS_TAB_LABEL": "Simulações",
      "CREATE_NEW_ASSIGNMENT_BUTTON": "Criar tarefa",
      "CREATE_NEW_SIMULATION_BUTTON": "Criar simulação",
      "NO_ASSIGNMENTS_FOUND": "Nenhuma tarefa encontrada",
      "ASSIGNMENT_STATUS_PLACEHOLDER": "Status da tarefa",
      "ASSIGNMENT_STATUS_PREFIX": "Status da tarefa:",
      "ASSIGNMENT_TYPE_LABEL": "Tipo de tarefa",
      "SELECT_ASSIGNMENT_TYPE_PLACEHOLDER": "Selecionar tipo de tarefa",
      "NAME_LABEL": "Nome",
      "ASSIGNMENT_NAME_PLACEHOLDER": "Nome da tarefa",
      "PASSING_SCORE_LABEL": "Pontuação de aprovação",
      "PASSING_SCORE_OPTIONAL_LABEL": "Pontuação de aprovação (opcional)",
      "SCORE_MAX_EXCEEDED_ERROR": "A pontuação não deve exceder 5",
      "GET_HELP_BUTTON": "Obter ajuda",
      "PASSING_SCORE_TOOLTIP": "Isso define a pontuação geral que um participante deve atingir para aprovação na simulação.",
      "DESCRIPTION_LABEL": "Descrição",
      "ASSIGNMENT_DESCRIPTION_PLACEHOLDER": "Descrição da tarefa",
      "MESSAGING_FEEDBACK_LABEL": "Feedback de mensagens",
      "MESSAGING_FEEDBACK_TOOLTIP_HEADING": "Feedback de mensagens",
      "MESSAGING_FEEDBACK_TOOLTIP_BODY": "Quando um participante formula uma mensagem incorretamente, são exibidas informações sobre como verbalizá-la melhor na próxima vez. A configuração determina se essas informações serão exibidas ou não.",
      "ENABLED_TEXT": "Ativado",
      "DISABLED_TEXT": "Desativado",
      "PAUSE_BUTTON_LABEL": "Botão Pausar",
      "ASSIGNMENT_START_DATE_LABEL": "Data de início da tarefa",
      "SELECT_DATE_PLACEHOLDER": "Selecionar data",
      "ASSIGNMENT_END_DATE_LABEL": "Data de término da tarefa",
      "ASSIGNMENT_END_DATE_OPTIONAL_LABEL": "Data de término da tarefa (opcional)",
      "END_DATE_RANGE_ERROR": "A data de início e a data de término não podem ser as mesmas",
      "ASSIGNMENT_INFORMATION_TITLE": "Informações da tarefa",
      "ASSIGNMENT_TYPE_CERTIFICATION": "Certificação",
      "ASSIGNMENT_TYPE_PRACTICE": "Prática",
      "ASSIGNMENT_TYPE_PERSONALIZED_PRACTICE": "Prática personalizada",
      "BUTTON_SAVE_AND_CLOSE": "Salvar e fechar",
      "BUTTON_ADD_SIMULATIONS": "Adicionar simulações",
      "ATTEMPTS_UNLIMITED": "Ilimitadas",
      "SEARCH_FOR_SIMULATION_LABEL": "Pesquisar simulação",
      "SIMULATION_NAME_PLACEHOLDER": "Nome da simulação",
      "BUTTON_REMOVE_ALL": "Remover tudo",
      "SIMULATIONS_IN_ASSIGNMENT_LABEL": "Simulações na tarefa",
      "BUTTON_ASSIGN_LEARNERS": "Atribuir participantes",
      "CALL_TYPE_UNKNOWN": "Desconhecido",
      "ASSIGNMENT_COUNT_NONE": "Nenhuma",
      "ASSIGNMENT_COUNT_SINGULAR": "{{ count }} tarefa",
      "ASSIGNMENT_COUNT_PLURAL": "{{ count }} tarefas",
      "ERROR_LOADING_ASSIGNMENTS": "Erro ao carregar as tarefas",
      "SEARCH_ASSIGNEES_TITLE": "Pesquisar designados",
      "DIALOG_DESCRIPTION_ADD_USERS": "Selecione os usuários que participarão da tarefa. A pesquisa por uma equipe permitirá que você atribua ou remova a atribuição de usuários específicos dessa equipe. Ao selecionar um usuário específico, certifique-se de que ele esteja associado à equipe correta para fins de relatório.",
      "ADD_USERS_TO_ASSIGNMENT_HEADING": "Adicionar usuários à tarefa",
      "BUTTON_REVIEW_SELECTED_USERS": "Revisar usuários selecionados",
      "FIND_USERS_LABEL": "Encontrar usuários",
      "BUTTON_CLEAR": "Limpar",
      "LEARNER_COUNT_NONE": "Nenhum",
      "LEARNER_COUNT_SINGULAR": "{{ count }} participante",
      "LEARNER_COUNT_PLURAL": "{{ count }} participantes",
      "ASSIGNMENT_TAB_DETAILS": "Detalhes",
      "ASSIGNMENT_TAB_SIMULATIONS": "Simulações",
      "ASSIGNMENT_TAB_ASSIGNEES": "Designados",
      "LOADING_ASSIGNMENT_DETAILS": "Carregando detalhes da atribuição...",
      "BREADCRUMB_ASSIGNMENTS": "Tarefas",
      "ASSIGNMENTS_COL_NAME": "Nome",
      "ASSIGNMENTS_COL_START_DATE": "Data de início da tarefa",
      "ASSIGNMENTS_COL_END_DATE": "Data de término da tarefa",
      "ASSIGNMENTS_COL_LEARNERS": "Participante atribuído",
      "ASSIGNMENTS_COL_TYPE": "Tipo de tarefa",
      "ASSIGNMENTS_COL_STATUS": "Status da tarefa",
      "SIMULATIONS_COL_NAME": "Nome",
      "SIMULATIONS_COL_PRODUCT": "Produto",
      "SIMULATIONS_COL_DATE_MODIFIED": "Data da última modificação",
      "SIMULATIONS_COL_STATUS": "Status",
      "SIMULATIONS_COL_USED_IN": "Usadas em",
      "SIMULATIONS_COL_TYPE": "Tipo de simulação",
      "SIMULATIONS_COL_DATE_PUBLISHED": "Data da publicação",
      "CONVERSE_PROMPT_LABEL": "Prompt de conversa",
      "CONVERSE_PROMPT_EXPAND_TO_EDIT": "Expandir para editar",
      "CONVERSE_PROMPT_ENTER_LABEL": "Insira o prompt de conversa aqui *",
      "CONVERSE_PROMPT_EDITING_HEADING": "Edição do prompt de conversa",
      "CONVERSE_PROMPT_OVERRIDE_CONFIRMATION_HEADING": "Confirmação de substituição do prompt",
      "CONVERSE_PROMPT_OVERRIDE_DESCRIPTION": "Tem certeza de que deseja substituir o prompt de conversa? Os autores perderão o acesso ao refinamento por conta própria se a mensagem for substituída.",
      "CONVERSE_PROMPT_FIELD_LABEL": "Prompt de conversa",
      "CONVERSE_PROMPT_SAVE_BUTTON": "Salvar prompt",
      "BUTTON_CONFIRM": "Confirmar",
      "DELETE_SIM_HEADING": "Excluir simulação",
      "DELETE_SIM_CONTENT": "Esta simulação será excluída. Quaisquer tarefas de teste associadas à simulação também serão removidas.",
      "DELETE_SIM_LABEL": "Excluir simulação",
      "DELETE_ASSIGNMENT_HEADING": "Excluir tarefa",
      "DELETE_ASSIGNMENT_CONTENT": "Esta tarefa será excluída permanentemente.",
      "DELETE_ASSIGNMENT_LABEL": "Excluir tarefa",
      "DELETE_ASSIGNMENT_NON_STAGED_CONTENT": "Para excluir uma tarefa com o status “Ativa” ou “Encerrada”, entre em contato com a equipe de experiência do cliente. Obrigado.",
      "REMOVE_FROM_ASSIGNMENT_HEADING": "Remover da tarefa",
      "REMOVE_FROM_ASSIGNMENT_CONTENT": "Isso removerá o usuário da tarefa e de todos os links de equipe associados.",
      "REMOVE_FROM_ASSIGNMENT_LABEL": "Remover da tarefa",
      "PUBLISH_SIMULATION_HEADING": "Publicar simulação",
      "PUBLISH_CONTINUE_EDITING": "Continuar a edição",
      "PUBLISH_BUTTON": "Publicar",
      "PUBLISH_SIMULATION_DESCRIPTION": "A dramatização poderá ser adicionada às atribuições, e as informações sobre persona, pontuação e instruções não poderão mais ser editadas.",
      "CONFIRMATION_SELECTED_USERS_HEADING": "Usuários selecionados",
      "CONFIRMATION_TOTAL_COUNT": "Total de {{ count }}",
      "CONFIRMATION_CREATE_HEADING": "Criar tarefa",
      "CONFIRMATION_ADD_USERS_HEADING": "Adicionar usuários à tarefa",
      "CONFIRMATION_SAVE_ASSIGNMENT_BTN": "Salvar tarefa",
      "CONFIRMATION_REMOVE_USER": "Remover",
      "EDIT_WEIGHTING_HEADING": "Editar pesos na pontuação",
      "EDIT_WEIGHTING_DESCRIPTION": "A pontuação geral será gerada a partir da média ponderada das seções a seguir. A soma de todos os pesos das seções ativadas deve ser igual a 100%. A seção de habilidades não pode ter um peso superior a 20%.",
      "EDIT_WEIGHTING_ERROR_ALL_DISABLED": "Pelo menos uma ação de pontuação deve estar ativada",
      "EDIT_WEIGHTING_ERROR_WEIGHT_RANGE": "O peso da seção deve ser entre 0 e 100",
      "EDIT_WEIGHTING_ERROR_SKILLS_MAX": "A seção de habilidades não pode ter um peso superior a 20%",
      "EDIT_WEIGHTING_ERROR_TOTAL": "O peso total das seções deve ser de 100%",
      "PERSONA_INFORMATION_TITLE": "Informações da persona",
      "PERSONA_AVATAR_LABEL": "Avatar *",
      "PERSONA_NAME_LABEL": "Nome *",
      "PERSONA_INITIAL_GREETINGS_LABEL": "Saudações iniciais *",
      "PERSONA_INITIAL_GREETINGS_DESCRIPTION": "A persona iniciará a simulação com uma dessas saudações. Você pode ter no máximo 5 opções.",
      "PERSONA_ADD_GREETING_OPTION": "Adicionar opção de saudação",
      "PERSONA_RESUME_MESSAGE_LABEL": "Retomar mensagem",
      "PERSONA_RESUME_MESSAGE_DESCRIPTION": "Quando um participante retomar uma simulação após uma pausa, a persona começará com uma dessas saudações. Você pode ter no máximo 5 opções.",
      "PERSONA_ADD_MESSAGE_OPTION": "Adicionar opção de mensagem",
      "PERSONA_UPLOADING": "Carregando...",
      "PERSONA_DELETING": "Excluindo...",
      "PERSONA_CUSTOM_BG_PREVIEW_ALT": "Visualização de plano de fundo personalizado",
      "PERSONA_AVATAR_THUMBNAIL_ALT": "Miniatura de avatar",
      "PERSONA_AVATAR_WITH_BG_ALT": "Avatar com plano de fundo personalizado",
      "PERSONA_PROCESSING_IMAGE": "Processando imagem...",
      "PERSONA_CUSTOM_BACKGROUND_LABEL": "Fundo personalizado",
      "PERSONA_REMOVE_BACKGROUND": "Remover plano de fundo",
      "PERSONA_CLICK_TO_REPLACE": "Clique para substituir",
      "PERSONA_UPLOAD_DESCRIPTION": "PNG ou JPG, preferencialmente na proporção 16:9, máx. de 2 MB",
      "SIM_INFORMATION_TITLE": "Informações da simulação",
      "SIM_NAME_FIELD_LABEL": "Nome *",
      "SIM_LANGUAGE_FIELD_LABEL": "Idioma",
      "SIM_DETAILS_SECTION_TITLE": "Detalhes da simulação",
      "SIM_ADDITIONAL_SECTION_TITLE_LABEL": "Título da seção adicional",
      "SIM_ADDITIONAL_SECTION_INFO_LABEL": "Informações adicionais da seção",
      "TESTING_SECTION_TITLE": "Testadores",
      "TESTING_SEND_ASSIGNMENTS_BTN": "Enviar tarefas de teste",
      "TESTING_MESSAGING_TOOLTIP": "Adicione pelo menos um fato à seção “Adesão à mensagem” antes de testar ou publicar.",
      "TESTING_DESCRIPTION": "Procure os usuários que testarão a simulação e, em seguida, envie a eles a tarefa de teste.",
      "TESTING_COL_NUMBER_OF_ATTEMPTS": "Número de tentativas",
      "TESTING_COL_DATE_OF_LAST_ATTEMPT": "Data da última tentativa",
      "TESTING_CLEAR_USERS": "Limpar usuários",
      "TESTING_REMOVE_ASSIGNEE": "Remover designado",
      "OVERALL_SECTION_TITLE": "Seções, pesos e prompts",
      "OVERALL_HEADING": "Geral",
      "TRANSCRIPT_PROMPT_TITLE": "Prompt de transcrição",
      "TRANSCRIPT_PROMPT_FIELD_LABEL": "Insira aqui o prompt da transcrição limpa aqui",
      "SIMULATION_PROMPTS_TITLE": "Prompts de simulação",
      "TAGS_LABEL": "Tags",
      "CREATE_TAG_OPTION": "Criar {{term}}",
      "TAG_CREATE_ERROR": "Não foi possível criar a tag. Tente novamente",
      "EDIT_SIMULATION_TAGS_TITLE": "Editar tags de simulação",
      "SAVE_TAGS_BUTTON": "Salvar tags",
      "CLOSE_BUTTON": "Fechar",
      "TAG_UPDATE_ERROR": "Não foi possível atualizar a tag. Tente novamente",
      "SCREEN_SHARE_TITLE": "Compartilhamento de tela",
      "SCREEN_SHARE_DESCRIPTION": "Permite que o usuário compartilhe sua tela com o avatar durante a chamada, para que ele possa ver e responder ao que está sendo exibido",
      "SCREEN_SHARE_STATUS_ON": "Ativado",
      "SCREEN_SHARE_STATUS_OFF": "Desativado",
      "SCREEN_SHARE_NO_PERSONA": "Adicione primeiro uma persona para ativar o compartilhamento de tela.",
      "HIDE_RESULTS_LABEL": "Ocultar resultados",
      "SEARCH_FIELD_HINT": "Digite pelo menos três caracteres para iniciar a pesquisa",
      "OTHERS_SINGULAR": "e mais 1",
      "OTHERS_PLURAL": "e {{ count }} mais",
      "PAGINATION_PREVIOUS": "Anterior",
      "PAGINATION_NEXT": "Avançar",
      "SKILLS_RUBRIC_REQUIRED_TOOLTIP": "Anexe uma rubrica de habilidades. As habilidades estão ativadas com um peso superior a 0%.",
      "ENTITY_TYPE_KNOWLEDGE_CHECK_DISPLAY": "verificação de conhecimento",
      "NAME_MAX_LENGTH_ERROR": "O nome deve ter no máximo 255 caracteres.",
      "UUID_COPIED_TOAST": "Chamar UUID copiados para a área de transferência",
      "MENU_ARCHIVE": "Arquivar",
      "MENU_EDIT_SIMULATION_TAGS": "Editar tags de simulação",
      "MENU_COPY_UUID": "Copiar UUID",
      "REFINEMENT_IN_PROGRESS_TOOLTIP": "Refinamento em andamento. Você pode continuar assim que a operação for concluída.",
      "SIMULATION_DOCUMENTS_PARSE_FAILED_BODY": "Não foi possível ler um dos seus documentos para {{ name }} — verifique-o ou substitua-o e tente novamente.",
      "REFINEMENT_ERROR_MESSAGE": "Infelizmente, não foi possível concluir esta solicitação. Tente novamente",
      "REFINEMENT_OUT_OF_SCOPE_TITLE": "Solicitação fora do escopo.",
      "REFINEMENT_OUT_OF_SCOPE_BODY": "Sua solicitação para {{ name }} está fora do que o refinamento pode fazer. Entre em contato com o suporte.",
      "TAB_QUESTIONS": "Perguntas",
      "KNOWLEDGE_CHECK_NAME_LABEL": "Nome*",
      "AVATAR_APPEARANCE_LABEL": "Aparência do avatar",
      "KNOWLEDGE_CHECK_AVATAR_NAME_LABEL": "Nome do avatar",
      "KNOWLEDGE_CHECK_SKILLS_FEEDBACK_TITLE": "Feedback das habilidades",
      "KNOWLEDGE_CHECK_SCORING_DESCRIPTION": "As simulações da verificação de conhecimento são pontuadas com base na porcentagem de pontos de resposta acertados em cada questão. Selecione uma rubrica de habilidades abaixo para receber também um feedback qualitativo.",
      "KNOWLEDGE_CHECK_SCORING_RESCORE_DESCRIPTION": "Depois de testar a simulação pelo menos uma vez, selecione “Avalie minha última sessão” para ver sua pontuação. Se você editar os pontos de resposta, poderá recalcular a pontuação da mesma sessão. Se você editar as perguntas, precisará realizar uma nova sessão de teste antes de avaliar.",
      "KNOWLEDGE_CHECK_SKILLS_RUBRIC_LABEL": "Rubrica de habilidades (opcional)",
      "SIMULATION_TYPE_MODAL_TITLE": "Criar simulação",
      "SIMULATION_TYPE_MODAL_DESCRIPTION": "Escolha como seus participantes vão praticar.",
      "SIMULATION_TYPE_ROLE_PLAY_TITLE": "Simulação de papéis",
      "SIMULATION_TYPE_ROLE_PLAY_DESCRIPTION": "Os participantes conduzem uma conversa aberta com um personagem de IA, que responde naturalmente a tudo o que eles dizem.",
      "SIMULATION_TYPE_ROLE_PLAY_BEST_FOR": "Ideal para: praticar chamadas de vendas realistas, como apresentações de produtos e tratamento de objeções.",
      "SIMULATION_TYPE_KNOWLEDGE_CHECK_TITLE": "Verificação de conhecimento",
      "SIMULATION_TYPE_KNOWLEDGE_CHECK_DESCRIPTION": "Um personagem de IA faz aos participantes as perguntas que você escreve, na ordem que você definir.",
      "SIMULATION_TYPE_KNOWLEDGE_CHECK_BEST_FOR": "Ideal para: testar o conhecimento sobre o produto e assegurar que os representantes estejam preparados.",
      "TAGS_FILTER_LABEL": "Tags",
      "TAGS_FILTER_PLACEHOLDER": "Selecione uma tag",
      "CLEAR_ALL_FILTERS": "Limpar todos os filtros",
      "LAST_SAVED_LABEL": "Última gravação",
      "BUTTON_OK": "OK",
      "KEYWORDS_RESET_TO_PRODUCT_DEFAULT": "Redefinir para o padrão do produto",
      "KEYWORDS_DETACH_FROM_PRODUCT_DEFAULT": "Desvincular do padrão do produto",
      "KEYWORDS_SAVE_AS_PRODUCT_DEFAULT": "Salvar como padrão do produto",
      "KEYWORDS_SAVE_AS_DEFAULT_OVERWRITE": "Isso substituirá o padrão {{ keywordTitle }} para o produto {{ moduleName }}.",
      "KEYWORDS_SAVE_AS_DEFAULT_IMPACT": "Essas palavras serão adicionadas às novas simulações para {{ moduleName }}. Todas as chamadas para o produto {{ moduleName }} serão afetadas.",
      "KEYWORDS_ADD_NEW_WORD": "Adicionar nova palavra",
      "KEYWORDS_FROM_LABEL": "De",
      "KEYWORDS_TO_LABEL": "Para",
      "KEYWORDS_PRONOUNCE_TITLE": "Pronunciar palavras",
      "KEYWORDS_PRONOUNCE_DESCRIPTION": "Forneça correções de pronúncia para o agente de IA, para que ele pronuncie nomes/termos corretamente. O agente mapeia pronúncias erradas comuns e variantes para a nova pronúncia.",
      "KEYWORDS_PRONOUNCE_NAME": "pronunciar palavras",
      "KEYWORDS_ADD_MISPRONUNCIATION": "Adicionar pronúncia incorreta",
      "KEYWORDS_SELECT_PERSONA_NOTICE": "Selecione uma persona para adicionar palavras a serem pronunciadas.",
      "KEYWORDS_REPLACE_TITLE": "Substituir palavras",
      "KEYWORDS_REPLACE_DESCRIPTION": "Correções explícitas de “localizar e substituir” para o texto da transcrição do usuário; substituições diretas de palavras que ocorrem antes da correção fonética.",
      "KEYWORDS_REPLACE_NAME": "substituir palavras",
      "KEYWORDS_ADD_REPLACEMENT": "Adicionar substituição",
      "KEYWORDS_STT_TITLE": "Palavras de STT",
      "KEYWORDS_STT_DESCRIPTION": "Lista de palavras fornecida a provedores de conversão de fala em texto (STT) (por exemplo, AssemblyAI, Tavus), especificamente para a configuração do provedor de STT.",
      "KEYWORDS_STT_NAME": "palavras de stt",
      "KEYWORDS_GENERATING": "Gerando...",
      "KEYWORDS_GENERATE_STT_PROMPT": "Gerar stt_prompt",
      "KEYWORDS_STT_PROMPT_OUTDATED": "A lista de palavras foi atualizada desde que este prompt foi gerado. Regenerar para refletir as alterações mais recentes.",
      "KEYWORDS_STT_CANNOT_SAVE_HEADING": "Não é possível salvar no nível do produto",
      "KEYWORDS_STT_CANNOT_SAVE_BODY": "As palavras e o prompt do STT não podem ser salvos no nível do produto. Você pode alterar manualmente outras configurações de STT da simulação ou entrar em contato com seu administrador para obter ajuda.",
      "KEYWORDS_CLEAN_TRANSCRIPT_TITLE": "Palavras da transcrição limpa",
      "KEYWORDS_CLEAN_TRANSCRIPT_DESCRIPTION": "Palavras inseridas no prompt CLEAN_TRANSCRIPT_V2.",
      "KEYWORDS_CLEAN_TRANSCRIPT_NAME": "palavras da transcrição limpa",
      "KEYWORDS_CALL_TITLE": "Palavras de chamada",
      "KEYWORDS_CALL_DESCRIPTION": "Dicionário de palavras corretas para correção fonética, usado pelo algoritmo Double Metaphone para corrigir erros ortográficos foneticamente semelhantes. Evite termos compostos por várias palavras, como “Anti MuSK AB+”, pois o corretor de transcrição baseado em código só funciona de maneira confiável com palavras isoladas. Evite também símbolos — por exemplo, “lp(a)” —, pois eles tendem a confundir o corretor. A lista deve permanecer o mais curta e simples possível, já que isso é tratado por um algoritmo determinístico, e não por um LLM, e ele não possui compreensão contextual",
      "KEYWORDS_CALL_NAME": "palavras de chamada"
    },
    "settings": {
      "DEVICE_SETUP_INTRO": "Vamos garantir que seu dispositivo esteja configurado.",
      "MICROPHONE_REQUIRED_NOTICE": "É necessário ter um microfone funcionando.",
      "DEVICE_ENABLE_INSTRUCTIONS": "Se não apareceu uma solicitação pop-up para ativar seus dispositivos após atualizar esta página, acesse as configurações do sistema ou do navegador e ative-os. Confira abaixo as páginas de suporte com instruções adicionais.",
      "ENABLE_CAMERA": "Como ativar sua câmera:",
      "WINDOWS_USERS": "Usuários do Windows",
      "MAC_USERS": "Usuários de Mac",
      "IPAD_USERS": "Usuários de iPad",
      "ENABLE_MICROPHONE": "Como ativar seu microfone:",
      "ENABLE_DEVICES_BY_BROWSER": "Como ativar seus dispositivos por navegador:",
      "CHROME_USERS": "Usuários do Chrome",
      "SAFARI_USERS": "Usuários do Safari",
      "FIREFOX_USERS": "Firefox",
      "EDGE_USERS": "Edge",
      "START_WITHOUT_CAMERA_BUTTON": "Iniciar sem câmera",
      "START_CALL_BUTTON": "Iniciar chamada",
      "MICROPHONE_REQUIRED_WARNING": "É necessário ter um microfone funcionando.",
      "MICROPHONE_ALT": "microfone",
      "MICROPHONE": "Microfone",
      "SELECT_MICROPHONE": "Selecione seu microfone",
      "ALERT": "alerta",
      "GIVE_PERMISSION": "Dar permissão",
      "SELECT_VIDEO_DEVICE": "Selecione seu dispositivo de vídeo",
      "VIDEO": "vídeo",
      "DEVICE_BLOCKED_ERROR": "Parece que você negou o acesso desse navegador a um ou mais dos seus dispositivos. Para ativar os dispositivos, acesse as configurações do sistema ou do navegador e ative o acesso.",
      "DEVICE_SETTINGS": "Configurações do dispositivo",
      "CONFIRM_SETTINGS": "Confirmar configurações",
      "LAPTOP": "Notebook",
      "SAD_EMOTE_FACE": "Rosto de emote triste",
      "GRANT_BROWSER_ACCESS": "Para concluir essa simulação, conceda ao navegador acesso ao reconhecimento de fala",
      "USING_IPAD": "Se estiver usando um iPad, acesse",
      "SETTINGS": "Configurações",
      "PRIVACY_AND_SECURITY": "Privacidade e segurança",
      "SPEECH_RECOGNITION": "Reconhecimento de fala",
      "GRANT_ACCESS_REFRESH": "Conceda acesso ao navegador e atualize a página",
      "REFRESH_PAGE": "ATUALIZAR A PÁGINA",
      "BROWSER_UNABLE_TO_ACCESS": "O navegador não consegue acessar este dispositivo",
      "ACCESS_DENIED": "acesso negado",
      "CAMERA": "Câmera",
      "DIAGNOSTIC_PASSED": "Todos os testes de diagnóstico foram concluídos com sucesso.",
      "DIAGNOSTIC_FAILED_MESSAGE": "Alguns testes de diagnóstico falharam. Clique no botão \"Copiar resultados de diagnóstico\" acima e envie os resultados para a equipe de suporte para receber assistência.",
      "DIAGNOSTIC_PARTIAL": "A maioria dos testes de diagnóstico foi aprovada com sucesso. Sua conexão parece boa.",
      "DIAGNOSTIC_RUNNING_MESSAGE": "Aguarde enquanto os testes de diagnóstico estão sendo executados...",
      "DIAGNOSTIC_RUNNING": "Diagnóstico em execução",
      "COPY_DIAGNOSTIC_RESULTS": "Copiar resultados de diagnóstico",
      "RUN_DIAGNOSTIC": "Executar diagnóstico",
      "RERUN_DIAGNOSTIC": "Executar diagnóstico novamente",
      "DIAGNOSTIC_RESULTS_COPIED": "Resultados do diagnóstico copiados para a área de transferência",
      "DIAGNOSTIC_FAILED": "Falha no diagnóstico",
      "DIAGNOSTIC_WEBSOCKET_NOT_TESTED": "Websocket: not tested",
      "DIAGNOSTIC_TURN_NOT_TESTED": "TURN: not tested",
      "DIAGNOSTIC_QUALITY_NOT_TESTED": "Quality: not tested",
      "DIAGNOSTIC_QUANTIFIED_DIAGNOSTICS": "Diagnósticos da Quantified",
      "DIAGNOSTIC_TIME": "Tempo",
      "DIAGNOSTIC_SUMMARY": "Resumo",
      "DIAGNOSTIC_CLIENT_INFO": "Informações do cliente",
      "DIAGNOSTIC_PLATFORM": "Plataforma",
      "DIAGNOSTIC_RTT_AVG_MAX": "RTT avg/max",
      "DIAGNOSTIC_PACKET_LOSS_SEND": "Perda de pacotes (envio)",
      "DIAGNOSTIC_AVG_SEND_BITRATE": "Taxa média de bits de envio",
      "DIAGNOSTIC_NA": "n/a",
      "DIAGNOSTIC_PROBLEMS_CONNECTING_PREFIX": "Problemas para se conectar?",
      "DIAGNOSTIC_CLICK_HERE": "Clique aqui",
      "DIAGNOSTIC_TO_RUN_SUFFIX": "para executar um diagnóstico."
    },
    "results": {
      "RETURN_HOME": "VOLTAR PARA O INÍCIO",
      "CLOSE_BUTTON": "Botão Fechar",
      "CONVERSATIONAL_CALL": "SIMULAÇÃO DE PAPÉIS",
      "INFORMATION_ICON": "Ícone de informações",
      "TOOLTIP_ARROW": "Seta de dica",
      "INFORMATION_TOOLTIP_CONTENT": "Você controla o fluxo da simulação, conduzindo a conversa para um conjunto de objetivos. As simulações de papéis são ótimas para testar habilidades, como aprofundar perguntas, fazer perguntas de segundo nível, identificar pontos problemáticos e criar empatia.",
      "CLOCK_ICON": "Ícone de relógio",
      "CALL_RESULTS": "Resultados",
      "SKILLS": "Habilidades",
      "MESSAGE_ADHERENCE": "Adesão à mensagem",
      "TRY_AGAIN_MESSAGE": "Tente novamente e melhore sua pontuação.",
      "PRACTICE_BENEFITS": "A prática semanal aumenta a confiança e melhora os resultados no mundo real.",
      "CALL_SUCCESS": "Ótimo trabalho! Você concluiu esta simulação com êxito.",
      "MAX_ATTEMPTS_REACHED": "Você atingiu o número máximo de tentativas",
      "TRY_AGAIN": "Tentar novamente",
      "GREAT_JOB_YOU_SUCCESSFULLY": "Ótimo trabalho! Você concluiu",
      "COMPLETED_THIS_CALL": "essa simulação com êxito.",
      "ACHIEVED_SCORE": "Você deve conseguir uma pontuação de",
      "ACHIEVE_SCORE": "Consiga uma pontuação de",
      "OR_HIGHER": "ou mais.",
      "OBJECTIVES_NOT_MET": "Você não atingiu todos os objetivos necessários.",
      "TRY_AGAIN_TARGET_SCORE": "Tente novamente para conseguir uma pontuação de",
      "YOUR_SCORE": "Sua pontuação",
      "OUT_OF_5": "DE 5",
      "CALL_FEEDBACK": "RESUMO DO FEEDBACK",
      "STRENGTH_ICON_ALT": "Ícone de força",
      "OPPORTUNITIES_ICON_ALT": "Ícone de oportunidades",
      "OBJECTIVES_FEEDBACK": "FEEDBACK SOBRE A METODOLOGIA",
      "SESSION_ID": "ID da sessão:",
      "SESSION_ID_COPIED": "ID da sessão copiado!",
      "OBJECTIVE": "METODOLOGIA:",
      "HOW_YOU_DID": "Como você se saiu:",
      "LIGHTBULB_ICON_ALT": "Ícone de lâmpada",
      "WHAT_WE_SUGGEST": "O que sugerimos:",
      "NO_SPECIFIC_RECOMMENDATION": "Nosso sistema não conseguiu encontrar uma recomendação específica para você.",
      "WHY": "Por quê?",
      "NO_INSIGHTS_AVAILABLE": "Nosso sistema não conseguiu fornecer insights sobre essa sugestão.",
      "CONFETTI_ICON_ALT": "Ícone de confete",
      "OBJECTIVE_SUCCESS_MESSAGE": "Você se saiu muito bem nesta metodologia. Continue assim!",
      "PROCESSING_CALL": "Estamos preparando sua pontuação e feedback.",
      "HANG_TIGHT": "Aguarde ou volte mais tarde para",
      "VIEW_YOUR_RESULTS": "ver seus resultados.",
      "NEED_MORE_TIME": "Precisamos de mais tempo para calcular os resultados.",
      "REFRESH_INSTRUCTION": "Verifique novamente ou atualize a tarefa",
      "RESULTS_IN_FEW_MINUTES": "resultados em poucos minutos.",
      "SCORE_CALCULATION_QUESTION": "Como isso é calculado?",
      "SINGLE_SCORE_EXPLANATION": "Esta simulação tem apenas um componente de pontuação. Por isso, a pontuação exibida é tanto a pontuação da seção individual quanto a pontuação geral.",
      "OVERALL_SCORE_PERCENT": "da pontuação geral",
      "SECTION_SCORE": "Pontuação da seção",
      "ELEVATE_MESSAGE_ADHERENCE_TITLE": "Aumente a adesão à mensagem da sua conversa",
      "MESSAGE_ADHERENCE_NOTE": "A adesão à mensagem é essencial para conduzir conversas bem-sucedidas, mas não afeta sua pontuação geral.",
      "NO_CREDIT": "Sem crédito",
      "PARTIAL_CREDIT": "Crédito parcial",
      "FULL_CREDIT": "Crédito total",
      "WHAT_YOU_DID_WELL": "O que você fez bem",
      "MISSED_ALL_KEY_POINTS": "Você deixou de abordar todos os pontos principais; revise-os e tente novamente.",
      "WHAT_TO_IMPROVE": "O que você pode melhorar",
      "PERFECT_SCORE_MESSAGE": "Parabéns! Você conseguiu uma pontuação perfeita, falando corretamente sobre todos os pontos principais.",
      "POINTS_LABEL": "Pontos",
      "TALKING_POINTS_COVERED": "Pontos de discussão abordados",
      "CHECKMARK_ICON_ALT": "marca de verificação",
      "TALKING_POINTS_MISSED": "Pontos de discussão não abordados",
      "X_ICON_ALT": "x",
      "PRACTICE_AGAIN": "Pratique novamente",
      "OUT_OF": "de",
      "OBJECTIVES": "Metodologia",
      "ELEVATE_OBJECTIVES_TITLE": "Melhore suas habilidades de conversa",
      "OBJECTIVES_NOTE": "A metodologia é essencial para conduzir conversas bem-sucedidas, mas não afeta sua pontuação geral.",
      "UNTIL": "até",
      "TO_IMPROVE_SCORE": "para melhorar sua pontuação.",
      "YOU_HAVE": "Você tem",
      "MORE_ATTEMPTS": "mais tentativas de atingir a pontuação de",
      "OR_HIGHER_BEFORE": "ou mais antes de",
      "AND_TRY_AGAIN": "e tente novamente.",
      "UNEXPECTED_STATE": "Ocorreu uma condição inesperada.",
      "REVIEW_APP_LOGIC": "Verifique a lógica do aplicativo.",
      "ASSIGNMENTS": "Tarefas",
      "VIEW_CALL_DETAILS": "Ver detalhes da chamada",
      "PRACTICE_SESSION": "Sessão de prática",
      "OVERALL_SCORE": "Pontuação geral",
      "OVERALL_SCORE_EXPLANATION": "A pontuação geral é calculada por meio de uma média ponderada da pontuação de cada seção. O peso de cada seção é exibido como uma porcentagem ao lado da pontuação.",
      "SCORE_CONFIG_NOTE": "As porcentagens de peso e a inclusão e exclusão de seções são definidas pela sua empresa. Todas as pontuações são arredondadas para a primeira casa decimal.",
      "STRENGTHS": "Pontos fortes",
      "OPPORTUNITIES": "Oportunidades",
      "YOUR_RESPONSE": "Sua resposta",
      "MINUS": "menos",
      "PLUS": "mais",
      "RECOMMENDED_RESPONSE": "Resposta recomendada",
      "REVIEW_MISSED_TITLE": "Revise o que você deixou passar.",
      "NO_TALKING_POINTS_COVERED": "Você não abordou nenhum dos pontos de discussão necessários para esse tema.",
      "LEARN_WHAT_YOU_MISSED": "Saiba o que você deixou passar",
      "NICE_JOB": "Bom trabalho!",
      "ALL_POINTS_COVERED": "Você abordou com sucesso todos os pontos de discussão necessários para esse tema.",
      "COVER_ALL_MESSAGES": "Aborde todas as mensagens principais.",
      "HIGHLIGHT_KEY_POINTS_NOTE": "Destacar os pontos principais durante a chamada ajudará a manter o foco da conversa.",
      "MESSAGES_LABEL": "Mensagens",
      "NO_FACTS_COVERED": "Ops! Parece que você não abordou nenhum dos fatos desta mensagem.",
      "NO_SPECIFICS_AVAILABLE": "Ops! Não conseguimos detalhar o que não foi abordado.",
      "ALL_KEY_POINTS_COVERED": "Ótimo trabalho! Você abordou todos os pontos principais.",
      "PROCESSING_SKILLS_FEEDBACK": "Estamos processando o feedback das suas habilidades.",
      "SKILLS_SCORING_NOT_ENABLED": "Lamentamos, mas não foi possível analisar sua chamada recente porque a pontuação de habilidades não estava ativada no momento do envio. Para receber feedback, basta reenviar sua prática de chamada como fez anteriormente. Se precisar de ajuda, entre em contato com a nossa equipe de suporte. Agradecemos sua compreensão e compromisso com o aprimoramento!",
      "ELEVATE_CONVERSATION_SKILLS": "Melhore suas habilidades de conversação",
      "SKILLS_NOTE": "As habilidades são essenciais para conduzir conversas bem-sucedidas, mas não afetam sua pontuação geral.",
      "SKILLS_SUMMARY_TITLE": "RESUMO DAS HABILIDADES",
      "LEARN_MORE_ABOUT_SKILLS": "Saiba mais sobre habilidades",
      "SKILLS_FEEDBACK_LABEL": "FEEDBACK",
      "WHAT_ARE_SKILLS_TITLE": "O que são habilidades",
      "SKILLS_DESCRIPTION": "As habilidades são calibradas para auxiliar no desenvolvimento do crescimento pessoal. Embora essas habilidades não façam parte da avaliação numérica da sua chamada, elas foram selecionadas pela sua organização para aumentar sua eficácia.",
      "PROFICIENCY_SCALE_TITLE": "ESCALA DE PROFICIÊNCIA",
      "EXPERT": "Especialista",
      "PROFICIENT": "Proficiente",
      "DEVELOPING": "Em desenvolvimento",
      "CALL_TRANSCRIPT": "Transcrição da chamada",
      "COLLAPSE_ALL": "Recolher tudo",
      "EXPAND_ALL": "Expandir tudo",
      "THUMBNAIL": "Miniatura",
      "OUT_OF_FIVE_POINTS": "/5 pontos",
      "TALKING_POINTS": "pontos de discussão",
      "TRANSCRIPT_LABEL": "Transcrição",
      "YOU_ARE_OUT_OF_ATTEMPTS": "Você não tem mais tentativas.",
      "REVIEW_GUIDELINES_REMAIN_COMPLIANT": "Revise as diretrizes e mantenha-se em conformidade daqui para a frente.",
      "TRY_AGAIN_ATTENTION_TO_COMPLIANCE": "Tente novamente e preste atenção às diretrizes de conformidade.",
      "NO_SCORE_OUT_OF_COMPLIANCE": "Identificamos algo que pode estar fora de conformidade",
      "WHY_OUT_OF_COMPLIANCE": "Por que você pode estar fora de conformidade",
      "REVIEW_TRANSCRIPT_MISSED_GUIDELINES": "Revise a transcrição para ver onde você não seguiu as diretrizes de conformidade.",
      "YOU_DID_FOLLOW_GUIDELINES": "Você seguiu efetivamente essas diretrizes.",
      "REVIEW_MISSED_GUIDELINES": "Revise as diretrizes de conformidade não observadas.",
      "OUT_OF_COMPLIANCE": "Fora de conformidade",
      "SCORE_CALCULATION_TITLE": "Cálculo da pontuação",
      "PROCESSING_TRANSCRIPT": "Estamos processando a transcrição.",
      "WAIT_OR_REVIEW_SCORES": "Aguarde aqui ou revise as outras seções de pontuação",
      "TRANSCRIPT_LOADING": "enquanto a transcrição é carregada.",
      "REVIEW_FEEDBACK_KEEP_PRACTICING": "Revise o feedback e continue praticando",
      "HIGH_PERFORMERS_PRACTICE": "Profissionais de alto desempenho praticam pelo menos uma vez por semana",
      "SUCCESSFULLY_PASSED": "Ótimo trabalho! Você conseguiu a aprovação nesta simulação.",
      "DIDNT_REACH_PASSING_SCORE": "Você não atingiu a pontuação de aprovação para esta simulação.",
      "OUT_OF_ATTEMPTS": "<b>Você não tem mais tentativas.</b> Revise o feedback para saber como melhorar.",
      "REVIEW_FEEDBACK_THEN_RETURN": "Revise o feedback e volte para o início quando estiver tudo pronto.",
      "GREAT_JOB_PRACTICED": "Ótimo trabalho, você praticou {{count}} {{times}}. Continue assim!",
      "TIME": "vez",
      "TIMES": "vezes",
      "COMPLIANCE_GUIDELINES": "Diretrizes de conformidade",
      "TALKING_POINT_TITLE": "PONTOS DE DISCUSSÃO NÃO ABORDADOS OU DITOS NO MOMENTO ERRADO",
      "NO_TRANSCRIPT": "Não há transcrição disponível.",
      "QUIZ_SUMMARY_BASE": "Reserve um momento para analisar seu desempenho neste teste.",
      "QUIZ_SUMMARY_FAILED": "Reserve um momento para analisar seu desempenho neste teste. Revise a(s) {{stepWord}} {{stepNames}} em destaque na tela de visão geral do caminho para se preparar melhor para a próxima tentativa.",
      "QUIZ_SUMMARY_PASSED_WITH_MISSES": "Reserve um momento para analisar seu desempenho neste teste. A(s) {{stepWord}} {{stepNames}} {{stepVerb}} a(s) {{areaWord}} em que você conseguiu as notas mais baixas.",
      "OUT_OF_100": "DE 100",
      "COVERED": "Abordado",
      "MISSED": "Não abordado",
      "RETURN_TO_ASSIGNMENT": "Retornar à tarefa",
      "RETURN_TO_PATHWAY": "VOLTAR AO CAMINHO",
      "QUIZ_RESULTS_SUMMARY": "Resumo dos resultados do teste",
      "PROCESSING_RESULTS": "Processando resultados...",
      "NONE_PERFECT": "Nenhum - Perfeito!",
      "MESSAGING": "Mensagens",
      "MISSED_ONE_TALKING_POINT": "Você perdeu 1 ponto de discussão sobre este assunto.",
      "MISSED_X_TALKING_POINTS": "Você perdeu {{count}} pontos de discussão sobre este assunto.",
      "ROLEPLAY_POST_CALL_TITLE": "Você chegou ao final da chamada.",
      "ROLEPLAY_POST_CALL_SUBTITLE_PROCESSING": "Deixe um feedback enquanto processamos seus resultados.",
      "ROLEPLAY_POST_CALL_SUBTITLE_DELAY": "Os resultados estão demorando um pouco para carregar. Saia do caminho. Avisaremos quando eles estiverem prontos.",
      "ROLEPLAY_POST_CALL_SUBTITLE_ERROR": "Erro ao processar seus resultados. Entre em contato com o suporte em",
      "ROLEPLAY_POST_CALL_PROCESSING_LABEL": "Processando resultados...",
      "ROLEPLAY_POST_CALL_FEEDBACK_QUESTION": "Essa conversa pareceu realista e natural?",
      "FEEDBACK_THANK_YOU": "Agradecemos o feedback!",
      "FEEDBACK_IMPROVEMENT_NOTE": "Agradecemos o feedback! Vamos trabalhar para melhorar a experiência.",
      "VIEW_RESULTS": "Ver resultados",
      "FEEDBACK_IMPROVEMENT_SUFFIX": "Vamos trabalhar para melhorar a experiência.",
      "QUIZ_RESULTS_LOADING": "Os resultados estão demorando um pouco para carregar. Saia do caminho. Avisaremos quando eles estiverem prontos.",
      "KC_TOAST_TITLE": "Os resultados da sua avaliação de conhecimento foram processados",
      "KC_TOAST_CONTENT": "Clique abaixo para ver os resultados ou volte à tela de detalhes do caminho para a próxima etapa.",
      "DISMISS": "Ignorar",
      "KC_TOAST_TITLE_PATHWAY": "Os resultados da avaliação de conhecimento de {{stepName}} foram processados",
      "MISSED_ONE_REQUIRED_TALKING_POINT": "Você perdeu 1 ponto de discussão obrigatório sobre este assunto",
      "MISSED_X_REQUIRED_TALKING_POINTS": "Você perdeu {{count}} pontos de discussão obrigatórios sobre este assunto",
      "MISSED_ALL_ONE_REQUIRED_TALKING_POINT_TITLE": "Você perdeu 1 ponto de discussão obrigatório sobre este assunto.",
      "MISSED_ALL_X_REQUIRED_TALKING_POINTS_TITLE": "Você perdeu {{count}} pontos de discussão obrigatórios sobre este assunto.",
      "REVIEW_MATERIAL_NEXT_TIME": "Analise o material para melhorar na próxima vez.",
      "POINT_LABEL": "Ponto",
      "GREAT_JOB_PRACTICED_FEMALE": "Ótimo trabalho, você praticou {{count}} {{times}}. Continue assim!",
      "ACCURACY": "Precisão",
      "ACCURACY_LOADING": "Carregando...",
      "ACCURACY_FLAGGED_MESSAGE": "Você mencionou algumas coisas que podem diferir dos seus materiais de referência. Veja abaixo mais detalhes.",
      "ACCURACY_ALL_CLEAR": "Não identificamos nenhuma afirmação que estivesse incorreta em relação aos materiais de referência.",
      "ACCURACY_ERROR": "Não foi possível fornecer feedback sobre esta sessão",
      "ACCURACY_YOU_SAID": "VOCÊ DISSE",
      "ACCURACY_CLAIM_IDENTIFIED": "A AFIRMAÇÃO QUE IDENTIFICAMOS",
      "ACCURACY_MATERIALS_STATE": "SEUS MATERIAIS AFIRMAM",
      "ACCURACY_OVERALL_BLOCK_PREFIX": "Você disse algumas coisas que podem estar incorretas. Verifique a ",
      "ACCURACY_OVERALL_BLOCK_LINK": "guia “Precisão”",
      "ACCURACY_OVERALL_BLOCK_SUFFIX": " para obter mais detalhes.",
      "PRACTICE_SIMULATION_AGAIN": "Faça a simulação novamente",
      "CALL_TYPE_CONVERSATIONAL": "Chamada de conversação",
      "CALL_TYPE_GUIDED": "Chamada guiada",
      "CALL_TYPE_VISUAL_AID": "Chamada com auxílio visual",
      "CALL_TYPE_ROLEPLAY": "Chamada de simulação de papéis",
      "PERSONALIZED_PRACTICE_BREADCRUMB": "Prática personalizada",
      "CONVERSATION_TYPE_LABEL": "Tipo de conversa:",
      "DIFFICULTY_LABEL": "Dificuldade:",
      "MOOD_LABEL": "Clima:",
      "DIFFICULTY": "Dificuldade",
      "TEMPERAMENT": "Temperamento",
      "OVERALL_SCORE_TAB": "Geral",
      "MESSAGE_ADHERENCE_TAB": "Mensagens",
      "OBJECTIVES_TAB": "Objetivos"
    },
    "reportingV2": {
      "DASHBOARD": "Painel",
      "LOADING_ACCOUNTS": "Carregando contas...",
      "SELECT_AN_ACCOUNT": "Selecione uma conta",
      "SEARCH_TEAMS": "Pesquisar equipes",
      "LOADING_TEAMS": "Carregando equipes...",
      "ALL_TEAMS": "Todas as equipes",
      "ACCOUNT": "Conta",
      "TEAMS": "Equipes",
      "TEAM_LABEL": "Equipe",
      "TOTAL_LABEL": "Total",
      "PASSING_SCORE": "Pontuação de aprovação",
      "ASSIGNMENT_LABEL": "Tarefas",
      "USER_LABEL": "Usuários",
      "PRACTICE_LABEL": "Prática",
      "CERTIFICATION_LABEL": "Certificação",
      "RESULTS_DESCRIPTION": "Aqui estão os resultados de sua(s) equipe(s) em todas as tarefas de prática:",
      "ENGAGEMENT_BY_ASSIGNMENT": "Engajamento por tarefa",
      "ASSIGNMENT_ENGAGEMENT": "Engajamento na tarefa",
      "ENGAGED_LABEL": "Engajado",
      "ENGAGEMENT_STATUS_LABEL": "Status do engajamento",
      "PROFICIENT_LABEL": "Proficiente",
      "ASSIGNMENT_NAME": "Nome da tarefa",
      "ACTIVE_USERS": "Usuários ativos",
      "ASSIGNMENT_PROGRESS": "Progresso por tarefa",
      "IN_PROGRESS_LABEL": "Em andamento",
      "CERTIFIED_LABEL": "Certificada",
      "OUT_OF_ATTEMPTS_LABEL": "Sem tentativas",
      "USERS_ENGAGED_LABEL": "Usuários engajados",
      "SESSIONS_PER_ACTIVE_USERS_LABEL": "Sessões por usuário ativo",
      "HIGHER_THAN_LABEL": "Maior que",
      "MORE_THAN_LABEL": "Mais de",
      "TOTAL_SESSIONS_COMPLETED_LABEL": "Total de sessões concluídas",
      "USER_CERTIFIED": "Usuários certificados em todas as tarefas",
      "ASSIGNMENT_CERTIFICATION": "Tarefas com 100% de certificação",
      "TRAINER_TIME_SAVED": "Economia de tempo do treinador",
      "HOURS_LABEL": "horas",
      "PRACTICE_ASSIGNMENT_LABEL": "Tarefas de prática",
      "CERTIFICATION_ASSIGNMENT_LABEL": "Tarefas de certificação",
      "START_DATE_LABEL": "Data de início",
      "END_DATE_LABEL": "Data de término",
      "NAME_LABEL": "Nome",
      "EMAIL_LABEL": "E-mail",
      "MEMBER_OF_TEAMS_LABEL": "Membro de equipes",
      "ASSIGNMENTS_COUNT_LABEL": "N.º de tarefas",
      "TOTAL_SESSIONS_LABEL": "Total de sessões",
      "NUMBER_OF_SESSIONS_LABEL": "Número de sessões",
      "TOTAL_USERS_LABEL": "Total de usuários",
      "AVERAGE_SCORE_LABEL": "Pontuação média",
      "INITIAL_SCORE_LABEL": "Pontuação inicial",
      "HIGH_SCORE_LABEL": "Pontuação alta",
      "LAST_PRACTICE_DATE_LABEL": "Data do último treino",
      "PERCENT_IMPROVED_LABEL": "% de melhoria",
      "PERCENT_IMPROVED_TOOLTIP_TEXT": "Esta métrica compara a pontuação inicial de um usuário com sua pontuação mais alta, expressa como uma porcentagem da melhoria máxima possível.",
      "ASSIGNMENTS_CERTIFIED_LABEL": "Tarefas certificadas",
      "ASSIGNMENTS_PROFICIENT_LABEL": "Tarefas com proficiência",
      "ASSIGNMENTS_CERTIFIED_TOOLTIP_TEXT": "O número de tarefas em que o usuário atingiu ou excedeu os critérios de pontuação para todas as simulações da tarefa.",
      "ASSIGNMENTS_PROFICIENT_TOOLTIP_TEXT": "O número de tarefas em que o usuário atingiu ou excedeu os critérios de pontuação pelo menos uma vez em todas as simulações da tarefa.",
      "PROFICIENT_TOOLTIP": "A porcentagem de usuários nesta tarefa que atenderem ou excederam os critérios de pontuação pelo menos uma vez em todas as simulações desta tarefa.",
      "IN_PROGRESS_TOOLTIP": "A porcentagem de usuários que concluíram pelo menos uma sessão de uma simulação desta tarefa e receberam uma pontuação.",
      "OUT_OF_ATTEMPTS_TOOLTIP": "A porcentagem de usuários que excederam as tentativas alocadas para uma ou mais simulações da tarefa.",
      "CERTIFIED_TOOLTIP": "A porcentagem de usuários que atingiram ou excederam os critérios de pontuação em todas as simulações da tarefa.",
      "SEARCH_FOR_A_USER_LABEL": "Pesquisar um usuário",
      "NO_USERS_FOUND_LABEL": "Nenhum usuário encontrado",
      "TRAINER_TIME_SAVED_TOOLTIP": "O tempo que os usuários gastaram na Quantified para concluir tentativas de certificação.",
      "AVG_SESSIONS_PER_ASSIGNMENT": "Média de sessões por tarefa",
      "ASSIGNMENTS_ENGAGED_WITH": "Tarefas em que houve progresso",
      "AVERAGE_IMPROVEMENT": "Melhoria média",
      "STATUS": "Status",
      "TOTAL_NUMBER_OF_SESSIONS": "Número total de sessões",
      "DATE_OF_LAST_PRACTICE": "Data da última prática",
      "CALL_NAME": "Nome da chamada",
      "SESSION_DATE": "Data da sessão",
      "DURATION_OF_SESSION": "Duração da sessão",
      "OVERALL_SCORE": "Pontuação geral",
      "MESSAGING_SCORE": "Pontuação de adesão à mensagem",
      "METHODOLOGY_SCORE": "Pontuação de metodologia",
      "SKILLS_SCORE": "Pontuação de habilidades",
      "SESSIONS": "Sessões",
      "TOTAL": "Total",
      "ALL_ASSIGNMENTS": "Todas as tarefas",
      "RECENT_ASSIGNMENTS": "Tarefas recentes",
      "AVERAGE_SESSIONS_ACTIVE_USER": "Média de sessões por usuário ativo",
      "HOURS_IN_SIMULATIONS": "Horas em simulações",
      "AVERAGE_SESSIONS_TO_PROFICIENCY": "Média de sessões até a proficiência",
      "PERCENT_PROFICIENT": "Porcentagem de proficiência",
      "SYSTEM_RUNNING_NORMALLY": "O sistema está funcionando normalmente no momento",
      "PRACTICE_SIMULATIONS_LABEL": "Simulações",
      "NO_USERS_MATCHING_FILTERS_LABEL": "Nenhum resultado corresponde aos seus filtros. Tente limpar um ou mais filtros para ampliar a pesquisa.",
      "USERS_PASSED": "Usuários que passaram na simulação",
      "AVERAGE_TIME": "Tempo médio para certificação",
      "USERS_OUT_OF_ATTEMPTS": "Usuários sem tentativas restantes",
      "NO_CERTIFICATION_SIMULATION": "Nenhuma simulação de certificação encontrada",
      "SIMULATION": "Simulação",
      "No_SIMULATION": "Nenhuma sessão",
      "PERCENT_CERTIFIED": "Percentual de certificados",
      "PERCENT_CERTIFIED_FIRST_ATTEMPT": "Percentual de certificados na primeira tentativa",
      "USERS": "Usuários",
      "ATTEMPTS_LABEL": "Tentativas",
      "NO_ATTEMPTS": "Nenhuma tentativa",
      "DATE_OF_SESSION": "Data da sessão",
      "NO_ASSIGNMENTS_MATCH_FILTERS": "Nenhuma tarefa corresponde aos filtros escolhidos",
      "NO_TEAMS_DATA": "Não há equipes nessa conta",
      "SIMULATION_NAME": "Nome da simulação",
      "AVERAGE_DURATION_OF_SESSION": "Duração média da sessão",
      "AVERAGE_SESSIONS_PER_ACTIVE_USER": "Média de sessões por usuário ativo",
      "AVERAGE_OVERALL_SCORE": "Pontuação geral média",
      "ASSIGNMENTS_CERTIFIED": "Tarefas certificadas",
      "HOURS_SPENT_PRACTICING": "Horas gastas praticando",
      "LAST_LOGIN": "Último login",
      "SELECT_ASSIGNMENTS": "Selecionar tarefas",
      "TOTAL_ASSIGNMENTS": "Total de tarefas",
      "TOTAL_SESSIONS": "Total de sessões",
      "CERTIFICATION_STATUS_LABEL": "Status da certificação",
      "CERTIFICATION_STATUS_PREFIX_LABEL": "Status da certificação:",
      "CERTIFIED_ON_FIRST_ATTEMPT_LABEL": "Certificado na primeira tentativa?",
      "DATE_OF_CERTIFICATION_LABEL": "Data da certificação",
      "ENGAGEMENT_STATUS_PREFIX_LABEL": "Status do engajamento:",
      "DURATION_OF_ATTEMPT": "Duração da tentativa",
      "USER_NAME": "Nome do usuário",
      "LEARNER": "Participante",
      "DATE_RANGE": "Intervalo de datas",
      "DATE_RANGE_LABEL": "Intervalo de datas",
      "SEARCH_USERS": "Pesquisar usuários...",
      "SEARCH_SIMULATIONS": "Pesquisar simulações...",
      "SEARCH_DATES": "Pesquisar datas...",
      "CERTIFIED_ON_FIRST_TRY": "Certificado na primeira tentativa",
      "DATE_OF_CERTIFICATION": "Data da certificação",
      "AVERAGE_CERTIFICATION_SCORE": "Pontuação média de certificação",
      "TOTAL_TIME_CERTIFYING": "Tempo total de certificação",
      "OF_THE_TIME": "do tempo",
      "ASSIGNED_LABEL": "Não iniciada",
      "USERS_ASSIGNED_LABEL": "Total de usuários atribuídos",
      "SESSION_ID": "ID da sessão",
      "NO_SIMULATIONS_FOUND_LABEL": "Nenhuma simulação encontrada",
      "USER_NAME_LABEL": "Nome do usuário",
      "MIN": "min",
      "SEC": "s",
      "OF_LABEL": "de",
      "SECOND": "segundo",
      "SECONDS": "segundos",
      "MINUTE": "minuto",
      "MINUTES": "minutos",
      "ASSIGNED": "Atribuído",
      "ENGAGED_TOOLTIP": "Porcentagem de usuários que completaram uma ou mais sessões de uma simulação nesta tarefa, mas ainda não alcançaram proficiência em todas as simulações.",
      "SEARCH_ASSIGNMENTS": "Pesquisar tarefas...",
      "ASSIGNMENT_NAME_LABEL": "Nome da tarefa",
      "SIMULATION_NAME_LABEL": "Nome da simulação",
      "START_DATE": "Data de início",
      "END_DATE": "Data de término",
      "NO_ASSIGNMENTS": "Nenhuma tarefa encontrada para este usuário.",
      "TOTAL_PRACTICE_ASSIGNMENTS": "Total de tarefas de prática",
      "SESSION_SCORES_OVER_TIME": "Pontuações da sessão ao longo do tempo",
      "TIME": "vez",
      "SCORE": "Pontuação",
      "NO_SESSIONS_AVAILABLE": "Nenhuma sessão disponível para gerar o gráfico.",
      "MESSAGING_SCORE_LABEL": "Pontuação de mensagens",
      "PERSONALIZED_PRACTICE_LABEL": "Prática personalizada",
      "ASSIGNMENT_ENAGEMENT": "Engajamento por tarefa",
      "NO_PRODUCTS": "Não há produtos de prática personalizados para as equipes selecionadas",
      "TOTAL_TIME_SPENT_PRACTICING": "Tempo de prática total",
      "AVERAGE_SESSIONS_PER_USER": "Média de sessões por usuário",
      "MOST_COMMON_CONVERSATION_TYPE_SELECTION": "Tipo de conversa mais comum selecionada",
      "LEAST_COMMON_CONVERSATION_TYPE_SELECTION": "Tipo de conversa menos comum selecionada",
      "CLEAR_TEAMS": "Limpar equipes",
      "METHODOLOGY_SCORE_DESCRIPTION": "Mede o nível de adesão dos participantes à estrutura de chamada recomendada. As pontuações refletem a média de todas as sessões desta simulação.",
      "METHODOLOGY": "Metodologia",
      "MESSAGING": "Mensagens",
      "MESSAGING_V2_DASHBOARD_DESCRIPTION": "Mede se os participantes articulam as ideias principais durante a chamada. Os gráficos mostram a porcentagem média de mensagens corretamente articuladas por tema, em todas as sessões.",
      "NO_METRICS_MESSAGE": "São necessárias mais sessões para gerar insights.",
      "SELECT_ALL": "Selecionar tudo",
      "DESELECT_ALL": "Desmarcar tudo",
      "SKILLS": "Habilidades",
      "SKILLS_SCORE_STATS_DESCRIPTION": "Mede o quanto os participantes conseguem demonstrar as principais habilidades durante a chamada. As pontuações refletem uma avaliação de IA média de todas as sessões.",
      "EXPERT": "Especialista",
      "PROFICIENT": "Proficiente",
      "DEVELOPING": "Em desenvolvimento",
      "FULLY_ARTICULATED": "Totalmente articulado",
      "PARTIALLY_ARTICULATED": "Parcialmente articulado",
      "NOT_MENTIONED": "Não mencionado",
      "MESSAGING_SCORE_STATS_DESCRIPTION": "Mede se os participantes articulam as ideias principais durante a chamada. Os gráficos mostram com que frequência cada mensagem foi corretamente articulada, em todas as sessões.",
      "CLEAR": "Limpar",
      "CLEAR_STATUS": "Limpar status",
      "CLEAR_USERS": "Limpar usuários",
      "CLEAR_SIMULATIONS": "Limpar simulações",
      "CLEAR_ASSIGNMENTS": "Limpar tarefas",
      "MODAL_SUBHEADING": "Todos os {{ count }} objetivos — pontuações médias em todas as sessões",
      "VIEW_ALL_OBJECTIVES": "Ver todos os {{ count }} objetivos →",
      "LEAST_MISSED_QUESTION": "PERGUNTA MENOS ERRADA",
      "MOST_MISSED_QUESTION": "PERGUNTA MAIS ERRADA",
      "HIGHEST_SCORING_METHODOLOGY_SECTION": "SEÇÃO DE METODOLOGIA COM MAIOR PONTUAÇÃO",
      "LOWEST_SCORING_METHODOLOGY_SECTION": "SEÇÃO DE METODOLOGIA COM MENOR PONTUAÇÃO",
      "LEAST_ARTICULATED_MESSAGE": "MENSAGEM MENOS ARTICULADA",
      "ENGAGEMENT": "ENGAJAMENTO",
      "USER_ENGAGEMENT_MORE_SESSIONS": "mais sessões concluídas do que a média da equipe",
      "QUESTION_CORRECT_PERCENTAGE_DESC": "das vezes, este usuário acertou",
      "QUESTION_CORRECT_PERCENTAGE_DESC_ASSIGNMENT": "das vezes, os usuários acertam",
      "METHODOLOGY_AVERAGE_POINTS_DESC": "pontos em média neste objetivo em todas as sessões",
      "MOST_ARTICULATED_MESSAGE": "MENSAGEM MAIS ARTICULADA",
      "LEAST_MISSED_ANSWER_POINT": "PONTO DE RESPOSTA MENOS ESQUECIDO",
      "MOST_MISSED_ANSWER_POINT": "PONTO DE RESPOSTA MAIS ESQUECIDO",
      "MOST_ARTICULATED_MESSAGE_DESCRIPTION": "das vezes, eles articulam plenamente esta mensagem",
      "LEAST_ARTICULATED_MESSAGE_DESCRIPTION": "das vezes, eles articulam esta mensagem",
      "ASSIGNMENT_STATUS": "Status da tarefa",
      "STATUS_ACTIVE": "Ativa",
      "STATUS_ENDED": "Terminada",
      "STATUS_CLOSED": "Encerrada",
      "STATUS_ARCHIVED": "Arquivada",
      "USER_ENGAGEMENT_FEWER_SESSIONS": "menos sessões concluídas do que a média da equipe",
      "MOST_ARTICULATED_MESSAGE_DESCRIPTION_ASSIGNMENT": "das vezes, os usuários articulam esta mensagem",
      "LEAST_ARTICULATED_MESSAGE_DESCRIPTION_ASSIGNMENT": "das vezes, os usuários articulam esta mensagem",
      "OTHERS_SINGULAR": "e mais 1",
      "OTHERS_PLURAL": "e {{ count }} mais",
      "PAGINATION_PREVIOUS": "Anterior",
      "PAGINATION_NEXT": "Avançar",
      "HOUR_LABEL": "hora",
      "SESSIONS_LABEL": "sessões"
    },
    "personalizedPractice": {
      "TITLE": "Prática personalizada",
      "DESCRIPTION": "Olá, {{userFirstName}}! As práticas personalizadas permitem que você defina seus próprios cenários para que sejam o mais realistas possível.",
      "LOADING": "Carregando...",
      "VIEW_SESSIONS": "Ver sessões",
      "VIEW_SIMULATION": "Ver simulação",
      "TOTAL_SESSION": "sessão no total",
      "TOTAL_SESSIONS": "sessões no total",
      "BREADCRUMB": "Prática personalizada",
      "SCENARIO_DETAILS_TITLE": "Detalhes do cenário",
      "SCENARIO_DETAILS_DESCRIPTION": "Selecione as variáveis nas opções abaixo para ajustar a simulação às suas necessidades.",
      "AVATAR": "Avatar",
      "SELECT_PLACEHOLDER": "Selecione",
      "CONVERSATION_TYPE": "Tipo de conversa",
      "SELECT_CONVERSATION_TYPE": "Selecione o tipo de conversa",
      "LAUNCH_SIMULATION": "Iniciar simulação com seleções",
      "PREVIOUS_SESSIONS": "Sessões anteriores",
      "TOTAL": "Total",
      "FILTERS": "Filtros:",
      "DATE": "Data",
      "DIFFICULTY": "Dificuldade",
      "TEMPERAMENT": "Temperamento",
      "SESSION_DATE": "Data da sessão",
      "SESSION_SCORE": "Pontuação da sessão",
      "DURATION": "Duração",
      "OVERALL_SCORE": "Pontuação geral",
      "MESSAGING": "Mensagens",
      "METHODOLOGY": "Metodologia",
      "SKILLS": "Habilidades",
      "RESULTS": "Resultados",
      "VIEW_FEEDBACK": "Ver feedback",
      "OVERALL_SCORE_LABEL": "Pontuação geral",
      "SCORE": "Pontuação",
      "NO_PRODUCTS_TITLE": "Não há produtos disponíveis",
      "NO_PRODUCTS_DESCRIPTION": "Você ainda não possui nenhum produto de prática personalizada.",
      "NO_SESSIONS_FOUND": "Nenhuma sessão encontrada com os filtros selecionados",
      "TIME": "vez",
      "ALL": "Todas",
      "LEARNER": "Participante",
      "MOOD": "Clima",
      "CLEAR_FILTERS": "Limpar filtros",
      "PAGINATION_PREVIOUS": "Anterior",
      "PAGINATION_NEXT": "Avançar",
      "DURATION_MINUTES_SECONDS": "{{minutes}}m {{seconds}}s",
      "DURATION_SECONDS": "{{seconds}}s"
    },
    "login": {
      "TITLE": "Bem-vindo de volta",
      "SUB_TITLE": "Como deseja fazer login?  ",
      "LOGIN_WITH_SSO": "Fazer login com o SSO da empresa",
      "LOGIN_WITH_PASSWORD": "Fazer login com senha",
      "PROVIDE_EMAIL": "Informe seu endereço de e-mail",
      "HELP_TEXT": "Precisa de ajuda? Contato",
      "EMAIL_ERROR": "Não foi possível efetuar o login. Fale com o administrador ou com o departamento de TI da empresa.",
      "EMAIL": "E-mail",
      "LOGIN": "Fazer login",
      "ALERT": "Alerta",
      "EMAIL_PLACEHOLDER": "olivia@untitledui.com",
      "LOGIN_CONSENT_MESSAGE": "Ao fazer login na sua conta, você concorda com os {{termsLink}} e a {{privacyLink}}.",
      "TERMS_OF_SERVICE": "Termos de Serviço",
      "PRIVACY_POLICY": "Política de Privacidade",
      "WRONG_REGION_MESSAGE": "Não foi possível efetuar o login. Fale com o administrador da sua empresa.",
      "WRONG_REGION_LINK": "Você também pode tentar fazer login no site {{regionName}}."
    },
    "learningPathway": {
      "BEGIN": "Começar",
      "DUE_DATE": "Prazo",
      "FOOTER_SUBTITLE_READY": "Pergunte qualquer coisa! Estou pronto para ajudar.",
      "LEAVE_STEP": "Sair da etapa",
      "NEXT_STEP": "Próxima etapa",
      "NOTIFICATIONS_ARIA": "Notificações",
      "PDF_NEXT_PAGE": "Próxima página",
      "PDF_NO_SOURCE": "Nenhuma fonte em PDF fornecida.",
      "PDF_PREVIOUS_PAGE": "Página anterior",
      "POST_CALL_SUBTITLE": "Deixe um feedback enquanto processamos seus resultados",
      "POST_CALL_TITLE": "Você chegou ao final deste teste.",
      "SETTINGS": "Configurações",
      "TOAST_CONTENT": "Clique abaixo para ver os resultados ou volte à tela de detalhes do caminho para a próxima etapa.",
      "TOAST_TITLE": "Os resultados da simulação de papéis de {{stepName}} foram processados",
      "ASSIGNMENTS": "Tarefas",
      "USER_FALLBACK": "Usuário",
      "VIEW_RESULTS": "Ver resultados",
      "QUIZ_TITLE": "Teste",
      "SUBMIT_ANSWER": "Enviar resposta",
      "CONTINUE": "Continuar",
      "REVIEW_MATERIAL": "Revisar material",
      "ASK_QUESTIONS_ABOUT_PATHWAY": "Faça perguntas sobre o caminho",
      "FOOTER_SUBTITLE_MUTED": "Seu microfone está desligado. O treinador não consegue ouvir você.",
      "FOOTER_SUBTITLE_LISTENING": "Ouvindo sua pergunta...",
      "FOOTER_SUBTITLE_THINKING": "Pensando em uma resposta...",
      "PDF_LOADING": "Carregando PDF",
      "PDF_SCROLL_HINT": "Deslize para continuar lendo",
      "QUIZ_OVERALL_SCORE_TOOLTIP": "A pontuação geral é a média ponderada das suas respostas nesta tentativa.",
      "QUIZ_COLUMN_DATE": "Data",
      "QUIZ_COLUMN_OVERALL_SCORE": "Pontuação geral",
      "QUIZ_COLUMN_ANSWER_POINTS": "Pontos de resposta",
      "QUIZ_COLUMN_RESULTS": "Resultados",
      "COMPLETE_STEP": "Concluir",
      "ERROR_TITLE": "Ocorreu um erro",
      "ERROR_MESSAGE": "Saia e entre novamente no caminho. Se o problema persistir, entre em contato com",
      "ERROR_HELP_EMAIL": "help@quantified.ai",
      "PATHWAY_COMPLETED_TITLE": "Você concluiu este caminho",
      "PATHWAY_COMPLETED_BODY": "Você pode revisar seus resultados quando quiser ou voltar a qualquer etapa para continuar praticando.",
      "PATHWAY_COMPLETED_RETURN": "Voltar às tarefas",
      "PATHWAY_OUT_OF_ATTEMPTS_TITLE": "Você não tem mais tentativas disponíveis para uma etapa do caminho.",
      "PATHWAY_OUT_OF_ATTEMPTS_BODY": "Entre em contato com seu gerente para discutir as próximas etapas.",
      "COMPLETED": "Concluída",
      "EXITING_QUIZ_EARLY": "O abandono deste teste agora contará como uma tentativa",
      "TRY_AGAIN": "Tentar novamente",
      "RETURN_TO_PATHWAY": "Voltar ao início do caminho",
      "REVIEW_BEFORE_QUIZ_TOOLTIP": "Revise esta etapa antes de refazer o teste",
      "FOOTER_SUBTITLE_QUIZ_RESULT_DONE": "Clique no botão à direita →",
      "VIEW_CALL_DETAILS": "Ver detalhes da chamada",
      "FOOTER_SUBTITLE_READY_LEARN_WITH_X": "O treinador está ouvindo caso você tenha alguma dúvida",
      "COLUMN_DATE": "Data",
      "COLUMN_OVERALL_SCORE": "Pontuação geral",
      "COLUMN_RESULTS": "Resultados",
      "COLUMN_ANSWER_POINTS": "Pontos de resposta",
      "COLUMN_MESSAGING_SCORE": "Pontuação de mensagens",
      "COLUMN_METHODOLOGY_SCORE": "Pontuação de metodologia",
      "COLUMN_SKILLS_SCORE": "Pontuação de habilidades",
      "PRACTICE_AGAIN": "Pratique novamente",
      "DEBRIEF_LATEST_SESSION": "Analisar a última sessão",
      "EXIT_MODAL_TITLE": "Deseja mesmo encerrar esta simulação de papéis?",
      "EXIT_MODAL_EXIT": "Sair",
      "EXIT_MODAL_RESUME": "Retomar",
      "EXIT_MODAL_DESC_LIMITED_ATTEMPTS": "Se você sair da simulação de papéis agora, ela não será pontuada, mas ainda assim contará como uma tentativa.",
      "EXIT_MODAL_DESC_UNLIMITED_ATTEMPTS": "Se você sair da simulação de papéis agora, ela não será pontuada.",
      "EXIT_MODAL_DESC_SCORED": "Se você sair da simulação de papéis agora, avaliaremos sua chamada tal como está.",
      "RESULTS_PROCESSING": "Processamento dos resultados",
      "RESULTS_FAILED": "Não foi possível carregar os resultados. Entre em contato com help@quantified.ai",
      "DEBRIEF_TITLE": "Análise",
      "DEBRIEF_DESCRIPTION": "Discuta os resultados da sua última tentativa de certificação",
      "DEBRIEF_DESCRIPTION_PRACTICE": "Discuta os resultados da sua última sessão de prática",
      "VIEW_ALL_SESSIONS": "Ver todas as sessões",
      "COLLAPSE_SESSIONS": "Ocultar sessões",
      "VIEW_ALL_ATTEMPTS": "Ver todas as tentativas",
      "COLLAPSE_ATTEMPTS": "Ocultar tentativas",
      "REATTEMPT_CERTIFICATION": "Tentar a certificação novamente",
      "DEBRIEF_EXIT_MODAL_TITLE": "Deseja mesmo encerrar esta análise?",
      "DEBRIEF_EXIT_MODAL_DESC": "Se você sair da análise agora, ela não será marcada como concluída.",
      "EXIT_PATHWAY": "Sair do caminho",
      "HELP": "Ajuda",
      "LEARN_STEP_HELP_CLOSE": "Fechar",
      "LEARN_STEP_HELP_TROUBLE": "Se você ainda estiver com dificuldades, entre em contato com",
      "LEARN_STEP_HELP_EMAIL": "help@quantified.ai",
      "LEARN_STEP_HELP_VIDEO_P1": "Assista ao material e tire as dúvidas com o treinador.",
      "LEARN_STEP_HELP_VIDEO_P2": "Selecione o botão de reprodução para começar o vídeo. Você pode voltar para revisar o material.",
      "LEARN_STEP_HELP_VIDEO_P3": "Reative seu próprio som no canto inferior direito para fazer uma pergunta. Isso pausará o vídeo. Quando você reproduzir o vídeo, seu microfone será silenciado.",
      "LEARN_STEP_HELP_VIDEO_P4": "Depois de assistir ao vídeo todo, avance para a próxima etapa.",
      "LEARN_STEP_HELP_PDF_P1": "Leia o material e tire as dúvidas com o treinador.",
      "LEARN_STEP_HELP_PDF_P2": "Navegue pelo material rolando a tela ou usando os botões de seta de cada lado para passar de uma página para outra.",
      "LEARN_STEP_HELP_PDF_P3": "Você pode silenciar e reativar seu próprio som no canto inferior direito.",
      "LEARN_STEP_HELP_PDF_P4": "Quando tiver lido tudo, avance para a próxima etapa.",
      "PDF_FULLSCREEN_ENTER": "Entrar em tela cheia",
      "PDF_FULLSCREEN_EXIT": "Sair de tela cheia",
      "PDF_ZOOM_IN": "Aumentar zoom",
      "PDF_ZOOM_OUT": "Diminuir zoom",
      "ASSESSMENT_EXIT_MODAL_TITLE": "Tem certeza de que deseja prosseguir?",
      "ASSESSMENT_EXIT_MODAL_DESC": "Avançar antes da conclusão desta conversa resultará em uma experiência de aprendizado mais longa e menos personalizada.",
      "ASSESSMENT_EXIT_MODAL_RESUME": "Retomar avaliação",
      "ASSESSMENT_EXIT_MODAL_PROCEED": "Prosseguir",
      "ASSESSMENT_PERSONALIZATION_ERROR_TITLE": "Não conseguimos personalizar seu caminho",
      "ASSESSMENT_PERSONALIZATION_ERROR_DESC_START": "Atribuímos a você o caminho completo — entre em contato com ",
      "ASSESSMENT_PERSONALIZATION_ERROR_DESC_END": " se quiser tentar a personalização novamente",
      "OPTIONAL": "Opcional",
      "DISMISS": "Ignorar",
      "DOWNLOAD": "Baixar"
    },
    "leaderboard": {
      "LEADERBOARD": "Tabela de classificação",
      "TOP10PERCENT": "10% superiores",
      "PRACTICE_ASSIGNMENT": "Tarefas de prática",
      "SIMULATION": "Simulação",
      "SELECT_ASSIGNMENT": "Selecionar tarefa",
      "SELECT_SIMULATION": "Selecionar simulação",
      "SELECT_ASSIGNMENT_AND_SIMULATION": "Selecione uma tarefa e uma simulação para ver os líderes",
      "NO_DATA": "Nenhuma atividade ainda. Quando a equipe começar a se envolver, você verá as classificações aparecerem aqui.",
      "NO_ASSIGNMENTS_AVAILABLE": "Não há tarefas disponíveis",
      "NO_SIMULATIONS_AVAILABLE": "Não há simulações disponíveis",
      "NAME": "Nome",
      "HIGH_SCORE": "Pontuação alta",
      "AVERAGE_SCORE": "Pontuação média",
      "TOTAL_SESSIONS": "Total de sessões",
      "LAST_SESSION": "Última sessão",
      "TOP5": "5 superiores",
      "OF": "de",
      "ENGAGED_USERS": "usuários engajados",
      "ENGAGED_USER": "usuário engajado",
      "NO_USERS_ENGAGED": "Nenhum usuário engajado",
      "HIDE_SESSIONS_WITH_LOW_SCORE": "Ocultar sessões com baixa pontuação de habilidades",
      "SESSIONS_WITH_LOW_SCORE_TOOLTIP": "As sessões com uma pontuação de \"desenvolvimento\" na seção de habilidades não contribuirão para as colunas de pontuação alta ou média.",
      "PAGINATION_PREVIOUS": "Anterior",
      "PAGINATION_NEXT": "Avançar"
    },
    "hotjarSurveys": {
      "FEEDBACK_MESSAGE": "Compartilhe seus comentários para nos ajudar a melhorar.",
      "THANK_YOU_MESSAGE": "Obrigado. Continuaremos trabalhando para melhorar sua experiência"
    },
    "general": {
      "NEED_HELP_QUESTION": "Precisa de ajuda?",
      "CONTACT": "Contato",
      "HELP_EMAIL": "help@quantified.ai",
      "PARENT_ACCOUNT": "Conta principal",
      "ACCOUNT": "Conta",
      "CHECKMARK": "Marca de verificação",
      "ICON": "Ícone",
      "ALERT": "alerta",
      "HEADS_UP": "Atenção!",
      "USE_HEADPHONES_FOR_OPTIMAL_AUDIO": "Para otimizar o áudio no iPad, use fones de ouvido.",
      "SETTINGS": "CONFIGURAÇÕES",
      "RP": "RP",
      "EMAIL_LABEL": "E-mail",
      "RAVEN_EMAIL": "Raven@InspireHR.com",
      "TEAM_MANAGER_FOR": "Gerente de equipe para",
      "MIAMI_SALE": "Vendas em Miami",
      "CHARLOTTE_SALES": "Vendas em Charlotte",
      "ATLANTA_SALES": "Vendas em Atlanta",
      "TEAM": "Equipe",
      "ASSIGNMENTS": "Tarefas",
      "MY_TEAMS": "Minhas equipes",
      "REPORTING": "Relatórios",
      "DASHBOARD": "Painel",
      "LEADERBOARD": "Tabela de classificação",
      "PERSONALIZED_PRACTICE": "Prática personalizada",
      "HELP_SEARCH_OUR": "Pesquise em nossa",
      "HELP_OR_REACH_OUT_TO": "ou entre em contato com",
      "HELP_WITH_QUESTIONS": "com dúvidas",
      "KNOWLEDGE_BASE": "base de conhecimento",
      "NO_ROLE_WEB_MESSAGE": "Este usuário não possui acesso ao sistema. Entre em contato com um administrador do sistema.",
      "NO_ROLE_IOS_TITLE": "Nosso aplicativo é voltado para a experiência do aluno",
      "NO_ROLE_IOS_BODY_START": "Acesse o nosso",
      "NO_ROLE_IOS_WEB_APP": "aplicativo web",
      "NO_ROLE_IOS_BODY_END": "no navegador do seu celular para usar funcionalidades adicionais.",
      "HELP_SECTION": "AJUDA",
      "ABOUT_SECTION": "SOBRE",
      "CONTACT_SUPPORT": "Entre em contato com o suporte",
      "OPEN_WEB_APP": "Abra o aplicativo web",
      "SEARCH_KNOWLEDGE_BASE": "Pesquise a base de conhecimento",
      "PRIVACY_POLICY": "Política de privacidade",
      "TERMS_OF_SERVICE": "Termos de serviço",
      "VERSION": "Versão",
      "LOG_OUT": "Sair"
    },
    "dashboard": {
      "ALL": "Todas",
      "IN_COMPLETE": "Incompletas",
      "COMPLETED": "Concluída",
      "NO_ASSIGNMENT_TITLE": "Você não tem nenhuma tarefa.",
      "NO_ASSIGNMENT_DETAILS": "Você receberá uma notificação quando tiver tarefas para concluir.",
      "IN_COMPLETE_ASSIGNMENT_TITLE": "Você não tem tarefas incompletas.",
      "IN_COMPLETE_ASSIGNMENT_DETAILS": "Você receberá uma notificação quando uma nova tarefa estiver pendente.",
      "COMPLETED_ASSIGNMENT_TITLE": "Você não tem tarefas concluídas.",
      "COMPLETED_ASSIGNMENT_DETAILS": "Verifique novamente quando tiver concluído uma tarefa.",
      "VIEW_ASSIGNMENT": "Ver tarefa",
      "ASSIGNMENT_LABEL": "Tarefas",
      "MODULE_ASSIGNMENT_ALT": "Ícone de tarefa do módulo",
      "VIEW_ASSIGNMENT_FOR": "Ver tarefa para",
      "DAY": "Dia",
      "UNTILL_DUE": "Até o prazo",
      "PAST_DUE": "Vencido",
      "AVAILABLE_IN": "Disponível em",
      "DUE_TODAY": "Prazo hoje",
      "PRACTICE": "Prática",
      "CERTIFICATION": "Certificação",
      "UPCOMING": "Em breve",
      "TEST_ASSIGNMENT": "Tarefa de teste",
      "CLOSED": "Fechada",
      "NO_ASSIGNMENT_FILTERED_TITLE": "Nenhuma tarefa encontrada.",
      "NO_ASSIGNMENT_FILTERED_DETAILS": "Tente ajustar os filtros para ver as tarefas disponíveis ou volte mais tarde quando novas tarefas forem adicionadas.",
      "VIEW_PATHWAY": "Exibir caminho",
      "TOTAL": "Total",
      "STATUS_LABEL": "Status",
      "STATUS_SELECTION_LABEL": "Status:",
      "ASSIGNMENT_TYPE": "Tipo de tarefa",
      "ASSIGNMENT_TYPE_SELECTION_LABEL": "Tipo de tarefa:",
      "NOT_STARTED": "Não iniciadas",
      "CERTIFIED": "Certificada",
      "NOT_CERTIFIED": "Não certificado",
      "IN_PROGRESS": "Em andamento",
      "PATHWAY": "Caminho de aprendizagem",
      "SELECT_ALL": "Selecionar tudo",
      "DESELECT_ALL": "Desmarcar tudo",
      "GET_STARTED": "Comece agora",
      "ASSIGNMENT_STATUS_LABEL": "Status da tarefa",
      "ASSIGNMENT_STATUS_SELECTION_LABEL": "Status da tarefa:",
      "CLEAR_STATUS": "Limpar status",
      "ENDED": "Terminada",
      "START_PATHWAY": "Iniciar caminho",
      "DAYS": "Dias",
      "OTHERS_SINGULAR": "e mais 1",
      "OTHERS_PLURAL": "e {{ count }} mais"
    },
    "cognito": {
      "INVITATION_SUBJECT": "Bem-vindo à Quantified!",
      "INVITATION_MESSAGE": "É muito bom ter você conosco! Para começar, siga as etapas abaixo para acessar sua conta pela primeira vez.",
      "ACCOUNT_DETAILS": "Detalhes da sua conta:",
      "USERNAME": "Nome de usuário",
      "PASSWORD": "Senha temporária",
      "STEPS_LABEL": "Próximas etapas para fazer login",
      "STEP_1": "1. Clique no botão \"Fazer login\" abaixo para acessar a página de login.",
      "STEP_2": "2. Digite seu nome de usuário e a senha temporária fornecidos acima.",
      "STEP_3": "3. Após fazer login, você deverá definir uma nova senha.",
      "LOGIN_BUTTON": "Fazer login",
      "ABOUT_US": "O Simulador da Quantified é um ambiente virtual projetado para ajudar você a desenvolver rapidamente habilidades essenciais, permitindo que se conecte e se comunique de forma mais eficaz com os clientes.",
      "EXPIRY_TIME": "Essa senha temporária expirará em 24 horas. Se tiver algum problema ao fazer login, entre em contato com nossa equipe de suporte em",
      "TEAM": "A equipe da Quantified",
      "INVITATION_SMS_USERNAME": "Seu nome de usuário é",
      "INVITATION_SMS_PASSWORD": "e a senha temporária é",
      "AUTHENTICATION_CODE": "Seu código de autenticação é",
      "PASSWORD_RESET_CODE": "Seu código de redefinição de senha da Quantified",
      "RESET_PASSWORD_EMAIL": "E-mail para redefinir a senha",
      "HELLO": "Olá",
      "USE_VERIFICATION_CODE": "Você solicitou uma redefinição de senha. Use o código de verificação abaixo para concluir o processo.",
      "VERIFICATION_CODE": "Código de verificação",
      "NEXT_STEP": "Próximas etapas",
      "RESET_PASSWORD_PAGE": "Volte à página de redefinição de senha no seu navegador.",
      "ENTER_VERIFICATION_CODE": "Digite o código de verificação quando solicitado.",
      "CREATE_PASSWORD": "Depois que o código for verificado, siga as instruções para criar uma nova senha.",
      "DISREGARD_NOTE": "Se você não solicitou a redefinição de senha, desconsidere este e-mail.",
      "CONTACT_SUPPORT": "Para receber mais ajuda, entre em contato com nossa equipe de suporte em",
      "HELP_EMAIL": "help@quantified.ai",
      "THANK_YOU": "Obrigado",
      "QUANTIFIED_TEAM": "A equipe da Quantified",
      "ADDRESS": "4200 Marathon Blvd, Suite 210, Austin, Texas 78756, Estados Unidos",
      "RETURN_TO_PATHWAY": "Voltar ao início do caminho"
    },
    "call": {
      "LOADING": "Carregando",
      "SIMULATION_PAUSED": "A simulação foi pausada.",
      "CLICK_RESUME": "Clique no botão \"Retomar\" abaixo para continuar.",
      "NO_INTERNET": "Sem conexão com a internet",
      "TRY_AGAIN": "Verifique sua conexão e tente novamente.",
      "MIC_MUTED": "O microfone está mudo",
      "MIC_MUTED_DESCRIPTION": "Ops, parece que seu microfone está mudo. Reative o som para responder e continuar.",
      "NO_RESPONSE": "Nenhuma resposta detectada",
      "MIC_NOT_CONNECTED": "Ops, parece que seu microfone não está conectado. Selecione novamente seu dispositivo para responder e continuar.",
      "AUDIO_ISSUE": "Ops, algo deu errado. Verifique as configurações do dispositivo e certifique-se de estar em um local silencioso e sem ruídos de fundo.",
      "LOADING_ALT": "Carregando...",
      "REPEAT_RESPONSE": "Você retornará automaticamente à simulação para repetir sua resposta e tentar novamente.",
      "NEEDS_MORE_TIME_QUESTION": "precisa de mais tempo para pensar. Você quer esperar?",
      "NEEDS_MORE_TIME": "precisa de mais tempo para pensar.",
      "WAIT_OR_END_CALL": "Nós avisaremos você quando o participante estiver pronto, ou você pode encerrar a chamada e",
      "RETURN_TO_ASSIGNMENTS": "retornar à tarefa",
      "READY": "Pronto",
      "IS_READY": "já está disponível para continuar sua conversa.",
      "TRY_AGAIN_LABEL": "Tentar novamente",
      "CHECK_SETTINGS": "Verificar configurações",
      "PAUSED_SIMULATION": "Você pausou a simulação.",
      "PAUSED_SIMULATION_DESCRIPTION": "A gravação de vídeo e áudio fica pausada até que a simulação seja retomada.",
      "RESUME": "Retomar",
      "SETTINGS": "Configurações",
      "CAPTURING_RESPONSE": "Capturando suas respostas",
      "TOUR_MESSAGE": "Quando terminar de falar, não se esqueça de clicar no botão Continuar para garantir que suas respostas sejam capturadas e pontuadas.",
      "NEXT": "Avançar",
      "START_CALL": "Início",
      "END_CALL_TITLE": "Deseja mesmo encerrar esta simulação?",
      "END_CALL_DESCRIPTION": "Se você encerrar a simulação agora, não receberá pontuação nem feedback sobre sua conversa.",
      "END_CALL": "Fim",
      "BROWSER_ACCESS_DENIED": "Seu navegador não tem acesso a esse dispositivo.",
      "COPY_SESSION_ID_BUTTON": "Copiar ID da sessão",
      "TIPS_GUIDANCE_MESSAGE": "Pontos de discussão e dicas aparecerão aqui.",
      "CONTINUE": "Continuar",
      "SESSION_ID_LABEL": "ID da sessão:",
      "SESSION_ID_COPIED": "ID da sessão copiado!",
      "HINTS_AND_SUGGESTIONS_TITLE": "Dicas e sugestões",
      "HINT_LABEL": "Dica",
      "CAPTIONS_LABEL": "Legendas",
      "PAUSE_LABEL": "Pausar",
      "VIDEO_LABEL": "Vídeo",
      "PARTY_EMOJI": "emoji de festa",
      "CALL_ENDED_MESSAGE": "Você chegou ao final da simulação.",
      "CALL_ENDED_INACTIVITY": "Esta simulação foi encerrada devido à inatividade",
      "CALL_ENDED_GENERIC": "Esta simulação foi encerrada",
      "FEEDBACK_PROMPT": "Deixe um feedback enquanto processamos seus resultados.",
      "INTERACTION_THRESHOLD_NOT_MET": "Você não atingiu nosso limite de interação para pontuação. Tente novamente.",
      "REALISTIC_CONVERSATION_QUESTION": "Essa conversa pareceu realista e natural?",
      "KNOWLEDGEABLE_PREPARED_QUESTION": "Você se sente mais bem informado e preparado depois desta simulação?",
      "FEEDBACK_THANK_YOU": "Agradecemos o feedback!",
      "FEEDBACK_IMPROVEMENT_NOTE": "Agradecemos o feedback! Vamos trabalhar para melhorar a experiência.",
      "AUDIO": "Áudio",
      "VISUAL_AID_LOAD_ERROR": "Não foi possível carregar o auxílio visual",
      "BEGIN_CALL": "Início",
      "LEAVE_CALL_BRIEFING": "Sair da preparação",
      "RESTORE_CALL": "Restaurando sua simulação",
      "FEW_SECONDS": "Isso pode levar alguns segundos.",
      "CHECK_ALT": "Marca de verificação",
      "COPY_ALT": "Copiar",
      "HINTS_ALT": "Dicas",
      "CLOSE_CAPTIONS": "Fechar legendas",
      "MICROPHONE_MUTED": "Microfone mudo",
      "RETURN_TO_CALL": "Retornar à simulação",
      "YES": "Sim",
      "NO": "Não",
      "VIEW_RESULTS": "Ver resultados",
      "RETURN_TO_ASSIGNMENT": "Retornar à tarefa",
      "HAVING_ISSUES": "Estamos com problemas de conexão. Verifique sua conexão com a internet e clique em OK.",
      "OK": "OK",
      "RESULTS_NOT_GENERATED": "Desculpe, não foi possível gerar resultados no momento. Tente novamente.",
      "INACTIVITY_ALERT_MESSAGE": "Esta chamada está sendo encerrada devido à inatividade. Fale com o avatar para continuar ou selecione \"Encerrar chamada\" para encerrar a chamada.",
      "INACTIVITY_DEFAULT_ALERT_TITLE": "Esta chamada será encerrada em {{secondsUntilHangup}} segundos",
      "INACTIVITY_SHORT_ALERT_TITLE": "Esta chamada será encerrada em alguns segundos",
      "TELL_YOUR_GENDER_HEADING": "Informe seu gênero:",
      "BY_KNOWING_YOUR_GENDER_DESCRIPTION": "Ao saber seu gênero, o avatar pode usar a gramática adequada, tornando a conversa mais natural e realista.",
      "GENDER_SELECTION": "Seleção de gênero:",
      "SELECT_OPTION": "Selecione uma opção",
      "CONFIRM": "Confirmar",
      "MALE": "Masculino",
      "FEMALE": "Feminino",
      "NON_BINARY": "Não binário/outros",
      "PREFER_NOT_TO_ANSWER": "Prefiro não responder",
      "NON_BINARY_MESSAGE": "Entendemos e respeitamos sua identidade de gênero não binária. Devido às limitações tecnológicas atuais, o padrão é usar pronomes masculinos. Saiba que estamos trabalhando em melhorias para acomodar melhor todas as identidades de gênero no futuro. Agradecemos sua compreensão e paciência.",
      "PREFER_NOT_TO_ANSWER_MESSAGE": "Respeitamos sua opção de não fornecer um gênero. Nesses casos, nossa tecnologia tem como padrão o uso de pronomes masculinos devido às limitações atuais.",
      "DISPLAY_VISUAL_AID": "Exibir auxílio visual",
      "FULL_SCREEN": "Tela cheia",
      "COLLAPSE": "Recolher",
      "COMPLETED_CONVERSATION_MESSAGE": "Obrigado por concluir esta conversa",
      "CONVERSATION_COMPLETION_FEEDBACK": "Deixe um feedback enquanto processamos sua conversa.",
      "ERROR_MESSAGE": "Ocorreu um erro. Entre em contato com",
      "SAVED_CONVERSATION_MESSAGE": "Sua conversa foi salva.",
      "RETURN_TO_MY_ASSIGNMENTS": "Voltar às minhas tarefas",
      "RETURN_TO_PERSONALIZED_PRACTICE": "Retornar à prática personalizada",
      "PERSONALIZED_CALL_NOTE": "Você acaba de concluir uma conversa de prática personalizada.",
      "LEAVE_STEP_TITLE": "Deseja mesmo sair desta etapa?",
      "EXIT": "Sair",
      "CERT_ACK_TITLE": "Confirmação do vídeo de certificação",
      "CERT_ACK_ACCEPT_AND_BEGIN": "Aceitar e começar",
      "CERT_ACK_RESUME_CALL": "Retomar a chamada",
      "CERT_ACK_PROCESSING": "Processando...",
      "CERT_ACK_CAMERA_WARNING": "Ative sua câmera para prosseguir com a certificação.",
      "CERT_ACK_CAMERA_OFF_DURING_CALL": "Sua câmera estava desligada. Reative sua câmera para retomar a certificação.",
      "CERT_ACK_TEXT_1": "Para garantir a integridade e a imparcialidade desta certificação, sua câmera deve permanecer ligada durante toda a sessão, que será monitorada. Este requisito visa confirmar a conformidade com todas as normas de certificação.",
      "CERT_ACK_TEXT_2": "Ao continuar, você reconhece e concorda com estes requisitos.",
      "CERT_ACK_END_CALL": "Encerrar chamada",
      "LAUNCH_SIMULATION": "Iniciar simulação",
      "DEBRIEF_LATEST_SESSION": "Analisar a última sessão",
      "RECONNECTING_AUDIO": "Reconectando o áudio...",
      "END": "Fim",
      "START_DEBRIEF": "Analisar a última sessão",
      "MOVE_TO_NEXT": "Avançar para a próxima etapa",
      "RETRY_ROLEPLAY": "Tentar a simulação de papéis novamente",
      "EXIT_PATHWAY": "Sair do caminho",
      "PROCESSING": "Processando...",
      "FEEDBACK_PROMPT_REQUIRED": "Deixe um feedback antes de ver seus resultados.",
      "MUTE": "Silenciar",
      "UNMUTE": "Ativar som",
      "SCREENSHARE_LABEL": "Compartilhar tela",
      "SCREENSHARE_UNSUPPORTED_TITLE": "{{callName}} está usando o recurso de compartilhamento de tela",
      "SCREENSHARE_UNSUPPORTED_MESSAGE_APP": "Para continuar com a chamada, use nosso aplicativo em vez do seu navegador.",
      "SCREENSHARE_UNSUPPORTED_MESSAGE_DESKTOP": "Para continuar com a chamada, acesse-a em um computador.",
      "SCREENSHARE_UNSUPPORTED_CLOSE_BUTTON": "Fechar",
      "SCREENSHARE_UNSUPPORTED_GO_TO_APP_BUTTON": "Acesse o aplicativo",
      "SCREENSHARE_UNSUPPORTED_GO_TO_APP_UNAVAILABLE": "O aplicativo móvel ainda não está disponível. Volte em breve.",
      "SCREENSHARE_STOP_LABEL": "Interromper o compartilhamento da tela",
      "SCREENSHARE_PIP_REOPEN_LABEL": "Reabrir a pré-visualização do vídeo",
      "SCREENSHARE_ACTIVE_LABEL": "Você está compartilhando a tela",
      "SCREENSHARE_OS_PERMISSION_HINT": "Não foi possível iniciar o compartilhamento de tela. Habilite a gravação de tela para o seu navegador em Configurações do sistema > Privacidade e segurança e tente novamente.",
      "SCREENSHARE_SAFARI_BLOCKED_HINT": "O Safari bloqueou o compartilhamento de tela para esta sessão. Saia e entre novamente, depois tente novamente."
    },
    "assignment": {
      "STATUS": "STATUS",
      "SCORE": "PONTUAÇÃO",
      "MUST_ACHIEVE": "Deve atingir",
      "OR_HIGHER": "ou mais",
      "TEST": "Teste",
      "OUT_OF_5": "de 5",
      "LATEST_ATTEMPT": "TENTATIVA MAIS RECENTE",
      "TOTAL_ATTEMPTS": "total de tentativas",
      "UNLIMITED": "Ilimitado",
      "REMAINING": "Restante",
      "VIEW_CALL_DETAILS": "Ver detalhes",
      "MAX_ATTEMPTS_REACHED": "Você atingiu o número máximo de tentativas",
      "DUE_DATE": "Prazo",
      "DAYS": "Dias",
      "DAY": "Dia",
      "UNTILL_DUE": "Até o prazo",
      "PAST_DUE": "Vencido",
      "ONGOING": "Em andamento",
      "SCORE_REQUIREMENT": "Requisito de pontuação",
      "SCORE_REQUIREMENT_DETAIL": "Você deve conseguir uma pontuação de",
      "TO_COMPLETE_EACH_CALL": "para concluir cada simulação necessária.",
      "CALLS_IN_ASSIGNMENT": "Simulações na tarefa",
      "INCOMPLETE_CALL": "Incompletas",
      "PREVIOUS_RESULTS": "Resultados anteriores",
      "DATE": "Data",
      "RESULTS": "Resultados",
      "VIEW_PREVIOUS_RESULTS": "Ver resultados anteriores",
      "VIEW_FEEDBACK": "Ver feedback",
      "LAUNCH_CALL": "Iniciar",
      "CLOSE_BUTTON": "Botão Fechar",
      "CHECKMARK": "marca de verificação",
      "CALL": "Chamada",
      "QUESTION": "Pergunta",
      "COMPLETED": "Concluída",
      "IN_PROGRESS": "Em andamento",
      "NOT_STARTED": "Não iniciada",
      "CERTIFIED": "Certificada",
      "GUIDED": "Guiada",
      "CONVERSATIONAL": "Conversacional",
      "GUIDED_SIMULATION": "Verificação de conhecimento",
      "CONVERSATIONAL_SIMULATION": "Simulação de papéis",
      "NO_ATTEMPTS_LEFT": "Nenhuma tentativa restante",
      "NO_ATTEMPTS": "Nenhuma tentativa",
      "OVERVIEW": "Visão geral",
      "ABOUT_THE_AVATAR": "Sobre o avatar",
      "SCORING_CRITERIA": "Critérios de pontuação",
      "SIMULATION_OVERVIEW": "Visão geral da simulação",
      "ABOUT_THE_PERSONA": "Sobre a persona",
      "OUTOF_COMPLIANCE": "Fora de conformidade",
      "CLOSED": "Fechada",
      "COMPLETED_CALLS": "Chamadas concluídas"
    }
  },
  "nl": {
    "root": {
      "ADMIN_PORTAL": "BEHEERPORTAAL",
      "SUPPORT": "SUPPORT",
      "U": "U",
      "USER": "Gebruiker",
      "LOGOUT": "Uitloggen",
      "ADMIN": "Beheer",
      "SUPPORT_SMALL": "Support",
      "QUANTIFIED_AI": "Quantified.AI",
      "MICROPHONE": "MICROFOON",
      "CAMERA": "CAMERA",
      "ACCESS_DENIED": "TOEGANG GEWEIGERD"
    },
    "teams": {
      "MY_TEAMS": "Mijn teams",
      "COMPLETED": "Voltooid",
      "IN_PROGRESS": "In uitvoering",
      "NOT_STARTED": "Nog niet gestart",
      "ASSIGNMET_MODULE": "Opdrachtmodule",
      "START_DATE": "Startdatum",
      "DUE_DATE": "Uiterste datum",
      "ASSIGNED_MEMBERS": "Toegewezen leden",
      "CALLS_IN_MODULE": "Simulaties in de module",
      "COMPLETION_REQUIRMENT": "Vereist om te voltooien",
      "COMPLETE_ALL_CALLS": "Voltooi alle simulaties met een score van",
      "OR_HIGHER": "of hoger",
      "PROGRESS_OVERVIEW": "VOORTGANGSOVERZICHT",
      "TEAM_MEMBERS": "teamleden",
      "AVERAGE_HIGH_SCORE": "Gemiddelde hoogste score",
      "AVERAGE_NUMBER_ATTEMPTS_CALL": "Gemiddeld aantal pogingen per simulatie",
      "TOTAL_PRACTICES": "Totaal aantal oefeningen",
      "INDIVIDUAL_CALL_PROGRESS": "VOORTGANG PER SIMULATIE",
      "OF_TEAM_MEMBERS": "van de teamleden heeft voltooid",
      "AVERAGE_PRACTICES_TO_COMPLETION": "Gemiddeld aantal oefeningen tot voltooiing",
      "TEAM_MEMBER_DETAILS": "GEGEVENS TEAMLEDEN",
      "DOWNLOAD_ACTIVITY_REPORT": "Activiteitenrapport downloaden",
      "TEAM_MEMBER": "Teamlid",
      "PROGRESS": "Voortgang",
      "CALLS_COMPLETED": "Voltooide simulaties",
      "PRACTICES": "Oefensessies",
      "MOST_RECENT_PRACTICE": "Meest recente sessie",
      "THIS_TEAM_HAS_NO_ACTIVE_ASSIGNMENTS": "Dit team heeft nu geen actieve opdrachten",
      "CALL_NAME_LABEL": "Simulatienaam",
      "HIGHEST_SCORE": "Hoogste score"
    },
    "simulationBuilder": {
      "THRESHOLD": "Drempelwaarde",
      "TYPE": "Type",
      "SELECT_AN_OPTION": "Kies een optie",
      "CORRECT_FEEDBACK": "Feedback bij juist antwoord",
      "INCORRECT_FEEDBACK": "Feedback bij onjuist antwoord",
      "CORRECT_FEEDBACK_PLACEHOLDER": "Wordt getoond als de cursist dit goed heeft",
      "INCORRECT_FEEDBACK_PLACEHOLDER": "Wordt getoond als de cursist dit fout heeft",
      "MESSAGE_NUMBER": "Boodschap {{ index }}",
      "ENTER_MESSAGE_TEXT": "Voer de tekst van de boodschap in ...",
      "FACT_MESSAGE_LABEL": "Boodschap",
      "FACT_MESSAGE_DESCRIPTION": "Een boodschap moet één stukje informatie zijn, geschreven als een volledige zin. Houd het specifiek, eenvoudig en beperkt van omvang. Vermijd boodschappen die iemand maar half kan verwoorden.",
      "FACT_INCORRECT_ANSWER_LABEL": "Tekst bij onjuist antwoord",
      "FACT_INCORRECT_ANSWER_DESCRIPTION": "De tekst die de cursist ziet bij een fout antwoord op dit feit",
      "SHOW_INCORRECT_ANSWER_TEXT": "Alternatieve tekst tonen bij onjuiste antwoorden",
      "ADD_NEW_FACT": "Nieuw feit toevoegen",
      "FACT_SINGULAR": "feit",
      "FACT_PLURAL": "feiten",
      "FACT_EXTRACTED_SINGULAR": "{{ count }} feit geëxtraheerd",
      "FACT_EXTRACTED_PLURAL": "{{ count }} feiten geëxtraheerd",
      "FACTS_CANNOT_BE_EMPTY": "Feiten mogen niet leeg zijn. Voeg een boodschap toe aan elk feit voordat je test of publiceert.",
      "REVIEW_REQUIRED_LABEL": "Controle aanbevolen",
      "DELETE": "Verwijderen",
      "SCORABLE": "Beoordeelbaar",
      "SEARCH_BY_SIMULATION_NAME": "Zoeken op simulatienaam",
      "SIMULATION_STATUS_PLACEHOLDER": "Simulatiestatus",
      "SIMULATION_STATUS_PREFIX": "Simulatiestatus:",
      "NO_SIMULATIONS_FOUND": "Geen simulaties gevonden",
      "SELECT_ALL": "Alles selecteren",
      "DESELECT_ALL": "Alles deselecteren",
      "STATUS_TESTING": "In test",
      "STATUS_DRAFT": "Concept",
      "STATUS_PUBLISHED": "Gepubliceerd",
      "STATUS_ARCHIVED": "Gearchiveerd",
      "SEARCH_BY_ASSIGNMENT_NAME": "Zoeken op opdrachtnaam",
      "ASSIGNEES_ZERO_STATE_MESSAGE": "Er zijn nog geen gebruikers toegewezen",
      "ADD_USERS_TO_ASSIGNMENT": "Gebruikers aan opdracht toevoegen",
      "NO_DATA_FOUND": "Geen gegevens gevonden",
      "NO_USERS_SELECTED": "Geen gebruiker geselecteerd",
      "COL_FIRST_NAME": "Voornaam",
      "COL_LAST_NAME": "Achternaam",
      "COL_EMAIL": "E-mail",
      "COL_VIEW_USER": "Gebruiker bekijken",
      "COL_VIEW_ASSIGNMENT": "Opdracht bekijken",
      "COL_ASSIGNMENT_NAME": "Opdrachtnaam",
      "COL_STATUS": "Status",
      "COL_TEAM_ASSOCIATIONS": "Teamkoppelingen",
      "COL_REPORTING_STATUS": "Rapportagestatus",
      "BREADCRUMB_USERS": "Gebruikers",
      "STATUS_STAGED": "In voorbereiding",
      "STATUS_ACTIVE": "Actief",
      "STATUS_ENDED": "Beëindigd",
      "STATUS_CLOSED": "Gesloten",
      "SEARCH_USERS_PLACEHOLDER": "Gebruikers zoeken",
      "NO_USERS_FOUND": "Geen gebruikers gevonden",
      "USERS_TAB_LABEL": "Gebruikers",
      "ADD_TO_ASSIGNMENT": "Toevoegen aan opdracht",
      "ASSIGNMENTS_COUNT": "opdrachten",
      "REPORTING_EXCLUDED": "Uitgesloten",
      "REPORTING_INCLUDED": "Opgenomen",
      "KEBAB_EDIT_TEAM_ASSOCIATIONS": "Teamkoppelingen bewerken",
      "KEBAB_EXCLUDE_FROM_REPORTING": "Uitsluiten van rapportage",
      "KEBAB_INCLUDE_IN_REPORTING": "Opnemen in rapportage",
      "KEBAB_REMOVE_FROM_ASSIGNMENT": "Uit opdracht verwijderen",
      "NO_TEAMS": "-",
      "TEAMS_COUNT": "{{ count }} teams",
      "ADD_TO_ASSIGNMENT_MODAL_HEADING": "Toevoegen aan opdracht",
      "FIELD_LABEL_ASSIGNMENT": "Opdracht",
      "SEARCH_ASSIGNMENTS_PLACEHOLDER": "Zoeken naar opdrachten",
      "BUTTON_SET_TEAM_ASSOCIATION": "Teamkoppeling instellen",
      "FIELD_LABEL_TEAM": "Team",
      "SEARCH_TEAM_PLACEHOLDER": "Team zoeken",
      "BUTTON_BACK": "Terug",
      "BUTTON_CANCEL": "Annuleren",
      "BUTTON_ADD_TO_ASSIGNMENT": "Toevoegen aan opdracht",
      "EDIT_TEAM_ASSOCIATIONS_HEADING": "Teamkoppelingen bewerken",
      "EDIT_TEAM_ASSOCIATIONS_DESCRIPTION": "Voor de opdracht {{ assignmentName }}",
      "BUTTON_SAVE_ASSOCIATIONS": "Koppelingen opslaan",
      "REFERENCE_DOCUMENT_STATUS_UPLOADING": "- Bezig met uploaden ...",
      "REFERENCE_DOCUMENT_STATUS_SUCCESS": "- 100% geüpload",
      "REFERENCE_DOCUMENT_STATUS_ERROR": "- Fout bij uploaden",
      "REFERENCE_DOCUMENT_STATUS_DELETING": "- Bezig met verwijderen",
      "REFERENCE_DOCUMENT_DELETE_ERROR": "We konden het document niet verwijderen. Probeer het nog eens.",
      "REFERENCE_DOCUMENT_UPLOAD_ERROR": "We konden het document niet uploaden. Probeer het nog eens.",
      "CONTENT_LIMIT_EXCEEDED_ERROR": "Je zit boven de limiet voor inhoud. Verwijder een of meer documenten om door te gaan.",
      "LAST_FACT_DELETE_WARNING_HEADING": "Het laatste feit verwijderen?",
      "LAST_FACT_DELETE_WARNING_DESCRIPTION": "Als je het laatste feit verwijdert, verdwijnen ook alle gebruikerskoppelingen met deze simulatie en gaat de status terug naar Concept.",
      "LEAVE_CONFIRMATION_HEADING": "Aanmaken van simulatie verlaten",
      "LEAVE_CONFIRMATION_DESCRIPTION": "Weet je zeker dat je wilt stoppen? Je voortgang gaat dan verloren.",
      "LEAVE_CONFIRMATION_LEAVE_BUTTON": "Verlaten",
      "CREATE_SIMULATION_DETAILS_BUTTON": "Simulatiegegevens aanmaken",
      "SELF_AUTHORING_DESCRIPTION": "Geef om te beginnen een naam, een korte beschrijving van het scenario en eventueel documenten voor de simulatie op",
      "CLICK_TO_UPLOAD": "Klik om te uploaden",
      "OR_DRAG_AND_DROP": "of sleep het bestand hierheen",
      "REFERENCE_DOCUMENTS_UPLOAD_DESCRIPTION": "Pdf (max. 50 MB)",
      "ASSIGNMENT_NAME_LABEL": "Opdrachtnaam *",
      "SIMULATION_NAME_LABEL": "Simulatienaam",
      "NAME_FIELD_DESCRIPTION": "Je kunt deze naam later wijzigen",
      "PRODUCT_LABEL": "Product",
      "SELECT_A_PRODUCT_PLACEHOLDER": "Selecteer een product",
      "ADD_NEW_PRODUCT": "Nieuw product toevoegen",
      "TAGS_LABEL": "Tags",
      "CREATE_TAG_OPTION": "{{term}} aanmaken",
      "TAG_CREATE_ERROR": "We konden de tag niet aanmaken. Probeer het opnieuw",
      "EDIT_SIMULATION_TAGS_TITLE": "Simulatietags bewerken",
      "SAVE_TAGS_BUTTON": "Tags opslaan",
      "CLOSE_BUTTON": "Sluiten",
      "TAG_UPDATE_ERROR": "We konden de tag niet bijwerken. Probeer het opnieuw",
      "SCENARIO_LABEL": "Scenario",
      "REFERENCE_DOCUMENTS_LABEL": "Referentiedocumenten",
      "ACTION_CREATE_NEW": "Nieuw aanmaken",
      "ACTION_CREATE": "Aanmaken",
      "ACTION_DUPLICATE": "Dupliceren",
      "ENTITY_TYPE_SIMULATION_DISPLAY": "Simulatie",
      "ENTITY_TYPE_ASSIGNMENT_DISPLAY": "Opdracht",
      "ENTITY_TYPE_SIMULATION_LOWER": "simulatie",
      "ENTITY_TYPE_ASSIGNMENT_LOWER": "opdracht",
      "MODAL_TITLE": "{{ action }} {{ type }}",
      "CONFIRM_BUTTON_LABEL": "{{ action }} {{ type }}",
      "DUPLICATE_NAME_ERROR_ASSIGNMENT": "Er bestaat al een opdracht met dezelfde naam.",
      "DUPLICATE_NAME_ERROR_SIMULATION": "Er bestaat al een simulatie met dezelfde naam.",
      "NAME_REQUIRED_ERROR": "Naam is verplicht.",
      "COPY_OF_PREFIX": "Kopie van - {{ name }}",
      "SCORE_DISTRIBUTION_TITLE": "Huidige scoreverdeling",
      "EDIT_SECTIONS_AND_WEIGHTING": "Secties en weging bewerken",
      "SCORING_WEIGHTS_TITLE": "Beoordeling instellen",
      "SCORING_WEIGHTS_DESCRIPTION": "Kies welke secties meetellen en hoeveel elke sectie bijdraagt aan de totaalscore. De gewichten van alle ingeschakelde secties moeten samen 100% zijn. De sectie Vaardigheden mag niet zwaarder wegen dan 20%.",
      "SCORING_WEIGHT_REQUIRED": "Verplicht",
      "SCORE_LAST_SESSION": "Mijn laatste sessie beoordelen",
      "SCORE_LAST_SESSION_MODAL_HEADING": "Laatste sessie beoordelen",
      "SCORE_LAST_SESSION_MODAL_DESCRIPTION": "Test eerst de simulatie en kom dan hier terug om ze te beoordelen met de geselecteerde rubric.",
      "SCORE_LAST_SESSION_MODAL_ERROR_HEADING": "Er is iets misgegaan",
      "SCORE_LAST_SESSION_MODAL_ERROR_DESCRIPTION": "Probeer het nog eens.",
      "MESSAGING_TITLE": "Boodschappen",
      "MESSAGING_SUBTITLE": "Beoordeel of de belangrijkste feiten worden overgebracht",
      "METHODOLOGY_TITLE": "Methodologie",
      "METHODOLOGY_SUBTITLE": "Beoordeel de aanpak en structuur van het gesprek",
      "METHODOLOGY_WEIGHTING_LABEL": "Weging: {{ weight }}%",
      "METHODOLOGY_RUBRIC_LABEL": "Rubric methodologie",
      "SELECT_RUBRIC_PLACEHOLDER": "Rubric selecteren",
      "SKILLS_TITLE": "Vaardigheden",
      "SKILLS_SUBTITLE": "Beoordeel communicatie en sociale vaardigheden",
      "SKILLS_WEIGHTING_LABEL": "Weging: {{ weight }}%",
      "SKILLS_RUBRIC_LABEL": "Rubric vaardigheden",
      "ACCURACY_FEEDBACK_TITLE": "Feedback op juistheid",
      "ACCURACY_FEEDBACK_DESCRIPTION": "Beoordeel elke uitspraak van de verkoper op juistheid aan de hand van de geüploade documenten",
      "ACCURACY_FEEDBACK_STATUS_ON": "Ingeschakeld",
      "ACCURACY_FEEDBACK_STATUS_OFF": "Uit",
      "ACCURACY_FEEDBACK_STATUS_DISABLED": "Uitgeschakeld",
      "ACCURACY_FEEDBACK_NO_DOCUMENTS": "We kunnen de juistheid niet beoordelen, want er zijn geen bijbehorende documenten toegevoegd.",
      "SCREEN_SHARE_TITLE": "Scherm delen",
      "SCREEN_SHARE_DESCRIPTION": "Zo kan de gebruiker tijdens het gesprek het scherm delen met de avatar, zodat die kan zien wat er te zien is en erop kan reageren",
      "SCREEN_SHARE_STATUS_ON": "Ingeschakeld",
      "SCREEN_SHARE_STATUS_OFF": "Uitgeschakeld",
      "SCREEN_SHARE_NO_PERSONA": "Voeg eerst een persona toe om scherm delen in te schakelen.",
      "SCORING_AI_REVIEW_NOTICE": "Een deel van de inhoud op dit tabblad komt uit het materiaal dat je hebt aangeleverd. Controleer alle inhoud op juistheid voordat je dit gesprek publiceert.",
      "PROCESSING_DOCUMENTS_MESSAGE": "Documenten worden verwerkt ...",
      "PROCESSING_DOCUMENTS_SUPPORTING_TEXT": "Je kunt gerust even iets anders doen: de resultaten zijn binnen 5 minuten klaar.",
      "CORE_SIGNAL_MESSAGE": "We interpreteren je inhoud ...",
      "SECTION_PLAN_MESSAGE": "We plannen de structuur van je simulatie ...",
      "DERIVED_COMPONENT_MESSAGE": "We stellen de onderdelen van je simulatie samen ...",
      "COMPONENT_WAVE_1_MESSAGE": "We schrijven de inhoud van je simulatie ...",
      "COMPONENT_WAVE_2_MESSAGE": "We verfijnen de inhoud van je simulatie ...",
      "COMPONENT_WAVE_3_MESSAGE": "We ronden de inhoud van je simulatie af ...",
      "MESSAGE_ADHERENCE_MESSAGE": "We stellen scorecriteria voor boodschappen voor ...",
      "ASSEMBLING_MESSAGE": "We stellen je simulatie samen ...",
      "FINISHING_SIMULATION_MESSAGE": "We ronden je simulatie af ...",
      "STILL_PROCESSING_TITLE": "Nog bezig met verwerken ...",
      "STILL_PROCESSING_BODY": "Dit duurt langer dan normaal. Je kunt deze simulatie verlaten en er later naar terugkeren via de lijst met simulaties.",
      "PROCESSING_FAILED_TITLE": "Verwerking mislukt",
      "PROCESSING_FAILED_BODY": "Er is iets misgegaan bij het verwerken van je documenten. Probeer het opnieuw. Neem contact op met ",
      "PROCESSING_FAILED_SUFFIX": " als het probleem zich blijft voordoen.",
      "BUTTON_RETRY": "Opnieuw proberen",
      "TOKEN_LIMIT_EXCEEDED_BODY_PREFIX": "Je zit boven de limiet voor inhoud. Verwijder een of meer documenten en probeer het opnieuw, of neem contact op met ",
      "TOKEN_LIMIT_EXCEEDED_BODY_SUFFIX": " als het probleem zich blijft voordoen.",
      "TEST_SIMULATION_BUTTON": "Simulatie testen",
      "EXPORT_SIMULATION_SUMMARY_BUTTON": "Simulatieoverzicht exporteren",
      "SIMULATION_PROCESSED_TITLE": "Verwerkte documenten",
      "SIMULATION_PROCESSED_BODY": "De documenten van je simulatie zijn verwerkt.",
      "SIMULATION_DOCUMENTS_PROCESSED_TITLE": "Simulatiedocumenten verwerkt.",
      "SIMULATION_DOCUMENTS_PROCESSED_BODY": "De documenten die je hebt geüpload voor de simulatie {{ name }} zijn verwerkt.",
      "SIMULATION_DOCUMENTS_FAILED_TITLE": "We konden de documenten voor de simulatie niet verwerken.",
      "SIMULATION_DOCUMENTS_FAILED_BODY": "We konden de documenten die je voor de simulatie {{ name }} hebt geüpload, niet verwerken.",
      "DISMISS": "Sluiten",
      "VIEW_SIMULATION": "Simulatie bekijken",
      "AVATAR_LOOK_LABEL": "Uiterlijk",
      "AVATAR_SELECT_PLACEHOLDER": "Avatar selecteren",
      "AVATAR_VOICE_LABEL": "Stem",
      "AVATAR_ALT": "Avatar",
      "PLAY_VOICE_PREVIEW_BUTTON": "Voorbeeld van de stem afspelen",
      "VOICE_OPTION_1": "Stem 1",
      "VOICE_OPTION_2": "Stem 2",
      "BACK_TO_SIMULATION_DETAILS_BUTTON": "Terug naar simulatiedetails",
      "AVATAR_SELECTION_TITLE": "Avatar selecteren",
      "VIEW_DOCUMENTS": "Documenten bekijken",
      "SELECT_AVATAR_BUTTON": "Avatar selecteren",
      "REQUEST_CHANGES_PLACEHOLDER": "Wijzigingen in de bovenstaande informatie aanvragen",
      "CALL_DETAILS_LOAD_ERROR": "We konden je gespreksgegevens niet laden. Probeer het nog eens.",
      "CALL": "Gesprek",
      "REFINEMENT_THINKING_MESSAGE": "Bezig met nadenken ...",
      "REFINEMENT_UPDATED_MESSAGE": "Bijgewerkt",
      "REFINEMENT_WARNING_PREFIX": "Deze informatie is handmatig overschreven. Neem contact op met",
      "REFINEMENT_WARNING_SUFFIX": "als je iets wilt laten bijwerken.",
      "REFINEMENT_OVERRIDDEN_PREFIX": "Deze informatie is handmatig overschreven. Neem contact op met",
      "REFINEMENT_OVERRIDDEN_SUFFIX": "als je iets wilt laten bijwerken.",
      "SUPPORT_EMAIL": "help@quantified.ai",
      "REFINEMENT_ERROR_PREFIX": "Helaas kan ik je daar niet bij helpen, maar",
      "REFINEMENT_ERROR_SUFFIX": "misschien wel.",
      "REFINEMENT_APPLIED_TITLE": "De gevraagde wijzigingen zijn doorgevoerd.",
      "REFINEMENT_APPLIED_BODY": "De wijzigingen die je hebt aangevraagd voor de simulatie {{ name }} zijn doorgevoerd.",
      "REFINEMENT_FAILED_TITLE": "De gevraagde wijzigingen zijn mislukt.",
      "REFINEMENT_FAILED_BODY": "We konden de wijzigingen die je hebt aangevraagd voor de simulatie {{ name }} niet doorvoeren.",
      "BLANK_THEME_MESSAGE_TOOLTIP": "Voeg tekst toe aan de lege boodschap voordat je een nieuw thema toevoegt.",
      "BLANK_MESSAGE_TOOLTIP": "Voeg tekst toe aan deze boodschap voordat je er nog een toevoegt.",
      "ADD_NEW_THEME_BUTTON": "Nieuw thema toevoegen",
      "ADD_THEME_BUTTON": "Thema toevoegen",
      "ADD_MESSAGE_BUTTON": "Boodschap toevoegen",
      "WHAT_USERS_SEE_DESCRIPTION_TITLE": "Simulatiebeschrijving",
      "WHAT_USERS_SEE_DESCRIPTION_HELPER": "Wat je op het tabblad 'Algemeen' bijwerkt, verschijnt hier, tenzij je hier zelf iets aanpast.",
      "WHAT_USERS_SEE_DESCRIPTION_FIELD_LABEL": "Beschrijving",
      "WHAT_USERS_SEE_DETAILS_TITLE": "Simulatiedetails",
      "WHAT_USERS_SEE_DETAILS_HELPER": "Dit is de inhoud die de gebruiker ziet voordat de simulatie begint. Wat je op het tabblad 'Algemeen' bijwerkt, verschijnt hier, tenzij je hier zelf iets aanpast. De cursist ziet geen secties die leeg blijven. Alle secties ondersteunen Markdown-opmaak.",
      "WHAT_USERS_SEE_OVERVIEW_FIELD_LABEL": "Overzicht van de simulatie",
      "WHAT_USERS_SEE_PERSONA_FIELD_LABEL": "Over de persona",
      "WHAT_USERS_SEE_SCORING_FIELD_LABEL": "Beoordelingscriteria",
      "WHAT_USERS_SEE_SCORING_FIELD_HELPER": "Deze sectie vult zich op basis van je keuzes op het tabblad 'Beoordeling'. Als je de informatie hier bewerkt, verandert er niets aan hoe de simulatie wordt beoordeeld.",
      "WHAT_USERS_SEE_PREVIEW_DETAILS_CTA": "Voorbeeld van venster met simulatiedetails",
      "WHAT_USERS_SEE_PREVIEW_CARD_CTA": "Voorbeeld van de simulatiekaart",
      "WHAT_USERS_SEE_OVERRIDE_WARNING_TITLE": "Het bewerken van deze velden blokkeert toekomstige updates",
      "WHAT_USERS_SEE_OVERRIDE_WARNING_BODY": "Als je deze secties handmatig bijwerkt, krijgen ze geen updates meer van het verfijningsproces op het tabblad 'Algemeen'.",
      "WHAT_USERS_SEE_DETAILS_OVERRIDE_EDITED_TITLE": "Deze velden zijn bewerkt",
      "WHAT_USERS_SEE_DETAILS_OVERRIDE_EDITED_BODY": "Ze krijgen geen verfijningsupdates meer via het tabblad 'Algemeen'",
      "TAB_GENERAL": "Algemeen",
      "TAB_CONTENTS": "Inhoud",
      "TAB_KEY_WORDS": "Trefwoorden",
      "TAB_SCORING": "Beoordeling",
      "TAB_TESTING": "In test",
      "TAB_PROMPTS": "Prompts",
      "TAB_WHAT_USERS_SEE": "Wat gebruikers zien",
      "SIMULATION_BUILDER_HEADING": "Simulatiebouwer",
      "ASSIGNMENTS_TAB_LABEL": "Opdrachten",
      "SIMULATIONS_TAB_LABEL": "Simulaties",
      "CREATE_NEW_ASSIGNMENT_BUTTON": "Nieuwe opdracht aanmaken",
      "CREATE_NEW_SIMULATION_BUTTON": "Nieuwe simulatie aanmaken",
      "NO_ASSIGNMENTS_FOUND": "Geen opdrachten gevonden",
      "ASSIGNMENT_STATUS_PLACEHOLDER": "Opdrachtstatus",
      "ASSIGNMENT_STATUS_PREFIX": "Opdrachtstatus:",
      "ASSIGNMENT_TYPE_LABEL": "Type opdracht",
      "SELECT_ASSIGNMENT_TYPE_PLACEHOLDER": "Selecteer het type opdracht",
      "NAME_LABEL": "Naam",
      "ASSIGNMENT_NAME_PLACEHOLDER": "Opdrachtnaam",
      "PASSING_SCORE_LABEL": "Minimale score",
      "PASSING_SCORE_OPTIONAL_LABEL": "Minimale score (optioneel)",
      "SCORE_MAX_EXCEEDED_ERROR": "De score mag niet hoger zijn dan 5",
      "GET_HELP_BUTTON": "Hulp vragen",
      "PASSING_SCORE_TOOLTIP": "Hiermee stel je de totaalscore in die een cursist moet behalen om voor de simulatie te slagen.",
      "DESCRIPTION_LABEL": "Beschrijving",
      "ASSIGNMENT_DESCRIPTION_PLACEHOLDER": "Opdrachtbeschrijving",
      "MESSAGING_FEEDBACK_LABEL": "Feedback op boodschappen",
      "MESSAGING_FEEDBACK_TOOLTIP_HEADING": "Feedback op boodschappen",
      "MESSAGING_FEEDBACK_TOOLTIP_BODY": "Als een cursist een boodschap verkeerd verwoordt, krijgt die informatie over hoe het de volgende keer beter kan. Met deze instelling bepaal je of de cursist die informatie ziet.",
      "ENABLED_TEXT": "Ingeschakeld",
      "DISABLED_TEXT": "Uitgeschakeld",
      "PAUSE_BUTTON_LABEL": "Pauzeknop",
      "HIDE_RESULTS_LABEL": "Resultaten verbergen",
      "ASSIGNMENT_START_DATE_LABEL": "Startdatum van de opdracht",
      "SELECT_DATE_PLACEHOLDER": "Datum selecteren",
      "ASSIGNMENT_END_DATE_LABEL": "Einddatum van de opdracht",
      "ASSIGNMENT_END_DATE_OPTIONAL_LABEL": "Einddatum van de opdracht (optioneel)",
      "END_DATE_RANGE_ERROR": "De start- en einddatum mogen niet gelijk zijn",
      "ASSIGNMENT_INFORMATION_TITLE": "Opdrachtgegevens",
      "ASSIGNMENT_TYPE_CERTIFICATION": "Certificering",
      "ASSIGNMENT_TYPE_PRACTICE": "Oefenen",
      "ASSIGNMENT_TYPE_PERSONALIZED_PRACTICE": "Oefenen op maat",
      "BUTTON_SAVE_AND_CLOSE": "Opslaan en sluiten",
      "BUTTON_ADD_SIMULATIONS": "Simulaties toevoegen",
      "ATTEMPTS_UNLIMITED": "Onbeperkt",
      "SEARCH_FOR_SIMULATION_LABEL": "Simulatie zoeken",
      "SIMULATION_NAME_PLACEHOLDER": "Simulatienaam",
      "BUTTON_REMOVE_ALL": "Alles verwijderen",
      "SIMULATIONS_IN_ASSIGNMENT_LABEL": "Simulaties in de opdracht",
      "BUTTON_ASSIGN_LEARNERS": "Cursisten toewijzen",
      "CALL_TYPE_UNKNOWN": "Onbekend",
      "ASSIGNMENT_COUNT_NONE": "Geen",
      "ASSIGNMENT_COUNT_SINGULAR": "{{ count }} opdracht",
      "ASSIGNMENT_COUNT_PLURAL": "{{ count }} opdrachten",
      "ERROR_LOADING_ASSIGNMENTS": "Fout bij het laden van opdrachten",
      "SEARCH_ASSIGNEES_TITLE": "Toegewezen gebruikers zoeken",
      "DIALOG_DESCRIPTION_ADD_USERS": "Selecteer de gebruikers die aan de opdracht deelnemen. Als je naar een team zoekt, kun je specifieke gebruikers van dat team toewijzen of hun toewijzing ongedaan maken. Zorg er bij het selecteren van een specifieke gebruiker voor dat die aan het juiste team gekoppeld is voor de rapportage.",
      "SEARCH_FIELD_HINT": "Typ minstens drie tekens om te zoeken",
      "ADD_USERS_TO_ASSIGNMENT_HEADING": "Gebruikers aan de opdracht toevoegen",
      "BUTTON_REVIEW_SELECTED_USERS": "Geselecteerde gebruikers controleren",
      "FIND_USERS_LABEL": "Gebruikers zoeken",
      "BUTTON_CLEAR": "Wissen",
      "LEARNER_COUNT_NONE": "Geen",
      "LEARNER_COUNT_SINGULAR": "{{ count }} cursist",
      "LEARNER_COUNT_PLURAL": "{{ count }} cursisten",
      "ASSIGNMENT_TAB_DETAILS": "Details",
      "ASSIGNMENT_TAB_SIMULATIONS": "Simulaties",
      "ASSIGNMENT_TAB_ASSIGNEES": "Toegewezen gebruikers",
      "LOADING_ASSIGNMENT_DETAILS": "Opdrachtdetails worden geladen ...",
      "BREADCRUMB_ASSIGNMENTS": "Opdrachten",
      "ASSIGNMENTS_COL_NAME": "Naam",
      "ASSIGNMENTS_COL_START_DATE": "Startdatum van de opdracht",
      "ASSIGNMENTS_COL_END_DATE": "Einddatum van de opdracht",
      "ASSIGNMENTS_COL_LEARNERS": "Cursist toegewezen",
      "ASSIGNMENTS_COL_TYPE": "Type opdracht",
      "ASSIGNMENTS_COL_STATUS": "Opdrachtstatus",
      "SIMULATIONS_COL_NAME": "Naam",
      "SIMULATIONS_COL_PRODUCT": "Product",
      "SIMULATIONS_COL_DATE_MODIFIED": "Laatst gewijzigd op",
      "SIMULATIONS_COL_STATUS": "Status",
      "SIMULATIONS_COL_USED_IN": "Gebruikt in",
      "SIMULATIONS_COL_TYPE": "Type simulatie",
      "SIMULATIONS_COL_DATE_PUBLISHED": "Publicatiedatum",
      "CONVERSE_PROMPT_LABEL": "Converse-prompt",
      "CONVERSE_PROMPT_EXPAND_TO_EDIT": "Uitvouwen om te bewerken",
      "CONVERSE_PROMPT_ENTER_LABEL": "Voer hier de converse-prompt in *",
      "CONVERSE_PROMPT_EDITING_HEADING": "Converse-prompt bewerken",
      "CONVERSE_PROMPT_OVERRIDE_CONFIRMATION_HEADING": "Bevestiging van het overschrijven van de prompt",
      "CONVERSE_PROMPT_OVERRIDE_DESCRIPTION": "Weet je zeker dat je de converse-prompt wilt overschrijven? Auteurs verliezen de toegang tot zelfstandig verfijnen als je deze overschrijft.",
      "CONVERSE_PROMPT_FIELD_LABEL": "Converse-prompt",
      "CONVERSE_PROMPT_SAVE_BUTTON": "Prompt opslaan",
      "BUTTON_CONFIRM": "Bevestigen",
      "DELETE_SIM_HEADING": "Simulatie verwijderen",
      "DELETE_SIM_CONTENT": "Hiermee verwijder je deze simulatie. Ook de testopdrachten die aan de simulatie gekoppeld zijn, verdwijnen.",
      "DELETE_SIM_LABEL": "Simulatie verwijderen",
      "DELETE_ASSIGNMENT_HEADING": "Opdracht verwijderen",
      "DELETE_ASSIGNMENT_CONTENT": "Hiermee verwijder je deze opdracht definitief.",
      "DELETE_ASSIGNMENT_LABEL": "Opdracht verwijderen",
      "DELETE_ASSIGNMENT_NON_STAGED_CONTENT": "Om een opdracht met de status 'Actief' of 'Beëindigd' te verwijderen, neem je contact op met het CX-team. Bedankt.",
      "REMOVE_FROM_ASSIGNMENT_HEADING": "Uit opdracht verwijderen",
      "REMOVE_FROM_ASSIGNMENT_CONTENT": "Hiermee verwijder je de gebruiker uit de opdracht en uit alle bijbehorende teamkoppelingen.",
      "REMOVE_FROM_ASSIGNMENT_LABEL": "Uit opdracht verwijderen",
      "PUBLISH_SIMULATION_HEADING": "Simulatie publiceren",
      "PUBLISH_CONTINUE_EDITING": "Doorgaan met bewerken",
      "PUBLISH_BUTTON": "Publiceren",
      "PUBLISH_SIMULATION_DESCRIPTION": "Je kunt het rollenspel dan aan opdrachten toevoegen, maar je kunt de informatie over persona, beoordeling en prompts niet meer bewerken.",
      "CONFIRMATION_SELECTED_USERS_HEADING": "Geselecteerde gebruikers",
      "CONFIRMATION_TOTAL_COUNT": "{{ count }} totaal",
      "CONFIRMATION_CREATE_HEADING": "Nieuwe opdracht aanmaken",
      "CONFIRMATION_ADD_USERS_HEADING": "Gebruikers aan de opdracht toevoegen",
      "CONFIRMATION_SAVE_ASSIGNMENT_BTN": "Opdracht opslaan",
      "CONFIRMATION_REMOVE_USER": "Verwijderen",
      "EDIT_WEIGHTING_HEADING": "Weging van de beoordeling bewerken",
      "EDIT_WEIGHTING_DESCRIPTION": "De totaalscore is het gewogen gemiddelde van de volgende secties. De gewichten van alle ingeschakelde secties moeten samen 100% zijn. De sectie Vaardigheden mag niet zwaarder wegen dan 20%.",
      "EDIT_WEIGHTING_ERROR_ALL_DISABLED": "Schakel minstens één beoordelingsactie in",
      "EDIT_WEIGHTING_ERROR_WEIGHT_RANGE": "De weging van een sectie moet tussen 0 en 100 liggen",
      "EDIT_WEIGHTING_ERROR_SKILLS_MAX": "De sectie Vaardigheden mag niet zwaarder wegen dan 20%",
      "EDIT_WEIGHTING_ERROR_TOTAL": "Het totale gewicht van de secties moet 100% zijn",
      "PERSONA_INFORMATION_TITLE": "Persona-informatie",
      "PERSONA_AVATAR_LABEL": "Avatar *",
      "PERSONA_NAME_LABEL": "Naam *",
      "PERSONA_INITIAL_GREETINGS_LABEL": "Openingsbegroetingen *",
      "PERSONA_INITIAL_GREETINGS_DESCRIPTION": "De persona begint de simulatie met een van deze begroetingen. Je kunt maximaal 5 opties instellen.",
      "PERSONA_ADD_GREETING_OPTION": "Begroetingsoptie toevoegen",
      "PERSONA_RESUME_MESSAGE_LABEL": "Bericht bij hervatten",
      "PERSONA_RESUME_MESSAGE_DESCRIPTION": "Wanneer een cursist een simulatie na een pauze hervat, begint de persona met een van deze begroetingen. Je kunt maximaal 5 opties instellen.",
      "PERSONA_ADD_MESSAGE_OPTION": "Berichtoptie toevoegen",
      "PERSONA_UPLOADING": "Bezig met uploaden ...",
      "PERSONA_DELETING": "Bezig met verwijderen ...",
      "PERSONA_CUSTOM_BG_PREVIEW_ALT": "Voorbeeld aangepaste achtergrond",
      "PERSONA_AVATAR_THUMBNAIL_ALT": "Miniatuur van avatar",
      "PERSONA_AVATAR_WITH_BG_ALT": "Avatar met aangepaste achtergrond",
      "PERSONA_PROCESSING_IMAGE": "Afbeelding wordt verwerkt ...",
      "PERSONA_CUSTOM_BACKGROUND_LABEL": "Aangepaste achtergrond",
      "PERSONA_REMOVE_BACKGROUND": "Achtergrond verwijderen",
      "PERSONA_CLICK_TO_REPLACE": "Klik om te vervangen",
      "PERSONA_UPLOAD_DESCRIPTION": "PNG of JPG, bij voorkeur beeldverhouding 16:9, max. 2 MB",
      "SIM_INFORMATION_TITLE": "Simulatie-informatie",
      "SIM_NAME_FIELD_LABEL": "Naam *",
      "SIM_LANGUAGE_FIELD_LABEL": "Taal",
      "SIM_DETAILS_SECTION_TITLE": "Simulatiedetails",
      "SIM_ADDITIONAL_SECTION_TITLE_LABEL": "Titel van extra sectie",
      "SIM_ADDITIONAL_SECTION_INFO_LABEL": "Informatie extra sectie",
      "TESTING_SECTION_TITLE": "Testers",
      "TESTING_SEND_ASSIGNMENTS_BTN": "Testopdrachten versturen",
      "TESTING_MESSAGING_TOOLTIP": "Voeg minstens één feit toe aan 'Naleving van boodschappen' voordat je test of publiceert.",
      "TESTING_DESCRIPTION": "Zoek gebruikers die de simulatie gaan testen en stuur hen vervolgens de testopdracht.",
      "TESTING_COL_NUMBER_OF_ATTEMPTS": "Aantal pogingen",
      "TESTING_COL_DATE_OF_LAST_ATTEMPT": "Datum van de laatste poging",
      "TESTING_CLEAR_USERS": "Gebruikers wissen",
      "TESTING_REMOVE_ASSIGNEE": "Toegewezen gebruiker verwijderen",
      "OVERALL_SECTION_TITLE": "Secties, wegingen en prompts",
      "OVERALL_HEADING": "Totaal",
      "TRANSCRIPT_PROMPT_TITLE": "Transcriptprompt",
      "TRANSCRIPT_PROMPT_FIELD_LABEL": "Voer hier de prompt voor het opgeschoonde transcript in",
      "SIMULATION_PROMPTS_TITLE": "Simulatieprompts",
      "OTHERS_SINGULAR": "en 1 andere",
      "OTHERS_PLURAL": "en {{ count }} andere",
      "PAGINATION_PREVIOUS": "Vorige",
      "PAGINATION_NEXT": "Volgende",
      "SKILLS_RUBRIC_REQUIRED_TOOLTIP": "Voeg een rubric vaardigheden toe. 'Vaardigheden' is ingeschakeld met een gewicht van meer dan 0%.",
      "ENTITY_TYPE_KNOWLEDGE_CHECK_DISPLAY": "kennistest",
      "NAME_MAX_LENGTH_ERROR": "De naam mag maximaal 255 tekens bevatten.",
      "UUID_COPIED_TOAST": "Gespreks-UUID gekopieerd naar het klembord",
      "MENU_ARCHIVE": "Archiveren",
      "MENU_EDIT_SIMULATION_TAGS": "Simulatietags bewerken",
      "MENU_COPY_UUID": "UUID kopiëren",
      "REFINEMENT_IN_PROGRESS_TOOLTIP": "Bezig met verfijnen. Je kunt verder zodra dit klaar is.",
      "SIMULATION_DOCUMENTS_PARSE_FAILED_BODY": "We konden een van je documenten voor {{ name }} niet lezen. Controleer of vervang het document en probeer het opnieuw.",
      "REFINEMENT_ERROR_MESSAGE": "Sorry, we konden dit verzoek niet uitvoeren. Probeer het opnieuw.",
      "REFINEMENT_OUT_OF_SCOPE_TITLE": "Verzoek valt buiten het bereik.",
      "REFINEMENT_OUT_OF_SCOPE_BODY": "Je verzoek voor {{ name }} valt buiten wat je met verfijnen kunt aanpassen. Neem contact op met support.",
      "TAB_QUESTIONS": "Vragen",
      "KNOWLEDGE_CHECK_NAME_LABEL": "Naam*",
      "AVATAR_APPEARANCE_LABEL": "Uiterlijk van de avatar",
      "KNOWLEDGE_CHECK_AVATAR_NAME_LABEL": "Naam van de avatar",
      "KNOWLEDGE_CHECK_SKILLS_FEEDBACK_TITLE": "Feedback over vaardigheden",
      "KNOWLEDGE_CHECK_SCORING_DESCRIPTION": "Kennistests krijgen een score op basis van het percentage antwoordpunten dat per vraag aan bod komt. Selecteer hieronder een rubric vaardigheden om ook kwalitatieve feedback te krijgen.",
      "KNOWLEDGE_CHECK_SCORING_RESCORE_DESCRIPTION": "Test de simulatie minstens één keer en selecteer daarna 'Mijn laatste sessie beoordelen' om je score te zien. Als je antwoordpunten bewerkt, kun je dezelfde sessie opnieuw laten beoordelen. Als je vragen bewerkt, moet je eerst een nieuwe testsessie doen voordat je die kunt laten beoordelen.",
      "KNOWLEDGE_CHECK_SKILLS_RUBRIC_LABEL": "Rubric vaardigheden (optioneel)",
      "SIMULATION_TYPE_MODAL_TITLE": "Nieuwe simulatie aanmaken",
      "SIMULATION_TYPE_MODAL_DESCRIPTION": "Kies hoe je cursisten gaan oefenen.",
      "SIMULATION_TYPE_ROLE_PLAY_TITLE": "Rollenspel",
      "SIMULATION_TYPE_ROLE_PLAY_DESCRIPTION": "Cursisten voeren een open gesprek met een AI-personage dat natuurlijk reageert op alles wat ze zeggen.",
      "SIMULATION_TYPE_ROLE_PLAY_BEST_FOR": "Ideaal voor: realistische verkoopgesprekken oefenen, zoals pitches en omgaan met bezwaren.",
      "SIMULATION_TYPE_KNOWLEDGE_CHECK_TITLE": "Kennistest",
      "SIMULATION_TYPE_KNOWLEDGE_CHECK_DESCRIPTION": "Een AI-personage stelt cursisten de vragen die jij opstelt, in de volgorde die jij bepaalt.",
      "SIMULATION_TYPE_KNOWLEDGE_CHECK_BEST_FOR": "Ideaal voor: productkennis testen en certificeren dat verkopers er klaar voor zijn.",
      "TAGS_FILTER_LABEL": "Tags",
      "TAGS_FILTER_PLACEHOLDER": "Tag selecteren",
      "CLEAR_ALL_FILTERS": "Alle filters wissen",
      "LAST_SAVED_LABEL": "Laatst opgeslagen",
      "BUTTON_OK": "OK",
      "KEYWORDS_RESET_TO_PRODUCT_DEFAULT": "Terugzetten naar productstandaard",
      "KEYWORDS_DETACH_FROM_PRODUCT_DEFAULT": "Loskoppelen van productstandaard",
      "KEYWORDS_SAVE_AS_PRODUCT_DEFAULT": "Opslaan als productstandaard",
      "KEYWORDS_SAVE_AS_DEFAULT_OVERWRITE": "Hiermee overschrijf je de standaardlijst voor {{ keywordTitle }} van het product {{ moduleName }}.",
      "KEYWORDS_SAVE_AS_DEFAULT_IMPACT": "Deze woorden worden toegevoegd aan nieuwe simulaties voor {{ moduleName }}. Dit geldt voor alle gesprekken voor het product {{ moduleName }}.",
      "KEYWORDS_ADD_NEW_WORD": "Nieuw woord toevoegen",
      "KEYWORDS_FROM_LABEL": "Van",
      "KEYWORDS_TO_LABEL": "Naar",
      "KEYWORDS_PRONOUNCE_TITLE": "Uitspraak van woorden",
      "KEYWORDS_PRONOUNCE_DESCRIPTION": "Geef uitspraakcorrecties op voor de AI-agent, zodat die namen en termen correct uitspreekt. De agent koppelt veelvoorkomende verkeerde uitspraken en varianten aan de nieuwe uitspraak.",
      "KEYWORDS_PRONOUNCE_NAME": "uitspraak van woorden",
      "KEYWORDS_ADD_MISPRONUNCIATION": "Verkeerde uitspraak toevoegen",
      "KEYWORDS_SELECT_PERSONA_NOTICE": "Selecteer een persona om woorden voor de uitspraak toe te voegen.",
      "KEYWORDS_REPLACE_TITLE": "Woorden vervangen",
      "KEYWORDS_REPLACE_DESCRIPTION": "Expliciete zoek-en-vervangcorrecties voor de transcripttekst van de gebruiker: directe woordvervangingen die vóór de fonetische correctie worden uitgevoerd.",
      "KEYWORDS_REPLACE_NAME": "woorden vervangen",
      "KEYWORDS_ADD_REPLACEMENT": "Vervanging toevoegen",
      "KEYWORDS_STT_TITLE": "STT-woorden",
      "KEYWORDS_STT_DESCRIPTION": "Woordenlijst voor Speech-to-Text-providers (STT), bijv. AssemblyAI en Tavus, specifiek voor de configuratie van de STT-provider.",
      "KEYWORDS_STT_NAME": "STT-woorden",
      "KEYWORDS_GENERATING": "Bezig met genereren ...",
      "KEYWORDS_GENERATE_STT_PROMPT": "stt_prompt genereren",
      "KEYWORDS_STT_PROMPT_OUTDATED": "De woordenlijst is bijgewerkt sinds deze prompt is gegenereerd. Genereer opnieuw om de laatste wijzigingen te verwerken.",
      "KEYWORDS_STT_CANNOT_SAVE_HEADING": "Opslaan op productniveau niet mogelijk",
      "KEYWORDS_STT_CANNOT_SAVE_BODY": "De STT-woorden en de prompt kunnen niet op productniveau worden opgeslagen. Je kunt de STT-configuratie van andere simulaties handmatig wijzigen of je beheerder om hulp vragen.",
      "KEYWORDS_CLEAN_TRANSCRIPT_TITLE": "Woorden voor transcriptopschoning",
      "KEYWORDS_CLEAN_TRANSCRIPT_DESCRIPTION": "Woorden die in de CLEAN_TRANSCRIPT_V2-prompt worden ingevoegd.",
      "KEYWORDS_CLEAN_TRANSCRIPT_NAME": "woorden voor transcriptopschoning",
      "KEYWORDS_CALL_TITLE": "Gesprekswoorden",
      "KEYWORDS_CALL_DESCRIPTION": "Woordenboek met correcte woorden voor fonetische correctie. Wordt gebruikt door het Double Metaphone-algoritme om fonetisch vergelijkbare spelfouten te corrigeren. Vermijd termen van meerdere woorden, zoals 'Anti MuSK AB+', want de transcriptcorrector op basis van code werkt alleen betrouwbaar met losse woorden. Vermijd ook symbolen, zoals 'lp(a)', omdat die de corrector vaak in de war brengen. Houd de lijst zo kort en eenvoudig mogelijk: een deterministisch algoritme verwerkt de lijst, geen LLM, en dat algoritme begrijpt geen context.",
      "KEYWORDS_CALL_NAME": "gesprekswoorden"
    },
    "settings": {
      "DEVICE_SETUP_INTRO": "We controleren even of je apparaat goed is ingesteld.",
      "MICROPHONE_REQUIRED_NOTICE": "Er is een werkende microfoon nodig.",
      "DEVICE_ENABLE_INSTRUCTIONS": "Zag je na het vernieuwen van deze pagina geen pop-up om je apparaten in te schakelen? Ga dan naar je systeem- of browserinstellingen en schakel je apparaten daar in. Hieronder vind je supportpagina's met meer instructies.",
      "ENABLE_CAMERA": "Zo schakel je je camera in:",
      "WINDOWS_USERS": "Windows-gebruikers",
      "MAC_USERS": "Mac-gebruikers",
      "IPAD_USERS": "iPad-gebruikers",
      "ENABLE_MICROPHONE": "Zo schakel je je microfoon in:",
      "ENABLE_DEVICES_BY_BROWSER": "Zo schakel je je apparaten in per browser:",
      "CHROME_USERS": "Chrome-gebruikers",
      "SAFARI_USERS": "Safari-gebruikers",
      "FIREFOX_USERS": "Firefox",
      "EDGE_USERS": "Edge",
      "START_WITHOUT_CAMERA_BUTTON": "Starten zonder camera",
      "START_CALL_BUTTON": "Gesprek starten",
      "MICROPHONE_REQUIRED_WARNING": "Er is een werkende microfoon nodig.",
      "MICROPHONE_ALT": "microfoon",
      "MICROPHONE": "Microfoon",
      "SELECT_MICROPHONE": "Kies je microfoon",
      "ALERT": "waarschuwing",
      "GIVE_PERMISSION": "Toestemming verlenen",
      "SELECT_VIDEO_DEVICE": "Kies je videoapparaat",
      "VIDEO": "video",
      "DEVICE_BLOCKED_ERROR": "Deze browser heeft geen toegang tot een of meer van je apparaten. Ga naar je systeem- of browserinstellingen en sta de toegang toe om de apparaten in te schakelen.",
      "DEVICE_SETTINGS": "Apparaatinstellingen",
      "CONFIRM_SETTINGS": "Instellingen bevestigen",
      "LAPTOP": "Laptop",
      "SAD_EMOTE_FACE": "Verdrietig gezichtje",
      "GRANT_BROWSER_ACCESS": "Geef de browser toegang tot spraakherkenning om deze simulatie te voltooien",
      "USING_IPAD": "Gebruik je een iPad? Ga dan naar",
      "SETTINGS": "Instellingen",
      "PRIVACY_AND_SECURITY": "Privacy en beveiliging",
      "SPEECH_RECOGNITION": "Spraakherkenning",
      "GRANT_ACCESS_REFRESH": "Verleen de browser toegang en vernieuw de pagina",
      "REFRESH_PAGE": "PAGINA VERNIEUWEN",
      "BROWSER_UNABLE_TO_ACCESS": "De browser heeft geen toegang tot dit apparaat",
      "ACCESS_DENIED": "toegang geweigerd",
      "CAMERA": "Camera",
      "DIAGNOSTIC_PASSED": "Alle diagnostische tests zijn geslaagd.",
      "DIAGNOSTIC_FAILED_MESSAGE": "Sommige diagnostische tests zijn mislukt. Klik hierboven op de knop 'Diagnoseresultaten kopiëren' en stuur de resultaten naar het supportteam voor hulp.",
      "DIAGNOSTIC_PARTIAL": "De meeste diagnostische tests zijn geslaagd. Je verbinding lijkt in orde.",
      "DIAGNOSTIC_RUNNING_MESSAGE": "Even geduld, de diagnostische tests worden uitgevoerd ...",
      "DIAGNOSTIC_RUNNING": "Diagnose wordt uitgevoerd",
      "COPY_DIAGNOSTIC_RESULTS": "Diagnoseresultaten kopiëren",
      "RUN_DIAGNOSTIC": "Diagnose uitvoeren",
      "RERUN_DIAGNOSTIC": "Diagnose opnieuw uitvoeren",
      "DIAGNOSTIC_RESULTS_COPIED": "Diagnoseresultaten gekopieerd naar het klembord",
      "DIAGNOSTIC_FAILED": "Diagnose mislukt",
      "DIAGNOSTIC_WEBSOCKET_NOT_TESTED": "Websocket: not tested",
      "DIAGNOSTIC_TURN_NOT_TESTED": "TURN: not tested",
      "DIAGNOSTIC_QUALITY_NOT_TESTED": "Quality: not tested",
      "DIAGNOSTIC_QUANTIFIED_DIAGNOSTICS": "Quantified-diagnose",
      "DIAGNOSTIC_TIME": "Tijd",
      "DIAGNOSTIC_SUMMARY": "Samenvatting",
      "DIAGNOSTIC_CLIENT_INFO": "Clientgegevens",
      "DIAGNOSTIC_PLATFORM": "Platform",
      "DIAGNOSTIC_RTT_AVG_MAX": "RTT avg/max",
      "DIAGNOSTIC_PACKET_LOSS_SEND": "Pakketverlies (verzenden)",
      "DIAGNOSTIC_AVG_SEND_BITRATE": "Gemiddelde verzendbitrate",
      "DIAGNOSTIC_NA": "n.v.t.",
      "DIAGNOSTIC_PROBLEMS_CONNECTING_PREFIX": "Problemen met de verbinding?",
      "DIAGNOSTIC_CLICK_HERE": "Klik hier",
      "DIAGNOSTIC_TO_RUN_SUFFIX": "om een diagnose uit te voeren."
    },
    "results": {
      "RETURN_HOME": "TERUG NAAR HET STARTSCHERM",
      "RETURN_TO_PATHWAY": "TERUG NAAR HET TRAJECT",
      "CLOSE_BUTTON": "Knop Sluiten",
      "CONVERSATIONAL_CALL": "ROLLENSPEL",
      "INFORMATION_ICON": "Informatiepictogram",
      "TOOLTIP_ARROW": "Tooltip-pijl",
      "INFORMATION_TOOLTIP_CONTENT": "Jij bepaalt het verloop van de simulatie en stuurt het gesprek naar een aantal doelstellingen. Rollenspellen zijn ideaal om vaardigheden te testen zoals doorvragen, knelpunten blootleggen en een band opbouwen.",
      "CLOCK_ICON": "Klokpictogram",
      "CALL_RESULTS": "Resultaten",
      "QUIZ_RESULTS_SUMMARY": "Overzicht quizresultaten",
      "PROCESSING_RESULTS": "Resultaten worden verwerkt ...",
      "SKILLS": "Vaardigheden",
      "MESSAGE_ADHERENCE": "Naleving van boodschappen",
      "MESSAGING": "Boodschappen",
      "TRY_AGAIN_MESSAGE": "Probeer het opnieuw en verbeter je score.",
      "QUIZ_SUMMARY_BASE": "Neem even de tijd om je prestaties in deze quiz te bekijken.",
      "QUIZ_SUMMARY_FAILED": "Neem even de tijd om je prestaties in deze quiz te bekijken. Bekijk de {{stepNames}} {{stepWord}} die gemarkeerd zijn in het trajectoverzicht, zodat je beter voorbereid bent op je volgende poging.",
      "QUIZ_SUMMARY_PASSED_WITH_MISSES": "Neem even de tijd om je prestaties in deze quiz te bekijken. De {{stepNames}} {{stepWord}} {{stepVerb}} je {{areaWord}} met de laagste score.",
      "PRACTICE_BENEFITS": "Oefen je elke week, dan word je zekerder en haal je betere resultaten in de praktijk.",
      "CALL_SUCCESS": "Goed gedaan Je hebt deze simulatie met succes voltooid.",
      "MAX_ATTEMPTS_REACHED": "Je hebt het maximale aantal pogingen bereikt",
      "TRY_AGAIN": "Opnieuw proberen",
      "GREAT_JOB_YOU_SUCCESSFULLY": "Goed gedaan Je hebt",
      "COMPLETED_THIS_CALL": "deze simulatie met succes voltooid.",
      "ACHIEVED_SCORE": "Je hebt een score behaald van",
      "ACHIEVE_SCORE": "Behaal een score van",
      "OR_HIGHER": "of hoger.",
      "OBJECTIVES_NOT_MET": "Je hebt niet aan alle vereiste doelstellingen voldaan.",
      "TRY_AGAIN_TARGET_SCORE": "Probeer het opnieuw om een score te halen van",
      "YOUR_SCORE": "Je score",
      "OUT_OF_5": "VAN DE 5",
      "OUT_OF_100": "VAN DE 100",
      "CALL_FEEDBACK": "SAMENVATTING FEEDBACK",
      "STRENGTH_ICON_ALT": "Pictogram Sterke punten",
      "OPPORTUNITIES_ICON_ALT": "Pictogram Verbeterpunten",
      "OBJECTIVES_FEEDBACK": "FEEDBACK OP DE METHODOLOGIE",
      "SESSION_ID": "Sessie-ID:",
      "SESSION_ID_COPIED": "Sessie-ID gekopieerd",
      "OBJECTIVE": "METHODOLOGIE:",
      "HOW_YOU_DID": "Zo heb je het gedaan:",
      "LIGHTBULB_ICON_ALT": "Pictogram gloeilamp",
      "WHAT_WE_SUGGEST": "Onze suggestie:",
      "NO_SPECIFIC_RECOMMENDATION": "Ons systeem kon geen specifieke aanbeveling voor je vinden.",
      "WHY": "Waarom?",
      "NO_INSIGHTS_AVAILABLE": "Ons systeem kon geen inzicht geven in deze suggestie.",
      "CONFETTI_ICON_ALT": "Pictogram confetti",
      "OBJECTIVE_SUCCESS_MESSAGE": "Je hebt het geweldig gedaan voor deze methodologie, ga zo door!",
      "PROCESSING_CALL": "We zijn bezig met het berekenen van je score en het opstellen van je feedback.",
      "HANG_TIGHT": "Even geduld of kom later terug om",
      "VIEW_YOUR_RESULTS": "je resultaten te bekijken.",
      "NEED_MORE_TIME": "We hebben wat meer tijd nodig om de resultaten te berekenen.",
      "REFRESH_INSTRUCTION": "Kom later terug of vernieuw de resultaten van de opdracht",
      "RESULTS_IN_FEW_MINUTES": "over een paar minuten.",
      "QUIZ_RESULTS_LOADING": "Het laden van de resultaten duurt even. Verlaat het traject en we laten je weten wanneer ze klaar zijn.",
      "KC_TOAST_TITLE": "De resultaten van je kennistest zijn verwerkt",
      "KC_TOAST_TITLE_PATHWAY": "De resultaten van je kennistest {{stepName}} zijn verwerkt",
      "KC_TOAST_CONTENT": "Klik hieronder om de resultaten te bekijken, of ga terug naar het scherm met de trajectdetails voor je volgende stap.",
      "DISMISS": "Sluiten",
      "SCORE_CALCULATION_QUESTION": "Hoe wordt dit berekend?",
      "SINGLE_SCORE_EXPLANATION": "Deze simulatie heeft maar één scoreonderdeel. De score die je ziet, is dus zowel de sectiescore als je totaalscore.",
      "OVERALL_SCORE_PERCENT": "van de totaalscore",
      "SECTION_SCORE": "Sectiescore",
      "ELEVATE_MESSAGE_ADHERENCE_TITLE": "Breng je boodschappen beter over in je gesprekken",
      "MESSAGE_ADHERENCE_NOTE": "Je boodschappen goed overbrengen is cruciaal voor een geslaagd gesprek, maar telt niet mee voor je totaalscore.",
      "NO_CREDIT": "Geen punten",
      "PARTIAL_CREDIT": "Gedeeltelijke punten",
      "FULL_CREDIT": "Volledige punten",
      "WHAT_YOU_DID_WELL": "Wat je goed hebt gedaan",
      "MISSED_ALL_KEY_POINTS": "Je hebt alle belangrijke punten gemist. Bekijk ze nog eens en probeer het opnieuw.",
      "WHAT_TO_IMPROVE": "Wat je beter kunt doen",
      "PERFECT_SCORE_MESSAGE": "Gefeliciteerd Je hebt een perfecte score behaald en alle belangrijke punten correct behandeld.",
      "POINTS_LABEL": "Punten",
      "POINT_LABEL": "Punt",
      "TALKING_POINTS_COVERED": "Behandelde gesprekspunten",
      "COVERED": "Behandeld",
      "CHECKMARK_ICON_ALT": "vinkje",
      "TALKING_POINTS_MISSED": "Gemiste gesprekspunten",
      "MISSED": "Gemist",
      "X_ICON_ALT": "x",
      "PRACTICE_AGAIN": "Opnieuw oefenen",
      "PRACTICE_SIMULATION_AGAIN": "Simulatie opnieuw oefenen",
      "CALL_TYPE_CONVERSATIONAL": "Vrij gesprek",
      "CALL_TYPE_GUIDED": "Begeleid gesprek",
      "CALL_TYPE_VISUAL_AID": "Gesprek met visuele ondersteuning",
      "CALL_TYPE_ROLEPLAY": "Rollenspelgesprek",
      "OUT_OF": "van de",
      "OBJECTIVES": "Methodologie",
      "ELEVATE_OBJECTIVES_TITLE": "Verbeter je gespreksmethodologie",
      "OBJECTIVES_NOTE": "Een goede methodologie is cruciaal voor een geslaagd gesprek, maar telt niet mee voor je totaalscore.",
      "UNTIL": "tot",
      "TO_IMPROVE_SCORE": "om je score te verbeteren.",
      "YOU_HAVE": "Je hebt nog",
      "MORE_ATTEMPTS": "pogingen om een score van",
      "OR_HIGHER_BEFORE": "of hoger te halen vóór",
      "AND_TRY_AGAIN": "en probeer het opnieuw.",
      "UNEXPECTED_STATE": "Er is een onverwachte status opgetreden.",
      "REVIEW_APP_LOGIC": "Controleer de logica van de applicatie.",
      "ASSIGNMENTS": "Opdrachten",
      "VIEW_CALL_DETAILS": "Gespreksdetails bekijken",
      "PRACTICE_SESSION": "Oefensessie",
      "OVERALL_SCORE": "Totaalscore",
      "OVERALL_SCORE_EXPLANATION": "De totaalscore is het gewogen gemiddelde van de scores voor elke sectie. Het gewicht van elke sectie staat als percentage naast de score.",
      "SCORE_CONFIG_NOTE": "Je bedrijf bepaalt de wegingspercentages en welke secties meetellen. We ronden alle scores af op een tiende van een punt.",
      "STRENGTHS": "Sterke punten",
      "OPPORTUNITIES": "Verbeterpunten",
      "YOUR_RESPONSE": "Je antwoord",
      "MINUS": "min",
      "PLUS": "plus",
      "RECOMMENDED_RESPONSE": "Aanbevolen antwoord",
      "REVIEW_MISSED_TITLE": "Bekijk wat je hebt gemist.",
      "NO_TALKING_POINTS_COVERED": "Je hebt geen van de vereiste gesprekspunten voor dit onderwerp behandeld.",
      "LEARN_WHAT_YOU_MISSED": "Ontdek wat je hebt gemist",
      "NICE_JOB": "Goed gedaan",
      "ALL_POINTS_COVERED": "Je hebt alle vereiste gesprekspunten voor dit onderwerp behandeld.",
      "COVER_ALL_MESSAGES": "Behandel alle kernboodschappen.",
      "HIGHLIGHT_KEY_POINTS_NOTE": "Door de belangrijkste punten tijdens het gesprek te benadrukken, blijft het gesprek gefocust.",
      "MESSAGES_LABEL": "Boodschappen",
      "NO_FACTS_COVERED": "Oeps Je hebt blijkbaar geen van de feiten uit deze boodschap behandeld.",
      "NO_SPECIFICS_AVAILABLE": "Oeps We konden helaas niet aangeven wat er precies ontbrak.",
      "ALL_KEY_POINTS_COVERED": "Goed gedaan Je hebt alle belangrijke punten behandeld.",
      "PROCESSING_SKILLS_FEEDBACK": "We verwerken je feedback over vaardigheden.",
      "SKILLS_SCORING_NOT_ENABLED": "Sorry, we konden je recente gesprek niet analyseren omdat de vaardigheidsbeoordeling niet was ingeschakeld toen je het indiende. Wil je feedback? Dien je gespreksoefening dan gewoon opnieuw in, zoals je eerder deed. Heb je hulp nodig? Neem dan gerust contact op met ons supportteam. Bedankt voor je begrip en je inzet om beter te worden.",
      "ELEVATE_CONVERSATION_SKILLS": "Verbeter je gespreksvaardigheden",
      "SKILLS_NOTE": "Vaardigheden zijn cruciaal voor een geslaagd gesprek, maar tellen niet mee voor je totaalscore.",
      "SKILLS_SUMMARY_TITLE": "OVERZICHT VAARDIGHEDEN",
      "LEARN_MORE_ABOUT_SKILLS": "Meer informatie over vaardigheden",
      "SKILLS_FEEDBACK_LABEL": "FEEDBACK",
      "WHAT_ARE_SKILLS_TITLE": "Wat zijn vaardigheden",
      "SKILLS_DESCRIPTION": "Vaardigheden zijn afgestemd op persoonlijke groei en ontwikkeling. Deze vaardigheden tellen niet mee voor de score van je gesprek. Je organisatie heeft ze gekozen om je te helpen nog beter te worden.",
      "PROFICIENCY_SCALE_TITLE": "NIVEAUSCHAAL",
      "EXPERT": "Expert",
      "PROFICIENT": "Voldoende niveau",
      "DEVELOPING": "In ontwikkeling",
      "CALL_TRANSCRIPT": "Gesprekstranscript",
      "COLLAPSE_ALL": "Alles samenvouwen",
      "EXPAND_ALL": "Alles uitvouwen",
      "THUMBNAIL": "Miniatuur",
      "OUT_OF_FIVE_POINTS": "/5 punten",
      "TALKING_POINTS": "gesprekspunten",
      "TRANSCRIPT_LABEL": "Transcript",
      "YOU_ARE_OUT_OF_ATTEMPTS": "Je hebt geen pogingen meer.",
      "REVIEW_GUIDELINES_REMAIN_COMPLIANT": "Bekijk de richtlijnen en houd je er in de toekomst aan.",
      "TRY_AGAIN_ATTENTION_TO_COMPLIANCE": "Probeer het opnieuw en let goed op de nalevingsrichtlijnen.",
      "NO_SCORE_OUT_OF_COMPLIANCE": "We hebben iets ontdekt dat mogelijk niet aan de richtlijnen voldoet",
      "WHY_OUT_OF_COMPLIANCE": "Waarom je mogelijk niet aan de richtlijnen voldoet",
      "REVIEW_TRANSCRIPT_MISSED_GUIDELINES": "Bekijk je transcript om te zien waar je de nalevingsrichtlijnen niet hebt gevolgd.",
      "YOU_DID_FOLLOW_GUIDELINES": "Je hebt deze richtlijnen goed gevolgd.",
      "REVIEW_MISSED_GUIDELINES": "Bekijk de nalevingsrichtlijnen die je hebt gemist.",
      "OUT_OF_COMPLIANCE": "Niet-conform",
      "SCORE_CALCULATION_TITLE": "Scoreberekening",
      "PROCESSING_TRANSCRIPT": "We zijn je transcript aan het verwerken.",
      "WAIT_OR_REVIEW_SCORES": "Wacht hier of bekijk de andere",
      "TRANSCRIPT_LOADING": "scoresecties terwijl het transcript wordt geladen.",
      "REVIEW_FEEDBACK_KEEP_PRACTICING": "Bekijk je feedback en blijf oefenen",
      "HIGH_PERFORMERS_PRACTICE": "Toppers oefenen minstens één keer per week",
      "SUCCESSFULLY_PASSED": "Goed gedaan Je bent geslaagd voor deze simulatie.",
      "DIDNT_REACH_PASSING_SCORE": "Je hebt de minimale score voor deze simulatie niet gehaald.",
      "OUT_OF_ATTEMPTS": "<b>Je hebt geen pogingen meer over.</b> Bekijk je feedback om te zien hoe je je prestaties kunt verbeteren.",
      "REVIEW_FEEDBACK_THEN_RETURN": "Bekijk je feedback en ga terug naar het startscherm als je er klaar voor bent.",
      "GREAT_JOB_PRACTICED": "Goed gedaan, je hebt {{count}} {{times}} geoefend. Ga zo door!",
      "GREAT_JOB_PRACTICED_FEMALE": "Goed gedaan, je hebt {{count}} {{times}} geoefend. Ga zo door!",
      "TIME": "keer",
      "TIMES": "keer",
      "COMPLIANCE_GUIDELINES": "Nalevingsrichtlijnen",
      "TALKING_POINT_TITLE": "GESPREKSPUNTEN GEMIST OF OP HET VERKEERDE MOMENT GENOEMD",
      "NO_TRANSCRIPT": "Geen transcript beschikbaar.",
      "RETURN_TO_ASSIGNMENT": "Terug naar de opdracht",
      "NONE_PERFECT": "Geen, perfect",
      "MISSED_ONE_TALKING_POINT": "Je hebt 1 gesprekspunt voor dit onderwerp gemist.",
      "MISSED_X_TALKING_POINTS": "Je hebt {{count}} gesprekspunten voor dit onderwerp gemist.",
      "MISSED_ONE_REQUIRED_TALKING_POINT": "Je hebt 1 verplicht gesprekspunt voor dit onderwerp gemist",
      "MISSED_X_REQUIRED_TALKING_POINTS": "Je hebt {{count}} verplichte gesprekspunten voor dit onderwerp gemist",
      "MISSED_ALL_ONE_REQUIRED_TALKING_POINT_TITLE": "Je hebt 1 verplicht gesprekspunt voor dit onderwerp gemist.",
      "MISSED_ALL_X_REQUIRED_TALKING_POINTS_TITLE": "Je hebt {{count}} verplichte gesprekspunten voor dit onderwerp gemist.",
      "REVIEW_MATERIAL_NEXT_TIME": "Bekijk de leerstof om het de volgende keer beter te doen.",
      "ROLEPLAY_POST_CALL_TITLE": "Je bent aan het einde van dit gesprek gekomen.",
      "ROLEPLAY_POST_CALL_SUBTITLE_PROCESSING": "Geef wat feedback terwijl we je resultaten verwerken.",
      "ROLEPLAY_POST_CALL_SUBTITLE_DELAY": "Het laden van de resultaten duurt even. Verlaat het traject en we laten je weten wanneer ze klaar zijn.",
      "ROLEPLAY_POST_CALL_SUBTITLE_ERROR": "Er is een fout opgetreden bij het verwerken van je resultaten. Neem contact op met support via",
      "ROLEPLAY_POST_CALL_PROCESSING_LABEL": "Resultaten worden verwerkt ...",
      "ROLEPLAY_POST_CALL_FEEDBACK_QUESTION": "Voelde dit gesprek realistisch en natuurlijk aan?",
      "FEEDBACK_THANK_YOU": "Bedankt voor je feedback.",
      "FEEDBACK_IMPROVEMENT_NOTE": "Bedankt voor je feedback. We gebruiken deze info om de ervaring te verbeteren.",
      "VIEW_RESULTS": "Resultaten bekijken",
      "FEEDBACK_IMPROVEMENT_SUFFIX": "We gebruiken deze info om de ervaring te verbeteren.",
      "ACCURACY": "Juistheid",
      "ACCURACY_LOADING": "Bezig met laden ...",
      "ACCURACY_FLAGGED_MESSAGE": "Je hebt een aantal dingen gezegd die mogelijk afwijken van je bronmateriaal. Zie hieronder voor meer details.",
      "ACCURACY_ALL_CLEAR": "We hebben geen beweringen gevonden die afwijken van het bronmateriaal.",
      "ACCURACY_ERROR": "We konden geen feedback geven over deze sessie",
      "ACCURACY_YOU_SAID": "JE ZEI",
      "ACCURACY_CLAIM_IDENTIFIED": "DE BEWERING DIE WE HEBBEN GEVONDEN",
      "ACCURACY_MATERIALS_STATE": "IN JE MATERIAAL STAAT",
      "ACCURACY_OVERALL_BLOCK_PREFIX": "Je hebt een aantal dingen gezegd die mogelijk onjuist zijn. Bekijk het tabblad ",
      "ACCURACY_OVERALL_BLOCK_LINK": "Juistheid",
      "ACCURACY_OVERALL_BLOCK_SUFFIX": " voor meer details.",
      "PERSONALIZED_PRACTICE_BREADCRUMB": "Oefenen op maat",
      "CONVERSATION_TYPE_LABEL": "Type gesprek:",
      "DIFFICULTY_LABEL": "Moeilijkheidsgraad:",
      "MOOD_LABEL": "Stemming:",
      "DIFFICULTY": "Moeilijkheidsgraad",
      "TEMPERAMENT": "Temperament",
      "OVERALL_SCORE_TAB": "Totaal",
      "MESSAGE_ADHERENCE_TAB": "Boodschappen",
      "OBJECTIVES_TAB": "Doelstellingen"
    },
    "reportingV2": {
      "DASHBOARD": "Dashboard",
      "LOADING_ACCOUNTS": "Accounts worden geladen ...",
      "SELECT_AN_ACCOUNT": "Selecteer een account",
      "SELECT_ASSIGNMENTS": "Selecteer opdrachten",
      "SEARCH_TEAMS": "Teams zoeken",
      "LOADING_TEAMS": "Teams worden geladen ...",
      "ALL_TEAMS": "Alle teams",
      "ACCOUNT": "Account",
      "TEAMS": "Teams",
      "TEAM_LABEL": "Team",
      "TOTAL_LABEL": "Totaal",
      "PASSING_SCORE": "Minimale score",
      "ASSIGNMENT_LABEL": "Opdrachten",
      "USER_LABEL": "Gebruikers",
      "PRACTICE_LABEL": "Oefenen",
      "CERTIFICATION_LABEL": "Certificering",
      "CERTIFICATION_STATUS_LABEL": "Certificeringsstatus",
      "CERTIFICATION_STATUS_PREFIX_LABEL": "Certificeringsstatus:",
      "CERTIFIED_ON_FIRST_ATTEMPT_LABEL": "Gecertificeerd bij de eerste poging?",
      "DATE_OF_CERTIFICATION_LABEL": "Datum van certificering",
      "RESULTS_DESCRIPTION": "Hier zijn de resultaten van je team(s) voor alle oefenopdrachten:",
      "ENGAGEMENT_BY_ASSIGNMENT": "Deelname per opdracht",
      "ASSIGNMENT_ENGAGEMENT": "Deelname per opdracht",
      "ENGAGED_LABEL": "Deelgenomen",
      "ENGAGEMENT_STATUS_LABEL": "Deelnamestatus",
      "ENGAGEMENT_STATUS_PREFIX_LABEL": "Deelnamestatus:",
      "PROFICIENT_LABEL": "Voldoende niveau",
      "ASSIGNMENT_NAME": "Opdrachtnaam",
      "ACTIVE_USERS": "Actieve gebruikers",
      "ASSIGNMENT_PROGRESS": "Voortgang per opdracht",
      "IN_PROGRESS_LABEL": "In uitvoering",
      "CERTIFIED_LABEL": "Gecertificeerd",
      "OUT_OF_ATTEMPTS_LABEL": "Geen pogingen meer",
      "USERS_ENGAGED_LABEL": "Deelnemende gebruikers",
      "SESSIONS_PER_ACTIVE_USERS_LABEL": "Sessies per actieve gebruiker",
      "HIGHER_THAN_LABEL": "Hoger dan",
      "MORE_THAN_LABEL": "Meer dan",
      "TOTAL_SESSIONS_COMPLETED_LABEL": "Totaal aantal voltooide sessies",
      "USER_CERTIFIED": "Gebruikers die voor alle opdrachten zijn gecertificeerd",
      "ASSIGNMENT_CERTIFICATION": "Opdrachten met 100% certificering",
      "TRAINER_TIME_SAVED": "Bespaarde trainerstijd",
      "HOURS_LABEL": "uur",
      "PRACTICE_ASSIGNMENT_LABEL": "Oefenopdrachten",
      "CERTIFICATION_ASSIGNMENT_LABEL": "Certificeringsopdrachten",
      "START_DATE_LABEL": "Startdatum",
      "END_DATE_LABEL": "Einddatum",
      "NAME_LABEL": "Naam",
      "EMAIL_LABEL": "E-mail",
      "MEMBER_OF_TEAMS_LABEL": "Lid van teams",
      "ASSIGNMENTS_COUNT_LABEL": "Aantal opdrachten",
      "TOTAL_SESSIONS_LABEL": "Totaal aantal sessies",
      "NUMBER_OF_SESSIONS_LABEL": "Aantal sessies",
      "TOTAL_USERS_LABEL": "Totaal aantal gebruikers",
      "AVERAGE_SCORE_LABEL": "Gemiddelde score",
      "INITIAL_SCORE_LABEL": "Beginscore",
      "HIGH_SCORE_LABEL": "Hoogste score",
      "LAST_PRACTICE_DATE_LABEL": "Datum van de laatste oefening",
      "PERCENT_IMPROVED_LABEL": "% verbeterd",
      "PERCENT_IMPROVED_TOOLTIP_TEXT": "Deze meetwaarde vergelijkt de begin- en de hoogste score van een gebruiker, uitgedrukt als percentage van de maximaal mogelijke verbetering.",
      "ASSIGNMENTS_CERTIFIED_LABEL": "Gecertificeerde opdrachten",
      "ASSIGNMENTS_PROFICIENT_LABEL": "Opdrachten met voldoende niveau",
      "ASSIGNMENTS_CERTIFIED_TOOLTIP_TEXT": "Het aantal opdrachten waarin de gebruiker de scorecriteria voor alle simulaties in de opdracht heeft gehaald of overtroffen.",
      "ASSIGNMENTS_PROFICIENT_TOOLTIP_TEXT": "Het aantal opdrachten waarin de gebruiker de scorecriteria bij alle simulaties in de opdracht minstens één keer heeft gehaald of overtroffen.",
      "PROFICIENT_TOOLTIP": "Het percentage gebruikers in deze opdracht dat de scorecriteria bij alle simulaties in deze opdracht minstens één keer heeft gehaald of overtroffen.",
      "ENGAGED_TOOLTIP": "Het percentage gebruikers dat een of meer sessies van een simulatie in deze opdracht heeft voltooid, maar nog niet voor alle simulaties het vereiste niveau heeft bereikt.",
      "IN_PROGRESS_TOOLTIP": "Het percentage gebruikers dat ten minste één sessie van een simulatie in deze opdracht heeft voltooid en een score heeft ontvangen.",
      "OUT_OF_ATTEMPTS_TOOLTIP": "Het percentage gebruikers dat voor een of meer simulaties in de opdracht al zijn pogingen heeft gebruikt.",
      "CERTIFIED_TOOLTIP": "Het percentage gebruikers dat de scorecriteria voor alle simulaties in de opdracht heeft gehaald of overtroffen.",
      "SEARCH_FOR_A_USER_LABEL": "Gebruiker zoeken",
      "NO_USERS_FOUND_LABEL": "Geen gebruikers gevonden",
      "TRAINER_TIME_SAVED_TOOLTIP": "De tijd die gebruikers in Quantified hebben doorgebracht met het voltooien van certificeringspogingen.",
      "AVG_SESSIONS_PER_ASSIGNMENT": "Gem. aantal sessies per opdracht",
      "ASSIGNMENTS_ENGAGED_WITH": "Opdrachten waaraan is deelgenomen",
      "AVERAGE_IMPROVEMENT": "Gemiddelde verbetering",
      "STATUS": "Status",
      "ASSIGNMENT_STATUS": "Opdrachtstatus",
      "STATUS_ACTIVE": "Actief",
      "STATUS_ENDED": "Beëindigd",
      "STATUS_CLOSED": "Gesloten",
      "STATUS_ARCHIVED": "Gearchiveerd",
      "TOTAL_NUMBER_OF_SESSIONS": "Totaal aantal sessies",
      "DATE_OF_LAST_PRACTICE": "Datum van de laatste oefening",
      "CALL_NAME": "Naam gesprek",
      "SESSION_DATE": "Sessiedatum",
      "DURATION_OF_SESSION": "Duur van de sessie",
      "DURATION_OF_ATTEMPT": "Duur van de poging",
      "OVERALL_SCORE": "Totaalscore",
      "MESSAGING_SCORE": "Score naleving van boodschappen",
      "METHODOLOGY_SCORE": "Score methodologie",
      "SKILLS_SCORE": "Score vaardigheden",
      "SESSIONS": "Sessies",
      "TOTAL": "Totaal",
      "ALL_ASSIGNMENTS": "Alle opdrachten",
      "RECENT_ASSIGNMENTS": "Recente opdrachten",
      "USER_NAME": "Gebruikersnaam",
      "LEARNER": "Cursist",
      "DATE_RANGE": "Datumbereik",
      "DATE_RANGE_LABEL": "Datumbereik",
      "SEARCH_USERS": "Gebruikers zoeken ...",
      "SEARCH_SIMULATIONS": "Simulaties zoeken ...",
      "SEARCH_DATES": "Datums zoeken ...",
      "SEARCH_ASSIGNMENTS": "Opdrachten zoeken ...",
      "CERTIFIED_ON_FIRST_TRY": "Gecertificeerd bij de eerste poging",
      "DATE_OF_CERTIFICATION": "Datum van certificering",
      "AVERAGE_CERTIFICATION_SCORE": "Gemiddelde certificeringsscore",
      "TOTAL_TIME_CERTIFYING": "Totale tijd aan certificering",
      "OF_THE_TIME": "van de keren",
      "AVERAGE_SESSIONS_ACTIVE_USER": "Gemiddeld aantal sessies per actieve gebruiker",
      "HOURS_IN_SIMULATIONS": "Uren in simulaties",
      "AVERAGE_SESSIONS_TO_PROFICIENCY": "Gemiddeld aantal sessies tot voldoende niveau",
      "PERCENT_PROFICIENT": "Percentage met voldoende niveau",
      "SYSTEM_RUNNING_NORMALLY": "Het systeem werkt normaal",
      "PRACTICE_SIMULATIONS_LABEL": "Simulaties",
      "SIMULATION_NAME": "Simulatienaam",
      "AVERAGE_DURATION_OF_SESSION": "Gemiddelde duur van een sessie",
      "AVERAGE_SESSIONS_PER_ACTIVE_USER": "Gemiddeld aantal sessies per actieve gebruiker",
      "NO_USERS_MATCHING_FILTERS_LABEL": "Er zijn geen resultaten die aan je filters voldoen. Probeer een of meer filters te verwijderen om de zoekopdracht te verbreden.",
      "USERS_PASSED": "Gebruikers die voor de simulatie geslaagd zijn",
      "AVERAGE_TIME": "Gemiddelde tijd tot certificering",
      "USERS_OUT_OF_ATTEMPTS": "Gebruikers die geen pogingen meer hebben",
      "NO_CERTIFICATION_SIMULATION": "Geen certificeringssimulaties gevonden",
      "AVERAGE_OVERALL_SCORE": "Gemiddelde totaalscore",
      "SIMULATION": "Simulatie",
      "No_SIMULATION": "Geen sessies",
      "PERCENT_CERTIFIED": "Percentage gecertificeerd",
      "PERCENT_CERTIFIED_FIRST_ATTEMPT": "Percentage gecertificeerd bij de eerste poging",
      "USERS": "Gebruikers",
      "ATTEMPTS_LABEL": "Pogingen",
      "NO_ATTEMPTS": "Geen pogingen",
      "DATE_OF_SESSION": "Datum van de sessie",
      "TOTAL_ASSIGNMENTS": "Totaal aantal opdrachten",
      "ASSIGNMENTS_CERTIFIED": "Gecertificeerde opdrachten",
      "TOTAL_SESSIONS": "Totaal aantal sessies",
      "HOURS_SPENT_PRACTICING": "Uren besteed aan oefenen",
      "LAST_LOGIN": "Laatst ingelogd",
      "NO_ASSIGNMENTS_MATCH_FILTERS": "Er zijn geen opdrachten die aan de gekozen filters voldoen",
      "NO_TEAMS_DATA": "Er zijn geen teams binnen dit account",
      "ASSIGNED_LABEL": "Nog niet gestart",
      "USERS_ASSIGNED_LABEL": "Totaal aantal toegewezen gebruikers",
      "SESSION_ID": "Sessie-ID",
      "USER_NAME_LABEL": "Gebruikersnaam",
      "NO_SIMULATIONS_FOUND_LABEL": "Geen simulaties gevonden",
      "MIN": "min",
      "SEC": "sec",
      "OF_LABEL": "van",
      "SECOND": "seconde",
      "SECONDS": "seconden",
      "MINUTE": "minuut",
      "MINUTES": "minuten",
      "ASSIGNMENT_NAME_LABEL": "Opdrachtnaam",
      "SIMULATION_NAME_LABEL": "Simulatienaam",
      "START_DATE": "Startdatum",
      "END_DATE": "Einddatum",
      "NO_ASSIGNMENTS": "Er is geen opdracht gevonden voor deze gebruiker.",
      "ASSIGNED": "Toegewezen",
      "TOTAL_PRACTICE_ASSIGNMENTS": "Totaal aantal oefenopdrachten",
      "SESSION_SCORES_OVER_TIME": "Verloop van de sessiescores",
      "TIME": "Tijd",
      "SCORE": "Score",
      "NO_SESSIONS_AVAILABLE": "Nog geen sessies om in een grafiek te tonen.",
      "MESSAGING_SCORE_LABEL": "Score boodschappen",
      "PERSONALIZED_PRACTICE_LABEL": "Oefenen op maat",
      "NO_PRODUCTS": "Geen producten voor oefenen op maat voor de geselecteerde teams",
      "TOTAL_TIME_SPENT_PRACTICING": "Totale oefentijd",
      "AVERAGE_SESSIONS_PER_USER": "Gemiddeld aantal sessies per gebruiker",
      "MOST_COMMON_CONVERSATION_TYPE_SELECTION": "Meest gekozen type gesprek",
      "LEAST_COMMON_CONVERSATION_TYPE_SELECTION": "Minst gekozen type gesprek",
      "CLEAR": "Wissen",
      "CLEAR_TEAMS": "Teams wissen",
      "METHODOLOGY_SCORE_DESCRIPTION": "Meet in hoeverre cursisten de aanbevolen gespreksstructuur volgen. De scores geven het gemiddelde weer van alle sessies van deze simulatie.",
      "METHODOLOGY": "Methodologie",
      "MESSAGING": "Boodschappen",
      "MESSAGING_V2_DASHBOARD_DESCRIPTION": "Meet of cursisten de belangrijkste ideeën tijdens het gesprek verwoorden. De grafieken tonen per thema het gemiddelde percentage correct verwoorde boodschappen, over alle sessies heen.",
      "NO_METRICS_MESSAGE": "Er zijn meer sessies nodig om inzichten te genereren.",
      "SELECT_ALL": "Alles selecteren",
      "DESELECT_ALL": "Alles deselecteren",
      "SKILLS": "Vaardigheden",
      "SKILLS_SCORE_STATS_DESCRIPTION": "Meet in hoeverre cursisten de belangrijkste vaardigheden tijdens het gesprek laten zien. De scores zijn een AI-beoordeling, gemiddeld over alle sessies.",
      "EXPERT": "Expert",
      "PROFICIENT": "Voldoende niveau",
      "DEVELOPING": "In ontwikkeling",
      "FULLY_ARTICULATED": "Volledig verwoord",
      "PARTIALLY_ARTICULATED": "Gedeeltelijk verwoord",
      "NOT_MENTIONED": "Niet vermeld",
      "MESSAGING_SCORE_STATS_DESCRIPTION": "Meet of cursisten de belangrijkste ideeën tijdens het gesprek verwoorden. De grafieken tonen hoe vaak elke boodschap correct is verwoord, over alle sessies heen.",
      "CLEAR_STATUS": "Status wissen",
      "CLEAR_USERS": "Gebruikers wissen",
      "CLEAR_SIMULATIONS": "Simulaties wissen",
      "CLEAR_ASSIGNMENTS": "Opdrachten wissen",
      "MODAL_SUBHEADING": "Alle {{ count }} doelstellingen: gemiddelde scores over alle sessies",
      "VIEW_ALL_OBJECTIVES": "Bekijk alle {{ count }} doelstellingen →",
      "LEAST_MISSED_QUESTION": "MINST GEMISTE VRAAG",
      "MOST_MISSED_QUESTION": "MEEST GEMISTE VRAAG",
      "HIGHEST_SCORING_METHODOLOGY_SECTION": "SECTIE METHODOLOGIE MET DE HOOGSTE SCORE",
      "LOWEST_SCORING_METHODOLOGY_SECTION": "SECTIE METHODOLOGIE MET DE LAAGSTE SCORE",
      "LEAST_ARTICULATED_MESSAGE": "MINST VERWOORDE BOODSCHAP",
      "ENGAGEMENT": "DEELNAME",
      "USER_ENGAGEMENT_MORE_SESSIONS": "meer sessies voltooid dan het teamgemiddelde",
      "USER_ENGAGEMENT_FEWER_SESSIONS": "minder sessies voltooid dan het teamgemiddelde",
      "QUESTION_CORRECT_PERCENTAGE_DESC": "van de keren hadden ze dit goed",
      "QUESTION_CORRECT_PERCENTAGE_DESC_ASSIGNMENT": "van de keren hebben gebruikers dit goed",
      "METHODOLOGY_AVERAGE_POINTS_DESC": "gem. aantal punten voor deze doelstelling over alle sessies",
      "MOST_ARTICULATED_MESSAGE": "MEEST VERWOORDE BOODSCHAP",
      "LEAST_MISSED_ANSWER_POINT": "MINST GEMISTE ANTWOORDPUNT",
      "MOST_MISSED_ANSWER_POINT": "MEEST GEMISTE ANTWOORDPUNT",
      "MOST_ARTICULATED_MESSAGE_DESCRIPTION": "van de keren verwoorden ze deze boodschap volledig",
      "LEAST_ARTICULATED_MESSAGE_DESCRIPTION": "van de keren verwoorden ze deze boodschap",
      "MOST_ARTICULATED_MESSAGE_DESCRIPTION_ASSIGNMENT": "van de keren verwoorden gebruikers deze boodschap",
      "LEAST_ARTICULATED_MESSAGE_DESCRIPTION_ASSIGNMENT": "van de keren verwoorden gebruikers deze boodschap",
      "OTHERS_SINGULAR": "en 1 andere",
      "OTHERS_PLURAL": "en {{ count }} andere",
      "PAGINATION_PREVIOUS": "Vorige",
      "PAGINATION_NEXT": "Volgende",
      "HOUR_LABEL": "uur",
      "SESSIONS_LABEL": "sessies"
    },
    "personalizedPractice": {
      "TITLE": "Oefenen op maat",
      "DESCRIPTION": "Hallo {{userFirstName}} Met oefenen op maat stel je zelf je scenario's in. Zo oefen je zo realistisch mogelijk.",
      "LOADING": "Bezig met laden ...",
      "VIEW_SESSIONS": "Sessies bekijken",
      "VIEW_SIMULATION": "Simulatie bekijken",
      "TOTAL_SESSION": "sessie in totaal",
      "TOTAL_SESSIONS": "sessies in totaal",
      "BREADCRUMB": "Oefenen op maat",
      "SCENARIO_DETAILS_TITLE": "Scenariodetails",
      "SCENARIO_DETAILS_DESCRIPTION": "Kies uit de onderstaande opties om de simulatie aan te passen aan je behoeften.",
      "AVATAR": "Avatar",
      "SELECT_PLACEHOLDER": "Selecteren",
      "CONVERSATION_TYPE": "Type gesprek",
      "SELECT_CONVERSATION_TYPE": "Selecteer het type gesprek",
      "LAUNCH_SIMULATION": "Simulatie starten met deze keuzes",
      "PREVIOUS_SESSIONS": "Eerdere sessies",
      "TOTAL": "Totaal",
      "FILTERS": "Filters:",
      "DATE": "Datum",
      "DIFFICULTY": "Moeilijkheidsgraad",
      "TEMPERAMENT": "Temperament",
      "SESSION_DATE": "Sessiedatum",
      "SESSION_SCORE": "Sessiescore",
      "DURATION": "Duur",
      "OVERALL_SCORE": "Totaalscore",
      "MESSAGING": "Boodschappen",
      "METHODOLOGY": "Methodologie",
      "SKILLS": "Vaardigheden",
      "RESULTS": "Resultaten",
      "VIEW_FEEDBACK": "Feedback bekijken",
      "OVERALL_SCORE_LABEL": "Totaalscore",
      "SCORE": "Score",
      "NO_PRODUCTS_TITLE": "Geen producten beschikbaar",
      "NO_PRODUCTS_DESCRIPTION": "Je hebt nog geen producten voor oefenen op maat.",
      "NO_SESSIONS_FOUND": "Geen sessies gevonden met de geselecteerde filters",
      "TIME": "Tijd",
      "ALL": "Alle",
      "LEARNER": "Cursist",
      "MOOD": "Stemming",
      "CLEAR_FILTERS": "Filters wissen",
      "PAGINATION_PREVIOUS": "Vorige",
      "PAGINATION_NEXT": "Volgende",
      "DURATION_MINUTES_SECONDS": "{{minutes}} min {{seconds}} s",
      "DURATION_SECONDS": "{{seconds}} s"
    },
    "login": {
      "TITLE": "Welkom terug",
      "SUB_TITLE": "Hoe wil je inloggen?  ",
      "LOGIN_WITH_SSO": "Inloggen met SSO van je bedrijf",
      "LOGIN_WITH_PASSWORD": "Inloggen met wachtwoord",
      "PROVIDE_EMAIL": "Vul je e-mailadres in",
      "HELP_TEXT": "Hulp nodig? Neem contact op met",
      "EMAIL_ERROR": "We kunnen je niet inloggen. Neem contact op met de beheerder of IT-afdeling van je bedrijf.",
      "EMAIL": "E-mail",
      "LOGIN": "Inloggen",
      "ALERT": "Melding",
      "EMAIL_PLACEHOLDER": "olivia@untitledui.com",
      "LOGIN_CONSENT_MESSAGE": "Door in te loggen op je account ga je akkoord met de {{termsLink}} en het {{privacyLink}}.",
      "TERMS_OF_SERVICE": "Gebruiksvoorwaarden",
      "PRIVACY_POLICY": "Privacybeleid",
      "WRONG_REGION_MESSAGE": "We kunnen je niet inloggen. Neem contact op met de beheerder van je bedrijf.",
      "WRONG_REGION_LINK": "Je kunt ook proberen in te loggen op de site voor {{regionName}}."
    },
    "learningPathway": {
      "BEGIN": "Beginnen",
      "SUBMIT_ANSWER": "Antwoord indienen",
      "CONTINUE": "Doorgaan",
      "REVIEW_MATERIAL": "Leerstof bekijken",
      "ASK_QUESTIONS_ABOUT_PATHWAY": "Stel vragen over het traject",
      "DUE_DATE": "Uiterste datum",
      "FOOTER_SUBTITLE_READY": "Vraag me maar wat je wilt! Ik sta klaar om je te helpen.",
      "FOOTER_SUBTITLE_READY_LEARN_WITH_X": "De coach luistert als je een vraag hebt",
      "FOOTER_SUBTITLE_MUTED": "Je microfoon is gedempt. De coach kan je niet horen.",
      "FOOTER_SUBTITLE_LISTENING": "Ik luister naar je vraag ...",
      "FOOTER_SUBTITLE_THINKING": "Ik denk na over een antwoord ...",
      "LEAVE_STEP": "Stap verlaten",
      "VIEW_CALL_DETAILS": "Gespreksdetails bekijken",
      "NEXT_STEP": "Volgende stap",
      "NOTIFICATIONS_ARIA": "Meldingen",
      "PDF_LOADING": "Pdf wordt geladen",
      "PDF_NEXT_PAGE": "Volgende pagina",
      "PDF_NO_SOURCE": "Er is geen pdf-bron opgegeven.",
      "PDF_PREVIOUS_PAGE": "Vorige pagina",
      "PDF_SCROLL_HINT": "Scrol om verder te lezen",
      "PDF_FULLSCREEN_ENTER": "Volledig scherm openen",
      "PDF_FULLSCREEN_EXIT": "Volledig scherm afsluiten",
      "PDF_ZOOM_IN": "Inzoomen",
      "PDF_ZOOM_OUT": "Uitzoomen",
      "POST_CALL_SUBTITLE": "Geef wat feedback terwijl we je resultaten verwerken",
      "POST_CALL_TITLE": "Je bent aan het einde van deze quiz gekomen.",
      "SETTINGS": "Instellingen",
      "TOAST_CONTENT": "Klik hieronder om de resultaten te bekijken, of ga terug naar het scherm met de trajectdetails voor je volgende stap.",
      "TOAST_TITLE": "De resultaten van je rollenspel {{ stepName }} zijn verwerkt",
      "ASSIGNMENTS": "Opdrachten",
      "USER_FALLBACK": "Gebruiker",
      "VIEW_RESULTS": "Resultaten bekijken",
      "DISMISS": "Sluiten",
      "QUIZ_TITLE": "Quiz",
      "QUIZ_OVERALL_SCORE_TOOLTIP": "De totaalscore is het gewogen gemiddelde van je antwoorden voor deze poging.",
      "COLUMN_DATE": "Datum",
      "COLUMN_OVERALL_SCORE": "Totaalscore",
      "COLUMN_RESULTS": "Resultaten",
      "COLUMN_ANSWER_POINTS": "Antwoordpunten",
      "COLUMN_MESSAGING_SCORE": "Score boodschappen",
      "COLUMN_METHODOLOGY_SCORE": "Score methodologie",
      "COLUMN_SKILLS_SCORE": "Score vaardigheden",
      "PRACTICE_AGAIN": "Opnieuw oefenen",
      "DEBRIEF_LATEST_SESSION": "Laatste sessie nabespreken",
      "COMPLETE_STEP": "Voltooien",
      "ERROR_TITLE": "Er is iets misgegaan",
      "ERROR_MESSAGE": "Verlaat het traject en open het opnieuw. Blijft het probleem bestaan? Neem dan contact op met",
      "ERROR_HELP_EMAIL": "help@quantified.ai",
      "PATHWAY_COMPLETED_TITLE": "Je hebt dit traject voltooid",
      "PATHWAY_COMPLETED_BODY": "Je kunt je resultaten op elk moment bekijken of een stap opnieuw doorlopen om te blijven oefenen.",
      "PATHWAY_COMPLETED_RETURN": "Terug naar opdrachten",
      "PATHWAY_OUT_OF_ATTEMPTS_TITLE": "Je hebt geen pogingen meer over voor een stap in het traject",
      "PATHWAY_OUT_OF_ATTEMPTS_BODY": "Neem contact op met je manager om de volgende stappen te bespreken.",
      "COMPLETED": "Voltooid",
      "EXITING_QUIZ_EARLY": "Als je deze quiz nu afsluit, telt dit als een poging",
      "TRY_AGAIN": "Opnieuw proberen",
      "RETURN_TO_PATHWAY": "Terug naar de startpagina van het traject",
      "REVIEW_BEFORE_QUIZ_TOOLTIP": "Bekijk deze stap nog eens voordat je de quiz opnieuw doet",
      "EXIT_MODAL_TITLE": "Weet je zeker dat je dit rollenspel wilt beëindigen?",
      "EXIT_MODAL_EXIT": "Afsluiten",
      "EXIT_MODAL_RESUME": "Hervatten",
      "EXIT_MODAL_DESC_LIMITED_ATTEMPTS": "Als je nu stopt, krijgt het rollenspel geen score, maar telt het wel als poging.",
      "EXIT_MODAL_DESC_UNLIMITED_ATTEMPTS": "Als je nu stopt, krijgt het rollenspel geen score.",
      "EXIT_MODAL_DESC_SCORED": "Als je het rollenspel nu verlaat, beoordelen we je gesprek zoals het nu is.",
      "RESULTS_PROCESSING": "Resultaten worden verwerkt",
      "RESULTS_FAILED": "We konden de resultaten niet laden. Neem contact op met help@quantified.ai",
      "DEBRIEF_TITLE": "Nabespreking",
      "DEBRIEF_DESCRIPTION": "Bespreek de resultaten van je laatste certificeringspoging",
      "DEBRIEF_DESCRIPTION_PRACTICE": "Bespreek de resultaten van je laatste oefensessie",
      "VIEW_ALL_SESSIONS": "Alle sessies bekijken",
      "COLLAPSE_SESSIONS": "Sessies verbergen",
      "VIEW_ALL_ATTEMPTS": "Alle pogingen bekijken",
      "COLLAPSE_ATTEMPTS": "Pogingen verbergen",
      "REATTEMPT_CERTIFICATION": "Certificering opnieuw proberen",
      "DEBRIEF_EXIT_MODAL_TITLE": "Weet je zeker dat je deze nabespreking wilt beëindigen?",
      "DEBRIEF_EXIT_MODAL_DESC": "Als je nu stopt, telt de nabespreking niet als voltooid.",
      "EXIT_PATHWAY": "Traject verlaten",
      "HELP": "Help",
      "DOWNLOAD": "Downloaden",
      "LEARN_STEP_HELP_CLOSE": "Sluiten",
      "LEARN_STEP_HELP_TROUBLE": "Heb je nog steeds problemen? Neem dan contact op met",
      "LEARN_STEP_HELP_EMAIL": "help@quantified.ai",
      "LEARN_STEP_HELP_VIDEO_P1": "Bekijk de leerstof en stel de coach al je vragen.",
      "LEARN_STEP_HELP_VIDEO_P2": "Klik op de afspeelknop om de video te starten. Je kunt terugspoelen om de leerstof nog eens te bekijken.",
      "LEARN_STEP_HELP_VIDEO_P3": "Schakel rechtsonder je microfoon in om een vraag te stellen. De video pauzeert dan. Zodra je de video afspeelt, dempen we je microfoon.",
      "LEARN_STEP_HELP_VIDEO_P4": "Als je de hele video hebt bekeken, ga je door naar de volgende stap.",
      "LEARN_STEP_HELP_PDF_P1": "Lees de leerstof en stel de coach al je vragen.",
      "LEARN_STEP_HELP_PDF_P2": "Scrol door de leerstof of gebruik de pijltjesknoppen aan beide kanten om tussen de pagina's te schakelen.",
      "LEARN_STEP_HELP_PDF_P3": "Rechtsonder kun je je microfoon dempen of weer inschakelen.",
      "LEARN_STEP_HELP_PDF_P4": "Als je alles hebt gelezen, ga je door naar de volgende stap.",
      "ASSESSMENT_EXIT_MODAL_TITLE": "Weet je zeker dat je verder wilt gaan?",
      "ASSESSMENT_EXIT_MODAL_DESC": "Als je verdergaat voordat dit gesprek is afgerond, wordt je leerervaring langer en minder persoonlijk.",
      "ASSESSMENT_EXIT_MODAL_RESUME": "Beoordeling hervatten",
      "ASSESSMENT_EXIT_MODAL_PROCEED": "Doorgaan",
      "ASSESSMENT_PERSONALIZATION_ERROR_TITLE": "We konden je traject niet personaliseren",
      "ASSESSMENT_PERSONALIZATION_ERROR_DESC_START": "We hebben je het volledige traject toegewezen. Neem contact op met ",
      "ASSESSMENT_PERSONALIZATION_ERROR_DESC_END": " als je de personalisatie opnieuw wilt proberen",
      "OPTIONAL": "Optioneel"
    },
    "leaderboard": {
      "LEADERBOARD": "Ranglijst",
      "TOP10PERCENT": "Top 10%",
      "PRACTICE_ASSIGNMENT": "Oefenopdrachten",
      "SIMULATION": "Simulatie",
      "SELECT_ASSIGNMENT": "Selecteer een opdracht",
      "SELECT_SIMULATION": "Selecteer een simulatie",
      "SELECT_ASSIGNMENT_AND_SIMULATION": "Selecteer een opdracht en simulatie om de koplopers te zien",
      "NO_DATA": "Nog geen activiteit. Zodra het team aan de slag gaat, verschijnt hier de ranglijst.",
      "NO_ASSIGNMENTS_AVAILABLE": "Geen opdrachten beschikbaar",
      "NO_SIMULATIONS_AVAILABLE": "Geen simulaties beschikbaar",
      "NAME": "Naam",
      "HIGH_SCORE": "Hoogste score",
      "AVERAGE_SCORE": "Gemiddelde score",
      "TOTAL_SESSIONS": "Totaal aantal sessies",
      "LAST_SESSION": "Laatste sessie",
      "TOP5": "Top 5",
      "OF": "van",
      "ENGAGED_USERS": "deelnemende gebruikers",
      "ENGAGED_USER": "deelnemende gebruiker",
      "NO_USERS_ENGAGED": "Geen deelnemende gebruikers",
      "HIDE_SESSIONS_WITH_LOW_SCORE": "Sessies met lage scores voor vaardigheden verbergen",
      "SESSIONS_WITH_LOW_SCORE_TOOLTIP": "Sessies met een score 'in ontwikkeling' voor de sectie Vaardigheden tellen niet mee voor de kolommen Hoogste score en Gemiddelde score.",
      "PAGINATION_PREVIOUS": "Vorige",
      "PAGINATION_NEXT": "Volgende"
    },
    "hotjarSurveys": {
      "FEEDBACK_MESSAGE": "Deel je feedback en help ons verbeteren.",
      "THANK_YOU_MESSAGE": "Bedankt, we blijven werken aan een betere ervaring voor jou"
    },
    "general": {
      "NO_ROLE_WEB_MESSAGE": "Deze gebruiker heeft nog geen toegang tot het systeem gekregen. Neem contact op met een systeembeheerder.",
      "NO_ROLE_IOS_TITLE": "Onze app draait om de ervaring van de cursist",
      "NO_ROLE_IOS_BODY_START": "Ga naar onze",
      "NO_ROLE_IOS_WEB_APP": "webapp",
      "NO_ROLE_IOS_BODY_END": "in je mobiele browser voor extra functies.",
      "NEED_HELP_QUESTION": "Hulp nodig?",
      "CONTACT": "Neem contact op met",
      "HELP_EMAIL": "help@quantified.ai",
      "PARENT_ACCOUNT": "Hoofdaccount",
      "ACCOUNT": "Account",
      "CHECKMARK": "Vinkje",
      "ICON": "Pictogram",
      "ALERT": "waarschuwing",
      "HEADS_UP": "Let op",
      "USE_HEADPHONES_FOR_OPTIMAL_AUDIO": "Gebruik een koptelefoon voor een optimale geluidsweergave op de iPad.",
      "SETTINGS": "INSTELLINGEN",
      "RP": "RP",
      "EMAIL_LABEL": "E-mail",
      "RAVEN_EMAIL": "Raven@InspireHR.com",
      "TEAM_MANAGER_FOR": "Teammanager voor",
      "MIAMI_SALE": "Miami Sale",
      "CHARLOTTE_SALES": "Charlotte Sales",
      "ATLANTA_SALES": "Atlanta Sales",
      "TEAM": "Team",
      "ASSIGNMENTS": "Opdrachten",
      "MY_TEAMS": "Mijn teams",
      "REPORTING": "Rapportage",
      "DASHBOARD": "Dashboard",
      "LEADERBOARD": "Ranglijst",
      "PERSONALIZED_PRACTICE": "Oefenen op maat",
      "HELP_SEARCH_OUR": "Zoek in onze",
      "HELP_OR_REACH_OUT_TO": "of neem contact op met",
      "HELP_WITH_QUESTIONS": "als je vragen hebt",
      "KNOWLEDGE_BASE": "kennisbank",
      "HELP_SECTION": "HELP",
      "ABOUT_SECTION": "OVER",
      "CONTACT_SUPPORT": "Contact opnemen met support",
      "OPEN_WEB_APP": "Webapp openen",
      "SEARCH_KNOWLEDGE_BASE": "Kennisbank doorzoeken",
      "PRIVACY_POLICY": "Privacybeleid",
      "TERMS_OF_SERVICE": "Gebruiksvoorwaarden",
      "VERSION": "Versie",
      "LOG_OUT": "Uitloggen"
    },
    "dashboard": {
      "ALL": "Alle",
      "IN_COMPLETE": "Onvolledig",
      "COMPLETED": "Voltooid",
      "NO_ASSIGNMENT_TITLE": "Je hebt geen opdrachten.",
      "NO_ASSIGNMENT_DETAILS": "Je krijgt een melding wanneer je opdrachten hebt om te voltooien.",
      "IN_COMPLETE_ASSIGNMENT_TITLE": "Je hebt geen onvoltooide opdrachten.",
      "IN_COMPLETE_ASSIGNMENT_DETAILS": "Je krijgt een melding als er een nieuwe opdracht op je wacht.",
      "COMPLETED_ASSIGNMENT_TITLE": "Je hebt geen voltooide opdrachten.",
      "COMPLETED_ASSIGNMENT_DETAILS": "Kom terug zodra je een opdracht hebt voltooid.",
      "NO_ASSIGNMENT_FILTERED_TITLE": "Geen opdrachten gevonden.",
      "NO_ASSIGNMENT_FILTERED_DETAILS": "Pas je filters aan om beschikbare opdrachten te zien, of kom later terug als er nieuwe opdrachten zijn.",
      "VIEW_ASSIGNMENT": "Opdracht bekijken",
      "VIEW_PATHWAY": "Traject bekijken",
      "START_PATHWAY": "Traject starten",
      "GET_STARTED": "Aan de slag",
      "ASSIGNMENT_LABEL": "Opdrachten",
      "MODULE_ASSIGNMENT_ALT": "Pictogram moduleopdracht",
      "VIEW_ASSIGNMENT_FOR": "Opdracht bekijken voor",
      "DAY": "Dag",
      "DAYS": "Dagen",
      "UNTILL_DUE": "tot de uiterste datum",
      "PAST_DUE": "Te laat",
      "AVAILABLE_IN": "Beschikbaar in",
      "DUE_TODAY": "Uiterlijk vandaag",
      "PRACTICE": "Oefenen",
      "CERTIFICATION": "Certificering",
      "UPCOMING": "Binnenkort",
      "TEST_ASSIGNMENT": "Testopdracht",
      "CLOSED": "Gesloten",
      "ENDED": "Beëindigd",
      "TOTAL": "Totaal",
      "ASSIGNMENT_STATUS_LABEL": "Opdrachtstatus",
      "ASSIGNMENT_STATUS_SELECTION_LABEL": "Opdrachtstatus:",
      "STATUS_SELECTION_LABEL": "Status:",
      "ASSIGNMENT_TYPE": "Type opdracht",
      "ASSIGNMENT_TYPE_SELECTION_LABEL": "Type opdracht:",
      "NOT_STARTED": "Nog niet gestart",
      "CERTIFIED": "Gecertificeerd",
      "NOT_CERTIFIED": "Niet gecertificeerd",
      "IN_PROGRESS": "In uitvoering",
      "PATHWAY": "Leertraject",
      "SELECT_ALL": "Alles selecteren",
      "DESELECT_ALL": "Alles deselecteren",
      "CLEAR_STATUS": "Status wissen",
      "OTHERS_SINGULAR": "en 1 andere",
      "OTHERS_PLURAL": "en {{ count }} andere"
    },
    "cognito": {
      "INVITATION_SUBJECT": "Welkom bij Quantified",
      "INVITATION_MESSAGE": "Fijn dat je erbij bent. Volg de onderstaande stappen om voor de eerste keer in te loggen op je account.",
      "ACCOUNT_DETAILS": "Je accountgegevens:",
      "USERNAME": "Gebruikersnaam",
      "PASSWORD": "Tijdelijk wachtwoord",
      "STEPS_LABEL": "Volgende stappen om in te loggen",
      "STEP_1": "1. Klik hieronder op de knop 'Inloggen' om naar de inlogpagina te gaan.",
      "STEP_2": "2. Voer de gebruikersnaam en het tijdelijke wachtwoord van hierboven in.",
      "STEP_3": "3. Na het inloggen stel je een nieuw wachtwoord in.",
      "LOGIN_BUTTON": "Inloggen",
      "ABOUT_US": "De Simulator van Quantified is een virtuele omgeving waarmee je snel essentiële vaardigheden opbouwt, zodat je effectiever contact kunt leggen en communiceren met klanten.",
      "EXPIRY_TIME": "Dit tijdelijke wachtwoord verloopt binnen 24 uur. Heb je problemen met inloggen? Neem dan contact op met ons supportteam via",
      "TEAM": "Het Quantified-team",
      "INVITATION_SMS_USERNAME": "Je gebruikersnaam is",
      "INVITATION_SMS_PASSWORD": "en je tijdelijke wachtwoord is",
      "AUTHENTICATION_CODE": "Je verificatiecode is",
      "PASSWORD_RESET_CODE": "Je Quantified-code om je wachtwoord opnieuw in te stellen",
      "RESET_PASSWORD_EMAIL": "E-mail om je wachtwoord opnieuw in te stellen",
      "HELLO": "Hallo",
      "USE_VERIFICATION_CODE": "Je hebt gevraagd om je wachtwoord opnieuw in te stellen. Gebruik de onderstaande verificatiecode om het proces te voltooien.",
      "VERIFICATION_CODE": "Verificatiecode",
      "NEXT_STEP": "Volgende stappen",
      "RETURN_TO_PATHWAY": "Terug naar de startpagina van het traject",
      "RESET_PASSWORD_PAGE": "Ga in je browser terug naar de pagina om je wachtwoord opnieuw in te stellen.",
      "ENTER_VERIFICATION_CODE": "Voer de verificatiecode in als we daarom vragen.",
      "CREATE_PASSWORD": "Zodra de code is geverifieerd, volg je de instructies om een nieuw wachtwoord aan te maken.",
      "DISREGARD_NOTE": "Heb je geen nieuw wachtwoord aangevraagd? Dan kun je deze e-mail negeren.",
      "CONTACT_SUPPORT": "Neem voor verdere hulp contact op met ons supportteam via",
      "HELP_EMAIL": "help@quantified.ai",
      "THANK_YOU": "Bedankt",
      "QUANTIFIED_TEAM": "Het Quantified-team",
      "ADDRESS": "4200 Marathon Blvd, Suite 210, Austin, Texas 78756, Verenigde Staten"
    },
    "call": {
      "LOADING": "Bezig met laden",
      "SIMULATION_PAUSED": "De simulatie is gepauzeerd.",
      "CLICK_RESUME": "Klik hieronder op de knop 'Hervatten' om door te gaan.",
      "NO_INTERNET": "Geen internetverbinding",
      "TRY_AGAIN": "Controleer je verbinding en probeer het opnieuw.",
      "MIC_MUTED": "Microfoon is gedempt",
      "MIC_MUTED_DESCRIPTION": "Oeps, is je microfoon misschien gedempt? Schakel de demping uit om te reageren en door te gaan.",
      "NO_RESPONSE": "Geen reactie gedetecteerd",
      "MIC_NOT_CONNECTED": "Oeps, is je microfoon misschien niet aangesloten? Selecteer je apparaat opnieuw om te reageren en door te gaan.",
      "AUDIO_ISSUE": "Oeps, er is iets misgegaan. Controleer de instellingen van je apparaat en zorg dat je op een rustige plek zit, zonder achtergrondgeluid.",
      "LOADING_ALT": "Bezig met laden ...",
      "REPEAT_RESPONSE": "We sturen je automatisch terug naar de simulatie, zodat je je antwoord kunt herhalen en het opnieuw kunt proberen.",
      "NEEDS_MORE_TIME_QUESTION": "heeft meer tijd nodig om na te denken. Wil je wachten?",
      "NEEDS_MORE_TIME": "heeft meer tijd nodig om na te denken.",
      "WAIT_OR_END_CALL": "We laten je weten wanneer die klaar is, of je kunt het gesprek beëindigen en",
      "RETURN_TO_ASSIGNMENTS": "terugkeren naar de opdracht",
      "READY": "Klaar",
      "IS_READY": "is klaar om je gesprek voort te zetten.",
      "TRY_AGAIN_LABEL": "Opnieuw proberen",
      "CHECK_SETTINGS": "Instellingen controleren",
      "PAUSED_SIMULATION": "Je hebt deze simulatie gepauzeerd.",
      "PAUSED_SIMULATION_DESCRIPTION": "De video- en audio-opname staan op pauze tot je de simulatie hervat.",
      "RESUME": "Hervatten",
      "SETTINGS": "Instellingen",
      "CAPTURING_RESPONSE": "Je antwoorden vastleggen",
      "TOUR_MESSAGE": "Klik als je klaar bent met spreken op de knop Doorgaan, zodat we je antwoorden kunnen vastleggen en beoordelen.",
      "NEXT": "Volgende",
      "START_CALL": "Starten",
      "END_CALL_TITLE": "Weet je zeker dat je deze simulatie wilt beëindigen?",
      "END_CALL_DESCRIPTION": "Als je de simulatie nu beëindigt, krijg je geen score of feedback op je gesprek.",
      "END_CALL": "Beëindigen",
      "BROWSER_ACCESS_DENIED": "Je browser heeft geen toegang tot dit apparaat.",
      "COPY_SESSION_ID_BUTTON": "Sessie-ID kopiëren",
      "RECONNECTING_AUDIO": "Audio wordt opnieuw verbonden ...",
      "TIPS_GUIDANCE_MESSAGE": "Gesprekspunten en tips verschijnen hier.",
      "CONTINUE": "Doorgaan",
      "SESSION_ID_LABEL": "Sessie-ID:",
      "SESSION_ID_COPIED": "Sessie-ID gekopieerd",
      "HINTS_AND_SUGGESTIONS_TITLE": "Tips en suggesties",
      "HINT_LABEL": "Tip",
      "CAPTIONS_LABEL": "Ondertitels",
      "PAUSE_LABEL": "Pauzeren",
      "VIDEO_LABEL": "Video",
      "SCREENSHARE_LABEL": "Scherm delen",
      "PARTY_EMOJI": "feest-emoji",
      "CALL_ENDED_MESSAGE": "Je bent aan het einde van deze simulatie gekomen.",
      "CALL_ENDED_INACTIVITY": "Deze simulatie is beëindigd vanwege inactiviteit",
      "CALL_ENDED_GENERIC": "Deze simulatie is beëindigd",
      "FEEDBACK_PROMPT": "Geef wat feedback terwijl we je resultaten verwerken.",
      "INTERACTION_THRESHOLD_NOT_MET": "Er was te weinig interactie tijdens het gesprek om een score te geven. Probeer het opnieuw.",
      "REALISTIC_CONVERSATION_QUESTION": "Voelde dit gesprek realistisch en natuurlijk aan?",
      "KNOWLEDGEABLE_PREPARED_QUESTION": "Weet je na deze simulatie meer en voel je je beter voorbereid?",
      "FEEDBACK_THANK_YOU": "Bedankt voor je feedback.",
      "FEEDBACK_IMPROVEMENT_NOTE": "Bedankt voor je feedback. We gebruiken deze info om de ervaring te verbeteren.",
      "AUDIO": "Audio",
      "MUTE": "Dempen",
      "UNMUTE": "Dempen opheffen",
      "VISUAL_AID_LOAD_ERROR": "We konden het visuele hulpmiddel niet laden",
      "BEGIN_CALL": "Starten",
      "LEAVE_STEP_TITLE": "Weet je zeker dat je deze stap wilt verlaten?",
      "EXIT": "Afsluiten",
      "LEAVE_CALL_BRIEFING": "Briefing verlaten",
      "RESTORE_CALL": "We herstellen je simulatie",
      "FEW_SECONDS": "Dit kan enkele seconden duren.",
      "CHECK_ALT": "Vinkje",
      "COPY_ALT": "Kopiëren",
      "HINTS_ALT": "Tips",
      "CLOSE_CAPTIONS": "Ondertiteling",
      "MICROPHONE_MUTED": "Microfoon gedempt",
      "RETURN_TO_CALL": "Terug naar de simulatie",
      "YES": "Ja",
      "NO": "Nee",
      "VIEW_RESULTS": "Resultaten bekijken",
      "RETURN_TO_ASSIGNMENT": "Terug naar de opdracht",
      "HAVING_ISSUES": "We hebben problemen met de verbinding. Controleer je internetverbinding en klik dan op OK.",
      "OK": "OK",
      "RESULTS_NOT_GENERATED": "Sorry, we kunnen op dit moment geen resultaten genereren. Probeer het opnieuw.",
      "INACTIVITY_ALERT_MESSAGE": "Dit gesprek stopt omdat er geen activiteit is. Spreek tegen de avatar om door te gaan of selecteer 'Gesprek beëindigen' om het gesprek te beëindigen.",
      "INACTIVITY_DEFAULT_ALERT_TITLE": "Dit gesprek stopt over {{secondsUntilHangup}} seconden",
      "INACTIVITY_SHORT_ALERT_TITLE": "Dit gesprek stopt over enkele seconden",
      "TELL_YOUR_GENDER_HEADING": "Wat is je geslacht?",
      "BY_KNOWING_YOUR_GENDER_DESCRIPTION": "Door je geslacht te kennen, kan de avatar de juiste grammatica gebruiken, waardoor het gesprek natuurlijker en realistischer verloopt.",
      "GENDER_SELECTION": "Geslachtskeuze:",
      "SELECT_OPTION": "Kies een optie",
      "CONFIRM": "Bevestigen",
      "MALE": "Man",
      "FEMALE": "Vrouw",
      "NON_BINARY": "Non-binair/Overig",
      "PREFER_NOT_TO_ANSWER": "Ik geef liever geen antwoord",
      "NON_BINARY_MESSAGE": "We begrijpen en respecteren je non-binaire genderidentiteit. Vanwege de huidige technologische beperkingen gebruiken we standaard mannelijke voornaamwoorden. We werken eraan om in de toekomst beter rekening te houden met alle genderidentiteiten. Bedankt voor je begrip en geduld.",
      "PREFER_NOT_TO_ANSWER_MESSAGE": "We respecteren je keuze om geen geslacht op te geven. In dergelijke gevallen gebruikt onze technologie standaard mannelijke voornaamwoorden vanwege de huidige beperkingen.",
      "DISPLAY_VISUAL_AID": "Visueel hulpmiddel tonen",
      "FULL_SCREEN": "Volledig scherm",
      "COLLAPSE": "Samenvouwen",
      "COMPLETED_CONVERSATION_MESSAGE": "Bedankt voor het afronden van dit gesprek",
      "CONVERSATION_COMPLETION_FEEDBACK": "Geef wat feedback terwijl wij je gesprek verwerken.",
      "ERROR_MESSAGE": "Er is een fout opgetreden. Neem contact op met",
      "SAVED_CONVERSATION_MESSAGE": "Je gesprek is opgeslagen.",
      "RETURN_TO_MY_ASSIGNMENTS": "Terug naar mijn opdrachten",
      "RETURN_TO_PERSONALIZED_PRACTICE": "Terug naar oefenen op maat",
      "CERT_ACK_TITLE": "Bevestiging van de certificeringsvideo",
      "CERT_ACK_ACCEPT_AND_BEGIN": "Accepteren en beginnen",
      "CERT_ACK_RESUME_CALL": "Gesprek hervatten",
      "CERT_ACK_PROCESSING": "Bezig met verwerken ...",
      "CERT_ACK_CAMERA_WARNING": "Schakel je camera in om door te gaan met de certificering.",
      "CERT_ACK_CAMERA_OFF_DURING_CALL": "Je camera is uitgeschakeld. Schakel je camera opnieuw in om de certificering te hervatten.",
      "CERT_ACK_TEXT_1": "Om deze certificering eerlijk te houden, moet je camera de hele sessie aan blijven en houden we toezicht op de sessie. Zo weten we zeker dat aan alle certificeringsnormen is voldaan.",
      "CERT_ACK_TEXT_2": "Als je verdergaat, ga je akkoord met deze vereisten.",
      "CERT_ACK_END_CALL": "Gesprek beëindigen",
      "LAUNCH_SIMULATION": "Simulatie starten",
      "DEBRIEF_LATEST_SESSION": "Laatste sessie nabespreken",
      "END": "Beëindigen",
      "START_DEBRIEF": "Laatste sessie nabespreken",
      "MOVE_TO_NEXT": "Naar de volgende stap",
      "RETRY_ROLEPLAY": "Rollenspel opnieuw proberen",
      "EXIT_PATHWAY": "Traject verlaten",
      "PROCESSING": "Bezig met verwerken ...",
      "FEEDBACK_PROMPT_REQUIRED": "Geef wat feedback voordat je je resultaten bekijkt.",
      "SCREENSHARE_UNSUPPORTED_TITLE": "{{callName}} gebruikt scherm delen",
      "SCREENSHARE_UNSUPPORTED_MESSAGE_APP": "Gebruik onze app in plaats van je browser om verder te gaan met het gesprek.",
      "SCREENSHARE_UNSUPPORTED_MESSAGE_DESKTOP": "Open het gesprek op een desktopcomputer om verder te gaan.",
      "SCREENSHARE_UNSUPPORTED_CLOSE_BUTTON": "Sluiten",
      "SCREENSHARE_UNSUPPORTED_GO_TO_APP_BUTTON": "Naar de app",
      "SCREENSHARE_UNSUPPORTED_GO_TO_APP_UNAVAILABLE": "De mobiele app is nog niet beschikbaar. Kom binnenkort nog eens terug.",
      "SCREENSHARE_STOP_LABEL": "Stoppen met scherm delen",
      "SCREENSHARE_PIP_REOPEN_LABEL": "Videovoorbeeld opnieuw openen",
      "SCREENSHARE_ACTIVE_LABEL": "Je deelt je scherm",
      "SCREENSHARE_OS_PERMISSION_HINT": "Scherm delen kon niet worden gestart. Schakel schermopname in voor je browser via Systeeminstellingen > Privacy en beveiliging en probeer het opnieuw.",
      "SCREENSHARE_SAFARI_BLOCKED_HINT": "Safari heeft scherm delen voor deze sessie geblokkeerd. Log uit en weer in en probeer het opnieuw."
    },
    "assignment": {
      "STATUS": "STATUS",
      "SCORE": "SCORE",
      "MUST_ACHIEVE": "Minimaal vereist:",
      "OR_HIGHER": "of hoger",
      "TEST": "Test",
      "OUT_OF_5": "van de 5",
      "LATEST_ATTEMPT": "LAATSTE POGING",
      "TOTAL_ATTEMPTS": "pogingen in totaal",
      "UNLIMITED": "Onbeperkt",
      "REMAINING": "Resterend",
      "VIEW_CALL_DETAILS": "Details bekijken",
      "MAX_ATTEMPTS_REACHED": "Je hebt het maximale aantal pogingen bereikt",
      "DUE_DATE": "Uiterste datum",
      "DAYS": "Dagen",
      "DAY": "Dag",
      "UNTILL_DUE": "tot de uiterste datum",
      "PAST_DUE": "Te laat",
      "ONGOING": "Lopend",
      "SCORE_REQUIREMENT": "Vereiste score",
      "SCORE_REQUIREMENT_DETAIL": "Je moet een score behalen van",
      "TO_COMPLETE_EACH_CALL": "om elke vereiste simulatie te voltooien.",
      "CALLS_IN_ASSIGNMENT": "Simulaties in de opdracht",
      "COMPLETED_CALLS": "Voltooide gesprekken",
      "INCOMPLETE_CALL": "Onvolledig",
      "PREVIOUS_RESULTS": "Eerdere resultaten",
      "DATE": "Datum",
      "RESULTS": "Resultaten",
      "VIEW_PREVIOUS_RESULTS": "Eerdere resultaten bekijken",
      "VIEW_FEEDBACK": "Feedback bekijken",
      "LAUNCH_CALL": "Starten",
      "CLOSE_BUTTON": "Knop Sluiten",
      "CHECKMARK": "vinkje",
      "CALL": "Gesprek",
      "QUESTION": "Vraag",
      "COMPLETED": "Voltooid",
      "IN_PROGRESS": "In uitvoering",
      "NOT_STARTED": "Nog niet gestart",
      "CERTIFIED": "Gecertificeerd",
      "GUIDED": "Begeleid",
      "CONVERSATIONAL": "Vrij gesprek",
      "GUIDED_SIMULATION": "Kennistest",
      "CONVERSATIONAL_SIMULATION": "Rollenspel",
      "NO_ATTEMPTS_LEFT": "Geen pogingen meer over",
      "NO_ATTEMPTS": "Geen pogingen",
      "OVERVIEW": "Overzicht",
      "ABOUT_THE_AVATAR": "Over de avatar",
      "SCORING_CRITERIA": "Beoordelingscriteria",
      "SIMULATION_OVERVIEW": "Overzicht van de simulatie",
      "ABOUT_THE_PERSONA": "Over de persona",
      "OUTOF_COMPLIANCE": "Niet-conform",
      "CLOSED": "Gesloten"
    }
  },
  "ko": {
    "root": {
      "ADMIN_PORTAL": "관리자 포털",
      "SUPPORT": "지원",
      "U": "U",
      "USER": "사용자",
      "LOGOUT": "로그아웃",
      "ADMIN": "관리자",
      "SUPPORT_SMALL": "지원",
      "QUANTIFIED_AI": "Quantified.AI",
      "MICROPHONE": "마이크",
      "CAMERA": "카메라",
      "ACCESS_DENIED": "접근_거부됨"
    },
    "teams": {
      "MY_TEAMS": "내 팀",
      "COMPLETED": "완료됨",
      "IN_PROGRESS": "진행 중",
      "NOT_STARTED": "시작하지 않음",
      "ASSIGNMET_MODULE": "과제 모듈",
      "START_DATE": "시작 날짜",
      "DUE_DATE": "마감일",
      "ASSIGNED_MEMBERS": "할당된 팀원",
      "CALLS_IN_MODULE": "모듈 내 시뮬레이션",
      "COMPLETION_REQUIRMENT": "완료 요구 사항",
      "COMPLETE_ALL_CALLS": "모든 시뮬레이션을",
      "OR_HIGHER": "또는 그 이상의 점수를 달성해야 합니다",
      "PROGRESS_OVERVIEW": "진행 상황 개요",
      "TEAM_MEMBERS": "팀원",
      "AVERAGE_HIGH_SCORE": "평균 최고 점수",
      "AVERAGE_NUMBER_ATTEMPTS_CALL": "시뮬레이션당 평균 시도 횟수",
      "TOTAL_PRACTICES": "총 연습 횟수",
      "INDIVIDUAL_CALL_PROGRESS": "개인별 시뮬레이션 진행 상황",
      "OF_TEAM_MEMBERS": "팀원 완료함",
      "AVERAGE_PRACTICES_TO_COMPLETION": "완료까지 평균 연습 횟수",
      "TEAM_MEMBER_DETAILS": "팀원 상세 정보",
      "DOWNLOAD_ACTIVITY_REPORT": "활동 보고서 다운로드",
      "TEAM_MEMBER": "팀원",
      "PROGRESS": "진행 상황",
      "CALLS_COMPLETED": "완료된 시뮬레이션 수",
      "PRACTICES": "연습 세션 수",
      "MOST_RECENT_PRACTICE": "가장 최근 세션",
      "THIS_TEAM_HAS_NO_ACTIVE_ASSIGNMENTS": "현재 이 팀에는 진행 중인 과제가 없습니다",
      "CALL_NAME_LABEL": "시뮬레이션 이름",
      "HIGHEST_SCORE": "최고 점수"
    },
    "simulationBuilder": {
      "THRESHOLD": "기준 점수",
      "TYPE": "유형",
      "SELECT_AN_OPTION": "옵션을 선택하세요",
      "CORRECT_FEEDBACK": "올바른 피드백",
      "INCORRECT_FEEDBACK": "올바르지 않은 피드백",
      "CORRECT_FEEDBACK_PLACEHOLDER": "학습자가 올바른 피드백을 한 경우 표시됨",
      "INCORRECT_FEEDBACK_PLACEHOLDER": "학습자가 올바르지 않은 피드백을 한 경우 표시됨",
      "MESSAGE_NUMBER": "메시지 {{ index }}",
      "ENTER_MESSAGE_TEXT": "메시지 내용을 입력하세요...",
      "FACT_MESSAGE_LABEL": "메시지",
      "FACT_MESSAGE_DESCRIPTION": "메시지는 하나의 정보를 담고 있어야 하며, 완전한 문장으로 작성되어야 합니다. 메시지는 구체적이고, 단순하며, 제한적인 범위를 다루도록 작성하세요. 부분적으로만 전달될 가능성이 있는 메시지는 피하세요.",
      "FACT_INCORRECT_ANSWER_LABEL": "오답 텍스트",
      "FACT_INCORRECT_ANSWER_DESCRIPTION": "학습자가 이 사실을 틀렸을 때 표시되는 텍스트",
      "SHOW_INCORRECT_ANSWER_TEXT": "틀린 답변에 대한 대체 텍스트 표시",
      "ADD_NEW_FACT": "새로운 사실 추가",
      "FACT_SINGULAR": "사실",
      "FACT_PLURAL": "사실",
      "FACT_EXTRACTED_SINGULAR": "{{ count }}개의 사실 추출됨",
      "FACT_EXTRACTED_PLURAL": "{{ count }}개의 사실 추출됨",
      "FACTS_CANNOT_BE_EMPTY": "사실 항목은 비워둘 수 없습니다. 테스트하거나 게시하기 전에 각 사실에 메시지를 추가하세요.",
      "REVIEW_REQUIRED_LABEL": "검토 권장",
      "DELETE": "삭제",
      "SCORABLE": "채점 가능",
      "SEARCH_BY_SIMULATION_NAME": "시뮬레이션 이름으로 검색",
      "SIMULATION_STATUS_PLACEHOLDER": "시뮬레이션 상태",
      "SIMULATION_STATUS_PREFIX": "시뮬레이션 상태:",
      "NO_SIMULATIONS_FOUND": "시뮬레이션이 없습니다",
      "SELECT_ALL": "모두 선택",
      "DESELECT_ALL": "모두 선택 해제",
      "STATUS_TESTING": "테스트",
      "STATUS_DRAFT": "초안",
      "STATUS_PUBLISHED": "게시됨",
      "STATUS_ARCHIVED": "보관됨",
      "SEARCH_BY_ASSIGNMENT_NAME": "과제명으로 검색",
      "ASSIGNEES_ZERO_STATE_MESSAGE": "아직 할당된 사용자가 없습니다",
      "ADD_USERS_TO_ASSIGNMENT": "과제에 사용자 추가",
      "NO_DATA_FOUND": "데이터가 없습니다!",
      "NO_USERS_SELECTED": "선택된 사용자가 없습니다",
      "COL_FIRST_NAME": "이름",
      "COL_LAST_NAME": "성",
      "COL_EMAIL": "이메일",
      "COL_VIEW_USER": "사용자 보기",
      "COL_VIEW_ASSIGNMENT": "과제 보기",
      "COL_ASSIGNMENT_NAME": "과제명",
      "COL_STATUS": "상태",
      "COL_TEAM_ASSOCIATIONS": "팀 연결",
      "COL_REPORTING_STATUS": "리포트 상태",
      "BREADCRUMB_USERS": "사용자",
      "STATUS_STAGED": "준비됨",
      "STATUS_ACTIVE": "활성",
      "STATUS_ENDED": "종료됨",
      "STATUS_CLOSED": "마감됨",
      "SEARCH_USERS_PLACEHOLDER": "사용자 검색",
      "NO_USERS_FOUND": "사용자가 없습니다",
      "USERS_TAB_LABEL": "사용자",
      "ADD_TO_ASSIGNMENT": "과제에 추가",
      "ASSIGNMENTS_COUNT": "과제",
      "REPORTING_EXCLUDED": "제외됨",
      "REPORTING_INCLUDED": "포함됨",
      "KEBAB_EDIT_TEAM_ASSOCIATIONS": "팀 연결 정보 편집",
      "KEBAB_EXCLUDE_FROM_REPORTING": "리포트에서 제외",
      "KEBAB_INCLUDE_IN_REPORTING": "리포트에 포함",
      "KEBAB_REMOVE_FROM_ASSIGNMENT": "과제에서 제거",
      "NO_TEAMS": "—",
      "TEAMS_COUNT": "{{ count }}개 팀",
      "ADD_TO_ASSIGNMENT_MODAL_HEADING": "과제에 추가",
      "FIELD_LABEL_ASSIGNMENT": "과제",
      "SEARCH_ASSIGNMENTS_PLACEHOLDER": "과제 검색",
      "BUTTON_SET_TEAM_ASSOCIATION": "팀 연결 설정",
      "FIELD_LABEL_TEAM": "팀",
      "SEARCH_TEAM_PLACEHOLDER": "팀 검색",
      "BUTTON_BACK": "뒤로",
      "BUTTON_CANCEL": "취소",
      "BUTTON_ADD_TO_ASSIGNMENT": "과제에 추가",
      "EDIT_TEAM_ASSOCIATIONS_HEADING": "팀 연결 정보 편집",
      "EDIT_TEAM_ASSOCIATIONS_DESCRIPTION": "{{ assignmentName }} 과제 관련",
      "BUTTON_SAVE_ASSOCIATIONS": "연결 저장",
      "REFERENCE_DOCUMENT_STATUS_UPLOADING": "– 업로드 중...",
      "REFERENCE_DOCUMENT_STATUS_SUCCESS": "– 100% 업로드됨",
      "REFERENCE_DOCUMENT_STATUS_ERROR": "– 업로드 오류",
      "REFERENCE_DOCUMENT_STATUS_DELETING": "– 삭제 중",
      "REFERENCE_DOCUMENT_DELETE_ERROR": "문서 삭제에 실패했습니다. 다시 시도해 주세요.",
      "REFERENCE_DOCUMENT_UPLOAD_ERROR": "문서 업로드에 실패했습니다. 다시 시도해 주세요.",
      "CONTENT_LIMIT_EXCEEDED_ERROR": "콘텐츠가 초과되었습니다. 계속하려면 하나 이상의 문서를 삭제하세요.",
      "LAST_FACT_DELETE_WARNING_HEADING": "마지막 사실을 삭제하시겠습니까?",
      "LAST_FACT_DELETE_WARNING_DESCRIPTION": "마지막 사실을 삭제하면 이 시뮬레이션과 관련된 모든 사용자 연결이 제거되고 초안 상태로 되돌아갑니다.",
      "LEAVE_CONFIRMATION_HEADING": "시뮬레이션 생성을 종료합니다",
      "LEAVE_CONFIRMATION_DESCRIPTION": "정말 종료하시겠습니까? 지금까지 진행한 모든 내용이 사라집니다.",
      "LEAVE_CONFIRMATION_LEAVE_BUTTON": "종료",
      "CREATE_SIMULATION_DETAILS_BUTTON": "시뮬레이션 상세 정보 생성",
      "SELF_AUTHORING_DESCRIPTION": "시뮬레이션 이름, 간단한 시나리오 설명 및 시뮬레이션 관련 문서를 입력하여 시작하세요",
      "CLICK_TO_UPLOAD": "PDF를 클릭하거나",
      "OR_DRAG_AND_DROP": "끌어다 놓기 하여",
      "REFERENCE_DOCUMENTS_UPLOAD_DESCRIPTION": "업로드하세요(최대 50MB)",
      "ASSIGNMENT_NAME_LABEL": "과제명 *",
      "SIMULATION_NAME_LABEL": "시뮬레이션 이름",
      "NAME_FIELD_DESCRIPTION": "이 이름은 나중에 변경할 수 있습니다",
      "PRODUCT_LABEL": "제품",
      "SELECT_A_PRODUCT_PLACEHOLDER": "제품 선택",
      "ADD_NEW_PRODUCT": "새 제품 추가",
      "SCENARIO_LABEL": "시나리오",
      "REFERENCE_DOCUMENTS_LABEL": "참조 문서",
      "ACTION_CREATE_NEW": "새로 만들기",
      "ACTION_CREATE": "생성",
      "ACTION_DUPLICATE": "복제",
      "ENTITY_TYPE_SIMULATION_DISPLAY": "시뮬레이션",
      "ENTITY_TYPE_ASSIGNMENT_DISPLAY": "과제",
      "ENTITY_TYPE_SIMULATION_LOWER": "시뮬레이션",
      "ENTITY_TYPE_ASSIGNMENT_LOWER": "과제",
      "MODAL_TITLE": "{{ action }} {{ type }}",
      "CONFIRM_BUTTON_LABEL": "{{ action }} {{ type }}",
      "DUPLICATE_NAME_ERROR_ASSIGNMENT": "동일한 이름의 과제가 이미 존재합니다.",
      "DUPLICATE_NAME_ERROR_SIMULATION": "동일한 이름의 시뮬레이션이 이미 존재합니다.",
      "NAME_REQUIRED_ERROR": "이름을 입력해야 합니다.",
      "COPY_OF_PREFIX": "{{ name }} - 복사본",
      "SCORE_DISTRIBUTION_TITLE": "현재 점수 분포",
      "EDIT_SECTIONS_AND_WEIGHTING": "섹션 및 가중치 편집",
      "SCORING_WEIGHTS_TITLE": "채점 구성",
      "SCORING_WEIGHTS_DESCRIPTION": "점수를 매길 영역을 선택하고 각 영역이 전체 성적에 얼마나 기여할지 결정하세요. 활성화된 모든 섹션의 가중치 합계는 100%가 되어야 합니다. 스킬 섹션의 가중치는 20%를 초과할 수 없습니다.",
      "SCORING_WEIGHT_REQUIRED": "필수",
      "MESSAGING_TITLE": "메시지",
      "MESSAGING_SUBTITLE": "핵심 사실이 전달되었는지 여부를 채점합니다",
      "METHODOLOGY_TITLE": "방법론",
      "METHODOLOGY_SUBTITLE": "접근 방식과 통화 구조를 채점합니다",
      "METHODOLOGY_WEIGHTING_LABEL": "가중치: {{ weight }}%",
      "METHODOLOGY_RUBRIC_LABEL": "방법론 평가 기준",
      "SELECT_RUBRIC_PLACEHOLDER": "평가 기준 선택",
      "SKILLS_TITLE": "스킬",
      "SKILLS_SUBTITLE": "의사소통 및 소프트 스킬을 채점합니다",
      "SKILLS_WEIGHTING_LABEL": "가중치: {{ weight }}%",
      "SKILLS_RUBRIC_LABEL": "스킬 평가 기준",
      "PROCESSING_DOCUMENTS_MESSAGE": "문서 처리 중...",
      "PROCESSING_DOCUMENTS_SUPPORTING_TEXT": "잠시 기다려 주세요. 5분 내로 결과 준비가 완료됩니다.",
      "CORE_SIGNAL_MESSAGE": "콘텐츠 분석 중...",
      "SECTION_PLAN_MESSAGE": "시뮬레이션 구조 계획 중...",
      "DERIVED_COMPONENT_MESSAGE": "시뮬레이션 구성 요소 생성 중...",
      "COMPONENT_WAVE_1_MESSAGE": "시뮬레이션 콘텐츠 작성 중...",
      "COMPONENT_WAVE_2_MESSAGE": "시뮬레이션 콘텐츠 다듬는 중...",
      "COMPONENT_WAVE_3_MESSAGE": "시뮬레이션 콘텐츠 마무리 중...",
      "MESSAGE_ADHERENCE_MESSAGE": "메시지 채점 기준 제안 중...",
      "ASSEMBLING_MESSAGE": "시뮬레이션 조립 중...",
      "FINISHING_SIMULATION_MESSAGE": "시뮬레이션 완료 중...",
      "STILL_PROCESSING_TITLE": "아직 처리 중입니다...",
      "STILL_PROCESSING_BODY": "평소보다 시간이 더 오래 걸리고 있습니다. 이 시뮬레이션에서 벗어나더라도, 나중에 시뮬레이션 목록 화면을 통해 다시 돌아오실 수 있습니다.",
      "PROCESSING_FAILED_TITLE": "처리 실패",
      "PROCESSING_FAILED_BODY": "문서 처리 중 문제가 발생했습니다. 다시 시도해 주세요. 문제가 지속될 경우 ",
      "PROCESSING_FAILED_SUFFIX": " 문의해 주세요.",
      "BUTTON_RETRY": "다시 시도",
      "TOKEN_LIMIT_EXCEEDED_BODY_PREFIX": "콘텐츠가 초과되었습니다. 하나 이상의 문서를 제거한 후 다시 시도하거나 다음 연락처로 문의해 주세요. ",
      "TOKEN_LIMIT_EXCEEDED_BODY_SUFFIX": " 문의해 주세요.",
      "TEST_SIMULATION_BUTTON": "시뮬레이션 테스트",
      "SIMULATION_PROCESSED_TITLE": "문서 처리 완료",
      "SIMULATION_PROCESSED_BODY": "시뮬레이션 문서가 처리되었습니다.",
      "SIMULATION_DOCUMENTS_PROCESSED_TITLE": "시뮬레이션 문서가 처리되었습니다.",
      "SIMULATION_DOCUMENTS_PROCESSED_BODY": "{{ name }} 시뮬레이션에 업로드한 문서가 처리되었습니다.",
      "SIMULATION_DOCUMENTS_FAILED_TITLE": "시뮬레이션 문서 처리에 실패했습니다.",
      "SIMULATION_DOCUMENTS_FAILED_BODY": "{{ name }} 시뮬레이션에 업로드한 문서가 처리되지 않았습니다.",
      "DISMISS": "닫기",
      "VIEW_SIMULATION": "시뮬레이션 보기",
      "AVATAR_LOOK_LABEL": "외형",
      "AVATAR_SELECT_PLACEHOLDER": "아바타 선택",
      "AVATAR_VOICE_LABEL": "음성",
      "AVATAR_ALT": "아바타",
      "PLAY_VOICE_PREVIEW_BUTTON": "음성 미리 듣기 재생",
      "VOICE_OPTION_1": "음성 1",
      "VOICE_OPTION_2": "음성 2",
      "BACK_TO_SIMULATION_DETAILS_BUTTON": "시뮬레이션 상세 정보로 돌아가기",
      "AVATAR_SELECTION_TITLE": "아바타 선택",
      "VIEW_DOCUMENTS": "문서 보기",
      "SELECT_AVATAR_BUTTON": "아바타 선택",
      "REQUEST_CHANGES_PLACEHOLDER": "위 정보에 대한 수정 요청",
      "CALL_DETAILS_LOAD_ERROR": "통화 상세 정보를 불러오지 못했습니다. 다시 시도해 주세요.",
      "BLANK_THEME_MESSAGE_TOOLTIP": "새 주제를 추가하기 전에 빈 메시지에 텍스트를 입력하세요.",
      "BLANK_MESSAGE_TOOLTIP": "다른 메시지를 추가하기 전에 이 메시지에 텍스트를 추가해 주세요.",
      "ADD_NEW_THEME_BUTTON": "새 주제 추가",
      "ADD_THEME_BUTTON": "주제 추가",
      "ADD_MESSAGE_BUTTON": "메시지 추가",
      "SCORE_LAST_SESSION": "내 마지막 세션 채점",
      "SCORE_LAST_SESSION_MODAL_HEADING": "마지막 세션 채점",
      "SCORE_LAST_SESSION_MODAL_DESCRIPTION": "먼저 시뮬레이션을 테스트한 다음, 여기로 돌아와 선택한 평가 기준에 따라 채점합니다.",
      "SCORE_LAST_SESSION_MODAL_ERROR_HEADING": "문제가 발생했습니다",
      "SCORE_LAST_SESSION_MODAL_ERROR_DESCRIPTION": "다시 시도하세요.",
      "REFINEMENT_THINKING_MESSAGE": "생각 중...",
      "REFINEMENT_UPDATED_MESSAGE": "업데이트됨",
      "REFINEMENT_WARNING_PREFIX": "이 정보는 수동으로 수정된 내용입니다. 업데이트 사항이 있는지 확인하려면",
      "REFINEMENT_WARNING_SUFFIX": "에 문의해 주세요.",
      "REFINEMENT_ERROR_PREFIX": "안타깝게도 제가 도와드릴 수는 없지만,",
      "REFINEMENT_ERROR_SUFFIX": "이(가) 도움이 될 수 있을지도 모릅니다.",
      "REFINEMENT_APPLIED_TITLE": "요청하신 변경 사항이 적용되었습니다.",
      "REFINEMENT_APPLIED_BODY": "{{ name }} 시뮬레이션에 대해 요청하신 변경 사항이 적용되었습니다.",
      "REFINEMENT_FAILED_TITLE": "요청하신 변경 사항을 적용하는 데 실패했습니다.",
      "REFINEMENT_FAILED_BODY": "{{ name }} 시뮬레이션에 대해 요청하신 변경 사항을 적용하지 못했습니다.",
      "WHAT_USERS_SEE_DESCRIPTION_TITLE": "시뮬레이션 설명",
      "WHAT_USERS_SEE_DESCRIPTION_HELPER": "'일반' 탭에서 업데이트된 정보는 수동으로 수정하지 않는 한 여기에 반영됩니다.",
      "WHAT_USERS_SEE_DESCRIPTION_FIELD_LABEL": "설명",
      "WHAT_USERS_SEE_DETAILS_TITLE": "시뮬레이션 상세 정보",
      "WHAT_USERS_SEE_DETAILS_HELPER": "이 내용은 사용자가 시뮬레이션을 시작하기 전에 제공됩니다. '일반' 탭에서 업데이트된 정보는 수동으로 수정하지 않는 한 여기에 반영됩니다. 비워 둔 섹션은 학습자에게 표시되지 않습니다. 모든 섹션에서 마크다운 서식을 사용할 수 있습니다.",
      "WHAT_USERS_SEE_OVERVIEW_FIELD_LABEL": "시뮬레이션 개요",
      "WHAT_USERS_SEE_PERSONA_FIELD_LABEL": "페르소나 정보",
      "WHAT_USERS_SEE_SCORING_FIELD_LABEL": "채점 기준",
      "WHAT_USERS_SEE_SCORING_FIELD_HELPER": "이 섹션은 채점 탭에서 선택한 내용에 따라 자동으로 채워집니다. 이곳의 정보를 편집하더라도 시뮬레이션 채점 방식에는 변화가 없습니다.",
      "WHAT_USERS_SEE_PREVIEW_DETAILS_CTA": "시뮬레이션 상세 정보 미리보기",
      "WHAT_USERS_SEE_PREVIEW_CARD_CTA": "시뮬레이션 카드 미리보기",
      "TAB_GENERAL": "일반",
      "TAB_CONTENTS": "콘텐츠",
      "TAB_KEY_WORDS": "키워드",
      "TAB_SCORING": "채점",
      "TAB_TESTING": "테스트",
      "TAB_PROMPTS": "프롬프트",
      "TAB_WHAT_USERS_SEE": "사용자에게 표시되는 화면",
      "ACCURACY_FEEDBACK_TITLE": "정확도 피드백",
      "ACCURACY_FEEDBACK_DESCRIPTION": "업로드된 문서를 기준으로 상담원이 말하는 모든 진술의 정확도를 평가합니다",
      "ACCURACY_FEEDBACK_STATUS_ON": "활성화됨",
      "ACCURACY_FEEDBACK_STATUS_OFF": "끄기",
      "ACCURACY_FEEDBACK_STATUS_DISABLED": "비활성화됨",
      "ACCURACY_FEEDBACK_NO_DOCUMENTS": "관련 문서가 추가되지 않아 정확도 점수 산정을 할 수 없습니다.",
      "SCORING_AI_REVIEW_NOTICE": "이 탭의 일부 내용은 귀하가 제공한 자료를 바탕으로 생성되었습니다. 이 통화를 게시하기 전에 모든 내용이 정확한지 검토하세요.",
      "EXPORT_SIMULATION_SUMMARY_BUTTON": "시뮬레이션 요약 내보내기",
      "CALL": "통화",
      "REFINEMENT_OVERRIDDEN_PREFIX": "이 정보는 수동으로 수정된 내용입니다. 업데이트 사항이 있는지 확인하려면",
      "REFINEMENT_OVERRIDDEN_SUFFIX": "에 문의해 주세요.",
      "SUPPORT_EMAIL": "help@quantified.ai",
      "WHAT_USERS_SEE_OVERRIDE_WARNING_TITLE": "이 필드를 편집하면 향후 업데이트가 차단됩니다",
      "WHAT_USERS_SEE_OVERRIDE_WARNING_BODY": "이 섹션을 수동으로 업데이트하면 일반 탭의 정제 프로세스의 추가 업데이트를 더 이상 받을 수 없습니다.",
      "WHAT_USERS_SEE_DETAILS_OVERRIDE_EDITED_TITLE": "이 필드는 편집되었습니다",
      "WHAT_USERS_SEE_DETAILS_OVERRIDE_EDITED_BODY": "이 필드는 더 이상 일반 탭에서 수행되는 정제 업데이트를 받지 않습니다",
      "SIMULATION_BUILDER_HEADING": "시뮬레이션 빌더",
      "ASSIGNMENTS_TAB_LABEL": "과제",
      "SIMULATIONS_TAB_LABEL": "시뮬레이션 수",
      "CREATE_NEW_ASSIGNMENT_BUTTON": "새 과제 생성",
      "CREATE_NEW_SIMULATION_BUTTON": "새 시뮬레이션 생성",
      "NO_ASSIGNMENTS_FOUND": "할당된 과제가 없습니다",
      "ASSIGNMENT_STATUS_PLACEHOLDER": "과제 상태",
      "ASSIGNMENT_STATUS_PREFIX": "과제 상태:",
      "ASSIGNMENT_TYPE_LABEL": "과제 유형",
      "SELECT_ASSIGNMENT_TYPE_PLACEHOLDER": "과제 유형 선택",
      "NAME_LABEL": "이름",
      "ASSIGNMENT_NAME_PLACEHOLDER": "과제명",
      "PASSING_SCORE_LABEL": "합격 점수",
      "PASSING_SCORE_OPTIONAL_LABEL": "합격 점수(선택 사항)",
      "SCORE_MAX_EXCEEDED_ERROR": "점수는 5를 초과할 수 없습니다",
      "GET_HELP_BUTTON": "도움말 보기",
      "PASSING_SCORE_TOOLTIP": "이 항목은 학습자가 시뮬레이션을 통과하기 위해 달성해야 하는 종합 점수를 설정합니다.",
      "DESCRIPTION_LABEL": "설명",
      "ASSIGNMENT_DESCRIPTION_PLACEHOLDER": "과제 설명",
      "MESSAGING_FEEDBACK_LABEL": "메시지 피드백",
      "MESSAGING_FEEDBACK_TOOLTIP_HEADING": "메시지 피드백",
      "MESSAGING_FEEDBACK_TOOLTIP_BODY": "학습자가 메시지를 잘못 말하면, 다음 번에 더 잘 표현할 수 있는 방법에 대한 정보가 표시됩니다. 이 설정은 해당 정보를 표시 기능을 켜거나 끕니다.",
      "ENABLED_TEXT": "활성화됨",
      "DISABLED_TEXT": "비활성화됨",
      "PAUSE_BUTTON_LABEL": "일시 정지 버튼",
      "ASSIGNMENT_START_DATE_LABEL": "과제 시작 날짜",
      "SELECT_DATE_PLACEHOLDER": "날짜 선택",
      "ASSIGNMENT_END_DATE_LABEL": "과제 종료 날짜",
      "ASSIGNMENT_END_DATE_OPTIONAL_LABEL": "과제 종료 날짜(선택 사항)",
      "END_DATE_RANGE_ERROR": "시작 날짜가 종료 날짜와 같을 수 없습니다",
      "ASSIGNMENT_INFORMATION_TITLE": "과제 정보",
      "ASSIGNMENT_TYPE_CERTIFICATION": "인증",
      "ASSIGNMENT_TYPE_PRACTICE": "연습",
      "ASSIGNMENT_TYPE_PERSONALIZED_PRACTICE": "맞춤형 연습",
      "BUTTON_SAVE_AND_CLOSE": "저장 및 닫기",
      "BUTTON_ADD_SIMULATIONS": "시뮬레이션 추가",
      "ATTEMPTS_UNLIMITED": "무제한",
      "SEARCH_FOR_SIMULATION_LABEL": "시뮬레이션 검색",
      "SIMULATION_NAME_PLACEHOLDER": "시뮬레이션 이름",
      "BUTTON_REMOVE_ALL": "전체 제거",
      "SIMULATIONS_IN_ASSIGNMENT_LABEL": "과제에 포함된 시뮬레이션",
      "BUTTON_ASSIGN_LEARNERS": "학습자 할당",
      "CALL_TYPE_UNKNOWN": "알 수 없음",
      "ASSIGNMENT_COUNT_NONE": "없음",
      "ASSIGNMENT_COUNT_SINGULAR": "{{ count }}개의 과제",
      "ASSIGNMENT_COUNT_PLURAL": "{{ count }}개의 과제",
      "ERROR_LOADING_ASSIGNMENTS": "과제 불러오기 오류",
      "SEARCH_ASSIGNEES_TITLE": "할당 대상자 검색",
      "DIALOG_DESCRIPTION_ADD_USERS": "과제에 참여할 사용자를 선택하세요. 팀을 검색하면 해당 팀의 특정 사용자에게 과제를 할당하거나 할당을 취소할 수 있습니다. 특정 사용자를 선택할 때는 보고를 위해 해당 사용자가 올바른 팀에 소속되어 있는지 확인하세요.",
      "ADD_USERS_TO_ASSIGNMENT_HEADING": "과제에 사용자 추가",
      "BUTTON_REVIEW_SELECTED_USERS": "선택된 사용자 검토",
      "FIND_USERS_LABEL": "사용자 검색",
      "BUTTON_CLEAR": "지우기",
      "LEARNER_COUNT_NONE": "없음",
      "LEARNER_COUNT_SINGULAR": "{{ count }}명의 학습자",
      "LEARNER_COUNT_PLURAL": "{{ count }}명의 학습자",
      "ASSIGNMENT_TAB_DETAILS": "상세 정보",
      "ASSIGNMENT_TAB_SIMULATIONS": "시뮬레이션 수",
      "ASSIGNMENT_TAB_ASSIGNEES": "할당 대상자",
      "LOADING_ASSIGNMENT_DETAILS": "과제 세부 정보 불러오는 중...",
      "BREADCRUMB_ASSIGNMENTS": "과제",
      "ASSIGNMENTS_COL_NAME": "이름",
      "ASSIGNMENTS_COL_START_DATE": "과제 시작 날짜",
      "ASSIGNMENTS_COL_END_DATE": "과제 종료 날짜",
      "ASSIGNMENTS_COL_LEARNERS": "학습자 할당됨",
      "ASSIGNMENTS_COL_TYPE": "과제 유형",
      "ASSIGNMENTS_COL_STATUS": "과제 상태",
      "SIMULATIONS_COL_NAME": "이름",
      "SIMULATIONS_COL_PRODUCT": "제품",
      "SIMULATIONS_COL_DATE_MODIFIED": "마지막 수정 날짜",
      "SIMULATIONS_COL_STATUS": "상태",
      "SIMULATIONS_COL_USED_IN": "사용 위치",
      "SIMULATIONS_COL_TYPE": "시뮬레이션 유형",
      "SIMULATIONS_COL_DATE_PUBLISHED": "게시 날짜",
      "CONVERSE_PROMPT_LABEL": "대화 프롬프트",
      "CONVERSE_PROMPT_EXPAND_TO_EDIT": "확장하여 편집",
      "CONVERSE_PROMPT_ENTER_LABEL": "여기에 대화 프롬프트를 입력하세요 *",
      "CONVERSE_PROMPT_EDITING_HEADING": "대화 프롬프트 편집",
      "CONVERSE_PROMPT_OVERRIDE_CONFIRMATION_HEADING": "프롬프트 덮어쓰기 확인",
      "CONVERSE_PROMPT_OVERRIDE_DESCRIPTION": "대화 프롬프트를 덮어쓰시겠습니까? 덮어쓰기 할 경우 작성자는 자체 정제 권한을 상실하게 됩니다.",
      "CONVERSE_PROMPT_FIELD_LABEL": "대화 프롬프트",
      "CONVERSE_PROMPT_SAVE_BUTTON": "프롬프트 저장",
      "BUTTON_CONFIRM": "확인",
      "DELETE_SIM_HEADING": "시뮬레이션 삭제",
      "DELETE_SIM_CONTENT": "이 시뮬레이션이 삭제됩니다. 시뮬레이션과 연결된 모든 테스트 과제도 함께 제거됩니다.",
      "DELETE_SIM_LABEL": "시뮬레이션 삭제",
      "DELETE_ASSIGNMENT_HEADING": "과제 삭제",
      "DELETE_ASSIGNMENT_CONTENT": "이 과제를 영구적으로 삭제합니다.",
      "DELETE_ASSIGNMENT_LABEL": "과제 삭제",
      "DELETE_ASSIGNMENT_NON_STAGED_CONTENT": "활성 또는 종료 상태인 과제를 삭제하려면 CX 팀에 문의하세요. 감사합니다.",
      "REMOVE_FROM_ASSIGNMENT_HEADING": "과제에서 제거",
      "REMOVE_FROM_ASSIGNMENT_CONTENT": "이렇게 하면 해당 사용자가 과제 및 관련된 모든 팀 링크에서 제거됩니다.",
      "REMOVE_FROM_ASSIGNMENT_LABEL": "과제에서 제거",
      "PUBLISH_SIMULATION_HEADING": "시뮬레이션 게시",
      "PUBLISH_CONTINUE_EDITING": "편집 계속",
      "PUBLISH_BUTTON": "게시",
      "PUBLISH_SIMULATION_DESCRIPTION": "롤플레이를 과제에 추가할 수 있지만, 페르소나, 채점 및 프롬프트 정보는 더 이상 편집할 수 없습니다.",
      "CONFIRMATION_SELECTED_USERS_HEADING": "선택된 사용자",
      "CONFIRMATION_TOTAL_COUNT": "합계 {{ count }}명",
      "CONFIRMATION_CREATE_HEADING": "새 과제 생성",
      "CONFIRMATION_ADD_USERS_HEADING": "과제에 사용자 추가",
      "CONFIRMATION_SAVE_ASSIGNMENT_BTN": "과제 저장",
      "CONFIRMATION_REMOVE_USER": "제거",
      "EDIT_WEIGHTING_HEADING": "채점 가중치 편집",
      "EDIT_WEIGHTING_DESCRIPTION": "종합 점수는 다음 섹션의 가중 평균을 바탕으로 산출됩니다. 활성화된 모든 섹션의 가중치 합계는 100%가 되어야 합니다. 스킬 섹션의 가중치는 20%를 초과할 수 없습니다.",
      "EDIT_WEIGHTING_ERROR_ALL_DISABLED": "하나 이상의 채점 작업이 활성화되어 있어야 합니다",
      "EDIT_WEIGHTING_ERROR_WEIGHT_RANGE": "섹션 가중치는 0과 100 사이여야 합니다",
      "EDIT_WEIGHTING_ERROR_SKILLS_MAX": "스킬 섹션의 가중치는 20%를 초과할 수 없습니다",
      "EDIT_WEIGHTING_ERROR_TOTAL": "섹션의 총 가중치는 100%여야 합니다",
      "PERSONA_INFORMATION_TITLE": "페르소나 정보",
      "PERSONA_AVATAR_LABEL": "아바타 *",
      "PERSONA_NAME_LABEL": "이름 *",
      "PERSONA_INITIAL_GREETINGS_LABEL": "초기 인사말 *",
      "PERSONA_INITIAL_GREETINGS_DESCRIPTION": "페르소나는 시뮬레이션을 시작할 때 이 인사말 중 하나로 시작합니다. 최대 5개의 옵션을 설정할 수 있습니다.",
      "PERSONA_ADD_GREETING_OPTION": "인사말 옵션 추가",
      "PERSONA_RESUME_MESSAGE_LABEL": "메시지 재개",
      "PERSONA_RESUME_MESSAGE_DESCRIPTION": "학습자가 일시 중지 후 시뮬레이션을 재개하면, 페르소나는 이 인사말 중 하나로 시작합니다. 최대 5개의 옵션을 설정할 수 있습니다.",
      "PERSONA_ADD_MESSAGE_OPTION": "메시지 옵션 추가",
      "PERSONA_UPLOADING": "업로드 중...",
      "PERSONA_DELETING": "삭제 중...",
      "PERSONA_CUSTOM_BG_PREVIEW_ALT": "사용자 지정 배경 미리보기",
      "PERSONA_AVATAR_THUMBNAIL_ALT": "아바타 썸네일",
      "PERSONA_AVATAR_WITH_BG_ALT": "사용자 지정 배경이 적용된 아바타",
      "PERSONA_PROCESSING_IMAGE": "이미지 처리 중...",
      "PERSONA_CUSTOM_BACKGROUND_LABEL": "사용자 지정 배경",
      "PERSONA_REMOVE_BACKGROUND": "배경 제거",
      "PERSONA_CLICK_TO_REPLACE": "클릭하여 교체",
      "PERSONA_UPLOAD_DESCRIPTION": "PNG 또는 JPG, 16:9 화면비 권장, 최대 2MB",
      "SIM_INFORMATION_TITLE": "시뮬레이션 정보",
      "SIM_NAME_FIELD_LABEL": "이름 *",
      "SIM_LANGUAGE_FIELD_LABEL": "언어",
      "SIM_DETAILS_SECTION_TITLE": "시뮬레이션 상세 정보",
      "SIM_ADDITIONAL_SECTION_TITLE_LABEL": "추가 섹션 제목",
      "SIM_ADDITIONAL_SECTION_INFO_LABEL": "추가 섹션 정보",
      "TESTING_SECTION_TITLE": "테스터",
      "TESTING_SEND_ASSIGNMENTS_BTN": "시험 과제 전송",
      "TESTING_MESSAGING_TOOLTIP": "테스트하거나 게시하기 전에 메시지 준수에 하나 이상의 사실을 추가하세요.",
      "TESTING_DESCRIPTION": "시뮬레이션을 테스트할 사용자를 검색하고 테스트 과제를 전송하세요.",
      "TESTING_COL_NUMBER_OF_ATTEMPTS": "시도 횟수",
      "TESTING_COL_DATE_OF_LAST_ATTEMPT": "최근 시도 날짜",
      "TESTING_CLEAR_USERS": "사용자 지우기",
      "TESTING_REMOVE_ASSIGNEE": "할당 대상자 제거",
      "OVERALL_SECTION_TITLE": "섹션, 가중치 및 프롬프트",
      "OVERALL_HEADING": "종합",
      "TRANSCRIPT_PROMPT_TITLE": "녹취록 프롬프트",
      "TRANSCRIPT_PROMPT_FIELD_LABEL": "여기에 녹취록 정제 프롬프트를 입력하세요",
      "SIMULATION_PROMPTS_TITLE": "시뮬레이션 프롬프트",
      "TAGS_LABEL": "태그",
      "CREATE_TAG_OPTION": "'{{term}}' 생성",
      "TAG_CREATE_ERROR": "태그를 생성할 수 없습니다. 다시 시도해 주세요.",
      "EDIT_SIMULATION_TAGS_TITLE": "시뮬레이션 태그 편집",
      "SAVE_TAGS_BUTTON": "태그 저장",
      "CLOSE_BUTTON": "닫기",
      "TAG_UPDATE_ERROR": "태그를 업데이트하지 못했습니다. 다시 시도해 주세요.",
      "SCREEN_SHARE_TITLE": "화면 공유",
      "SCREEN_SHARE_DESCRIPTION": "통화 중에 사용자가 아바타와 화면을 공유할 수 있게 하여, 아바타가 표시된 내용을 보고 이에 반응할 수 있도록 합니다",
      "SCREEN_SHARE_STATUS_ON": "활성화됨",
      "SCREEN_SHARE_STATUS_OFF": "비활성화됨",
      "SCREEN_SHARE_NO_PERSONA": "화면 공유를 사용하려면 먼저 페르소나를 추가해야 합니다.",
      "HIDE_RESULTS_LABEL": "결과 숨기기",
      "SEARCH_FIELD_HINT": "검색을 시작하려면 3자 이상 입력하세요",
      "OTHERS_SINGULAR": "및 1개 더",
      "OTHERS_PLURAL": "및 {{ count }}개 더",
      "PAGINATION_PREVIOUS": "이전",
      "PAGINATION_NEXT": "다음",
      "SKILLS_RUBRIC_REQUIRED_TOOLTIP": "스킬 평가 기준을 첨부하세요. '스킬'은 가중치가 0%를 넘을 때 활성화됩니다.",
      "ENTITY_TYPE_KNOWLEDGE_CHECK_DISPLAY": "지식 점검",
      "NAME_MAX_LENGTH_ERROR": "표시 이름은 최대 255자 이내여야 합니다.",
      "UUID_COPIED_TOAST": "통화 UUID가 클립보드에 복사되었습니다",
      "MENU_ARCHIVE": "보관함",
      "MENU_EDIT_SIMULATION_TAGS": "시뮬레이션 태그 편집",
      "MENU_COPY_UUID": "UUID 복사",
      "REFINEMENT_IN_PROGRESS_TOOLTIP": "정제 진행 중. 정제가 완료되면 계속 진행할 수 있습니다.",
      "SIMULATION_DOCUMENTS_PARSE_FAILED_BODY": "{{ name }}에 대한 문서 중 하나를 읽을 수 없습니다. 문서를 확인하거나 교체한 후 다시 시도하세요..",
      "REFINEMENT_ERROR_MESSAGE": "죄송합니다. 이 요청을 완료할 수 없습니다. 다시 시도해 주세요",
      "REFINEMENT_OUT_OF_SCOPE_TITLE": "요청이 범위를 벗어났습니다.",
      "REFINEMENT_OUT_OF_SCOPE_BODY": "{{ name }}에 대한 요청이 정제 기능의 범위를 벗어납니다. 지원팀에 문의해 주세요.",
      "TAB_QUESTIONS": "질문",
      "KNOWLEDGE_CHECK_NAME_LABEL": "이름*",
      "AVATAR_APPEARANCE_LABEL": "아바타 외형",
      "KNOWLEDGE_CHECK_AVATAR_NAME_LABEL": "아바타 이름",
      "KNOWLEDGE_CHECK_SKILLS_FEEDBACK_TITLE": "스킬 피드백",
      "KNOWLEDGE_CHECK_SCORING_DESCRIPTION": "지식 점검 시뮬레이션은 각 질문에 대한 응답 항목의 비율로 채점됩니다. 아래에서 스킬 평가 기준을 선택하면 정성적인 피드백도 받을 수 있습니다.",
      "KNOWLEDGE_CHECK_SCORING_RESCORE_DESCRIPTION": "시뮬레이션을 최소 한 번 이상 테스트한 후, “내 마지막 세션 채점”을 선택하여 점수를 확인하세요. 응답 항목을 수정하면 동일한 세션에 대해 다시 채점할 수 있습니다. 질문을 수정하는 경우, 채점하기 전에 새로운 테스트 세션을 실행해야 합니다.",
      "KNOWLEDGE_CHECK_SKILLS_RUBRIC_LABEL": "스킬 평가 기준(선택 사항)",
      "SIMULATION_TYPE_MODAL_TITLE": "새 시뮬레이션 생성",
      "SIMULATION_TYPE_MODAL_DESCRIPTION": "학습자가 연습할 방식을 선택하세요.",
      "SIMULATION_TYPE_ROLE_PLAY_TITLE": "롤플레이",
      "SIMULATION_TYPE_ROLE_PLAY_DESCRIPTION": "학습자는 AI 캐릭터와의 자유 대화를 이끌어가며, AI 캐릭터는 학습자의 말에 자연스럽게 반응합니다.",
      "SIMULATION_TYPE_ROLE_PLAY_BEST_FOR": "가장 적합한 용도: 권유 및 이의 제기에 대한 처리와 같은 현실적인 영업 전화 연습.",
      "SIMULATION_TYPE_KNOWLEDGE_CHECK_TITLE": "지식 점검",
      "SIMULATION_TYPE_KNOWLEDGE_CHECK_DESCRIPTION": "AI 캐릭터가 학습자에게 귀하가 작성한 질문을 귀하가 설정한 순서대로 묻습니다.",
      "SIMULATION_TYPE_KNOWLEDGE_CHECK_BEST_FOR": "가장 적합한 용도: 제품 지식 테스트 및 상담원의 준비 상태 확인.",
      "TAGS_FILTER_LABEL": "태그",
      "TAGS_FILTER_PLACEHOLDER": "태그 선택",
      "CLEAR_ALL_FILTERS": "모든 필터 지우기",
      "LAST_SAVED_LABEL": "마지막 저장 시간",
      "BUTTON_OK": "확인",
      "KEYWORDS_RESET_TO_PRODUCT_DEFAULT": "제품 기본값으로 재설정",
      "KEYWORDS_DETACH_FROM_PRODUCT_DEFAULT": "제품 기본값에서 분리",
      "KEYWORDS_SAVE_AS_PRODUCT_DEFAULT": "제품 기본값으로 저장",
      "KEYWORDS_SAVE_AS_DEFAULT_OVERWRITE": "이렇게 하면 {{ moduleName }} 제품의 {{ keywordTitle }} 기본값을 덮어쓰게 됩니다.",
      "KEYWORDS_SAVE_AS_DEFAULT_IMPACT": "이 단어들은 {{ moduleName }}에 대한 새로운 시뮬레이션에 추가됩니다. {{ moduleName }} 제품에 대한 모든 통화에 이 변경 사항이 적용됩니다.",
      "KEYWORDS_ADD_NEW_WORD": "새 단어 추가",
      "KEYWORDS_FROM_LABEL": "교체 전",
      "KEYWORDS_TO_LABEL": "교체 후",
      "KEYWORDS_PRONOUNCE_TITLE": "단어 발음",
      "KEYWORDS_PRONOUNCE_DESCRIPTION": "AI 에이전트가 이름/용어를 올바르게 발음할 수 있도록 올바른 발음 정보를 제공해 주세요. 에이전트는 흔히 발생하는 잘못된 발음이나 변형된 발음을 ‘새로운 발음’에 매핑합니다.",
      "KEYWORDS_PRONOUNCE_NAME": "단어 발음",
      "KEYWORDS_ADD_MISPRONUNCIATION": "잘못된 발음 추가",
      "KEYWORDS_SELECT_PERSONA_NOTICE": "단어 발음을 추가할 페르소나를 선택해 주세요.",
      "KEYWORDS_REPLACE_TITLE": "단어 교체",
      "KEYWORDS_REPLACE_DESCRIPTION": "사용자 녹취록 텍스트에 대한 명시적인 찾기 및 바꾸기 수정 기능으로, 발음 교정 전에 단어를 직접 교체합니다.",
      "KEYWORDS_REPLACE_NAME": "단어 교체",
      "KEYWORDS_ADD_REPLACEMENT": "교체 항목 추가",
      "KEYWORDS_STT_TITLE": "음성 텍스트 변환 단어",
      "KEYWORDS_STT_DESCRIPTION": "음성 텍스트 변환(STT) 제공업체(예: AssemblyAI, Tavus)에 제공되는 단어 목록으로, 특히 STT 제공업체 구성을 위해 사용됩니다.",
      "KEYWORDS_STT_NAME": "음성 텍스트 변환 단어",
      "KEYWORDS_GENERATING": "생성 중...",
      "KEYWORDS_GENERATE_STT_PROMPT": "stt_prompt 생성",
      "KEYWORDS_STT_PROMPT_OUTDATED": "이 프롬프트가 생성된 이후 단어 목록이 업데이트되었습니다. 최신 변경 사항을 반영하려면 다시 생성하세요.",
      "KEYWORDS_STT_CANNOT_SAVE_HEADING": "제품 수준에서 저장할 수 없음",
      "KEYWORDS_STT_CANNOT_SAVE_BODY": "음성 텍스트 변환 단어 및 프롬프트는 제품 수준에서 저장할 수 없습니다. 다른 시뮬레이션 음성 텍스트 변환 구성을 수동으로 변경하거나 관리자에게 도움을 요청할 수 있습니다.",
      "KEYWORDS_CLEAN_TRANSCRIPT_TITLE": "녹취록 단어 지우기",
      "KEYWORDS_CLEAN_TRANSCRIPT_DESCRIPTION": "CLEAN_TRANSCRIPT_V2 프롬프트에 삽입되는 단어입니다.",
      "KEYWORDS_CLEAN_TRANSCRIPT_NAME": "녹취록 단어 지우기",
      "KEYWORDS_CALL_TITLE": "통화 단어",
      "KEYWORDS_CALL_DESCRIPTION": "발음 교정을 위한 올바른 단어 사전으로, Double Metaphone 알고리즘에서 발음이 유사한 잘못된 표기를 교정하는 데 사용됩니다. 'Anti MuSK AB+'같이 여러 단어로 구성된 용어는 피해 주세요. 코드 기반 녹취록 교정기는 단어 하나로 이루어진 경우에만 안정적으로 작동하기 때문입니다. 또한 'lp(a)' 같은 기호도 피해 주세요. 교정기를 혼란스럽게 할 수 있습니다. 이 목록은 최대한 작고 단순해야 합니다. 이는 LLM이 아닌 결정론적 알고리즘에 의해 처리되며, 문맥을 이해하지 못하기 때문입니다",
      "KEYWORDS_CALL_NAME": "통화 단어"
    },
    "settings": {
      "DEVICE_SETUP_INTRO": "기기가 제대로 설정되어 있는지 확인해 보겠습니다.",
      "MICROPHONE_REQUIRED_NOTICE": "정상 작동하는 마이크가 필요합니다.",
      "DEVICE_ENABLE_INSTRUCTIONS": "이 페이지를 새로고침 한 후 기기 활성화 요청 팝업이 표시되지 않았다면, 시스템 또는 브라우저 설정으로 이동하여 기기를 활성화해 주세요. 자세한 지침을 제공하는 지원 페이지는 아래에 있습니다.",
      "ENABLE_CAMERA": "카메라 활성화 방법:",
      "WINDOWS_USERS": "Windows 사용자",
      "MAC_USERS": "Mac 사용자",
      "IPAD_USERS": "iPad 사용자",
      "ENABLE_MICROPHONE": "마이크 활성화 방법:",
      "ENABLE_DEVICES_BY_BROWSER": "브라우저별 기기 활성화 방법:",
      "CHROME_USERS": "Chrome 사용자",
      "SAFARI_USERS": "Safari 사용자",
      "FIREFOX_USERS": "Firefox",
      "EDGE_USERS": "Edge",
      "START_WITHOUT_CAMERA_BUTTON": "카메라 없이 시작하기",
      "START_CALL_BUTTON": "통화 시작하기",
      "MICROPHONE_REQUIRED_WARNING": "정상 작동하는 마이크가 필요합니다.",
      "MICROPHONE_ALT": "마이크",
      "MICROPHONE": "마이크",
      "SELECT_MICROPHONE": "마이크 선택",
      "ALERT": "알림",
      "GIVE_PERMISSION": "권한 허용",
      "SELECT_VIDEO_DEVICE": "동영상 장치 선택",
      "VIDEO": "동영상",
      "DEVICE_BLOCKED_ERROR": "이 브라우저가 하나 이상의 기기에 접근하는 것을 거부하도록 설정되어 있습니다. 기기를 활성화하려면 시스템 설정 또는 브라우저 설정으로 이동하여 접근을 허용해 주세요.",
      "DEVICE_SETTINGS": "기기 설정",
      "CONFIRM_SETTINGS": "설정 확인",
      "LAPTOP": "노트북",
      "SAD_EMOTE_FACE": "우는 얼굴 이모티콘",
      "GRANT_BROWSER_ACCESS": "이 시뮬레이션을 완료하려면 브라우저에서 음성 인식에 대한 접근을 허용해 주세요",
      "USING_IPAD": "iPad를 사용하는 경우, 다음으로 이동하세요.",
      "SETTINGS": "설정",
      "PRIVACY_AND_SECURITY": "개인정보 및 보안",
      "SPEECH_RECOGNITION": "음성 인식",
      "GRANT_ACCESS_REFRESH": "브라우저에 접근을 허용하고 페이지를 새로고침 하세요",
      "REFRESH_PAGE": "페이지 새로고침",
      "BROWSER_UNABLE_TO_ACCESS": "브라우저가 이 기기에 접근할 수 없습니다",
      "ACCESS_DENIED": "접근 거부됨",
      "CAMERA": "카메라",
      "DIAGNOSTIC_PASSED": "모든 진단 테스트를 성공적으로 통과했습니다.",
      "DIAGNOSTIC_FAILED_MESSAGE": "일부 진단 테스트에 실패했습니다. 위의 '진단 결과 복사' 버튼을 클릭하여 결과를 지원팀에 보내 도움을 받으세요.",
      "DIAGNOSTIC_PARTIAL": "대부분의 진단 테스트를 성공적으로 통과했습니다. 연결 상태가 양호합니다.",
      "DIAGNOSTIC_RUNNING_MESSAGE": "진단 테스트가 실행되는 동안 잠시 기다려 주세요...",
      "DIAGNOSTIC_RUNNING": "진단 중",
      "COPY_DIAGNOSTIC_RESULTS": "진단 결과 복사",
      "RUN_DIAGNOSTIC": "진단 실행",
      "RERUN_DIAGNOSTIC": "진단 다시 실행",
      "DIAGNOSTIC_RESULTS_COPIED": "진단 결과가 클립보드에 복사되었습니다",
      "DIAGNOSTIC_FAILED": "진단 실패",
      "DIAGNOSTIC_WEBSOCKET_NOT_TESTED": "Websocket: not tested",
      "DIAGNOSTIC_TURN_NOT_TESTED": "TURN: not tested",
      "DIAGNOSTIC_QUALITY_NOT_TESTED": "Quality: not tested",
      "DIAGNOSTIC_QUANTIFIED_DIAGNOSTICS": "Quantified 진단",
      "DIAGNOSTIC_TIME": "시간",
      "DIAGNOSTIC_SUMMARY": "요약",
      "DIAGNOSTIC_CLIENT_INFO": "클라이언트 정보",
      "DIAGNOSTIC_PLATFORM": "플랫폼",
      "DIAGNOSTIC_RTT_AVG_MAX": "RTT avg/max",
      "DIAGNOSTIC_PACKET_LOSS_SEND": "패킷 손실(송신)",
      "DIAGNOSTIC_AVG_SEND_BITRATE": "평균 송신 비트레이트",
      "DIAGNOSTIC_NA": "해당 없음",
      "DIAGNOSTIC_PROBLEMS_CONNECTING_PREFIX": "연결에 문제가 있으신가요?",
      "DIAGNOSTIC_CLICK_HERE": "여기를 클릭하여",
      "DIAGNOSTIC_TO_RUN_SUFFIX": "진단을 실행하세요."
    },
    "results": {
      "RETURN_HOME": "홈으로 돌아가기",
      "RETURN_TO_PATHWAY": "학습 경로로 돌아가기",
      "CLOSE_BUTTON": "닫기 버튼",
      "CONVERSATIONAL_CALL": "롤플레이",
      "INFORMATION_ICON": "정보 아이콘",
      "TOOLTIP_ARROW": "툴팁 화살표",
      "INFORMATION_TOOLTIP_CONTENT": "시뮬레이션의 진행 흐름을 통제하며, 대화를 일련의 목표에 따라 이끌어 나갑니다. 롤플레이는 문제를 파고들고 심층적인 질문을 던지며, 고충을 파악하고, 신뢰 관계를 구축하는 등의 능력을 테스트하는 데 매우 유용합니다.",
      "CLOCK_ICON": "시계 아이콘",
      "CALL_RESULTS": "결과",
      "QUIZ_RESULTS_SUMMARY": "퀴즈 결과 요약",
      "PROCESSING_RESULTS": "결과 처리 중...",
      "SKILLS": "스킬",
      "MESSAGE_ADHERENCE": "메시지 준수",
      "MESSAGING": "메시지",
      "TRY_AGAIN_MESSAGE": "다시 시도하여 점수를 높여 보세요.",
      "QUIZ_SUMMARY_BASE": "잠시 시간을 내어 이 퀴즈의 성적을 검토해 보세요.",
      "QUIZ_SUMMARY_FAILED": "잠시 시간을 내어 이 퀴즈의 성적을 검토해 보세요. 다음 번 시도에서 더 잘 수행할 수 있도록 학습 경로 개요 화면에서 강조 표시된 {{stepNames}} {{stepWord}}를 복습하세요.",
      "QUIZ_SUMMARY_PASSED_WITH_MISSES": "잠시 시간을 내어 이 퀴즈의 성적을 검토해 보세요. 점수가 가장 낮은 {{areaWord}}은 {{stepNames}} {{stepWord}}{{stepVerb}}입니다.",
      "PRACTICE_BENEFITS": "매주 연습하면 자신감이 높아지고 실제 성과도 향상됩니다.",
      "CALL_SUCCESS": "정말 잘하셨습니다! 이 시뮬레이션을 성공적으로 완료했습니다.",
      "MAX_ATTEMPTS_REACHED": "최대 시도 횟수에 도달했습니다",
      "TRY_AGAIN": "다시 시도",
      "GREAT_JOB_YOU_SUCCESSFULLY": "정말 잘하셨습니다! 성공적으로",
      "COMPLETED_THIS_CALL": "이 시뮬레이션을 완료했습니다.",
      "ACHIEVED_SCORE": "획득 점수:",
      "ACHIEVE_SCORE": "목표 점수:",
      "OR_HIGHER": "또는 그 이상",
      "OBJECTIVES_NOT_MET": "목표를 달성하지 못했습니다.",
      "TRY_AGAIN_TARGET_SCORE": "다시 시도해 보세요. 목표 점수:",
      "YOUR_SCORE": "내 점수",
      "OUT_OF_5": "/5점",
      "OUT_OF_100": "/100점",
      "CALL_FEEDBACK": "피드백 요약",
      "STRENGTH_ICON_ALT": "강점 아이콘",
      "OPPORTUNITIES_ICON_ALT": "개선점 아이콘",
      "OBJECTIVES_FEEDBACK": "방법론에 대한 피드백",
      "SESSION_ID": "세션 ID:",
      "SESSION_ID_COPIED": "세션 ID가 복사되었습니다!",
      "OBJECTIVE": "방법론:",
      "HOW_YOU_DID": "결과:",
      "LIGHTBULB_ICON_ALT": "전구 아이콘",
      "WHAT_WE_SUGGEST": "제안 사항:",
      "NO_SPECIFIC_RECOMMENDATION": "시스템에서 딱 맞는 추천 항목을 찾을 수 없었습니다.",
      "WHY": "이유:",
      "NO_INSIGHTS_AVAILABLE": "시스템에서 이 제안에 대한 인사이트를 제공할 수 없었습니다.",
      "CONFETTI_ICON_ALT": "색종이 조각 아이콘",
      "OBJECTIVE_SUCCESS_MESSAGE": "이 방법론에서 훌륭한 성과를 거두셨습니다. 계속해서 좋은 모습 보여주세요!",
      "PROCESSING_CALL": "현재 점수와 피드백을 준비 중입니다.",
      "HANG_TIGHT": "잠시만 기다리시거나 나중에 다시 방문하여",
      "VIEW_YOUR_RESULTS": "결과를 확인해 보세요.",
      "NEED_MORE_TIME": "결과를 산출하는 데 시간이 조금 더 필요합니다.",
      "REFRESH_INSTRUCTION": "잠시 후 다시 확인하시거나 몇 분 뒤",
      "RESULTS_IN_FEW_MINUTES": "과제 결과를 새로고침 해 주세요.",
      "QUIZ_RESULTS_LOADING": "결과를 불러오는 데 다소 시간이 걸립니다. 이 학습 경로를 종료하시면 결과가 준비되는 대로 알려드리겠습니다.",
      "KC_TOAST_TITLE": "지식 점검 결과가 처리되었습니다",
      "KC_TOAST_TITLE_PATHWAY": "{{stepName}} 지식 점검 결과가 처리되었습니다",
      "KC_TOAST_CONTENT": "아래를 클릭하여 결과를 확인하거나, 학습 경로 상세 화면으로 돌아가 다음 단계를 확인하세요.",
      "DISMISS": "닫기",
      "SCORE_CALCULATION_QUESTION": "이 점수는 어떻게 계산되나요?",
      "SINGLE_SCORE_EXPLANATION": "이 시뮬레이션의 점수 구성 요소는 하나뿐이므로, 표시된 점수는 개별 섹션의 점수이자 종합 점수입니다.",
      "OVERALL_SCORE_PERCENT": "(종합 점수 대비)",
      "SECTION_SCORE": "섹션 점수",
      "ELEVATE_MESSAGE_ADHERENCE_TITLE": "대화 메시지 준수도를 향상하기",
      "MESSAGE_ADHERENCE_NOTE": "메시지 준수도는 대화를 성공적으로 이끌어가는 데 매우 중요하지만, 종합 점수에는 영향을 미치지 않습니다.",
      "NO_CREDIT": "점수 없음",
      "PARTIAL_CREDIT": "부분 점수",
      "FULL_CREDIT": "만점",
      "WHAT_YOU_DID_WELL": "잘한 점",
      "MISSED_ALL_KEY_POINTS": "모든 핵심 항목을 누락했습니다. 복습 후 다시 시도해 보세요.",
      "WHAT_TO_IMPROVE": "개선할 점",
      "PERFECT_SCORE_MESSAGE": "축하합니다! 모든 핵심 항목을 정확하게 전달하여 만점을 받았습니다.",
      "POINTS_LABEL": "점",
      "TALKING_POINTS_COVERED": "언급된 내용",
      "COVERED": "다룸",
      "CHECKMARK_ICON_ALT": "체크 표시",
      "TALKING_POINTS_MISSED": "언급되지 않은 내용",
      "MISSED": "누락함",
      "X_ICON_ALT": "x",
      "PRACTICE_AGAIN": "다시 연습하기",
      "OUT_OF": "/",
      "OBJECTIVES": "방법론",
      "ELEVATE_OBJECTIVES_TITLE": "대화 방법론 향상하기",
      "OBJECTIVES_NOTE": "방법론은 대화를 성공적으로 이끌어가는 데 매우 중요하지만, 종합 점수에는 영향을 미치지 않습니다.",
      "UNTIL": "기한은",
      "TO_IMPROVE_SCORE": "점수를 올려보세요.",
      "YOU_HAVE": "현재",
      "MORE_ATTEMPTS": "시도가 남아 있으며 통과 기준 점수는",
      "OR_HIGHER_BEFORE": "또는 그 이상이며 기한은",
      "AND_TRY_AGAIN": "다시 시도해 보세요.",
      "UNEXPECTED_STATE": "예기치 않은 상태가 발생했습니다.",
      "REVIEW_APP_LOGIC": "애플리케이션의 로직을 검토해 주세요.",
      "ASSIGNMENTS": "과제",
      "VIEW_CALL_DETAILS": "통화 상세 정보 보기",
      "PRACTICE_SESSION": "연습 세션",
      "OVERALL_SCORE": "종합 점수",
      "OVERALL_SCORE_EXPLANATION": "종합 점수는 각 섹션의 점수에 가중치를 적용하여 산출된 평균입니다. 각 섹션의 가중치는 점수 옆에 백분율로 표시됩니다.",
      "SCORE_CONFIG_NOTE": "가중치 백분율과 섹션의 포함 및 제외 여부는 회사에서 설정합니다. 모든 점수는 반올림하여 소수점 첫째 자리까지 표시됩니다.",
      "STRENGTHS": "강점",
      "OPPORTUNITIES": "개선점",
      "YOUR_RESPONSE": "내 답변",
      "MINUS": "마이너스",
      "PLUS": "플러스",
      "RECOMMENDED_RESPONSE": "권장 답변",
      "REVIEW_MISSED_TITLE": "누락한 부분을 다시 살펴보세요.",
      "NO_TALKING_POINTS_COVERED": "이 주제에서 요구하는 언급 항목을 하나도 다루지 않았습니다.",
      "LEARN_WHAT_YOU_MISSED": "누락한 부분 학습하기",
      "NICE_JOB": "잘하셨습니다!",
      "ALL_POINTS_COVERED": "이 주제에서 요구하는 모든 언급 항목을 성공적으로 다루었습니다.",
      "COVER_ALL_MESSAGES": "모든 핵심 메시지를 다루세요.",
      "HIGHLIGHT_KEY_POINTS_NOTE": "통화 내내 핵심 항목을 강조하면 대화의 초점을 유지하는 데 도움이 됩니다.",
      "MESSAGES_LABEL": "메시지",
      "NO_FACTS_COVERED": "이런! 이 메시지의 사실 관계를 하나도 다루지 않은 것 같습니다.",
      "NO_SPECIFICS_AVAILABLE": "이런! 세부적인 누락 내용을 제공하지 못했습니다.",
      "ALL_KEY_POINTS_COVERED": "정말 잘하셨습니다! 모든 핵심 항목을 다루었습니다.",
      "PROCESSING_SKILLS_FEEDBACK": "스킬 피드백을 처리 중입니다.",
      "SKILLS_SCORING_NOT_ENABLED": "유감스럽게도, 제출 당시 스킬 점수 평가 기능이 활성화되어 있지 않아 최근 통화 내용을 분석할 수 없었습니다. 피드백을 받으시려면 이전처럼 통화 연습을 다시 제출해 주세요. 도움이 필요하시면 언제든지 지원팀에 문의해 주세요. 양해를 부탁드리며 실력 향상을 위해 노력해 주셔서 감사합니다!",
      "ELEVATE_CONVERSATION_SKILLS": "대화 스킬 향상하기",
      "SKILLS_NOTE": "스킬은 대화를 성공적으로 이끌어가는 데 매우 중요하지만, 종합 점수에는 영향을 미치지 않습니다.",
      "SKILLS_SUMMARY_TITLE": "스킬 요약",
      "LEARN_MORE_ABOUT_SKILLS": "스킬에 대해 더 알아보기",
      "SKILLS_FEEDBACK_LABEL": "피드백",
      "WHAT_ARE_SKILLS_TITLE": "스킬이란",
      "SKILLS_DESCRIPTION": "스킬은 개인의 성장과 발전을 지원하기 위해 측정됩니다. 이러한 스킬은 통화 점수 산정 기준에는 포함되지 않지만, 업무 효율성을 높이기 위해 조직에서 선정한 항목입니다.",
      "PROFICIENCY_SCALE_TITLE": "숙련도 척도",
      "EXPERT": "전문가",
      "PROFICIENT": "숙련",
      "DEVELOPING": "발전 중",
      "CALL_TRANSCRIPT": "통화 녹취록",
      "COLLAPSE_ALL": "모두 접기",
      "EXPAND_ALL": "모두 펼치기",
      "THUMBNAIL": "썸네일",
      "OUT_OF_FIVE_POINTS": "/5점",
      "TALKING_POINTS": "언급 항목",
      "TRANSCRIPT_LABEL": "녹취록",
      "YOU_ARE_OUT_OF_ATTEMPTS": "시도 횟수를 모두 소진했습니다.",
      "REVIEW_GUIDELINES_REMAIN_COMPLIANT": "복습을 통해 앞으로는 지침을 준수해 주세요.",
      "TRY_AGAIN_ATTENTION_TO_COMPLIANCE": "지침에 유의하며 다시 시도해 주세요.",
      "NO_SCORE_OUT_OF_COMPLIANCE": "지침 미준수로 볼 수 있는 사항을 확인했습니다",
      "WHY_OUT_OF_COMPLIANCE": "지침 미준수로 볼 수 있는 이유",
      "REVIEW_TRANSCRIPT_MISSED_GUIDELINES": "녹취록을 검토하여 어디에서 지침을 준수하지 못했는지 확인하세요.",
      "YOU_DID_FOLLOW_GUIDELINES": "이 지침을 효과적으로 준수하였습니다.",
      "REVIEW_MISSED_GUIDELINES": "준수하지 못한 지침을 다시 확인해 보세요.",
      "OUT_OF_COMPLIANCE": "지침 미준수",
      "SCORE_CALCULATION_TITLE": "점수 산출",
      "PROCESSING_TRANSCRIPT": "녹취록을 처리 중입니다.",
      "WAIT_OR_REVIEW_SCORES": "여기서 기다리시거나, 녹취록을 불러오는 동안",
      "TRANSCRIPT_LOADING": "다른 점수 섹션을 확인해 보세요.",
      "REVIEW_FEEDBACK_KEEP_PRACTICING": "피드백을 확인하고 계속 연습하세요",
      "HIGH_PERFORMERS_PRACTICE": "성적이 우수한 학습자는 주당 한 번 이상 연습합니다",
      "SUCCESSFULLY_PASSED": "정말 잘하셨습니다! 이 시뮬레이션을 성공적으로 통과했습니다.",
      "DIDNT_REACH_PASSING_SCORE": "이 시뮬레이션의 합격 점수에 도달하지 못했습니다.",
      "OUT_OF_ATTEMPTS": "<b>시도 횟수를 모두 소진했습니다.</b> 피드백을 검토하고 개선할 점을 파악해 보세요.",
      "REVIEW_FEEDBACK_THEN_RETURN": "피드백을 확인한 후, 준비가 되면 홈 화면으로 돌아가세요.",
      "GREAT_JOB_PRACTICED": "잘하셨습니다. {{count}}{{times}} 연습했습니다. 이대로 계속하세요!",
      "TIME": "번",
      "TIMES": "번",
      "COMPLIANCE_GUIDELINES": "준수 지침",
      "TALKING_POINT_TITLE": "누락했거나 타이밍이 부적절했던 언급 항목",
      "NO_TRANSCRIPT": "사용 가능한 녹취록이 없습니다.",
      "RETURN_TO_ASSIGNMENT": "과제로 돌아가기",
      "NONE_PERFECT": "없음 - 완벽합니다!",
      "MISSED_ONE_TALKING_POINT": "이 주제에 대해 1개의 언급 항목을 누락했습니다.",
      "MISSED_X_TALKING_POINTS": "이 주제에 대해 {{count}}개의 언급 항목을 누락했습니다.",
      "MISSED_ONE_REQUIRED_TALKING_POINT": "이 주제에 대해 1개의 필수 언급 항목을 누락했습니다",
      "MISSED_X_REQUIRED_TALKING_POINTS": "이 주제에 대해 {{count}}개의 필수 언급 항목을 누락했습니다",
      "MISSED_ALL_ONE_REQUIRED_TALKING_POINT_TITLE": "이 주제에 대해 1개의 필수 언급 항목을 누락했습니다.",
      "MISSED_ALL_X_REQUIRED_TALKING_POINTS_TITLE": "이 주제에 대해 {{count}}개의 필수 언급 항목을 누락했습니다.",
      "REVIEW_MATERIAL_NEXT_TIME": "다음 번을 위해 자료를 다시 확인하여 실력을 향상시키세요.",
      "ROLEPLAY_POST_CALL_TITLE": "통화가 끝났습니다.",
      "ROLEPLAY_POST_CALL_SUBTITLE_PROCESSING": "결과를 처리하는 동안 의견을 남겨주세요.",
      "ROLEPLAY_POST_CALL_SUBTITLE_DELAY": "결과를 불러오는 데 다소 시간이 걸립니다. 이 학습 경로를 종료하시면 결과가 준비되는 대로 알려드리겠습니다.",
      "ROLEPLAY_POST_CALL_SUBTITLE_ERROR": "결과 처리 중에 오류가 발생했습니다. 다음 연락처로 지원팀에 문의해 주세요.",
      "ROLEPLAY_POST_CALL_PROCESSING_LABEL": "결과 처리 중...",
      "ROLEPLAY_POST_CALL_FEEDBACK_QUESTION": "이번 대화가 현실적이고 자연스러웠나요?",
      "FEEDBACK_THANK_YOU": "피드백을 보내 주셔서 감사합니다!",
      "FEEDBACK_IMPROVEMENT_NOTE": "피드백을 보내 주셔서 감사합니다! 사용자 경험을 개선하기 위해 노력하겠습니다.",
      "VIEW_RESULTS": "결과 보기",
      "FEEDBACK_IMPROVEMENT_SUFFIX": "사용자 경험을 개선하기 위해 노력하겠습니다.",
      "POINT_LABEL": "점",
      "GREAT_JOB_PRACTICED_FEMALE": "잘하셨습니다. {{count}}{{times}} 연습했습니다. 이대로 계속하세요!",
      "ACCURACY": "정확도",
      "ACCURACY_LOADING": "불러오는 중...",
      "ACCURACY_FLAGGED_MESSAGE": "원본 자료와 다소 차이가 있을 수 있는 내용을 언급하셨습니다. 자세한 내용은 아래를 참조하세요.",
      "ACCURACY_ALL_CLEAR": "원본 자료와 불일치하는 주장을 확인하지 못했습니다.",
      "ACCURACY_ERROR": "이번 세션에 대한 피드백을 제공하지 못했습니다",
      "ACCURACY_YOU_SAID": "귀하가 언급한 내용",
      "ACCURACY_CLAIM_IDENTIFIED": "Quantified가 확인한 주장",
      "ACCURACY_MATERIALS_STATE": "귀하의 자료에 명시된 내용",
      "ACCURACY_OVERALL_BLOCK_PREFIX": "귀하의 언급 중 일부 내용이 부정확할 수 있습니다. 확인하려면 ",
      "ACCURACY_OVERALL_BLOCK_LINK": "정확도",
      "ACCURACY_OVERALL_BLOCK_SUFFIX": " 탭에서 자세한 내용을 참조하세요.",
      "PRACTICE_SIMULATION_AGAIN": "시뮬레이션 다시 연습하기",
      "CALL_TYPE_CONVERSATIONAL": "대화형 통화",
      "CALL_TYPE_GUIDED": "안내형 통화",
      "CALL_TYPE_VISUAL_AID": "시각 자료 보조 통화",
      "CALL_TYPE_ROLEPLAY": "롤플레이 통화",
      "PERSONALIZED_PRACTICE_BREADCRUMB": "맞춤형 연습",
      "CONVERSATION_TYPE_LABEL": "대화 유형:",
      "DIFFICULTY_LABEL": "난이도:",
      "MOOD_LABEL": "분위기:",
      "DIFFICULTY": "난이도",
      "TEMPERAMENT": "성향",
      "OVERALL_SCORE_TAB": "종합",
      "MESSAGE_ADHERENCE_TAB": "메시지",
      "OBJECTIVES_TAB": "목표"
    },
    "reportingV2": {
      "DASHBOARD": "대시보드",
      "LOADING_ACCOUNTS": "계정 불러오는 중...",
      "SELECT_AN_ACCOUNT": "계정 선택",
      "SELECT_ASSIGNMENTS": "과제 선택",
      "SEARCH_TEAMS": "팀 검색",
      "LOADING_TEAMS": "팀 불러오는 중...",
      "ALL_TEAMS": "모든 팀",
      "ACCOUNT": "계정",
      "TEAMS": "팀",
      "TEAM_LABEL": "팀",
      "TOTAL_LABEL": "총계",
      "PASSING_SCORE": "합격 점수",
      "ASSIGNMENT_LABEL": "과제",
      "USER_LABEL": "사용자",
      "PRACTICE_LABEL": "연습",
      "CERTIFICATION_LABEL": "인증",
      "CERTIFICATION_STATUS_LABEL": "인증 상태",
      "CERTIFICATION_STATUS_PREFIX_LABEL": "인증 상태:",
      "CERTIFIED_ON_FIRST_ATTEMPT_LABEL": "첫 번째 시도에서 인증을 취득했습니까?",
      "DATE_OF_CERTIFICATION_LABEL": "인증 날짜",
      "RESULTS_DESCRIPTION": "다음은 모든 연습 과제에 대한 팀 결과입니다.",
      "ENGAGEMENT_BY_ASSIGNMENT": "과제별 참여 상태",
      "ASSIGNMENT_ENGAGEMENT": "과제 참여 상태",
      "ENGAGED_LABEL": "참여함",
      "ENGAGEMENT_STATUS_LABEL": "참여 상태",
      "ENGAGEMENT_STATUS_PREFIX_LABEL": "참여 상태:",
      "PROFICIENT_LABEL": "숙련",
      "ASSIGNMENT_NAME": "과제명",
      "ACTIVE_USERS": "활성 사용자",
      "ASSIGNMENT_PROGRESS": "과제별 진행 상황",
      "IN_PROGRESS_LABEL": "진행 중",
      "CERTIFIED_LABEL": "인증됨",
      "OUT_OF_ATTEMPTS_LABEL": "시도 횟수 소진",
      "USERS_ENGAGED_LABEL": "참여한 사용자",
      "SESSIONS_PER_ACTIVE_USERS_LABEL": "활성 사용자당 세션 수",
      "HIGHER_THAN_LABEL": "보다 높음",
      "MORE_THAN_LABEL": "보다 많음",
      "TOTAL_SESSIONS_COMPLETED_LABEL": "완료된 총 세션 수",
      "USER_CERTIFIED": "모든 과제에서 인증받은 사용자",
      "ASSIGNMENT_CERTIFICATION": "100% 인증을 받은 과제",
      "TRAINER_TIME_SAVED": "강사 시간 절감",
      "HOURS_LABEL": "시간",
      "PRACTICE_ASSIGNMENT_LABEL": "연습 과제",
      "CERTIFICATION_ASSIGNMENT_LABEL": "인증 과제",
      "START_DATE_LABEL": "시작 날짜",
      "END_DATE_LABEL": "종료 날짜",
      "NAME_LABEL": "이름",
      "EMAIL_LABEL": "이메일",
      "MEMBER_OF_TEAMS_LABEL": "소속 팀",
      "ASSIGNMENTS_COUNT_LABEL": "과제 수",
      "TOTAL_SESSIONS_LABEL": "총 세션 수",
      "NUMBER_OF_SESSIONS_LABEL": "세션 수",
      "TOTAL_USERS_LABEL": "총 사용자 수",
      "AVERAGE_SCORE_LABEL": "평균 점수",
      "INITIAL_SCORE_LABEL": "초기 점수",
      "HIGH_SCORE_LABEL": "최고 점수",
      "LAST_PRACTICE_DATE_LABEL": "최근 연습 날짜",
      "PERCENT_IMPROVED_LABEL": "% 향상됨",
      "PERCENT_IMPROVED_TOOLTIP_TEXT": "이 지표는 사용자의 초기 점수와 최고 점수를 비교하여, 달성 가능한 최대 향상폭 대비 실제 향상분을 백분율로 나타냅니다.",
      "ASSIGNMENTS_CERTIFIED_LABEL": "인증된 과제 수",
      "ASSIGNMENTS_PROFICIENT_LABEL": "숙련된 과제",
      "ASSIGNMENTS_CERTIFIED_TOOLTIP_TEXT": "사용자가 과제에 포함된 모든 시뮬레이션에 대하여 점수 기준을 충족하거나 초과한 경우 과제의 수",
      "ASSIGNMENTS_PROFICIENT_TOOLTIP_TEXT": "사용자가 과제에 포함된 모든 시뮬레이션에 대하여 점수 기준을 한 번 이상 충족하거나 초과한 경우 과제의 수",
      "PROFICIENT_TOOLTIP": "이 과제에 포함된 모든 시뮬레이션에 대하여 점수 기준을 한 번 이상 충족하거나 초과한 사용자의 비율",
      "ENGAGED_TOOLTIP": "이 과제에 포함된 시뮬레이션의 세션 중 하나 이상을 완료했으나, 아직 모든 시뮬레이션에서 숙련도 기준을 달성하지 못한 사용자의 비율.",
      "IN_PROGRESS_TOOLTIP": "이 과제에 포함된 시뮬레이션의 세션 중 하나 이상을 완료하고 점수를 받은 사용자의 비율.",
      "OUT_OF_ATTEMPTS_TOOLTIP": "과제에 포함된 하나 이상의 시뮬레이션에 대하여 할당된 시도 횟수를 초과한 사용자의 비율.",
      "CERTIFIED_TOOLTIP": "과제에 포함된 모든 시뮬레이션에 대하여 점수 기준을 충족하거나 초과한 사용자의 비율.",
      "SEARCH_FOR_A_USER_LABEL": "사용자 검색",
      "NO_USERS_FOUND_LABEL": "사용자가 없습니다",
      "TRAINER_TIME_SAVED_TOOLTIP": "사용자가 Quantified에서 인증을 완료하는 데 소요한 시간입니다.",
      "AVG_SESSIONS_PER_ASSIGNMENT": "과제당 평균 세션 수",
      "ASSIGNMENTS_ENGAGED_WITH": "참여한 과제 수",
      "AVERAGE_IMPROVEMENT": "평균 향상도",
      "STATUS": "상태",
      "ASSIGNMENT_STATUS": "과제 상태",
      "STATUS_ACTIVE": "활성",
      "STATUS_ENDED": "종료됨",
      "STATUS_CLOSED": "마감됨",
      "STATUS_ARCHIVED": "보관됨",
      "TOTAL_NUMBER_OF_SESSIONS": "총 세션 수",
      "DATE_OF_LAST_PRACTICE": "최근 연습 날짜",
      "CALL_NAME": "통화명",
      "SESSION_DATE": "세션 날짜",
      "DURATION_OF_SESSION": "세션 소요 시간",
      "DURATION_OF_ATTEMPT": "시도 소요 시간",
      "OVERALL_SCORE": "종합 점수",
      "MESSAGING_SCORE": "메시지 준수 점수",
      "METHODOLOGY_SCORE": "방법론 점수",
      "SKILLS_SCORE": "스킬 점수",
      "SESSIONS": "세션 수",
      "TOTAL": "총계",
      "ALL_ASSIGNMENTS": "모든 과제",
      "RECENT_ASSIGNMENTS": "최근 과제",
      "USER_NAME": "사용자 이름",
      "LEARNER": "학습자",
      "DATE_RANGE": "날짜 범위",
      "DATE_RANGE_LABEL": "날짜 범위",
      "SEARCH_USERS": "사용자 검색...",
      "SEARCH_SIMULATIONS": "시뮬레이션 검색...",
      "SEARCH_DATES": "날짜 검색...",
      "SEARCH_ASSIGNMENTS": "과제 검색...",
      "CERTIFIED_ON_FIRST_TRY": "첫 시도에서 인증 획득",
      "DATE_OF_CERTIFICATION": "인증 날짜",
      "AVERAGE_CERTIFICATION_SCORE": "평균 인증 점수",
      "TOTAL_TIME_CERTIFYING": "인증에 소요된 총 시간",
      "OF_THE_TIME": "확률",
      "AVERAGE_SESSIONS_ACTIVE_USER": "활성 사용자당 평균 세션 수",
      "HOURS_IN_SIMULATIONS": "시뮬레이션 소요 시간",
      "AVERAGE_SESSIONS_TO_PROFICIENCY": "숙련까지 소요된 평균 세션 수",
      "PERCENT_PROFICIENT": "숙련 비율",
      "SYSTEM_RUNNING_NORMALLY": "시스템은 현재 정상적으로 작동 중입니다",
      "PRACTICE_SIMULATIONS_LABEL": "시뮬레이션 수",
      "SIMULATION_NAME": "시뮬레이션 이름",
      "AVERAGE_DURATION_OF_SESSION": "세션의 평균 지속 시간",
      "AVERAGE_SESSIONS_PER_ACTIVE_USER": "활성 사용자당 평균 세션 수",
      "NO_USERS_MATCHING_FILTERS_LABEL": "필터 조건에 맞는 결과가 없습니다. 검색 범위를 넓히려면 하나 이상의 필터를 해제해 보세요.",
      "USERS_PASSED": "시뮬레이션을 통과한 사용자 수",
      "AVERAGE_TIME": "인증까지 걸리는 평균 시간",
      "USERS_OUT_OF_ATTEMPTS": "시도 횟수를 소진한 사용자 수",
      "NO_CERTIFICATION_SIMULATION": "인증 시뮬레이션이 없습니다",
      "AVERAGE_OVERALL_SCORE": "평균 종합 점수",
      "SIMULATION": "시뮬레이션",
      "No_SIMULATION": "세션 없음",
      "PERCENT_CERTIFIED": "인증 획득률",
      "PERCENT_CERTIFIED_FIRST_ATTEMPT": "1차 시도에서 인증 획득 비율",
      "USERS": "사용자",
      "ATTEMPTS_LABEL": "시도 횟수",
      "NO_ATTEMPTS": "시도 횟수 없음",
      "DATE_OF_SESSION": "세션 날짜",
      "TOTAL_ASSIGNMENTS": "총 과제 수",
      "ASSIGNMENTS_CERTIFIED": "인증된 과제 수",
      "TOTAL_SESSIONS": "총 세션 수",
      "HOURS_SPENT_PRACTICING": "연습에 소요된 시간",
      "LAST_LOGIN": "최근 로그인",
      "NO_ASSIGNMENTS_MATCH_FILTERS": "선택한 필터에 해당하는 과제가 없습니다",
      "NO_TEAMS_DATA": "이 계정에는 팀이 없습니다",
      "ASSIGNED_LABEL": "시작하지 않음",
      "USERS_ASSIGNED_LABEL": "총 할당 사용자 수",
      "SESSION_ID": "세션 ID",
      "USER_NAME_LABEL": "사용자 이름",
      "NO_SIMULATIONS_FOUND_LABEL": "시뮬레이션이 없습니다",
      "MIN": "분",
      "SEC": "초",
      "OF_LABEL": "/",
      "SECOND": "초",
      "SECONDS": "초",
      "MINUTE": "분",
      "MINUTES": "분",
      "ASSIGNMENT_NAME_LABEL": "과제명",
      "SIMULATION_NAME_LABEL": "시뮬레이션 이름",
      "START_DATE": "시작 날짜",
      "END_DATE": "종료 날짜",
      "NO_ASSIGNMENTS": "이 사용자에 대한 과제가 없습니다.",
      "ASSIGNED": "할당됨",
      "TOTAL_PRACTICE_ASSIGNMENTS": "총 연습 과제 수",
      "SESSION_SCORES_OVER_TIME": "세션 점수 추이",
      "TIME": "시간",
      "SCORE": "점수",
      "NO_SESSIONS_AVAILABLE": "그래프로 표시할 세션이 없습니다.",
      "MESSAGING_SCORE_LABEL": "메시지 점수",
      "PERSONALIZED_PRACTICE_LABEL": "맞춤형 연습",
      "NO_PRODUCTS": "선택한 팀에 대한 맞춤형 연습 제품이 없습니다",
      "TOTAL_TIME_SPENT_PRACTICING": "연습에 소요된 총 시간",
      "AVERAGE_SESSIONS_PER_USER": "사용자당 평균 세션 수",
      "MOST_COMMON_CONVERSATION_TYPE_SELECTION": "가장 흔한 대화 유형 선택",
      "LEAST_COMMON_CONVERSATION_TYPE_SELECTION": "가장 드문 대화 유형 선택",
      "CLEAR": "지우기",
      "CLEAR_TEAMS": "팀 지우기",
      "METHODOLOGY_SCORE_DESCRIPTION": "학습자가 권장되는 통화 구조를 얼마나 잘 따르는지를 측정합니다. 점수는 이 시뮬레이션의 모든 세션에 대한 평균을 반영합니다.",
      "METHODOLOGY": "방법론",
      "MESSAGING": "메시지",
      "MESSAGING_V2_DASHBOARD_DESCRIPTION": "학습자가 통화 중에 핵심 아이디어를 명확하게 전달하는지 여부를 측정합니다. 차트는 모든 세션에 걸쳐 주제별로 메시지가 올바르게 전달된 평균 비율을 보여줍니다.",
      "NO_METRICS_MESSAGE": "인사이트를 도출하기 위해서는 더 많은 세션이 필요합니다.",
      "SELECT_ALL": "모두 선택",
      "DESELECT_ALL": "모두 선택 해제",
      "SKILLS": "스킬",
      "SKILLS_SCORE_STATS_DESCRIPTION": "학습자가 통화 중에 핵심 스킬을 얼마나 잘 사용하는지 측정합니다. 점수는 모든 세션에 대하여 평균을 낸 AI 평가 결과를 반영합니다.",
      "EXPERT": "전문가",
      "PROFICIENT": "숙련",
      "DEVELOPING": "발전 중",
      "FULLY_ARTICULATED": "완전히 전달됨",
      "PARTIALLY_ARTICULATED": "부분적으로 전달됨",
      "NOT_MENTIONED": "언급되지 않음",
      "MESSAGING_SCORE_STATS_DESCRIPTION": "학습자가 통화 중에 핵심 아이디어를 명확하게 전달하는지 여부를 측정합니다. 차트는 모든 세션에 걸쳐 각 메시지가 올바르게 전달된 빈도를 보여줍니다.",
      "CLEAR_STATUS": "상태 지우기",
      "CLEAR_USERS": "사용자 지우기",
      "CLEAR_SIMULATIONS": "시뮬레이션 지우기",
      "CLEAR_ASSIGNMENTS": "과제 지우기",
      "MODAL_SUBHEADING": "총 {{ count }}개 목표 — 모든 세션의 평균 점수",
      "VIEW_ALL_OBJECTIVES": "모든 {{ count }}개 목표 보기 →",
      "LEAST_MISSED_QUESTION": "가장 적게 틀린 문제",
      "MOST_MISSED_QUESTION": "가장 많이 틀린 문제",
      "HIGHEST_SCORING_METHODOLOGY_SECTION": "점수가 가장 높은 방법론 섹션",
      "LOWEST_SCORING_METHODOLOGY_SECTION": "점수가 가장 낮은 방법론 섹션",
      "LEAST_ARTICULATED_MESSAGE": "가장 전달되지 않은 메시지",
      "ENGAGEMENT": "참여도",
      "USER_ENGAGEMENT_MORE_SESSIONS": "완료 세션 수(팀 평균 초과)",
      "USER_ENGAGEMENT_FEWER_SESSIONS": "완료 세션 수(팀 평균 미만)",
      "QUESTION_CORRECT_PERCENTAGE_DESC": "정답을 맞힌 비율",
      "QUESTION_CORRECT_PERCENTAGE_DESC_ASSIGNMENT": "정답을 맞힌 사용자 비율",
      "METHODOLOGY_AVERAGE_POINTS_DESC": "모든 세션을 통틀어 이 목표에 대한 평균 점수",
      "MOST_ARTICULATED_MESSAGE": "가장 잘 전달된 메시지",
      "LEAST_MISSED_ANSWER_POINT": "가장 적게 누락한 응답 항목",
      "MOST_MISSED_ANSWER_POINT": "가장 많이 누락된 응답 항목",
      "MOST_ARTICULATED_MESSAGE_DESCRIPTION": "이 메시지를 완벽하게 전달한 비율",
      "LEAST_ARTICULATED_MESSAGE_DESCRIPTION": "이 메시지를 전달한 비율",
      "MOST_ARTICULATED_MESSAGE_DESCRIPTION_ASSIGNMENT": "이 메시지를 전달한 사용자 비율",
      "LEAST_ARTICULATED_MESSAGE_DESCRIPTION_ASSIGNMENT": "이 메시지를 전달한 사용자 비율",
      "OTHERS_SINGULAR": "및 1개 더",
      "OTHERS_PLURAL": "및 {{ count }}개 더",
      "PAGINATION_PREVIOUS": "이전",
      "PAGINATION_NEXT": "다음",
      "HOUR_LABEL": "시간",
      "SESSIONS_LABEL": "세션"
    },
    "personalizedPractice": {
      "TITLE": "맞춤형 연습",
      "DESCRIPTION": "{{userFirstName}} 님 안녕하세요! 맞춤형 연습을 통해 최대한 실제에 가까운 시나리오를 설정할 수 있습니다.",
      "LOADING": "불러오는 중...",
      "VIEW_SESSIONS": "세션 보기",
      "VIEW_SIMULATION": "시뮬레이션 보기",
      "TOTAL_SESSION": "총 세션",
      "TOTAL_SESSIONS": "총 세션",
      "BREADCRUMB": "맞춤형 연습",
      "SCENARIO_DETAILS_TITLE": "시나리오 상세 정보",
      "SCENARIO_DETAILS_DESCRIPTION": "아래 옵션에서 변수를 선택하여 원하는 대로 시뮬레이션을 조정하세요.",
      "AVATAR": "아바타",
      "SELECT_PLACEHOLDER": "선택",
      "CONVERSATION_TYPE": "대화 유형",
      "SELECT_CONVERSATION_TYPE": "대화 유형 선택",
      "LAUNCH_SIMULATION": "선택한 항목으로 시뮬레이션 시작",
      "PREVIOUS_SESSIONS": "이전 세션",
      "TOTAL": "총계",
      "FILTERS": "필터:",
      "DATE": "날짜",
      "DIFFICULTY": "난이도",
      "TEMPERAMENT": "성향",
      "SESSION_DATE": "세션 날짜",
      "SESSION_SCORE": "세션 점수",
      "DURATION": "소요 시간",
      "OVERALL_SCORE": "종합 점수",
      "MESSAGING": "메시지",
      "METHODOLOGY": "방법론",
      "SKILLS": "스킬",
      "RESULTS": "결과",
      "VIEW_FEEDBACK": "피드백 보기",
      "OVERALL_SCORE_LABEL": "종합 점수",
      "SCORE": "점수",
      "NO_PRODUCTS_TITLE": "사용 가능한 제품이 없습니다",
      "NO_PRODUCTS_DESCRIPTION": "아직 맞춤형 연습 제품이 없습니다.",
      "NO_SESSIONS_FOUND": "선택한 필터에 해당하는 세션이 없습니다",
      "TIME": "시간",
      "ALL": "전체",
      "LEARNER": "학습자",
      "MOOD": "분위기",
      "CLEAR_FILTERS": "필터 지우기",
      "PAGINATION_PREVIOUS": "이전",
      "PAGINATION_NEXT": "다음",
      "DURATION_MINUTES_SECONDS": "{{minutes}}분 {{seconds}}초",
      "DURATION_SECONDS": "{{seconds}}초"
    },
    "login": {
      "TITLE": "다시 오신 것을 환영합니다",
      "SUB_TITLE": "어떤 방법으로 로그인하시겠습니까?  ",
      "LOGIN_WITH_SSO": "회사 SSO로 로그인",
      "LOGIN_WITH_PASSWORD": "비밀번호로 로그인",
      "PROVIDE_EMAIL": "이메일 주소를 입력해 주세요",
      "HELP_TEXT": "도움이 필요하신가요? 문의하기",
      "EMAIL_ERROR": "로그인하지 못했습니다. 회사 관리자나 IT 부서에 문의하시기 바랍니다.",
      "EMAIL": "이메일",
      "LOGIN": "로그인",
      "ALERT": "알림",
      "EMAIL_PLACEHOLDER": "olivia@untitledui.com",
      "LOGIN_CONSENT_MESSAGE": "계정에 로그인하면 {{termsLink}} 및 {{privacyLink}}에 동의하는 것으로 간주됩니다.",
      "TERMS_OF_SERVICE": "서비스 약관",
      "PRIVACY_POLICY": "개인정보 처리방침",
      "WRONG_REGION_MESSAGE": "로그인하지 못했습니다. 회사 관리자에게 문의하시기 바랍니다.",
      "WRONG_REGION_LINK": "{{regionName}} 사이트에 로그인해 보실 수도 있습니다."
    },
    "learningPathway": {
      "BEGIN": "시작",
      "SUBMIT_ANSWER": "응답 제출",
      "CONTINUE": "계속",
      "REVIEW_MATERIAL": "학습 자료 복습",
      "ASK_QUESTIONS_ABOUT_PATHWAY": "이 학습 경로에 대해 질문하기",
      "DUE_DATE": "마감일",
      "FOOTER_SUBTITLE_READY": "무엇이든 물어보세요! 기꺼이 도와드리겠습니다.",
      "FOOTER_SUBTITLE_READY_LEARN_WITH_X": "코치가 질문을 귀 기울여 듣고 있습니다",
      "FOOTER_SUBTITLE_MUTED": "현재 음소거 상태입니다. 코치에게 목소리가 들리지 않습니다.",
      "FOOTER_SUBTITLE_LISTENING": "질문을 듣고 있습니다...",
      "FOOTER_SUBTITLE_THINKING": "답변을 생각 중입니다...",
      "LEAVE_STEP": "단계 나가기",
      "VIEW_CALL_DETAILS": "통화 상세 정보 보기",
      "NEXT_STEP": "다음 단계",
      "NOTIFICATIONS_ARIA": "알림",
      "PDF_LOADING": "PDF 불러오는 중",
      "PDF_NEXT_PAGE": "다음 페이지",
      "PDF_NO_SOURCE": "제공된 PDF 자료가 없습니다.",
      "PDF_PREVIOUS_PAGE": "이전 페이지",
      "PDF_SCROLL_HINT": "스크롤하여 계속 읽기",
      "PDF_FULLSCREEN_ENTER": "전체 화면으로 전환",
      "PDF_FULLSCREEN_EXIT": "전체 화면 종료",
      "PDF_ZOOM_IN": "확대",
      "PDF_ZOOM_OUT": "축소",
      "POST_CALL_SUBTITLE": "결과를 처리하는 동안 의견을 남겨주세요",
      "POST_CALL_TITLE": "퀴즈가 끝났습니다.",
      "SETTINGS": "설정",
      "TOAST_CONTENT": "아래를 클릭하여 결과를 확인하거나, 학습 경로 상세 화면으로 돌아가 다음 단계를 확인하세요.",
      "TOAST_TITLE": "{{ stepName }} 롤플레이 결과가 처리되었습니다",
      "ASSIGNMENTS": "과제",
      "USER_FALLBACK": "사용자",
      "VIEW_RESULTS": "결과 보기",
      "DISMISS": "닫기",
      "QUIZ_TITLE": "퀴즈",
      "QUIZ_OVERALL_SCORE_TOOLTIP": "종합 점수는 이번에 시도한 응답의 가중 평균입니다.",
      "COLUMN_DATE": "날짜",
      "COLUMN_OVERALL_SCORE": "종합 점수",
      "COLUMN_RESULTS": "결과",
      "COLUMN_ANSWER_POINTS": "응답 점수",
      "COLUMN_MESSAGING_SCORE": "메시지 점수",
      "COLUMN_METHODOLOGY_SCORE": "방법론 점수",
      "COLUMN_SKILLS_SCORE": "스킬 점수",
      "PRACTICE_AGAIN": "다시 연습하기",
      "DEBRIEF_LATEST_SESSION": "최신 세션 결과 분석",
      "COMPLETE_STEP": "완료",
      "ERROR_TITLE": "문제가 발생했습니다",
      "ERROR_MESSAGE": "종료한 후 학습 경로에 다시 접속해 주세요. 문제가 지속되면 다음 연락처로 문의해 주세요.",
      "ERROR_HELP_EMAIL": "help@quantified.ai",
      "PATHWAY_COMPLETED_TITLE": "이 학습 과정을 완료하셨습니다",
      "PATHWAY_COMPLETED_BODY": "언제든지 결과를 확인할 수 있으며, 원하는 단계로 다시 돌아가 계속 연습할 수 있습니다.",
      "PATHWAY_COMPLETED_RETURN": "과제로 돌아가기",
      "PATHWAY_OUT_OF_ATTEMPTS_TITLE": "학습 경로상 특정 단계의 시도 횟수를 다 소진했습니다",
      "PATHWAY_OUT_OF_ATTEMPTS_BODY": "다음 단계에 대해 매니저와 상담하시기 바랍니다.",
      "COMPLETED": "완료됨",
      "EXITING_QUIZ_EARLY": "지금 이 퀴즈를 종료하면 한 번의 시도로 간주됩니다",
      "TRY_AGAIN": "다시 시도",
      "RETURN_TO_PATHWAY": "학습 경로 홈으로 돌아가기",
      "REVIEW_BEFORE_QUIZ_TOOLTIP": "퀴즈를 다시 시도하기 전에 이 단계를 검토하세요",
      "EXIT_MODAL_TITLE": "이 롤플레이를 정말 종료하시겠습니까?",
      "EXIT_MODAL_EXIT": "종료하기",
      "EXIT_MODAL_RESUME": "계속하기",
      "EXIT_MODAL_DESC_LIMITED_ATTEMPTS": "지금 롤플레이를 종료하면 점수를 매기지는 않지만, 시도 횟수에는 포함됩니다.",
      "EXIT_MODAL_DESC_UNLIMITED_ATTEMPTS": "지금 롤플레이를 종료하면 점수를 매기지 않습니다.",
      "EXIT_MODAL_DESC_SCORED": "지금 롤플레이를 종료하면, 통화 내용을 있는 그대로 채점합니다.",
      "RESULTS_PROCESSING": "결과 처리",
      "RESULTS_FAILED": "결과를 불러오지 못했습니다. help@quantified.ai에 문의해 주세요",
      "DEBRIEF_TITLE": "결과 분석",
      "DEBRIEF_DESCRIPTION": "마지막 인증 시도 결과에 대해 설명해 주세요",
      "DEBRIEF_DESCRIPTION_PRACTICE": "마지막 연습 세션의 결과에 대해 설명해 주세요",
      "VIEW_ALL_SESSIONS": "모든 세션 보기",
      "COLLAPSE_SESSIONS": "세션 접기",
      "VIEW_ALL_ATTEMPTS": "모든 시도 보기",
      "COLLAPSE_ATTEMPTS": "시도 접기",
      "REATTEMPT_CERTIFICATION": "인증 재시도",
      "DEBRIEF_EXIT_MODAL_TITLE": "이 결과 분석을 종료하시겠습니까?",
      "DEBRIEF_EXIT_MODAL_DESC": "지금 결과 분석을 종료하면 완료로 표시되지 않습니다.",
      "EXIT_PATHWAY": "학습 경로 종료하기",
      "HELP": "도움말",
      "DOWNLOAD": "다운로드",
      "LEARN_STEP_HELP_CLOSE": "닫기",
      "LEARN_STEP_HELP_TROUBLE": "문제가 지속되면 다음 연락처로 문의해 주세요.",
      "LEARN_STEP_HELP_EMAIL": "help@quantified.ai",
      "LEARN_STEP_HELP_VIDEO_P1": "영상을 시청하고 코치에게 궁금한 점을 질문하세요.",
      "LEARN_STEP_HELP_VIDEO_P2": "재생 버튼을 눌러 동영상을 시작하세요. 앞으로 건너뛰기 하여 자료를 다시 복습할 수 있습니다.",
      "LEARN_STEP_HELP_VIDEO_P3": "질문을 하려면 오른쪽 하단의 음소거를 해제하세요. 이 경우 동영상이 일시 정지됩니다. 동영상을 재생하면 마이크가 자동으로 음소거됩니다.",
      "LEARN_STEP_HELP_VIDEO_P4": "동영상을 모두 시청하셨다면 다음 단계로 진행합니다.",
      "LEARN_STEP_HELP_PDF_P1": "자료를 읽고 코치에게 궁금한 점을 질문하세요.",
      "LEARN_STEP_HELP_PDF_P2": "스크롤하거나 양쪽의 화살표 버튼을 사용하여 페이지를 이동하며 자료를 살펴보세요.",
      "LEARN_STEP_HELP_PDF_P3": "오른쪽 하단에서 마이크 음소거를 켜거나 끌 수 있습니다.",
      "LEARN_STEP_HELP_PDF_P4": "모든 내용을 읽으셨다면 다음 단계로 진행하세요.",
      "ASSESSMENT_EXIT_MODAL_TITLE": "계속 진행하시겠습니까?",
      "ASSESSMENT_EXIT_MODAL_DESC": "이 대화를 완료하기 전에 다음 단계로 진행하면 학습 시간이 길어지고 맞춤형 학습 효과가 떨어질 수 있습니다.",
      "ASSESSMENT_EXIT_MODAL_RESUME": "평가 재개하기",
      "ASSESSMENT_EXIT_MODAL_PROCEED": "진행하기",
      "ASSESSMENT_PERSONALIZATION_ERROR_TITLE": "학습 경로를 맞춤화하지 못했습니다",
      "ASSESSMENT_PERSONALIZATION_ERROR_DESC_START": "학습 경로 전체를 할당해 드렸습니다. 맞춤화 재시도를 원하실 경우 ",
      "ASSESSMENT_PERSONALIZATION_ERROR_DESC_END": " 에 문의해 주세요",
      "OPTIONAL": "선택 사항"
    },
    "leaderboard": {
      "LEADERBOARD": "순위표",
      "TOP10PERCENT": "상위 10%",
      "PRACTICE_ASSIGNMENT": "연습 과제",
      "SIMULATION": "시뮬레이션",
      "SELECT_ASSIGNMENT": "과제 선택",
      "SELECT_SIMULATION": "시뮬레이션 선택",
      "SELECT_ASSIGNMENT_AND_SIMULATION": "선두 인원을 확인하려면 과제와 시뮬레이션을 선택하세요",
      "NO_DATA": "아직 활동이 없습니다. 팀원들이 활동을 시작하면 이곳에 순위가 표시됩니다.",
      "NO_ASSIGNMENTS_AVAILABLE": "수행 가능한 과제가 없습니다",
      "NO_SIMULATIONS_AVAILABLE": "수행 가능한 시뮬레이션이 없습니다",
      "NAME": "이름",
      "HIGH_SCORE": "최고 점수",
      "AVERAGE_SCORE": "평균 점수",
      "TOTAL_SESSIONS": "총 세션 수",
      "LAST_SESSION": "마지막 세션",
      "TOP5": "상위 5명",
      "OF": "/",
      "ENGAGED_USERS": "참여 사용자",
      "ENGAGED_USER": "참여 사용자",
      "NO_USERS_ENGAGED": "참여한 사용자가 없습니다",
      "HIDE_SESSIONS_WITH_LOW_SCORE": "스킬 점수가 낮은 세션 숨기기",
      "SESSIONS_WITH_LOW_SCORE_TOOLTIP": "스킬 섹션 점수가 '발전 중'인 세션은 높은 점수 또는 평균 점수 열에 반영되지 않습니다.",
      "PAGINATION_PREVIOUS": "이전",
      "PAGINATION_NEXT": "다음"
    },
    "hotjarSurveys": {
      "FEEDBACK_MESSAGE": "서비스를 개선할 수 있도록 의견을 공유해 주세요.",
      "THANK_YOU_MESSAGE": "감사합니다. 앞으로도 사용자 경험을 개선하기 위해 최선을 다하겠습니다."
    },
    "general": {
      "NEED_HELP_QUESTION": "도움이 필요하신가요?",
      "CONTACT": "문의하기",
      "HELP_EMAIL": "help@quantified.ai",
      "PARENT_ACCOUNT": "상위 계정",
      "ACCOUNT": "계정",
      "CHECKMARK": "체크 표시",
      "ICON": "아이콘",
      "ALERT": "알림",
      "HEADS_UP": "잠깐!",
      "USE_HEADPHONES_FOR_OPTIMAL_AUDIO": "iPad에서 최적의 음질로 이용하려면 헤드폰을 사용하세요.",
      "SETTINGS": "설정",
      "RP": "RP",
      "EMAIL_LABEL": "이메일",
      "RAVEN_EMAIL": "Raven@InspireHR.com",
      "TEAM_MANAGER_FOR": "다음의 팀 매니저",
      "MIAMI_SALE": "마이애미 영업팀",
      "CHARLOTTE_SALES": "샬럿 영업팀",
      "ATLANTA_SALES": "애틀랜타 영업팀",
      "TEAM": "팀",
      "ASSIGNMENTS": "과제",
      "MY_TEAMS": "내 팀",
      "REPORTING": "리포트",
      "DASHBOARD": "대시보드",
      "LEADERBOARD": "순위표",
      "PERSONALIZED_PRACTICE": "맞춤형 연습",
      "HELP_SEARCH_OUR": "Quantified",
      "HELP_OR_REACH_OUT_TO": "이메일",
      "HELP_WITH_QUESTIONS": "에 문의해 주세요",
      "KNOWLEDGE_BASE": "지식 베이스에서 검색하거나",
      "NO_ROLE_WEB_MESSAGE": "이 사용자는 시스템에 대한 접근 권한이 설정되어 있지 않습니다. 시스템 관리자에게 문의해 주세요.",
      "NO_ROLE_IOS_TITLE": "Quantified 앱은 학습자 경험에 중점을 두고 있습니다",
      "NO_ROLE_IOS_BODY_START": "모바일 브라우저에서 Quantified",
      "NO_ROLE_IOS_WEB_APP": "웹 앱에",
      "NO_ROLE_IOS_BODY_END": "접속하여 추가 기능을 이용해 보세요.",
      "HELP_SECTION": "도움말",
      "ABOUT_SECTION": "소개",
      "CONTACT_SUPPORT": "지원팀에 문의",
      "OPEN_WEB_APP": "웹 앱 열기",
      "SEARCH_KNOWLEDGE_BASE": "지식 베이스 검색",
      "PRIVACY_POLICY": "개인정보 처리방침",
      "TERMS_OF_SERVICE": "서비스 약관",
      "VERSION": "버전",
      "LOG_OUT": "로그아웃"
    },
    "dashboard": {
      "ALL": "전체",
      "IN_COMPLETE": "미완료",
      "COMPLETED": "완료됨",
      "NO_ASSIGNMENT_TITLE": "할당된 과제가 없습니다.",
      "NO_ASSIGNMENT_DETAILS": "완료해야 할 과제가 생기면 알림을 받게 됩니다.",
      "IN_COMPLETE_ASSIGNMENT_TITLE": "미완료 과제가 없습니다.",
      "IN_COMPLETE_ASSIGNMENT_DETAILS": "새로운 과제의 제출 기한이 다가오면 알림을 받게 됩니다.",
      "COMPLETED_ASSIGNMENT_TITLE": "완료된 과제가 없습니다.",
      "COMPLETED_ASSIGNMENT_DETAILS": "과제를 완료한 후 다시 확인해 주세요.",
      "NO_ASSIGNMENT_FILTERED_TITLE": "할당된 과제가 없습니다.",
      "NO_ASSIGNMENT_FILTERED_DETAILS": "수행 가능한 과제를 확인하려면 필터를 조정하거나, 새로운 과제가 추가되면 다시 확인해 주세요.",
      "VIEW_ASSIGNMENT": "과제 보기",
      "VIEW_PATHWAY": "학습 경로 보기",
      "START_PATHWAY": "학습 경로 시작",
      "GET_STARTED": "시작하기",
      "ASSIGNMENT_LABEL": "과제",
      "MODULE_ASSIGNMENT_ALT": "모듈 과제 아이콘",
      "VIEW_ASSIGNMENT_FOR": "다음에 대한 과제 보기",
      "DAY": "일",
      "DAYS": "일",
      "UNTILL_DUE": "남은 기한",
      "PAST_DUE": "기한 경과",
      "AVAILABLE_IN": "이용 가능 위치:",
      "DUE_TODAY": "오늘 마감",
      "PRACTICE": "연습",
      "CERTIFICATION": "인증",
      "UPCOMING": "예정",
      "TEST_ASSIGNMENT": "시험 과제",
      "CLOSED": "마감됨",
      "ENDED": "종료됨",
      "TOTAL": "총계",
      "ASSIGNMENT_STATUS_LABEL": "과제 상태",
      "ASSIGNMENT_STATUS_SELECTION_LABEL": "과제 상태:",
      "STATUS_SELECTION_LABEL": "상태:",
      "ASSIGNMENT_TYPE": "과제 유형",
      "ASSIGNMENT_TYPE_SELECTION_LABEL": "과제 유형:",
      "NOT_STARTED": "시작하지 않음",
      "CERTIFIED": "인증됨",
      "NOT_CERTIFIED": "인증되지 않음",
      "IN_PROGRESS": "진행 중",
      "PATHWAY": "학습 경로",
      "SELECT_ALL": "모두 선택",
      "DESELECT_ALL": "모두 선택 해제",
      "CLEAR_STATUS": "상태 지우기",
      "OTHERS_SINGULAR": "및 1개 더",
      "OTHERS_PLURAL": "및 {{ count }}개 더"
    },
    "cognito": {
      "INVITATION_SUBJECT": "Quantified에 오신 것을 환영합니다!",
      "INVITATION_MESSAGE": "여러분과 함께하게 되어 기쁩니다! 시작하시려면 아래 단계를 따라 계정에 처음으로 로그인해 주세요.",
      "ACCOUNT_DETAILS": "계정 상세 정보:",
      "USERNAME": "사용자 이름",
      "PASSWORD": "임시 비밀번호",
      "STEPS_LABEL": "로그인을 위한 다음 단계",
      "STEP_1": "1. 아래의 ‘로그인’ 버튼을 클릭하여 로그인 페이지로 이동합니다.",
      "STEP_2": "2. 위에 제공된 사용자 이름과 임시 비밀번호를 입력합니다.",
      "STEP_3": "3. 로그인 후, 새 비밀번호를 설정하라는 메시지가 표시됩니다.",
      "LOGIN_BUTTON": "로그인",
      "ABOUT_US": "Quantified의 시뮬레이터는 필수 스킬을 빠르게 습득하여 고객과 더 효과적으로 연결되고 소통할 수 있도록 돕기 위해 설계된 가상 환경입니다.",
      "EXPIRY_TIME": "이 임시 비밀번호는 24시간 후에 만료됩니다. 로그인에 문제가 있는 경우 Quantified 지원팀에 다음 이메일로 연락하시기 바랍니다.",
      "TEAM": "Quantified 팀",
      "INVITATION_SMS_USERNAME": "사용자 이름:",
      "INVITATION_SMS_PASSWORD": "임시 비밀번호:",
      "AUTHENTICATION_CODE": "인증 코드:",
      "PASSWORD_RESET_CODE": "Quantified 비밀번호 재설정 코드",
      "RESET_PASSWORD_EMAIL": "비밀번호 재설정 이메일",
      "HELLO": "안녕하세요",
      "USE_VERIFICATION_CODE": "비밀번호 재설정을 요청하셨습니다. 아래의 인증 코드를 사용하여 재설정 절차를 완료해 주세요.",
      "VERIFICATION_CODE": "인증 코드",
      "NEXT_STEP": "다음 단계",
      "RETURN_TO_PATHWAY": "학습 경로 홈으로 돌아가기",
      "RESET_PASSWORD_PAGE": "브라우저에서 비밀번호 재설정 페이지로 돌아가세요.",
      "ENTER_VERIFICATION_CODE": "메시지가 표시되면 인증 코드를 입력하세요.",
      "CREATE_PASSWORD": "코드가 인증되면 안내에 따라 새 비밀번호를 생성하세요.",
      "DISREGARD_NOTE": "비밀번호 재설정을 요청하지 않으셨다면 이 이메일은 무시해 주세요.",
      "CONTACT_SUPPORT": "추가 도움이 필요하시면 Quantified 지원팀에 다음 이메일로 문의하시기 바랍니다.",
      "HELP_EMAIL": "help@quantified.ai",
      "THANK_YOU": "감사합니다.",
      "QUANTIFIED_TEAM": "Quantified 팀",
      "ADDRESS": "4200 Marathon Blvd, Suite 210, Austin, Texas 78756, United States"
    },
    "call": {
      "LOADING": "불러오는 중",
      "SIMULATION_PAUSED": "시뮬레이션이 일시 중지되었습니다.",
      "CLICK_RESUME": "계속하려면 아래의 '계속하기' 버튼을 클릭하세요.",
      "NO_INTERNET": "인터넷에 연결되어 있지 않습니다",
      "TRY_AGAIN": "인터넷 연결 상태를 확인하고 다시 시도해 주세요.",
      "MIC_MUTED": "마이크가 음소거 상태입니다",
      "MIC_MUTED_DESCRIPTION": "이런, 마이크가 음소거 상태인 것 같습니다. 음소거를 해제하여 답변하고 계속 진행하세요.",
      "NO_RESPONSE": "답변이 감지되지 않았습니다",
      "MIC_NOT_CONNECTED": "이런, 마이크가 연결되지 않은 것 같습니다. 기기를 다시 선택하여 답변하고 계속 진행하세요.",
      "AUDIO_ISSUE": "죄송합니다. 문제가 발생했습니다. 기기 설정을 확인하고, 주위에 소음이 없는 조용한 장소에 있는지 확인해 주세요.",
      "LOADING_ALT": "불러오는 중...",
      "REPEAT_RESPONSE": "시뮬레이션 화면으로 자동으로 돌아가서 답변을 반복하고 다시 시도하게 됩니다.",
      "NEEDS_MORE_TIME_QUESTION": "에게 생각할 시간이 더 필요합니다. 기다리시겠습니까?",
      "NEEDS_MORE_TIME": "에게 생각할 시간이 더 필요합니다.",
      "WAIT_OR_END_CALL": "준비되면 알림을 보내드립니다. 혹은 통화를 종료하고",
      "RETURN_TO_ASSIGNMENTS": "과제로 돌아가실 수도 있습니다.",
      "READY": "준비 완료",
      "IS_READY": "대화를 계속할 준비가 되었습니다.",
      "TRY_AGAIN_LABEL": "다시 시도",
      "CHECK_SETTINGS": "설정 확인",
      "PAUSED_SIMULATION": "이 시뮬레이션을 일시 중지했습니다.",
      "PAUSED_SIMULATION_DESCRIPTION": "시뮬레이션이 재개될 때까지 동영상 및 오디오 녹화가 일시 중지됩니다.",
      "RESUME": "계속하기",
      "SETTINGS": "설정",
      "CAPTURING_RESPONSE": "답변 기록하기",
      "TOUR_MESSAGE": "말하기를 마친 후에는 '계속' 버튼을 클릭하여 답변을 기록하고 채점하세요.",
      "NEXT": "다음",
      "START_CALL": "시작",
      "END_CALL_TITLE": "이 시뮬레이션을 정말 종료하시겠습니까?",
      "END_CALL_DESCRIPTION": "지금 시뮬레이션을 종료하면 대화에 대한 점수나 피드백을 받을 수 없습니다.",
      "END_CALL": "종료",
      "BROWSER_ACCESS_DENIED": "이 기기에 대한 브라우저 접근이 거부되었습니다.",
      "COPY_SESSION_ID_BUTTON": "세션 ID 복사",
      "RECONNECTING_AUDIO": "오디오 재연결 중...",
      "TIPS_GUIDANCE_MESSAGE": "이곳에 언급 항목과 팁이 표시됩니다.",
      "CONTINUE": "계속",
      "SESSION_ID_LABEL": "세션 ID:",
      "SESSION_ID_COPIED": "세션 ID가 복사되었습니다!",
      "HINTS_AND_SUGGESTIONS_TITLE": "팁 및 제안",
      "HINT_LABEL": "힌트",
      "CAPTIONS_LABEL": "자막",
      "PAUSE_LABEL": "일시 정지",
      "VIDEO_LABEL": "동영상",
      "PARTY_EMOJI": "파티 이모티콘",
      "CALL_ENDED_MESSAGE": "이 시뮬레이션이 끝났습니다.",
      "CALL_ENDED_INACTIVITY": "비활성 상태로 인해 이 시뮬레이션이 종료되었습니다",
      "CALL_ENDED_GENERIC": "이 시뮬레이션이 종료되었습니다",
      "FEEDBACK_PROMPT": "결과를 처리하는 동안 의견을 남겨주세요.",
      "INTERACTION_THRESHOLD_NOT_MET": "채점을 위한 상호작용 기준 점수에 미달했습니다. 다시 시도해 주세요.",
      "REALISTIC_CONVERSATION_QUESTION": "이번 대화가 현실적이고 자연스러웠나요?",
      "KNOWLEDGEABLE_PREPARED_QUESTION": "이 시뮬레이션을 마친 후 지식이 늘고 업무 준비가 더 잘 되었다고 느끼시나요?",
      "FEEDBACK_THANK_YOU": "피드백을 보내 주셔서 감사합니다!",
      "FEEDBACK_IMPROVEMENT_NOTE": "피드백을 보내 주셔서 감사합니다! 사용자 경험을 개선하기 위해 노력하겠습니다.",
      "AUDIO": "오디오",
      "MUTE": "음소거",
      "UNMUTE": "음소거 해제",
      "VISUAL_AID_LOAD_ERROR": "시각 보조 자료를 불러오지 못했습니다",
      "BEGIN_CALL": "시작",
      "LEAVE_STEP_TITLE": "이 단계를 정말 종료하시겠습니까?",
      "EXIT": "종료하기",
      "LEAVE_CALL_BRIEFING": "브리핑 종료",
      "RESTORE_CALL": "시뮬레이션 복원 중",
      "FEW_SECONDS": "이 작업에는 몇 초 가량 소요될 수 있습니다.",
      "CHECK_ALT": "확인",
      "COPY_ALT": "복사",
      "HINTS_ALT": "힌트",
      "CLOSE_CAPTIONS": "자막 닫기",
      "MICROPHONE_MUTED": "마이크 음소거됨",
      "RETURN_TO_CALL": "시뮬레이션으로 돌아가기",
      "YES": "예",
      "NO": "아니요",
      "VIEW_RESULTS": "결과 보기",
      "RETURN_TO_ASSIGNMENT": "과제로 돌아가기",
      "HAVING_ISSUES": "연결에 문제가 있습니다. 인터넷 연결을 확인한 후 '확인'을 클릭해 주세요.",
      "OK": "확인",
      "RESULTS_NOT_GENERATED": "죄송합니다. 현재 결과를 생성할 수 없습니다. 다시 시도해 주세요.",
      "INACTIVITY_ALERT_MESSAGE": "비활성 상태로 인해 통화가 종료됩니다. 계속 진행하려면 아바타에게 말을 걸거나, 통화를 종료하려면 '통화 종료'를 선택해 주세요.",
      "INACTIVITY_DEFAULT_ALERT_TITLE": "이 통화는 {{secondsUntilHangup}}초 후에 종료됩니다",
      "INACTIVITY_SHORT_ALERT_TITLE": "이 통화는 몇 초 후에 종료됩니다",
      "TELL_YOUR_GENDER_HEADING": "성별을 알려주세요.",
      "BY_KNOWING_YOUR_GENDER_DESCRIPTION": "성별을 알려주시면 아바타가 적절한 문법을 사용하여 대화를 더욱 자연스럽고 현실감 있게 이끌어갈 수 있습니다.",
      "GENDER_SELECTION": "성별 선택:",
      "SELECT_OPTION": "옵션을 선택하세요",
      "CONFIRM": "확인",
      "MALE": "남성",
      "FEMALE": "여성",
      "NON_BINARY": "논바이너리/기타",
      "PREFER_NOT_TO_ANSWER": "답변을 원치 않음",
      "NON_BINARY_MESSAGE": "귀하의 논바이너리 정체성을 이해하고 존중합니다. 현재 기술적 한계로 인해, 기본적으로 남성 대명사를 사용하고 있습니다. 향후 모든 성 정체성을 더 잘 반영할 수 있도록 개선 작업을 진행 중임을 알려드립니다. 양해해 주셔서 감사합니다.",
      "PREFER_NOT_TO_ANSWER_MESSAGE": "성별을 밝히지 않으시기로 한 선택을 존중합니다. 이러한 경우, 현재 기술적 한계로 인해 시스템은 기본적으로 남성 대명사를 사용합니다.",
      "DISPLAY_VISUAL_AID": "시각 보조 자료 표시",
      "FULL_SCREEN": "전체 화면",
      "COLLAPSE": "접기",
      "COMPLETED_CONVERSATION_MESSAGE": "대화를 완료해 주셔서 감사합니다",
      "CONVERSATION_COMPLETION_FEEDBACK": "대화를 처리하는 동안 피드백을 남겨 주세요.",
      "ERROR_MESSAGE": "오류가 발생했습니다. 다음 연락처로 문의해 주세요.",
      "SAVED_CONVERSATION_MESSAGE": "대화가 저장되었습니다.",
      "RETURN_TO_MY_ASSIGNMENTS": "내 과제로 돌아가기",
      "RETURN_TO_PERSONALIZED_PRACTICE": "맞춤형 연습으로 돌아가기",
      "CERT_ACK_TITLE": "인증 동영상 확인",
      "CERT_ACK_ACCEPT_AND_BEGIN": "동의하고 시작하기",
      "CERT_ACK_RESUME_CALL": "통화 재개",
      "CERT_ACK_PROCESSING": "처리 중...",
      "CERT_ACK_CAMERA_WARNING": "인증 절차를 진행하려면 카메라를 켜 주세요.",
      "CERT_ACK_CAMERA_OFF_DURING_CALL": "카메라가 꺼져 있습니다. 인증 절차를 재개하려면 카메라를 다시 켜 주세요.",
      "CERT_ACK_TEXT_1": "본 인증의 무결성과 공정성을 보장하기 위해, 세션이 진행되는 동안 카메라를 켜 두어야 하며, 세션은 모니터링됩니다. 이 요건은 모든 인증 기준을 준수하는지 확인하기 위한 것입니다.",
      "CERT_ACK_TEXT_2": "계속 진행함으로써 귀하는 이러한 요건을 확인하고 이에 동의하는 것으로 간주됩니다.",
      "CERT_ACK_END_CALL": "통화 종료",
      "LAUNCH_SIMULATION": "시뮬레이션 시작",
      "DEBRIEF_LATEST_SESSION": "최신 세션 결과 분석",
      "END": "종료",
      "START_DEBRIEF": "최신 세션 결과 분석",
      "MOVE_TO_NEXT": "다음 단계로 이동",
      "RETRY_ROLEPLAY": "롤플레이 다시 시도",
      "EXIT_PATHWAY": "학습 경로 종료하기",
      "PROCESSING": "처리 중...",
      "FEEDBACK_PROMPT_REQUIRED": "결과를 확인하기 전에 피드백을 남겨주세요.",
      "SCREENSHARE_LABEL": "화면 공유",
      "SCREENSHARE_UNSUPPORTED_TITLE": "{{callName}}이(가) 화면 공유를 사용하고 있습니다",
      "SCREENSHARE_UNSUPPORTED_MESSAGE_APP": "통화를 계속 진행하려면 브라우저 대신 Qualified 앱을 사용해 주세요.",
      "SCREENSHARE_UNSUPPORTED_MESSAGE_DESKTOP": "통화를 계속하려면 데스크톱 컴퓨터에서 접속해 주세요.",
      "SCREENSHARE_UNSUPPORTED_CLOSE_BUTTON": "닫기",
      "SCREENSHARE_UNSUPPORTED_GO_TO_APP_BUTTON": "앱으로 이동",
      "SCREENSHARE_UNSUPPORTED_GO_TO_APP_UNAVAILABLE": "모바일 앱은 아직 이용하실 수 없습니다. 조만간 다시 확인해 주세요.",
      "SCREENSHARE_STOP_LABEL": "화면 공유 중지",
      "SCREENSHARE_PIP_REOPEN_LABEL": "동영상 미리보기 다시 열기",
      "SCREENSHARE_ACTIVE_LABEL": "현재 화면 공유 중입니다",
      "SCREENSHARE_OS_PERMISSION_HINT": "화면 공유를 시작할 수 없습니다. ‘시스템 설정 > 개인정보 및 보안’에서 브라우저의 화면 녹화 기능을 활성화한 후 다시 시도해 주세요.",
      "SCREENSHARE_SAFARI_BLOCKED_HINT": "Safari에서 이 세션의 화면 공유를 차단했습니다. 로그아웃한 후 다시 로그인하고 재차 시도해 주세요."
    },
    "assignment": {
      "STATUS": "상태",
      "SCORE": "점수",
      "MUST_ACHIEVE": "반드시",
      "OR_HIGHER": "또는 그 이상의 점수를 달성해야 합니다",
      "TEST": "시험",
      "OUT_OF_5": "/5",
      "LATEST_ATTEMPT": "최근 시도",
      "TOTAL_ATTEMPTS": "총 시도 횟수",
      "UNLIMITED": "무제한",
      "REMAINING": "남은 횟수",
      "VIEW_CALL_DETAILS": "상세 정보 보기",
      "MAX_ATTEMPTS_REACHED": "최대 시도 횟수에 도달했습니다",
      "DUE_DATE": "마감일",
      "DAYS": "일",
      "DAY": "일",
      "UNTILL_DUE": "남은 기한",
      "PAST_DUE": "기한 경과",
      "ONGOING": "진행 중",
      "SCORE_REQUIREMENT": "점수 요건",
      "SCORE_REQUIREMENT_DETAIL": "각 필수 시뮬레이션을 완료하기 위한 점수는",
      "TO_COMPLETE_EACH_CALL": "입니다.",
      "CALLS_IN_ASSIGNMENT": "과제에 포함된 시뮬레이션",
      "INCOMPLETE_CALL": "미완료",
      "PREVIOUS_RESULTS": "이전 결과",
      "DATE": "날짜",
      "RESULTS": "결과",
      "VIEW_PREVIOUS_RESULTS": "이전 결과 보기",
      "VIEW_FEEDBACK": "피드백 보기",
      "LAUNCH_CALL": "시작",
      "CLOSE_BUTTON": "닫기 버튼",
      "CHECKMARK": "체크 표시",
      "CALL": "통화",
      "QUESTION": "질문",
      "COMPLETED": "완료됨",
      "IN_PROGRESS": "진행 중",
      "NOT_STARTED": "시작하지 않음",
      "CERTIFIED": "인증됨",
      "GUIDED": "안내형",
      "CONVERSATIONAL": "대화형",
      "GUIDED_SIMULATION": "지식 점검",
      "CONVERSATIONAL_SIMULATION": "롤플레이",
      "NO_ATTEMPTS_LEFT": "잔여 시도 횟수가 없습니다",
      "NO_ATTEMPTS": "시도 횟수 없음",
      "OVERVIEW": "개요",
      "ABOUT_THE_AVATAR": "아바타 정보",
      "SCORING_CRITERIA": "채점 기준",
      "SIMULATION_OVERVIEW": "시뮬레이션 개요",
      "ABOUT_THE_PERSONA": "페르소나 정보",
      "OUTOF_COMPLIANCE": "지침 미준수",
      "CLOSED": "마감됨",
      "COMPLETED_CALLS": "완료된 통화"
    }
  },
  "ja": {
    "root": {
      "ADMIN_PORTAL": "管理者ポータル",
      "SUPPORT": "サポート",
      "U": "U",
      "USER": "ユーザー",
      "LOGOUT": "ログアウト",
      "ADMIN": "管理者",
      "SUPPORT_SMALL": "サポート",
      "QUANTIFIED_AI": "Quantified.AI",
      "MICROPHONE": "マイク",
      "CAMERA": "カメラ",
      "ACCESS_DENIED": "アクセスが_拒否されました"
    },
    "teams": {
      "MY_TEAMS": "マイチーム",
      "COMPLETED": "完了",
      "IN_PROGRESS": "進行中",
      "NOT_STARTED": "未開始",
      "ASSIGNMET_MODULE": "課題モジュール",
      "START_DATE": "開始日",
      "DUE_DATE": "期限",
      "ASSIGNED_MEMBERS": "割り当てられたメンバー",
      "CALLS_IN_MODULE": "モジュール内のシミュレーション",
      "COMPLETION_REQUIRMENT": "完了要件",
      "COMPLETE_ALL_CALLS": "すべてのシミュレーションを",
      "OR_HIGHER": "点以上で完了",
      "PROGRESS_OVERVIEW": "進捗概要",
      "TEAM_MEMBERS": "チームメンバー",
      "AVERAGE_HIGH_SCORE": "平均の高スコア",
      "AVERAGE_NUMBER_ATTEMPTS_CALL": "シミュレーション1回あたりの平均試行回数",
      "TOTAL_PRACTICES": "練習の総数",
      "INDIVIDUAL_CALL_PROGRESS": "シミュレーションごとの進捗状況",
      "OF_TEAM_MEMBERS": "完了したチームメンバーの割合",
      "AVERAGE_PRACTICES_TO_COMPLETION": "完了までの平均練習回数",
      "TEAM_MEMBER_DETAILS": "チームメンバーの詳細",
      "DOWNLOAD_ACTIVITY_REPORT": "活動レポートをダウンロード",
      "TEAM_MEMBER": "チームメンバー",
      "PROGRESS": "進捗状況",
      "CALLS_COMPLETED": "完了したシミュレーション",
      "PRACTICES": "練習セッション",
      "MOST_RECENT_PRACTICE": "最新のセッション",
      "THIS_TEAM_HAS_NO_ACTIVE_ASSIGNMENTS": "このチームには現在、アクティブな課題がありません",
      "CALL_NAME_LABEL": "シミュレーション名",
      "HIGHEST_SCORE": "最高スコア"
    },
    "simulationBuilder": {
      "THRESHOLD": "閾値",
      "TYPE": "タイプ",
      "SELECT_AN_OPTION": "オプションを選択してください",
      "CORRECT_FEEDBACK": "正しいフィードバック",
      "INCORRECT_FEEDBACK": "間違ったフィードバック",
      "CORRECT_FEEDBACK_PLACEHOLDER": "学習者が正解したときに表示される",
      "INCORRECT_FEEDBACK_PLACEHOLDER": "学習者が間違えたときに表示される",
      "MESSAGE_NUMBER": "メッセージ {{ index }}",
      "ENTER_MESSAGE_TEXT": "メッセージ本文を入力してください…",
      "FACT_MESSAGE_LABEL": "メッセージ",
      "FACT_MESSAGE_DESCRIPTION": "メッセージは、1つの情報単位として、完全な文で記述してください。具体的かつ簡潔に、範囲を限定して記述してください。部分的にしか説明できていないメッセージは避けてください。",
      "FACT_INCORRECT_ANSWER_LABEL": "不正解の回答のテキスト",
      "FACT_INCORRECT_ANSWER_DESCRIPTION": "学習者がこの事実を間違えた場合に表示されるテキスト",
      "SHOW_INCORRECT_ANSWER_TEXT": "不正解の際の代替テキストを表示",
      "ADD_NEW_FACT": "新しい事実を追加",
      "FACT_SINGULAR": "事実",
      "FACT_PLURAL": "事実",
      "FACT_EXTRACTED_SINGULAR": "{{ count }}件の事実が抽出されました",
      "FACT_EXTRACTED_PLURAL": "{{ count }}件の事実が抽出されました",
      "FACTS_CANNOT_BE_EMPTY": "事実は空のままにしないでください。テストや公開を行う前に、各ファクトにメッセージを追加してください。",
      "REVIEW_REQUIRED_LABEL": "提案されたことを確認する",
      "DELETE": "削除",
      "SCORABLE": "採点可能",
      "SEARCH_BY_SIMULATION_NAME": "シミュレーション名で検索",
      "SIMULATION_STATUS_PLACEHOLDER": "シミュレーションのステータス",
      "SIMULATION_STATUS_PREFIX": "シミュレーションのステータス：",
      "NO_SIMULATIONS_FOUND": "シミュレーションが見つかりませんでした",
      "SELECT_ALL": "すべて選択",
      "DESELECT_ALL": "すべて選択解除",
      "STATUS_TESTING": "テスト中",
      "STATUS_DRAFT": "下書き",
      "STATUS_PUBLISHED": "公開済み",
      "STATUS_ARCHIVED": "アーカイブ済み",
      "SEARCH_BY_ASSIGNMENT_NAME": "課題名で検索",
      "ASSIGNEES_ZERO_STATE_MESSAGE": "まだ割り当てられたユーザーはいません",
      "ADD_USERS_TO_ASSIGNMENT": "課題にユーザーを追加",
      "NO_DATA_FOUND": "データが見つかりませんでした！",
      "NO_USERS_SELECTED": "ユーザーが選択されていません",
      "COL_FIRST_NAME": "名",
      "COL_LAST_NAME": "姓",
      "COL_EMAIL": "メールアドレス",
      "COL_VIEW_USER": "ユーザーを表示",
      "COL_VIEW_ASSIGNMENT": "課題を表示",
      "COL_ASSIGNMENT_NAME": "課題名",
      "COL_STATUS": "ステータス",
      "COL_TEAM_ASSOCIATIONS": "チームとの関連",
      "COL_REPORTING_STATUS": "レポートステータス",
      "BREADCRUMB_USERS": "ユーザー",
      "STATUS_STAGED": "ステージング済み",
      "STATUS_ACTIVE": "アクティブ",
      "STATUS_ENDED": "終了",
      "STATUS_CLOSED": "終了しました",
      "SEARCH_USERS_PLACEHOLDER": "ユーザーの検索",
      "NO_USERS_FOUND": "ユーザーが見つかりませんでした",
      "USERS_TAB_LABEL": "ユーザー",
      "ADD_TO_ASSIGNMENT": "課題に追加",
      "ASSIGNMENTS_COUNT": "課題",
      "REPORTING_EXCLUDED": "除外済み",
      "REPORTING_INCLUDED": "含まれている",
      "KEBAB_EDIT_TEAM_ASSOCIATIONS": "チームの関連付けを編集",
      "KEBAB_EXCLUDE_FROM_REPORTING": "レポートから除外",
      "KEBAB_INCLUDE_IN_REPORTING": "レポートに含める",
      "KEBAB_REMOVE_FROM_ASSIGNMENT": "課題から削除",
      "NO_TEAMS": "—",
      "TEAMS_COUNT": "{{ count }}つのチーム",
      "ADD_TO_ASSIGNMENT_MODAL_HEADING": "課題に追加",
      "FIELD_LABEL_ASSIGNMENT": "課題",
      "SEARCH_ASSIGNMENTS_PLACEHOLDER": "課題を検索",
      "BUTTON_SET_TEAM_ASSOCIATION": "チームの関連付けを設定",
      "FIELD_LABEL_TEAM": "チーム",
      "SEARCH_TEAM_PLACEHOLDER": "チームを検索",
      "BUTTON_BACK": "戻る",
      "BUTTON_CANCEL": "キャンセル",
      "BUTTON_ADD_TO_ASSIGNMENT": "課題に追加",
      "EDIT_TEAM_ASSOCIATIONS_HEADING": "チームの関連付けを編集",
      "EDIT_TEAM_ASSOCIATIONS_DESCRIPTION": "課題{{ assignmentName }}について",
      "BUTTON_SAVE_ASSOCIATIONS": "関連付けを保存",
      "REFERENCE_DOCUMENT_STATUS_UPLOADING": "– アップロード中…",
      "REFERENCE_DOCUMENT_STATUS_SUCCESS": "– 100% アップロード完了",
      "REFERENCE_DOCUMENT_STATUS_ERROR": "– アップロードエラー",
      "REFERENCE_DOCUMENT_STATUS_DELETING": "– 削除中",
      "REFERENCE_DOCUMENT_DELETE_ERROR": "ドキュメントの削除に失敗しました。もう一度お試しください。",
      "REFERENCE_DOCUMENT_UPLOAD_ERROR": "ドキュメントのアップロードに失敗しました。もう一度お試しください。",
      "CONTENT_LIMIT_EXCEEDED_ERROR": "コンテンツの制限を超えました。続行するには、1つ以上のドキュメントを削除してください。",
      "LAST_FACT_DELETE_WARNING_HEADING": "最後の事実を削除しますか？",
      "LAST_FACT_DELETE_WARNING_DESCRIPTION": "最後の事実を削除すると、このシミュレーションとのユーザーの関連付けがすべて削除され、ステータスが「下書き」に戻ります。",
      "LEAVE_CONFIRMATION_HEADING": "シミュレーションの作成を終了する",
      "LEAVE_CONFIRMATION_DESCRIPTION": "終了してもよろしいですか？これまでの進捗はすべて失われます。",
      "LEAVE_CONFIRMATION_LEAVE_BUTTON": "終了する",
      "CREATE_SIMULATION_DETAILS_BUTTON": "シミュレーションの詳細を作成",
      "SELF_AUTHORING_DESCRIPTION": "開始するには、名前、シナリオの簡単な説明、およびシミュレーション固有のドキュメントを入力してください",
      "CLICK_TO_UPLOAD": "クリックしてアップロード",
      "OR_DRAG_AND_DROP": "またはドラッグ＆ドロップ",
      "REFERENCE_DOCUMENTS_UPLOAD_DESCRIPTION": "PDF（最大50MB）",
      "ASSIGNMENT_NAME_LABEL": "課題名*",
      "SIMULATION_NAME_LABEL": "シミュレーション名",
      "NAME_FIELD_DESCRIPTION": "この名前は後で変更可能です",
      "PRODUCT_LABEL": "製品",
      "SELECT_A_PRODUCT_PLACEHOLDER": "製品を選択",
      "ADD_NEW_PRODUCT": "新しい製品を追加",
      "SCENARIO_LABEL": "シナリオ",
      "REFERENCE_DOCUMENTS_LABEL": "参考資料",
      "ACTION_CREATE_NEW": "新規作成",
      "ACTION_CREATE": "作成",
      "ACTION_DUPLICATE": "複製",
      "ENTITY_TYPE_SIMULATION_DISPLAY": "シミュレーション",
      "ENTITY_TYPE_ASSIGNMENT_DISPLAY": "課題",
      "ENTITY_TYPE_SIMULATION_LOWER": "シミュレーション",
      "ENTITY_TYPE_ASSIGNMENT_LOWER": "課題",
      "MODAL_TITLE": "{{ action }} {{ type }}",
      "CONFIRM_BUTTON_LABEL": "{{ action }} {{ type }}",
      "DUPLICATE_NAME_ERROR_ASSIGNMENT": "同じ名前の課題がすでに存在します。",
      "DUPLICATE_NAME_ERROR_SIMULATION": "同じ名前のシミュレーションがすでに存在します。",
      "NAME_REQUIRED_ERROR": "名前は必須です。",
      "COPY_OF_PREFIX": "{{ name }}のコピー",
      "SCORE_DISTRIBUTION_TITLE": "現在のスコア分布",
      "EDIT_SECTIONS_AND_WEIGHTING": "セクションと加重を編集",
      "SCORING_WEIGHTS_TITLE": "採点の設定",
      "SCORING_WEIGHTS_DESCRIPTION": "採点対象の分野と、各分野が総合評価に占める割合を選択します。有効化されたすべてのセクションの配点の合計は100%になる必要があります。「スキル」セクションの配点は、20%を超えてはなりません。",
      "SCORING_WEIGHT_REQUIRED": "必須",
      "SCORE_LAST_SESSION": "私の前回のセッションを採点する",
      "SCORE_LAST_SESSION_MODAL_HEADING": "前回のセッションを採点する",
      "SCORE_LAST_SESSION_MODAL_DESCRIPTION": "まずシミュレーションをテストし、その後、ここに戻って選択した評価基準に基づいて採点してください。",
      "SCORE_LAST_SESSION_MODAL_ERROR_HEADING": "エラーが発生しました",
      "SCORE_LAST_SESSION_MODAL_ERROR_DESCRIPTION": "もう一度試してください。",
      "MESSAGING_TITLE": "メッセージ",
      "MESSAGING_SUBTITLE": "重要な事実が伝達されたかどうかを採点する",
      "METHODOLOGY_TITLE": "手法",
      "METHODOLOGY_SUBTITLE": "通話への取り組み方と構成を採点する",
      "METHODOLOGY_WEIGHTING_LABEL": "加重：{{ weight }}%",
      "METHODOLOGY_RUBRIC_LABEL": "手法の評価基準",
      "SELECT_RUBRIC_PLACEHOLDER": "評価基準を選択してください",
      "SKILLS_TITLE": "スキル",
      "SKILLS_SUBTITLE": "コミュニケーションスキルとソフトスキルを採点する",
      "SKILLS_WEIGHTING_LABEL": "加重：{{ weight }}%",
      "SKILLS_RUBRIC_LABEL": "スキルの評価基準",
      "ACCURACY_FEEDBACK_TITLE": "正確性に関するフィードバック",
      "ACCURACY_FEEDBACK_DESCRIPTION": "担当者が述べたすべての発言について、アップロードされたドキュメントと照らし合わせて正確性を評価する",
      "ACCURACY_FEEDBACK_STATUS_ON": "有効化済み",
      "ACCURACY_FEEDBACK_STATUS_OFF": "オフ",
      "ACCURACY_FEEDBACK_STATUS_DISABLED": "無効化済み",
      "ACCURACY_FEEDBACK_NO_DOCUMENTS": "関連するドキュメントが追加されていないため、正確性の採点は利用できません。",
      "SCORING_AI_REVIEW_NOTICE": "このタブの一部の内容は、ご提供いただいた資料から生成されたものです。この通話を公開する前に、すべての内容の正確性を確認してください。",
      "PROCESSING_DOCUMENTS_MESSAGE": "ドキュメントを処理中です…",
      "PROCESSING_DOCUMENTS_SUPPORTING_TEXT": "堆積しても構いません。5分以内に結果が用意されます。",
      "CORE_SIGNAL_MESSAGE": "コンテンツの解析中…",
      "SECTION_PLAN_MESSAGE": "シミュレーションの構造を計画中…",
      "DERIVED_COMPONENT_MESSAGE": "シミュレーションのコンポーネントを構築しています…",
      "COMPONENT_WAVE_1_MESSAGE": "シミュレーションのコンテンツを作成中…",
      "COMPONENT_WAVE_2_MESSAGE": "シミュレーションのコンテンツを調整中…",
      "COMPONENT_WAVE_3_MESSAGE": "シミュレーションのコンテンツを最終化しています…",
      "MESSAGE_ADHERENCE_MESSAGE": "メッセージングの評価基準を提案しています…",
      "ASSEMBLING_MESSAGE": "シミュレーションを組み立てています…",
      "FINISHING_SIMULATION_MESSAGE": "シミュレーションを終了しています…",
      "STILL_PROCESSING_TITLE": "まだ処理中です…",
      "STILL_PROCESSING_BODY": "通常より時間がかかっています。このシミュレーションから一旦離れて、後でシミュレーション一覧画面から戻ってくることができます。",
      "PROCESSING_FAILED_TITLE": "処理に失敗しました",
      "PROCESSING_FAILED_BODY": "ドキュメントの処理中に問題が発生しました。再挑戦してください。問題が継続する場合は ",
      "PROCESSING_FAILED_SUFFIX": " までお問い合わせください。",
      "BUTTON_RETRY": "再挑戦",
      "TOKEN_LIMIT_EXCEEDED_BODY_PREFIX": "コンテンツの制限を超えました。問題が継続する場合は、1つ以上のドキュメントを削除して再度お試しいただくか、 ",
      "TOKEN_LIMIT_EXCEEDED_BODY_SUFFIX": " までお問い合わせください。",
      "TEST_SIMULATION_BUTTON": "シミュレーションをテスト",
      "EXPORT_SIMULATION_SUMMARY_BUTTON": "シミュレーションの概要をエクスポート",
      "SIMULATION_PROCESSED_TITLE": "ドキュメントの処理",
      "SIMULATION_PROCESSED_BODY": "シミュレーションのドキュメントが処理されました。",
      "SIMULATION_DOCUMENTS_PROCESSED_TITLE": "シミュレーションのドキュメントが処理されました。",
      "SIMULATION_DOCUMENTS_PROCESSED_BODY": "シミュレーション {{ name }}用にアップロードされたドキュメントは処理されました。",
      "SIMULATION_DOCUMENTS_FAILED_TITLE": "シミュレーションのドキュメントの処理に失敗しました。",
      "SIMULATION_DOCUMENTS_FAILED_BODY": "シミュレーション {{ name }}用にアップロードされたドキュメントは処理されませんでした。",
      "DISMISS": "却下",
      "VIEW_SIMULATION": "シミュレーションを表示",
      "AVATAR_LOOK_LABEL": "外観",
      "AVATAR_SELECT_PLACEHOLDER": "アバターを選択",
      "AVATAR_VOICE_LABEL": "音声",
      "AVATAR_ALT": "アバター",
      "PLAY_VOICE_PREVIEW_BUTTON": "音声プレビューを再生",
      "VOICE_OPTION_1": "音声 1",
      "VOICE_OPTION_2": "音声 2",
      "BACK_TO_SIMULATION_DETAILS_BUTTON": "シミュレーションの詳細に戻る",
      "AVATAR_SELECTION_TITLE": "アバターの選択",
      "VIEW_DOCUMENTS": "ドキュメントを表示",
      "SELECT_AVATAR_BUTTON": "アバターを選択",
      "REQUEST_CHANGES_PLACEHOLDER": "上記の情報の変更をリクエストする",
      "CALL_DETAILS_LOAD_ERROR": "通話の詳細を読み込めませんでした。もう一度お試しください。",
      "CALL": "通話",
      "REFINEMENT_THINKING_MESSAGE": "検討中…",
      "REFINEMENT_UPDATED_MESSAGE": "更新済み",
      "REFINEMENT_WARNING_PREFIX": "この情報は手動で上書きされていました。更新がある場合は、",
      "REFINEMENT_WARNING_SUFFIX": "までご連絡ください。",
      "REFINEMENT_OVERRIDDEN_PREFIX": "この情報は手動で上書きされていました。更新がある場合は、",
      "REFINEMENT_OVERRIDDEN_SUFFIX": "までご連絡ください。",
      "SUPPORT_EMAIL": "help@quantified.ai",
      "REFINEMENT_ERROR_PREFIX": "残念ながら、その件についてはお手伝いできませんが、",
      "REFINEMENT_ERROR_SUFFIX": "なら対応できるかもしれません。",
      "REFINEMENT_APPLIED_TITLE": "リクエストされた変更が適用されました。",
      "REFINEMENT_APPLIED_BODY": "シミュレーション {{ name }} に対してリクエストされた変更が適用されました。",
      "REFINEMENT_FAILED_TITLE": "リクエストされた変更は適用できませんでした。",
      "REFINEMENT_FAILED_BODY": "シミュレーション {{ name }}に対してリクエストされた変更を適用できませんでした。",
      "BLANK_THEME_MESSAGE_TOOLTIP": "新しいテーマを追加する前に、空のメッセージにテキストを追加してください。",
      "BLANK_MESSAGE_TOOLTIP": "別のメッセージを追加する前に、このメッセージにテキストを追加してください。",
      "ADD_NEW_THEME_BUTTON": "新しいテーマを追加",
      "ADD_THEME_BUTTON": "テーマを追加",
      "ADD_MESSAGE_BUTTON": "メッセージを追加",
      "WHAT_USERS_SEE_DESCRIPTION_TITLE": "シミュレーションの説明",
      "WHAT_USERS_SEE_DESCRIPTION_HELPER": "「全般」タブで更新された情報は、手動で更新しない限り、ここに反映されます。",
      "WHAT_USERS_SEE_DESCRIPTION_FIELD_LABEL": "説明",
      "WHAT_USERS_SEE_DETAILS_TITLE": "シミュレーションの詳細",
      "WHAT_USERS_SEE_DETAILS_HELPER": "これは、ユーザーがシミュレーションを開始する前に表示されるコンテンツです。「全般」タブで更新された情報は、手動で更新しない限り、ここに反映されます。空白のままにされたセクションは、学習者に表示されません。すべてのセクションでマークダウン形式が使用可能です。",
      "WHAT_USERS_SEE_OVERVIEW_FIELD_LABEL": "シミュレーションの概要",
      "WHAT_USERS_SEE_PERSONA_FIELD_LABEL": "ペルソナについて",
      "WHAT_USERS_SEE_SCORING_FIELD_LABEL": "採点基準",
      "WHAT_USERS_SEE_SCORING_FIELD_HELPER": "このセクションは、「採点」タブでの選択に基づいて自動的に入力されます。ここで情報を編集しても、シミュレーションの採点方法には影響しません。",
      "WHAT_USERS_SEE_PREVIEW_DETAILS_CTA": "シミュレーション詳細のプレビューモーダル",
      "WHAT_USERS_SEE_PREVIEW_CARD_CTA": "シミュレーションカードのプレビュー",
      "WHAT_USERS_SEE_OVERRIDE_WARNING_TITLE": "これらのフィールドを編集すると、今後の更新がブロックされます",
      "WHAT_USERS_SEE_OVERRIDE_WARNING_BODY": "これらのセクションを手動で更新すると、「全般」タブでの微調整プロセスによる追加の更新を受け取れなくなります。",
      "WHAT_USERS_SEE_DETAILS_OVERRIDE_EDITED_TITLE": "これらのフィールドは編集済みです",
      "WHAT_USERS_SEE_DETAILS_OVERRIDE_EDITED_BODY": "「全般」タブで行われる微調整の更新を受け取らなくなります",
      "TAB_GENERAL": "全般",
      "TAB_CONTENTS": "目次",
      "TAB_KEY_WORDS": "キーワード",
      "TAB_SCORING": "採点",
      "TAB_TESTING": "テスト中",
      "TAB_PROMPTS": "プロンプト",
      "TAB_WHAT_USERS_SEE": "ユーザーに表示される内容",
      "SIMULATION_BUILDER_HEADING": "シミュレーションビルダー",
      "ASSIGNMENTS_TAB_LABEL": "課題",
      "SIMULATIONS_TAB_LABEL": "シミュレーション",
      "CREATE_NEW_ASSIGNMENT_BUTTON": "新しい課題を作成",
      "CREATE_NEW_SIMULATION_BUTTON": "新しいシミュレーションを作成",
      "NO_ASSIGNMENTS_FOUND": "課題が見つかりませんでした",
      "ASSIGNMENT_STATUS_PLACEHOLDER": "課題のステータス",
      "ASSIGNMENT_STATUS_PREFIX": "課題のステータス：",
      "ASSIGNMENT_TYPE_LABEL": "課題の種類",
      "SELECT_ASSIGNMENT_TYPE_PLACEHOLDER": "課題の種類を選択",
      "NAME_LABEL": "名前",
      "ASSIGNMENT_NAME_PLACEHOLDER": "課題名",
      "PASSING_SCORE_LABEL": "合格点",
      "PASSING_SCORE_OPTIONAL_LABEL": "合格点（任意）",
      "SCORE_MAX_EXCEEDED_ERROR": "スコアは5を超えてはなりません",
      "GET_HELP_BUTTON": "ヘルプを取得",
      "PASSING_SCORE_TOOLTIP": "これは、学習者がシミュレーションに合格するために達成しなければならない総合スコアを設定します。",
      "DESCRIPTION_LABEL": "説明",
      "ASSIGNMENT_DESCRIPTION_PLACEHOLDER": "課題の説明",
      "MESSAGING_FEEDBACK_LABEL": "メッセージに関するフィードバック",
      "MESSAGING_FEEDBACK_TOOLTIP_HEADING": "メッセージに関するフィードバック",
      "MESSAGING_FEEDBACK_TOOLTIP_BODY": "学習者がメッセージを誤って伝えた場合、次回より適切に表現するための情報が表示されます。この設定では、その情報を表示するかどうかを切り替えることができます。",
      "ENABLED_TEXT": "有効化済み",
      "DISABLED_TEXT": "無効化済み",
      "PAUSE_BUTTON_LABEL": "一時停止ボタン",
      "ASSIGNMENT_START_DATE_LABEL": "課題の開始日",
      "SELECT_DATE_PLACEHOLDER": "日付を選択",
      "ASSIGNMENT_END_DATE_LABEL": "課題の終了日",
      "ASSIGNMENT_END_DATE_OPTIONAL_LABEL": "課題の終了日（任意）",
      "END_DATE_RANGE_ERROR": "開始日と終了日を同じ日にはできません",
      "ASSIGNMENT_INFORMATION_TITLE": "課題の情報",
      "ASSIGNMENT_TYPE_CERTIFICATION": "認定",
      "ASSIGNMENT_TYPE_PRACTICE": "練習",
      "ASSIGNMENT_TYPE_PERSONALIZED_PRACTICE": "パーソナライズされた練習",
      "BUTTON_SAVE_AND_CLOSE": "保存して閉じる",
      "BUTTON_ADD_SIMULATIONS": "シミュレーションを追加",
      "ATTEMPTS_UNLIMITED": "無制限",
      "SEARCH_FOR_SIMULATION_LABEL": "シミュレーションを検索",
      "SIMULATION_NAME_PLACEHOLDER": "シミュレーション名",
      "BUTTON_REMOVE_ALL": "すべて削除",
      "SIMULATIONS_IN_ASSIGNMENT_LABEL": "課題内のシミュレーション",
      "BUTTON_ASSIGN_LEARNERS": "学習者を割り当てる",
      "CALL_TYPE_UNKNOWN": "不明",
      "ASSIGNMENT_COUNT_NONE": "なし",
      "ASSIGNMENT_COUNT_SINGULAR": "{{ count }}つの課題",
      "ASSIGNMENT_COUNT_PLURAL": "{{ count }}つの課題",
      "ERROR_LOADING_ASSIGNMENTS": "課題の読み込みに失敗しました",
      "SEARCH_ASSIGNEES_TITLE": "割り当て先を検索",
      "DIALOG_DESCRIPTION_ADD_USERS": "課題に参加するユーザーを選択してください。チームを検索すると、そのチーム内の特定のユーザーに割り当てたり、割り当てを解除したりできます。特定のユーザーを選択する際は、レポートの目的上、そのユーザーが正しいチームに関連付けられていることを確認してください。",
      "ADD_USERS_TO_ASSIGNMENT_HEADING": "課題にユーザーを追加する",
      "BUTTON_REVIEW_SELECTED_USERS": "選択したユーザーを確認する",
      "FIND_USERS_LABEL": "ユーザーを見つける",
      "BUTTON_CLEAR": "クリア",
      "LEARNER_COUNT_NONE": "なし",
      "LEARNER_COUNT_SINGULAR": "{{ count }}名の学習者",
      "LEARNER_COUNT_PLURAL": "{{ count }}名の学習者",
      "ASSIGNMENT_TAB_DETAILS": "詳細",
      "ASSIGNMENT_TAB_SIMULATIONS": "シミュレーション",
      "ASSIGNMENT_TAB_ASSIGNEES": "割り当て先",
      "LOADING_ASSIGNMENT_DETAILS": "課題の詳細を読み込み中…",
      "BREADCRUMB_ASSIGNMENTS": "課題",
      "ASSIGNMENTS_COL_NAME": "名前",
      "ASSIGNMENTS_COL_START_DATE": "課題の開始日",
      "ASSIGNMENTS_COL_END_DATE": "課題の終了日",
      "ASSIGNMENTS_COL_LEARNERS": "割り当てられた学習者",
      "ASSIGNMENTS_COL_TYPE": "課題の種類",
      "ASSIGNMENTS_COL_STATUS": "課題のステータス",
      "SIMULATIONS_COL_NAME": "名前",
      "SIMULATIONS_COL_PRODUCT": "製品",
      "SIMULATIONS_COL_DATE_MODIFIED": "最終更新日",
      "SIMULATIONS_COL_STATUS": "ステータス",
      "SIMULATIONS_COL_USED_IN": "使用先",
      "SIMULATIONS_COL_TYPE": "シミュレーションの種類",
      "SIMULATIONS_COL_DATE_PUBLISHED": "公開日",
      "CONVERSE_PROMPT_LABEL": "会話プロンプト",
      "CONVERSE_PROMPT_EXPAND_TO_EDIT": "展開して編集",
      "CONVERSE_PROMPT_ENTER_LABEL": "ここに会話プロンプトを入力してください*",
      "CONVERSE_PROMPT_EDITING_HEADING": "会話プロンプトの編集",
      "CONVERSE_PROMPT_OVERRIDE_CONFIRMATION_HEADING": "プロンプトの上書き確認",
      "CONVERSE_PROMPT_OVERRIDE_DESCRIPTION": "会話プロンプトを上書きしてもよろしいですか？上書きされると、作成者はセルフサービスによる微調整へのアクセスを失います。",
      "CONVERSE_PROMPT_FIELD_LABEL": "会話プロンプト",
      "CONVERSE_PROMPT_SAVE_BUTTON": "プロンプトを保存",
      "BUTTON_CONFIRM": "確認",
      "DELETE_SIM_HEADING": "シミュレーションを削除",
      "DELETE_SIM_CONTENT": "このシミュレーションが削除されます。このシミュレーションに関連付けられているテストの課題もすべて削除されます。",
      "DELETE_SIM_LABEL": "シミュレーションを削除",
      "DELETE_ASSIGNMENT_HEADING": "課題を削除",
      "DELETE_ASSIGNMENT_CONTENT": "この課題は完全に削除されます。",
      "DELETE_ASSIGNMENT_LABEL": "課題を削除",
      "DELETE_ASSIGNMENT_NON_STAGED_CONTENT": "「アクティブ」または「終了」ステータスの課題を削除するには、CXチームまでご連絡ください。ありがとうございます。",
      "REMOVE_FROM_ASSIGNMENT_HEADING": "課題から削除",
      "REMOVE_FROM_ASSIGNMENT_CONTENT": "これにより、ユーザーは課題および関連するすべてのチームリンクから削除されます。",
      "REMOVE_FROM_ASSIGNMENT_LABEL": "課題から削除",
      "PUBLISH_SIMULATION_HEADING": "シミュレーションを公開",
      "PUBLISH_CONTINUE_EDITING": "編集を続ける",
      "PUBLISH_BUTTON": "公開",
      "PUBLISH_SIMULATION_DESCRIPTION": "ロールプレイを課題に追加できるようになりますが、ペルソナ、採点、およびプロンプト情報は編集できなくなります。",
      "CONFIRMATION_SELECTED_USERS_HEADING": "選択されたユーザー",
      "CONFIRMATION_TOTAL_COUNT": "合計{{ count }}",
      "CONFIRMATION_CREATE_HEADING": "新しい課題を作成",
      "CONFIRMATION_ADD_USERS_HEADING": "課題にユーザーを追加する",
      "CONFIRMATION_SAVE_ASSIGNMENT_BTN": "課題を保存",
      "CONFIRMATION_REMOVE_USER": "削除",
      "EDIT_WEIGHTING_HEADING": "採点の加重を編集",
      "EDIT_WEIGHTING_DESCRIPTION": "総合スコアは、以下のセクションの加重平均から算出されます。有効化されたすべてのセクションの配点の合計は100%になる必要があります。「スキル」セクションの配点は、20%を超えてはなりません。",
      "EDIT_WEIGHTING_ERROR_ALL_DISABLED": "少なくとも1つの採点アクションを有効にする必要があります",
      "EDIT_WEIGHTING_ERROR_WEIGHT_RANGE": "セクションの加重は0から100の間でなければなりません",
      "EDIT_WEIGHTING_ERROR_SKILLS_MAX": "「スキル」セクションの加重は20%を超えてはなりません",
      "EDIT_WEIGHTING_ERROR_TOTAL": "各セクションの加重の合計は100％でなければなりません",
      "PERSONA_INFORMATION_TITLE": "ペルソナ情報",
      "PERSONA_AVATAR_LABEL": "アバター*",
      "PERSONA_NAME_LABEL": "名前*",
      "PERSONA_INITIAL_GREETINGS_LABEL": "最初の挨拶*",
      "PERSONA_INITIAL_GREETINGS_DESCRIPTION": "ペルソナは、これらの挨拶のいずれか一つでシミュレーションを開始します。最大5つの選択肢を設定できます。",
      "PERSONA_ADD_GREETING_OPTION": "挨拶のオプションを追加",
      "PERSONA_RESUME_MESSAGE_LABEL": "再開時のメッセージ",
      "PERSONA_RESUME_MESSAGE_DESCRIPTION": "学習者が一時停止後にシミュレーションを再開すると、ペルソナはこれらの挨拶のいずれかで開始します。最大5つの選択肢を設定できます。",
      "PERSONA_ADD_MESSAGE_OPTION": "メッセージのオプションを追加",
      "PERSONA_UPLOADING": "アップロード中…",
      "PERSONA_DELETING": "削除中…",
      "PERSONA_CUSTOM_BG_PREVIEW_ALT": "カスタム背景のプレビュー",
      "PERSONA_AVATAR_THUMBNAIL_ALT": "アバターのサムネイル",
      "PERSONA_AVATAR_WITH_BG_ALT": "カスタム背景付きアバター",
      "PERSONA_PROCESSING_IMAGE": "画像を処理中…",
      "PERSONA_CUSTOM_BACKGROUND_LABEL": "カスタム背景",
      "PERSONA_REMOVE_BACKGROUND": "背景を削除",
      "PERSONA_CLICK_TO_REPLACE": "クリックして差し替える",
      "PERSONA_UPLOAD_DESCRIPTION": "PNGまたはJPG、アスペクト比16:9が推奨、最大2MB",
      "SIM_INFORMATION_TITLE": "シミュレーション情報",
      "SIM_NAME_FIELD_LABEL": "名前*",
      "SIM_LANGUAGE_FIELD_LABEL": "言語",
      "SIM_DETAILS_SECTION_TITLE": "シミュレーションの詳細",
      "SIM_ADDITIONAL_SECTION_TITLE_LABEL": "追加セクションのタイトル",
      "SIM_ADDITIONAL_SECTION_INFO_LABEL": "追加セクション情報",
      "TESTING_SECTION_TITLE": "テスター",
      "TESTING_SEND_ASSIGNMENTS_BTN": "テストの課題を送信",
      "TESTING_MESSAGING_TOOLTIP": "テストまたは公開を行う前に、「メッセージの遵守状況」に少なくとも1つの事実を追加してください。",
      "TESTING_DESCRIPTION": "シミュレーションをテストするユーザーを検索し、そのユーザーにテストの課題を送信してください。",
      "TESTING_COL_NUMBER_OF_ATTEMPTS": "挑戦回数",
      "TESTING_COL_DATE_OF_LAST_ATTEMPT": "最終挑戦日",
      "TESTING_CLEAR_USERS": "ユーザーをクリア",
      "TESTING_REMOVE_ASSIGNEE": "割り当て先を削除",
      "OVERALL_SECTION_TITLE": "セクション、加重、プロンプト",
      "OVERALL_HEADING": "全体的な",
      "TRANSCRIPT_PROMPT_TITLE": "通話記録のプロンプト",
      "TRANSCRIPT_PROMPT_FIELD_LABEL": "ここにクリーンな通話記録のプロンプトを入力してください",
      "SIMULATION_PROMPTS_TITLE": "シミュレーションのプロンプト",
      "TAGS_LABEL": "タグ",
      "CREATE_TAG_OPTION": "{{term}}を作成",
      "TAG_CREATE_ERROR": "タグを作成できませんでした。もう一度お試しください。",
      "EDIT_SIMULATION_TAGS_TITLE": "シミュレーションのタグを編集",
      "SAVE_TAGS_BUTTON": "タグを保存",
      "CLOSE_BUTTON": "閉じる",
      "TAG_UPDATE_ERROR": "タグをアップロードできませんでした。もう一度お試しください。",
      "SCREEN_SHARE_TITLE": "画面共有",
      "SCREEN_SHARE_DESCRIPTION": "通話中にユーザーがアバターと画面を共有することで、アバターは画面に表示されている内容を確認して反応することができます",
      "SCREEN_SHARE_STATUS_ON": "有効化済み",
      "SCREEN_SHARE_STATUS_OFF": "無効化済み",
      "SCREEN_SHARE_NO_PERSONA": "画面共有を有効にするには、まずペルソナを追加してください。",
      "HIDE_RESULTS_LABEL": "結果を非表示にする",
      "SEARCH_FIELD_HINT": "検索を開始するには、3文字以上入力してください",
      "OTHERS_SINGULAR": "および、さらに1つ",
      "OTHERS_PLURAL": "および、さらに{{ count }}つ",
      "PAGINATION_PREVIOUS": "戻る",
      "PAGINATION_NEXT": "次へ",
      "SKILLS_RUBRIC_REQUIRED_TOOLTIP": "スキルの評価基準を添付してください。スキルは、加重が0%を超える場合に有効になります。",
      "ENTITY_TYPE_KNOWLEDGE_CHECK_DISPLAY": "知識の確認",
      "NAME_MAX_LENGTH_ERROR": "名前は255文字以下でなければなりません。",
      "UUID_COPIED_TOAST": "通話UUIDがクリップボードにコピーされました",
      "MENU_ARCHIVE": "アーカイブ",
      "MENU_EDIT_SIMULATION_TAGS": "シミュレーションのタグを編集",
      "MENU_COPY_UUID": "UUIDをコピー",
      "REFINEMENT_IN_PROGRESS_TOOLTIP": "微調整が進行中です。完了したら、続行できます。",
      "SIMULATION_DOCUMENTS_PARSE_FAILED_BODY": "{{ name }}のドキュメントの1つを読み込めませんでした。ドキュメントを確認または置き換えて、もう一度お試しください。",
      "REFINEMENT_ERROR_MESSAGE": "申し訳ありませんが、このリクエストは完了できませんでした。もう一度お試しください",
      "REFINEMENT_OUT_OF_SCOPE_TITLE": "リクエストが適用範囲外です。",
      "REFINEMENT_OUT_OF_SCOPE_BODY": "{{ name }}に関するリクエストは、微調整で可能な処理の適用範囲外です。サポートまでお問い合わせください。",
      "TAB_QUESTIONS": "質問",
      "KNOWLEDGE_CHECK_NAME_LABEL": "名前*",
      "AVATAR_APPEARANCE_LABEL": "アバターの外観",
      "KNOWLEDGE_CHECK_AVATAR_NAME_LABEL": "アバターの名前",
      "KNOWLEDGE_CHECK_SKILLS_FEEDBACK_TITLE": "スキルのフィードバック",
      "KNOWLEDGE_CHECK_SCORING_DESCRIPTION": "ナレッジチェックのシミュレーションは、各問題の正解ポイントの割合に基づいて採点されます。以下のスキル評価基準を選択すると、定性的なフィードバックも受け取ります。",
      "KNOWLEDGE_CHECK_SCORING_RESCORE_DESCRIPTION": "シミュレーションを少なくとも1回テストした後、「前回のセッションを採点」を選択してスコアを確認してください。回答ポイントを編集した場合、同じセッションを再採点することができます。質問を編集した場合は、採点を行う前に新しいテストセッションを実行する必要があります。",
      "KNOWLEDGE_CHECK_SKILLS_RUBRIC_LABEL": "スキルの評価基準（任意）",
      "SIMULATION_TYPE_MODAL_TITLE": "新しいシミュレーションを作成",
      "SIMULATION_TYPE_MODAL_DESCRIPTION": "学習者がどのように練習するかを選択してください。",
      "SIMULATION_TYPE_ROLE_PLAY_TITLE": "ロールプレイ",
      "SIMULATION_TYPE_ROLE_PLAY_DESCRIPTION": "学習者はAIキャラクターと自由な会話を進め、AIキャラクターは学習者の発言に対して自然に対応します。",
      "SIMULATION_TYPE_ROLE_PLAY_BEST_FOR": "最適な用途：ピッチや反論への対応など、現実的な営業通話の練習。",
      "SIMULATION_TYPE_KNOWLEDGE_CHECK_TITLE": "知識の確認",
      "SIMULATION_TYPE_KNOWLEDGE_CHECK_DESCRIPTION": "AIキャラクターが、あなたが作成した質問を設定した順序で学習者に尋ねます。",
      "SIMULATION_TYPE_KNOWLEDGE_CHECK_BEST_FOR": "最適な用途：製品知識のテストや、営業担当者の準備状況の証明。",
      "TAGS_FILTER_LABEL": "タグ",
      "TAGS_FILTER_PLACEHOLDER": "タグを選択",
      "CLEAR_ALL_FILTERS": "すべてのフィルタをクリア",
      "LAST_SAVED_LABEL": "最終保存日",
      "BUTTON_OK": "OK",
      "KEYWORDS_RESET_TO_PRODUCT_DEFAULT": "製品のデフォルトにリセット",
      "KEYWORDS_DETACH_FROM_PRODUCT_DEFAULT": "製品のデフォルトから切り離す",
      "KEYWORDS_SAVE_AS_PRODUCT_DEFAULT": "製品のデフォルトとして保存",
      "KEYWORDS_SAVE_AS_DEFAULT_OVERWRITE": "これにより、製品 {{ moduleName }}のデフォルトの{{ keywordTitle }}が上書きされます。",
      "KEYWORDS_SAVE_AS_DEFAULT_IMPACT": "これらの単語は、{{ moduleName }}の新しいシミュレーションに追加されます。製品 {{ moduleName }}に対するすべての通話に影響が及びます。",
      "KEYWORDS_ADD_NEW_WORD": "新しい単語を追加",
      "KEYWORDS_FROM_LABEL": "変更前",
      "KEYWORDS_TO_LABEL": "変更後",
      "KEYWORDS_PRONOUNCE_TITLE": "単語の発音",
      "KEYWORDS_PRONOUNCE_DESCRIPTION": "AIエージェントが名前や用語を正しく発音できるよう、発音の修正情報を提供してください。エージェントは、よくある誤った発音やバリエーションを「新しい発音」に紐付けます。",
      "KEYWORDS_PRONOUNCE_NAME": "単語の発音",
      "KEYWORDS_ADD_MISPRONUNCIATION": "誤った発音を追加",
      "KEYWORDS_SELECT_PERSONA_NOTICE": "単語の発音を追加するには、ペルソナを選択してください。",
      "KEYWORDS_REPLACE_TITLE": "単語を置換",
      "KEYWORDS_REPLACE_DESCRIPTION": "ユーザーの通話記録のテキストに対する明示的な「検索して置換」による修正。発音修正の前に直接行われる単語の置換。",
      "KEYWORDS_REPLACE_NAME": "単語の置換",
      "KEYWORDS_ADD_REPLACEMENT": "置換を追加",
      "KEYWORDS_STT_TITLE": "STTワード",
      "KEYWORDS_STT_DESCRIPTION": "音声認識（STT）プロバイダー（AssemblyAI、Tavusなど）に提供される単語リスト。特に、STTプロバイダーの設定用に用意されています。",
      "KEYWORDS_STT_NAME": "STTワード",
      "KEYWORDS_GENERATING": "生成中…",
      "KEYWORDS_GENERATE_STT_PROMPT": "stt_promptを生成",
      "KEYWORDS_STT_PROMPT_OUTDATED": "このプロンプトが生成されてから、単語リストは更新されています。最新の変更を反映させるために再生成してください。",
      "KEYWORDS_STT_CANNOT_SAVE_HEADING": "製品レベルでの保存はできません",
      "KEYWORDS_STT_CANNOT_SAVE_BODY": "STTワードとプロンプトは、製品レベルでは保存できません。他のシミュレーションのSTT設定を手動で変更するか、管理者にお問い合わせください。",
      "KEYWORDS_CLEAN_TRANSCRIPT_TITLE": "クリーン通話記録ワード",
      "KEYWORDS_CLEAN_TRANSCRIPT_DESCRIPTION": "CLEAN_TRANSCRIPT_V2 プロンプトに挿入される単語。",
      "KEYWORDS_CLEAN_TRANSCRIPT_NAME": "クリーン通話記録ワード",
      "KEYWORDS_CALL_TITLE": "通話ワード",
      "KEYWORDS_CALL_DESCRIPTION": "発音修正用の正しい単語の辞書。Double Metaphone（ダブルメタフォン）アルゴリズムによって、発音が似ている誤字を修正するために使用されます。コードベースの通話記録補正機能は、単一の単語に対してのみ確実に機能するため、「Anti MuSK AB+」のような複数単語からなる用語は避けてください。また、記号（「lp（a）」など）も避けてください。これらは補正機能を混乱させる傾向があるためです。このリストは、LLMではなく決定論的アルゴリズムによって処理され、文脈を理解しないため、できるだけ小さくかつシンプルに保つ必要があります。",
      "KEYWORDS_CALL_NAME": "通話ワード"
    },
    "settings": {
      "DEVICE_SETUP_INTRO": "お使いのデバイスが正しく設定されていることを確認しましょう。",
      "MICROPHONE_REQUIRED_NOTICE": "正常に動作するマイクが必要です。",
      "DEVICE_ENABLE_INSTRUCTIONS": "このページを更新した後、デバイスを有効にするよう求めるポップアップが表示されなかった場合は、システムまたはブラウザの設定画面を開き、デバイスを有効にしてください。詳細な手順については、以下のサポートページをご参照ください。",
      "ENABLE_CAMERA": "カメラを有効にする方法：",
      "WINDOWS_USERS": "Windowsユーザー",
      "MAC_USERS": "Macユーザー",
      "IPAD_USERS": "iPadユーザー",
      "ENABLE_MICROPHONE": "マイクを有効にする方法：",
      "ENABLE_DEVICES_BY_BROWSER": "ブラウザごとにデバイスを有効にする方法：",
      "CHROME_USERS": "Chromeユーザー",
      "SAFARI_USERS": "Safariユーザー",
      "FIREFOX_USERS": "Firefox",
      "EDGE_USERS": "Edge",
      "START_WITHOUT_CAMERA_BUTTON": "カメラを使わずに開始する",
      "START_CALL_BUTTON": "通話を開始する",
      "MICROPHONE_REQUIRED_WARNING": "正常に動作するマイクが必要です。",
      "MICROPHONE_ALT": "マイク",
      "MICROPHONE": "マイク",
      "SELECT_MICROPHONE": "マイクを選択",
      "ALERT": "アラート",
      "GIVE_PERMISSION": "許可を与える",
      "SELECT_VIDEO_DEVICE": "ビデオデバイスを選択",
      "VIDEO": "ビデオ",
      "DEVICE_BLOCKED_ERROR": "このブラウザによる1つ以上のデバイスへのアクセスが拒否されているようです。デバイスを有効にするには、システム設定またはブラウザの設定にアクセスし、アクセスを許可してください。",
      "DEVICE_SETTINGS": "デバイスの設定",
      "CONFIRM_SETTINGS": "設定を確認",
      "LAPTOP": "ノートパソコン",
      "SAD_EMOTE_FACE": "悲しい顔の絵文字",
      "GRANT_BROWSER_ACCESS": "このシミュレーションを完了するには、ブラウザで音声認識へのアクセスを許可してください",
      "USING_IPAD": "iPadをご利用の場合は、以下にアクセスしてください",
      "SETTINGS": "設定",
      "PRIVACY_AND_SECURITY": "プライバシーとセキュリティ",
      "SPEECH_RECOGNITION": "音声認識",
      "GRANT_ACCESS_REFRESH": "ブラウザへのアクセスを許可し、ページを更新してください",
      "REFRESH_PAGE": "ページを更新",
      "BROWSER_UNABLE_TO_ACCESS": "ブラウザがこのデバイスにアクセスできません",
      "ACCESS_DENIED": "アクセスが拒否されました",
      "CAMERA": "カメラ",
      "DIAGNOSTIC_PASSED": "すべての診断テストに正常に合格しました。",
      "DIAGNOSTIC_FAILED_MESSAGE": "一部の診断テストに失敗しました。上の「診断結果をコピー」ボタンをクリックし、サポートチームに結果を送信してサポートを受けてください。",
      "DIAGNOSTIC_PARTIAL": "ほとんどの診断テストに合格しました。接続状態は良好のようです。",
      "DIAGNOSTIC_RUNNING_MESSAGE": "診断テストの実行中はお待ちください…",
      "DIAGNOSTIC_RUNNING": "診断を実行中",
      "COPY_DIAGNOSTIC_RESULTS": "診断結果をコピー",
      "RUN_DIAGNOSTIC": "診断を実行",
      "RERUN_DIAGNOSTIC": "診断を再実行",
      "DIAGNOSTIC_RESULTS_COPIED": "診断結果がクリップボードにコピーされました",
      "DIAGNOSTIC_FAILED": "診断に失敗しました",
      "DIAGNOSTIC_WEBSOCKET_NOT_TESTED": "Websocket: not tested",
      "DIAGNOSTIC_TURN_NOT_TESTED": "TURN: not tested",
      "DIAGNOSTIC_QUALITY_NOT_TESTED": "Quality: not tested",
      "DIAGNOSTIC_QUANTIFIED_DIAGNOSTICS": "定量診断",
      "DIAGNOSTIC_TIME": "時間",
      "DIAGNOSTIC_SUMMARY": "概要",
      "DIAGNOSTIC_CLIENT_INFO": "クライアント情報",
      "DIAGNOSTIC_PLATFORM": "プラットフォーム",
      "DIAGNOSTIC_RTT_AVG_MAX": "RTT avg/max",
      "DIAGNOSTIC_PACKET_LOSS_SEND": "パケットロス（送信）",
      "DIAGNOSTIC_AVG_SEND_BITRATE": "平均送信ビットレート",
      "DIAGNOSTIC_NA": "該当なし",
      "DIAGNOSTIC_PROBLEMS_CONNECTING_PREFIX": "接続に問題がありますか？",
      "DIAGNOSTIC_CLICK_HERE": "ここをクリックして",
      "DIAGNOSTIC_TO_RUN_SUFFIX": "診断を実行してください。"
    },
    "results": {
      "RETURN_HOME": "ホームに戻る",
      "RETURN_TO_PATHWAY": "パスウェイに戻る",
      "CLOSE_BUTTON": "閉じるボタン",
      "CONVERSATIONAL_CALL": "ロールプレイ",
      "INFORMATION_ICON": "情報アイコン",
      "TOOLTIP_ARROW": "ツールチップの矢印",
      "INFORMATION_TOOLTIP_CONTENT": "あなたはシミュレーションの流れをコントロールし、会話を一連の目標へと導いていきます。ロールプレイは、問題を掘り下げたり、一歩踏み込んだ質問をしたり、課題点を明らかにしたり、信頼関係を築いたりといった能力をテストするのに最適です。",
      "CLOCK_ICON": "時計アイコン",
      "CALL_RESULTS": "結果",
      "QUIZ_RESULTS_SUMMARY": "クイズ結果の概要",
      "PROCESSING_RESULTS": "結果を処理中…",
      "SKILLS": "スキル",
      "MESSAGE_ADHERENCE": "メッセージの遵守状況",
      "MESSAGING": "メッセージ",
      "TRY_AGAIN_MESSAGE": "もう一度挑戦して、スコアを向上させましょう。",
      "QUIZ_SUMMARY_BASE": "少し時間を取って、このクイズの成績を振り返ってみましょう。",
      "QUIZ_SUMMARY_FAILED": "少し時間を取って、このクイズの成績を振り返ってみましょう。次の挑戦への準備をさらに整えるため、パスウェイの概要画面でハイライト表示されている{{stepNames}} {{stepWord}}を確認してください。",
      "QUIZ_SUMMARY_PASSED_WITH_MISSES": "少し時間を取って、このクイズの成績を振り返ってみましょう。あなたのスコアが最も低かった{{areaWord}}は、{{stepNames}} {{stepWord}} {{stepVerb}}。",
      "PRACTICE_BENEFITS": "毎週の練習は自信を高め、現場での成果を向上させます。",
      "CALL_SUCCESS": "よくできました！このシミュレーションを無事に完了しました。",
      "MAX_ATTEMPTS_REACHED": "試行回数が上限に達しました",
      "TRY_AGAIN": "再挑戦",
      "GREAT_JOB_YOU_SUCCESSFULLY": "よくできました！このシミュレーションを",
      "COMPLETED_THIS_CALL": "無事に完了しました。",
      "ACHIEVED_SCORE": "達成したスコア",
      "ACHIEVE_SCORE": "少なくとも",
      "OR_HIGHER": "のスコアを達成してください。",
      "OBJECTIVES_NOT_MET": "必要な目標をすべて達成できませんでした。",
      "TRY_AGAIN_TARGET_SCORE": "もう一度挑戦して、次のスコアを達成してください：",
      "YOUR_SCORE": "あなたのスコア",
      "OUT_OF_5": "5点満点中",
      "OUT_OF_100": "100点満点中",
      "CALL_FEEDBACK": "フィードバックの概要",
      "STRENGTH_ICON_ALT": "強みのアイコン",
      "OPPORTUNITIES_ICON_ALT": "改善点のアイコン",
      "OBJECTIVES_FEEDBACK": "手法に関するフィードバック",
      "SESSION_ID": "セッションID：",
      "SESSION_ID_COPIED": "セッションIDがコピーされました！",
      "OBJECTIVE": "手法：",
      "HOW_YOU_DID": "評価結果：",
      "LIGHTBULB_ICON_ALT": "電球アイコン",
      "WHAT_WE_SUGGEST": "提案内容：",
      "NO_SPECIFIC_RECOMMENDATION": "当システムでは、あなた向けの具体的な推奨事項が見つかりませんでした。",
      "WHY": "理由",
      "NO_INSIGHTS_AVAILABLE": "当社のシステムは、この提案に関する分析結果を提供できませんでした。",
      "CONFETTI_ICON_ALT": "紙吹雪のアイコン",
      "OBJECTIVE_SUCCESS_MESSAGE": "この手法で素晴らしい成績となりました。これからも頑張ってください！",
      "PROCESSING_CALL": "現在、スコアとフィードバックを準備中です。",
      "HANG_TIGHT": "しばらくお待ちいただくか、後ほど",
      "VIEW_YOUR_RESULTS": "結果を確認してください。",
      "NEED_MORE_TIME": "結果の算出にさらに時間がかかります。",
      "REFRESH_INSTRUCTION": "しばらくお待ちいただくか、数分後に課題の",
      "RESULTS_IN_FEW_MINUTES": "結果を更新してください。",
      "QUIZ_RESULTS_LOADING": "結果の読み込みに少し時間がかかっています。パスウェイを終了してください。準備が整い次第、お知らせいたします。",
      "KC_TOAST_TITLE": "知識の確認の結果が処理されました",
      "KC_TOAST_TITLE_PATHWAY": "{{stepName}}の知識の確認の結果が処理されました",
      "KC_TOAST_CONTENT": "以下をクリックして結果を確認するか、パスウェイ詳細画面に戻って次のステップをご覧ください。",
      "DISMISS": "却下",
      "SCORE_CALCULATION_QUESTION": "これはどのように算出されるのですか？",
      "SINGLE_SCORE_EXPLANATION": "このシミュレーションにはスコアを構成する要素が1つしかないため、表示されているスコアは、個々のセクションのスコアであると同時に総合スコアでもあります。",
      "OVERALL_SCORE_PERCENT": "総合スコア中",
      "SECTION_SCORE": "セクションスコア",
      "ELEVATE_MESSAGE_ADHERENCE_TITLE": "会話メッセージの遵守率を高める",
      "MESSAGE_ADHERENCE_NOTE": "メッセージの遵守率は、会話を成功させる上で極めて重要ですが、総合スコアには影響しません。",
      "NO_CREDIT": "加点なし",
      "PARTIAL_CREDIT": "部分点",
      "FULL_CREDIT": "満点",
      "WHAT_YOU_DID_WELL": "良かった点",
      "MISSED_ALL_KEY_POINTS": "重要なポイントをすべて見落としていました。それらを見直して、もう一度挑戦してください。",
      "WHAT_TO_IMPROVE": "改善点",
      "PERFECT_SCORE_MESSAGE": "おめでとうございます！満点でした。すべての重要なポイントを正しく話すことができました。",
      "POINTS_LABEL": "ポイント",
      "POINT_LABEL": "ポイント",
      "TALKING_POINTS_COVERED": "取り上げたトークポイント",
      "COVERED": "取り上げた",
      "CHECKMARK_ICON_ALT": "チェックマーク",
      "TALKING_POINTS_MISSED": "取り上げられなかったトークポイント",
      "MISSED": "触れられなかった",
      "X_ICON_ALT": "x",
      "PRACTICE_AGAIN": "もう一度練習する",
      "OUT_OF": "/",
      "OBJECTIVES": "手法",
      "ELEVATE_OBJECTIVES_TITLE": "会話の手法を向上させる",
      "OBJECTIVES_NOTE": "手法は会話を成功に導く上で極めて重要ですが、総合スコアには影響しません。",
      "UNTIL": "までに",
      "TO_IMPROVE_SCORE": "スコアを向上させるため",
      "YOU_HAVE": "あなたには、",
      "MORE_ATTEMPTS": "さらに挑戦して、",
      "OR_HIGHER_BEFORE": "以上のスコアを上げる機会が次までにあります：",
      "AND_TRY_AGAIN": "そして、もう一度試してみてください。",
      "UNEXPECTED_STATE": "予期せぬ状態が発生しました。",
      "REVIEW_APP_LOGIC": "アプリケーションのロジックを見直してください。",
      "ASSIGNMENTS": "課題",
      "VIEW_CALL_DETAILS": "通話の詳細を表示",
      "PRACTICE_SESSION": "練習セッション",
      "OVERALL_SCORE": "総合スコア",
      "OVERALL_SCORE_EXPLANATION": "総合スコアは、各セクションのスコアの加重平均を算出して算出されます。各セクションの加重は、スコアの横にパーセンテージで表示されます。",
      "SCORE_CONFIG_NOTE": "加重の割合や、各セクションの算入・除外は、貴社が設定します。すべてのスコアは、小数点以下第1位まで四捨五入されます。",
      "STRENGTHS": "強み",
      "OPPORTUNITIES": "改善点",
      "YOUR_RESPONSE": "あなたの回答",
      "MINUS": "マイナス",
      "PLUS": "プラス",
      "RECOMMENDED_RESPONSE": "推奨される回答",
      "REVIEW_MISSED_TITLE": "取り上げなかった点を確認してください。",
      "NO_TALKING_POINTS_COVERED": "このトピックで求められるトークポイントをまったく取り上げていませんでした。",
      "LEARN_WHAT_YOU_MISSED": "取り上げなかった点について学びましょう",
      "NICE_JOB": "よくできました！",
      "ALL_POINTS_COVERED": "このトピックで求められるトークポイントをすべて取り上げました。",
      "COVER_ALL_MESSAGES": "すべての重要なメッセージを取り上げてください。",
      "HIGHLIGHT_KEY_POINTS_NOTE": "通話全体を通して重要な点を強調することで、会話を集中し続けることができます。",
      "MESSAGES_LABEL": "メッセージ",
      "NO_FACTS_COVERED": "おっと！このメッセージの事実について、何も取り上げていないようです。",
      "NO_SPECIFICS_AVAILABLE": "おっと！何が抜け落ちていたかについて、具体的な点を特定できなかったようです。",
      "ALL_KEY_POINTS_COVERED": "よくできました！すべての重要なポイントを取り上げました。",
      "PROCESSING_SKILLS_FEEDBACK": "スキルに関するフィードバックを処理中です。",
      "SKILLS_SCORING_NOT_ENABLED": "申し訳ありませんが、送信時点でスキル評価が有効になっていなかったため、直近の通話データを分析できませんでした。フィードバックを受け取るには、以前と同様に通話の練習を再送信してください。ご不明な点がございましたら、サポートチームまでお問い合わせください。ご理解と向上に向けた取り組みに感謝しております。",
      "ELEVATE_CONVERSATION_SKILLS": "会話スキルを向上させる",
      "SKILLS_NOTE": "スキルは会話を成功させるために不可欠ですが、総合スコアには影響しません。",
      "SKILLS_SUMMARY_TITLE": "スキルの概要",
      "LEARN_MORE_ABOUT_SKILLS": "スキルについて詳しく見る",
      "SKILLS_FEEDBACK_LABEL": "フィードバック",
      "WHAT_ARE_SKILLS_TITLE": "スキルとは",
      "SKILLS_DESCRIPTION": "スキルは、個人の成長と能力開発を支援するために設定されています。これらのスキルは、通話に対する数値評価の一部ではありませんが、あなたの効率性を高めるために組織によって選定されたものです。",
      "PROFICIENCY_SCALE_TITLE": "習熟度スケール",
      "EXPERT": "エキスパート",
      "PROFICIENT": "習熟",
      "DEVELOPING": "開発中",
      "CALL_TRANSCRIPT": "通話記録",
      "COLLAPSE_ALL": "すべて折りたたむ",
      "EXPAND_ALL": "すべて展開",
      "THUMBNAIL": "サムネイル",
      "OUT_OF_FIVE_POINTS": "/5ポイント",
      "TALKING_POINTS": "トークポイント",
      "TRANSCRIPT_LABEL": "通話記録",
      "YOU_ARE_OUT_OF_ATTEMPTS": "挑戦回数が上限に達しました。",
      "REVIEW_GUIDELINES_REMAIN_COMPLIANT": "ガイドラインを確認し、今後もガイドラインを遵守してください。",
      "TRY_AGAIN_ATTENTION_TO_COMPLIANCE": "もう一度挑戦し、コンプライアンスガイドラインに注意を払ってください。",
      "NO_SCORE_OUT_OF_COMPLIANCE": "コンプライアンスに違反している可能性のある点を特定しました",
      "WHY_OUT_OF_COMPLIANCE": "コンプライアンス違反となる可能性がある理由",
      "REVIEW_TRANSCRIPT_MISSED_GUIDELINES": "通話記録を確認し、どこでコンプライアンスガイドラインに違反したかを確認してください。",
      "YOU_DID_FOLLOW_GUIDELINES": "これらのガイドラインは適切に遵守されていました。",
      "REVIEW_MISSED_GUIDELINES": "コンプライアンスガイドラインに従えなかった点を確認してください。",
      "OUT_OF_COMPLIANCE": "コンプライアンス違反",
      "SCORE_CALCULATION_TITLE": "スコアの算出",
      "PROCESSING_TRANSCRIPT": "現在、通話記録を処理中です。",
      "WAIT_OR_REVIEW_SCORES": "通話記録の読み込み中は、このまま待つか、他のスコア",
      "TRANSCRIPT_LOADING": "セクションを確認することができます。",
      "REVIEW_FEEDBACK_KEEP_PRACTICING": "フィードバックを確認し、練習を続けてください",
      "HIGH_PERFORMERS_PRACTICE": "成績優秀な受講生は、少なくとも週に1回は練習しています",
      "SUCCESSFULLY_PASSED": "よくできました！このシミュレーションに合格しました。",
      "DIDNT_REACH_PASSING_SCORE": "このシミュレーションの合格点に達しませんでした。",
      "OUT_OF_ATTEMPTS": "<b>挑戦回数が上限に達しました。</b>フィードバックを確認し、改善点を見つけてください。",
      "REVIEW_FEEDBACK_THEN_RETURN": "フィードバックを確認し、準備ができたらホームに戻ってください。",
      "GREAT_JOB_PRACTICED": "よくできました。{{count}} {{times}}回練習しましたね。これからも頑張ってください！",
      "GREAT_JOB_PRACTICED_FEMALE": "よくできました。{{count}} {{times}}回練習しましたね。これからも頑張ってください！",
      "TIME": "回",
      "TIMES": "回",
      "COMPLIANCE_GUIDELINES": "コンプライアンスガイドライン",
      "TALKING_POINT_TITLE": "取り上げなかった、またはタイミングを間違えて発したトークポイント",
      "NO_TRANSCRIPT": "通話記録は利用できません。",
      "RETURN_TO_ASSIGNMENT": "課題に戻る",
      "NONE_PERFECT": "なし - 完璧です！",
      "MISSED_ONE_TALKING_POINT": "このトピックについて、1つのトークポイントを取り上げませんでした。",
      "MISSED_X_TALKING_POINTS": "このトピックで{{count}}つのトークポイントを取り上げませんでした。",
      "MISSED_ONE_REQUIRED_TALKING_POINT": "このトピックで必須のトークポイントを1つ取り上げませんでした",
      "MISSED_X_REQUIRED_TALKING_POINTS": "このトピックで必須のトークポイントを{{count}}つ取り上げませんでした",
      "MISSED_ALL_ONE_REQUIRED_TALKING_POINT_TITLE": "このトピックで必須のトークポイントを1つ取り上げませんでした。",
      "MISSED_ALL_X_REQUIRED_TALKING_POINTS_TITLE": "このトピックで必須のトークポイントを{{count}}つ取り上げませんでした。",
      "REVIEW_MATERIAL_NEXT_TIME": "次回に向けて、教材を見直して改善してください。",
      "ROLEPLAY_POST_CALL_TITLE": "この通話の最後に達しました。",
      "ROLEPLAY_POST_CALL_SUBTITLE_PROCESSING": "結果の処理中に、フィードバックをお寄せください。",
      "ROLEPLAY_POST_CALL_SUBTITLE_DELAY": "結果の読み込みに少し時間がかかっています。パスウェイを終了してください。準備が整い次第、お知らせいたします。",
      "ROLEPLAY_POST_CALL_SUBTITLE_ERROR": "結果の処理中にエラーが発生しました。次までサポートにお問い合わせください：",
      "ROLEPLAY_POST_CALL_PROCESSING_LABEL": "結果を処理中…",
      "ROLEPLAY_POST_CALL_FEEDBACK_QUESTION": "この会話は、リアルで自然な感じでしたか？",
      "FEEDBACK_THANK_YOU": "フィードバックをいただき、ありがとうございます！",
      "FEEDBACK_IMPROVEMENT_NOTE": "フィードバックをいただき、ありがとうございます！体験の向上に努めてまいります。",
      "VIEW_RESULTS": "結果を表示",
      "FEEDBACK_IMPROVEMENT_SUFFIX": "体験の向上に努めてまいります。",
      "ACCURACY": "正確性",
      "ACCURACY_LOADING": "読み込み中…",
      "ACCURACY_FLAGGED_MESSAGE": "ソース資料とは異なる内容が含まれている可能性があります。詳細については以下をご覧ください。",
      "ACCURACY_ALL_CLEAR": "ソース資料と不一致と思われる発言は特定されませんでした。",
      "ACCURACY_ERROR": "このセッションに関するフィードバックは提供できませんでした",
      "ACCURACY_YOU_SAID": "あなたの発言",
      "ACCURACY_CLAIM_IDENTIFIED": "当社が特定した発言",
      "ACCURACY_MATERIALS_STATE": "教材の記載内容",
      "ACCURACY_OVERALL_BLOCK_PREFIX": "不正確かもしれないものがあるとおっしゃいました。詳細は ",
      "ACCURACY_OVERALL_BLOCK_LINK": "正確性",
      "ACCURACY_OVERALL_BLOCK_SUFFIX": " タブで確認してください。",
      "PRACTICE_SIMULATION_AGAIN": "シミュレーションをもう一度練習する",
      "CALL_TYPE_CONVERSATIONAL": "会話型の通話",
      "CALL_TYPE_GUIDED": "ガイド付きの通話",
      "CALL_TYPE_VISUAL_AID": "視覚的資料付きの通話",
      "CALL_TYPE_ROLEPLAY": "ロールプレイの通話",
      "PERSONALIZED_PRACTICE_BREADCRUMB": "パーソナライズされた練習",
      "CONVERSATION_TYPE_LABEL": "会話の種類：",
      "DIFFICULTY_LABEL": "難易度：",
      "MOOD_LABEL": "気分：",
      "DIFFICULTY": "難易度",
      "TEMPERAMENT": "気質",
      "OVERALL_SCORE_TAB": "全体的な",
      "MESSAGE_ADHERENCE_TAB": "メッセージ",
      "OBJECTIVES_TAB": "目標"
    },
    "reportingV2": {
      "DASHBOARD": "ダッシュボード",
      "LOADING_ACCOUNTS": "アカウントを読み込んでいます…",
      "SELECT_AN_ACCOUNT": "アカウントを選択",
      "SELECT_ASSIGNMENTS": "課題を選択",
      "SEARCH_TEAMS": "チームを検索",
      "LOADING_TEAMS": "チームを読み込んでいます…",
      "ALL_TEAMS": "すべてのチーム",
      "ACCOUNT": "アカウント",
      "TEAMS": "チーム",
      "TEAM_LABEL": "チーム",
      "TOTAL_LABEL": "合計",
      "PASSING_SCORE": "合格点",
      "ASSIGNMENT_LABEL": "課題",
      "USER_LABEL": "ユーザー",
      "PRACTICE_LABEL": "練習",
      "CERTIFICATION_LABEL": "認定",
      "CERTIFICATION_STATUS_LABEL": "認定ステータス",
      "CERTIFICATION_STATUS_PREFIX_LABEL": "認定ステータス：",
      "CERTIFIED_ON_FIRST_ATTEMPT_LABEL": "初めての挑戦で認定されましたか？",
      "DATE_OF_CERTIFICATION_LABEL": "認定日",
      "RESULTS_DESCRIPTION": "すべての練習の課題における、あなたのチームの結果は以下の通りです：",
      "ENGAGEMENT_BY_ASSIGNMENT": "課題ごとの取り組み",
      "ASSIGNMENT_ENGAGEMENT": "課題への取り組み",
      "ENGAGED_LABEL": "取り組み済み",
      "ENGAGEMENT_STATUS_LABEL": "取り組み状況",
      "ENGAGEMENT_STATUS_PREFIX_LABEL": "取り組み状況：",
      "PROFICIENT_LABEL": "習熟",
      "ASSIGNMENT_NAME": "課題名",
      "ACTIVE_USERS": "アクティブユーザー",
      "ASSIGNMENT_PROGRESS": "課題ごとの進捗状況",
      "IN_PROGRESS_LABEL": "進行中",
      "CERTIFIED_LABEL": "認定済み",
      "OUT_OF_ATTEMPTS_LABEL": "挑戦回数中",
      "USERS_ENGAGED_LABEL": "取り組んでいるユーザー数",
      "SESSIONS_PER_ACTIVE_USERS_LABEL": "アクティブユーザーあたりのセッション数",
      "HIGHER_THAN_LABEL": "次より高い：",
      "MORE_THAN_LABEL": "次より多い：",
      "TOTAL_SESSIONS_COMPLETED_LABEL": "完了したセッション総数",
      "USER_CERTIFIED": "すべての課題で認定を受けたユーザー数",
      "ASSIGNMENT_CERTIFICATION": "認定率100％の課題",
      "TRAINER_TIME_SAVED": "削減されたトレーナーの時間",
      "HOURS_LABEL": "時間",
      "PRACTICE_ASSIGNMENT_LABEL": "練習の課題",
      "CERTIFICATION_ASSIGNMENT_LABEL": "認定の課題",
      "START_DATE_LABEL": "開始日",
      "END_DATE_LABEL": "終了日",
      "NAME_LABEL": "名前",
      "EMAIL_LABEL": "メールアドレス",
      "MEMBER_OF_TEAMS_LABEL": "チームのメンバー",
      "ASSIGNMENTS_COUNT_LABEL": "課題数",
      "TOTAL_SESSIONS_LABEL": "セッション総数",
      "NUMBER_OF_SESSIONS_LABEL": "セッション数",
      "TOTAL_USERS_LABEL": "ユーザー総数",
      "AVERAGE_SCORE_LABEL": "平均スコア",
      "INITIAL_SCORE_LABEL": "最初のスコア",
      "HIGH_SCORE_LABEL": "最高スコア",
      "LAST_PRACTICE_DATE_LABEL": "最終練習日",
      "PERCENT_IMPROVED_LABEL": "向上率（%）",
      "PERCENT_IMPROVED_TOOLTIP_TEXT": "この指標は、ユーザーの最初のスコアと最高スコアを比較し、達成可能な最大改善率として表したものです。",
      "ASSIGNMENTS_CERTIFIED_LABEL": "認定された課題",
      "ASSIGNMENTS_PROFICIENT_LABEL": "習熟した課題",
      "ASSIGNMENTS_CERTIFIED_TOOLTIP_TEXT": "ユーザーが課題のすべてのシミュレーションにおいて、スコア基準を満たしたか、それを上回った課題の数",
      "ASSIGNMENTS_PROFICIENT_TOOLTIP_TEXT": "ユーザーが課題のすべてのシミュレーションにおいて、少なくとも1回スコア基準を満たしたか、それを上回った課題の数",
      "PROFICIENT_TOOLTIP": "ユーザーがこの課題のすべてのシミュレーションにおいて、少なくとも1回スコア基準を満たしたか、それを上回った課題でのユーザーの割合（%）",
      "ENGAGED_TOOLTIP": "この課題において、シミュレーションのセッションを1回以上完了しているが、すべてのシミュレーションで習熟レベルに達していないユーザーの割合（%）。",
      "IN_PROGRESS_TOOLTIP": "この課題において、シミュレーションのセッションを1回以上完了しており、スコアを取得したユーザーの割合（%）。",
      "OUT_OF_ATTEMPTS_TOOLTIP": "課題内の1つ以上のシミュレーションで、割り当てられた挑戦回数を超過したユーザーの割合（%）。",
      "CERTIFIED_TOOLTIP": "課題内のすべてのシミュレーションで、スコア基準を満たした、または上回ったユーザーの割合（%）。",
      "SEARCH_FOR_A_USER_LABEL": "ユーザーを検索",
      "NO_USERS_FOUND_LABEL": "ユーザーが見つかりませんでした",
      "TRAINER_TIME_SAVED_TOOLTIP": "ユーザーがQuantifiedで認定のための挑戦に費やした時間。",
      "AVG_SESSIONS_PER_ASSIGNMENT": "課題あたりの平均セッション数",
      "ASSIGNMENTS_ENGAGED_WITH": "取り組まれた課題数",
      "AVERAGE_IMPROVEMENT": "平均改善度",
      "STATUS": "ステータス",
      "ASSIGNMENT_STATUS": "課題のステータス",
      "STATUS_ACTIVE": "アクティブ",
      "STATUS_ENDED": "終了",
      "STATUS_CLOSED": "終了しました",
      "STATUS_ARCHIVED": "アーカイブ済み",
      "TOTAL_NUMBER_OF_SESSIONS": "セッション総数",
      "DATE_OF_LAST_PRACTICE": "最後の練習日",
      "CALL_NAME": "通話名",
      "SESSION_DATE": "セッション日",
      "DURATION_OF_SESSION": "セッションの所要時間",
      "DURATION_OF_ATTEMPT": "挑戦の所要時間",
      "OVERALL_SCORE": "総合スコア",
      "MESSAGING_SCORE": "メッセージ遵守スコア",
      "METHODOLOGY_SCORE": "手法スコア",
      "SKILLS_SCORE": "スキルスコア",
      "SESSIONS": "セッション数",
      "TOTAL": "合計",
      "ALL_ASSIGNMENTS": "すべての課題",
      "RECENT_ASSIGNMENTS": "最近の課題",
      "USER_NAME": "ユーザー名",
      "LEARNER": "学習者",
      "DATE_RANGE": "日付範囲",
      "DATE_RANGE_LABEL": "日付範囲",
      "SEARCH_USERS": "ユーザーを検索…",
      "SEARCH_SIMULATIONS": "シミュレーションを検索…",
      "SEARCH_DATES": "日付を検索…",
      "SEARCH_ASSIGNMENTS": "課題を検索…",
      "CERTIFIED_ON_FIRST_TRY": "最初の挑戦で認定取得",
      "DATE_OF_CERTIFICATION": "認定日",
      "AVERAGE_CERTIFICATION_SCORE": "認定の平均スコア",
      "TOTAL_TIME_CERTIFYING": "認定に要した総時間",
      "OF_THE_TIME": "の割合",
      "AVERAGE_SESSIONS_ACTIVE_USER": "アクティブユーザーの平均セッション数",
      "HOURS_IN_SIMULATIONS": "シミュレーションに要した時間",
      "AVERAGE_SESSIONS_TO_PROFICIENCY": "習熟に至るまでの平均セッション数",
      "PERCENT_PROFICIENT": "習熟率（％）",
      "SYSTEM_RUNNING_NORMALLY": "システムは現在正常に稼働しています",
      "PRACTICE_SIMULATIONS_LABEL": "シミュレーション",
      "SIMULATION_NAME": "シミュレーション名",
      "AVERAGE_DURATION_OF_SESSION": "セッションの平均所要時間",
      "AVERAGE_SESSIONS_PER_ACTIVE_USER": "アクティブユーザーあたりの平均セッション数",
      "NO_USERS_MATCHING_FILTERS_LABEL": "フィルタに一致する結果はありません。検索範囲を広げるために、1つ以上のフィルタを解除してみてください。",
      "USERS_PASSED": "シミュレーションに合格したユーザー",
      "AVERAGE_TIME": "認定取得までの平均所要時間",
      "USERS_OUT_OF_ATTEMPTS": "挑戦回数を超えたユーザー",
      "NO_CERTIFICATION_SIMULATION": "認定シミュレーションが見つかりませんでした",
      "AVERAGE_OVERALL_SCORE": "総合平均スコア",
      "SIMULATION": "シミュレーション",
      "No_SIMULATION": "セッションなし",
      "PERCENT_CERTIFIED": "認定取得の割合",
      "PERCENT_CERTIFIED_FIRST_ATTEMPT": "初回の挑戦での認定率",
      "USERS": "ユーザー",
      "ATTEMPTS_LABEL": "挑戦回数",
      "NO_ATTEMPTS": "挑戦回数なし",
      "DATE_OF_SESSION": "セッションの日付",
      "TOTAL_ASSIGNMENTS": "課題の総数",
      "ASSIGNMENTS_CERTIFIED": "認定された課題",
      "TOTAL_SESSIONS": "セッション総数",
      "HOURS_SPENT_PRACTICING": "練習に費やした時間",
      "LAST_LOGIN": "最終ログイン日",
      "NO_ASSIGNMENTS_MATCH_FILTERS": "選択したフィルタに一致する課題はありません",
      "NO_TEAMS_DATA": "このアカウントにはチームがありません",
      "ASSIGNED_LABEL": "未開始",
      "USERS_ASSIGNED_LABEL": "割り当てられたユーザーの総数",
      "SESSION_ID": "セッションID",
      "USER_NAME_LABEL": "ユーザー名",
      "NO_SIMULATIONS_FOUND_LABEL": "シミュレーションが見つかりませんでした",
      "MIN": "分",
      "SEC": "秒",
      "OF_LABEL": "/",
      "SECOND": "秒",
      "SECONDS": "秒",
      "MINUTE": "分",
      "MINUTES": "分",
      "ASSIGNMENT_NAME_LABEL": "課題名",
      "SIMULATION_NAME_LABEL": "シミュレーション名",
      "START_DATE": "開始日",
      "END_DATE": "終了日",
      "NO_ASSIGNMENTS": "このユーザーには課題が見つかりませんでした。",
      "ASSIGNED": "割り当て済み",
      "TOTAL_PRACTICE_ASSIGNMENTS": "練習の課題の合計数",
      "SESSION_SCORES_OVER_TIME": "経時的なセッションスコア",
      "TIME": "時間",
      "SCORE": "スコア",
      "NO_SESSIONS_AVAILABLE": "グラフ化できるセッションがありません。",
      "MESSAGING_SCORE_LABEL": "メッセージングスコア",
      "PERSONALIZED_PRACTICE_LABEL": "パーソナライズされた練習",
      "NO_PRODUCTS": "選択されたチームには、パーソナライズされた練習用の製品がありません",
      "TOTAL_TIME_SPENT_PRACTICING": "練習に費やした合計時間",
      "AVERAGE_SESSIONS_PER_USER": "ユーザーあたりの平均セッション数",
      "MOST_COMMON_CONVERSATION_TYPE_SELECTION": "最も一般的な会話タイプの選択",
      "LEAST_COMMON_CONVERSATION_TYPE_SELECTION": "最も一般的でない会話タイプの選択",
      "CLEAR": "クリア",
      "CLEAR_TEAMS": "チームをクリア",
      "METHODOLOGY_SCORE_DESCRIPTION": "学習者が推奨される通話構成にどの程度従っているかを測定します。スコアは、このシミュレーションの全セッションの平均値を反映しています。",
      "METHODOLOGY": "手法",
      "MESSAGING": "メッセージ",
      "MESSAGING_V2_DASHBOARD_DESCRIPTION": "学習者が通話中に重要な考えを正確に伝達できているかどうかを測定します。グラフは、全セッションを通じて、テーマごとのメッセージが正しく伝達された割合の平均を示しています。",
      "NO_METRICS_MESSAGE": "洞察を生み出すには、さらに多くのセッションが必要です。",
      "SELECT_ALL": "すべて選択",
      "DESELECT_ALL": "すべて選択解除",
      "SKILLS": "スキル",
      "SKILLS_SCORE_STATS_DESCRIPTION": "通話中に学習者が主要なスキルをどの程度発揮しているかを測定します。スコアは、全セッションの平均値として算出されたAI評価を反映しています。",
      "EXPERT": "エキスパート",
      "PROFICIENT": "習熟",
      "DEVELOPING": "開発中",
      "FULLY_ARTICULATED": "明確な表現が完全にできた",
      "PARTIALLY_ARTICULATED": "明確な表現が部分的にできた",
      "NOT_MENTIONED": "言及なし",
      "MESSAGING_SCORE_STATS_DESCRIPTION": "学習者が通話中に重要な考えを正確に伝達できているかどうかを測定します。グラフは、各メッセージが全セッションを通じて正しく伝達された頻度を示しています。",
      "CLEAR_STATUS": "ステータスをクリア",
      "CLEAR_USERS": "ユーザーをクリア",
      "CLEAR_SIMULATIONS": "シミュレーションをクリア",
      "CLEAR_ASSIGNMENTS": "課題をクリア",
      "MODAL_SUBHEADING": "{{ count }}つの目標すべて — 全セッションにわたる平均スコア",
      "VIEW_ALL_OBJECTIVES": "{{ count }}つの目標すべてを表示 →",
      "LEAST_MISSED_QUESTION": "最も正解率が高かった問題",
      "MOST_MISSED_QUESTION": "最も正解率が低かった問題",
      "HIGHEST_SCORING_METHODOLOGY_SECTION": "最高得点を記録した手法セクション",
      "LOWEST_SCORING_METHODOLOGY_SECTION": "最低得点を記録した手法セクション",
      "LEAST_ARTICULATED_MESSAGE": "最も正確に伝達されなかったメッセージ",
      "ENGAGEMENT": "取り組み",
      "USER_ENGAGEMENT_MORE_SESSIONS": "チーム平均よりも多くのセッションを完了",
      "USER_ENGAGEMENT_FEWER_SESSIONS": "チーム平均よりも少ないセッションを完了",
      "QUESTION_CORRECT_PERCENTAGE_DESC": "この課題を正解した割合",
      "QUESTION_CORRECT_PERCENTAGE_DESC_ASSIGNMENT": "ユーザーがこの課題を正解した割合",
      "METHODOLOGY_AVERAGE_POINTS_DESC": "全セッションにおけるこの目標の平均得点",
      "MOST_ARTICULATED_MESSAGE": "最も正確に伝達されたメッセージ",
      "LEAST_MISSED_ANSWER_POINT": "最も見落とされなかった回答ポイント",
      "MOST_MISSED_ANSWER_POINT": "最も見落とされた回答ポイント",
      "MOST_ARTICULATED_MESSAGE_DESCRIPTION": "このメッセージを完全に正しく伝達できた割合",
      "LEAST_ARTICULATED_MESSAGE_DESCRIPTION": "このメッセージを正しく伝達できた割合",
      "MOST_ARTICULATED_MESSAGE_DESCRIPTION_ASSIGNMENT": "このメッセージをユーザーが正しく伝達できた割合",
      "LEAST_ARTICULATED_MESSAGE_DESCRIPTION_ASSIGNMENT": "このメッセージをユーザーが正しく伝達できた割合",
      "OTHERS_SINGULAR": "および、さらに1つ",
      "OTHERS_PLURAL": "および、さらに{{ count }}つ",
      "PAGINATION_PREVIOUS": "戻る",
      "PAGINATION_NEXT": "次へ",
      "HOUR_LABEL": "時間",
      "SESSIONS_LABEL": "セッション数"
    },
    "personalizedPractice": {
      "TITLE": "パーソナライズされた練習",
      "DESCRIPTION": "{{userFirstName}}さん、こんにちは！パーソナライズされた練習では、できるだけ現実的な状況になるよう、ご自身でシナリオを設定することができます。",
      "LOADING": "読み込み中…",
      "VIEW_SESSIONS": "セッションを表示",
      "VIEW_SIMULATION": "シミュレーションを表示",
      "TOTAL_SESSION": "セッション総数",
      "TOTAL_SESSIONS": "セッション総数",
      "BREADCRUMB": "パーソナライズされた練習",
      "SCENARIO_DETAILS_TITLE": "シナリオの詳細",
      "SCENARIO_DETAILS_DESCRIPTION": "以下のオプションから変数を選択し、ニーズに合うようにシミュレーションを調整してください。",
      "AVATAR": "アバター",
      "SELECT_PLACEHOLDER": "選択",
      "CONVERSATION_TYPE": "会話の種類",
      "SELECT_CONVERSATION_TYPE": "会話の種類を選択",
      "LAUNCH_SIMULATION": "選択内容に基づいてシミュレーションを開始",
      "PREVIOUS_SESSIONS": "過去のセッション",
      "TOTAL": "合計",
      "FILTERS": "フィルタ：",
      "DATE": "日付",
      "DIFFICULTY": "難易度",
      "TEMPERAMENT": "気質",
      "SESSION_DATE": "セッション日",
      "SESSION_SCORE": "セッションのスコア",
      "DURATION": "所要時間",
      "OVERALL_SCORE": "総合スコア",
      "MESSAGING": "メッセージ",
      "METHODOLOGY": "手法",
      "SKILLS": "スキル",
      "RESULTS": "結果",
      "VIEW_FEEDBACK": "フィードバックを表示",
      "OVERALL_SCORE_LABEL": "総合スコア",
      "SCORE": "スコア",
      "NO_PRODUCTS_TITLE": "利用可能な製品はありません",
      "NO_PRODUCTS_DESCRIPTION": "まだパーソナライズされた練習用の製品はありません。",
      "NO_SESSIONS_FOUND": "選択したフィルタではセッションが見つかりませんでした",
      "TIME": "時間",
      "ALL": "すべて",
      "LEARNER": "学習者",
      "MOOD": "気分",
      "CLEAR_FILTERS": "フィルタをクリア",
      "PAGINATION_PREVIOUS": "戻る",
      "PAGINATION_NEXT": "次へ",
      "DURATION_MINUTES_SECONDS": "{{minutes}}分{{seconds}}秒",
      "DURATION_SECONDS": "{{seconds}}秒"
    },
    "login": {
      "TITLE": "ようこそ",
      "SUB_TITLE": "どの方法でログインしますか？ ",
      "LOGIN_WITH_SSO": "会社のSSOでログイン",
      "LOGIN_WITH_PASSWORD": "パスワードでログイン",
      "PROVIDE_EMAIL": "メールアドレスを入力してください",
      "HELP_TEXT": "お困りですか？お問い合わせください：",
      "EMAIL_ERROR": "ログインできません。貴社の管理者またはIT部門にお問い合わせください。",
      "EMAIL": "メールアドレス",
      "LOGIN": "ログイン",
      "ALERT": "アラート",
      "EMAIL_PLACEHOLDER": "olivia@untitledui.com",
      "LOGIN_CONSENT_MESSAGE": "アカウントにログインすることで、{{termsLink}} および {{privacyLink}} に同意したものとみなされます。",
      "TERMS_OF_SERVICE": "利用規約",
      "PRIVACY_POLICY": "プライバシーポリシー",
      "WRONG_REGION_MESSAGE": "ログインできません。貴社の管理者にお問い合わせください。",
      "WRONG_REGION_LINK": "{{regionName}}のサイトにログインしてみることもできます。"
    },
    "learningPathway": {
      "BEGIN": "開始",
      "SUBMIT_ANSWER": "回答を送信",
      "CONTINUE": "続行",
      "REVIEW_MATERIAL": "教材を確認する",
      "ASK_QUESTIONS_ABOUT_PATHWAY": "パスウェイについて質問する",
      "DUE_DATE": "期限",
      "FOOTER_SUBTITLE_READY": "何でも聞いてください！喜んでお手伝いします。",
      "FOOTER_SUBTITLE_READY_LEARN_WITH_X": "質問があれば、コーチが聞いています",
      "FOOTER_SUBTITLE_MUTED": "現在、音声はミュートされています。コーチにはあなたの声が聞こえません。",
      "FOOTER_SUBTITLE_LISTENING": "質問をお聞きしています…",
      "FOOTER_SUBTITLE_THINKING": "回答を考えています…",
      "LEAVE_STEP": "ステップを終了",
      "VIEW_CALL_DETAILS": "通話の詳細を表示",
      "NEXT_STEP": "次のステップ",
      "NOTIFICATIONS_ARIA": "通知",
      "PDF_LOADING": "PDFを読み込み中",
      "PDF_NEXT_PAGE": "次のページ",
      "PDF_NO_SOURCE": "PDFソースが提供されていません。",
      "PDF_PREVIOUS_PAGE": "前のページ",
      "PDF_SCROLL_HINT": "スクロールして読み続ける",
      "PDF_FULLSCREEN_ENTER": "全画面表示にする",
      "PDF_FULLSCREEN_EXIT": "全画面表示を終了する",
      "PDF_ZOOM_IN": "拡大",
      "PDF_ZOOM_OUT": "縮小",
      "POST_CALL_SUBTITLE": "結果の処理中に、フィードバックをお寄せください",
      "POST_CALL_TITLE": "このクイズはこれで終了です。",
      "SETTINGS": "設定",
      "TOAST_CONTENT": "以下をクリックして結果を確認するか、パスウェイ詳細画面に戻って次のステップをご覧ください。",
      "TOAST_TITLE": "{{ stepName }}のロールプレイの結果が処理されました",
      "ASSIGNMENTS": "課題",
      "USER_FALLBACK": "ユーザー",
      "VIEW_RESULTS": "結果を表示",
      "DISMISS": "却下",
      "QUIZ_TITLE": "クイズ",
      "QUIZ_OVERALL_SCORE_TOOLTIP": "総合スコアは、今回の挑戦での回答の加重平均です。",
      "COLUMN_DATE": "日付",
      "COLUMN_OVERALL_SCORE": "総合スコア",
      "COLUMN_RESULTS": "結果",
      "COLUMN_ANSWER_POINTS": "回答ポイント",
      "COLUMN_MESSAGING_SCORE": "メッセージングスコア",
      "COLUMN_METHODOLOGY_SCORE": "手法スコア",
      "COLUMN_SKILLS_SCORE": "スキルスコア",
      "PRACTICE_AGAIN": "もう一度練習する",
      "DEBRIEF_LATEST_SESSION": "直近のセッションの振り返り",
      "COMPLETE_STEP": "完了",
      "ERROR_TITLE": "問題が発生しました",
      "ERROR_MESSAGE": "一度終了して、パスウェイに再度アクセスしてください。問題が解決しない場合は、以下までご連絡ください：",
      "ERROR_HELP_EMAIL": "help@quantified.ai",
      "PATHWAY_COMPLETED_TITLE": "このパスウェイを完了しました",
      "PATHWAY_COMPLETED_BODY": "結果はいつでも確認できます。また、どのステップも再挑戦して練習し続けることができます。",
      "PATHWAY_COMPLETED_RETURN": "課題に戻る",
      "PATHWAY_OUT_OF_ATTEMPTS_TITLE": "パスウェイでのステップで、挑戦回数が上限に達しました",
      "PATHWAY_OUT_OF_ATTEMPTS_BODY": "次のステップについて、マネージャーにご相談ください。",
      "COMPLETED": "完了",
      "EXITING_QUIZ_EARLY": "今このクイズを終了すると、1回の挑戦としてカウントされます",
      "TRY_AGAIN": "再挑戦",
      "RETURN_TO_PATHWAY": "パスウェイのホームに戻る",
      "REVIEW_BEFORE_QUIZ_TOOLTIP": "クイズに再挑戦する前に、このステップを見直してください",
      "EXIT_MODAL_TITLE": "このロールプレイを終了してもよろしいですか？",
      "EXIT_MODAL_EXIT": "終了",
      "EXIT_MODAL_RESUME": "再開",
      "EXIT_MODAL_DESC_LIMITED_ATTEMPTS": "今ロールプレイを終了すると、採点されませんが、挑戦数としてカウントされます。",
      "EXIT_MODAL_DESC_UNLIMITED_ATTEMPTS": "今ロールプレイを終了すると、採点されません。",
      "EXIT_MODAL_DESC_SCORED": "今ロールプレイを終了すると、その通話は現状のまま採点されます。",
      "RESULTS_PROCESSING": "結果の処理",
      "RESULTS_FAILED": "結果の読み込みに失敗しました。help@quantified.ai までご連絡ください。",
      "DEBRIEF_TITLE": "振り返り",
      "DEBRIEF_DESCRIPTION": "前回の認定試験の結果について話し合う",
      "DEBRIEF_DESCRIPTION_PRACTICE": "前回の練習セッションの結果について話し合う",
      "VIEW_ALL_SESSIONS": "すべてのセッションを表示",
      "COLLAPSE_SESSIONS": "セッションを折りたたむ",
      "VIEW_ALL_ATTEMPTS": "すべての挑戦を表示",
      "COLLAPSE_ATTEMPTS": "挑戦を折りたたむ",
      "REATTEMPT_CERTIFICATION": "認定試験に再挑戦する",
      "DEBRIEF_EXIT_MODAL_TITLE": "振り返りを終了してもよろしいですか？",
      "DEBRIEF_EXIT_MODAL_DESC": "この振り返りを今終了すると、完了としてマークされません。",
      "EXIT_PATHWAY": "パスウェイを終了",
      "HELP": "ヘルプ",
      "DOWNLOAD": "ダウンロード",
      "LEARN_STEP_HELP_CLOSE": "閉じる",
      "LEARN_STEP_HELP_TROUBLE": "それでも問題が解決しない場合は、以下までご連絡ください：",
      "LEARN_STEP_HELP_EMAIL": "help@quantified.ai",
      "LEARN_STEP_HELP_VIDEO_P1": "教材をご覧になり、質問があればコーチに尋ねてください。",
      "LEARN_STEP_HELP_VIDEO_P2": "再生ボタンを選択して、動画を再生してください。教材を再確認するために、前の部分に戻ることができます。",
      "LEARN_STEP_HELP_VIDEO_P3": "質問をする際は、右下のアイコンを使用してミュートを解除してください。これにより、動画が一時停止します。動画を再生すると、マイクがミュートされます。",
      "LEARN_STEP_HELP_VIDEO_P4": "動画を最後まで視聴したら、次のステップに進んでください。",
      "LEARN_STEP_HELP_PDF_P1": "教材を読み、質問があればコーチに尋ねてください。",
      "LEARN_STEP_HELP_PDF_P2": "スクロールするか、両側の矢印ボタンを使ってページ間を移動し、教材を進めてください。",
      "LEARN_STEP_HELP_PDF_P3": "右下でマイクの音声をミュートしたり、ミュートを解除したりできます。",
      "LEARN_STEP_HELP_PDF_P4": "すべて読み終えたら、次のステップに進んでください。",
      "ASSESSMENT_EXIT_MODAL_TITLE": "先に進んでもよろしいですか？",
      "ASSESSMENT_EXIT_MODAL_DESC": "この会話が完了する前に先に進むと、学習時間が長くなり、学習体験のパーソナライズ度が低下します。",
      "ASSESSMENT_EXIT_MODAL_RESUME": "評価を再開する",
      "ASSESSMENT_EXIT_MODAL_PROCEED": "続行",
      "ASSESSMENT_PERSONALIZATION_ERROR_TITLE": "パスウェイをパーソナライズできませんでした",
      "ASSESSMENT_PERSONALIZATION_ERROR_DESC_START": "すべてのパスウェイが割り当てられました。 ",
      "ASSESSMENT_PERSONALIZATION_ERROR_DESC_END": " パーソナライズされたものに再挑戦したい場合は、こちらまでご連絡ください。",
      "OPTIONAL": "任意"
    },
    "leaderboard": {
      "LEADERBOARD": "リーダーボード",
      "TOP10PERCENT": "上位10％",
      "PRACTICE_ASSIGNMENT": "練習の課題",
      "SIMULATION": "シミュレーション",
      "SELECT_ASSIGNMENT": "課題を選択",
      "SELECT_SIMULATION": "シミュレーションを選択",
      "SELECT_ASSIGNMENT_AND_SIMULATION": "課題とシミュレーションを選択すると、上位者を表示できます",
      "NO_DATA": "まだ活動はありません。チームが活動を開始すると、ここにランキングが表示されます。",
      "NO_ASSIGNMENTS_AVAILABLE": "利用可能な課題はありません",
      "NO_SIMULATIONS_AVAILABLE": "利用可能なシミュレーションはありません",
      "NAME": "名前",
      "HIGH_SCORE": "最高スコア",
      "AVERAGE_SCORE": "平均スコア",
      "TOTAL_SESSIONS": "セッション総数",
      "LAST_SESSION": "直近のセッション",
      "TOP5": "上位5",
      "OF": "/",
      "ENGAGED_USERS": "取り組んだユーザー",
      "ENGAGED_USER": "取り組んだユーザー",
      "NO_USERS_ENGAGED": "取り組んだユーザーはいません",
      "HIDE_SESSIONS_WITH_LOW_SCORE": "スキルスコアが低いセッションを非表示にする",
      "SESSIONS_WITH_LOW_SCORE_TOOLTIP": "スキルセクションのスコアが「開発中」のセッションは、最高スコアと平均スコアの列には算入されません。",
      "PAGINATION_PREVIOUS": "戻る",
      "PAGINATION_NEXT": "次へ"
    },
    "hotjarSurveys": {
      "FEEDBACK_MESSAGE": "サービスの改善に役立てるため、ぜひご意見をお寄せください。",
      "THANK_YOU_MESSAGE": "ありがとうございます。今後も皆様の体験をより良いものにするよう努めてまいります。"
    },
    "general": {
      "NEED_HELP_QUESTION": "お困りですか？",
      "CONTACT": "お問い合わせください：",
      "HELP_EMAIL": "help@quantified.ai",
      "PARENT_ACCOUNT": "親アカウント",
      "ACCOUNT": "アカウント",
      "CHECKMARK": "チェックマーク",
      "ICON": "アイコン",
      "ALERT": "アラート",
      "HEADS_UP": "ご注意",
      "USE_HEADPHONES_FOR_OPTIMAL_AUDIO": "iPadで最適な音質をお楽しみいただくには、ヘッドフォンをご使用ください。",
      "SETTINGS": "設定",
      "RP": "RP",
      "EMAIL_LABEL": "メールアドレス",
      "RAVEN_EMAIL": "Raven@InspireHR.com",
      "TEAM_MANAGER_FOR": "担当チームマネージャー",
      "MIAMI_SALE": "マイアミ営業部",
      "CHARLOTTE_SALES": "シャーロット営業部",
      "ATLANTA_SALES": "アトランタ営業部",
      "TEAM": "チーム",
      "ASSIGNMENTS": "課題",
      "MY_TEAMS": "マイチーム",
      "REPORTING": "レポート",
      "DASHBOARD": "ダッシュボード",
      "LEADERBOARD": "リーダーボード",
      "PERSONALIZED_PRACTICE": "パーソナライズされた練習",
      "HELP_SEARCH_OUR": "検索する",
      "HELP_OR_REACH_OUT_TO": "または、お問い合わせ",
      "HELP_WITH_QUESTIONS": "ください",
      "KNOWLEDGE_BASE": "ナレッジベース",
      "NO_ROLE_WEB_MESSAGE": "このユーザーには、システムへのアクセス権限が設定されていません。システム管理者にお問い合わせください。",
      "NO_ROLE_IOS_TITLE": "当社のアプリは、学習者の体験を重視しています",
      "NO_ROLE_IOS_BODY_START": "モバイルブラウザで",
      "NO_ROLE_IOS_WEB_APP": "当社のWebアプリに",
      "NO_ROLE_IOS_BODY_END": "アクセスして、追加機能をご利用ください。",
      "HELP_SECTION": "ヘルプ",
      "ABOUT_SECTION": "会社概要",
      "CONTACT_SUPPORT": "サポート",
      "OPEN_WEB_APP": "ウェブアプリを開く",
      "SEARCH_KNOWLEDGE_BASE": "ナレッジベースを検索",
      "PRIVACY_POLICY": "プライバシーポリシー",
      "TERMS_OF_SERVICE": "利用規約",
      "VERSION": "バージョン",
      "LOG_OUT": "ログアウト"
    },
    "dashboard": {
      "ALL": "すべて",
      "IN_COMPLETE": "未完了",
      "COMPLETED": "完了",
      "NO_ASSIGNMENT_TITLE": "課題はありません。",
      "NO_ASSIGNMENT_DETAILS": "完了すべき課題がある場合は、通知が届きます。",
      "IN_COMPLETE_ASSIGNMENT_TITLE": "未完了の課題はありません。",
      "IN_COMPLETE_ASSIGNMENT_DETAILS": "新しい課題の期限になると、通知が届きます。",
      "COMPLETED_ASSIGNMENT_TITLE": "完了した課題はありません。",
      "COMPLETED_ASSIGNMENT_DETAILS": "課題を完了したときに再度確認してください。",
      "NO_ASSIGNMENT_FILTERED_TITLE": "課題が見つかりませんでした。",
      "NO_ASSIGNMENT_FILTERED_DETAILS": "利用可能な課題を表示するためにフィルタ設定を調整するか、後ほど新しい課題が追加されたときに再度確認してください。",
      "VIEW_ASSIGNMENT": "課題を表示",
      "VIEW_PATHWAY": "パスウェイを表示",
      "START_PATHWAY": "パスウェイを開始",
      "GET_STARTED": "はじめに",
      "ASSIGNMENT_LABEL": "課題",
      "MODULE_ASSIGNMENT_ALT": "モジュールの課題アイコン",
      "VIEW_ASSIGNMENT_FOR": "次の課題を表示：",
      "DAY": "日",
      "DAYS": "日",
      "UNTILL_DUE": "で期限",
      "PAST_DUE": "期限を経過",
      "AVAILABLE_IN": "利用可能：",
      "DUE_TODAY": "期限が今日",
      "PRACTICE": "練習",
      "CERTIFICATION": "認定",
      "UPCOMING": "まもなく実施",
      "TEST_ASSIGNMENT": "テスト課題",
      "CLOSED": "終了しました",
      "ENDED": "終了",
      "TOTAL": "合計",
      "ASSIGNMENT_STATUS_LABEL": "課題のステータス",
      "ASSIGNMENT_STATUS_SELECTION_LABEL": "課題のステータス：",
      "STATUS_SELECTION_LABEL": "ステータス：",
      "ASSIGNMENT_TYPE": "課題の種類",
      "ASSIGNMENT_TYPE_SELECTION_LABEL": "課題の種類：",
      "NOT_STARTED": "未開始",
      "CERTIFIED": "認定済み",
      "NOT_CERTIFIED": "未認定",
      "IN_PROGRESS": "進行中",
      "PATHWAY": "学習パスウェイ",
      "SELECT_ALL": "すべて選択",
      "DESELECT_ALL": "すべて選択解除",
      "CLEAR_STATUS": "ステータスをクリア",
      "OTHERS_SINGULAR": "および、さらに1つ",
      "OTHERS_PLURAL": "および、さらに{{ count }}つ"
    },
    "cognito": {
      "INVITATION_SUBJECT": "Quantifiedへようこそ！",
      "INVITATION_MESSAGE": "ご登録いただき、誠にありがとうございます。まずは、アカウントに初めてログインするために、以下の手順に従ってください。",
      "ACCOUNT_DETAILS": "アカウント情報：",
      "USERNAME": "ユーザー名",
      "PASSWORD": "仮パスワード",
      "STEPS_LABEL": "ログインの手順",
      "STEP_1": "1.下の「ログイン」ボタンをクリックして、ログインページへ進んでください。",
      "STEP_2": "2.上記のユーザー名と仮パスワードを入力してください。",
      "STEP_3": "3.ログイン後、新しいパスワードの設定を求められます。",
      "LOGIN_BUTTON": "ログイン",
      "ABOUT_US": "Quantifiedのシミュレーターは、顧客とのつながりを深め、より効果的にコミュニケーションを図るために必要なスキルを迅速に身につけられるよう設計された仮想環境です。",
      "EXPIRY_TIME": "この仮パスワードは24時間有効です。ログインに問題がある場合は、次のサポートチームまでご連絡ください：",
      "TEAM": "Quantifiedチーム",
      "INVITATION_SMS_USERNAME": "あなたのユーザー名：",
      "INVITATION_SMS_PASSWORD": "仮パスワード：",
      "AUTHENTICATION_CODE": "認証コード：",
      "PASSWORD_RESET_CODE": "Quantifiedのパスワードリセットコード",
      "RESET_PASSWORD_EMAIL": "パスワードリセット用メールアドレス",
      "HELLO": "こんにちは",
      "USE_VERIFICATION_CODE": "パスワードのリセットをご依頼いただきました。以下の確認コードを使用して、手続きを完了してください。",
      "VERIFICATION_CODE": "確認コード",
      "NEXT_STEP": "次の手順",
      "RETURN_TO_PATHWAY": "パスウェイのホームに戻る",
      "RESET_PASSWORD_PAGE": "ブラウザのパスワードリセットページに戻ります。",
      "ENTER_VERIFICATION_CODE": "プロンプトが表示されたら、確認コードを入力してください。",
      "CREATE_PASSWORD": "コードの確認が完了したら、指示に従って新しいパスワードを作成してください。",
      "DISREGARD_NOTE": "パスワードのリセットをリクエストしていない場合は、このメールを無視してください。",
      "CONTACT_SUPPORT": "さらにサポートが必要な場合は、サポートチームまでご連絡ください：",
      "HELP_EMAIL": "help@quantified.ai",
      "THANK_YOU": "ありがとうございます",
      "QUANTIFIED_TEAM": "Quantifiedチーム",
      "ADDRESS": "4200 Marathon Blvd, Suite 210, Austin, Texas 78756, United States"
    },
    "call": {
      "LOADING": "読み込み中",
      "SIMULATION_PAUSED": "シミュレーションが一時停止されました。",
      "CLICK_RESUME": "続行するには、下の「再開」ボタンをクリックしてください。",
      "NO_INTERNET": "インターネットに接続されていません",
      "TRY_AGAIN": "接続状態を確認し、もう一度お試しください。",
      "MIC_MUTED": "マイクがミュートされています",
      "MIC_MUTED_DESCRIPTION": "おっと、マイクがミュートになっているようです。応答して続行するには、ミュートを解除してください。",
      "NO_RESPONSE": "応答が検出されませんでした",
      "MIC_NOT_CONNECTED": "おっと、マイクが接続されていないようです。応答して続行するには、デバイスを再選択してください。",
      "AUDIO_ISSUE": "おっと、何か問題が発生しました。デバイスの設定を確認し、周囲の雑音のない静かな場所にいることを確認してください。",
      "LOADING_ALT": "読み込み中…",
      "REPEAT_RESPONSE": "回答をやり直して再挑戦するために、自動的にシミュレーションに戻ります。",
      "NEEDS_MORE_TIME_QUESTION": "はもう少し時間が必要です。待っていただけますか？",
      "NEEDS_MORE_TIME": "はもう少し時間が必要です。",
      "WAIT_OR_END_CALL": "準備ができ次第お知らせします。または、通話を終了して",
      "RETURN_TO_ASSIGNMENTS": "課題に戻ることができます。",
      "READY": "準備完了",
      "IS_READY": "は会話を続ける準備ができています。",
      "TRY_AGAIN_LABEL": "再挑戦",
      "CHECK_SETTINGS": "設定を確認",
      "PAUSED_SIMULATION": "このシミュレーションを一時停止しました。",
      "PAUSED_SIMULATION_DESCRIPTION": "シミュレーションが再開されるまで、ビデオと音声の録画は一時停止されます。",
      "RESUME": "再開",
      "SETTINGS": "設定",
      "CAPTURING_RESPONSE": "回答の記録",
      "TOUR_MESSAGE": "話し終えたら、必ず「続行」ボタンをクリックして、回答が記録され、採点されるようにしてください。",
      "NEXT": "次へ",
      "START_CALL": "開始",
      "END_CALL_TITLE": "このシミュレーションを終了してもよろしいですか？",
      "END_CALL_DESCRIPTION": "今シミュレーションを終了すると、会話に関するスコアやフィードバックは受け取れません。",
      "END_CALL": "終了する",
      "BROWSER_ACCESS_DENIED": "お使いのブラウザはこのデバイスへのアクセスが拒否されています。",
      "COPY_SESSION_ID_BUTTON": "セッションIDをコピー",
      "RECONNECTING_AUDIO": "音声を再接続しています…",
      "TIPS_GUIDANCE_MESSAGE": "会話の要点やヒントがここに表示されます。",
      "CONTINUE": "続行",
      "SESSION_ID_LABEL": "セッションID：",
      "SESSION_ID_COPIED": "セッションIDがコピーされました！",
      "HINTS_AND_SUGGESTIONS_TITLE": "ヒントと提案",
      "HINT_LABEL": "ヒント",
      "CAPTIONS_LABEL": "キャプション",
      "PAUSE_LABEL": "一時停止",
      "VIDEO_LABEL": "ビデオ",
      "PARTY_EMOJI": "パーティーの絵文字",
      "CALL_ENDED_MESSAGE": "このシミュレーションはすべて終了しました。",
      "CALL_ENDED_INACTIVITY": "操作がないため、このシミュレーションは終了しました",
      "CALL_ENDED_GENERIC": "このシミュレーションは終了しました",
      "FEEDBACK_PROMPT": "結果の処理中に、フィードバックをお寄せください。",
      "INTERACTION_THRESHOLD_NOT_MET": "採点に必要なインタラクションの閾値に達しませんでした。もう一度お試しください。",
      "REALISTIC_CONVERSATION_QUESTION": "この会話は、リアルで自然な感じでしたか？",
      "KNOWLEDGEABLE_PREPARED_QUESTION": "このシミュレーションを通じて、知識が深まり、準備が整ったと感じますか？",
      "FEEDBACK_THANK_YOU": "フィードバックをいただき、ありがとうございます！",
      "FEEDBACK_IMPROVEMENT_NOTE": "フィードバックをいただき、ありがとうございます！体験の向上に努めてまいります。",
      "AUDIO": "音声",
      "MUTE": "ミュート",
      "UNMUTE": "ミュート解除",
      "VISUAL_AID_LOAD_ERROR": "視覚的資料を読み込めませんでした",
      "BEGIN_CALL": "開始",
      "LEAVE_STEP_TITLE": "このステップを終了してもよろしいですか？",
      "EXIT": "終了",
      "LEAVE_CALL_BRIEFING": "ブリーフィングを終了",
      "RESTORE_CALL": "シミュレーションを復元",
      "FEW_SECONDS": "数秒かかる場合があります。",
      "CHECK_ALT": "チェック",
      "COPY_ALT": "コピー",
      "HINTS_ALT": "ヒント",
      "CLOSE_CAPTIONS": "クローズドキャプション",
      "MICROPHONE_MUTED": "マイクはミュートになっています",
      "RETURN_TO_CALL": "シミュレーションに戻る",
      "YES": "はい",
      "NO": "いいえ",
      "VIEW_RESULTS": "結果を表示",
      "RETURN_TO_ASSIGNMENT": "課題に戻る",
      "HAVING_ISSUES": "接続に問題が発生しています。インターネット接続を確認してから、「OK」をクリックしてください。",
      "OK": "OK",
      "RESULTS_NOT_GENERATED": "申し訳ありませんが、現在結果を生成できません。後ほどもう一度お試しください。",
      "INACTIVITY_ALERT_MESSAGE": "操作がないため、この通話を終了します。アバターに話しかけて続行するか、「通話を終了」を選択して通話を終了してください。",
      "INACTIVITY_DEFAULT_ALERT_TITLE": "この通話は{{secondsUntilHangup}}秒後に終了します",
      "INACTIVITY_SHORT_ALERT_TITLE": "この通話は数秒後に終了します",
      "TELL_YOUR_GENDER_HEADING": "性別をお教えください：",
      "BY_KNOWING_YOUR_GENDER_DESCRIPTION": "性別を知ることで、アバターは適切な文法を使用し、会話をより自然でリアルなものにすることができます。",
      "GENDER_SELECTION": "性別の選択：",
      "SELECT_OPTION": "オプションを選択してください",
      "CONFIRM": "確認",
      "MALE": "男性",
      "FEMALE": "女性",
      "NON_BINARY": "ノンバイナリー／その他",
      "PREFER_NOT_TO_ANSWER": "回答を控える",
      "NON_BINARY_MESSAGE": "ノンバイナリーのジェンダーアイデンティティを理解し、尊重しています。現在の技術的な制約により、デフォルトでは男性代名詞を使用しています。将来的には、あらゆるジェンダーアイデンティティにより適切に対応できるよう、改善に取り組んでおりますので、何卒ご了承ください。ご理解とご協力に感謝いたします。",
      "PREFER_NOT_TO_ANSWER_MESSAGE": "性別を提供しないというご選択を尊重いたします。その場合、現在の技術的制約により、当システムではデフォルトで男性代名詞が使用されます。",
      "DISPLAY_VISUAL_AID": "視覚的資料を表示",
      "FULL_SCREEN": "全画面表示",
      "COLLAPSE": "折りたたむ",
      "COMPLETED_CONVERSATION_MESSAGE": "この会話を完了していただき、ありがとうございます",
      "CONVERSATION_COMPLETION_FEEDBACK": "会話の処理中に、フィードバックをお寄せください。",
      "ERROR_MESSAGE": "エラーが発生しました。次までお問い合わせください：",
      "SAVED_CONVERSATION_MESSAGE": "会話内容は保存されました。",
      "RETURN_TO_MY_ASSIGNMENTS": "課題一覧に戻る",
      "RETURN_TO_PERSONALIZED_PRACTICE": "パーソナライズされた練習に戻る",
      "CERT_ACK_TITLE": "認定動画の確認",
      "CERT_ACK_ACCEPT_AND_BEGIN": "同意して開始",
      "CERT_ACK_RESUME_CALL": "通話を再開",
      "CERT_ACK_PROCESSING": "処理中…",
      "CERT_ACK_CAMERA_WARNING": "認定手続きを進めるには、カメラを有効にしてください。",
      "CERT_ACK_CAMERA_OFF_DURING_CALL": "カメラがオフになっています。カメラを再度オンにして、認定を再開してください。",
      "CERT_ACK_TEXT_1": "この認定の完全性と公平性を確保するため、セッション中はカメラをオンにしたままにしてください。また、セッションは監視されます。この要件は、すべての認定基準への準拠を確認するためのものです。",
      "CERT_ACK_TEXT_2": "続行することにより、これらの要件を確認し、同意したものとみなされます。",
      "CERT_ACK_END_CALL": "通話を終了",
      "LAUNCH_SIMULATION": "シミュレーションを開始",
      "DEBRIEF_LATEST_SESSION": "直近のセッションの振り返り",
      "END": "終了する",
      "START_DEBRIEF": "直近のセッションの振り返り",
      "MOVE_TO_NEXT": "次のステップへ進む",
      "RETRY_ROLEPLAY": "ロールプレイに再挑戦",
      "EXIT_PATHWAY": "パスウェイを終了",
      "PROCESSING": "処理中…",
      "FEEDBACK_PROMPT_REQUIRED": "結果を確認する前に、フィードバックを残してください。",
      "SCREENSHARE_LABEL": "画面を共有",
      "SCREENSHARE_UNSUPPORTED_TITLE": "{{callName}}は画面共有を使用しています",
      "SCREENSHARE_UNSUPPORTED_MESSAGE_APP": "通話を続けるには、ブラウザではなく当社のアプリをご利用ください。",
      "SCREENSHARE_UNSUPPORTED_MESSAGE_DESKTOP": "通話を続けるには、デスクトップパソコンからアクセスしてください。",
      "SCREENSHARE_UNSUPPORTED_CLOSE_BUTTON": "閉じる",
      "SCREENSHARE_UNSUPPORTED_GO_TO_APP_BUTTON": "アプリへ移動",
      "SCREENSHARE_UNSUPPORTED_GO_TO_APP_UNAVAILABLE": "モバイルアプリはまだご利用いただけません。後ほど再度ご確認ください。",
      "SCREENSHARE_STOP_LABEL": "画面共有を中止する",
      "SCREENSHARE_PIP_REOPEN_LABEL": "動画プレビューを再度開く",
      "SCREENSHARE_ACTIVE_LABEL": "現在、画面を共有しています",
      "SCREENSHARE_OS_PERMISSION_HINT": "画面共有を開始できませんでした。「システム設定」＞「プライバシーとセキュリティ」で、お使いのブラウザの「画面録画」を有効にしてから、もう一度お試しください。",
      "SCREENSHARE_SAFARI_BLOCKED_HINT": "Safariによって、このセッションの画面共有がブロックされました。一度ログアウトして再度ログインし、もう一度お試しください。"
    },
    "assignment": {
      "STATUS": "ステータス",
      "SCORE": "スコア",
      "MUST_ACHIEVE": "次のスコア",
      "OR_HIGHER": "点以上で完了",
      "TEST": "テスト",
      "OUT_OF_5": "/ 5点中",
      "LATEST_ATTEMPT": "直近のテスト結果",
      "TOTAL_ATTEMPTS": "総テスト回数",
      "UNLIMITED": "無制限",
      "REMAINING": "残り",
      "VIEW_CALL_DETAILS": "詳細を表示",
      "MAX_ATTEMPTS_REACHED": "試行回数が上限に達しました",
      "DUE_DATE": "期限",
      "DAYS": "日",
      "DAY": "日",
      "UNTILL_DUE": "で期限",
      "PAST_DUE": "期限を経過",
      "ONGOING": "継続中",
      "SCORE_REQUIREMENT": "スコア要件",
      "SCORE_REQUIREMENT_DETAIL": "必須の各シミュレーションを完了するには、",
      "TO_COMPLETE_EACH_CALL": "のスコアを達成する必要があります。",
      "CALLS_IN_ASSIGNMENT": "課題に含まれるシミュレーション",
      "INCOMPLETE_CALL": "未完了",
      "PREVIOUS_RESULTS": "過去の結果",
      "DATE": "日付",
      "RESULTS": "結果",
      "VIEW_PREVIOUS_RESULTS": "過去の結果を表示",
      "VIEW_FEEDBACK": "フィードバックを表示",
      "LAUNCH_CALL": "起動",
      "CLOSE_BUTTON": "閉じるボタン",
      "CHECKMARK": "チェックマーク",
      "CALL": "通話",
      "QUESTION": "質問",
      "COMPLETED": "完了",
      "IN_PROGRESS": "進行中",
      "NOT_STARTED": "未開始",
      "CERTIFIED": "認定済み",
      "GUIDED": "ガイド付き",
      "CONVERSATIONAL": "会話型",
      "GUIDED_SIMULATION": "知識の確認",
      "CONVERSATIONAL_SIMULATION": "ロールプレイ",
      "NO_ATTEMPTS_LEFT": "テスト回数の残りなし",
      "NO_ATTEMPTS": "挑戦回数なし",
      "OVERVIEW": "概要",
      "ABOUT_THE_AVATAR": "アバターについて",
      "SCORING_CRITERIA": "採点基準",
      "SIMULATION_OVERVIEW": "シミュレーションの概要",
      "ABOUT_THE_PERSONA": "ペルソナについて",
      "OUTOF_COMPLIANCE": "コンプライアンス違反",
      "CLOSED": "終了しました",
      "COMPLETED_CALLS": "通話を完了"
    }
  },
  "it": {
    "root": {
      "ADMIN_PORTAL": "PORTALE AMMINISTRATIVO",
      "SUPPORT": "ASSISTENZA",
      "U": "U",
      "USER": "Utente",
      "LOGOUT": "Esci",
      "ADMIN": "Amministratore",
      "SUPPORT_SMALL": "Assistenza",
      "QUANTIFIED_AI": "Quantified.AI",
      "MICROPHONE": "MICROFONO",
      "CAMERA": "TELECAMERA",
      "ACCESS_DENIED": "ACCESSO_NEGATO"
    },
    "teams": {
      "MY_TEAMS": "I miei team",
      "COMPLETED": "Completato",
      "IN_PROGRESS": "In corso",
      "NOT_STARTED": "Non iniziato",
      "ASSIGNMET_MODULE": "Modulo incarico",
      "START_DATE": "Data di inizio",
      "DUE_DATE": "Data di scadenza",
      "ASSIGNED_MEMBERS": "Membri con incarichi",
      "CALLS_IN_MODULE": "Simulazioni nel modulo",
      "COMPLETION_REQUIRMENT": "Requisito di completamento",
      "COMPLETE_ALL_CALLS": "Completa tutte le simulazioni con un punteggio di",
      "OR_HIGHER": "o superiore",
      "PROGRESS_OVERVIEW": "PANORAMICA DEI PROGRESSI",
      "TEAM_MEMBERS": "membri del team",
      "AVERAGE_HIGH_SCORE": "Punteggio medio alto",
      "AVERAGE_NUMBER_ATTEMPTS_CALL": "Numero medio di tentativi per simulazione",
      "TOTAL_PRACTICES": "Totale esercitazioni",
      "INDIVIDUAL_CALL_PROGRESS": "PROGRESSO DELLA SIMULAZIONE INDIVIDUALE",
      "OF_TEAM_MEMBERS": "dei membri del team completate",
      "AVERAGE_PRACTICES_TO_COMPLETION": "Media esercitazioni da completare",
      "TEAM_MEMBER_DETAILS": "DETTAGLI DEI MEMBRI DEL TEAM",
      "DOWNLOAD_ACTIVITY_REPORT": "Scarica il report attività",
      "TEAM_MEMBER": "Membro del team",
      "PROGRESS": "Avanzamento",
      "CALLS_COMPLETED": "Simulazioni completate",
      "PRACTICES": "Sessioni di esercitazione",
      "MOST_RECENT_PRACTICE": "Sessione più recente",
      "THIS_TEAM_HAS_NO_ACTIVE_ASSIGNMENTS": "Questo team non ha incarichi attivi al momento",
      "CALL_NAME_LABEL": "Nome simulazione",
      "HIGHEST_SCORE": "Punteggio più alto"
    },
    "simulationBuilder": {
      "THRESHOLD": "Soglia",
      "TYPE": "Tipo",
      "SELECT_AN_OPTION": "Seleziona un'opzione",
      "CORRECT_FEEDBACK": "Feedback corretto",
      "INCORRECT_FEEDBACK": "Feedback errato",
      "CORRECT_FEEDBACK_PLACEHOLDER": "Visualizzato quando lo studente risponde in modo corretto",
      "INCORRECT_FEEDBACK_PLACEHOLDER": "Visualizzato quando lo studente risponde in modo errato",
      "ENTER_MESSAGE_TEXT": "Inserisci il testo del messaggio...",
      "DELETE": "Elimina",
      "SCORABLE": "Valutabile",
      "MESSAGE_NUMBER": "Messaggio {{ index }}",
      "SEARCH_BY_SIMULATION_NAME": "Ricerca per nome simulazione",
      "SEARCH_BY_ASSIGNMENT_NAME": "Ricerca per nome incarico",
      "SIMULATION_STATUS_PLACEHOLDER": "Stato di simulazione",
      "SIMULATION_STATUS_PREFIX": "Stato di simulazione:",
      "NO_SIMULATIONS_FOUND": "Nessuna simulazione trovata",
      "SELECT_ALL": "Seleziona tutto",
      "DESELECT_ALL": "Deseleziona tutto",
      "STATUS_TESTING": "Test",
      "STATUS_DRAFT": "Progetto",
      "STATUS_PUBLISHED": "Pubblicato",
      "STATUS_ARCHIVED": "Archiviato",
      "ASSIGNEES_ZERO_STATE_MESSAGE": "Nessun utente è stato ancora assegnato",
      "ADD_USERS_TO_ASSIGNMENT": "Aggiungere utenti all'assegnazione",
      "NO_DATA_FOUND": "Nessun dato trovato",
      "NO_USERS_SELECTED": "Nessun utente selezionato",
      "COL_FIRST_NAME": "Nome",
      "COL_LAST_NAME": "Cognome",
      "COL_EMAIL": "Email",
      "COL_VIEW_USER": "Visualizza utente",
      "COL_VIEW_ASSIGNMENT": "Visualizza l'incarico",
      "COL_ASSIGNMENT_NAME": "Nome dell'incarico",
      "COL_STATUS": "Stato",
      "COL_TEAM_ASSOCIATIONS": "Associazioni di team",
      "COL_REPORTING_STATUS": "Stato delle segnalazioni",
      "BREADCRUMB_USERS": "Utenti",
      "STATUS_STAGED": "Messa in scena",
      "STATUS_ACTIVE": "Attivo",
      "STATUS_ENDED": "Terminato",
      "STATUS_CLOSED": "Chiuso",
      "SEARCH_USERS_PLACEHOLDER": "Cerca utenti",
      "NO_USERS_FOUND": "Nessun utente trovato",
      "USERS_TAB_LABEL": "Utenti",
      "ADD_TO_ASSIGNMENT": "Aggiungi all'incarico",
      "ASSIGNMENTS_COUNT": "Incarichi",
      "REPORTING_EXCLUDED": "Esclusi",
      "REPORTING_INCLUDED": "Incluso",
      "KEBAB_EDIT_TEAM_ASSOCIATIONS": "Modifica associazioni di team",
      "KEBAB_EXCLUDE_FROM_REPORTING": "Escludi dal report",
      "KEBAB_INCLUDE_IN_REPORTING": "Includi nel report",
      "KEBAB_REMOVE_FROM_ASSIGNMENT": "Rimuovi dall'incarico",
      "NO_TEAMS": "—",
      "TEAMS_COUNT": "{{count}} team",
      "ADD_TO_ASSIGNMENT_MODAL_HEADING": "Aggiungi all'incarico",
      "FIELD_LABEL_ASSIGNMENT": "Incarico",
      "SEARCH_ASSIGNMENTS_PLACEHOLDER": "Ricerca di incarichi",
      "BUTTON_SET_TEAM_ASSOCIATION": "Imposta associazione di team",
      "FIELD_LABEL_TEAM": "Team",
      "SEARCH_TEAM_PLACEHOLDER": "Ricerca per team",
      "BUTTON_BACK": "Indietro",
      "BUTTON_CANCEL": "Annulla",
      "BUTTON_ADD_TO_ASSIGNMENT": "Aggiungi all'incarico",
      "EDIT_TEAM_ASSOCIATIONS_HEADING": "Modifica associazioni di team",
      "EDIT_TEAM_ASSOCIATIONS_DESCRIPTION": "Per l'incarico {{assignmentName}}",
      "BUTTON_SAVE_ASSOCIATIONS": "Salva associazioni",
      "REFERENCE_DOCUMENT_STATUS_UPLOADING": "– Caricamento in corso...",
      "REFERENCE_DOCUMENT_STATUS_SUCCESS": "– Caricamento completato al 100%",
      "REFERENCE_DOCUMENT_STATUS_ERROR": "– Errore di caricamento",
      "CREATE_SIMULATION_DETAILS_BUTTON": "Crea dettagli simulazione",
      "SELF_AUTHORING_DESCRIPTION": "Per iniziare, inserisci un nome, una breve descrizione dello scenario ed eventuali documenti specifici relativi alla simulazione",
      "CLICK_TO_UPLOAD": "Clicca per caricare",
      "OR_DRAG_AND_DROP": "oppure trascina qui i file",
      "REFERENCE_DOCUMENTS_UPLOAD_DESCRIPTION": "PDF (max. 50 MB)",
      "ASSIGNMENT_NAME_LABEL": "Nome incarico*",
      "SIMULATION_NAME_LABEL": "Nome simulazione",
      "NAME_FIELD_DESCRIPTION": "Questo nome può essere modificato in seguito",
      "PRODUCT_LABEL": "Prodotto",
      "SELECT_A_PRODUCT_PLACEHOLDER": "Seleziona un prodotto",
      "ADD_NEW_PRODUCT": "Aggiungi un nuovo prodotto",
      "SCENARIO_LABEL": "Scenario",
      "REFERENCE_DOCUMENTS_LABEL": "Documenti di riferimento",
      "ACTION_CREATE_NEW": "Crea nuovo",
      "ACTION_CREATE": "Crea",
      "ACTION_DUPLICATE": "Duplica",
      "ENTITY_TYPE_SIMULATION_DISPLAY": "Simulazione",
      "ENTITY_TYPE_ASSIGNMENT_DISPLAY": "Incarico",
      "ENTITY_TYPE_SIMULATION_LOWER": "simulazione",
      "ENTITY_TYPE_ASSIGNMENT_LOWER": "incarico",
      "MODAL_TITLE": "{{ action }} {{ type }}",
      "CONFIRM_BUTTON_LABEL": "{{ action }} {{ type }}",
      "DUPLICATE_NAME_ERROR_ASSIGNMENT": "Esiste già un incarico con lo stesso nome.",
      "DUPLICATE_NAME_ERROR_SIMULATION": "Esiste già una simulazione con lo stesso nome.",
      "NAME_REQUIRED_ERROR": "Il nome è obbligatorio.",
      "COPY_OF_PREFIX": "Copia di - {{ name }}",
      "SCORE_DISTRIBUTION_TITLE": "Distribuzione attuale dei punteggi",
      "EDIT_SECTIONS_AND_WEIGHTING": "Modifica sezioni e ponderazione",
      "SCORING_WEIGHTS_TITLE": "Configura il sistema di punteggio",
      "SCORING_WEIGHTS_DESCRIPTION": "Scegli quali aree valutare e in che misura ciascuna contribuisce al punteggio complessivo. La somma della ponderazione di ciascuna sezione abilitata deve essere pari al 100%. La sezione delle competenze non può avere una ponderazione superiore al 20%.",
      "SCORING_WEIGHT_REQUIRED": "Obbligatoria",
      "REFERENCE_DOCUMENT_STATUS_DELETING": "- Eliminazione in corso...",
      "REFERENCE_DOCUMENT_DELETE_ERROR": "Impossibile eliminare il documento. Riprova.",
      "REFERENCE_DOCUMENT_UPLOAD_ERROR": "Impossibile caricare il documento. Riprova.",
      "CONTENT_LIMIT_EXCEEDED_ERROR": "Limite di contenuti superato. Rimuovi uno o più documenti per continuare.",
      "LAST_FACT_DELETE_WARNING_HEADING": "Desideri eliminare l'ultimo elemento?",
      "LAST_FACT_DELETE_WARNING_DESCRIPTION": "L'eliminazione dell'ultimo elemento, che tornerà in stato di \"Bozza\", comporta la rimozione di tutte le associazioni degli utenti a questa simulazione.",
      "LEAVE_CONFIRMATION_HEADING": "Esci dalla creazione della simulazione",
      "LEAVE_CONFIRMATION_DESCRIPTION": "Confermi di voler uscire? Tutti i progressi fatti andranno persi.",
      "LEAVE_CONFIRMATION_LEAVE_BUTTON": "Esci",
      "METHODOLOGY_TITLE": "Metodologia",
      "METHODOLOGY_SUBTITLE": "Valuta l'approccio e la struttura della chiamata",
      "METHODOLOGY_WEIGHTING_LABEL": "Ponderazione: {{ weight }}%",
      "METHODOLOGY_RUBRIC_LABEL": "Criteri di valutazione della metodologia",
      "SELECT_RUBRIC_PLACEHOLDER": "Seleziona criteri di valutazione",
      "SKILLS_TITLE": "Competenze",
      "SKILLS_SUBTITLE": "Valuta la comunicazione e le competenze trasversali",
      "SKILLS_WEIGHTING_LABEL": "Ponderazione: {{ weight }}%",
      "SKILLS_RUBRIC_LABEL": "Criteri di valutazione delle competenze",
      "PROCESSING_DOCUMENTS_MESSAGE": "Elaborazione documenti in corso...",
      "PROCESSING_DOCUMENTS_SUPPORTING_TEXT": "Non esitare a prenderti una pausa: i risultati saranno pronti nei prossimi 5 minuti.",
      "CORE_SIGNAL_MESSAGE": "Analisi dei contenuti in corso...",
      "SECTION_PLAN_MESSAGE": "Pianificazione della struttura della simulazione in corso...",
      "DERIVED_COMPONENT_MESSAGE": "Creazione dei componenti della simulazione in corso...",
      "COMPONENT_WAVE_1_MESSAGE": "Stesura dei contenuti della simulazione in corso...",
      "STILL_PROCESSING_TITLE": "Elaborazione ancora in corso...",
      "STILL_PROCESSING_BODY": "L'operazione sta richiedendo più tempo del previsto: puoi uscire da questa simulazione e riaprirla più tardi dalla schermata di elenco delle simulazioni.",
      "PROCESSING_FAILED_TITLE": "Elaborazione non riuscita",
      "PROCESSING_FAILED_BODY": "Si è verificato un errore durante l’elaborazione dei tuoi documenti. Riprova. Mettiti in contatto con ",
      "TEST_SIMULATION_BUTTON": "Testa la simulazione",
      "SIMULATION_PROCESSED_TITLE": "Documenti elaborati",
      "SIMULATION_PROCESSED_BODY": "I documenti della simulazione sono stati elaborati.",
      "SIMULATION_DOCUMENTS_PROCESSED_TITLE": "Documenti della simulazione elaborati.",
      "SIMULATION_DOCUMENTS_PROCESSED_BODY": "I documenti caricati per la simulazione {{ name }} sono stati elaborati.",
      "SIMULATION_DOCUMENTS_FAILED_TITLE": "Elaborazione dei documenti della simulazione non riuscita.",
      "SIMULATION_DOCUMENTS_FAILED_BODY": "Non è stato possibile elaborare i documenti che hai caricato per la simulazione {{ name }}.",
      "DISMISS": "Ignora",
      "VIEW_SIMULATION": "Visualizza simulazione",
      "FACT_MESSAGE_LABEL": "Messaggio",
      "FACT_MESSAGE_DESCRIPTION": "I messaggi devono contenere un'unica informazione ed essere formulati come una frase completa. Il messaggio deve essere specifico, semplice e circoscritto. Evita, quindi, formulazioni che potrebbero risultare incomplete.",
      "FACT_INCORRECT_ANSWER_LABEL": "Testo della risposta errata",
      "FACT_INCORRECT_ANSWER_DESCRIPTION": "Il testo mostrato allo studente se interpreta questo elemento in modo errato ",
      "SHOW_INCORRECT_ANSWER_TEXT": "Mostra un testo alternativo per le risposte errate",
      "ADD_NEW_FACT": "Aggiungi nuovo elemento",
      "FACT_SINGULAR": "elemento",
      "FACT_PLURAL": "elementi",
      "FACT_EXTRACTED_SINGULAR": "{{ count }} elemento estratto",
      "FACT_EXTRACTED_PLURAL": "{{ count }} elementi estratti",
      "REVIEW_REQUIRED_LABEL": "Rivedi i suggerimenti",
      "MESSAGING_TITLE": "Messaggistica",
      "MESSAGING_SUBTITLE": "Valuta se gli elementi chiave sono stati espressi",
      "COMPONENT_WAVE_2_MESSAGE": "Ottimizzazione dei contenuti della simulazione in corso...",
      "COMPONENT_WAVE_3_MESSAGE": "Completamento dei contenuti della simulazione in corso...",
      "MESSAGE_ADHERENCE_MESSAGE": "Suggerimento di criteri di valutazione dei messaggi...",
      "ASSEMBLING_MESSAGE": "Caricamento della simulazione in corso...",
      "PROCESSING_FAILED_SUFFIX": " se il problema persiste.",
      "BUTTON_RETRY": "Riprova",
      "TOKEN_LIMIT_EXCEEDED_BODY_PREFIX": "Limite di contenuti superato. Rimuovi uno o più documenti e riprova oppure contatta ",
      "TOKEN_LIMIT_EXCEEDED_BODY_SUFFIX": " se il problema persiste.",
      "AVATAR_LOOK_LABEL": "Aspetto",
      "AVATAR_SELECT_PLACEHOLDER": "Seleziona avatar",
      "AVATAR_VOICE_LABEL": "Voce",
      "AVATAR_ALT": "Avatar",
      "PLAY_VOICE_PREVIEW_BUTTON": "Riproduci anteprima vocale",
      "VOICE_OPTION_1": "Voce 1",
      "VOICE_OPTION_2": "Voce 2",
      "BACK_TO_SIMULATION_DETAILS_BUTTON": "Torna ai dettagli simulazione",
      "AVATAR_SELECTION_TITLE": "Selezione avatar",
      "VIEW_DOCUMENTS": "Visualizza documenti",
      "SELECT_AVATAR_BUTTON": "Seleziona avatar",
      "REQUEST_CHANGES_PLACEHOLDER": "Richiedi eventuali modifiche alle informazioni sopra riportate",
      "CALL_DETAILS_LOAD_ERROR": "Non è stato possibile caricare i dettagli della chiamata. Riprova.",
      "FACTS_CANNOT_BE_EMPTY": "Gli elementi non possono essere vuoti. Aggiungi un messaggio a ogni elemento prima di testarlo o pubblicarlo.",
      "FINISHING_SIMULATION_MESSAGE": "Conclusione della simulazione in corso...",
      "BLANK_THEME_MESSAGE_TOOLTIP": "Aggiungi del testo al messaggio vuoto prima di aggiungere un nuovo tema.",
      "BLANK_MESSAGE_TOOLTIP": "Aggiungi del testo a questo messaggio prima di aggiungerne un altro.",
      "ADD_NEW_THEME_BUTTON": "Aggiungi nuovo tema",
      "ADD_THEME_BUTTON": "Aggiungi tema",
      "ADD_MESSAGE_BUTTON": "Aggiungi messaggio",
      "SCORE_LAST_SESSION": "Valuta la mia ultima sessione",
      "SCORE_LAST_SESSION_MODAL_HEADING": "Valuta l'ultima sessione",
      "SCORE_LAST_SESSION_MODAL_DESCRIPTION": "Prova prima la simulazione, poi torna qui per valutarla in base ai criteri di valutazione selezionati.",
      "SCORE_LAST_SESSION_MODAL_ERROR_HEADING": "Qualcosa è andato storto",
      "SCORE_LAST_SESSION_MODAL_ERROR_DESCRIPTION": "Riprova.",
      "REFINEMENT_THINKING_MESSAGE": "Sto pensando...",
      "REFINEMENT_UPDATED_MESSAGE": "Aggiornamento effettuato",
      "REFINEMENT_WARNING_PREFIX": "Queste informazioni sono state modificate manualmente: contatta",
      "REFINEMENT_WARNING_SUFFIX": "per eventuali aggiornamenti.",
      "REFINEMENT_ERROR_PREFIX": "Purtroppo non posso aiutarti in merito a questa questione, ma forse",
      "REFINEMENT_ERROR_SUFFIX": "può farlo.",
      "REFINEMENT_APPLIED_TITLE": "Modifiche richieste applicate.",
      "REFINEMENT_APPLIED_BODY": "Le modifiche da te richieste per la simulazione {{ name }} sono state applicate.",
      "REFINEMENT_FAILED_TITLE": "Le modifiche richieste non sono andate a buon fine.",
      "REFINEMENT_FAILED_BODY": "Non è stato possibile applicare le modifiche richieste per la simulazione {{ name }}.",
      "WHAT_USERS_SEE_DESCRIPTION_TITLE": "Descrizione simulazione",
      "WHAT_USERS_SEE_DESCRIPTION_HELPER": "Le informazioni aggiornate nella scheda Generale verranno riportate qui, a meno che non vengano effettuati aggiornamenti manuali.",
      "WHAT_USERS_SEE_DESCRIPTION_FIELD_LABEL": "Descrizione",
      "WHAT_USERS_SEE_DETAILS_TITLE": "Dettagli simulazione",
      "WHAT_USERS_SEE_DETAILS_HELPER": "Questo è il contenuto che verrà fornito all'utente prima che inizi la Simulazione. Le informazioni aggiornate nella scheda Generale verranno riportate qui, a meno che non vengano effettuati aggiornamenti manuali. Le sezioni lasciate vuote non verranno mostrate allo studente. Tutte le sezioni supportano la formattazione Markdown.",
      "WHAT_USERS_SEE_OVERVIEW_FIELD_LABEL": "Panoramica della simulazione",
      "WHAT_USERS_SEE_PERSONA_FIELD_LABEL": "Informazioni sulla persona",
      "WHAT_USERS_SEE_SCORING_FIELD_LABEL": "Criteri di valutazione",
      "WHAT_USERS_SEE_SCORING_FIELD_HELPER": "Questa sezione viene compilata in base alle selezioni effettuate nella scheda di valutazione. La modifica delle informazioni in questa sezione non influirà sul modo in cui viene valutata la simulazione.",
      "WHAT_USERS_SEE_PREVIEW_DETAILS_CTA": "Vedi in anteprima la finestra di dialogo dei dettagli della simulazione",
      "WHAT_USERS_SEE_PREVIEW_CARD_CTA": "Visualizza carta simulazione",
      "TAB_GENERAL": "Informazioni generali",
      "TAB_CONTENTS": "Indice",
      "TAB_KEY_WORDS": "Parole chiave",
      "TAB_SCORING": "Punteggio",
      "TAB_TESTING": "Test",
      "TAB_PROMPTS": "Prompt",
      "TAB_WHAT_USERS_SEE": "Cosa vedono gli utenti",
      "ACCURACY_FEEDBACK_TITLE": "Feedback sull'accuratezza",
      "ACCURACY_FEEDBACK_DESCRIPTION": "Valutare l'accuratezza di ogni affermazione del rappresentante rispetto ai documenti caricati",
      "ACCURACY_FEEDBACK_STATUS_ON": "Abilitato",
      "ACCURACY_FEEDBACK_STATUS_OFF": "Off",
      "ACCURACY_FEEDBACK_STATUS_DISABLED": "Disabilitato",
      "ACCURACY_FEEDBACK_NO_DOCUMENTS": "Il punteggio di accuratezza non è disponibile perché non sono stati aggiunti documenti correlati.",
      "SCORING_AI_REVIEW_NOTICE": "Alcuni contenuti di questa scheda sono stati generati dai materiali da te forniti. Verifica l'accuratezza di tutti i contenuti prima di pubblicare questa chiamata.",
      "EXPORT_SIMULATION_SUMMARY_BUTTON": "Esporta il riepilogo della simulazione",
      "CALL": "Chiamata",
      "REFINEMENT_OVERRIDDEN_PREFIX": "Queste informazioni sono state modificate manualmente: contatta",
      "REFINEMENT_OVERRIDDEN_SUFFIX": "per eventuali aggiornamenti.",
      "SUPPORT_EMAIL": "help@quantified.ai",
      "WHAT_USERS_SEE_OVERRIDE_WARNING_TITLE": "La modifica di questi campi bloccherà gli aggiornamenti futuri",
      "WHAT_USERS_SEE_OVERRIDE_WARNING_BODY": "L'aggiornamento manuale di queste sezioni impedirà la ricezione di ulteriori aggiornamenti derivanti dal processo di perfezionamento nella scheda Generale.",
      "WHAT_USERS_SEE_DETAILS_OVERRIDE_EDITED_TITLE": "Questi campi sono stati modificati",
      "WHAT_USERS_SEE_DETAILS_OVERRIDE_EDITED_BODY": "Non riceveranno più gli aggiornamenti di perfezionamento effettuati nella scheda Generale",
      "SIMULATION_BUILDER_HEADING": "Generatore di simulazioni",
      "ASSIGNMENTS_TAB_LABEL": "Incarichi",
      "SIMULATIONS_TAB_LABEL": "Simulazioni",
      "CREATE_NEW_ASSIGNMENT_BUTTON": "Crea nuovo incarico",
      "CREATE_NEW_SIMULATION_BUTTON": "Crea nuova simulazione",
      "NO_ASSIGNMENTS_FOUND": "Nessun incarico trovato",
      "ASSIGNMENT_STATUS_PLACEHOLDER": "Stato dell'incarico",
      "ASSIGNMENT_STATUS_PREFIX": "Stato dell'incarico:",
      "ASSIGNMENT_TYPE_LABEL": "Tipo di incarico",
      "SELECT_ASSIGNMENT_TYPE_PLACEHOLDER": "Seleziona tipo di incarico",
      "NAME_LABEL": "Nome",
      "ASSIGNMENT_NAME_PLACEHOLDER": "Nome dell'incarico",
      "PASSING_SCORE_LABEL": "Punteggio minimo per il superamento",
      "PASSING_SCORE_OPTIONAL_LABEL": "Punteggio minimo per il superamento (facoltativo)",
      "SCORE_MAX_EXCEEDED_ERROR": "Il punteggio non deve superare 5",
      "GET_HELP_BUTTON": "Ottieni assistenza",
      "PASSING_SCORE_TOOLTIP": "Questo valore definisce il punteggio complessivo che uno studente deve raggiungere per superare la simulazione.",
      "DESCRIPTION_LABEL": "Descrizione",
      "ASSIGNMENT_DESCRIPTION_PLACEHOLDER": "Descrizione incarico",
      "MESSAGING_FEEDBACK_LABEL": "Feedback messaggistica",
      "MESSAGING_FEEDBACK_TOOLTIP_HEADING": "Feedback messaggistica",
      "MESSAGING_FEEDBACK_TOOLTIP_BODY": "Quando uno studente formula un messaggio in modo errato, visualizza informazioni su come esprimerlo meglio la volta successiva. Questa impostazione determina se visualizzare o meno tali informazioni.",
      "ENABLED_TEXT": "Abilitato",
      "DISABLED_TEXT": "Disabilitato",
      "PAUSE_BUTTON_LABEL": "Pulsante di pausa",
      "ASSIGNMENT_START_DATE_LABEL": "Data di inizio dell'incarico",
      "SELECT_DATE_PLACEHOLDER": "Seleziona data",
      "ASSIGNMENT_END_DATE_LABEL": "Data di fine incarico",
      "ASSIGNMENT_END_DATE_OPTIONAL_LABEL": "Data di fine incarico (facoltativo)",
      "END_DATE_RANGE_ERROR": "La data di inizio e di fine non possono coincidere",
      "ASSIGNMENT_INFORMATION_TITLE": "Informazioni incarico",
      "ASSIGNMENT_TYPE_CERTIFICATION": "Certificazione",
      "ASSIGNMENT_TYPE_PRACTICE": "Esercitazione",
      "ASSIGNMENT_TYPE_PERSONALIZED_PRACTICE": "Esercitazione personalizzata",
      "BUTTON_SAVE_AND_CLOSE": "Salva e chiudi",
      "BUTTON_ADD_SIMULATIONS": "Aggiungi simulazioni",
      "ATTEMPTS_UNLIMITED": "Illimitato",
      "SEARCH_FOR_SIMULATION_LABEL": "Cerca simulazione",
      "SIMULATION_NAME_PLACEHOLDER": "Nome simulazione",
      "BUTTON_REMOVE_ALL": "Rimuovi tutto",
      "SIMULATIONS_IN_ASSIGNMENT_LABEL": "Simulazioni nell'incarico",
      "BUTTON_ASSIGN_LEARNERS": "Assegna studenti",
      "CALL_TYPE_UNKNOWN": "Sconosciuto",
      "ASSIGNMENT_COUNT_NONE": "Nessuno",
      "ASSIGNMENT_COUNT_SINGULAR": "{{ count }} incarico",
      "ASSIGNMENT_COUNT_PLURAL": "{{ count }} incarichi",
      "ERROR_LOADING_ASSIGNMENTS": "Errore durante il caricamento degli incarichi",
      "SEARCH_ASSIGNEES_TITLE": "Cerca assegnatari",
      "DIALOG_DESCRIPTION_ADD_USERS": "Seleziona gli utenti che parteciperanno all'incarico. La ricerca di un team ti consentirà di assegnare o rimuovere l'assegnazione di utenti specifici a quel team. Ai fini della reportistica, quando selezioni un utente specifico, assicurati che sia associato al team corretto.",
      "ADD_USERS_TO_ASSIGNMENT_HEADING": "Aggiungi utenti all'incarico",
      "BUTTON_REVIEW_SELECTED_USERS": "Rivedi utenti selezionati",
      "FIND_USERS_LABEL": "Trova utenti",
      "BUTTON_CLEAR": "Cancella",
      "LEARNER_COUNT_NONE": "Nessuno",
      "LEARNER_COUNT_SINGULAR": "{{ count }} studente",
      "LEARNER_COUNT_PLURAL": "{{ count }} studenti",
      "ASSIGNMENT_TAB_DETAILS": "Dettagli",
      "ASSIGNMENT_TAB_SIMULATIONS": "Simulazioni",
      "ASSIGNMENT_TAB_ASSIGNEES": "Assegnatari",
      "LOADING_ASSIGNMENT_DETAILS": "Caricamento dei dettagli dell’incarico in corso...",
      "BREADCRUMB_ASSIGNMENTS": "Incarichi",
      "ASSIGNMENTS_COL_NAME": "Nome",
      "ASSIGNMENTS_COL_START_DATE": "Data di inizio dell'incarico",
      "ASSIGNMENTS_COL_END_DATE": "Data di fine incarico",
      "ASSIGNMENTS_COL_LEARNERS": "Studente con incarico assegnato",
      "ASSIGNMENTS_COL_TYPE": "Tipo di incarico",
      "ASSIGNMENTS_COL_STATUS": "Stato dell'incarico",
      "SIMULATIONS_COL_NAME": "Nome",
      "SIMULATIONS_COL_PRODUCT": "Prodotto",
      "SIMULATIONS_COL_DATE_MODIFIED": "Data ultima modifica",
      "SIMULATIONS_COL_STATUS": "Stato",
      "SIMULATIONS_COL_USED_IN": "Utilizzato in",
      "SIMULATIONS_COL_TYPE": "Tipo simulazione",
      "SIMULATIONS_COL_DATE_PUBLISHED": "Data pubblicazione",
      "CONVERSE_PROMPT_LABEL": "Prompt di conversazione",
      "CONVERSE_PROMPT_EXPAND_TO_EDIT": "Espandi per modificare",
      "CONVERSE_PROMPT_ENTER_LABEL": "Inserisci qui il prompt di conversazione *",
      "CONVERSE_PROMPT_EDITING_HEADING": "Modifica del prompt di conversazione",
      "CONVERSE_PROMPT_OVERRIDE_CONFIRMATION_HEADING": "Conferma della sostituzione del prompt",
      "CONVERSE_PROMPT_OVERRIDE_DESCRIPTION": "Confermi di voler sostituire il prompt di conversazione? In caso di sostituzione, gli autori perderanno l'accesso alle opzioni di perfezionamento autonomo.",
      "CONVERSE_PROMPT_FIELD_LABEL": "Prompt di conversazione",
      "CONVERSE_PROMPT_SAVE_BUTTON": "Salva prompt",
      "BUTTON_CONFIRM": "Conferma",
      "DELETE_SIM_HEADING": "Elimina simulazione",
      "DELETE_SIM_CONTENT": "Questa simulazione verrà eliminata. Verranno rimossi anche tutti gli incarichi di prova associati alla simulazione.",
      "DELETE_SIM_LABEL": "Elimina simulazione",
      "DELETE_ASSIGNMENT_HEADING": "Elimina incarico",
      "DELETE_ASSIGNMENT_CONTENT": "Questo incarico verrà eliminato in modo definitivo.",
      "DELETE_ASSIGNMENT_LABEL": "Elimina incarico",
      "DELETE_ASSIGNMENT_NON_STAGED_CONTENT": "Per eliminare un incarico con stato Attivo o Concluso, contatta il team CX. Grazie.",
      "REMOVE_FROM_ASSIGNMENT_HEADING": "Rimuovi dall'incarico",
      "REMOVE_FROM_ASSIGNMENT_CONTENT": "In questo modo l’utente verrà rimosso dall’incarico e da tutti i link associati al team.",
      "REMOVE_FROM_ASSIGNMENT_LABEL": "Rimuovi dall'incarico",
      "PUBLISH_SIMULATION_HEADING": "Pubblica simulazione",
      "PUBLISH_CONTINUE_EDITING": "Continua modifica",
      "PUBLISH_BUTTON": "Pubblica",
      "PUBLISH_SIMULATION_DESCRIPTION": "Il gioco di ruolo potrà essere aggiunto agli incarichi e non sarà più possibile modificare le informazioni relative a persona, punteggio e prompt.",
      "CONFIRMATION_SELECTED_USERS_HEADING": "Utenti selezionati",
      "CONFIRMATION_TOTAL_COUNT": "{{ count }} in totale",
      "CONFIRMATION_CREATE_HEADING": "Crea nuovo incarico",
      "CONFIRMATION_ADD_USERS_HEADING": "Aggiungi utenti all'incarico",
      "CONFIRMATION_SAVE_ASSIGNMENT_BTN": "Salva incarico",
      "CONFIRMATION_REMOVE_USER": "Rimuovi",
      "EDIT_WEIGHTING_HEADING": "Modifica ponderazione punteggi",
      "EDIT_WEIGHTING_DESCRIPTION": "Il punteggio complessivo verrà generato dalla media ponderata delle seguenti sezioni. La somma della ponderazione di ciascuna sezione abilitata deve essere pari al 100%. La sezione delle competenze non può avere una ponderazione superiore al 20%.",
      "EDIT_WEIGHTING_ERROR_ALL_DISABLED": "È necessario abilitare almeno un'azione di valutazione",
      "EDIT_WEIGHTING_ERROR_WEIGHT_RANGE": "La ponderazione della sezione deve essere compresa tra 0 e 100",
      "EDIT_WEIGHTING_ERROR_SKILLS_MAX": "La sezione delle competenze non può avere una ponderazione superiore al 20%",
      "EDIT_WEIGHTING_ERROR_TOTAL": "Il peso totale della sezione deve essere pari al 100%",
      "PERSONA_INFORMATION_TITLE": "Informazioni persona",
      "PERSONA_AVATAR_LABEL": "Avatar *",
      "PERSONA_NAME_LABEL": "Nome *",
      "PERSONA_INITIAL_GREETINGS_LABEL": "Saluti iniziali *",
      "PERSONA_INITIAL_GREETINGS_DESCRIPTION": "La persona inizierà la simulazione con uno di questi saluti. Puoi avere un massimo di 5 opzioni.",
      "PERSONA_ADD_GREETING_OPTION": "Aggiungi opzione di saluto",
      "PERSONA_RESUME_MESSAGE_LABEL": "Riprendi messaggio",
      "PERSONA_RESUME_MESSAGE_DESCRIPTION": "Quando uno studente riprende una simulazione dopo una pausa, la persona inizierà formulando uno di questi saluti. Puoi avere un massimo di 5 opzioni.",
      "PERSONA_ADD_MESSAGE_OPTION": "Aggiungi opzione del messaggio",
      "PERSONA_UPLOADING": "Caricamento in corso...",
      "PERSONA_DELETING": "Eliminazione in corso...",
      "PERSONA_CUSTOM_BG_PREVIEW_ALT": "Anteprima dello sfondo personalizzato",
      "PERSONA_AVATAR_THUMBNAIL_ALT": "Miniatura avatar",
      "PERSONA_AVATAR_WITH_BG_ALT": "Avatar con sfondo personalizzato",
      "PERSONA_PROCESSING_IMAGE": "Elaborazione immagine in corso...",
      "PERSONA_CUSTOM_BACKGROUND_LABEL": "Sfondo personalizzato",
      "PERSONA_REMOVE_BACKGROUND": "Rimuovi sfondo",
      "PERSONA_CLICK_TO_REPLACE": "Clicca per sostituire",
      "PERSONA_UPLOAD_DESCRIPTION": "PNG o JPG, preferibilmente con rapporto di aspetto 16:9, massimo 2 MB",
      "SIM_INFORMATION_TITLE": "Informazioni simulazione",
      "SIM_NAME_FIELD_LABEL": "Nome *",
      "SIM_LANGUAGE_FIELD_LABEL": "Lingua",
      "SIM_DETAILS_SECTION_TITLE": "Dettagli simulazione",
      "SIM_ADDITIONAL_SECTION_TITLE_LABEL": "Titolo sezione aggiuntiva",
      "SIM_ADDITIONAL_SECTION_INFO_LABEL": "Informazioni sezione aggiuntiva",
      "TESTING_SECTION_TITLE": "Tester",
      "TESTING_SEND_ASSIGNMENTS_BTN": "Invia incarichi di test",
      "TESTING_MESSAGING_TOOLTIP": "Aggiungi almeno un dato alla sezione Adesione al messaggio prima di eseguire o di pubblicare il test.",
      "TESTING_DESCRIPTION": "Cerca gli utenti che effettueranno il test della simulazione, quindi invia loro l’incarico del test.",
      "TESTING_COL_NUMBER_OF_ATTEMPTS": "Numero di tentativi",
      "TESTING_COL_DATE_OF_LAST_ATTEMPT": "Data dell'ultimo tentativo",
      "TESTING_CLEAR_USERS": "Cancella utenti",
      "TESTING_REMOVE_ASSIGNEE": "Rimuovi assegnatario",
      "OVERALL_SECTION_TITLE": "Sezioni, pesi e messaggi",
      "OVERALL_HEADING": "Generale",
      "TRANSCRIPT_PROMPT_TITLE": "Prompt trascrizione",
      "TRANSCRIPT_PROMPT_FIELD_LABEL": "Inserisci qui il prompt della trascrizione ripulita",
      "SIMULATION_PROMPTS_TITLE": "Prompt simulazione",
      "TAGS_LABEL": "Tag",
      "CREATE_TAG_OPTION": "Crea {{term}}",
      "TAG_CREATE_ERROR": "Impossibile creare il tag, riprova",
      "EDIT_SIMULATION_TAGS_TITLE": "Modifica tag simulazione",
      "SAVE_TAGS_BUTTON": "Salva tag",
      "CLOSE_BUTTON": "Chiudi",
      "TAG_UPDATE_ERROR": "Impossibile caricare il tag, riprova",
      "SCREEN_SHARE_TITLE": "Condividi schermo",
      "SCREEN_SHARE_DESCRIPTION": "Consente all'utente di condividere il proprio schermo con l'avatar durante la chiamata, in modo che quest'ultimo possa visualizzare e rispondere in base a ciò che viene mostrato",
      "SCREEN_SHARE_STATUS_ON": "Abilitata",
      "SCREEN_SHARE_STATUS_OFF": "Disabilitata",
      "SCREEN_SHARE_NO_PERSONA": "Per abilitare la condivisione dello schermo, aggiungi prima una persona.",
      "HIDE_RESULTS_LABEL": "Nascondi risultati",
      "SEARCH_FIELD_HINT": "Digita almeno tre caratteri per avviare la ricerca",
      "OTHERS_SINGULAR": "e 1 altro",
      "OTHERS_PLURAL": "e altri {{ count }}",
      "PAGINATION_PREVIOUS": "Precedente",
      "PAGINATION_NEXT": "Successiva",
      "SKILLS_RUBRIC_REQUIRED_TOOLTIP": "Allega criteri di valutazione delle competenze. L'opzione Competenze è abilitata con una ponderazione superiore allo 0%.",
      "ENTITY_TYPE_KNOWLEDGE_CHECK_DISPLAY": "controllo delle conoscenze",
      "NAME_MAX_LENGTH_ERROR": "Il nome deve contenere massimo 255 caratteri.",
      "UUID_COPIED_TOAST": "UUID della chiamata copiato negli appunti",
      "MENU_ARCHIVE": "Archivio",
      "MENU_EDIT_SIMULATION_TAGS": "Modifica tag simulazione",
      "MENU_COPY_UUID": "Copia UUID",
      "REFINEMENT_IN_PROGRESS_TOOLTIP": "Perfezionamento in corso. Puoi continuare una volta completata l'operazione.",
      "SIMULATION_DOCUMENTS_PARSE_FAILED_BODY": "Impossibile leggere uno dei tuoi documenti per {{ name }}: controllalo o sostituiscilo. Quindi, riprova.",
      "REFINEMENT_ERROR_MESSAGE": "Siamo spiacenti, impossibile completare questa richiesta. Riprova",
      "REFINEMENT_OUT_OF_SCOPE_TITLE": "Richiesta fuori ambito.",
      "REFINEMENT_OUT_OF_SCOPE_BODY": "La tua richiesta relativa a {{ name }} non rientra nelle funzionalità di perfezionamento. Contatta l'assistenza.",
      "TAB_QUESTIONS": "Domande",
      "KNOWLEDGE_CHECK_NAME_LABEL": "Nome*",
      "AVATAR_APPEARANCE_LABEL": "Aspetto avatar",
      "KNOWLEDGE_CHECK_AVATAR_NAME_LABEL": "Nome avatar",
      "KNOWLEDGE_CHECK_SKILLS_FEEDBACK_TITLE": "Feedback competenze",
      "KNOWLEDGE_CHECK_SCORING_DESCRIPTION": "Le simulazioni di Controllo delle conoscenze vengono valutate in base alla percentuale di punti di risposta trattati per ciascuna domanda. Seleziona uno dei criteri di valutazione delle competenze qui sotto per ricevere anche un feedback qualitativo.",
      "KNOWLEDGE_CHECK_SCORING_RESCORE_DESCRIPTION": "Dopo aver testato la simulazione almeno una volta, seleziona “Valuta la mia ultima sessione” per visualizzare il tuo punteggio. Se modifichi i punti di risposta, puoi ricalcolare il punteggio della stessa sessione. Se modifichi le domande, dovrai svolgere una nuova sessione di test prima di calcolare il punteggio.",
      "KNOWLEDGE_CHECK_SKILLS_RUBRIC_LABEL": "Criteri di valutazione delle competenze (facoltativi)",
      "SIMULATION_TYPE_MODAL_TITLE": "Crea nuova simulazione",
      "SIMULATION_TYPE_MODAL_DESCRIPTION": "Scegli il modo in cui i tuoi studenti posso esercitarsi.",
      "SIMULATION_TYPE_ROLE_PLAY_TITLE": "Gioco di ruolo",
      "SIMULATION_TYPE_ROLE_PLAY_DESCRIPTION": "Gli studenti conversano liberamente con un personaggio IA, che risponde in modo naturale a ogni loro intervento.",
      "SIMULATION_TYPE_ROLE_PLAY_BEST_FOR": "Ideale per esercitarsi in chiamate di vendita realistiche, come presentazioni commerciali e gestione delle obiezioni.",
      "SIMULATION_TYPE_KNOWLEDGE_CHECK_TITLE": "Controllo delle conoscenze",
      "SIMULATION_TYPE_KNOWLEDGE_CHECK_DESCRIPTION": "Un personaggio IA pone agli studenti le domande che hai scritto, nell'ordine che hai stabilito.",
      "SIMULATION_TYPE_KNOWLEDGE_CHECK_BEST_FOR": "Ideale per verificare la conoscenza del prodotto e certificare che i rappresentanti siano pronti.",
      "TAGS_FILTER_LABEL": "Tag",
      "TAGS_FILTER_PLACEHOLDER": "Seleziona un tag",
      "CLEAR_ALL_FILTERS": "Cancella tutti i filtri",
      "LAST_SAVED_LABEL": "Ultimo salvataggio",
      "BUTTON_OK": "Ok",
      "KEYWORDS_RESET_TO_PRODUCT_DEFAULT": "Ripristina impostazioni predefinite del prodotto",
      "KEYWORDS_DETACH_FROM_PRODUCT_DEFAULT": "Scollega dalle impostazioni predefinite del prodotto",
      "KEYWORDS_SAVE_AS_PRODUCT_DEFAULT": "Salva come impostazioni predefinite del prodotto",
      "KEYWORDS_SAVE_AS_DEFAULT_OVERWRITE": "Questa operazione sovrascriverà l'impostazione predefinita {{ keywordTitle }} relativa al prodotto {{ moduleName }}.",
      "KEYWORDS_SAVE_AS_DEFAULT_IMPACT": "Queste parole verranno aggiunte alle nuove simulazioni relative a {{ moduleName }}. La modifica avrà effetto su tutte le chiamate relative al prodotto {{ moduleName }}.",
      "KEYWORDS_ADD_NEW_WORD": "Aggiungi nuova parola",
      "KEYWORDS_FROM_LABEL": "Da",
      "KEYWORDS_TO_LABEL": "A",
      "KEYWORDS_PRONOUNCE_TITLE": "Pronuncia delle parole",
      "KEYWORDS_PRONOUNCE_DESCRIPTION": "Correggi la pronuncia dell'agente IA affinché articoli correttamente nomi e termini. L'agente associa gli errori di pronuncia e le varianti più comuni alla Nuova pronuncia.",
      "KEYWORDS_PRONOUNCE_NAME": "pronuncia delle parole",
      "KEYWORDS_ADD_MISPRONUNCIATION": "Aggiungi pronuncia errata",
      "KEYWORDS_SELECT_PERSONA_NOTICE": "Seleziona una persona per aggiungere parole con una pronuncia specifica.",
      "KEYWORDS_REPLACE_TITLE": "Sostituisci parole",
      "KEYWORDS_REPLACE_DESCRIPTION": "Correzioni esplicite mediante ricerca e sostituzione del testo delle trascrizioni degli utenti. Sostituzioni dirette di parole effettuate prima della correzione fonetica.",
      "KEYWORDS_REPLACE_NAME": "sostituisci parole",
      "KEYWORDS_ADD_REPLACEMENT": "Aggiungi sostituzione",
      "KEYWORDS_STT_TITLE": "Parole per il riconoscimento vocale",
      "KEYWORDS_STT_DESCRIPTION": "Elenco di parole fornito ai fornitori di servizi per il riconoscimento vocale (STT) (ad es. AssemblyAI, Tavus), in particolare per la configurazione del fornitore di servizi per il riconoscimento vocale.",
      "KEYWORDS_STT_NAME": "parole per il riconoscimento vocale",
      "KEYWORDS_GENERATING": "Generazione in corso...",
      "KEYWORDS_GENERATE_STT_PROMPT": "Genera stt_prompt",
      "KEYWORDS_STT_PROMPT_OUTDATED": "È stato aggiornato l'elenco delle parole dopo la generazione di questo prompt. Rigenera per includere le ultime modifiche.",
      "KEYWORDS_STT_CANNOT_SAVE_HEADING": "Impossibile salvare a livello di prodotto",
      "KEYWORDS_STT_CANNOT_SAVE_BODY": "Le parole e il prompt per il riconoscimento vocale non possono essere salvati a livello di prodotto. Puoi modificare manualmente le altre impostazioni di riconoscimento vocale della simulazione oppure rivolgerti all'amministratore della piattaforma per ricevere assistenza.",
      "KEYWORDS_CLEAN_TRANSCRIPT_TITLE": "Parole per la pulizia della trascrizione",
      "KEYWORDS_CLEAN_TRANSCRIPT_DESCRIPTION": "Parole inserite nel prompt CLEAN_TRANSCRIPT_V2.",
      "KEYWORDS_CLEAN_TRANSCRIPT_NAME": "parole per la pulizia della trascrizione",
      "KEYWORDS_CALL_TITLE": "Parole della chiamata",
      "KEYWORDS_CALL_DESCRIPTION": "Dizionario di parole corrette per la correzione fonetica, utilizzato dall'algoritmo Double Metaphone per correggere errori ortografici foneticamente simili. Evita termini composti da più parole come \"Anti MuSK AB+\", poiché il correttore della trascrizione basato su codice funziona in modo affidabile solo con parole singole. Evita anche i simboli (ad esempio, \"lp(a)\"), poiché tendono a confondere il correttore. L'elenco dovrebbe essere il più breve e semplice possibile, poiché viene gestito da un algoritmo deterministico, non da un modello linguistico di grandi dimensioni (LLM), e non è quindi in grado di comprendere il contesto",
      "KEYWORDS_CALL_NAME": "parole della chiamata"
    },
    "settings": {
      "DEVICE_SETUP_INTRO": "Assicurati che il dispositivo sia configurato.",
      "MICROPHONE_REQUIRED_NOTICE": "È necessario un microfono funzionante.",
      "DEVICE_ENABLE_INSTRUCTIONS": "Se non hai visualizzato un pop-up di richiesta di abilitazione dei dispositivi dopo l'aggiornamento di questa pagina, accedi alle impostazioni del sistema o del browser e abilita i dispositivi. Di seguito sono riportate le pagine di supporto con ulteriori istruzioni.",
      "ENABLE_CAMERA": "Come attivare la fotocamera:",
      "WINDOWS_USERS": "Utenti Windows",
      "MAC_USERS": "Utenti Mac",
      "IPAD_USERS": "Utenti iPad",
      "ENABLE_MICROPHONE": "Come attivare il microfono:",
      "ENABLE_DEVICES_BY_BROWSER": "Come abilitare i dispositivi in base al browser:",
      "CHROME_USERS": "Utenti di Chrome",
      "SAFARI_USERS": "Utenti di Safari",
      "FIREFOX_USERS": "Firefox",
      "EDGE_USERS": "Bordo",
      "START_WITHOUT_CAMERA_BUTTON": "Avvio senza telecamera",
      "START_CALL_BUTTON": "Avvia chiamata",
      "MICROPHONE_REQUIRED_WARNING": "È necessario un microfono funzionante.",
      "MICROPHONE_ALT": "microfono",
      "MICROPHONE": "Microfono",
      "SELECT_MICROPHONE": "Seleziona il microfono",
      "ALERT": "avviso",
      "GIVE_PERMISSION": "Dai il permesso",
      "SELECT_VIDEO_DEVICE": "Seleziona il dispositivo video",
      "VIDEO": "video",
      "DEVICE_BLOCKED_ERROR": "Sembra che tu abbia negato a questo browser l'accesso a uno o più dispositivi. Per abilitare i dispositivi, accedi alle impostazioni del sistema o del browser e abilita l'accesso.",
      "DEVICE_SETTINGS": "Impostazioni del dispositivo",
      "CONFIRM_SETTINGS": "Conferma impostazioni",
      "LAPTOP": "Computer portatile",
      "SAD_EMOTE_FACE": "Faccina emoji triste",
      "GRANT_BROWSER_ACCESS": "Per completare questa simulazione, concedi al browser l'accesso al riconoscimento vocale",
      "USING_IPAD": "Se utilizzi un iPad, vai su",
      "SETTINGS": "Impostazioni",
      "PRIVACY_AND_SECURITY": "Privacy e sicurezza",
      "SPEECH_RECOGNITION": "Riconoscimento vocale",
      "GRANT_ACCESS_REFRESH": "Consenti l'accesso al browser e aggiorna la pagina",
      "REFRESH_PAGE": "AGGIORNA LA PAGINA",
      "BROWSER_UNABLE_TO_ACCESS": "Il browser non è in grado di accedere a questo dispositivo",
      "ACCESS_DENIED": "accesso negato",
      "CAMERA": "Telecamera",
      "DIAGNOSTIC_PASSED": "Tutti i test diagnostici sono stati superati con successo.",
      "DIAGNOSTIC_FAILED_MESSAGE": "Alcuni test diagnostici non sono stati superati. Clicca sul pulsante \"Copia risultati diagnostici\" sopra e invia i risultati al team di supporto per assistenza.",
      "DIAGNOSTIC_PARTIAL": "La maggior parte dei test diagnostici è stata superata con successo. La tua connessione sembra buona.",
      "DIAGNOSTIC_RUNNING_MESSAGE": "Attendi mentre i test diagnostici sono in esecuzione...",
      "DIAGNOSTIC_RUNNING": "Diagnostica in esecuzione",
      "COPY_DIAGNOSTIC_RESULTS": "Copia risultati diagnostici",
      "RUN_DIAGNOSTIC": "Esegui diagnostica",
      "RERUN_DIAGNOSTIC": "Ripeti diagnostica",
      "DIAGNOSTIC_RESULTS_COPIED": "Risultati diagnostici copiati negli appunti",
      "DIAGNOSTIC_FAILED": "Diagnostica non riuscita",
      "DIAGNOSTIC_WEBSOCKET_NOT_TESTED": "Websocket: not tested",
      "DIAGNOSTIC_TURN_NOT_TESTED": "TURN: not tested",
      "DIAGNOSTIC_QUALITY_NOT_TESTED": "Quality: not tested",
      "DIAGNOSTIC_QUANTIFIED_DIAGNOSTICS": "Diagnostica Quantified",
      "DIAGNOSTIC_TIME": "Volta",
      "DIAGNOSTIC_SUMMARY": "Riepilogo",
      "DIAGNOSTIC_CLIENT_INFO": "Informazioni client",
      "DIAGNOSTIC_PLATFORM": "Piattaforma",
      "DIAGNOSTIC_RTT_AVG_MAX": "RTT avg/max",
      "DIAGNOSTIC_PACKET_LOSS_SEND": "Perdita di pacchetti (invio)",
      "DIAGNOSTIC_AVG_SEND_BITRATE": "Bitrate medio di invio",
      "DIAGNOSTIC_NA": "N/D",
      "DIAGNOSTIC_PROBLEMS_CONNECTING_PREFIX": "Problemi di connessione?",
      "DIAGNOSTIC_CLICK_HERE": "clicca qui",
      "DIAGNOSTIC_TO_RUN_SUFFIX": "per eseguire una diagnostica."
    },
    "results": {
      "RETURN_HOME": "TORNA ALLA HOME",
      "CLOSE_BUTTON": "Pulsante di chiusura",
      "CONVERSATIONAL_CALL": "GIOCO DI RUOLO",
      "INFORMATION_ICON": "Icona informazioni",
      "TOOLTIP_ARROW": "Freccia suggerimento",
      "INFORMATION_TOOLTIP_CONTENT": "Sei tu a controllare l'andamento della simulazione, guidando la conversazione verso una serie di obiettivi. I giochi di ruolo sono ottimi per testare le competenze di approfondimento e formulazione di domande di secondo livello, individuazione di punti dolenti e sviluppo di un rapporto.",
      "CLOCK_ICON": "Icona orologio",
      "CALL_RESULTS": "Risultati",
      "SKILLS": "Competenze",
      "MESSAGE_ADHERENCE": "Rispetto del messaggio",
      "TRY_AGAIN_MESSAGE": "Riprova e migliora il tuo punteggio.",
      "PRACTICE_BENEFITS": "Esercitarsi settimanalmente aumenta la fiducia e migliora i risultati nel mondo reale.",
      "CALL_SUCCESS": "Ottimo lavoro! Hai completato la simulazione con successo.",
      "MAX_ATTEMPTS_REACHED": "Hai raggiunto il numero massimo di tentativi",
      "TRY_AGAIN": "Riprova",
      "GREAT_JOB_YOU_SUCCESSFULLY": "Ottimo lavoro! Hai completato",
      "COMPLETED_THIS_CALL": "questa simulazione con successo.",
      "ACHIEVED_SCORE": "Hai raggiunto un punteggio di",
      "ACHIEVE_SCORE": "Raggiungi un punteggio di",
      "OR_HIGHER": "o superiore.",
      "OBJECTIVES_NOT_MET": "Non hai raggiunto tutti gli obiettivi richiesti.",
      "TRY_AGAIN_TARGET_SCORE": "Riprova a raggiungi un punteggio di",
      "YOUR_SCORE": "Il tuo punteggio",
      "OUT_OF_5": "SU 5",
      "CALL_FEEDBACK": "RIEPILOGO DEL FEEDBACK",
      "STRENGTH_ICON_ALT": "Icona forza",
      "OPPORTUNITIES_ICON_ALT": "Icona opportunità",
      "OBJECTIVES_FEEDBACK": "FEEDBACK SULLA METODOLOGIA",
      "SESSION_ID": "ID sessione:",
      "SESSION_ID_COPIED": "ID sessione copiato!",
      "OBJECTIVE": "METODOLOGIA:",
      "HOW_YOU_DID": "Il tuo risultato:",
      "LIGHTBULB_ICON_ALT": "Icona lampadina",
      "WHAT_WE_SUGGEST": "Cosa suggeriamo:",
      "NO_SPECIFIC_RECOMMENDATION": "Il nostro sistema non è riuscito a trovare un suggerimento specifico per te.",
      "WHY": "Perché?",
      "NO_INSIGHTS_AVAILABLE": "Il nostro sistema non è stato in grado di fornire indicazioni su questo suggerimento.",
      "CONFETTI_ICON_ALT": "Icona coriandoli",
      "OBJECTIVE_SUCCESS_MESSAGE": "Hai ottenuto ottimi risultati per questa metodologia, continua così!",
      "PROCESSING_CALL": "Stiamo preparando il tuo punteggio e il tuo feedback.",
      "HANG_TIGHT": "Rimani in attesa o riprova più tardi a",
      "VIEW_YOUR_RESULTS": "visualizzare i risultati.",
      "NEED_MORE_TIME": "Abbiamo bisogno di più tempo per calcolare i risultati.",
      "REFRESH_INSTRUCTION": "Ricontrolla o aggiorna i risultati",
      "RESULTS_IN_FEW_MINUTES": "dell'incarico tra qualche minuto.",
      "SCORE_CALCULATION_QUESTION": "Come viene calcolato?",
      "SINGLE_SCORE_EXPLANATION": "Questa simulazione ha un solo componente di punteggio, quindi il punteggio visualizzato rappresenta sia quello della singola sezione sia quello complessivo.",
      "OVERALL_SCORE_PERCENT": "del punteggio complessivo",
      "SECTION_SCORE": "Punteggio della sezione",
      "ELEVATE_MESSAGE_ADHERENCE_TITLE": "Migliora il rispetto dei messaggi conversazionali",
      "MESSAGE_ADHERENCE_NOTE": "Il rispetto del messaggio è fondamentale per condurre conversazioni di successo, ma non influisce sul punteggio complessivo.",
      "NO_CREDIT": "Nessun credito",
      "PARTIAL_CREDIT": "Credito parziale",
      "FULL_CREDIT": "Credito pieno",
      "WHAT_YOU_DID_WELL": "Aspetti svolti con successo",
      "MISSED_ALL_KEY_POINTS": "Non hai capito tutti i punti chiave; rivedili e riprova.",
      "WHAT_TO_IMPROVE": "Aspetti da migliorare",
      "PERFECT_SCORE_MESSAGE": "Congratulazioni! Hai ottenuto un punteggio perfetto, rispondendo correttamente a tutti i punti chiave.",
      "POINTS_LABEL": "Punti",
      "TALKING_POINTS_COVERED": "Punti di discussione trattati",
      "CHECKMARK_ICON_ALT": "segno di spunta",
      "TALKING_POINTS_MISSED": "Punti di discussione non trattati",
      "X_ICON_ALT": "x",
      "PRACTICE_AGAIN": "Esercitati di nuovo",
      "OUT_OF": "di",
      "OBJECTIVES": "Metodologia",
      "ELEVATE_OBJECTIVES_TITLE": "Migliora la tua metodologia di conversazione",
      "OBJECTIVES_NOTE": "La metodologia è fondamentale per condurre conversazioni di successo, ma non influisce sul punteggio complessivo.",
      "UNTIL": "fino al",
      "TO_IMPROVE_SCORE": "per migliorare il tuo punteggio.",
      "YOU_HAVE": "Hai",
      "MORE_ATTEMPTS": "ulteriori tentativi per ottenere un punteggio di",
      "OR_HIGHER_BEFORE": "o superiore prima del",
      "AND_TRY_AGAIN": "e riprova.",
      "UNEXPECTED_STATE": "Si è verificato uno stato inatteso.",
      "REVIEW_APP_LOGIC": "Rivedi la logica dell'applicazione.",
      "ASSIGNMENTS": "Incarichi",
      "VIEW_CALL_DETAILS": "Visualizza dettagli chiamata",
      "PRACTICE_SESSION": "Sessione di esercitazione",
      "OVERALL_SCORE": "Punteggio complessivo",
      "OVERALL_SCORE_EXPLANATION": "Il punteggio complessivo viene calcolato facendo la media ponderata dei punteggi di ciascuna sezione. Il peso di ciascuna sezione viene visualizzato in percentuale accanto al punteggio.",
      "SCORE_CONFIG_NOTE": "Le percentuali di peso, nonché l'inclusione e l'esclusione delle sezioni sono stabilite dalla tua azienda. Tutti i punteggi sono arrotondati al decimo di punto più vicino.",
      "STRENGTHS": "Punti di forza",
      "OPPORTUNITIES": "Opportunità",
      "YOUR_RESPONSE": "La tua risposta",
      "MINUS": "meno",
      "PLUS": "più",
      "RECOMMENDED_RESPONSE": "Risposta suggerita",
      "REVIEW_MISSED_TITLE": "Rivedi gli aspetti che ti sono sfuggiti.",
      "NO_TALKING_POINTS_COVERED": "Non hai trattato nessuno dei punti di discussione richiesti per questo argomento.",
      "LEARN_WHAT_YOU_MISSED": "Scopri gli aspetti che ti sono sfuggiti",
      "NICE_JOB": "Bel lavoro!",
      "ALL_POINTS_COVERED": "Hai trattato con successo tutti i punti di discussione richiesti per questo argomento.",
      "COVER_ALL_MESSAGES": "Tratta tutti i messaggi chiave.",
      "HIGHLIGHT_KEY_POINTS_NOTE": "Evidenziare i punti chiave nel corso della telefonata aiuterà a mantenere la conversazione focalizzata sull'obiettivo.",
      "MESSAGES_LABEL": "Messaggi",
      "NO_FACTS_COVERED": "Ops! Sembra che tu non abbia affrontato nessuno degli argomenti di questo messaggio.",
      "NO_SPECIFICS_AVAILABLE": "Ops! Sembra che non siamo riusciti a fornire informazioni specifiche su ciò che ti è sfuggito.",
      "ALL_KEY_POINTS_COVERED": "Ottimo lavoro! Hai trattato tutti i punti chiave.",
      "PROCESSING_SKILLS_FEEDBACK": "Stiamo elaborando il feedback sulle tue competenze.",
      "SKILLS_SCORING_NOT_ENABLED": "Siamo spiacenti, ma non abbiamo potuto analizzare la tua chiamata recente perché il punteggio delle competenze non era abilitato al momento dell'invio. Per ottenere un riscontro, è sufficiente ripresentare l'esercitazione di chiamata come fatto in precedenza. Se hai bisogno di aiuto, non esitare a contattare il nostro team di assistenza. Grazie per la comprensione e per il tuo impegno a migliorare!",
      "ELEVATE_CONVERSATION_SKILLS": "Migliora le tue competenze di conversazione",
      "SKILLS_NOTE": "Le competenze sono fondamentali per condurre conversazioni di successo, ma non influiscono sul punteggio complessivo.",
      "SKILLS_SUMMARY_TITLE": "SINTESI DELLE COMPETENZE",
      "LEARN_MORE_ABOUT_SKILLS": "Per saperne di più sulle competenze",
      "SKILLS_FEEDBACK_LABEL": "FEEDBACK",
      "WHAT_ARE_SKILLS_TITLE": "Cosa sono le competenze",
      "SKILLS_DESCRIPTION": "Le competenze sono calibrate per supportare lo sviluppo della crescita personale. Anche se queste competenze non fanno parte della valutazione numerica della chiamata, sono state selezionate dalla tua organizzazione per migliorare la tua efficacia.",
      "PROFICIENCY_SCALE_TITLE": "SCALA DI COMPETENZA",
      "EXPERT": "Esperto",
      "PROFICIENT": "Competente",
      "DEVELOPING": "In crescita",
      "CALL_TRANSCRIPT": "Trascrizione della chiamata",
      "COLLAPSE_ALL": "Chiudi tutto",
      "EXPAND_ALL": "Espandi tutto",
      "THUMBNAIL": "Miniatura",
      "OUT_OF_FIVE_POINTS": "/5 punti",
      "TALKING_POINTS": "punti di discussione",
      "TRANSCRIPT_LABEL": "Trascrizione",
      "YOU_ARE_OUT_OF_ATTEMPTS": "I tentativi sono finiti.",
      "REVIEW_GUIDELINES_REMAIN_COMPLIANT": "Rivedi le linee guida e rimani conforme in futuro.",
      "TRY_AGAIN_ATTENTION_TO_COMPLIANCE": "Riprova e presta attenzione alle linee guida di conformità.",
      "NO_SCORE_OUT_OF_COMPLIANCE": "Abbiamo individuato un elemento che potrebbe non essere conforme",
      "WHY_OUT_OF_COMPLIANCE": "Perché potresti non essere conforme",
      "REVIEW_TRANSCRIPT_MISSED_GUIDELINES": "Rivedi la tua trascrizione per capire in che momento non hai rispettato le linee guida per la conformità.",
      "YOU_DID_FOLLOW_GUIDELINES": "Hai effettivamente seguito queste linee guida.",
      "REVIEW_MISSED_GUIDELINES": "Rivedi le linee guida sulla conformità mancante.",
      "OUT_OF_COMPLIANCE": "Non conforme",
      "SCORE_CALCULATION_TITLE": "Calcolo del punteggio",
      "PROCESSING_TRANSCRIPT": "Stiamo elaborando la tua trascrizione.",
      "WAIT_OR_REVIEW_SCORES": "Aspetta qui o rivedi le altre sezioni",
      "TRANSCRIPT_LOADING": "del punteggio mentre la trascrizione viene caricata.",
      "REVIEW_FEEDBACK_KEEP_PRACTICING": "Esamina il feedback e continua a esercitarti",
      "HIGH_PERFORMERS_PRACTICE": "Gli artisti di alto livello si esercitano almeno una volta alla settimana",
      "SUCCESSFULLY_PASSED": "Ottimo lavoro! La simulazione è stata superata con successo.",
      "DIDNT_REACH_PASSING_SCORE": "Non hai raggiunto il punteggio minimo per questa simulazione.",
      "OUT_OF_ATTEMPTS": "<b>Hai terminato i tentativi.</b> Esamina il feedback per scoprire come puoi migliorare.",
      "REVIEW_FEEDBACK_THEN_RETURN": "Esamina il feedback, quindi torna alla home.",
      "GREAT_JOB_PRACTICED": "Ottimo lavoro, hai svolto l'esercitazione {{count}} {{times}}. Continua così!",
      "TIME": "volta",
      "TIMES": "volte",
      "COMPLIANCE_GUIDELINES": "Linee guida per la conformità",
      "TALKING_POINT_TITLE": "PUNTI DI DISCUSSIONE NON AFFRONTATI O TRATTATI NEL MOMENTO SBAGLIATO",
      "NO_TRANSCRIPT": "La trascrizione non è disponibile.",
      "QUIZ_SUMMARY_BASE": "Prenditi un momento per rivedere la tua performance in questo quiz.",
      "QUIZ_SUMMARY_FAILED": "Prenditi un momento per rivedere la tua performance in questo quiz. Rivedi {{stepNames}} {{stepWord}}, evidenziati nella schermata della panoramica del percorso, per prepararti meglio al prossimo tentativo.",
      "QUIZ_SUMMARY_PASSED_WITH_MISSES": "Prenditi un momento per rivedere la tua performance in questo quiz. I {{stepWord}} {{stepNames}} {{stepVerb}} le tue {{areaWord}} con il punteggio più basso.",
      "OUT_OF_100": "SU 100",
      "COVERED": "Trattati",
      "MISSED": "Non trattati",
      "RETURN_TO_ASSIGNMENT": "Ritorna all'incarico",
      "RETURN_TO_PATHWAY": "TORNA AL PERCORSO",
      "QUIZ_RESULTS_SUMMARY": "Riepilogo risultati del quiz",
      "PROCESSING_RESULTS": "Elaborazione risultati in corso...",
      "NONE_PERFECT": "Nessuno, perfetto!",
      "MESSAGING": "Messaggistica",
      "MISSED_ONE_TALKING_POINT": "Non hai trattato 1 punto fondamentale su questo argomento.",
      "MISSED_X_TALKING_POINTS": "Non hai trattato {{count}} punti fondamentali su questo argomento.",
      "ROLEPLAY_POST_CALL_TITLE": "Hai raggiunto la fine di questa chiamata.",
      "ROLEPLAY_POST_CALL_SUBTITLE_PROCESSING": "Lascia un feedback mentre elaboriamo i tuoi risultati.",
      "ROLEPLAY_POST_CALL_SUBTITLE_DELAY": "Il caricamento dei risultati potrebbe richiedere qualche istante. Esci dal percorso e ti avviseremo quando saranno pronti.",
      "ROLEPLAY_POST_CALL_SUBTITLE_ERROR": "Si è verificato un errore durante l'elaborazione dei risultati. Contatta l'assistenza all'indirizzo",
      "ROLEPLAY_POST_CALL_PROCESSING_LABEL": "Elaborazione risultati in corso...",
      "ROLEPLAY_POST_CALL_FEEDBACK_QUESTION": "La conversazione è stata realistica e naturale?",
      "FEEDBACK_THANK_YOU": "Grazie per il tuo feedback!",
      "FEEDBACK_IMPROVEMENT_NOTE": "Grazie per il tuo feedback! Lavoreremo per migliorare l'esperienza.",
      "VIEW_RESULTS": "Visualizza risultati",
      "FEEDBACK_IMPROVEMENT_SUFFIX": "Lavoreremo per migliorare l'esperienza.",
      "QUIZ_RESULTS_LOADING": "Il caricamento dei risultati potrebbe richiedere qualche istante. Esci dal percorso e ti avviseremo quando saranno pronti.",
      "KC_TOAST_TITLE": "I risultati del controllo delle tue conoscenze sono stati elaborati",
      "KC_TOAST_CONTENT": "Clicca qui sotto per visualizzarli oppure torna alla schermata dei dettagli del percorso per procedere con il passaggio successivo.",
      "DISMISS": "Ignora",
      "KC_TOAST_TITLE_PATHWAY": "I risultati del controllo delle tue conoscenze per {{stepName}} sono stati elaborati",
      "MISSED_ONE_REQUIRED_TALKING_POINT": "Non hai trattato 1 punto fondamentale richiesto su questo argomento",
      "MISSED_X_REQUIRED_TALKING_POINTS": "Non hai trattato {{count}} punti fondamentali richiesti su questo argomento",
      "MISSED_ALL_ONE_REQUIRED_TALKING_POINT_TITLE": "Non hai trattato 1 punto fondamentale richiesto su questo argomento.",
      "MISSED_ALL_X_REQUIRED_TALKING_POINTS_TITLE": "Non hai trattato {{count}} punti fondamentali richiesti su questo argomento.",
      "REVIEW_MATERIAL_NEXT_TIME": "Rivedi il materiale per migliorare in vista del prossimo tentativo.",
      "POINT_LABEL": "Punto",
      "GREAT_JOB_PRACTICED_FEMALE": "Ottimo lavoro, hai svolto l'esercitazione {{count}} {{times}}. Continua così!",
      "ACCURACY": "Accuratezza",
      "ACCURACY_LOADING": "Caricamento in corso...",
      "ACCURACY_FLAGGED_MESSAGE": "Alcune tue affermazioni potrebbero differire dai materiali di riferimento. Vedi sotto per maggiori dettagli.",
      "ACCURACY_ALL_CLEAR": "Non abbiamo individuato alcuna affermazione che risultasse inesatta rispetto ai materiali di riferimento.",
      "ACCURACY_ERROR": "Impossibile fornire un feedback su questa sessione",
      "ACCURACY_YOU_SAID": "HAI AFFERMATO",
      "ACCURACY_CLAIM_IDENTIFIED": "L'AFFERMAZIONE CHE ABBIAMO INDIVIDUATO",
      "ACCURACY_MATERIALS_STATE": "I TUOI DOCUMENTI AFFERMANO",
      "ACCURACY_OVERALL_BLOCK_PREFIX": "Alcune delle tue affermazioni potrebbero essere inesatte. Spunta la scheda ",
      "ACCURACY_OVERALL_BLOCK_LINK": "accuratezza",
      "ACCURACY_OVERALL_BLOCK_SUFFIX": " per maggiori dettagli.",
      "PRACTICE_SIMULATION_AGAIN": "Ripeti la simulazione",
      "CALL_TYPE_CONVERSATIONAL": "Chiamata conversazionale",
      "CALL_TYPE_GUIDED": "Chiamata guidata",
      "CALL_TYPE_VISUAL_AID": "Chiamata di aiuto visivo",
      "CALL_TYPE_ROLEPLAY": "Chiamata gioco di ruolo",
      "PERSONALIZED_PRACTICE_BREADCRUMB": "Esercitazione personalizzata",
      "CONVERSATION_TYPE_LABEL": "Tipo di conversazione:",
      "DIFFICULTY_LABEL": "Difficoltà:",
      "MOOD_LABEL": "Umore:",
      "DIFFICULTY": "Difficoltà",
      "TEMPERAMENT": "Temperamento",
      "OVERALL_SCORE_TAB": "Complessivo",
      "MESSAGE_ADHERENCE_TAB": "Messaggi",
      "OBJECTIVES_TAB": "Obiettivi"
    },
    "reportingV2": {
      "DASHBOARD": "Dashboard",
      "LOADING_ACCOUNTS": "Caricamento account in corso...",
      "SELECT_AN_ACCOUNT": "Seleziona un account",
      "SEARCH_TEAMS": "Cerca team",
      "LOADING_TEAMS": "Caricamento team in corso...",
      "ALL_TEAMS": "Tutti i team",
      "ACCOUNT": "Account",
      "TEAMS": "Team",
      "TEAM_LABEL": "Team",
      "TOTAL_LABEL": "Totale",
      "PASSING_SCORE": "Punteggio minimo per il superamento",
      "ASSIGNMENT_LABEL": "Incarichi",
      "USER_LABEL": "Utenti",
      "PRACTICE_LABEL": "Esercitazione",
      "CERTIFICATION_LABEL": "Certificazione",
      "RESULTS_DESCRIPTION": "Ecco i risultati del tuo (o dei tuoi) team in tutti gli incarichi di esercitazione:",
      "ENGAGEMENT_BY_ASSIGNMENT": "Impegno per incarico",
      "ASSIGNMENT_ENGAGEMENT": "Impegno per gli incarichi",
      "ENGAGED_LABEL": "Impegno in corso",
      "ENGAGEMENT_STATUS_LABEL": "Stato dell'impegno",
      "PROFICIENT_LABEL": "Competente",
      "ASSIGNMENT_NAME": "Nome dell'incarico",
      "ACTIVE_USERS": "Utenti attivi",
      "ASSIGNMENT_PROGRESS": "Progresso per incarico",
      "IN_PROGRESS_LABEL": "In corso",
      "CERTIFIED_LABEL": "Certificato",
      "OUT_OF_ATTEMPTS_LABEL": "Tentativi esauriti",
      "USERS_ENGAGED_LABEL": "Utenti con impegni in corso",
      "SESSIONS_PER_ACTIVE_USERS_LABEL": "Sessioni per utente attivo",
      "HIGHER_THAN_LABEL": "Superiore a",
      "MORE_THAN_LABEL": "Più di",
      "TOTAL_SESSIONS_COMPLETED_LABEL": "Totale sessioni completate",
      "USER_CERTIFIED": "Utenti certificati su tutti gli incarichi",
      "ASSIGNMENT_CERTIFICATION": "Incarichi con certificazione al 100%",
      "TRAINER_TIME_SAVED": "Tempo risparmiato dagli istruttori",
      "HOURS_LABEL": "ore",
      "PRACTICE_ASSIGNMENT_LABEL": "Incarichi di esercitazione",
      "CERTIFICATION_ASSIGNMENT_LABEL": "Incarichi di certificazione",
      "START_DATE_LABEL": "Data di inizio",
      "END_DATE_LABEL": "Data di fine",
      "NAME_LABEL": "Nome",
      "EMAIL_LABEL": "Email",
      "MEMBER_OF_TEAMS_LABEL": "Membro dei team",
      "ASSIGNMENTS_COUNT_LABEL": "N. di incarichi",
      "TOTAL_SESSIONS_LABEL": "Totale sessioni",
      "NUMBER_OF_SESSIONS_LABEL": "Numero di sessioni",
      "TOTAL_USERS_LABEL": "Utenti totali",
      "AVERAGE_SCORE_LABEL": "Punteggio medio",
      "INITIAL_SCORE_LABEL": "Punteggio iniziale",
      "HIGH_SCORE_LABEL": "Punteggio elevato",
      "LAST_PRACTICE_DATE_LABEL": "Data dell'ultima esercitazione",
      "PERCENT_IMPROVED_LABEL": "% di miglioramento",
      "PERCENT_IMPROVED_TOOLTIP_TEXT": "Questo indicatore, espresso come percentuale del miglioramento massimo possibile, mette a confronto il punteggio iniziale con il punteggio più alto di un utente.",
      "ASSIGNMENTS_CERTIFIED_LABEL": "Incarichi certificati",
      "ASSIGNMENTS_PROFICIENT_LABEL": "Incarichi con punteggio Competente",
      "ASSIGNMENTS_CERTIFIED_TOOLTIP_TEXT": "Il numero di incarichi in cui l'utente ha soddisfatto o superato i criteri di valutazione per tutte le simulazioni dell'incarico.",
      "ASSIGNMENTS_PROFICIENT_TOOLTIP_TEXT": "Il numero di incarichi in cui l'utente ha soddisfatto o superato almeno una volta i criteri di valutazione in tutte le simulazioni dell'incarico.",
      "PROFICIENT_TOOLTIP": "La percentuale di utenti in questo incarico che hanno soddisfatto o superato almeno una volta i criteri di valutazione in tutte le simulazioni dell'incarico.",
      "IN_PROGRESS_TOOLTIP": "La percentuale di utenti che hanno completato almeno una sessione di simulazione in questo incarico e hanno ricevuto un punteggio.",
      "OUT_OF_ATTEMPTS_TOOLTIP": "La percentuale di utenti che hanno superato i tentativi assegnati per una o più simulazioni nell'incarico.",
      "CERTIFIED_TOOLTIP": "La percentuale di utenti che hanno soddisfatto o superato i criteri di valutazione per tutte le simulazioni dell'incarico.",
      "SEARCH_FOR_A_USER_LABEL": "Ricerca di un utente",
      "NO_USERS_FOUND_LABEL": "Nessun utente trovato",
      "TRAINER_TIME_SAVED_TOOLTIP": "La quantità di tempo che gli utenti hanno trascorso in Quantified completando i tentativi di certificazione.",
      "AVG_SESSIONS_PER_ASSIGNMENT": "Sessioni medie per incarico",
      "ASSIGNMENTS_ENGAGED_WITH": "Incarichi a cui ha partecipato",
      "AVERAGE_IMPROVEMENT": "Miglioramento medio",
      "STATUS": "Stato",
      "TOTAL_NUMBER_OF_SESSIONS": "Numero totale di sessioni",
      "DATE_OF_LAST_PRACTICE": "Data dell'ultima esercitazione",
      "CALL_NAME": "Nome della chiamata",
      "SESSION_DATE": "Data sessione",
      "DURATION_OF_SESSION": "Durata sessione",
      "OVERALL_SCORE": "Punteggio complessivo",
      "MESSAGING_SCORE": "Punteggio rispetto del messaggio",
      "METHODOLOGY_SCORE": "Punteggio metodologia",
      "SKILLS_SCORE": "Punteggio competenze",
      "SESSIONS": "Sessioni",
      "TOTAL": "Totale",
      "ALL_ASSIGNMENTS": "Tutti gli incarichi",
      "RECENT_ASSIGNMENTS": "Incarichi recenti",
      "AVERAGE_SESSIONS_ACTIVE_USER": "Sessioni medie per utente attivo",
      "HOURS_IN_SIMULATIONS": "Ore in simulazioni",
      "AVERAGE_SESSIONS_TO_PROFICIENCY": "Sessioni medie al conseguimento della competenza",
      "PERCENT_PROFICIENT": "Percentuale di competenti",
      "SYSTEM_RUNNING_NORMALLY": "Il sistema sta funzionando normalmente",
      "PRACTICE_SIMULATIONS_LABEL": "Simulazioni",
      "NO_USERS_MATCHING_FILTERS_LABEL": "Nessun risultato corrisponde ai filtri impostati. Prova a deselezionare uno o più filtri per ampliare la ricerca.",
      "USERS_PASSED": "Utenti che hanno superato la simulazione",
      "AVERAGE_TIME": "Tempo medio impiegato per ottenere la certificazione",
      "USERS_OUT_OF_ATTEMPTS": "Utenti senza tentativi",
      "NO_CERTIFICATION_SIMULATION": "Nessuna simulazione di certificazione trovata",
      "SIMULATION": "Simulazione",
      "No_SIMULATION": "Nessuna sessione",
      "PERCENT_CERTIFIED": "Percentuale certificata",
      "PERCENT_CERTIFIED_FIRST_ATTEMPT": "Percentuale certificata al primo tentativo",
      "USERS": "Utenti",
      "ATTEMPTS_LABEL": "Tentativi",
      "NO_ATTEMPTS": "Nessun tentativo",
      "DATE_OF_SESSION": "Data della sessione",
      "NO_ASSIGNMENTS_MATCH_FILTERS": "Nessun incarico corrisponde ai filtri scelti",
      "NO_TEAMS_DATA": "Non sono presenti team in questo account",
      "SIMULATION_NAME": "Nome simulazione",
      "AVERAGE_DURATION_OF_SESSION": "Durata media della sessione",
      "AVERAGE_SESSIONS_PER_ACTIVE_USER": "Numero medio di sessioni per utente attivo",
      "AVERAGE_OVERALL_SCORE": "Punteggio complessivo medio",
      "TOTAL_ASSIGNMENTS": "Totale incarichi",
      "ASSIGNMENTS_CERTIFIED": "Incarichi certificati",
      "TOTAL_SESSIONS": "Totale sessioni",
      "HOURS_SPENT_PRACTICING": "Ore dedicate alle esercitazioni",
      "LAST_LOGIN": "Ultimo accesso",
      "SELECT_ASSIGNMENTS": "Seleziona incarichi",
      "CERTIFICATION_STATUS_LABEL": "Stato della certificazione",
      "CERTIFICATION_STATUS_PREFIX_LABEL": "Stato della certificazione:",
      "CERTIFIED_ON_FIRST_ATTEMPT_LABEL": "Certificazione ottenuta al primo tentativo?",
      "DATE_OF_CERTIFICATION_LABEL": "Data della certificazione",
      "ENGAGEMENT_STATUS_PREFIX_LABEL": "Stato dell'impegno:",
      "DURATION_OF_ATTEMPT": "Durata tentativo",
      "USER_NAME": "Nome utente",
      "LEARNER": "Studente",
      "DATE_RANGE": "Intervallo di date",
      "DATE_RANGE_LABEL": "Intervallo di date",
      "SEARCH_USERS": "Cerca utenti...",
      "SEARCH_SIMULATIONS": "Cerca simulazioni...",
      "SEARCH_DATES": "Cerca date...",
      "CERTIFIED_ON_FIRST_TRY": "Certificazione ottenuta al primo tentativo",
      "DATE_OF_CERTIFICATION": "Data della certificazione",
      "AVERAGE_CERTIFICATION_SCORE": "Punteggio medio di certificazione",
      "TOTAL_TIME_CERTIFYING": "Tempo totale impiegato per ottenere la certificazione",
      "OF_THE_TIME": "del tempo",
      "ASSIGNED_LABEL": "Non iniziato",
      "USERS_ASSIGNED_LABEL": "Totale utenti con incarichi",
      "SESSION_ID": "ID sessione",
      "NO_SIMULATIONS_FOUND_LABEL": "Nessuna simulazione trovata",
      "USER_NAME_LABEL": "Nome utente",
      "MIN": "min",
      "SEC": "sec",
      "OF_LABEL": "di",
      "SECOND": "secondo",
      "SECONDS": "secondi",
      "MINUTE": "minuto",
      "MINUTES": "minuti",
      "ASSIGNED": "Assegnato",
      "ENGAGED_TOOLTIP": "La percentuale di utenti che hanno completato una o più sessioni di una simulazione in questo incarico, ma non hanno ancora raggiunto la competenza richiesta in tutte le simulazioni.",
      "SEARCH_ASSIGNMENTS": "Cerca incarichi...",
      "ASSIGNMENT_NAME_LABEL": "Nome dell'incarico",
      "SIMULATION_NAME_LABEL": "Nome simulazione",
      "START_DATE": "Data di inizio",
      "END_DATE": "Data di fine",
      "NO_ASSIGNMENTS": "Nessun incarico trovato per questo utente.",
      "TOTAL_PRACTICE_ASSIGNMENTS": "Totale incarichi di esercitazione",
      "SESSION_SCORES_OVER_TIME": "Punteggi sessioni nel tempo",
      "TIME": "Volta",
      "SCORE": "Punteggio",
      "NO_SESSIONS_AVAILABLE": "Nessuna sessione disponibile da tracciare nel grafico.",
      "MESSAGING_SCORE_LABEL": "Punteggio messaggistica",
      "PERSONALIZED_PRACTICE_LABEL": "Esercitazione personalizzata",
      "ASSIGNMENT_ENAGEMENT": "Impegno per incarico",
      "NO_PRODUCTS": "Nessun prodotto di esercitazione personalizzato per i team selezionati",
      "TOTAL_TIME_SPENT_PRACTICING": "Tempo totale dedicato all'esercitazione",
      "AVERAGE_SESSIONS_PER_USER": "Sessioni medie per utente",
      "MOST_COMMON_CONVERSATION_TYPE_SELECTION": "Selezione del tipo di conversazione più comune",
      "LEAST_COMMON_CONVERSATION_TYPE_SELECTION": "Selezione del tipo di conversazione meno comune",
      "CLEAR_TEAMS": "Cancella i team",
      "METHODOLOGY_SCORE_DESCRIPTION": "Misura la capacità degli studenti di seguire la struttura di chiamata consigliata. I punteggi riflettono la media di tutte le sessioni di questa simulazione.",
      "METHODOLOGY": "Metodologia",
      "MESSAGING": "Messaggistica",
      "MESSAGING_V2_DASHBOARD_DESCRIPTION": "Misura se gli studenti esprimono le idee chiave durante la chiamata. I grafici mostrano la percentuale media di messaggi espressi correttamente per tema in tutte le sessioni.",
      "NO_METRICS_MESSAGE": "Sono necessarie ulteriori sessioni per generare indicazioni.",
      "SELECT_ALL": "Seleziona tutto",
      "DESELECT_ALL": "Deseleziona tutto",
      "SKILLS": "Competenze",
      "SKILLS_SCORE_STATS_DESCRIPTION": "Misura la capacità degli studenti di dimostrare le competenze chiave durante la chiamata. I punteggi riflettono una valutazione media dell'IA in tutte le sessioni.",
      "EXPERT": "Esperto",
      "PROFICIENT": "Competente",
      "DEVELOPING": "In crescita",
      "FULLY_ARTICULATED": "Completamente espresso",
      "PARTIALLY_ARTICULATED": "Parzialmente espresso",
      "NOT_MENTIONED": "Non menzionato",
      "MESSAGING_SCORE_STATS_DESCRIPTION": "Misura se gli studenti esprimono le idee chiave durante la chiamata. I grafici mostrano la frequenza con cui ogni messaggio è stato articolato correttamente in tutte le sessioni.",
      "CLEAR": "Cancella",
      "CLEAR_STATUS": "Cancella stato",
      "CLEAR_USERS": "Cancella utenti",
      "CLEAR_SIMULATIONS": "Cancella simulazioni",
      "CLEAR_ASSIGNMENTS": "Cancella incarichi",
      "MODAL_SUBHEADING": "Tutti e {{count}} gli obiettivi: punteggi medi in tutte le sessioni",
      "VIEW_ALL_OBJECTIVES": "Visualizza tutti e {{count}} gli obiettivi →",
      "LEAST_MISSED_QUESTION": "DOMANDA CON MENO ERRORI",
      "MOST_MISSED_QUESTION": "DOMANDA CON PIÙ ERRORI",
      "HIGHEST_SCORING_METHODOLOGY_SECTION": "SEZIONE METODOLOGIA CON IL PUNTEGGIO PIÙ ALTO",
      "LOWEST_SCORING_METHODOLOGY_SECTION": "SEZIONE METODOLOGIA CON IL PUNTEGGIO PIÙ BASSO",
      "LEAST_ARTICULATED_MESSAGE": "MESSAGGIO MENO ESPRESSO",
      "ENGAGEMENT": "COINVOLGIMENTO",
      "USER_ENGAGEMENT_MORE_SESSIONS": "sessioni completate in più rispetto alla media del team",
      "QUESTION_CORRECT_PERCENTAGE_DESC": "delle volte, hanno risposto correttamente",
      "QUESTION_CORRECT_PERCENTAGE_DESC_ASSIGNMENT": "delle volte, gli utenti rispondono correttamente",
      "METHODOLOGY_AVERAGE_POINTS_DESC": "punti medi su questo obiettivo in tutte le sessioni",
      "MOST_ARTICULATED_MESSAGE": "MESSAGGIO PIÙ ESPRESSO",
      "LEAST_MISSED_ANSWER_POINT": "PUNTO DI RISPOSTA CON MENO ERRORI",
      "MOST_MISSED_ANSWER_POINT": "PUNTO DI RISPOSTA CON PIÙ ERRORI",
      "MOST_ARTICULATED_MESSAGE_DESCRIPTION": "delle volte, esprimono a pieno questo messaggio",
      "LEAST_ARTICULATED_MESSAGE_DESCRIPTION": "delle volte, esprimono questo messaggio",
      "ASSIGNMENT_STATUS": "Stato dell'incarico",
      "STATUS_ACTIVE": "Attivo",
      "STATUS_ENDED": "Terminato",
      "STATUS_CLOSED": "Chiuso",
      "STATUS_ARCHIVED": "Archiviato",
      "USER_ENGAGEMENT_FEWER_SESSIONS": "sessioni completate in meno rispetto alla media del team",
      "MOST_ARTICULATED_MESSAGE_DESCRIPTION_ASSIGNMENT": "delle volte, gli utenti esprimono questo messaggio",
      "LEAST_ARTICULATED_MESSAGE_DESCRIPTION_ASSIGNMENT": "delle volte, gli utenti esprimono questo messaggio",
      "OTHERS_SINGULAR": "e 1 altro",
      "OTHERS_PLURAL": "e altri {{ count }}",
      "PAGINATION_PREVIOUS": "Precedente",
      "PAGINATION_NEXT": "Successiva",
      "HOUR_LABEL": "ora",
      "SESSIONS_LABEL": "sessioni"
    },
    "personalizedPractice": {
      "TITLE": "Esercitazione personalizzata",
      "DESCRIPTION": "Ciao {{userFirstName}}. Le pratiche personalizzate ti consentono di impostare i tuoi scenari in modo che siano il più realistici possibile.",
      "LOADING": "Caricamento in corso...",
      "VIEW_SESSIONS": "Visualizza sessioni",
      "VIEW_SIMULATION": "Visualizza simulazione",
      "TOTAL_SESSION": "totale sessione",
      "TOTAL_SESSIONS": "totale sessioni",
      "BREADCRUMB": "Esercitazione personalizzata",
      "SCENARIO_DETAILS_TITLE": "Dettagli scenario",
      "SCENARIO_DETAILS_DESCRIPTION": "Seleziona le variabili dalle opzioni qui sotto per adattare la simulazione alle tue esigenze.",
      "AVATAR": "Avatar",
      "SELECT_PLACEHOLDER": "Seleziona",
      "CONVERSATION_TYPE": "Tipo di conversazione",
      "SELECT_CONVERSATION_TYPE": "Seleziona il tipo di conversazione",
      "LAUNCH_SIMULATION": "Lancia simulazione con selezioni",
      "PREVIOUS_SESSIONS": "Sessioni precedenti",
      "TOTAL": "Totale",
      "FILTERS": "Filtri:",
      "DATE": "Data",
      "DIFFICULTY": "Difficoltà",
      "TEMPERAMENT": "Temperamento",
      "SESSION_DATE": "Data sessione",
      "SESSION_SCORE": "Punteggio sessione",
      "DURATION": "Durata",
      "OVERALL_SCORE": "Punteggio complessivo",
      "MESSAGING": "Messaggistica",
      "METHODOLOGY": "Metodologia",
      "SKILLS": "Competenze",
      "RESULTS": "Risultati",
      "VIEW_FEEDBACK": "Visualizza feedback",
      "OVERALL_SCORE_LABEL": "Punteggio complessivo",
      "SCORE": "Punteggio",
      "NO_PRODUCTS_TITLE": "Nessun prodotto disponibile",
      "NO_PRODUCTS_DESCRIPTION": "Non hai ancora prodotti di esercitazione personalizzati.",
      "NO_SESSIONS_FOUND": "Nessuna sessione trovata con i filtri selezionati",
      "TIME": "Volta",
      "ALL": "Tutti",
      "LEARNER": "Studente",
      "MOOD": "Umore",
      "CLEAR_FILTERS": "Filtri trasparenti",
      "PAGINATION_PREVIOUS": "Precedente",
      "PAGINATION_NEXT": "Successiva",
      "DURATION_MINUTES_SECONDS": "{{minutes}} m {{seconds}} s",
      "DURATION_SECONDS": "{{seconds}} s"
    },
    "login": {
      "TITLE": "Che bello rivederti qua",
      "SUB_TITLE": "Come desideri effettuare il login?  ",
      "LOGIN_WITH_SSO": "Accedi con l'SSO aziendale",
      "LOGIN_WITH_PASSWORD": "Accedi con la password",
      "PROVIDE_EMAIL": "Fornisci l'indirizzo e-mail",
      "HELP_TEXT": "Hai bisogno di aiuto? Contatta",
      "EMAIL_ERROR": "Impossibile effettuare l'accesso, contatta l'amministratore dell'azienda o il reparto IT.",
      "EMAIL": "Email",
      "LOGIN": "Accedi",
      "ALERT": "Avviso",
      "EMAIL_PLACEHOLDER": "olivia@untitledui.com",
      "LOGIN_CONSENT_MESSAGE": "Effettuando l'accesso al tuo account accetti le {{terminiLink}} e la {{privacyLink}}.",
      "TERMS_OF_SERVICE": "Condizioni di servizio",
      "PRIVACY_POLICY": "Informativa sulla privacy",
      "WRONG_REGION_MESSAGE": "Impossibile effettuare l'accesso, contatta l'amministratore dell'azienda.",
      "WRONG_REGION_LINK": "Puoi anche provare ad accedere al sito {{regionName}}."
    },
    "learningPathway": {
      "BEGIN": "Inizia",
      "DUE_DATE": "Data di scadenza",
      "FOOTER_SUBTITLE_READY": "Chiedimi ciò che vuoi. Sono qua per aiutarti.",
      "LEAVE_STEP": "Esci da questo passaggio",
      "NEXT_STEP": "Passaggio successivo",
      "NOTIFICATIONS_ARIA": "Notifiche",
      "PDF_NEXT_PAGE": "Pagina successiva",
      "PDF_NO_SOURCE": "Nessuna fonte PDF fornita.",
      "PDF_PREVIOUS_PAGE": "Pagina precedente",
      "POST_CALL_SUBTITLE": "Lascia un feedback mentre elaboriamo i tuoi risultati",
      "POST_CALL_TITLE": "Hai raggiunto la fine di questo quiz.",
      "SETTINGS": "Impostazioni",
      "TOAST_CONTENT": "Clicca qui sotto per visualizzarle oppure torna alla schermata dei dettagli del percorso per procedere con il passaggio successivo.",
      "TOAST_TITLE": "I risultati del gioco di ruolo {{stepName}} sono stati elaborati",
      "ASSIGNMENTS": "Incarichi",
      "USER_FALLBACK": "Utente",
      "VIEW_RESULTS": "Visualizza risultati",
      "QUIZ_TITLE": "Quiz",
      "SUBMIT_ANSWER": "Invia risposta",
      "CONTINUE": "Continua",
      "REVIEW_MATERIAL": "Rivedi materiale",
      "ASK_QUESTIONS_ABOUT_PATHWAY": "Fai domande sul percorso",
      "FOOTER_SUBTITLE_MUTED": "Al momento, il tuo audio è disattivato. L'istruttore non può sentirti.",
      "FOOTER_SUBTITLE_LISTENING": "Sto ascoltando la tua domanda...",
      "FOOTER_SUBTITLE_THINKING": "Sto pensando a una risposta...",
      "PDF_LOADING": "Caricamento PDF in corso",
      "PDF_SCROLL_HINT": "Scorri per continuare a leggere",
      "QUIZ_OVERALL_SCORE_TOOLTIP": "Il punteggio complessivo equivale alla media ponderata delle tue risposte per questo tentativo.",
      "QUIZ_COLUMN_DATE": "Data",
      "QUIZ_COLUMN_OVERALL_SCORE": "Punteggio complessivo",
      "QUIZ_COLUMN_ANSWER_POINTS": "Punti di risposta",
      "QUIZ_COLUMN_RESULTS": "Risultati",
      "COMPLETE_STEP": "Completa",
      "ERROR_TITLE": "Qualcosa è andato storto",
      "ERROR_MESSAGE": "Esci e accedi nuovamente al percorso. Se il problema persiste, scrivi un'email all'indirizzo",
      "ERROR_HELP_EMAIL": "help@quantified.ai",
      "PATHWAY_COMPLETED_TITLE": "Hai completato questo percorso",
      "PATHWAY_COMPLETED_BODY": "Puoi rivedere i tuoi risultati in qualsiasi momento o ripercorrere i vari passaggi per continuare a esercitarti.",
      "PATHWAY_COMPLETED_RETURN": "Torna agli incarichi",
      "PATHWAY_OUT_OF_ATTEMPTS_TITLE": "Hai esaurito i tentativi per questo passaggio del percorso",
      "PATHWAY_OUT_OF_ATTEMPTS_BODY": "Contatta il tuo manager per discutere i prossimi passi.",
      "COMPLETED": "Completato",
      "EXITING_QUIZ_EARLY": "Se esci ora dal quiz, perderai questo tentativo",
      "TRY_AGAIN": "Riprova",
      "RETURN_TO_PATHWAY": "Torna alla pagina iniziale del percorso",
      "REVIEW_BEFORE_QUIZ_TOOLTIP": "Rivedi questo passaggio prima di riprovare a svolgere il quiz",
      "FOOTER_SUBTITLE_QUIZ_RESULT_DONE": "Clicca sul pulsante sulla destra →",
      "VIEW_CALL_DETAILS": "Visualizza dettagli chiamata",
      "FOOTER_SUBTITLE_READY_LEARN_WITH_X": "Se hai domande, l'istruttore è in ascolto",
      "COLUMN_DATE": "Data",
      "COLUMN_OVERALL_SCORE": "Punteggio complessivo",
      "COLUMN_RESULTS": "Risultati",
      "COLUMN_ANSWER_POINTS": "Punti di risposta",
      "COLUMN_MESSAGING_SCORE": "Punteggio messaggistica",
      "COLUMN_METHODOLOGY_SCORE": "Punteggio metodologia",
      "COLUMN_SKILLS_SCORE": "Punteggio competenze",
      "PRACTICE_AGAIN": "Esercitati di nuovo",
      "DEBRIEF_LATEST_SESSION": "Resoconto ultima sessione",
      "EXIT_MODAL_TITLE": "Confermi di voler terminare questo gioco di ruolo?",
      "EXIT_MODAL_EXIT": "Esci",
      "EXIT_MODAL_RESUME": "Riprendi",
      "EXIT_MODAL_DESC_LIMITED_ATTEMPTS": "Se esci ora dal gioco di ruolo, non ti verrà assegnato alcun punteggio, ma perderai comunque un tentativo.",
      "EXIT_MODAL_DESC_UNLIMITED_ATTEMPTS": "Se esci ora dal gioco di ruolo, non ti verrà assegnato alcun punteggio.",
      "EXIT_MODAL_DESC_SCORED": "Se esci ora dal gioco di ruolo, valuteremo la tua chiamata così com'è.",
      "RESULTS_PROCESSING": "Elaborazione dei risultati",
      "RESULTS_FAILED": "Impossibile caricare i risultati. Contatta help@quantified.ai",
      "DEBRIEF_TITLE": "Resoconto",
      "DEBRIEF_DESCRIPTION": "Analizza i risultati del tuo ultimo tentativo di certificazione",
      "DEBRIEF_DESCRIPTION_PRACTICE": "Analizza i risultati della tua ultima sessione di esercitazione",
      "VIEW_ALL_SESSIONS": "Vedi tutte le sessioni",
      "COLLAPSE_SESSIONS": "Comprimi sessioni",
      "VIEW_ALL_ATTEMPTS": "Visualizza tutti i tentativi",
      "COLLAPSE_ATTEMPTS": "Comprimi tentativi",
      "REATTEMPT_CERTIFICATION": "Prova di nuovo la certificazione",
      "DEBRIEF_EXIT_MODAL_TITLE": "Confermi di voler terminare questo resoconto?",
      "DEBRIEF_EXIT_MODAL_DESC": "Se esci ora dal resoconto non sarà contrassegnato come completato.",
      "EXIT_PATHWAY": "Esci dal percorso",
      "HELP": "Aiuto",
      "LEARN_STEP_HELP_CLOSE": "Chiudi",
      "LEARN_STEP_HELP_TROUBLE": "Se stai ancora riscontrato problemi, contatta",
      "LEARN_STEP_HELP_EMAIL": "help@quantified.ai",
      "LEARN_STEP_HELP_VIDEO_P1": "Guarda il materiale e poni all'istruttore le domande che desideri.",
      "LEARN_STEP_HELP_VIDEO_P2": "Seleziona il pulsante play per avviare il video. Puoi tornare indietro per rivedere il materiale.",
      "LEARN_STEP_HELP_VIDEO_P3": "Attiva il microfono in basso a destra per porre una domanda. In questo modo, il video verrà messo in pausa. Quando riproduci il video, disattiveremo il tuo microfono.",
      "LEARN_STEP_HELP_VIDEO_P4": "Una volta visto l'intero video, passa al passaggio successivo.",
      "LEARN_STEP_HELP_PDF_P1": "Leggi il materiale e poni all'istruttore le domande che desideri.",
      "LEARN_STEP_HELP_PDF_P2": "Sfoglia il materiale scorrendo la pagina o utilizzando i pulsanti freccia situati ai lati per passare da una pagina all'altra.",
      "LEARN_STEP_HELP_PDF_P3": "Puoi disattivare e riattivare il tuo microfono in basso a destra.",
      "LEARN_STEP_HELP_PDF_P4": "Quando hai letto tutto il materiale, passa alla fase successiva.",
      "PDF_FULLSCREEN_ENTER": "Passa alla modalità a schermo intero",
      "PDF_FULLSCREEN_EXIT": "Esci dalla modalità a schermo intero",
      "PDF_ZOOM_IN": "Ingrandisci",
      "PDF_ZOOM_OUT": "Riduci l'ingrandimento",
      "ASSESSMENT_EXIT_MODAL_TITLE": "Sei sicuro di voler procedere?",
      "ASSESSMENT_EXIT_MODAL_DESC": "Se si passa oltre prima che questa conversazione sia terminata, l'esperienza di apprendimento risulterà più lunga e meno personalizzata.",
      "ASSESSMENT_EXIT_MODAL_RESUME": "Riprendi la valutazione",
      "ASSESSMENT_EXIT_MODAL_PROCEED": "Continua",
      "ASSESSMENT_PERSONALIZATION_ERROR_TITLE": "Non siamo riusciti a personalizzare il tuo percorso",
      "ASSESSMENT_PERSONALIZATION_ERROR_DESC_START": "Ti abbiamo assegnato l'intero percorso: contatta ",
      "ASSESSMENT_PERSONALIZATION_ERROR_DESC_END": " se desideri riprovare a personalizzare",
      "OPTIONAL": "Facoltativo",
      "DISMISS": "Ignora",
      "DOWNLOAD": "Scarica"
    },
    "leaderboard": {
      "LEADERBOARD": "Classifica",
      "TOP10PERCENT": "10% dei migliori",
      "PRACTICE_ASSIGNMENT": "Incarichi di esercitazione",
      "SIMULATION": "Simulazione",
      "SELECT_ASSIGNMENT": "Seleziona incarico",
      "SELECT_SIMULATION": "Seleziona simulazione",
      "SELECT_ASSIGNMENT_AND_SIMULATION": "Seleziona un incarico e una simulazione per vedere la classifica",
      "NO_DATA": "Ancora nessuna attività. Una volta che il team inizia a impegnarsi, la classifica apparirà qui.",
      "NO_ASSIGNMENTS_AVAILABLE": "Nessun incarico disponibile",
      "NO_SIMULATIONS_AVAILABLE": "Nessuna simulazione disponibile",
      "NAME": "Nome",
      "HIGH_SCORE": "Punteggio elevato",
      "AVERAGE_SCORE": "Punteggio medio",
      "TOTAL_SESSIONS": "Totale sessioni",
      "LAST_SESSION": "Ultima sessione",
      "TOP5": "Migliori 5",
      "OF": "di",
      "ENGAGED_USERS": "utenti impegnati",
      "ENGAGED_USER": "utente impegnato",
      "HIDE_SESSIONS_WITH_LOW_SCORE": "Nascondi le sessioni con punteggi di competenza bassi",
      "SESSIONS_WITH_LOW_SCORE_TOOLTIP": "Le sessioni con un punteggio della sezione di competenza equivalente a \"In crescita\" non contribuiranno alle colonne dei punteggi alti o medi.",
      "NO_USERS_ENGAGED": "Nessun utente impegnato",
      "PAGINATION_PREVIOUS": "Precedente",
      "PAGINATION_NEXT": "Successiva"
    },
    "hotjarSurveys": {
      "FEEDBACK_MESSAGE": "Ti invitiamo a condividere il tuo feedback per aiutarci a migliorare.",
      "THANK_YOU_MESSAGE": "Grazie, continueremo a lavorare per migliorare la tua esperienza"
    },
    "general": {
      "NEED_HELP_QUESTION": "Hai bisogno di aiuto?",
      "CONTACT": "Contatta",
      "HELP_EMAIL": "help@quantified.ai",
      "PARENT_ACCOUNT": "Account parent",
      "ACCOUNT": "Account",
      "CHECKMARK": "Segno di spunta",
      "ICON": "Icona",
      "ALERT": "avviso",
      "HEADS_UP": "Attenzione!",
      "USE_HEADPHONES_FOR_OPTIMAL_AUDIO": "Per un audio ottimale su iPad, utilizza le cuffie.",
      "SETTINGS": "IMPOSTAZIONI",
      "RP": "RP",
      "EMAIL_LABEL": "Email",
      "RAVEN_EMAIL": "Raven@InspireHR.com",
      "TEAM_MANAGER_FOR": "Team manager per",
      "MIAMI_SALE": "Vendite a Miami",
      "CHARLOTTE_SALES": "Vendite a Charlotte",
      "ATLANTA_SALES": "Vendite ad Atlanta",
      "TEAM": "Team",
      "ASSIGNMENTS": "Incarichi",
      "MY_TEAMS": "I miei team",
      "REPORTING": "Report",
      "DASHBOARD": "Dashboard",
      "LEADERBOARD": "Classifica",
      "PERSONALIZED_PRACTICE": "Esercitazione personalizzata",
      "HELP_SEARCH_OUR": "Effettua una ricerca nella nostra",
      "HELP_OR_REACH_OUT_TO": "o contatta",
      "HELP_WITH_QUESTIONS": "se hai domande",
      "KNOWLEDGE_BASE": "base di conoscenza",
      "NO_ROLE_WEB_MESSAGE": "A questo utente non è stato concesso l'accesso al sistema. Contatta un amministratore di sistema.",
      "NO_ROLE_IOS_TITLE": "La nostra app è incentrata sull'esperienza dello studente",
      "NO_ROLE_IOS_BODY_START": "Accedi alla nostra",
      "NO_ROLE_IOS_WEB_APP": "app web",
      "NO_ROLE_IOS_BODY_END": "sul browser del tuo dispositivo mobile per usufruire di funzionalità aggiuntive.",
      "HELP_SECTION": "AIUTO",
      "ABOUT_SECTION": "CHI SIAMO",
      "CONTACT_SUPPORT": "Contatta l'assistenza",
      "OPEN_WEB_APP": "Apri l'app web",
      "SEARCH_KNOWLEDGE_BASE": "Cerca nella base di conoscenza",
      "PRIVACY_POLICY": "Informativa sulla privacy",
      "TERMS_OF_SERVICE": "Condizioni di servizio",
      "VERSION": "Versione",
      "LOG_OUT": "Esci"
    },
    "dashboard": {
      "ALL": "Tutti",
      "IN_COMPLETE": "Incompleto",
      "COMPLETED": "Completato",
      "NO_ASSIGNMENT_TITLE": "Non hai incarichi.",
      "NO_ASSIGNMENT_DETAILS": "Ti avviseremo quando avrai degli incarichi da completare.",
      "IN_COMPLETE_ASSIGNMENT_TITLE": "Non ci sono incarichi incompleti.",
      "IN_COMPLETE_ASSIGNMENT_DETAILS": "Ti avviseremo della scadenza di un nuovo incarico.",
      "COMPLETED_ASSIGNMENT_TITLE": "Non hai incarichi completati.",
      "COMPLETED_ASSIGNMENT_DETAILS": "Ricontrolla una volta completato un incarico.",
      "VIEW_ASSIGNMENT": "Visualizza l'incarico",
      "ASSIGNMENT_LABEL": "Incarichi",
      "MODULE_ASSIGNMENT_ALT": "Icona modulo incarico",
      "VIEW_ASSIGNMENT_FOR": "Visualizza l'incarico per",
      "DAY": "Giorno",
      "UNTILL_DUE": "Scadenza",
      "PAST_DUE": "Scaduto",
      "AVAILABLE_IN": "Disponibile tra",
      "DUE_TODAY": "In scadenza oggi",
      "PRACTICE": "Esercitazione",
      "CERTIFICATION": "Certificazione",
      "UPCOMING": "Prossimamente",
      "TEST_ASSIGNMENT": "Incarico di test",
      "CLOSED": "Chiuso",
      "NO_ASSIGNMENT_FILTERED_TITLE": "Nessun incarico trovato.",
      "NO_ASSIGNMENT_FILTERED_DETAILS": "Prova a regolare i tuoi filtri per vedere gli incarichi disponibili oppure controlla più tardi quando verranno aggiunti nuovi incarichi.",
      "VIEW_PATHWAY": "Visualizza percorso",
      "TOTAL": "Totale",
      "STATUS_LABEL": "Stato",
      "STATUS_SELECTION_LABEL": "Stato:",
      "ASSIGNMENT_TYPE": "Tipo di incarico",
      "ASSIGNMENT_TYPE_SELECTION_LABEL": "Tipo di incarico:",
      "NOT_STARTED": "Non iniziato",
      "CERTIFIED": "Certificato",
      "NOT_CERTIFIED": "Non certificato",
      "IN_PROGRESS": "In corso",
      "PATHWAY": "Percorso di apprendimento",
      "SELECT_ALL": "Seleziona tutto",
      "DESELECT_ALL": "Deseleziona tutto",
      "GET_STARTED": "Inizia",
      "ASSIGNMENT_STATUS_LABEL": "Stato dell'incarico",
      "ASSIGNMENT_STATUS_SELECTION_LABEL": "Stato dell'incarico:",
      "CLEAR_STATUS": "Cancella stato",
      "ENDED": "Terminato",
      "START_PATHWAY": "Inizia il percorso",
      "DAYS": "Giorni",
      "OTHERS_SINGULAR": "e 1 altro",
      "OTHERS_PLURAL": "e altri {{ count }}"
    },
    "cognito": {
      "INVITATION_SUBJECT": "Ti diamo il benvenuto su Quantified!",
      "INVITATION_MESSAGE": "Siamo entusiasti di averti a bordo! Segui la procedura seguente per accedere al tuo account per la prima volta.",
      "ACCOUNT_DETAILS": "I dati del tuo account:",
      "USERNAME": "Nome utente",
      "PASSWORD": "Password temporanea",
      "STEPS_LABEL": "Passi successivi per l'accesso",
      "STEP_1": "1. Clicca sul pulsante \"Accedi\" per accedere alla pagina di login.",
      "STEP_2": "2. Inserisci il nome utente e la password temporanea forniti sopra.",
      "STEP_3": "3. Una volta effettuato l'accesso, ti verrà richiesto di impostare una nuova password.",
      "LOGIN_BUTTON": "Accedi",
      "ABOUT_US": "Il simulatore di Quantified è un ambiente virtuale progettato per aiutarti a sviluppare rapidamente le competenze essenziali. Questo ti consente di connetterti e comunicare in modo più efficace con i clienti.",
      "EXPIRY_TIME": "Questa password temporanea scadrà tra 24 ore. In caso di problemi di accesso, contatta il nostro team di assistenza all'indirizzo",
      "TEAM": "Il team Quantified",
      "INVITATION_SMS_USERNAME": "Il tuo nome utente è",
      "INVITATION_SMS_PASSWORD": "e la password temporanea è",
      "AUTHENTICATION_CODE": "Il codice di autenticazione è",
      "PASSWORD_RESET_CODE": "Il codice di reimpostazione della password Quantified",
      "RESET_PASSWORD_EMAIL": "Ripristino della password via e-mail",
      "HELLO": "Ciao",
      "USE_VERIFICATION_CODE": "Hai richiesto la reimpostazione della password. Per completare la procedura, utilizza il codice di verifica riportato di seguito.",
      "VERIFICATION_CODE": "Codice di verifica",
      "NEXT_STEP": "I prossimi passi",
      "RESET_PASSWORD_PAGE": "Torna alla pagina di reimpostazione della password nel browser.",
      "ENTER_VERIFICATION_CODE": "Immetti il codice di verifica quando richiesto.",
      "CREATE_PASSWORD": "Una volta verificato il codice, segui le istruzioni per creare una nuova password.",
      "DISREGARD_NOTE": "Se non hai richiesto la reimpostazione della password, ignora questa e-mail.",
      "CONTACT_SUPPORT": "Per ulteriore assistenza, contatta il nostro team di assistenza all'indirizzo",
      "HELP_EMAIL": "help@quantified.ai",
      "THANK_YOU": "Grazie",
      "QUANTIFIED_TEAM": "Il team Quantified",
      "ADDRESS": "4200 Marathon Blvd, Suite 210, Austin, Texas 78756, Stati Uniti",
      "RETURN_TO_PATHWAY": "Torna alla pagina iniziale del percorso"
    },
    "call": {
      "LOADING": "Caricamento",
      "SIMULATION_PAUSED": "La simulazione è stata messa in pausa.",
      "CLICK_RESUME": "Clicca sul pulsante \"Riprendi\" qui sotto per continuare.",
      "NO_INTERNET": "Nessuna connessione a Internet",
      "TRY_AGAIN": "Controlla la connessione e riprova.",
      "MIC_MUTED": "Il microfono è disattivato",
      "MIC_MUTED_DESCRIPTION": "Ops, sembra che il tuo microfono sia disattivato. Attiva il microfono per rispondere e continuare.",
      "NO_RESPONSE": "Nessuna risposta rilevata",
      "MIC_NOT_CONNECTED": "Ops, sembra che il microfono non sia collegato. Riseleziona il dispositivo per rispondere e continuare.",
      "AUDIO_ISSUE": "Ops, qualcosa è andato storto. Controlla le impostazioni del dispositivo e assicurati di trovarti in un luogo tranquillo e privo di rumori di fondo.",
      "LOADING_ALT": "Caricamento in corso...",
      "REPEAT_RESPONSE": "Il sistema ti rimanderà automaticamente alla simulazione per ripetere la risposta e riprovare.",
      "NEEDS_MORE_TIME_QUESTION": "ha bisogno di più tempo per pensare, vuoi aspettare?",
      "NEEDS_MORE_TIME": "ha bisogno di più tempo per pensare.",
      "WAIT_OR_END_CALL": "Ti comunicheremo quando avrà terminato oppure puoi chiudere la chiamata e",
      "RETURN_TO_ASSIGNMENTS": "ritorna all'incarico",
      "READY": "Pronto",
      "IS_READY": "è pronto per continuare la conversazione.",
      "TRY_AGAIN_LABEL": "Riprova",
      "CHECK_SETTINGS": "Controlla le impostazioni",
      "PAUSED_SIMULATION": "Hai messo in pausa la simulazione.",
      "PAUSED_SIMULATION_DESCRIPTION": "La registrazione video e audio viene messa in pausa fino alla ripresa della simulazione.",
      "RESUME": "Riprendi",
      "SETTINGS": "Impostazioni",
      "CAPTURING_RESPONSE": "Acquisizione delle risposte",
      "TOUR_MESSAGE": "Una volta terminata la conversazione, fai clic sul pulsante Continua per assicurarti che le risposte vengano acquisite e valutate.",
      "NEXT": "Avanti",
      "START_CALL": "Avvia",
      "END_CALL_TITLE": "Confermi di voler terminare questa simulazione?",
      "END_CALL_DESCRIPTION": "Se termini la simulazione ora, riceverai un punteggio o un feedback sulla conversazione.",
      "END_CALL": "Termina",
      "BROWSER_ACCESS_DENIED": "Al browser è negato l'accesso a questo dispositivo.",
      "COPY_SESSION_ID_BUTTON": "Copia ID sessione",
      "TIPS_GUIDANCE_MESSAGE": "I punti di discussione e i suggerimenti appariranno qui.",
      "CONTINUE": "Continua",
      "SESSION_ID_LABEL": "ID sessione:",
      "SESSION_ID_COPIED": "ID sessione copiato!",
      "HINTS_AND_SUGGESTIONS_TITLE": "Suggerimenti e indicazioni",
      "HINT_LABEL": "Suggerimento",
      "CAPTIONS_LABEL": "Didascalie",
      "PAUSE_LABEL": "Metti in pausa",
      "VIDEO_LABEL": "Video",
      "PARTY_EMOJI": "emoji della festa",
      "CALL_ENDED_MESSAGE": "Hai raggiunto la fine di questa simulazione.",
      "CALL_ENDED_INACTIVITY": "La simulazione è terminata per inattività",
      "CALL_ENDED_GENERIC": "La simulazione è terminata",
      "FEEDBACK_PROMPT": "Lascia un feedback mentre elaboriamo i tuoi risultati.",
      "INTERACTION_THRESHOLD_NOT_MET": "Non hai raggiunto la soglia di interazione per il punteggio, riprova.",
      "REALISTIC_CONVERSATION_QUESTION": "La conversazione è stata realistica e naturale?",
      "KNOWLEDGEABLE_PREPARED_QUESTION": "Pensi che questa simulazione ti abbia aiutato a migliorare competenza e preparazione?",
      "FEEDBACK_THANK_YOU": "Grazie per il tuo feedback!",
      "FEEDBACK_IMPROVEMENT_NOTE": "Grazie per il tuo feedback! Lavoreremo per migliorare l'esperienza.",
      "AUDIO": "Audio",
      "VISUAL_AID_LOAD_ERROR": "Impossibile caricare l'aiuto visivo",
      "BEGIN_CALL": "Avvia",
      "LEAVE_CALL_BRIEFING": "Esci dal resoconto",
      "RESTORE_CALL": "Ripristino della simulazione in corso",
      "FEW_SECONDS": "L'operazione potrebbe richiedere alcuni secondi.",
      "CHECK_ALT": "Spunta",
      "COPY_ALT": "Copia",
      "HINTS_ALT": "Suggerimenti",
      "CLOSE_CAPTIONS": "Chiudi didascalie",
      "MICROPHONE_MUTED": "Microfono disattivato",
      "RETURN_TO_CALL": "Torna alla simulazione",
      "YES": "Sì",
      "NO": "No",
      "VIEW_RESULTS": "Visualizza risultati",
      "RETURN_TO_ASSIGNMENT": "Ritorna all'incarico",
      "HAVING_ISSUES": "Stiamo riscontrando problemi di connessione, controlla la connessione a Internet, quindi clicca su OK.",
      "OK": "OK",
      "RESULTS_NOT_GENERATED": "Siamo spiacenti, ma non siamo in grado di generare risultati in questo momento.",
      "INACTIVITY_ALERT_MESSAGE": "La chiamata viene interrotta per inattività. Parlare all'avatar per continuare o selezionare \"Fine chiamata\" per terminare la chiamata.",
      "INACTIVITY_DEFAULT_ALERT_TITLE": "Questa chiamata terminerà tra {{secondsUntilHangup}} secondi",
      "INACTIVITY_SHORT_ALERT_TITLE": "La chiamata terminerà tra pochi secondi",
      "TELL_YOUR_GENDER_HEADING": "Indicaci il tuo genere:",
      "BY_KNOWING_YOUR_GENDER_DESCRIPTION": "Conoscendo il tuo genere, l'avatar può utilizzare una grammatica corretta, rendendo la conversazione più naturale e realistica.",
      "GENDER_SELECTION": "Selezione del genere:",
      "SELECT_OPTION": "Seleziona un'opzione",
      "CONFIRM": "Conferma",
      "MALE": "Uomo",
      "FEMALE": "Donna",
      "NON_BINARY": "Non-binario/altro",
      "PREFER_NOT_TO_ANSWER": "Preferisco non rispondere",
      "NON_BINARY_MESSAGE": "Comprendiamo e rispettiamo la tua identità di genere non binaria. A causa delle attuali limitazioni tecnologiche, usiamo di default i pronomi maschili. Sappi che stiamo lavorando per migliorarci e poter accogliere meglio tutte le identità di genere in futuro. Grazie per la comprensione e la pazienza.",
      "PREFER_NOT_TO_ANSWER_MESSAGE": "Rispettiamo la tua scelta di non fornire un genere. In questi casi, la nostra tecnologia utilizza di default i pronomi maschili a causa delle limitazioni attuali.",
      "DISPLAY_VISUAL_AID": "Display aiuto visivo",
      "FULL_SCREEN": "Schermo intero",
      "COLLAPSE": "Comprimi",
      "COMPLETED_CONVERSATION_MESSAGE": "Grazie per aver completato questa conversazione",
      "CONVERSATION_COMPLETION_FEEDBACK": "Lasciaci un feedback mentre elaboriamo la tua conversazione.",
      "ERROR_MESSAGE": "Si è verificato un errore. Contatta",
      "SAVED_CONVERSATION_MESSAGE": "La tua conversazione è stata salvata.",
      "RETURN_TO_MY_ASSIGNMENTS": "Torna ai miei incarichi",
      "RETURN_TO_PERSONALIZED_PRACTICE": "Torna all'esercitazione personalizzata",
      "PERSONALIZED_CALL_NOTE": "Hai appena completato un'esercitazione personalizzata di conversazione.",
      "LEAVE_STEP_TITLE": "Confermi di voler uscire da questo passaggio?",
      "EXIT": "Esci",
      "CERT_ACK_TITLE": "Conferma di visione del video di certificazione",
      "CERT_ACK_ACCEPT_AND_BEGIN": "Accetta e inizia",
      "CERT_ACK_RESUME_CALL": "Riprendi la chiamata",
      "CERT_ACK_PROCESSING": "Elaborazione in corso...",
      "CERT_ACK_CAMERA_WARNING": "Attiva la videocamera per procedere con la certificazione.",
      "CERT_ACK_CAMERA_OFF_DURING_CALL": "La tua videocamera era spenta. Riattiva la videocamera per riprendere la procedura di certificazione.",
      "CERT_ACK_TEXT_1": "Per garantire l'integrità e l'imparzialità di questa certificazione, la videocamera deve rimanere accesa per tutta la durata della sessione, che verrà monitorata. Questo requisito ha lo scopo di confermare la conformità a tutti gli standard di certificazione.",
      "CERT_ACK_TEXT_2": "Proseguendo, dichiari di aver letto e accettato questi requisiti.",
      "CERT_ACK_END_CALL": "Fine chiamata",
      "LAUNCH_SIMULATION": "Simulazione lancio",
      "DEBRIEF_LATEST_SESSION": "Resoconto ultima sessione",
      "RECONNECTING_AUDIO": "Riconnessione audio in corso...",
      "END": "Termina",
      "START_DEBRIEF": "Resoconto ultima sessione",
      "MOVE_TO_NEXT": "Passa al passaggio successivo",
      "RETRY_ROLEPLAY": "Riprova gioco di ruolo",
      "EXIT_PATHWAY": "Esci dal percorso",
      "PROCESSING": "Elaborazione in corso...",
      "FEEDBACK_PROMPT_REQUIRED": "Lascia un feedback prima di visualizzare i risultati.",
      "MUTE": "Disattiva audio",
      "UNMUTE": "Riattiva audio",
      "SCREENSHARE_LABEL": "Condividi schermo",
      "SCREENSHARE_UNSUPPORTED_TITLE": "{{callName}} utilizza la condivisione dello schermo",
      "SCREENSHARE_UNSUPPORTED_MESSAGE_APP": "Per proseguire con la chiamata, usa la nostra app anziché il browser.",
      "SCREENSHARE_UNSUPPORTED_MESSAGE_DESKTOP": "Per proseguire con la chiamata, accedi da un computer desktop.",
      "SCREENSHARE_UNSUPPORTED_CLOSE_BUTTON": "Chiudi",
      "SCREENSHARE_UNSUPPORTED_GO_TO_APP_BUTTON": "Vai all'app",
      "SCREENSHARE_UNSUPPORTED_GO_TO_APP_UNAVAILABLE": "L'app mobile non è ancora disponibile. Torna a controllare tra poco.",
      "SCREENSHARE_STOP_LABEL": "Interrompi la condivisione dello schermo",
      "SCREENSHARE_PIP_REOPEN_LABEL": "Riapri l'anteprima video",
      "SCREENSHARE_ACTIVE_LABEL": "Al momento, stai condividendo lo schermo",
      "SCREENSHARE_OS_PERMISSION_HINT": "Impossibile avviare la condivisione dello schermo. Abilita la registrazione dello schermo per il tuo browser in Impostazioni di sistema > Privacy e sicurezza, quindi riprova.",
      "SCREENSHARE_SAFARI_BLOCKED_HINT": "Safari ha bloccato la condivisione dello schermo per questa sessione. Esci e accedi nuovamente, quindi riprova."
    },
    "assignment": {
      "STATUS": "STATO",
      "SCORE": "PUNTEGGIO",
      "MUST_ACHIEVE": "Deve raggiungere un",
      "OR_HIGHER": "o superiore",
      "TEST": "Test",
      "OUT_OF_5": "su 5",
      "LATEST_ATTEMPT": "ULTIMO TENTATIVO",
      "TOTAL_ATTEMPTS": "tentativi totali",
      "UNLIMITED": "Illimitato",
      "REMAINING": "Rimanente",
      "VIEW_CALL_DETAILS": "Visualizza dettagli",
      "MAX_ATTEMPTS_REACHED": "Hai raggiunto il numero massimo di tentativi",
      "DUE_DATE": "Data di scadenza",
      "DAYS": "Giorni",
      "DAY": "Giorno",
      "UNTILL_DUE": "Scadenza",
      "PAST_DUE": "Scaduto",
      "ONGOING": "In corso",
      "SCORE_REQUIREMENT": "Requisito punteggio",
      "SCORE_REQUIREMENT_DETAIL": "È necessario raggiungere un punteggio di",
      "TO_COMPLETE_EACH_CALL": "per completare ogni simulazione richiesta.",
      "CALLS_IN_ASSIGNMENT": "Simulazioni nell'incarico",
      "INCOMPLETE_CALL": "Incompleto",
      "PREVIOUS_RESULTS": "Risultati precedenti",
      "DATE": "Data",
      "RESULTS": "Risultati",
      "VIEW_PREVIOUS_RESULTS": "Visualizza risultati precedenti",
      "VIEW_FEEDBACK": "Visualizza feedback",
      "LAUNCH_CALL": "Lancia",
      "CLOSE_BUTTON": "Pulsante di chiusura",
      "CHECKMARK": "segno di spunta",
      "CALL": "Chiamata",
      "QUESTION": "Domanda",
      "COMPLETED": "Completato",
      "IN_PROGRESS": "In corso",
      "NOT_STARTED": "Non iniziato",
      "CERTIFIED": "Certificato",
      "GUIDED": "Guidata",
      "CONVERSATIONAL": "Conversazionale",
      "GUIDED_SIMULATION": "Controllo delle conoscenze",
      "CONVERSATIONAL_SIMULATION": "Gioco di ruolo",
      "NO_ATTEMPTS_LEFT": "Non ci sono più tentativi",
      "NO_ATTEMPTS": "Nessun tentativo",
      "OVERVIEW": "Panoramica",
      "ABOUT_THE_AVATAR": "Informazioni sull'Avatar",
      "SCORING_CRITERIA": "Criteri di valutazione",
      "SIMULATION_OVERVIEW": "Panoramica della simulazione",
      "ABOUT_THE_PERSONA": "Informazioni sulla persona",
      "OUTOF_COMPLIANCE": "Non conforme",
      "CLOSED": "Chiuso",
      "COMPLETED_CALLS": "Chiamate completate"
    }
  },
  "fr-FR": {
    "root": {
      "ADMIN_PORTAL": "PORTAIL ADMIN",
      "SUPPORT": "ASSISTANCE",
      "U": "U",
      "USER": "Utilisateur",
      "LOGOUT": "Déconnexion",
      "ADMIN": "Administrateur",
      "SUPPORT_SMALL": "Assistance",
      "QUANTIFIED_AI": "Quantified.AI",
      "MICROPHONE": "MICROPHONE",
      "CAMERA": "CAMÉRA",
      "ACCESS_DENIED": "ACCÈS_REFUSÉ"
    },
    "teams": {
      "MY_TEAMS": "Mes équipes",
      "COMPLETED": "Terminé",
      "IN_PROGRESS": "En cours",
      "NOT_STARTED": "Non commencée",
      "ASSIGNMET_MODULE": "Module de mission",
      "START_DATE": "Date de début",
      "DUE_DATE": "Date d’échéance",
      "ASSIGNED_MEMBERS": "Membres assignés",
      "CALLS_IN_MODULE": "Simulations dans le module",
      "COMPLETION_REQUIRMENT": "Condition d’achèvement",
      "COMPLETE_ALL_CALLS": "Terminez toutes les simulations avec une note de",
      "OR_HIGHER": "ou plus",
      "PROGRESS_OVERVIEW": "APERÇU DE LA PROGRESSION",
      "TEAM_MEMBERS": "membres de l’équipe",
      "AVERAGE_HIGH_SCORE": "Moyenne des meilleures notes",
      "AVERAGE_NUMBER_ATTEMPTS_CALL": "Nombre moyen de tentatives par simulation",
      "TOTAL_PRACTICES": "Nombre total d’entraînements",
      "INDIVIDUAL_CALL_PROGRESS": "PROGRESSION DE SIMULATION INDIVIDUELLE",
      "OF_TEAM_MEMBERS": "des membres de l’équipe ont terminé",
      "AVERAGE_PRACTICES_TO_COMPLETION": "Entraînements moyens jusqu’à l’achèvement",
      "TEAM_MEMBER_DETAILS": "INFORMATIONS SUR LES MEMBRES DE L’ÉQUIPE",
      "DOWNLOAD_ACTIVITY_REPORT": "Télécharger le rapport d’activité",
      "TEAM_MEMBER": "Membre de l’équipe",
      "PROGRESS": "Progression",
      "CALLS_COMPLETED": "Simulations terminées",
      "PRACTICES": "Sessions d’entraînement",
      "MOST_RECENT_PRACTICE": "Session la plus récente",
      "THIS_TEAM_HAS_NO_ACTIVE_ASSIGNMENTS": "Cette équipe n’a pas de missions actives pour le moment",
      "CALL_NAME_LABEL": "Nom de la simulation",
      "HIGHEST_SCORE": "Meilleure note"
    },
    "simulationBuilder": {
      "THRESHOLD": "Seuil",
      "TYPE": "Type",
      "SELECT_AN_OPTION": "Sélectionner une option",
      "CORRECT_FEEDBACK": "Retour d’information correct",
      "INCORRECT_FEEDBACK": "Retour d’information incorrect",
      "CORRECT_FEEDBACK_PLACEHOLDER": "S'affiche lorsque l'apprenant répond correctement",
      "INCORRECT_FEEDBACK_PLACEHOLDER": "S'affiche lorsque l'apprenant se trompe",
      "ENTER_MESSAGE_TEXT": "Saisissez le texte du message…",
      "DELETE": "Supprimer",
      "SCORABLE": "Notable",
      "MESSAGE_NUMBER": "Message {{index}}",
      "SEARCH_BY_SIMULATION_NAME": "Chercher par nom de simulation",
      "SEARCH_BY_ASSIGNMENT_NAME": "Chercher par nom de mission",
      "SIMULATION_STATUS_PLACEHOLDER": "État de la simulation",
      "SIMULATION_STATUS_PREFIX": "État de la simulation:",
      "NO_SIMULATIONS_FOUND": "Aucune simulation trouvée",
      "SELECT_ALL": "Sélectionner tout",
      "DESELECT_ALL": "Désélectionner tout",
      "STATUS_TESTING": "Essais",
      "STATUS_DRAFT": "Brouillon",
      "STATUS_PUBLISHED": "Publié",
      "STATUS_ARCHIVED": "Archivé",
      "ASSIGNEES_ZERO_STATE_MESSAGE": "Aucun utilisateur n'a encore été assigné",
      "ADD_USERS_TO_ASSIGNMENT": "Ajouter des utilisateurs à la mission",
      "NO_DATA_FOUND": "Aucune donnée n’a été trouvée",
      "NO_USERS_SELECTED": "Aucun utilisateur sélectionné",
      "COL_FIRST_NAME": "Prénom",
      "COL_LAST_NAME": "Nom de famille",
      "COL_EMAIL": "E-mail",
      "COL_VIEW_USER": "Voir l'utilisateur",
      "COL_VIEW_ASSIGNMENT": "Voir la mission",
      "COL_ASSIGNMENT_NAME": "Nom de la mission",
      "COL_STATUS": "État",
      "COL_TEAM_ASSOCIATIONS": "Associations d’équipes",
      "COL_REPORTING_STATUS": "État du rapport",
      "BREADCRUMB_USERS": "Utilisateurs",
      "STATUS_STAGED": "Configuré",
      "STATUS_ACTIVE": "Actif",
      "STATUS_ENDED": "Terminé",
      "STATUS_CLOSED": "Fermé",
      "SEARCH_USERS_PLACEHOLDER": "Chercher des utilisateurs",
      "NO_USERS_FOUND": "Aucun utilisateur trouvé",
      "USERS_TAB_LABEL": "Utilisateurs",
      "ADD_TO_ASSIGNMENT": "Ajouter à la mission",
      "ASSIGNMENTS_COUNT": "missions",
      "REPORTING_EXCLUDED": "Exclu",
      "REPORTING_INCLUDED": "Inclus",
      "KEBAB_EDIT_TEAM_ASSOCIATIONS": "Modifier les associations d'équipes",
      "KEBAB_EXCLUDE_FROM_REPORTING": "Exclure du rapport",
      "KEBAB_INCLUDE_IN_REPORTING": "Inclure dans le rapport",
      "KEBAB_REMOVE_FROM_ASSIGNMENT": "Supprimer de la mission",
      "NO_TEAMS": "—",
      "TEAMS_COUNT": "{{count}} équipes",
      "ADD_TO_ASSIGNMENT_MODAL_HEADING": "Ajouter à la mission",
      "FIELD_LABEL_ASSIGNMENT": "Mission",
      "SEARCH_ASSIGNMENTS_PLACEHOLDER": "Chercher des missions",
      "BUTTON_SET_TEAM_ASSOCIATION": "Définir l'association d’équipe",
      "FIELD_LABEL_TEAM": "Équipe",
      "SEARCH_TEAM_PLACEHOLDER": "Chercher une équipe",
      "BUTTON_BACK": "Retour",
      "BUTTON_CANCEL": "Annuler",
      "BUTTON_ADD_TO_ASSIGNMENT": "Ajouter à la mission",
      "EDIT_TEAM_ASSOCIATIONS_HEADING": "Modifier les associations d'équipes",
      "EDIT_TEAM_ASSOCIATIONS_DESCRIPTION": "Pour la mission {{assignmentName}}",
      "BUTTON_SAVE_ASSOCIATIONS": "Enregistrer les associations",
      "REFERENCE_DOCUMENT_STATUS_UPLOADING": "– En cours de téléchargement…",
      "REFERENCE_DOCUMENT_STATUS_SUCCESS": "– Téléchargement effectué à 100 %",
      "REFERENCE_DOCUMENT_STATUS_ERROR": "– Erreur de téléchargement",
      "CREATE_SIMULATION_DETAILS_BUTTON": "Créer les détails de la simulation",
      "SELF_AUTHORING_DESCRIPTION": "Indiquez un nom, une brève description du scénario, et fournissez tout document propre à la simulation pour commencer",
      "CLICK_TO_UPLOAD": "Cliquer pour télécharger",
      "OR_DRAG_AND_DROP": "ou faire glisser",
      "REFERENCE_DOCUMENTS_UPLOAD_DESCRIPTION": "PDF (50 Mo max.)",
      "ASSIGNMENT_NAME_LABEL": "Nom de la mission *",
      "SIMULATION_NAME_LABEL": "Nom de la simulation",
      "NAME_FIELD_DESCRIPTION": "Ce nom peut être modifié ultérieurement",
      "PRODUCT_LABEL": "Produit",
      "SELECT_A_PRODUCT_PLACEHOLDER": "Sélectionner un produit",
      "ADD_NEW_PRODUCT": "Ajouter un nouveau produit",
      "SCENARIO_LABEL": "Scénario",
      "REFERENCE_DOCUMENTS_LABEL": "Documents de référence",
      "ACTION_CREATE_NEW": "Créer un nouveau",
      "ACTION_CREATE": "Créer",
      "ACTION_DUPLICATE": "Dupliquer",
      "ENTITY_TYPE_SIMULATION_DISPLAY": "Simulation",
      "ENTITY_TYPE_ASSIGNMENT_DISPLAY": "Mission",
      "ENTITY_TYPE_SIMULATION_LOWER": "simulation",
      "ENTITY_TYPE_ASSIGNMENT_LOWER": "mission",
      "MODAL_TITLE": "{{ action }} {{ type }}",
      "CONFIRM_BUTTON_LABEL": "{{ action }} {{ type }}",
      "DUPLICATE_NAME_ERROR_ASSIGNMENT": "Il existe déjà une mission portant ce nom.",
      "DUPLICATE_NAME_ERROR_SIMULATION": "Il existe déjà une simulation portant ce nom.",
      "NAME_REQUIRED_ERROR": "Le nom est obligatoire.",
      "COPY_OF_PREFIX": "Copie de - {{ name }}",
      "SCORE_DISTRIBUTION_TITLE": "Répartition actuelle des notes",
      "EDIT_SECTIONS_AND_WEIGHTING": "Modifier les sections et la pondération",
      "SCORING_WEIGHTS_TITLE": "Configurer la notation",
      "SCORING_WEIGHTS_DESCRIPTION": "Choisissez les domaines à noter et la part de chacun dans la note globale. La somme des pondérations de toutes les sections activées doit être égale à 100 %. La section « Compétences » ne peut pas avoir une pondération supérieure à 20 %.",
      "SCORING_WEIGHT_REQUIRED": "Obligatoire",
      "REFERENCE_DOCUMENT_STATUS_DELETING": "– Suppression",
      "REFERENCE_DOCUMENT_DELETE_ERROR": "La suppression du document a échoué. Veuillez réessayer.",
      "REFERENCE_DOCUMENT_UPLOAD_ERROR": "Le téléchargement du document a échoué. Veuillez réessayer.",
      "CONTENT_LIMIT_EXCEEDED_ERROR": "Limite de contenu dépassée. Supprimez un ou plusieurs documents pour continuer.",
      "LAST_FACT_DELETE_WARNING_HEADING": "Supprimer le dernier fait ?",
      "LAST_FACT_DELETE_WARNING_DESCRIPTION": "La suppression du dernier fait supprimera toutes les associations d'utilisateur avec cette simulation et rétablira son état de brouillon.",
      "LEAVE_CONFIRMATION_HEADING": "Quitter la création de simulation",
      "LEAVE_CONFIRMATION_DESCRIPTION": "Souhaitez-vous vraiment quitter ? Toute votre progression sera perdue.",
      "LEAVE_CONFIRMATION_LEAVE_BUTTON": "Quitter",
      "METHODOLOGY_TITLE": "Méthodologie",
      "METHODOLOGY_SUBTITLE": "Notez l'approche et la structure de l'appel",
      "METHODOLOGY_WEIGHTING_LABEL": "Pondération : {{ weight }} %",
      "METHODOLOGY_RUBRIC_LABEL": "Rubrique de méthodologie",
      "SELECT_RUBRIC_PLACEHOLDER": "Sélectionner la rubrique",
      "SKILLS_TITLE": "Compétences",
      "SKILLS_SUBTITLE": "Noter la communication et les compétences relationnelles",
      "SKILLS_WEIGHTING_LABEL": "Pondération : {{ weight }} %",
      "SKILLS_RUBRIC_LABEL": "Rubrique de compétences",
      "PROCESSING_DOCUMENTS_MESSAGE": "Traitement des documents…",
      "PROCESSING_DOCUMENTS_SUPPORTING_TEXT": "N'hésitez pas à vous absenter un instant. Les résultats seront prêts dans 5 minutes.",
      "CORE_SIGNAL_MESSAGE": "Interprétation de votre contenu...",
      "SECTION_PLAN_MESSAGE": "Planification de la structure de votre simulation…",
      "DERIVED_COMPONENT_MESSAGE": "Création des éléments de votre simulation…",
      "COMPONENT_WAVE_1_MESSAGE": "Rédaction du contenu de votre simulation…",
      "STILL_PROCESSING_TITLE": "Toujours en cours de traitement…",
      "STILL_PROCESSING_BODY": "Cela prend plus de temps que d'habitude. Vous pouvez quitter cette simulation et y revenir plus tard à partir de la liste des simulations.",
      "PROCESSING_FAILED_TITLE": "Échec du traitement",
      "PROCESSING_FAILED_BODY": "Une erreur s'est produite lors du traitement de vos documents. Veuillez réessayer. Contactez ",
      "TEST_SIMULATION_BUTTON": "Tester la simulation",
      "SIMULATION_PROCESSED_TITLE": "Documents traités",
      "SIMULATION_PROCESSED_BODY": "Les documents de votre simulation ont été traités.",
      "SIMULATION_DOCUMENTS_PROCESSED_TITLE": "Documents de simulation traités.",
      "SIMULATION_DOCUMENTS_PROCESSED_BODY": "Les documents que vous avez téléchargés pour la simulation {{ name }} ont été traités.",
      "SIMULATION_DOCUMENTS_FAILED_TITLE": "Le traitement des documents de simulation a échoué.",
      "SIMULATION_DOCUMENTS_FAILED_BODY": "Les documents que vous avez téléchargés pour la simulation {{ nom }} n'ont pas été traités.",
      "DISMISS": "Rejeter",
      "VIEW_SIMULATION": "Voir la simulation",
      "FACT_MESSAGE_LABEL": "Message",
      "FACT_MESSAGE_DESCRIPTION": "Les messages doivent contenir une seule information, rédigée sous forme de phrase complète. Veillez à ce qu’ils soient précis, simples et d’une portée limitée. Évitez les messages qui pourraient n’être formulés que partiellement.",
      "FACT_INCORRECT_ANSWER_LABEL": "Texte de réponse incorrecte",
      "FACT_INCORRECT_ANSWER_DESCRIPTION": "Texte que voit l'apprenant s'il se trompe sur ce fait",
      "SHOW_INCORRECT_ANSWER_TEXT": "Afficher un texte alternatif pour les réponses incorrectes",
      "ADD_NEW_FACT": "Ajouter un nouveau fait",
      "FACT_SINGULAR": "fait",
      "FACT_PLURAL": "faits",
      "FACT_EXTRACTED_SINGULAR": "{{ count }} fait extrait",
      "FACT_EXTRACTED_PLURAL": "{{ count }} faits extraits",
      "REVIEW_REQUIRED_LABEL": "Révision suggérée",
      "MESSAGING_TITLE": "Messages",
      "MESSAGING_SUBTITLE": "Évaluer si les faits clés sont communiqués",
      "COMPONENT_WAVE_2_MESSAGE": "Affinage du contenu de votre simulation…",
      "COMPONENT_WAVE_3_MESSAGE": "Finalisation du contenu de votre simulation…",
      "MESSAGE_ADHERENCE_MESSAGE": "Proposition de critères de notation des messages...",
      "ASSEMBLING_MESSAGE": "Assemblage de votre simulation",
      "PROCESSING_FAILED_SUFFIX": " si le problème persiste.",
      "BUTTON_RETRY": "Réessayer",
      "TOKEN_LIMIT_EXCEEDED_BODY_PREFIX": "Limite de contenu dépassée. Supprimez un ou plusieurs documents et réessayez, ou contactez ",
      "TOKEN_LIMIT_EXCEEDED_BODY_SUFFIX": " si le problème persiste.",
      "AVATAR_LOOK_LABEL": "Apparence",
      "AVATAR_SELECT_PLACEHOLDER": "Sélectionner un avatar",
      "AVATAR_VOICE_LABEL": "Voix",
      "AVATAR_ALT": "Avatar",
      "PLAY_VOICE_PREVIEW_BUTTON": "Écouter un aperçu de la voix",
      "VOICE_OPTION_1": "Voix 1",
      "VOICE_OPTION_2": "Voix 2",
      "BACK_TO_SIMULATION_DETAILS_BUTTON": "Retourner aux détails de la simulation",
      "AVATAR_SELECTION_TITLE": "Sélection de l’avatar",
      "VIEW_DOCUMENTS": "Voir les documents",
      "SELECT_AVATAR_BUTTON": "Sélectionner un avatar",
      "REQUEST_CHANGES_PLACEHOLDER": "Demander à modifier les informations ci-dessus",
      "CALL_DETAILS_LOAD_ERROR": "Nous n'avons pas pu charger les détails de votre appel. Veuillez réessayer.",
      "FACTS_CANNOT_BE_EMPTY": "Les faits ne peuvent pas être vides. Ajoutez un message à chaque fait avant de le tester ou de le publier.",
      "FINISHING_SIMULATION_MESSAGE": "Finalisation de votre simulation…",
      "BLANK_THEME_MESSAGE_TOOLTIP": "Ajoutez du texte au message vide avant d’ajouter un nouveau thème.",
      "BLANK_MESSAGE_TOOLTIP": "Ajoutez du texte à ce message avant d’en ajouter un autre.",
      "ADD_NEW_THEME_BUTTON": "Ajouter un nouveau thème",
      "ADD_THEME_BUTTON": "Ajouter un thème",
      "ADD_MESSAGE_BUTTON": "Ajouter un message",
      "SCORE_LAST_SESSION": "Noter ma dernière session",
      "SCORE_LAST_SESSION_MODAL_HEADING": "Noter la dernière session",
      "SCORE_LAST_SESSION_MODAL_DESCRIPTION": "Testez d'abord la simulation, puis revenez ici pour la noter en fonction de la rubrique sélectionnée.",
      "SCORE_LAST_SESSION_MODAL_ERROR_HEADING": "Un problème est survenu",
      "SCORE_LAST_SESSION_MODAL_ERROR_DESCRIPTION": "Réessayez.",
      "REFINEMENT_THINKING_MESSAGE": "Réflexion en cours…",
      "REFINEMENT_UPDATED_MESSAGE": "Mis à jour",
      "REFINEMENT_WARNING_PREFIX": "Ces informations ont été modifiées manuellement. Veuillez contacter",
      "REFINEMENT_WARNING_SUFFIX": "pour toute mise à jour.",
      "REFINEMENT_ERROR_PREFIX": "Je ne peux malheureusement pas vous aider sur ce point, mais",
      "REFINEMENT_ERROR_SUFFIX": "le pourra peut-être.",
      "REFINEMENT_APPLIED_TITLE": "Les modifications demandées ont été appliquées.",
      "REFINEMENT_APPLIED_BODY": "Les modifications que vous avez demandées pour la simulation {{ name }} ont été appliquées.",
      "REFINEMENT_FAILED_TITLE": "Les modifications demandées ont échoué.",
      "REFINEMENT_FAILED_BODY": "Nous n'avons pas pu appliquer les modifications que vous avez demandées pour la simulation {{ name }}.",
      "WHAT_USERS_SEE_DESCRIPTION_TITLE": "Description de la simulation",
      "WHAT_USERS_SEE_DESCRIPTION_HELPER": "Les informations mises à jour dans l’onglet Général seront reprises ici, sauf en cas de mise à jour manuelle.",
      "WHAT_USERS_SEE_DESCRIPTION_FIELD_LABEL": "Description",
      "WHAT_USERS_SEE_DETAILS_TITLE": "Détails de la simulation",
      "WHAT_USERS_SEE_DETAILS_HELPER": "Il s’agit du contenu qui sera présenté à l’utilisateur avant qu’il commence la simulation. Les informations mises à jour dans l’onglet Général seront reprises ici, sauf en cas de mise à jour manuelle. Les sections laissées vides ne seront pas montrées à l'apprenant. Toutes les sections prennent en charge le formatage Markdown.",
      "WHAT_USERS_SEE_OVERVIEW_FIELD_LABEL": "Aperçu de la simulation",
      "WHAT_USERS_SEE_PERSONA_FIELD_LABEL": "À propos de la persona",
      "WHAT_USERS_SEE_SCORING_FIELD_LABEL": "Critères de notation",
      "WHAT_USERS_SEE_SCORING_FIELD_HELPER": "Cette section est remplie par les choix effectués dans l'onglet de notation. Le fait de modifier ces informations n'aura aucune incidence sur la notation de la simulation.",
      "WHAT_USERS_SEE_PREVIEW_DETAILS_CTA": "Voir un aperçu de la fenêtre contextuelle des détails de la simulation",
      "WHAT_USERS_SEE_PREVIEW_CARD_CTA": "Voir un aperçu de la carte de la simulation",
      "TAB_GENERAL": "Général",
      "TAB_CONTENTS": "Sommaire",
      "TAB_KEY_WORDS": "Mots-clés",
      "TAB_SCORING": "Notation",
      "TAB_TESTING": "Essais",
      "TAB_PROMPTS": "Invites",
      "TAB_WHAT_USERS_SEE": "Ce que voient les utilisateurs",
      "ACCURACY_FEEDBACK_TITLE": "Retour d'information sur l’exactitude",
      "ACCURACY_FEEDBACK_DESCRIPTION": "Évaluez l'exactitude de chaque déclaration faite par un représentant par rapport aux documents téléchargés",
      "ACCURACY_FEEDBACK_STATUS_ON": "Activé",
      "ACCURACY_FEEDBACK_STATUS_OFF": "Désactivé",
      "ACCURACY_FEEDBACK_STATUS_DISABLED": "Désactivé",
      "ACCURACY_FEEDBACK_NO_DOCUMENTS": "La notation de l’exactitude n'est pas disponible, car aucun document associé n'a été ajouté.",
      "SCORING_AI_REVIEW_NOTICE": "Une partie du contenu de cet onglet a été générée à partir des documents que vous avez fournis. Vérifiez l’exactitude de l’ensemble du contenu avant de publier cet appel.",
      "EXPORT_SIMULATION_SUMMARY_BUTTON": "Exporter le résumé de la simulation",
      "CALL": "Appeler",
      "REFINEMENT_OVERRIDDEN_PREFIX": "Ces informations ont été modifiées manuellement. Veuillez contacter",
      "REFINEMENT_OVERRIDDEN_SUFFIX": "pour toute mise à jour.",
      "SUPPORT_EMAIL": "help@quantified.ai",
      "WHAT_USERS_SEE_OVERRIDE_WARNING_TITLE": "La modification de ces champs bloquera toute actualisation ultérieure",
      "WHAT_USERS_SEE_OVERRIDE_WARNING_BODY": "La mise à jour manuelle de ces sections les empêchera de recevoir des actualisations supplémentaires issues du processus d’affinement de l’onglet Général.",
      "WHAT_USERS_SEE_DETAILS_OVERRIDE_EDITED_TITLE": "Ces champs ont été modifiés",
      "WHAT_USERS_SEE_DETAILS_OVERRIDE_EDITED_BODY": "Ils ne recevront plus les actualisations d’affinement effectuées dans l’onglet Général",
      "SIMULATION_BUILDER_HEADING": "Créateur de simulation",
      "ASSIGNMENTS_TAB_LABEL": "Missions",
      "SIMULATIONS_TAB_LABEL": "Simulations",
      "CREATE_NEW_ASSIGNMENT_BUTTON": "Créer une nouvelle mission",
      "CREATE_NEW_SIMULATION_BUTTON": "Créer une nouvelle simulation",
      "NO_ASSIGNMENTS_FOUND": "Aucune mission trouvée",
      "ASSIGNMENT_STATUS_PLACEHOLDER": "État de la mission",
      "ASSIGNMENT_STATUS_PREFIX": "État de la mission :",
      "ASSIGNMENT_TYPE_LABEL": "Type de mission",
      "SELECT_ASSIGNMENT_TYPE_PLACEHOLDER": "Sélectionner un type de mission",
      "NAME_LABEL": "Nom",
      "ASSIGNMENT_NAME_PLACEHOLDER": "Nom de la mission",
      "PASSING_SCORE_LABEL": "Note minimale",
      "PASSING_SCORE_OPTIONAL_LABEL": "Note minimale (facultatif)",
      "SCORE_MAX_EXCEEDED_ERROR": "La note ne doit pas dépasser 5",
      "GET_HELP_BUTTON": "Obtenir de l’aide",
      "PASSING_SCORE_TOOLTIP": "Ce paramètre définit la note globale qu’un apprenant doit obtenir pour réussir la simulation.",
      "DESCRIPTION_LABEL": "Description",
      "ASSIGNMENT_DESCRIPTION_PLACEHOLDER": "Description de la mission",
      "MESSAGING_FEEDBACK_LABEL": "Retour d’information de la messagerie",
      "MESSAGING_FEEDBACK_TOOLTIP_HEADING": "Retour d’information de la messagerie",
      "MESSAGING_FEEDBACK_TOOLTIP_BODY": "Lorsqu'un apprenant formule incorrectement un message, des informations lui sont présentées pour l'aider à mieux l'exprimer la prochaine fois. Ce paramètre permet d’activer ou de désactiver l’affichage de ces informations.",
      "ENABLED_TEXT": "Activé",
      "DISABLED_TEXT": "Désactivé",
      "PAUSE_BUTTON_LABEL": "Bouton de mise en pause",
      "ASSIGNMENT_START_DATE_LABEL": "Date de début de la mission",
      "SELECT_DATE_PLACEHOLDER": "Sélectionner une date",
      "ASSIGNMENT_END_DATE_LABEL": "Date de fin de la mission",
      "ASSIGNMENT_END_DATE_OPTIONAL_LABEL": "Date de fin de la mission (facultatif)",
      "END_DATE_RANGE_ERROR": "La date de début et la date de fin ne peuvent pas être identiques",
      "ASSIGNMENT_INFORMATION_TITLE": "Informations sur la mission",
      "ASSIGNMENT_TYPE_CERTIFICATION": "Certification",
      "ASSIGNMENT_TYPE_PRACTICE": "Entraînement",
      "ASSIGNMENT_TYPE_PERSONALIZED_PRACTICE": "Entraînement personnalisé",
      "BUTTON_SAVE_AND_CLOSE": "Enregistrer et fermer",
      "BUTTON_ADD_SIMULATIONS": "Ajouter des simulations",
      "ATTEMPTS_UNLIMITED": "Illimité",
      "SEARCH_FOR_SIMULATION_LABEL": "Recherche de simulation",
      "SIMULATION_NAME_PLACEHOLDER": "Nom de la simulation",
      "BUTTON_REMOVE_ALL": "Tout supprimer",
      "SIMULATIONS_IN_ASSIGNMENT_LABEL": "Simulations de la mission",
      "BUTTON_ASSIGN_LEARNERS": "Attribuer des apprenants",
      "CALL_TYPE_UNKNOWN": "Inconnu",
      "ASSIGNMENT_COUNT_NONE": "Aucun",
      "ASSIGNMENT_COUNT_SINGULAR": "{{ count }} mission",
      "ASSIGNMENT_COUNT_PLURAL": "{{ count }} missions",
      "ERROR_LOADING_ASSIGNMENTS": "Erreur lors du chargement des missions",
      "SEARCH_ASSIGNEES_TITLE": "Chercher des apprenants attribués",
      "DIALOG_DESCRIPTION_ADD_USERS": "Sélectionnez les utilisateurs qui participeront à la mission. La recherche d'une équipe vous permettra d'attribuer des utilisateurs donnés dans cette équipe, ou d’annuler leur attribution. Lorsque vous sélectionnez un utilisateur en particulier, assurez-vous qu’il est associé à la bonne équipe à des fins de rapport.",
      "ADD_USERS_TO_ASSIGNMENT_HEADING": "Ajouter des utilisateurs à la mission",
      "BUTTON_REVIEW_SELECTED_USERS": "Vérifier les utilisateurs sélectionnés",
      "FIND_USERS_LABEL": "Chercher des utilisateurs",
      "BUTTON_CLEAR": "Effacer",
      "LEARNER_COUNT_NONE": "Aucun",
      "LEARNER_COUNT_SINGULAR": "{{ count }} apprenant",
      "LEARNER_COUNT_PLURAL": "{{ count }} apprenants",
      "ASSIGNMENT_TAB_DETAILS": "Détails",
      "ASSIGNMENT_TAB_SIMULATIONS": "Simulations",
      "ASSIGNMENT_TAB_ASSIGNEES": "Apprenants attribués",
      "LOADING_ASSIGNMENT_DETAILS": "Chargement des détails de la mission…",
      "BREADCRUMB_ASSIGNMENTS": "Missions",
      "ASSIGNMENTS_COL_NAME": "Nom",
      "ASSIGNMENTS_COL_START_DATE": "Date de début de la mission",
      "ASSIGNMENTS_COL_END_DATE": "Date de fin de la mission",
      "ASSIGNMENTS_COL_LEARNERS": "Apprenant attribué",
      "ASSIGNMENTS_COL_TYPE": "Type de mission",
      "ASSIGNMENTS_COL_STATUS": "État de la mission",
      "SIMULATIONS_COL_NAME": "Nom",
      "SIMULATIONS_COL_PRODUCT": "Produit",
      "SIMULATIONS_COL_DATE_MODIFIED": "Date de la dernière modification",
      "SIMULATIONS_COL_STATUS": "État",
      "SIMULATIONS_COL_USED_IN": "Utilisée dans",
      "SIMULATIONS_COL_TYPE": "Type de simulation",
      "SIMULATIONS_COL_DATE_PUBLISHED": "Date de publication",
      "CONVERSE_PROMPT_LABEL": "Invite de conversation",
      "CONVERSE_PROMPT_EXPAND_TO_EDIT": "Développer pour modifier",
      "CONVERSE_PROMPT_ENTER_LABEL": "Saisissez ici l'invite de conversation *",
      "CONVERSE_PROMPT_EDITING_HEADING": "Modification de l’invite de conversation",
      "CONVERSE_PROMPT_OVERRIDE_CONFIRMATION_HEADING": "Confirmation de modification de l’invite",
      "CONVERSE_PROMPT_OVERRIDE_DESCRIPTION": "Voulez-vous vraiment modifier l'invite de conversation ? En cas de modification, les auteurs perdront l'accès à l'affinement en libre-service.",
      "CONVERSE_PROMPT_FIELD_LABEL": "Invite de conversation",
      "CONVERSE_PROMPT_SAVE_BUTTON": "Enregistrer l’invite",
      "BUTTON_CONFIRM": "Confirmer",
      "DELETE_SIM_HEADING": "Supprimer la simulation",
      "DELETE_SIM_CONTENT": "Cette simulation sera supprimée. Toutes les missions tests associées à la simulation seront également supprimés.",
      "DELETE_SIM_LABEL": "Supprimer la simulation",
      "DELETE_ASSIGNMENT_HEADING": "Supprimer la mission",
      "DELETE_ASSIGNMENT_CONTENT": "Cette mission sera définitivement supprimée.",
      "DELETE_ASSIGNMENT_LABEL": "Supprimer la mission",
      "DELETE_ASSIGNMENT_NON_STAGED_CONTENT": "Pour supprimer une mission dont l’état est Active ou Terminée, veuillez contacter l’équipe CX. Merci.",
      "REMOVE_FROM_ASSIGNMENT_HEADING": "Supprimer de la mission",
      "REMOVE_FROM_ASSIGNMENT_CONTENT": "Cela supprimera l'utilisateur de la mission et de tous les liens d'équipe associés.",
      "REMOVE_FROM_ASSIGNMENT_LABEL": "Supprimer de la mission",
      "PUBLISH_SIMULATION_HEADING": "Publier la simulation",
      "PUBLISH_CONTINUE_EDITING": "Continuer la modification",
      "PUBLISH_BUTTON": "Publier",
      "PUBLISH_SIMULATION_DESCRIPTION": "Le jeu de rôle pourra être ajouté aux missions, mais les informations relatives à la persona, à la notation et aux informations d’invite ne pourront plus être modifiées.",
      "CONFIRMATION_SELECTED_USERS_HEADING": "Utilisateurs sélectionnés",
      "CONFIRMATION_TOTAL_COUNT": "{{ count }} total",
      "CONFIRMATION_CREATE_HEADING": "Créer une nouvelle mission",
      "CONFIRMATION_ADD_USERS_HEADING": "Ajouter des utilisateurs à la mission",
      "CONFIRMATION_SAVE_ASSIGNMENT_BTN": "Enregistrer la mission",
      "CONFIRMATION_REMOVE_USER": "Supprimer",
      "EDIT_WEIGHTING_HEADING": "Modifier la pondération de la notation",
      "EDIT_WEIGHTING_DESCRIPTION": "La note globale sera calculée à partir de la moyenne pondérée des sections suivantes. La somme des pondérations de toutes les sections activées doit être égale à 100 %. La section Compétences ne peut pas avoir une pondération supérieure à 20 %.",
      "EDIT_WEIGHTING_ERROR_ALL_DISABLED": "Au moins une action de notation doit être activée",
      "EDIT_WEIGHTING_ERROR_WEIGHT_RANGE": "La pondération des sections doit être comprise entre 0 et 100",
      "EDIT_WEIGHTING_ERROR_SKILLS_MAX": "La section Compétences ne peut pas avoir une pondération supérieure à 20 %",
      "EDIT_WEIGHTING_ERROR_TOTAL": "La pondération totale des sections doit être égale à 100 %",
      "PERSONA_INFORMATION_TITLE": "Informations sur la persona",
      "PERSONA_AVATAR_LABEL": "Avatar *",
      "PERSONA_NAME_LABEL": "Nom *",
      "PERSONA_INITIAL_GREETINGS_LABEL": "Formules d’accueil *",
      "PERSONA_INITIAL_GREETINGS_DESCRIPTION": "La persona commencera la simulation par une de ces formules d'accueil. Vous pouvez proposer jusqu’à 5 options.",
      "PERSONA_ADD_GREETING_OPTION": "Ajouter une option de formule d'accueil",
      "PERSONA_RESUME_MESSAGE_LABEL": "Message de reprise",
      "PERSONA_RESUME_MESSAGE_DESCRIPTION": "Lorsqu'un apprenant reprend une simulation après une pause, la persona commencera par une de ces formules d'accueil. Vous pouvez proposer jusqu’à 5 options.",
      "PERSONA_ADD_MESSAGE_OPTION": "Ajouter une option de message",
      "PERSONA_UPLOADING": "Téléchargement en cours…",
      "PERSONA_DELETING": "Suppression en cours…",
      "PERSONA_CUSTOM_BG_PREVIEW_ALT": "Aperçu de l'arrière-plan personnalisé",
      "PERSONA_AVATAR_THUMBNAIL_ALT": "Miniature de l’avatar",
      "PERSONA_AVATAR_WITH_BG_ALT": "Avatar avec arrière-plan personnalisé",
      "PERSONA_PROCESSING_IMAGE": "Traitement de l’image…",
      "PERSONA_CUSTOM_BACKGROUND_LABEL": "Arrière-plan personnalisé",
      "PERSONA_REMOVE_BACKGROUND": "Supprimer l'arrière-plan",
      "PERSONA_CLICK_TO_REPLACE": "Cliquer pour remplacer",
      "PERSONA_UPLOAD_DESCRIPTION": "PNG ou JPG, format 16:9 recommandé, 2 Mo max.",
      "SIM_INFORMATION_TITLE": "Informations sur la simulation",
      "SIM_NAME_FIELD_LABEL": "Nom *",
      "SIM_LANGUAGE_FIELD_LABEL": "Langue",
      "SIM_DETAILS_SECTION_TITLE": "Détails de la simulation",
      "SIM_ADDITIONAL_SECTION_TITLE_LABEL": "Titre de la section supplémentaire",
      "SIM_ADDITIONAL_SECTION_INFO_LABEL": "Informations sur la section supplémentaire",
      "TESTING_SECTION_TITLE": "Testeurs",
      "TESTING_SEND_ASSIGNMENTS_BTN": "Envoyer des missions tests",
      "TESTING_MESSAGING_TOOLTIP": "Ajoutez au moins un fait à la section Adhésion au message avant de procéder au test ou à la publication.",
      "TESTING_DESCRIPTION": "Recherchez les utilisateurs qui testeront la simulation, puis envoyez-leur la mission test.",
      "TESTING_COL_NUMBER_OF_ATTEMPTS": "Nombre de tentatives",
      "TESTING_COL_DATE_OF_LAST_ATTEMPT": "Date de la dernière tentative",
      "TESTING_CLEAR_USERS": "Effacer des utilisateurs",
      "TESTING_REMOVE_ASSIGNEE": "Supprimer un apprenant attribué",
      "OVERALL_SECTION_TITLE": "Sections, pondérations et invites",
      "OVERALL_HEADING": "Général",
      "TRANSCRIPT_PROMPT_TITLE": "Invite de transcription",
      "TRANSCRIPT_PROMPT_FIELD_LABEL": "Saisissez ici l’invite de transcription épurée",
      "SIMULATION_PROMPTS_TITLE": "Invites de la simulation",
      "TAGS_LABEL": "Balises",
      "CREATE_TAG_OPTION": "Créer {{term}}",
      "TAG_CREATE_ERROR": "Impossible de créer la balise. Veuillez réessayer",
      "EDIT_SIMULATION_TAGS_TITLE": "Modifier les balises de la simulation",
      "SAVE_TAGS_BUTTON": "Enregistrer les balises",
      "CLOSE_BUTTON": "Fermer",
      "TAG_UPDATE_ERROR": "Impossible d’actualiser la balise. Veuillez réessayer",
      "SCREEN_SHARE_TITLE": "Partage d'écran",
      "SCREEN_SHARE_DESCRIPTION": "Permet à l'utilisateur de partager son écran avec l'avatar pendant l'appel, afin que celui-ci puisse voir ce qui s'y affiche et y réagir",
      "SCREEN_SHARE_STATUS_ON": "Activé",
      "SCREEN_SHARE_STATUS_OFF": "Désactivé",
      "SCREEN_SHARE_NO_PERSONA": "Commencez par ajouter une persona pour activer le partage d'écran.",
      "HIDE_RESULTS_LABEL": "Masquer les résultats",
      "SEARCH_FIELD_HINT": "Saisissez au moins trois caractères pour lancer la recherche",
      "OTHERS_SINGULAR": "et 1 autre",
      "OTHERS_PLURAL": "et {{ count }} autres",
      "PAGINATION_PREVIOUS": "Précédent",
      "PAGINATION_NEXT": "Suivant",
      "SKILLS_RUBRIC_REQUIRED_TOOLTIP": "Joignez une rubrique de compétences. Les compétences sont activées si leur pondération est supérieure à 0 %.",
      "ENTITY_TYPE_KNOWLEDGE_CHECK_DISPLAY": "vérification des connaissances",
      "NAME_MAX_LENGTH_ERROR": "Le nom doit comporter 255 caractères ou moins.",
      "UUID_COPIED_TOAST": "UUID de l’appel copié dans le presse-papiers",
      "MENU_ARCHIVE": "Archive",
      "MENU_EDIT_SIMULATION_TAGS": "Modifier les balises de la simulation",
      "MENU_COPY_UUID": "Copier l'UUID",
      "REFINEMENT_IN_PROGRESS_TOOLTIP": "Affinement en cours. Vous pourrez continuer quand il sera terminé.",
      "SIMULATION_DOCUMENTS_PARSE_FAILED_BODY": "L'un de vos documents pour {{ name }} n'a pas pu être lu. Vérifiez-le ou remplacez-le, puis réessayez.",
      "REFINEMENT_ERROR_MESSAGE": "Nous sommes désolés, mais cette demande n'a pas pu être traitée. Veuillez réessayer",
      "REFINEMENT_OUT_OF_SCOPE_TITLE": "Demande hors du champ d'application.",
      "REFINEMENT_OUT_OF_SCOPE_BODY": "Votre demande concernant {{ name }} dépasse le champ d’application de l’affinement. Veuillez contacter l’assistance.",
      "TAB_QUESTIONS": "Questions",
      "KNOWLEDGE_CHECK_NAME_LABEL": "Nom*",
      "AVATAR_APPEARANCE_LABEL": "Apparence de l’avatar",
      "KNOWLEDGE_CHECK_AVATAR_NAME_LABEL": "Nom de l’avatar",
      "KNOWLEDGE_CHECK_SKILLS_FEEDBACK_TITLE": "Retour d’information sur les compétences",
      "KNOWLEDGE_CHECK_SCORING_DESCRIPTION": "Les simulations de la vérification des connaissances sont notées en fonction du pourcentage de points de réponse couverts pour chaque question. Sélectionnez une rubrique de compétences ci-dessous pour recevoir également un retour d’information qualitatif.",
      "KNOWLEDGE_CHECK_SCORING_RESCORE_DESCRIPTION": "Après avoir testé la simulation au moins une fois, sélectionnez « Noter ma dernière session » pour voir votre note. Si vous modifiez des points de réponse, vous pourrez noter à nouveau la même session. Si vous modifiez des questions, vous devrez effectuer une nouvelle session de test avant de procéder à la notation.",
      "KNOWLEDGE_CHECK_SKILLS_RUBRIC_LABEL": "Rubrique de compétences (facultatif)",
      "SIMULATION_TYPE_MODAL_TITLE": "Créer une nouvelle simulation",
      "SIMULATION_TYPE_MODAL_DESCRIPTION": "Choisissez la manière dont vos apprenants s'entraîneront.",
      "SIMULATION_TYPE_ROLE_PLAY_TITLE": "Jeu de rôle",
      "SIMULATION_TYPE_ROLE_PLAY_DESCRIPTION": "Les apprenants mènent une conversation ouverte avec un personnage IA, qui réagit naturellement à tout ce qu’ils disent.",
      "SIMULATION_TYPE_ROLE_PLAY_BEST_FOR": "Idéal pour : s'entraîner à des appels commerciaux réalistes, comme les argumentaires de vente et la gestion des objections.",
      "SIMULATION_TYPE_KNOWLEDGE_CHECK_TITLE": "Vérification des connaissances",
      "SIMULATION_TYPE_KNOWLEDGE_CHECK_DESCRIPTION": "Un personnage IA pose aux apprenants les questions que vous rédigez, dans l'ordre que vous définissez.",
      "SIMULATION_TYPE_KNOWLEDGE_CHECK_BEST_FOR": "Idéal pour : évaluer la connaissance des produits et certifier que les commerciaux sont prêts.",
      "TAGS_FILTER_LABEL": "Balises",
      "TAGS_FILTER_PLACEHOLDER": "Sélectionnez une balise",
      "CLEAR_ALL_FILTERS": "Effacer tous les filtres",
      "LAST_SAVED_LABEL": "Dernier enregistrement",
      "BUTTON_OK": "OK",
      "KEYWORDS_RESET_TO_PRODUCT_DEFAULT": "Réinitialiser aux paramètres par défaut du produit",
      "KEYWORDS_DETACH_FROM_PRODUCT_DEFAULT": "Détacher des paramètres par défaut du produit",
      "KEYWORDS_SAVE_AS_PRODUCT_DEFAULT": "Enregistrer en tant que paramètre par défaut du produit",
      "KEYWORDS_SAVE_AS_DEFAULT_OVERWRITE": "Cela écrasera le paramètre par défaut {{ keywordTitle }} pour le produit {{ moduleName }}.",
      "KEYWORDS_SAVE_AS_DEFAULT_IMPACT": "Ces mots seront ajoutés aux nouvelles simulations pour {{ moduleName }}. Tous les appels liés au produit {{ moduleName }} seront mis à jour.",
      "KEYWORDS_ADD_NEW_WORD": "Ajouter un nouveau mot",
      "KEYWORDS_FROM_LABEL": "Original",
      "KEYWORDS_TO_LABEL": "Remplacement",
      "KEYWORDS_PRONOUNCE_TITLE": "Prononcer les mots",
      "KEYWORDS_PRONOUNCE_DESCRIPTION": "Fournissez des corrections de prononciation à l'agent IA afin qu'il prononce correctement les noms/termes. L'agent associera les erreurs de prononciation et les variantes fréquentes à la nouvelle prononciation.",
      "KEYWORDS_PRONOUNCE_NAME": "prononcer les mots",
      "KEYWORDS_ADD_MISPRONUNCIATION": "Ajouter une erreur de prononciation",
      "KEYWORDS_SELECT_PERSONA_NOTICE": "Veuillez sélectionner une persona pour ajouter des mots à prononcer.",
      "KEYWORDS_REPLACE_TITLE": "Remplacer des mots",
      "KEYWORDS_REPLACE_DESCRIPTION": "Corrections explicites de type « rechercher et remplacer » pour le texte de la transcription de l'utilisateur ; remplacements directs de mots avant la correction phonétique.",
      "KEYWORDS_REPLACE_NAME": "remplacer des mots",
      "KEYWORDS_ADD_REPLACEMENT": "Ajouter un remplacement",
      "KEYWORDS_STT_TITLE": "Mots de reconnaissance automatique de la parole",
      "KEYWORDS_STT_DESCRIPTION": "Liste de mots fournie aux fournisseurs de reconnaissance automatique de la parole (ex. : AssemblyAI, Tavus), spécifiquement pour la configuration de ces fournisseurs.",
      "KEYWORDS_STT_NAME": "mots de reconnaissance automatique de la parole",
      "KEYWORDS_GENERATING": "Génération en cours…",
      "KEYWORDS_GENERATE_STT_PROMPT": "Générer stt_prompt",
      "KEYWORDS_STT_PROMPT_OUTDATED": "La liste de mots a été mise à jour depuis la génération de cette invite. Générer à nouveau pour prendre en compte les dernières modifications.",
      "KEYWORDS_STT_CANNOT_SAVE_HEADING": "Impossible d'enregistrer au niveau du produit",
      "KEYWORDS_STT_CANNOT_SAVE_BODY": "Les mots et l’invite de reconnaissance automatique de la parole ne peuvent pas être enregistrés au niveau d’un produit. Vous pouvez modifier manuellement d'autres configurations de reconnaissance automatique de la parole de la simulation, ou contacter votre administrateur pour obtenir de l'aide.",
      "KEYWORDS_CLEAN_TRANSCRIPT_TITLE": "Nettoyer les mots de la transcription",
      "KEYWORDS_CLEAN_TRANSCRIPT_DESCRIPTION": "Mots injectés dans l'invite CLEAN_TRANSCRIPT_V2.",
      "KEYWORDS_CLEAN_TRANSCRIPT_NAME": "nettoyer les mots de la transcription",
      "KEYWORDS_CALL_TITLE": "Mots de l’appel",
      "KEYWORDS_CALL_DESCRIPTION": "Dictionnaire de mots corrects pour la correction phonétique, utilisé par l’algorithme Double Metaphone pour corriger les fautes d’orthographe phonétiquement similaires. Évitez les expressions composées de plusieurs mots telles que « Anti MuSK AB+ », car le correcteur de transcription basé sur des codes ne fonctionne de manière fiable qu’avec des mots isolés. Évitez également les symboles, par exemple « lp(a) », car ils ont tendance à induire le correcteur en erreur. La liste doit rester aussi brève et simple que possible, car elle est gérée par un algorithme déterministe, et non par un LLM, et ne comprend pas le contexte",
      "KEYWORDS_CALL_NAME": "mots de l’appel"
    },
    "settings": {
      "DEVICE_SETUP_INTRO": "Assurons-nous que votre appareil est configuré.",
      "MICROPHONE_REQUIRED_NOTICE": "Un microphone en état de marche est nécessaire.",
      "DEVICE_ENABLE_INSTRUCTIONS": "Si vous n’avez pas vu de fenêtre contextuelle vous demandant d’activer vos appareils après avoir actualisé cette page, veuillez accéder aux paramètres de votre système ou de votre navigateur, puis activer vos appareils. Vous trouverez ci-dessous des pages d'aide contenant des instructions supplémentaires.",
      "ENABLE_CAMERA": "Comment activer votre caméra :",
      "WINDOWS_USERS": "Utilisateurs de Windows",
      "MAC_USERS": "Utilisateurs de Mac",
      "IPAD_USERS": "Utilisateurs d’iPad",
      "ENABLE_MICROPHONE": "Comment activer votre microphone :",
      "ENABLE_DEVICES_BY_BROWSER": "Comment activer vos appareils par navigateur :",
      "CHROME_USERS": "Utilisateurs de Chrome",
      "SAFARI_USERS": "Utilisateurs de Safari",
      "FIREFOX_USERS": "Firefox",
      "EDGE_USERS": "Edge",
      "START_WITHOUT_CAMERA_BUTTON": "Commencer sans caméra",
      "START_CALL_BUTTON": "Commencer l’appel",
      "MICROPHONE_REQUIRED_WARNING": "Un microphone en état de marche est nécessaire.",
      "MICROPHONE_ALT": "microphone",
      "MICROPHONE": "Microphone",
      "SELECT_MICROPHONE": "Sélectionner votre microphone",
      "ALERT": "alerte",
      "GIVE_PERMISSION": "Donner l’autorisation",
      "SELECT_VIDEO_DEVICE": "Sélectionner votre appareil vidéo",
      "VIDEO": "vidéo",
      "DEVICE_BLOCKED_ERROR": "Il semble que vous ayez refusé à ce navigateur l’accès à un ou plusieurs de vos appareils. Pour activer les appareils, veuillez accéder aux paramètres de votre système ou de votre navigateur, puis activer l’accès.",
      "DEVICE_SETTINGS": "Paramètres de l’appareil",
      "CONFIRM_SETTINGS": "Confirmer les paramètres",
      "LAPTOP": "Ordinateur portable",
      "SAD_EMOTE_FACE": "Émoji visage triste",
      "GRANT_BROWSER_ACCESS": "Pour effectuer cette simulation, veuillez autoriser le navigateur à accéder à la reconnaissance vocale",
      "USING_IPAD": "Si vous utilisez un iPad, accédez à",
      "SETTINGS": "Paramètres",
      "PRIVACY_AND_SECURITY": "Confidentialité et sécurité",
      "SPEECH_RECOGNITION": "Reconnaissance vocale",
      "GRANT_ACCESS_REFRESH": "Accordez l’accès au navigateur, puis actualisez la page",
      "REFRESH_PAGE": "ACTUALISER LA PAGE",
      "BROWSER_UNABLE_TO_ACCESS": "Le navigateur ne peut pas accéder à cet appareil",
      "ACCESS_DENIED": "accès refusé",
      "CAMERA": "Caméra",
      "DIAGNOSTIC_PASSED": "Tous les tests de diagnostic ont réussi.",
      "DIAGNOSTIC_FAILED_MESSAGE": "Certains tests de diagnostic ont échoué. Veuillez cliquer sur le bouton « Copier les résultats du diagnostic » ci-dessus et envoyer les résultats à l'équipe d’assistance pour qu’elle vous aide.",
      "DIAGNOSTIC_PARTIAL": "La plupart des tests de diagnostic ont réussi. Votre connexion semble bonne.",
      "DIAGNOSTIC_RUNNING_MESSAGE": "Veuillez patienter pendant que les tests de diagnostic sont en cours…",
      "DIAGNOSTIC_RUNNING": "Diagnostic en cours",
      "COPY_DIAGNOSTIC_RESULTS": "Copier les résultats du diagnostic",
      "RUN_DIAGNOSTIC": "Exécuter le diagnostic",
      "RERUN_DIAGNOSTIC": "Relancer le diagnostic",
      "DIAGNOSTIC_RESULTS_COPIED": "Résultats du diagnostic copiés dans le presse-papiers",
      "DIAGNOSTIC_FAILED": "Le diagnostic a échoué",
      "DIAGNOSTIC_WEBSOCKET_NOT_TESTED": "Websocket: not tested",
      "DIAGNOSTIC_TURN_NOT_TESTED": "TURN: not tested",
      "DIAGNOSTIC_QUALITY_NOT_TESTED": "Quality: not tested",
      "DIAGNOSTIC_QUANTIFIED_DIAGNOSTICS": "Diagnostics quantifiés",
      "DIAGNOSTIC_TIME": "Temps",
      "DIAGNOSTIC_SUMMARY": "Résumé",
      "DIAGNOSTIC_CLIENT_INFO": "Infos du client",
      "DIAGNOSTIC_PLATFORM": "Plate-forme",
      "DIAGNOSTIC_RTT_AVG_MAX": "RTT avg/max",
      "DIAGNOSTIC_PACKET_LOSS_SEND": "Perte de paquets (envoi)",
      "DIAGNOSTIC_AVG_SEND_BITRATE": "Débit binaire d'envoi moyen",
      "DIAGNOSTIC_NA": "N/A",
      "DIAGNOSTIC_PROBLEMS_CONNECTING_PREFIX": "Vous rencontrez des problèmes de connexion ?",
      "DIAGNOSTIC_CLICK_HERE": "Cliquez ici",
      "DIAGNOSTIC_TO_RUN_SUFFIX": "pour effectuer un diagnostic."
    },
    "results": {
      "RETURN_HOME": "RETOURNER À L’ACCUEIL",
      "CLOSE_BUTTON": "Bouton de fermeture",
      "CONVERSATIONAL_CALL": "JEU DE RÔLE",
      "INFORMATION_ICON": "Icône d’information",
      "TOOLTIP_ARROW": "Flèche d’info-bulle",
      "INFORMATION_TOOLTIP_CONTENT": "Vous contrôlez le flux de la simulation en orientant la conversation vers un ensemble d’objectifs. Les jeux de rôle sont parfaits pour tester des capacités telles que l’analyse approfondie et les questions de second niveau, la recherche de difficultés et l’établissement d’une relation.",
      "CLOCK_ICON": "Icône d’horloge",
      "CALL_RESULTS": "Résultats",
      "SKILLS": "Compétences",
      "MESSAGE_ADHERENCE": "Adhésion au message",
      "TRY_AGAIN_MESSAGE": "Réessayez pour améliorer votre note.",
      "PRACTICE_BENEFITS": "Un entraînement hebdomadaire renforce la confiance en soi et améliore les résultats en situation concrète.",
      "CALL_SUCCESS": "Excellent travail ! Vous avez terminé cette simulation avec succès.",
      "MAX_ATTEMPTS_REACHED": "Vous avez atteint le nombre maximum de tentatives",
      "TRY_AGAIN": "Réessayer",
      "GREAT_JOB_YOU_SUCCESSFULLY": "Excellent travail ! Vous avez terminé",
      "COMPLETED_THIS_CALL": "a terminé cette simulation.",
      "ACHIEVED_SCORE": "Vous avez obtenu une note de",
      "ACHIEVE_SCORE": "Obtenez une note de",
      "OR_HIGHER": "ou plus.",
      "OBJECTIVES_NOT_MET": "Vous n’avez pas atteint tous les objectifs requis.",
      "TRY_AGAIN_TARGET_SCORE": "Essayez à nouveau d’obtenir une note de",
      "YOUR_SCORE": "Votre note",
      "OUT_OF_5": "SUR 5",
      "CALL_FEEDBACK": "RÉSUMÉ DU RETOUR D'INFORMATION",
      "STRENGTH_ICON_ALT": "Icône de force",
      "OPPORTUNITIES_ICON_ALT": "Icône des opportunités",
      "OBJECTIVES_FEEDBACK": "RETOUR D'INFORMATION SUR LA MÉTHODOLOGIE",
      "SESSION_ID": "ID de session :",
      "SESSION_ID_COPIED": "L’ID de session a été copié !",
      "OBJECTIVE": "MÉTHODOLOGIE :",
      "HOW_YOU_DID": "Vos résultats :",
      "LIGHTBULB_ICON_ALT": "Icône d’ampoule",
      "WHAT_WE_SUGGEST": "Ce que nous suggérons :",
      "NO_SPECIFIC_RECOMMENDATION": "Notre système n’a pas trouvé de recommandation propre à votre cas.",
      "WHY": "Pourquoi ?",
      "NO_INSIGHTS_AVAILABLE": "Notre système n’a pas été en mesure de fournir des informations sur cette suggestion.",
      "CONFETTI_ICON_ALT": "Icône de confettis",
      "OBJECTIVE_SUCCESS_MESSAGE": "Vous avez fait du bon travail sur cette méthodologie. Continuez comme ça !",
      "PROCESSING_CALL": "Nous préparons votre note et votre retour d'information.",
      "HANG_TIGHT": "Patientez ou revenez plus tard pour",
      "VIEW_YOUR_RESULTS": "consulter vos résultats.",
      "NEED_MORE_TIME": "Nous avons besoin de plus de temps pour calculer les résultats.",
      "REFRESH_INSTRUCTION": "Veuillez revenir plus tard ou actualiser la mission",
      "RESULTS_IN_FEW_MINUTES": "résultats dans quelques minutes.",
      "SCORE_CALCULATION_QUESTION": "Quelle est la méthode de calcul ?",
      "SINGLE_SCORE_EXPLANATION": "Cette simulation comporte un seul élément de notation. La note affichée correspond donc à la fois à la note de la section et à votre note globale.",
      "OVERALL_SCORE_PERCENT": "de la note globale",
      "SECTION_SCORE": "Note de la section",
      "ELEVATE_MESSAGE_ADHERENCE_TITLE": "Améliorez votre adhésion au message de conversation",
      "MESSAGE_ADHERENCE_NOTE": "L’adhésion au message est essentielle pour mener des conversations fructueuses, mais elles n’ont pas d’incidence sur votre note globale.",
      "NO_CREDIT": "Aucun crédit",
      "PARTIAL_CREDIT": "Crédit partiel",
      "FULL_CREDIT": "Crédit complet",
      "WHAT_YOU_DID_WELL": "Ce que vous avez réussi",
      "MISSED_ALL_KEY_POINTS": "Vous avez omis tous les points clés. Revoyez-les et essayez à nouveau.",
      "WHAT_TO_IMPROVE": "Ce que vous pouvez améliorer",
      "PERFECT_SCORE_MESSAGE": "Félicitations ! Vous avez obtenu une note parfaite, en abordant correctement tous les points clés.",
      "POINTS_LABEL": "Points",
      "POINT_LABEL": "Point",
      "TALKING_POINTS_COVERED": "Points de discussion abordés",
      "CHECKMARK_ICON_ALT": "coche",
      "TALKING_POINTS_MISSED": "Points de discussion manqués",
      "X_ICON_ALT": "x",
      "PRACTICE_AGAIN": "Entraînez-vous à nouveau",
      "OUT_OF": "sur",
      "OBJECTIVES": "Méthodologie",
      "ELEVATE_OBJECTIVES_TITLE": "Améliorez votre méthodologie de conversation",
      "OBJECTIVES_NOTE": "La méthodologie est essentielle pour mener des conversations fructueuses, mais elle n’a pas d’incidence sur votre note globale.",
      "UNTIL": "jusqu’au",
      "TO_IMPROVE_SCORE": "pour améliorer votre note.",
      "YOU_HAVE": "Vous avez",
      "MORE_ATTEMPTS": "tentatives supplémentaires pour obtenir une note de",
      "OR_HIGHER_BEFORE": "ou plus avant",
      "AND_TRY_AGAIN": "et réessayer.",
      "UNEXPECTED_STATE": "Un état inattendu s’est produit.",
      "REVIEW_APP_LOGIC": "Veuillez revoir la logique de l’application.",
      "ASSIGNMENTS": "Missions",
      "VIEW_CALL_DETAILS": "Voir les détails de l’appel",
      "PRACTICE_SESSION": "Session d’entraînement",
      "OVERALL_SCORE": "Note globale",
      "OVERALL_SCORE_EXPLANATION": "La note globale est calculée en faisant la moyenne pondérée des notes de chaque section. Le poids de chaque section s’affiche sous forme de pourcentage à côté de la note.",
      "SCORE_CONFIG_NOTE": "Les pourcentages de pondération, ainsi que l’inclusion et l’exclusion de sections, sont fixés par votre entreprise. Toutes les notes sont arrondies au dixième de point le plus proche.",
      "STRENGTHS": "Points forts",
      "OPPORTUNITIES": "Opportunités",
      "YOUR_RESPONSE": "Votre réponse",
      "MINUS": "moins",
      "PLUS": "plus",
      "RECOMMENDED_RESPONSE": "Réponse recommandée",
      "REVIEW_MISSED_TITLE": "Passez en revue ce que vous avez manqué.",
      "NO_TALKING_POINTS_COVERED": "Vous n’avez abordé aucun des points de discussion requis pour ce sujet.",
      "LEARN_WHAT_YOU_MISSED": "Découvrir ce que vous avez manqué",
      "NICE_JOB": "Beau travail !",
      "ALL_POINTS_COVERED": "Vous avez réussi à aborder tous les points de discussion requis pour ce sujet.",
      "COVER_ALL_MESSAGES": "Abordez tous les messages clés.",
      "HIGHLIGHT_KEY_POINTS_NOTE": "En mettant l’accent sur les points clés tout au long de l’appel, vous contribuerez à maintenir la conversation sur les rails.",
      "MESSAGES_LABEL": "Messages",
      "NO_FACTS_COVERED": "Oups ! Il semble que vous n’ayez abordé aucun des faits de ce message.",
      "NO_SPECIFICS_AVAILABLE": "Oups ! Il semble que nous n’ayons pas pu fournir de précisions sur ce qui a été omis.",
      "ALL_KEY_POINTS_COVERED": "Excellent travail ! Vous avez abordé tous les points clés.",
      "PROCESSING_SKILLS_FEEDBACK": "Nous sommes en train de traiter votre retour d’information sur les compétences.",
      "SKILLS_SCORING_NOT_ENABLED": "Nous sommes désolés, mais nous n’avons pas pu analyser votre appel récent, car la notation des compétences n’était pas activée au moment de l’envoi. Pour obtenir un retour d’information, il vous suffit de renvoyer votre appel d’entraînement, comme vous l’avez fait précédemment. Si vous avez besoin d’aide, n’hésitez pas à contacter notre équipe d’assistance. Merci de votre compréhension et de votre volonté à vous améliorer !",
      "ELEVATE_CONVERSATION_SKILLS": "Améliorer vos compétences en matière de conversation",
      "SKILLS_NOTE": "Les compétences sont essentielles pour mener des conversations fructueuses, mais elles n’ont pas d’incidence sur votre note globale.",
      "SKILLS_SUMMARY_TITLE": "RÉSUMÉ DES COMPÉTENCES",
      "LEARN_MORE_ABOUT_SKILLS": "En savoir plus sur les compétences",
      "SKILLS_FEEDBACK_LABEL": "RETOUR D’INFORMATION",
      "WHAT_ARE_SKILLS_TITLE": "Définition des compétences",
      "SKILLS_DESCRIPTION": "Les compétences sont établies pour favoriser la croissance et le développement personnels. Bien que ces compétences ne fassent pas partie de l’évaluation numérique de votre appel, elles ont été sélectionnées par votre entreprise pour améliorer votre efficacité.",
      "PROFICIENCY_SCALE_TITLE": "ÉCHELLE DE COMPÉTENCE",
      "EXPERT": "Expert",
      "PROFICIENT": "Compétent",
      "DEVELOPING": "En développement",
      "CALL_TRANSCRIPT": "Transcription de l’appel",
      "COLLAPSE_ALL": "Tout réduire",
      "EXPAND_ALL": "Tout développer",
      "THUMBNAIL": "Miniature",
      "OUT_OF_FIVE_POINTS": "/5 points",
      "TALKING_POINTS": "points de discussion",
      "TRANSCRIPT_LABEL": "Transcription",
      "YOU_ARE_OUT_OF_ATTEMPTS": "Vous avez épuisé toutes vos tentatives.",
      "REVIEW_GUIDELINES_REMAIN_COMPLIANT": "Passez en revue les consignes, et tâchez de les respecter à l’avenir.",
      "TRY_AGAIN_ATTENTION_TO_COMPLIANCE": "Réessayez en veillant à respecter les consignes de conformité.",
      "NO_SCORE_OUT_OF_COMPLIANCE": "Nous avons identifié un élément susceptible de ne pas être conforme",
      "WHY_OUT_OF_COMPLIANCE": "Raison de votre éventuelle non-conformité",
      "REVIEW_TRANSCRIPT_MISSED_GUIDELINES": "Examinez votre transcription pour voir où vous n’avez pas respecté les directives en matière de conformité.",
      "YOU_DID_FOLLOW_GUIDELINES": "Vous avez suivi efficacement ces directives.",
      "REVIEW_MISSED_GUIDELINES": "Passez en revue les directives relatives à la conformité que vous avez manquées.",
      "OUT_OF_COMPLIANCE": "Non conforme",
      "SCORE_CALCULATION_TITLE": "Calcul de la note",
      "PROCESSING_TRANSCRIPT": "Nous sommes en train de traiter votre transcription.",
      "WAIT_OR_REVIEW_SCORES": "Patientez ici, ou passez en revue les autres sections de notes",
      "TRANSCRIPT_LOADING": "pendant le chargement de la transcription.",
      "REVIEW_FEEDBACK_KEEP_PRACTICING": "Passez en revue votre retour d’information, et continuez de vous entraîner",
      "HIGH_PERFORMERS_PRACTICE": "Les personnes très performantes s’entraînent au moins une fois par semaine",
      "SUCCESSFULLY_PASSED": "Excellent travail ! Vous avez réussi cette simulation.",
      "DIDNT_REACH_PASSING_SCORE": "Vous n’avez pas atteint la note minimale pour cette simulation.",
      "OUT_OF_ATTEMPTS": "<b>Vous avez épuisé toutes vos tentatives.</b> Consultez votre retour d’information pour savoir comment vous améliorer.",
      "REVIEW_FEEDBACK_THEN_RETURN": "Passez en revue votre retour d’information, puis retournez à l’accueil lorsque vous serez prêt.",
      "GREAT_JOB_PRACTICED": "Bon travail. Vous vous êtes entraîné {{count}} {{times}}. Continuez comme ça !",
      "GREAT_JOB_PRACTICED_FEMALE": "Bravo, vous vous êtes entraîné(e) {{count}} {{times}}. Continuez comme ça !",
      "TIME": "fois",
      "TIMES": "fois",
      "COMPLIANCE_GUIDELINES": "Directives en matière de conformité",
      "TALKING_POINT_TITLE": "POINTS DE DISCUSSION MANQUÉS OU DITS AU MAUVAIS MOMENT",
      "NO_TRANSCRIPT": "Aucune transcription disponible.",
      "QUIZ_SUMMARY_BASE": "Prenez un moment pour passer en revue votre performance sur ce questionnaire.",
      "QUIZ_SUMMARY_FAILED": "Prenez un moment pour passer en revue votre performance sur ce questionnaire. Passez en revue les {{stepNames}} {{stepWord}} mis en évidence sur l'écran d'aperçu du parcours pour mieux vous préparer à votre prochaine tentative.",
      "QUIZ_SUMMARY_PASSED_WITH_MISSES": "Prenez un moment pour passer en revue votre performance sur ce questionnaire. La ou les {{stepWord}} {{stepNames}} {{stepVerb}} votre/vos {{areaWord}} le(s) moins bien noté(s).",
      "OUT_OF_100": "SUR 100",
      "COVERED": "Abordé",
      "MISSED": "Manqué",
      "RETURN_TO_ASSIGNMENT": "Retourner à la mission",
      "RETURN_TO_PATHWAY": "RETOURNER AU PARCOURS",
      "QUIZ_RESULTS_SUMMARY": "Résumé des résultats du questionnaire",
      "PROCESSING_RESULTS": "Traitement des résultats…",
      "NONE_PERFECT": "Aucun - Parfait !",
      "MESSAGING": "Messagerie",
      "MISSED_ONE_TALKING_POINT": "Vous avez manqué 1 point de discussion pour ce sujet.",
      "MISSED_X_TALKING_POINTS": "Vous avez manqué {{count}} points de discussion pour ce sujet.",
      "ROLEPLAY_POST_CALL_TITLE": "Vous avez atteint la fin de cet appel.",
      "ROLEPLAY_POST_CALL_SUBTITLE_PROCESSING": "Laissez-nous vos commentaires pendant que nous traitons vos résultats.",
      "ROLEPLAY_POST_CALL_SUBTITLE_DELAY": "Les résultats sont longs à charger. Quittez le parcours, et nous vous avertirons quand ils seront prêts.",
      "ROLEPLAY_POST_CALL_SUBTITLE_ERROR": "Une erreur s'est produite lors du traitement de vos résultats. Veuillez contacter l’assistance à",
      "ROLEPLAY_POST_CALL_PROCESSING_LABEL": "Traitement des résultats…",
      "ROLEPLAY_POST_CALL_FEEDBACK_QUESTION": "Cette conversation vous a-t-elle semblé réaliste et naturelle ?",
      "FEEDBACK_THANK_YOU": "Merci pour vos commentaires !",
      "FEEDBACK_IMPROVEMENT_NOTE": "Merci pour vos commentaires ! Nous nous efforcerons d’améliorer l’expérience.",
      "VIEW_RESULTS": "Voir les résultats",
      "FEEDBACK_IMPROVEMENT_SUFFIX": "Nous nous efforcerons d’améliorer l’expérience.",
      "QUIZ_RESULTS_LOADING": "Les résultats sont longs à charger. Quittez le parcours, et nous vous avertirons quand ils seront prêts.",
      "KC_TOAST_TITLE": "Les résultats de votre vérification des connaissances ont été traités",
      "KC_TOAST_CONTENT": "Cliquez ci-dessous pour voir les résultats, ou retournez à l'écran des détails du parcours pour votre prochaine étape.",
      "DISMISS": "Rejeter",
      "KC_TOAST_TITLE_PATHWAY": "Les résultats de votre vérification des connaissances pour {{stepName}} ont été traités",
      "MISSED_ONE_REQUIRED_TALKING_POINT": "Vous avez manqué 1 point de discussion obligatoire pour ce sujet",
      "MISSED_X_REQUIRED_TALKING_POINTS": "Vous avez manqué {{count}} points de discussion obligatoires pour ce sujet",
      "MISSED_ALL_ONE_REQUIRED_TALKING_POINT_TITLE": "Vous avez manqué 1 point de discussion obligatoire pour ce sujet.",
      "MISSED_ALL_X_REQUIRED_TALKING_POINTS_TITLE": "Vous avez manqué {{count}} points de discussion obligatoires pour ce sujet.",
      "REVIEW_MATERIAL_NEXT_TIME": "Passez le document en revue afin de vous améliorer pour la prochaine fois.",
      "ACCURACY": "Exactitude",
      "ACCURACY_LOADING": "Chargement en cours...",
      "ACCURACY_FLAGGED_MESSAGE": "Certaines de vos déclarations semblent différer de vos documents sources. Vous trouverez plus d’informations ci-dessous.",
      "ACCURACY_ALL_CLEAR": "Nous n'avons identifié aucune affirmation inexacte par rapport aux documents sources.",
      "ACCURACY_ERROR": "Nous ne pouvons pas donner de retour d’information sur cette session",
      "ACCURACY_YOU_SAID": "VOUS AVEZ DIT",
      "ACCURACY_CLAIM_IDENTIFIED": "L'AFFIRMATION QUE NOUS AVONS IDENTIFIÉE",
      "ACCURACY_MATERIALS_STATE": "CE QU’INDIQUENT VOS DOCUMENTS",
      "ACCURACY_OVERALL_BLOCK_PREFIX": "Il se peut que certaines de vos déclarations soient inexactes. Consultez l’onglet ",
      "ACCURACY_OVERALL_BLOCK_LINK": "Exactitude",
      "ACCURACY_OVERALL_BLOCK_SUFFIX": " pour plus d’informations.",
      "PRACTICE_SIMULATION_AGAIN": "Entraînez-vous de nouveau à la simulation",
      "CALL_TYPE_CONVERSATIONAL": "Appel conversationnel",
      "CALL_TYPE_GUIDED": "Appel guidé",
      "CALL_TYPE_VISUAL_AID": "Appel avec aide visuelle",
      "CALL_TYPE_ROLEPLAY": "Appel jeu de rôle",
      "PERSONALIZED_PRACTICE_BREADCRUMB": "Entraînement personnalisé",
      "CONVERSATION_TYPE_LABEL": "Type de conversation :",
      "DIFFICULTY_LABEL": "Difficulté :",
      "MOOD_LABEL": "Humeur :",
      "DIFFICULTY": "Difficulté",
      "TEMPERAMENT": "Tempérament",
      "OVERALL_SCORE_TAB": "Général",
      "MESSAGE_ADHERENCE_TAB": "Messages",
      "OBJECTIVES_TAB": "Objectifs"
    },
    "reportingV2": {
      "DASHBOARD": "Tableau de bord",
      "LOADING_ACCOUNTS": "Chargement des comptes...",
      "SELECT_AN_ACCOUNT": "Sélectionner un compte",
      "SEARCH_TEAMS": "Chercher des équipes",
      "LOADING_TEAMS": "Chargement des équipes...",
      "ALL_TEAMS": "Toutes les équipes",
      "ACCOUNT": "Compte",
      "TEAMS": "Équipes",
      "TEAM_LABEL": "Équipe",
      "TOTAL_LABEL": "Total",
      "PASSING_SCORE": "Note minimale",
      "ASSIGNMENT_LABEL": "Missions",
      "USER_LABEL": "Utilisateurs",
      "PRACTICE_LABEL": "Entraînement",
      "CERTIFICATION_LABEL": "Certification",
      "RESULTS_DESCRIPTION": "Voici les résultats de votre ou vos équipes pour l'ensemble des missions d’entraînement :",
      "ENGAGEMENT_BY_ASSIGNMENT": "Engagement par mission",
      "ASSIGNMENT_ENGAGEMENT": "Engagement de mission",
      "ENGAGED_LABEL": "Engagé",
      "ENGAGEMENT_STATUS_LABEL": "État de l’engagement",
      "PROFICIENT_LABEL": "Compétent",
      "ASSIGNMENT_NAME": "Nom de la mission",
      "ACTIVE_USERS": "Utilisateurs actifs",
      "ASSIGNMENT_PROGRESS": "Progression par mission",
      "IN_PROGRESS_LABEL": "En cours",
      "CERTIFIED_LABEL": "Certifié",
      "OUT_OF_ATTEMPTS_LABEL": "Nombre de tentatives épuisé",
      "USERS_ENGAGED_LABEL": "Utilisateurs engagés",
      "SESSIONS_PER_ACTIVE_USERS_LABEL": "Sessions par utilisateur actif",
      "HIGHER_THAN_LABEL": "Supérieur à",
      "MORE_THAN_LABEL": "Plus de",
      "TOTAL_SESSIONS_COMPLETED_LABEL": "Nombre total de sessions achevées",
      "USER_CERTIFIED": "Utilisateurs certifiés pour toutes les missions",
      "ASSIGNMENT_CERTIFICATION": "Missions avec une certification de 100 %",
      "TRAINER_TIME_SAVED": "Gain de temps pour le formateur",
      "HOURS_LABEL": "heures",
      "PRACTICE_ASSIGNMENT_LABEL": "Missions d’entraînement",
      "CERTIFICATION_ASSIGNMENT_LABEL": "Missions de certification",
      "START_DATE_LABEL": "Date de début",
      "END_DATE_LABEL": "Date de fin",
      "NAME_LABEL": "Nom",
      "EMAIL_LABEL": "E-mail",
      "MEMBER_OF_TEAMS_LABEL": "Membre des équipes",
      "ASSIGNMENTS_COUNT_LABEL": "Nombre de missions",
      "TOTAL_SESSIONS_LABEL": "Nombre total de sessions",
      "NUMBER_OF_SESSIONS_LABEL": "Nombre de sessions",
      "TOTAL_USERS_LABEL": "Nombre total d’utilisateurs",
      "AVERAGE_SCORE_LABEL": "Note moyenne",
      "INITIAL_SCORE_LABEL": "Note initiale",
      "HIGH_SCORE_LABEL": "Note élevée",
      "LAST_PRACTICE_DATE_LABEL": "Date du dernier entraînement",
      "PERCENT_IMPROVED_LABEL": "% d'amélioration",
      "PERCENT_IMPROVED_TOOLTIP_TEXT": "Cet indicateur compare le score initial d'un utilisateur à son meilleur score, exprimé en pourcentage de l'amélioration maximale possible.",
      "ASSIGNMENTS_CERTIFIED_LABEL": "Certifié pour les missions",
      "ASSIGNMENTS_PROFICIENT_LABEL": "Compétent pour les missions",
      "ASSIGNMENTS_CERTIFIED_TOOLTIP_TEXT": "Nombre de missions dans lesquelles l'utilisateur a atteint ou dépassé les critères de notation pour toutes les simulations de la mission.",
      "ASSIGNMENTS_PROFICIENT_TOOLTIP_TEXT": "Nombre de missions dans lesquelles l'utilisateur a atteint ou dépassé les critères de notation au moins une fois pour toutes les simulations de la mission.",
      "PROFICIENT_TOOLTIP": "Pourcentage d’utilisateurs de cette mission ayant atteint ou dépassé les critères de notation au moins une fois pour toutes les simulations de cette mission.",
      "IN_PROGRESS_TOOLTIP": "Pourcentage d'utilisateurs ayant terminé au moins une session de simulation dans le cadre de cette mission, et qui ont obtenu une note.",
      "OUT_OF_ATTEMPTS_TOOLTIP": "Pourcentage d'utilisateurs ayant dépassé leur nombre de tentatives allouées pour une ou plusieurs simulations de la mission.",
      "CERTIFIED_TOOLTIP": "Pourcentage d'utilisateurs ayant atteint ou dépassé les critères de notation pour toutes les simulations de la mission.",
      "SEARCH_FOR_A_USER_LABEL": "Chercher un utilisateur",
      "NO_USERS_FOUND_LABEL": "Aucun utilisateur trouvé",
      "TRAINER_TIME_SAVED_TOOLTIP": "Temps que les utilisateurs ont passé dans Quantified à tenter d’obtenir une certification.",
      "AVG_SESSIONS_PER_ASSIGNMENT": "Nombre moyen de sessions par mission",
      "ASSIGNMENTS_ENGAGED_WITH": "Missions terminées",
      "AVERAGE_IMPROVEMENT": "Amélioration moyenne",
      "STATUS": "État",
      "TOTAL_NUMBER_OF_SESSIONS": "Nombre total de sessions",
      "DATE_OF_LAST_PRACTICE": "Date du dernier entraînement",
      "CALL_NAME": "Nom de l’appel",
      "SESSION_DATE": "Date de la session",
      "DURATION_OF_SESSION": "Durée de la session",
      "OVERALL_SCORE": "Note globale",
      "MESSAGING_SCORE": "Note d'adhésion au message",
      "METHODOLOGY_SCORE": "Note de méthodologie",
      "SKILLS_SCORE": "Note de compétences",
      "SESSIONS": "Sessions",
      "TOTAL": "Total",
      "ALL_ASSIGNMENTS": "Toutes les missions",
      "RECENT_ASSIGNMENTS": "Missions récentes",
      "AVERAGE_SESSIONS_ACTIVE_USER": "Nombre moyen de sessions par utilisateur actif",
      "HOURS_IN_SIMULATIONS": "Heures de simulation",
      "AVERAGE_SESSIONS_TO_PROFICIENCY": "Nombre moyen de sessions pour devenir compétent",
      "PERCENT_PROFICIENT": "Pourcentage de compétence",
      "SYSTEM_RUNNING_NORMALLY": "Le système fonctionne actuellement normalement",
      "PRACTICE_SIMULATIONS_LABEL": "Simulations",
      "NO_USERS_MATCHING_FILTERS_LABEL": "Aucun résultat ne correspond à vos filtres. Essayez de supprimer un ou plusieurs filtres pour élargir la recherche.",
      "USERS_PASSED": "Utilisateurs ayant réussi la simulation",
      "AVERAGE_TIME": "Temps moyen de la certification",
      "USERS_OUT_OF_ATTEMPTS": "Utilisateurs ayant épuisé toutes leurs tentatives",
      "NO_CERTIFICATION_SIMULATION": "Aucune simulation de certification trouvée",
      "SIMULATION": "Simulation",
      "No_SIMULATION": "Aucune session",
      "PERCENT_CERTIFIED": "Pourcentage certifié",
      "PERCENT_CERTIFIED_FIRST_ATTEMPT": "Pourcentage certifié à la première tentative",
      "USERS": "Utilisateurs",
      "ATTEMPTS_LABEL": "Tentatives",
      "NO_ATTEMPTS": "Aucune tentative",
      "DATE_OF_SESSION": "Date de la session",
      "NO_ASSIGNMENTS_MATCH_FILTERS": "Aucune mission ne correspond aux filtres choisis",
      "NO_TEAMS_DATA": "Il n'y a aucune équipe dans ce compte",
      "SIMULATION_NAME": "Nom de la simulation",
      "AVERAGE_DURATION_OF_SESSION": "Durée moyenne d’une session",
      "AVERAGE_SESSIONS_PER_ACTIVE_USER": "Nombre moyen de sessions par utilisateur actif",
      "AVERAGE_OVERALL_SCORE": "Note globale moyenne",
      "TOTAL_ASSIGNMENTS": "Total des missions",
      "ASSIGNMENTS_CERTIFIED": "Certifié pour les missions",
      "TOTAL_SESSIONS": "Nombre total de sessions",
      "HOURS_SPENT_PRACTICING": "Heures passées à l’entraînement",
      "LAST_LOGIN": "Dernière connexion",
      "SELECT_ASSIGNMENTS": "Sélectionner des missions",
      "CERTIFICATION_STATUS_LABEL": "État de la certification",
      "CERTIFICATION_STATUS_PREFIX_LABEL": "État de la certification :",
      "CERTIFIED_ON_FIRST_ATTEMPT_LABEL": "Certifié dès la première tentative ?",
      "DATE_OF_CERTIFICATION_LABEL": "Date de la certification",
      "ENGAGEMENT_STATUS_PREFIX_LABEL": "État de l’engagement :",
      "DURATION_OF_ATTEMPT": "Durée de la tentative",
      "USER_NAME": "Nom de l'utilisateur",
      "LEARNER": "Apprenant",
      "DATE_RANGE": "Fourchette de dates",
      "DATE_RANGE_LABEL": "Fourchette de dates",
      "SEARCH_USERS": "Recherche d'utilisateurs…",
      "SEARCH_SIMULATIONS": "Recherche de simulations…",
      "SEARCH_DATES": "Recherche de dates…",
      "CERTIFIED_ON_FIRST_TRY": "Certifié dès la première tentative",
      "DATE_OF_CERTIFICATION": "Date de la certification",
      "AVERAGE_CERTIFICATION_SCORE": "Note de certification moyenne",
      "TOTAL_TIME_CERTIFYING": "Durée totale de la certification",
      "OF_THE_TIME": "du temps",
      "ASSIGNED_LABEL": "Non commencée",
      "USERS_ASSIGNED_LABEL": "Total des utilisateurs assignés",
      "SESSION_ID": "ID de session",
      "USER_NAME_LABEL": "Nom de l'utilisateur",
      "NO_SIMULATIONS_FOUND_LABEL": "Aucune simulation trouvée",
      "MIN": "min",
      "SEC": "s",
      "OF_LABEL": "sur",
      "SECOND": "seconde",
      "SECONDS": "secondes",
      "MINUTE": "minute",
      "MINUTES": "minutes",
      "ASSIGNED": "Attribué",
      "ENGAGED_TOOLTIP": "Pourcentage d'utilisateurs de cette mission ayant complété une ou plusieurs sessions d'une simulation mais n'ayant pas encore atteint le niveau de compétence requis sur toutes les simulations.",
      "SEARCH_ASSIGNMENTS": "Recherche de missions…",
      "ASSIGNMENT_NAME_LABEL": "Nom de la mission",
      "SIMULATION_NAME_LABEL": "Nom de la simulation",
      "START_DATE": "Date de début",
      "END_DATE": "Date de fin",
      "NO_ASSIGNMENTS": "Aucune mission trouvée pour cet utilisateur.",
      "TOTAL_PRACTICE_ASSIGNMENTS": "Nombre total de missions d’entraînement",
      "SESSION_SCORES_OVER_TIME": "Note des sessions au fil du temps",
      "TIME": "Temps",
      "SCORE": "Note",
      "NO_SESSIONS_AVAILABLE": "Aucune session disponible pour le graphique.",
      "MESSAGING_SCORE_LABEL": "Note de messagerie",
      "PERSONALIZED_PRACTICE_LABEL": "Entraînement personnalisé",
      "ASSIGNMENT_ENAGEMENT": "Engagement par mission",
      "NO_PRODUCTS": "Aucun produit d’entraînement personnalisé pour les équipes sélectionnées",
      "TOTAL_TIME_SPENT_PRACTICING": "Temps total passé à pratiquer",
      "AVERAGE_SESSIONS_PER_USER": "Moyenne des sessions par utilisateur",
      "MOST_COMMON_CONVERSATION_TYPE_SELECTION": "Sélection du type de conversation le plus courant",
      "LEAST_COMMON_CONVERSATION_TYPE_SELECTION": "Sélection du type de conversation le moins courant",
      "CLEAR_TEAMS": "Effacer les équipes",
      "METHODOLOGY_SCORE_DESCRIPTION": "Détermine dans quelle mesure les apprenants suivent la structure d'appel recommandée. Les notes reflètent la moyenne sur l’ensemble des sessions de cette simulation.",
      "METHODOLOGY": "Méthodologie",
      "MESSAGING": "Messagerie",
      "MESSAGING_V2_DASHBOARD_DESCRIPTION": "Détermine si les apprenants expriment les idées clés pendant l'appel. Les graphiques montrent le pourcentage moyen de messages correctement exprimés par thème sur l’ensemble des sessions.",
      "NO_METRICS_MESSAGE": "D’autres sessions sont nécessaires pour générer des informations.",
      "SELECT_ALL": "Sélectionner tout",
      "DESELECT_ALL": "Désélectionner tout",
      "SKILLS": "Compétences",
      "SKILLS_SCORE_STATS_DESCRIPTION": "Détermine dans quelle mesure les apprenants mettent en œuvre des compétences clés pendant l'appel. Les notes reflètent une évaluation de l'IA moyennée sur l’ensemble des sessions.",
      "EXPERT": "Expert",
      "PROFICIENT": "Compétent",
      "DEVELOPING": "En développement",
      "FULLY_ARTICULATED": "Exprimé très clairement",
      "PARTIALLY_ARTICULATED": "Exprimé partiellement",
      "NOT_MENTIONED": "Non mentionné",
      "MESSAGING_SCORE_STATS_DESCRIPTION": "Détermine si les apprenants expriment les idées clés pendant l'appel. Les graphiques indiquent à quelle fréquence chaque message a été correctement exprimé sur l’ensemble des sessions.",
      "CLEAR": "Effacer",
      "CLEAR_STATUS": "Effacer l’état",
      "CLEAR_USERS": "Effacer les utilisateurs",
      "CLEAR_SIMULATIONS": "Effacer les simulations",
      "CLEAR_ASSIGNMENTS": "Effacer les missions",
      "MODAL_SUBHEADING": "Ensemble des {{ count }} objectifs - notes moyennes sur l’ensemble des sessions",
      "VIEW_ALL_OBJECTIVES": "Voir la totalité des {{ count }} objectifs →",
      "LEAST_MISSED_QUESTION": "QUESTION LA MOINS MANQUÉE",
      "MOST_MISSED_QUESTION": "QUESTION LA PLUS SOUVENT MANQUÉE",
      "HIGHEST_SCORING_METHODOLOGY_SECTION": "SECTION CONSACRÉE À LA MÉTHODOLOGIE AYANT REÇU LA NOTE LA PLUS ÉLEVÉE",
      "LOWEST_SCORING_METHODOLOGY_SECTION": "SECTION CONSACRÉE À LA MÉTHODOLOGIE AYANT REÇU LA NOTE LA PLUS BASSE",
      "LEAST_ARTICULATED_MESSAGE": "MESSAGE LE MOINS CLAIR",
      "ENGAGEMENT": "ENGAGEMENT",
      "USER_ENGAGEMENT_MORE_SESSIONS": "sessions terminées en plus par rapport à la moyenne de l'équipe",
      "QUESTION_CORRECT_PERCENTAGE_DESC": "du temps, ils ont bien répondu",
      "QUESTION_CORRECT_PERCENTAGE_DESC_ASSIGNMENT": "du temps, les utilisateurs réussissent cette question",
      "METHODOLOGY_AVERAGE_POINTS_DESC": "points en moyenne pour cet objectif sur l’ensemble des sessions",
      "MOST_ARTICULATED_MESSAGE": "MESSAGE LE PLUS CLAIR",
      "LEAST_MISSED_ANSWER_POINT": "POINT DE RÉPONSE LE MOINS MANQUÉ",
      "MOST_MISSED_ANSWER_POINT": "POINT DE RÉPONSE LE PLUS MANQUÉ",
      "MOST_ARTICULATED_MESSAGE_DESCRIPTION": "du temps, ils expriment très clairement ce message",
      "LEAST_ARTICULATED_MESSAGE_DESCRIPTION": "du temps, ils expriment clairement ce message",
      "ASSIGNMENT_STATUS": "État de la mission",
      "STATUS_ACTIVE": "Actif",
      "STATUS_ENDED": "Terminé",
      "STATUS_CLOSED": "Fermé",
      "STATUS_ARCHIVED": "Archivé",
      "USER_ENGAGEMENT_FEWER_SESSIONS": "sessions terminées en moins par rapport à la moyenne de l'équipe",
      "MOST_ARTICULATED_MESSAGE_DESCRIPTION_ASSIGNMENT": "du temps, les utilisateurs expriment clairement ce message",
      "LEAST_ARTICULATED_MESSAGE_DESCRIPTION_ASSIGNMENT": "du temps, les utilisateurs expriment clairement ce message",
      "OTHERS_SINGULAR": "et 1 autre",
      "OTHERS_PLURAL": "et {{ count }} autres",
      "PAGINATION_PREVIOUS": "Précédent",
      "PAGINATION_NEXT": "Suivant",
      "HOUR_LABEL": "heure",
      "SESSIONS_LABEL": "sessions"
    },
    "personalizedPractice": {
      "TITLE": "Entraînement personnalisé",
      "DESCRIPTION": "Bonjour {{userFirstName}} ! Les entraînements personnalisés vous permettent de paramétrer vos propres scénarios afin qu'ils soient aussi réalistes que possible.",
      "LOADING": "Chargement...",
      "VIEW_SESSIONS": "Voir les sessions",
      "VIEW_SIMULATION": "Voir la simulation",
      "TOTAL_SESSION": "nombre total de sessions",
      "TOTAL_SESSIONS": "nombre total de sessions",
      "BREADCRUMB": "Entraînement personnalisé",
      "SCENARIO_DETAILS_TITLE": "Détails du scénario",
      "SCENARIO_DETAILS_DESCRIPTION": "Sélectionnez des variables parmi les options ci-dessous pour ajuster la simulation en fonction de vos besoins.",
      "AVATAR": "Avatar",
      "SELECT_PLACEHOLDER": "Sélectionnez",
      "CONVERSATION_TYPE": "Type de conversation",
      "SELECT_CONVERSATION_TYPE": "Sélectionner un type de conversation",
      "LAUNCH_SIMULATION": "Lancer la simulation avec les sélections",
      "PREVIOUS_SESSIONS": "Sessions précédentes",
      "TOTAL": "Total",
      "FILTERS": "Filtres :",
      "DATE": "Date",
      "DIFFICULTY": "Difficulté",
      "TEMPERAMENT": "Tempérament",
      "SESSION_DATE": "Date de la session",
      "SESSION_SCORE": "Note de la session",
      "DURATION": "Durée",
      "OVERALL_SCORE": "Note globale",
      "MESSAGING": "Messagerie",
      "METHODOLOGY": "Méthodologie",
      "SKILLS": "Compétences",
      "RESULTS": "Résultats",
      "VIEW_FEEDBACK": "Voir le retour d’information",
      "OVERALL_SCORE_LABEL": "Note globale",
      "SCORE": "Note",
      "NO_PRODUCTS_TITLE": "Aucun produit disponible",
      "NO_PRODUCTS_DESCRIPTION": "Vous n'avez pas encore de produits d’entraînements personnalisés.",
      "NO_SESSIONS_FOUND": "Aucune session trouvée avec les filtres sélectionnés",
      "TIME": "Temps",
      "ALL": "Tous",
      "LEARNER": "Apprenant",
      "MOOD": "Humeur",
      "CLEAR_FILTERS": "Supprimer les filtres",
      "PAGINATION_PREVIOUS": "Précédent",
      "PAGINATION_NEXT": "Suivant",
      "DURATION_MINUTES_SECONDS": "{{minutes}} m {{seconds}} s",
      "DURATION_SECONDS": "{{seconds}} s"
    },
    "login": {
      "TITLE": "Bienvenue",
      "SUB_TITLE": "Comment souhaitez-vous vous connecter ?  ",
      "LOGIN_WITH_SSO": "Se connecter avec le SSO de l’entreprise",
      "LOGIN_WITH_PASSWORD": "Se connecter avec un mot de passe",
      "PROVIDE_EMAIL": "Indiquez votre adresse électronique",
      "HELP_TEXT": "Vous avez besoin d’aide ? Coordonnées",
      "EMAIL_ERROR": "Nous ne sommes pas en mesure de vous connecter. Veuillez contacter l’administrateur ou le service informatique de votre entreprise.",
      "EMAIL": "E-mail",
      "LOGIN": "Se connecter",
      "ALERT": "Alerte",
      "EMAIL_PLACEHOLDER": "olivia@untitledui.com",
      "LOGIN_CONSENT_MESSAGE": "En vous connectant à votre compte, vous acceptez les {{termsLink}} et la {{privacyLink}}.",
      "TERMS_OF_SERVICE": "Conditions de service",
      "PRIVACY_POLICY": "Politique de confidentialité",
      "WRONG_REGION_MESSAGE": "Nous ne parvenons pas à vous connecter. Veuillez contacter l'administrateur de votre entreprise.",
      "WRONG_REGION_LINK": "Vous pouvez également essayer de vous connecter au site {{regionName}}."
    },
    "learningPathway": {
      "BEGIN": "Commencer",
      "DUE_DATE": "Date d’échéance",
      "FOOTER_SUBTITLE_READY": "Posez-moi n'importe quelle question ! Je suis prêt à vous aider.",
      "LEAVE_STEP": "Quitter l’étape",
      "NEXT_STEP": "Étape suivante",
      "NOTIFICATIONS_ARIA": "Notifications",
      "PDF_NEXT_PAGE": "Page suivante",
      "PDF_NO_SOURCE": "Aucune source PDF fournie.",
      "PDF_PREVIOUS_PAGE": "Page précédente",
      "POST_CALL_SUBTITLE": "Laissez-nous un retour d’information pendant que nous traitons vos résultats",
      "POST_CALL_TITLE": "Vous avez atteint la fin de ce questionnaire.",
      "SETTINGS": "Paramètres",
      "TOAST_CONTENT": "Cliquez ci-dessous pour voir les résultats, ou retournez à l'écran des détails du parcours pour votre prochaine étape.",
      "TOAST_TITLE": "Vos résultats pour le jeu de rôle {{stepName}} ont été traités",
      "ASSIGNMENTS": "Missions",
      "USER_FALLBACK": "Utilisateur",
      "VIEW_RESULTS": "Voir les résultats",
      "QUIZ_TITLE": "Questionnaire",
      "SUBMIT_ANSWER": "Envoyer la réponse",
      "CONTINUE": "Continuer",
      "REVIEW_MATERIAL": "Passer le document en revue",
      "ASK_QUESTIONS_ABOUT_PATHWAY": "Poser des questions sur le parcours",
      "FOOTER_SUBTITLE_MUTED": "Vous êtes actuellement en sourdine. Le formateur ne peut pas vous entendre.",
      "FOOTER_SUBTITLE_LISTENING": "J’écoute votre question…",
      "FOOTER_SUBTITLE_THINKING": "Je réfléchis à une réponse…",
      "PDF_LOADING": "Chargement du PDF",
      "PDF_SCROLL_HINT": "Faites défiler pour continuer à lire",
      "QUIZ_OVERALL_SCORE_TOOLTIP": "La note globale est la moyenne pondérée de vos réponses pour cette tentative.",
      "QUIZ_COLUMN_DATE": "Date",
      "QUIZ_COLUMN_OVERALL_SCORE": "Note globale",
      "QUIZ_COLUMN_ANSWER_POINTS": "Points de réponse",
      "QUIZ_COLUMN_RESULTS": "Résultats",
      "COMPLETE_STEP": "Terminé",
      "ERROR_TITLE": "Un problème est survenu",
      "ERROR_MESSAGE": "Veuillez quitter le parcours, puis le réintégrer. Si le problème persiste, contactez",
      "ERROR_HELP_EMAIL": "help@quantified.ai",
      "PATHWAY_COMPLETED_TITLE": "Vous avez terminé ce parcours",
      "PATHWAY_COMPLETED_BODY": "Vous pouvez consulter vos résultats à tout moment, ou revoir n'importe quelle étape pour continuer à vous entraîner.",
      "PATHWAY_COMPLETED_RETURN": "Retourner aux missions",
      "PATHWAY_OUT_OF_ATTEMPTS_TITLE": "Vous avez épuisé vos tentatives pour une étape du parcours",
      "PATHWAY_OUT_OF_ATTEMPTS_BODY": "Contactez votre responsable pour discuter des prochaines étapes.",
      "COMPLETED": "Terminé",
      "EXITING_QUIZ_EARLY": "Si vous quittez ce questionnaire maintenant, cela comptera comme une tentative",
      "TRY_AGAIN": "Réessayer",
      "RETURN_TO_PATHWAY": "Retourner à l'accueil du parcours",
      "REVIEW_BEFORE_QUIZ_TOOLTIP": "Revoyez cette étape avant de retenter le questionnaire",
      "FOOTER_SUBTITLE_QUIZ_RESULT_DONE": "Cliquez sur le bouton à droite →",
      "VIEW_CALL_DETAILS": "Voir les détails de l’appel",
      "FOOTER_SUBTITLE_READY_LEARN_WITH_X": "Le formateur est à l’écoute si vous avez une question",
      "COLUMN_DATE": "Date",
      "COLUMN_OVERALL_SCORE": "Note globale",
      "COLUMN_RESULTS": "Résultats",
      "COLUMN_ANSWER_POINTS": "Points de réponse",
      "COLUMN_MESSAGING_SCORE": "Note de messagerie",
      "COLUMN_METHODOLOGY_SCORE": "Note de méthodologie",
      "COLUMN_SKILLS_SCORE": "Note de compétences",
      "PRACTICE_AGAIN": "Entraînez-vous à nouveau",
      "DEBRIEF_LATEST_SESSION": "Récapituler la dernière session",
      "EXIT_MODAL_TITLE": "Êtes-vous sûr de vouloir mettre fin à ce jeu de rôle ?",
      "EXIT_MODAL_EXIT": "Quitter",
      "EXIT_MODAL_RESUME": "Reprendre",
      "EXIT_MODAL_DESC_LIMITED_ATTEMPTS": "Si vous quittez le jeu de rôle maintenant, il ne sera pas noté, mais il sera malgré tout comptabilisé comme une tentative.",
      "EXIT_MODAL_DESC_UNLIMITED_ATTEMPTS": "Si vous quittez le jeu de rôle maintenant, il ne sera pas noté.",
      "EXIT_MODAL_DESC_SCORED": "Si vous quittez le jeu de rôle maintenant, nous noterons votre appel tel quel.",
      "RESULTS_PROCESSING": "Traitement des résultats",
      "RESULTS_FAILED": "Les résultats n'ont pas pu être chargés. Contactez help@quantified.ai",
      "DEBRIEF_TITLE": "Récapitulatif",
      "DEBRIEF_DESCRIPTION": "Discutez des résultats de votre dernière tentative de certification",
      "DEBRIEF_DESCRIPTION_PRACTICE": "Discutez des résultats de votre dernière session d'entraînement",
      "VIEW_ALL_SESSIONS": "Voir toutes les sessions",
      "COLLAPSE_SESSIONS": "Réduire les sessions",
      "VIEW_ALL_ATTEMPTS": "Voir toutes les tentatives",
      "COLLAPSE_ATTEMPTS": "Réduire les tentatives",
      "REATTEMPT_CERTIFICATION": "Retenter la certification",
      "DEBRIEF_EXIT_MODAL_TITLE": "Êtes-vous sûr de vouloir mettre fin à ce récapitulatif ?",
      "DEBRIEF_EXIT_MODAL_DESC": "Si vous quittez le récapitulatif maintenant, il ne sera pas marqué comme terminé.",
      "EXIT_PATHWAY": "Quitter le parcours",
      "HELP": "Aide",
      "LEARN_STEP_HELP_CLOSE": "Fermer",
      "LEARN_STEP_HELP_TROUBLE": "Si vous rencontrez toujours des problèmes, contactez",
      "LEARN_STEP_HELP_EMAIL": "help@quantified.ai",
      "LEARN_STEP_HELP_VIDEO_P1": "Regardez le document et posez au formateur toutes les questions que vous souhaitez.",
      "LEARN_STEP_HELP_VIDEO_P2": "Sélectionnez le bouton de lecture pour lancer la vidéo. Vous pouvez revenir en arrière pour revoir le document.",
      "LEARN_STEP_HELP_VIDEO_P3": "Rétablissez votre son en bas à droite pour poser une question. Cela mettra la vidéo en pause. Lorsque vous lancerez la vidéo, nous mettrons le son de votre microphone en sourdine.",
      "LEARN_STEP_HELP_VIDEO_P4": "Lorsque vous aurez regardé la vidéo en entier, passez à l'étape suivante.",
      "LEARN_STEP_HELP_PDF_P1": "Lisez le document et posez au formateur toutes les questions que vous souhaitez.",
      "LEARN_STEP_HELP_PDF_P2": "Parcourez le document en le faisant défiler ou en utilisant les boutons fléchés de chaque côté pour passer d'une page à l'autre.",
      "LEARN_STEP_HELP_PDF_P3": "Vous pouvez vous mettre en sourdine et rétablir votre son en bas à droite.",
      "LEARN_STEP_HELP_PDF_P4": "Lorsque vous aurez tout lu, passez à l'étape suivante.",
      "PDF_FULLSCREEN_ENTER": "Passer en mode plein écran",
      "PDF_FULLSCREEN_EXIT": "Quitter le mode plein écran",
      "PDF_ZOOM_IN": "Agrandir",
      "PDF_ZOOM_OUT": "Réduire",
      "ASSESSMENT_EXIT_MODAL_TITLE": "Êtes-vous sûr de vouloir continuer ?",
      "ASSESSMENT_EXIT_MODAL_DESC": "Si l'on passe à autre chose avant la fin de cette conversation, l'expérience d'apprentissage s'en trouvera allongée et moins personnalisée.",
      "ASSESSMENT_EXIT_MODAL_RESUME": "Reprendre l’évaluation",
      "ASSESSMENT_EXIT_MODAL_PROCEED": "Continuer",
      "ASSESSMENT_PERSONALIZATION_ERROR_TITLE": "Nous n'avons pas pu personnaliser votre parcours",
      "ASSESSMENT_PERSONALIZATION_ERROR_DESC_START": "Nous vous avons attribué l'ensemble du parcours. N'hésitez pas à contacter ",
      "ASSESSMENT_PERSONALIZATION_ERROR_DESC_END": " si vous souhaitez réessayer la personnalisation",
      "OPTIONAL": "Facultatif",
      "DISMISS": "Rejeter",
      "DOWNLOAD": "Télécharger"
    },
    "leaderboard": {
      "LEADERBOARD": "Tableau des notes",
      "TOP10PERCENT": "10 % les meilleures",
      "PRACTICE_ASSIGNMENT": "Missions d’entraînement",
      "SIMULATION": "Simulation",
      "SELECT_ASSIGNMENT": "Sélectionner une mission",
      "SELECT_SIMULATION": "Sélectionner une simulation",
      "SELECT_ASSIGNMENT_AND_SIMULATION": "Sélectionnez une mission et une simulation pour voir les meilleures notes",
      "NO_DATA": "Aucune activité pour l’instant. Une fois que l'équipe aura commencé à s’engager, vous verrez les classements apparaître ici.",
      "NO_ASSIGNMENTS_AVAILABLE": "Aucune mission disponible",
      "NO_SIMULATIONS_AVAILABLE": "Aucune simulation disponible",
      "NAME": "Nom",
      "HIGH_SCORE": "Note élevée",
      "AVERAGE_SCORE": "Note moyenne",
      "TOTAL_SESSIONS": "Nombre total de sessions",
      "LAST_SESSION": "Dernière session",
      "TOP5": "5 meilleures",
      "OF": "sur",
      "ENGAGED_USERS": "utilisateurs engagés",
      "ENGAGED_USER": "utilisateur engagé",
      "HIDE_SESSIONS_WITH_LOW_SCORE": "Masquer les sessions dont les notes de compétences sont faibles",
      "SESSIONS_WITH_LOW_SCORE_TOOLTIP": "Les sessions dont la note de la section compétences est « en développement » ne contribueront pas aux colonnes des notes élevées ou moyennes.",
      "NO_USERS_ENGAGED": "Aucun utilisateur engagé",
      "PAGINATION_PREVIOUS": "Précédent",
      "PAGINATION_NEXT": "Suivant"
    },
    "hotjarSurveys": {
      "FEEDBACK_MESSAGE": "N’hésitez pas à nous faire part de vos commentaires pour nous aider à nous améliorer.",
      "THANK_YOU_MESSAGE": "Merci. Nous continuerons à travailler pour améliorer votre expérience"
    },
    "general": {
      "NEED_HELP_QUESTION": "Vous avez besoin d’aide ?",
      "CONTACT": "Coordonnées",
      "HELP_EMAIL": "help@quantified.ai",
      "PARENT_ACCOUNT": "Compte parent",
      "ACCOUNT": "Compte",
      "CHECKMARK": "Coche",
      "ICON": "Icône",
      "ALERT": "alerte",
      "HEADS_UP": "Attention !",
      "USE_HEADPHONES_FOR_OPTIMAL_AUDIO": "Pour un son optimal sur iPad, veuillez utiliser des écouteurs.",
      "SETTINGS": "PARAMÈTRES",
      "RP": "RP",
      "EMAIL_LABEL": "E-mail",
      "RAVEN_EMAIL": "Raven@InspireHR.com",
      "TEAM_MANAGER_FOR": "Chef d’équipe pou",
      "MIAMI_SALE": "Ventes à Miami",
      "CHARLOTTE_SALES": "Ventes à Charlotte",
      "ATLANTA_SALES": "Ventes à Atlanta",
      "TEAM": "Équipe",
      "ASSIGNMENTS": "Missions",
      "MY_TEAMS": "Mes équipes",
      "REPORTING": "Rapports",
      "DASHBOARD": "Tableau de bord",
      "LEADERBOARD": "Tableau des notes",
      "PERSONALIZED_PRACTICE": "Entraînement personnalisé",
      "HELP_SEARCH_OUR": "Effectuez une recherche dans notre",
      "HELP_OR_REACH_OUT_TO": "ou contactez",
      "HELP_WITH_QUESTIONS": "pour poser des questions",
      "KNOWLEDGE_BASE": "base de connaissances",
      "NO_ROLE_WEB_MESSAGE": "Cet utilisateur ne dispose pas d'un accès au système. Veuillez contacter un administrateur système.",
      "NO_ROLE_IOS_TITLE": "Notre application s’attache à l'expérience de l'apprenant",
      "NO_ROLE_IOS_BODY_START": "Accédez à notre",
      "NO_ROLE_IOS_WEB_APP": "application Web",
      "NO_ROLE_IOS_BODY_END": "dans votre navigateur mobile pour bénéficier de fonctionnalités supplémentaires.",
      "HELP_SECTION": "AIDE",
      "ABOUT_SECTION": "À PROPOS DE",
      "CONTACT_SUPPORT": "Contacter l’assistance",
      "OPEN_WEB_APP": "Ouvrir l'application Web",
      "SEARCH_KNOWLEDGE_BASE": "Effectuer une recherche dans la base de connaissances",
      "PRIVACY_POLICY": "Politique de confidentialité",
      "TERMS_OF_SERVICE": "Conditions de service",
      "VERSION": "Version",
      "LOG_OUT": "Se déconnecter"
    },
    "dashboard": {
      "ALL": "Tous",
      "IN_COMPLETE": "Incomplet",
      "COMPLETED": "Terminé",
      "NO_ASSIGNMENT_TITLE": "Vous n’avez pas de mission à accomplir.",
      "NO_ASSIGNMENT_DETAILS": "Vous serez averti lorsque vous aurez des missions à accomplir.",
      "IN_COMPLETE_ASSIGNMENT_TITLE": "Vous n’avez aucune mission incomplète.",
      "IN_COMPLETE_ASSIGNMENT_DETAILS": "Vous serez averti lorsqu’une nouvelle mission sera à remettre.",
      "COMPLETED_ASSIGNMENT_TITLE": "Vous n’avez aucune mission terminée.",
      "COMPLETED_ASSIGNMENT_DETAILS": "Revenez une fois que vous aurez terminé une mission.",
      "VIEW_ASSIGNMENT": "Voir la mission",
      "ASSIGNMENT_LABEL": "Missions",
      "MODULE_ASSIGNMENT_ALT": "Icône de mission du module",
      "VIEW_ASSIGNMENT_FOR": "Voir la mission pour",
      "DAY": "Jour",
      "UNTILL_DUE": "Délai restant",
      "PAST_DUE": "En retard",
      "AVAILABLE_IN": "Disponible dans",
      "DUE_TODAY": "À remettre aujourd’hui",
      "PRACTICE": "Entraînement",
      "CERTIFICATION": "Certification",
      "UPCOMING": "À venir",
      "TEST_ASSIGNMENT": "Mission test",
      "CLOSED": "Fermé",
      "NO_ASSIGNMENT_FILTERED_TITLE": "Aucune mission trouvée.",
      "NO_ASSIGNMENT_FILTERED_DETAILS": "Essayez d'ajuster vos filtres pour voir les missions disponibles, ou revenez plus tard lorsque de nouvelles missions auront été ajoutées.",
      "VIEW_PATHWAY": "Voir le parcours",
      "TOTAL": "Total",
      "STATUS_LABEL": "État",
      "STATUS_SELECTION_LABEL": "État :",
      "ASSIGNMENT_TYPE": "Type de mission",
      "ASSIGNMENT_TYPE_SELECTION_LABEL": "Type de mission :",
      "NOT_STARTED": "Non commencé",
      "CERTIFIED": "Certifié",
      "NOT_CERTIFIED": "Non certifié",
      "IN_PROGRESS": "En cours",
      "PATHWAY": "Parcours d'apprentissage",
      "SELECT_ALL": "Sélectionner tout",
      "DESELECT_ALL": "Désélectionner tout",
      "GET_STARTED": "Commencer",
      "ASSIGNMENT_STATUS_LABEL": "État de la mission",
      "ASSIGNMENT_STATUS_SELECTION_LABEL": "État de la mission :",
      "CLEAR_STATUS": "Effacer l’état",
      "ENDED": "Terminé",
      "START_PATHWAY": "Commencer le parcours",
      "DAYS": "Jours",
      "OTHERS_SINGULAR": "et 1 autre",
      "OTHERS_PLURAL": "et {{ count }} autres"
    },
    "cognito": {
      "INVITATION_SUBJECT": "Bienvenue à Quantified !",
      "INVITATION_MESSAGE": "Nous sommes ravis de vous compter parmi nous ! Pour commencer, veuillez suivre les étapes ci-dessous afin de vous connecter à votre compte pour la première fois.",
      "ACCOUNT_DETAILS": "Détails de votre compte :",
      "USERNAME": "Nom d’utilisateur",
      "PASSWORD": "Mot de passe temporaire",
      "STEPS_LABEL": "Étapes suivantes pour se connecter",
      "STEP_1": "1. Cliquez sur le bouton \"Se connecter\" ci-dessous pour accéder à la page de connexion.",
      "STEP_2": "2. Saisissez votre nom d’utilisateur et le mot de passe temporaire indiqué ci-dessus.",
      "STEP_3": "3. Une fois connecté, vous serez invité à définir un nouveau mot de passe.",
      "LOGIN_BUTTON": "Se connecter",
      "ABOUT_US": "Le Simulateur de Quantified est un environnement virtuel conçu pour vous aider à développer rapidement des compétences essentielles, vous permettant de contacter des clients et de communiquer plus efficacement avec eux.",
      "EXPIRY_TIME": "Ce mot de passe temporaire expirera dans 24 heures. Si vous rencontrez des difficultés pour vous connecter, veuillez contacter notre équipe d’assistance à l’adresse",
      "TEAM": "L’équipe Quantified",
      "INVITATION_SMS_USERNAME": "Votre nom d’utilisateur est",
      "INVITATION_SMS_PASSWORD": "et le mot de passe temporaire est",
      "AUTHENTICATION_CODE": "Votre code d’authentification est",
      "PASSWORD_RESET_CODE": "Votre code de réinitialisation du mot de passe Quantified",
      "RESET_PASSWORD_EMAIL": "E-mail de réinitialisation du mot de passe",
      "HELLO": "Bonjour",
      "USE_VERIFICATION_CODE": "Vous avez demandé une réinitialisation de votre mot de passe. Veuillez utiliser le code de vérification ci-dessous pour terminer le processus.",
      "VERIFICATION_CODE": "Code de vérification",
      "NEXT_STEP": "Étapes suivantes",
      "RESET_PASSWORD_PAGE": "Retournez à la page de réinitialisation de votre mot de passe dans votre navigateur.",
      "ENTER_VERIFICATION_CODE": "Saisissez le code de vérification lorsque vous y êtes invité.",
      "CREATE_PASSWORD": "Une fois le code vérifié, suivez les instructions pour créer un nouveau mot de passe.",
      "DISREGARD_NOTE": "Si vous n’avez pas demandé à réinitialiser votre mot de passe, veuillez ignorer cet e-mail.",
      "CONTACT_SUPPORT": "Pour plus d’assistance, contactez notre équipe d’assistance à l’adresse",
      "HELP_EMAIL": "help@quantified.ai",
      "THANK_YOU": "Merci",
      "QUANTIFIED_TEAM": "L’équipe Quantified",
      "ADDRESS": "4200 Marathon Blvd, Suite 210, Austin, Texas 78756, États-Unis",
      "RETURN_TO_PATHWAY": "Retourner à l'accueil du parcours"
    },
    "call": {
      "LOADING": "Chargement",
      "SIMULATION_PAUSED": "La simulation a été mise en pause.",
      "CLICK_RESUME": "Cliquez sur le bouton « Reprendre » ci-dessous pour continuer.",
      "NO_INTERNET": "Aucune connexion Internet",
      "TRY_AGAIN": "Veuillez vérifier votre connexion et réessayer.",
      "MIC_MUTED": "Le micro est en sourdine",
      "MIC_MUTED_DESCRIPTION": "Oups, on dirait que votre micro est en sourdine. Rétablissez le son pour répondre et poursuivre.",
      "NO_RESPONSE": "Aucune réponse détectée",
      "MIC_NOT_CONNECTED": "Oups, on dirait que votre micro n’est pas connecté. Sélectionnez à nouveau votre appareil pour répondre et poursuivre.",
      "AUDIO_ISSUE": "Oups, un problème est survenu. Vérifiez les paramètres de votre appareil, et assurez-vous d'être dans un endroit calme, sans bruit de fond.",
      "LOADING_ALT": "Chargement...",
      "REPEAT_RESPONSE": "Vous serez automatiquement renvoyé à la simulation pour répéter votre réponse et réessayer.",
      "NEEDS_MORE_TIME_QUESTION": "a besoin de plus de temps pour réfléchir. Voulez-vous attendre ?",
      "NEEDS_MORE_TIME": "a besoin de plus de temps pour réfléchir.",
      "WAIT_OR_END_CALL": "Nous vous préviendrons lorsqu’ils seront prêts, ou vous pouvez mettre fin à l’appel et",
      "RETURN_TO_ASSIGNMENTS": "retourner à la mission",
      "READY": "Prêt",
      "IS_READY": "est prêt à poursuivre la conversation.",
      "TRY_AGAIN_LABEL": "Réessayer",
      "CHECK_SETTINGS": "Vérifier les paramètres",
      "PAUSED_SIMULATION": "Vous avez mis cette simulation en pause.",
      "PAUSED_SIMULATION_DESCRIPTION": "L’enregistrement vidéo et audio est mis en pause jusqu’à ce que la simulation reprenne.",
      "RESUME": "Reprendre",
      "SETTINGS": "Paramètres",
      "CAPTURING_RESPONSE": "Capture de vos réponses",
      "TOUR_MESSAGE": "Une fois que vous aurez fini de parler, assurez-vous de cliquer sur le bouton Continuer pour que vos réponses soient capturées et notées.",
      "NEXT": "Suivant",
      "START_CALL": "Commencer",
      "END_CALL_TITLE": "Souhaitez-vous vraiment mettre fin à cette simulation ?",
      "END_CALL_DESCRIPTION": "Si vous mettez fin à la simulation maintenant, vous n’obtiendrez pas de note ni de retour d’information sur votre conversation.",
      "END_CALL": "Terminer",
      "BROWSER_ACCESS_DENIED": "Votre navigateur n’a pas accès à cet appareil.",
      "COPY_SESSION_ID_BUTTON": "Copier l’ID de session",
      "TIPS_GUIDANCE_MESSAGE": "Des points de discussion et des conseils s’afficheront ici.",
      "CONTINUE": "Continuer",
      "SESSION_ID_LABEL": "ID de session :",
      "SESSION_ID_COPIED": "L’ID de session a été copié !",
      "HINTS_AND_SUGGESTIONS_TITLE": "Conseils et suggestions",
      "HINT_LABEL": "Conseil",
      "CAPTIONS_LABEL": "Sous-titres",
      "PAUSE_LABEL": "Pause",
      "VIDEO_LABEL": "Vidéo",
      "PARTY_EMOJI": "émoji de fête",
      "CALL_ENDED_MESSAGE": "Vous avez atteint la fin de cette simulation.",
      "CALL_ENDED_INACTIVITY": "Cette simulation a pris fin en raison d’une inactivité",
      "CALL_ENDED_GENERIC": "Cette simulation est terminée",
      "FEEDBACK_PROMPT": "Laissez-nous vos commentaires pendant que nous traitons vos résultats.",
      "INTERACTION_THRESHOLD_NOT_MET": "Vous n’avez pas atteint notre seuil d’interaction pour la notation. Veuillez réessayer.",
      "REALISTIC_CONVERSATION_QUESTION": "Cette conversation vous a-t-elle semblé réaliste et naturelle ?",
      "KNOWLEDGEABLE_PREPARED_QUESTION": "Vous sentez-vous mieux informé et préparé après cette simulation ?",
      "FEEDBACK_THANK_YOU": "Merci pour vos commentaires !",
      "FEEDBACK_IMPROVEMENT_NOTE": "Merci pour vos commentaires ! Nous nous efforcerons d’améliorer l’expérience.",
      "AUDIO": "Audio",
      "VISUAL_AID_LOAD_ERROR": "L’aide visuelle n’a pas pu être chargée",
      "BEGIN_CALL": "Commencer",
      "LEAVE_CALL_BRIEFING": "Quitter les directives",
      "RESTORE_CALL": "Restauration de votre simulation",
      "FEW_SECONDS": "Cela peut prendre quelques secondes.",
      "CHECK_ALT": "Coche",
      "COPY_ALT": "Copier",
      "HINTS_ALT": "Conseils",
      "CLOSE_CAPTIONS": "Fermer les sous-titres",
      "MICROPHONE_MUTED": "Microphone en sourdine",
      "RETURN_TO_CALL": "Retourner à la simulation",
      "YES": "Oui",
      "NO": "Non",
      "VIEW_RESULTS": "Voir les résultats",
      "RETURN_TO_ASSIGNMENT": "Retourner à la mission",
      "HAVING_ISSUES": "Nous avons des difficultés à nous connecter. Veuillez vérifier votre connexion Internet, puis cliquez sur OK.",
      "OK": "OK",
      "RESULTS_NOT_GENERATED": "Désolé, nous ne sommes pas en mesure de générer des résultats pour le moment. Veuillez réessayer.",
      "INACTIVITY_ALERT_MESSAGE": "Cet appel est en train de se terminer en raison d’une inactivité. Parlez à l’avatar pour continuer, ou sélectionnez « Mettre fin à l’appel » pour terminer l’appel.",
      "INACTIVITY_DEFAULT_ALERT_TITLE": "Cet appel se terminera dans {{secondsUntilHangup}} secondes",
      "INACTIVITY_SHORT_ALERT_TITLE": "Cet appel se terminera dans quelques secondes",
      "TELL_YOUR_GENDER_HEADING": "Veuillez indiquer votre genre :",
      "BY_KNOWING_YOUR_GENDER_DESCRIPTION": "En connaissant votre genre, l’avatar pourra utiliser une grammaire correcte, ce qui rendra la conversation plus naturelle et plus réaliste.",
      "GENDER_SELECTION": "Sélection du genre :",
      "SELECT_OPTION": "Sélectionner une option",
      "CONFIRM": "Confirmer",
      "MALE": "Homme",
      "FEMALE": "Femme",
      "NON_BINARY": "Non-binaire/Autre",
      "PREFER_NOT_TO_ANSWER": "Préfère ne pas répondre",
      "NON_BINARY_MESSAGE": "Nous comprenons et respectons votre identité de genre non binaire. En raison des limites technologiques actuelles, nous utilisons par défaut des pronoms masculins. Sachez que nous travaillons à des améliorations pour mieux prendre en compte toutes les identités de genre. Nous vous remercions de votre compréhension et de votre patience.",
      "PREFER_NOT_TO_ANSWER_MESSAGE": "Nous respectons votre choix de ne pas fournir de genre. Dans ce cas, notre technologie utilise par défaut les pronoms masculins en raison des limitations actuelles.",
      "DISPLAY_VISUAL_AID": "Afficher l’aide visuelle",
      "FULL_SCREEN": "Plein écran",
      "COLLAPSE": "Réduire",
      "COMPLETED_CONVERSATION_MESSAGE": "Merci d'avoir terminé cette conversation",
      "CONVERSATION_COMPLETION_FEEDBACK": "Laissez un retour d’information pendant que nous traitons votre conversation.",
      "ERROR_MESSAGE": "Une erreur s'est produite. Veuillez contacter",
      "SAVED_CONVERSATION_MESSAGE": "Votre conversation a été enregistrée.",
      "RETURN_TO_MY_ASSIGNMENTS": "Retourner à mes missions",
      "RETURN_TO_PERSONALIZED_PRACTICE": "Retourner à l’entraînement personnalisé",
      "PERSONALIZED_CALL_NOTE": "Vous venez de terminer une conversation d’entraînement personnalisée.",
      "LEAVE_STEP_TITLE": "Souhaitez-vous vraiment quitter cette étape ?",
      "EXIT": "Quitter",
      "CERT_ACK_TITLE": "Reconnaissance de la vidéo de certification",
      "CERT_ACK_ACCEPT_AND_BEGIN": "Accepter et commencer",
      "CERT_ACK_RESUME_CALL": "Reprendre l'appel",
      "CERT_ACK_PROCESSING": "En cours de traitement…",
      "CERT_ACK_CAMERA_WARNING": "Veuillez activer votre caméra pour procéder à la certification.",
      "CERT_ACK_CAMERA_OFF_DURING_CALL": "Votre caméra était éteinte. Veuillez réactiver votre caméra pour reprendre la certification.",
      "CERT_ACK_TEXT_1": "Afin que l'intégrité et l'équité de cette certification soient garanties, votre caméra doit rester allumée tout au long de la session, et la session sera surveillée. Cette exigence vise à confirmer la conformité à toutes les normes de certification.",
      "CERT_ACK_TEXT_2": "En continuant, vous reconnaissez et acceptez ces exigences.",
      "CERT_ACK_END_CALL": "Mettre fin à l’appel",
      "LAUNCH_SIMULATION": "Lancer la simulation",
      "DEBRIEF_LATEST_SESSION": "Récapituler la dernière session",
      "RECONNECTING_AUDIO": "Reconnexion du son…",
      "END": "Terminer",
      "START_DEBRIEF": "Récapituler la dernière session",
      "MOVE_TO_NEXT": "Passer à l'étape suivante",
      "RETRY_ROLEPLAY": "Réessayer le jeu de rôle",
      "EXIT_PATHWAY": "Quitter le parcours",
      "PROCESSING": "En cours de traitement…",
      "FEEDBACK_PROMPT_REQUIRED": "Laissez un commentaire avant de consulter vos résultats.",
      "MUTE": "Couper le son",
      "UNMUTE": "Rétablir le son",
      "SCREENSHARE_LABEL": "Partager l’écran",
      "SCREENSHARE_UNSUPPORTED_TITLE": "{{callName}} utilise le partage d'écran",
      "SCREENSHARE_UNSUPPORTED_MESSAGE_APP": "Pour poursuivre l'appel, veuillez utiliser notre application au lieu de votre navigateur.",
      "SCREENSHARE_UNSUPPORTED_MESSAGE_DESKTOP": "Pour poursuivre l'appel, accédez-y sur un ordinateur de bureau.",
      "SCREENSHARE_UNSUPPORTED_CLOSE_BUTTON": "Fermer",
      "SCREENSHARE_UNSUPPORTED_GO_TO_APP_BUTTON": "Aller sur l'application",
      "SCREENSHARE_UNSUPPORTED_GO_TO_APP_UNAVAILABLE": "L'application mobile n'est pas encore disponible. Veuillez réessayer plus tard.",
      "SCREENSHARE_STOP_LABEL": "Arrêter de partager l’écran",
      "SCREENSHARE_PIP_REOPEN_LABEL": "Rouvrir l’aperçu vidéo",
      "SCREENSHARE_ACTIVE_LABEL": "Vous partagez actuellement l’écran",
      "SCREENSHARE_OS_PERMISSION_HINT": "Impossible de lancer le partage d'écran. Activez l'enregistrement de l’écran pour votre navigateur dans Paramètres système > Confidentialité et sécurité, puis réessayez.",
      "SCREENSHARE_SAFARI_BLOCKED_HINT": "Safari a bloqué le partage d'écran pour cette session. Déconnectez-vous et reconnectez-vous, puis réessayez."
    },
    "assignment": {
      "STATUS": "ÉTAT",
      "SCORE": "NOTE",
      "MUST_ACHIEVE": "Doit obtenir un",
      "OR_HIGHER": "ou plus",
      "TEST": "Test",
      "OUT_OF_5": "sur 5",
      "LATEST_ATTEMPT": "DERNIÈRE TENTATIVE",
      "TOTAL_ATTEMPTS": "Nombre total de tentatives",
      "UNLIMITED": "Illimité",
      "REMAINING": "Restant",
      "VIEW_CALL_DETAILS": "Voir les détails",
      "MAX_ATTEMPTS_REACHED": "Vous avez atteint le nombre maximum de tentatives",
      "DUE_DATE": "Date d’échéance",
      "DAYS": "Jours",
      "DAY": "Jour",
      "UNTILL_DUE": "Délai restant",
      "PAST_DUE": "En retard",
      "ONGOING": "En cours",
      "SCORE_REQUIREMENT": "Exigence de note",
      "SCORE_REQUIREMENT_DETAIL": "Vous devez obtenir une note de",
      "TO_COMPLETE_EACH_CALL": "pour terminer chaque simulation requise.",
      "CALLS_IN_ASSIGNMENT": "Simulations de la mission",
      "INCOMPLETE_CALL": "Incomplet",
      "PREVIOUS_RESULTS": "Résultats précédents",
      "DATE": "Date",
      "RESULTS": "Résultats",
      "VIEW_PREVIOUS_RESULTS": "Voir les résultats précédents",
      "VIEW_FEEDBACK": "Voir le retour d’information",
      "LAUNCH_CALL": "Lancer",
      "CLOSE_BUTTON": "Bouton de fermeture",
      "CHECKMARK": "coche",
      "CALL": "Appeler",
      "QUESTION": "Question",
      "COMPLETED": "Terminé",
      "IN_PROGRESS": "En cours",
      "NOT_STARTED": "Non commencée",
      "CERTIFIED": "Certifié",
      "GUIDED": "Guidé",
      "CONVERSATIONAL": "Conversationnel",
      "GUIDED_SIMULATION": "Vérification des connaissances",
      "CONVERSATIONAL_SIMULATION": "Jeu de rôle",
      "NO_ATTEMPTS_LEFT": "Il ne reste plus de tentatives",
      "NO_ATTEMPTS": "Aucune tentative",
      "OVERVIEW": "Vue d’ensemble",
      "ABOUT_THE_AVATAR": "À propos de l’avatar",
      "SCORING_CRITERIA": "Critères de notation",
      "SIMULATION_OVERVIEW": "Aperçu de la simulation",
      "ABOUT_THE_PERSONA": "À propos de la persona",
      "OUTOF_COMPLIANCE": "Non conforme",
      "CLOSED": "Fermé",
      "COMPLETED_CALLS": "Appels terminés"
    }
  },
  "fr-CA": {
    "root": {
      "ADMIN_PORTAL": "PORTAIL ADMIN",
      "SUPPORT": "SOUTIEN",
      "U": "U",
      "USER": "Utilisateur",
      "LOGOUT": "Déconnexion",
      "ADMIN": "Administrateur",
      "SUPPORT_SMALL": "Soutien",
      "QUANTIFIED_AI": "Quantified.AI",
      "MICROPHONE": "MICROPHONE",
      "CAMERA": "CAMÉRA",
      "ACCESS_DENIED": "ACCÈS_REFUSÉ"
    },
    "teams": {
      "MY_TEAMS": "Mes équipes",
      "COMPLETED": "Terminé",
      "IN_PROGRESS": "En cours",
      "NOT_STARTED": "Pas commencé",
      "ASSIGNMET_MODULE": "Module d’affectation",
      "START_DATE": "Date de début",
      "DUE_DATE": "Date d’échéance",
      "ASSIGNED_MEMBERS": "Membres assignés",
      "CALLS_IN_MODULE": "Simulations dans le module",
      "COMPLETION_REQUIRMENT": "Condition d’achèvement",
      "COMPLETE_ALL_CALLS": "Terminer tous les appels avec une note de",
      "OR_HIGHER": "ou plus",
      "PROGRESS_OVERVIEW": "APERÇU DES PROGRÈS RÉALISÉS",
      "TEAM_MEMBERS": "membres de l’équipe",
      "AVERAGE_HIGH_SCORE": "Moyenne des notes élevées",
      "AVERAGE_NUMBER_ATTEMPTS_CALL": "Nombre moyen de tentatives par simulation",
      "TOTAL_PRACTICES": "Total des pratiques",
      "INDIVIDUAL_CALL_PROGRESS": "LA PROGRESSION DE LA SIMULATION INDIVIDUELLE",
      "OF_TEAM_MEMBERS": "Nombre de membres de l’équipe ayant terminé leur formation",
      "AVERAGE_PRACTICES_TO_COMPLETION": "Pratiques moyennes jusqu’à l’achèvement",
      "TEAM_MEMBER_DETAILS": "INFORMATIONS SUR LES MEMBRES DE L’ÉQUIPE",
      "DOWNLOAD_ACTIVITY_REPORT": "Téléverser le rapport d’activité",
      "TEAM_MEMBER": "Membre de l’équipe",
      "PROGRESS": "Progrès",
      "CALLS_COMPLETED": "Simulations réalisées",
      "PRACTICES": "Séances de pratique",
      "MOST_RECENT_PRACTICE": "Dernière session",
      "THIS_TEAM_HAS_NO_ACTIVE_ASSIGNMENTS": "Cette équipe n’a pas d’affectation active pour le moment.",
      "CALL_NAME_LABEL": "Nom de la simulation",
      "HIGHEST_SCORE": "Meilleure note"
    },
    "simulationBuilder": {
      "THRESHOLD": "Seuil",
      "TYPE": "Type",
      "SELECT_AN_OPTION": "Sélectionner une option",
      "CORRECT_FEEDBACK": "Réponse correcte",
      "INCORRECT_FEEDBACK": "Réponse incorrecte",
      "CORRECT_FEEDBACK_PLACEHOLDER": "S’affiche lorsque l'apprenant répond correctement",
      "INCORRECT_FEEDBACK_PLACEHOLDER": "S’affiche lorsque l'apprenant répond de manière incorrecte",
      "ENTER_MESSAGE_TEXT": "Entrez le texte du message...",
      "DELETE": "Supprimer",
      "SCORABLE": "Assujetti à une note",
      "MESSAGE_NUMBER": "Message {{ index }}",
      "SEARCH_BY_SIMULATION_NAME": "Recherche par nom de simulation",
      "SEARCH_BY_ASSIGNMENT_NAME": "Recherche par nom d'assignation",
      "SIMULATION_STATUS_PLACEHOLDER": "État de la simulation",
      "SIMULATION_STATUS_PREFIX": "État de la simulation :",
      "NO_SIMULATIONS_FOUND": "Aucune simulation trouvée",
      "SELECT_ALL": "Tout sélectionner",
      "DESELECT_ALL": "Tout désélectionner",
      "STATUS_TESTING": "Essai",
      "STATUS_DRAFT": "Brouillon",
      "STATUS_PUBLISHED": "Publié",
      "STATUS_ARCHIVED": "Archivé",
      "ASSIGNEES_ZERO_STATE_MESSAGE": "Aucun utilisateur n'a encore été affecté.",
      "ADD_USERS_TO_ASSIGNMENT": "Ajouter des utilisateurs à l'affectation",
      "NO_DATA_FOUND": "Aucune donnée n’a été trouvée",
      "NO_USERS_SELECTED": "Aucun utilisateur sélectionné",
      "COL_FIRST_NAME": "Prénom",
      "COL_LAST_NAME": "Nom de famille",
      "COL_EMAIL": "Courriel",
      "COL_VIEW_USER": "Voir l'utilisateur",
      "COL_VIEW_ASSIGNMENT": "Voir l’affectation",
      "COL_ASSIGNMENT_NAME": "Nom de l'affectation",
      "COL_STATUS": "État",
      "COL_TEAM_ASSOCIATIONS": "Associations d'équipes",
      "COL_REPORTING_STATUS": "État des rapports",
      "BREADCRUMB_USERS": "Utilisateurs",
      "STATUS_STAGED": "Mise en scène",
      "STATUS_ACTIVE": "Actif",
      "STATUS_ENDED": "Terminé",
      "STATUS_CLOSED": "Fermé",
      "SEARCH_USERS_PLACEHOLDER": "Recherche d'utilisateurs",
      "NO_USERS_FOUND": "Aucun utilisateur trouvé",
      "USERS_TAB_LABEL": "Utilisateurs",
      "ADD_TO_ASSIGNMENT": "Ajouter à mes affectations",
      "ASSIGNMENTS_COUNT": "Affectations",
      "REPORTING_EXCLUDED": "Exclus",
      "REPORTING_INCLUDED": "Inclus",
      "KEBAB_EDIT_TEAM_ASSOCIATIONS": "Modifier les associations de l'équipe",
      "KEBAB_EXCLUDE_FROM_REPORTING": "Exclure dans le rapport",
      "KEBAB_INCLUDE_IN_REPORTING": "Inclure dans le rapport",
      "KEBAB_REMOVE_FROM_ASSIGNMENT": "Retirer de l'affectation",
      "NO_TEAMS": "—",
      "TEAMS_COUNT": "{{count}} équipe(s)",
      "ADD_TO_ASSIGNMENT_MODAL_HEADING": "Ajouter à mes affectations",
      "FIELD_LABEL_ASSIGNMENT": "Affectation",
      "SEARCH_ASSIGNMENTS_PLACEHOLDER": "Recherche d’affectations",
      "BUTTON_SET_TEAM_ASSOCIATION": "Définir les associations de l'équipe",
      "FIELD_LABEL_TEAM": "Équipe",
      "SEARCH_TEAM_PLACEHOLDER": "Rechercher une équipe",
      "BUTTON_BACK": "Retour",
      "BUTTON_CANCEL": "Annuler",
      "BUTTON_ADD_TO_ASSIGNMENT": "Ajouter à mes affectations",
      "EDIT_TEAM_ASSOCIATIONS_HEADING": "Modifier les associations de l'équipe",
      "EDIT_TEAM_ASSOCIATIONS_DESCRIPTION": "Pour l'affectation {{assignmentName}}",
      "BUTTON_SAVE_ASSOCIATIONS": "Enregistrer les associations",
      "REFERENCE_DOCUMENT_STATUS_UPLOADING": "– En cours de téléversement...",
      "REFERENCE_DOCUMENT_STATUS_SUCCESS": "– Téléversement terminé à 100 %",
      "REFERENCE_DOCUMENT_STATUS_ERROR": "– Erreur de téléversement",
      "CREATE_SIMULATION_DETAILS_BUTTON": "Créez les détails de la simulation",
      "SELF_AUTHORING_DESCRIPTION": "Entrez un nom, une brève description du scénario et tout document spécifique à la simulation pour commencer",
      "CLICK_TO_UPLOAD": "Cliquez pour téléverser",
      "OR_DRAG_AND_DROP": "ou glissez-déposez",
      "REFERENCE_DOCUMENTS_UPLOAD_DESCRIPTION": "PDF (max. 50 Mo)",
      "ASSIGNMENT_NAME_LABEL": "Nom de l'affectation *",
      "SIMULATION_NAME_LABEL": "Nom de la simulation",
      "NAME_FIELD_DESCRIPTION": "Ce nom peut être modifié ultérieurement",
      "PRODUCT_LABEL": "Produit",
      "SELECT_A_PRODUCT_PLACEHOLDER": "Sélectionnez un produit",
      "ADD_NEW_PRODUCT": "Ajoutez un nouveau produit",
      "SCENARIO_LABEL": "Scénario",
      "REFERENCE_DOCUMENTS_LABEL": "Documents de référence",
      "ACTION_CREATE_NEW": "Créez un nouveau",
      "ACTION_CREATE": "Créez",
      "ACTION_DUPLICATE": "Dupliquez",
      "ENTITY_TYPE_SIMULATION_DISPLAY": "Simulation",
      "ENTITY_TYPE_ASSIGNMENT_DISPLAY": "Affectation",
      "ENTITY_TYPE_SIMULATION_LOWER": "simulation",
      "ENTITY_TYPE_ASSIGNMENT_LOWER": "affectation",
      "MODAL_TITLE": "{{ action }} {{ type }}",
      "CONFIRM_BUTTON_LABEL": "{{ action }} {{ type }}",
      "DUPLICATE_NAME_ERROR_ASSIGNMENT": "Une affectation portant le même nom existe déjà.",
      "DUPLICATE_NAME_ERROR_SIMULATION": "Une simulation portant le même nom existe déjà.",
      "NAME_REQUIRED_ERROR": "Le nom est obligatoire.",
      "COPY_OF_PREFIX": "Copie de - {{ name }}",
      "SCORE_DISTRIBUTION_TITLE": "Répartition actuelle des notes",
      "EDIT_SECTIONS_AND_WEIGHTING": "Modifiez les sections et la pondération",
      "SCORING_WEIGHTS_TITLE": "Configurer la notation",
      "SCORING_WEIGHTS_DESCRIPTION": "Choisissez les domaines à évaluer et la contribution de chacun à la note globale. La somme des pondérations de toutes les sections activées doit être égale à 100 %. La section « Compétences » ne peut pas avoir une pondération supérieure à 20 %.",
      "SCORING_WEIGHT_REQUIRED": "Obligatoire",
      "REFERENCE_DOCUMENT_STATUS_DELETING": "– Suppression",
      "REFERENCE_DOCUMENT_DELETE_ERROR": "Échec de la suppression du document. Veuillez réessayer.",
      "REFERENCE_DOCUMENT_UPLOAD_ERROR": "Échec du téléversement du document. Veuillez réessayer.",
      "CONTENT_LIMIT_EXCEEDED_ERROR": "Limite de contenu dépassée. Supprimer un ou plusieurs documents pour continuer.",
      "LAST_FACT_DELETE_WARNING_HEADING": "Voulez-vous supprimer le dernier fait?",
      "LAST_FACT_DELETE_WARNING_DESCRIPTION": "La suppression du dernier fait supprimera toutes les associations d’utilisateurs avec cette simulation et rétablira son état à « Ébauche ».",
      "LEAVE_CONFIRMATION_HEADING": "Quitter la création de la simulation",
      "LEAVE_CONFIRMATION_DESCRIPTION": "Êtes-vous sûr de vouloir quitter? Tout le travail que vous avez accompli sera perdu.",
      "LEAVE_CONFIRMATION_LEAVE_BUTTON": "Quitter",
      "METHODOLOGY_TITLE": "Méthodologie",
      "METHODOLOGY_SUBTITLE": "Évaluer l’approche et la structure de l’appel",
      "METHODOLOGY_WEIGHTING_LABEL": "Pondération : {{ weight }} %",
      "METHODOLOGY_RUBRIC_LABEL": "Grille méthodologique",
      "SELECT_RUBRIC_PLACEHOLDER": "Sélectionner la grille",
      "SKILLS_TITLE": "Compétences",
      "SKILLS_SUBTITLE": "Évaluer la communication et les compétences interpersonnelles",
      "SKILLS_WEIGHTING_LABEL": "Pondération : {{ weight }} %",
      "SKILLS_RUBRIC_LABEL": "Grille des compétences",
      "PROCESSING_DOCUMENTS_MESSAGE": "Traitement des documents...",
      "PROCESSING_DOCUMENTS_SUPPORTING_TEXT": "N’hésitez pas à vous éloigner un instant — les résultats seront prêts d’ici 5 minutes.",
      "CORE_SIGNAL_MESSAGE": "Interprétation de votre contenu…",
      "SECTION_PLAN_MESSAGE": "Planification de la structure de votre simulation...",
      "DERIVED_COMPONENT_MESSAGE": "Création des composantes de votre simulation…",
      "COMPONENT_WAVE_1_MESSAGE": "Rédaction du contenu de votre simulation...",
      "STILL_PROCESSING_TITLE": "Traitement toujours en cours...",
      "STILL_PROCESSING_BODY": "Cela prend plus de temps que d’habitude — vous pouvez quitter cette simulation et y revenir plus tard à partir de la liste des simulations.",
      "PROCESSING_FAILED_TITLE": "Le traitement a échoué",
      "PROCESSING_FAILED_BODY": "Une erreur s’est produite lors du traitement de vos documents — veuillez réessayer. Communiquez avec ",
      "TEST_SIMULATION_BUTTON": "Faire l’essai de la simulation",
      "SIMULATION_PROCESSED_TITLE": "Documents traités",
      "SIMULATION_PROCESSED_BODY": "Les documents de votre simulation ont été traités.",
      "SIMULATION_DOCUMENTS_PROCESSED_TITLE": "Documents de simulation traités.",
      "SIMULATION_DOCUMENTS_PROCESSED_BODY": "Les documents que vous avez téléversés pour la simulation {{ name }} ont été traités.",
      "SIMULATION_DOCUMENTS_FAILED_TITLE": "Échec du traitement des documents de simulation.",
      "SIMULATION_DOCUMENTS_FAILED_BODY": "Les documents que vous avez téléversés pour la simulation {{ name }} n’ont pas pu être traités.",
      "DISMISS": "Rejeter",
      "VIEW_SIMULATION": "Voir la simulation",
      "FACT_MESSAGE_LABEL": "Message",
      "FACT_MESSAGE_DESCRIPTION": "Les messages doivent contenir une seule information, formulée sous forme de phrase complète. Veillez à ce qu’ils soient précis, simples et de portée limitée — évitez les messages qui pourraient être partiellement formulés.",
      "FACT_INCORRECT_ANSWER_LABEL": "Texte de réponse incorrect",
      "FACT_INCORRECT_ANSWER_DESCRIPTION": "Texte affiché à l’apprenant s’il répond incorrectement à cet énoncé de fait",
      "SHOW_INCORRECT_ANSWER_TEXT": "Afficher un texte alternatif pour les réponses incorrectes",
      "ADD_NEW_FACT": "Ajouter un nouveau fait",
      "FACT_SINGULAR": "fait",
      "FACT_PLURAL": "faits",
      "FACT_EXTRACTED_SINGULAR": "{{ count }} fait extrait",
      "FACT_EXTRACTED_PLURAL": "{{ count }} faits extraits",
      "REVIEW_REQUIRED_LABEL": "Révision suggérée",
      "MESSAGING_TITLE": "Messagerie",
      "MESSAGING_SUBTITLE": "Évaluer si les faits clés sont communiqués",
      "COMPONENT_WAVE_2_MESSAGE": "Amélioration du contenu de votre simulation...",
      "COMPONENT_WAVE_3_MESSAGE": "Finalisation du contenu de votre simulation...",
      "MESSAGE_ADHERENCE_MESSAGE": "Suggestion de critères d’évaluation du message…",
      "ASSEMBLING_MESSAGE": "Assemblage de votre simulation...",
      "PROCESSING_FAILED_SUFFIX": " si le problème persiste.",
      "BUTTON_RETRY": "Réessayer",
      "TOKEN_LIMIT_EXCEEDED_BODY_PREFIX": "Limite de contenu dépassée. Retirez un ou plusieurs documents et réessayez, ou communiquez avec ",
      "TOKEN_LIMIT_EXCEEDED_BODY_SUFFIX": " si le problème persiste.",
      "AVATAR_LOOK_LABEL": "Apparence",
      "AVATAR_SELECT_PLACEHOLDER": "Sélectionner un avatar",
      "AVATAR_VOICE_LABEL": "Voix",
      "AVATAR_ALT": "Avatar",
      "PLAY_VOICE_PREVIEW_BUTTON": "Écouter l’aperçu vocal",
      "VOICE_OPTION_1": "Voix 1",
      "VOICE_OPTION_2": "Voix 2",
      "BACK_TO_SIMULATION_DETAILS_BUTTON": "Créez les détails de la simulation",
      "AVATAR_SELECTION_TITLE": "Sélection de l’avatar",
      "VIEW_DOCUMENTS": "Afficher les documents",
      "SELECT_AVATAR_BUTTON": "Sélectionner un avatar",
      "REQUEST_CHANGES_PLACEHOLDER": "Demander des modifications aux renseignements ci-dessus",
      "CALL_DETAILS_LOAD_ERROR": "Nous n'avons pas pu charger les détails de votre appel. Veuillez réessayer.",
      "FACTS_CANNOT_BE_EMPTY": "Les faits ne peuvent pas être vides. Ajoutez un message à chaque fait avant de le tester ou de le publier.",
      "FINISHING_SIMULATION_MESSAGE": "Finalisation de votre simulation...",
      "BLANK_THEME_MESSAGE_TOOLTIP": "Ajoutez du texte au message vide avant d'ajouter un nouveau thème.",
      "BLANK_MESSAGE_TOOLTIP": "Ajoutez du texte à ce message avant d'en ajouter un autre.",
      "ADD_NEW_THEME_BUTTON": "Ajouter un nouveau thème",
      "ADD_THEME_BUTTON": "Ajouter un thème",
      "ADD_MESSAGE_BUTTON": "Ajouter un message",
      "SCORE_LAST_SESSION": "Évaluer ma dernière session",
      "SCORE_LAST_SESSION_MODAL_HEADING": "Évaluer la dernière session",
      "SCORE_LAST_SESSION_MODAL_DESCRIPTION": "Testez d’abord la simulation, puis revenez ici pour l’évaluer selon la grille sélectionnée.",
      "SCORE_LAST_SESSION_MODAL_ERROR_HEADING": "Quelque chose s'est mal passé",
      "SCORE_LAST_SESSION_MODAL_ERROR_DESCRIPTION": "Réessayer.",
      "REFINEMENT_THINKING_MESSAGE": "Réflexion…",
      "REFINEMENT_UPDATED_MESSAGE": "Mise à jour",
      "REFINEMENT_WARNING_PREFIX": "Ces renseignements ont été modifiés manuellement – veuillez communiquer avec",
      "REFINEMENT_WARNING_SUFFIX": "pour toute mise à jour.",
      "REFINEMENT_ERROR_PREFIX": "Malheureusement, je ne peux pas vous aider à ce sujet, mais",
      "REFINEMENT_ERROR_SUFFIX": "pourrait peut-être le faire.",
      "REFINEMENT_APPLIED_TITLE": "Les modifications demandées ont été appliquées.",
      "REFINEMENT_APPLIED_BODY": "Les modifications que vous avez demandées pour la simulation {{ name }} ont été appliquées.",
      "REFINEMENT_FAILED_TITLE": "Échec des modifications demandées.",
      "REFINEMENT_FAILED_BODY": "Nous n’avons pas pu appliquer les modifications que vous avez demandées pour la simulation {{ name }}.",
      "WHAT_USERS_SEE_DESCRIPTION_TITLE": "Description de la simulation",
      "WHAT_USERS_SEE_DESCRIPTION_HELPER": "Les renseignements mis à jour dans l’onglet « Général » s’afficheront ici, à moins que des mises à jour manuelles ne soient effectuées.",
      "WHAT_USERS_SEE_DESCRIPTION_FIELD_LABEL": "Description",
      "WHAT_USERS_SEE_DETAILS_TITLE": "Détails de la simulation",
      "WHAT_USERS_SEE_DETAILS_HELPER": "Il s’agit du contenu qui sera présenté à l’utilisateur avant qu’il ne commence la simulation. Les renseignements mis à jour dans l’onglet « Général » s’afficheront ici, à moins que des mises à jour manuelles ne soient effectuées. Les sections laissées vides ne seront pas affichées à l’apprenant. Toutes les sections prennent en charge le formatage Markdown.",
      "WHAT_USERS_SEE_OVERVIEW_FIELD_LABEL": "Aperçu de la simulation",
      "WHAT_USERS_SEE_PERSONA_FIELD_LABEL": "À propos de la persona",
      "WHAT_USERS_SEE_SCORING_FIELD_LABEL": "Critères de notation",
      "WHAT_USERS_SEE_SCORING_FIELD_HELPER": "Cette section est remplie en fonction des choix effectués dans l’onglet « Notation ». La modification des renseignements ici n’aura aucune incidence sur la façon dont la simulation est notée.",
      "WHAT_USERS_SEE_PREVIEW_DETAILS_CTA": "Aperçu des détails de la simulation",
      "WHAT_USERS_SEE_PREVIEW_CARD_CTA": "Aperçu de la carte de la simulation",
      "TAB_GENERAL": "Général",
      "TAB_CONTENTS": "Table des matières",
      "TAB_KEY_WORDS": "Mots-clés",
      "TAB_SCORING": "Notation",
      "TAB_TESTING": "Essai",
      "TAB_PROMPTS": "Invites",
      "TAB_WHAT_USERS_SEE": "Ce que voient les utilisateurs",
      "ACCURACY_FEEDBACK_TITLE": "Rétroaction sur l’exactitude",
      "ACCURACY_FEEDBACK_DESCRIPTION": "Évaluer l’exactitude de chaque déclaration faite par un représentant par rapport aux documents téléversés",
      "ACCURACY_FEEDBACK_STATUS_ON": "Activé",
      "ACCURACY_FEEDBACK_STATUS_OFF": "Désactivé",
      "ACCURACY_FEEDBACK_STATUS_DISABLED": "Désactivé",
      "ACCURACY_FEEDBACK_NO_DOCUMENTS": "La notation de l’exactitude n’est pas disponible, car aucun document connexe n’a été ajouté.",
      "SCORING_AI_REVIEW_NOTICE": "Une partie du contenu de cet onglet a été générée à partir des documents que vous avez fournis. Vérifiez l’exactitude de tout le contenu avant de publier cet appel.",
      "EXPORT_SIMULATION_SUMMARY_BUTTON": "Exporter le résumé de la simulation",
      "CALL": "Appeler",
      "REFINEMENT_OVERRIDDEN_PREFIX": "Ces renseignements ont été modifiés manuellement – veuillez communiquer avec",
      "REFINEMENT_OVERRIDDEN_SUFFIX": "pour toute mise à jour.",
      "SUPPORT_EMAIL": "help@quantified.ai",
      "WHAT_USERS_SEE_OVERRIDE_WARNING_TITLE": "La modification de ces champs bloquera les mises à jour futures",
      "WHAT_USERS_SEE_OVERRIDE_WARNING_BODY": "La mise à jour manuelle de ces sections les empêchera de recevoir toute mise à jour supplémentaire issue du processus de raffinement de l’onglet « Général ».",
      "WHAT_USERS_SEE_DETAILS_OVERRIDE_EDITED_TITLE": "Ces champs ont été modifiés",
      "WHAT_USERS_SEE_DETAILS_OVERRIDE_EDITED_BODY": "Ils ne recevront plus les mises à jour de raffinement effectuées sous l’onglet « Général »",
      "SIMULATION_BUILDER_HEADING": "Concepteur de simulation",
      "ASSIGNMENTS_TAB_LABEL": "Affectations",
      "SIMULATIONS_TAB_LABEL": "Simulations",
      "CREATE_NEW_ASSIGNMENT_BUTTON": "Créer une nouvelle affectation",
      "CREATE_NEW_SIMULATION_BUTTON": "Créer une nouvelle simulation",
      "NO_ASSIGNMENTS_FOUND": "Aucune affectation trouvée",
      "ASSIGNMENT_STATUS_PLACEHOLDER": "État de l’affectation",
      "ASSIGNMENT_STATUS_PREFIX": "État de l’affectation :",
      "ASSIGNMENT_TYPE_LABEL": "Type d'affectation",
      "SELECT_ASSIGNMENT_TYPE_PLACEHOLDER": "Sélectionner le type d'affectation",
      "NAME_LABEL": "Nom",
      "ASSIGNMENT_NAME_PLACEHOLDER": "Nom de l'affectation",
      "PASSING_SCORE_LABEL": "Note de passage",
      "PASSING_SCORE_OPTIONAL_LABEL": "Note de passage (facultatif)",
      "SCORE_MAX_EXCEEDED_ERROR": "La note ne doit pas dépasser 5",
      "GET_HELP_BUTTON": "Aide",
      "PASSING_SCORE_TOOLTIP": "Ce paramètre définit la note globale qu’un apprenant doit obtenir pour réussir la simulation.",
      "DESCRIPTION_LABEL": "Description",
      "ASSIGNMENT_DESCRIPTION_PLACEHOLDER": "Description de l’affectation",
      "MESSAGING_FEEDBACK_LABEL": "Rétroaction sur la messagerie",
      "MESSAGING_FEEDBACK_TOOLTIP_HEADING": "Rétroaction sur la messagerie",
      "MESSAGING_FEEDBACK_TOOLTIP_BODY": "Lorsqu’un apprenant formule incorrectement un message, on lui présente des renseignements sur la façon de mieux l’exprimer la prochaine fois. Ce paramètre permet d’activer ou de désactiver l’affichage de ces renseignements.",
      "ENABLED_TEXT": "Activé",
      "DISABLED_TEXT": "Désactivé",
      "PAUSE_BUTTON_LABEL": "Bouton de pause",
      "ASSIGNMENT_START_DATE_LABEL": "Date de début de l'affectation",
      "SELECT_DATE_PLACEHOLDER": "Sélectionner une date",
      "ASSIGNMENT_END_DATE_LABEL": "Date de fin de l’affectation",
      "ASSIGNMENT_END_DATE_OPTIONAL_LABEL": "Date de fin de l’affectation (facultatif)",
      "END_DATE_RANGE_ERROR": "La date de début et la date de fin ne peuvent pas être identiques",
      "ASSIGNMENT_INFORMATION_TITLE": "Renseignements sur l’affectation",
      "ASSIGNMENT_TYPE_CERTIFICATION": "Certification",
      "ASSIGNMENT_TYPE_PRACTICE": "Pratique",
      "ASSIGNMENT_TYPE_PERSONALIZED_PRACTICE": "Pratique personnalisée",
      "BUTTON_SAVE_AND_CLOSE": "Enregistrer et fermer",
      "BUTTON_ADD_SIMULATIONS": "Ajouter des simulations",
      "ATTEMPTS_UNLIMITED": "Illimité",
      "SEARCH_FOR_SIMULATION_LABEL": "Rechercher une simulation",
      "SIMULATION_NAME_PLACEHOLDER": "Nom de la simulation",
      "BUTTON_REMOVE_ALL": "Tout supprimer",
      "SIMULATIONS_IN_ASSIGNMENT_LABEL": "Simulations dans l'affectation",
      "BUTTON_ASSIGN_LEARNERS": "Affecter des apprenants",
      "CALL_TYPE_UNKNOWN": "Inconnu",
      "ASSIGNMENT_COUNT_NONE": "Aucun",
      "ASSIGNMENT_COUNT_SINGULAR": "{{ count }} affectation",
      "ASSIGNMENT_COUNT_PLURAL": "{{ count }} affectations",
      "ERROR_LOADING_ASSIGNMENTS": "Erreur lors du chargement des affectations",
      "SEARCH_ASSIGNEES_TITLE": "Rechercher des destinataires",
      "DIALOG_DESCRIPTION_ADD_USERS": "Sélectionner les utilisateurs qui participeront à l’affectation. La recherche d’une équipe vous permettra d’affecter ou de retirer des utilisateurs spécifiques à cette équipe. Lorsque vous sélectionnez un utilisateur en particulier, assurez-vous qu’il est associé à la bonne équipe aux fins de production de rapports.",
      "ADD_USERS_TO_ASSIGNMENT_HEADING": "Ajouter des utilisateurs à l'affectation",
      "BUTTON_REVIEW_SELECTED_USERS": "Vérifier les utilisateurs sélectionnés",
      "FIND_USERS_LABEL": "Trouver des utilisateurs",
      "BUTTON_CLEAR": "Supprimer",
      "LEARNER_COUNT_NONE": "Aucun",
      "LEARNER_COUNT_SINGULAR": "{{ count }} apprenant",
      "LEARNER_COUNT_PLURAL": "{{ count }} apprenants",
      "ASSIGNMENT_TAB_DETAILS": "Détails",
      "ASSIGNMENT_TAB_SIMULATIONS": "Simulations",
      "ASSIGNMENT_TAB_ASSIGNEES": "Destinataires",
      "LOADING_ASSIGNMENT_DETAILS": "Chargement des détails de l'affectation…",
      "BREADCRUMB_ASSIGNMENTS": "Affectations",
      "ASSIGNMENTS_COL_NAME": "Nom",
      "ASSIGNMENTS_COL_START_DATE": "Date de début de l'affectation",
      "ASSIGNMENTS_COL_END_DATE": "Date de fin de l’affectation",
      "ASSIGNMENTS_COL_LEARNERS": "Apprenant affecté",
      "ASSIGNMENTS_COL_TYPE": "Type d'affectation",
      "ASSIGNMENTS_COL_STATUS": "État de l’affectation",
      "SIMULATIONS_COL_NAME": "Nom",
      "SIMULATIONS_COL_PRODUCT": "Produit",
      "SIMULATIONS_COL_DATE_MODIFIED": "Date de la dernière modification",
      "SIMULATIONS_COL_STATUS": "État",
      "SIMULATIONS_COL_USED_IN": "Utilisé dans",
      "SIMULATIONS_COL_TYPE": "Type de simulation",
      "SIMULATIONS_COL_DATE_PUBLISHED": "Date de publication",
      "CONVERSE_PROMPT_LABEL": "Invite de conversation",
      "CONVERSE_PROMPT_EXPAND_TO_EDIT": "Développer pour modifier",
      "CONVERSE_PROMPT_ENTER_LABEL": "Saisir l'invite de conversation ici *",
      "CONVERSE_PROMPT_EDITING_HEADING": "Modification de l’invite de conversation",
      "CONVERSE_PROMPT_OVERRIDE_CONFIRMATION_HEADING": "Confirmation du remplacement de l’invite",
      "CONVERSE_PROMPT_OVERRIDE_DESCRIPTION": "Êtes-vous certain de vouloir remplacer l’invite de conversation? Les auteurs perdront l’accès au raffinement en libre-service si l’invite est remplacée.",
      "CONVERSE_PROMPT_FIELD_LABEL": "Invite de conversation",
      "CONVERSE_PROMPT_SAVE_BUTTON": "Enregistrer l’invite",
      "BUTTON_CONFIRM": "Confirmer",
      "DELETE_SIM_HEADING": "Supprimer la simulation",
      "DELETE_SIM_CONTENT": "Cette simulation sera supprimée. Toutes les affectations de test associés à la simulation seront également supprimées.",
      "DELETE_SIM_LABEL": "Supprimer la simulation",
      "DELETE_ASSIGNMENT_HEADING": "Supprimer l’affectation",
      "DELETE_ASSIGNMENT_CONTENT": "Cette affectation sera supprimée de façon permanente.",
      "DELETE_ASSIGNMENT_LABEL": "Supprimer l’affectation",
      "DELETE_ASSIGNMENT_NON_STAGED_CONTENT": "Pour supprimer une affectation dont l’état est « Actif » ou « Terminé », veuillez communiquer avec l’équipe de l’expérience client (CX). Merci.",
      "REMOVE_FROM_ASSIGNMENT_HEADING": "Retirer de l'affectation",
      "REMOVE_FROM_ASSIGNMENT_CONTENT": "Cela retirera l’utilisateur de l’affectation et de tous les liens d’équipe associés.",
      "REMOVE_FROM_ASSIGNMENT_LABEL": "Retirer de l'affectation",
      "PUBLISH_SIMULATION_HEADING": "Publier la simulation",
      "PUBLISH_CONTINUE_EDITING": "Continuer la modification",
      "PUBLISH_BUTTON": "Publier",
      "PUBLISH_SIMULATION_DESCRIPTION": "Le jeu de rôle pourra être ajouté aux affectations et les renseignements relatifs au personnage, à la notation et aux invites ne pourront plus être modifiés.",
      "CONFIRMATION_SELECTED_USERS_HEADING": "Utilisateurs sélectionnés",
      "CONFIRMATION_TOTAL_COUNT": "{{ count }} Total",
      "CONFIRMATION_CREATE_HEADING": "Créer une nouvelle affectation",
      "CONFIRMATION_ADD_USERS_HEADING": "Ajouter des utilisateurs à l'affectation",
      "CONFIRMATION_SAVE_ASSIGNMENT_BTN": "Enregistrer l’affectation",
      "CONFIRMATION_REMOVE_USER": "Supprimer",
      "EDIT_WEIGHTING_HEADING": "Modifier la notation",
      "EDIT_WEIGHTING_DESCRIPTION": "La note globale sera calculée à partir de la moyenne pondérée des sections suivantes. La somme des pondérations de toutes les sections activées doit être égale à 100 %. La section « Compétences » ne peut pas avoir une pondération supérieure à 20 %.",
      "EDIT_WEIGHTING_ERROR_ALL_DISABLED": "Au moins une action de notation doit être activée",
      "EDIT_WEIGHTING_ERROR_WEIGHT_RANGE": "La pondération de la section doit être comprise entre 0 et 100",
      "EDIT_WEIGHTING_ERROR_SKILLS_MAX": "La section « Compétences » ne peut pas avoir une pondération supérieure à 20 %.",
      "EDIT_WEIGHTING_ERROR_TOTAL": "La pondération totale des sections doit être de 100 %",
      "PERSONA_INFORMATION_TITLE": "Renseignements sur le personnage",
      "PERSONA_AVATAR_LABEL": "Avatar *",
      "PERSONA_NAME_LABEL": "Nom *",
      "PERSONA_INITIAL_GREETINGS_LABEL": "Salutations initiales *",
      "PERSONA_INITIAL_GREETINGS_DESCRIPTION": "Le personnage commencera la simulation par l’une de ces salutations. Vous pouvez choisir jusqu’à 5 options.",
      "PERSONA_ADD_GREETING_OPTION": "Ajouter une option de formule d’accueil",
      "PERSONA_RESUME_MESSAGE_LABEL": "Reprendre le message",
      "PERSONA_RESUME_MESSAGE_DESCRIPTION": "Lorsqu’un apprenant reprend une simulation après une pause, le personnage commencera par l’une de ces formules d’accueil. Vous pouvez choisir jusqu’à 5 options.",
      "PERSONA_ADD_MESSAGE_OPTION": "Ajouter une option de message",
      "PERSONA_UPLOADING": "En cours de téléversement...",
      "PERSONA_DELETING": "Suppression...",
      "PERSONA_CUSTOM_BG_PREVIEW_ALT": "Aperçu de l’arrière-plan personnalisé",
      "PERSONA_AVATAR_THUMBNAIL_ALT": "Vignette de l’avatar",
      "PERSONA_AVATAR_WITH_BG_ALT": "Avatar avec arrière-plan personnalisé",
      "PERSONA_PROCESSING_IMAGE": "Traitement de l’image...",
      "PERSONA_CUSTOM_BACKGROUND_LABEL": "Arrière-plan personnalisé",
      "PERSONA_REMOVE_BACKGROUND": "Supprimer l’arrière-plan",
      "PERSONA_CLICK_TO_REPLACE": "Cliquer pour remplacer",
      "PERSONA_UPLOAD_DESCRIPTION": "Fichier PNG ou JPG, format 16:9 de préférence, taille maximale de 2 Mo",
      "SIM_INFORMATION_TITLE": "Renseignements sur la simulation",
      "SIM_NAME_FIELD_LABEL": "Nom *",
      "SIM_LANGUAGE_FIELD_LABEL": "Langue",
      "SIM_DETAILS_SECTION_TITLE": "Détails de la simulation",
      "SIM_ADDITIONAL_SECTION_TITLE_LABEL": "Titre supplémentaire pour la section",
      "SIM_ADDITIONAL_SECTION_INFO_LABEL": "Renseignements supplémentaires sur la section",
      "TESTING_SECTION_TITLE": "Testeurs",
      "TESTING_SEND_ASSIGNMENTS_BTN": "Envoyer les affectations de test",
      "TESTING_MESSAGING_TOOLTIP": "Ajouter au moins un fait à la section « Respect du message » avant de procéder aux tests ou à la publication.",
      "TESTING_DESCRIPTION": "Rechercher les utilisateurs qui testeront la simulation, puis envoyez-leur l’affectation de test.",
      "TESTING_COL_NUMBER_OF_ATTEMPTS": "Nombre de tentatives",
      "TESTING_COL_DATE_OF_LAST_ATTEMPT": "Date de la dernière tentative",
      "TESTING_CLEAR_USERS": "Supprimer les utilisateurs",
      "TESTING_REMOVE_ASSIGNEE": "Retirer le destinataire",
      "OVERALL_SECTION_TITLE": "Sections, pondérations et invites",
      "OVERALL_HEADING": "Dans l’ensemble",
      "TRANSCRIPT_PROMPT_TITLE": "Invite de transcription",
      "TRANSCRIPT_PROMPT_FIELD_LABEL": "Saisir l’invite de transcription épurée ici",
      "SIMULATION_PROMPTS_TITLE": "Invites de la simulation",
      "TAGS_LABEL": "Étiquettes",
      "CREATE_TAG_OPTION": "Créer {{term}}",
      "TAG_CREATE_ERROR": "Impossible de créer l’étiquette, veuillez réessayer",
      "EDIT_SIMULATION_TAGS_TITLE": "Modifier les étiquettes de simulation",
      "SAVE_TAGS_BUTTON": "Enregistrer les étiquettes",
      "CLOSE_BUTTON": "Fermer",
      "TAG_UPDATE_ERROR": "Impossible de mettre l’étiquette à jour, veuillez réessayer",
      "SCREEN_SHARE_TITLE": "Partage d'écran",
      "SCREEN_SHARE_DESCRIPTION": "Permet à l’utilisateur de partager son écran avec l’avatar pendant l’appel, afin que celui-ci puisse voir ce qui s’affiche et y réagir",
      "SCREEN_SHARE_STATUS_ON": "Activé",
      "SCREEN_SHARE_STATUS_OFF": "Désactivé",
      "SCREEN_SHARE_NO_PERSONA": "Vous devez d’abord ajouter un personnage pour activer le partage d’écran.",
      "HIDE_RESULTS_LABEL": "Masquer les résultats",
      "SEARCH_FIELD_HINT": "Tapez au moins trois caractères pour lancer la recherche",
      "OTHERS_SINGULAR": "et 1 autre",
      "OTHERS_PLURAL": "et {{ count }} autres",
      "PAGINATION_PREVIOUS": "Précédent",
      "PAGINATION_NEXT": "Suivant",
      "SKILLS_RUBRIC_REQUIRED_TOOLTIP": "Joignez une grille des compétences. La compétence est activée si sa pondération est supérieure à 0 %.",
      "ENTITY_TYPE_KNOWLEDGE_CHECK_DISPLAY": "contrôle des connaissances",
      "NAME_MAX_LENGTH_ERROR": "Le nom doit comporter au plus 255 caractères.",
      "UUID_COPIED_TOAST": "UUID de l’appel copié dans le presse-papiers",
      "MENU_ARCHIVE": "Archive",
      "MENU_EDIT_SIMULATION_TAGS": "Modifier les étiquettes de simulation",
      "MENU_COPY_UUID": "Copier l’UUID",
      "REFINEMENT_IN_PROGRESS_TOOLTIP": "Raffinement en cours. Vous pouvez continuer une fois l’opération terminée.",
      "SIMULATION_DOCUMENTS_PARSE_FAILED_BODY": "L’un de vos documents pour {{ name }} n’a pas pu être lu — vérifiez-le ou remplacez-le, puis réessayez.",
      "REFINEMENT_ERROR_MESSAGE": "Désolé, cette demande n’a pas pu être traitée. Veuillez réessayer",
      "REFINEMENT_OUT_OF_SCOPE_TITLE": "Demande hors de la portée de la fonction.",
      "REFINEMENT_OUT_OF_SCOPE_BODY": "Votre demande concernant {{ name }} dépasse les capacités de la fonction de raffinement. Contacter le service de soutien.",
      "TAB_QUESTIONS": "Questions",
      "KNOWLEDGE_CHECK_NAME_LABEL": "Nom*",
      "AVATAR_APPEARANCE_LABEL": "Apparence de l’avatar",
      "KNOWLEDGE_CHECK_AVATAR_NAME_LABEL": "Nom de l’avatar",
      "KNOWLEDGE_CHECK_SKILLS_FEEDBACK_TITLE": "Rétroaction sur les compétences",
      "KNOWLEDGE_CHECK_SCORING_DESCRIPTION": "Les simulations du Contrôle des connaissances sont notées en fonction du pourcentage de points de réponse couverts pour chaque question. Sélectionnez une grille des compétences ci-dessous pour recevoir également une rétroaction qualitative.",
      "KNOWLEDGE_CHECK_SCORING_RESCORE_DESCRIPTION": "Après avoir testé la simulation au moins une fois, sélectionnez « Évaluer ma dernière session » pour consulter votre note. Si vous modifiez les points de réponse, vous pouvez réévaluer la même session. Si vous modifiez les questions, vous devrez effectuer une nouvelle session de test avant de procéder à l’évaluation.",
      "KNOWLEDGE_CHECK_SKILLS_RUBRIC_LABEL": "Grille des compétences (facultatif)",
      "SIMULATION_TYPE_MODAL_TITLE": "Créer une nouvelle simulation",
      "SIMULATION_TYPE_MODAL_DESCRIPTION": "Choisissez la façon dont vos apprenants se pratiqueront.",
      "SIMULATION_TYPE_ROLE_PLAY_TITLE": "Jeu de rôle",
      "SIMULATION_TYPE_ROLE_PLAY_DESCRIPTION": "Les apprenants mènent une conversation libre avec un personnage généré par l’IA, qui répond naturellement à tout ce qu’ils disent.",
      "SIMULATION_TYPE_ROLE_PLAY_BEST_FOR": "Idéal pour : se pratiquer à des appels de vente réalistes, comme les présentations commerciales et la gestion des objections.",
      "SIMULATION_TYPE_KNOWLEDGE_CHECK_TITLE": "Contrôle des connaissances",
      "SIMULATION_TYPE_KNOWLEDGE_CHECK_DESCRIPTION": "Un personnage généré par l’IA pose aux apprenants les questions que vous rédigez, dans l’ordre que vous définissez.",
      "SIMULATION_TYPE_KNOWLEDGE_CHECK_BEST_FOR": "Idéal pour : évaluer la connaissance des produits et certifier que les représentants sont prêts.",
      "TAGS_FILTER_LABEL": "Étiquettes",
      "TAGS_FILTER_PLACEHOLDER": "Sélectionner une étiquette",
      "CLEAR_ALL_FILTERS": "Supprimer tous les filtres",
      "LAST_SAVED_LABEL": "Dernière sauvegarde",
      "BUTTON_OK": "OK",
      "KEYWORDS_RESET_TO_PRODUCT_DEFAULT": "Réinitialiser aux paramètres par défaut du produit",
      "KEYWORDS_DETACH_FROM_PRODUCT_DEFAULT": "Détacher des paramètres par défaut du produit",
      "KEYWORDS_SAVE_AS_PRODUCT_DEFAULT": "Enregistrer comme valeur par défaut du produit",
      "KEYWORDS_SAVE_AS_DEFAULT_OVERWRITE": "Cela remplacera le paramètre par défaut {{ keywordTitle }} pour le produit {{ moduleName }}.",
      "KEYWORDS_SAVE_AS_DEFAULT_IMPACT": "Ces mots seront ajoutés aux nouvelles simulations pour {{ moduleName }}. Tous les appels pour le produit {{ moduleName }} seront affectés.",
      "KEYWORDS_ADD_NEW_WORD": "Ajouter un nouveau mot",
      "KEYWORDS_FROM_LABEL": "Mot d’origine",
      "KEYWORDS_TO_LABEL": "Mot de remplacement",
      "KEYWORDS_PRONOUNCE_TITLE": "Prononcer les mots",
      "KEYWORDS_PRONOUNCE_DESCRIPTION": "Fournissez des corrections de prononciation à l’agent IA afin qu’il prononce correctement les noms et les termes. L’agent associe les erreurs de prononciation et les variantes courantes à la nouvelle prononciation.",
      "KEYWORDS_PRONOUNCE_NAME": "prononcer les mots",
      "KEYWORDS_ADD_MISPRONUNCIATION": "Ajouter une prononciation erronée",
      "KEYWORDS_SELECT_PERSONA_NOTICE": "Veuillez sélectionner un personnage pour ajouter des mots à prononcer.",
      "KEYWORDS_REPLACE_TITLE": "Remplacer des mots",
      "KEYWORDS_REPLACE_DESCRIPTION": "Corrections explicites de type « rechercher et remplacer » pour le texte de la transcription de l’utilisateur; remplacements directs de mots qui ont lieu avant la correction phonétique.",
      "KEYWORDS_REPLACE_NAME": "remplacer des mots",
      "KEYWORDS_ADD_REPLACEMENT": "Ajouter un remplacement",
      "KEYWORDS_STT_TITLE": "Mots STT",
      "KEYWORDS_STT_DESCRIPTION": "Liste de mots fournie aux fournisseurs de services de reconnaissance vocale (STT) (p. ex., AssemblyAI, Tavus), spécialement pour la configuration de ces fournisseurs.",
      "KEYWORDS_STT_NAME": "mots STT",
      "KEYWORDS_GENERATING": "Génération en cours...",
      "KEYWORDS_GENERATE_STT_PROMPT": "Générer stt_prompt",
      "KEYWORDS_STT_PROMPT_OUTDATED": "La liste de mots a été mise à jour depuis la génération de cette invite. Régénérer pour refléter les dernières modifications.",
      "KEYWORDS_STT_CANNOT_SAVE_HEADING": "Impossible d’enregistrer au niveau du produit",
      "KEYWORDS_STT_CANNOT_SAVE_BODY": "Les mots STT et l’invite ne peuvent pas être enregistrés au niveau du produit. Vous pouvez modifier manuellement d’autres paramètres de configuration de la simulation STT ou communiquer avec votre administrateur pour obtenir de l’aide.",
      "KEYWORDS_CLEAN_TRANSCRIPT_TITLE": "Mots de la transcription épurés",
      "KEYWORDS_CLEAN_TRANSCRIPT_DESCRIPTION": "Mots injectés dans l’invite CLEAN_TRANSCRIPT_V2.",
      "KEYWORDS_CLEAN_TRANSCRIPT_NAME": "mots de la transcription épurés",
      "KEYWORDS_CALL_TITLE": "Mots de l’appel",
      "KEYWORDS_CALL_DESCRIPTION": "Dictionnaire de mots corrects pour la correction phonétique, utilisé par l’algorithme Double Metaphone pour corriger les fautes d’orthographe phonétiquement similaires. Évitez les termes composés de plusieurs mots, comme « Anti MuSK AB+ », puisque le correcteur de transcription basé sur du code ne fonctionne de façon fiable qu’avec des mots uniques. Évitez également les symboles — p. ex., « lp(a) » — car ils ont tendance à semer la confusion chez le correcteur. La liste doit rester aussi courte et simple que possible, car elle est gérée par un algorithme déterministe, et non par un grand modèle de langage (LLM), et ne dispose pas de compréhension contextuelle",
      "KEYWORDS_CALL_NAME": "mots de l’appel"
    },
    "settings": {
      "DEVICE_SETUP_INTRO": "Assurez-vous que votre appareil est configuré.",
      "MICROPHONE_REQUIRED_NOTICE": "Un microphone en état de marche est nécessaire.",
      "DEVICE_ENABLE_INSTRUCTIONS": "Si vous n’avez pas vu de fenêtre contextuelle vous demandant d’activer vos appareils après avoir actualisé cette page, veuillez accéder aux paramètres de votre système ou de votre navigateur et activer vos appareils à partir de là. Vous trouverez ci-dessous des pages d'aide contenant des instructions supplémentaires.",
      "ENABLE_CAMERA": "Comment activer votre appareil photo :",
      "WINDOWS_USERS": "Utilisateurs de Windows",
      "MAC_USERS": "Utilisateurs de Mac",
      "IPAD_USERS": "Utilisateurs d’iPad",
      "ENABLE_MICROPHONE": "Comment activer votre microphone :",
      "ENABLE_DEVICES_BY_BROWSER": "Comment activer vos appareils par navigateur :",
      "CHROME_USERS": "Utilisateurs de Chrome",
      "SAFARI_USERS": "Utilisateurs de Safari",
      "FIREFOX_USERS": "Firefox",
      "EDGE_USERS": "Edge",
      "START_WITHOUT_CAMERA_BUTTON": "Démarrage sans caméra",
      "START_CALL_BUTTON": "Début de l’appel",
      "MICROPHONE_REQUIRED_WARNING": "Un microphone en état de marche est nécessaire.",
      "MICROPHONE_ALT": "microphone",
      "MICROPHONE": "Microphone",
      "SELECT_MICROPHONE": "Sélectionnez votre microphone",
      "ALERT": "alerte",
      "GIVE_PERMISSION": "Donner l’autorisation",
      "SELECT_VIDEO_DEVICE": "Sélectionnez votre appareil vidéo",
      "VIDEO": "vidéo",
      "DEVICE_BLOCKED_ERROR": "Il semble que vous ayez refusé à ce navigateur l’accès à un ou plusieurs de vos appareils. Pour activer les appareils, veuillez accéder aux paramètres de votre système ou de votre navigateur et activer l’accès.",
      "DEVICE_SETTINGS": "Paramètres de l’appareil",
      "CONFIRM_SETTINGS": "Confirmer les paramètres",
      "LAPTOP": "Ordinateur portable",
      "SAD_EMOTE_FACE": "Émoji visage triste",
      "GRANT_BROWSER_ACCESS": "Pour effectuer cette simulation, veuillez autoriser l’accès du navigateur à la reconnaissance vocale.",
      "USING_IPAD": "Si vous utilisez un iPad, accédez à",
      "SETTINGS": "Paramètres",
      "PRIVACY_AND_SECURITY": "Vie privée et sécurité",
      "SPEECH_RECOGNITION": "Reconnaissance de la parole",
      "GRANT_ACCESS_REFRESH": "Accorder l’accès au navigateur et actualiser la page",
      "REFRESH_PAGE": "ACTUALISER LA PAGE",
      "BROWSER_UNABLE_TO_ACCESS": "Le navigateur ne peut pas accéder à cet appareil",
      "ACCESS_DENIED": "accès refusé",
      "CAMERA": "Appareil photo",
      "DIAGNOSTIC_PASSED": "Tous les tests de diagnostic ont réussi avec succès.",
      "DIAGNOSTIC_FAILED_MESSAGE": "Certains tests de diagnostic ont échoué. Veuillez cliquer sur le bouton « Copier les résultats du diagnostic » ci-dessus et envoyer les résultats à l'équipe de soutien pour plus d’assistance.",
      "DIAGNOSTIC_PARTIAL": "La plupart des tests de diagnostic ont réussi avec succès. Votre connexion semble bonne.",
      "DIAGNOSTIC_RUNNING_MESSAGE": "Veuillez patienter pendant que les tests de diagnostic sont en cours d'exécution...",
      "DIAGNOSTIC_RUNNING": "Diagnostic en cours",
      "COPY_DIAGNOSTIC_RESULTS": "Copier les résultats du diagnostic",
      "RUN_DIAGNOSTIC": "Exécuter le diagnostic",
      "RERUN_DIAGNOSTIC": "Relancer le diagnostic",
      "DIAGNOSTIC_RESULTS_COPIED": "Résultats du diagnostic copiés dans le presse-papiers",
      "DIAGNOSTIC_FAILED": "Le diagnostic a échoué",
      "DIAGNOSTIC_WEBSOCKET_NOT_TESTED": "Websocket: not tested",
      "DIAGNOSTIC_TURN_NOT_TESTED": "TURN : not tested",
      "DIAGNOSTIC_QUALITY_NOT_TESTED": "Quality: not tested",
      "DIAGNOSTIC_QUANTIFIED_DIAGNOSTICS": "Diagnostics quantifiés",
      "DIAGNOSTIC_TIME": "Temps",
      "DIAGNOSTIC_SUMMARY": "Résumé",
      "DIAGNOSTIC_CLIENT_INFO": "Renseignements sur le client",
      "DIAGNOSTIC_PLATFORM": "Plateforme",
      "DIAGNOSTIC_RTT_AVG_MAX": "RTT avg/max",
      "DIAGNOSTIC_PACKET_LOSS_SEND": "Perte de paquets (envoi)",
      "DIAGNOSTIC_AVG_SEND_BITRATE": "Débit binaire d'envoi moyen",
      "DIAGNOSTIC_NA": "S. O.",
      "DIAGNOSTIC_PROBLEMS_CONNECTING_PREFIX": "Des problèmes de connexion?",
      "DIAGNOSTIC_CLICK_HERE": "Cliquez ici",
      "DIAGNOSTIC_TO_RUN_SUFFIX": "pour exécuter un diagnostic."
    },
    "results": {
      "RETURN_HOME": "RETOUR À L’ACCUEIL",
      "CLOSE_BUTTON": "Bouton de fermeture",
      "CONVERSATIONAL_CALL": "APPELS CONVERSATIONNELS",
      "INFORMATION_ICON": "Icône d’information",
      "TOOLTIP_ARROW": "Flèche d’info-bulle",
      "INFORMATION_TOOLTIP_CONTENT": "Vous contrôlez le flux de la simulation, en orientant la conversation vers un ensemble d’objectifs. Les appels conversationnels sont parfaits pour tester des capacités telles que l’approfondissement et la pose de questions de second niveau, la découverte de points douloureux et l’établissement d’une relation.",
      "CLOCK_ICON": "Icône d’horloge",
      "CALL_RESULTS": "Résultats",
      "SKILLS": "Compétences",
      "MESSAGE_ADHERENCE": "Adhésion au message",
      "TRY_AGAIN_MESSAGE": "Réessayez et améliorez votre note.",
      "PRACTICE_BENEFITS": "La pratique hebdomadaire renforce la confiance en soi et améliore les résultats dans le monde réel.",
      "CALL_SUCCESS": "Excellent travail! Vous avez terminé cette simulation avec succès.",
      "MAX_ATTEMPTS_REACHED": "Vous avez atteint le nombre maximum de tentatives",
      "TRY_AGAIN": "Réessayer",
      "GREAT_JOB_YOU_SUCCESSFULLY": "Excellent travail! Vous avez terminé",
      "COMPLETED_THIS_CALL": "cette simulation avec succès.",
      "ACHIEVED_SCORE": "Vous devez obtenir une note de",
      "ACHIEVE_SCORE": "Obtenir une note de",
      "OR_HIGHER": "ou plus",
      "OBJECTIVES_NOT_MET": "Vous n’avez pas atteint tous les objectifs requis.",
      "TRY_AGAIN_TARGET_SCORE": "Essayez à nouveau d’obtenir une note de",
      "YOUR_SCORE": "Votre note",
      "OUT_OF_5": "SUR 5",
      "CALL_FEEDBACK": "RÉSUMÉ DU RETOUR D'INFORMATION",
      "STRENGTH_ICON_ALT": "Icône de force",
      "OPPORTUNITIES_ICON_ALT": "Icône des possibilités",
      "OBJECTIVES_FEEDBACK": "RETOUR D'INFORMATION SUR LA MÉTHODOLOGIE",
      "SESSION_ID": "ID de la session :",
      "SESSION_ID_COPIED": "L’identifiant de la session a été copié!",
      "OBJECTIVE": "MÉTHODOLOGIE :",
      "HOW_YOU_DID": "Vos résultats :",
      "LIGHTBULB_ICON_ALT": "Icône d’ampoule",
      "WHAT_WE_SUGGEST": "Ce que nous suggérons :",
      "NO_SPECIFIC_RECOMMENDATION": "Notre système n’a pas pu trouver une recommandation pour vous.",
      "WHY": "Pourquoi?",
      "NO_INSIGHTS_AVAILABLE": "Notre système n’a pas été en mesure de fournir des informations sur cette suggestion.",
      "CONFETTI_ICON_ALT": "Icône de confettis",
      "OBJECTIVE_SUCCESS_MESSAGE": "Vous avez bien travaillé sur cette méthodologie, ne lâchez pas!",
      "PROCESSING_CALL": "Nous préparons votre note et votre retour d'information.",
      "HANG_TIGHT": "Patientez ou revenez plus tard pour",
      "VIEW_YOUR_RESULTS": "consulter vos résultats.",
      "NEED_MORE_TIME": "Nous avons besoin de plus de temps pour calculer les résultats.",
      "REFRESH_INSTRUCTION": "Veuillez revenir plus tard ou actualiser l’affectation",
      "RESULTS_IN_FEW_MINUTES": "des résultats en quelques minutes.",
      "SCORE_CALCULATION_QUESTION": "Méthode de calcul",
      "SINGLE_SCORE_EXPLANATION": "Cette simulation comporte un seul élément de notation, donc la note affichée correspond à la fois à la note de la section et à votre note globale.",
      "OVERALL_SCORE_PERCENT": "de la note globale",
      "SECTION_SCORE": "Note de la section",
      "ELEVATE_MESSAGE_ADHERENCE_TITLE": "Améliorez l’adhésion à votre message de conversation",
      "MESSAGE_ADHERENCE_NOTE": "Le respect du message est essentiel pour mener des conversations fructueuses, mais n’affecte pas votre note globale.",
      "NO_CREDIT": "Aucun crédit",
      "PARTIAL_CREDIT": "Crédit partiel",
      "FULL_CREDIT": "Crédit complet",
      "WHAT_YOU_DID_WELL": "Ce que vous avez fait de bien",
      "MISSED_ALL_KEY_POINTS": "Vous avez omis tous les points clés. Renvoyez-les puis essayez à nouveau.",
      "WHAT_TO_IMPROVE": "Ce que vous pouvez améliorer",
      "PERFECT_SCORE_MESSAGE": "Félicitations! Vous avez obtenu une note parfaite, en abordant correctement tous les points clés.",
      "POINTS_LABEL": "Points",
      "POINT_LABEL": "Point",
      "TALKING_POINTS_COVERED": "Points de discussion abordés",
      "CHECKMARK_ICON_ALT": "coche",
      "TALKING_POINTS_MISSED": "Points de discussion manqués",
      "X_ICON_ALT": "x",
      "PRACTICE_AGAIN": "Pratiquer à nouveau",
      "OUT_OF": "sur",
      "OBJECTIVES": "Méthodologie",
      "ELEVATE_OBJECTIVES_TITLE": "Améliorez votre méthodologie en matière de conversation",
      "OBJECTIVES_NOTE": "La méthodologie est essentielle pour mener des conversations fructueuses, mais n’affecte pas votre note globale.",
      "UNTIL": "jusqu’à",
      "TO_IMPROVE_SCORE": "pour améliorer votre note.",
      "YOU_HAVE": "Vous avez",
      "MORE_ATTEMPTS": "plus de tentatives d’obtenir une note de",
      "OR_HIGHER_BEFORE": "ou plus avant le",
      "AND_TRY_AGAIN": "et réessayer.",
      "UNEXPECTED_STATE": "Un état inattendu s’est produit.",
      "REVIEW_APP_LOGIC": "Veuillez revoir la logique de l’application.",
      "ASSIGNMENTS": "Affectations",
      "VIEW_CALL_DETAILS": "Voir les détails de l’appel",
      "PRACTICE_SESSION": "Séance de pratique",
      "OVERALL_SCORE": "Note globale",
      "OVERALL_SCORE_EXPLANATION": "La note globale est calculée en faisant la moyenne pondérée des notes de chaque section. Le poids de chaque section est affiché sous forme de pourcentage à côté de la note.",
      "SCORE_CONFIG_NOTE": "Les pourcentages de pondération ainsi que l’inclusion et l’exclusion de sections sont fixés par votre entreprise. Toutes les notes sont arrondies au dixième de point le plus proche.",
      "STRENGTHS": "Points forts",
      "OPPORTUNITIES": "Possibilités",
      "YOUR_RESPONSE": "Votre réponse",
      "MINUS": "moins",
      "PLUS": "plus",
      "RECOMMENDED_RESPONSE": "Réponse recommandée",
      "REVIEW_MISSED_TITLE": "Passez en revue ce que vous avez manqué.",
      "NO_TALKING_POINTS_COVERED": "Vous n’avez abordé aucun des points de discussion requis pour ce sujet.",
      "LEARN_WHAT_YOU_MISSED": "Apprenez ce que vous avez manqué",
      "NICE_JOB": "Beau travail!",
      "ALL_POINTS_COVERED": "Vous avez réussi à couvrir tous les points de discussion nécessaires pour ce sujet.",
      "COVER_ALL_MESSAGES": "Couvrir tous les messages clés.",
      "HIGHLIGHT_KEY_POINTS_NOTE": "Le fait de souligner les points clés tout au long de l’appel permet de maintenir le cap de la conversation.",
      "MESSAGES_LABEL": "Messages",
      "NO_FACTS_COVERED": "Oups! Il semble que vous n’ayez couvert aucun des faits de ce message.",
      "NO_SPECIFICS_AVAILABLE": "Oups! Il semble que nous n’ayons pas pu fournir de précisions sur ce qui a été omis.",
      "ALL_KEY_POINTS_COVERED": "Excellent travail! Vous avez couvert tous les points essentiels.",
      "PROCESSING_SKILLS_FEEDBACK": "Nous sommes en train de traiter votre retour d’information sur les compétences.",
      "SKILLS_SCORING_NOT_ENABLED": "Nous sommes désolés, mais nous n’avons pas pu analyser votre appel récent, car l’évaluation des compétences n’était pas activée au moment de la soumission. Pour obtenir un retour d’information, il vous suffit de soumettre à nouveau votre pratique d’appel comme vous l’avez fait précédemment. Si vous avez besoin d’aide, n’hésitez pas à contacter notre équipe de soutien. Merci de votre compréhension et de votre volonté d’amélioration!",
      "ELEVATE_CONVERSATION_SKILLS": "Améliorez vos compétences en matière de conversation",
      "SKILLS_NOTE": "Ces compétences sont essentielles pour mener des conversations fructueuses, mais elles n’ont pas d’incidence sur votre note globale.",
      "SKILLS_SUMMARY_TITLE": "RÉSUMÉ DES COMPÉTENCES",
      "LEARN_MORE_ABOUT_SKILLS": "En savoir plus sur les compétences",
      "SKILLS_FEEDBACK_LABEL": "RETOUR D’INFORMATION",
      "WHAT_ARE_SKILLS_TITLE": "Définition des compétences",
      "SKILLS_DESCRIPTION": "Les compétences sont établies pour favoriser la croissance et le développement personnels. Bien que ces compétences ne fassent pas partie de l’évaluation numérique de votre appel, elles ont été sélectionnées par votre organisation pour améliorer votre efficacité.",
      "PROFICIENCY_SCALE_TITLE": "ÉCHELLE DE COMPÉTENCE",
      "EXPERT": "Expert",
      "PROFICIENT": "Maîtrise de la langue",
      "DEVELOPING": "En développement",
      "CALL_TRANSCRIPT": "Transcription de l’appel",
      "COLLAPSE_ALL": "Réduire tout",
      "EXPAND_ALL": "Tout développer",
      "THUMBNAIL": "Vignette",
      "OUT_OF_FIVE_POINTS": "/5 points",
      "TALKING_POINTS": "points de discussion",
      "TRANSCRIPT_LABEL": "Transcription",
      "YOU_ARE_OUT_OF_ATTEMPTS": "Vous n’avez plus de tentatives.",
      "REVIEW_GUIDELINES_REMAIN_COMPLIANT": "Passez en revue les consignes et respectez-les à l’avenir.",
      "TRY_AGAIN_ATTENTION_TO_COMPLIANCE": "Réessayez et veillez à respecter les consignes de conformité.",
      "NO_SCORE_OUT_OF_COMPLIANCE": "Nous avons relevé un élément qui pourrait ne pas être conforme",
      "WHY_OUT_OF_COMPLIANCE": "Pourquoi vous pourriez être non conforme",
      "REVIEW_TRANSCRIPT_MISSED_GUIDELINES": "Examinez votre relevé de notes pour voir où vous n’avez pas respecté les lignes directrices en matière de conformité.",
      "YOU_DID_FOLLOW_GUIDELINES": "Vous avez effectivement suivi ces lignes directrices.",
      "REVIEW_MISSED_GUIDELINES": "Examinez les lignes directrices relatives à la conformité manquée.",
      "OUT_OF_COMPLIANCE": "Non conforme",
      "SCORE_CALCULATION_TITLE": "Calcul de la note",
      "PROCESSING_TRANSCRIPT": "Nous sommes en train de traiter votre relevé de notes.",
      "WAIT_OR_REVIEW_SCORES": "Patientez ici ou examinez les autres sections de notes",
      "TRANSCRIPT_LOADING": "pendant le chargement de la transcription.",
      "REVIEW_FEEDBACK_KEEP_PRACTICING": "Examinez votre retour d’information et continuez à pratiquer",
      "HIGH_PERFORMERS_PRACTICE": "Les personnes très performantes pratiquent au moins une fois par semaine",
      "SUCCESSFULLY_PASSED": "Excellent travail! Vous avez réussi cette simulation.",
      "DIDNT_REACH_PASSING_SCORE": "Vous n’avez pas atteint la note de passage pour cette simulation.",
      "OUT_OF_ATTEMPTS": "<b>Vous avez épuisé toutes vos tentatives.</b> Consultez vos commentaires pour savoir comment vous pouvez vous améliorer.",
      "REVIEW_FEEDBACK_THEN_RETURN": "Passez en revue votre rétroaction, puis retournez à la page d’accueil lorsque vous serez prêt.",
      "GREAT_JOB_PRACTICED": "Bon travail, vous avez pratiqué {{count}} {{times}}. Continuez!",
      "GREAT_JOB_PRACTICED_FEMALE": "Bon travail, vous avez pratiqué {{count}} {{times}}. Continuez!",
      "TIME": "temps",
      "TIMES": "fois",
      "COMPLIANCE_GUIDELINES": "Lignes directrices en matière de conformité",
      "TALKING_POINT_TITLE": "LES POINTS DE DISCUSSION MANQUÉS OU DITS AU MAUVAIS MOMENT",
      "NO_TRANSCRIPT": "Pas de transcription disponible.",
      "QUIZ_SUMMARY_BASE": "Prenez un moment pour passer en revue votre rendement dans le cadre de ce quiz.",
      "QUIZ_SUMMARY_FAILED": "Prenez un moment pour passer en revue votre rendement dans le cadre de ce quiz. Passez en revue le {{stepNames}} {{StepWord}} mis en évidence sur l'écran d'aperçu du parcours pour mieux préparer votre prochaine tentative.",
      "QUIZ_SUMMARY_PASSED_WITH_MISSES": "Prenez un moment pour passer en revue votre rendement dans le cadre de ce quiz. Le {{stepNames}} {{stepWord}} {{stepVerb}} votre note la plus basse {{areaWord}}.",
      "OUT_OF_100": "SUR 100",
      "COVERED": "Couvert",
      "MISSED": "Manqués",
      "RETURN_TO_ASSIGNMENT": "Retour à l’affectation",
      "RETURN_TO_PATHWAY": "RETOURNER AU PARCOURS",
      "QUIZ_RESULTS_SUMMARY": "Résumé des résultats du quiz",
      "PROCESSING_RESULTS": "Traitement des résultats...",
      "NONE_PERFECT": "Aucun - Parfait!",
      "MESSAGING": "Messagerie",
      "MISSED_ONE_TALKING_POINT": "Vous avez omis 1 point de discussion pour ce sujet.",
      "MISSED_X_TALKING_POINTS": "Vous avez omis {{count}} points de discussion pour ce sujet.",
      "ROLEPLAY_POST_CALL_TITLE": "Vous avez atteint la fin de cet appel.",
      "ROLEPLAY_POST_CALL_SUBTITLE_PROCESSING": "Laissez-nous vos commentaires pendant que nous traitons vos résultats.",
      "ROLEPLAY_POST_CALL_SUBTITLE_DELAY": "Les résultats mettent un certain temps à se charger. Quittez le parcours et nous vous informerons quand ils seront prêts.",
      "ROLEPLAY_POST_CALL_SUBTITLE_ERROR": "Une erreur s'est produite lors du traitement de vos résultats. Veuillez contacter l'assistance à l'adresse",
      "ROLEPLAY_POST_CALL_PROCESSING_LABEL": "Traitement des résultats...",
      "ROLEPLAY_POST_CALL_FEEDBACK_QUESTION": "Cette conversation vous a-t-elle semblé réaliste et naturelle?",
      "FEEDBACK_THANK_YOU": "Merci pour vos commentaires!",
      "FEEDBACK_IMPROVEMENT_NOTE": "Merci pour vos commentaires! Nous nous efforcerons d’améliorer l’expérience.",
      "VIEW_RESULTS": "Voir les résultats",
      "FEEDBACK_IMPROVEMENT_SUFFIX": "Nous nous efforcerons d’améliorer l’expérience.",
      "QUIZ_RESULTS_LOADING": "Les résultats mettent un certain temps à se charger. Quittez le parcours et nous vous informerons quand ils seront prêts.",
      "KC_TOAST_TITLE": "Les résultats de votre contrôle des connaissances ont été traités",
      "KC_TOAST_CONTENT": "Cliquez ci-dessous pour voir les résultats, ou retournez à l'écran de détails du parcours pour votre prochaine étape.",
      "DISMISS": "Rejeter",
      "KC_TOAST_TITLE_PATHWAY": "Les résultats de votre contrôle des connaissances {{stepName}} ont été traités",
      "MISSED_ONE_REQUIRED_TALKING_POINT": "Vous avez omis 1 point de discussion requis pour ce sujet",
      "MISSED_X_REQUIRED_TALKING_POINTS": "Vous avez omis {{count}} points de discussion requis pour ce sujet",
      "MISSED_ALL_ONE_REQUIRED_TALKING_POINT_TITLE": "Vous avez omis 1 point de discussion requis pour ce sujet.",
      "MISSED_ALL_X_REQUIRED_TALKING_POINTS_TITLE": "Vous avez omis {{count}} points de discussion requis pour ce sujet.",
      "REVIEW_MATERIAL_NEXT_TIME": "Passez en revue le contenu pour vous améliorer la prochaine fois.",
      "ACCURACY": "Exactitude",
      "ACCURACY_LOADING": "Chargement...",
      "ACCURACY_FLAGGED_MESSAGE": "Vous avez fait certaines affirmations qui pourraient différer de vos documents sources. Voir ci-dessous pour plus de détails.",
      "ACCURACY_ALL_CLEAR": "Nous n’avons relevé aucune affirmation inexacte par rapport aux documents sources.",
      "ACCURACY_ERROR": "Impossible de donner une rétroaction sur cette séance",
      "ACCURACY_YOU_SAID": "CE QUE VOUS AVEZ DIT",
      "ACCURACY_CLAIM_IDENTIFIED": "L'AFFIRMATION QUE NOUS AVONS IDENTIFIÉE",
      "ACCURACY_MATERIALS_STATE": "CE QUE VOS DOCUMENTS INDIQUENT",
      "ACCURACY_OVERALL_BLOCK_PREFIX": "Vous avez fait certaines affirmations qui pourraient être inexactes. Vérifier ",
      "ACCURACY_OVERALL_BLOCK_LINK": "l’onglet « exactitude »",
      "ACCURACY_OVERALL_BLOCK_SUFFIX": " pour plus de détails.",
      "PRACTICE_SIMULATION_AGAIN": "Pratiquer la simulation à nouveau",
      "CALL_TYPE_CONVERSATIONAL": "Appel conversationnel",
      "CALL_TYPE_GUIDED": "Appel guidé",
      "CALL_TYPE_VISUAL_AID": "Appel avec aide visuelle",
      "CALL_TYPE_ROLEPLAY": "Appel de jeu de rôle",
      "PERSONALIZED_PRACTICE_BREADCRUMB": "Pratique personnalisée",
      "CONVERSATION_TYPE_LABEL": "Type de conversation :",
      "DIFFICULTY_LABEL": "Difficulté :",
      "MOOD_LABEL": "Ambiance :",
      "DIFFICULTY": "Difficulté",
      "TEMPERAMENT": "Tempérament",
      "OVERALL_SCORE_TAB": "Dans l’ensemble",
      "MESSAGE_ADHERENCE_TAB": "Messages",
      "OBJECTIVES_TAB": "Objectifs"
    },
    "reportingV2": {
      "DASHBOARD": "Tableau de bord",
      "LOADING_ACCOUNTS": "Chargement des comptes...",
      "SELECT_AN_ACCOUNT": "Sélectionner un compte",
      "SEARCH_TEAMS": "Équipes de recherche",
      "LOADING_TEAMS": "Chargement des équipes...",
      "ALL_TEAMS": "Toutes les équipes",
      "ACCOUNT": "Compte",
      "TEAMS": "Équipes",
      "TEAM_LABEL": "Équipe",
      "TOTAL_LABEL": "Total",
      "PASSING_SCORE": "Note de passage",
      "ASSIGNMENT_LABEL": "Affectations",
      "USER_LABEL": "Utilisateur",
      "PRACTICE_LABEL": "Pratique",
      "CERTIFICATION_LABEL": "Certification",
      "RESULTS_DESCRIPTION": "Voici les résultats de votre (vos) équipe(s) pour l'ensemble des exercices :",
      "ENGAGEMENT_BY_ASSIGNMENT": "Engagement par affectation",
      "ASSIGNMENT_ENGAGEMENT": "Affectation complétée",
      "ENGAGED_LABEL": "Engagé",
      "ENGAGEMENT_STATUS_LABEL": "État d’engagement",
      "PROFICIENT_LABEL": "Maîtrise de la langue",
      "ASSIGNMENT_NAME": "Nom de l'affectation",
      "ACTIVE_USERS": "Utilisateurs actifs",
      "ASSIGNMENT_PROGRESS": "Progrès par affectation",
      "IN_PROGRESS_LABEL": "En cours",
      "CERTIFIED_LABEL": "Certifié",
      "OUT_OF_ATTEMPTS_LABEL": "Hors des tentatives",
      "USERS_ENGAGED_LABEL": "Utilisateurs engagés",
      "SESSIONS_PER_ACTIVE_USERS_LABEL": "Sessions par utilisateur actif",
      "HIGHER_THAN_LABEL": "Plus élevé que",
      "MORE_THAN_LABEL": "Plus de",
      "TOTAL_SESSIONS_COMPLETED_LABEL": "Nombre total de sessions achevées",
      "USER_CERTIFIED": "Utilisateurs certifiés pour toutes les affectations",
      "ASSIGNMENT_CERTIFICATION": "Affectations avec une certification de 100 %",
      "TRAINER_TIME_SAVED": "Gain de temps pour le formateur",
      "HOURS_LABEL": "heures",
      "PRACTICE_ASSIGNMENT_LABEL": "Travaux pratiques",
      "CERTIFICATION_ASSIGNMENT_LABEL": "Affectations de certification",
      "START_DATE_LABEL": "Date de début",
      "END_DATE_LABEL": "Date de fin",
      "NAME_LABEL": "Nom",
      "EMAIL_LABEL": "Courriel",
      "MEMBER_OF_TEAMS_LABEL": "Membre des équipes",
      "ASSIGNMENTS_COUNT_LABEL": "Nombre d'affectations",
      "TOTAL_SESSIONS_LABEL": "Total des sessions",
      "NUMBER_OF_SESSIONS_LABEL": "Nombre de sessions",
      "TOTAL_USERS_LABEL": "Total des utilisateurs",
      "AVERAGE_SCORE_LABEL": "Note moyenne",
      "INITIAL_SCORE_LABEL": "Note initial",
      "HIGH_SCORE_LABEL": "Note élevée",
      "LAST_PRACTICE_DATE_LABEL": "Date de la dernière pratique",
      "PERCENT_IMPROVED_LABEL": "% d'amélioration",
      "PERCENT_IMPROVED_TOOLTIP_TEXT": "Cet indicateur compare la note initiale d'un utilisateur à sa note la plus élevée, exprimé en pourcentage de l'amélioration maximale possible.",
      "ASSIGNMENTS_CERTIFIED_LABEL": "Affectations certifiées",
      "ASSIGNMENTS_PROFICIENT_LABEL": "Compétent pour les affectations",
      "ASSIGNMENTS_CERTIFIED_TOOLTIP_TEXT": "Le nombre d’affectations pour lesquelles l'utilisateur a atteint ou dépassé les critères de score pour toutes les simulations de l’affectation.",
      "ASSIGNMENTS_PROFICIENT_TOOLTIP_TEXT": "Le nombre d’affectations pour lesquelles l'utilisateur a atteint ou dépassé le critère de score au moins une fois pour toutes les simulations de l’affectation.",
      "PROFICIENT_TOOLTIP": "Le nombre d’utilisateurs dans cette affectation ayant obtenu au moins une fois un résultat égal ou supérieur au critère de haute note défini pour tous les appels de cette affectation.",
      "IN_PROGRESS_TOOLTIP": "Pourcentage d'utilisateurs ayant effectué au moins une session de simulation dans le cadre de cette affectation et ayant obtenu une note.",
      "OUT_OF_ATTEMPTS_TOOLTIP": "Le pourcentage d'utilisateurs qui ont dépassé leur nombre de tentatives pour une ou plusieurs simulations de l'affectation.",
      "CERTIFIED_TOOLTIP": "Le pourcentage d'utilisateurs qui ont atteint ou dépassé les critères de score pour toutes les simulations de l'affectation.",
      "SEARCH_FOR_A_USER_LABEL": "Recherche d'un utilisateur",
      "NO_USERS_FOUND_LABEL": "Aucun utilisateur trouvé",
      "TRAINER_TIME_SAVED_TOOLTIP": "Le temps que les utilisateurs ont passé dans Quantified à effectuer des tentatives de certification.",
      "AVG_SESSIONS_PER_ASSIGNMENT": "Nombre moyen de sessions par affectation",
      "ASSIGNMENTS_ENGAGED_WITH": "Affectations terminées",
      "AVERAGE_IMPROVEMENT": "Amélioration moyenne",
      "STATUS": "État",
      "TOTAL_NUMBER_OF_SESSIONS": "Nombre total de sessions",
      "DATE_OF_LAST_PRACTICE": "Date de la dernière pratique",
      "CALL_NAME": "Nom de l’appel",
      "SESSION_DATE": "Date de la session",
      "DURATION_OF_SESSION": "Durée de la session",
      "OVERALL_SCORE": "Note globale",
      "MESSAGING_SCORE": "Note d'adhésion au message",
      "METHODOLOGY_SCORE": "Note méthodologique",
      "SKILLS_SCORE": "Note de compétences",
      "SESSIONS": "session",
      "TOTAL": "Total",
      "ALL_ASSIGNMENTS": "Toutes les affectations",
      "RECENT_ASSIGNMENTS": "Affectations récentes",
      "AVERAGE_SESSIONS_ACTIVE_USER": "Nombre moyen de sessions par utilisateur actif",
      "HOURS_IN_SIMULATIONS": "Heures de simulation",
      "AVERAGE_SESSIONS_TO_PROFICIENCY": "Nombre moyen de sessions pour atteindre la compétence",
      "PERCENT_PROFICIENT": "Pourcentage de réussite",
      "SYSTEM_RUNNING_NORMALLY": "Le système fonctionne actuellement normalement",
      "PRACTICE_SIMULATIONS_LABEL": "Simulations",
      "NO_USERS_MATCHING_FILTERS_LABEL": "Aucun résultat ne correspond à vos filtres. Essayez de supprimer un ou plusieurs filtres pour élargir la recherche.",
      "USERS_PASSED": "Utilisateurs ayant réussi la simulation",
      "AVERAGE_TIME": "Délai moyen de certification",
      "USERS_OUT_OF_ATTEMPTS": "Utilisateurs hors de tentatives",
      "NO_CERTIFICATION_SIMULATION": "Aucune simulation de certification trouvée",
      "SIMULATION": "Simulation",
      "No_SIMULATION": "Pas de sessions",
      "PERCENT_CERTIFIED": "Pourcentage certifié",
      "PERCENT_CERTIFIED_FIRST_ATTEMPT": "Pourcentage certifié à la première tentative",
      "USERS": "Utilisateur",
      "ATTEMPTS_LABEL": "Tentatives",
      "NO_ATTEMPTS": "Pas de tentatives",
      "DATE_OF_SESSION": "Date de la session",
      "NO_ASSIGNMENTS_MATCH_FILTERS": "Aucune affectation ne correspond aux filtres choisis",
      "NO_TEAMS_DATA": "Il n'y a pas d'équipes dans ce compte",
      "SIMULATION_NAME": "Nom de la simulation",
      "AVERAGE_DURATION_OF_SESSION": "Durée moyenne de la session",
      "AVERAGE_SESSIONS_PER_ACTIVE_USER": "Nombre moyen de séances de pratique par utilisateur actif",
      "AVERAGE_OVERALL_SCORE": "Note globale moyenne",
      "TOTAL_ASSIGNMENTS": "Total des affectations",
      "ASSIGNMENTS_CERTIFIED": "Affectations certifiées",
      "TOTAL_SESSIONS": "Total des sessions",
      "HOURS_SPENT_PRACTICING": "Heures consacrées à la pratique",
      "LAST_LOGIN": "Dernière connexion",
      "SELECT_ASSIGNMENTS": "Sélectionner les affectations",
      "CERTIFICATION_STATUS_LABEL": "État de la certification",
      "CERTIFICATION_STATUS_PREFIX_LABEL": "État de la certification :",
      "CERTIFIED_ON_FIRST_ATTEMPT_LABEL": "Certifié dès le premier essai?",
      "DATE_OF_CERTIFICATION_LABEL": "Date de certification",
      "ENGAGEMENT_STATUS_PREFIX_LABEL": "État d’engagement :",
      "DURATION_OF_ATTEMPT": "Durée de la tentative",
      "USER_NAME": "Nom de l'utilisateur",
      "LEARNER": "Apprenant",
      "DATE_RANGE": "Plage de dates",
      "DATE_RANGE_LABEL": "Plage de dates",
      "SEARCH_USERS": "Recherche d'utilisateurs...",
      "SEARCH_SIMULATIONS": "Simulations de recherche...",
      "SEARCH_DATES": "Dates de recherche...",
      "CERTIFIED_ON_FIRST_TRY": "Certifié du premier coup",
      "DATE_OF_CERTIFICATION": "Date de certification",
      "AVERAGE_CERTIFICATION_SCORE": "Note moyenne de certification",
      "TOTAL_TIME_CERTIFYING": "Durée totale de la certification",
      "OF_THE_TIME": "du temps",
      "ASSIGNED_LABEL": "Pas commencé",
      "USERS_ASSIGNED_LABEL": "Total des utilisateurs assignés",
      "SESSION_ID": "ID de la session :",
      "USER_NAME_LABEL": "Nom de l'utilisateur",
      "NO_SIMULATIONS_FOUND_LABEL": "Aucune simulation trouvée",
      "MIN": "min",
      "SEC": "sec",
      "OF_LABEL": "de",
      "SECOND": "seconde",
      "SECONDS": "secondes",
      "MINUTE": "minute",
      "MINUTES": "minutes",
      "ASSIGNED": "Attribué",
      "ENGAGED_TOOLTIP": "Pourcentage d'utilisateurs ayant terminé une ou plusieurs sessions de simulation dans le cadre de cette affectation, mais n'ayant pas encore atteint le niveau de maîtrise requis pour toutes les simulations.",
      "SEARCH_ASSIGNMENTS": "Rechercher des affectations...",
      "ASSIGNMENT_NAME_LABEL": "Nom de l'affectation",
      "SIMULATION_NAME_LABEL": "Nom de la simulation",
      "START_DATE": "Date de début",
      "END_DATE": "Date de fin",
      "NO_ASSIGNMENTS": "Aucune affectation trouvée pour cet utilisateur.",
      "TOTAL_PRACTICE_ASSIGNMENTS": "Total des travaux pratiques",
      "SESSION_SCORES_OVER_TIME": "Notes de session au fil du temps",
      "TIME": "Temps",
      "SCORE": "Note",
      "NO_SESSIONS_AVAILABLE": "Aucune session disponible à représenter graphiquement.",
      "MESSAGING_SCORE_LABEL": "Note de messagerie",
      "PERSONALIZED_PRACTICE_LABEL": "Pratique personnalisée",
      "ASSIGNMENT_ENAGEMENT": "Engagement par affectation",
      "NO_PRODUCTS": "Aucun produit d'entraînement personnalisé pour les équipes sélectionnées",
      "TOTAL_TIME_SPENT_PRACTICING": "Temps total consacré à la pratique",
      "AVERAGE_SESSIONS_PER_USER": "Nombre moyen de sessions par utilisateur",
      "MOST_COMMON_CONVERSATION_TYPE_SELECTION": "Sélection du type de conversation le plus courant",
      "LEAST_COMMON_CONVERSATION_TYPE_SELECTION": "Sélection du type de conversation le moins courant",
      "CLEAR_TEAMS": "Supprimer les équipes",
      "METHODOLOGY_SCORE_DESCRIPTION": "Mesure à quel degré les apprenants suivent la structure d'appel recommandée. Les notes reflètent la moyenne sur toutes les sessions de cette simulation.",
      "METHODOLOGY": "Méthodologie",
      "MESSAGING": "Messagerie",
      "MESSAGING_V2_DASHBOARD_DESCRIPTION": "Mesure si les apprenants articulent les idées clés pendant l'appel. Les graphiques montrent le pourcentage moyen de messages correctement articulés par thème, sur toutes les sessions.",
      "NO_METRICS_MESSAGE": "Il faudrait davantage de séances pour dégager des conclusions.",
      "SELECT_ALL": "Tout sélectionner",
      "DESELECT_ALL": "Tout désélectionner",
      "SKILLS": "Compétences",
      "SKILLS_SCORE_STATS_DESCRIPTION": "Mesure à quel degré les apprenants démontrent des compétences clés pendant l'appel. Les notes reflètent une évaluation IA moyennée sur toutes les sessions.",
      "EXPERT": "Expert",
      "PROFICIENT": "Maîtrise de la langue",
      "DEVELOPING": "En développement",
      "FULLY_ARTICULATED": "Entièrement exprimé",
      "PARTIALLY_ARTICULATED": "Partiellement exprimé",
      "NOT_MENTIONED": "Non mentionné",
      "MESSAGING_SCORE_STATS_DESCRIPTION": "Mesure si les apprenants articulent les idées clés pendant l'appel. Les graphiques montrent à quelle fréquence chaque message a été correctement articulé, sur toutes les sessions.",
      "CLEAR": "Supprimer",
      "CLEAR_STATUS": "Supprimer l’état",
      "CLEAR_USERS": "Supprimer les utilisateurs",
      "CLEAR_SIMULATIONS": "Supprimer les simulations",
      "CLEAR_ASSIGNMENTS": "Supprimer les affectations",
      "MODAL_SUBHEADING": "Tous les objectifs {{ count }} — notes moyennes sur toutes les sessions",
      "VIEW_ALL_OBJECTIVES": "Voir tous les objectifs {{ count }} →",
      "LEAST_MISSED_QUESTION": "QUESTION LA MOINS OMISE",
      "MOST_MISSED_QUESTION": "QUESTION LA PLUS OMISE",
      "HIGHEST_SCORING_METHODOLOGY_SECTION": "SECTION CONSACRÉE À LA MÉTHODOLOGIE DES MEILLEURS SCORES",
      "LOWEST_SCORING_METHODOLOGY_SECTION": "SECTION CONSACRÉE À LA MÉTHODOLOGIE DES MOINS BONS SCORES",
      "LEAST_ARTICULATED_MESSAGE": "MESSAGE LE MOINS ARTICULÉ",
      "ENGAGEMENT": "ENGAGEMENT",
      "USER_ENGAGEMENT_MORE_SESSIONS": "nombre de séances effectuées supérieur à la moyenne de l'équipe",
      "QUESTION_CORRECT_PERCENTAGE_DESC": "du temps, ils réussissaient cette question",
      "QUESTION_CORRECT_PERCENTAGE_DESC_ASSIGNMENT": "du temps, les utilisateurs réussissent cette question",
      "METHODOLOGY_AVERAGE_POINTS_DESC": "moyenne de points pour cet objectif pour l’ensemble des séances",
      "MOST_ARTICULATED_MESSAGE": "MESSAGE LE PLUS ARTICULÉ",
      "LEAST_MISSED_ANSWER_POINT": "POINT DE RÉPONSE LE MOINS OMIS",
      "MOST_MISSED_ANSWER_POINT": "POINT DE RÉPONSE LE PLUS OMIS",
      "MOST_ARTICULATED_MESSAGE_DESCRIPTION": "du temps, ils articulent pleinement ce message",
      "LEAST_ARTICULATED_MESSAGE_DESCRIPTION": "du temps, ils articulent ce message",
      "ASSIGNMENT_STATUS": "État de l’affectation",
      "STATUS_ACTIVE": "Actif",
      "STATUS_ENDED": "Terminé",
      "STATUS_CLOSED": "Fermé",
      "STATUS_ARCHIVED": "Archivé",
      "USER_ENGAGEMENT_FEWER_SESSIONS": "nombre de séances effectuées inférieur à la moyenne de l'équipe",
      "MOST_ARTICULATED_MESSAGE_DESCRIPTION_ASSIGNMENT": "du temps, les utilisateurs articulent ce message",
      "LEAST_ARTICULATED_MESSAGE_DESCRIPTION_ASSIGNMENT": "du temps, les utilisateurs articulent ce message",
      "OTHERS_SINGULAR": "et 1 autre",
      "OTHERS_PLURAL": "et {{ count }} autres",
      "PAGINATION_PREVIOUS": "Précédent",
      "PAGINATION_NEXT": "Suivant",
      "HOUR_LABEL": "heure",
      "SESSIONS_LABEL": "sessions"
    },
    "personalizedPractice": {
      "TITLE": "Pratique personnalisée",
      "DESCRIPTION": "Bonjour {{userFirstName}}! Les pratiques personnalisées vous permettent de paramétrer vos propres scénarios afin qu'ils soient aussi réalistes que possible.",
      "LOADING": "Chargement...",
      "VIEW_SESSIONS": "Voir les sessions",
      "VIEW_SIMULATION": "Voir la simulation",
      "TOTAL_SESSION": "session totale",
      "TOTAL_SESSIONS": "total des sessions",
      "BREADCRUMB": "Pratique personnalisée",
      "SCENARIO_DETAILS_TITLE": "Détails du scénario",
      "SCENARIO_DETAILS_DESCRIPTION": "Sélectionnez des variables parmi les options ci-dessous pour ajuster la simulation à vos besoins.",
      "AVATAR": "Avatar",
      "SELECT_PLACEHOLDER": "Sélectionner",
      "CONVERSATION_TYPE": "Type de conversation",
      "SELECT_CONVERSATION_TYPE": "Sélectionner le type de conversation",
      "LAUNCH_SIMULATION": "Lancer la simulation avec les sélections",
      "PREVIOUS_SESSIONS": "Sessions précédentes",
      "TOTAL": "Total",
      "FILTERS": "Filtres :",
      "DATE": "Date",
      "DIFFICULTY": "Difficulté",
      "TEMPERAMENT": "Tempérament",
      "SESSION_DATE": "Date de la session",
      "SESSION_SCORE": "Note de la session",
      "DURATION": "Durée",
      "OVERALL_SCORE": "Note globale",
      "MESSAGING": "Messagerie",
      "METHODOLOGY": "Méthodologie",
      "SKILLS": "Compétences",
      "RESULTS": "Résultats",
      "VIEW_FEEDBACK": "Voir le retour d’information",
      "OVERALL_SCORE_LABEL": "Note globale",
      "SCORE": "Note",
      "NO_PRODUCTS_TITLE": "Aucun produit disponible",
      "NO_PRODUCTS_DESCRIPTION": "Vous n'avez pas encore de produits de pratiques personnalisées.",
      "NO_SESSIONS_FOUND": "Aucune session trouvée avec les filtres sélectionnés",
      "TIME": "Temps",
      "ALL": "Tous",
      "LEARNER": "Apprenant",
      "MOOD": "Ambiance",
      "CLEAR_FILTERS": "Supprimer les filtres",
      "PAGINATION_PREVIOUS": "Précédent",
      "PAGINATION_NEXT": "Suivant",
      "DURATION_MINUTES_SECONDS": "{{minutes}} m {{seconds}} s",
      "DURATION_SECONDS": "{{seconds}}s"
    },
    "login": {
      "TITLE": "Bienvenue à nouveau",
      "SUB_TITLE": "Comment souhaitez-vous vous connecter?  ",
      "LOGIN_WITH_SSO": "Se connecter avec le SSO de l’entreprise",
      "LOGIN_WITH_PASSWORD": "Se connecter avec le mot de passe",
      "PROVIDE_EMAIL": "Indiquez votre adresse courriel",
      "HELP_TEXT": "Besoin d’aide? Contact",
      "EMAIL_ERROR": "Nous ne sommes pas en mesure de vous connecter, veuillez contacter l’administrateur ou le service informatique de votre entreprise.",
      "EMAIL": "Courriel",
      "LOGIN": "Se connecter",
      "ALERT": "Alerte",
      "EMAIL_PLACEHOLDER": "olivia@untitledui.com",
      "LOGIN_CONSENT_MESSAGE": "En vous connectant à votre compte, vous acceptez les {{termsLink}} et {{privacyLink}}.",
      "TERMS_OF_SERVICE": "Conditions d'utilisation",
      "PRIVACY_POLICY": "Politique de confidentialité",
      "WRONG_REGION_MESSAGE": "Nous ne parvenons pas à vous connecter, veuillez contacter l'administrateur de votre entreprise.",
      "WRONG_REGION_LINK": "Vous pouvez également essayer de vous connecter au site {{regionName}}."
    },
    "learningPathway": {
      "BEGIN": "Commencer",
      "DUE_DATE": "Date d’échéance",
      "FOOTER_SUBTITLE_READY": "Posez-moi n'importe quelle question ! Je suis prêt à vous aider.",
      "LEAVE_STEP": "Passer l'étape",
      "NEXT_STEP": "Étape suivante",
      "NOTIFICATIONS_ARIA": "Notifications",
      "PDF_NEXT_PAGE": "Page suivante",
      "PDF_NO_SOURCE": "Aucune source PDF fournie.",
      "PDF_PREVIOUS_PAGE": "Page précédente",
      "POST_CALL_SUBTITLE": "Laissez-nous vos commentaires pendant que nous traitons vos résultats.",
      "POST_CALL_TITLE": "Vous avez atteint la fin de ce quiz.",
      "SETTINGS": "Paramètres",
      "TOAST_CONTENT": "Cliquez ci-dessous pour voir les résultats, ou retournez à l'écran de détails du parcours pour votre prochaine étape.",
      "TOAST_TITLE": "Vos résultats de jeu de rôle {{stepName}} ont été traités",
      "ASSIGNMENTS": "Affectations",
      "USER_FALLBACK": "Utilisateur",
      "VIEW_RESULTS": "Voir les résultats",
      "QUIZ_TITLE": "Quiz",
      "SUBMIT_ANSWER": "Soumettre la réponse",
      "CONTINUE": "Continuer",
      "REVIEW_MATERIAL": "Matériel de révision",
      "ASK_QUESTIONS_ABOUT_PATHWAY": "Posez des questions sur le parcours",
      "FOOTER_SUBTITLE_MUTED": "Vous êtes actuellement en mode silencieux. L'entraîneur ne peut pas vous entendre.",
      "FOOTER_SUBTITLE_LISTENING": "J'écoute votre question...",
      "FOOTER_SUBTITLE_THINKING": "Je réfléchis à une réponse...",
      "PDF_LOADING": "Chargement du PDF",
      "PDF_SCROLL_HINT": "Défilez pour continuer la lecture",
      "QUIZ_OVERALL_SCORE_TOOLTIP": "Le score global correspond à la moyenne pondérée de vos réponses pour cette tentative.",
      "QUIZ_COLUMN_DATE": "Date",
      "QUIZ_COLUMN_OVERALL_SCORE": "Note globale",
      "QUIZ_COLUMN_ANSWER_POINTS": "Points de réponse",
      "QUIZ_COLUMN_RESULTS": "Résultats",
      "COMPLETE_STEP": "Complet",
      "ERROR_TITLE": "Quelque chose s'est mal passé",
      "ERROR_MESSAGE": "Veuillez quitter le parcours et y revenir. Si le problème persiste, contactez",
      "ERROR_HELP_EMAIL": "help@quantified.ai",
      "PATHWAY_COMPLETED_TITLE": "Vous avez terminé ce parcours",
      "PATHWAY_COMPLETED_BODY": "Vous pouvez consulter vos résultats à tout moment ou revenir sur n'importe quelle étape pour continuer à vous pratiquer.",
      "PATHWAY_COMPLETED_RETURN": "Retour aux affectations",
      "PATHWAY_OUT_OF_ATTEMPTS_TITLE": "Vous avez épuisé toutes vos tentatives pour une étape du parcours",
      "PATHWAY_OUT_OF_ATTEMPTS_BODY": "Contactez votre responsable pour discuter des prochaines étapes.",
      "COMPLETED": "Terminé",
      "EXITING_QUIZ_EARLY": "Quitter ce quiz maintenant comptera comme une tentative",
      "TRY_AGAIN": "Réessayer",
      "RETURN_TO_PATHWAY": "Retour à la page d'accueil du parcours",
      "REVIEW_BEFORE_QUIZ_TOOLTIP": "Veuillez revoir cette étape avant de réessayer le quiz",
      "FOOTER_SUBTITLE_QUIZ_RESULT_DONE": "Cliquez sur le bouton à droite →",
      "VIEW_CALL_DETAILS": "Voir les détails de l’appel",
      "FOOTER_SUBTITLE_READY_LEARN_WITH_X": "L'entraîneur est à l’écoute si vous avez une question",
      "COLUMN_DATE": "Date",
      "COLUMN_OVERALL_SCORE": "Note globale",
      "COLUMN_RESULTS": "Résultats",
      "COLUMN_ANSWER_POINTS": "Points de réponse",
      "COLUMN_MESSAGING_SCORE": "Note de messagerie",
      "COLUMN_METHODOLOGY_SCORE": "Note de méthodologie",
      "COLUMN_SKILLS_SCORE": "Note de compétences",
      "PRACTICE_AGAIN": "Pratiquer à nouveau",
      "DEBRIEF_LATEST_SESSION": "Faire un compte rendu de la dernière session",
      "EXIT_MODAL_TITLE": "Êtes-vous sûr de vouloir mettre fin à ce jeu de rôle?",
      "EXIT_MODAL_EXIT": "Sortir",
      "EXIT_MODAL_RESUME": "Reprendre",
      "EXIT_MODAL_DESC_LIMITED_ATTEMPTS": "Si vous quittez le jeu de rôle maintenant, il ne sera pas noté mais comptabilisé comme une tentative.",
      "EXIT_MODAL_DESC_UNLIMITED_ATTEMPTS": "Si vous quittez le jeu de rôle maintenant, il ne sera pas noté.",
      "EXIT_MODAL_DESC_SCORED": "Si vous quittez le jeu de rôle maintenant, nous noterons votre appel tel quel.",
      "RESULTS_PROCESSING": "Traitement des résultats",
      "RESULTS_FAILED": "Les résultats n'ont pas pu être chargés. Contactez help@quantified.ai",
      "DEBRIEF_TITLE": "Débreffage",
      "DEBRIEF_DESCRIPTION": "Discutez des résultats de votre dernière tentative de certification",
      "DEBRIEF_DESCRIPTION_PRACTICE": "Discutez des résultats de votre dernière séance d'entraînement",
      "VIEW_ALL_SESSIONS": "Voir toutes les séances",
      "COLLAPSE_SESSIONS": "Réduire les séances",
      "VIEW_ALL_ATTEMPTS": "Voir toutes les tentatives",
      "COLLAPSE_ATTEMPTS": "Réduire les tentatives",
      "REATTEMPT_CERTIFICATION": "Réessayer la certification",
      "DEBRIEF_EXIT_MODAL_TITLE": "Êtes-vous sûr de vouloir mettre fin à ce débreffage?",
      "DEBRIEF_EXIT_MODAL_DESC": "Si vous quittez le débreffage maintenant, il ne sera pas marqué comme terminé.",
      "EXIT_PATHWAY": "Quitter le parcours",
      "HELP": "Aide",
      "LEARN_STEP_HELP_CLOSE": "Fermer",
      "LEARN_STEP_HELP_TROUBLE": "Si vous rencontrez toujours des problèmes, contactez",
      "LEARN_STEP_HELP_EMAIL": "help@quantified.ai",
      "LEARN_STEP_HELP_VIDEO_P1": "Regardez le matériel et posez toutes vos questions à l'entraîneur.",
      "LEARN_STEP_HELP_VIDEO_P2": "Sélectionnez le bouton de lecture pour démarrer la vidéo. Vous pouvez revenir en arrière pour revoir le matériel.",
      "LEARN_STEP_HELP_VIDEO_P3": "Réactivez votre microphone en bas à droite pour poser une question. Cela mettra la vidéo en pause. Lorsque vous lancerez la vidéo, nous mettrons le son de votre microphone en sourdine.",
      "LEARN_STEP_HELP_VIDEO_P4": "Lorsque vous aurez regardé la vidéo en entier, passez à l'étape suivante.",
      "LEARN_STEP_HELP_PDF_P1": "Lisez le matériel et posez toutes les questions que vous souhaitez à l’entraîneur.",
      "LEARN_STEP_HELP_PDF_P2": "Naviguez dans le matériel en faisant défiler ou en utilisant les boutons de direction des deux côtés pour passer d'une page à l'autre.",
      "LEARN_STEP_HELP_PDF_P3": "Vous pouvez vous mettre en sourdine et réactiver votre microphone en bas à droite.",
      "LEARN_STEP_HELP_PDF_P4": "Lorsque vous aurez tout lu, passez à l'étape suivante.",
      "PDF_FULLSCREEN_ENTER": "Passer en mode plein écran",
      "PDF_FULLSCREEN_EXIT": "Quitter le mode plein écran",
      "PDF_ZOOM_IN": "Agrandir",
      "PDF_ZOOM_OUT": "Réduire",
      "ASSESSMENT_EXIT_MODAL_TITLE": "Êtes-vous sûr de vouloir continuer?",
      "ASSESSMENT_EXIT_MODAL_DESC": "Si l'on passe à autre chose avant que cette conversation ne soit terminée, l'expérience d'apprentissage s'en trouvera allongée et moins personnalisée.",
      "ASSESSMENT_EXIT_MODAL_RESUME": "Reprendre l’évaluation",
      "ASSESSMENT_EXIT_MODAL_PROCEED": "Continuer",
      "ASSESSMENT_PERSONALIZATION_ERROR_TITLE": "Nous n'avons pas pu personnaliser votre parcours",
      "ASSESSMENT_PERSONALIZATION_ERROR_DESC_START": "Nous vous avons attribué l'intégralité du parcours. Contactez ",
      "ASSESSMENT_PERSONALIZATION_ERROR_DESC_END": " si vous souhaitez réessayer la personnalisation",
      "OPTIONAL": "Facultatif",
      "DISMISS": "Rejeter",
      "DOWNLOAD": "Téléverser"
    },
    "leaderboard": {
      "LEADERBOARD": "Tableau de bord",
      "TOP10PERCENT": "Top 10 %",
      "PRACTICE_ASSIGNMENT": "Travaux pratiques",
      "SIMULATION": "Simulation",
      "SELECT_ASSIGNMENT": "Sélectionner l'affectation",
      "SELECT_SIMULATION": "Sélectionner la simulation",
      "SELECT_ASSIGNMENT_AND_SIMULATION": "Sélectionnez une mission et une simulation pour voir les chefs de file",
      "NO_DATA": "Pas encore d'activité. Une fois que l'équipe commence à s'engager, vous verrez les classements apparaître ici.",
      "NO_ASSIGNMENTS_AVAILABLE": "Pas d’affectation disponible",
      "NO_SIMULATIONS_AVAILABLE": "Pas de simulations disponibles",
      "NAME": "Nom",
      "HIGH_SCORE": "Note élevée",
      "AVERAGE_SCORE": "Note moyenne",
      "TOTAL_SESSIONS": "Total des sessions",
      "LAST_SESSION": "Dernière session",
      "TOP5": "Top 5",
      "OF": "de",
      "ENGAGED_USERS": "utilisateurs engagés",
      "ENGAGED_USER": "utilisateur engagé",
      "HIDE_SESSIONS_WITH_LOW_SCORE": "Masquer les sessions dont les notes de compétences sont faibles",
      "SESSIONS_WITH_LOW_SCORE_TOOLTIP": "Les sessions dont la note de la section compétences est « en développement » ne contribuent pas aux colonnes des notes élevées ou moyennes.",
      "NO_USERS_ENGAGED": "Aucun utilisateur engagé",
      "PAGINATION_PREVIOUS": "Précédent",
      "PAGINATION_NEXT": "Suivant"
    },
    "hotjarSurveys": {
      "FEEDBACK_MESSAGE": "N’hésitez pas à nous faire part de vos commentaires pour nous aider à nous améliorer.",
      "THANK_YOU_MESSAGE": "Merci, nous continuerons à travailler pour améliorer votre expérience"
    },
    "general": {
      "NEED_HELP_QUESTION": "Besoin d’aide?",
      "CONTACT": "Contact",
      "HELP_EMAIL": "help@quantified.ai",
      "PARENT_ACCOUNT": "Compte parent",
      "ACCOUNT": "Compte",
      "CHECKMARK": "Coche",
      "ICON": "Icône",
      "ALERT": "alerte",
      "HEADS_UP": "Attention!",
      "USE_HEADPHONES_FOR_OPTIMAL_AUDIO": "Pour un son optimal sur l’iPad, utilisez des écouteurs.",
      "SETTINGS": "PARAMÈTRES",
      "RP": "RP",
      "EMAIL_LABEL": "Courriel",
      "RAVEN_EMAIL": "Raven@InspireHR.com",
      "TEAM_MANAGER_FOR": "Chef d’équipe pour",
      "MIAMI_SALE": "Vente à Miami",
      "CHARLOTTE_SALES": "Ventes à Charlotte",
      "ATLANTA_SALES": "Ventes à Atlanta",
      "TEAM": "Équipe",
      "ASSIGNMENTS": "Affectations",
      "MY_TEAMS": "Mes équipes",
      "REPORTING": "Rapports",
      "DASHBOARD": "Tableau de bord",
      "LEADERBOARD": "Tableau de bord",
      "PERSONALIZED_PRACTICE": "Pratique personnalisée",
      "HELP_SEARCH_OUR": "Recherchez sur notre site",
      "HELP_OR_REACH_OUT_TO": "ou contactez",
      "HELP_WITH_QUESTIONS": "avec des questions",
      "KNOWLEDGE_BASE": "base de connaissances",
      "NO_ROLE_WEB_MESSAGE": "Cet utilisateur n'a pas reçu d'accès au système. Veuillez communiquer avec un administrateur du système.",
      "NO_ROLE_IOS_TITLE": "Notre application est axée sur l’expérience de l’apprenant",
      "NO_ROLE_IOS_BODY_START": "Accédez à notre",
      "NO_ROLE_IOS_WEB_APP": "application Web",
      "NO_ROLE_IOS_BODY_END": "dans votre navigateur mobile pour profiter de fonctionnalités supplémentaires.",
      "HELP_SECTION": "AIDE",
      "ABOUT_SECTION": "À PROPOS",
      "CONTACT_SUPPORT": "Contacter le service de soutien",
      "OPEN_WEB_APP": "Ouvrir l’application Web",
      "SEARCH_KNOWLEDGE_BASE": "Rechercher dans la base de connaissances",
      "PRIVACY_POLICY": "Politique de confidentialité",
      "TERMS_OF_SERVICE": "Conditions d'utilisation",
      "VERSION": "Version",
      "LOG_OUT": "Se déconnecter"
    },
    "dashboard": {
      "ALL": "Tous",
      "IN_COMPLETE": "Incomplet",
      "COMPLETED": "Terminé",
      "NO_ASSIGNMENT_TITLE": "Vous n’avez pas d’affectation à accomplir.",
      "NO_ASSIGNMENT_DETAILS": "Vous serez averti lorsque vous aurez des affectations à accomplir.",
      "IN_COMPLETE_ASSIGNMENT_TITLE": "Vous n’avez aucune affectation incomplète.",
      "IN_COMPLETE_ASSIGNMENT_DETAILS": "Vous serez averti lorsqu’une nouvelle affectation sera à remettre.",
      "COMPLETED_ASSIGNMENT_TITLE": "Vous n’avez aucune affectation terminée.",
      "COMPLETED_ASSIGNMENT_DETAILS": "Revenez une fois que vous aurez terminé une affectation.",
      "VIEW_ASSIGNMENT": "Voir l’affectation",
      "ASSIGNMENT_LABEL": "Affectations",
      "MODULE_ASSIGNMENT_ALT": "Icône d’affectation du module",
      "VIEW_ASSIGNMENT_FOR": "Voir l’affectation pour",
      "DAY": "Jour",
      "UNTILL_DUE": "Délai restant",
      "PAST_DUE": "En retard",
      "AVAILABLE_IN": "Disponible dans",
      "DUE_TODAY": "À remettre aujourd’hui",
      "PRACTICE": "Pratique",
      "CERTIFICATION": "Certification",
      "UPCOMING": "À venir",
      "TEST_ASSIGNMENT": "Test d'évaluation",
      "CLOSED": "Fermé",
      "NO_ASSIGNMENT_FILTERED_TITLE": "Aucune affectation trouvée.",
      "NO_ASSIGNMENT_FILTERED_DETAILS": "Essayez d'ajuster vos filtres pour voir les affectations disponibles, ou revenez plus tard lorsque de nouvelles affectations sont ajoutées.",
      "VIEW_PATHWAY": "Voir le parcours",
      "TOTAL": "Total",
      "STATUS_LABEL": "Statut :",
      "STATUS_SELECTION_LABEL": "État :",
      "ASSIGNMENT_TYPE": "Type d'affectation",
      "ASSIGNMENT_TYPE_SELECTION_LABEL": "Type d'affectation :",
      "NOT_STARTED": "Pas commencé",
      "CERTIFIED": "Certifié",
      "NOT_CERTIFIED": "Non certifié",
      "IN_PROGRESS": "En cours",
      "PATHWAY": "Parcours d'apprentissage",
      "SELECT_ALL": "Tout sélectionner",
      "DESELECT_ALL": "Tout désélectionner",
      "GET_STARTED": "Commencer",
      "ASSIGNMENT_STATUS_LABEL": "État de l’affectation",
      "ASSIGNMENT_STATUS_SELECTION_LABEL": "État de l’affectation :",
      "CLEAR_STATUS": "Supprimer l’état",
      "ENDED": "Terminé",
      "START_PATHWAY": "Commencer le parcours",
      "DAYS": "Jours",
      "OTHERS_SINGULAR": "et 1 autre",
      "OTHERS_PLURAL": "et {{ count }} autres"
    },
    "cognito": {
      "INVITATION_SUBJECT": "Bienvenue à Quantified!",
      "INVITATION_MESSAGE": "Nous sommes ravis de vous compter parmi nous! Pour commencer, veuillez suivre les étapes ci-dessous pour vous connecter à votre compte pour la première fois.",
      "ACCOUNT_DETAILS": "Les détails de votre compte :",
      "USERNAME": "Nom d’utilisateur",
      "PASSWORD": "Mot de passe temporaire",
      "STEPS_LABEL": "Prochaines étapes pour se connecter",
      "STEP_1": "1. Cliquez sur le bouton « Se connecter » ci-dessous pour accéder à la page de connexion.",
      "STEP_2": "2. Saisissez votre nom d’utilisateur et votre mot de passe temporaire fournis ci-dessus.",
      "STEP_3": "3. Une fois connecté, vous serez invité à définir un nouveau mot de passe.",
      "LOGIN_BUTTON": "Se connecter",
      "ABOUT_US": "Le Simulateur de Quantified est un environnement virtuel conçu pour vous aider à développer rapidement des compétences essentielles, vous permettant de vous connecter et de communiquer plus efficacement avec les clients.",
      "EXPIRY_TIME": "Ce mot de passe temporaire expirera dans 24 heures. Si vous rencontrez des difficultés pour vous connecter, veuillez contacter notre équipe de soutien à l’adresse suivante",
      "TEAM": "L’équipe Quantified",
      "INVITATION_SMS_USERNAME": "Votre nom d’utilisateur est",
      "INVITATION_SMS_PASSWORD": "et le mot de passe temporaire est",
      "AUTHENTICATION_CODE": "Votre code d’authentification est",
      "PASSWORD_RESET_CODE": "Votre code de réinitialisation de mot de passe Quantified",
      "RESET_PASSWORD_EMAIL": "Réinitialiser le mot de passe par courriel",
      "HELLO": "Bonjour",
      "USE_VERIFICATION_CODE": "Vous avez demandé une réinitialisation de votre mot de passe. Veuillez utiliser le code de vérification ci-dessous pour terminer le processus.",
      "VERIFICATION_CODE": "Code de vérification",
      "NEXT_STEP": "Prochaines étapes",
      "RESET_PASSWORD_PAGE": "Retournez à la page de réinitialisation de votre mot de passe dans votre navigateur.",
      "ENTER_VERIFICATION_CODE": "Saisissez le code de vérification lorsque vous y êtes invité.",
      "CREATE_PASSWORD": "Une fois le code vérifié, suivez les instructions pour créer un nouveau mot de passe.",
      "DISREGARD_NOTE": "Si vous n’avez pas demandé de réinitialisation de mot de passe, veuillez ignorer ce courriel.",
      "CONTACT_SUPPORT": "Pour plus d’assistance, contactez notre équipe de soutien à l’adresse suivante",
      "HELP_EMAIL": "help@quantified.ai",
      "THANK_YOU": "Merci",
      "QUANTIFIED_TEAM": "L’équipe Quantified",
      "ADDRESS": "4200 Marathon Blvd, Suite 210, Austin, Texas 78756, États-Unis",
      "RETURN_TO_PATHWAY": "Retour à la page d'accueil du parcours"
    },
    "call": {
      "LOADING": "Chargement",
      "SIMULATION_PAUSED": "La simulation a été interrompue.",
      "CLICK_RESUME": "Cliquez sur le bouton « Reprendre » ci-dessous pour continuer.",
      "NO_INTERNET": "Aucune connexion Internet",
      "TRY_AGAIN": "Veuillez vérifier votre connexion et réessayer.",
      "MIC_MUTED": "Le micro est en sourdine",
      "MIC_MUTED_DESCRIPTION": "Oups, on dirait que votre micro est en sourdine. Rétablissez le son pour répondre et poursuivre l’appel.",
      "NO_RESPONSE": "Aucune réponse détectée",
      "MIC_NOT_CONNECTED": "Oups, on dirait que votre micro n’est pas connecté. Sélectionnez à nouveau votre appareil pour répondre et poursuivre l’appel.",
      "AUDIO_ISSUE": "Oups, un problème est survenu. Vérifiez les réglages de votre appareil et assurez-vous d'être dans un endroit calme, sans bruit de fond.",
      "LOADING_ALT": "Chargement...",
      "REPEAT_RESPONSE": "Vous serez automatiquement renvoyé à votre simulation pour répéter votre réponse et réessayer.",
      "NEEDS_MORE_TIME_QUESTION": "a besoin de plus de temps pour réfléchir. Voulez-vous attendre?",
      "NEEDS_MORE_TIME": "a besoin de plus de temps pour réfléchir.",
      "WAIT_OR_END_CALL": "Nous vous préviendrons lorsqu’ils seront prêts, ou vous pouvez mettre fin à l’appel et",
      "RETURN_TO_ASSIGNMENTS": "retourner à l’affectation",
      "READY": "Prêt",
      "IS_READY": "est prêt à poursuivre la conversation.",
      "TRY_AGAIN_LABEL": "Réessayer",
      "CHECK_SETTINGS": "Vérifier les paramètres",
      "PAUSED_SIMULATION": "Vous avez interrompu cette simulation.",
      "PAUSED_SIMULATION_DESCRIPTION": "L’enregistrement vidéo et audio est interrompu jusqu’à ce que la simulation reprenne.",
      "RESUME": "Reprendre",
      "SETTINGS": "Paramètres",
      "CAPTURING_RESPONSE": "Saisir vos réponses",
      "TOUR_MESSAGE": "Une fois que vous avez fini de parler, assurez-vous de cliquer sur le bouton Continuer pour que vos réponses soient saisies et notées.",
      "NEXT": "Suivant",
      "START_CALL": "Démarrage",
      "END_CALL_TITLE": "Souhaitez-vous vraiment mettre fin à cette simulation?",
      "END_CALL_DESCRIPTION": "Si vous terminez la simulation maintenant, vous n’obtiendrez pas de note ni de retour d’information sur votre conversation.",
      "END_CALL": "Fin",
      "BROWSER_ACCESS_DENIED": "Votre navigateur n’a pas accès à cet appareil.",
      "COPY_SESSION_ID_BUTTON": "Copier l’identifiant de la session",
      "TIPS_GUIDANCE_MESSAGE": "Des points de discussion et des conseils seront publiés ici.",
      "CONTINUE": "Continuer",
      "SESSION_ID_LABEL": "ID de la session :",
      "SESSION_ID_COPIED": "L’identifiant de la session a été copié!",
      "HINTS_AND_SUGGESTIONS_TITLE": "Conseils et suggestions",
      "HINT_LABEL": "Conseil",
      "CAPTIONS_LABEL": "Sous-titres",
      "PAUSE_LABEL": "Pause",
      "VIDEO_LABEL": "Vidéo",
      "PARTY_EMOJI": "émoji de fête",
      "CALL_ENDED_MESSAGE": "Vous avez atteint la fin de cette simulation.",
      "CALL_ENDED_INACTIVITY": "Cette simulation a pris fin en raison d’une inactivité",
      "CALL_ENDED_GENERIC": "Cette simulation est terminée",
      "FEEDBACK_PROMPT": "Laissez-nous vos commentaires pendant que nous traitons vos résultats.",
      "INTERACTION_THRESHOLD_NOT_MET": "Vous n’avez pas atteint notre seuil d’interaction pour la notation, veuillez réessayer.",
      "REALISTIC_CONVERSATION_QUESTION": "Cette conversation vous a-t-elle semblé réaliste et naturelle?",
      "KNOWLEDGEABLE_PREPARED_QUESTION": "Vous sentez-vous mieux informé et préparé après cette simulation?",
      "FEEDBACK_THANK_YOU": "Merci pour vos commentaires!",
      "FEEDBACK_IMPROVEMENT_NOTE": "Merci pour vos commentaires! Nous nous efforcerons d’améliorer l’expérience.",
      "AUDIO": "Audio",
      "VISUAL_AID_LOAD_ERROR": "L’aide visuelle n’a pas pu être chargée",
      "BEGIN_CALL": "Démarrage",
      "LEAVE_CALL_BRIEFING": "Breffage sur les congés",
      "RESTORE_CALL": "Restauration de la simulation",
      "FEW_SECONDS": "Cela peut prendre quelques secondes.",
      "CHECK_ALT": "Vérifier",
      "COPY_ALT": "Copie",
      "HINTS_ALT": "Conseils",
      "CLOSE_CAPTIONS": "Fermer les sous-titres",
      "MICROPHONE_MUTED": "Microphone en sourdine",
      "RETURN_TO_CALL": "Retour à la simulation",
      "YES": "Oui",
      "NO": "Non",
      "VIEW_RESULTS": "Voir les résultats",
      "RETURN_TO_ASSIGNMENT": "Retour à l’affectation",
      "HAVING_ISSUES": "Nous avons des difficultés à nous connecter. Veuillez vérifier votre connexion Internet, puis cliquez sur OK.",
      "OK": "OK",
      "RESULTS_NOT_GENERATED": "Désolé, nous ne sommes pas en mesure de générer des résultats pour le moment. Veuillez réessayer.",
      "INACTIVITY_ALERT_MESSAGE": "Cet appel sera terminé en raison d’une inactivité. Parlez à l’avatar pour continuer ou sélectionnez « Terminer l’appel » pour mettre fin à l’appel.",
      "INACTIVITY_DEFAULT_ALERT_TITLE": "Cet appel se terminera dans {{secondsUntilHangup}} secondes",
      "INACTIVITY_SHORT_ALERT_TITLE": "Cet appel se terminera dans quelques secondes",
      "TELL_YOUR_GENDER_HEADING": "Veuillez indiquer votre genre :",
      "BY_KNOWING_YOUR_GENDER_DESCRIPTION": "En connaissant votre genre, l’avatar peut utiliser une grammaire correcte, ce qui rend la conversation plus naturelle et plus réaliste.",
      "GENDER_SELECTION": "Sélection du genre :",
      "SELECT_OPTION": "Sélectionner une option",
      "CONFIRM": "Confirmer",
      "MALE": "Homme",
      "FEMALE": "Femme",
      "NON_BINARY": "Non-binaire/Autre",
      "PREFER_NOT_TO_ANSWER": "Préfère ne pas répondre",
      "NON_BINARY_MESSAGE": "Nous comprenons et respectons votre identité de genre non binaire. En raison des limites technologiques actuelles, nous utilisons par défaut des pronoms masculins. Sachez que nous travaillons à des améliorations pour mieux prendre en compte toutes les identités de genre à l’avenir. Nous vous remercions de votre compréhension et de votre patience.",
      "PREFER_NOT_TO_ANSWER_MESSAGE": "Nous respectons votre choix de ne pas fournir de genre. Dans de tels cas, notre technologie utilise par défaut les pronoms masculins en raison des limitations actuelles.",
      "DISPLAY_VISUAL_AID": "Afficher l’aide visuelle",
      "FULL_SCREEN": "Plein écran",
      "COLLAPSE": "Réduire",
      "COMPLETED_CONVERSATION_MESSAGE": "Merci d'avoir terminé cette conversation",
      "CONVERSATION_COMPLETION_FEEDBACK": "Laissez-nous vos commentaires pendant que nous traitons votre conversation.",
      "ERROR_MESSAGE": "Une erreur s'est produite. Veuillez contacter",
      "SAVED_CONVERSATION_MESSAGE": "Votre conversation a été enregistrée.",
      "RETURN_TO_MY_ASSIGNMENTS": "Retour à mes affectations",
      "RETURN_TO_PERSONALIZED_PRACTICE": "Retour à la pratique personnalisée",
      "PERSONALIZED_CALL_NOTE": "Vous venez de terminer une conversation de pratique personnalisée.",
      "LEAVE_STEP_TITLE": "Êtes-vous sûr de vouloir quitter cette étape?",
      "EXIT": "Sortir",
      "CERT_ACK_TITLE": "Remerciements pour la vidéo de certification",
      "CERT_ACK_ACCEPT_AND_BEGIN": "Accepter et commencer",
      "CERT_ACK_RESUME_CALL": "Reprendre l'appel",
      "CERT_ACK_PROCESSING": "Traitement en cours...",
      "CERT_ACK_CAMERA_WARNING": "Veuillez activer votre caméra pour poursuivre la certification.",
      "CERT_ACK_CAMERA_OFF_DURING_CALL": "Votre caméra était éteinte. Veuillez réactiver votre caméra pour reprendre la certification.",
      "CERT_ACK_TEXT_1": "Afin de garantir l'intégrité et l'équité de cette certification, votre caméra doit rester allumée pendant toute la durée de la session, qui fera l'objet d'une surveillance. Cette exigence vise à vérifier le respect de toutes les normes de certification.",
      "CERT_ACK_TEXT_2": "En poursuivant, vous reconnaissez et acceptez ces conditions.",
      "CERT_ACK_END_CALL": "Fin de l’appel",
      "LAUNCH_SIMULATION": "Lancer la simulation",
      "DEBRIEF_LATEST_SESSION": "Faire un compte rendu de la dernière session",
      "RECONNECTING_AUDIO": "Reconnexion de l'audio...",
      "END": "Fin",
      "START_DEBRIEF": "Faire un compte rendu de la dernière session",
      "MOVE_TO_NEXT": "Passer à l'étape suivante",
      "RETRY_ROLEPLAY": "Réessayer le jeu de rôle",
      "EXIT_PATHWAY": "Quitter le parcours",
      "PROCESSING": "Traitement en cours...",
      "FEEDBACK_PROMPT_REQUIRED": "Laisser quelques commentaires avant d'afficher vos résultats.",
      "MUTE": "Désactiver le son",
      "UNMUTE": "Réactiver le son",
      "SCREENSHARE_LABEL": "Partager l’écran",
      "SCREENSHARE_UNSUPPORTED_TITLE": "{{callName}} utilise le partage d'écran",
      "SCREENSHARE_UNSUPPORTED_MESSAGE_APP": "Pour poursuivre l’appel, veuillez utiliser notre application plutôt que votre navigateur.",
      "SCREENSHARE_UNSUPPORTED_MESSAGE_DESKTOP": "Pour poursuivre l’appel, accédez-y à partir d’un ordinateur de bureau.",
      "SCREENSHARE_UNSUPPORTED_CLOSE_BUTTON": "Fermer",
      "SCREENSHARE_UNSUPPORTED_GO_TO_APP_BUTTON": "Accéder à l’application",
      "SCREENSHARE_UNSUPPORTED_GO_TO_APP_UNAVAILABLE": "L'application mobile n'est pas encore disponible. Veuillez revenir bientôt.",
      "SCREENSHARE_STOP_LABEL": "Cesser de partager l'écran",
      "SCREENSHARE_PIP_REOPEN_LABEL": "Rouvrir l'aperçu vidéo",
      "SCREENSHARE_ACTIVE_LABEL": "Vous êtes actuellement en mode de partage d’écran",
      "SCREENSHARE_OS_PERMISSION_HINT": "Impossible de démarrer le partage d'écran. Activez l’enregistrement d’écran pour votre navigateur dans Paramètres du système > Confidentialité et sécurité, puis réessayez.",
      "SCREENSHARE_SAFARI_BLOCKED_HINT": "Safari a bloqué le partage d’écran pour cette session. Déconnectez-vous, puis reconnectez-vous, et réessayez."
    },
    "assignment": {
      "STATUS": "ÉTAT",
      "SCORE": "NOTE",
      "MUST_ACHIEVE": "Doit obtenir une note de",
      "OR_HIGHER": "ou plus",
      "TEST": "Test",
      "OUT_OF_5": "sur 5",
      "LATEST_ATTEMPT": "DERNIÈRE TENTATIVE",
      "TOTAL_ATTEMPTS": "Nombre total de tentatives",
      "UNLIMITED": "Illimité",
      "REMAINING": "Restant",
      "VIEW_CALL_DETAILS": "Voir les détails de l’appel",
      "MAX_ATTEMPTS_REACHED": "Vous avez atteint le nombre maximum de tentatives",
      "DUE_DATE": "Date d’échéance",
      "DAYS": "Jours",
      "DAY": "Jour",
      "UNTILL_DUE": "Délai restant",
      "PAST_DUE": "En retard",
      "ONGOING": "En cours",
      "SCORE_REQUIREMENT": "Exigence de note",
      "SCORE_REQUIREMENT_DETAIL": "Vous devez obtenir une note de",
      "TO_COMPLETE_EACH_CALL": "pour effectuer chaque simulation requise.",
      "CALLS_IN_ASSIGNMENT": "Simulations dans l'affectation",
      "INCOMPLETE_CALL": "Incomplet",
      "PREVIOUS_RESULTS": "Résultats précédents",
      "DATE": "Date",
      "RESULTS": "Résultats",
      "VIEW_PREVIOUS_RESULTS": "Voir les résultats précédents",
      "VIEW_FEEDBACK": "Voir le retour d’information",
      "LAUNCH_CALL": "Lancement",
      "CLOSE_BUTTON": "Bouton de fermeture",
      "CHECKMARK": "coche",
      "CALL": "Appeler",
      "QUESTION": "Question",
      "COMPLETED": "Terminé",
      "IN_PROGRESS": "En cours",
      "NOT_STARTED": "Pas commencé",
      "CERTIFIED": "Certifié",
      "GUIDED": "Guidé",
      "CONVERSATIONAL": "Conversationnel",
      "GUIDED_SIMULATION": "Contrôle des connaissances",
      "CONVERSATIONAL_SIMULATION": "Appels conversationnels",
      "NO_ATTEMPTS_LEFT": "Il ne reste plus de tentatives",
      "NO_ATTEMPTS": "Pas de tentatives",
      "OVERVIEW": "Vue d’ensemble",
      "ABOUT_THE_AVATAR": "À propos de l’avatar",
      "SCORING_CRITERIA": "Critères de notation",
      "SIMULATION_OVERVIEW": "Aperçu de la simulation",
      "ABOUT_THE_PERSONA": "À propos de la Persona",
      "OUTOF_COMPLIANCE": "Non conforme",
      "CLOSED": "Fermé",
      "COMPLETED_CALLS": "Appels terminés"
    }
  },
  "es": {
    "root": {
      "ADMIN_PORTAL": "PORTAL DEL ADMINISTRADOR",
      "SUPPORT": "ASISTENCIA",
      "U": "U",
      "USER": "Usuario",
      "LOGOUT": "Cierre de sesión",
      "ADMIN": "Administrador",
      "SUPPORT_SMALL": "Asistencia",
      "QUANTIFIED_AI": "Quantified.AI",
      "MICROPHONE": "MICRÓFONO",
      "CAMERA": "CÁMARA",
      "ACCESS_DENIED": "ACCESO_DENEGADO"
    },
    "teams": {
      "MY_TEAMS": "Mis equipos",
      "COMPLETED": "Completada",
      "IN_PROGRESS": "En progreso",
      "NOT_STARTED": "Sin iniciar",
      "ASSIGNMET_MODULE": "Módulo de tarea",
      "START_DATE": "Fecha de inicio",
      "DUE_DATE": "Fecha de entrega",
      "ASSIGNED_MEMBERS": "Miembros asignados",
      "CALLS_IN_MODULE": "Simulaciones en módulo",
      "COMPLETION_REQUIRMENT": "Requisito de finalización",
      "COMPLETE_ALL_CALLS": "Completa todas las simulaciones con una puntuación de",
      "OR_HIGHER": "o más",
      "PROGRESS_OVERVIEW": "RESUMEN DEL PROGRESO",
      "TEAM_MEMBERS": "miembros del equipo",
      "AVERAGE_HIGH_SCORE": "Puntuación media alta",
      "AVERAGE_NUMBER_ATTEMPTS_CALL": "Número medio de intentos por simulación",
      "TOTAL_PRACTICES": "Prácticas totales",
      "INDIVIDUAL_CALL_PROGRESS": "PROGRESO INDIVIDUAL DE LA SIMULACIÓN",
      "OF_TEAM_MEMBERS": "de los miembros del equipo completaron",
      "AVERAGE_PRACTICES_TO_COMPLETION": "Media de prácticas hasta la finalización",
      "TEAM_MEMBER_DETAILS": "DETALLES DEL MIEMBRO DEL EQUIPO",
      "DOWNLOAD_ACTIVITY_REPORT": "Descargar informe de actividad",
      "TEAM_MEMBER": "Miembro del equipo",
      "PROGRESS": "Progreso",
      "CALLS_COMPLETED": "Simulaciones realizadas",
      "PRACTICES": "Sesiones de práctica",
      "MOST_RECENT_PRACTICE": "Sesión más reciente",
      "THIS_TEAM_HAS_NO_ACTIVE_ASSIGNMENTS": "Este equipo no tiene tareas activas en este momento",
      "CALL_NAME_LABEL": "Nombre de la simulación",
      "HIGHEST_SCORE": "Puntuación más alta"
    },
    "simulationBuilder": {
      "THRESHOLD": "Umbral",
      "TYPE": "Tipo",
      "SELECT_AN_OPTION": "Selecciona una opción",
      "CORRECT_FEEDBACK": "Comentarios constructivos",
      "INCORRECT_FEEDBACK": "Comentarios incorrectos",
      "CORRECT_FEEDBACK_PLACEHOLDER": "Se muestra cuando el alumno acierta",
      "INCORRECT_FEEDBACK_PLACEHOLDER": "Se muestra cuando el alumno responde incorrectamente",
      "ENTER_MESSAGE_TEXT": "Escribe el texto del mensaje...",
      "DELETE": "Eliminar",
      "SCORABLE": "Anotable",
      "MESSAGE_NUMBER": "Mensaje {{ index }}",
      "SEARCH_BY_SIMULATION_NAME": "Buscar por nombre de simulación",
      "SEARCH_BY_ASSIGNMENT_NAME": "Buscar por nombre de tarea",
      "SIMULATION_STATUS_PLACEHOLDER": "Estado de la simulación",
      "SIMULATION_STATUS_PREFIX": "Estado de la simulación:",
      "NO_SIMULATIONS_FOUND": "No se han encontrado simulaciones",
      "SELECT_ALL": "Seleccionar todo",
      "DESELECT_ALL": "Deseleccionar todo",
      "STATUS_TESTING": "Probando",
      "STATUS_DRAFT": "Borrador",
      "STATUS_PUBLISHED": "Publicado",
      "STATUS_ARCHIVED": "Archivado",
      "ASSIGNEES_ZERO_STATE_MESSAGE": "Aún no se han asignado usuarios",
      "ADD_USERS_TO_ASSIGNMENT": "Añadir usuarios a la tarea",
      "NO_DATA_FOUND": "No se han encontrado datos",
      "NO_USERS_SELECTED": "Ningún usuario seleccionado",
      "COL_FIRST_NAME": "Nombre",
      "COL_LAST_NAME": "Apellido",
      "COL_EMAIL": "Correo electrónico",
      "COL_VIEW_USER": "Ver usuario",
      "COL_VIEW_ASSIGNMENT": "Ver tarea",
      "COL_ASSIGNMENT_NAME": "Nombre de la tarea",
      "COL_STATUS": "Estado",
      "COL_TEAM_ASSOCIATIONS": "Asociaciones de equipos",
      "COL_REPORTING_STATUS": "Estado del informe",
      "BREADCRUMB_USERS": "Usuarios",
      "STATUS_STAGED": "Escenificado",
      "STATUS_ACTIVE": "Activo",
      "STATUS_ENDED": "Terminado",
      "STATUS_CLOSED": "Cerrado",
      "SEARCH_USERS_PLACEHOLDER": "Buscar usuarios",
      "NO_USERS_FOUND": "No se han encontrado usuarios",
      "USERS_TAB_LABEL": "Usuarios",
      "ADD_TO_ASSIGNMENT": "Añadir a la tarea",
      "ASSIGNMENTS_COUNT": "tareas",
      "REPORTING_EXCLUDED": "Excluido",
      "REPORTING_INCLUDED": "Incluido",
      "KEBAB_EDIT_TEAM_ASSOCIATIONS": "Editar asociaciones de equipo",
      "KEBAB_EXCLUDE_FROM_REPORTING": "Excluir de los informes",
      "KEBAB_INCLUDE_IN_REPORTING": "Incluir en los informes",
      "KEBAB_REMOVE_FROM_ASSIGNMENT": "Eliminar de la tarea",
      "NO_TEAMS": "—",
      "TEAMS_COUNT": "{{count}} equipos",
      "ADD_TO_ASSIGNMENT_MODAL_HEADING": "Añadir a la tarea",
      "FIELD_LABEL_ASSIGNMENT": "Tarea",
      "SEARCH_ASSIGNMENTS_PLACEHOLDER": "Buscar tareas",
      "BUTTON_SET_TEAM_ASSOCIATION": "Establecer asociación de equipo",
      "FIELD_LABEL_TEAM": "Equipo",
      "SEARCH_TEAM_PLACEHOLDER": "Buscar equipo",
      "BUTTON_BACK": "Atrás",
      "BUTTON_CANCEL": "Cancelar",
      "BUTTON_ADD_TO_ASSIGNMENT": "Añadir a la tarea",
      "EDIT_TEAM_ASSOCIATIONS_HEADING": "Editar asociaciones de equipo",
      "EDIT_TEAM_ASSOCIATIONS_DESCRIPTION": "Para la tarea {{assignmentName}}",
      "BUTTON_SAVE_ASSOCIATIONS": "Guardar asociaciones",
      "REFERENCE_DOCUMENT_STATUS_UPLOADING": "– Cargando...",
      "REFERENCE_DOCUMENT_STATUS_SUCCESS": "– 100 % cargado",
      "REFERENCE_DOCUMENT_STATUS_ERROR": "– Error al cargar el archivo",
      "CREATE_SIMULATION_DETAILS_BUTTON": "Crear detalles de la simulación",
      "SELF_AUTHORING_DESCRIPTION": "Introduce un nombre, una breve descripción del escenario y cualquier documento específico de la simulación para empezar",
      "CLICK_TO_UPLOAD": "Haz clic para cargar el archivo",
      "OR_DRAG_AND_DROP": "o arrastra y suelta",
      "REFERENCE_DOCUMENTS_UPLOAD_DESCRIPTION": "PDF (máx. 50 MB)",
      "ASSIGNMENT_NAME_LABEL": "Nombre de la tarea *",
      "SIMULATION_NAME_LABEL": "Nombre de la simulación",
      "NAME_FIELD_DESCRIPTION": "Este nombre se puede cambiar más adelante",
      "PRODUCT_LABEL": "Producto",
      "SELECT_A_PRODUCT_PLACEHOLDER": "Selecciona un producto",
      "ADD_NEW_PRODUCT": "Añadir un nuevo producto",
      "SCENARIO_LABEL": "Escenario",
      "REFERENCE_DOCUMENTS_LABEL": "Documentos de referencia",
      "ACTION_CREATE_NEW": "Crear nuevo",
      "ACTION_CREATE": "Crear",
      "ACTION_DUPLICATE": "Duplicar",
      "ENTITY_TYPE_SIMULATION_DISPLAY": "Simulación",
      "ENTITY_TYPE_ASSIGNMENT_DISPLAY": "Tarea",
      "ENTITY_TYPE_SIMULATION_LOWER": "simulación",
      "ENTITY_TYPE_ASSIGNMENT_LOWER": "tarea",
      "MODAL_TITLE": "{{ action }} {{ type }}",
      "CONFIRM_BUTTON_LABEL": "{{ action }} {{ type }}",
      "DUPLICATE_NAME_ERROR_ASSIGNMENT": "Ya existe una tarea con el mismo nombre.",
      "DUPLICATE_NAME_ERROR_SIMULATION": "Ya existe una simulación con el mismo nombre.",
      "NAME_REQUIRED_ERROR": "Es obligatorio introducir un nombre.",
      "COPY_OF_PREFIX": "Copia de {{ name }}",
      "SCORE_DISTRIBUTION_TITLE": "Distribución actual de puntuaciones",
      "EDIT_SECTIONS_AND_WEIGHTING": "Editar secciones y ponderación",
      "SCORING_WEIGHTS_TITLE": "Configurar la puntuación",
      "SCORING_WEIGHTS_DESCRIPTION": "Elige qué áreas se van a puntuar y en qué medida contribuye cada una a la nota global. La suma de las ponderaciones de todas las secciones activadas debe ser del 100 %. La sección de habilidades no puede tener una ponderación superior al 20 %.",
      "SCORING_WEIGHT_REQUIRED": "Obligatorio",
      "REFERENCE_DOCUMENT_STATUS_DELETING": "– Eliminando",
      "REFERENCE_DOCUMENT_DELETE_ERROR": "No se ha podido eliminar el documento. Inténtalo de nuevo.",
      "REFERENCE_DOCUMENT_UPLOAD_ERROR": "No se ha podido cargar el documento. Inténtalo de nuevo.",
      "CONTENT_LIMIT_EXCEEDED_ERROR": "Se ha superado el límite de contenido. Elimina uno o más documentos para continuar.",
      "LAST_FACT_DELETE_WARNING_HEADING": "¿Deseas eliminar el último dato?",
      "LAST_FACT_DELETE_WARNING_DESCRIPTION": "Si eliminas el último dato, se borrarán todas las asociaciones de usuarios con esta simulación y su estado volverá a ser «Borrador».",
      "LEAVE_CONFIRMATION_HEADING": "Salir de la creación de la simulación",
      "LEAVE_CONFIRMATION_DESCRIPTION": "¿Seguro que quieres salir? Se perderá todo el progreso que hayas realizado.",
      "LEAVE_CONFIRMATION_LEAVE_BUTTON": "Salir",
      "METHODOLOGY_TITLE": "Metodología",
      "METHODOLOGY_SUBTITLE": "Valora el enfoque y la estructura de la llamada",
      "METHODOLOGY_WEIGHTING_LABEL": "Ponderación: {{ weight }} %",
      "METHODOLOGY_RUBRIC_LABEL": "Rúbrica de metodología",
      "SELECT_RUBRIC_PLACEHOLDER": "Seleccionar rúbrica",
      "SKILLS_TITLE": "Habilidades",
      "SKILLS_SUBTITLE": "Valora la comunicación y las habilidades interpersonales",
      "SKILLS_WEIGHTING_LABEL": "Ponderación: {{ weight }} %",
      "SKILLS_RUBRIC_LABEL": "Rúbrica de habilidades",
      "PROCESSING_DOCUMENTS_MESSAGE": "Procesando documentos...",
      "PROCESSING_DOCUMENTS_SUPPORTING_TEXT": "Si quieres, puedes irte un rato; tendremos los resultados listos en 5 minutos.",
      "CORE_SIGNAL_MESSAGE": "Interpretando tu contenido...",
      "SECTION_PLAN_MESSAGE": "Planificando la estructura de tu simulación...",
      "DERIVED_COMPONENT_MESSAGE": "Creando los componentes de tu simulación...",
      "COMPONENT_WAVE_1_MESSAGE": "Redactando el contenido de tu simulación...",
      "STILL_PROCESSING_TITLE": "Todavía se está procesando...",
      "STILL_PROCESSING_BODY": "El proceso está tardando más de lo habitual; puedes salir de esta simulación y volver a ella más tarde desde la vista de lista de simulaciones.",
      "PROCESSING_FAILED_TITLE": "Error en el procesamiento",
      "PROCESSING_FAILED_BODY": "Ha ocurrido un error al procesar tus documentos; vuelve a intentarlo. Comunícate con ",
      "TEST_SIMULATION_BUTTON": "Probar simulación",
      "SIMULATION_PROCESSED_TITLE": "Documentos procesados",
      "SIMULATION_PROCESSED_BODY": "Se han procesado los documentos de tu simulación.",
      "SIMULATION_DOCUMENTS_PROCESSED_TITLE": "Documentos de la simulación procesados.",
      "SIMULATION_DOCUMENTS_PROCESSED_BODY": "Se han procesado los documentos que has subido para la simulación {{ name }}.",
      "SIMULATION_DOCUMENTS_FAILED_TITLE": "No se han podido procesar los documentos de la simulación.",
      "SIMULATION_DOCUMENTS_FAILED_BODY": "Los documentos que has subido para la simulación {{ name }} no se han procesado.",
      "DISMISS": "Descartar",
      "VIEW_SIMULATION": "Ver simulación",
      "FACT_MESSAGE_LABEL": "Mensaje",
      "FACT_MESSAGE_DESCRIPTION": "Los mensajes deben contener un solo dato, redactado en una frase completa. Deben ser específicos, sencillos y de ámbito limitado; evita los mensajes que puedan expresarse de forma parcial.",
      "FACT_INCORRECT_ANSWER_LABEL": "Texto de respuesta incorrecta",
      "FACT_INCORRECT_ANSWER_DESCRIPTION": "Texto que se muestra al alumno si responde incorrectamente a esta pregunta",
      "SHOW_INCORRECT_ANSWER_TEXT": "Mostrar texto alternativo para las respuestas incorrectas",
      "ADD_NEW_FACT": "Añadir nuevo dato",
      "FACT_SINGULAR": "dato",
      "FACT_PLURAL": "datos",
      "FACT_EXTRACTED_SINGULAR": "{{ count }} dato extraído",
      "FACT_EXTRACTED_PLURAL": "{{ count }} datos extraídos",
      "REVIEW_REQUIRED_LABEL": "Revisión sugerida",
      "MESSAGING_TITLE": "Adherencia al mensaje",
      "MESSAGING_SUBTITLE": "Valora si se han comunicado los datos clave",
      "COMPONENT_WAVE_2_MESSAGE": "Refinando el contenido de tu simulación...",
      "COMPONENT_WAVE_3_MESSAGE": "Finalizando el contenido de tu simulación...",
      "MESSAGE_ADHERENCE_MESSAGE": "Sugiriendo criterios de puntuación para la adherencia al mensaje...",
      "ASSEMBLING_MESSAGE": "Montando tu simulación...",
      "PROCESSING_FAILED_SUFFIX": " si el problema persiste.",
      "BUTTON_RETRY": "Intentar de nuevo",
      "TOKEN_LIMIT_EXCEEDED_BODY_PREFIX": "Se ha superado el límite de contenido. Elimina uno o más documentos e inténtalo de nuevo, o ponte en contacto con ",
      "TOKEN_LIMIT_EXCEEDED_BODY_SUFFIX": " si el problema persiste.",
      "AVATAR_LOOK_LABEL": "Apariencia",
      "AVATAR_SELECT_PLACEHOLDER": "Seleccionar avatar",
      "AVATAR_VOICE_LABEL": "Voz",
      "AVATAR_ALT": "Avatar",
      "PLAY_VOICE_PREVIEW_BUTTON": "Reproducir vista previa de voz",
      "VOICE_OPTION_1": "Voz 1",
      "VOICE_OPTION_2": "Voz 2",
      "BACK_TO_SIMULATION_DETAILS_BUTTON": "Volver a los detalles de la simulación",
      "AVATAR_SELECTION_TITLE": "Selección de avatar",
      "VIEW_DOCUMENTS": "Ver documentos",
      "SELECT_AVATAR_BUTTON": "Seleccionar avatar",
      "REQUEST_CHANGES_PLACEHOLDER": "Solicita cualquier cambio en la información anterior",
      "CALL_DETAILS_LOAD_ERROR": "No hemos podido cargar los detalles de tu llamada. Inténtalo de nuevo.",
      "FACTS_CANNOT_BE_EMPTY": "Los datos no pueden estar vacíos. Añade un mensaje a cada dato antes de probarlo o publicarlo.",
      "FINISHING_SIMULATION_MESSAGE": "Terminando tu simulación...",
      "BLANK_THEME_MESSAGE_TOOLTIP": "Añade texto al mensaje vacío antes de añadir un nuevo tema.",
      "BLANK_MESSAGE_TOOLTIP": "Añade texto a este mensaje antes de añadir otro.",
      "ADD_NEW_THEME_BUTTON": "Añadir nuevo tema",
      "ADD_THEME_BUTTON": "Añadir tema",
      "ADD_MESSAGE_BUTTON": "Añadir mensaje",
      "SCORE_LAST_SESSION": "Puntuar mi última sesión",
      "SCORE_LAST_SESSION_MODAL_HEADING": "Puntuar última sesión",
      "SCORE_LAST_SESSION_MODAL_DESCRIPTION": "Prueba primero la simulación y luego vuelve aquí para puntuarla según la rúbrica seleccionada.",
      "SCORE_LAST_SESSION_MODAL_ERROR_HEADING": "Ha ocurrido un error",
      "SCORE_LAST_SESSION_MODAL_ERROR_DESCRIPTION": "Inténtalo de nuevo.",
      "REFINEMENT_THINKING_MESSAGE": "Reflexionando...",
      "REFINEMENT_UPDATED_MESSAGE": "Actualizado",
      "REFINEMENT_WARNING_PREFIX": "Esta información se había modificado manualmente; ponte en contacto con",
      "REFINEMENT_WARNING_SUFFIX": "para cualquier actualización.",
      "REFINEMENT_ERROR_PREFIX": "Lamentablemente, no puedo ayudarte con eso, pero",
      "REFINEMENT_ERROR_SUFFIX": "quizá sí pueda.",
      "REFINEMENT_APPLIED_TITLE": "Se han aplicado los cambios solicitados.",
      "REFINEMENT_APPLIED_BODY": "Se han aplicado los cambios que solicitaste para la simulación {{ name }}.",
      "REFINEMENT_FAILED_TITLE": "Los cambios solicitados no se han podido aplicar.",
      "REFINEMENT_FAILED_BODY": "No hemos podido aplicar los cambios que has solicitado para la simulación {{ name }}.",
      "WHAT_USERS_SEE_DESCRIPTION_TITLE": "Descripción de la simulación",
      "WHAT_USERS_SEE_DESCRIPTION_HELPER": "La información actualizada en la pestaña «General» se reflejará aquí, a menos que se realicen cambios manuales.",
      "WHAT_USERS_SEE_DESCRIPTION_FIELD_LABEL": "Descripción",
      "WHAT_USERS_SEE_DETAILS_TITLE": "Detalles de la simulación",
      "WHAT_USERS_SEE_DETAILS_HELPER": "Este es el contenido que se le mostrará al usuario antes de que empiece la simulación. La información actualizada en la pestaña «General» se reflejará aquí, a menos que se realicen cambios manuales. Las secciones que se dejen en blanco no se mostrarán al alumno. Todas las secciones admiten el formato Markdown.",
      "WHAT_USERS_SEE_OVERVIEW_FIELD_LABEL": "Resumen de la simulación",
      "WHAT_USERS_SEE_PERSONA_FIELD_LABEL": "Sobre la persona",
      "WHAT_USERS_SEE_SCORING_FIELD_LABEL": "Criterios de puntuación",
      "WHAT_USERS_SEE_SCORING_FIELD_HELPER": "Esta sección se rellena con las selecciones realizadas en la pestaña «Puntuación». Editar la información aquí no modificará la forma en que se puntúa la simulación.",
      "WHAT_USERS_SEE_PREVIEW_DETAILS_CTA": "Vista previa modal de los detalles de la simulación",
      "WHAT_USERS_SEE_PREVIEW_CARD_CTA": "Tarjeta de vista previa de la simulación",
      "TAB_GENERAL": "General",
      "TAB_CONTENTS": "Contenidos",
      "TAB_KEY_WORDS": "Palabras clave",
      "TAB_SCORING": "Puntuación",
      "TAB_TESTING": "Probando",
      "TAB_PROMPTS": "Indicaciones",
      "TAB_WHAT_USERS_SEE": "Lo que ven los usuarios",
      "ACCURACY_FEEDBACK_TITLE": "Comentarios sobre la precisión",
      "ACCURACY_FEEDBACK_DESCRIPTION": "Evalúa la precisión de cada afirmación que haga un agente comparándola con los documentos subidos",
      "ACCURACY_FEEDBACK_STATUS_ON": "Habilitado",
      "ACCURACY_FEEDBACK_STATUS_OFF": "Desactivado",
      "ACCURACY_FEEDBACK_STATUS_DISABLED": "Deshabilitado",
      "ACCURACY_FEEDBACK_NO_DOCUMENTS": "La puntuación de precisión no está disponible porque no se han añadido documentos relacionados.",
      "SCORING_AI_REVIEW_NOTICE": "Parte del contenido de esta pestaña se ha generado a partir de los materiales que has proporcionado. Revisa todo el contenido para comprobar su precisión antes de publicar esta llamada.",
      "EXPORT_SIMULATION_SUMMARY_BUTTON": "Exportar resumen de la simulación",
      "CALL": "Llamada",
      "REFINEMENT_OVERRIDDEN_PREFIX": "Esta información se había modificado manualmente; ponte en contacto con",
      "REFINEMENT_OVERRIDDEN_SUFFIX": "para cualquier actualización.",
      "SUPPORT_EMAIL": "help@quantified.ai",
      "WHAT_USERS_SEE_OVERRIDE_WARNING_TITLE": "Si editas estos campos, se bloquearán las futuras actualizaciones",
      "WHAT_USERS_SEE_OVERRIDE_WARNING_BODY": "Si actualizas manualmente estas secciones, dejarán de recibir cualquier actualización adicional del proceso de perfeccionamiento de la pestaña «General».",
      "WHAT_USERS_SEE_DETAILS_OVERRIDE_EDITED_TITLE": "Estos campos se han editado",
      "WHAT_USERS_SEE_DETAILS_OVERRIDE_EDITED_BODY": "Ya no recibirán las actualizaciones de perfeccionamiento realizadas en la pestaña «General»",
      "SIMULATION_BUILDER_HEADING": "Creador de simulaciones",
      "ASSIGNMENTS_TAB_LABEL": "Tareas",
      "SIMULATIONS_TAB_LABEL": "Simulaciones",
      "CREATE_NEW_ASSIGNMENT_BUTTON": "Crear nueva tarea",
      "CREATE_NEW_SIMULATION_BUTTON": "Crear nueva simulación",
      "NO_ASSIGNMENTS_FOUND": "No se encontraron tareas",
      "ASSIGNMENT_STATUS_PLACEHOLDER": "Estado de la tarea",
      "ASSIGNMENT_STATUS_PREFIX": "Estado de la tarea:",
      "ASSIGNMENT_TYPE_LABEL": "Tipo de tarea",
      "SELECT_ASSIGNMENT_TYPE_PLACEHOLDER": "Selecciona el tipo de tarea",
      "NAME_LABEL": "Nombre",
      "ASSIGNMENT_NAME_PLACEHOLDER": "Nombre de la tarea",
      "PASSING_SCORE_LABEL": "Calificación mínima para aprobar",
      "PASSING_SCORE_OPTIONAL_LABEL": "Calificación mínima para aprobar (opcional)",
      "SCORE_MAX_EXCEEDED_ERROR": "La puntuación no debe superar el 5",
      "GET_HELP_BUTTON": "Obtener ayuda",
      "PASSING_SCORE_TOOLTIP": "Esto establece la puntuación global que debe alcanzar un estudiante para aprobar la simulación.",
      "DESCRIPTION_LABEL": "Descripción",
      "ASSIGNMENT_DESCRIPTION_PLACEHOLDER": "Descripción de la tarea",
      "MESSAGING_FEEDBACK_LABEL": "Comentarios sobre la adherencia al mensaje",
      "MESSAGING_FEEDBACK_TOOLTIP_HEADING": "Comentarios sobre la adherencia al mensaje",
      "MESSAGING_FEEDBACK_TOOLTIP_BODY": "Cuando un estudiante articula un mensaje incorrectamente, se le muestra información sobre cómo expresarlo mejor la próxima vez. Esta configuración permite activar o desactivar la visualización de esa información.",
      "ENABLED_TEXT": "Habilitado",
      "DISABLED_TEXT": "Deshabilitado",
      "PAUSE_BUTTON_LABEL": "Botón de pausa",
      "ASSIGNMENT_START_DATE_LABEL": "Fecha de inicio de la tarea",
      "SELECT_DATE_PLACEHOLDER": "Seleccionar fecha",
      "ASSIGNMENT_END_DATE_LABEL": "Fecha de finalización de la tarea",
      "ASSIGNMENT_END_DATE_OPTIONAL_LABEL": "Fecha de finalización de la tarea (opcional)",
      "END_DATE_RANGE_ERROR": "La fecha de inicio y la de finalización no pueden ser la misma",
      "ASSIGNMENT_INFORMATION_TITLE": "Información de la tarea",
      "ASSIGNMENT_TYPE_CERTIFICATION": "Certificación",
      "ASSIGNMENT_TYPE_PRACTICE": "Práctica",
      "ASSIGNMENT_TYPE_PERSONALIZED_PRACTICE": "Práctica personalizada",
      "BUTTON_SAVE_AND_CLOSE": "Guardar y cerrar",
      "BUTTON_ADD_SIMULATIONS": "Añadir simulaciones",
      "ATTEMPTS_UNLIMITED": "Ilimitado",
      "SEARCH_FOR_SIMULATION_LABEL": "Buscar simulación",
      "SIMULATION_NAME_PLACEHOLDER": "Nombre de la simulación",
      "BUTTON_REMOVE_ALL": "Eliminar todo",
      "SIMULATIONS_IN_ASSIGNMENT_LABEL": "Simulaciones de la tarea",
      "BUTTON_ASSIGN_LEARNERS": "Asignar estudiantes",
      "CALL_TYPE_UNKNOWN": "Desconocido",
      "ASSIGNMENT_COUNT_NONE": "Ninguno",
      "ASSIGNMENT_COUNT_SINGULAR": "{{ count }} tarea",
      "ASSIGNMENT_COUNT_PLURAL": "{{ count }} tareas",
      "ERROR_LOADING_ASSIGNMENTS": "Error al cargar las tareas",
      "SEARCH_ASSIGNEES_TITLE": "Buscar asignados",
      "DIALOG_DESCRIPTION_ADD_USERS": "Selecciona a los usuarios que participarán en la tarea. Si buscas un equipo, podrás asignar o desasignar a usuarios específicos de ese equipo. Cuando selecciones a un usuario concreto, asegúrate de que esté asociado al equipo correcto para la elaboración de informes.",
      "ADD_USERS_TO_ASSIGNMENT_HEADING": "Añadir usuarios a la tarea",
      "BUTTON_REVIEW_SELECTED_USERS": "Revisa los usuarios seleccionados",
      "FIND_USERS_LABEL": "Buscar usuarios",
      "BUTTON_CLEAR": "Eliminar",
      "LEARNER_COUNT_NONE": "Ninguno",
      "LEARNER_COUNT_SINGULAR": "{{ count }} estudiante",
      "LEARNER_COUNT_PLURAL": "{{ count }} estudiantes",
      "ASSIGNMENT_TAB_DETAILS": "Detalles",
      "ASSIGNMENT_TAB_SIMULATIONS": "Simulaciones",
      "ASSIGNMENT_TAB_ASSIGNEES": "Asignados",
      "LOADING_ASSIGNMENT_DETAILS": "Cargando detalles de la tarea...",
      "BREADCRUMB_ASSIGNMENTS": "Tareas",
      "ASSIGNMENTS_COL_NAME": "Nombre",
      "ASSIGNMENTS_COL_START_DATE": "Fecha de inicio de la tarea",
      "ASSIGNMENTS_COL_END_DATE": "Fecha de finalización de la tarea",
      "ASSIGNMENTS_COL_LEARNERS": "Estudiante asignado",
      "ASSIGNMENTS_COL_TYPE": "Tipo de tarea",
      "ASSIGNMENTS_COL_STATUS": "Estado de la tarea",
      "SIMULATIONS_COL_NAME": "Nombre",
      "SIMULATIONS_COL_PRODUCT": "Producto",
      "SIMULATIONS_COL_DATE_MODIFIED": "Fecha de la última modificación",
      "SIMULATIONS_COL_STATUS": "Estado",
      "SIMULATIONS_COL_USED_IN": "Utilizado en",
      "SIMULATIONS_COL_TYPE": "Tipo de simulación",
      "SIMULATIONS_COL_DATE_PUBLISHED": "Fecha de publicación",
      "CONVERSE_PROMPT_LABEL": "Indicación de conversación",
      "CONVERSE_PROMPT_EXPAND_TO_EDIT": "Expandir para editar",
      "CONVERSE_PROMPT_ENTER_LABEL": "Escribe aquí la indicación de conversación *",
      "CONVERSE_PROMPT_EDITING_HEADING": "Editando la indicación de conversación",
      "CONVERSE_PROMPT_OVERRIDE_CONFIRMATION_HEADING": "Confirmación de anulación de la indicación",
      "CONVERSE_PROMPT_OVERRIDE_DESCRIPTION": "¿Seguro que quieres anular la indicación de conversación? Los autores perderán el acceso al perfeccionamiento autónomo si se anula.",
      "CONVERSE_PROMPT_FIELD_LABEL": "Indicación de conversación",
      "CONVERSE_PROMPT_SAVE_BUTTON": "Guardar indicación",
      "BUTTON_CONFIRM": "Confirmar",
      "DELETE_SIM_HEADING": "Eliminar simulación",
      "DELETE_SIM_CONTENT": "Esta simulación se eliminará. También se eliminarán todas las tareas de prueba asociadas a la simulación.",
      "DELETE_SIM_LABEL": "Eliminar simulación",
      "DELETE_ASSIGNMENT_HEADING": "Eliminar tarea",
      "DELETE_ASSIGNMENT_CONTENT": "Esta tarea se eliminará de forma permanente.",
      "DELETE_ASSIGNMENT_LABEL": "Eliminar tarea",
      "DELETE_ASSIGNMENT_NON_STAGED_CONTENT": "Para eliminar una tarea con el estado «Activo» o «Terminado», ponte en contacto con el equipo de CX. Gracias.",
      "REMOVE_FROM_ASSIGNMENT_HEADING": "Eliminar de la tarea",
      "REMOVE_FROM_ASSIGNMENT_CONTENT": "Esto eliminará al usuario de la tarea y de todos los enlaces de equipo asociados.",
      "REMOVE_FROM_ASSIGNMENT_LABEL": "Eliminar de la tarea",
      "PUBLISH_SIMULATION_HEADING": "Publicar simulación",
      "PUBLISH_CONTINUE_EDITING": "Seguir editando",
      "PUBLISH_BUTTON": "Publicar",
      "PUBLISH_SIMULATION_DESCRIPTION": "El juego de rol se podrá añadir a las tareas, pero ya no se podrá editar la información de la persona, la puntuación ni la indicación.",
      "CONFIRMATION_SELECTED_USERS_HEADING": "Usuarios seleccionados",
      "CONFIRMATION_TOTAL_COUNT": "{{ count }} en total",
      "CONFIRMATION_CREATE_HEADING": "Crear nueva tarea",
      "CONFIRMATION_ADD_USERS_HEADING": "Añadir usuarios a la tarea",
      "CONFIRMATION_SAVE_ASSIGNMENT_BTN": "Guardar tarea",
      "CONFIRMATION_REMOVE_USER": "Eliminar",
      "EDIT_WEIGHTING_HEADING": "Editar ponderación de puntuación",
      "EDIT_WEIGHTING_DESCRIPTION": "La puntuación global se generará a partir de la media ponderada de las siguientes secciones. La suma de las ponderaciones de todas las secciones activadas debe ser del 100 %. La sección de habilidades no puede tener una ponderación superior al 20 %.",
      "EDIT_WEIGHTING_ERROR_ALL_DISABLED": "Debe activarse al menos una acción de puntuación",
      "EDIT_WEIGHTING_ERROR_WEIGHT_RANGE": "La ponderación de la sección debe estar entre 0 y 100",
      "EDIT_WEIGHTING_ERROR_SKILLS_MAX": "La sección de habilidades no puede tener una ponderación superior al 20 %.",
      "EDIT_WEIGHTING_ERROR_TOTAL": "La ponderación total de las secciones debe ser del 100 %",
      "PERSONA_INFORMATION_TITLE": "Información de la persona",
      "PERSONA_AVATAR_LABEL": "Avatar *",
      "PERSONA_NAME_LABEL": "Nombre *",
      "PERSONA_INITIAL_GREETINGS_LABEL": "Saludos iniciales *",
      "PERSONA_INITIAL_GREETINGS_DESCRIPTION": "La persona comenzará la simulación con uno de estos saludos. Puedes tener un máximo de 5 opciones.",
      "PERSONA_ADD_GREETING_OPTION": "Añadir opción de saludo",
      "PERSONA_RESUME_MESSAGE_LABEL": "Mensaje de reanudación",
      "PERSONA_RESUME_MESSAGE_DESCRIPTION": "Cuando un estudiante reanude una simulación tras una pausa, la persona empezará con uno de estos saludos. Puedes tener un máximo de 5 opciones.",
      "PERSONA_ADD_MESSAGE_OPTION": "Añadir opción de mensaje",
      "PERSONA_UPLOADING": "Cargando...",
      "PERSONA_DELETING": "Eliminando...",
      "PERSONA_CUSTOM_BG_PREVIEW_ALT": "Vista previa del fondo personalizado",
      "PERSONA_AVATAR_THUMBNAIL_ALT": "Miniatura del avatar",
      "PERSONA_AVATAR_WITH_BG_ALT": "Avatar con fondo personalizado",
      "PERSONA_PROCESSING_IMAGE": "Procesando imagen...",
      "PERSONA_CUSTOM_BACKGROUND_LABEL": "Fondo personalizado",
      "PERSONA_REMOVE_BACKGROUND": "Eliminar fondo",
      "PERSONA_CLICK_TO_REPLACE": "Haz clic para sustituir",
      "PERSONA_UPLOAD_DESCRIPTION": "PNG o JPG, preferiblemente con relación de aspecto 16:9, máx. 2 MB",
      "SIM_INFORMATION_TITLE": "Información de la simulación",
      "SIM_NAME_FIELD_LABEL": "Nombre *",
      "SIM_LANGUAGE_FIELD_LABEL": "Idioma",
      "SIM_DETAILS_SECTION_TITLE": "Detalles de la simulación",
      "SIM_ADDITIONAL_SECTION_TITLE_LABEL": "Título de la sección adicional",
      "SIM_ADDITIONAL_SECTION_INFO_LABEL": "Información de la sección adicional",
      "TESTING_SECTION_TITLE": "Evaluadores",
      "TESTING_SEND_ASSIGNMENTS_BTN": "Enviar tareas de prueba",
      "TESTING_MESSAGING_TOOLTIP": "Añade al menos un dato a «Adherencia al mensaje» antes de hacer la prueba o publicarla.",
      "TESTING_DESCRIPTION": "Busca a los usuarios que van a probar la simulación y envíales la tarea de prueba.",
      "TESTING_COL_NUMBER_OF_ATTEMPTS": "Número de intentos",
      "TESTING_COL_DATE_OF_LAST_ATTEMPT": "Fecha del último intento",
      "TESTING_CLEAR_USERS": "Borrar usuarios",
      "TESTING_REMOVE_ASSIGNEE": "Eliminar asignado",
      "OVERALL_SECTION_TITLE": "Secciones, ponderaciones e indicaciones",
      "OVERALL_HEADING": "General",
      "TRANSCRIPT_PROMPT_TITLE": "Indicación de transcripción",
      "TRANSCRIPT_PROMPT_FIELD_LABEL": "Introduce aquí la indicación de transcripción limpia",
      "SIMULATION_PROMPTS_TITLE": "Indicaciones de la simulación",
      "TAGS_LABEL": "Etiquetas",
      "CREATE_TAG_OPTION": "Crear {{term}}",
      "TAG_CREATE_ERROR": "No se ha podido crear la etiqueta; inténtalo de nuevo",
      "EDIT_SIMULATION_TAGS_TITLE": "Editar etiquetas de la simulación",
      "SAVE_TAGS_BUTTON": "Guardar etiquetas",
      "CLOSE_BUTTON": "Cerrar",
      "TAG_UPDATE_ERROR": "No se ha podido actualizar la etiqueta; inténtalo de nuevo",
      "SCREEN_SHARE_TITLE": "Compartir pantalla",
      "SCREEN_SHARE_DESCRIPTION": "Permite al usuario compartir su pantalla con el avatar durante la llamada, para que este pueda ver y responder a lo que se muestra",
      "SCREEN_SHARE_STATUS_ON": "Habilitado",
      "SCREEN_SHARE_STATUS_OFF": "Deshabilitado",
      "SCREEN_SHARE_NO_PERSONA": "Añade primero una persona para habilitar la función de compartir pantalla.",
      "HIDE_RESULTS_LABEL": "Ocultar resultados",
      "SEARCH_FIELD_HINT": "Escribe al menos tres caracteres para empezar a buscar",
      "OTHERS_SINGULAR": "y 1 más",
      "OTHERS_PLURAL": "y {{ count }} más",
      "PAGINATION_PREVIOUS": "Anterior",
      "PAGINATION_NEXT": "Siguiente",
      "SKILLS_RUBRIC_REQUIRED_TOOLTIP": "Adjunta una rúbrica de habilidades. Las habilidades están activadas con una ponderación superior al 0 %.",
      "ENTITY_TYPE_KNOWLEDGE_CHECK_DISPLAY": "prueba de conocimientos",
      "NAME_MAX_LENGTH_ERROR": "El nombre debe tener 255 caracteres o menos.",
      "UUID_COPIED_TOAST": "Se ha copiado el UUID de la llamada al portapapeles",
      "MENU_ARCHIVE": "Archivar",
      "MENU_EDIT_SIMULATION_TAGS": "Editar etiquetas de la simulación",
      "MENU_COPY_UUID": "Copiar UUID",
      "REFINEMENT_IN_PROGRESS_TOOLTIP": "Refinamiento en curso. Podrás continuar una vez que haya terminado.",
      "SIMULATION_DOCUMENTS_PARSE_FAILED_BODY": "No se ha podido leer uno de tus documentos para {{ name }}: compruébalo o cámbialo y vuelve a intentarlo.",
      "REFINEMENT_ERROR_MESSAGE": "Lo sentimos, no se ha podido completar esta solicitud. Inténtalo de nuevo",
      "REFINEMENT_OUT_OF_SCOPE_TITLE": "Solicitud fuera del ámbito de aplicación.",
      "REFINEMENT_OUT_OF_SCOPE_BODY": "Tu solicitud para {{ name }} está fuera de lo que puede hacer el refinamiento. Ponte en contacto con el servicio de asistencia.",
      "TAB_QUESTIONS": "Preguntas",
      "KNOWLEDGE_CHECK_NAME_LABEL": "Nombre*",
      "AVATAR_APPEARANCE_LABEL": "Apariencia del avatar",
      "KNOWLEDGE_CHECK_AVATAR_NAME_LABEL": "Nombre del avatar",
      "KNOWLEDGE_CHECK_SKILLS_FEEDBACK_TITLE": "Comentarios sobre las habilidades",
      "KNOWLEDGE_CHECK_SCORING_DESCRIPTION": "Las simulaciones de la prueba de conocimientos se puntúan según el porcentaje de puntos de respuesta cubiertos en cada pregunta. Selecciona una rúbrica de habilidades a continuación para recibir también comentarios cualitativos.",
      "KNOWLEDGE_CHECK_SCORING_RESCORE_DESCRIPTION": "Después de realizar la simulación al menos una vez, selecciona «Calificar mi última sesión» para ver tu puntuación. Si editas los puntos de respuesta, puedes volver a puntuar la misma sesión. Si editas las preguntas, tendrás que realizar una nueva sesión de prueba antes de puntuarla.",
      "KNOWLEDGE_CHECK_SKILLS_RUBRIC_LABEL": "Rúbrica de habilidades (opcional)",
      "SIMULATION_TYPE_MODAL_TITLE": "Crear nueva simulación",
      "SIMULATION_TYPE_MODAL_DESCRIPTION": "Elige cómo practicarán tus alumnos.",
      "SIMULATION_TYPE_ROLE_PLAY_TITLE": "Juego de roles",
      "SIMULATION_TYPE_ROLE_PLAY_DESCRIPTION": "Los alumnos mantienen una conversación abierta con un personaje de IA, que responde de forma natural a todo lo que dicen.",
      "SIMULATION_TYPE_ROLE_PLAY_BEST_FOR": "Ideal para: practicar llamadas de ventas realistas, como argumentos de venta y gestión de objeciones.",
      "SIMULATION_TYPE_KNOWLEDGE_CHECK_TITLE": "Prueba de conocimientos",
      "SIMULATION_TYPE_KNOWLEDGE_CHECK_DESCRIPTION": "Un personaje de IA plantea a los alumnos las preguntas que redactes, en el orden que tú establezcas.",
      "SIMULATION_TYPE_KNOWLEDGE_CHECK_BEST_FOR": "Ideal para: evaluar los conocimientos sobre el producto y certificar que los comerciales están preparados.",
      "TAGS_FILTER_LABEL": "Etiquetas",
      "TAGS_FILTER_PLACEHOLDER": "Selecciona una etiqueta",
      "CLEAR_ALL_FILTERS": "Borrar todos los filtros",
      "LAST_SAVED_LABEL": "Última configuración guardada",
      "BUTTON_OK": "Aceptar",
      "KEYWORDS_RESET_TO_PRODUCT_DEFAULT": "Restablecer a los valores predeterminados del producto",
      "KEYWORDS_DETACH_FROM_PRODUCT_DEFAULT": "Desvincular de la configuración predeterminada del producto",
      "KEYWORDS_SAVE_AS_PRODUCT_DEFAULT": "Guardar como valor predeterminado del producto",
      "KEYWORDS_SAVE_AS_DEFAULT_OVERWRITE": "Esto sobrescribirá el valor predeterminado {{ keywordTitle }} para el producto {{ moduleName }}.",
      "KEYWORDS_SAVE_AS_DEFAULT_IMPACT": "Estas palabras se añadirán a las nuevas simulaciones para {{ moduleName }}. Se aplicarán a todas las llamadas del producto {{ moduleName }}.",
      "KEYWORDS_ADD_NEW_WORD": "Añadir nueva palabra",
      "KEYWORDS_FROM_LABEL": "De",
      "KEYWORDS_TO_LABEL": "A",
      "KEYWORDS_PRONOUNCE_TITLE": "Pronunciar palabras",
      "KEYWORDS_PRONOUNCE_DESCRIPTION": "Proporciona correcciones de pronunciación para que el agente de IA pronuncie correctamente los nombres y términos. El agente asocia los errores de pronunciación y variantes habituales a la nueva pronunciación.",
      "KEYWORDS_PRONOUNCE_NAME": "pronunciar palabras",
      "KEYWORDS_ADD_MISPRONUNCIATION": "Añadir pronunciación incorrecta",
      "KEYWORDS_SELECT_PERSONA_NOTICE": "Selecciona un personaje para añadir pronunciaciones de palabras.",
      "KEYWORDS_REPLACE_TITLE": "Sustituir palabras",
      "KEYWORDS_REPLACE_DESCRIPTION": "Correcciones explícitas de «buscar y reemplazar» para el texto de la transcripción del usuario; sustituciones directas de palabras que se producen antes de la corrección fonética.",
      "KEYWORDS_REPLACE_NAME": "sustituir palabras",
      "KEYWORDS_ADD_REPLACEMENT": "Añadir sustitución",
      "KEYWORDS_STT_TITLE": "Palabras STT",
      "KEYWORDS_STT_DESCRIPTION": "Lista de palabras facilitada a los proveedores de conversión de voz a texto (STT) (p. ej., AssemblyAI, Tavus), específicamente para la configuración de dichos proveedores.",
      "KEYWORDS_STT_NAME": "palabras STT",
      "KEYWORDS_GENERATING": "Generando...",
      "KEYWORDS_GENERATE_STT_PROMPT": "Generar stt_prompt",
      "KEYWORDS_STT_PROMPT_OUTDATED": "La lista de palabras se ha actualizado desde que se generó esta indicación. Vuelve a generarla para reflejar los últimos cambios.",
      "KEYWORDS_STT_CANNOT_SAVE_HEADING": "No se puede guardar a nivel de producto",
      "KEYWORDS_STT_CANNOT_SAVE_BODY": "Las palabras STT y la indicación no se pueden guardar a nivel de producto. Puedes modificar manualmente otros ajustes de configuración de STT de la simulación o ponerte en contacto con tu administrador para que te ayude.",
      "KEYWORDS_CLEAN_TRANSCRIPT_TITLE": "Palabras de la transcripción limpia",
      "KEYWORDS_CLEAN_TRANSCRIPT_DESCRIPTION": "Palabras que se añaden a la indicación CLEAN_TRANSCRIPT_V2.",
      "KEYWORDS_CLEAN_TRANSCRIPT_NAME": "palabras de la transcripción limpia",
      "KEYWORDS_CALL_TITLE": "Palabras de referencia",
      "KEYWORDS_CALL_DESCRIPTION": "Diccionario de palabras correctas para corregir la fonética. Lo usa el algoritmo Double Metaphone para corregir errores ortográficos fonéticamente similares. Evita términos de varias palabras como «Anti MuSK AB+», ya que el corrector de transcripciones basado en código solo funciona bien con palabras sueltas. Evita también los símbolos —por ejemplo, «lp(a)»—, ya que suelen confundir al corrector. La lista debe ser lo más breve y sencilla posible, ya que la gestiona un algoritmo determinista, no un modelo de lenguaje grande (LLM), y carece de comprensión contextual.",
      "KEYWORDS_CALL_NAME": "palabras de referencia"
    },
    "settings": {
      "DEVICE_SETUP_INTRO": "Asegurémonos de que tu dispositivo está configurado.",
      "MICROPHONE_REQUIRED_NOTICE": "Se requiere un micrófono que funcione.",
      "DEVICE_ENABLE_INSTRUCTIONS": "Si al actualizar esta página no aparece una ventana emergente solicitándote que habilites tus dispositivos, accede a la configuración de tu sistema o navegador y habilita tus dispositivos desde allí. A continuación, encontrarás páginas de ayuda con más instrucciones.",
      "ENABLE_CAMERA": "Cómo habilitar la cámara:",
      "WINDOWS_USERS": "Usuarios de Windows",
      "MAC_USERS": "Usuarios de Mac",
      "IPAD_USERS": "Usuarios de iPad",
      "ENABLE_MICROPHONE": "Cómo activar el micrófono:",
      "ENABLE_DEVICES_BY_BROWSER": "Cómo habilitar sus dispositivos mediante el navegador:",
      "CHROME_USERS": "Usuarios de Chrome",
      "SAFARI_USERS": "Usuarios de Safari",
      "FIREFOX_USERS": "Firefox",
      "EDGE_USERS": "Edge",
      "START_WITHOUT_CAMERA_BUTTON": "Iniciar sin cámara",
      "START_CALL_BUTTON": "Iniciar llamada",
      "MICROPHONE_REQUIRED_WARNING": "Se requiere un micrófono que funcione.",
      "MICROPHONE_ALT": "micrófono",
      "MICROPHONE": "Micrófono",
      "SELECT_MICROPHONE": "Selecciona tu micrófono",
      "ALERT": "alerta",
      "GIVE_PERMISSION": "Dar permiso",
      "SELECT_VIDEO_DEVICE": "Selecciona tu dispositivo de vídeo",
      "VIDEO": "vídeo",
      "DEVICE_BLOCKED_ERROR": "Parece que le has negado el acceso a este navegador a uno o más de tus dispositivos. Para habilitar los dispositivos, accede a la configuración de tu sistema o del navegador y habilita el acceso.",
      "DEVICE_SETTINGS": "Configuración del dispositivo",
      "CONFIRM_SETTINGS": "Confirmar ajustes",
      "LAPTOP": "Portátil",
      "SAD_EMOTE_FACE": "Cara de emoticón triste",
      "GRANT_BROWSER_ACCESS": "Para realizar esta simulación, concede al navegador acceso al reconocimiento de voz",
      "USING_IPAD": "Si utilizas un iPad, ve a",
      "SETTINGS": "Ajustes",
      "PRIVACY_AND_SECURITY": "Privacidad y seguridad",
      "SPEECH_RECOGNITION": "Reconocimiento de voz",
      "GRANT_ACCESS_REFRESH": "Concede acceso al navegador y actualiza la página",
      "REFRESH_PAGE": "ACTUALIZAR PÁGINA",
      "BROWSER_UNABLE_TO_ACCESS": "El navegador no puede acceder a este dispositivo",
      "ACCESS_DENIED": "acceso denegado",
      "CAMERA": "Cámara",
      "DIAGNOSTIC_PASSED": "Todas las pruebas de diagnóstico se realizaron con éxito.",
      "DIAGNOSTIC_FAILED_MESSAGE": "Algunas pruebas de diagnóstico fallaron. Haz clic en el botón «Copiar resultados del diagnóstico» situado arriba y envía los resultados al equipo de asistencia para que te ayuden.",
      "DIAGNOSTIC_PARTIAL": "La mayoría de las pruebas de diagnóstico se realizaron con éxito. Tu conexión parece buena.",
      "DIAGNOSTIC_RUNNING_MESSAGE": "Por favor, espera mientras se ejecutan las pruebas de diagnóstico...",
      "DIAGNOSTIC_RUNNING": "Ejecutando diagnóstico",
      "COPY_DIAGNOSTIC_RESULTS": "Copiar resultados del diagnóstico",
      "RUN_DIAGNOSTIC": "Ejecutar Diagnóstico",
      "RERUN_DIAGNOSTIC": "Reejecutar diagnóstico",
      "DIAGNOSTIC_RESULTS_COPIED": "Resultados del diagnóstico copiados al portapapeles",
      "DIAGNOSTIC_FAILED": "Diagnóstico fallido",
      "DIAGNOSTIC_WEBSOCKET_NOT_TESTED": "Websocket: not tested",
      "DIAGNOSTIC_TURN_NOT_TESTED": "TURN: not tested",
      "DIAGNOSTIC_QUALITY_NOT_TESTED": "Quality: not tested",
      "DIAGNOSTIC_QUANTIFIED_DIAGNOSTICS": "Diagnóstico de Quantified",
      "DIAGNOSTIC_TIME": "Tiempo",
      "DIAGNOSTIC_SUMMARY": "Resumen",
      "DIAGNOSTIC_CLIENT_INFO": "Información del cliente",
      "DIAGNOSTIC_PLATFORM": "Plataforma",
      "DIAGNOSTIC_RTT_AVG_MAX": "RTT avg/max",
      "DIAGNOSTIC_PACKET_LOSS_SEND": "Pérdida de paquetes (enviar)",
      "DIAGNOSTIC_AVG_SEND_BITRATE": "Tasa de bits de envío promedio",
      "DIAGNOSTIC_NA": "N/A",
      "DIAGNOSTIC_PROBLEMS_CONNECTING_PREFIX": "¿Tienes problemas de conexión?",
      "DIAGNOSTIC_CLICK_HERE": "Haz clic aquí",
      "DIAGNOSTIC_TO_RUN_SUFFIX": "para ejecutar un diagnóstico."
    },
    "results": {
      "RETURN_HOME": "REGRESAR A INICIO",
      "CLOSE_BUTTON": "Botón de cerrar",
      "CONVERSATIONAL_CALL": "JUEGO DE ROLES",
      "INFORMATION_ICON": "Icono de información",
      "TOOLTIP_ARROW": "Flecha del tooltip",
      "INFORMATION_TOOLTIP_CONTENT": "Tú controlas el desarrollo de la simulación y diriges la conversación hacia una serie de objetivos. Los juegos de rol son excelentes para poner a prueba habilidades como profundizar en detalles y hacer preguntas de segundo nivel, descubrir puntos de dolor y crear una buena relación.",
      "CLOCK_ICON": "Icono de reloj",
      "CALL_RESULTS": "Resultados",
      "SKILLS": "Habilidades",
      "MESSAGE_ADHERENCE": "Adherencia al mensaje",
      "TRY_AGAIN_MESSAGE": "Inténtalo de nuevo y mejora tu puntuación.",
      "PRACTICE_BENEFITS": "Practicar semanalmente aumenta la confianza y mejora los resultados en el mundo real.",
      "CALL_SUCCESS": "¡Buen trabajo! Has completado esta simulación con éxito.",
      "MAX_ATTEMPTS_REACHED": "Has alcanzado el número máximo de intentos",
      "TRY_AGAIN": "Inténtalo de nuevo",
      "GREAT_JOB_YOU_SUCCESSFULLY": "¡Buen trabajo! Has completado",
      "COMPLETED_THIS_CALL": "correctamente esta simulación.",
      "ACHIEVED_SCORE": "Has logrado una puntuación de",
      "ACHIEVE_SCORE": "Logra una puntuación de",
      "OR_HIGHER": "o superior.",
      "OBJECTIVES_NOT_MET": "No cumpliste con todos los objetivos requeridos.",
      "TRY_AGAIN_TARGET_SCORE": "Inténtalo de nuevo para lograr una puntuación de",
      "YOUR_SCORE": "Tu puntuación",
      "OUT_OF_5": "SOBRE 5",
      "CALL_FEEDBACK": "RESUMEN DE COMENTARIOS",
      "STRENGTH_ICON_ALT": "Icono de fuerza",
      "OPPORTUNITIES_ICON_ALT": "Icono de oportunidades",
      "OBJECTIVES_FEEDBACK": "COMENTARIOS SOBRE LA METODOLOGÍA",
      "SESSION_ID": "ID de sesión:",
      "SESSION_ID_COPIED": "¡ID de sesión copiado!",
      "OBJECTIVE": "METODOLOGÍA:",
      "HOW_YOU_DID": "Qué tal lo hiciste:",
      "LIGHTBULB_ICON_ALT": "Icono de bombilla",
      "WHAT_WE_SUGGEST": "Lo que sugerimos:",
      "NO_SPECIFIC_RECOMMENDATION": "Nuestro sistema no ha podido encontrar una recomendación específica para ti.",
      "WHY": "¿Por qué?",
      "NO_INSIGHTS_AVAILABLE": "Nuestro sistema no ha podido proporcionar información sobre esta sugerencia.",
      "CONFETTI_ICON_ALT": "Icono de confeti",
      "OBJECTIVE_SUCCESS_MESSAGE": "Lo has hecho muy bien en esta metodología, ¡sigue así!",
      "PROCESSING_CALL": "Estamos preparando tu puntuación y tus comentarios.",
      "HANG_TIGHT": "Espera un momento o vuelve a consultar más tarde para",
      "VIEW_YOUR_RESULTS": "ver tus resultados.",
      "NEED_MORE_TIME": "Necesitamos más tiempo para calcular los resultados.",
      "REFRESH_INSTRUCTION": "Vuelve a consultarlo o actualiza los resultados",
      "RESULTS_IN_FEW_MINUTES": "de los resultados dentro de unos minutos.",
      "SCORE_CALCULATION_QUESTION": "¿Cómo se calcula esto?",
      "SINGLE_SCORE_EXPLANATION": "Esta simulación solo tiene un único componente de puntuación, por lo que la puntuación mostrada es tanto la puntuación de sección individual como la puntuación general.",
      "OVERALL_SCORE_PERCENT": "de la puntuación global",
      "SECTION_SCORE": "Puntuación de la sección",
      "ELEVATE_MESSAGE_ADHERENCE_TITLE": "Mejora la adherencia al mensaje en la conversación",
      "MESSAGE_ADHERENCE_NOTE": "La adherencia al mensaje es fundamental para dirigir conversaciones exitosas, pero no afecta a la puntuación general.",
      "NO_CREDIT": "Sin crédito",
      "PARTIAL_CREDIT": "Crédito parcial",
      "FULL_CREDIT": "Crédito completo",
      "WHAT_YOU_DID_WELL": "Lo que hiciste bien",
      "MISSED_ALL_KEY_POINTS": "Te has saltado todos los puntos clave; revísalos y vuelve a intentarlo.",
      "WHAT_TO_IMPROVE": "Lo que puedes mejorar",
      "PERFECT_SCORE_MESSAGE": "¡Felicidades! Has obtenido una puntuación perfecta, hablando correctamente de todos los puntos clave.",
      "POINTS_LABEL": "Puntos",
      "TALKING_POINTS_COVERED": "Temas de conversación tratados",
      "CHECKMARK_ICON_ALT": "marca de verificación",
      "TALKING_POINTS_MISSED": "Temas de conversación omitidos",
      "X_ICON_ALT": "x",
      "PRACTICE_AGAIN": "Practica de nuevo",
      "OUT_OF": "de",
      "OBJECTIVES": "Metodología",
      "ELEVATE_OBJECTIVES_TITLE": "Mejora tu metodología de conversación",
      "OBJECTIVES_NOTE": "La metodología es fundamental para dirigir conversaciones exitosas, pero no afecta a la puntuación general.",
      "UNTIL": "hasta",
      "TO_IMPROVE_SCORE": "para mejorar tu puntuación.",
      "YOU_HAVE": "Tienes",
      "MORE_ATTEMPTS": "más intentos para conseguir",
      "OR_HIGHER_BEFORE": "puntos o más antes del",
      "AND_TRY_AGAIN": "e intentarlo de nuevo.",
      "UNEXPECTED_STATE": "Ha ocurrido un estado inesperado.",
      "REVIEW_APP_LOGIC": "Por favor, revisa la lógica de la aplicación.",
      "ASSIGNMENTS": "Tareas",
      "VIEW_CALL_DETAILS": "Ver detalles de la llamada",
      "PRACTICE_SESSION": "Sesión de práctica",
      "OVERALL_SCORE": "Puntuación general",
      "OVERALL_SCORE_EXPLANATION": "La puntuación general se calcula tomando una media ponderada de la puntuación de cada sección. El peso de cada sección se muestra como un porcentaje junto a la puntuación.",
      "SCORE_CONFIG_NOTE": "Los porcentajes de peso y la inclusión y exclusión de secciones los establece tu empresa. Todas las puntuaciones se redondean a la décima más cercana.",
      "STRENGTHS": "Fortalezas",
      "OPPORTUNITIES": "Oportunidades",
      "YOUR_RESPONSE": "Tu respuesta",
      "MINUS": "menos",
      "PLUS": "más",
      "RECOMMENDED_RESPONSE": "Respuesta recomendada",
      "REVIEW_MISSED_TITLE": "Revisa lo que has omitido.",
      "NO_TALKING_POINTS_COVERED": "No has tratado ninguno de los temas de conversación requeridos para este tema.",
      "LEARN_WHAT_YOU_MISSED": "Descubre lo que has omitido",
      "NICE_JOB": "¡Buen trabajo!",
      "ALL_POINTS_COVERED": "Has tratado exitosamente todos los temas de conversación requeridos para este tema.",
      "COVER_ALL_MESSAGES": "Tratar todos los mensajes clave.",
      "HIGHLIGHT_KEY_POINTS_NOTE": "Resaltar los puntos clave durante la llamada ayudará a mantener la conversación centrada.",
      "MESSAGES_LABEL": "Mensajes",
      "NO_FACTS_COVERED": "¡Vaya! Parece que no has mencionado ninguno de los hechos de este mensaje.",
      "NO_SPECIFICS_AVAILABLE": "¡Vaya! Parece que no hemos podido proporcionar detalles sobre lo que has omitido.",
      "ALL_KEY_POINTS_COVERED": "¡Buen trabajo! Has tratado todos los puntos clave.",
      "PROCESSING_SKILLS_FEEDBACK": "Estamos procesando los comentarios sobre tus habilidades.",
      "SKILLS_SCORING_NOT_ENABLED": "Lo sentimos, pero no hemos podido analizar tu llamada reciente porque la evaluación de habilidades no estaba habilitada en el momento del envío. Para recibir comentarios, solo tienes que volver a enviar tu práctica de llamada como lo hiciste anteriormente. Si necesitas ayuda, no dudes en contactar a nuestro equipo de soporte. ¡Gracias por tu comprensión y compromiso por mejorar!",
      "ELEVATE_CONVERSATION_SKILLS": "Mejora tus habilidades de conversación",
      "SKILLS_NOTE": "Las habilidades son críticas para dirigir conversaciones exitosas, pero no afectan a la puntuación general.",
      "SKILLS_SUMMARY_TITLE": "RESUMEN DE HABILIDADES",
      "LEARN_MORE_ABOUT_SKILLS": "Obtén más información sobre las habilidades",
      "SKILLS_FEEDBACK_LABEL": "COMENTARIOS",
      "WHAT_ARE_SKILLS_TITLE": "¿Qué son las habilidades?",
      "SKILLS_DESCRIPTION": "Las habilidades están calibradas para favorecer el desarrollo del crecimiento personal. Aunque estas habilidades no forman parte de la evaluación numérica de tu llamada, tu organización las ha seleccionado para mejorar tu eficacia.",
      "PROFICIENCY_SCALE_TITLE": "ESCALA DE COMPETENCIA",
      "EXPERT": "Experto",
      "PROFICIENT": "Competente",
      "DEVELOPING": "En desarrollo",
      "CALL_TRANSCRIPT": "Transcripción de la llamada",
      "COLLAPSE_ALL": "Colapsar todo",
      "EXPAND_ALL": "Expandir todo",
      "THUMBNAIL": "Miniatura",
      "OUT_OF_FIVE_POINTS": "/5 puntos",
      "TALKING_POINTS": "temas de conversación",
      "TRANSCRIPT_LABEL": "Transcripción",
      "YOU_ARE_OUT_OF_ATTEMPTS": "Te has quedado sin intentos.",
      "REVIEW_GUIDELINES_REMAIN_COMPLIANT": "Revisa las directrices y sigue cumpliéndolas en el futuro.",
      "TRY_AGAIN_ATTENTION_TO_COMPLIANCE": "Inténtalo de nuevo y presta atención a las directrices de cumplimiento.",
      "NO_SCORE_OUT_OF_COMPLIANCE": "Hemos identificado algo que podría no cumplir con la normativa",
      "WHY_OUT_OF_COMPLIANCE": "Por qué podrías estar incumpliendo las normas",
      "REVIEW_TRANSCRIPT_MISSED_GUIDELINES": "Revisa tu transcripción para ver en qué aspectos no has cumplido con la normativa.",
      "YOU_DID_FOLLOW_GUIDELINES": "Cumpliste con estas directrices de manera efectiva.",
      "REVIEW_MISSED_GUIDELINES": "Revisa las directrices de cumplimiento incumplidas.",
      "OUT_OF_COMPLIANCE": "Incumplimiento",
      "SCORE_CALCULATION_TITLE": "Cálculo de puntuación",
      "PROCESSING_TRANSCRIPT": "Estamos procesando tu transcripción.",
      "WAIT_OR_REVIEW_SCORES": "Espera aquí o revisa las otras secciones",
      "TRANSCRIPT_LOADING": "de la puntuación mientras se carga la transcripción.",
      "REVIEW_FEEDBACK_KEEP_PRACTICING": "Revisa tus comentarios y sigue practicando",
      "HIGH_PERFORMERS_PRACTICE": "Las personas con mejor rendimiento practican al menos una vez a la semana",
      "SUCCESSFULLY_PASSED": "¡Buen trabajo! Has superado con éxito esta simulación.",
      "DIDNT_REACH_PASSING_SCORE": "No has alcanzado la puntuación de aprobado para esta simulación.",
      "OUT_OF_ATTEMPTS": "<b>Te has quedado sin intentos.</b> Revisa tus comentarios para saber cómo puedes mejorar.",
      "REVIEW_FEEDBACK_THEN_RETURN": "Revisa tus comentarios y vuelve al inicio cuando estés preparado.",
      "GREAT_JOB_PRACTICED": "¡Buen trabajo! Has practicado {{count}} {{times}}. ¡Sigue así!",
      "TIME": "vez",
      "TIMES": "veces",
      "COMPLIANCE_GUIDELINES": "Normativa de cumplimiento",
      "TALKING_POINT_TITLE": "TEMAS DE CONVERSACIÓN OMITIDOS O ABORDADOS EN EL MOMENTO EQUIVOCADO",
      "NO_TRANSCRIPT": "No hay transcripción disponible.",
      "QUIZ_SUMMARY_BASE": "Tómate un momento para revisar tu desempeño en este cuestionario.",
      "QUIZ_SUMMARY_FAILED": "Tómate un momento para revisar tu desempeño en este cuestionario. Revisa los {{stepNames}} {{stepWord}} resaltados en la pantalla de resumen de la ruta para prepararte mejor para tu próximo intento.",
      "QUIZ_SUMMARY_PASSED_WITH_MISSES": "Tómate un momento para revisar tu desempeño en este cuestionario. El/los {{stepWord}} {{stepNames}} {{stepVerb}} tu(s) {{areaWord}} con la puntuación más baja.",
      "OUT_OF_100": "SOBRE 100",
      "COVERED": "Tratados",
      "MISSED": "Omitidos",
      "RETURN_TO_ASSIGNMENT": "Volver a la tarea",
      "RETURN_TO_PATHWAY": "VOLVER A LA RUTA",
      "QUIZ_RESULTS_SUMMARY": "Resumen de resultados del cuestionario",
      "PROCESSING_RESULTS": "Procesando los resultados...",
      "NONE_PERFECT": "No hay nada: ¡perfecto!",
      "MESSAGING": "Mensaje",
      "MISSED_ONE_TALKING_POINT": "Te has perdido 1 punto de conversación para este tema.",
      "MISSED_X_TALKING_POINTS": "Te has perdido {{count}} puntos de conversación para este tema.",
      "ROLEPLAY_POST_CALL_TITLE": "Has llegado al final de esta llamada.",
      "ROLEPLAY_POST_CALL_SUBTITLE_PROCESSING": "Deja algún comentario mientras procesamos tus resultados.",
      "ROLEPLAY_POST_CALL_SUBTITLE_DELAY": "Los resultados tardan un poco en cargarse. Sal de la ruta y te notificaremos cuando estén listos.",
      "ROLEPLAY_POST_CALL_SUBTITLE_ERROR": "Ha habido un error al procesar tus resultados. Ponte en contacto con el servicio de asistencia en",
      "ROLEPLAY_POST_CALL_PROCESSING_LABEL": "Procesando los resultados...",
      "ROLEPLAY_POST_CALL_FEEDBACK_QUESTION": "¿Te pareció realista y natural esta conversación?",
      "FEEDBACK_THANK_YOU": "¡Gracias por tus comentarios!",
      "FEEDBACK_IMPROVEMENT_NOTE": "¡Gracias por tus comentarios! Trabajaremos en mejorar la experiencia.",
      "VIEW_RESULTS": "Ver resultados",
      "FEEDBACK_IMPROVEMENT_SUFFIX": "Trabajaremos en mejorar la experiencia.",
      "QUIZ_RESULTS_LOADING": "Los resultados tardan un poco en cargarse. Sal de la ruta y te notificaremos cuando estén listos.",
      "KC_TOAST_TITLE": "Los resultados de tu prueba de conocimientos han sido procesados.",
      "KC_TOAST_CONTENT": "Haz clic abajo para verlos o vuelve a la pantalla de detalles de la ruta para ver el siguiente paso.",
      "DISMISS": "Descartar",
      "KC_TOAST_TITLE_PATHWAY": "Se han procesado los resultados de la prueba de conocimientos de {{stepName}}.",
      "MISSED_ONE_REQUIRED_TALKING_POINT": "Te has saltado 1 tema de conversación obligatorio de este tema",
      "MISSED_X_REQUIRED_TALKING_POINTS": "Te has saltado {{count}} temas de conversación obligatorios de este tema",
      "MISSED_ALL_ONE_REQUIRED_TALKING_POINT_TITLE": "Te has saltado 1 tema de conversación obligatorio de este tema.",
      "MISSED_ALL_X_REQUIRED_TALKING_POINTS_TITLE": "Te has saltado {{count}} temas de conversación obligatorios de este tema.",
      "REVIEW_MATERIAL_NEXT_TIME": "Repasa el material para mejorar la próxima vez.",
      "POINT_LABEL": "Punto",
      "GREAT_JOB_PRACTICED_FEMALE": "¡Buen trabajo! Has practicado {{count}} {{times}}. ¡Sigue así!",
      "ACCURACY": "Precisión",
      "ACCURACY_LOADING": "Cargando...",
      "ACCURACY_FLAGGED_MESSAGE": "Has dicho algunas cosas que pueden diferir de los materiales originales. Para obtener más detalles, sigue leyendo.",
      "ACCURACY_ALL_CLEAR": "No hemos identificado ninguna afirmación que fuera inexacta respecto a los materiales originales.",
      "ACCURACY_ERROR": "No se han podido proporcionar comentarios sobre esta sesión",
      "ACCURACY_YOU_SAID": "LO QUE DIJISTE",
      "ACCURACY_CLAIM_IDENTIFIED": "LA AFIRMACIÓN QUE IDENTIFICAMOS",
      "ACCURACY_MATERIALS_STATE": "LO QUE DICEN TUS MATERIALES",
      "ACCURACY_OVERALL_BLOCK_PREFIX": "Has dicho algunas cosas que podrían ser inexactas. Echa un vistazo a la ",
      "ACCURACY_OVERALL_BLOCK_LINK": "pestaña «Precisión»",
      "ACCURACY_OVERALL_BLOCK_SUFFIX": " para obtener más detalles.",
      "PRACTICE_SIMULATION_AGAIN": "Practica la simulación de nuevo",
      "CALL_TYPE_CONVERSATIONAL": "Llamada conversacional",
      "CALL_TYPE_GUIDED": "Llamada guiada",
      "CALL_TYPE_VISUAL_AID": "Llamada con ayuda visual",
      "CALL_TYPE_ROLEPLAY": "Llamada con juego de roles",
      "PERSONALIZED_PRACTICE_BREADCRUMB": "Práctica personalizada",
      "CONVERSATION_TYPE_LABEL": "Tipo de conversación:",
      "DIFFICULTY_LABEL": "Dificultad:",
      "MOOD_LABEL": "Estado:",
      "DIFFICULTY": "Dificultad",
      "TEMPERAMENT": "Temperamento",
      "OVERALL_SCORE_TAB": "General",
      "MESSAGE_ADHERENCE_TAB": "Mensajes",
      "OBJECTIVES_TAB": "Objetivos"
    },
    "reportingV2": {
      "DASHBOARD": "Panel",
      "LOADING_ACCOUNTS": "Cargando cuentas…",
      "SELECT_AN_ACCOUNT": "Selecciona una cuenta",
      "SEARCH_TEAMS": "Buscar equipos",
      "LOADING_TEAMS": "Cargando equipos…",
      "ALL_TEAMS": "Todos los equipos",
      "ACCOUNT": "Cuenta",
      "TEAMS": "Equipos",
      "TEAM_LABEL": "Equipo",
      "TOTAL_LABEL": "Total",
      "PASSING_SCORE": "Calificación mínima para aprobar",
      "ASSIGNMENT_LABEL": "Tareas",
      "USER_LABEL": "Usuarios",
      "PRACTICE_LABEL": "Práctica",
      "CERTIFICATION_LABEL": "Certificación",
      "RESULTS_DESCRIPTION": "Aquí tienes los resultados de tu(s) equipo(s) en todas las prácticas:",
      "ENGAGEMENT_BY_ASSIGNMENT": "Participación por tarea",
      "ASSIGNMENT_ENGAGEMENT": "Participación de la tarea",
      "ENGAGED_LABEL": "Realizada",
      "ENGAGEMENT_STATUS_LABEL": "Estado de participación",
      "PROFICIENT_LABEL": "Competente",
      "ASSIGNMENT_NAME": "Nombre de la tarea",
      "ACTIVE_USERS": "Usuarios activos",
      "ASSIGNMENT_PROGRESS": "Progreso por tarea",
      "IN_PROGRESS_LABEL": "En progreso",
      "CERTIFIED_LABEL": "Certificadas",
      "OUT_OF_ATTEMPTS_LABEL": "No quedan intentos",
      "USERS_ENGAGED_LABEL": "Usuarios participantes",
      "SESSIONS_PER_ACTIVE_USERS_LABEL": "Sesiones por usuario activo",
      "HIGHER_THAN_LABEL": "Superior a",
      "MORE_THAN_LABEL": "Más de",
      "TOTAL_SESSIONS_COMPLETED_LABEL": "Total de sesiones completadas",
      "USER_CERTIFIED": "Usuarios certificados en todas las tareas",
      "ASSIGNMENT_CERTIFICATION": "Tareas con certificación del 100 %",
      "TRAINER_TIME_SAVED": "Ahorro de tiempo del formador",
      "HOURS_LABEL": "horas",
      "PRACTICE_ASSIGNMENT_LABEL": "Tareas de práctica",
      "CERTIFICATION_ASSIGNMENT_LABEL": "Tareas de certificación",
      "START_DATE_LABEL": "Fecha de inicio",
      "END_DATE_LABEL": "Fecha de finalización",
      "NAME_LABEL": "Nombre",
      "EMAIL_LABEL": "Correo electrónico",
      "MEMBER_OF_TEAMS_LABEL": "Miembro de equipos",
      "ASSIGNMENTS_COUNT_LABEL": "# de tareas",
      "TOTAL_SESSIONS_LABEL": "Sesiones totales",
      "NUMBER_OF_SESSIONS_LABEL": "Número de sesiones",
      "TOTAL_USERS_LABEL": "Usuarios totales",
      "AVERAGE_SCORE_LABEL": "Puntuación media",
      "INITIAL_SCORE_LABEL": "Puntuación inicial",
      "HIGH_SCORE_LABEL": "Puntuación alta",
      "LAST_PRACTICE_DATE_LABEL": "Última fecha de práctica",
      "PERCENT_IMPROVED_LABEL": "% mejorado",
      "PERCENT_IMPROVED_TOOLTIP_TEXT": "Esta métrica compara la puntuación inicial de un usuario con su puntuación más alta, expresada como porcentaje de la mejora máxima posible.",
      "ASSIGNMENTS_CERTIFIED_LABEL": "Tareas certificadas",
      "ASSIGNMENTS_PROFICIENT_LABEL": "Tareas satisfactorias",
      "ASSIGNMENTS_CERTIFIED_TOOLTIP_TEXT": "Número de tareas en las que el usuario ha cumplido o superado los criterios de puntuación para todas las simulaciones de la tarea.",
      "ASSIGNMENTS_PROFICIENT_TOOLTIP_TEXT": "Número de tareas en las que el usuario ha cumplido o superado los criterios de puntuación al menos una vez en todas las simulaciones de la tarea.",
      "PROFICIENT_TOOLTIP": "Porcentaje de usuarios de esta tarea que han cumplido o superado los criterios de puntuación al menos una vez en todas las simulaciones de esta tarea.",
      "IN_PROGRESS_TOOLTIP": "Porcentaje de usuarios que han completado al menos una sesión de una simulación en esta tarea y han recibido una puntuación.",
      "OUT_OF_ATTEMPTS_TOOLTIP": "Porcentaje de usuarios que han superado los intentos asignados para una o varias simulaciones de la tarea.",
      "CERTIFIED_TOOLTIP": "Porcentaje de usuarios que han cumplido o superado los criterios de puntuación para todas las simulaciones de la tarea.",
      "SEARCH_FOR_A_USER_LABEL": "Buscar un usuario",
      "NO_USERS_FOUND_LABEL": "No se han encontrado usuarios",
      "TRAINER_TIME_SAVED_TOOLTIP": "La cantidad de tiempo que los usuarios han pasado en Quantified completando intentos de certificación.",
      "AVG_SESSIONS_PER_ASSIGNMENT": "Sesiones medias por tarea",
      "ASSIGNMENTS_ENGAGED_WITH": "Tareas realizadas con",
      "AVERAGE_IMPROVEMENT": "Mejora media",
      "STATUS": "Estado",
      "TOTAL_NUMBER_OF_SESSIONS": "Número total de sesiones",
      "DATE_OF_LAST_PRACTICE": "Fecha de la última práctica",
      "CALL_NAME": "Nombre de la llamada",
      "SESSION_DATE": "Fecha de la sesión",
      "DURATION_OF_SESSION": "Duración de la sesión",
      "OVERALL_SCORE": "Puntuación general",
      "MESSAGING_SCORE": "Puntuación de adherencia al mensaje",
      "METHODOLOGY_SCORE": "Puntuación de metodología",
      "SKILLS_SCORE": "Puntuación por competencia",
      "SESSIONS": "Sesiones",
      "TOTAL": "Total",
      "ALL_ASSIGNMENTS": "Todas las tareas",
      "RECENT_ASSIGNMENTS": "Tareas recientes",
      "AVERAGE_SESSIONS_ACTIVE_USER": "Media de sesiones por usuario activo",
      "HOURS_IN_SIMULATIONS": "Horas en simulaciones",
      "AVERAGE_SESSIONS_TO_PROFICIENCY": "Promedio de sesiones hasta la competencia",
      "PERCENT_PROFICIENT": "Porcentaje competente",
      "SYSTEM_RUNNING_NORMALLY": "El sistema está funcionando con normalidad",
      "PRACTICE_SIMULATIONS_LABEL": "Simulaciones",
      "NO_USERS_MATCHING_FILTERS_LABEL": "Ningún resultado coincide con los filtros. Prueba a borrar uno o varios filtros para ampliar la búsqueda.",
      "USERS_PASSED": "Usuarios que han superado la simulación",
      "AVERAGE_TIME": "Tiempo medio de certificación",
      "USERS_OUT_OF_ATTEMPTS": "Usuarios sin intentos",
      "NO_CERTIFICATION_SIMULATION": "No se han encontrado simulaciones de certificación",
      "No_SIMULATION": "Sin sesiones",
      "PERCENT_CERTIFIED": "Porcentaje de certificaciones",
      "PERCENT_CERTIFIED_FIRST_ATTEMPT": "Porcentaje de certificaciones en el primer intento",
      "USERS": "Usuarios",
      "ATTEMPTS_LABEL": "Intentos",
      "NO_ATTEMPTS": "Ningún intento",
      "DATE_OF_SESSION": "Fecha de la sesión",
      "NO_ASSIGNMENTS_MATCH_FILTERS": "Ninguna tarea coincide con los filtros elegidos",
      "NO_TEAMS_DATA": "No hay equipos en esta cuenta",
      "SIMULATION_NAME": "Nombre de la simulación",
      "AVERAGE_DURATION_OF_SESSION": "Duración media de la sesión",
      "AVERAGE_SESSIONS_PER_ACTIVE_USER": "Media de sesiones por usuario activo",
      "AVERAGE_OVERALL_SCORE": "Puntuación media global",
      "TOTAL_ASSIGNMENTS": "Tareas totales",
      "ASSIGNMENTS_CERTIFIED": "Tareas certificadas",
      "TOTAL_SESSIONS": "Sesiones totales",
      "HOURS_SPENT_PRACTICING": "Horas dedicadas a practicar",
      "LAST_LOGIN": "Último acceso",
      "SELECT_ASSIGNMENTS": "Seleccionar tareas",
      "CERTIFICATION_STATUS_LABEL": "Estado de la certificación",
      "CERTIFICATION_STATUS_PREFIX_LABEL": "Estado de la certificación:",
      "CERTIFIED_ON_FIRST_ATTEMPT_LABEL": "¿Certificado al primer intento?",
      "DATE_OF_CERTIFICATION_LABEL": "Fecha de certificación",
      "ENGAGEMENT_STATUS_PREFIX_LABEL": "Estado de participación:",
      "DURATION_OF_ATTEMPT": "Duración del intento",
      "USER_NAME": "Nombre de usuario",
      "LEARNER": "Estudiante",
      "DATE_RANGE": "Intervalo de fechas",
      "DATE_RANGE_LABEL": "Intervalo de fechas",
      "SEARCH_USERS": "Buscar usuarios...",
      "SEARCH_SIMULATIONS": "Buscar simulaciones...",
      "SEARCH_DATES": "Buscar fechas...",
      "CERTIFIED_ON_FIRST_TRY": "Certificado a la primera",
      "DATE_OF_CERTIFICATION": "Fecha de certificación",
      "AVERAGE_CERTIFICATION_SCORE": "Puntuación media de la certificación",
      "TOTAL_TIME_CERTIFYING": "Tiempo total de certificación",
      "OF_THE_TIME": "de las veces",
      "ASSIGNED_LABEL": "Sin iniciar",
      "USERS_ASSIGNED_LABEL": "Total de usuarios asignados",
      "SESSION_ID": "ID de sesión",
      "USER_NAME_LABEL": "Nombre de usuario",
      "NO_SIMULATIONS_FOUND_LABEL": "No se han encontrado simulaciones",
      "MIN": "min",
      "SEC": "seg",
      "OF_LABEL": "de",
      "SECOND": "segundo",
      "SECONDS": "segundos",
      "MINUTE": "minuto",
      "MINUTES": "minutos",
      "ASSIGNED": "Asignada",
      "SIMULATION": "Simulación",
      "ENGAGED_TOOLTIP": "El porcentaje de usuarios que han completado una o más sesiones de una simulación en esta tarea pero que aún no han alcanzado la competencia en todas las simulaciones.",
      "SEARCH_ASSIGNMENTS": "Buscar tareas...",
      "ASSIGNMENT_NAME_LABEL": "Nombre de la tarea",
      "SIMULATION_NAME_LABEL": "Nombre de la simulación",
      "START_DATE": "Fecha de inicio",
      "END_DATE": "Fecha de finalización",
      "NO_ASSIGNMENTS": "No se encontró ninguna tarea para este usuario.",
      "TOTAL_PRACTICE_ASSIGNMENTS": "Total de tareas de práctica",
      "SESSION_SCORES_OVER_TIME": "Puntuaciones de la sesión a lo largo del tiempo",
      "TIME": "Tiempo",
      "SCORE": "media",
      "NO_SESSIONS_AVAILABLE": "No hay sesiones disponibles para graficar.",
      "MESSAGING_SCORE_LABEL": "Puntuación de adherencia al mensaje",
      "PERSONALIZED_PRACTICE_LABEL": "Práctica personalizada",
      "ASSIGNMENT_ENAGEMENT": "Participación por tarea",
      "NO_PRODUCTS": "No hay productos de práctica personalizada para los equipos seleccionados",
      "TOTAL_TIME_SPENT_PRACTICING": "Tiempo total dedicado a la práctica",
      "AVERAGE_SESSIONS_PER_USER": "Promedio de sesiones por usuario",
      "MOST_COMMON_CONVERSATION_TYPE_SELECTION": "Selección del tipo de conversación más común",
      "LEAST_COMMON_CONVERSATION_TYPE_SELECTION": "Selección del tipo de conversación menos común",
      "CLEAR_TEAMS": "Eliminar equipos",
      "METHODOLOGY_SCORE_DESCRIPTION": "Mide qué tan bien los alumnos siguen la estructura de llamadas recomendada. Las puntuaciones reflejan el promedio de todas las sesiones de esta simulación.",
      "METHODOLOGY": "Metodología",
      "MESSAGING": "Mensaje",
      "MESSAGING_V2_DASHBOARD_DESCRIPTION": "Mide si los alumnos logran articular las ideas clave durante la llamada. Los gráficos muestran el porcentaje promedio de mensajes articulados correctamente por tema, en todas las sesiones.",
      "NO_METRICS_MESSAGE": "Se necesitan más sesiones para generar información.",
      "SELECT_ALL": "Seleccionar todo",
      "DESELECT_ALL": "Deseleccionar todo",
      "SKILLS": "Habilidades",
      "SKILLS_SCORE_STATS_DESCRIPTION": "Mide el grado de eficacia con el que los alumnos demuestran las habilidades clave durante la llamada. Las puntuaciones reflejan una evaluación de IA promediada en todas las sesiones.",
      "EXPERT": "Experto",
      "PROFICIENT": "Competente",
      "DEVELOPING": "En desarrollo",
      "FULLY_ARTICULATED": "Totalmente articulado",
      "PARTIALLY_ARTICULATED": "Parcialmente articulado",
      "NOT_MENTIONED": "No mencionado",
      "MESSAGING_SCORE_STATS_DESCRIPTION": "Mide si los alumnos logran articular las ideas clave durante la llamada. Los gráficos muestran con qué frecuencia se articuló correctamente cada mensaje en todas las sesiones.",
      "CLEAR": "Eliminar",
      "CLEAR_STATUS": "Borrar estado",
      "CLEAR_USERS": "Borrar usuarios",
      "CLEAR_SIMULATIONS": "Borrar simulaciones",
      "CLEAR_ASSIGNMENTS": "Borrar tareas",
      "MODAL_SUBHEADING": "Todos los {{ count }} objetivos: puntuaciones promedio en todas las sesiones",
      "VIEW_ALL_OBJECTIVES": "Ver todos los objetivos {{ count }} →",
      "LEAST_MISSED_QUESTION": "PREGUNTA MENOS FALLIDA",
      "MOST_MISSED_QUESTION": "PREGUNTA MÁS FALLIDA",
      "HIGHEST_SCORING_METHODOLOGY_SECTION": "SECCIÓN DE METODOLOGÍA CON LA PUNTUACIÓN MÁS ALTA",
      "LOWEST_SCORING_METHODOLOGY_SECTION": "SECCIÓN DE METODOLOGÍA CON LA PUNTUACIÓN MÁS BAJA",
      "LEAST_ARTICULATED_MESSAGE": "MENSAJE MENOS ARTICULADO",
      "ENGAGEMENT": "PARTICIPACIÓN",
      "USER_ENGAGEMENT_MORE_SESSIONS": "sesiones más completadas que el promedio del equipo",
      "QUESTION_CORRECT_PERCENTAGE_DESC": "de las veces, este usuario acertó.",
      "QUESTION_CORRECT_PERCENTAGE_DESC_ASSIGNMENT": "de las veces, los usuarios aciertan.",
      "METHODOLOGY_AVERAGE_POINTS_DESC": "puntos medios en este objetivo en todas las sesiones",
      "MOST_ARTICULATED_MESSAGE": "MENSAJE MÁS ARTICULADO",
      "LEAST_MISSED_ANSWER_POINT": "PUNTO DE RESPUESTA MENOS FALLIDO",
      "MOST_MISSED_ANSWER_POINT": "PUNTO DE RESPUESTA MÁS ERRÓNEO",
      "MOST_ARTICULATED_MESSAGE_DESCRIPTION": "de las veces, este usuario articuló plenamente este mensaje",
      "LEAST_ARTICULATED_MESSAGE_DESCRIPTION": "de las veces, este usuario articuló este mensaje",
      "ASSIGNMENT_STATUS": "Estado de la tarea",
      "STATUS_ACTIVE": "Activo",
      "STATUS_ENDED": "Terminado",
      "STATUS_CLOSED": "Cerrado",
      "STATUS_ARCHIVED": "Archivado",
      "USER_ENGAGEMENT_FEWER_SESSIONS": "sesiones menos completadas que el promedio del equipo",
      "MOST_ARTICULATED_MESSAGE_DESCRIPTION_ASSIGNMENT": "de las veces, los usuarios articulan este mensaje",
      "LEAST_ARTICULATED_MESSAGE_DESCRIPTION_ASSIGNMENT": "de las veces, los usuarios articulan este mensaje",
      "OTHERS_SINGULAR": "y 1 más",
      "OTHERS_PLURAL": "y {{ count }} más",
      "PAGINATION_PREVIOUS": "Anterior",
      "PAGINATION_NEXT": "Siguiente",
      "HOUR_LABEL": "hora",
      "SESSIONS_LABEL": "sesiones"
    },
    "personalizedPractice": {
      "TITLE": "Práctica personalizada",
      "DESCRIPTION": "¡Hola, {{userFirstName}}! Las prácticas personalizadas te permiten establecer tus propios escenarios para que sean lo más realistas posible.",
      "LOADING": "Cargando...",
      "VIEW_SESSIONS": "Ver sesiones",
      "VIEW_SIMULATION": "Ver simulación",
      "TOTAL_SESSION": "sesión total",
      "TOTAL_SESSIONS": "sesiones totales",
      "BREADCRUMB": "Práctica personalizada",
      "SCENARIO_DETAILS_TITLE": "Detalles del escenario",
      "SCENARIO_DETAILS_DESCRIPTION": "Selecciona variables de las opciones a continuación para ajustar la simulación a tus necesidades.",
      "AVATAR": "Avatar",
      "SELECT_PLACEHOLDER": "Seleccionar",
      "CONVERSATION_TYPE": "Tipo de conversación",
      "SELECT_CONVERSATION_TYPE": "Seleccionar tipo de conversación",
      "LAUNCH_SIMULATION": "Iniciar simulación con selecciones",
      "PREVIOUS_SESSIONS": "Sesiones anteriores",
      "TOTAL": "Total",
      "FILTERS": "Filtros:",
      "DATE": "Fecha",
      "DIFFICULTY": "Dificultad",
      "TEMPERAMENT": "Temperamento",
      "SESSION_DATE": "Fecha de la sesión",
      "SESSION_SCORE": "Puntuación de la sesión",
      "DURATION": "Duración",
      "OVERALL_SCORE": "Puntuación general",
      "MESSAGING": "Mensaje",
      "METHODOLOGY": "Metodología",
      "SKILLS": "Habilidades",
      "RESULTS": "Resultados",
      "VIEW_FEEDBACK": "Ver comentarios",
      "OVERALL_SCORE_LABEL": "Puntuación global",
      "SCORE": "media",
      "NO_PRODUCTS_TITLE": "No hay productos disponibles",
      "NO_PRODUCTS_DESCRIPTION": "Aún no tienes productos de práctica personalizados.",
      "NO_SESSIONS_FOUND": "No se encontraron sesiones con los filtros seleccionados.",
      "TIME": "Tiempo",
      "ALL": "Todo",
      "LEARNER": "Estudiante",
      "MOOD": "Estado",
      "CLEAR_FILTERS": "Borrar filtros",
      "PAGINATION_PREVIOUS": "Anterior",
      "PAGINATION_NEXT": "Siguiente",
      "DURATION_MINUTES_SECONDS": "{{minutos}} m {{segundos}} s",
      "DURATION_SECONDS": "{{seconds}} s"
    },
    "login": {
      "TITLE": "Bienvenido de nuevo",
      "SUB_TITLE": "¿Cómo te gustaría iniciar sesión?  ",
      "LOGIN_WITH_SSO": "Iniciar sesión con el SSO de la empresa",
      "LOGIN_WITH_PASSWORD": "Iniciar sesión con contraseña",
      "PROVIDE_EMAIL": "Proporciona tu dirección de correo electrónico",
      "HELP_TEXT": "¿Necesitas ayuda? Contacto",
      "EMAIL_ERROR": "No podemos iniciar sesión, por favor contacta al administrador de tu empresa o al departamento de TI.",
      "EMAIL": "Correo electrónico",
      "LOGIN": "Iniciar sesión",
      "ALERT": "Alerta",
      "EMAIL_PLACEHOLDER": "olivia@untitledui.com",
      "LOGIN_CONSENT_MESSAGE": "Al iniciar sesión en tu cuenta, aceptas los {{termsLink}} y {{privacyLink}}.",
      "TERMS_OF_SERVICE": "Condiciones de uso",
      "PRIVACY_POLICY": "Política de privacidad",
      "WRONG_REGION_MESSAGE": "No podemos iniciar sesión, por favor contacta al administrador de tu empresa.",
      "WRONG_REGION_LINK": "También puedes intentar iniciar sesión en el sitio de {{regionName}}."
    },
    "learningPathway": {
      "BEGIN": "Comenzar",
      "DUE_DATE": "Fecha de vencimiento",
      "FOOTER_SUBTITLE_READY": "¡Pregúntame cualquier cosa! Estoy listo para ayudar.",
      "LEAVE_STEP": "Dejar paso",
      "NEXT_STEP": "Siguiente paso",
      "NOTIFICATIONS_ARIA": "Notificaciones",
      "PDF_NEXT_PAGE": "Siguiente página",
      "PDF_NO_SOURCE": "No se proporcionó fuente PDF.",
      "PDF_PREVIOUS_PAGE": "Página anterior",
      "POST_CALL_SUBTITLE": "Deja algún comentario mientras procesamos tus resultados",
      "POST_CALL_TITLE": "Has llegado al final de este cuestionario.",
      "SETTINGS": "Ajustes",
      "TOAST_CONTENT": "Haz clic abajo para ver, o regresa a la pantalla de detalles de la ruta para tu siguiente paso.",
      "TOAST_TITLE": "Los resultados de tu juego de rol {{stepName}} han sido procesados.",
      "ASSIGNMENTS": "Tareas",
      "USER_FALLBACK": "Usuario",
      "VIEW_RESULTS": "Ver resultados",
      "QUIZ_TITLE": "Cuestionario",
      "SUBMIT_ANSWER": "Enviar respuesta",
      "CONTINUE": "Continuar",
      "REVIEW_MATERIAL": "Revisar material",
      "ASK_QUESTIONS_ABOUT_PATHWAY": "Haz preguntas sobre la ruta",
      "FOOTER_SUBTITLE_MUTED": "Ahora mismo tienes el micrófono silenciado. El entrenador no te oye.",
      "FOOTER_SUBTITLE_LISTENING": "Escuchando tu pregunta...",
      "FOOTER_SUBTITLE_THINKING": "Pensando en una respuesta...",
      "PDF_LOADING": "Cargando PDF",
      "PDF_SCROLL_HINT": "Desplázate para seguir leyendo",
      "QUIZ_OVERALL_SCORE_TOOLTIP": "La puntuación total es la media ponderada de tus respuestas en este intento.",
      "QUIZ_COLUMN_DATE": "Fecha",
      "QUIZ_COLUMN_OVERALL_SCORE": "Puntuación global",
      "QUIZ_COLUMN_ANSWER_POINTS": "Puntos de respuesta",
      "QUIZ_COLUMN_RESULTS": "Resultados",
      "COMPLETE_STEP": "Completado",
      "ERROR_TITLE": "Ha ocurrido un error",
      "ERROR_MESSAGE": "Sal y vuelve a entrar a la ruta. Si el problema persiste, ponte en contacto con",
      "ERROR_HELP_EMAIL": "help@quantified.ai",
      "PATHWAY_COMPLETED_TITLE": "Has completado esta ruta",
      "PATHWAY_COMPLETED_BODY": "Puedes consultar tus resultados en cualquier momento o volver a cualquier paso para seguir practicando.",
      "PATHWAY_COMPLETED_RETURN": "Volver a las tareas",
      "PATHWAY_OUT_OF_ATTEMPTS_TITLE": "Ya no te quedan intentos para completar un paso de la ruta",
      "PATHWAY_OUT_OF_ATTEMPTS_BODY": "Habla con tu gerente para comentar los próximos pasos.",
      "COMPLETED": "Completada",
      "EXITING_QUIZ_EARLY": "Si sales ahora de este cuestionario, se contará como un intento",
      "TRY_AGAIN": "Inténtalo de nuevo",
      "RETURN_TO_PATHWAY": "Volver a la página de inicio de la ruta",
      "REVIEW_BEFORE_QUIZ_TOOLTIP": "Revisa este paso antes de volver a intentar el cuestionario",
      "FOOTER_SUBTITLE_QUIZ_RESULT_DONE": "Haz clic en el botón de la derecha →",
      "VIEW_CALL_DETAILS": "Ver detalles de la llamada",
      "FOOTER_SUBTITLE_READY_LEARN_WITH_X": "El entrenador está escuchando si tienes alguna pregunta",
      "COLUMN_DATE": "Fecha",
      "COLUMN_OVERALL_SCORE": "Puntuación global",
      "COLUMN_RESULTS": "Resultados",
      "COLUMN_ANSWER_POINTS": "Puntos de respuesta",
      "COLUMN_MESSAGING_SCORE": "Puntuación de adherencia al mensaje",
      "COLUMN_METHODOLOGY_SCORE": "Puntuación de metodología",
      "COLUMN_SKILLS_SCORE": "Puntuación de habilidades",
      "PRACTICE_AGAIN": "Practica de nuevo",
      "DEBRIEF_LATEST_SESSION": "Resumen de la última sesión",
      "EXIT_MODAL_TITLE": "¿Seguro que quieres terminar este juego de rol?",
      "EXIT_MODAL_EXIT": "Salir",
      "EXIT_MODAL_RESUME": "Continuar",
      "EXIT_MODAL_DESC_LIMITED_ATTEMPTS": "Si abandonas el juego de rol ahora, no se puntuará, pero seguirá contando como un intento.",
      "EXIT_MODAL_DESC_UNLIMITED_ATTEMPTS": "Si abandonas el juego de rol ahora, no se puntuará.",
      "EXIT_MODAL_DESC_SCORED": "Si abandonas el juego de rol ahora, calificaremos tu llamada tal cual.",
      "RESULTS_PROCESSING": "Los resultados se están procesando",
      "RESULTS_FAILED": "No se pudieron cargar los resultados. Ponte en contacto con help@quantified.ai",
      "DEBRIEF_TITLE": "Sesión informativa",
      "DEBRIEF_DESCRIPTION": "Comenta los resultados de tu último intento de certificación",
      "DEBRIEF_DESCRIPTION_PRACTICE": "Comenta los resultados de tu última sesión de práctica",
      "VIEW_ALL_SESSIONS": "Ver todas las sesiones",
      "COLLAPSE_SESSIONS": "Contraer las sesiones",
      "VIEW_ALL_ATTEMPTS": "Ver todos los intentos",
      "COLLAPSE_ATTEMPTS": "Contraer los intentos",
      "REATTEMPT_CERTIFICATION": "Volver a intentar la certificación",
      "DEBRIEF_EXIT_MODAL_TITLE": "¿Seguro que quieres finalizar esta sesión informativa?",
      "DEBRIEF_EXIT_MODAL_DESC": "Si sales de la sesión informativa ahora, no se marcará como completada.",
      "EXIT_PATHWAY": "Salir de la ruta",
      "HELP": "Ayuda",
      "LEARN_STEP_HELP_CLOSE": "Cerrar",
      "LEARN_STEP_HELP_TROUBLE": "Si sigues teniendo problemas, ponte en contacto con",
      "LEARN_STEP_HELP_EMAIL": "help@quantified.ai",
      "LEARN_STEP_HELP_VIDEO_P1": "Mira el material y pregúntale al entrenador lo que quieras.",
      "LEARN_STEP_HELP_VIDEO_P2": "Selecciona el botón de reproducción para iniciar el vídeo. Puedes retroceder para repasar el material.",
      "LEARN_STEP_HELP_VIDEO_P3": "Activa el micrófono en la parte inferior derecha para hacer una pregunta. Esto pausará el vídeo. Al reproducir el vídeo, silenciaremos tu micrófono.",
      "LEARN_STEP_HELP_VIDEO_P4": "Cuando hayas visto el vídeo completo, pasa al siguiente paso.",
      "LEARN_STEP_HELP_PDF_P1": "Lee el material y hazle cualquier pregunta al entrenador.",
      "LEARN_STEP_HELP_PDF_P2": "Navega por el contenido desplazándote con el ratón o usando las flechas de cada lado para pasar de una página a otra.",
      "LEARN_STEP_HELP_PDF_P3": "Puedes silenciar o reactivar tu micrófono en la parte inferior derecha.",
      "LEARN_STEP_HELP_PDF_P4": "Cuando hayas leído todo, pasa al siguiente paso.",
      "PDF_FULLSCREEN_ENTER": "Pasar a pantalla completa",
      "PDF_FULLSCREEN_EXIT": "Salir de pantalla completa",
      "PDF_ZOOM_IN": "Acercar",
      "PDF_ZOOM_OUT": "Alejar",
      "ASSESSMENT_EXIT_MODAL_TITLE": "¿Seguro que quieres continuar?",
      "ASSESSMENT_EXIT_MODAL_DESC": "Avanzar antes de que esta conversación se complete resultará en una experiencia de aprendizaje más larga y menos personalizada.",
      "ASSESSMENT_EXIT_MODAL_RESUME": "Reanudar la evaluación",
      "ASSESSMENT_EXIT_MODAL_PROCEED": "Proceder",
      "ASSESSMENT_PERSONALIZATION_ERROR_TITLE": "No hemos podido personalizar tu ruta",
      "ASSESSMENT_PERSONALIZATION_ERROR_DESC_START": "Te hemos asignado la ruta completa; ponte en contacto con ",
      "ASSESSMENT_PERSONALIZATION_ERROR_DESC_END": " si quieres volver a intentar la personalización",
      "OPTIONAL": "Opcional",
      "DISMISS": "Descartar",
      "DOWNLOAD": "Descargar"
    },
    "leaderboard": {
      "LEADERBOARD": "Clasificación",
      "TOP10PERCENT": "El 10 % más alto",
      "PRACTICE_ASSIGNMENT": "Tareas de práctica",
      "SIMULATION": "Simulación",
      "SELECT_ASSIGNMENT": "Seleccionar tarea",
      "SELECT_SIMULATION": "Seleccionar simulación",
      "SELECT_ASSIGNMENT_AND_SIMULATION": "Seleccione una tarea y una simulación para ver a los líderes",
      "NO_DATA": "Aún no hay actividad. Una vez que el equipo empiece a participar, verás que las clasificaciones aparecen aquí.",
      "NO_ASSIGNMENTS_AVAILABLE": "No hay asignaciones disponibles",
      "NO_SIMULATIONS_AVAILABLE": "No hay simulaciones disponibles",
      "NAME": "Nombre",
      "HIGH_SCORE": "Puntuación alta",
      "AVERAGE_SCORE": "Puntuación media",
      "TOTAL_SESSIONS": "Sesiones totales",
      "LAST_SESSION": "Última sesión",
      "TOP5": "Mejores 5",
      "OF": "de",
      "ENGAGED_USERS": "usuarios participantes",
      "ENGAGED_USER": "usuario participante",
      "HIDE_SESSIONS_WITH_LOW_SCORE": "Ocultar las sesiones con puntuaciones bajas",
      "SESSIONS_WITH_LOW_SCORE_TOOLTIP": "Las sesiones con una puntuación de «en desarrollo» en la sección de habilidades no contribuirán a las columnas de puntuación alta o media.",
      "NO_USERS_ENGAGED": "No hay usuarios participantes",
      "PAGINATION_PREVIOUS": "Anterior",
      "PAGINATION_NEXT": "Siguiente"
    },
    "hotjarSurveys": {
      "FEEDBACK_MESSAGE": "No dudes en compartir tu opinión para ayudarnos a mejorar.",
      "THANK_YOU_MESSAGE": "Gracias, seguiremos trabajando para mejorar tu experiencia."
    },
    "general": {
      "NEED_HELP_QUESTION": "¿Necesitas ayuda?",
      "CONTACT": "Contacto",
      "HELP_EMAIL": "help@quantified.ai",
      "PARENT_ACCOUNT": "Cuenta principal",
      "ACCOUNT": "Cuenta",
      "CHECKMARK": "Marca de verificación",
      "ICON": "Icono",
      "ALERT": "alerta",
      "HEADS_UP": "¡Atención!",
      "USE_HEADPHONES_FOR_OPTIMAL_AUDIO": "Para obtener un sonido óptimo en iPad, utiliza auriculares.",
      "SETTINGS": "AJUSTES",
      "RP": "RP",
      "EMAIL_LABEL": "Correo electrónico",
      "RAVEN_EMAIL": "Raven@InspireHR.com",
      "TEAM_MANAGER_FOR": "Gerente de equipo de",
      "MIAMI_SALE": "ventas en Miami",
      "CHARLOTTE_SALES": "ventas en Charlotte",
      "ATLANTA_SALES": "ventas en Atlanta",
      "TEAM": "Equipo",
      "ASSIGNMENTS": "Tareas",
      "MY_TEAMS": "Mis equipos",
      "REPORTING": "Informes",
      "DASHBOARD": "Panel",
      "LEADERBOARD": "Clasificación",
      "PERSONALIZED_PRACTICE": "Práctica personalizada",
      "HELP_SEARCH_OUR": "Busca en nuestra",
      "HELP_OR_REACH_OUT_TO": "o comunícate con",
      "HELP_WITH_QUESTIONS": "con preguntas",
      "KNOWLEDGE_BASE": "base de conocimientos",
      "NO_ROLE_WEB_MESSAGE": "A este usuario no se le ha concedido acceso al sistema. Ponte en contacto con un administrador del sistema.",
      "NO_ROLE_IOS_TITLE": "Nuestra aplicación se centra en la experiencia del estudiante",
      "NO_ROLE_IOS_BODY_START": "Accede a nuestra",
      "NO_ROLE_IOS_WEB_APP": "aplicación web",
      "NO_ROLE_IOS_BODY_END": "en el navegador de tu móvil para disfrutar de funcionalidades adicionales.",
      "HELP_SECTION": "AYUDA",
      "ABOUT_SECTION": "ACERCA DE",
      "CONTACT_SUPPORT": "Ponte en contacto con el servicio de asistencia",
      "OPEN_WEB_APP": "Abrir la aplicación web",
      "SEARCH_KNOWLEDGE_BASE": "Buscar en la base de conocimientos",
      "PRIVACY_POLICY": "Política de privacidad",
      "TERMS_OF_SERVICE": "Condiciones de uso",
      "VERSION": "Versión",
      "LOG_OUT": "Cerrar sesión"
    },
    "dashboard": {
      "ALL": "Todo",
      "IN_COMPLETE": "Incompleto",
      "COMPLETED": "Completada",
      "NO_ASSIGNMENT_TITLE": "No tienes ninguna tarea.",
      "NO_ASSIGNMENT_DETAILS": "Se te notificará cuando tengas tareas que completar.",
      "IN_COMPLETE_ASSIGNMENT_TITLE": "No tienes tareas incompletas.",
      "IN_COMPLETE_ASSIGNMENT_DETAILS": "Se te notificará cuando haya una nueva tarea pendiente.",
      "COMPLETED_ASSIGNMENT_TITLE": "No tienes tareas completadas.",
      "COMPLETED_ASSIGNMENT_DETAILS": "Vuelve a comprobarlo una vez que hayas completado una tarea.",
      "VIEW_ASSIGNMENT": "Ver tarea",
      "ASSIGNMENT_LABEL": "Tareas",
      "MODULE_ASSIGNMENT_ALT": "Icono de asignación de módulo",
      "VIEW_ASSIGNMENT_FOR": "Ver tarea de",
      "DAY": "Día",
      "UNTILL_DUE": "Hasta el vencimiento",
      "PAST_DUE": "De retraso",
      "AVAILABLE_IN": "Disponible en",
      "DUE_TODAY": "Vence hoy",
      "PRACTICE": "Práctica",
      "CERTIFICATION": "Certificación",
      "UPCOMING": "Próximamente",
      "TEST_ASSIGNMENT": "Tarea de prueba",
      "CLOSED": "Cerrado",
      "NO_ASSIGNMENT_FILTERED_TITLE": "No se encontraron tareas.",
      "NO_ASSIGNMENT_FILTERED_DETAILS": "Intenta ajustar tus filtros para ver las tareas disponibles, o vuelve más tarde cuando se añadan nuevas tareas.",
      "VIEW_PATHWAY": "Ver ruta",
      "TOTAL": "Total",
      "STATUS_LABEL": "Estado",
      "STATUS_SELECTION_LABEL": "Estado:",
      "ASSIGNMENT_TYPE": "Tipo de tarea",
      "ASSIGNMENT_TYPE_SELECTION_LABEL": "Tipo de tarea:",
      "NOT_STARTED": "Sin iniciar",
      "CERTIFIED": "Certificadas",
      "NOT_CERTIFIED": "No certificado",
      "IN_PROGRESS": "En curso",
      "PATHWAY": "Ruta de aprendizaje",
      "SELECT_ALL": "Seleccionar todo",
      "DESELECT_ALL": "Deseleccionar todo",
      "GET_STARTED": "Empieza",
      "ASSIGNMENT_STATUS_LABEL": "Estado de la tarea",
      "ASSIGNMENT_STATUS_SELECTION_LABEL": "Estado de la tarea:",
      "CLEAR_STATUS": "Borrar estado",
      "ENDED": "Terminado",
      "START_PATHWAY": "Iniciar ruta",
      "DAYS": "Días",
      "OTHERS_SINGULAR": "y 1 más",
      "OTHERS_PLURAL": "y {{ count }} más"
    },
    "cognito": {
      "INVITATION_SUBJECT": "¡Te damos la bienvenida a Quantified!",
      "INVITATION_MESSAGE": "Estamos encantados de tenerte con nosotros. Para empezar, sigue los pasos que se indican a continuación para acceder a tu cuenta por primera vez.",
      "ACCOUNT_DETAILS": "Datos de tu cuenta:",
      "USERNAME": "Nombre de usuario",
      "PASSWORD": "Contraseña temporal",
      "STEPS_LABEL": "Próximos pasos para iniciar sesión",
      "STEP_1": "1. Haz clic en el botón «Iniciar sesión» para ir a la página de inicio de sesión.",
      "STEP_2": "2. Introduce el nombre de usuario y la contraseña temporal que te hemos proporcionado anteriormente.",
      "STEP_3": "3. Una vez que te hayas conectado, se te pedirá que crees una nueva contraseña.",
      "LOGIN_BUTTON": "Iniciar sesión",
      "ABOUT_US": "El simulador de Quantified es un entorno virtual diseñado para ayudarte a desarrollar rápidamente habilidades esenciales, lo que te permite conectar y comunicarte más eficazmente con tus clientes.",
      "EXPIRY_TIME": "Esta contraseña temporal caducará en 24 horas. Si tienes problemas para iniciar sesión, ponte en contacto con nuestro equipo de asistencia en",
      "TEAM": "el Equipo de Quantified",
      "INVITATION_SMS_USERNAME": "Tu nombre de usuario es",
      "INVITATION_SMS_PASSWORD": "y tu contraseña temporal es",
      "AUTHENTICATION_CODE": "Tu código de autenticación es",
      "PASSWORD_RESET_CODE": "Tu código de restablecimiento de contraseña de Quantified",
      "RESET_PASSWORD_EMAIL": "Correo electrónico de restablecimiento de contraseña",
      "HELLO": "¡Hola!",
      "USE_VERIFICATION_CODE": "Has solicitado restablecer la contraseña. Utiliza el código de verificación que aparece a continuación para completar el proceso.",
      "VERIFICATION_CODE": "Código de verificación",
      "NEXT_STEP": "Próximos pasos",
      "RESET_PASSWORD_PAGE": "Vuelve a la página de restablecimiento de contraseña en el navegador.",
      "ENTER_VERIFICATION_CODE": "Introduce el código de verificación cuando se te solicite.",
      "CREATE_PASSWORD": "Una vez verificado el código, sigue las instrucciones para crear una nueva contraseña.",
      "DISREGARD_NOTE": "Si no has solicitado restablecer tu contraseña, ignora este correo electrónico.",
      "CONTACT_SUPPORT": "Si necesitas más ayuda, ponte en contacto con nuestro equipo de asistencia en",
      "HELP_EMAIL": "help@quantified.ai",
      "THANK_YOU": "Atentamente,",
      "QUANTIFIED_TEAM": "el Equipo de Quantified",
      "ADDRESS": "4200 Marathon Blvd, Suite 210, Austin, Texas 78756, Estados Unidos",
      "RETURN_TO_PATHWAY": "Volver a la página de inicio de la ruta"
    },
    "call": {
      "LOADING": "Cargando",
      "SIMULATION_PAUSED": "La simulación se ha pausado.",
      "CLICK_RESUME": "Haz clic en el botón «Reanudar» para continuar.",
      "NO_INTERNET": "Sin conexión a Internet",
      "TRY_AGAIN": "Revisa tu conexión y vuelve a intentarlo.",
      "MIC_MUTED": "El micrófono está silenciado",
      "MIC_MUTED_DESCRIPTION": "Vaya, parece que el micrófono está silenciado. Desactiva el silencio para responder y continuar.",
      "NO_RESPONSE": "No se detectó respuesta",
      "MIC_NOT_CONNECTED": "Vaya, parece que el micrófono no está conectado. Vuelve a seleccionar tu dispositivo para responder y continuar.",
      "AUDIO_ISSUE": "Vaya, algo ha ido mal. Comprueba la configuración de tu dispositivo y asegúrate de que estás en un lugar tranquilo y sin ruidos de fondo.",
      "LOADING_ALT": "Cargando...",
      "REPEAT_RESPONSE": "Se te remitirá automáticamente a la simulación para que repitas tu respuesta y vuelvas a intentarlo.",
      "NEEDS_MORE_TIME_QUESTION": "necesita más tiempo para pensar, ¿quieres esperar?",
      "NEEDS_MORE_TIME": "necesita más tiempo para pensar.",
      "WAIT_OR_END_CALL": "Te informaremos cuando estén listos, o puedes finalizar la llamada y",
      "RETURN_TO_ASSIGNMENTS": "volver a la tarea",
      "READY": "Listo",
      "IS_READY": "está listo/a para continuar la conversación.",
      "TRY_AGAIN_LABEL": "Inténtalo de nuevo",
      "CHECK_SETTINGS": "Verificar ajustes",
      "PAUSED_SIMULATION": "Has pausado esta simulación.",
      "PAUSED_SIMULATION_DESCRIPTION": "La grabación de vídeo y audio se pausan hasta que se reanude la simulación.",
      "RESUME": "Continuar",
      "SETTINGS": "Ajustes",
      "CAPTURING_RESPONSE": "Capturando las respuestas",
      "TOUR_MESSAGE": "Una vez que termines de hablar, asegúrate de hacer clic en el botón Continuar para garantizar que las respuestas se capturan y puntúan.",
      "NEXT": "Siguiente",
      "START_CALL": "Comenzar",
      "END_CALL_TITLE": "¿Seguro de que deseas terminar esta simulación?",
      "END_CALL_DESCRIPTION": "Si terminas la simulación ahora, no recibirás una puntuación ni comentarios sobre la conversación.",
      "END_CALL": "Finalizar",
      "BROWSER_ACCESS_DENIED": "Tu navegador tiene denegado el acceso a este dispositivo.",
      "COPY_SESSION_ID_BUTTON": "Copiar ID de sesión",
      "TIPS_GUIDANCE_MESSAGE": "Aquí aparecerán temas de conversación y consejos.",
      "CONTINUE": "Continuar",
      "SESSION_ID_LABEL": "ID de sesión:",
      "SESSION_ID_COPIED": "¡ID de sesión copiado!",
      "HINTS_AND_SUGGESTIONS_TITLE": "Pistas y sugerencias",
      "HINT_LABEL": "Pista",
      "CAPTIONS_LABEL": "Subtítulos",
      "PAUSE_LABEL": "Pausa",
      "VIDEO_LABEL": "Vídeo",
      "PARTY_EMOJI": "emoji de fiesta",
      "CALL_ENDED_MESSAGE": "Has llegado al final de esta simulación.",
      "CALL_ENDED_INACTIVITY": "Esta simulación ha terminado por inactividad",
      "CALL_ENDED_GENERIC": "Esta simulación ha terminado",
      "FEEDBACK_PROMPT": "Deja algún comentario mientras procesamos tus resultados.",
      "INTERACTION_THRESHOLD_NOT_MET": "No has alcanzado nuestro umbral de interacción para la puntuación, inténtalo de nuevo.",
      "REALISTIC_CONVERSATION_QUESTION": "¿Te pareció realista y natural esta conversación?",
      "KNOWLEDGEABLE_PREPARED_QUESTION": "¿Te sientes más informado y preparado después de esta simulación?",
      "FEEDBACK_THANK_YOU": "¡Gracias por tus comentarios!",
      "FEEDBACK_IMPROVEMENT_NOTE": "¡Gracias por tus comentarios! Trabajaremos en mejorar la experiencia.",
      "AUDIO": "Audio",
      "VISUAL_AID_LOAD_ERROR": "No se pudo cargar la ayuda visual",
      "BEGIN_CALL": "Comenzar",
      "LEAVE_CALL_BRIEFING": "Dejar la sesión",
      "RESTORE_CALL": "Restaurando la simulación",
      "FEW_SECONDS": "Esto puede tardar unos segundos.",
      "CHECK_ALT": "Comprobar",
      "COPY_ALT": "Copiar",
      "HINTS_ALT": "Pistas",
      "CLOSE_CAPTIONS": "Cerrar subtítulos",
      "MICROPHONE_MUTED": "Micrófono silenciado",
      "RETURN_TO_CALL": "Volver a la simulación",
      "YES": "Sí",
      "NO": "No",
      "VIEW_RESULTS": "Ver resultados",
      "RETURN_TO_ASSIGNMENT": "Volver a la tarea",
      "HAVING_ISSUES": "Tenemos problemas para conectarnos, comprueba tu conexión a Internet y haz clic en Aceptar.",
      "OK": "Aceptar",
      "RESULTS_NOT_GENERATED": "Lo sentimos, no podemos generar resultados en este momento, inténtalo de nuevo.",
      "INACTIVITY_ALERT_MESSAGE": "Esta llamada ha finalizado por inactividad. Habla con el avatar para continuar o selecciona “Finaliza llamada” para terminar la llamada.",
      "INACTIVITY_DEFAULT_ALERT_TITLE": "Esta llamada terminará en {{secondsUntilHangup}} segundos",
      "INACTIVITY_SHORT_ALERT_TITLE": "Esta llamada terminará en unos segundos",
      "TELL_YOUR_GENDER_HEADING": "Indícanos tu género:",
      "BY_KNOWING_YOUR_GENDER_DESCRIPTION": "Al conocer tu género, el avatar puede utilizar la gramática adecuada, lo que hace que la conversación sea más natural y realista.",
      "GENDER_SELECTION": "Selección de género:",
      "SELECT_OPTION": "Selecciona una opción",
      "CONFIRM": "Confirmar",
      "MALE": "Masculino",
      "FEMALE": "Femenino",
      "NON_BINARY": "No binario/Otro",
      "PREFER_NOT_TO_ANSWER": "Prefiero no contestar",
      "NON_BINARY_MESSAGE": "Entendemos y respetamos tu identidad de género no binaria. Debido a las limitaciones tecnológicas actuales, utilizamos pronombres masculinos por defecto. Te informamos que estamos trabajando en mejoras para dar cabida a todas las identidades de género en el futuro. Gracias por tu comprensión y paciencia.",
      "PREFER_NOT_TO_ANSWER_MESSAGE": "Respetamos tu decisión de no indicar tu género. En estos casos, nuestra tecnología utiliza por defecto pronombres masculinos debido a las limitaciones actuales.",
      "DISPLAY_VISUAL_AID": "Mostrar la ayuda visual",
      "FULL_SCREEN": "Pantalla completa",
      "COLLAPSE": "Contraer",
      "COMPLETED_CONVERSATION_MESSAGE": "Gracias por completar esta conversación.",
      "CONVERSATION_COMPLETION_FEEDBACK": "Deja algunos comentarios mientras procesamos tu conversación.",
      "ERROR_MESSAGE": "Ha habido un error. Ponte en contacto con",
      "SAVED_CONVERSATION_MESSAGE": "Tu conversación ha sido guardada.",
      "RETURN_TO_MY_ASSIGNMENTS": "Regresar a mis tareas",
      "RETURN_TO_PERSONALIZED_PRACTICE": "Volver a la práctica personalizada",
      "PERSONALIZED_CALL_NOTE": "Acabas de completar una conversación de práctica personalizada.",
      "LEAVE_STEP_TITLE": "¿Seguro que quieres dejar este paso?",
      "EXIT": "Salir",
      "CERT_ACK_TITLE": "Agradecimiento por el vídeo de certificación",
      "CERT_ACK_ACCEPT_AND_BEGIN": "Aceptar y empezar",
      "CERT_ACK_RESUME_CALL": "Reanudar llamada",
      "CERT_ACK_PROCESSING": "Procesando...",
      "CERT_ACK_CAMERA_WARNING": "Activa la cámara para continuar con la certificación.",
      "CERT_ACK_CAMERA_OFF_DURING_CALL": "Tu cámara estaba apagada. Vuelve a activar la cámara para continuar con la certificación.",
      "CERT_ACK_TEXT_1": "Para garantizar la integridad y la imparcialidad de esta certificación, la cámara debe permanecer encendida durante toda la sesión, y esta será supervisada. Este requisito tiene por objeto confirmar el cumplimiento de todas las normas de certificación.",
      "CERT_ACK_TEXT_2": "Al continuar, reconoces y aceptas estos requisitos.",
      "CERT_ACK_END_CALL": "Finalizar llamada",
      "LAUNCH_SIMULATION": "Iniciar simulación",
      "DEBRIEF_LATEST_SESSION": "Resumen de la última sesión",
      "RECONNECTING_AUDIO": "Reconectando el audio...",
      "END": "Finalizar",
      "START_DEBRIEF": "Resumen de la última sesión",
      "MOVE_TO_NEXT": "Pasar al siguiente paso",
      "RETRY_ROLEPLAY": "Volver a intentar el juego de roles",
      "EXIT_PATHWAY": "Salir de la ruta",
      "PROCESSING": "Procesando...",
      "FEEDBACK_PROMPT_REQUIRED": "Deja un comentario antes de ver tus resultados.",
      "MUTE": "Silenciar",
      "UNMUTE": "Activar sonido",
      "SCREENSHARE_LABEL": "Compartir pantalla",
      "SCREENSHARE_UNSUPPORTED_TITLE": "{{callName}} utiliza la función de compartir pantalla",
      "SCREENSHARE_UNSUPPORTED_MESSAGE_APP": "Para continuar con la llamada, utiliza nuestra aplicación en lugar de tu navegador.",
      "SCREENSHARE_UNSUPPORTED_MESSAGE_DESKTOP": "Para continuar con la llamada, accede a ella desde un ordenador de sobremesa.",
      "SCREENSHARE_UNSUPPORTED_CLOSE_BUTTON": "Cerrar",
      "SCREENSHARE_UNSUPPORTED_GO_TO_APP_BUTTON": "Ir a la aplicación",
      "SCREENSHARE_UNSUPPORTED_GO_TO_APP_UNAVAILABLE": "La aplicación móvil aún no está disponible. Vuelve a comprobarlo más adelante.",
      "SCREENSHARE_STOP_LABEL": "Dejar de compartir la pantalla",
      "SCREENSHARE_PIP_REOPEN_LABEL": "Volver a abrir la vista previa del vídeo",
      "SCREENSHARE_ACTIVE_LABEL": "Ahora mismo estás compartiendo pantalla",
      "SCREENSHARE_OS_PERMISSION_HINT": "No se ha podido iniciar el uso compartido de pantalla. Activa la grabación de pantalla para tu navegador en Ajustes del sistema > Privacidad y seguridad, y vuelve a intentarlo.",
      "SCREENSHARE_SAFARI_BLOCKED_HINT": "Safari ha bloqueado el uso compartido de pantalla para esta sesión. Cierra sesión y vuelve a iniciar sesión; a continuación, vuelve a intentarlo."
    },
    "assignment": {
      "STATUS": "ESTADO",
      "SCORE": "PUNTUACIÓN",
      "MUST_ACHIEVE": "Debes lograr un",
      "OR_HIGHER": "o más",
      "TEST": "Prueba",
      "OUT_OF_5": "sobre 5",
      "LATEST_ATTEMPT": "ÚLTIMO INTENTO",
      "TOTAL_ATTEMPTS": "intentos totales",
      "UNLIMITED": "Ilimitado",
      "REMAINING": "Restante",
      "VIEW_CALL_DETAILS": "Ver detalles",
      "MAX_ATTEMPTS_REACHED": "Has alcanzado el número máximo de intentos",
      "DUE_DATE": "Fecha de vencimiento",
      "DAYS": "Días",
      "DAY": "Día",
      "UNTILL_DUE": "Hasta el vencimiento",
      "PAST_DUE": "De retraso",
      "ONGOING": "En curso",
      "SCORE_REQUIREMENT": "Requisito de puntuación",
      "SCORE_REQUIREMENT_DETAIL": "Debes lograr una puntuación de",
      "TO_COMPLETE_EACH_CALL": "para completar cada simulación requerida.",
      "CALLS_IN_ASSIGNMENT": "Simulaciones asignadas",
      "INCOMPLETE_CALL": "Incompleto",
      "PREVIOUS_RESULTS": "Resultados anteriores",
      "DATE": "Fecha",
      "RESULTS": "Resultados",
      "VIEW_PREVIOUS_RESULTS": "Ver resultados anteriores",
      "VIEW_FEEDBACK": "Ver comentarios",
      "LAUNCH_CALL": "Iniciar",
      "CLOSE_BUTTON": "Botón de cerrar",
      "CHECKMARK": "marca de verificación",
      "CALL": "Llamada",
      "QUESTION": "Pregunta",
      "COMPLETED": "Completada",
      "IN_PROGRESS": "En progreso",
      "NOT_STARTED": "Sin iniciar",
      "CERTIFIED": "Certificadas",
      "GUIDED": "Guiada",
      "CONVERSATIONAL": "Conversacional",
      "GUIDED_SIMULATION": "Prueba de conocimientos",
      "CONVERSATIONAL_SIMULATION": "Juego de roles",
      "NO_ATTEMPTS_LEFT": "No quedan intentos",
      "NO_ATTEMPTS": "Ningún intento",
      "OVERVIEW": "Visión general",
      "ABOUT_THE_AVATAR": "Acerca del avatar",
      "SCORING_CRITERIA": "Criterios de puntuación",
      "SIMULATION_OVERVIEW": "Resumen de la simulación",
      "ABOUT_THE_PERSONA": "Sobre la persona",
      "OUTOF_COMPLIANCE": "Incumplimiento",
      "CLOSED": "Cerrado",
      "COMPLETED_CALLS": "Llamadas completadas"
    }
  },
  "es-MX": {
    "root": {
      "ADMIN_PORTAL": "PORTAL DEL ADMINISTRADOR",
      "SUPPORT": "SOPORTE",
      "U": "U",
      "USER": "Usuario",
      "LOGOUT": "Cierre de sesión",
      "ADMIN": "Administrador",
      "SUPPORT_SMALL": "Soporte",
      "QUANTIFIED_AI": "Quantified.AI",
      "MICROPHONE": "MICRÓFONO",
      "CAMERA": "CÁMARA",
      "ACCESS_DENIED": "ACCESO_DENEGADO"
    },
    "teams": {
      "MY_TEAMS": "Mis equipos",
      "COMPLETED": "Completada",
      "IN_PROGRESS": "En progreso",
      "NOT_STARTED": "Sin comenzar",
      "ASSIGNMET_MODULE": "Módulo de tarea",
      "START_DATE": "Fecha de inicio",
      "DUE_DATE": "Fecha de entrega",
      "ASSIGNED_MEMBERS": "Miembros asignados",
      "CALLS_IN_MODULE": "Simulaciones en módulo",
      "COMPLETION_REQUIRMENT": "Requisito de finalización",
      "COMPLETE_ALL_CALLS": "Completa todas las simulaciones con una puntuación de",
      "OR_HIGHER": "o más",
      "PROGRESS_OVERVIEW": "RESUMEN DEL PROGRESO",
      "TEAM_MEMBERS": "miembros del equipo",
      "AVERAGE_HIGH_SCORE": "Puntuación alta promedio",
      "AVERAGE_NUMBER_ATTEMPTS_CALL": "Número medio de intentos por simulación",
      "TOTAL_PRACTICES": "Total de prácticas",
      "INDIVIDUAL_CALL_PROGRESS": "PROGRESO INDIVIDUAL DE LA SIMULACIÓN",
      "OF_TEAM_MEMBERS": "de los miembros del equipo completaron",
      "AVERAGE_PRACTICES_TO_COMPLETION": "Promedio de prácticas hasta la finalización",
      "TEAM_MEMBER_DETAILS": "DETALLES DEL MIEMBRO DEL EQUIPO",
      "DOWNLOAD_ACTIVITY_REPORT": "Descargar informe de actividad",
      "TEAM_MEMBER": "Miembro del equipo",
      "PROGRESS": "Progreso",
      "CALLS_COMPLETED": "Simulaciones realizadas",
      "PRACTICES": "Sesiones de práctica",
      "MOST_RECENT_PRACTICE": "Sesión más reciente",
      "THIS_TEAM_HAS_NO_ACTIVE_ASSIGNMENTS": "Este equipo no tiene tareas activas en este momento",
      "CALL_NAME_LABEL": "Nombre de la simulación",
      "HIGHEST_SCORE": "Puntuación más alta"
    },
    "simulationBuilder": {
      "THRESHOLD": "Umbral",
      "TYPE": "Tipo",
      "SELECT_AN_OPTION": "Selecciona una opción",
      "CORRECT_FEEDBACK": "Retroalimentación correcta",
      "INCORRECT_FEEDBACK": "Retroalimentación incorrecta",
      "CORRECT_FEEDBACK_PLACEHOLDER": "Se muestra cuando el alumno acierta",
      "INCORRECT_FEEDBACK_PLACEHOLDER": "Se muestra cuando el alumno no acierta",
      "ENTER_MESSAGE_TEXT": "Introducir texto del mensaje...",
      "DELETE": "Eliminar",
      "SCORABLE": "Calificable",
      "MESSAGE_NUMBER": "Mensaje {{ index }}",
      "SEARCH_BY_SIMULATION_NAME": "Buscar por nombre de simulación",
      "SEARCH_BY_ASSIGNMENT_NAME": "Buscar por nombre de tarea",
      "SIMULATION_STATUS_PLACEHOLDER": "Estado de la simulación",
      "SIMULATION_STATUS_PREFIX": "Estado de la simulación:",
      "NO_SIMULATIONS_FOUND": "No se han encontrado simulaciones",
      "SELECT_ALL": "Seleccionar todo",
      "DESELECT_ALL": "Deseleccionar todo",
      "STATUS_TESTING": "Probando",
      "STATUS_DRAFT": "Borrador",
      "STATUS_PUBLISHED": "Publicado",
      "STATUS_ARCHIVED": "Archivada",
      "ASSIGNEES_ZERO_STATE_MESSAGE": "Aún no se ha asignado ningún usuario",
      "ADD_USERS_TO_ASSIGNMENT": "Agregar usuarios a la tarea",
      "NO_DATA_FOUND": "No se han encontrado datos",
      "NO_USERS_SELECTED": "Ningún usuario seleccionado",
      "COL_FIRST_NAME": "Nombre",
      "COL_LAST_NAME": "Apellido",
      "COL_EMAIL": "Correo electrónico",
      "COL_VIEW_USER": "Ver usuario",
      "COL_VIEW_ASSIGNMENT": "Ver tarea",
      "COL_ASSIGNMENT_NAME": "Nombre de la tarea",
      "COL_STATUS": "Estado",
      "COL_TEAM_ASSOCIATIONS": "Asociaciones de equipos",
      "COL_REPORTING_STATUS": "Estado de los informes",
      "BREADCRUMB_USERS": "Usuarios",
      "STATUS_STAGED": "Preparado",
      "STATUS_ACTIVE": "Activo",
      "STATUS_ENDED": "Finalizado",
      "STATUS_CLOSED": "Cerrado",
      "SEARCH_USERS_PLACEHOLDER": "Buscar usuarios",
      "NO_USERS_FOUND": "No se han encontrado usuarios",
      "USERS_TAB_LABEL": "Usuarios",
      "ADD_TO_ASSIGNMENT": "Agregar a la tarea",
      "ASSIGNMENTS_COUNT": "tareas",
      "REPORTING_EXCLUDED": "Excluido",
      "REPORTING_INCLUDED": "Incluido",
      "KEBAB_EDIT_TEAM_ASSOCIATIONS": "Editar asociaciones del equipo",
      "KEBAB_EXCLUDE_FROM_REPORTING": "Excluir de los informes",
      "KEBAB_INCLUDE_IN_REPORTING": "Incluir en los informes",
      "KEBAB_REMOVE_FROM_ASSIGNMENT": "Eliminar de la tarea",
      "NO_TEAMS": "—",
      "TEAMS_COUNT": "{{count}} equipos",
      "ADD_TO_ASSIGNMENT_MODAL_HEADING": "Agregar a la tarea",
      "FIELD_LABEL_ASSIGNMENT": "Tarea",
      "SEARCH_ASSIGNMENTS_PLACEHOLDER": "Buscar tareas",
      "BUTTON_SET_TEAM_ASSOCIATION": "Establecer asociaciones del equipo",
      "FIELD_LABEL_TEAM": "Equipo",
      "SEARCH_TEAM_PLACEHOLDER": "Buscar equipo",
      "BUTTON_BACK": "Volver",
      "BUTTON_CANCEL": "Cancelar",
      "BUTTON_ADD_TO_ASSIGNMENT": "Agregar a la tarea",
      "EDIT_TEAM_ASSOCIATIONS_HEADING": "Editar asociaciones del equipo",
      "EDIT_TEAM_ASSOCIATIONS_DESCRIPTION": "Para la tarea {{assignmentName}}",
      "BUTTON_SAVE_ASSOCIATIONS": "Guardar asociaciones",
      "REFERENCE_DOCUMENT_STATUS_UPLOADING": "– Subiendo…",
      "REFERENCE_DOCUMENT_STATUS_SUCCESS": "– 100 % subido",
      "REFERENCE_DOCUMENT_STATUS_ERROR": "– Error al subir el documento",
      "CREATE_SIMULATION_DETAILS_BUTTON": "Crear detalles de la simulación",
      "SELF_AUTHORING_DESCRIPTION": "Introduce un nombre, una breve descripción del escenario y cualquier documento específico de la simulación para comenzar",
      "CLICK_TO_UPLOAD": "Haz clic para subir",
      "OR_DRAG_AND_DROP": "o arrastra y suelta",
      "REFERENCE_DOCUMENTS_UPLOAD_DESCRIPTION": "PDF (máx. 50 MB)",
      "ASSIGNMENT_NAME_LABEL": "Nombre de la tarea *",
      "SIMULATION_NAME_LABEL": "Nombre de la simulación",
      "NAME_FIELD_DESCRIPTION": "Este nombre se puede cambiar más adelante",
      "PRODUCT_LABEL": "Producto",
      "SELECT_A_PRODUCT_PLACEHOLDER": "Selecciona un producto",
      "ADD_NEW_PRODUCT": "Agregar un nuevo producto",
      "SCENARIO_LABEL": "Escenario",
      "REFERENCE_DOCUMENTS_LABEL": "Documentos de referencia",
      "ACTION_CREATE_NEW": "Crear nuevo",
      "ACTION_CREATE": "Crear",
      "ACTION_DUPLICATE": "Duplicar",
      "ENTITY_TYPE_SIMULATION_DISPLAY": "Simulación",
      "ENTITY_TYPE_ASSIGNMENT_DISPLAY": "Tarea",
      "ENTITY_TYPE_SIMULATION_LOWER": "simulación",
      "ENTITY_TYPE_ASSIGNMENT_LOWER": "tarea",
      "MODAL_TITLE": "{{ action }} {{ type }}",
      "CONFIRM_BUTTON_LABEL": "{{ action }} {{ type }}",
      "DUPLICATE_NAME_ERROR_ASSIGNMENT": "Ya existe una tarea con el mismo nombre.",
      "DUPLICATE_NAME_ERROR_SIMULATION": "Ya existe una simulación con el mismo nombre.",
      "NAME_REQUIRED_ERROR": "Es obligatorio introducir un nombre.",
      "COPY_OF_PREFIX": "Copia de {{ name }}",
      "SCORE_DISTRIBUTION_TITLE": "Distribución actual de la puntuación",
      "EDIT_SECTIONS_AND_WEIGHTING": "Editar secciones y ponderación",
      "SCORING_WEIGHTS_TITLE": "Configurar la puntuación",
      "SCORING_WEIGHTS_DESCRIPTION": "Elige qué áreas se puntuarán y cuánto contribuye cada una a la calificación global. La suma de las ponderaciones de todas las secciones activas debe ser del 100 %. La sección de habilidades no puede tener una ponderación superior al 20 %.",
      "SCORING_WEIGHT_REQUIRED": "Obligatoria",
      "REFERENCE_DOCUMENT_STATUS_DELETING": "– Eliminando",
      "REFERENCE_DOCUMENT_DELETE_ERROR": "No se pudo eliminar el documento. Inténtalo de nuevo.",
      "REFERENCE_DOCUMENT_UPLOAD_ERROR": "No se pudo subir el documento. Inténtalo de nuevo.",
      "CONTENT_LIMIT_EXCEEDED_ERROR": "Se superó el límite de contenido. Elimina uno o más documentos para continuar.",
      "LAST_FACT_DELETE_WARNING_HEADING": "¿Desea eliminar el último dato?",
      "LAST_FACT_DELETE_WARNING_DESCRIPTION": "Si eliminas el último dato, se eliminarán todas las asociaciones de usuarios con esta simulación y su estado volverá a ser “Borrador”.",
      "LEAVE_CONFIRMATION_HEADING": "Salir de la creación de la simulación",
      "LEAVE_CONFIRMATION_DESCRIPTION": "¿Seguro de que deseas salir? Se perderá todo el progreso que hayas realizado.",
      "LEAVE_CONFIRMATION_LEAVE_BUTTON": "Salir",
      "METHODOLOGY_TITLE": "Metodología",
      "METHODOLOGY_SUBTITLE": "Valora el enfoque y la estructura de la llamada",
      "METHODOLOGY_WEIGHTING_LABEL": "Ponderación: {{ weight }} %",
      "METHODOLOGY_RUBRIC_LABEL": "Rúbrica de metodología",
      "SELECT_RUBRIC_PLACEHOLDER": "Seleccionar rúbrica",
      "SKILLS_TITLE": "Habilidades",
      "SKILLS_SUBTITLE": "Valora la comunicación y las habilidades interpersonales",
      "SKILLS_WEIGHTING_LABEL": "Ponderación: {{ weight }} %",
      "SKILLS_RUBRIC_LABEL": "Rúbrica de habilidades",
      "PROCESSING_DOCUMENTS_MESSAGE": "Procesando documentos…",
      "PROCESSING_DOCUMENTS_SUPPORTING_TEXT": "Si necesitas ausentarse un momento, puedes hacerlo; los resultados estarán listos en 5 minutos.",
      "CORE_SIGNAL_MESSAGE": "Interpretando tu contenido…",
      "SECTION_PLAN_MESSAGE": "Planificando la estructura de tu simulación…",
      "DERIVED_COMPONENT_MESSAGE": "Creando los componentes de tu simulación…",
      "COMPONENT_WAVE_1_MESSAGE": "Escribiendo el contenido de tu simulación…",
      "STILL_PROCESSING_TITLE": "Todavía se está procesando…",
      "STILL_PROCESSING_BODY": "Esto está tardando más de lo habitual; puedes salir de esta simulación y volver más tarde desde la vista de lista de simulaciones.",
      "PROCESSING_FAILED_TITLE": "Falló el procesamiento",
      "PROCESSING_FAILED_BODY": "Se produjo un error al procesar tus documentos; inténtalo de nuevo. Ponte en contacto con ",
      "TEST_SIMULATION_BUTTON": "Probar simulación",
      "SIMULATION_PROCESSED_TITLE": "Documentos procesados",
      "SIMULATION_PROCESSED_BODY": "Se procesaron los documentos de tu simulación.",
      "SIMULATION_DOCUMENTS_PROCESSED_TITLE": "Documentos de la simulación procesados.",
      "SIMULATION_DOCUMENTS_PROCESSED_BODY": "Se procesaron los documentos que subiste para la simulación {{ name }}.",
      "SIMULATION_DOCUMENTS_FAILED_TITLE": "No se pudieron procesar los documentos de la simulación.",
      "SIMULATION_DOCUMENTS_FAILED_BODY": "Los documentos que subiste para la simulación {{ name }} no se procesaron.",
      "DISMISS": "Descartar",
      "VIEW_SIMULATION": "Ver simulación",
      "FACT_MESSAGE_LABEL": "Mensaje",
      "FACT_MESSAGE_DESCRIPTION": "Los mensajes deben contener un solo dato, redactado en una oración completa. Que sean específicos, sencillos y de alcance limitado; evita los mensajes que puedan interpretarse de forma parcial.",
      "FACT_INCORRECT_ANSWER_LABEL": "Texto de respuesta incorrecta",
      "FACT_INCORRECT_ANSWER_DESCRIPTION": "Texto que se muestra al alumno si responde incorrectamente a esta pregunta",
      "SHOW_INCORRECT_ANSWER_TEXT": "Mostrar texto alternativo para las respuestas incorrectas",
      "ADD_NEW_FACT": "Agregar nuevo usuario",
      "FACT_SINGULAR": "dato",
      "FACT_PLURAL": "datos",
      "FACT_EXTRACTED_SINGULAR": "{{ count }} dato extraído",
      "FACT_EXTRACTED_PLURAL": "{{ count }} datos extraídos",
      "REVIEW_REQUIRED_LABEL": "Revisar sugerido",
      "MESSAGING_TITLE": "Mensajería",
      "MESSAGING_SUBTITLE": "Valora si se comunican los datos clave",
      "COMPONENT_WAVE_2_MESSAGE": "Perfeccionando el contenido de tu simulación…",
      "COMPONENT_WAVE_3_MESSAGE": "Finalizando el contenido de tu simulación…",
      "MESSAGE_ADHERENCE_MESSAGE": "Sugiriendo criterios de puntuación para el mensaje…",
      "ASSEMBLING_MESSAGE": "Montando tu simulación…",
      "PROCESSING_FAILED_SUFFIX": " si el problema persiste.",
      "BUTTON_RETRY": "Intentar de nuevo",
      "TOKEN_LIMIT_EXCEEDED_BODY_PREFIX": "Se superó el límite de contenido. Elimina uno o más documentos e inténtalo de nuevo o ponte en contacto con ",
      "TOKEN_LIMIT_EXCEEDED_BODY_SUFFIX": " si el problema persiste.",
      "AVATAR_LOOK_LABEL": "Apariencia",
      "AVATAR_SELECT_PLACEHOLDER": "Seleccionar avatar",
      "AVATAR_VOICE_LABEL": "Voz",
      "AVATAR_ALT": "Avatar",
      "PLAY_VOICE_PREVIEW_BUTTON": "Reproducir vista previa de voz",
      "VOICE_OPTION_1": "Voz 1",
      "VOICE_OPTION_2": "Voz 2",
      "BACK_TO_SIMULATION_DETAILS_BUTTON": "Volver a los detalles de la simulación",
      "AVATAR_SELECTION_TITLE": "Selección de avatar",
      "VIEW_DOCUMENTS": "Ver documentos",
      "SELECT_AVATAR_BUTTON": "Seleccionar avatar",
      "REQUEST_CHANGES_PLACEHOLDER": "Solicitar cualquier modificación de la información anterior",
      "CALL_DETAILS_LOAD_ERROR": "No pudimos cargar los detalles de tu llamada. Inténtalo de nuevo.",
      "FACTS_CANNOT_BE_EMPTY": "Los datos no pueden estar vacíos. Agrega un mensaje a cada dato antes de probarlo o publicarlo.",
      "FINISHING_SIMULATION_MESSAGE": "Finalizando tu simulación…",
      "BLANK_THEME_MESSAGE_TOOLTIP": "Agrega texto al mensaje vacío antes de agregar un nuevo tema.",
      "BLANK_MESSAGE_TOOLTIP": "Agrega texto a este mensaje antes de agregar otro.",
      "ADD_NEW_THEME_BUTTON": "Agregar nuevo tema",
      "ADD_THEME_BUTTON": "Agregar tema",
      "ADD_MESSAGE_BUTTON": "Agregar mensaje",
      "SCORE_LAST_SESSION": "Puntuar mi última sesión",
      "SCORE_LAST_SESSION_MODAL_HEADING": "Puntuar la última sesión",
      "SCORE_LAST_SESSION_MODAL_DESCRIPTION": "Prueba primero la simulación y, a continuación, vuelve aquí para puntuarla según la rúbrica seleccionada.",
      "SCORE_LAST_SESSION_MODAL_ERROR_HEADING": "Algo salió mal",
      "SCORE_LAST_SESSION_MODAL_ERROR_DESCRIPTION": "Inténtalo de nuevo.",
      "REFINEMENT_THINKING_MESSAGE": "Pensando…",
      "REFINEMENT_UPDATED_MESSAGE": "Actualizado",
      "REFINEMENT_WARNING_PREFIX": "Esta información se había modificado manualmente; ponte en contacto con",
      "REFINEMENT_WARNING_SUFFIX": "para cualquier actualización.",
      "REFINEMENT_ERROR_PREFIX": "Lamentablemente, no puedo ayudarte con eso, pero",
      "REFINEMENT_ERROR_SUFFIX": "quizá sí pueda.",
      "REFINEMENT_APPLIED_TITLE": "Se aplicaron los cambios solicitados.",
      "REFINEMENT_APPLIED_BODY": "Se aplicaron los cambios solicitados para la simulación {{ name }}.",
      "REFINEMENT_FAILED_TITLE": "Los cambios solicitados no se pudieron aplicar.",
      "REFINEMENT_FAILED_BODY": "No pudimos aplicar los cambios que solicitados para la simulación {{ name }}.",
      "WHAT_USERS_SEE_DESCRIPTION_TITLE": "Descripción de la simulación",
      "WHAT_USERS_SEE_DESCRIPTION_HELPER": "La información actualizada en la pestaña “General” se reflejará aquí, a menos que se realicen actualizaciones manuales.",
      "WHAT_USERS_SEE_DESCRIPTION_FIELD_LABEL": "Descripción",
      "WHAT_USERS_SEE_DETAILS_TITLE": "Detalles de la simulación",
      "WHAT_USERS_SEE_DETAILS_HELPER": "Este es el contenido que se mostrará al usuario antes de que comience la simulación. La información actualizada en la pestaña “General” se reflejará aquí, a menos que se realicen actualizaciones manuales. Las secciones que se dejen en blanco no se mostrarán al estudiante. Todas las secciones admiten el formato Markdown.",
      "WHAT_USERS_SEE_OVERVIEW_FIELD_LABEL": "Resumen de la simulación",
      "WHAT_USERS_SEE_PERSONA_FIELD_LABEL": "Sobre el personaje",
      "WHAT_USERS_SEE_SCORING_FIELD_LABEL": "Criterios de puntuación",
      "WHAT_USERS_SEE_SCORING_FIELD_HELPER": "Esta sección se rellena con las selecciones realizadas en la pestaña “Puntuación”. Editar la información aquí no modificará la forma en que se puntúa la simulación.",
      "WHAT_USERS_SEE_PREVIEW_DETAILS_CTA": "Vista previa modal de los detalles de la simulación",
      "WHAT_USERS_SEE_PREVIEW_CARD_CTA": "Vista previa de la tarjeta de simulación",
      "TAB_GENERAL": "General",
      "TAB_CONTENTS": "Índice",
      "TAB_KEY_WORDS": "Palabras clave",
      "TAB_SCORING": "Puntuación",
      "TAB_TESTING": "Probando",
      "TAB_PROMPTS": "Instrucciones",
      "TAB_WHAT_USERS_SEE": "Lo que ven los usuarios",
      "ACCURACY_FEEDBACK_TITLE": "Retroalimentación sobre la precisión",
      "ACCURACY_FEEDBACK_DESCRIPTION": "Evalúa la precisión de cada afirmación que haga un agente comparándola con los documentos cargados",
      "ACCURACY_FEEDBACK_STATUS_ON": "Habilitada",
      "ACCURACY_FEEDBACK_STATUS_OFF": "Desactivada",
      "ACCURACY_FEEDBACK_STATUS_DISABLED": "Deshabilitada",
      "ACCURACY_FEEDBACK_NO_DOCUMENTS": "La puntuación de la precisión no está disponible porque no se agregaron documentos relacionados.",
      "SCORING_AI_REVIEW_NOTICE": "Parte del contenido de esta pestaña se generó a partir de los materiales que proporcionaste. Revisa todo el contenido para comprobar su precisión antes de publicar esta llamada.",
      "EXPORT_SIMULATION_SUMMARY_BUTTON": "Exportar resumen de la simulación",
      "CALL": "Llamada",
      "REFINEMENT_OVERRIDDEN_PREFIX": "Esta información se había modificado manualmente; ponte en contacto con",
      "REFINEMENT_OVERRIDDEN_SUFFIX": "para cualquier actualización.",
      "SUPPORT_EMAIL": "help@quantified.ai",
      "WHAT_USERS_SEE_OVERRIDE_WARNING_TITLE": "La edición de estos campos bloqueará futuras actualizaciones",
      "WHAT_USERS_SEE_OVERRIDE_WARNING_BODY": "La actualización manual de estas secciones impedirá que reciban actualizaciones adicionales del proceso de refinamiento de la pestaña “General”.",
      "WHAT_USERS_SEE_DETAILS_OVERRIDE_EDITED_TITLE": "Estos campos se editaron",
      "WHAT_USERS_SEE_DETAILS_OVERRIDE_EDITED_BODY": "Ya no recibirán las actualizaciones de refinamiento realizadas en la pestaña “General”",
      "SIMULATION_BUILDER_HEADING": "Creador de simulaciones",
      "ASSIGNMENTS_TAB_LABEL": "Tareas",
      "SIMULATIONS_TAB_LABEL": "Simulaciones",
      "CREATE_NEW_ASSIGNMENT_BUTTON": "Crear nueva tarea",
      "CREATE_NEW_SIMULATION_BUTTON": "Crear nueva simulación",
      "NO_ASSIGNMENTS_FOUND": "No se encontraron tareas",
      "ASSIGNMENT_STATUS_PLACEHOLDER": "Estado de la tarea",
      "ASSIGNMENT_STATUS_PREFIX": "Estado de la tarea:",
      "ASSIGNMENT_TYPE_LABEL": "Tipo de tarea",
      "SELECT_ASSIGNMENT_TYPE_PLACEHOLDER": "Seleccionar tipo de tarea",
      "NAME_LABEL": "Nombre",
      "ASSIGNMENT_NAME_PLACEHOLDER": "Nombre de la tarea",
      "PASSING_SCORE_LABEL": "Puntuación para aprobar",
      "PASSING_SCORE_OPTIONAL_LABEL": "Puntuación para aprobar (opcional)",
      "SCORE_MAX_EXCEEDED_ERROR": "La puntuación no debe superar el 5",
      "GET_HELP_BUTTON": "Obtener ayuda",
      "PASSING_SCORE_TOOLTIP": "Esto establece la puntuación global que un estudiante debe alcanzar para aprobar la simulación.",
      "DESCRIPTION_LABEL": "Descripción",
      "ASSIGNMENT_DESCRIPTION_PLACEHOLDER": "Descripción de la tarea",
      "MESSAGING_FEEDBACK_LABEL": "Retroalimentación de la mensajería",
      "MESSAGING_FEEDBACK_TOOLTIP_HEADING": "Retroalimentación de la mensajería",
      "MESSAGING_FEEDBACK_TOOLTIP_BODY": "Cuando un estudiante formula incorrectamente un mensaje, se le muestra información sobre cómo expresarlo mejor la próxima vez. Esta configuración permite mostrar u ocultar dicha información.",
      "ENABLED_TEXT": "Habilitado",
      "DISABLED_TEXT": "Deshabilitado",
      "PAUSE_BUTTON_LABEL": "Botón de pausa",
      "ASSIGNMENT_START_DATE_LABEL": "Fecha de inicio de la tarea",
      "SELECT_DATE_PLACEHOLDER": "Seleccionar fecha",
      "ASSIGNMENT_END_DATE_LABEL": "Fecha de finalización de la tarea",
      "ASSIGNMENT_END_DATE_OPTIONAL_LABEL": "Fecha de finalización de la tarea (opcional)",
      "END_DATE_RANGE_ERROR": "La fecha de inicio y la fecha de finalización no pueden ser la misma",
      "ASSIGNMENT_INFORMATION_TITLE": "Información de la tarea",
      "ASSIGNMENT_TYPE_CERTIFICATION": "Certificación",
      "ASSIGNMENT_TYPE_PRACTICE": "Práctica",
      "ASSIGNMENT_TYPE_PERSONALIZED_PRACTICE": "Práctica personalizada",
      "BUTTON_SAVE_AND_CLOSE": "Guardar y cerrar",
      "BUTTON_ADD_SIMULATIONS": "Agregar simulaciones",
      "ATTEMPTS_UNLIMITED": "Ilimitados",
      "SEARCH_FOR_SIMULATION_LABEL": "Buscar simulación",
      "SIMULATION_NAME_PLACEHOLDER": "Nombre de la simulación",
      "BUTTON_REMOVE_ALL": "Eliminar todo",
      "SIMULATIONS_IN_ASSIGNMENT_LABEL": "Simulaciones en la tarea",
      "BUTTON_ASSIGN_LEARNERS": "Asignar estudiantes",
      "CALL_TYPE_UNKNOWN": "Desconocida",
      "ASSIGNMENT_COUNT_NONE": "Ninguna",
      "ASSIGNMENT_COUNT_SINGULAR": "{{ count }} tarea",
      "ASSIGNMENT_COUNT_PLURAL": "{{ count }} tareas",
      "ERROR_LOADING_ASSIGNMENTS": "Error al cargar las tareas",
      "SEARCH_ASSIGNEES_TITLE": "Buscar asignados",
      "DIALOG_DESCRIPTION_ADD_USERS": "Selecciona los usuarios que participarán en la tarea. La búsqueda de un equipo te permitirá asignar o desasignar a usuarios específicos de ese equipo. Al seleccionar un usuario específico, asegúrate de que esté asociado al equipo correcto a efectos de generación de informes.",
      "ADD_USERS_TO_ASSIGNMENT_HEADING": "Agregar usuarios a la tarea",
      "BUTTON_REVIEW_SELECTED_USERS": "Revisar usuarios seleccionados",
      "FIND_USERS_LABEL": "Encontrar usuarios",
      "BUTTON_CLEAR": "Quitar",
      "LEARNER_COUNT_NONE": "Ninguno",
      "LEARNER_COUNT_SINGULAR": "{{ count }} estudiante",
      "LEARNER_COUNT_PLURAL": "{{ count }} estudiantes",
      "ASSIGNMENT_TAB_DETAILS": "Detalles",
      "ASSIGNMENT_TAB_SIMULATIONS": "Simulaciones",
      "ASSIGNMENT_TAB_ASSIGNEES": "Asignados",
      "LOADING_ASSIGNMENT_DETAILS": "Cargando detalles de la tarea…",
      "BREADCRUMB_ASSIGNMENTS": "Tareas",
      "ASSIGNMENTS_COL_NAME": "Nombre",
      "ASSIGNMENTS_COL_START_DATE": "Fecha de inicio de la tarea",
      "ASSIGNMENTS_COL_END_DATE": "Fecha de finalización de la tarea",
      "ASSIGNMENTS_COL_LEARNERS": "Estudiante asignado",
      "ASSIGNMENTS_COL_TYPE": "Tipo de tarea",
      "ASSIGNMENTS_COL_STATUS": "Estado de la tarea",
      "SIMULATIONS_COL_NAME": "Nombre",
      "SIMULATIONS_COL_PRODUCT": "Producto",
      "SIMULATIONS_COL_DATE_MODIFIED": "Fecha de la última modificación",
      "SIMULATIONS_COL_STATUS": "Estado",
      "SIMULATIONS_COL_USED_IN": "Utilizada en",
      "SIMULATIONS_COL_TYPE": "Tipo de simulación",
      "SIMULATIONS_COL_DATE_PUBLISHED": "Fecha de publicación",
      "CONVERSE_PROMPT_LABEL": "Instrucción de la conversación",
      "CONVERSE_PROMPT_EXPAND_TO_EDIT": "Expandir para editar",
      "CONVERSE_PROMPT_ENTER_LABEL": "Introduce la instrucción de la conversación aquí *",
      "CONVERSE_PROMPT_EDITING_HEADING": "Edición de la instrucción de la conversación",
      "CONVERSE_PROMPT_OVERRIDE_CONFIRMATION_HEADING": "Confirmación de anulación de la instrucción",
      "CONVERSE_PROMPT_OVERRIDE_DESCRIPTION": "¿Seguro de que deseas anular la instrucción de la conversación? Si se anula, los autores perderán el acceso al refinamiento de autoservicio.",
      "CONVERSE_PROMPT_FIELD_LABEL": "Instrucción de la conversación",
      "CONVERSE_PROMPT_SAVE_BUTTON": "Guardar instrucción",
      "BUTTON_CONFIRM": "Confirmar",
      "DELETE_SIM_HEADING": "Eliminar simulación",
      "DELETE_SIM_CONTENT": "Esta simulación se eliminará. También se eliminarán todas las tareas de prueba asociadas a la simulación.",
      "DELETE_SIM_LABEL": "Eliminar simulación",
      "DELETE_ASSIGNMENT_HEADING": "Eliminar tarea",
      "DELETE_ASSIGNMENT_CONTENT": "Esta tarea se eliminará de forma permanente.",
      "DELETE_ASSIGNMENT_LABEL": "Eliminar tarea",
      "DELETE_ASSIGNMENT_NON_STAGED_CONTENT": "Para eliminar una tarea con el estado “Activa” o “Finalizada”, ponte en contacto con el equipo de CX. Gracias.",
      "REMOVE_FROM_ASSIGNMENT_HEADING": "Eliminar de la tarea",
      "REMOVE_FROM_ASSIGNMENT_CONTENT": "Esto eliminará al usuario de la tarea y de todos los enlaces de equipo asociados.",
      "REMOVE_FROM_ASSIGNMENT_LABEL": "Eliminar de la tarea",
      "PUBLISH_SIMULATION_HEADING": "Publicar simulación",
      "PUBLISH_CONTINUE_EDITING": "Continuar editando",
      "PUBLISH_BUTTON": "Publicar",
      "PUBLISH_SIMULATION_DESCRIPTION": "El juego de roles se podrá agregar a las tareas, pero ya no se podrá editar la información sobre el personaje, la puntuación ni las instrucciones.",
      "CONFIRMATION_SELECTED_USERS_HEADING": "Usuarios seleccionados",
      "CONFIRMATION_TOTAL_COUNT": "{{ count }} en total",
      "CONFIRMATION_CREATE_HEADING": "Crear nueva tarea",
      "CONFIRMATION_ADD_USERS_HEADING": "Agregar usuarios a la tarea",
      "CONFIRMATION_SAVE_ASSIGNMENT_BTN": "Guardar tarea",
      "CONFIRMATION_REMOVE_USER": "Eliminar",
      "EDIT_WEIGHTING_HEADING": "Editar ponderación de la puntuación",
      "EDIT_WEIGHTING_DESCRIPTION": "La puntuación global se generará a partir de la media ponderada de las siguientes secciones. La suma de las ponderaciones de todas las secciones activas debe ser del 100 %. La sección de habilidades no puede tener una ponderación superior al 20 %.",
      "EDIT_WEIGHTING_ERROR_ALL_DISABLED": "Se debe habilitar al menos una acción de puntuación",
      "EDIT_WEIGHTING_ERROR_WEIGHT_RANGE": "La ponderación de la sección debe estar entre 0 y 100",
      "EDIT_WEIGHTING_ERROR_SKILLS_MAX": "La sección de habilidades no puede tener una ponderación superior al 20 %",
      "EDIT_WEIGHTING_ERROR_TOTAL": "La ponderación total de las secciones debe ser del 100 %",
      "PERSONA_INFORMATION_TITLE": "Información del personaje",
      "PERSONA_AVATAR_LABEL": "Avatar *",
      "PERSONA_NAME_LABEL": "Nombre *",
      "PERSONA_INITIAL_GREETINGS_LABEL": "Saludos iniciales *",
      "PERSONA_INITIAL_GREETINGS_DESCRIPTION": "El personaje iniciará la simulación con uno de estos saludos. Puedes tener un máximo de 5 opciones.",
      "PERSONA_ADD_GREETING_OPTION": "Agregar opción de saludo",
      "PERSONA_RESUME_MESSAGE_LABEL": "Reanudar mensaje",
      "PERSONA_RESUME_MESSAGE_DESCRIPTION": "Cuando un estudiante reanude una simulación tras una pausa, el personaje comenzará con uno de estos saludos. Puedes tener un máximo de 5 opciones.",
      "PERSONA_ADD_MESSAGE_OPTION": "Agregar opción de mensaje",
      "PERSONA_UPLOADING": "Subiendo…",
      "PERSONA_DELETING": "Eliminando…",
      "PERSONA_CUSTOM_BG_PREVIEW_ALT": "Vista previa del fondo personalizado",
      "PERSONA_AVATAR_THUMBNAIL_ALT": "Miniatura del avatar",
      "PERSONA_AVATAR_WITH_BG_ALT": "Avatar con fondo personalizado",
      "PERSONA_PROCESSING_IMAGE": "Procesando imagen…",
      "PERSONA_CUSTOM_BACKGROUND_LABEL": "Fondo personalizado",
      "PERSONA_REMOVE_BACKGROUND": "Eliminar fondo",
      "PERSONA_CLICK_TO_REPLACE": "Haz clic para reemplazar",
      "PERSONA_UPLOAD_DESCRIPTION": "PNG o JPG, preferiblemente con relación de aspecto 16:9, máx. 2 MB",
      "SIM_INFORMATION_TITLE": "Información de la simulación",
      "SIM_NAME_FIELD_LABEL": "Nombre *",
      "SIM_LANGUAGE_FIELD_LABEL": "Idioma",
      "SIM_DETAILS_SECTION_TITLE": "Detalles de la simulación",
      "SIM_ADDITIONAL_SECTION_TITLE_LABEL": "Título de la sección adicional",
      "SIM_ADDITIONAL_SECTION_INFO_LABEL": "Información de la sección adicional",
      "TESTING_SECTION_TITLE": "Probadores",
      "TESTING_SEND_ASSIGNMENTS_BTN": "Enviar tarea de prueba",
      "TESTING_MESSAGING_TOOLTIP": "Agrega al menos un dato a “Adherencia al mensaje” antes de realizar las pruebas o publicar.",
      "TESTING_DESCRIPTION": "Busca a los usuarios que van a probar la simulación y, a continuación, envíales la tarea de prueba.",
      "TESTING_COL_NUMBER_OF_ATTEMPTS": "Número de intentos",
      "TESTING_COL_DATE_OF_LAST_ATTEMPT": "Fecha del último intento",
      "TESTING_CLEAR_USERS": "Quitar usuarios",
      "TESTING_REMOVE_ASSIGNEE": "Eliminar al asignado",
      "OVERALL_SECTION_TITLE": "Secciones, ponderaciones e instrucciones",
      "OVERALL_HEADING": "Global",
      "TRANSCRIPT_PROMPT_TITLE": "Instrucción de la transcripción",
      "TRANSCRIPT_PROMPT_FIELD_LABEL": "Introduce aquí la instrucción de la transcripción limpia",
      "SIMULATION_PROMPTS_TITLE": "Instrucciones de la simulación",
      "TAGS_LABEL": "Etiquetas",
      "CREATE_TAG_OPTION": "Crear {{term}}",
      "TAG_CREATE_ERROR": "No pudo crear la etiqueta; inténtalo de nuevo",
      "EDIT_SIMULATION_TAGS_TITLE": "Editar etiquetas de la simulación",
      "SAVE_TAGS_BUTTON": "Guardar etiquetas",
      "CLOSE_BUTTON": "Cerrar",
      "TAG_UPDATE_ERROR": "No se pudo actualizar la etiqueta; inténtalo de nuevo",
      "SCREEN_SHARE_TITLE": "Compartir pantalla",
      "SCREEN_SHARE_DESCRIPTION": "Permite al usuario compartir su pantalla con el avatar durante la llamada, para que este pueda ver y responder a lo que se muestra",
      "SCREEN_SHARE_STATUS_ON": "Habilitado",
      "SCREEN_SHARE_STATUS_OFF": "Deshabilitado",
      "SCREEN_SHARE_NO_PERSONA": "Agrega primero un personaje para activar la función de compartir pantalla.",
      "HIDE_RESULTS_LABEL": "Ocultar resultados",
      "SEARCH_FIELD_HINT": "Escribe al menos tres caracteres para iniciar la búsqueda",
      "OTHERS_SINGULAR": "y 1 más",
      "OTHERS_PLURAL": "y {{ count }} más",
      "PAGINATION_PREVIOUS": "Anterior",
      "PAGINATION_NEXT": "Siguiente",
      "SKILLS_RUBRIC_REQUIRED_TOOLTIP": "Adjunta una rúbrica de habilidades. Las habilidades están activadas con una ponderación superior al 0 %.",
      "ENTITY_TYPE_KNOWLEDGE_CHECK_DISPLAY": "prueba de conocimientos",
      "NAME_MAX_LENGTH_ERROR": "El nombre debe tener 255 caracteres o menos.",
      "UUID_COPIED_TOAST": "UUID de la llamada copiado al portapapeles",
      "MENU_ARCHIVE": "Archivar",
      "MENU_EDIT_SIMULATION_TAGS": "Editar etiquetas de la simulación",
      "MENU_COPY_UUID": "Copiar UUID",
      "REFINEMENT_IN_PROGRESS_TOOLTIP": "Refinamiento en curso. Podrás continuar una vez que haya finalizado.",
      "SIMULATION_DOCUMENTS_PARSE_FAILED_BODY": "No se pudo leer uno de tus documentos para {{ name }}; compruébalo o reemplázalo e inténtalo de nuevo.",
      "REFINEMENT_ERROR_MESSAGE": "Lo sentimos, no se pudo completar esta solicitud. Inténtalo de nuevo",
      "REFINEMENT_OUT_OF_SCOPE_TITLE": "Solicitud fuera del ámbito de aplicación.",
      "REFINEMENT_OUT_OF_SCOPE_BODY": "Tu solicitud para {{ name }} excede las capacidades del refinamiento. Ponte en contacto con el equipo de soporte.",
      "TAB_QUESTIONS": "Preguntas",
      "KNOWLEDGE_CHECK_NAME_LABEL": "Nombre*",
      "AVATAR_APPEARANCE_LABEL": "Apariencia del avatar",
      "KNOWLEDGE_CHECK_AVATAR_NAME_LABEL": "Nombre del avatar",
      "KNOWLEDGE_CHECK_SKILLS_FEEDBACK_TITLE": "Retroalimentación de las habilidades",
      "KNOWLEDGE_CHECK_SCORING_DESCRIPTION": "Las simulaciones de la prueba de conocimientos se puntúan según el porcentaje de puntos de respuesta cubiertos en cada pregunta. Selecciona una rúbrica de habilidades a continuación para recibir también retroalimentación cualitativa.",
      "KNOWLEDGE_CHECK_SCORING_RESCORE_DESCRIPTION": "Después de realizar la simulación al menos una vez, selecciona “Puntuar mi última sesión” para ver tu puntuación. Si editas los puntos de respuesta, puedes volver a puntuar la misma sesión. Si editas las preguntas, tendrás que realizar una nueva sesión de prueba antes de puntuarla.",
      "KNOWLEDGE_CHECK_SKILLS_RUBRIC_LABEL": "Rúbrica de habilidades (opcional)",
      "SIMULATION_TYPE_MODAL_TITLE": "Crear nueva simulación",
      "SIMULATION_TYPE_MODAL_DESCRIPTION": "Elige cómo practicarán tus estudiantes.",
      "SIMULATION_TYPE_ROLE_PLAY_TITLE": "Juego de roles",
      "SIMULATION_TYPE_ROLE_PLAY_DESCRIPTION": "Los estudiantes mantienen una conversación abierta con un personaje de IA, que responde de forma natural a todo lo que dicen.",
      "SIMULATION_TYPE_ROLE_PLAY_BEST_FOR": "Ideal para practicar llamadas de ventas realistas, como discursos de venta y gestión de objeciones.",
      "SIMULATION_TYPE_KNOWLEDGE_CHECK_TITLE": "Prueba de conocimientos",
      "SIMULATION_TYPE_KNOWLEDGE_CHECK_DESCRIPTION": "Un personaje de IA plantea a los estudiantes las preguntas que tú redactes, en el orden que tú establezcas.",
      "SIMULATION_TYPE_KNOWLEDGE_CHECK_BEST_FOR": "Ideal para evaluar los conocimientos sobre el producto y certificar que los representantes están preparados.",
      "TAGS_FILTER_LABEL": "Etiquetas",
      "TAGS_FILTER_PLACEHOLDER": "Selecciona una etiqueta",
      "CLEAR_ALL_FILTERS": "Quitar todos los filtros",
      "LAST_SAVED_LABEL": "Última configuración guardada",
      "BUTTON_OK": "Aceptar",
      "KEYWORDS_RESET_TO_PRODUCT_DEFAULT": "Restablecer a los valores predeterminados del producto",
      "KEYWORDS_DETACH_FROM_PRODUCT_DEFAULT": "Desvincular de los valores predeterminados del producto",
      "KEYWORDS_SAVE_AS_PRODUCT_DEFAULT": "Guardar como valor predeterminado del producto",
      "KEYWORDS_SAVE_AS_DEFAULT_OVERWRITE": "Esto sobrescribirá el valor predeterminado {{ keywordTitle }} del producto {{ moduleName }}.",
      "KEYWORDS_SAVE_AS_DEFAULT_IMPACT": "Estas palabras se agregarán a las nuevas simulaciones de {{ moduleName }}. Se aplicarán a todas las llamadas del producto {{ moduleName }}.",
      "KEYWORDS_ADD_NEW_WORD": "Agregar nueva palabra",
      "KEYWORDS_FROM_LABEL": "De",
      "KEYWORDS_TO_LABEL": "A",
      "KEYWORDS_PRONOUNCE_TITLE": "Pronunciar palabras",
      "KEYWORDS_PRONOUNCE_DESCRIPTION": "Proporciona las correcciones de pronunciación para que el agente de IA pronuncie correctamente los nombres y términos. El agente asocia los errores de pronunciación y variantes habituales a la nueva pronunciación.",
      "KEYWORDS_PRONOUNCE_NAME": "pronunciar palabras",
      "KEYWORDS_ADD_MISPRONUNCIATION": "Agregar pronunciación incorrecta",
      "KEYWORDS_SELECT_PERSONA_NOTICE": "Selecciona un personaje para agregar las palabras que debe pronunciar.",
      "KEYWORDS_REPLACE_TITLE": "Reemplazar palabras",
      "KEYWORDS_REPLACE_DESCRIPTION": "Correcciones explícitas de “buscar y reemplazar” para el texto transcrito por el usuario; sustituciones directas de palabras que se producen antes de la corrección fonética.",
      "KEYWORDS_REPLACE_NAME": "reemplazar palabras",
      "KEYWORDS_ADD_REPLACEMENT": "Agregar reemplazo",
      "KEYWORDS_STT_TITLE": "Palabras para la conversión de voz a texto (STT)",
      "KEYWORDS_STT_DESCRIPTION": "Lista de palabras facilitada a los proveedores de conversión de voz a texto (STT) (p. ej., AssemblyAI, Tavus), específicamente para la configuración de dichos proveedores.",
      "KEYWORDS_STT_NAME": "palabras para la conversión voz a texto (STT)",
      "KEYWORDS_GENERATING": "Generando…",
      "KEYWORDS_GENERATE_STT_PROMPT": "Generar stt_prompt",
      "KEYWORDS_STT_PROMPT_OUTDATED": "La lista de palabras se actualizó desde que se generó esta instrucción. Vuelve a generarla para reflejar los últimos cambios.",
      "KEYWORDS_STT_CANNOT_SAVE_HEADING": "No se puede guardar a nivel de producto",
      "KEYWORDS_STT_CANNOT_SAVE_BODY": "Las palabras y la indicación para conversión de voz a texto no se pueden guardar a nivel de producto. Puedes cambiar manualmente otros ajustes de la conversión de voz a texto de la simulación o ponerte en contacto con tu administrador si necesitas ayuda.",
      "KEYWORDS_CLEAN_TRANSCRIPT_TITLE": "Palabras de la transcripción limpia",
      "KEYWORDS_CLEAN_TRANSCRIPT_DESCRIPTION": "Palabras que se insertan en la indicación CLEAN_TRANSCRIPT_V2.",
      "KEYWORDS_CLEAN_TRANSCRIPT_NAME": "palabras de la transcripción limpia",
      "KEYWORDS_CALL_TITLE": "Palabras de la llamada",
      "KEYWORDS_CALL_DESCRIPTION": "Diccionario de palabras correctas para la corrección fonética, utilizado por el algoritmo Double Metaphone para corregir errores ortográficos fonéticamente similares. Evita términos compuestos por varias palabras, como “Anti MuSK AB+”, ya que el corrector de transcripciones basado en códigos solo funciona de forma fiable con palabras sueltas. Evita también los símbolos —por ejemplo, “lp(a)”—, ya que suelen confundir al corrector. La lista debe ser lo más breve y sencilla posible, ya que la gestiona un algoritmo determinista, no un modelo de lenguaje grande (LLM), y carece de comprensión contextual.",
      "KEYWORDS_CALL_NAME": "palabras de la llamada"
    },
    "settings": {
      "DEVICE_SETUP_INTRO": "Asegurémonos de que tu dispositivo está configurado.",
      "MICROPHONE_REQUIRED_NOTICE": "Se requiere un micrófono que funcione.",
      "DEVICE_ENABLE_INSTRUCTIONS": "Si al actualizar esta página no aparece una ventana emergente solicitándote que habilites tus dispositivos, accede a la configuración de tu sistema o navegador y habilita tus dispositivos desde allí. A continuación, encontrarás páginas de ayuda con más instrucciones.",
      "ENABLE_CAMERA": "Cómo habilitar la cámara:",
      "WINDOWS_USERS": "Usuarios de Windows",
      "MAC_USERS": "Usuarios de Mac",
      "IPAD_USERS": "Usuarios de iPad",
      "ENABLE_MICROPHONE": "Cómo activar el micrófono:",
      "ENABLE_DEVICES_BY_BROWSER": "Cómo habilitar tus dispositivos mediante el navegador:",
      "CHROME_USERS": "Usuarios de Chrome",
      "SAFARI_USERS": "Usuarios de Safari",
      "FIREFOX_USERS": "Firefox",
      "EDGE_USERS": "Edge",
      "START_WITHOUT_CAMERA_BUTTON": "Iniciar sin cámara",
      "START_CALL_BUTTON": "Iniciar llamada",
      "MICROPHONE_REQUIRED_WARNING": "Se requiere un micrófono que funcione.",
      "MICROPHONE_ALT": "micrófono",
      "MICROPHONE": "Micrófono",
      "SELECT_MICROPHONE": "Selecciona tu micrófono",
      "ALERT": "alerta",
      "GIVE_PERMISSION": "Dar permiso",
      "SELECT_VIDEO_DEVICE": "Selecciona tu dispositivo de video",
      "VIDEO": "video",
      "DEVICE_BLOCKED_ERROR": "Parece que le negaste el acceso a este navegador a uno o más de tus dispositivos. Para habilitar los dispositivos, accede a los ajustes de tu sistema o del navegador y habilita el acceso.",
      "DEVICE_SETTINGS": "Ajustes del dispositivo",
      "CONFIRM_SETTINGS": "Confirmar ajustes",
      "LAPTOP": "Computadora portátil",
      "SAD_EMOTE_FACE": "Cara de emoticón triste",
      "GRANT_BROWSER_ACCESS": "Para realizar esta simulación, concede al navegador acceso al reconocimiento de voz",
      "USING_IPAD": "Si utilizas un iPad, ve a",
      "SETTINGS": "Ajustes",
      "PRIVACY_AND_SECURITY": "Privacidad y seguridad",
      "SPEECH_RECOGNITION": "Reconocimiento de voz",
      "GRANT_ACCESS_REFRESH": "Concede acceso al navegador y actualiza la página",
      "REFRESH_PAGE": "ACTUALIZAR PÁGINA",
      "BROWSER_UNABLE_TO_ACCESS": "El navegador no puede acceder a este dispositivo",
      "ACCESS_DENIED": "acceso denegado",
      "CAMERA": "Cámara",
      "DIAGNOSTIC_PASSED": "Todas las pruebas de diagnóstico se aprobaron con éxito.",
      "DIAGNOSTIC_FAILED_MESSAGE": "Algunas pruebas de diagnóstico fallaron. Haz clic en el botón “Copiar resultados de diagnóstico” situado arriba y envía los resultados al equipo de soporte para obtener asistencia.",
      "DIAGNOSTIC_PARTIAL": "La mayoría de las pruebas de diagnóstico se aprobaron con éxito. Tu conexión parece estable.",
      "DIAGNOSTIC_RUNNING_MESSAGE": "Por favor, espera mientras se ejecutan las pruebas de diagnóstico...",
      "DIAGNOSTIC_RUNNING": "Diagnóstico en curso",
      "COPY_DIAGNOSTIC_RESULTS": "Copiar resultados de diagnóstico",
      "RUN_DIAGNOSTIC": "Iniciar diagnóstico",
      "RERUN_DIAGNOSTIC": "Repetir diagnóstico",
      "DIAGNOSTIC_RESULTS_COPIED": "Resultados de diagnóstico copiados al portapapeles",
      "DIAGNOSTIC_FAILED": "Falló el diagnóstico",
      "DIAGNOSTIC_WEBSOCKET_NOT_TESTED": "Websocket: not tested",
      "DIAGNOSTIC_TURN_NOT_TESTED": "TURN: not tested",
      "DIAGNOSTIC_QUALITY_NOT_TESTED": "Quality: not tested",
      "DIAGNOSTIC_QUANTIFIED_DIAGNOSTICS": "Diagnósticos de Quantified",
      "DIAGNOSTIC_TIME": "vez",
      "DIAGNOSTIC_SUMMARY": "Resumen",
      "DIAGNOSTIC_CLIENT_INFO": "Información del cliente",
      "DIAGNOSTIC_PLATFORM": "Plataforma",
      "DIAGNOSTIC_RTT_AVG_MAX": "RTT promedio/máx",
      "DIAGNOSTIC_PACKET_LOSS_SEND": "Pérdida de paquetes (enviar)",
      "DIAGNOSTIC_AVG_SEND_BITRATE": "Promedio de tasa de bits de envío",
      "DIAGNOSTIC_NA": "N/A",
      "DIAGNOSTIC_PROBLEMS_CONNECTING_PREFIX": "¿Tienes problemas de conexión?",
      "DIAGNOSTIC_CLICK_HERE": "Haz clic aquí",
      "DIAGNOSTIC_TO_RUN_SUFFIX": "para ejecutar un diagnóstico."
    },
    "results": {
      "RETURN_HOME": "REGRESAR A INICIO",
      "CLOSE_BUTTON": "Botón de cerrar",
      "CONVERSATIONAL_CALL": "JUEGO DE ROLES",
      "INFORMATION_ICON": "Ícono de información",
      "TOOLTIP_ARROW": "Flecha de información sobre herramientas",
      "INFORMATION_TOOLTIP_CONTENT": "Tú controlas el desarrollo de la simulación y diriges la conversación hacia una serie de objetivos. Los juegos de rol son excelentes para poner a prueba habilidades como profundizar en detalles y hacer preguntas de segundo nivel, descubrir puntos de dolor y crear una buena relación.",
      "CLOCK_ICON": "Ícono de reloj",
      "CALL_RESULTS": "Resultados",
      "SKILLS": "Habilidades",
      "MESSAGE_ADHERENCE": "Adherencia al mensaje",
      "TRY_AGAIN_MESSAGE": "Inténtalo de nuevo y mejora tu puntuación.",
      "PRACTICE_BENEFITS": "Practicar semanalmente aumenta la confianza y mejora los resultados en el mundo real.",
      "CALL_SUCCESS": "¡Buen trabajo! Completaste esta simulación con éxito.",
      "MAX_ATTEMPTS_REACHED": "Alcanzaste el número máximo de intentos",
      "TRY_AGAIN": "Inténtalo de nuevo",
      "GREAT_JOB_YOU_SUCCESSFULLY": "¡Buen trabajo! Completaste",
      "COMPLETED_THIS_CALL": "correctamente esta simulación.",
      "ACHIEVED_SCORE": "Lograste una puntuación de",
      "ACHIEVE_SCORE": "Logra una puntuación de",
      "OR_HIGHER": "o superior.",
      "OBJECTIVES_NOT_MET": "No cumpliste con todos los objetivos requeridos.",
      "TRY_AGAIN_TARGET_SCORE": "Inténtalo de nuevo para lograr una puntuación de",
      "YOUR_SCORE": "Tu puntuación",
      "OUT_OF_5": "DE 5",
      "CALL_FEEDBACK": "RESUMEN DE COMENTARIOS",
      "STRENGTH_ICON_ALT": "Ícono de fuerza",
      "OPPORTUNITIES_ICON_ALT": "Ícono de oportunidades",
      "OBJECTIVES_FEEDBACK": "COMENTARIOS SOBRE LA METODOLOGÍA",
      "SESSION_ID": "ID de sesión:",
      "SESSION_ID_COPIED": "ID de sesión copiado",
      "OBJECTIVE": "METODOLOGÍA:",
      "HOW_YOU_DID": "Qué tal lo hiciste:",
      "LIGHTBULB_ICON_ALT": "Ícono de foco",
      "WHAT_WE_SUGGEST": "Lo que sugerimos:",
      "NO_SPECIFIC_RECOMMENDATION": "Nuestro sistema no ha podido encontrar una recomendación específica para ti.",
      "WHY": "¿Por qué?",
      "NO_INSIGHTS_AVAILABLE": "Nuestro sistema no ha podido proporcionar información sobre esta sugerencia.",
      "CONFETTI_ICON_ALT": "Ícono de confeti",
      "OBJECTIVE_SUCCESS_MESSAGE": "Lo hiciste muy bien en esta metodología, ¡sigue así!",
      "PROCESSING_CALL": "Estamos preparando tu puntuación y tus comentarios.",
      "HANG_TIGHT": "Espera un momento o vuelve a consultar más tarde para",
      "VIEW_YOUR_RESULTS": "ver tus resultados.",
      "NEED_MORE_TIME": "Necesitamos más tiempo para calcular los resultados.",
      "REFRESH_INSTRUCTION": "Vuelve a consultarlo o actualiza los resultados",
      "RESULTS_IN_FEW_MINUTES": "de la tarea dentro de unos minutos.",
      "SCORE_CALCULATION_QUESTION": "¿Cómo se calcula esto?",
      "SINGLE_SCORE_EXPLANATION": "Esta simulación solo tiene un único componente de puntuación, por lo que la puntuación mostrada es tanto la puntuación de sección individual como la puntuación general.",
      "OVERALL_SCORE_PERCENT": "de la puntuación global",
      "SECTION_SCORE": "Puntuación de la sección",
      "ELEVATE_MESSAGE_ADHERENCE_TITLE": "Mejora la adherencia al mensaje en la conversación",
      "MESSAGE_ADHERENCE_NOTE": "La adherencia al mensaje es fundamental para mantener conversaciones exitosas, pero no afecta tu puntuación global.",
      "NO_CREDIT": "Sin crédito",
      "PARTIAL_CREDIT": "Crédito parcial",
      "FULL_CREDIT": "Crédito completo",
      "WHAT_YOU_DID_WELL": "Lo que hiciste bien",
      "MISSED_ALL_KEY_POINTS": "Te saltaste todos los puntos clave; revísalos y vuelve a intentarlo.",
      "WHAT_TO_IMPROVE": "Lo que puedes mejorar",
      "PERFECT_SCORE_MESSAGE": "¡Felicidades! Obtuviste una puntuación perfecta y hablaste correctamente de todos los puntos clave.",
      "POINTS_LABEL": "Puntos",
      "TALKING_POINTS_COVERED": "Temas de conversación cubiertos",
      "CHECKMARK_ICON_ALT": "marca de verificación",
      "TALKING_POINTS_MISSED": "Temas de conversación omitidos",
      "X_ICON_ALT": "x",
      "PRACTICE_AGAIN": "Practica de nuevo",
      "OUT_OF": "de",
      "OBJECTIVES": "Metodología",
      "ELEVATE_OBJECTIVES_TITLE": "Mejora tu metodología de conversación",
      "OBJECTIVES_NOTE": "La metodología es fundamental para dirigir conversaciones exitosas, pero no afecta la puntuación general.",
      "UNTIL": "hasta el",
      "TO_IMPROVE_SCORE": "para mejorar tu puntuación.",
      "YOU_HAVE": "Tienes",
      "MORE_ATTEMPTS": "intentos más para conseguir",
      "OR_HIGHER_BEFORE": "puntos o más antes del",
      "AND_TRY_AGAIN": "e intentarlo de nuevo.",
      "UNEXPECTED_STATE": "Ha ocurrido un estado inesperado.",
      "REVIEW_APP_LOGIC": "Por favor, revisa la lógica de la aplicación.",
      "ASSIGNMENTS": "Tareas",
      "VIEW_CALL_DETAILS": "Ver detalles de la llamada",
      "PRACTICE_SESSION": "Sesión de práctica",
      "OVERALL_SCORE": "Puntuación global",
      "OVERALL_SCORE_EXPLANATION": "La puntuación global se calcula tomando una media ponderada de la puntuación de cada sección. El peso de cada sección se muestra como un porcentaje junto a la puntuación.",
      "SCORE_CONFIG_NOTE": "Los porcentajes de peso y la inclusión y exclusión de secciones los establece tu empresa. Todas las puntuaciones se redondean a la décima más cercana.",
      "STRENGTHS": "Fortalezas",
      "OPPORTUNITIES": "Oportunidades",
      "YOUR_RESPONSE": "Tu respuesta",
      "MINUS": "menos",
      "PLUS": "más",
      "RECOMMENDED_RESPONSE": "Respuesta recomendada",
      "REVIEW_MISSED_TITLE": "Revisa lo que has omitido.",
      "NO_TALKING_POINTS_COVERED": "No cubriste ninguno de los temas de conversación requeridos para este tema.",
      "LEARN_WHAT_YOU_MISSED": "Descubre lo que has omitido",
      "NICE_JOB": "¡Buen trabajo!",
      "ALL_POINTS_COVERED": "Cubriste exitosamente todos los temas de conversación requeridos para este tema.",
      "COVER_ALL_MESSAGES": "Cubre todos los mensajes clave.",
      "HIGHLIGHT_KEY_POINTS_NOTE": "Resaltar los puntos clave durante la llamada ayudará a mantener la conversación centrada.",
      "MESSAGES_LABEL": "Mensajes",
      "NO_FACTS_COVERED": "¡Uy! Parece que no mencionaste ninguno de los hechos de este mensaje.",
      "NO_SPECIFICS_AVAILABLE": "¡Uy! Parece que no pudimos proporcionar detalles sobre lo que has omitido.",
      "ALL_KEY_POINTS_COVERED": "¡Buen trabajo! Cubriste todos los puntos clave.",
      "PROCESSING_SKILLS_FEEDBACK": "Estamos procesando la retroalimentación de tus habilidades.",
      "SKILLS_SCORING_NOT_ENABLED": "Lo sentimos, pero no hemos podido analizar tu llamada reciente porque la evaluación de habilidades no estaba habilitada en el momento del envío. Para recibir retroalimentación, solo tienes que volver a enviar tu práctica de llamada como lo hiciste anteriormente. Si necesitas ayuda, no dudes en contactar a nuestro equipo de soporte. ¡Gracias por tu comprensión y compromiso por mejorar!",
      "ELEVATE_CONVERSATION_SKILLS": "Mejora tus habilidades de conversación",
      "SKILLS_NOTE": "Las habilidades son críticas para mantener conversaciones exitosas, pero no afectan tu puntuación global.",
      "SKILLS_SUMMARY_TITLE": "RESUMEN DE HABILIDADES",
      "LEARN_MORE_ABOUT_SKILLS": "Obtén más información sobre las habilidades",
      "SKILLS_FEEDBACK_LABEL": "RETROALIMENTACIÓN",
      "WHAT_ARE_SKILLS_TITLE": "¿Qué son las habilidades?",
      "SKILLS_DESCRIPTION": "Las habilidades están calibradas para favorecer el desarrollo del crecimiento personal. Aunque estas habilidades no forman parte de la evaluación numérica de tu llamada, tu organización las ha seleccionado para mejorar tu eficacia.",
      "PROFICIENCY_SCALE_TITLE": "ESCALA DE COMPETENCIA",
      "EXPERT": "Experto",
      "PROFICIENT": "Competente",
      "DEVELOPING": "En desarrollo",
      "CALL_TRANSCRIPT": "Transcripción de la llamada",
      "COLLAPSE_ALL": "Colapsar todo",
      "EXPAND_ALL": "Expandir todo",
      "THUMBNAIL": "Miniatura",
      "OUT_OF_FIVE_POINTS": "/5 puntos",
      "TALKING_POINTS": "temas de conversación",
      "TRANSCRIPT_LABEL": "Transcripción",
      "YOU_ARE_OUT_OF_ATTEMPTS": "Te quedaste sin intentos.",
      "REVIEW_GUIDELINES_REMAIN_COMPLIANT": "Revisa las directrices y sigue cumpliéndolas en el futuro.",
      "TRY_AGAIN_ATTENTION_TO_COMPLIANCE": "Inténtalo de nuevo y presta atención a las directrices de cumplimiento.",
      "NO_SCORE_OUT_OF_COMPLIANCE": "Detectamos algo que podría suponer un incumplimiento de la normativa",
      "WHY_OUT_OF_COMPLIANCE": "Por qué no cumpliste con la normativa",
      "REVIEW_TRANSCRIPT_MISSED_GUIDELINES": "Revisa tu transcripción para ver en qué aspectos cumpliste con la normativa.",
      "YOU_DID_FOLLOW_GUIDELINES": "Cumpliste con esta normativa de manera efectiva.",
      "REVIEW_MISSED_GUIDELINES": "Revisa la normativa de cumplimiento que no se siguió.",
      "OUT_OF_COMPLIANCE": "Incumplimiento",
      "SCORE_CALCULATION_TITLE": "Cálculo de puntuación",
      "PROCESSING_TRANSCRIPT": "Estamos procesando tu transcripción.",
      "WAIT_OR_REVIEW_SCORES": "Espera aquí o revisa las otras secciones",
      "TRANSCRIPT_LOADING": "de la puntuación mientras se carga la transcripción.",
      "REVIEW_FEEDBACK_KEEP_PRACTICING": "Revisa tu retroalimentación y sigue practicando",
      "HIGH_PERFORMERS_PRACTICE": "Las personas con mejor rendimiento practican al menos una vez a la semana",
      "SUCCESSFULLY_PASSED": "¡Buen trabajo! Aprobaste con éxito esta simulación.",
      "DIDNT_REACH_PASSING_SCORE": "No alcanzaste la puntuación para aprobar esta simulación.",
      "OUT_OF_ATTEMPTS": "<b>Se agotó el número de intentos.</b> Revise la retroalimentación para saber cómo puede mejorar.",
      "REVIEW_FEEDBACK_THEN_RETURN": "Revisa tu retroalimentación y vuelve al inicio cuando estés preparado.",
      "GREAT_JOB_PRACTICED": "¡Buen trabajo! Practicaste {{count}} {{times}}. ¡Sigue así!",
      "TIME": "vez",
      "TIMES": "veces",
      "COMPLIANCE_GUIDELINES": "Normativa de cumplimiento",
      "TALKING_POINT_TITLE": "TEMAS DE CONVERSACIÓN OMITIDOS O ABORDADOS EN EL MOMENTO EQUIVOCADO",
      "NO_TRANSCRIPT": "No hay transcripción disponible.",
      "QUIZ_SUMMARY_BASE": "Tómate un momento para revisar tu desempeño en este cuestionario.",
      "QUIZ_SUMMARY_FAILED": "Tómate un momento para revisar tu desempeño en este cuestionario. Revisa los {{stepNames}} {{stepWord}} resaltados en la pantalla de resumen de la trayectoria para prepararte mejor para tu próximo intento.",
      "QUIZ_SUMMARY_PASSED_WITH_MISSES": "Tómate un momento para revisar tu desempeño en este cuestionario. El/los {{stepWord}} {{stepNames}} {{stepVerb}} el/las {{areaWord}} con la puntuación más baja.",
      "OUT_OF_100": "DE 100",
      "COVERED": "Cubierto",
      "MISSED": "Omitido",
      "RETURN_TO_ASSIGNMENT": "Volver a la tarea",
      "RETURN_TO_PATHWAY": "VOLVER A LA TRAYECTORIA",
      "QUIZ_RESULTS_SUMMARY": "Resumen de resultados del cuestionario",
      "PROCESSING_RESULTS": "Procesando resultados...",
      "NONE_PERFECT": "Ninguno - ¡Perfecto!",
      "MESSAGING": "Mensaje",
      "MISSED_ONE_TALKING_POINT": "Omitiste 1 tema de conversación para este tema.",
      "MISSED_X_TALKING_POINTS": "Omitiste {{count}} temas de conversación para este tema.",
      "ROLEPLAY_POST_CALL_TITLE": "Llegaste al final de esta llamada.",
      "ROLEPLAY_POST_CALL_SUBTITLE_PROCESSING": "Deja algún comentario mientras procesamos tus resultados.",
      "ROLEPLAY_POST_CALL_SUBTITLE_DELAY": "Los resultados tardan un poco en cargarse. Sal de la trayectoria y te notificaremos cuando estén listos.",
      "ROLEPLAY_POST_CALL_SUBTITLE_ERROR": "Hubo un error al procesar tus resultados. Ponte en contacto con soporte en",
      "ROLEPLAY_POST_CALL_PROCESSING_LABEL": "Procesando resultados...",
      "ROLEPLAY_POST_CALL_FEEDBACK_QUESTION": "¿Te pareció realista y natural esta conversación?",
      "FEEDBACK_THANK_YOU": "¡Gracias por tus comentarios!",
      "FEEDBACK_IMPROVEMENT_NOTE": "¡Gracias por tus comentarios! Trabajaremos en mejorar la experiencia.",
      "VIEW_RESULTS": "Ver resultados",
      "FEEDBACK_IMPROVEMENT_SUFFIX": "Trabajaremos en mejorar la experiencia.",
      "QUIZ_RESULTS_LOADING": "Los resultados tardan un poco en cargarse. Sal de la trayectoria y te notificaremos cuando estén listos.",
      "KC_TOAST_TITLE": "Los resultados de tu prueba de conocimientos fueron procesados",
      "KC_TOAST_CONTENT": "Haz clic abajo para ver, o regresa a la pantalla de detalles de la trayectoria para tu siguiente paso.",
      "DISMISS": "Descartar",
      "KC_TOAST_TITLE_PATHWAY": "Los resultados de tu prueba de conocimientos {{stepName}} fueron procesados",
      "MISSED_ONE_REQUIRED_TALKING_POINT": "Omitiste 1 tema de conversación requerido para este tema",
      "MISSED_X_REQUIRED_TALKING_POINTS": "Omitiste {{count}} temas de conversación requeridos para este tema",
      "MISSED_ALL_ONE_REQUIRED_TALKING_POINT_TITLE": "Omitiste 1 tema de conversación requerido para este tema.",
      "MISSED_ALL_X_REQUIRED_TALKING_POINTS_TITLE": "Omitiste {{count}} temas de conversación requeridos para este tema.",
      "REVIEW_MATERIAL_NEXT_TIME": "Revisa el material para mejorar la próxima vez.",
      "POINT_LABEL": "Punto",
      "GREAT_JOB_PRACTICED_FEMALE": "¡Buen trabajo! Practicaste {{count}} {{times}}. ¡Sigue así!",
      "ACCURACY": "Precisión",
      "ACCURACY_LOADING": "Cargando…",
      "ACCURACY_FLAGGED_MESSAGE": "Dijiste algunas cosas que pueden diferir de tus materiales de referencia. Consulta a continuación para obtener más detalles.",
      "ACCURACY_ALL_CLEAR": "No identificamos ninguna afirmación que sea inexacta con respecto a los materiales de referencia.",
      "ACCURACY_ERROR": "No se pudo proporcionar retroalimentación sobre esta sesión",
      "ACCURACY_YOU_SAID": "LO QUE DIJISTE",
      "ACCURACY_CLAIM_IDENTIFIED": "LA AFIRMACIÓN QUE IDENTIFICAMOS",
      "ACCURACY_MATERIALS_STATE": "LO QUE INDICAN TUS MATERIALES",
      "ACCURACY_OVERALL_BLOCK_PREFIX": "Dijiste algunas cosas que podrían ser inexactas. Comprueba la pestaña ",
      "ACCURACY_OVERALL_BLOCK_LINK": "“Precisión”",
      "ACCURACY_OVERALL_BLOCK_SUFFIX": " para obtener más detalles.",
      "PRACTICE_SIMULATION_AGAIN": "Vuelve a practicar la simulación",
      "CALL_TYPE_CONVERSATIONAL": "Llamada conversacional",
      "CALL_TYPE_GUIDED": "Llamada guiada",
      "CALL_TYPE_VISUAL_AID": "Llamada con ayuda visual",
      "CALL_TYPE_ROLEPLAY": "Llamada con juego de roles",
      "PERSONALIZED_PRACTICE_BREADCRUMB": "Práctica personalizada",
      "CONVERSATION_TYPE_LABEL": "Tipo de conversación:",
      "DIFFICULTY_LABEL": "Dificultad:",
      "MOOD_LABEL": "Estado de ánimo:",
      "DIFFICULTY": "Dificultad",
      "TEMPERAMENT": "Temperamento",
      "OVERALL_SCORE_TAB": "Global",
      "MESSAGE_ADHERENCE_TAB": "Mensajes",
      "OBJECTIVES_TAB": "Objetivos"
    },
    "reportingV2": {
      "DASHBOARD": "Panel",
      "LOADING_ACCOUNTS": "Cargando cuentas…",
      "SELECT_AN_ACCOUNT": "Seleccionar una cuenta",
      "SEARCH_TEAMS": "Buscar equipos",
      "LOADING_TEAMS": "Cargando equipos…",
      "ALL_TEAMS": "Todos los equipos",
      "ACCOUNT": "Cuenta",
      "TEAMS": "Equipos",
      "TEAM_LABEL": "Equipo",
      "TOTAL_LABEL": "Total",
      "PASSING_SCORE": "Puntuación para aprobar",
      "ASSIGNMENT_LABEL": "Tareas",
      "USER_LABEL": "Usuarios",
      "PRACTICE_LABEL": "Práctica",
      "CERTIFICATION_LABEL": "Certificación",
      "RESULTS_DESCRIPTION": "Aquí tienes los resultados de tu(s) equipo(s) en todas las tareas de práctica:",
      "ENGAGEMENT_BY_ASSIGNMENT": "Ejecución por tarea",
      "ASSIGNMENT_ENGAGEMENT": "Ejecución en tarea",
      "ENGAGED_LABEL": "Ejecutada",
      "ENGAGEMENT_STATUS_LABEL": "Estado de la ejecución",
      "PROFICIENT_LABEL": "Competente",
      "ASSIGNMENT_NAME": "Nombre de la tarea",
      "ACTIVE_USERS": "Usuarios activos",
      "ASSIGNMENT_PROGRESS": "Progreso por tarea",
      "IN_PROGRESS_LABEL": "En progreso",
      "CERTIFIED_LABEL": "Certificada",
      "OUT_OF_ATTEMPTS_LABEL": "No quedan intentos",
      "USERS_ENGAGED_LABEL": "Usuarios que participaron",
      "SESSIONS_PER_ACTIVE_USERS_LABEL": "Sesiones por usuario activo",
      "HIGHER_THAN_LABEL": "Superior a",
      "MORE_THAN_LABEL": "Más de",
      "TOTAL_SESSIONS_COMPLETED_LABEL": "Total de sesiones completadas",
      "USER_CERTIFIED": "Usuarios certificados en todas las tareas",
      "ASSIGNMENT_CERTIFICATION": "Tareas con certificación del 100 %",
      "TRAINER_TIME_SAVED": "Ahorro de tiempo del instructor",
      "HOURS_LABEL": "horas",
      "PRACTICE_ASSIGNMENT_LABEL": "Tareas de práctica",
      "CERTIFICATION_ASSIGNMENT_LABEL": "Tareas de certificación",
      "START_DATE_LABEL": "Fecha de inicio",
      "END_DATE_LABEL": "Fecha final",
      "NAME_LABEL": "Nombre",
      "EMAIL_LABEL": "Correo electrónico",
      "MEMBER_OF_TEAMS_LABEL": "Miembro de equipos",
      "ASSIGNMENTS_COUNT_LABEL": "n.º de tareas",
      "TOTAL_SESSIONS_LABEL": "Total de sesiones",
      "NUMBER_OF_SESSIONS_LABEL": "Número de sesiones",
      "TOTAL_USERS_LABEL": "Total de usuarios",
      "AVERAGE_SCORE_LABEL": "Puntuación promedio",
      "INITIAL_SCORE_LABEL": "Puntuación inicial",
      "HIGH_SCORE_LABEL": "Puntuación alta",
      "LAST_PRACTICE_DATE_LABEL": "Última fecha de práctica",
      "PERCENT_IMPROVED_LABEL": "% mejorado",
      "PERCENT_IMPROVED_TOOLTIP_TEXT": "Esta métrica compara la puntuación inicial de un usuario con su puntuación más alta, expresada como porcentaje de la mejora máxima posible.",
      "ASSIGNMENTS_CERTIFIED_LABEL": "Tareas certificadas",
      "ASSIGNMENTS_PROFICIENT_LABEL": "Tareas competentes",
      "ASSIGNMENTS_CERTIFIED_TOOLTIP_TEXT": "Número de tareas en las que el usuario ha cumplido o superado los criterios de puntuación para todas las simulaciones de la tarea.",
      "ASSIGNMENTS_PROFICIENT_TOOLTIP_TEXT": "Número de tareas en las que el usuario ha cumplido o superado los criterios de puntuación al menos una vez en todas las simulaciones de la tarea.",
      "PROFICIENT_TOOLTIP": "Número de usuarios de esta tarea que han obtenido una puntuación igual o superior a los criterios de puntuación alta definidos, al menos una vez en todas las simulaciones de esta tarea.",
      "IN_PROGRESS_TOOLTIP": "Porcentaje de usuarios que han completado al menos una sesión de una simulación en esta tarea y han recibido una puntuación.",
      "OUT_OF_ATTEMPTS_TOOLTIP": "Porcentaje de usuarios que han superado los intentos asignados para una o varias simulaciones de la tarea.",
      "CERTIFIED_TOOLTIP": "Porcentaje de usuarios que han cumplido o superado los criterios de puntuación para todas las simulaciones de la tarea.",
      "SEARCH_FOR_A_USER_LABEL": "Buscar un usuario",
      "NO_USERS_FOUND_LABEL": "No se han encontrado usuarios",
      "TRAINER_TIME_SAVED_TOOLTIP": "La cantidad de tiempo que los usuarios han pasado en Quantified completando intentos de certificación.",
      "AVG_SESSIONS_PER_ASSIGNMENT": "Sesiones promedio por tarea",
      "ASSIGNMENTS_ENGAGED_WITH": "Tareas ejecutadas",
      "AVERAGE_IMPROVEMENT": "Promedio de mejora",
      "STATUS": "Estado",
      "TOTAL_NUMBER_OF_SESSIONS": "Número total de sesiones",
      "DATE_OF_LAST_PRACTICE": "Fecha de la última práctica",
      "CALL_NAME": "Nombre de la llamada",
      "SESSION_DATE": "Fecha de la sesión",
      "DURATION_OF_SESSION": "Duración de la sesión",
      "OVERALL_SCORE": "Puntuación global",
      "MESSAGING_SCORE": "Puntuación de adherencia al mensaje",
      "METHODOLOGY_SCORE": "Puntuación de la metodología",
      "SKILLS_SCORE": "Puntuación por competencias",
      "SESSIONS": "Sesiones",
      "TOTAL": "Total",
      "ALL_ASSIGNMENTS": "Todas las tareas",
      "RECENT_ASSIGNMENTS": "Tareas recientes",
      "AVERAGE_SESSIONS_ACTIVE_USER": "Promedio de sesiones de usuario activo",
      "HOURS_IN_SIMULATIONS": "Horas en simulaciones",
      "AVERAGE_SESSIONS_TO_PROFICIENCY": "Promedio de sesiones hasta la competencia",
      "PERCENT_PROFICIENT": "Porcentaje competente",
      "SYSTEM_RUNNING_NORMALLY": "El sistema funciona con normalidad",
      "PRACTICE_SIMULATIONS_LABEL": "Simulaciones",
      "NO_USERS_MATCHING_FILTERS_LABEL": "Ningún resultado coincide con tus filtros. Prueba a borrar uno o varios filtros para ampliar la búsqueda.",
      "USERS_PASSED": "Usuarios que aprobaron la simulación",
      "AVERAGE_TIME": "Tiempo promedio de certificación",
      "USERS_OUT_OF_ATTEMPTS": "Usuarios sin intentos",
      "NO_CERTIFICATION_SIMULATION": "No se han encontrado simulaciones de certificación",
      "SIMULATION": "Simulación",
      "No_SIMULATION": "Sin sesiones",
      "PERCENT_CERTIFIED": "Porcentaje certificado",
      "PERCENT_CERTIFIED_FIRST_ATTEMPT": "Porcentaje certificado en el primer intento",
      "USERS": "Usuarios",
      "ATTEMPTS_LABEL": "Intentos",
      "NO_ATTEMPTS": "Ningún intento",
      "DATE_OF_SESSION": "Fecha de la sesión",
      "NO_ASSIGNMENTS_MATCH_FILTERS": "Ninguna tarea coincide con los filtros elegidos",
      "NO_TEAMS_DATA": "No hay equipos en esta cuenta",
      "SIMULATION_NAME": "Nombre de la simulación",
      "AVERAGE_DURATION_OF_SESSION": "Duración media de la sesión",
      "AVERAGE_SESSIONS_PER_ACTIVE_USER": "Promedio de prácticas por usuario activo",
      "AVERAGE_OVERALL_SCORE": "Promedio de puntuación global",
      "TOTAL_ASSIGNMENTS": "Tareas totales",
      "ASSIGNMENTS_CERTIFIED": "Tareas certificadas",
      "TOTAL_SESSIONS": "Total de sesiones",
      "HOURS_SPENT_PRACTICING": "Horas dedicadas a practicar",
      "LAST_LOGIN": "Último acceso",
      "SELECT_ASSIGNMENTS": "Seleccionar tareas",
      "CERTIFICATION_STATUS_LABEL": "Estado de la certificación",
      "CERTIFICATION_STATUS_PREFIX_LABEL": "Estado de la certificación:",
      "CERTIFIED_ON_FIRST_ATTEMPT_LABEL": "¿Certificado al primer intento?",
      "DATE_OF_CERTIFICATION_LABEL": "Fecha de certificación",
      "ENGAGEMENT_STATUS_PREFIX_LABEL": "Estado de la ejecución:",
      "DURATION_OF_ATTEMPT": "Duración del intento",
      "USER_NAME": "Nombre de usuario",
      "LEARNER": "Estudiante",
      "DATE_RANGE": "Intervalo de fechas",
      "DATE_RANGE_LABEL": "Intervalo de fechas",
      "SEARCH_USERS": "Buscar usuarios...",
      "SEARCH_SIMULATIONS": "Buscar simulaciones...",
      "SEARCH_DATES": "Buscar fechas...",
      "CERTIFIED_ON_FIRST_TRY": "Certificado al primer intento",
      "DATE_OF_CERTIFICATION": "Fecha de certificación",
      "AVERAGE_CERTIFICATION_SCORE": "Puntuación promedio de la certificación",
      "TOTAL_TIME_CERTIFYING": "Tiempo total de certificación",
      "OF_THE_TIME": "de las veces",
      "ASSIGNED_LABEL": "Sin comenzar",
      "USERS_ASSIGNED_LABEL": "Total de usuarios asignados",
      "SESSION_ID": "ID de sesión",
      "USER_NAME_LABEL": "Nombre de usuario",
      "NO_SIMULATIONS_FOUND_LABEL": "No se han encontrado simulaciones",
      "MIN": "min",
      "SEC": "s",
      "OF_LABEL": "de",
      "SECOND": "segundo",
      "SECONDS": "segundos",
      "MINUTE": "minuto",
      "MINUTES": "minutos",
      "ASSIGNED": "Asignada",
      "ENGAGED_TOOLTIP": "El porcentaje de usuarios que han completado una o más sesiones de una simulación en esta tarea pero que aún no han alcanzado la competencia en todas las simulaciones.",
      "SEARCH_ASSIGNMENTS": "Buscar tareas...",
      "ASSIGNMENT_NAME_LABEL": "Nombre de la tarea",
      "SIMULATION_NAME_LABEL": "Nombre de la simulación",
      "START_DATE": "Fecha de inicio",
      "END_DATE": "Fecha final",
      "NO_ASSIGNMENTS": "No se encontró ninguna tarea para este usuario.",
      "TOTAL_PRACTICE_ASSIGNMENTS": "Tareas de práctica totales",
      "SESSION_SCORES_OVER_TIME": "Puntuaciones de las sesiones a lo largo del tiempo",
      "TIME": "vez",
      "SCORE": "de puntuaciones",
      "NO_SESSIONS_AVAILABLE": "No hay sesiones disponibles para graficar.",
      "MESSAGING_SCORE_LABEL": "Puntuación de la mensajería",
      "PERSONALIZED_PRACTICE_LABEL": "Práctica personalizada",
      "ASSIGNMENT_ENAGEMENT": "Ejecución por tarea",
      "NO_PRODUCTS": "No hay productos de práctica personalizados para los equipos seleccionados",
      "TOTAL_TIME_SPENT_PRACTICING": "Tiempo total dedicado a la práctica",
      "AVERAGE_SESSIONS_PER_USER": "Promedio de sesiones por usuario",
      "MOST_COMMON_CONVERSATION_TYPE_SELECTION": "Selección del tipo de conversación más común",
      "LEAST_COMMON_CONVERSATION_TYPE_SELECTION": "Selección del tipo de conversación menos común",
      "CLEAR_TEAMS": "Eliminar equipos",
      "METHODOLOGY_SCORE_DESCRIPTION": "Calcula qué tan bien los alumnos siguen la estructura de llamadas recomendada. Las puntuaciones reflejan el promedio en todas las sesiones de esta simulación.",
      "METHODOLOGY": "Metodología",
      "MESSAGING": "Mensaje",
      "MESSAGING_V2_DASHBOARD_DESCRIPTION": "Calcula si los alumnos articulan ideas clave durante la llamada. Los gráficos muestran el porcentaje promedio de mensajes correctamente articulados por tema, en todas las sesiones.",
      "NO_METRICS_MESSAGE": "Se necesitan más sesiones para generar ideas.",
      "SELECT_ALL": "Seleccionar todo",
      "DESELECT_ALL": "Deseleccionar todo",
      "SKILLS": "Habilidades",
      "SKILLS_SCORE_STATS_DESCRIPTION": "Calcula qué tan bien los estudiantes demuestran habilidades clave durante la llamada. Las puntuaciones reflejan una evaluación de IA promediada en todas las sesiones.",
      "EXPERT": "Experto",
      "PROFICIENT": "Competente",
      "DEVELOPING": "En desarrollo",
      "FULLY_ARTICULATED": "Totalmente articulado",
      "PARTIALLY_ARTICULATED": "Parcialmente articulado",
      "NOT_MENTIONED": "No mencionado",
      "MESSAGING_SCORE_STATS_DESCRIPTION": "Calcula si los alumnos articulan ideas clave durante la llamada. Los gráficos muestran la frecuencia con la que cada mensaje se articuló correctamente en todas las sesiones.",
      "CLEAR": "Quitar",
      "CLEAR_STATUS": "Quitar estado",
      "CLEAR_USERS": "Quitar usuarios",
      "CLEAR_SIMULATIONS": "Quitar simulaciones",
      "CLEAR_ASSIGNMENTS": "Quitar tareas",
      "MODAL_SUBHEADING": "Todos los objetivos {{ count }} — promedio de puntuaciones en todas las sesiones",
      "VIEW_ALL_OBJECTIVES": "Ver todos los objetivos {{ count }} →",
      "LEAST_MISSED_QUESTION": "PREGUNTA MENOS FALLADA",
      "MOST_MISSED_QUESTION": "PREGUNTA MÁS FALLADA",
      "HIGHEST_SCORING_METHODOLOGY_SECTION": "SECCIÓN DE METODOLOGÍA DE MAYOR PUNTUACIÓN",
      "LOWEST_SCORING_METHODOLOGY_SECTION": "SECCIÓN DE METODOLOGÍA DE PUNTUACIÓN MÁS BAJA",
      "LEAST_ARTICULATED_MESSAGE": "MENSAJE MENOS ARTICULADO",
      "ENGAGEMENT": "PARTICIPACIÓN",
      "USER_ENGAGEMENT_MORE_SESSIONS": "más sesiones completadas que el promedio del equipo",
      "QUESTION_CORRECT_PERCENTAGE_DESC": "de las veces, este usuario acertó",
      "QUESTION_CORRECT_PERCENTAGE_DESC_ASSIGNMENT": "de las veces, los usuarios aciertan",
      "METHODOLOGY_AVERAGE_POINTS_DESC": "puntos promedio en este objetivo en todas las sesiones",
      "MOST_ARTICULATED_MESSAGE": "MENSAJE MÁS ARTICULADO",
      "LEAST_MISSED_ANSWER_POINT": "PUNTO DE RESPUESTA MENOS FALLADO",
      "MOST_MISSED_ANSWER_POINT": "PUNTO DE RESPUESTA MÁS FALLADO",
      "MOST_ARTICULATED_MESSAGE_DESCRIPTION": "de las veces, este usuario articula plenamente este mensaje",
      "LEAST_ARTICULATED_MESSAGE_DESCRIPTION": "de las veces, este usuario articula este mensaje",
      "ASSIGNMENT_STATUS": "Estado de la tarea",
      "STATUS_ACTIVE": "Activo",
      "STATUS_ENDED": "Finalizado",
      "STATUS_CLOSED": "Cerrado",
      "STATUS_ARCHIVED": "Archivada",
      "USER_ENGAGEMENT_FEWER_SESSIONS": "menos sesiones completadas que el promedio del equipo",
      "MOST_ARTICULATED_MESSAGE_DESCRIPTION_ASSIGNMENT": "de las veces, los usuarios articulan este mensaje",
      "LEAST_ARTICULATED_MESSAGE_DESCRIPTION_ASSIGNMENT": "de las veces, los usuarios articulan este mensaje",
      "OTHERS_SINGULAR": "y 1 más",
      "OTHERS_PLURAL": "y {{ count }} más",
      "PAGINATION_PREVIOUS": "Anterior",
      "PAGINATION_NEXT": "Siguiente",
      "HOUR_LABEL": "hora",
      "SESSIONS_LABEL": "sesiones"
    },
    "personalizedPractice": {
      "TITLE": "Práctica personalizada",
      "DESCRIPTION": "¡Hola, {{userFirstName}}! Las prácticas personalizadas te permiten establecer tus propios escenarios para que sean lo más realistas posible.",
      "LOADING": "Cargando…",
      "VIEW_SESSIONS": "Ver sesiones",
      "VIEW_SIMULATION": "Ver simulación",
      "TOTAL_SESSION": "sesión total",
      "TOTAL_SESSIONS": "total de sesiones",
      "BREADCRUMB": "Práctica personalizada",
      "SCENARIO_DETAILS_TITLE": "Detalles del escenario",
      "SCENARIO_DETAILS_DESCRIPTION": "Selecciona variables de las opciones a continuación para ajustar la simulación a tus necesidades.",
      "AVATAR": "Avatar",
      "SELECT_PLACEHOLDER": "Seleccionar",
      "CONVERSATION_TYPE": "Tipo de conversación",
      "SELECT_CONVERSATION_TYPE": "Seleccionar tipo de conversación",
      "LAUNCH_SIMULATION": "Iniciar simulación con selecciones",
      "PREVIOUS_SESSIONS": "Sesiones anteriores",
      "TOTAL": "Total",
      "FILTERS": "Filtros:",
      "DATE": "Fecha",
      "DIFFICULTY": "Dificultad",
      "TEMPERAMENT": "Temperamento",
      "SESSION_DATE": "Fecha de la sesión",
      "SESSION_SCORE": "Puntuación de la sesión",
      "DURATION": "Duración",
      "OVERALL_SCORE": "Puntuación global",
      "MESSAGING": "Mensaje",
      "METHODOLOGY": "Metodología",
      "SKILLS": "Habilidades",
      "RESULTS": "Resultados",
      "VIEW_FEEDBACK": "Ver retroalimentación",
      "OVERALL_SCORE_LABEL": "Puntuación global",
      "SCORE": "de puntuaciones",
      "NO_PRODUCTS_TITLE": "No hay productos disponibles",
      "NO_PRODUCTS_DESCRIPTION": "Todavía no tienes ningún producto de práctica personalizada.",
      "NO_SESSIONS_FOUND": "No se encontraron sesiones con los filtros seleccionados",
      "TIME": "vez",
      "ALL": "Todo",
      "LEARNER": "Estudiante",
      "MOOD": "Estado de ánimo",
      "CLEAR_FILTERS": "Quitar filtros",
      "PAGINATION_PREVIOUS": "Anterior",
      "PAGINATION_NEXT": "Siguiente",
      "DURATION_MINUTES_SECONDS": "{{minutes}} m {{seconds}} s",
      "DURATION_SECONDS": "{{seconds}} s"
    },
    "login": {
      "TITLE": "Bienvenido de nuevo",
      "SUB_TITLE": "¿Cómo te gustaría iniciar sesión?  ",
      "LOGIN_WITH_SSO": "Iniciar sesión con el inicio de sesión único (SSO) de la empresa",
      "LOGIN_WITH_PASSWORD": "Iniciar sesión con contraseña",
      "PROVIDE_EMAIL": "Proporciona tu dirección de correo electrónico",
      "HELP_TEXT": "¿Necesitas ayuda? Contacto",
      "EMAIL_ERROR": "No podemos iniciar sesión; ponte en contacto con el administrador de tu empresa o al departamento de TI.",
      "EMAIL": "Correo electrónico",
      "LOGIN": "Iniciar sesión",
      "ALERT": "Alerta",
      "EMAIL_PLACEHOLDER": "olivia@untitledui.com",
      "LOGIN_CONSENT_MESSAGE": "Al acceder a tu cuenta, aceptas las {{termsLink}} y la {{privacyLink}}.",
      "TERMS_OF_SERVICE": "Condiciones de uso",
      "PRIVACY_POLICY": "Política de privacidad",
      "WRONG_REGION_MESSAGE": "No podemos iniciar tu sesión; ponte en contacto con el administrador de tu empresa.",
      "WRONG_REGION_LINK": "También puedes intentar iniciar sesión en el sitio web de {{regionName}}."
    },
    "learningPathway": {
      "BEGIN": "Comenzar",
      "DUE_DATE": "Fecha de entrega",
      "FOOTER_SUBTITLE_READY": "¡Pregúntame cualquier cosa! Estoy listo para ayudar.",
      "LEAVE_STEP": "Abandonar paso",
      "NEXT_STEP": "Siguiente paso",
      "NOTIFICATIONS_ARIA": "Notificaciones",
      "PDF_NEXT_PAGE": "Siguiente página",
      "PDF_NO_SOURCE": "No se proporcionó el archivo PDF original.",
      "PDF_PREVIOUS_PAGE": "Página anterior",
      "POST_CALL_SUBTITLE": "Deja algún comentario mientras procesamos tus resultados.",
      "POST_CALL_TITLE": "Llegaste al final de este cuestionario.",
      "SETTINGS": "Ajustes",
      "TOAST_CONTENT": "Haz clic abajo para ver, o regresa a la pantalla de detalles de la trayectoria para tu siguiente paso.",
      "TOAST_TITLE": "Los resultados de tu juego de roles {{stepName}} fueron procesados",
      "ASSIGNMENTS": "Tareas",
      "USER_FALLBACK": "Usuario",
      "VIEW_RESULTS": "Ver resultados",
      "QUIZ_TITLE": "Cuestionario",
      "SUBMIT_ANSWER": "Enviar respuesta",
      "CONTINUE": "Continuar",
      "REVIEW_MATERIAL": "Revisar material",
      "ASK_QUESTIONS_ABOUT_PATHWAY": "Hacer preguntas sobre la trayectoria",
      "FOOTER_SUBTITLE_MUTED": "Actualmente estás en silencio. El entrenador no puede oírte.",
      "FOOTER_SUBTITLE_LISTENING": "Escuchando tu pregunta...",
      "FOOTER_SUBTITLE_THINKING": "Pensando en una respuesta...",
      "PDF_LOADING": "Cargando PDF",
      "PDF_SCROLL_HINT": "Desplázate para continuar leyendo",
      "QUIZ_OVERALL_SCORE_TOOLTIP": "La puntuación general es el promedio ponderado de tus respuestas para este intento.",
      "QUIZ_COLUMN_DATE": "Fecha",
      "QUIZ_COLUMN_OVERALL_SCORE": "Puntuación global",
      "QUIZ_COLUMN_ANSWER_POINTS": "Puntos de respuesta",
      "QUIZ_COLUMN_RESULTS": "Resultados",
      "COMPLETE_STEP": "Completado",
      "ERROR_TITLE": "Algo salió mal",
      "ERROR_MESSAGE": "Sal y vuelve a entrar a la trayectoria. Si el problema persiste, ponte en contacto con",
      "ERROR_HELP_EMAIL": "help@quantified.ai",
      "PATHWAY_COMPLETED_TITLE": "Completaste esta trayectoria",
      "PATHWAY_COMPLETED_BODY": "Puedes revisar tus resultados en cualquier momento o volver a cualquier paso para seguir practicando.",
      "PATHWAY_COMPLETED_RETURN": "Volver a las tareas",
      "PATHWAY_OUT_OF_ATTEMPTS_TITLE": "Te quedaste sin intentos para un paso en la trayectoria",
      "PATHWAY_OUT_OF_ATTEMPTS_BODY": "Ponte en contacto con tu gerente para discutir los próximos pasos.",
      "COMPLETED": "Completada",
      "EXITING_QUIZ_EARLY": "Salir de este cuestionario ahora contará como un intento",
      "TRY_AGAIN": "Inténtalo de nuevo",
      "RETURN_TO_PATHWAY": "Vuelve a la página de inicio de la trayectoria",
      "REVIEW_BEFORE_QUIZ_TOOLTIP": "Revisa este paso antes de volver a realizar el cuestionario",
      "FOOTER_SUBTITLE_QUIZ_RESULT_DONE": "Haz clic en el botón de la derecha →",
      "VIEW_CALL_DETAILS": "Ver detalles de la llamada",
      "FOOTER_SUBTITLE_READY_LEARN_WITH_X": "El entrenador está escuchando si tienes alguna pregunta",
      "COLUMN_DATE": "Fecha",
      "COLUMN_OVERALL_SCORE": "Puntuación global",
      "COLUMN_RESULTS": "Resultados",
      "COLUMN_ANSWER_POINTS": "Puntos de respuesta",
      "COLUMN_MESSAGING_SCORE": "Puntuación de la mensajería",
      "COLUMN_METHODOLOGY_SCORE": "Puntuación de la metodología",
      "COLUMN_SKILLS_SCORE": "Puntuación de habilidades",
      "PRACTICE_AGAIN": "Practica de nuevo",
      "DEBRIEF_LATEST_SESSION": "Informe de la última sesión",
      "EXIT_MODAL_TITLE": "¿Seguro de que deseas terminar este juego de roles?",
      "EXIT_MODAL_EXIT": "Salir",
      "EXIT_MODAL_RESUME": "Continuar",
      "EXIT_MODAL_DESC_LIMITED_ATTEMPTS": "Si sales del juego de roles ahora, no se puntuará, pero seguirá contando como un intento.",
      "EXIT_MODAL_DESC_UNLIMITED_ATTEMPTS": "Si sales del juego de roles ahora, no se puntuará.",
      "EXIT_MODAL_DESC_SCORED": "Si sales el juego de roles ahora, puntuaremos tu llamada tal cual.",
      "RESULTS_PROCESSING": "Los resultados se están procesando",
      "RESULTS_FAILED": "No se pudieron cargar los resultados. Ponte en contacto con help@quantified.ai",
      "DEBRIEF_TITLE": "Informe",
      "DEBRIEF_DESCRIPTION": "Comenta los resultados de tu último intento de certificación",
      "DEBRIEF_DESCRIPTION_PRACTICE": "Comenta los resultados de tu última sesión de práctica",
      "VIEW_ALL_SESSIONS": "Ver todas las sesiones",
      "COLLAPSE_SESSIONS": "Contraer sesiones",
      "VIEW_ALL_ATTEMPTS": "Ver todos los intentos",
      "COLLAPSE_ATTEMPTS": "Contraer intentos",
      "REATTEMPT_CERTIFICATION": "Volver a intentar la certificación",
      "DEBRIEF_EXIT_MODAL_TITLE": "¿Seguro de que deseas terminar este informe?",
      "DEBRIEF_EXIT_MODAL_DESC": "Si sales del informe ahora, no se marcará como completo.",
      "EXIT_PATHWAY": "Salir de la trayectoria",
      "HELP": "Ayuda",
      "LEARN_STEP_HELP_CLOSE": "Cerrar",
      "LEARN_STEP_HELP_TROUBLE": "Si todavía tienes problemas, ponte en contacto con",
      "LEARN_STEP_HELP_EMAIL": "help@quantified.ai",
      "LEARN_STEP_HELP_VIDEO_P1": "Mira el material y hazle preguntas al entrenador.",
      "LEARN_STEP_HELP_VIDEO_P2": "Selecciona el botón de reproducción para iniciar el video. Puedes retroceder para volver a revisar el material.",
      "LEARN_STEP_HELP_VIDEO_P3": "Desactiva el silencio en la parte inferior derecha para hacer una pregunta. Esto pausará el video. Cuando reproduzcas el video, silenciaremos tu micrófono.",
      "LEARN_STEP_HELP_VIDEO_P4": "Cuando hayas visto todo el video, avanza al siguiente paso.",
      "LEARN_STEP_HELP_PDF_P1": "Lee el material y hazle preguntas al entrenador.",
      "LEARN_STEP_HELP_PDF_P2": "Navega por el material desplazándote o usando los botones de flecha a cada lado para moverte entre páginas.",
      "LEARN_STEP_HELP_PDF_P3": "Puedes activar y desactivar el silencio en la parte inferior derecha.",
      "LEARN_STEP_HELP_PDF_P4": "Cuando hayas leído todo, avanza al siguiente paso.",
      "PDF_FULLSCREEN_ENTER": "Entrar a pantalla completa",
      "PDF_FULLSCREEN_EXIT": "Salir de pantalla completa",
      "PDF_ZOOM_IN": "Acercar",
      "PDF_ZOOM_OUT": "Alejar",
      "ASSESSMENT_EXIT_MODAL_TITLE": "¿Seguro de que deseas continuar?",
      "ASSESSMENT_EXIT_MODAL_DESC": "Si avanzas antes de que se complete esta conversación, la experiencia de aprendizaje será más larga y menos personalizada.",
      "ASSESSMENT_EXIT_MODAL_RESUME": "Reanudar la evaluación",
      "ASSESSMENT_EXIT_MODAL_PROCEED": "Continuar",
      "ASSESSMENT_PERSONALIZATION_ERROR_TITLE": "No hemos podido personalizar tu trayectoria",
      "ASSESSMENT_PERSONALIZATION_ERROR_DESC_START": "Te hemos asignado la trayectoria completa: comunícate con ",
      "ASSESSMENT_PERSONALIZATION_ERROR_DESC_END": " si deseas volver a intentar la personalización",
      "OPTIONAL": "Opcional",
      "DISMISS": "Descartar",
      "DOWNLOAD": "Descargar"
    },
    "leaderboard": {
      "LEADERBOARD": "Clasificación",
      "TOP10PERCENT": "El 10 % más alto",
      "PRACTICE_ASSIGNMENT": "Tareas de práctica",
      "SIMULATION": "Simulación",
      "SELECT_ASSIGNMENT": "Seleccionar tarea",
      "SELECT_SIMULATION": "Seleccionar simulación",
      "SELECT_ASSIGNMENT_AND_SIMULATION": "Selecciona una tarea y una simulación para ver a los líderes",
      "NO_DATA": "Aún no hay actividad. Una vez que el equipo empiece a participar, verás que las clasificaciones aparecen aquí.",
      "NO_ASSIGNMENTS_AVAILABLE": "No hay tareas disponibles",
      "NO_SIMULATIONS_AVAILABLE": "No hay simulaciones disponibles",
      "NAME": "Nombre",
      "HIGH_SCORE": "Puntuación alta",
      "AVERAGE_SCORE": "Puntuación promedio",
      "TOTAL_SESSIONS": "Total de sesiones",
      "LAST_SESSION": "Última sesión",
      "TOP5": "Top 5",
      "OF": "de",
      "ENGAGED_USERS": "usuarios que participaron",
      "ENGAGED_USER": "usuario que participó",
      "HIDE_SESSIONS_WITH_LOW_SCORE": "Ocultar las sesiones con puntuaciones bajas",
      "SESSIONS_WITH_LOW_SCORE_TOOLTIP": "Las sesiones con una puntuación de \"en desarrollo\" en la sección de habilidades no contribuirán a las columnas de puntuación alta o media.",
      "NO_USERS_ENGAGED": "No hay usuarios participando",
      "PAGINATION_PREVIOUS": "Anterior",
      "PAGINATION_NEXT": "Siguiente"
    },
    "hotjarSurveys": {
      "FEEDBACK_MESSAGE": "Comparte tus comentarios para ayudarnos a mejorar.",
      "THANK_YOU_MESSAGE": "Gracias, seguiremos trabajando para mejorar tu experiencia"
    },
    "general": {
      "NEED_HELP_QUESTION": "¿Necesitas ayuda?",
      "CONTACT": "Contacto",
      "HELP_EMAIL": "help@quantified.ai",
      "PARENT_ACCOUNT": "Cuenta principal",
      "ACCOUNT": "Cuenta",
      "CHECKMARK": "Marca de verificación",
      "ICON": "Ícono",
      "ALERT": "alerta",
      "HEADS_UP": "¡Atención!",
      "USE_HEADPHONES_FOR_OPTIMAL_AUDIO": "Te recomendamos usar auriculares para que el sonido sea óptimo en tu iPad.",
      "SETTINGS": "AJUSTES",
      "RP": "RP",
      "EMAIL_LABEL": "Correo electrónico",
      "RAVEN_EMAIL": "Raven@InspireHR.com",
      "TEAM_MANAGER_FOR": "Gerente de equipo de",
      "MIAMI_SALE": "ventas en Miami",
      "CHARLOTTE_SALES": "ventas en Charlotte",
      "ATLANTA_SALES": "ventas en Atlanta",
      "TEAM": "Equipo",
      "ASSIGNMENTS": "Tareas",
      "MY_TEAMS": "Mis equipos",
      "REPORTING": "Informes",
      "DASHBOARD": "Panel",
      "LEADERBOARD": "Clasificación",
      "PERSONALIZED_PRACTICE": "Práctica personalizada",
      "HELP_SEARCH_OUR": "Busca en nuestra",
      "HELP_OR_REACH_OUT_TO": "o ponte en contacto con",
      "HELP_WITH_QUESTIONS": "con preguntas",
      "KNOWLEDGE_BASE": "base de conocimientos",
      "NO_ROLE_WEB_MESSAGE": "A este usuario no se le concedió acceso al sistema. Ponte en contacto con un administrador del sistema.",
      "NO_ROLE_IOS_TITLE": "Nuestra aplicación se centra en la experiencia del estudiante",
      "NO_ROLE_IOS_BODY_START": "Ingresa a nuestra",
      "NO_ROLE_IOS_WEB_APP": "aplicación web",
      "NO_ROLE_IOS_BODY_END": "desde el navegador de tu teléfono celular para disfrutar de funcionalidades adicionales.",
      "HELP_SECTION": "AYUDA",
      "ABOUT_SECTION": "ACERCA DE",
      "CONTACT_SUPPORT": "Ponte en contacto con el equipo de soporte",
      "OPEN_WEB_APP": "Abrir la aplicación web",
      "SEARCH_KNOWLEDGE_BASE": "Buscar en la base de conocimientos",
      "PRIVACY_POLICY": "Política de privacidad",
      "TERMS_OF_SERVICE": "Condiciones de uso",
      "VERSION": "Versión",
      "LOG_OUT": "Cerrar sesión"
    },
    "dashboard": {
      "ALL": "Todo",
      "IN_COMPLETE": "Incompleto",
      "COMPLETED": "Completada",
      "NO_ASSIGNMENT_TITLE": "No tienes ninguna tarea.",
      "NO_ASSIGNMENT_DETAILS": "Se te notificará cuando tengas tareas que completar.",
      "IN_COMPLETE_ASSIGNMENT_TITLE": "No tienes tareas incompletas.",
      "IN_COMPLETE_ASSIGNMENT_DETAILS": "Se te notificará cuando haya una nueva tarea pendiente.",
      "COMPLETED_ASSIGNMENT_TITLE": "No tienes tareas completadas.",
      "COMPLETED_ASSIGNMENT_DETAILS": "Vuelve a comprobarlo una vez que hayas completado una tarea.",
      "VIEW_ASSIGNMENT": "Ver tarea",
      "ASSIGNMENT_LABEL": "Tareas",
      "MODULE_ASSIGNMENT_ALT": "Ícono de asignación de módulo",
      "VIEW_ASSIGNMENT_FOR": "Ver tarea de",
      "DAY": "Día",
      "UNTILL_DUE": "Hasta la fecha de entrega",
      "PAST_DUE": "De retraso",
      "AVAILABLE_IN": "Disponible en",
      "DUE_TODAY": "Se entrega hoy",
      "PRACTICE": "Práctica",
      "CERTIFICATION": "Certificación",
      "UPCOMING": "Próximamente",
      "TEST_ASSIGNMENT": "Tarea de prueba",
      "CLOSED": "Cerrada",
      "NO_ASSIGNMENT_FILTERED_TITLE": "No se encontraron tareas.",
      "NO_ASSIGNMENT_FILTERED_DETAILS": "Intenta ajustar tus filtros para ver las tareas disponibles, o vuelve a consultar más tarde cuando se agreguen nuevas tareas.",
      "VIEW_PATHWAY": "Ver trayectoria",
      "TOTAL": "Total",
      "STATUS_LABEL": "Estado",
      "STATUS_SELECTION_LABEL": "Estado:",
      "ASSIGNMENT_TYPE": "Tipo de tarea",
      "ASSIGNMENT_TYPE_SELECTION_LABEL": "Tipo de tarea:",
      "NOT_STARTED": "Sin iniciar",
      "CERTIFIED": "Certificada",
      "NOT_CERTIFIED": "No certificada",
      "IN_PROGRESS": "En curso",
      "PATHWAY": "Trayectoria de aprendizaje",
      "SELECT_ALL": "Seleccionar todo",
      "DESELECT_ALL": "Deseleccionar todo",
      "GET_STARTED": "Comenzar",
      "ASSIGNMENT_STATUS_LABEL": "Estado de la tarea",
      "ASSIGNMENT_STATUS_SELECTION_LABEL": "Estado de la tarea:",
      "CLEAR_STATUS": "Quitar estado",
      "ENDED": "Finalizada",
      "START_PATHWAY": "Comenzar trayectoria",
      "DAYS": "Días",
      "OTHERS_SINGULAR": "y 1 más",
      "OTHERS_PLURAL": "y {{ count }} más"
    },
    "cognito": {
      "INVITATION_SUBJECT": "¡Te damos la bienvenida a Quantified!",
      "INVITATION_MESSAGE": "Estamos encantados de tenerte con nosotros. Para empezar, sigue los pasos que se indican a continuación para acceder a tu cuenta por primera vez.",
      "ACCOUNT_DETAILS": "Datos de tu cuenta:",
      "USERNAME": "Nombre de usuario",
      "PASSWORD": "Contraseña temporal",
      "STEPS_LABEL": "Próximos pasos para iniciar sesión",
      "STEP_1": "1. Haz clic en el botón “Iniciar sesión” para ir a la página de inicio de sesión.",
      "STEP_2": "2. Introduce el nombre de usuario y la contraseña temporal que te hemos proporcionado anteriormente.",
      "STEP_3": "3. Una vez que hayas iniciado sesión, se te pedirá que crees una nueva contraseña.",
      "LOGIN_BUTTON": "Iniciar sesión",
      "ABOUT_US": "El simulador de Quantified es un entorno virtual diseñado para ayudarte a desarrollar rápidamente habilidades esenciales, lo que te permite conectar y comunicarte más eficazmente con tus clientes.",
      "EXPIRY_TIME": "Esta contraseña temporal caducará en 24 horas. Si tienes problemas para iniciar sesión, ponte en contacto con nuestro equipo de soporte en",
      "TEAM": "El equipo de Quantified",
      "INVITATION_SMS_USERNAME": "Tu nombre de usuario es",
      "INVITATION_SMS_PASSWORD": "y tu contraseña temporal es",
      "AUTHENTICATION_CODE": "Tu código de autenticación es",
      "PASSWORD_RESET_CODE": "Tu código de restablecimiento de contraseña de Quantified",
      "RESET_PASSWORD_EMAIL": "Correo electrónico de restablecimiento de contraseña",
      "HELLO": "¡Hola!",
      "USE_VERIFICATION_CODE": "Solicitaste restablecer la contraseña. Utiliza el código de verificación que aparece a continuación para completar el proceso.",
      "VERIFICATION_CODE": "Código de verificación",
      "NEXT_STEP": "Próximos pasos",
      "RESET_PASSWORD_PAGE": "Vuelve a la página de restablecimiento de contraseña en el navegador.",
      "ENTER_VERIFICATION_CODE": "Introduce el código de verificación cuando se te solicite.",
      "CREATE_PASSWORD": "Una vez verificado el código, sigue las instrucciones para crear una nueva contraseña.",
      "DISREGARD_NOTE": "Si no solicitaste restablecer tu contraseña, ignora este correo electrónico.",
      "CONTACT_SUPPORT": "Si necesitas más ayuda, ponte en contacto con nuestro equipo de soporte en",
      "HELP_EMAIL": "help@quantified.ai",
      "THANK_YOU": "Atentamente,",
      "QUANTIFIED_TEAM": "El equipo de Quantified",
      "ADDRESS": "4200 Marathon Blvd, Suite 210, Austin, Texas 78756, Estados Unidos",
      "RETURN_TO_PATHWAY": "Vuelve a la página de inicio de la trayectoria"
    },
    "call": {
      "LOADING": "Cargando",
      "SIMULATION_PAUSED": "La simulación se ha pausado.",
      "CLICK_RESUME": "Haz clic en el botón “Reanudar” para continuar.",
      "NO_INTERNET": "Sin conexión a Internet",
      "TRY_AGAIN": "Revisa tu conexión y vuelve a intentarlo.",
      "MIC_MUTED": "El micrófono está silenciado",
      "MIC_MUTED_DESCRIPTION": "Uy, parece que el micrófono está silenciado. Desactiva el silencio para responder y continuar.",
      "NO_RESPONSE": "No se detectó respuesta",
      "MIC_NOT_CONNECTED": "Uy, parece que el micrófono no está conectado. Vuelve a seleccionar tu dispositivo para responder y continuar.",
      "AUDIO_ISSUE": "Uy, algo salió mal. Comprueba la configuración de tu dispositivo y asegúrate de que estás en un lugar tranquilo y sin ruidos de fondo.",
      "LOADING_ALT": "Cargando…",
      "REPEAT_RESPONSE": "Se te remitirá automáticamente a la simulación para que repitas tu respuesta y vuelvas a intentarlo.",
      "NEEDS_MORE_TIME_QUESTION": "necesita más tiempo para pensar, ¿quieres esperar?",
      "NEEDS_MORE_TIME": "necesita más tiempo para pensar.",
      "WAIT_OR_END_CALL": "Te informaremos cuando estén listos, o puedes finalizar la llamada y",
      "RETURN_TO_ASSIGNMENTS": "volver a la tarea",
      "READY": "Listo",
      "IS_READY": "está listo/a para continuar la conversación.",
      "TRY_AGAIN_LABEL": "Inténtalo de nuevo",
      "CHECK_SETTINGS": "Verificar ajustes",
      "PAUSED_SIMULATION": "Pausaste esta simulación.",
      "PAUSED_SIMULATION_DESCRIPTION": "La grabación de video y audio se pausa hasta que se reanude la simulación.",
      "RESUME": "Continuar",
      "SETTINGS": "Ajustes",
      "CAPTURING_RESPONSE": "Capturando las respuestas",
      "TOUR_MESSAGE": "Una vez que termines de hablar, asegúrate de hacer clic en el botón Continuar para garantizar que las respuestas se registran y puntúan.",
      "NEXT": "Siguiente",
      "START_CALL": "Comenzar",
      "END_CALL_TITLE": "¿Seguro/a de que deseas terminar esta simulación?",
      "END_CALL_DESCRIPTION": "Si terminas la simulación ahora, no recibirás una puntuación ni retroalimentación sobre la conversación.",
      "END_CALL": "Finalizar",
      "BROWSER_ACCESS_DENIED": "Tu navegador tiene denegado el acceso a este dispositivo.",
      "COPY_SESSION_ID_BUTTON": "Copiar ID de sesión",
      "TIPS_GUIDANCE_MESSAGE": "Aquí aparecerán temas de conversación y consejos.",
      "CONTINUE": "Continuar",
      "SESSION_ID_LABEL": "ID de sesión:",
      "SESSION_ID_COPIED": "ID de sesión copiado",
      "HINTS_AND_SUGGESTIONS_TITLE": "Pistas y sugerencias",
      "HINT_LABEL": "Pista",
      "CAPTIONS_LABEL": "Subtítulos",
      "PAUSE_LABEL": "Pausa",
      "VIDEO_LABEL": "Video",
      "PARTY_EMOJI": "emoji de fiesta",
      "CALL_ENDED_MESSAGE": "Llegaste al final de esta simulación.",
      "CALL_ENDED_INACTIVITY": "Esta simulación ha terminado por inactividad",
      "CALL_ENDED_GENERIC": "Esta simulación ha terminado",
      "FEEDBACK_PROMPT": "Deja algún comentario mientras procesamos tus resultados.",
      "INTERACTION_THRESHOLD_NOT_MET": "No alcanzaste nuestro umbral de interacción para obtener una puntuación. Inténtalo de nuevo.",
      "REALISTIC_CONVERSATION_QUESTION": "¿Te pareció realista y natural esta conversación?",
      "KNOWLEDGEABLE_PREPARED_QUESTION": "¿Te sientes más informado y preparado después de esta simulación?",
      "FEEDBACK_THANK_YOU": "¡Gracias por tus comentarios!",
      "FEEDBACK_IMPROVEMENT_NOTE": "¡Gracias por tus comentarios! Trabajaremos en mejorar la experiencia.",
      "AUDIO": "Audio",
      "VISUAL_AID_LOAD_ERROR": "No se pudo cargar la ayuda visual",
      "BEGIN_CALL": "Comenzar",
      "LEAVE_CALL_BRIEFING": "Salir del resumen",
      "RESTORE_CALL": "Restaurar la simulación",
      "FEW_SECONDS": "Esto puede tardar unos segundos.",
      "CHECK_ALT": "Comprobar",
      "COPY_ALT": "Copiar",
      "HINTS_ALT": "Pistas",
      "CLOSE_CAPTIONS": "Cerrar subtítulos",
      "MICROPHONE_MUTED": "Micrófono silenciado",
      "RETURN_TO_CALL": "Volver a la simulación",
      "YES": "Sí",
      "NO": "No",
      "VIEW_RESULTS": "Ver resultados",
      "RETURN_TO_ASSIGNMENT": "Volver a la tarea",
      "HAVING_ISSUES": "Tenemos problemas para conectarnos; comprueba tu conexión a Internet y haz clic en Aceptar.",
      "OK": "Aceptar",
      "RESULTS_NOT_GENERATED": "Lo sentimos, no podemos generar resultados en este momento, inténtalo de nuevo.",
      "INACTIVITY_ALERT_MESSAGE": "Esta llamada ha finalizado por inactividad. Habla con el avatar para continuar o selecciona “Finaliza llamada” para terminar la llamada.",
      "INACTIVITY_DEFAULT_ALERT_TITLE": "Esta llamada terminará en {{secondsUntilHangup}} segundos",
      "INACTIVITY_SHORT_ALERT_TITLE": "Esta llamada terminará en unos segundos",
      "TELL_YOUR_GENDER_HEADING": "Indícanos tu género:",
      "BY_KNOWING_YOUR_GENDER_DESCRIPTION": "Al conocer tu género, el avatar puede utilizar la gramática adecuada, lo que hace que la conversación sea más natural y realista.",
      "GENDER_SELECTION": "Selección de género:",
      "SELECT_OPTION": "Selecciona una opción",
      "CONFIRM": "Confirmar",
      "MALE": "Masculino",
      "FEMALE": "Femenino",
      "NON_BINARY": "No binario/Otro",
      "PREFER_NOT_TO_ANSWER": "Prefiero no contestar",
      "NON_BINARY_MESSAGE": "Entendemos y respetamos tu identidad de género no binaria. Debido a las limitaciones tecnológicas actuales, utilizamos pronombres masculinos por defecto. Te informamos que estamos trabajando en mejoras para incluir a todas las identidades de género en el futuro. Gracias por tu comprensión y paciencia.",
      "PREFER_NOT_TO_ANSWER_MESSAGE": "Respetamos tu decisión de no indicar tu género. En estos casos, nuestra tecnología utiliza por defecto pronombres masculinos debido a las limitaciones actuales.",
      "DISPLAY_VISUAL_AID": "Mostrar la ayuda visual",
      "FULL_SCREEN": "Pantalla completa",
      "COLLAPSE": "Contraer",
      "COMPLETED_CONVERSATION_MESSAGE": "Gracias por completar esta conversación",
      "CONVERSATION_COMPLETION_FEEDBACK": "Deje una opinión mientras procesamos su conversación.",
      "ERROR_MESSAGE": "Hubo un error. Ponte en contacto con",
      "SAVED_CONVERSATION_MESSAGE": "Su conversación se ha guardado.",
      "RETURN_TO_MY_ASSIGNMENTS": "Volver a mis tareas",
      "RETURN_TO_PERSONALIZED_PRACTICE": "Regresar a la práctica personalizada",
      "PERSONALIZED_CALL_NOTE": "Acabas de completar una conversación de práctica personalizada.",
      "LEAVE_STEP_TITLE": "¿Estás seguro de que quieres abandonar este paso?",
      "EXIT": "Salir",
      "CERT_ACK_TITLE": "Confirmación del video de certificación",
      "CERT_ACK_ACCEPT_AND_BEGIN": "Aceptar y empezar",
      "CERT_ACK_RESUME_CALL": "Reanudar la llamada",
      "CERT_ACK_PROCESSING": "Procesando...",
      "CERT_ACK_CAMERA_WARNING": "Activa la cámara para continuar con la certificación.",
      "CERT_ACK_CAMERA_OFF_DURING_CALL": "Tu cámara estaba apagada. Vuelve a activar la cámara para continuar con la certificación.",
      "CERT_ACK_TEXT_1": "Para garantizar la integridad y la imparcialidad de esta certificación, tu cámara debe permanecer encendida durante toda la sesión, que será supervisada. Este requisito permite confirmar el cumplimiento de todas las normas de certificación.",
      "CERT_ACK_TEXT_2": "Al continuar, reconoces y aceptas estos requisitos.",
      "CERT_ACK_END_CALL": "Finalizar llamada",
      "LAUNCH_SIMULATION": "Simulación de lanzamiento",
      "DEBRIEF_LATEST_SESSION": "Informe de la última sesión",
      "RECONNECTING_AUDIO": "Reconectando el audio…",
      "END": "Finalizar",
      "START_DEBRIEF": "Informe de la última sesión",
      "MOVE_TO_NEXT": "Ir al siguiente paso",
      "RETRY_ROLEPLAY": "Volver a intentar el juego de roles",
      "EXIT_PATHWAY": "Salir de la trayectoria",
      "PROCESSING": "Procesando...",
      "FEEDBACK_PROMPT_REQUIRED": "Deja un comentario antes de ver tus resultados.",
      "MUTE": "Silenciar",
      "UNMUTE": "Activar sonido",
      "SCREENSHARE_LABEL": "Compartir pantalla",
      "SCREENSHARE_UNSUPPORTED_TITLE": "{{callName}} utiliza la función de compartir pantalla",
      "SCREENSHARE_UNSUPPORTED_MESSAGE_APP": "Para continuar con la llamada, utiliza nuestra aplicación en lugar de tu navegador.",
      "SCREENSHARE_UNSUPPORTED_MESSAGE_DESKTOP": "Para continuar con la llamada, acceda a ella desde una computadora de escritorio.",
      "SCREENSHARE_UNSUPPORTED_CLOSE_BUTTON": "Cerrar",
      "SCREENSHARE_UNSUPPORTED_GO_TO_APP_BUTTON": "Ir a la aplicación",
      "SCREENSHARE_UNSUPPORTED_GO_TO_APP_UNAVAILABLE": "La aplicación móvil aún no está disponible. Vuelve a comprobarlo más tarde.",
      "SCREENSHARE_STOP_LABEL": "Dejar de compartir pantalla",
      "SCREENSHARE_PIP_REOPEN_LABEL": "Volver a abrir la vista previa del vídeo",
      "SCREENSHARE_ACTIVE_LABEL": "Actualmente estás compartiendo pantalla",
      "SCREENSHARE_OS_PERMISSION_HINT": "No se pudo empezar a compartir pantalla. Activa la grabación de pantalla de tu navegador en Configuración del sistema > Privacidad y seguridad, e inténtalo de nuevo.",
      "SCREENSHARE_SAFARI_BLOCKED_HINT": "Safari bloqueó la función de compartir pantalla para esta sesión. Cierra sesión, vuelve a ingresar e inténtalo de nuevo."
    },
    "assignment": {
      "STATUS": "ESTADO",
      "SCORE": "PUNTUACIÓN",
      "MUST_ACHIEVE": "Debes lograr",
      "OR_HIGHER": "o más",
      "TEST": "Prueba",
      "OUT_OF_5": "de 5",
      "LATEST_ATTEMPT": "ÚLTIMO INTENTO",
      "TOTAL_ATTEMPTS": "intentos totales",
      "UNLIMITED": "Ilimitado",
      "REMAINING": "Restante",
      "VIEW_CALL_DETAILS": "Ver detalles",
      "MAX_ATTEMPTS_REACHED": "Alcanzaste el número máximo de intentos",
      "DUE_DATE": "Fecha de entrega",
      "DAYS": "Días",
      "DAY": "Día",
      "UNTILL_DUE": "Hasta la fecha de entrega",
      "PAST_DUE": "De retraso",
      "ONGOING": "En curso",
      "SCORE_REQUIREMENT": "Requisito de puntuación",
      "SCORE_REQUIREMENT_DETAIL": "Debes lograr una puntuación de",
      "TO_COMPLETE_EACH_CALL": "para completar cada simulación requerida.",
      "CALLS_IN_ASSIGNMENT": "Simulaciones asignadas",
      "INCOMPLETE_CALL": "Incompleto",
      "PREVIOUS_RESULTS": "Resultados anteriores",
      "DATE": "Fecha",
      "RESULTS": "Resultados",
      "VIEW_PREVIOUS_RESULTS": "Ver resultados anteriores",
      "VIEW_FEEDBACK": "Ver retroalimentación",
      "LAUNCH_CALL": "Iniciar",
      "CLOSE_BUTTON": "Botón de cerrar",
      "CHECKMARK": "marca de verificación",
      "CALL": "Llamada",
      "QUESTION": "Pregunta",
      "COMPLETED": "Completada",
      "IN_PROGRESS": "En progreso",
      "NOT_STARTED": "Sin comenzar",
      "CERTIFIED": "Certificada",
      "GUIDED": "Guiada",
      "CONVERSATIONAL": "Conversacional",
      "GUIDED_SIMULATION": "Prueba de conocimientos",
      "CONVERSATIONAL_SIMULATION": "Juego de roles",
      "NO_ATTEMPTS_LEFT": "No quedan intentos",
      "NO_ATTEMPTS": "Ningún intento",
      "OVERVIEW": "Visión general",
      "ABOUT_THE_AVATAR": "Acerca del avatar",
      "SCORING_CRITERIA": "Criterios de puntuación",
      "SIMULATION_OVERVIEW": "Resumen de la simulación",
      "ABOUT_THE_PERSONA": "Sobre el personaje",
      "OUTOF_COMPLIANCE": "Incumplimiento",
      "CLOSED": "Cerrada",
      "COMPLETED_CALLS": "Llamadas completadas"
    }
  },
  "en": {
    "root": {
      "ADMIN_PORTAL": "ADMIN PORTAL",
      "SUPPORT": "SUPPORT",
      "U": "U",
      "USER": "User",
      "LOGOUT": "Logout",
      "ADMIN": "Admin",
      "SUPPORT_SMALL": "Support",
      "QUANTIFIED_AI": "Quantified.AI",
      "MICROPHONE": "MICROPHONE",
      "CAMERA": "CAMERA",
      "ACCESS_DENIED": "ACCESS_DENIED"
    },
    "teams": {
      "MY_TEAMS": "My teams",
      "COMPLETED": "Completed",
      "IN_PROGRESS": "In progress",
      "NOT_STARTED": "Not started",
      "ASSIGNMET_MODULE": "Assignment Module",
      "START_DATE": "Start date",
      "DUE_DATE": "Due date",
      "ASSIGNED_MEMBERS": "Assigned members",
      "CALLS_IN_MODULE": "Simulations in module",
      "COMPLETION_REQUIRMENT": "Completion requirement",
      "COMPLETE_ALL_CALLS": "Complete all simulations with a score of",
      "OR_HIGHER": "or higher",
      "PROGRESS_OVERVIEW": "PROGRESS OVERVIEW",
      "TEAM_MEMBERS": "team members",
      "AVERAGE_HIGH_SCORE": "Average high score",
      "AVERAGE_NUMBER_ATTEMPTS_CALL": "Average number of attempts per simulation",
      "TOTAL_PRACTICES": "Total practices",
      "INDIVIDUAL_CALL_PROGRESS": "INDIVIDUAL SIMULATION PROGRESS",
      "OF_TEAM_MEMBERS": "of team members completed",
      "AVERAGE_PRACTICES_TO_COMPLETION": "Average practices to completion",
      "TEAM_MEMBER_DETAILS": "TEAM MEMBER DETAILS",
      "DOWNLOAD_ACTIVITY_REPORT": "Download activity report",
      "TEAM_MEMBER": "Team member",
      "PROGRESS": "Progress",
      "CALLS_COMPLETED": "Simulations completed",
      "PRACTICES": "Practice sessions",
      "MOST_RECENT_PRACTICE": "Most recent session",
      "THIS_TEAM_HAS_NO_ACTIVE_ASSIGNMENTS": "This team has no active assignments at this time",
      "CALL_NAME_LABEL": "Simulation name",
      "HIGHEST_SCORE": "Highest Score"
    },
    "simulationBuilder": {
      "THRESHOLD": "Threshold",
      "TYPE": "Type",
      "SELECT_AN_OPTION": "Select an option",
      "CORRECT_FEEDBACK": "Correct feedback",
      "INCORRECT_FEEDBACK": "Incorrect feedback",
      "CORRECT_FEEDBACK_PLACEHOLDER": "Displayed when the learner gets this correct",
      "INCORRECT_FEEDBACK_PLACEHOLDER": "Displayed when the learner gets this incorrect",
      "MESSAGE_NUMBER": "Message {{ index }}",
      "ENTER_MESSAGE_TEXT": "Enter message text...",
      "FACT_MESSAGE_LABEL": "Message",
      "FACT_MESSAGE_DESCRIPTION": "Messages should be one piece of information, written as a complete sentence. Keep it specific, simple, and limited in scope — avoid messages that could be partially articulated.",
      "FACT_INCORRECT_ANSWER_LABEL": "Incorrect answer text",
      "FACT_INCORRECT_ANSWER_DESCRIPTION": "The text displayed to the learner if they get this fact incorrect",
      "SHOW_INCORRECT_ANSWER_TEXT": "Show alternative text for incorrect responses",
      "ADD_NEW_FACT": "Add new fact",
      "FACT_SINGULAR": "fact",
      "FACT_PLURAL": "facts",
      "FACT_EXTRACTED_SINGULAR": "{{ count }} fact extracted",
      "FACT_EXTRACTED_PLURAL": "{{ count }} facts extracted",
      "FACTS_CANNOT_BE_EMPTY": "Facts cannot be empty. Add a message to each fact before testing or publishing.",
      "SKILLS_RUBRIC_REQUIRED_TOOLTIP": "Attach a skills rubric. Skills is enabled with a weight above 0%.",
      "METHODOLOGY_REQUIRED_TOOLTIP": "Select a methodology rubric. Methodology is enabled with a weight above 0%.",
      "REVIEW_REQUIRED_LABEL": "Review suggested",
      "DELETE": "Delete",
      "SCORABLE": "Scorable",
      "SEARCH_BY_SIMULATION_NAME": "Search by simulation name",
      "SIMULATION_STATUS_PLACEHOLDER": "Simulation status",
      "SIMULATION_STATUS_PREFIX": "Simulation status:",
      "NO_SIMULATIONS_FOUND": "No simulations found",
      "SELECT_ALL": "Select all",
      "DESELECT_ALL": "Deselect all",
      "STATUS_TESTING": "Testing",
      "STATUS_DRAFT": "Draft",
      "STATUS_PUBLISHED": "Published",
      "STATUS_ARCHIVED": "Archived",
      "SEARCH_BY_ASSIGNMENT_NAME": "Search by assignment name",
      "ASSIGNEES_ZERO_STATE_MESSAGE": "No users have been assigned yet",
      "ADD_USERS_TO_ASSIGNMENT": "Add users to assignment",
      "NO_DATA_FOUND": "No Data Found!",
      "NO_USERS_SELECTED": "No user selected",
      "COL_FIRST_NAME": "First Name",
      "COL_LAST_NAME": "Last Name",
      "COL_EMAIL": "Email",
      "COL_VIEW_USER": "View user",
      "COL_VIEW_ASSIGNMENT": "View assignment",
      "COL_ASSIGNMENT_NAME": "Assignment name",
      "COL_STATUS": "Status",
      "COL_TEAM_ASSOCIATIONS": "Team associations",
      "COL_REPORTING_STATUS": "Reporting status",
      "BREADCRUMB_USERS": "Users",
      "STATUS_STAGED": "Staged",
      "STATUS_ACTIVE": "Active",
      "STATUS_ENDED": "Ended",
      "STATUS_CLOSED": "Closed",
      "SEARCH_USERS_PLACEHOLDER": "Search users",
      "NO_USERS_FOUND": "No users found",
      "USERS_TAB_LABEL": "Users",
      "ADD_TO_ASSIGNMENT": "Add to Assignment",
      "ASSIGNMENTS_COUNT": "assignments",
      "REPORTING_EXCLUDED": "Excluded",
      "REPORTING_INCLUDED": "Included",
      "KEBAB_EDIT_TEAM_ASSOCIATIONS": "Edit team associations",
      "KEBAB_EXCLUDE_FROM_REPORTING": "Exclude from reporting",
      "KEBAB_INCLUDE_IN_REPORTING": "Include in reporting",
      "KEBAB_REMOVE_FROM_ASSIGNMENT": "Remove from assignment",
      "NO_TEAMS": "—",
      "TEAMS_COUNT": "{{ count }} teams",
      "ADD_TO_ASSIGNMENT_MODAL_HEADING": "Add to assignment",
      "FIELD_LABEL_ASSIGNMENT": "Assignment",
      "SEARCH_ASSIGNMENTS_PLACEHOLDER": "Search for assignments",
      "BUTTON_SET_TEAM_ASSOCIATION": "Set team association",
      "FIELD_LABEL_TEAM": "Team",
      "SEARCH_TEAM_PLACEHOLDER": "Search for team",
      "BUTTON_BACK": "Back",
      "BUTTON_CANCEL": "Cancel",
      "BUTTON_ADD_TO_ASSIGNMENT": "Add to assignment",
      "EDIT_TEAM_ASSOCIATIONS_HEADING": "Edit team associations",
      "EDIT_TEAM_ASSOCIATIONS_DESCRIPTION": "For the assignment {{ assignmentName }}",
      "BUTTON_SAVE_ASSOCIATIONS": "Save associations",
      "REFERENCE_DOCUMENT_STATUS_UPLOADING": "– Uploading...",
      "REFERENCE_DOCUMENT_STATUS_SUCCESS": "– 100% uploaded",
      "REFERENCE_DOCUMENT_STATUS_ERROR": "– Upload error",
      "REFERENCE_DOCUMENT_STATUS_DELETING": "– Deleting",
      "REFERENCE_DOCUMENT_DELETE_ERROR": "Failed to delete the document. Please try again.",
      "REFERENCE_DOCUMENT_UPLOAD_ERROR": "Failed to upload the document. Please try again.",
      "CONTENT_LIMIT_EXCEEDED_ERROR": "Content limit exceeded.  Remove one or more documents to continue.",
      "LAST_FACT_DELETE_WARNING_HEADING": "Delete last fact?",
      "LAST_FACT_DELETE_WARNING_DESCRIPTION": "Deleting the last fact will remove all user associations with this simulation and revert its status to Draft.",
      "LEAVE_CONFIRMATION_HEADING": "Leave simulation creation",
      "LEAVE_CONFIRMATION_DESCRIPTION": "Are you sure you want to leave? Any progress you've made will be lost.",
      "LEAVE_CONFIRMATION_LEAVE_BUTTON": "Leave",
      "CREATE_SIMULATION_DETAILS_BUTTON": "Create simulation details",
      "SELF_AUTHORING_DESCRIPTION": "Provide a name, brief scenario description and any simulation specific documents to get started",
      "CLICK_TO_UPLOAD": "Click to upload",
      "OR_DRAG_AND_DROP": "or drag and drop",
      "REFERENCE_DOCUMENTS_UPLOAD_DESCRIPTION": "PDF (max. 50mb)",
      "ASSIGNMENT_NAME_LABEL": "Assignment name *",
      "SIMULATION_NAME_LABEL": "Simulation name",
      "NAME_FIELD_DESCRIPTION": "This name can be changed later",
      "PRODUCT_LABEL": "Product",
      "SELECT_A_PRODUCT_PLACEHOLDER": "Select a product",
      "ADD_NEW_PRODUCT": "Add new product",
      "TAGS_LABEL": "Tags",
      "CREATE_TAG_OPTION": "Create {{term}}",
      "TAG_CREATE_ERROR": "Tag could not be created, please try again",
      "EDIT_SIMULATION_TAGS_TITLE": "Edit simulation tags",
      "SAVE_TAGS_BUTTON": "Save tags",
      "CLOSE_BUTTON": "Close",
      "TAG_UPDATE_ERROR": "Tag could not be updated, please try again",
      "SCENARIO_LABEL": "Scenario",
      "REFERENCE_DOCUMENTS_LABEL": "Reference documents",
      "KC_INSTRUCTIONS_LABEL": "Instructions",
      "ADDITIONAL_GENERATION_OPTIONS_LABEL": "Additional generation options",
      "GENERATE_HINTS_LABEL": "Generate hints",
      "HINTS_TOOLTIP_TITLE": "Hints",
      "GENERATE_RESOURCE_NOTES_LABEL": "Generate resource notes",
      "RESOURCE_NOTES_TOOLTIP_TITLE": "Resource notes",
      "ACTION_CREATE_NEW": "Create new",
      "ACTION_CREATE": "Create",
      "ACTION_DUPLICATE": "Duplicate",
      "ENTITY_TYPE_SIMULATION_DISPLAY": "Simulation",
      "ENTITY_TYPE_ASSIGNMENT_DISPLAY": "Assignment",
      "ENTITY_TYPE_KNOWLEDGE_CHECK_DISPLAY": "knowledge check",
      "ENTITY_TYPE_SIMULATION_LOWER": "simulation",
      "ENTITY_TYPE_ASSIGNMENT_LOWER": "assignment",
      "MODAL_TITLE": "{{ action }} {{ type }}",
      "CONFIRM_BUTTON_LABEL": "{{ action }} {{ type }}",
      "DUPLICATE_NAME_ERROR_ASSIGNMENT": "An assignment with the same name already exists.",
      "DUPLICATE_NAME_ERROR_SIMULATION": "A simulation with the same name already exists.",
      "NAME_REQUIRED_ERROR": "Name is required.",
      "NAME_MAX_LENGTH_ERROR": "Name must be 255 characters or less.",
      "COPY_OF_PREFIX": "Copy of - {{ name }}",
      "UUID_COPIED_TOAST": "Call UUID copied to clipboard",
      "MENU_ARCHIVE": "Archive",
      "MENU_EDIT_SIMULATION_TAGS": "Edit simulation tags",
      "MENU_COPY_UUID": "Copy UUID",
      "SCORE_DISTRIBUTION_TITLE": "Current score distribution",
      "EDIT_SECTIONS_AND_WEIGHTING": "Edit sections and weighting",
      "SCORING_WEIGHTS_TITLE": "Configure scoring",
      "SCORING_WEIGHTS_DESCRIPTION": "Choose which areas to score and how much each contributes to the overall grade.  All enabled section weights must add up to 100%. The skills section cannot have a weight greater than 20%.",
      "SCORING_WEIGHT_REQUIRED": "Required",
      "SCORE_LAST_SESSION": "Score my last session",
      "REFINEMENT_IN_PROGRESS_TOOLTIP": "Refinement in progress. You can continue once it's complete.",
      "REFINEMENT_IN_PROGRESS_OVERRIDE_WARNING": "A refinement is in progress. Saving is disabled until it completes.",
      "SCORE_LAST_SESSION_MODAL_HEADING": "Score last session",
      "SCORE_LAST_SESSION_MODAL_DESCRIPTION": "Test the simulation first, then return here to score it against the selected rubric.",
      "SCORE_LAST_SESSION_MODAL_ERROR_HEADING": "Something went wrong",
      "SCORE_LAST_SESSION_MODAL_ERROR_DESCRIPTION": "Try again.",
      "MESSAGING_TITLE": "Messaging",
      "MESSAGING_SUBTITLE": "Score whether key facts are communicated",
      "METHODOLOGY_TITLE": "Methodology",
      "METHODOLOGY_SUBTITLE": "Score the approach and structure of the call",
      "METHODOLOGY_WEIGHTING_LABEL": "Weighting: {{ weight }}%",
      "METHODOLOGY_RUBRIC_LABEL": "Methodology Rubric",
      "SELECT_RUBRIC_PLACEHOLDER": "Select rubric",
      "SKILLS_TITLE": "Skills",
      "SKILLS_SUBTITLE": "Score communication and soft skills",
      "SKILLS_WEIGHTING_LABEL": "Weighting: {{ weight }}%",
      "SKILLS_RUBRIC_LABEL": "Skills Rubric",
      "ACCURACY_FEEDBACK_TITLE": "Accuracy feedback",
      "ACCURACY_FEEDBACK_DESCRIPTION": "Evaluate every statement a rep makes for accuracy against the uploaded documents",
      "ACCURACY_FEEDBACK_STATUS_ON": "Enabled",
      "ACCURACY_FEEDBACK_STATUS_OFF": "Off",
      "ACCURACY_FEEDBACK_STATUS_DISABLED": "Disabled",
      "ACCURACY_FEEDBACK_NO_DOCUMENTS": "Accuracy scoring is not available because no related documents were added.",
      "SCREEN_SHARE_TITLE": "Screen share",
      "SCREEN_SHARE_DESCRIPTION": "Allows the user to share their screen with the avatar during the call, so it can see and respond to what's shown",
      "SCREEN_SHARE_STATUS_ON": "Enabled",
      "SCREEN_SHARE_STATUS_OFF": "Disabled",
      "SCREEN_SHARE_NO_PERSONA": "Add a persona first to enable screen share.",
      "SCREEN_SHARE_OVERRIDE_MESSAGE_PREFIX": "This call has been manually overridden. Please reach out to",
      "SCREEN_SHARE_OVERRIDE_MESSAGE_SUFFIX": "for any updates.",
      "SCORING_AI_REVIEW_NOTICE": "Some content on this tab has been generated from the materials you provided. Review all content for accuracy before publishing this call.",
      "PROCESSING_DOCUMENTS_MESSAGE": "Processing documents...",
      "PROCESSING_DOCUMENTS_SUPPORTING_TEXT": "Feel free to step away — we'll have results ready within 5 minutes.",
      "CORE_SIGNAL_MESSAGE": "Interpreting your content...",
      "SECTION_PLAN_MESSAGE": "Planning your simulation's structure...",
      "DERIVED_COMPONENT_MESSAGE": "Building your simulation's components...",
      "COMPONENT_WAVE_1_MESSAGE": "Writing your simulation's content...",
      "COMPONENT_WAVE_2_MESSAGE": "Refining your simulation's content...",
      "COMPONENT_WAVE_3_MESSAGE": "Finalizing your simulation's content...",
      "MESSAGE_ADHERENCE_MESSAGE": "Suggesting messaging scoring criteria...",
      "ASSEMBLING_MESSAGE": "Assembling your simulation...",
      "FINISHING_SIMULATION_MESSAGE": "Finishing your simulation...",
      "STILL_PROCESSING_TITLE": "Still processing...",
      "STILL_PROCESSING_BODY": "This is taking longer than usual — you can navigate away from this simulation and return to it later from the simulation list view.",
      "PROCESSING_FAILED_TITLE": "Processing failed",
      "PROCESSING_FAILED_BODY": "Something went wrong while processing your documents — please retry. Reach out to ",
      "PROCESSING_FAILED_SUFFIX": " if the issue persists.",
      "BUTTON_RETRY": "Retry",
      "TOKEN_LIMIT_EXCEEDED_BODY_PREFIX": "Content limit exceeded.  Remove one or more documents and try again or reach out to ",
      "TOKEN_LIMIT_EXCEEDED_BODY_SUFFIX": " if the issue persists.",
      "TEST_SIMULATION_BUTTON": "Test simulation",
      "EXPORT_SIMULATION_SUMMARY_BUTTON": "Export simulation summary",
      "SIMULATION_PROCESSED_TITLE": "Documents processed",
      "SIMULATION_PROCESSED_BODY": "Your simulation's documents have been processed.",
      "SIMULATION_DOCUMENTS_PROCESSED_TITLE": "Simulation documents processed.",
      "SIMULATION_DOCUMENTS_PROCESSED_BODY": "The documents you uploaded for the simulation {{ name }} have processed.",
      "SIMULATION_DOCUMENTS_FAILED_TITLE": "Simulation documents failed to process.",
      "SIMULATION_DOCUMENTS_FAILED_BODY": "The documents you uploaded for the simulation {{ name }} did not process.",
      "SIMULATION_DOCUMENTS_PARSE_FAILED_BODY": "One of your documents for {{ name }} couldn't be read — check or replace it and try again.",
      "DISMISS": "Dismiss",
      "VIEW_SIMULATION": "View simulation",
      "AVATAR_LOOK_LABEL": "Appearance",
      "AVATAR_SELECT_PLACEHOLDER": "Select avatar",
      "AVATAR_VOICE_LABEL": "Voice",
      "AVATAR_ALT": "Avatar",
      "PLAY_VOICE_PREVIEW_BUTTON": "Play voice preview",
      "VOICE_OPTION_1": "Voice 1",
      "VOICE_OPTION_2": "Voice 2",
      "BACK_TO_SIMULATION_DETAILS_BUTTON": "Back to simulation details",
      "AVATAR_SELECTION_TITLE": "Avatar Selection",
      "VIEW_DOCUMENTS": "View documents",
      "SELECT_AVATAR_BUTTON": "Select avatar",
      "REQUEST_CHANGES_PLACEHOLDER": "Request any changes to the information above",
      "CALL_DETAILS_LOAD_ERROR": "We couldn't load your call details. Please try again.",
      "CALL": "Call",
      "REFINEMENT_THINKING_MESSAGE": "Thinking...",
      "REFINEMENT_UPDATED_MESSAGE": "Updated",
      "REFINEMENT_WARNING_PREFIX": "This information had been manually overridden - please reach out to",
      "REFINEMENT_WARNING_SUFFIX": "for any updates.",
      "REFINEMENT_OVERRIDDEN_PREFIX": "This information had been manually overridden - please reach out to",
      "REFINEMENT_OVERRIDDEN_SUFFIX": "for any updates.",
      "SUPPORT_EMAIL": "help@quantified.ai",
      "REFINEMENT_ERROR_PREFIX": "Unfortunately I can't help you with that, but",
      "REFINEMENT_ERROR_SUFFIX": "may be able to.",
      "REFINEMENT_ERROR_MESSAGE": "We're sorry, this request could not be completed. Please try again",
      "REFINEMENT_OUT_OF_SCOPE_TITLE": "Request out of scope.",
      "REFINEMENT_OUT_OF_SCOPE_BODY": "Your request for {{ name }} is outside what refinement can do. Please contact support.",
      "REFINEMENT_APPLIED_TITLE": "Requested changes applied.",
      "REFINEMENT_APPLIED_BODY": "The changes you requested for the simulation {{ name }} have been applied.",
      "REFINEMENT_FAILED_TITLE": "Requested changes failed.",
      "REFINEMENT_FAILED_BODY": "We couldn't apply the changes you requested for the simulation {{ name }}.",
      "BLANK_THEME_MESSAGE_TOOLTIP": "Add text to the empty message before adding a new theme.",
      "BLANK_MESSAGE_TOOLTIP": "Add text to this message before adding another.",
      "ADD_NEW_THEME_BUTTON": "Add new theme",
      "ADD_THEME_BUTTON": "Add theme",
      "ADD_MESSAGE_BUTTON": "Add message",
      "WHAT_USERS_SEE_DESCRIPTION_TITLE": "Simulation Description",
      "WHAT_USERS_SEE_DESCRIPTION_HELPER": "Information updated on the General tab will be reflected here unless manual updates are made.",
      "WHAT_USERS_SEE_DESCRIPTION_FIELD_LABEL": "Description",
      "WHAT_USERS_SEE_DETAILS_TITLE": "Simulation details",
      "WHAT_USERS_SEE_DETAILS_HELPER": "This is the content that will be provided to the user before they begin the Simulation. Information updated on the General tab will be reflected here unless manual updates are made. Any sections left blank will not be shown to the learner. All sections support markdown formatting.",
      "WHAT_USERS_SEE_OVERVIEW_FIELD_LABEL": "Simulation overview",
      "WHAT_USERS_SEE_PERSONA_FIELD_LABEL": "About the persona",
      "WHAT_USERS_SEE_SCORING_FIELD_LABEL": "Scoring criteria",
      "WHAT_USERS_SEE_SCORING_FIELD_HELPER": "This section is populated by the selections made on the scoring tab. Editing the information here will not change how the simulation is scored.",
      "WHAT_USERS_SEE_PREVIEW_DETAILS_CTA": "Preview simulation details modal",
      "WHAT_USERS_SEE_PREVIEW_CARD_CTA": "Preview simulation card",
      "WHAT_USERS_SEE_OVERRIDE_WARNING_TITLE": "Editing these fields will block future updates",
      "WHAT_USERS_SEE_OVERRIDE_WARNING_BODY": "Manually updating these sections will stop them from receiving any additional updates from the refinement process on the General tab.",
      "WHAT_USERS_SEE_DETAILS_OVERRIDE_EDITED_TITLE": "These fields have been edited",
      "WHAT_USERS_SEE_DETAILS_OVERRIDE_EDITED_BODY": "They will no longer receive refinement updates made on the General tab",
      "TAB_GENERAL": "General",
      "TAB_CONTENTS": "Contents",
      "TAB_KEY_WORDS": "Key Words",
      "TAB_SCORING": "Scoring",
      "TAB_TESTING": "Testing",
      "TAB_PROMPTS": "Prompts",
      "TAB_WHAT_USERS_SEE": "What users see",
      "TAB_QUESTIONS": "Questions",
      "KNOWLEDGE_CHECK_NAME_LABEL": "Name*",
      "AVATAR_APPEARANCE_LABEL": "Avatar appearance",
      "KNOWLEDGE_CHECK_AVATAR_NAME_LABEL": "Avatar name",
      "KNOWLEDGE_CHECK_SKILLS_FEEDBACK_TITLE": "Skills feedback",
      "KNOWLEDGE_CHECK_SCORING_DESCRIPTION": "Knowledge Check simulations are scored by the percentage of answer points covered for each question. Select a skills rubric below to also receive qualitative feedback.",
      "KNOWLEDGE_CHECK_SCORING_RESCORE_DESCRIPTION": "After testing the simulation at least once, select “Score my last session” to view your score. If you edit answer points, you can re-score the same session. If you edit questions, you’ll need to run a new test session before scoring.",
      "KNOWLEDGE_CHECK_SKILLS_RUBRIC_LABEL": "Skills Rubric (optional)",
      "KNOWLEDGE_CHECK_QUESTION_SCRIPT_LABEL": "Question script",
      "KNOWLEDGE_CHECK_QUESTION_HINT_LABEL": "Hint",
      "KNOWLEDGE_CHECK_QUESTION_HINT_TOOLTIP": "Shown to users during the session to help them answer the avatar's questions.",
      "KNOWLEDGE_CHECK_QUESTION_RESOURCE_LABEL": "Resource Note",
      "KNOWLEDGE_CHECK_QUESTION_RESOURCE_TOOLTIP": "Shown on the results page when a user misses an answer point directing them where to find the correct information.",
      "KNOWLEDGE_CHECK_UNTITLED_QUESTION": "Untitled question",
      "KNOWLEDGE_CHECK_ADD_NEW_QUESTION": "Add new question",
      "KNOWLEDGE_CHECK_BLANK_QUESTION_TOOLTIP": "Add text to the empty question before adding a new one.",
      "KNOWLEDGE_CHECK_REORDER_DISABLED_TOOLTIP": "Add question title or script to create the question first before reordering.",
      "KNOWLEDGE_CHECK_INCOMPLETE_CONTENT_TOOLTIP": "Add a title, script, and complete answer points (verb and display text) to every question before publishing.",
      "KNOWLEDGE_CHECK_ANSWER_POINT_SINGULAR": "answer point",
      "KNOWLEDGE_CHECK_ANSWER_POINT_PLURAL": "answer points",
      "SIMULATION_BUILDER_HEADING": "Simulation Builder",
      "ASSIGNMENTS_TAB_LABEL": "Assignments",
      "SIMULATIONS_TAB_LABEL": "Simulations",
      "CREATE_NEW_ASSIGNMENT_BUTTON": "Create new assignment",
      "CREATE_NEW_SIMULATION_BUTTON": "Create new simulation",
      "NO_ASSIGNMENTS_FOUND": "No Assignments found",
      "ASSIGNMENT_STATUS_PLACEHOLDER": "Assignment status",
      "ASSIGNMENT_STATUS_PREFIX": "Assignment status:",
      "ASSIGNMENT_TYPE_LABEL": "Assignment type",
      "SELECT_ASSIGNMENT_TYPE_PLACEHOLDER": "Select Assignment type",
      "NAME_LABEL": "Name",
      "ASSIGNMENT_NAME_PLACEHOLDER": "Assignment name",
      "PASSING_SCORE_LABEL": "Passing score",
      "PASSING_SCORE_OPTIONAL_LABEL": "Passing score (optional)",
      "SCORE_MAX_EXCEEDED_ERROR": "Score should not exceed 5",
      "GET_HELP_BUTTON": "Get help",
      "PASSING_SCORE_TOOLTIP": "This sets the overall score that a learner must achieve in order to pass the simulation.",
      "DESCRIPTION_LABEL": "Description",
      "ASSIGNMENT_DESCRIPTION_PLACEHOLDER": "Assignment description",
      "MESSAGING_FEEDBACK_LABEL": "Messaging feedback",
      "MESSAGING_FEEDBACK_TOOLTIP_HEADING": "Messaging Feedback",
      "MESSAGING_FEEDBACK_TOOLTIP_BODY": "When a learner incorrectly states a message, they are shown information about how to better verbalize it the next time. This setting toggles whether that information is shown or not.",
      "ENABLED_TEXT": "Enabled",
      "DISABLED_TEXT": "Disabled",
      "PAUSE_BUTTON_LABEL": "Pause button",
      "HIDE_RESULTS_LABEL": "Hide results",
      "ASSIGNMENT_START_DATE_LABEL": "Assignment start date",
      "SELECT_DATE_PLACEHOLDER": "Select date",
      "ASSIGNMENT_END_DATE_LABEL": "Assignment end date",
      "ASSIGNMENT_END_DATE_OPTIONAL_LABEL": "Assignment end date (optional)",
      "END_DATE_RANGE_ERROR": "Start date and end date cannot be the same",
      "ASSIGNMENT_INFORMATION_TITLE": "Assignment Information",
      "ASSIGNMENT_TYPE_CERTIFICATION": "Certification",
      "ASSIGNMENT_TYPE_PRACTICE": "Practice",
      "ASSIGNMENT_TYPE_PERSONALIZED_PRACTICE": "Personalized Practice",
      "BUTTON_SAVE_AND_CLOSE": "Save and close",
      "BUTTON_ADD_SIMULATIONS": "Add simulations",
      "ATTEMPTS_UNLIMITED": "Unlimited",
      "SEARCH_FOR_SIMULATION_LABEL": "Search for simulation",
      "SIMULATION_NAME_PLACEHOLDER": "Simulation name",
      "BUTTON_REMOVE_ALL": "Remove all",
      "SIMULATIONS_IN_ASSIGNMENT_LABEL": "Simulations in the assignment",
      "ATTEMPTS_ALLOWED_LABEL": "Attempts allowed",
      "ATTEMPTS_ALLOWED_DESCRIPTION": "Set the maximum number of attempts per user",
      "REMOVE_SIMULATION_FROM_ASSIGNMENT": "Remove simulation from assignment",
      "SIMULATIONS_LIST_SORTED_ASCENDING": "sorted ascending",
      "SIMULATIONS_LIST_SORTED_DESCENDING": "sorted descending",
      "COMPLIANCE_SCORE_LABEL": "Compliance Score:",
      "COMPLIANCE_SCORE_DESCRIPTION": "Sets how compliance violations impact the score displayed.",
      "COMPLIANCE_SCORE_TOOLTIP_INTRO": "For each, in the case of a compliance violation:",
      "COMPLIANCE_SCORE_TOOLTIP_FOOTER": "When the user is in compliance, they will receive normal scoring",
      "COMPLIANCE_SCORE_HELP_LABEL": "More information about compliance score",
      "COMPLIANCE_SCORE_COMPLIANCE_ONLY": "Compliance only",
      "COMPLIANCE_SCORE_COMPLIANCE_ONLY_TOOLTIP": "receive an out of compliance score and only compliance feedback",
      "COMPLIANCE_SCORE_INCLUDE_FEEDBACK": "Include feedback",
      "COMPLIANCE_SCORE_INCLUDE_FEEDBACK_TOOLTIP": "shows section level feedback, with an out of compliance score instead of a normal overall score",
      "BUTTON_ASSIGN_LEARNERS": "Assign learners",
      "CALL_TYPE_UNKNOWN": "Unknown",
      "ASSIGNMENT_COUNT_NONE": "None",
      "ASSIGNMENT_COUNT_SINGULAR": "{{ count }} assignment",
      "ASSIGNMENT_COUNT_PLURAL": "{{ count }} assignments",
      "ERROR_LOADING_ASSIGNMENTS": "Error loading assignments",
      "SEARCH_ASSIGNEES_TITLE": "Search assignees",
      "DIALOG_DESCRIPTION_ADD_USERS": "Select the users that will participate in the assignment. Searching for a team will allow you to assign or unassign specific users on that team. When selecting a specific user, make sure they are associated with the correct team for reporting purposes.",
      "ADD_USERS_TO_ASSIGNMENT_HEADING": "Add users to the assignment",
      "BUTTON_REVIEW_SELECTED_USERS": "Review selected users",
      "FIND_USERS_LABEL": "Find users",
      "BUTTON_CLEAR": "Clear",
      "LEARNER_COUNT_NONE": "None",
      "LEARNER_COUNT_SINGULAR": "{{ count }} learner",
      "LEARNER_COUNT_PLURAL": "{{ count }} learners",
      "ASSIGNMENT_TAB_DETAILS": "Details",
      "ASSIGNMENT_TAB_SIMULATIONS": "Simulations",
      "ASSIGNMENT_TAB_ASSIGNEES": "Assignees",
      "LOADING_ASSIGNMENT_DETAILS": "Loading assignment details...",
      "BREADCRUMB_ASSIGNMENTS": "Assignments",
      "ASSIGNMENTS_COL_NAME": "Name",
      "ASSIGNMENTS_COL_START_DATE": "Assignment start date",
      "ASSIGNMENTS_COL_END_DATE": "Assignment end date",
      "ASSIGNMENTS_COL_LEARNERS": "Learner assigned",
      "ASSIGNMENTS_COL_TYPE": "Assignment type",
      "ASSIGNMENTS_COL_STATUS": "Assignment status",
      "SIMULATIONS_COL_NAME": "Name",
      "SIMULATIONS_COL_PRODUCT": "Product",
      "SIMULATIONS_COL_DATE_MODIFIED": "Date last modified",
      "SIMULATIONS_COL_STATUS": "Status",
      "SIMULATIONS_COL_USED_IN": "Used in",
      "SIMULATIONS_COL_TYPE": "Simulation type",
      "SIMULATIONS_COL_DATE_PUBLISHED": "Published date",
      "CONVERSE_PROMPT_LABEL": "Converse Prompt",
      "CONVERSE_PROMPT_EXPAND_TO_EDIT": "Expand to edit",
      "CONVERSE_PROMPT_ENTER_LABEL": "Enter the converse prompt here *",
      "CONVERSE_PROMPT_EDITING_HEADING": "Editing converse prompt",
      "CONVERSE_PROMPT_OVERRIDE_CONFIRMATION_HEADING": "Prompt override confirmation",
      "CONVERSE_PROMPT_OVERRIDE_DESCRIPTION": "Are you sure you want to override the converse prompt? Authors will lose self-serve refinement access if overridden.",
      "CONVERSE_PROMPT_FIELD_LABEL": "Converse prompt",
      "CONVERSE_PROMPT_SAVE_BUTTON": "Save prompt",
      "BUTTON_CONFIRM": "Confirm",
      "DELETE_SIM_HEADING": "Delete simulation",
      "DELETE_SIM_CONTENT": "This simulation will be deleted. Any test assignments associated with the simulation will be removed as well.",
      "DELETE_SIM_LABEL": "Delete simulation",
      "DELETE_ASSIGNMENT_HEADING": "Delete assignment",
      "DELETE_ASSIGNMENT_CONTENT": "This assignment will be deleted permanently.",
      "DELETE_ASSIGNMENT_LABEL": "Delete assignment",
      "DELETE_ASSIGNMENT_NON_STAGED_CONTENT": "To delete an assignment with Active, or Ended status, please contact the CX team. Thank you.",
      "REMOVE_FROM_ASSIGNMENT_HEADING": "Remove from assignment",
      "REMOVE_FROM_ASSIGNMENT_CONTENT": "This will remove the user from the assignment and all associated team links.",
      "REMOVE_FROM_ASSIGNMENT_LABEL": "Remove from assignment",
      "PUBLISH_SIMULATION_HEADING": "Publish simulation",
      "PUBLISH_CONTINUE_EDITING": "Continue editing",
      "PUBLISH_BUTTON": "Publish",
      "PUBLISH_SIMULATION_DESCRIPTION": "The role play will be able to be added to assignments and persona, scoring, and prompt information can no longer be edited.",
      "CONFIRMATION_SELECTED_USERS_HEADING": "Selected Users",
      "CONFIRMATION_TOTAL_COUNT": "{{ count }} Total",
      "CONFIRMATION_CREATE_HEADING": "Create new assignment",
      "CONFIRMATION_ADD_USERS_HEADING": "Add users to the assignment",
      "CONFIRMATION_SAVE_ASSIGNMENT_BTN": "Save assignment",
      "CONFIRMATION_REMOVE_USER": "Remove",
      "EDIT_WEIGHTING_HEADING": "Edit scoring weighting",
      "EDIT_WEIGHTING_DESCRIPTION": "The overall score will be generated from the weighted average of the following sections. All enabled section weights must add up to 100%. The skills section cannot have a weight greater than 20%.",
      "EDIT_WEIGHTING_ERROR_ALL_DISABLED": "At least one scoring action must be enabled",
      "EDIT_WEIGHTING_ERROR_WEIGHT_RANGE": "Section weight must be between 0 and 100",
      "EDIT_WEIGHTING_ERROR_SKILLS_MAX": "The skills section cannot have a weight greater than 20%",
      "EDIT_WEIGHTING_ERROR_TOTAL": "The total section weight must be 100%",
      "PERSONA_INFORMATION_TITLE": "Persona Information",
      "PERSONA_AVATAR_LABEL": "Avatar *",
      "PERSONA_NAME_LABEL": "Name *",
      "PERSONA_INITIAL_GREETINGS_LABEL": "Initial greetings *",
      "PERSONA_INITIAL_GREETINGS_DESCRIPTION": "The persona will start the simulation with one of these greetings. You can have a maximum of 5 options.",
      "PERSONA_ADD_GREETING_OPTION": "Add greeting option",
      "PERSONA_RESUME_MESSAGE_LABEL": "Resume message",
      "PERSONA_RESUME_MESSAGE_DESCRIPTION": "When a learner resumes a simulation after a pause, the persona will begin with one of these greetings. You can have a maximum of 5 options.",
      "PERSONA_ADD_MESSAGE_OPTION": "Add message option",
      "PERSONA_UPLOADING": "Uploading...",
      "PERSONA_DELETING": "Deleting...",
      "PERSONA_CUSTOM_BG_PREVIEW_ALT": "Custom Background Preview",
      "PERSONA_AVATAR_THUMBNAIL_ALT": "Avatar Thumbnail",
      "PERSONA_AVATAR_WITH_BG_ALT": "Avatar with custom background",
      "PERSONA_PROCESSING_IMAGE": "Processing image...",
      "PERSONA_CUSTOM_BACKGROUND_LABEL": "Custom Background",
      "PERSONA_REMOVE_BACKGROUND": "Remove background",
      "PERSONA_CLICK_TO_REPLACE": "Click to replace",
      "PERSONA_UPLOAD_DESCRIPTION": "PNG or JPG, 16:9 aspect ratio preferred, max. 2MB",
      "SIM_INFORMATION_TITLE": "Simulation Information",
      "SIM_NAME_FIELD_LABEL": "Name *",
      "SIM_LANGUAGE_FIELD_LABEL": "Language",
      "SIM_DETAILS_SECTION_TITLE": "Simulation Details",
      "SIM_ADDITIONAL_SECTION_TITLE_LABEL": "Additional section title",
      "SIM_ADDITIONAL_SECTION_INFO_LABEL": "Additional section information",
      "TESTING_SECTION_TITLE": "Testers",
      "TESTING_SEND_ASSIGNMENTS_BTN": "Send test assignments",
      "TESTING_MESSAGING_TOOLTIP": "Add at least one fact to Message Adherence before testing or publishing.",
      "TESTING_DESCRIPTION": "Search for users who will be testing the simulation, then send them the test assignment.",
      "TESTING_COL_NUMBER_OF_ATTEMPTS": "Number of attempts",
      "TESTING_COL_DATE_OF_LAST_ATTEMPT": "Date of last attempt",
      "TESTING_CLEAR_USERS": "Clear users",
      "TESTING_REMOVE_ASSIGNEE": "Remove assignee",
      "OVERALL_SECTION_TITLE": "Sections, weights and prompts",
      "OVERALL_HEADING": "Overall",
      "TRANSCRIPT_PROMPT_TITLE": "Clean transcript prompt",
      "TRANSCRIPT_PROMPT_FIELD_LABEL": "Enter the clean transcript prompt here",
      "SIMULATION_PROMPTS_TITLE": "Simulation prompts",
      "OTHERS_SINGULAR": "and 1 other",
      "OTHERS_PLURAL": "and {{ count }} others",
      "PAGINATION_PREVIOUS": "Previous",
      "PAGINATION_NEXT": "Next",
      "SIMULATION_TYPE_MODAL_TITLE": "Create new simulation",
      "SIMULATION_TYPE_MODAL_DESCRIPTION": "Choose how your learners will practice.",
      "SIMULATION_TYPE_ROLE_PLAY_TITLE": "Role Play",
      "SIMULATION_TYPE_ROLE_PLAY_DESCRIPTION": "Learners lead an open conversation with an AI character, who responds naturally to whatever they say.",
      "SIMULATION_TYPE_ROLE_PLAY_BEST_FOR": "Best for: practicing realistic sales calls, like pitches and objection handling.",
      "SIMULATION_TYPE_KNOWLEDGE_CHECK_TITLE": "Knowledge Check",
      "SIMULATION_TYPE_KNOWLEDGE_CHECK_DESCRIPTION": "An AI character asks learners the questions you write, in the order you set.",
      "SIMULATION_TYPE_KNOWLEDGE_CHECK_BEST_FOR": "Best for: testing product knowledge and certifying that reps are ready.",
      "TAGS_FILTER_LABEL": "Tags",
      "TAGS_FILTER_PLACEHOLDER": "Select a tag",
      "CLEAR_ALL_FILTERS": "Clear all filters",
      "LAST_SAVED_LABEL": "Last saved",
      "BUTTON_OK": "OK",
      "KEYWORDS_RESET_TO_PRODUCT_DEFAULT": "Reset to product default",
      "KEYWORDS_DETACH_FROM_PRODUCT_DEFAULT": "Detach from product default",
      "KEYWORDS_SAVE_AS_PRODUCT_DEFAULT": "Save as product default",
      "KEYWORDS_SAVE_AS_DEFAULT_OVERWRITE": "This will overwrite the default {{ keywordTitle }} for the product {{ moduleName }}.",
      "KEYWORDS_SAVE_AS_DEFAULT_IMPACT": "These words will be added to new simulations for {{ moduleName }}. All calls for the product {{ moduleName }} will be effected.",
      "KEYWORDS_ADD_NEW_WORD": "Add new word",
      "KEYWORDS_FROM_LABEL": "From",
      "KEYWORDS_TO_LABEL": "To",
      "KEYWORDS_PRONOUNCE_TITLE": "Pronounce words",
      "KEYWORDS_PRONOUNCE_DESCRIPTION": "Provide pronunciation corrections for the AI agent so it speaks names/terms correctly. Agent maps common mispronunciations/variants to the New pronunciation.",
      "KEYWORDS_PRONOUNCE_NAME": "pronounce words",
      "KEYWORDS_ADD_MISPRONUNCIATION": "Add mispronunciation",
      "KEYWORDS_SELECT_PERSONA_NOTICE": "Please select a persona to add pronounce words.",
      "KEYWORDS_REPLACE_TITLE": "Replace words",
      "KEYWORDS_REPLACE_DESCRIPTION": "Explicit find-and-replace corrections for user transcript text, Direct word replacements that happen before phonetic correction.",
      "KEYWORDS_REPLACE_NAME": "replace words",
      "KEYWORDS_ADD_REPLACEMENT": "Add replacement",
      "KEYWORDS_STT_TITLE": "STT words",
      "KEYWORDS_STT_DESCRIPTION": "Word list supplied to Speech-to-Text (STT) providers (e.g., AssemblyAI, Tavus), specifically for STT provider configuration.",
      "KEYWORDS_STT_NAME": "stt words",
      "KEYWORDS_GENERATING": "Generating...",
      "KEYWORDS_GENERATE_STT_PROMPT": "Generate stt_prompt",
      "KEYWORDS_STT_PROMPT_OUTDATED": "The word list has been updated since this prompt was generated. Regenerate to reflect the latest changes.",
      "KEYWORDS_STT_CANNOT_SAVE_HEADING": "Cannot Save at Product Level",
      "KEYWORDS_STT_CANNOT_SAVE_BODY": "The STT words and prompt cannot be saved at a product level. You can manually change other simulation STT config or reach out to your admin for help.",
      "KEYWORDS_CLEAN_TRANSCRIPT_TITLE": "Clean transcript words",
      "KEYWORDS_CLEAN_TRANSCRIPT_DESCRIPTION": "Words that are injected to the CLEAN_TRANSCRIPT_V2 prompt.",
      "KEYWORDS_CLEAN_TRANSCRIPT_NAME": "clean transcript words",
      "KEYWORDS_CALL_TITLE": "Call words",
      "KEYWORDS_CALL_DESCRIPTION": "Dictionary of correct words for phonetic correction, Used by Double Metaphone algorithm to correct phonetically similar misspellings. Avoid multi-word terms like \"Anti MuSK AB+\", since the code-based transcript corrector only works reliably with single words. Also avoid symbols—e.g., \"lp(a)\"—because they tend to confuse the corrector. The list should remain as small and simple as possible, since this is handled by a deterministic algorithm, not an LLM, and it doesn't have contextual understanding",
      "KEYWORDS_CALL_NAME": "call words",
      "KC_TIPS_TITLE": "Tips for writing answer points",
      "KC_TIPS_BULLET_1": "Learners are scored against the details you provide. Write each answer point so that someone unfamiliar with the scenario could listen to a call and know whether the learner earned credit.",
      "KC_TIPS_BULLET_2": "Be specific. Name the exact product, feature, study, or detail you expect to hear. \"Mention the case study on ramp time\" is clearer than \"Mention a relevant success story.\"",
      "KC_TIPS_BULLET_3": "Keep it to one idea. If two things could be addressed separately, make them separate answer points.",
      "KC_TIPS_BULLET_4": "Use plain, direct language. Describe the specific information the learner needs to convey. Vague phrasing leaves the scoring open to interpretation, so name the actual claim, benefit, or detail you expect to hear.",
      "KC_TIPS_STATE_BADGE": "State",
      "KC_TIPS_STATE_DESCRIPTION": "(strictest): The learner must say everything in the answer point to get credit. If you list multiple items, they need to say all of them. e.g., ",
      "KC_TIPS_STATE_EXAMPLE": "\"State that Quantified offers AI role play, automated coaching feedback, and certification against custom rubrics.\"",
      "KC_TIPS_MENTION_BADGE": "Mention",
      "KC_TIPS_MENTION_DESCRIPTION": "(flexible): The learner must reference the information but doesn't need to explain it. For example, they might name a study without going into its details. You can also require only part of a list; if so, say how many in the answer point. e.g., ",
      "KC_TIPS_MENTION_EXAMPLE": "\"Mention two of the following dashboard metrics: practice frequency, score improvement, or leaderboards.\"",
      "KC_TIPS_ACKNOWLEDGE_BADGE": "Acknowledge",
      "KC_TIPS_ACKNOWLEDGE_DESCRIPTION": "(lightest): The learner must recognize what's specified in the answer point, such as a concern, a past conversation, or a preference. They don't need to repeat any details. e.g., ",
      "KC_TIPS_ACKNOWLEDGE_EXAMPLE": "\"Acknowledge the customer's challenges scaling live role plays with their managers.\"",
      "KC_ANSWER_POINTS_TITLE": "Answer points:",
      "KC_ADD_ANSWER_POINT": "Add new answer point",
      "KC_ANSWER_POINT_VERB_STATE": "State",
      "KC_ANSWER_POINT_VERB_MENTION": "Mention",
      "KC_ANSWER_POINT_VERB_ACKNOWLEDGE": "Acknowledge",
      "KC_ANSWER_POINT_TEXT_PLACEHOLDER": "that Quantified offers AI role play, automated coaching feedback, and certification against custom rubrics.",
      "KC_ANSWER_POINT_CUSTOM_FEEDBACK": "Custom feedback for misses",
      "KC_ANSWER_POINT_CUSTOM_FEEDBACK_LABEL": "Shown when missed",
      "KC_ANSWER_POINT_CUSTOM_FEEDBACK_HELPER": "Learners who miss this point will see this message on the results screen rather than the answer"
    },
    "settings": {
      "DEVICE_SETUP_INTRO": "Let's ensure your device is configured.",
      "MICROPHONE_REQUIRED_NOTICE": "A functioning microphone is required.",
      "DEVICE_ENABLE_INSTRUCTIONS": "If you did not see a pop-up request to enable your devices after refreshing this page, please go into your system or browser settings and enable your devices. Below are support pages with further instruction.",
      "ENABLE_CAMERA": "How to enable your camera:",
      "WINDOWS_USERS": "Windows users",
      "MAC_USERS": "Mac users",
      "IPAD_USERS": "iPad users",
      "ENABLE_MICROPHONE": "How to enable your microphone:",
      "ENABLE_DEVICES_BY_BROWSER": "How to enable your devices by browser:",
      "CHROME_USERS": "Chrome users",
      "SAFARI_USERS": "Safari users",
      "FIREFOX_USERS": "Firefox",
      "EDGE_USERS": "Edge",
      "START_WITHOUT_CAMERA_BUTTON": "Start without Camera",
      "START_CALL_BUTTON": "Start Call",
      "MICROPHONE_REQUIRED_WARNING": "A functioning microphone is required.",
      "MICROPHONE_ALT": "microphone",
      "MICROPHONE": "Microphone",
      "SELECT_MICROPHONE": "Select Your Microphone",
      "ALERT": "alert",
      "GIVE_PERMISSION": "Give Permission",
      "SELECT_VIDEO_DEVICE": "Select Your Video Device",
      "VIDEO": "video",
      "DEVICE_BLOCKED_ERROR": "It looks like you have denied this browser access to one or more of your devices. To enable the devices, please go into your system settings or browser settings and enable access.",
      "DEVICE_SETTINGS": "Device settings",
      "CONFIRM_SETTINGS": "Confirm Settings",
      "LAPTOP": "Laptop",
      "SAD_EMOTE_FACE": "Sad Emote Face",
      "GRANT_BROWSER_ACCESS": "In order to complete this simulation, please grant browser access to Speech Recognition",
      "USING_IPAD": "If using an iPad, go to",
      "SETTINGS": "Settings",
      "PRIVACY_AND_SECURITY": "Privacy & Security",
      "SPEECH_RECOGNITION": "Speech Recognition",
      "GRANT_ACCESS_REFRESH": "Grant browser access and refresh the page",
      "REFRESH_PAGE": "REFRESH PAGE",
      "BROWSER_UNABLE_TO_ACCESS": "Browser is unable to access this device",
      "ACCESS_DENIED": "access denied",
      "CAMERA": "Camera",
      "DIAGNOSTIC_PASSED": "All diagnostic tests passed successfully.",
      "DIAGNOSTIC_FAILED_MESSAGE": "Some diagnostic tests failed. Please click the \"Copy Diagnostic Results\" button above and send the results to the support team for assistance.",
      "DIAGNOSTIC_PARTIAL": "Most diagnostic tests passed successfully. Your connection looks good.",
      "DIAGNOSTIC_RUNNING_MESSAGE": "Please wait while diagnostic tests are running...",
      "DIAGNOSTIC_RUNNING": "Diagnostic Running",
      "COPY_DIAGNOSTIC_RESULTS": "Copy Diagnostic Results",
      "RUN_DIAGNOSTIC": "Run Diagnostic",
      "RERUN_DIAGNOSTIC": "Rerun Diagnostic",
      "DIAGNOSTIC_RESULTS_COPIED": "Diagnostic results copied to clipboard",
      "DIAGNOSTIC_FAILED": "Diagnostic failed",
      "DIAGNOSTIC_WEBSOCKET_NOT_TESTED": "Websocket: not tested",
      "DIAGNOSTIC_TURN_NOT_TESTED": "TURN: not tested",
      "DIAGNOSTIC_QUALITY_NOT_TESTED": "Quality: not tested",
      "DIAGNOSTIC_QUANTIFIED_DIAGNOSTICS": "Quantified Diagnostics",
      "DIAGNOSTIC_TIME": "Time",
      "DIAGNOSTIC_SUMMARY": "Summary",
      "DIAGNOSTIC_CLIENT_INFO": "Client info",
      "DIAGNOSTIC_PLATFORM": "Platform",
      "DIAGNOSTIC_RTT_AVG_MAX": "RTT avg/max",
      "DIAGNOSTIC_PACKET_LOSS_SEND": "Packet loss (send)",
      "DIAGNOSTIC_AVG_SEND_BITRATE": "Avg send bitrate",
      "DIAGNOSTIC_NA": "n/a",
      "DIAGNOSTIC_PROBLEMS_CONNECTING_PREFIX": "Problems connecting?",
      "DIAGNOSTIC_CLICK_HERE": "Click here",
      "DIAGNOSTIC_TO_RUN_SUFFIX": "to run a diagnostic."
    },
    "results": {
      "RETURN_HOME": "RETURN HOME",
      "RETURN_TO_PATHWAY": "RETURN TO PATHWAY",
      "CLOSE_BUTTON": "Close Button",
      "CONVERSATIONAL_CALL": "ROLE PLAY",
      "INFORMATION_ICON": "Information Icon",
      "TOOLTIP_ARROW": "Tooltip Arrow",
      "INFORMATION_TOOLTIP_CONTENT": "You control the flow of the simulation, driving the conversation towards a set of objectives. Role plays are great for testing abilities like drilling down and asking second-level questions, uncovering pain points, and building rapport.",
      "CLOCK_ICON": "Clock Icon",
      "CALL_RESULTS": "Results",
      "QUIZ_RESULTS_SUMMARY": "Quiz Results Summary",
      "PROCESSING_RESULTS": "Processing results...",
      "SKILLS": "Skills",
      "MESSAGE_ADHERENCE": "Message Adherence",
      "MESSAGING": "Messaging",
      "TRY_AGAIN_MESSAGE": "Try again and improve your score.",
      "QUIZ_SUMMARY_BASE": "Take a moment to review your performance on this quiz.",
      "QUIZ_SUMMARY_FAILED": "Take a moment to review your performance on this quiz. Review the {{stepNames}} {{stepWord}} highlighted on the pathway overview screen to better prepare for your next attempt.",
      "QUIZ_SUMMARY_PASSED_WITH_MISSES": "Take a moment to review your performance on this quiz. The {{stepNames}} {{stepWord}} {{stepVerb}} your lowest scoring {{areaWord}}.",
      "PRACTICE_BENEFITS": "Weekly practice boosts confidence and improves real world outcomes.",
      "CALL_SUCCESS": "Great job! You successfully completed this simulation.",
      "MAX_ATTEMPTS_REACHED": "You have reached the maximum number of attempts",
      "TRY_AGAIN": "Try Again",
      "GREAT_JOB_YOU_SUCCESSFULLY": "Great job! You successfully",
      "COMPLETED_THIS_CALL": "completed this simulation.",
      "ACHIEVED_SCORE": "You achieved a score of",
      "ACHIEVE_SCORE": "Achieve a score of",
      "OR_HIGHER": "or higher.",
      "OBJECTIVES_NOT_MET": "You didn't meet all the required objectives.",
      "TRY_AGAIN_TARGET_SCORE": "Try again to achieve a score of",
      "YOUR_SCORE": "Your Score",
      "OUT_OF_5": "OUT OF 5",
      "OUT_OF_100": "OUT OF 100",
      "CALL_FEEDBACK": "FEEDBACK SUMMARY",
      "STRENGTH_ICON_ALT": "Strength Icon",
      "OPPORTUNITIES_ICON_ALT": "Opportunities Icon",
      "OBJECTIVES_FEEDBACK": "FEEDBACK ON METHODOLOGY",
      "SESSION_ID": "Session ID:",
      "SESSION_ID_COPIED": "Session ID copied!",
      "OBJECTIVE": "METHODOLOGY:",
      "HOW_YOU_DID": "How you did:",
      "LIGHTBULB_ICON_ALT": "Lightbulb Icon",
      "WHAT_WE_SUGGEST": "What we suggest:",
      "NO_SPECIFIC_RECOMMENDATION": "Our system could not find a specific recommendation for you.",
      "WHY": "Why?",
      "NO_INSIGHTS_AVAILABLE": "Our system could not provide insights into this suggestion.",
      "CONFETTI_ICON_ALT": "Confetti Icon",
      "OBJECTIVE_SUCCESS_MESSAGE": "You did great on this methodology, keep up the good work!",
      "PROCESSING_CALL": "We are preparing your score and feedback.",
      "HANG_TIGHT": "Hang tight or check back later to",
      "VIEW_YOUR_RESULTS": "view your results.",
      "NEED_MORE_TIME": "We need more time to calculate the results.",
      "REFRESH_INSTRUCTION": "Please check back or refresh the assignment",
      "RESULTS_IN_FEW_MINUTES": "results in a few minutes.",
      "QUIZ_RESULTS_LOADING": "Results are taking awhile to load. Exit the pathway and we'll notify you when they're ready.",
      "KC_TOAST_TITLE": "Your knowledge check results have been processed",
      "KC_TOAST_TITLE_PATHWAY": "Your {{stepName}} knowledge check results have been processed",
      "KC_TOAST_CONTENT": "Click below to view, or return to the pathway details screen for your next step.",
      "DISMISS": "Dismiss",
      "SCORE_CALCULATION_QUESTION": "How is this calculated?",
      "SINGLE_SCORE_EXPLANATION": "This simulation only has a single score component, so the score displayed is both the individual section score as well as your overall score.",
      "OVERALL_SCORE_PERCENT": "of overall score",
      "SECTION_SCORE": "Section score",
      "ELEVATE_MESSAGE_ADHERENCE_TITLE": "Elevate your conversation message adherence",
      "MESSAGE_ADHERENCE_NOTE": "Message adherence is critical for leading successful conversations, but doesn't affect your overall score.",
      "NO_CREDIT": "No credit",
      "PARTIAL_CREDIT": "Partial credit",
      "FULL_CREDIT": "Full credit",
      "WHAT_YOU_DID_WELL": "What you did well",
      "MISSED_ALL_KEY_POINTS": "You missed all the key points; review them and try again.",
      "WHAT_TO_IMPROVE": "What you can do better",
      "PERFECT_SCORE_MESSAGE": "Congrats! You got a perfect score, correctly speaking to all of the key points.",
      "POINTS_LABEL": "Points",
      "POINT_LABEL": "Point",
      "TALKING_POINTS_COVERED": "Talking points covered",
      "COVERED": "Covered",
      "CHECKMARK_ICON_ALT": "checkmark",
      "TALKING_POINTS_MISSED": "Talking points missed",
      "MISSED": "Missed",
      "X_ICON_ALT": "x",
      "PRACTICE_AGAIN": "Practice again",
      "PRACTICE_SIMULATION_AGAIN": "Practice simulation again",
      "CALL_TYPE_CONVERSATIONAL": "Conversational Call",
      "CALL_TYPE_GUIDED": "Guided Call",
      "CALL_TYPE_VISUAL_AID": "Visual Aid Call",
      "CALL_TYPE_ROLEPLAY": "Role Play Call",
      "OUT_OF": "out of",
      "COVERED_TALKING_POINTS_SUMMARY": "You covered {{covered}} out of {{total}} possible talking points throughout the simulation.",
      "COVERED_TALKING_POINTS_POSITIVE": "You did a great job highlighting key points throughout the call, and covered {{covered}} out of {{total}} possible talking points.",
      "COVERED_TALKING_POINTS_MIXED": "You missed some of the key points throughout the simulation, and covered {{covered}} out of {{total}} possible talking points.",
      "KEEP_PRACTICING_TO_SCORE": "Review your feedback and keep practicing to score {{score}} or higher.",
      "KEEP_PRACTICING_TO_SCORE_BEFORE": "Review your feedback and keep practicing to score {{score}} or higher before {{date}}.",
      "OBJECTIVES": "Methodology",
      "ELEVATE_OBJECTIVES_TITLE": "Elevate your conversation methodology",
      "OBJECTIVES_NOTE": "Methodology is critical for leading successful conversations, but doesn't affect your overall score.",
      "UNTIL": "until",
      "TO_IMPROVE_SCORE": "to improve your score.",
      "YOU_HAVE": "You have",
      "MORE_ATTEMPTS": "more attempts to score",
      "OR_HIGHER_BEFORE": "or higher before",
      "AND_TRY_AGAIN": "and try again.",
      "UNEXPECTED_STATE": "An unexpected state occurred.",
      "REVIEW_APP_LOGIC": "Please review the application's logic.",
      "ASSIGNMENTS": "Assignments",
      "VIEW_CALL_DETAILS": "View call details",
      "PRACTICE_SESSION": "Practice session",
      "OVERALL_SCORE": "Overall score",
      "OVERALL_SCORE_TAB": "Overall",
      "MESSAGE_ADHERENCE_TAB": "Messages",
      "OBJECTIVES_TAB": "Objectives",
      "OVERALL_SCORE_EXPLANATION": "The overall score is calculated by taking a weighted average of the score for each section. The weight of each section is displayed as a percentage next to the score.",
      "SCORE_CONFIG_NOTE": "Weight percentages and the inclusion and exclusion of sections are set by your company. All scores are rounded to the nearest tenth of a point.",
      "STRENGTHS": "Strengths",
      "OPPORTUNITIES": "Opportunities",
      "YOUR_RESPONSE": "Your Response",
      "MINUS": "minus",
      "PLUS": "plus",
      "RECOMMENDED_RESPONSE": "Recommended Response",
      "REVIEW_MISSED_TITLE": "Review what you missed.",
      "NO_TALKING_POINTS_COVERED": "You did not cover any of the required talking points for this topic.",
      "LEARN_WHAT_YOU_MISSED": "Learn What You Missed",
      "NICE_JOB": "Nice job!",
      "ALL_POINTS_COVERED": "You successfully covered all the required talking points for this topic.",
      "COVER_ALL_MESSAGES": "Cover all the key messages.",
      "HIGHLIGHT_KEY_POINTS_NOTE": "Highlighting the key points throughout the call will help keep the conversation focused.",
      "MESSAGES_LABEL": "Messages",
      "NO_FACTS_COVERED": "Oops! Looks like you didn't cover any of the facts of this message.",
      "NO_SPECIFICS_AVAILABLE": "Oops! Looks like we couldn't provide specifics on what was missed.",
      "ALL_KEY_POINTS_COVERED": "Great job! You covered all the key points.",
      "PROCESSING_SKILLS_FEEDBACK": "We are processing your skills feedback.",
      "SKILLS_SCORING_NOT_ENABLED": "We're sorry, but we couldn't analyze your recent call because skill scoring wasn't enabled at the time of submission. To get feedback, just resubmit your call practice as you did before. If you need help, feel free to reach out to our support team. Thanks for your understanding and commitment to improvement!",
      "ELEVATE_CONVERSATION_SKILLS": "Elevate Your Conversation Skills",
      "SKILLS_NOTE": "Skills are critical for leading successful conversations, but don't affect your overall score.",
      "SKILLS_SUMMARY_TITLE": "SKILLS SUMMARY",
      "LEARN_MORE_ABOUT_SKILLS": "Learn more about skills",
      "SKILLS_FEEDBACK_LABEL": "FEEDBACK",
      "WHAT_ARE_SKILLS_TITLE": "What Are Skills",
      "SKILLS_DESCRIPTION": "Skills are calibrated to support personal growth development. While these skills are not part of the numerical evaluation for your call, they've been selected by your organization to enhance your effectiveness.",
      "PROFICIENCY_SCALE_TITLE": "PROFICIENCY SCALE",
      "EXPERT": "Expert",
      "PROFICIENT": "Proficient",
      "DEVELOPING": "Developing",
      "CALL_TRANSCRIPT": "Call transcript",
      "COLLAPSE_ALL": "Collapse All",
      "EXPAND_ALL": "Expand All",
      "THUMBNAIL": "Thumbnail",
      "OUT_OF_FIVE_POINTS": "/5 points",
      "TALKING_POINTS": "talking points",
      "TRANSCRIPT_LABEL": "Transcript",
      "YOU_ARE_OUT_OF_ATTEMPTS": "You’re out of attempts.",
      "REVIEW_GUIDELINES_REMAIN_COMPLIANT": "Review the guidelines and remain compliant in the future.",
      "TRY_AGAIN_ATTENTION_TO_COMPLIANCE": "Try again and pay attention to compliance guidelines.",
      "NO_SCORE_OUT_OF_COMPLIANCE": "We identified something that might be out of compliance",
      "WHY_OUT_OF_COMPLIANCE": "Why you might be out of compliance",
      "POSSIBLE_COMPLIANCE_ISSUES": "Possible compliance issues for review",
      "NO_SCORE_COMPLIANCE_ONLY": "We noticed you were out of compliance, therefore you did not receive a score.",
      "WHY_OUT_OF_COMPLIANCE_COMPLIANCE_ONLY": "Why you were out of compliance",
      "REVIEW_TRANSCRIPT_MISSED_GUIDELINES": "Review your transcript to see where you missed compliance guidelines.",
      "YOU_DID_FOLLOW_GUIDELINES": "You did effectively follow these guidelines.",
      "REVIEW_MISSED_GUIDELINES": "Review the missed compliance guidelines.",
      "EXAMPLE_FROM_CONVERSATION": "Here's an example from your conversation:",
      "OUT_OF_COMPLIANCE": "Out of compliance",
      "SCORE_CALCULATION_TITLE": "Score calculation",
      "PROCESSING_TRANSCRIPT": "We are processing your transcript.",
      "WAIT_OR_REVIEW_SCORES": "Wait here, or review the other score",
      "TRANSCRIPT_LOADING": "sections while the transcript loads.",
      "REVIEW_FEEDBACK_KEEP_PRACTICING": "Review your feedback and keep practicing",
      "HIGH_PERFORMERS_PRACTICE": "High performers practice at least once a week",
      "SUCCESSFULLY_PASSED": "Great job! You successfully passed this simulation.",
      "DIDNT_REACH_PASSING_SCORE": "You didn't reach the passing score for this simulation.",
      "OUT_OF_ATTEMPTS": "<b>You are out of attempts.</b> Review your feedback to learn how you can improve.",
      "REVIEW_FEEDBACK_THEN_RETURN": "Review your feedback, then return home when you are ready.",
      "GREAT_JOB_PRACTICED": "Great job, you've practiced {{count}} {{times}}. Keep going!",
      "GREAT_JOB_PRACTICED_FEMALE": "Great job, you've practiced {{count}} {{times}}. Keep going!",
      "TIME": "time",
      "TIMES": "times",
      "COMPLIANCE_GUIDELINES": "Compliance guidelines",
      "TALKING_POINT_TITLE": "TALKING POINTS MISSED OR SAID AT WRONG TIME",
      "NO_TRANSCRIPT": "No transcript available.",
      "RETURN_TO_ASSIGNMENT": "Return to assignment",
      "NONE_PERFECT": "None - Perfect!",
      "MISSED_ONE_TALKING_POINT": "You missed 1 talking point for this topic.",
      "MISSED_X_TALKING_POINTS": "You missed {{count}} talking points for this topic.",
      "MISSED_ONE_REQUIRED_TALKING_POINT": "You missed 1 required talking point for this topic",
      "MISSED_X_REQUIRED_TALKING_POINTS": "You missed {{count}} required talking points for this topic",
      "MISSED_ALL_ONE_REQUIRED_TALKING_POINT_TITLE": "You missed 1 required talking point for this topic.",
      "MISSED_ALL_X_REQUIRED_TALKING_POINTS_TITLE": "You missed {{count}} required talking points for this topic.",
      "REVIEW_MATERIAL_NEXT_TIME": "Review the material to improve for next time.",
      "ROLEPLAY_POST_CALL_TITLE": "You've reached the end of this call.",
      "ROLEPLAY_POST_CALL_SUBTITLE_PROCESSING": "Leave some feedback while we process your results.",
      "ROLEPLAY_POST_CALL_SUBTITLE_DELAY": "Results are taking awhile to load. Exit the pathway and we'll notify you when they're ready.",
      "ROLEPLAY_POST_CALL_SUBTITLE_ERROR": "There has been an error processing your results. Please reach out to support at",
      "ROLEPLAY_POST_CALL_PROCESSING_LABEL": "Processing results...",
      "ROLEPLAY_POST_CALL_FEEDBACK_QUESTION": "Did this conversation feel realistic and natural?",
      "FEEDBACK_THANK_YOU": "Thank you for your feedback!",
      "FEEDBACK_IMPROVEMENT_NOTE": "Thank you for your feedback! We will work on improving the experience.",
      "VIEW_RESULTS": "View Results",
      "FEEDBACK_IMPROVEMENT_SUFFIX": "We will work on improving the experience.",
      "ACCURACY": "Accuracy",
      "ACCURACY_LOADING": "Loading...",
      "ACCURACY_FLAGGED_MESSAGE": "You said some things that may differ from your source materials. See below for more details.",
      "ACCURACY_ALL_CLEAR": "We did not identify any claims that were inaccurate to the source materials.",
      "ACCURACY_ERROR": "Could not provide feedback on this session",
      "ACCURACY_YOU_SAID": "YOU SAID",
      "ACCURACY_CLAIM_IDENTIFIED": "THE CLAIM WE IDENTIFIED",
      "ACCURACY_MATERIALS_STATE": "YOUR MATERIALS STATE",
      "ACCURACY_OVERALL_BLOCK_PREFIX": "You said some things that might be inaccurate. Check the ",
      "ACCURACY_OVERALL_BLOCK_LINK": "accuracy",
      "ACCURACY_OVERALL_BLOCK_SUFFIX": " tab for more details.",
      "PERSONALIZED_PRACTICE_BREADCRUMB": "Personalized practice",
      "CONVERSATION_TYPE_LABEL": "Conversation type:",
      "DIFFICULTY_LABEL": "Difficulty:",
      "MOOD_LABEL": "Mood:",
      "DIFFICULTY": "Difficulty",
      "TEMPERAMENT": "Temperament"
    },
    "reportingV2": {
      "DASHBOARD": "Dashboard",
      "LOADING_ACCOUNTS": "Loading accounts...",
      "SELECT_AN_ACCOUNT": "Select an account",
      "SELECT_ASSIGNMENTS": "Select Assignments",
      "SEARCH_TEAMS": "Search teams",
      "LOADING_TEAMS": "Loading teams...",
      "ALL_TEAMS": "All teams",
      "ACCOUNT": "Account",
      "TEAMS": "Teams",
      "TEAM_LABEL": "Team",
      "TOTAL_LABEL": "Total",
      "PASSING_SCORE": "Passing Score",
      "ASSIGNMENT_LABEL": "Assignments",
      "USER_LABEL": "Users",
      "PRACTICE_LABEL": "Practice",
      "CERTIFICATION_LABEL": "Certification",
      "CERTIFICATION_STATUS_LABEL": "Certification status",
      "CERTIFICATION_STATUS_PREFIX_LABEL": "Certification Status:",
      "CERTIFIED_ON_FIRST_ATTEMPT_LABEL": "Certified on first attempt?",
      "DATE_OF_CERTIFICATION_LABEL": "Date of certification",
      "RESULTS_DESCRIPTION": "Here are the results of your team(s) across all practice assignments:",
      "ENGAGEMENT_BY_ASSIGNMENT": "Engagement by assignment",
      "ASSIGNMENT_ENGAGEMENT": "Assignment Engagement",
      "ENGAGED_LABEL": "Engaged",
      "ENGAGEMENT_STATUS_LABEL": "Engagement status",
      "ENGAGEMENT_STATUS_PREFIX_LABEL": "Engagement Status:",
      "PROFICIENT_LABEL": "Proficient",
      "ASSIGNMENT_NAME": "Assignment name",
      "ACTIVE_USERS": "Active users",
      "ASSIGNMENT_PROGRESS": "Progress by assignment",
      "IN_PROGRESS_LABEL": "In progress",
      "CERTIFIED_LABEL": "Certified",
      "OUT_OF_ATTEMPTS_LABEL": "Out of attempts",
      "USERS_ENGAGED_LABEL": "Users engaged",
      "SESSIONS_PER_ACTIVE_USERS_LABEL": "Sessions per active user",
      "HIGHER_THAN_LABEL": "Higher than",
      "MORE_THAN_LABEL": "More than",
      "TOTAL_SESSIONS_COMPLETED_LABEL": "Total sessions completed",
      "USER_CERTIFIED": "Users certified on all assignments",
      "ASSIGNMENT_CERTIFICATION": "Assignments with 100% certification",
      "TRAINER_TIME_SAVED": "Trainer time saved",
      "HOURS_LABEL": "hours",
      "PRACTICE_ASSIGNMENT_LABEL": "Practice Assignments",
      "CERTIFICATION_ASSIGNMENT_LABEL": "Certification Assignments",
      "START_DATE_LABEL": "Start date",
      "END_DATE_LABEL": "End date",
      "NAME_LABEL": "Name",
      "EMAIL_LABEL": "Email",
      "MEMBER_OF_TEAMS_LABEL": "Member of teams",
      "ASSIGNMENTS_COUNT_LABEL": "# of assignments",
      "TOTAL_SESSIONS_LABEL": "Total sessions",
      "NUMBER_OF_SESSIONS_LABEL": "Number of sessions",
      "TOTAL_USERS_LABEL": "Total Users",
      "AVERAGE_SCORE_LABEL": "Average score",
      "INITIAL_SCORE_LABEL": "Initial score",
      "HIGH_SCORE_LABEL": "High score",
      "LAST_PRACTICE_DATE_LABEL": "Last practice date",
      "PERCENT_IMPROVED_LABEL": "% improved",
      "PERCENT_IMPROVED_TOOLTIP_TEXT": "This metric compares a user's initial score to their highest score, expressed as a percentage of the maximum possible improvement.",
      "ASSIGNMENTS_CERTIFIED_LABEL": "Assignments certified",
      "ASSIGNMENTS_PROFICIENT_LABEL": "Assignments proficient",
      "ASSIGNMENTS_CERTIFIED_TOOLTIP_TEXT": "The number of assignments where the user has met or exceeded the score criteria for all simulations in the assignment",
      "ASSIGNMENTS_PROFICIENT_TOOLTIP_TEXT": "The number of assignments where the user has met or exceeded the score criteria at least once on all simulations in the assignment",
      "PROFICIENT_TOOLTIP": "The percent of users in this assignment that have met or exceeded the score criteria at least once on all simulations in this assignment",
      "ENGAGED_TOOLTIP": "The percent of users who have completed one or more sessions of a simulation in this assignment but have not yet achieved proficiency on all simulations.",
      "IN_PROGRESS_TOOLTIP": "The percent of users that have completed at least one session of a simulation in this assignment and received a score.",
      "OUT_OF_ATTEMPTS_TOOLTIP": "The percent of users who have exceeded their allotted attempts for one or more simulations in the assignment.",
      "CERTIFIED_TOOLTIP": "The percent of users who have met or exceeded the score criteria for all simulations in the assignment.",
      "SEARCH_FOR_A_USER_LABEL": "Search for a user",
      "NO_USERS_FOUND_LABEL": "No users found",
      "TRAINER_TIME_SAVED_TOOLTIP": "The amount of time users have spent in Quantified completing certification attempts.",
      "AVG_SESSIONS_PER_ASSIGNMENT": "Avg. sessions per assignment",
      "ASSIGNMENTS_ENGAGED_WITH": "Assignments engaged with",
      "AVERAGE_IMPROVEMENT": "Average improvement",
      "STATUS": "Status",
      "ASSIGNMENT_STATUS": "Assignment status",
      "STATUS_ACTIVE": "Active",
      "STATUS_ENDED": "Ended",
      "STATUS_CLOSED": "Closed",
      "STATUS_ARCHIVED": "Archived",
      "TOTAL_NUMBER_OF_SESSIONS": "Total number of sessions",
      "DATE_OF_LAST_PRACTICE": "Date of last practice",
      "CALL_NAME": "Call Name",
      "SESSION_DATE": "Session date",
      "DURATION_OF_SESSION": "Duration of session",
      "DURATION_OF_ATTEMPT": "Duration of attempt",
      "OVERALL_SCORE": "Overall score",
      "MESSAGING_SCORE": "Message adherence score",
      "METHODOLOGY_SCORE": "Methodology score",
      "SKILLS_SCORE": "Skills score",
      "SESSIONS": "Sessions",
      "TOTAL": "Total",
      "ALL_ASSIGNMENTS": "All assignments",
      "RECENT_ASSIGNMENTS": "Recent assignments",
      "USER_NAME": "User name",
      "LEARNER": "Learner",
      "DATE_RANGE": "Date Range",
      "DATE_RANGE_LABEL": "Date range",
      "SEARCH_USERS": "Search users...",
      "SEARCH_SIMULATIONS": "Search simulations...",
      "SEARCH_DATES": "Search dates...",
      "SEARCH_ASSIGNMENTS": "Search assignments...",
      "CERTIFIED_ON_FIRST_TRY": "Certified on the first try",
      "DATE_OF_CERTIFICATION": "Date of certification",
      "AVERAGE_CERTIFICATION_SCORE": "Average certification score",
      "TOTAL_TIME_CERTIFYING": "Total time certifying",
      "OF_THE_TIME": "of the time",
      "AVERAGE_SESSIONS_ACTIVE_USER": "Average sessions active user",
      "HOURS_IN_SIMULATIONS": "Hours in simulations",
      "AVERAGE_SESSIONS_TO_PROFICIENCY": "Average sessions to proficiency",
      "PERCENT_PROFICIENT": "Percent proficient",
      "SYSTEM_RUNNING_NORMALLY": "System is currently running normally",
      "PRACTICE_SIMULATIONS_LABEL": "Simulations",
      "SIMULATION_NAME": "Simulation name",
      "AVERAGE_DURATION_OF_SESSION": "Average duration of session",
      "AVERAGE_SESSIONS_PER_ACTIVE_USER": "Average sessions per active user",
      "NO_USERS_MATCHING_FILTERS_LABEL": "No results match your filters. Try clearing one or more filters to broaden the search.",
      "USERS_PASSED": "Users who have passed the simulation",
      "AVERAGE_TIME": "Average time to certify",
      "USERS_OUT_OF_ATTEMPTS": "Users out of attempts",
      "NO_CERTIFICATION_SIMULATION": "No certification simulations found",
      "AVERAGE_OVERALL_SCORE": "Average overall score",
      "SIMULATION": "Simulation",
      "No_SIMULATION": "No Sessions",
      "PERCENT_CERTIFIED": "Percent certified",
      "PERCENT_CERTIFIED_FIRST_ATTEMPT": "Percent certified on the 1st attempt",
      "USERS": "Users",
      "ATTEMPTS_LABEL": "Attempts",
      "NO_ATTEMPTS": "No attempts",
      "DATE_OF_SESSION": "Date of session",
      "TOTAL_ASSIGNMENTS": "Total assignments",
      "ASSIGNMENTS_CERTIFIED": "Assignments certified",
      "TOTAL_SESSIONS": "Total sessions",
      "HOURS_SPENT_PRACTICING": "Hours spent practicing",
      "LAST_LOGIN": "Last login",
      "NO_ASSIGNMENTS_MATCH_FILTERS": "No assignments match the chosen filters",
      "NO_TEAMS_DATA": "There are no teams within this account",
      "ASSIGNED_LABEL": "Not started",
      "USERS_ASSIGNED_LABEL": "Total assigned users",
      "SESSION_ID": "Session ID",
      "USER_NAME_LABEL": "User name",
      "NO_SIMULATIONS_FOUND_LABEL": "No Simulations Found",
      "MIN": "min",
      "SEC": "sec",
      "OF_LABEL": "of",
      "SECOND": "second",
      "SECONDS": "seconds",
      "MINUTE": "minute",
      "MINUTES": "minutes",
      "ASSIGNMENT_NAME_LABEL": "Assignment Name",
      "SIMULATION_NAME_LABEL": "Simulation Name",
      "START_DATE": "Start Date",
      "END_DATE": "End Date",
      "NO_ASSIGNMENTS": "No assignment found for this user.",
      "ASSIGNED": "Assigned",
      "TOTAL_PRACTICE_ASSIGNMENTS": "Total practice assignments",
      "SESSION_SCORES_OVER_TIME": "Session scores over time",
      "TIME": "Time",
      "SCORE": "Score",
      "NO_SESSIONS_AVAILABLE": "No sessions available to graph.",
      "MESSAGING_SCORE_LABEL": "Messaging score",
      "PERSONALIZED_PRACTICE_LABEL": "Personalized practice",
      "NO_PRODUCTS": "No personalized practice products for the selected teams",
      "TOTAL_TIME_SPENT_PRACTICING": "Total time spent practicing",
      "AVERAGE_SESSIONS_PER_USER": "Average sessions per user",
      "MOST_COMMON_CONVERSATION_TYPE_SELECTION": "Most common conversation type selection",
      "LEAST_COMMON_CONVERSATION_TYPE_SELECTION": "Least common conversation type selection",
      "CLEAR": "Clear",
      "CLEAR_TEAMS": "Clear teams",
      "METHODOLOGY_SCORE_DESCRIPTION": "Measures how well learners follow the recommended call structure. Scores reflect the average across all sessions of this simulation.",
      "METHODOLOGY": "Methodology",
      "MESSAGING": "Messaging",
      "MESSAGING_V2_DASHBOARD_DESCRIPTION": "Measures whether learners articulate key ideas during the call. Charts show the average percentage of messages correctly articulated per theme, across all sessions.",
      "NO_METRICS_MESSAGE": "More sessions needed to generate insights.",
      "SELECT_ALL": "Select all",
      "DESELECT_ALL": "Deselect all",
      "SKILLS": "Skills",
      "SKILLS_SCORE_STATS_DESCRIPTION": "Measures how well learners demonstrate key skills during the call. Scores reflect an AI assessment averaged across all sessions.",
      "EXPERT": "Expert",
      "PROFICIENT": "Proficient",
      "DEVELOPING": "Developing",
      "FULLY_ARTICULATED": "Fully articulated",
      "PARTIALLY_ARTICULATED": "Partially articulated",
      "NOT_MENTIONED": "Not mentioned",
      "MESSAGING_SCORE_STATS_DESCRIPTION": "Measures whether learners articulate key ideas during the call. Charts show how often each message was correctly articulated, across all sessions.",
      "CLEAR_STATUS": "Clear status",
      "CLEAR_USERS": "Clear users",
      "CLEAR_SIMULATIONS": "Clear simulations",
      "CLEAR_ASSIGNMENTS": "Clear assignments",
      "MODAL_SUBHEADING": "All {{ count }} objectives — average scores across all sessions",
      "VIEW_ALL_OBJECTIVES": "View all {{ count }} objectives →",
      "LEAST_MISSED_QUESTION": "LEAST MISSED QUESTION",
      "MOST_MISSED_QUESTION": "MOST MISSED QUESTION",
      "HIGHEST_SCORING_METHODOLOGY_SECTION": "HIGHEST SCORING METHODOLOGY SECTION",
      "LOWEST_SCORING_METHODOLOGY_SECTION": "LOWEST SCORING METHODOLOGY SECTION",
      "LEAST_ARTICULATED_MESSAGE": "LEAST ARTICULATED MESSAGE",
      "ENGAGEMENT": "ENGAGEMENT",
      "USER_ENGAGEMENT_MORE_SESSIONS": "more sessions completed than team average",
      "USER_ENGAGEMENT_FEWER_SESSIONS": "fewer sessions completed than team average",
      "QUESTION_CORRECT_PERCENTAGE_DESC": "of the time, they got this right",
      "QUESTION_CORRECT_PERCENTAGE_DESC_ASSIGNMENT": "of the time, users get this right",
      "METHODOLOGY_AVERAGE_POINTS_DESC": "avg. points on this objective across all sessions",
      "MOST_ARTICULATED_MESSAGE": "MOST ARTICULATED MESSAGE",
      "LEAST_MISSED_ANSWER_POINT": "LEAST MISSED ANSWER POINT",
      "MOST_MISSED_ANSWER_POINT": "MOST MISSED ANSWER POINT",
      "MOST_ARTICULATED_MESSAGE_DESCRIPTION": "of the time, they fully articulate this message",
      "LEAST_ARTICULATED_MESSAGE_DESCRIPTION": "of the time, they articulate this message",
      "MOST_ARTICULATED_MESSAGE_DESCRIPTION_ASSIGNMENT": "of the time, users articulate this message",
      "LEAST_ARTICULATED_MESSAGE_DESCRIPTION_ASSIGNMENT": "of the time, users articulate this message",
      "OTHERS_SINGULAR": "and 1 other",
      "OTHERS_PLURAL": "and {{ count }} others",
      "PAGINATION_PREVIOUS": "Previous",
      "PAGINATION_NEXT": "Next",
      "HOUR_LABEL": "hour",
      "SESSIONS_LABEL": "sessions",
      "YES_LABEL": "Yes",
      "NO_LABEL": "No"
    },
    "personalizedPractice": {
      "TITLE": "Personalized Practice",
      "DESCRIPTION": "Hi {{userFirstName}}! Personalized practices allow you to set your own scenarios so they are as realistic as possible.",
      "LOADING": "Loading...",
      "VIEW_SESSIONS": "View sessions",
      "VIEW_SIMULATION": "View simulation",
      "TOTAL_SESSION": "total session",
      "TOTAL_SESSIONS": "total sessions",
      "BREADCRUMB": "Personalized practice",
      "SCENARIO_DETAILS_TITLE": "Scenario details",
      "SCENARIO_DETAILS_DESCRIPTION": "Select variables from the options below to adjust the simulation to fit your needs.",
      "AVATAR": "Avatar",
      "SELECT_PLACEHOLDER": "Select",
      "CONVERSATION_TYPE": "Conversation type",
      "SELECT_CONVERSATION_TYPE": "Select conversation type",
      "LAUNCH_SIMULATION": "Launch simulation with selections",
      "PREVIOUS_SESSIONS": "Previous sessions",
      "TOTAL": "Total",
      "FILTERS": "Filters:",
      "DATE": "Date",
      "DIFFICULTY": "Difficulty",
      "TEMPERAMENT": "Temperament",
      "SESSION_DATE": "Session date",
      "SESSION_SCORE": "Session score",
      "DURATION": "Duration",
      "OVERALL_SCORE": "Overall score",
      "MESSAGING": "Messaging",
      "METHODOLOGY": "Methodology",
      "SKILLS": "Skills",
      "RESULTS": "Results",
      "VIEW_FEEDBACK": "View feedback",
      "OVERALL_SCORE_LABEL": "Overall Score",
      "SCORE": "Score",
      "NO_PRODUCTS_TITLE": "No products available",
      "NO_PRODUCTS_DESCRIPTION": "You don't have any personalized practice products yet.",
      "NO_SESSIONS_FOUND": "No sessions found with the selected filters",
      "TIME": "Time",
      "ALL": "All",
      "LEARNER": "Learner",
      "MOOD": "Mood",
      "CLEAR_FILTERS": "Clear filters",
      "PAGINATION_PREVIOUS": "Previous",
      "PAGINATION_NEXT": "Next",
      "DURATION_MINUTES_SECONDS": "{{minutes}}m {{seconds}}s",
      "DURATION_SECONDS": "{{seconds}}s"
    },
    "login": {
      "TITLE": "Welcome back",
      "SUB_TITLE": "How would you like to log in?  ",
      "LOGIN_WITH_SSO": "Log in with company SSO",
      "LOGIN_WITH_PASSWORD": "Log in with password",
      "PROVIDE_EMAIL": "Provide your email address",
      "HELP_TEXT": "Need help? Contact",
      "EMAIL_ERROR": "We are unable to log you in, please contact your company admin or IT department.",
      "EMAIL": "Email",
      "LOGIN": "Log in",
      "ALERT": "Alert",
      "EMAIL_PLACEHOLDER": "olivia@untitledui.com",
      "LOGIN_CONSENT_MESSAGE": "By logging into your account you agree to the {{termsLink}} and {{privacyLink}}.",
      "TERMS_OF_SERVICE": "Terms of Service",
      "PRIVACY_POLICY": "Privacy Policy",
      "WRONG_REGION_MESSAGE": "We're unable to log you in, please contact your company admin.",
      "WRONG_REGION_LINK": "You may also try logging into the {{regionName}} site.",
      "SWITCH_REGION": "Switch Region"
    },
    "learningPathway": {
      "BEGIN": "Begin",
      "SUBMIT_ANSWER": "Submit Answer",
      "CONTINUE": "Continue",
      "REVIEW_MATERIAL": "Review material",
      "ASK_QUESTIONS_ABOUT_PATHWAY": "Ask questions about the pathway",
      "DUE_DATE": "Due Date",
      "FOOTER_SUBTITLE_READY": "Ask me anything! I'm ready to help.",
      "FOOTER_SUBTITLE_READY_LEARN_WITH_X": "The coach is listening if you have a question",
      "FOOTER_SUBTITLE_MUTED": "You are currently muted. The coach cannot hear you.",
      "FOOTER_SUBTITLE_LISTENING": "Listening to your question...",
      "FOOTER_SUBTITLE_THINKING": "Thinking of a response...",
      "LEAVE_STEP": "Leave Step",
      "VIEW_CALL_DETAILS": "View call details",
      "NEXT_STEP": "Next Step",
      "NOTIFICATIONS_ARIA": "Notifications",
      "PDF_LOADING": "Loading PDF",
      "PDF_NEXT_PAGE": "Next page",
      "PDF_NO_SOURCE": "No PDF source provided.",
      "PDF_PREVIOUS_PAGE": "Previous page",
      "PDF_SCROLL_HINT": "Scroll to continue reading",
      "PDF_FULLSCREEN_ENTER": "Enter full screen",
      "PDF_FULLSCREEN_EXIT": "Exit full screen",
      "PDF_ZOOM_IN": "Zoom in",
      "PDF_ZOOM_OUT": "Zoom out",
      "POST_CALL_SUBTITLE": "Leave some feedback while we process your results",
      "POST_CALL_TITLE": "You have reached the end of this quiz.",
      "SETTINGS": "Settings",
      "TOAST_CONTENT": "Click below to view, or return to the pathway details screen for your next step.",
      "TOAST_TITLE": "Your {{ stepName }} role-play results have been processed",
      "ASSIGNMENTS": "Assignments",
      "USER_FALLBACK": "User",
      "VIEW_RESULTS": "View results",
      "DISMISS": "Dismiss",
      "QUIZ_TITLE": "Quiz",
      "QUIZ_OVERALL_SCORE_TOOLTIP": "The overall score is the weighted average of your answers for this attempt.",
      "COLUMN_DATE": "Date",
      "COLUMN_OVERALL_SCORE": "Overall Score",
      "COLUMN_RESULTS": "Results",
      "COLUMN_ANSWER_POINTS": "Answer points",
      "COLUMN_MESSAGING_SCORE": "Messaging Score",
      "COLUMN_METHODOLOGY_SCORE": "Methodology Score",
      "COLUMN_SKILLS_SCORE": "Skills Score",
      "PRACTICE_AGAIN": "Practice again",
      "DEBRIEF_LATEST_SESSION": "Debrief latest session",
      "COMPLETE_STEP": "Complete",
      "ERROR_TITLE": "Something went wrong",
      "ERROR_MESSAGE": "Please exit and re-enter the pathway. If the problem persists, reach out to",
      "ERROR_HELP_EMAIL": "help@quantified.ai",
      "PATHWAY_COMPLETED_TITLE": "You have completed this pathway",
      "PATHWAY_COMPLETED_BODY": "You can review your results at any time, or revisit any step to keep practicing.",
      "PATHWAY_COMPLETED_RETURN": "Return to assignments",
      "PATHWAY_OUT_OF_ATTEMPTS_TITLE": "You are out of attempts for a step on the pathway",
      "PATHWAY_OUT_OF_ATTEMPTS_BODY": "Reach out to your manager to discuss next steps.",
      "COMPLETED": "Completed",
      "EXITING_QUIZ_EARLY": "Exiting this quiz now will count as an attempt",
      "TRY_AGAIN": "Try Again",
      "RETURN_TO_PATHWAY": "Return to pathway home",
      "REVIEW_BEFORE_QUIZ_TOOLTIP": "Review this step before reattempting the quiz",
      "EXIT_MODAL_TITLE": "Are you sure you want to end this role-play?",
      "EXIT_MODAL_EXIT": "Exit",
      "EXIT_MODAL_RESUME": "Resume",
      "EXIT_MODAL_DESC_LIMITED_ATTEMPTS": "If you exit the role-play now, it will not be scored but will still count as an attempt.",
      "EXIT_MODAL_DESC_UNLIMITED_ATTEMPTS": "If you exit the role-play now, it will not be scored.",
      "EXIT_MODAL_DESC_SCORED": "If you exit the role-play now, we will score your call as-is.",
      "RESULTS_PROCESSING": "Results processing",
      "RESULTS_FAILED": "Results failed to load. Reach out to help@quantified.ai",
      "DEBRIEF_TITLE": "Debrief",
      "DEBRIEF_DESCRIPTION": "Discuss the results from your last certification attempt",
      "DEBRIEF_DESCRIPTION_PRACTICE": "Discuss the results from your last practice session",
      "VIEW_ALL_SESSIONS": "View all sessions",
      "COLLAPSE_SESSIONS": "Collapse sessions",
      "VIEW_ALL_ATTEMPTS": "View all attempts",
      "COLLAPSE_ATTEMPTS": "Collapse attempts",
      "REATTEMPT_CERTIFICATION": "Reattempt certification",
      "DEBRIEF_EXIT_MODAL_TITLE": "Are you sure you want to end this debrief?",
      "DEBRIEF_EXIT_MODAL_DESC": "If you exit the debrief now it will not be marked as complete.",
      "EXIT_PATHWAY": "Exit pathway",
      "HELP": "Help",
      "DOWNLOAD": "Download",
      "LEARN_STEP_HELP_CLOSE": "Close",
      "LEARN_STEP_HELP_TROUBLE": "If you're still having trouble, reach out to",
      "LEARN_STEP_HELP_EMAIL": "help@quantified.ai",
      "LEARN_STEP_HELP_VIDEO_P1": "Watch the material and ask the Coach any questions.",
      "LEARN_STEP_HELP_VIDEO_P2": "Select the play button to start the video. You can skip backwards to re-review the material.",
      "LEARN_STEP_HELP_VIDEO_P3": "Unmuting yourself in the bottom right to ask a question. This will pause the video. When you play the video we will mute your microphone.",
      "LEARN_STEP_HELP_VIDEO_P4": "When you've watched the whole video, advance to the next step.",
      "LEARN_STEP_HELP_PDF_P1": "Read the material and ask the Coach any questions.",
      "LEARN_STEP_HELP_PDF_P2": "Navigate the material by scrolling or using the arrow buttons on either side to move between pages.",
      "LEARN_STEP_HELP_PDF_P3": "You can mute and unmute yourself in the bottom right.",
      "LEARN_STEP_HELP_PDF_P4": "When you've read everything, advance to the next step.",
      "ASSESSMENT_EXIT_MODAL_TITLE": "Are you sure you want to proceed?",
      "ASSESSMENT_EXIT_MODAL_DESC": "Moving on before this conversation is complete will result in a longer and less personalized learning experience.",
      "ASSESSMENT_EXIT_MODAL_RESUME": "Resume assessment",
      "ASSESSMENT_EXIT_MODAL_PROCEED": "Proceed",
      "ASSESSMENT_PERSONALIZATION_ERROR_TITLE": "We were unable to personalize your pathway",
      "ASSESSMENT_PERSONALIZATION_ERROR_DESC_START": "We've assigned you the full pathway - reach out to ",
      "ASSESSMENT_PERSONALIZATION_ERROR_DESC_END": " if you would like to retry the personalization",
      "OPTIONAL": "Optional"
    },
    "leaderboard": {
      "LEADERBOARD": "Leaderboard",
      "TOP10PERCENT": "Top 10%",
      "PRACTICE_ASSIGNMENT": "Practice Assignments",
      "SIMULATION": "Simulation",
      "SELECT_ASSIGNMENT": "Select assignment",
      "SELECT_SIMULATION": "Select simulation",
      "SELECT_ASSIGNMENT_AND_SIMULATION": "Select an assignment and simulation to see the leaders",
      "NO_DATA": "No activity yet. Once the team starts engaging, you’ll see rankings appear here.",
      "NO_ASSIGNMENTS_AVAILABLE": "No Assignments available",
      "NO_SIMULATIONS_AVAILABLE": "No Simulations available",
      "NAME": "Name",
      "HIGH_SCORE": "High score",
      "AVERAGE_SCORE": "Average score",
      "TOTAL_SESSIONS": "Total sessions",
      "LAST_SESSION": "Last session",
      "TOP5": "Top 5",
      "OF": "of",
      "ENGAGED_USERS": "engaged users",
      "ENGAGED_USER": "engaged user",
      "NO_USERS_ENGAGED": "No users engaged",
      "HIDE_SESSIONS_WITH_LOW_SCORE": "Hide sessions with low skills scores",
      "SESSIONS_WITH_LOW_SCORE_TOOLTIP": "Sessions with a skills section score of \"developing\" will not contribute to the high or average score columns.",
      "PAGINATION_PREVIOUS": "Previous",
      "PAGINATION_NEXT": "Next"
    },
    "hotjarSurveys": {
      "FEEDBACK_MESSAGE": "Please share your feedback to help us improve.",
      "THANK_YOU_MESSAGE": "Thank you, we'll keep working to improve your experience"
    },
    "general": {
      "NO_ROLE_WEB_MESSAGE": "This user has not been set up with access to the system. Please contact a system administrator.",
      "NO_ROLE_IOS_TITLE": "Our app is focused on the learner experience",
      "NO_ROLE_IOS_BODY_START": "Access our",
      "NO_ROLE_IOS_WEB_APP": "web app",
      "NO_ROLE_IOS_BODY_END": "on your mobile browser to use additional functionality.",
      "NEED_HELP_QUESTION": "Need help?",
      "CONTACT": "Contact",
      "HELP_EMAIL": "help@quantified.ai",
      "PARENT_ACCOUNT": "Parent Account",
      "ACCOUNT": "Account",
      "CHECKMARK": "Checkmark",
      "ICON": "Icon",
      "ALERT": "alert",
      "HEADS_UP": "Heads up!",
      "USE_HEADPHONES_FOR_OPTIMAL_AUDIO": "For optimal audio on iPad, please use headphones.",
      "SETTINGS": "SETTINGS",
      "RP": "RP",
      "EMAIL_LABEL": "Email",
      "RAVEN_EMAIL": "Raven@InspireHR.com",
      "TEAM_MANAGER_FOR": "Team Manager for",
      "MIAMI_SALE": "Miami Sale",
      "CHARLOTTE_SALES": "Charlotte Sales",
      "ATLANTA_SALES": "Atlanta Sales",
      "TEAM": "Team",
      "ASSIGNMENTS": "Assignments",
      "MY_TEAMS": "My Teams",
      "REPORTING": "Reporting",
      "DASHBOARD": "Dashboard",
      "LEADERBOARD": "Leaderboard",
      "PERSONALIZED_PRACTICE": "Personalized Practice",
      "HELP_SEARCH_OUR": "Search our",
      "HELP_OR_REACH_OUT_TO": "or reach out to",
      "HELP_WITH_QUESTIONS": "with questions",
      "KNOWLEDGE_BASE": "knowledge base",
      "HELP_SECTION": "HELP",
      "ABOUT_SECTION": "ABOUT",
      "CONTACT_SUPPORT": "Contact support",
      "OPEN_WEB_APP": "Open the web app",
      "SEARCH_KNOWLEDGE_BASE": "Search the knowledge base",
      "PRIVACY_POLICY": "Privacy policy",
      "TERMS_OF_SERVICE": "Terms of service",
      "VERSION": "Version",
      "LOG_OUT": "Log out"
    },
    "dashboard": {
      "ALL": "All",
      "IN_COMPLETE": "Incomplete",
      "COMPLETED": "Completed",
      "NO_ASSIGNMENT_TITLE": "You do not have any assignments.",
      "NO_ASSIGNMENT_DETAILS": "You will be notified when you have assignments to complete.",
      "IN_COMPLETE_ASSIGNMENT_TITLE": "You have no incomplete assignments.",
      "IN_COMPLETE_ASSIGNMENT_DETAILS": "You will be notified when a new assignment is due.",
      "COMPLETED_ASSIGNMENT_TITLE": "You have no completed assignments.",
      "COMPLETED_ASSIGNMENT_DETAILS": "Check back once you have completed an assignment.",
      "NO_ASSIGNMENT_FILTERED_TITLE": "No assignments found.",
      "NO_ASSIGNMENT_FILTERED_DETAILS": "Try adjusting your filters to see available assignments, or check back later when new assignments are added.",
      "VIEW_ASSIGNMENT": "View Assignment",
      "VIEW_PATHWAY": "View pathway",
      "START_PATHWAY": "Start pathway",
      "GET_STARTED": "Get started",
      "ASSIGNMENT_LABEL": "Assignments",
      "MODULE_ASSIGNMENT_ALT": "Module Assignment Icon",
      "VIEW_ASSIGNMENT_FOR": "View assignment for",
      "DAY": "Day",
      "DAYS": "Days",
      "UNTILL_DUE": "Until Due",
      "PAST_DUE": "Past Due",
      "AVAILABLE_IN": "Available in",
      "DUE_TODAY": "Due Today",
      "PRACTICE": "Practice",
      "CERTIFICATION": "Certification",
      "UPCOMING": "Upcoming",
      "TEST_ASSIGNMENT": "Test Assignment",
      "CLOSED": "Closed",
      "ENDED": "Ended",
      "TOTAL": "Total",
      "ASSIGNMENT_STATUS_LABEL": "Assignment status",
      "ASSIGNMENT_STATUS_SELECTION_LABEL": "Assignment status:",
      "STATUS_SELECTION_LABEL": "Status:",
      "ASSIGNMENT_TYPE": "Assignment type",
      "ASSIGNMENT_TYPE_SELECTION_LABEL": "Assignment type:",
      "NOT_STARTED": "Not Started",
      "CERTIFIED": "Certified",
      "NOT_CERTIFIED": "Not Certified",
      "IN_PROGRESS": "In Progress",
      "PATHWAY": "Learning Pathway",
      "SELECT_ALL": "Select all",
      "DESELECT_ALL": "Deselect all",
      "CLEAR_STATUS": "Clear status",
      "OTHERS_SINGULAR": "and 1 other",
      "OTHERS_PLURAL": "and {{ count }} others"
    },
    "cognito": {
      "INVITATION_SUBJECT": "Welcome to Quantified!",
      "INVITATION_MESSAGE": "We're excited to have you on board! To get started, please follow the steps below to log in to your account for the first time.",
      "ACCOUNT_DETAILS": "Your account details:",
      "USERNAME": "Username",
      "PASSWORD": "Temporary password",
      "STEPS_LABEL": "Next steps to log in",
      "STEP_1": "1. Click the “Log In” button below to go to the login page.",
      "STEP_2": "2. Enter your username and temporary password provided above.",
      "STEP_3": "3. Once logged in, you’ll be prompted to set a new password.",
      "LOGIN_BUTTON": "Log In",
      "ABOUT_US": "Quantified’s Simulator is a virtual environment designed to help you quickly build essential skills, enabling you to connect and communicate more effectively with customers.",
      "EXPIRY_TIME": "This temporary password will expire in 24 hours. If you experience any issues logging in, please contact our support team at",
      "TEAM": "The Quantified Team",
      "INVITATION_SMS_USERNAME": "Your username is",
      "INVITATION_SMS_PASSWORD": "and temporary password is",
      "AUTHENTICATION_CODE": "Your authentication code is",
      "PASSWORD_RESET_CODE": "Your Quantified Password Reset Code",
      "RESET_PASSWORD_EMAIL": "Reset Password Email",
      "HELLO": "Hello",
      "USE_VERIFICATION_CODE": "You requested a password reset. Please use the verification code below to complete the process.",
      "VERIFICATION_CODE": "Verification code",
      "NEXT_STEP": "Next steps",
      "RETURN_TO_PATHWAY": "Return to pathway home",
      "RESET_PASSWORD_PAGE": "Return to your password reset page in your browser.",
      "ENTER_VERIFICATION_CODE": "Enter the verification code when prompted.",
      "CREATE_PASSWORD": "Once the code is verified, follow the instructions to create a new password.",
      "DISREGARD_NOTE": "If you didn’t request a password reset, please disregard this email.",
      "CONTACT_SUPPORT": "For further assistance, reach out to our support team at",
      "HELP_EMAIL": "help@quantified.ai",
      "THANK_YOU": "Thank you",
      "QUANTIFIED_TEAM": "The Quantified Team",
      "ADDRESS": "4200 Marathon Blvd, Suite 210, Austin, Texas 78756, United States"
    },
    "call": {
      "LOADING": "Loading",
      "SIMULATION_PAUSED": "The simulation has been paused.",
      "CLICK_RESUME": "Click the 'Resume' button below to continue.",
      "NO_INTERNET": "No internet connection",
      "TRY_AGAIN": "Please check your connection and try again.",
      "MIC_MUTED": "Mic is muted",
      "MIC_MUTED_DESCRIPTION": "Oops, looks like your mic is muted. Unmute to respond and continue.",
      "NO_RESPONSE": "No Response Detected",
      "MIC_NOT_CONNECTED": "Oops, looks like your mic isn't connected. Reselect your device to respond and continue.",
      "AUDIO_ISSUE": "Oops, something went wrong. Check your device settings and ensure you are in a quiet place free of background noise.",
      "LOADING_ALT": "Loading...",
      "REPEAT_RESPONSE": "You'll automatically be sent back to the simulation to repeat your response and try again.",
      "NEEDS_MORE_TIME_QUESTION": "needs more time to think, do you want to wait?",
      "NEEDS_MORE_TIME": "needs more time to think.",
      "WAIT_OR_END_CALL": "We will let you know when they're ready, or you can end the call and",
      "RETURN_TO_ASSIGNMENTS": "return to assignment",
      "READY": "Ready",
      "IS_READY": "is ready to continue your conversation.",
      "TRY_AGAIN_LABEL": "Try Again",
      "CHECK_SETTINGS": "Check Settings",
      "PAUSED_SIMULATION": "You've paused this simulation.",
      "PAUSED_SIMULATION_DESCRIPTION": "Video and audio recording are paused until the simulation is resumed.",
      "RESUME": "Resume",
      "SETTINGS": "Settings",
      "CAPTURING_RESPONSE": "Capturing Your Responses",
      "TOUR_MESSAGE": "Once you finish speaking, be sure to click the Continue button to ensure your responses are captured and scored.",
      "NEXT": "Next",
      "START_CALL": "Start",
      "END_CALL_TITLE": "Are you sure you want to end this simulation?",
      "END_CALL_DESCRIPTION": "If you end the simulation now you will not receive a score or feedback on your conversation.",
      "END_CALL": "End",
      "BROWSER_ACCESS_DENIED": "Your browser is denied access to this device.",
      "COPY_SESSION_ID_BUTTON": "Copy session ID",
      "RECONNECTING_AUDIO": "Reconnecting audio...",
      "TIPS_GUIDANCE_MESSAGE": "Talking points and tips will appear here.",
      "CONTINUE": "Continue",
      "SESSION_ID_LABEL": "Session ID:",
      "SESSION_ID_COPIED": "Session ID copied!",
      "HINTS_AND_SUGGESTIONS_TITLE": "Hints & Suggestions",
      "HINT_LABEL": "Hint",
      "CAPTIONS_LABEL": "Captions",
      "PAUSE_LABEL": "Pause",
      "VIDEO_LABEL": "Video",
      "SCREENSHARE_LABEL": "Share screen",
      "SCREENSHARE_STOP_LABEL": "Stop sharing screen",
      "SCREENSHARE_PIP_REOPEN_LABEL": "Re-open video preview",
      "SCREENSHARE_ACTIVE_LABEL": "You are currently screen sharing",
      "SCREENSHARE_OS_PERMISSION_HINT": "Couldn't start screen share. Enable Screen Recording for your browser in System Settings > Privacy & Security, then try again.",
      "SCREENSHARE_SAFARI_BLOCKED_HINT": "Safari has blocked screen sharing for this session. Log out and log back in, then try again.",
      "PARTY_EMOJI": "party emoji",
      "CALL_ENDED_MESSAGE": "You've reached the end of this simulation.",
      "CALL_ENDED_INACTIVITY": "This simulation has ended due to inactivity",
      "CALL_ENDED_GENERIC": "This simulation has ended",
      "FEEDBACK_PROMPT": "Leave some feedback while we process your results.",
      "INTERACTION_THRESHOLD_NOT_MET": "You did not meet our interaction threshold for scoring, please try again.",
      "REALISTIC_CONVERSATION_QUESTION": "Did this conversation feel realistic and natural?",
      "KNOWLEDGEABLE_PREPARED_QUESTION": "Do you feel more knowledgeable and prepared after this simulation?",
      "FEEDBACK_THANK_YOU": "Thank you for your feedback!",
      "FEEDBACK_IMPROVEMENT_NOTE": "Thank you for your feedback! We will work on improving the experience.",
      "AUDIO": "Audio",
      "MUTE": "Mute",
      "UNMUTE": "Unmute",
      "VISUAL_AID_LOAD_ERROR": "Visual Aid could not be loaded",
      "BEGIN_CALL": "Start",
      "LEAVE_STEP_TITLE": "Are you sure you want to leave this step?",
      "EXIT": "Exit",
      "LEAVE_CALL_BRIEFING": "Leave Briefing",
      "RESTORE_CALL": "Restoring your simulation",
      "FEW_SECONDS": "This may take a few seconds.",
      "CHECK_ALT": "Check",
      "COPY_ALT": "Copy",
      "HINTS_ALT": "Hints",
      "CLOSE_CAPTIONS": "Close Captions",
      "MICROPHONE_MUTED": "Microphone Muted",
      "RETURN_TO_CALL": "Return to Simulation",
      "YES": "Yes",
      "NO": "No",
      "VIEW_RESULTS": "View Results",
      "RETURN_TO_ASSIGNMENT": "Return to Assignment",
      "HAVING_ISSUES": "We're having trouble connecting, please check your internet connection, then click OK.",
      "OK": "OK",
      "RESULTS_NOT_GENERATED": "Sorry, we're unable to generate results at this time, please try again.",
      "INACTIVITY_ALERT_MESSAGE": "This call is being ended due to inactivity. Speak to the avatar to continue or select 'End Call' to end the call.",
      "INACTIVITY_DEFAULT_ALERT_TITLE": "This call will end in {{secondsUntilHangup}} seconds",
      "INACTIVITY_SHORT_ALERT_TITLE": "This call will end in a few seconds",
      "TELL_YOUR_GENDER_HEADING": "Please tell us your gender:",
      "BY_KNOWING_YOUR_GENDER_DESCRIPTION": "By knowing your gender, the avatar can use proper grammar, making the conversation more natural and realistic.",
      "GENDER_SELECTION": "Gender selection:",
      "SELECT_OPTION": "Select an option",
      "CONFIRM": "Confirm",
      "MALE": "Male",
      "FEMALE": "Female",
      "NON_BINARY": "Non-binary/Other",
      "PREFER_NOT_TO_ANSWER": "Prefer not to answer",
      "NON_BINARY_MESSAGE": "We understand and respect your non-binary gender identity. Due to current technological limitations, we default to using masculine pronouns. Please know that we are working on improvements to better accommodate all gender identities in the future. Thank you for your understanding and patience.",
      "PREFER_NOT_TO_ANSWER_MESSAGE": "We respect your choice not to provide a gender. In such cases, our technology defaults to using masculine pronouns due to current limitations.",
      "DISPLAY_VISUAL_AID": "Display Visual Aid",
      "FULL_SCREEN": "Full Screen",
      "COLLAPSE": "Collapse",
      "COMPLETED_CONVERSATION_MESSAGE": "Thank you for completing this conversation",
      "CONVERSATION_COMPLETION_FEEDBACK": "Leave some feedback while we process your conversation.",
      "ERROR_MESSAGE": "There was an error. Please reach out to",
      "SAVED_CONVERSATION_MESSAGE": "Your conversation has been saved.",
      "RETURN_TO_MY_ASSIGNMENTS": "Return to my assignments",
      "RETURN_TO_PERSONALIZED_PRACTICE": "Return to personalized practice",
      "CERT_ACK_TITLE": "Certification Video Acknowledgement",
      "CERT_ACK_ACCEPT_AND_BEGIN": "Accept and begin",
      "CERT_ACK_RESUME_CALL": "Resume call",
      "CERT_ACK_PROCESSING": "Processing...",
      "CERT_ACK_CAMERA_WARNING": "Please enable your camera to proceed with the certification.",
      "CERT_ACK_CAMERA_OFF_DURING_CALL": "Your camera was turned off. Please re-enable your camera to resume the certification.",
      "CERT_ACK_TEXT_1": "To ensure the integrity and fairness of this certification, your camera must remain on throughout the session, and the session will be monitored. This requirement is to confirm compliance with all certification standards.",
      "CERT_ACK_TEXT_2": "By continuing, you acknowledge and agree to these requirements.",
      "CERT_ACK_END_CALL": "End call",
      "LAUNCH_SIMULATION": "Launch simulation",
      "DEBRIEF_LATEST_SESSION": "Debrief latest session",
      "END": "End",
      "START_DEBRIEF": "Debrief latest session",
      "MOVE_TO_NEXT": "Move to next step",
      "RETRY_ROLEPLAY": "Retry role-play",
      "EXIT_PATHWAY": "Exit pathway",
      "PROCESSING": "Processing...",
      "FEEDBACK_PROMPT_REQUIRED": "Leave some feedback before viewing your results.",
      "SCREENSHARE_UNSUPPORTED_TITLE": "{{callName}} uses screen share",
      "SCREENSHARE_UNSUPPORTED_MESSAGE_APP": "In order to proceed with the call, please use our app instead of your browser.",
      "SCREENSHARE_UNSUPPORTED_MESSAGE_DESKTOP": "In order to proceed with the call, access it on a desktop computer.",
      "SCREENSHARE_UNSUPPORTED_CLOSE_BUTTON": "Close",
      "SCREENSHARE_UNSUPPORTED_GO_TO_APP_BUTTON": "Go to app",
      "SCREENSHARE_UNSUPPORTED_GO_TO_APP_UNAVAILABLE": "The mobile app is not available yet. Please check back soon."
    },
    "assignment": {
      "STATUS": "STATUS",
      "SCORE": "SCORE",
      "MUST_ACHIEVE": "Must achieve a",
      "OR_HIGHER": "or higher",
      "TEST": "Test",
      "OUT_OF_5": "out of 5",
      "LATEST_ATTEMPT": "LATEST ATTEMPT",
      "TOTAL_ATTEMPTS": "total attempts",
      "UNLIMITED": "Unlimited",
      "REMAINING": "Remaining",
      "VIEW_CALL_DETAILS": "View Details",
      "MAX_ATTEMPTS_REACHED": "You have reached the maximum number of attempts",
      "DUE_DATE": "Due Date",
      "DAYS": "Days",
      "DAY": "Day",
      "UNTILL_DUE": "Until Due",
      "PAST_DUE": "Past Due",
      "ONGOING": "Ongoing",
      "SCORE_REQUIREMENT": "Score Requirement",
      "SCORE_REQUIREMENT_DETAIL": "You must achieve a score of",
      "TO_COMPLETE_EACH_CALL": "to complete each required simulation.",
      "CALLS_IN_ASSIGNMENT": "Simulations in Assignment",
      "COMPLETED_CALLS": "Completed Calls",
      "INCOMPLETE_CALL": "Incomplete",
      "PREVIOUS_RESULTS": "Previous Results",
      "DATE": "Date",
      "RESULTS": "Results",
      "VIEW_PREVIOUS_RESULTS": "View Previous Results",
      "VIEW_FEEDBACK": "View Feedback",
      "LAUNCH_CALL": "Launch",
      "CLOSE_BUTTON": "Close Button",
      "CHECKMARK": "checkmark",
      "CALL": "Call",
      "QUESTION": "Question",
      "COMPLETED": "Completed",
      "IN_PROGRESS": "In progress",
      "NOT_STARTED": "Not started",
      "CERTIFIED": "Certified",
      "GUIDED": "Guided",
      "CONVERSATIONAL": "Conversational",
      "GUIDED_SIMULATION": "Knowledge Check",
      "CONVERSATIONAL_SIMULATION": "Role Play",
      "NO_ATTEMPTS_LEFT": "No attempts left",
      "NO_ATTEMPTS": "No attempts",
      "OVERVIEW": "Overview",
      "ABOUT_THE_AVATAR": "About the Avatar",
      "SCORING_CRITERIA": "Scoring Criteria",
      "SIMULATION_OVERVIEW": "Simulation Overview",
      "ABOUT_THE_PERSONA": "About the Persona",
      "OUTOF_COMPLIANCE": "Out of compliance",
      "CLOSED": "Closed"
    }
  },
  "de": {
    "root": {
      "ADMIN_PORTAL": "ADMIN-PORTAL",
      "SUPPORT": "SUPPORT",
      "U": "U",
      "USER": "Benutzer",
      "LOGOUT": "Abmelden",
      "ADMIN": "Admin",
      "SUPPORT_SMALL": "Support",
      "QUANTIFIED_AI": "Quantified.AI",
      "MICROPHONE": "MIKROFON",
      "CAMERA": "KAMERA",
      "ACCESS_DENIED": "ZUGANG_VERWEIGERT"
    },
    "teams": {
      "MY_TEAMS": "Meine Teams",
      "COMPLETED": "Abgeschlossen",
      "IN_PROGRESS": "Wird ausgeführt",
      "NOT_STARTED": "Nicht gestartet",
      "ASSIGNMET_MODULE": "Aufgabenmodul",
      "START_DATE": "Startdatum",
      "DUE_DATE": "Fälligkeitsdatum",
      "ASSIGNED_MEMBERS": "Zugewiesene Mitglieder",
      "CALLS_IN_MODULE": "Simulationen im Modul",
      "COMPLETION_REQUIRMENT": "Voraussetzung für den Abschluss",
      "COMPLETE_ALL_CALLS": "Schließen Sie alle Simulationen mit einer Punktzahl von",
      "OR_HIGHER": "oder höher",
      "PROGRESS_OVERVIEW": "FORTSCHRITTSÜBERSICHT",
      "TEAM_MEMBERS": "Teammitglieder",
      "AVERAGE_HIGH_SCORE": "Durchschnittlich höchste Punktzahl",
      "AVERAGE_NUMBER_ATTEMPTS_CALL": "Durchschnittliche Anzahl von Versuchen pro Simulation",
      "TOTAL_PRACTICES": "Übungen insgesamt",
      "INDIVIDUAL_CALL_PROGRESS": "INDIVIDUELLER SIMULATIONSFORTSCHRITT",
      "OF_TEAM_MEMBERS": "der Teammitglieder abgeschlossen",
      "AVERAGE_PRACTICES_TO_COMPLETION": "Durchschnittliche Übungen bis zum Abschluss",
      "TEAM_MEMBER_DETAILS": "INFOS ZUM TEAMMITGLIED",
      "DOWNLOAD_ACTIVITY_REPORT": "Aktivitätsbericht herunterladen",
      "TEAM_MEMBER": "Teammitglied",
      "PROGRESS": "Fortschritt",
      "CALLS_COMPLETED": "Abgeschlossene Simulationen",
      "PRACTICES": "Übungssitzungen",
      "MOST_RECENT_PRACTICE": "Letzte Sitzung",
      "THIS_TEAM_HAS_NO_ACTIVE_ASSIGNMENTS": "Dieses Team hat zur Zeit keine aktiven Aufgaben",
      "CALL_NAME_LABEL": "Name der Simulation",
      "HIGHEST_SCORE": "Höchste Punktzahl"
    },
    "simulationBuilder": {
      "THRESHOLD": "Schwellenwert",
      "TYPE": "Typ",
      "SELECT_AN_OPTION": "Option wählen",
      "CORRECT_FEEDBACK": "Feedback zu richtigen Antworten",
      "INCORRECT_FEEDBACK": "Feedback zu falschen Antworten",
      "CORRECT_FEEDBACK_PLACEHOLDER": "Wird angezeigt, wenn der Lernende die Frage richtig beantwortet",
      "INCORRECT_FEEDBACK_PLACEHOLDER": "Wird angezeigt, wenn der Lernende die Frage falsch beantwortet",
      "ENTER_MESSAGE_TEXT": "Nachrichtentext eingeben...",
      "DELETE": "Löschen",
      "SCORABLE": "Bewertbar",
      "MESSAGE_NUMBER": "Nachricht {{ index }}",
      "SEARCH_BY_SIMULATION_NAME": "Suche nach Simulationsnamen",
      "SEARCH_BY_ASSIGNMENT_NAME": "Suche nach Aufgabennamen",
      "SIMULATION_STATUS_PLACEHOLDER": "Simulationsstatus",
      "SIMULATION_STATUS_PREFIX": "Simulationsstatus:",
      "NO_SIMULATIONS_FOUND": "Keine Simulationen gefunden",
      "SELECT_ALL": "Alle auswählen",
      "DESELECT_ALL": "Alle abwählen",
      "STATUS_TESTING": "Testen",
      "STATUS_DRAFT": "Entwurf",
      "STATUS_PUBLISHED": "Veröffentlicht",
      "STATUS_ARCHIVED": "Archiviert",
      "ASSIGNEES_ZERO_STATE_MESSAGE": "Es wurden noch keine Benutzer zugewiesen",
      "ADD_USERS_TO_ASSIGNMENT": "Benutzer zur Aufgabe hinzufügen",
      "NO_DATA_FOUND": "Keine Daten gefunden!",
      "NO_USERS_SELECTED": "Kein Benutzer ausgewählt",
      "COL_FIRST_NAME": "Vorname",
      "COL_LAST_NAME": "Nachname",
      "COL_EMAIL": "E-Mail",
      "COL_VIEW_USER": "Nutzer anzeigen",
      "COL_VIEW_ASSIGNMENT": "Aufgabe anzeigen",
      "COL_ASSIGNMENT_NAME": "Name der Aufgabe",
      "COL_STATUS": "Status",
      "COL_TEAM_ASSOCIATIONS": "Teamzuordnungen",
      "COL_REPORTING_STATUS": "Berichtsstatus",
      "BREADCRUMB_USERS": "Benutzer",
      "STATUS_STAGED": "Gestuft",
      "STATUS_ACTIVE": "Aktiv",
      "STATUS_ENDED": "Beendet",
      "STATUS_CLOSED": "Geschlossen",
      "SEARCH_USERS_PLACEHOLDER": "Benutzer suchen",
      "NO_USERS_FOUND": "Keine Benutzer gefunden",
      "USERS_TAB_LABEL": "Benutzer",
      "ADD_TO_ASSIGNMENT": "Zur Aufgabe hinzufügen",
      "ASSIGNMENTS_COUNT": "Aufgaben",
      "REPORTING_EXCLUDED": "Ausgeschlossen",
      "REPORTING_INCLUDED": "Einbezogen",
      "KEBAB_EDIT_TEAM_ASSOCIATIONS": "Teamzuordnungen bearbeiten",
      "KEBAB_EXCLUDE_FROM_REPORTING": "Von der Berichterstattung ausschließen",
      "KEBAB_INCLUDE_IN_REPORTING": "In die Berichterstattung einbeziehen",
      "KEBAB_REMOVE_FROM_ASSIGNMENT": "Aus der Aufgabe entfernen",
      "NO_TEAMS": "—",
      "TEAMS_COUNT": "{{count}} Teams",
      "ADD_TO_ASSIGNMENT_MODAL_HEADING": "Zur Aufgabe hinzufügen",
      "FIELD_LABEL_ASSIGNMENT": "Aufgabe",
      "SEARCH_ASSIGNMENTS_PLACEHOLDER": "Nach Aufgaben suchen",
      "BUTTON_SET_TEAM_ASSOCIATION": "Teamzuweisung festlegen",
      "FIELD_LABEL_TEAM": "Team",
      "SEARCH_TEAM_PLACEHOLDER": "Nach Team suchen",
      "BUTTON_BACK": "Zurück",
      "BUTTON_CANCEL": "Abbrechen",
      "BUTTON_ADD_TO_ASSIGNMENT": "Zur Aufgabe hinzufügen",
      "EDIT_TEAM_ASSOCIATIONS_HEADING": "Teamzuordnungen bearbeiten",
      "EDIT_TEAM_ASSOCIATIONS_DESCRIPTION": "Für die Aufgabe {{assignmentName}}",
      "BUTTON_SAVE_ASSOCIATIONS": "Zuordnungen speichern",
      "REFERENCE_DOCUMENT_STATUS_UPLOADING": "– Wird hochgeladen...",
      "REFERENCE_DOCUMENT_STATUS_SUCCESS": "– Zu 100 % hochgeladen",
      "REFERENCE_DOCUMENT_STATUS_ERROR": "– Fehler beim Hochladen",
      "CREATE_SIMULATION_DETAILS_BUTTON": "Details zur Simulation erstellen",
      "SELF_AUTHORING_DESCRIPTION": "Geben Sie einen Namen, eine kurze Beschreibung des Szenarios und gegebenenfalls simulationsspezifische Dokumente an, um loszulegen",
      "CLICK_TO_UPLOAD": "Zum Hochladen hier klicken",
      "OR_DRAG_AND_DROP": "oder Drag &amp; Drop verwenden",
      "REFERENCE_DOCUMENTS_UPLOAD_DESCRIPTION": "PDF (max. 50 MB)",
      "ASSIGNMENT_NAME_LABEL": "Name der Aufgabe *",
      "SIMULATION_NAME_LABEL": "Name der Simulation",
      "NAME_FIELD_DESCRIPTION": "Dieser Name kann später geändert werden",
      "PRODUCT_LABEL": "Produkt",
      "SELECT_A_PRODUCT_PLACEHOLDER": "Produkt auswählen",
      "ADD_NEW_PRODUCT": "Neues Produkt hinzufügen",
      "SCENARIO_LABEL": "Szenario",
      "REFERENCE_DOCUMENTS_LABEL": "Referenzdokumente",
      "ACTION_CREATE_NEW": "Neu erstellen",
      "ACTION_CREATE": "Erstellen",
      "ACTION_DUPLICATE": "Duplizieren",
      "ENTITY_TYPE_SIMULATION_DISPLAY": "Simulation",
      "ENTITY_TYPE_ASSIGNMENT_DISPLAY": "Aufgabe",
      "ENTITY_TYPE_SIMULATION_LOWER": "Simulation",
      "ENTITY_TYPE_ASSIGNMENT_LOWER": "Aufgabe",
      "MODAL_TITLE": "{{ action }} {{ type }}",
      "CONFIRM_BUTTON_LABEL": "{{ action }} {{ type }}",
      "DUPLICATE_NAME_ERROR_ASSIGNMENT": "Eine Aufgabe mit demselben Namen existiert bereits.",
      "DUPLICATE_NAME_ERROR_SIMULATION": "Eine Simulation mit demselben Namen existiert bereits.",
      "NAME_REQUIRED_ERROR": "Der Name ist erforderlich.",
      "COPY_OF_PREFIX": "Kopie von – {{ name }}",
      "SCORE_DISTRIBUTION_TITLE": "Aktuelle Punkteverteilung",
      "EDIT_SECTIONS_AND_WEIGHTING": "Abschnitte und Gewichtung bearbeiten",
      "SCORING_WEIGHTS_TITLE": "Bewertung konfigurieren",
      "SCORING_WEIGHTS_DESCRIPTION": "Wählen Sie aus, welche Bereiche bewertet werden sollen und wie stark jeder einzelne zur Gesamtnote beiträgt. Die Gewichtung aller aktivierten Abschnitte muss sich auf insgesamt 100 % summieren. Der Abschnitt „Fähigkeiten“ darf nicht stärker als 20 % gewichtet werden.",
      "SCORING_WEIGHT_REQUIRED": "Erforderlich",
      "REFERENCE_DOCUMENT_STATUS_DELETING": "– Wird gelöscht",
      "REFERENCE_DOCUMENT_DELETE_ERROR": "Das Dokument konnte nicht gelöscht werden. Versuchen Sie es erneut.",
      "REFERENCE_DOCUMENT_UPLOAD_ERROR": "Das Dokument konnte nicht hochgeladen werden. Versuchen Sie es erneut.",
      "CONTENT_LIMIT_EXCEEDED_ERROR": "Inhaltslimit überschritten. Entfernen Sie ein oder mehrere Dokumente, um fortzufahren.",
      "LAST_FACT_DELETE_WARNING_HEADING": "Letzte Tatsache löschen?",
      "LAST_FACT_DELETE_WARNING_DESCRIPTION": "Durch das Löschen der letzten Tatsache werden alle Benutzerzuordnungen zu dieser Simulation entfernt und ihr Status auf „Entwurf“ zurückgesetzt.",
      "LEAVE_CONFIRMATION_HEADING": "Simulationserstellung beenden",
      "LEAVE_CONFIRMATION_DESCRIPTION": "Möchten Sie die Seite wirklich verlassen? Alle bisherigen Fortschritte gehen verloren.",
      "LEAVE_CONFIRMATION_LEAVE_BUTTON": "Verlassen",
      "METHODOLOGY_TITLE": "Methodik",
      "METHODOLOGY_SUBTITLE": "Bewerten Sie die Herangehensweise und den Aufbau des Gesprächs",
      "METHODOLOGY_WEIGHTING_LABEL": "Gewichtung: {{ weight }} %",
      "METHODOLOGY_RUBRIC_LABEL": "Methodik-Bewertungsschema",
      "SELECT_RUBRIC_PLACEHOLDER": "Bewertungsschema auswählen",
      "SKILLS_TITLE": "Fertigkeiten",
      "SKILLS_SUBTITLE": "Kommunikation und soziale Kompetenzen bewerten",
      "SKILLS_WEIGHTING_LABEL": "Gewichtung: {{ weight }} %",
      "SKILLS_RUBRIC_LABEL": "Fertigkeiten-Bewertungsschema",
      "PROCESSING_DOCUMENTS_MESSAGE": "Dokumente werden verarbeitet…",
      "PROCESSING_DOCUMENTS_SUPPORTING_TEXT": "Sie können sich gerne kurz zurücklehnen – die Ergebnisse liegen innerhalb von 5 Minuten vor.",
      "CORE_SIGNAL_MESSAGE": "Ihre Inhalte werden ausgewertet...",
      "SECTION_PLAN_MESSAGE": "Ihre Simulation wird strukturiert...",
      "DERIVED_COMPONENT_MESSAGE": "Die Komponenten Ihrer Simulation werden erstellt...",
      "COMPONENT_WAVE_1_MESSAGE": "Die Inhalte Ihrer Simulation werden formuliert...",
      "STILL_PROCESSING_TITLE": "Verarbeitung läuft...",
      "STILL_PROCESSING_BODY": "Dieser Vorgang dauert länger als gewöhnlich – Sie können die Simulation verlassen und später über die Simulationslistenansicht wieder darauf zugreifen.",
      "PROCESSING_FAILED_TITLE": "Verarbeitung fehlgeschlagen",
      "PROCESSING_FAILED_BODY": "Bei der Verarbeitung Ihrer Dokumente ist ein Fehler aufgetreten – bitte versuchen Sie es erneut. Wenden Sie sich an ",
      "TEST_SIMULATION_BUTTON": "Simulation testen",
      "SIMULATION_PROCESSED_TITLE": "Dokumente verarbeitet",
      "SIMULATION_PROCESSED_BODY": "Die Dokumente Ihrer Simulation wurden verarbeitet.",
      "SIMULATION_DOCUMENTS_PROCESSED_TITLE": "Simulationsdokumente verarbeitet.",
      "SIMULATION_DOCUMENTS_PROCESSED_BODY": "Die Dokumente, die Sie für die Simulation {{ name }} hochgeladen haben, wurden verarbeitet.",
      "SIMULATION_DOCUMENTS_FAILED_TITLE": "Die Simulationsdokumente konnten nicht verarbeitet werden.",
      "SIMULATION_DOCUMENTS_FAILED_BODY": "Die Dokumente, die Sie für die Simulation {{ name }} hochgeladen haben, konnten nicht verarbeitet werden.",
      "DISMISS": "Verwerfen",
      "VIEW_SIMULATION": "Simulation anzeigen",
      "FACT_MESSAGE_LABEL": "Nachricht",
      "FACT_MESSAGE_DESCRIPTION": "Nachrichten sollten informativ und als vollständiger Satz formuliert sein. Formulieren Sie Nachrichten klar, präzise und auf das Wesentliche beschränkt – vermeiden Sie unvollständige oder mehrdeutige Aussagen.",
      "FACT_INCORRECT_ANSWER_LABEL": "Text bei falscher Antwort",
      "FACT_INCORRECT_ANSWER_DESCRIPTION": "Text, der angezeigt wird, wenn eine Frage falsch beantwortet wird",
      "SHOW_INCORRECT_ANSWER_TEXT": "Alternativtext für falsche Antworten anzeigen",
      "ADD_NEW_FACT": "Neue Tatsache hinzufügen",
      "FACT_SINGULAR": "Tatsache",
      "FACT_PLURAL": "Tatsachen",
      "FACT_EXTRACTED_SINGULAR": "{{ count }} Tatsache extrahiert",
      "FACT_EXTRACTED_PLURAL": "{{ count }} Tatsachen extrahiert",
      "REVIEW_REQUIRED_LABEL": "Überprüfung empfohlen",
      "MESSAGING_TITLE": "Gesprächsinhalt",
      "MESSAGING_SUBTITLE": "Bewerten Sie, ob die wichtigsten Tatsachen vermittelt werden",
      "COMPONENT_WAVE_2_MESSAGE": "Die Inhalte Ihrer Simulation werden angepasst...",
      "COMPONENT_WAVE_3_MESSAGE": "Die Inhalte Ihrer Simulation werden fertiggestellt...",
      "MESSAGE_ADHERENCE_MESSAGE": "Kriterien für die Punktevergabe für Gesprächsinhalte werden vorgeschlagen...",
      "ASSEMBLING_MESSAGE": "Ihre Simulation wird erstellt...",
      "PROCESSING_FAILED_SUFFIX": " falls das Problem weiterhin besteht.",
      "BUTTON_RETRY": "Erneut versuchen",
      "TOKEN_LIMIT_EXCEEDED_BODY_PREFIX": "Inhaltslimit überschritten. Entfernen Sie ein oder mehrere Dokumente und versuchen Sie es erneut oder wenden Sie sich an ",
      "TOKEN_LIMIT_EXCEEDED_BODY_SUFFIX": " falls das Problem weiterhin besteht.",
      "AVATAR_LOOK_LABEL": "Darstellung",
      "AVATAR_SELECT_PLACEHOLDER": "Avatar auswählen",
      "AVATAR_VOICE_LABEL": "Stimme",
      "AVATAR_ALT": "Avatar",
      "PLAY_VOICE_PREVIEW_BUTTON": "Stimmvorschau abspielen",
      "VOICE_OPTION_1": "Stimme 1",
      "VOICE_OPTION_2": "Stimme 2",
      "BACK_TO_SIMULATION_DETAILS_BUTTON": "Zurück zu den Simulationsdetails",
      "AVATAR_SELECTION_TITLE": "Avatar-Auswahl",
      "VIEW_DOCUMENTS": "Dokumente anzeigen",
      "SELECT_AVATAR_BUTTON": "Avatar auswählen",
      "REQUEST_CHANGES_PLACEHOLDER": "Änderungen an den oben genannten Informationen anfordern",
      "CALL_DETAILS_LOAD_ERROR": "Wir konnten Ihre Anrufdetails nicht laden. Versuchen Sie es erneut.",
      "FACTS_CANNOT_BE_EMPTY": "Tatsachen müssen ausgefüllt sein. Fügen Sie jeder Tatsache eine Nachricht hinzu, bevor Sie sie testen oder veröffentlichen.",
      "FINISHING_SIMULATION_MESSAGE": "Ihre Simulation wird abgeschlossen...",
      "BLANK_THEME_MESSAGE_TOOLTIP": "Fügen Sie Text zur leeren Nachricht hinzu, bevor Sie ein neues Thema hinzufügen.",
      "BLANK_MESSAGE_TOOLTIP": "Fügen Sie Text zu dieser Nachricht hinzu, bevor Sie eine weitere hinzufügen.",
      "ADD_NEW_THEME_BUTTON": "Neues Thema hinzufügen",
      "ADD_THEME_BUTTON": "Thema hinzufügen",
      "ADD_MESSAGE_BUTTON": "Nachricht hinzufügen",
      "SCORE_LAST_SESSION": "Meine letzte Sitzung bewerten",
      "SCORE_LAST_SESSION_MODAL_HEADING": "Letzte Sitzung bewerten",
      "SCORE_LAST_SESSION_MODAL_DESCRIPTION": "Testen Sie die Simulation zunächst und kehren Sie dann hierher zurück, um sie anhand des ausgewählten Bewertungsschemas zu bewerten.",
      "SCORE_LAST_SESSION_MODAL_ERROR_HEADING": "Etwas ist schief gelaufen",
      "SCORE_LAST_SESSION_MODAL_ERROR_DESCRIPTION": "Erneut versuchen",
      "REFINEMENT_THINKING_MESSAGE": "Ich denke nach...",
      "REFINEMENT_UPDATED_MESSAGE": "Aktualisiert",
      "REFINEMENT_WARNING_PREFIX": "Diese Informationen wurden manuell überschrieben – bitte wenden Sie sich an",
      "REFINEMENT_WARNING_SUFFIX": ", um etwaige Aktualisierungen zu erhalten.",
      "REFINEMENT_ERROR_PREFIX": "Leider kann ich Ihnen dabei nicht helfen, aber",
      "REFINEMENT_ERROR_SUFFIX": "kann es vielleicht.",
      "REFINEMENT_APPLIED_TITLE": "Die angeforderten Änderungen wurden übernommen.",
      "REFINEMENT_APPLIED_BODY": "Die von Ihnen für die Simulation {{ name }} angeforderten Änderungen wurden vorgenommen.",
      "REFINEMENT_FAILED_TITLE": "Die angeforderten Änderungen konnten nicht vorgenommen werden.",
      "REFINEMENT_FAILED_BODY": "Wir konnten die von dir für die Simulation {{ name }} angeforderten Änderungen nicht vornehmen.",
      "WHAT_USERS_SEE_DESCRIPTION_TITLE": "Beschreibung der Simulation",
      "WHAT_USERS_SEE_DESCRIPTION_HELPER": "Die auf der Registerkarte „Allgemein“ aktualisierten Informationen werden hier übernommen, sofern keine manuellen Änderungen vorgenommen werden.",
      "WHAT_USERS_SEE_DESCRIPTION_FIELD_LABEL": "Beschreibung",
      "WHAT_USERS_SEE_DETAILS_TITLE": "Details zur Simulation",
      "WHAT_USERS_SEE_DETAILS_HELPER": "Dies sind die Inhalte, die dem Benutzer vor Beginn der Simulation angezeigt werden. Die auf der Registerkarte „Allgemein“ aktualisierten Informationen werden hier übernommen, sofern keine manuellen Änderungen vorgenommen werden. Alle leer gelassenen Abschnitte werden dem Lernenden nicht angezeigt. Alle Abschnitte unterstützen die Markdown-Formatierung.",
      "WHAT_USERS_SEE_OVERVIEW_FIELD_LABEL": "Überblick über die Simulation",
      "WHAT_USERS_SEE_PERSONA_FIELD_LABEL": "Über die Persona",
      "WHAT_USERS_SEE_SCORING_FIELD_LABEL": "Kriterien für die Punktevergabe",
      "WHAT_USERS_SEE_SCORING_FIELD_HELPER": "Dieser Abschnitt wird anhand der auf der Registerkarte „Bewertung“ getroffenen Auswahlen ausgefüllt. Das Bearbeiten der Informationen an dieser Stelle hat keinen Einfluss auf die Bewertung der Simulation.",
      "WHAT_USERS_SEE_PREVIEW_DETAILS_CTA": "Vorschau des Simulationsdetails‑Modals",
      "WHAT_USERS_SEE_PREVIEW_CARD_CTA": "Vorschau der Simulationskarte",
      "TAB_GENERAL": "Allgemeines",
      "TAB_CONTENTS": "Inhalt",
      "TAB_KEY_WORDS": "Schlüsselwörter",
      "TAB_SCORING": "Bewertung",
      "TAB_TESTING": "Testen",
      "TAB_PROMPTS": "Eingabeaufforderungen",
      "TAB_WHAT_USERS_SEE": "Was die Benutzer sehen",
      "ACCURACY_FEEDBACK_TITLE": "Feedback zur Genauigkeit",
      "ACCURACY_FEEDBACK_DESCRIPTION": "Bewerten Sie jede Aussage eines Vertreters auf ihre Genauigkeit im Vergleich zu den hochgeladenen Dokumenten",
      "ACCURACY_FEEDBACK_STATUS_ON": "Aktiviert",
      "ACCURACY_FEEDBACK_STATUS_OFF": "Aus",
      "ACCURACY_FEEDBACK_STATUS_DISABLED": "Deaktiviert",
      "ACCURACY_FEEDBACK_NO_DOCUMENTS": "Die Genauigkeitsbewertung ist nicht verfügbar, da keine zugehörigen Dokumente hinzugefügt wurden.",
      "SCORING_AI_REVIEW_NOTICE": "Einige Inhalte auf dieser Registerkarte wurden anhand der von Ihnen bereitgestellten Materialien generiert. Überprüfen Sie alle Inhalte auf ihre Richtigkeit, bevor Sie diesen Anruf veröffentlichen.",
      "EXPORT_SIMULATION_SUMMARY_BUTTON": "Zusammenfassung der Export-Simulation",
      "CALL": "Anruf",
      "REFINEMENT_OVERRIDDEN_PREFIX": "Diese Informationen wurden manuell überschrieben – bitte wenden Sie sich an",
      "REFINEMENT_OVERRIDDEN_SUFFIX": ", um etwaige Aktualisierungen zu erhalten.",
      "SUPPORT_EMAIL": "help@quantified.ai",
      "WHAT_USERS_SEE_OVERRIDE_WARNING_TITLE": "Das Bearbeiten dieser Felder verhindert zukünftige Aktualisierungen",
      "WHAT_USERS_SEE_OVERRIDE_WARNING_BODY": "Durch die manuelle Aktualisierung dieser Abschnitte werden diese davon ausgeschlossen, weitere Aktualisierungen aus dem Verfeinerungsprozess auf der Registerkarte „Allgemeines“ zu erhalten.",
      "WHAT_USERS_SEE_DETAILS_OVERRIDE_EDITED_TITLE": "Diese Felder wurden bearbeitet",
      "WHAT_USERS_SEE_DETAILS_OVERRIDE_EDITED_BODY": "Sie erhalten keine Verfeinerungsaktualisierungen mehr, die auf der Registerkarte „Allgemeines“ vorgenommen werden",
      "SIMULATION_BUILDER_HEADING": "Simulations-Builder",
      "ASSIGNMENTS_TAB_LABEL": "Aufgaben",
      "SIMULATIONS_TAB_LABEL": "Simulationen",
      "CREATE_NEW_ASSIGNMENT_BUTTON": "Neue Aufgabe erstellen",
      "CREATE_NEW_SIMULATION_BUTTON": "Neue Simulation erstellen",
      "NO_ASSIGNMENTS_FOUND": "Keine Aufgaben gefunden",
      "ASSIGNMENT_STATUS_PLACEHOLDER": "Aufgabenstatus",
      "ASSIGNMENT_STATUS_PREFIX": "Aufgabenstatus:",
      "ASSIGNMENT_TYPE_LABEL": "Aufgabentyp",
      "SELECT_ASSIGNMENT_TYPE_PLACEHOLDER": "Aufgabentyp wählen",
      "NAME_LABEL": "Name",
      "ASSIGNMENT_NAME_PLACEHOLDER": "Name der Aufgabe",
      "PASSING_SCORE_LABEL": "Punktzahl zum Bestehen",
      "PASSING_SCORE_OPTIONAL_LABEL": "Punktzahl zum Bestehen (optional)",
      "SCORE_MAX_EXCEEDED_ERROR": "Die Punktzahl sollte 5 nicht überschreiten",
      "GET_HELP_BUTTON": "Hilfe anfordern",
      "PASSING_SCORE_TOOLTIP": "Hiermit wird die Gesamtpunktzahl festgelegt, die ein Lernender erreichen muss, um die Simulation zu bestehen.",
      "DESCRIPTION_LABEL": "Beschreibung",
      "ASSIGNMENT_DESCRIPTION_PLACEHOLDER": "Beschreibung der Aufgabe",
      "MESSAGING_FEEDBACK_LABEL": "Feedback zu Gesprächsinhalten",
      "MESSAGING_FEEDBACK_TOOLTIP_HEADING": "Feedback zu Gesprächsinhalten",
      "MESSAGING_FEEDBACK_TOOLTIP_BODY": "Wenn ein Lernender ein Thema falsch formuliert, werden ihm Informationen angezeigt, wie er sie beim nächsten Mal besser formulieren kann. Mit dieser Einstellung wird festgelegt, ob diese Informationen angezeigt werden oder nicht.",
      "ENABLED_TEXT": "Aktiviert",
      "DISABLED_TEXT": "Deaktiviert",
      "PAUSE_BUTTON_LABEL": "Schaltfläche „Pause“",
      "ASSIGNMENT_START_DATE_LABEL": "Startdatum der Aufgabe",
      "SELECT_DATE_PLACEHOLDER": "Datum auswählen",
      "ASSIGNMENT_END_DATE_LABEL": "Enddatum der Aufgabe",
      "ASSIGNMENT_END_DATE_OPTIONAL_LABEL": "Enddatum der Aufgabe (optional)",
      "END_DATE_RANGE_ERROR": "Start- und Enddatum dürfen nicht identisch sein",
      "ASSIGNMENT_INFORMATION_TITLE": "Informationen zur Aufgabe",
      "ASSIGNMENT_TYPE_CERTIFICATION": "Zertifizierung",
      "ASSIGNMENT_TYPE_PRACTICE": "Übung",
      "ASSIGNMENT_TYPE_PERSONALIZED_PRACTICE": "Personalisierte Übung",
      "BUTTON_SAVE_AND_CLOSE": "Speichern und schließen",
      "BUTTON_ADD_SIMULATIONS": "Simulationen hinzufügen",
      "ATTEMPTS_UNLIMITED": "Unbegrenzt",
      "SEARCH_FOR_SIMULATION_LABEL": "Nach Simulation suchen",
      "SIMULATION_NAME_PLACEHOLDER": "Name der Simulation",
      "BUTTON_REMOVE_ALL": "Alle entfernen",
      "SIMULATIONS_IN_ASSIGNMENT_LABEL": "Simulationen in der Aufgabe",
      "BUTTON_ASSIGN_LEARNERS": "Lernende zuweisen",
      "CALL_TYPE_UNKNOWN": "Unbekannt",
      "ASSIGNMENT_COUNT_NONE": "Keine",
      "ASSIGNMENT_COUNT_SINGULAR": "{{ count }} Aufgabe",
      "ASSIGNMENT_COUNT_PLURAL": "{{ count }} Aufgaben",
      "ERROR_LOADING_ASSIGNMENTS": "Fehler beim Laden der Aufgaben",
      "SEARCH_ASSIGNEES_TITLE": "Benutzer durchsuchen",
      "DIALOG_DESCRIPTION_ADD_USERS": "Wählen Sie die Benutzer aus, die an der Aufgabe teilnehmen sollen. Durch die Suche nach einem Team können Sie bestimmte Benutzer diesem Team zuweisen oder die Zuweisung aufheben. Achten Sie bei der Auswahl eines bestimmten Benutzers darauf, dass dieser für Berichtszwecke dem richtigen Team zugeordnet ist.",
      "ADD_USERS_TO_ASSIGNMENT_HEADING": "Benutzer zur Aufgabe hinzufügen",
      "BUTTON_REVIEW_SELECTED_USERS": "Ausgewählte Benutzer überprüfen",
      "FIND_USERS_LABEL": "Benutzer suchen",
      "BUTTON_CLEAR": "Löschen",
      "LEARNER_COUNT_NONE": "Kein",
      "LEARNER_COUNT_SINGULAR": "{{ count }} Lernender",
      "LEARNER_COUNT_PLURAL": "{{ count }} Lernende",
      "ASSIGNMENT_TAB_DETAILS": "Details",
      "ASSIGNMENT_TAB_SIMULATIONS": "Simulationen",
      "ASSIGNMENT_TAB_ASSIGNEES": "Benutzer",
      "LOADING_ASSIGNMENT_DETAILS": "Aufgabendetails werden geladen...",
      "BREADCRUMB_ASSIGNMENTS": "Aufgaben",
      "ASSIGNMENTS_COL_NAME": "Name",
      "ASSIGNMENTS_COL_START_DATE": "Startdatum der Aufgabe",
      "ASSIGNMENTS_COL_END_DATE": "Enddatum der Aufgabe",
      "ASSIGNMENTS_COL_LEARNERS": "Lernender zugewiesen",
      "ASSIGNMENTS_COL_TYPE": "Aufgabentyp",
      "ASSIGNMENTS_COL_STATUS": "Aufgabenstatus",
      "SIMULATIONS_COL_NAME": "Name",
      "SIMULATIONS_COL_PRODUCT": "Produkt",
      "SIMULATIONS_COL_DATE_MODIFIED": "Datum der letzten Änderung",
      "SIMULATIONS_COL_STATUS": "Status",
      "SIMULATIONS_COL_USED_IN": "Verwendet bei",
      "SIMULATIONS_COL_TYPE": "Simulationstyp",
      "SIMULATIONS_COL_DATE_PUBLISHED": "Veröffentlichungsdatum",
      "CONVERSE_PROMPT_LABEL": "Konversationsaufforderung",
      "CONVERSE_PROMPT_EXPAND_TO_EDIT": "Zum Bearbeiten erweitern",
      "CONVERSE_PROMPT_ENTER_LABEL": "Konversationsaufforderung hier eingeben *",
      "CONVERSE_PROMPT_EDITING_HEADING": "Konversationsaufforderung bearbeiten",
      "CONVERSE_PROMPT_OVERRIDE_CONFIRMATION_HEADING": "Bestätigung zum Überschreiben der Eingabeaufforderung",
      "CONVERSE_PROMPT_OVERRIDE_DESCRIPTION": "Möchten Sie die Konversationsaufforderung wirklich überschreiben? Autoren verlieren den Selbstbedienungszugriff auf Verfeinerungen, wenn dieser überschrieben wird.",
      "CONVERSE_PROMPT_FIELD_LABEL": "Konversationsaufforderung",
      "CONVERSE_PROMPT_SAVE_BUTTON": "Eingabeaufforderung speichern",
      "BUTTON_CONFIRM": "Bestätigen",
      "DELETE_SIM_HEADING": "Simulation löschen",
      "DELETE_SIM_CONTENT": "Diese Simulation wird gelöscht. Alle mit der Simulation verknüpften Testaufgaben werden ebenfalls entfernt.",
      "DELETE_SIM_LABEL": "Simulation löschen",
      "DELETE_ASSIGNMENT_HEADING": "Aufgabe löschen",
      "DELETE_ASSIGNMENT_CONTENT": "Diese Aufgabe wird endgültig gelöscht.",
      "DELETE_ASSIGNMENT_LABEL": "Aufgabe löschen",
      "DELETE_ASSIGNMENT_NON_STAGED_CONTENT": "Um eine Aufgabe mit dem Status „Aktiv“ oder „Beendet“ zu löschen, wenden Sie sich bitte an das CX-Team. Vielen Dank.",
      "REMOVE_FROM_ASSIGNMENT_HEADING": "Aus der Aufgabe entfernen",
      "REMOVE_FROM_ASSIGNMENT_CONTENT": "Dadurch wird der Benutzer aus der Aufgabe und allen zugehörigen Team-Links entfernt.",
      "REMOVE_FROM_ASSIGNMENT_LABEL": "Aus der Aufgabe entfernen",
      "PUBLISH_SIMULATION_HEADING": "Simulation veröffentlichen",
      "PUBLISH_CONTINUE_EDITING": "Bearbeitung fortsetzen",
      "PUBLISH_BUTTON": "Veröffentlichen",
      "PUBLISH_SIMULATION_DESCRIPTION": "Das Rollenspiel kann zu Aufgaben hinzugefügt werden; Informationen zu Rollen, Bewertung und Anweisungen können nicht mehr bearbeitet werden.",
      "CONFIRMATION_SELECTED_USERS_HEADING": "Ausgewählte Benutzer",
      "CONFIRMATION_TOTAL_COUNT": "{{ count }} insgesamt",
      "CONFIRMATION_CREATE_HEADING": "Neue Aufgabe erstellen",
      "CONFIRMATION_ADD_USERS_HEADING": "Benutzer zur Aufgabe hinzufügen",
      "CONFIRMATION_SAVE_ASSIGNMENT_BTN": "Aufgabe speichern",
      "CONFIRMATION_REMOVE_USER": "Entfernen",
      "EDIT_WEIGHTING_HEADING": "Gewichtung der Bewertung bearbeiten",
      "EDIT_WEIGHTING_DESCRIPTION": "Die Gesamtpunktzahl wird aus dem gewichteten Durchschnitt der folgenden Abschnitte berechnet. Die Gewichtung aller aktivierten Abschnitte muss sich auf insgesamt 100 % summieren. Der Abschnitt „Fähigkeiten“ darf nicht stärker als 20 % gewichtet werden.",
      "EDIT_WEIGHTING_ERROR_ALL_DISABLED": "Mindestens eine Bewertungsaktion muss aktiviert sein",
      "EDIT_WEIGHTING_ERROR_WEIGHT_RANGE": "Die Gewichtung muss zwischen 0 und 100 liegen",
      "EDIT_WEIGHTING_ERROR_SKILLS_MAX": "Der Abschnitt „Fähigkeiten“ darf nicht stärker als 20 % gewichtet werden",
      "EDIT_WEIGHTING_ERROR_TOTAL": "Die Gesamtgewichtung der Abschnitte muss 100 % betragen",
      "PERSONA_INFORMATION_TITLE": "Informationen zur Persona",
      "PERSONA_AVATAR_LABEL": "Avatar *",
      "PERSONA_NAME_LABEL": "Name *",
      "PERSONA_INITIAL_GREETINGS_LABEL": "Erste Begrüßungen *",
      "PERSONA_INITIAL_GREETINGS_DESCRIPTION": "Die Persona beginnt die Simulation mit einer dieser Begrüßungen. Sie können maximal 5 Optionen auswählen.",
      "PERSONA_ADD_GREETING_OPTION": "Begrüßungsoption hinzufügen",
      "PERSONA_RESUME_MESSAGE_LABEL": "Nachricht fortsetzen",
      "PERSONA_RESUME_MESSAGE_DESCRIPTION": "Wenn ein Lernender eine Simulation nach einer Pause fortsetzt, beginnt die Persona mit einer dieser Begrüßungen. Sie können maximal 5 Optionen auswählen.",
      "PERSONA_ADD_MESSAGE_OPTION": "Nachrichtenoption hinzufügen",
      "PERSONA_UPLOADING": "Wird hochgeladen...",
      "PERSONA_DELETING": "Wird gelöscht...",
      "PERSONA_CUSTOM_BG_PREVIEW_ALT": "Vorschau benutzerdefinierter Hintergrund",
      "PERSONA_AVATAR_THUMBNAIL_ALT": "Avatar-Vorschaubild",
      "PERSONA_AVATAR_WITH_BG_ALT": "Avatar mit benutzerdefiniertem Hintergrund",
      "PERSONA_PROCESSING_IMAGE": "Bild wird verarbeitet...",
      "PERSONA_CUSTOM_BACKGROUND_LABEL": "Benutzerdefinierter Hintergrund",
      "PERSONA_REMOVE_BACKGROUND": "Hintergrund entfernen",
      "PERSONA_CLICK_TO_REPLACE": "Zum Ersetzen klicken",
      "PERSONA_UPLOAD_DESCRIPTION": "PNG oder JPG, vorzugsweise im Seitenverhältnis 16:9, max. 2 MB",
      "SIM_INFORMATION_TITLE": "Informationen zur Simulation",
      "SIM_NAME_FIELD_LABEL": "Name *",
      "SIM_LANGUAGE_FIELD_LABEL": "Sprache",
      "SIM_DETAILS_SECTION_TITLE": "Details zur Simulation",
      "SIM_ADDITIONAL_SECTION_TITLE_LABEL": "Titel des zusätzlichen Abschnitts",
      "SIM_ADDITIONAL_SECTION_INFO_LABEL": "Informationen zum zusätzlichen Abschnitt",
      "TESTING_SECTION_TITLE": "Tester",
      "TESTING_SEND_ASSIGNMENTS_BTN": "Testaufgaben senden",
      "TESTING_MESSAGING_TOOLTIP": "Fügen Sie vor dem Testen oder Veröffentlichen mindestens eine Tatsache zu „Einhaltung der Gesprächsinhalte“ hinzu.",
      "TESTING_DESCRIPTION": "Suchen Sie nach Benutzern, die die Simulation testen sollen, und senden Sie ihnen anschließend die Testaufgabe.",
      "TESTING_COL_NUMBER_OF_ATTEMPTS": "Keine Versuche mehr",
      "TESTING_COL_DATE_OF_LAST_ATTEMPT": "Datum des letzten Versuchs",
      "TESTING_CLEAR_USERS": "Benutzer löschen",
      "TESTING_REMOVE_ASSIGNEE": "Benutzer entfernen",
      "OVERALL_SECTION_TITLE": "Abschnitte, Gewichtungen und Eingabeaufforderungen",
      "OVERALL_HEADING": "Insgesamt",
      "TRANSCRIPT_PROMPT_TITLE": "Abschrift-Eingabeaufforderung",
      "TRANSCRIPT_PROMPT_FIELD_LABEL": "Aufforderung für die bereinigte Abschrift hier ein eingeben",
      "SIMULATION_PROMPTS_TITLE": "Simulation-Eingabeaufforderungen",
      "TAGS_LABEL": "Tags",
      "CREATE_TAG_OPTION": "„{{term}}“ erstellen",
      "TAG_CREATE_ERROR": "Das Tag konnte nicht erstellt werden. Bitte versuchen Sie es erneut.",
      "EDIT_SIMULATION_TAGS_TITLE": "Simulationstags bearbeiten",
      "SAVE_TAGS_BUTTON": "Tags speichern",
      "CLOSE_BUTTON": "Schließen",
      "TAG_UPDATE_ERROR": "Das Tag konnte nicht aktualisiert werden. Bitte versuchen Sie es erneut.",
      "SCREEN_SHARE_TITLE": "Bildschirmfreigabe",
      "SCREEN_SHARE_DESCRIPTION": "Ermöglicht es dem Nutzer, seinen Bildschirm während des Anrufs für den Avatar freizugeben, damit dieser sehen und auf das Angezeigte reagieren kann",
      "SCREEN_SHARE_STATUS_ON": "Aktiviert",
      "SCREEN_SHARE_STATUS_OFF": "Deaktiviert",
      "SCREEN_SHARE_NO_PERSONA": "Fügen Sie zunächst eine Persona hinzu, um die Bildschirmfreigabe zu aktivieren.",
      "HIDE_RESULTS_LABEL": "Ergebnisse ausblenden",
      "SEARCH_FIELD_HINT": "Geben Sie mindestens drei Zeichen ein, um die Suche zu starten",
      "OTHERS_SINGULAR": "und 1 weitere",
      "OTHERS_PLURAL": "und {{count}} weitere",
      "PAGINATION_PREVIOUS": "Vorherige",
      "PAGINATION_NEXT": "Nächste",
      "SKILLS_RUBRIC_REQUIRED_TOOLTIP": "Hängen Sie ein Fertigkeiten-Bewertungsschema an. „Fertigkeiten“ ist aktiviert, wenn die Gewichtung über 0 % liegt.",
      "ENTITY_TYPE_KNOWLEDGE_CHECK_DISPLAY": "Wissens-Check",
      "NAME_MAX_LENGTH_ERROR": "Der Name darf maximal 255 Zeichen lang sein.",
      "UUID_COPIED_TOAST": "UUID in die Zwischenablage kopiert",
      "MENU_ARCHIVE": "Archiv",
      "MENU_EDIT_SIMULATION_TAGS": "Simulationstags bearbeiten",
      "MENU_COPY_UUID": "UUID kopieren",
      "REFINEMENT_IN_PROGRESS_TOOLTIP": "Verfeinerungen werden ausgeführt. Sie können fortfahren, sobald der Vorgang abgeschlossen ist.",
      "SIMULATION_DOCUMENTS_PARSE_FAILED_BODY": "Eines Ihrer Dokumente für {{ name }} konnte nicht gelesen werden – bitte überprüfen oder ersetzen Sie es und versuchen Sie es erneut.",
      "REFINEMENT_ERROR_MESSAGE": "Es tut uns leid, diese Anfrage konnte nicht abgeschlossen werden. Versuchen Sie es erneut",
      "REFINEMENT_OUT_OF_SCOPE_TITLE": "Anfrage außerhalb des Gültigkeitsbereichs.",
      "REFINEMENT_OUT_OF_SCOPE_BODY": "Ihre Anfrage für {{ name }} geht über die Möglichkeiten von „Verfeinerungen“ hinaus. Kontaktieren Sie den Support.",
      "TAB_QUESTIONS": "Fragen",
      "KNOWLEDGE_CHECK_NAME_LABEL": "Name*",
      "AVATAR_APPEARANCE_LABEL": "Avatar-Design",
      "KNOWLEDGE_CHECK_AVATAR_NAME_LABEL": "Name des Avatars",
      "KNOWLEDGE_CHECK_SKILLS_FEEDBACK_TITLE": "Feedback zu Fertigkeiten",
      "KNOWLEDGE_CHECK_SCORING_DESCRIPTION": "Die Simulationen im Wissens-Check werden anhand des Prozentsatzes der für jede Frage erreichten Antwortpunkte bewertet. Wählen Sie unten ein Fertigkeiten-Bewertungsschema aus, um zusätzlich qualitatives Feedback zu erhalten.",
      "KNOWLEDGE_CHECK_SCORING_RESCORE_DESCRIPTION": "Nachdem Sie die Simulation mindestens einmal getestet haben, wählen Sie „Meine letzte Sitzung bewerten“, um Ihre Punktzahl anzuzeigen. Wenn Sie Antwortpunkte bearbeiten, können Sie dieselbe Sitzung erneut bewerten lassen. Wenn Sie Fragen bearbeiten, müssen Sie vor der Bewertung eine neue Testsitzung durchführen.",
      "KNOWLEDGE_CHECK_SKILLS_RUBRIC_LABEL": "Fertigkeiten-Bewertungsschema (optional)",
      "SIMULATION_TYPE_MODAL_TITLE": "Neue Simulation erstellen",
      "SIMULATION_TYPE_MODAL_DESCRIPTION": "Wählen Sie aus, wie Ihre Lernenden üben sollen.",
      "SIMULATION_TYPE_ROLE_PLAY_TITLE": "Rollenspiel",
      "SIMULATION_TYPE_ROLE_PLAY_DESCRIPTION": "Die Lernenden führen ein offenes Gespräch mit einer KI-Figur, die ganz natürlich auf alles reagiert, was sie sagen.",
      "SIMULATION_TYPE_ROLE_PLAY_BEST_FOR": "Am besten geeignet für realistische Verkaufsgespräche, z. B. Verkaufspitches und den Umgang mit Einwänden.",
      "SIMULATION_TYPE_KNOWLEDGE_CHECK_TITLE": "Wissens-Check",
      "SIMULATION_TYPE_KNOWLEDGE_CHECK_DESCRIPTION": "Ein KI-Charakter stellt den Lernenden die von Ihnen verfassten Fragen in der von Ihnen festgelegten Reihenfolge.",
      "SIMULATION_TYPE_KNOWLEDGE_CHECK_BEST_FOR": "Am besten geeignet für das Testen von Produktwissen und die Zertifizierung, dass Vertriebsmitarbeiter einsatzbereit sind.",
      "TAGS_FILTER_LABEL": "Tags",
      "TAGS_FILTER_PLACEHOLDER": "Tag auswählen",
      "CLEAR_ALL_FILTERS": "Alle Filter löschen",
      "LAST_SAVED_LABEL": "Zuletzt gespeichert",
      "BUTTON_OK": "OK",
      "KEYWORDS_RESET_TO_PRODUCT_DEFAULT": "Auf Produktstandard zurücksetzen",
      "KEYWORDS_DETACH_FROM_PRODUCT_DEFAULT": "Von Produktstandard trennen",
      "KEYWORDS_SAVE_AS_PRODUCT_DEFAULT": "Als Produktstandard speichern",
      "KEYWORDS_SAVE_AS_DEFAULT_OVERWRITE": "Dadurch wird die Standardeinstellung {{ keywordTitle }} für das Produkt {{ moduleName }} überschrieben.",
      "KEYWORDS_SAVE_AS_DEFAULT_IMPACT": "Diese Begriffe werden zu neuen Simulationen für {{ moduleName }} hinzugefügt. Alle Aufrufe für das Produkt {{ moduleName }} werden angepasst.",
      "KEYWORDS_ADD_NEW_WORD": "Neues Wort hinzufügen",
      "KEYWORDS_FROM_LABEL": "Von",
      "KEYWORDS_TO_LABEL": "Zu",
      "KEYWORDS_PRONOUNCE_TITLE": "Wörter aussprechen",
      "KEYWORDS_PRONOUNCE_DESCRIPTION": "Geben Sie Aussprachekorrekturen für den KI-Agenten an, damit dieser Namen/Begriffe korrekt ausspricht. Der Agent ordnet häufige Fehlaussprachen und Varianten der neuen Aussprache zu.",
      "KEYWORDS_PRONOUNCE_NAME": "Wörter aussprechen",
      "KEYWORDS_ADD_MISPRONUNCIATION": "Falsche Aussprache hinzufügen",
      "KEYWORDS_SELECT_PERSONA_NOTICE": "Bitte wählen Sie eine Persona aus, um „Wörter aussprechen“ hinzuzufügen.",
      "KEYWORDS_REPLACE_TITLE": "Wörter ersetzen",
      "KEYWORDS_REPLACE_DESCRIPTION": "Explizite Suchen-und-Ersetzen-Korrekturen für den Transkripttext des Nutzers; direkte Wortersetzungen, die vor der phonetischen Korrektur erfolgen.",
      "KEYWORDS_REPLACE_NAME": "Wörter ersetzen",
      "KEYWORDS_ADD_REPLACEMENT": "Ersetzung hinzufügen",
      "KEYWORDS_STT_TITLE": "STT-Wörter",
      "KEYWORDS_STT_DESCRIPTION": "Wortliste, die an Speech-to-Text-Anbieter (STT) (z. B. AssemblyAI, Tavus) übermittelt wird, speziell für die Konfiguration des STT-Anbieters.",
      "KEYWORDS_STT_NAME": "STT-Wörter",
      "KEYWORDS_GENERATING": "Wird generiert...",
      "KEYWORDS_GENERATE_STT_PROMPT": "stt_prompt generieren",
      "KEYWORDS_STT_PROMPT_OUTDATED": "Die Wortliste wurde seit der Erstellung dieser Eingabeaufforderung aktualisiert. Erneut generieren, um die neuesten Änderungen zu berücksichtigen.",
      "KEYWORDS_STT_CANNOT_SAVE_HEADING": "Speichern auf Produktebene nicht möglich",
      "KEYWORDS_STT_CANNOT_SAVE_BODY": "Die STT-Wörter und die Eingabeaufforderung können nicht auf Produktebene gespeichert werden. Sie können andere STT-Konfigurationen für die Simulation manuell ändern oder sich an Ihren Administrator wenden, um Hilfe zu erhalten.",
      "KEYWORDS_CLEAN_TRANSCRIPT_TITLE": "Wörter aus dem Transkript entfernen",
      "KEYWORDS_CLEAN_TRANSCRIPT_DESCRIPTION": "Wörter, die in die Eingabeaufforderung „CLEAN_TRANSCRIPT_V2“ eingefügt werden.",
      "KEYWORDS_CLEAN_TRANSCRIPT_NAME": "Wörter für „Clean Transcript“",
      "KEYWORDS_CALL_TITLE": "Schlüsselwörter",
      "KEYWORDS_CALL_DESCRIPTION": "Wörterbuch mit korrekten Wörtern für die phonetische Korrektur, das vom Double-Metaphone-Algorithmus verwendet wird, um phonetisch ähnliche Rechtschreibfehler zu korrigieren. Vermeiden Sie mehrwortige Begriffe wie „Anti MuSK AB+“, da der codebasierte Transkriptkorrektor nur bei einzelnen Wörtern zuverlässig funktioniert. Vermeiden Sie außerdem Symbole – z. B. „lp(a)“ –, da diese den Korrektor verwirren können. Die Liste sollte so klein und einfach wie möglich gehalten werden, da dies von einem deterministischen Algorithmus und nicht von einem LLM verarbeitet wird und dieser kein Kontextverständnis besitzt.",
      "KEYWORDS_CALL_NAME": "Schlüsselwörter"
    },
    "settings": {
      "DEVICE_SETUP_INTRO": "Stellen Sie sicher, dass Ihr Gerät konfiguriert ist.",
      "MICROPHONE_REQUIRED_NOTICE": "Ein funktionierendes Mikrofon ist erforderlich.",
      "DEVICE_ENABLE_INSTRUCTIONS": "Falls nach dem Aktualisieren dieser Seite kein Pop-up zur Gerätefreigabe erschienen ist, öffnen Sie bitte Ihre System- oder Browsereinstellungen und aktivieren Sie die Geräte. Nachstehend finden Sie Support-Seiten mit weiteren Anweisungen.",
      "ENABLE_CAMERA": "So aktivieren Sie Ihre Kamera:",
      "WINDOWS_USERS": "Windows-Benutzer",
      "MAC_USERS": "Mac-Benutzer",
      "IPAD_USERS": "iPad-Benutzer",
      "ENABLE_MICROPHONE": "So aktivieren Sie Ihr Mikrofon:",
      "ENABLE_DEVICES_BY_BROWSER": "Wie Sie Ihre Geräte per Browser aktivieren:",
      "CHROME_USERS": "Chrome-Benutzer",
      "SAFARI_USERS": "Safari-Benutzer",
      "FIREFOX_USERS": "Firefox",
      "EDGE_USERS": "Edge",
      "START_WITHOUT_CAMERA_BUTTON": "Ohne Kamera starten",
      "START_CALL_BUTTON": "Anruf starten",
      "MICROPHONE_REQUIRED_WARNING": "Ein funktionierendes Mikrofon ist erforderlich.",
      "MICROPHONE_ALT": "Mikrofon",
      "MICROPHONE": "Mikrofon",
      "SELECT_MICROPHONE": "Wählen Sie Ihr Mikrofon",
      "ALERT": "Alarm",
      "GIVE_PERMISSION": "Erlaubnis erteilen",
      "SELECT_VIDEO_DEVICE": "Wählen Sie Ihr Videogerät",
      "VIDEO": "Video",
      "DEVICE_BLOCKED_ERROR": "Anscheinend wurde diesem Browser der Zugriff auf eines oder mehrere Ihrer Geräte verweigert. Um die Geräte zu aktivieren, gehen Sie bitte in Ihre System- oder Browsereinstellungen und aktivieren Sie den Zugriff.",
      "DEVICE_SETTINGS": "Geräteeinstellungen",
      "CONFIRM_SETTINGS": "Einstellungen bestätigen",
      "LAPTOP": "Laptop",
      "SAD_EMOTE_FACE": "Trauriges Emoji-Gesicht",
      "GRANT_BROWSER_ACCESS": "Um diese Simulation abzuschließen, benötigt der Browser Zugriff auf die Spracherkennung",
      "USING_IPAD": "Wenn Sie ein iPad verwenden, gehen Sie zu",
      "SETTINGS": "Einstellungen",
      "PRIVACY_AND_SECURITY": "Datenschutz und Sicherheit",
      "SPEECH_RECOGNITION": "Spracherkennung",
      "GRANT_ACCESS_REFRESH": "Gewähren Sie dem Browser Zugriff und aktualisieren Sie die Seite",
      "REFRESH_PAGE": "SEITE AKTUALISIEREN",
      "BROWSER_UNABLE_TO_ACCESS": "Der Browser kann nicht auf dieses Gerät zugreifen",
      "ACCESS_DENIED": "Zugriff verweigert",
      "CAMERA": "Kamera",
      "DIAGNOSTIC_PASSED": "Alle Diagnosetests wurden erfolgreich bestanden.",
      "DIAGNOSTIC_FAILED_MESSAGE": "Einige Diagnosetests sind fehlgeschlagen. Bitte klicken Sie oben auf die Schaltfläche „Diagnoseergebnisse kopieren“ und senden Sie die Ergebnisse an das Support-Team, um Unterstützung zu erhalten.",
      "DIAGNOSTIC_PARTIAL": "Die meisten Diagnosetests wurden erfolgreich bestanden. Ihre Verbindung sieht gut aus.",
      "DIAGNOSTIC_RUNNING_MESSAGE": "Bitte warten Sie, während die Diagnosetests laufen...",
      "DIAGNOSTIC_RUNNING": "Diagnose läuft",
      "COPY_DIAGNOSTIC_RESULTS": "Kopie der Diagnoseergebnisse",
      "RUN_DIAGNOSTIC": "Diagnose durchführen",
      "RERUN_DIAGNOSTIC": "Diagnose erneut ausführen",
      "DIAGNOSTIC_RESULTS_COPIED": "Diagnoseergebnisse in die Zwischenablage kopiert",
      "DIAGNOSTIC_FAILED": "Diagnose fehlgeschlagen",
      "DIAGNOSTIC_WEBSOCKET_NOT_TESTED": "Websocket: not tested",
      "DIAGNOSTIC_TURN_NOT_TESTED": "TURN: not tested",
      "DIAGNOSTIC_QUALITY_NOT_TESTED": "Quality: not tested",
      "DIAGNOSTIC_QUANTIFIED_DIAGNOSTICS": "Quantified Diagnostik",
      "DIAGNOSTIC_TIME": "Zeit",
      "DIAGNOSTIC_SUMMARY": "Zusammenfassung",
      "DIAGNOSTIC_CLIENT_INFO": "Kundeninformationen",
      "DIAGNOSTIC_PLATFORM": "Plattform",
      "DIAGNOSTIC_RTT_AVG_MAX": "RTT avg/max",
      "DIAGNOSTIC_PACKET_LOSS_SEND": "Paketverlust (Senden)",
      "DIAGNOSTIC_AVG_SEND_BITRATE": "Durchschnittliche Sendebitrate",
      "DIAGNOSTIC_NA": "K.A.",
      "DIAGNOSTIC_PROBLEMS_CONNECTING_PREFIX": "Verbindungsprobleme?",
      "DIAGNOSTIC_CLICK_HERE": "klicken Sie hier",
      "DIAGNOSTIC_TO_RUN_SUFFIX": "um eine Diagnose durchzuführen."
    },
    "results": {
      "RETURN_HOME": "ZURÜCK ZUR STARTSEITE",
      "CLOSE_BUTTON": "Schaltfläche „Schließen“",
      "CONVERSATIONAL_CALL": "ROLLENSPIEL",
      "INFORMATION_ICON": "Informationssymbol",
      "TOOLTIP_ARROW": "Tooltip-Pfeil",
      "INFORMATION_TOOLTIP_CONTENT": "Sie steuern den Simulationsverlauf und lenken das Gespräch auf eine Reihe von Zielen. Rollenspiele sind ideal, um Fertigkeiten wie tiefgehendes Fragenstellen, das Aufdecken von Herausforderungen und das Schaffen einer Gesprächsbasis zu trainieren.",
      "CLOCK_ICON": "Uhr-Symbol",
      "CALL_RESULTS": "Ergebnisse",
      "SKILLS": "Fertigkeiten",
      "MESSAGE_ADHERENCE": "Einhaltung der Gesprächsinhalte",
      "TRY_AGAIN_MESSAGE": "Versuchen Sie es erneut und verbessern Sie Ihr Ergebnis.",
      "PRACTICE_BENEFITS": "Wöchentliches Üben stärkt das Selbstvertrauen und verbessert die Ergebnisse in der Praxis.",
      "CALL_SUCCESS": "Gut gemacht! Sie haben diese Simulation erfolgreich abgeschlossen.",
      "MAX_ATTEMPTS_REACHED": "Sie haben die maximale Anzahl von Versuchen erreicht",
      "TRY_AGAIN": "Erneut versuchen",
      "GREAT_JOB_YOU_SUCCESSFULLY": "Gut gemacht! Sie haben",
      "COMPLETED_THIS_CALL": "diese Simulation erfolgreich abgeschlossen.",
      "ACHIEVED_SCORE": "Erreichte Punktzahl ",
      "ACHIEVE_SCORE": "Erreichen Sie eine Punktzahl von",
      "OR_HIGHER": "oder höher.",
      "OBJECTIVES_NOT_MET": "Sie haben nicht alle erforderlichen Ziele erreicht.",
      "TRY_AGAIN_TARGET_SCORE": "Versuchen Sie es erneut, um folgende Punktzahl zu erreichen:",
      "YOUR_SCORE": "Ihr Ergebnis",
      "OUT_OF_5": "AUS 5",
      "CALL_FEEDBACK": "FEEDBACK-ZUSAMMENFASSUNG",
      "STRENGTH_ICON_ALT": "Stärken-Symbol",
      "OPPORTUNITIES_ICON_ALT": "Chancen-Symbol",
      "OBJECTIVES_FEEDBACK": "FEEDBACK ZUR METHODIK",
      "SESSION_ID": "Sitzungs-ID:",
      "SESSION_ID_COPIED": "Sitzungs-ID kopiert!",
      "OBJECTIVE": "METHODIK:",
      "HOW_YOU_DID": "Ihr Ergebnis:",
      "LIGHTBULB_ICON_ALT": "Glühbirnen-Symbol",
      "WHAT_WE_SUGGEST": "Was wir vorschlagen:",
      "NO_SPECIFIC_RECOMMENDATION": "Unser System konnte keine spezifische Empfehlung für Sie finden.",
      "WHY": "Warum?",
      "NO_INSIGHTS_AVAILABLE": "Unser System konnte keine Erkenntnisse zu diesem Vorschlag liefern.",
      "CONFETTI_ICON_ALT": "Konfetti-Symbol",
      "OBJECTIVE_SUCCESS_MESSAGE": "Ausgezeichnete Leistung bei dieser Methodik – bleiben Sie dran!",
      "PROCESSING_CALL": "Wir bereiten Ihre Punktzahl und Ihr Feedback vor.",
      "HANG_TIGHT": "Bitte warten Sie einen Moment oder rufen Sie die Seite später erneut auf, um",
      "VIEW_YOUR_RESULTS": "Ihre Ergebnisse zu sehen.",
      "NEED_MORE_TIME": "Die Berechnung der Ergebnisse dauert noch an.",
      "REFRESH_INSTRUCTION": "Bitte schauen Sie noch einmal nach oder aktualisieren Sie die Aufgabeergebnisse",
      "RESULTS_IN_FEW_MINUTES": "in wenigen Minuten.",
      "SCORE_CALCULATION_QUESTION": "Wie wird dies berechnet?",
      "SINGLE_SCORE_EXPLANATION": "Da diese Simulation nur eine Bewertungskomponente enthält, entspricht die angezeigte Punktzahl sowohl der Abschnittsbewertung als auch Ihrer Gesamtpunktzahl.",
      "OVERALL_SCORE_PERCENT": "der Gesamtpunktzahl",
      "SECTION_SCORE": "Ergebnis für diesen Abschnitt",
      "ELEVATE_MESSAGE_ADHERENCE_TITLE": "Optimieren Sie die Einhaltung Ihrer Gesprächsinhalte",
      "MESSAGE_ADHERENCE_NOTE": "Eine konsistente Gesprächsführung ist entscheidend für den Erfolg, beeinflusst jedoch nicht Ihre Gesamtbewertung.",
      "NO_CREDIT": "Nicht angerechnet",
      "PARTIAL_CREDIT": "Teilweise angerechnet",
      "FULL_CREDIT": "Vollständig angerechnet",
      "WHAT_YOU_DID_WELL": "Was Sie gut gemacht haben",
      "MISSED_ALL_KEY_POINTS": "Sie haben alle wichtigen Punkte übersehen; überprüfen Sie sie und versuchen Sie es erneut.",
      "WHAT_TO_IMPROVE": "Was Sie besser machen können",
      "PERFECT_SCORE_MESSAGE": "Herzlichen Glückwunsch! Sie haben ein perfektes Ergebnis erzielt, da Sie alle wichtigen Punkte richtig angesprochen haben.",
      "POINTS_LABEL": "Punkte",
      "TALKING_POINTS_COVERED": "Abgedeckte Gesprächsthemen",
      "CHECKMARK_ICON_ALT": "Häkchen",
      "TALKING_POINTS_MISSED": "Nicht behandelte Gesprächsthemen",
      "X_ICON_ALT": "x",
      "PRACTICE_AGAIN": "Übung wiederholen",
      "OUT_OF": "von",
      "OBJECTIVES": "Methodik",
      "ELEVATE_OBJECTIVES_TITLE": "Optimieren Sie Ihre Gesprächsmethodik",
      "OBJECTIVES_NOTE": "Eine konsistente Methodik ist entscheidend für den Erfolg, beeinflusst jedoch nicht Ihre Gesamtbewertung.",
      "UNTIL": "bis",
      "TO_IMPROVE_SCORE": ", um Ihr Ergebnis zu verbessern.",
      "YOU_HAVE": "Sie haben",
      "MORE_ATTEMPTS": "weitere Versuche, um",
      "OR_HIGHER_BEFORE": "oder höher zu erzielen, bevor",
      "AND_TRY_AGAIN": "und es erneut zu versuchen.",
      "UNEXPECTED_STATE": "Ein unerwarteter Zustand ist eingetreten.",
      "REVIEW_APP_LOGIC": "Bitte überprüfen Sie die Logik der Anwendung.",
      "ASSIGNMENTS": "Aufgaben",
      "VIEW_CALL_DETAILS": "Anrufdetails anzeigen",
      "PRACTICE_SESSION": "Übungssitzung",
      "OVERALL_SCORE": "Gesamtpunktzahl",
      "OVERALL_SCORE_EXPLANATION": "Die Gesamtpunktzahl wird aus dem gewichteten Durchschnitt der Punktzahlen der einzelnen Abschnitte berechnet. Die Gewichtung der einzelnen Abschnitte wird als Prozentsatz neben der Punktzahl angezeigt.",
      "SCORE_CONFIG_NOTE": "Ihr Unternehmen legt fest, welche Abschnitte einbezogen oder ausgeschlossen werden und wie sie gewichtet sind. Alle Punktzahlen werden auf den nächsten Zehntelpunkt gerundet.",
      "STRENGTHS": "Stärken",
      "OPPORTUNITIES": "Chancen",
      "YOUR_RESPONSE": "Ihre Antwort",
      "MINUS": "minus",
      "PLUS": "plus",
      "RECOMMENDED_RESPONSE": "Empfohlene Antwort",
      "REVIEW_MISSED_TITLE": "Überprüfen Sie, was Sie verpasst haben.",
      "NO_TALKING_POINTS_COVERED": "Sie haben keines der geforderten Gesprächsthemen für dieses Thema behandelt.",
      "LEARN_WHAT_YOU_MISSED": "Erfahren Sie, was Sie verpasst haben",
      "NICE_JOB": "Gute Arbeit!",
      "ALL_POINTS_COVERED": "Sie haben alle für dieses Thema erforderlichen Gesprächsthemen erfolgreich abgedeckt.",
      "COVER_ALL_MESSAGES": "Behandeln Sie alle Schlüsselaussagen.",
      "HIGHLIGHT_KEY_POINTS_NOTE": "Wenn Sie die Schlüsselpunkte im Gespräch betonen, bleibt die Unterhaltung zielgerichtet.",
      "MESSAGES_LABEL": "Nachrichten",
      "NO_FACTS_COVERED": "Hoppla! Sie haben keines der geforderten Gesprächsthemen für diese Nachricht abgedeckt.",
      "NO_SPECIFICS_AVAILABLE": "Hoppla! Es sieht so aus, als könnten wir nicht genau sagen, was gefehlt hat.",
      "ALL_KEY_POINTS_COVERED": "Gut gemacht! Sie haben alle wichtigen Punkte angesprochen.",
      "PROCESSING_SKILLS_FEEDBACK": "Ihr Fertigkeiten-Feedback wird derzeit verarbeitet.",
      "SKILLS_SCORING_NOT_ENABLED": "Wir bedauern, dass Ihr letzter Anruf nicht analysiert werden konnte, da die Funktion zur Bewertung von Fertigkeiten deaktiviert war. Reichen Sie Ihre Gesprächsübung erneut ein, um Feedback zu erhalten – wie beim letzten Mal. Wenn Sie Hilfe benötigen, wenden Sie sich bitte an unser Support-Team. Vielen Dank für Ihr Verständnis und Ihr Engagement für Verbesserungen!",
      "ELEVATE_CONVERSATION_SKILLS": "Optimieren Sie Ihre Konversationsfertigkeiten",
      "SKILLS_NOTE": "Fertigkeiten sind entscheidend für eine erfolgreiche Gesprächsführung, haben aber keinen Einfluss auf die Gesamtpunktzahl.",
      "SKILLS_SUMMARY_TITLE": "ZUSAMMENFASSUNG DER FERTIGKEITEN",
      "LEARN_MORE_ABOUT_SKILLS": "Erfahren Sie mehr über Fertigkeiten",
      "SKILLS_FEEDBACK_LABEL": "FEEDBACK",
      "WHAT_ARE_SKILLS_TITLE": "Was sind Fertigkeiten?",
      "SKILLS_DESCRIPTION": "Die Fertigkeiten werden so kalibriert, dass sie die Entwicklung der Persönlichkeit unterstützen. Diese Fertigkeiten fließen zwar nicht in die Punktzahl Ihres Gesprächs ein, wurden jedoch von Ihrer Organisation ausgewählt, um Ihre Gesprächsführung zu verbessern",
      "PROFICIENCY_SCALE_TITLE": "KOMPETENZSKALA",
      "EXPERT": "Experte",
      "PROFICIENT": "Fortgeschritten",
      "DEVELOPING": "In Entwicklung",
      "CALL_TRANSCRIPT": "Gesprächsprotokoll",
      "COLLAPSE_ALL": "Alle minimieren",
      "EXPAND_ALL": "Alle erweitern",
      "THUMBNAIL": "Vorschaubild",
      "OUT_OF_FIVE_POINTS": "/5 Punkte",
      "TALKING_POINTS": "Gesprächsthemen",
      "TRANSCRIPT_LABEL": "Abschrift",
      "YOU_ARE_OUT_OF_ATTEMPTS": "Du hast keine Versuche mehr.",
      "REVIEW_GUIDELINES_REMAIN_COMPLIANT": "Überprüfen Sie die Richtlinien und halten Sie sich auch in Zukunft daran.",
      "TRY_AGAIN_ATTENTION_TO_COMPLIANCE": "Versuchen Sie es erneut und achten Sie auf die Einhaltung der Richtlinien.",
      "NO_SCORE_OUT_OF_COMPLIANCE": "Wir haben etwas festgestellt, das möglicherweise nicht den Vorschriften entspricht",
      "WHY_OUT_OF_COMPLIANCE": "Gründe für die möglicherweise fehlende Regelkonformität",
      "REVIEW_TRANSCRIPT_MISSED_GUIDELINES": "Überprüfen Sie Ihre Abschrift, um festzustellen, wo Sie die Richtlinien nicht eingehalten haben.",
      "YOU_DID_FOLLOW_GUIDELINES": "Sie haben die Richtlinien erfolgreich umgesetzt.",
      "REVIEW_MISSED_GUIDELINES": "Sehen Sie sich die nicht eingehaltenen Richtlinien an.",
      "OUT_OF_COMPLIANCE": "Nicht konform",
      "SCORE_CALCULATION_TITLE": "Berechnung der Punktzahl",
      "PROCESSING_TRANSCRIPT": "Wir verarbeiten Ihre Abschrift.",
      "WAIT_OR_REVIEW_SCORES": "Bitte warten Sie hier oder sehen Sie sich die anderen Bewertungsabschnitte an,",
      "TRANSCRIPT_LOADING": "während die Abschrift geladen wird.",
      "REVIEW_FEEDBACK_KEEP_PRACTICING": "Überprüfen Sie Ihr Feedback und üben Sie weiter, um",
      "HIGH_PERFORMERS_PRACTICE": "High Performer üben mindestens einmal pro Woche",
      "SUCCESSFULLY_PASSED": "Gut gemacht! Sie haben diese Simulation erfolgreich bestanden.",
      "DIDNT_REACH_PASSING_SCORE": "Sie haben die erforderliche Punktzahl für diese Simulation nicht erreicht.",
      "OUT_OF_ATTEMPTS": "<b>Sie haben keine Versuche mehr.</b> Prüfen Sie Ihr Feedback, um zu erfahren, wie Sie sich verbessern können.",
      "REVIEW_FEEDBACK_THEN_RETURN": "Prüfen Sie Ihr Feedback und navigieren Sie zur Startseite, wenn Sie fertig sind.",
      "GREAT_JOB_PRACTICED": "Großartige Arbeit – Sie haben {{count}} {{times}} geübt. Weiter so!",
      "TIME": "Mal",
      "TIMES": "Mal",
      "COMPLIANCE_GUIDELINES": "Richtlinien zur Einhaltung",
      "TALKING_POINT_TITLE": "GESPRÄCHSTHEMEN, DIE NICHT ODER ZUR FALSCHEN ZEIT EINGEBRACHT WURDEN",
      "NO_TRANSCRIPT": "Keine Abschrift verfügbar.",
      "QUIZ_SUMMARY_BASE": "Nehmen Sie sich einen Moment Zeit, um Ihre Leistung bei diesem Quiz zu überprüfen.",
      "QUIZ_SUMMARY_FAILED": "Nehmen Sie sich einen Moment Zeit, um Ihre Leistung bei diesem Quiz zu überprüfen. Überprüfen Sie die auf dem Übersichtsbildschirm des Lernpfads hervorgehobenen {{stepNames}} {{stepWord}}, um sich besser auf Ihren nächsten Versuch vorzubereiten.",
      "QUIZ_SUMMARY_PASSED_WITH_MISSES": "Nehmen Sie sich einen Moment Zeit, um Ihre Leistung bei diesem Quiz zu überprüfen. Der oder die {{stepWord}} für {{stepNames}} {{stepVerb}} Ihr niedrigstes Ergebnis für {{areaWord}}.",
      "OUT_OF_100": "AUS 100",
      "COVERED": "Abgedeckt",
      "MISSED": "Nicht behandelt",
      "RETURN_TO_ASSIGNMENT": "Zurück zur Aufgabe",
      "RETURN_TO_PATHWAY": "ZURÜCK ZUM LERNPFAD",
      "QUIZ_RESULTS_SUMMARY": "Zusammenfassung der Quiz‑Ergebnisse",
      "PROCESSING_RESULTS": "Ergebnisse werden verarbeitet…",
      "NONE_PERFECT": "Keine – perfekt!",
      "MESSAGING": "Gesprächsinhalt",
      "MISSED_ONE_TALKING_POINT": "Sie haben einen Gesprächspunkt zu diesem Thema verfehlt.",
      "MISSED_X_TALKING_POINTS": "Sie haben {{count}} Gesprächspunkte zu diesem Thema verfehlt.",
      "ROLEPLAY_POST_CALL_TITLE": "Sie sind am Ende dieses Anrufs angelangt.",
      "ROLEPLAY_POST_CALL_SUBTITLE_PROCESSING": "Hinterlassen Sie ein Feedback, während wir Ihre Ergebnisse verarbeiten.",
      "ROLEPLAY_POST_CALL_SUBTITLE_DELAY": "Die Ergebnisse werden gerade geladen. Bitte haben Sie einen Moment Geduld. Beenden Sie den Lernpfad, und wir benachrichtigen Sie, sobald die Ergebnisse bereitstehen.",
      "ROLEPLAY_POST_CALL_SUBTITLE_ERROR": "Es gab einen Fehler bei der Verarbeitung Ihrer Ergebnisse. Bitte wenden Sie sich an den Support unter",
      "ROLEPLAY_POST_CALL_PROCESSING_LABEL": "Ergebnisse werden verarbeitet…",
      "ROLEPLAY_POST_CALL_FEEDBACK_QUESTION": "Hat sich dieses Gespräch realistisch und natürlich angefühlt?",
      "FEEDBACK_THANK_YOU": "Vielen Dank für Ihr Feedback!",
      "FEEDBACK_IMPROVEMENT_NOTE": "Vielen Dank für Ihr Feedback! Wir werden daran arbeiten, diese Erfahrung zu verbessern.",
      "VIEW_RESULTS": "Ergebnisse anzeigen",
      "FEEDBACK_IMPROVEMENT_SUFFIX": "Wir werden daran arbeiten, diese Erfahrung zu verbessern.",
      "QUIZ_RESULTS_LOADING": "Die Ergebnisse werden gerade geladen. Bitte haben Sie einen Moment Geduld. Beenden Sie den Lernpfad, und wir benachrichtigen Sie, sobald die Ergebnisse bereitstehen.",
      "KC_TOAST_TITLE": "Ihre Ergebnisse des Wissens‑Checks wurden verarbeitet",
      "KC_TOAST_CONTENT": "Zum Anzeigen klicken Sie unten, oder kehren Sie zum Detailbildschirm des Lernpfads zurück, um mit dem nächsten Schritt fortzufahren.",
      "DISMISS": "Verwerfen",
      "KC_TOAST_TITLE_PATHWAY": "Ihre {{stepName}}-Wissens-Check-Ergebnisse wurden verarbeitet",
      "MISSED_ONE_REQUIRED_TALKING_POINT": "Sie haben einen erforderlichen Gesprächspunkt zu diesem Thema verfehlt",
      "MISSED_X_REQUIRED_TALKING_POINTS": "Sie haben {{count}} erforderliche Gesprächspunkte zu diesem Thema verfehlt",
      "MISSED_ALL_ONE_REQUIRED_TALKING_POINT_TITLE": "Sie haben einen erforderlichen Gesprächspunkt zu diesem Thema verfehlt.",
      "MISSED_ALL_X_REQUIRED_TALKING_POINTS_TITLE": "Sie haben {{count}} erforderliche Gesprächspunkte zu diesem Thema verfehlt.",
      "REVIEW_MATERIAL_NEXT_TIME": "Gehen Sie die Lernmaterialien noch einmal durch, um sich für das nächste Mal zu verbessern.",
      "POINT_LABEL": "Punkt",
      "GREAT_JOB_PRACTICED_FEMALE": "Großartige Arbeit – Sie haben {{count}} {{times}} geübt. Weiter so!",
      "ACCURACY": "Genauigkeit",
      "ACCURACY_LOADING": "Laden...",
      "ACCURACY_FLAGGED_MESSAGE": "Sie haben einige Aussagen getroffen, die möglicherweise von Ihren Unterlagen abweichen. Weitere Details finden Sie weiter unten.",
      "ACCURACY_ALL_CLEAR": "Wir haben keine Aussagen identifiziert, die im Vergleich zu den Unterlagen ungenau waren.",
      "ACCURACY_ERROR": "Es konnte kein Feedback zu dieser Sitzung abgegeben werden",
      "ACCURACY_YOU_SAID": "SIE HABEN GESAGT",
      "ACCURACY_CLAIM_IDENTIFIED": "DIE VON UNS IDENTIFIZIERTE AUSSAGE",
      "ACCURACY_MATERIALS_STATE": "IN IHREN UNTERLAGEN HEISST ES",
      "ACCURACY_OVERALL_BLOCK_PREFIX": "Sie haben einige Aussagen getroffen, die möglicherweise ungenau sind. Überprüfen Sie die Registerkarte ",
      "ACCURACY_OVERALL_BLOCK_LINK": "„Genauigkeit“",
      "ACCURACY_OVERALL_BLOCK_SUFFIX": " für weitere Details.",
      "PRACTICE_SIMULATION_AGAIN": "Simulation noch einmal üben",
      "CALL_TYPE_CONVERSATIONAL": "Dialoganruf",
      "CALL_TYPE_GUIDED": "Angeleiteter Anruf",
      "CALL_TYPE_VISUAL_AID": "Anruf mit visueller Unterstützung",
      "CALL_TYPE_ROLEPLAY": "Anruf mit Rollenspiel",
      "PERSONALIZED_PRACTICE_BREADCRUMB": "Personalisierte Übung",
      "CONVERSATION_TYPE_LABEL": "Gesprächstyp:",
      "DIFFICULTY_LABEL": "Schwierigkeitsgrad:",
      "MOOD_LABEL": "Stimmung:",
      "DIFFICULTY": "Schwierigkeitsgrad",
      "TEMPERAMENT": "Temperament",
      "OVERALL_SCORE_TAB": "Insgesamt",
      "MESSAGE_ADHERENCE_TAB": "Nachrichten",
      "OBJECTIVES_TAB": "Zielsetzungen"
    },
    "reportingV2": {
      "DASHBOARD": "Dashboard",
      "LOADING_ACCOUNTS": "Konten laden...",
      "SELECT_AN_ACCOUNT": "Konto wählen",
      "SEARCH_TEAMS": "Teams suchen",
      "LOADING_TEAMS": "Teams laden...",
      "ALL_TEAMS": "Alle Teams",
      "ACCOUNT": "Konto",
      "TEAMS": "Teams",
      "TEAM_LABEL": "Team",
      "TOTAL_LABEL": "Insgesamt",
      "PASSING_SCORE": "Punktzahl zum Bestehen",
      "ASSIGNMENT_LABEL": "Aufgaben",
      "USER_LABEL": "Benutzer",
      "PRACTICE_LABEL": "Übung",
      "CERTIFICATION_LABEL": "Zertifizierung",
      "CERTIFICATION_STATUS_LABEL": "Zertifizierungsstatus",
      "CERTIFICATION_STATUS_PREFIX_LABEL": "Zertifizierungsstatus:",
      "CERTIFIED_ON_FIRST_ATTEMPT_LABEL": "Beim ersten Versuch zertifiziert?",
      "DATE_OF_CERTIFICATION_LABEL": "Datum der Zertifizierung",
      "RESULTS_DESCRIPTION": "Hier sind die Ergebnisse Ihres/Ihrer Teams für alle Übungsaufgaben:",
      "ENGAGEMENT_BY_ASSIGNMENT": "Beteiligung nach Aufgabe",
      "ASSIGNMENT_ENGAGEMENT": "Aufgabenbeteiligung",
      "ENGAGED_LABEL": "Beteiligt",
      "ENGAGEMENT_STATUS_LABEL": "Beteiligungsstatus",
      "ENGAGEMENT_STATUS_PREFIX_LABEL": "Beteiligungsstatus:",
      "PROFICIENT_LABEL": "Fortgeschritten",
      "ASSIGNMENT_NAME": "Name der Aufgabe",
      "ACTIVE_USERS": "Aktive Nutzer",
      "ASSIGNMENT_PROGRESS": "Fortschritt je Aufgabe",
      "IN_PROGRESS_LABEL": "Wird ausgeführt",
      "CERTIFIED_LABEL": "Zertifiziert",
      "OUT_OF_ATTEMPTS_LABEL": "Keine Versuche mehr",
      "USERS_ENGAGED_LABEL": "Beteiligte Nutzer",
      "SESSIONS_PER_ACTIVE_USERS_LABEL": "Sitzungen pro aktivem Nutzer",
      "HIGHER_THAN_LABEL": "Höher als",
      "MORE_THAN_LABEL": "Mehr als",
      "TOTAL_SESSIONS_COMPLETED_LABEL": "Abgeschlossene Sitzungen insgesamt",
      "USER_CERTIFIED": "Benutzer für alle Aufgaben zertifiziert",
      "ASSIGNMENT_CERTIFICATION": "Aufgaben mit 100%iger Zertifizierung",
      "TRAINER_TIME_SAVED": "Zeitersparnis für Trainer",
      "HOURS_LABEL": "Stunden",
      "PRACTICE_ASSIGNMENT_LABEL": "Übungsaufgaben",
      "CERTIFICATION_ASSIGNMENT_LABEL": "Zertifizierungsaufgaben",
      "START_DATE_LABEL": "Startdatum",
      "END_DATE_LABEL": "Enddatum",
      "NAME_LABEL": "Name",
      "EMAIL_LABEL": "E-Mail",
      "MEMBER_OF_TEAMS_LABEL": "Teammitglied",
      "ASSIGNMENTS_COUNT_LABEL": "# Anzahl von Aufgaben",
      "TOTAL_SESSIONS_LABEL": "Sitzungen insgesamt",
      "NUMBER_OF_SESSIONS_LABEL": "Anzahl der Sitzungen",
      "TOTAL_USERS_LABEL": "Benutzer insgesamt",
      "AVERAGE_SCORE_LABEL": "Durchschnittliche Punktzahl",
      "INITIAL_SCORE_LABEL": "Anfangspunktzahl",
      "HIGH_SCORE_LABEL": "Höchste Punktzahl",
      "LAST_PRACTICE_DATE_LABEL": "Letzter Übungstermin",
      "PERCENT_IMPROVED_LABEL": "% verbessert",
      "PERCENT_IMPROVED_TOOLTIP_TEXT": "Diese Kennzahl vergleicht die Anfangspunktzahl eines Benutzers mit seiner höchsten Punktzahl, ausgedrückt als Prozentsatz der maximal möglichen Verbesserung.",
      "ASSIGNMENTS_CERTIFIED_LABEL": "Zertifizierte Aufgaben",
      "ASSIGNMENTS_PROFICIENT_LABEL": "Erfolgreich absolvierte Aufgaben",
      "ASSIGNMENTS_CERTIFIED_TOOLTIP_TEXT": "Die Anzahl der Aufgaben, bei denen der Benutzer die Bewertungskriterien für alle Simulationen in der Aufgabe erfüllt oder überschritten hat.",
      "ASSIGNMENTS_PROFICIENT_TOOLTIP_TEXT": "Die Anzahl der Aufgaben, bei denen der Benutzer die Bewertungskriterien bei allen Simulationen in der Aufgabe mindestens einmal erreicht oder überschritten hat.",
      "PROFICIENT_TOOLTIP": "Der Prozentsatz der Benutzer in dieser Aufgabe, die die Bewertungskriterien bei allen Simulationen in dieser Aufgabe mindestens einmal erreicht oder überschritten haben.",
      "IN_PROGRESS_TOOLTIP": "Der Prozentsatz der Benutzer, die mindestens eine Sitzung einer Simulation in dieser Aufgabe abgeschlossen und eine Bewertung erhalten haben.",
      "OUT_OF_ATTEMPTS_TOOLTIP": "Der Prozentsatz der Benutzer, die die ihnen zugeteilten Versuche für eine oder mehrere Simulationen in der Aufgabe überschritten haben.",
      "CERTIFIED_TOOLTIP": "Der Prozentsatz der Benutzer, die die Bewertungskriterien für alle Simulationen in der Aufgabe erfüllt oder übertroffen haben.",
      "SEARCH_FOR_A_USER_LABEL": "Suche nach einem Benutzer",
      "NO_USERS_FOUND_LABEL": "Keine Benutzer gefunden",
      "TRAINER_TIME_SAVED_TOOLTIP": "Die Zeit, die Benutzer in Quantified verbracht haben, um Zertifizierungsversuche abzuschließen.",
      "AVG_SESSIONS_PER_ASSIGNMENT": "Durchschnittliche Anzahl von Sitzungen pro Aufgabe",
      "ASSIGNMENTS_ENGAGED_WITH": "Aufgaben sind in Bearbeitung",
      "AVERAGE_IMPROVEMENT": "Durchschnittliche Verbesserung",
      "STATUS": "Status",
      "TOTAL_NUMBER_OF_SESSIONS": "Gesamtzahl der Sitzungen",
      "DATE_OF_LAST_PRACTICE": "Datum der letzten Übung",
      "CALL_NAME": "Name des Anrufs",
      "SESSION_DATE": "Datum der Sitzung",
      "DURATION_OF_SESSION": "Dauer der Sitzung",
      "DURATION_OF_ATTEMPT": "Dauer des Versuchs",
      "OVERALL_SCORE": "Gesamtpunktzahl",
      "MESSAGING_SCORE": "Punktzahl für die Einhaltung der Gesprächsinhalte",
      "METHODOLOGY_SCORE": "Methodik-Punktzahl",
      "SKILLS_SCORE": "Kompetenzwert",
      "SESSIONS": "Sitzunen",
      "TOTAL": "Insgesamt",
      "ALL_ASSIGNMENTS": "Alle Aufgaben",
      "RECENT_ASSIGNMENTS": "Neueste Aufgaben",
      "USER_NAME": "Benutzername",
      "LEARNER": "Lernende:r",
      "DATE_RANGE": "Datumsbereich",
      "DATE_RANGE_LABEL": "Datumsbereich",
      "SEARCH_USERS": "Benutzer suchen ...",
      "SEARCH_SIMULATIONS": "Simulationen suchen ...",
      "SEARCH_DATES": "Daten suchen ...",
      "CERTIFIED_ON_FIRST_TRY": "Im ersten Anlauf zertifiziert",
      "DATE_OF_CERTIFICATION": "Datum der Zertifizierung",
      "AVERAGE_CERTIFICATION_SCORE": "Durchschnittliche Zertifizierungspunktzahl",
      "TOTAL_TIME_CERTIFYING": "Gesamtdauer der Zertifizierung",
      "OF_THE_TIME": "der Zeit",
      "AVERAGE_SESSIONS_ACTIVE_USER": "Durchschnittliche Sitzungen aktiver Benutzer",
      "HOURS_IN_SIMULATIONS": "Stunden in Simulationen",
      "AVERAGE_SESSIONS_TO_PROFICIENCY": "Durchschnittliche Anzahl an Sitzungen bis zur Zielerreichung",
      "PERCENT_PROFICIENT": "Prozentsatz der Kompetenz",
      "SYSTEM_RUNNING_NORMALLY": "Das System läuft derzeit normal",
      "PRACTICE_SIMULATIONS_LABEL": "Simulationen",
      "SIMULATION_NAME": "Name der Simulation",
      "AVERAGE_DURATION_OF_SESSION": "Durchschnittliche Dauer der Sitzung",
      "AVERAGE_SESSIONS_PER_ACTIVE_USER": "Durchschnittliche Anzahl von Sitzungen pro aktivem Nutzer",
      "NO_USERS_MATCHING_FILTERS_LABEL": "Keine Ergebnisse entsprechen Ihren Filtern. Versuchen Sie, einen oder mehrere Filter zu deaktivieren, um die Suche zu erweitern.",
      "USERS_PASSED": "Benutzer, die die Simulation bestanden haben",
      "AVERAGE_TIME": "Durchschnittliche Zeit bis zur Zertifizierung",
      "USERS_OUT_OF_ATTEMPTS": "Keine Versuche mehr verfügbar",
      "NO_CERTIFICATION_SIMULATION": "Keine Zertifizierungssimulationen gefunden",
      "AVERAGE_OVERALL_SCORE": "Durchschnittliche Gesamtpunktzahl",
      "SIMULATION": "Simulation",
      "No_SIMULATION": "Keine Sitzungen",
      "PERCENT_CERTIFIED": "Prozent zertifiziert",
      "PERCENT_CERTIFIED_FIRST_ATTEMPT": "Prozent zertifiziert beim 1. Versuch",
      "USERS": "Benutzer",
      "ATTEMPTS_LABEL": "Versuche",
      "NO_ATTEMPTS": "Keine Versuche",
      "DATE_OF_SESSION": "Datum der Sitzung",
      "NO_ASSIGNMENTS_MATCH_FILTERS": "Keine Aufgaben entsprechen den gewählten Filtern",
      "NO_TEAMS_DATA": "In diesem Konto sind keine Teams vorhanden",
      "ASSIGNED_LABEL": "Nicht gestartet",
      "USERS_ASSIGNED_LABEL": "Zugewiesene Benutzer insgesamt",
      "SESSION_ID": "Sitzungs-ID",
      "NO_SIMULATIONS_FOUND_LABEL": "Keine Simulationen gefunden",
      "USER_NAME_LABEL": "Benutzername",
      "MIN": "min",
      "SEC": "sec",
      "OF_LABEL": "von",
      "SECOND": "Sekunde",
      "SECONDS": "Sekunden",
      "MINUTE": "Minute",
      "MINUTES": "Minuten",
      "ASSIGNED": "Zugewiesen",
      "SELECT_ASSIGNMENTS": "Aufgaben wählen",
      "TOTAL_ASSIGNMENTS": "Aufgaben insgesamt",
      "ASSIGNMENTS_CERTIFIED": "Zertifizierte Aufgaben",
      "TOTAL_SESSIONS": "Sitzungen insgesamt",
      "HOURS_SPENT_PRACTICING": "Anzahl der Übungsstunden",
      "LAST_LOGIN": "Letzte Anmeldung",
      "ENGAGED_TOOLTIP": "Der Prozentsatz der Benutzer, die eine oder mehrere Sitzungen einer Simulation in dieser Aufgabe abgeschlossen haben, aber noch nicht in allen Simulationen die erforderliche Kompetenz erreicht haben.",
      "SEARCH_ASSIGNMENTS": "Aufgaben suchen...",
      "ASSIGNMENT_NAME_LABEL": "Name der Aufgabe",
      "SIMULATION_NAME_LABEL": "Name der Simulation",
      "START_DATE": "Startdatum",
      "END_DATE": "Enddatum",
      "NO_ASSIGNMENTS": "Keine Aufgabe für diesen Benutzer gefunden.",
      "TOTAL_PRACTICE_ASSIGNMENTS": "Gesamtzahl der Übungsaufgaben",
      "SESSION_SCORES_OVER_TIME": "Sitzungsergebnisse im Zeitverlauf",
      "TIME": "Zeit",
      "SCORE": "Punktzahl",
      "NO_SESSIONS_AVAILABLE": "Keine Sitzungen für die grafische Darstellung verfügbar.",
      "MESSAGING_SCORE_LABEL": "Punktzahl für Gesprächsinhalte",
      "PERSONALIZED_PRACTICE_LABEL": "Personalisierte Übung",
      "ASSIGNMENT_ENAGEMENT": "Beteiligung je Aufgabe",
      "NO_PRODUCTS": "Keine personalisierten Übungsprodukte für die ausgewählten Teams",
      "TOTAL_TIME_SPENT_PRACTICING": "Gesamte Übungszeit",
      "AVERAGE_SESSIONS_PER_USER": "Durchschnittliche Sitzungen pro Benutzer",
      "MOST_COMMON_CONVERSATION_TYPE_SELECTION": "Häufigste Auswahl des Gesprächstyps",
      "LEAST_COMMON_CONVERSATION_TYPE_SELECTION": "Seltenste Auswahl des Gesprächstyps",
      "CLEAR_TEAMS": "Teams löschen",
      "METHODOLOGY_SCORE_DESCRIPTION": "Misst, wie gut Lernende der empfohlenen Gesprächsstruktur folgen. Die angegebenen Werte stellen den Durchschnitt aller Sitzungen dieser Simulation dar.",
      "METHODOLOGY": "Methodik",
      "MESSAGING": "Gesprächsinhalt",
      "MESSAGING_V2_DASHBOARD_DESCRIPTION": "Misst, ob die Lernenden während des Gesprächs wichtige Ideen artikulieren. Die Diagramme zeigen den durchschnittlichen Prozentsatz der korrekt formulierten Botschaften pro Thema über alle Sitzungen hinweg.",
      "NO_METRICS_MESSAGE": "Weitere Sitzungen sind erforderlich, um Erkenntnisse zu gewinnen.",
      "SELECT_ALL": "Alle auswählen",
      "DESELECT_ALL": "Alle abwählen",
      "SKILLS": "Fertigkeiten",
      "SKILLS_SCORE_STATS_DESCRIPTION": "Misst, wie gut die Lernenden während des Gesprächs wichtige Fähigkeiten demonstrieren. Die Ergebnisse spiegeln eine KI-Bewertung wider, die über alle Sitzungen gemittelt wurde.",
      "EXPERT": "Experte",
      "PROFICIENT": "Fortgeschritten",
      "DEVELOPING": "In Entwicklung",
      "FULLY_ARTICULATED": "Vollständig artikuliert",
      "PARTIALLY_ARTICULATED": "Teilweise artikuliert",
      "NOT_MENTIONED": "Nicht erwähnt",
      "MESSAGING_SCORE_STATS_DESCRIPTION": "Misst, ob die Lernenden während des Gesprächs wichtige Ideen artikulieren. Die Diagramme zeigen, wie oft die einzelnen Botschaften über alle Sitzungen hinweg korrekt formuliert wurden.",
      "CLEAR": "Löschen",
      "CLEAR_STATUS": "Status löschen",
      "CLEAR_USERS": "Benutzer löschen",
      "CLEAR_SIMULATIONS": "Simulationen löschen",
      "CLEAR_ASSIGNMENTS": "Aufgaben löschen",
      "MODAL_SUBHEADING": "Alle {{ count }} Ziele – Durchschnittswerte über alle Sitzungen hinweg",
      "VIEW_ALL_OBJECTIVES": "Alle {{ count }} Ziele anzeigen →",
      "LEAST_MISSED_QUESTION": "AM WENIGSTEN VERFEHLTE FRAGE",
      "MOST_MISSED_QUESTION": "AM HÄUFIGSTEN VERFEHLTE FRAGE",
      "HIGHEST_SCORING_METHODOLOGY_SECTION": "ABSCHNITT MIT DER HÖCHSTEN BEWERTUNG DER METHODIK",
      "LOWEST_SCORING_METHODOLOGY_SECTION": "ABSCHNITT MIT DER NIEDRIGSTEN BEWERTUNG DER METHODIK",
      "LEAST_ARTICULATED_MESSAGE": "AM WENIGSTEN ARTIKULIERTE BOTSCHAFT",
      "ENGAGEMENT": "ENGAGEMENT",
      "USER_ENGAGEMENT_MORE_SESSIONS": "mehr abgeschlossene Sitzungen als der Teamdurchschnitt",
      "QUESTION_CORRECT_PERCENTAGE_DESC": "der Zeit wurde dies richtig beantwortet",
      "QUESTION_CORRECT_PERCENTAGE_DESC_ASSIGNMENT": "der Zeit haben Benutzer das richtig beantwortet",
      "METHODOLOGY_AVERAGE_POINTS_DESC": "Durchschnittliche Punktzahl für dieses Ziel über alle Sitzungen hinweg",
      "MOST_ARTICULATED_MESSAGE": "AM MEISTEN ARTIKULIERTE BOTSCHAFT",
      "LEAST_MISSED_ANSWER_POINT": "AM WENIGSTEN VERFEHLTER ANTWORTPUNKT",
      "MOST_MISSED_ANSWER_POINT": "AM MEISTEN VERFEHLTER ANTWORTPUNKT",
      "MOST_ARTICULATED_MESSAGE_DESCRIPTION": "der Zeit wurde die Botschaft vollständig artikuliert",
      "LEAST_ARTICULATED_MESSAGE_DESCRIPTION": "der Zeit wurde die Botschaft artikuliert",
      "ASSIGNMENT_STATUS": "Aufgabenstatus",
      "STATUS_ACTIVE": "Aktiv",
      "STATUS_ENDED": "Beendet",
      "STATUS_CLOSED": "Geschlossen",
      "STATUS_ARCHIVED": "Archiviert",
      "USER_ENGAGEMENT_FEWER_SESSIONS": "weniger abgeschlossene Sitzungen als der Teamdurchschnitt",
      "MOST_ARTICULATED_MESSAGE_DESCRIPTION_ASSIGNMENT": "der Zeit haben Benutzer die Botschaft artikuliert",
      "LEAST_ARTICULATED_MESSAGE_DESCRIPTION_ASSIGNMENT": "der Zeit haben Benutzer die Botschaft artikuliert",
      "OTHERS_SINGULAR": "und 1 weitere",
      "OTHERS_PLURAL": "und {{count}} weitere",
      "PAGINATION_PREVIOUS": "Vorherige",
      "PAGINATION_NEXT": "Nächste",
      "HOUR_LABEL": "Stunde",
      "SESSIONS_LABEL": "Sitzungen"
    },
    "personalizedPractice": {
      "TITLE": "Personalisierte Übung",
      "DESCRIPTION": "Hi {{userFirstName}}! Personalisierte Übungen ermöglichen es Ihnen, eigene Szenarien festzulegen, sodass diese möglichst realistisch sind.",
      "LOADING": "Laden...",
      "VIEW_SESSIONS": "Sitzungen anzeigen",
      "VIEW_SIMULATION": "Simulation anzeigen",
      "TOTAL_SESSION": "Sitzung insgesamt",
      "TOTAL_SESSIONS": "Sitzungen insgesamt",
      "BREADCRUMB": "Personalisierte Übung",
      "SCENARIO_DETAILS_TITLE": "Szenariodetails",
      "SCENARIO_DETAILS_DESCRIPTION": "Bitte wählen Sie aus den folgenden Optionen die Variablen aus, mit denen Sie die Simulation individuell auf Ihre Anforderungen abstimmen können.",
      "AVATAR": "Avatar",
      "SELECT_PLACEHOLDER": "Auswählen",
      "CONVERSATION_TYPE": "Gesprächstyp",
      "SELECT_CONVERSATION_TYPE": "Gesprächstyp auswählen",
      "LAUNCH_SIMULATION": "Simulation mit den ausgewählten Einstellungen starten",
      "PREVIOUS_SESSIONS": "Vorherige Sitzungen",
      "TOTAL": "Insgesamt",
      "FILTERS": "Filter:",
      "DATE": "Datum",
      "DIFFICULTY": "Schwierigkeitsgrad",
      "TEMPERAMENT": "Temperament",
      "SESSION_DATE": "Datum der Sitzung",
      "SESSION_SCORE": "Punktzahl der Sitzung",
      "DURATION": "Dauer",
      "OVERALL_SCORE": "Gesamtpunktzahl",
      "MESSAGING": "Gesprächsinhalt",
      "METHODOLOGY": "Methodik",
      "SKILLS": "Fertigkeiten",
      "RESULTS": "Ergebnisse",
      "VIEW_FEEDBACK": "Feedback anzeigen",
      "OVERALL_SCORE_LABEL": "Gesamtpunktzahl",
      "SCORE": "Punktzahl",
      "NO_PRODUCTS_TITLE": "Keine Produkte verfügbar",
      "NO_PRODUCTS_DESCRIPTION": "Sie haben noch keine personalisierten Übungsprodukte.",
      "NO_SESSIONS_FOUND": "Keine Sitzungen mit den ausgewählten Filtern gefunden",
      "TIME": "Zeit",
      "ALL": "Alle",
      "LEARNER": "Lernende:r",
      "MOOD": "Stimmung",
      "CLEAR_FILTERS": "Filter zurücksetzen",
      "PAGINATION_PREVIOUS": "Vorherige",
      "PAGINATION_NEXT": "Nächste",
      "DURATION_MINUTES_SECONDS": "{{minutes}} min {{seconds}} s",
      "DURATION_SECONDS": "{{seconds}} s"
    },
    "login": {
      "TITLE": "Willkommen zurück",
      "SUB_TITLE": "Wie möchten Sie sich anmelden?  ",
      "LOGIN_WITH_SSO": "Anmeldung mit Unternehmens-SSO",
      "LOGIN_WITH_PASSWORD": "Mit Passwort anmelden",
      "PROVIDE_EMAIL": "Geben Sie Ihre E-Mail-Adresse an",
      "HELP_TEXT": "Benötigen Sie Hilfe? Kontakt",
      "EMAIL_ERROR": "Wir können Sie nicht anmelden. Bitte wenden Sie sich an die Verwaltung oder IT-Abteilung Ihres Unternehmens.",
      "EMAIL": "E-Mail",
      "LOGIN": "Anmelden",
      "ALERT": "Alarm",
      "EMAIL_PLACEHOLDER": "olivia@untitledui.com",
      "LOGIN_CONSENT_MESSAGE": "Wenn Sie sich in Ihr Konto einloggen, stimmen Sie den {{termsLink}} und {{privacyLink}} zu.",
      "TERMS_OF_SERVICE": "Nutzungsbedingungen",
      "PRIVACY_POLICY": "Datenschutzbestimmungen",
      "WRONG_REGION_MESSAGE": "Wir können Sie nicht anmelden. Bitte wenden Sie sich an den Administrator Ihres Unternehmens.",
      "WRONG_REGION_LINK": "Sie können auch versuchen, sich auf der {{regionName}}-Website anzumelden."
    },
    "learningPathway": {
      "BEGIN": "Start",
      "DUE_DATE": "Fälligkeitsdatum",
      "FOOTER_SUBTITLE_READY": "Stellen Sie mir jede Frage. Ich helfe Ihnen gerne.",
      "LEAVE_STEP": "Schritt überspringen",
      "NEXT_STEP": "Nächster Schritt",
      "NOTIFICATIONS_ARIA": "Benachrichtigungen",
      "PDF_NEXT_PAGE": "Nächste Seite",
      "PDF_NO_SOURCE": "Keine PDF-Quelle angegeben.",
      "PDF_PREVIOUS_PAGE": "Vorherige Seite",
      "POST_CALL_SUBTITLE": "Hinterlassen Sie ein Feedback, während wir Ihre Ergebnisse verarbeiten",
      "POST_CALL_TITLE": "Sie haben das Ende dieses Quiz erreicht.",
      "SETTINGS": "Einstellungen",
      "TOAST_CONTENT": "Zum Anzeigen klicken Sie unten, oder kehren Sie zum Detailbildschirm des Lernpfads zurück, um mit dem nächsten Schritt fortzufahren.",
      "TOAST_TITLE": "Ihre {{stepName}}-Rollenspielergebnisse wurden verarbeitet",
      "ASSIGNMENTS": "Aufgaben",
      "USER_FALLBACK": "Benutzer",
      "VIEW_RESULTS": "Ergebnisse anzeigen",
      "QUIZ_TITLE": "Quiz",
      "SUBMIT_ANSWER": "Antwort abschicken",
      "CONTINUE": "Fortsetzen",
      "REVIEW_MATERIAL": "Material überprüfen",
      "ASK_QUESTIONS_ABOUT_PATHWAY": "Fragen zum Lernpfad stellen",
      "FOOTER_SUBTITLE_MUTED": "Sie sind derzeit stummgeschaltet. Der Trainer kann Sie nicht hören.",
      "FOOTER_SUBTITLE_LISTENING": "Ich höre mir Ihre Frage an...",
      "FOOTER_SUBTITLE_THINKING": "Ich denke über eine Antwort nach...",
      "PDF_LOADING": "PDF wird geladen",
      "PDF_SCROLL_HINT": "Scrollen Sie, um weiterzulesen",
      "QUIZ_OVERALL_SCORE_TOOLTIP": "Die Gesamtpunktzahl ist der gewichtete Durchschnitt Ihrer Antworten für diesen Versuch.",
      "QUIZ_COLUMN_DATE": "Datum",
      "QUIZ_COLUMN_OVERALL_SCORE": "Gesamtpunktzahl",
      "QUIZ_COLUMN_ANSWER_POINTS": "Antwortpunkte",
      "QUIZ_COLUMN_RESULTS": "Ergebnisse",
      "COMPLETE_STEP": "Vollständig",
      "ERROR_TITLE": "Etwas ist schief gelaufen",
      "ERROR_MESSAGE": "Bitte verlassen Sie den Lernpfad und starten Sie ihn erneut. Wenn das Problem weiterhin besteht, wenden Sie sich an",
      "ERROR_HELP_EMAIL": "help@quantified.ai",
      "PATHWAY_COMPLETED_TITLE": "Sie haben diesen Lernpfad abgeschlossen",
      "PATHWAY_COMPLETED_BODY": "Sie können Ihre Ergebnisse jederzeit überprüfen oder jeden Schritt wiederholen, um weiter zu üben.",
      "PATHWAY_COMPLETED_RETURN": "Zurück zu den Aufgaben",
      "PATHWAY_OUT_OF_ATTEMPTS_TITLE": "Keine weiteren Versuche für diesen Abschnitt des Lernpfads verfügbar",
      "PATHWAY_OUT_OF_ATTEMPTS_BODY": "Kontaktieren Sie Ihren Vorgesetzten, um die nächsten Schritte zu besprechen.",
      "COMPLETED": "Abgeschlossen",
      "EXITING_QUIZ_EARLY": "Wenn Sie dieses Quiz jetzt beenden, wird dies als Versuch gewertet",
      "TRY_AGAIN": "Erneut versuchen",
      "RETURN_TO_PATHWAY": "Zurück zur Startseite",
      "REVIEW_BEFORE_QUIZ_TOOLTIP": "Überprüfen Sie diesen Schritt, bevor Sie das Quiz erneut versuchen",
      "FOOTER_SUBTITLE_QUIZ_RESULT_DONE": "Klicken Sie auf die Schaltfläche rechts →",
      "VIEW_CALL_DETAILS": "Anrufdetails anzeigen",
      "FOOTER_SUBTITLE_READY_LEARN_WITH_X": "Der Trainer hört zu, wenn Sie eine Frage haben",
      "COLUMN_DATE": "Datum",
      "COLUMN_OVERALL_SCORE": "Gesamtpunktzahl",
      "COLUMN_RESULTS": "Ergebnisse",
      "COLUMN_ANSWER_POINTS": "Antwortpunkte",
      "COLUMN_MESSAGING_SCORE": "Punktzahl für Gesprächsinhalte",
      "COLUMN_METHODOLOGY_SCORE": "Methodik-Punktzahl",
      "COLUMN_SKILLS_SCORE": "Kompetenzwert",
      "PRACTICE_AGAIN": "Übung wiederholen",
      "DEBRIEF_LATEST_SESSION": "Nachbesprechung der letzten Sitzung",
      "EXIT_MODAL_TITLE": "Sind Sie sicher, dass Sie dieses Rollenspiel beenden möchten?",
      "EXIT_MODAL_EXIT": "Ausgang",
      "EXIT_MODAL_RESUME": "Fortsetzen",
      "EXIT_MODAL_DESC_LIMITED_ATTEMPTS": "Wenn Sie das Rollenspiel jetzt beenden, wird es nicht bewertet, zählt jedoch trotzdem als Versuch.",
      "EXIT_MODAL_DESC_UNLIMITED_ATTEMPTS": "Wenn Sie das Rollenspiel jetzt beenden, wird es nicht bewertet.",
      "EXIT_MODAL_DESC_SCORED": "Wenn Sie das Rollenspiel jetzt beenden, wird Ihr Gespräch so bewertet, wie es ist.",
      "RESULTS_PROCESSING": "Ergebnisauswertung",
      "RESULTS_FAILED": "Die Ergebnisse konnten nicht geladen werden. Schreiben Sie an help@quantified.ai",
      "DEBRIEF_TITLE": "Nachbesprechung",
      "DEBRIEF_DESCRIPTION": "Besprechen Sie die Ergebnisse Ihres letzten Zertifizierungsversuchs",
      "DEBRIEF_DESCRIPTION_PRACTICE": "Besprechen Sie die Ergebnisse Ihres letzten Übungssitzung",
      "VIEW_ALL_SESSIONS": "Alle Sitzungen anzeigen",
      "COLLAPSE_SESSIONS": "Sitzungen ausblenden",
      "VIEW_ALL_ATTEMPTS": "Alle Versuche anzeigen",
      "COLLAPSE_ATTEMPTS": "Versuche ausblenden",
      "REATTEMPT_CERTIFICATION": "Zertifizierung wiederholen",
      "DEBRIEF_EXIT_MODAL_TITLE": "Möchten Sie diese Nachbesprechung wirklich beenden?",
      "DEBRIEF_EXIT_MODAL_DESC": "Wenn Sie die Nachbesprechung jetzt beenden, wird sie nicht als abgeschlossen markiert.",
      "EXIT_PATHWAY": "Lernpfad beenden",
      "HELP": "Hilfe",
      "LEARN_STEP_HELP_CLOSE": "Schließen",
      "LEARN_STEP_HELP_TROUBLE": "Sollten Sie weiterhin Probleme haben, wenden Sie sich bitte an",
      "LEARN_STEP_HELP_EMAIL": "help@quantified.ai",
      "LEARN_STEP_HELP_VIDEO_P1": "Sehen Sie sich das Material an und stellen Sie dem Trainer alle Fragen, die Sie haben.",
      "LEARN_STEP_HELP_VIDEO_P2": "Klicken Sie auf die Wiedergabetaste, um das Video abzuspielen. Sie können zurückspringen, um das Material erneut zu überprüfen.",
      "LEARN_STEP_HELP_VIDEO_P3": "Schalten Sie unten rechts Ihr Mikrofon ein, um eine Frage zu stellen. Dadurch wird das Video angehalten. Wenn Sie das Video abspielen, schalten wir Ihr Mikrofon stumm.",
      "LEARN_STEP_HELP_VIDEO_P4": "Wenn Sie das gesamte Video angesehen haben, fahren Sie mit dem nächsten Schritt fort.",
      "LEARN_STEP_HELP_PDF_P1": "Lesen Sie das Material und stellen Sie dem Trainer alle Fragen, die Sie haben.",
      "LEARN_STEP_HELP_PDF_P2": "Navigieren Sie durch den Inhalt, indem Sie scrollen oder die Pfeiltasten auf beiden Seiten verwenden, um zwischen den Seiten zu wechseln.",
      "LEARN_STEP_HELP_PDF_P3": "Sie können unten rechts Ihr Mikrofon stummschalten und wieder einschalten.",
      "LEARN_STEP_HELP_PDF_P4": "Wenn Sie alles gelesen haben, fahren Sie mit dem nächsten Schritt fort.",
      "PDF_FULLSCREEN_ENTER": "Vollbild aufrufen",
      "PDF_FULLSCREEN_EXIT": "Vollbild beenden",
      "PDF_ZOOM_IN": "Hineinzoomen",
      "PDF_ZOOM_OUT": "Herauszoomen",
      "ASSESSMENT_EXIT_MODAL_TITLE": "Sind Sie sicher, dass Sie fortfahren möchten?",
      "ASSESSMENT_EXIT_MODAL_DESC": "Wenn Sie fortfahren, bevor dieses Gespräch abgeschlossen ist, führt das zu einer längeren und weniger personalisierten Lernerfahrung.",
      "ASSESSMENT_EXIT_MODAL_RESUME": "Bewertung fortsetzen",
      "ASSESSMENT_EXIT_MODAL_PROCEED": "Fortfahren",
      "ASSESSMENT_PERSONALIZATION_ERROR_TITLE": "Wir konnten Ihren Lernpfad nicht personalisieren",
      "ASSESSMENT_PERSONALIZATION_ERROR_DESC_START": "Wir haben Ihnen den gesamten Lernpfad zugewiesen — wenden Sie sich an ",
      "ASSESSMENT_PERSONALIZATION_ERROR_DESC_END": " wenn Sie die Personalisierung erneut versuchen möchten",
      "OPTIONAL": "Optional",
      "DISMISS": "Verwerfen",
      "DOWNLOAD": "Download"
    },
    "leaderboard": {
      "LEADERBOARD": "Bestenliste",
      "TOP10PERCENT": "Top 10 %",
      "PRACTICE_ASSIGNMENT": "Übungsaufgaben",
      "SIMULATION": "Simulation",
      "SELECT_ASSIGNMENT": "Aufgabe wählen",
      "SELECT_SIMULATION": "Simulation wählen",
      "SELECT_ASSIGNMENT_AND_SIMULATION": "Wählen Sie eine Aufgabe und eine Simulation aus, um die Bestenliste anzuzeigen",
      "NO_DATA": "Noch keine Aktivität. Sobald das Team anfängt, sich zu beteiligen, werden hier die Ranglisten angezeigt.",
      "NO_ASSIGNMENTS_AVAILABLE": "Keine Aufgaben verfügbar",
      "NO_SIMULATIONS_AVAILABLE": "Keine Simulationen verfügbar",
      "NAME": "Name",
      "HIGH_SCORE": "Höchste Punktzahl",
      "AVERAGE_SCORE": "Durchschnittliche Punktzahl",
      "TOTAL_SESSIONS": "Sitzungen insgesamt",
      "LAST_SESSION": "Letzte Sitzung",
      "TOP5": "Top 5",
      "OF": "von",
      "ENGAGED_USERS": "beteiligte Nutzer",
      "ENGAGED_USER": "beteiligter Nutzer",
      "NO_USERS_ENGAGED": "Keine Benutzer beteiligt",
      "HIDE_SESSIONS_WITH_LOW_SCORE": "Sitzungen mit niedrigen Kompetenzwerten ausblenden",
      "SESSIONS_WITH_LOW_SCORE_TOOLTIP": "Sitzungen mit einer Kompetenzbewertung von „in der Entwicklung“ werden bei der Berechnung der hohen und durchschnittlichen Punktzahlen nicht berücksichtigt.",
      "PAGINATION_PREVIOUS": "Vorherige",
      "PAGINATION_NEXT": "Nächste"
    },
    "hotjarSurveys": {
      "FEEDBACK_MESSAGE": "Bitte teilen Sie uns Ihr Feedback mit, damit wir uns verbessern können.",
      "THANK_YOU_MESSAGE": "Vielen Dank, wir werden weiterhin daran arbeiten, Ihr Erlebnis zu verbessern."
    },
    "general": {
      "NEED_HELP_QUESTION": "Benötigen Sie Hilfe?",
      "CONTACT": "Kontakt",
      "HELP_EMAIL": "help@quantified.ai",
      "PARENT_ACCOUNT": "Übergeordnetes Konto",
      "ACCOUNT": "Konto",
      "CHECKMARK": "Häkchen",
      "ICON": "Symbol",
      "ALERT": "Alarm",
      "HEADS_UP": "Aufgepasst!",
      "USE_HEADPHONES_FOR_OPTIMAL_AUDIO": "Für bestmöglichen Klang auf dem iPad empfehlen wir die Verwendung von Kopfhörern.",
      "SETTINGS": "EINSTELLUNGEN",
      "RP": "RP",
      "EMAIL_LABEL": "E-Mail",
      "RAVEN_EMAIL": "Raven@InspireHR.com",
      "TEAM_MANAGER_FOR": "Teamleiter für",
      "MIAMI_SALE": "Vertrieb Miami",
      "CHARLOTTE_SALES": "Vertrieb Charlotte",
      "ATLANTA_SALES": "Vertrieb Atlanta",
      "TEAM": "Team",
      "ASSIGNMENTS": "Aufgaben",
      "MY_TEAMS": "Meine Teams",
      "REPORTING": "Berichterstattung",
      "DASHBOARD": "Dashboard",
      "LEADERBOARD": "Bestenliste",
      "PERSONALIZED_PRACTICE": "Personalisierte Übung",
      "HELP_SEARCH_OUR": "Durchsuchen Sie unsere",
      "HELP_OR_REACH_OUT_TO": "oder wenden Sie sich an",
      "HELP_WITH_QUESTIONS": "bei Fragen",
      "KNOWLEDGE_BASE": "Wissensdatenbank",
      "NO_ROLE_WEB_MESSAGE": "Für diesen Benutzer wurde noch kein Zugriff auf das System eingerichtet. Bitte wenden Sie sich an einen Systemadministrator.",
      "NO_ROLE_IOS_TITLE": "Unsere App ist auf das Lernerlebnis ausgerichtet",
      "NO_ROLE_IOS_BODY_START": "Öffnen Sie unsere",
      "NO_ROLE_IOS_WEB_APP": "Web-App",
      "NO_ROLE_IOS_BODY_END": "in Ihrem mobilen Browser, um auf zusätzliche Funktionen zuzugreifen.",
      "HELP_SECTION": "HILFE",
      "ABOUT_SECTION": "ÜBER",
      "CONTACT_SUPPORT": "Support kontaktieren",
      "OPEN_WEB_APP": "Web-App öffnen",
      "SEARCH_KNOWLEDGE_BASE": "Wissensdatenbank durchsuchen",
      "PRIVACY_POLICY": "Datenschutzerklärung",
      "TERMS_OF_SERVICE": "Nutzungsbedingungen",
      "VERSION": "Version",
      "LOG_OUT": "Abmelden"
    },
    "dashboard": {
      "ALL": "Alle",
      "IN_COMPLETE": "Unvollständig",
      "COMPLETED": "Abgeschlossen",
      "NO_ASSIGNMENT_TITLE": "Sie haben keine Aufgaben.",
      "NO_ASSIGNMENT_DETAILS": "Sie werden benachrichtigt, wenn Sie Aufgaben zu erledigen haben.",
      "IN_COMPLETE_ASSIGNMENT_TITLE": "Sie haben keine unvollständigen Aufgaben.",
      "IN_COMPLETE_ASSIGNMENT_DETAILS": "Sie werden benachrichtigt, wenn eine neue Aufgabe fällig ist.",
      "COMPLETED_ASSIGNMENT_TITLE": "Sie haben keine abgeschlossenen Aufgaben.",
      "COMPLETED_ASSIGNMENT_DETAILS": "Kommen Sie zurück, wenn Sie eine Aufgabe abgeschlossen haben.",
      "VIEW_ASSIGNMENT": "Aufgabe anzeigen",
      "ASSIGNMENT_LABEL": "Aufgaben",
      "MODULE_ASSIGNMENT_ALT": "Symbol für Modulaufgaben",
      "VIEW_ASSIGNMENT_FOR": "Aufgabe anzeigen für",
      "DAY": "Tag",
      "UNTILL_DUE": "Verbleibende Zeit",
      "PAST_DUE": "Überfällig",
      "AVAILABLE_IN": "Verfügbar in",
      "DUE_TODAY": "Heute fällig",
      "PRACTICE": "Übung",
      "CERTIFICATION": "Zertifizierung",
      "UPCOMING": "Demnächst",
      "TEST_ASSIGNMENT": "Testaufgabe",
      "CLOSED": "Abgeschlossen",
      "NO_ASSIGNMENT_FILTERED_TITLE": "Keine Aufgaben gefunden.",
      "NO_ASSIGNMENT_FILTERED_DETAILS": "Passen Sie Ihre Filter an, um verfügbare Aufgaben anzuzeigen, oder schauen Sie später noch einmal vorbei, wenn neue Aufgaben hinzugefügt wurden.",
      "VIEW_PATHWAY": "Lernpfad anzeigen",
      "TOTAL": "Insgesamt",
      "STATUS_LABEL": "Status",
      "STATUS_SELECTION_LABEL": "Status:",
      "ASSIGNMENT_TYPE": "Aufgabentyp",
      "ASSIGNMENT_TYPE_SELECTION_LABEL": "Aufgabentyp:",
      "NOT_STARTED": "Nicht begonnen",
      "CERTIFIED": "Zertifiziert",
      "NOT_CERTIFIED": "Nicht zertifiziert",
      "IN_PROGRESS": "Wird bearbeitet",
      "PATHWAY": "Lernpfad",
      "SELECT_ALL": "Alle auswählen",
      "DESELECT_ALL": "Alle abwählen",
      "GET_STARTED": "Jetzt starten",
      "ASSIGNMENT_STATUS_LABEL": "Aufgabenstatus",
      "ASSIGNMENT_STATUS_SELECTION_LABEL": "Aufgabenstatus:",
      "CLEAR_STATUS": "Status löschen",
      "ENDED": "Beendet",
      "START_PATHWAY": "Lernpfad beginnen",
      "DAYS": "Tage",
      "OTHERS_SINGULAR": "und 1 weitere",
      "OTHERS_PLURAL": "und {{count}} weitere"
    },
    "cognito": {
      "INVITATION_SUBJECT": "Willkommen bei Quantified!",
      "INVITATION_MESSAGE": "Wir freuen uns, Sie an Bord zu haben! Bitte befolgen Sie die folgenden Schritte, um sich zum ersten Mal bei Ihrem Konto anzumelden.",
      "ACCOUNT_DETAILS": "Ihre Kontodaten:",
      "USERNAME": "Benutzername",
      "PASSWORD": "Temporäres Passwort",
      "STEPS_LABEL": "Nächste Schritte zum Einloggen",
      "STEP_1": "1. Klicken Sie unten auf die Schaltfläche „Anmelden“, um zur Anmeldeseite zu gelangen.",
      "STEP_2": "2. Geben Sie Ihren Benutzernamen und Ihr temporäres Passwort ein, wie oben angegeben.",
      "STEP_3": "3. Sobald Sie angemeldet sind, werden Sie aufgefordert, ein neues Passwort festzulegen.",
      "LOGIN_BUTTON": "Anmelden",
      "ABOUT_US": "Der Simulator von Quantified ist eine virtuelle Umgebung, in der Sie schnell wichtige Fähigkeiten erwerben, um effektiver mit Kunden zu kommunizieren.",
      "EXPIRY_TIME": "Dieses temporäre Passwort läuft in 24 Stunden ab. Sollten Sie Probleme bei der Anmeldung haben, wenden Sie sich bitte an unser Support-Team unter",
      "TEAM": "Das Quantified-Team",
      "INVITATION_SMS_USERNAME": "Ihr Benutzername lautet",
      "INVITATION_SMS_PASSWORD": "und das vorläufige Passwort lautet",
      "AUTHENTICATION_CODE": "Ihr Authentifizierungscode lautet",
      "PASSWORD_RESET_CODE": "Ihr Code zum Zurücksetzen Ihres Quantified-Passworts",
      "RESET_PASSWORD_EMAIL": "E-Mail zum Zurücksetzen des Passworts",
      "HELLO": "Hallo",
      "USE_VERIFICATION_CODE": "Sie haben ein neues Passwort beantragt. Bitte geben Sie den untenstehenden Verifizierungscode ein, um den Vorgang abzuschließen.",
      "VERIFICATION_CODE": "Verifizierungscode",
      "NEXT_STEP": "Nächste Schritte",
      "RESET_PASSWORD_PAGE": "Rufen Sie die Seite zum Zurücksetzen Ihres Passworts in Ihrem Browser erneut auf.",
      "ENTER_VERIFICATION_CODE": "Geben Sie den Verifizierungscode ein, wenn Sie dazu aufgefordert werden.",
      "CREATE_PASSWORD": "Sobald der Code verifiziert ist, folgen Sie den Anweisungen, um ein neues Passwort zu erstellen.",
      "DISREGARD_NOTE": "Wenn Sie kein neues Passwort angefordert haben, ignorieren Sie bitte diese E-Mail.",
      "CONTACT_SUPPORT": "Für weitere Unterstützung wenden Sie sich bitte an unser Support-Team unter",
      "HELP_EMAIL": "help@quantified.ai",
      "THANK_YOU": "Vielen Dank",
      "QUANTIFIED_TEAM": "Das Quantified-Team",
      "ADDRESS": "4200 Marathon Blvd, Suite 210, Austin, Texas 78756, USA",
      "RETURN_TO_PATHWAY": "Zurück zur Startseite"
    },
    "call": {
      "LOADING": "Laden",
      "SIMULATION_PAUSED": "Die Simulation wurde angehalten.",
      "CLICK_RESUME": "Klicken Sie auf die Schaltfläche „Fortfahren“, um fortzufahren.",
      "NO_INTERNET": "Keine Internetverbindung",
      "TRY_AGAIN": "Bitte überprüfen Sie Ihre Verbindung und versuchen Sie es erneut.",
      "MIC_MUTED": "Mikrofon ist stummgeschaltet",
      "MIC_MUTED_DESCRIPTION": "Hoppla, es sieht so aus, als ob Ihr Mikrofon stumm geschaltet ist. Heben Sie die Stummschaltung auf, um zu antworten und fortzufahren.",
      "NO_RESPONSE": "Keine Antwort erkannt",
      "MIC_NOT_CONNECTED": "Hoppla, es sieht so aus, als ob Ihr Mikrofon nicht angeschlossen ist. Wählen Sie Ihr Gerät erneut aus, um zu antworten und fortzufahren.",
      "AUDIO_ISSUE": "Hoppla, da ist etwas schief gelaufen. Überprüfen Sie die Einstellungen Ihres Geräts und stellen Sie sicher, dass Sie sich an einem ruhigen Ort befinden, der frei von Hintergrundgeräuschen ist.",
      "LOADING_ALT": "Laden...",
      "REPEAT_RESPONSE": "Sie werden automatisch zu der Simulation zurückgeführt, um Ihre Antwort zu wiederholen und es erneut zu versuchen.",
      "NEEDS_MORE_TIME_QUESTION": "braucht mehr Zeit zum Nachdenken, wollen Sie warten?",
      "NEEDS_MORE_TIME": "braucht mehr Zeit zum Nachdenken.",
      "WAIT_OR_END_CALL": "Wir werden Sie benachrichtigen, wenn sie fertig sind, oder Sie können den Anruf beenden und",
      "RETURN_TO_ASSIGNMENTS": "zur Aufgabe zurückkehren",
      "READY": "Bereit",
      "IS_READY": "ist bereit, Ihr Gespräch fortzusetzen.",
      "TRY_AGAIN_LABEL": "Erneut versuchen",
      "CHECK_SETTINGS": "Einstellungen überprüfen",
      "PAUSED_SIMULATION": "Sie haben die Simulation angehalten.",
      "PAUSED_SIMULATION_DESCRIPTION": "Die Video- und Audioaufzeichnung wird angehalten, bis die Simulation fortgesetzt wird.",
      "RESUME": "Fortsetzen",
      "SETTINGS": "Einstellungen",
      "CAPTURING_RESPONSE": "Erfassen Ihrer Antworten",
      "TOUR_MESSAGE": "Sobald Sie Ihren Beitrag beendet haben, klicken Sie auf „Weiter“, damit Ihre Antworten erfasst und bewertet werden.",
      "NEXT": "Weiter",
      "START_CALL": "Start",
      "END_CALL_TITLE": "Sind Sie sicher, dass Sie diese Simulation beenden möchten?",
      "END_CALL_DESCRIPTION": "Wenn Sie die Simulation jetzt beenden, erhalten Sie weder eine Bewertung noch ein Feedback zu Ihrem Gespräch.",
      "END_CALL": "Ende",
      "BROWSER_ACCESS_DENIED": "Ihrem Browser wird der Zugriff auf dieses Gerät verweigert.",
      "COPY_SESSION_ID_BUTTON": "Sitzungs-ID kopieren",
      "TIPS_GUIDANCE_MESSAGE": "Hier werden Diskussionspunkte und Tipps angezeigt.",
      "CONTINUE": "Fortsetzen",
      "SESSION_ID_LABEL": "Sitzungs-ID:",
      "SESSION_ID_COPIED": "Sitzungs-ID kopiert!",
      "HINTS_AND_SUGGESTIONS_TITLE": "Hinweise und Vorschläge",
      "HINT_LABEL": "Hinweis",
      "CAPTIONS_LABEL": "Untertitel",
      "PAUSE_LABEL": "Pause",
      "VIDEO_LABEL": "Video",
      "PARTY_EMOJI": "Party-Emoji",
      "CALL_ENDED_MESSAGE": "Sie sind am Ende dieser Simulation angelangt.",
      "CALL_ENDED_INACTIVITY": "Diese Simulation wurde aufgrund von Inaktivität beendet",
      "CALL_ENDED_GENERIC": "Diese Simulation ist beendet",
      "FEEDBACK_PROMPT": "Hinterlassen Sie ein Feedback, während wir Ihre Ergebnisse verarbeiten.",
      "INTERACTION_THRESHOLD_NOT_MET": "Sie haben unsere Interaktionsschwelle für die Bewertung nicht erreicht. Bitte versuchen Sie es erneut.",
      "REALISTIC_CONVERSATION_QUESTION": "Hat sich dieses Gespräch realistisch und natürlich angefühlt?",
      "KNOWLEDGEABLE_PREPARED_QUESTION": "Fühlen Sie sich nach dieser Simulation besser informiert und vorbereitet?",
      "FEEDBACK_THANK_YOU": "Vielen Dank für Ihr Feedback!",
      "FEEDBACK_IMPROVEMENT_NOTE": "Vielen Dank für Ihr Feedback! Wir werden daran arbeiten, diese Erfahrung zu verbessern.",
      "AUDIO": "Audio",
      "VISUAL_AID_LOAD_ERROR": "Visuelle Unterstützung konnte nicht geladen werden",
      "BEGIN_CALL": "Start",
      "LEAVE_CALL_BRIEFING": "Briefing verlassen",
      "RESTORE_CALL": "Wiederherstellung Ihrer Simulation",
      "FEW_SECONDS": "Dies kann ein paar Sekunden dauern.",
      "CHECK_ALT": "Häkchen",
      "COPY_ALT": "Kopieren",
      "HINTS_ALT": "Hinweise",
      "CLOSE_CAPTIONS": "Untertitel ausblenden",
      "MICROPHONE_MUTED": "Mikrofon stummgeschaltet",
      "RETURN_TO_CALL": "Zurück zur Simulation",
      "YES": "Ja",
      "NO": "Nein",
      "VIEW_RESULTS": "Ergebnisse anzeigen",
      "RETURN_TO_ASSIGNMENT": "Zurück zur Aufgabe",
      "HAVING_ISSUES": "Es gibt Probleme mit der Verbindung. Bitte überprüfen Sie Ihre Internetverbindung und klicken Sie dann auf „OK“.",
      "OK": "OK",
      "RESULTS_NOT_GENERATED": "Leider können wir zu diesem Zeitpunkt keine Ergebnisse generieren. Bitte versuchen Sie es erneut.",
      "INACTIVITY_ALERT_MESSAGE": "Dieser Anruf wird aufgrund von Inaktivität beendet. Sprechen Sie mit dem Avatar, um den Anruf fortzusetzen, oder wählen Sie „Anruf beenden“, um das Gespräch zu beenden.",
      "INACTIVITY_DEFAULT_ALERT_TITLE": "Dieser Aufruf wird in {{secondsUntilHangup}} Sekunden beendet",
      "INACTIVITY_SHORT_ALERT_TITLE": "Dieser Anruf wird in wenigen Sekunden beendet",
      "TELL_YOUR_GENDER_HEADING": "Bitte teilen Sie uns Ihre bevorzugte Anrede mit:",
      "BY_KNOWING_YOUR_GENDER_DESCRIPTION": "So kann der Avatar die richtige Grammatik verwenden, was die Unterhaltung natürlicher und realistischer macht.",
      "GENDER_SELECTION": "Auswahl der Anrede:",
      "SELECT_OPTION": "Wählen Sie eine Option",
      "CONFIRM": "Bestätigen",
      "MALE": "Männlich",
      "FEMALE": "Weiblich",
      "NON_BINARY": "Nicht-binär/Andere",
      "PREFER_NOT_TO_ANSWER": "Keine Angabe",
      "NON_BINARY_MESSAGE": "Wir verstehen und respektieren Ihre nicht-binäre Geschlechtsidentität. Aufgrund der derzeitigen technischen Einschränkungen verwenden wir standardmäßig männliche Pronomen. Bitte beachten Sie, dass wir an Verbesserungen arbeiten, um in Zukunft alle Geschlechteridentitäten besser zu berücksichtigen. Wir danken Ihnen für Ihr Verständnis und Ihre Geduld.",
      "PREFER_NOT_TO_ANSWER_MESSAGE": "Wir respektieren Ihre Entscheidung, kein Geschlecht anzugeben. In solchen Fällen verwendet unsere Technologie aufgrund der derzeitigen Beschränkungen standardmäßig männliche Pronomen.",
      "DISPLAY_VISUAL_AID": "Visuelle Unterstützung anzeigen",
      "FULL_SCREEN": "Vollbild",
      "COLLAPSE": "Minimieren",
      "COMPLETED_CONVERSATION_MESSAGE": "Vielen Dank, dass Sie dieses Gespräch abgeschlossen haben.",
      "CONVERSATION_COMPLETION_FEEDBACK": "Hinterlassen Sie bitte ein Feedback, während wir Ihr Gespräch verarbeiten.",
      "ERROR_MESSAGE": "Es ist ein Fehler aufgetreten. Bitte wenden Sie sich an",
      "SAVED_CONVERSATION_MESSAGE": "Ihr Gespräch wurde gespeichert.",
      "RETURN_TO_MY_ASSIGNMENTS": "Zurück zu meinen Aufgaben",
      "RETURN_TO_PERSONALIZED_PRACTICE": "Zurück zur personalisierten Übung",
      "PERSONALIZED_CALL_NOTE": "Sie haben soeben ein personalisiertes Übungsgespräch abgeschlossen.",
      "LEAVE_STEP_TITLE": "Wollen Sie diesen Schritt wirklich verlassen?",
      "EXIT": "Ausgang",
      "CERT_ACK_TITLE": "Zertifizierung per Videobestätigung",
      "CERT_ACK_ACCEPT_AND_BEGIN": "Akzeptieren und beginnen",
      "CERT_ACK_RESUME_CALL": "Anruf fortsetzen",
      "CERT_ACK_PROCESSING": "Verarbeitung ...",
      "CERT_ACK_CAMERA_WARNING": "Bitte aktivieren Sie Ihre Kamera, um mit der Zertifizierung fortzufahren.",
      "CERT_ACK_CAMERA_OFF_DURING_CALL": "Ihre Kamera war ausgeschaltet. Bitte aktivieren Sie Ihre Kamera erneut, um die Zertifizierung fortzusetzen.",
      "CERT_ACK_TEXT_1": "Um die Integrität und Fairness dieser Zertifizierung zu gewährleisten, muss Ihre Kamera während der gesamten Sitzung eingeschaltet bleiben, und die Sitzung wird überwacht. Diese Anforderung dient der Bestätigung der Einhaltung aller Zertifizierungsstandards.",
      "CERT_ACK_TEXT_2": "Indem Sie fortfahren, bestätigen und stimmen Sie diesen Anforderungen zu.",
      "CERT_ACK_END_CALL": "Anruf beenden",
      "LAUNCH_SIMULATION": "Simulation starten",
      "DEBRIEF_LATEST_SESSION": "Nachbesprechung der letzten Sitzung",
      "RECONNECTING_AUDIO": "Audioverbindung wird wiederhergestellt...",
      "END": "Ende",
      "START_DEBRIEF": "Nachbesprechung der letzten Sitzung",
      "MOVE_TO_NEXT": "Weiter zum nächsten Schritt",
      "RETRY_ROLEPLAY": "Rollenspiel erneut versuchen",
      "EXIT_PATHWAY": "Lernpfad beenden",
      "PROCESSING": "Verarbeitung ...",
      "FEEDBACK_PROMPT_REQUIRED": "Hinterlassen Sie bitte Feedback, bevor Sie sich Ihre Ergebnisse ansehen.",
      "MUTE": "Stummschalten",
      "UNMUTE": "Stummschaltung aufheben",
      "SCREENSHARE_LABEL": "Bildschirm freigeben",
      "SCREENSHARE_UNSUPPORTED_TITLE": "{{callName}} nutzt die Bildschirmfreigabe",
      "SCREENSHARE_UNSUPPORTED_MESSAGE_APP": "Um das Gespräch fortzusetzen, nutzen Sie bitte unsere App anstelle Ihres Browsers.",
      "SCREENSHARE_UNSUPPORTED_MESSAGE_DESKTOP": "Um das Gespräch fortzusetzen, rufen Sie es bitte auf einem Desktop-Computer auf.",
      "SCREENSHARE_UNSUPPORTED_CLOSE_BUTTON": "Schließen",
      "SCREENSHARE_UNSUPPORTED_GO_TO_APP_BUTTON": "Zur App",
      "SCREENSHARE_UNSUPPORTED_GO_TO_APP_UNAVAILABLE": "Die mobile App ist noch nicht verfügbar. Bitte versuchen Sie es bald erneut.",
      "SCREENSHARE_STOP_LABEL": "Bildschirmfreigabe beenden",
      "SCREENSHARE_PIP_REOPEN_LABEL": "Videovorschau erneut öffnen",
      "SCREENSHARE_ACTIVE_LABEL": "Sie nutzen derzeit die Bildschirmfreigabe",
      "SCREENSHARE_OS_PERMISSION_HINT": "Die Bildschirmfreigabe konnte nicht gestartet werden. Aktivieren Sie die Bildschirmaufzeichnung für Ihren Browser unter „Systemeinstellungen“ > „Datenschutz &amp; Sicherheit“ und versuchen Sie es dann erneut.",
      "SCREENSHARE_SAFARI_BLOCKED_HINT": "Safari hat die Bildschirmfreigabe für diese Sitzung blockiert. Melden Sie sich ab und wieder an, und versuchen Sie es dann erneut."
    },
    "assignment": {
      "STATUS": "STATUS",
      "SCORE": "PUNKTZAHL",
      "MUST_ACHIEVE": "Erforderliche Punktzahl von",
      "OR_HIGHER": "oder höher",
      "OUT_OF_5": "von 5",
      "LATEST_ATTEMPT": "VORIGER VERSUCH",
      "TOTAL_ATTEMPTS": "Gesamtversuche",
      "UNLIMITED": "Unbegrenzt",
      "REMAINING": "Verbleibende",
      "VIEW_CALL_DETAILS": "Details anzeigen",
      "MAX_ATTEMPTS_REACHED": "Sie haben die maximale Anzahl von Versuchen erreicht",
      "DUE_DATE": "Fälligkeitsdatum",
      "DAYS": "Tage",
      "DAY": "Tag",
      "UNTILL_DUE": "Verbleibende Zeit",
      "PAST_DUE": "Überfällig",
      "ONGOING": "Laufend",
      "SCORE_REQUIREMENT": "Erforderliche Punktzahl",
      "SCORE_REQUIREMENT_DETAIL": "Sie müssen eine Punktzahl von",
      "TO_COMPLETE_EACH_CALL": "erreichen, um jede erforderliche Simulation abzuschließen.",
      "CALLS_IN_ASSIGNMENT": "Simulationen in der Aufgabe",
      "INCOMPLETE_CALL": "Unvollständig",
      "PREVIOUS_RESULTS": "Vorherige Ergebnisse",
      "DATE": "Datum",
      "RESULTS": "Ergebnisse",
      "VIEW_PREVIOUS_RESULTS": "Vorherige Ergebnisse anzeigen",
      "VIEW_FEEDBACK": "Feedback anzeigen",
      "LAUNCH_CALL": "Start",
      "CLOSE_BUTTON": "Schaltfläche „Schließen“",
      "CHECKMARK": "Häkchen",
      "CALL": "Anruf",
      "QUESTION": "Frage",
      "COMPLETED": "Abgeschlossen",
      "IN_PROGRESS": "Wird ausgeführt",
      "NOT_STARTED": "Nicht gestartet",
      "CERTIFIED": "Zertifiziert",
      "GUIDED": "Mit Anleitung",
      "CONVERSATIONAL": "Dialogorientiert",
      "GUIDED_SIMULATION": "Wissens-Check",
      "CONVERSATIONAL_SIMULATION": "Rollenspiel",
      "NO_ATTEMPTS_LEFT": "Keine verbleibenden Versuche",
      "OVERVIEW": "Übersicht",
      "ABOUT_THE_AVATAR": "Über den Avatar",
      "SCORING_CRITERIA": "Kriterien für die Punktevergabe",
      "SIMULATION_OVERVIEW": "Überblick über die Simulation",
      "ABOUT_THE_PERSONA": "Über die Persona",
      "OUTOF_COMPLIANCE": "Nicht konform",
      "TEST": "Test",
      "NO_ATTEMPTS": "Keine Versuche",
      "CLOSED": "Abgeschlossen",
      "COMPLETED_CALLS": "Abgeschlossene Anrufe"
    }
  }
};
